var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import React, { useRef, useMemo, useState, useEffect, useCallback, Fragment as Fragment$1, createElement as createElement$1, createRef, forwardRef, createContext, useLayoutEffect, Component } from "react";
import { createPortal } from "react-dom";
import ReactDOM from "react-dom/client";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$1(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var lib = {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browser$1 = { exports: {} };
var process = browser$1.exports = {};
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    if (typeof setTimeout === "function") {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    if (typeof clearTimeout === "function") {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    return setTimeout(fun, 0);
  }
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e2) {
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    return clearTimeout(marker);
  }
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      return cachedClearTimeout.call(null, marker);
    } catch (e2) {
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}
process.nextTick = function(fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
};
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop() {
}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
  return [];
};
process.binding = function(name) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(dir) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser$1.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var slider = {};
var innerSlider = {};
var initialState = {};
var hasRequiredInitialState;
function requireInitialState() {
  if (hasRequiredInitialState) return initialState;
  hasRequiredInitialState = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = void 0;
    var initialState2 = {
      animating: false,
      autoplaying: null,
      currentDirection: 0,
      currentLeft: null,
      currentSlide: 0,
      direction: 1,
      dragging: false,
      edgeDragged: false,
      initialized: false,
      lazyLoadedList: [],
      listHeight: null,
      listWidth: null,
      scrolling: false,
      slideCount: null,
      slideHeight: null,
      slideWidth: null,
      swipeLeft: null,
      swiped: false,
      // used by swipeEvent. differentites between touch and swipe.
      swiping: false,
      touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
      },
      trackStyle: {},
      trackWidth: 0,
      targetSlide: 0
    };
    var _default = initialState2;
    exports["default"] = _default;
  })(initialState);
  return initialState;
}
var lodash_debounce;
var hasRequiredLodash_debounce;
function requireLodash_debounce() {
  if (hasRequiredLodash_debounce) return lodash_debounce;
  hasRequiredLodash_debounce = 1;
  var FUNC_ERROR_TEXT = "Expected a function";
  var NAN = 0 / 0;
  var symbolTag = "[object Symbol]";
  var reTrim = /^\s+|\s+$/g;
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
  var reIsBinary = /^0b[01]+$/i;
  var reIsOctal = /^0o[0-7]+$/i;
  var freeParseInt = parseInt;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  var objectProto = Object.prototype;
  var objectToString = objectProto.toString;
  var nativeMax = Math.max, nativeMin = Math.min;
  var now2 = function() {
    return root.Date.now();
  };
  function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait = toNumber(wait) || 0;
    if (isObject2(options)) {
      leading = !!options.leading;
      maxing = "maxWait" in options;
      maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
      trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs, thisArg = lastThis;
      lastArgs = lastThis = void 0;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }
    function leadingEdge(time) {
      lastInvokeTime = time;
      timerId = setTimeout(timerExpired, wait);
      return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
      return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
      return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now2();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = void 0;
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = void 0;
      return result;
    }
    function cancel() {
      if (timerId !== void 0) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = void 0;
    }
    function flush() {
      return timerId === void 0 ? result : trailingEdge(now2());
    }
    function debounced() {
      var time = now2(), isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === void 0) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === void 0) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }
  function isObject2(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  function isObjectLike(value) {
    return !!value && typeof value == "object";
  }
  function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
  }
  function toNumber(value) {
    if (typeof value == "number") {
      return value;
    }
    if (isSymbol(value)) {
      return NAN;
    }
    if (isObject2(value)) {
      var other = typeof value.valueOf == "function" ? value.valueOf() : value;
      value = isObject2(other) ? other + "" : other;
    }
    if (typeof value != "string") {
      return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, "");
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }
  lodash_debounce = debounce;
  return lodash_debounce;
}
var classnames$1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var hasRequiredClassnames;
function requireClassnames() {
  if (hasRequiredClassnames) return classnames$1.exports;
  hasRequiredClassnames = 1;
  (function(module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames() {
        var classes2 = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes2 = appendClass(classes2, parseValue(arg));
          }
        }
        return classes2;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes2 = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes2 = appendClass(classes2, key);
          }
        }
        return classes2;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
      } else {
        window.classNames = classNames;
      }
    })();
  })(classnames$1);
  return classnames$1.exports;
}
var innerSliderUtils = {};
var hasRequiredInnerSliderUtils;
function requireInnerSliderUtils() {
  if (hasRequiredInnerSliderUtils) return innerSliderUtils;
  hasRequiredInnerSliderUtils = 1;
  Object.defineProperty(innerSliderUtils, "__esModule", {
    value: true
  });
  innerSliderUtils.clamp = clamp;
  innerSliderUtils.canUseDOM = innerSliderUtils.slidesOnLeft = innerSliderUtils.slidesOnRight = innerSliderUtils.siblingDirection = innerSliderUtils.getTotalSlides = innerSliderUtils.getPostClones = innerSliderUtils.getPreClones = innerSliderUtils.getTrackLeft = innerSliderUtils.getTrackAnimateCSS = innerSliderUtils.getTrackCSS = innerSliderUtils.checkSpecKeys = innerSliderUtils.getSlideCount = innerSliderUtils.checkNavigable = innerSliderUtils.getNavigableIndexes = innerSliderUtils.swipeEnd = innerSliderUtils.swipeMove = innerSliderUtils.swipeStart = innerSliderUtils.keyHandler = innerSliderUtils.changeSlide = innerSliderUtils.slideHandler = innerSliderUtils.initializedState = innerSliderUtils.extractObject = innerSliderUtils.canGoNext = innerSliderUtils.getSwipeDirection = innerSliderUtils.getHeight = innerSliderUtils.getWidth = innerSliderUtils.lazySlidesOnRight = innerSliderUtils.lazySlidesOnLeft = innerSliderUtils.lazyEndIndex = innerSliderUtils.lazyStartIndex = innerSliderUtils.getRequiredLazySlides = innerSliderUtils.getOnDemandLazySlides = void 0;
  var _react = _interopRequireDefault(React);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function ownKeys2(object2, enumerableOnly) {
    var keys = Object.keys(object2);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object2);
      if (enumerableOnly) symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys2(Object(source), true).forEach(function(key) {
          _defineProperty2(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys2(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
  }
  var getOnDemandLazySlides = function getOnDemandLazySlides2(spec) {
    var onDemandSlides = [];
    var startIndex = lazyStartIndex(spec);
    var endIndex = lazyEndIndex(spec);
    for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
      if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
        onDemandSlides.push(slideIndex);
      }
    }
    return onDemandSlides;
  };
  innerSliderUtils.getOnDemandLazySlides = getOnDemandLazySlides;
  var getRequiredLazySlides = function getRequiredLazySlides2(spec) {
    var requiredSlides = [];
    var startIndex = lazyStartIndex(spec);
    var endIndex = lazyEndIndex(spec);
    for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
      requiredSlides.push(slideIndex);
    }
    return requiredSlides;
  };
  innerSliderUtils.getRequiredLazySlides = getRequiredLazySlides;
  var lazyStartIndex = function lazyStartIndex2(spec) {
    return spec.currentSlide - lazySlidesOnLeft(spec);
  };
  innerSliderUtils.lazyStartIndex = lazyStartIndex;
  var lazyEndIndex = function lazyEndIndex2(spec) {
    return spec.currentSlide + lazySlidesOnRight(spec);
  };
  innerSliderUtils.lazyEndIndex = lazyEndIndex;
  var lazySlidesOnLeft = function lazySlidesOnLeft2(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
  };
  innerSliderUtils.lazySlidesOnLeft = lazySlidesOnLeft;
  var lazySlidesOnRight = function lazySlidesOnRight2(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
  };
  innerSliderUtils.lazySlidesOnRight = lazySlidesOnRight;
  var getWidth = function getWidth2(elem) {
    return elem && elem.offsetWidth || 0;
  };
  innerSliderUtils.getWidth = getWidth;
  var getHeight = function getHeight2(elem) {
    return elem && elem.offsetHeight || 0;
  };
  innerSliderUtils.getHeight = getHeight;
  var getSwipeDirection = function getSwipeDirection2(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var xDist, yDist, r2, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r2 = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r2 * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
      return "left";
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return "right";
    }
    if (verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return "up";
      } else {
        return "down";
      }
    }
    return "vertical";
  };
  innerSliderUtils.getSwipeDirection = getSwipeDirection;
  var canGoNext = function canGoNext2(spec) {
    var canGo = true;
    if (!spec.infinite) {
      if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
        canGo = false;
      } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
        canGo = false;
      }
    }
    return canGo;
  };
  innerSliderUtils.canGoNext = canGoNext;
  var extractObject = function extractObject2(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
      return newObject[key] = spec[key];
    });
    return newObject;
  };
  innerSliderUtils.extractObject = extractObject;
  var initializedState = function initializedState2(spec) {
    var slideCount = _react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil(getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil(getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
      var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
      if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
        centerPaddingAdj *= listWidth / 100;
      }
      slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else {
      slideWidth = listWidth;
    }
    var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === void 0 ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === void 0) {
      currentSlide = slideCount - 1 - spec.initialSlide;
    }
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = getOnDemandLazySlides(_objectSpread2(_objectSpread2({}, spec), {}, {
      currentSlide,
      lazyLoadedList
    }));
    lazyLoadedList.concat(slidesToLoad);
    var state = {
      slideCount,
      slideWidth,
      listWidth,
      trackWidth,
      currentSlide,
      slideHeight,
      listHeight,
      lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) {
      state["autoplaying"] = "playing";
    }
    return state;
  };
  innerSliderUtils.initializedState = initializedState;
  var slideHandler = function slideHandler2(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index2 = spec.index, slideCount = spec.slideCount, lazyLoadedList = spec.lazyLoadedList, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    if (waitForAnimate && animating) return {};
    var animationSlide = index2, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index2 : clamp(index2, 0, slideCount - 1);
    if (fade) {
      if (!infinite && (index2 < 0 || index2 >= slideCount)) return {};
      if (index2 < 0) {
        animationSlide = index2 + slideCount;
      } else if (index2 >= slideCount) {
        animationSlide = index2 - slideCount;
      }
      if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
        lazyLoadedList.push(animationSlide);
      }
      state = {
        animating: true,
        currentSlide: animationSlide,
        lazyLoadedList,
        targetSlide: animationSlide
      };
      nextState = {
        animating: false,
        targetSlide: animationSlide
      };
    } else {
      finalSlide = animationSlide;
      if (animationSlide < 0) {
        finalSlide = animationSlide + slideCount;
        if (!infinite) finalSlide = 0;
        else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
      } else if (!canGoNext(spec) && animationSlide > currentSlide) {
        animationSlide = finalSlide = currentSlide;
      } else if (centerMode && animationSlide >= slideCount) {
        animationSlide = infinite ? slideCount : slideCount - 1;
        finalSlide = infinite ? 0 : slideCount - 1;
      } else if (animationSlide >= slideCount) {
        finalSlide = animationSlide - slideCount;
        if (!infinite) finalSlide = slideCount - slidesToShow;
        else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
      }
      if (!infinite && animationSlide + slidesToShow >= slideCount) {
        finalSlide = slideCount - slidesToShow;
      }
      animationLeft = getTrackLeft(_objectSpread2(_objectSpread2({}, spec), {}, {
        slideIndex: animationSlide
      }));
      finalLeft = getTrackLeft(_objectSpread2(_objectSpread2({}, spec), {}, {
        slideIndex: finalSlide
      }));
      if (!infinite) {
        if (animationLeft === finalLeft) animationSlide = finalSlide;
        animationLeft = finalLeft;
      }
      lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread2(_objectSpread2({}, spec), {}, {
        currentSlide: animationSlide
      })));
      if (!useCSS) {
        state = {
          currentSlide: finalSlide,
          trackStyle: getTrackCSS(_objectSpread2(_objectSpread2({}, spec), {}, {
            left: finalLeft
          })),
          lazyLoadedList,
          targetSlide
        };
      } else {
        state = {
          animating: true,
          currentSlide: finalSlide,
          trackStyle: getTrackAnimateCSS(_objectSpread2(_objectSpread2({}, spec), {}, {
            left: animationLeft
          })),
          lazyLoadedList,
          targetSlide
        };
        nextState = {
          animating: false,
          currentSlide: finalSlide,
          trackStyle: getTrackCSS(_objectSpread2(_objectSpread2({}, spec), {}, {
            left: finalLeft
          })),
          swipeLeft: null,
          targetSlide
        };
      }
    }
    return {
      state,
      nextState
    };
  };
  innerSliderUtils.slideHandler = slideHandler;
  var changeSlide = function changeSlide2(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
      targetSlide = currentSlide - slideOffset;
      if (lazyLoad && !infinite) {
        previousInt = currentSlide - slideOffset;
        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
      }
      if (!infinite) {
        targetSlide = previousTargetSlide - slidesToScroll;
      }
    } else if (options.message === "next") {
      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
      targetSlide = currentSlide + slideOffset;
      if (lazyLoad && !infinite) {
        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
      }
      if (!infinite) {
        targetSlide = previousTargetSlide + slidesToScroll;
      }
    } else if (options.message === "dots") {
      targetSlide = options.index * options.slidesToScroll;
    } else if (options.message === "children") {
      targetSlide = options.index;
      if (infinite) {
        var direction = siblingDirection(_objectSpread2(_objectSpread2({}, spec), {}, {
          targetSlide
        }));
        if (targetSlide > options.currentSlide && direction === "left") {
          targetSlide = targetSlide - slideCount;
        } else if (targetSlide < options.currentSlide && direction === "right") {
          targetSlide = targetSlide + slideCount;
        }
      }
    } else if (options.message === "index") {
      targetSlide = Number(options.index);
    }
    return targetSlide;
  };
  innerSliderUtils.changeSlide = changeSlide;
  var keyHandler = function keyHandler2(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
  };
  innerSliderUtils.keyHandler = keyHandler;
  var swipeStart = function swipeStart2(e, swipe, draggable) {
    e.target.tagName === "IMG" && e.preventDefault();
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
      dragging: true,
      touchObject: {
        startX: e.touches ? e.touches[0].pageX : e.clientX,
        startY: e.touches ? e.touches[0].pageY : e.clientY,
        curX: e.touches ? e.touches[0].pageX : e.clientX,
        curY: e.touches ? e.touches[0].pageY : e.clientY
      }
    };
  };
  innerSliderUtils.swipeStart = swipeStart;
  var swipeMove = function swipeMove2(e, spec) {
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return e.preventDefault();
    if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
    var swipeLeft, state = {};
    var curLeft = getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
      return {
        scrolling: true
      };
    }
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
      if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
        touchSwipeLength = touchObject.swipeLength * edgeFriction;
        if (edgeDragged === false && onEdge) {
          onEdge(swipeDirection);
          state["edgeDragged"] = true;
        }
      }
    }
    if (!swiped && swipeEvent) {
      swipeEvent(swipeDirection);
      state["swiped"] = true;
    }
    if (!vertical) {
      if (!rtl) {
        swipeLeft = curLeft + touchSwipeLength * positionOffset;
      } else {
        swipeLeft = curLeft - touchSwipeLength * positionOffset;
      }
    } else {
      swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    }
    if (verticalSwiping) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    }
    state = _objectSpread2(_objectSpread2({}, state), {}, {
      touchObject,
      swipeLeft,
      trackStyle: getTrackCSS(_objectSpread2(_objectSpread2({}, spec), {}, {
        left: swipeLeft
      }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
      return state;
    }
    if (touchObject.swipeLength > 10) {
      state["swiping"] = true;
      e.preventDefault();
    }
    return state;
  };
  innerSliderUtils.swipeMove = swipeMove;
  var swipeEnd = function swipeEnd2(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
      if (swipe) e.preventDefault();
      return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
    var state = {
      dragging: false,
      edgeDragged: false,
      scrolling: false,
      swiping: false,
      swiped: false,
      swipeLeft: null,
      touchObject: {}
    };
    if (scrolling) {
      return state;
    }
    if (!touchObject.swipeLength) {
      return state;
    }
    if (touchObject.swipeLength > minSwipe) {
      e.preventDefault();
      if (onSwipe) {
        onSwipe(swipeDirection);
      }
      var slideCount, newSlide;
      var activeSlide = infinite ? currentSlide : targetSlide;
      switch (swipeDirection) {
        case "left":
        case "up":
          newSlide = activeSlide + getSlideCount(spec);
          slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
          state["currentDirection"] = 0;
          break;
        case "right":
        case "down":
          newSlide = activeSlide - getSlideCount(spec);
          slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
          state["currentDirection"] = 1;
          break;
        default:
          slideCount = activeSlide;
      }
      state["triggerSlideHandler"] = slideCount;
    } else {
      var currentLeft = getTrackLeft(spec);
      state["trackStyle"] = getTrackAnimateCSS(_objectSpread2(_objectSpread2({}, spec), {}, {
        left: currentLeft
      }));
    }
    return state;
  };
  innerSliderUtils.swipeEnd = swipeEnd;
  var getNavigableIndexes = function getNavigableIndexes2(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while (breakpoint < max) {
      indexes.push(breakpoint);
      breakpoint = counter + spec.slidesToScroll;
      counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
  };
  innerSliderUtils.getNavigableIndexes = getNavigableIndexes;
  var checkNavigable = function checkNavigable2(spec, index2) {
    var navigables = getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index2 > navigables[navigables.length - 1]) {
      index2 = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index2 < navigables[n]) {
          index2 = prevNavigable;
          break;
        }
        prevNavigable = navigables[n];
      }
    }
    return index2;
  };
  innerSliderUtils.checkNavigable = checkNavigable;
  var getSlideCount = function getSlideCount2(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
      var swipedSlide;
      var slickList = spec.listRef;
      var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
      Array.from(slides).every(function(slide2) {
        if (!spec.vertical) {
          if (slide2.offsetLeft - centerOffset + getWidth(slide2) / 2 > spec.swipeLeft * -1) {
            swipedSlide = slide2;
            return false;
          }
        } else {
          if (slide2.offsetTop + getHeight(slide2) / 2 > spec.swipeLeft * -1) {
            swipedSlide = slide2;
            return false;
          }
        }
        return true;
      });
      if (!swipedSlide) {
        return 0;
      }
      var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
      var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
      return slidesTraversed;
    } else {
      return spec.slidesToScroll;
    }
  };
  innerSliderUtils.getSlideCount = getSlideCount;
  var checkSpecKeys = function checkSpecKeys2(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
      return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
  };
  innerSliderUtils.checkSpecKeys = checkSpecKeys;
  var getTrackCSS = function getTrackCSS2(spec) {
    checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) {
      trackWidth = getTotalSlides(spec) * spec.slideWidth;
    } else {
      trackHeight = trackChildren * spec.slideHeight;
    }
    var style = {
      opacity: 1,
      transition: "",
      WebkitTransition: ""
    };
    if (spec.useTransform) {
      var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
      var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
      var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
      style = _objectSpread2(_objectSpread2({}, style), {}, {
        WebkitTransform,
        transform,
        msTransform
      });
    } else {
      if (spec.vertical) {
        style["top"] = spec.left;
      } else {
        style["left"] = spec.left;
      }
    }
    if (spec.fade) style = {
      opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    if (window && !window.addEventListener && window.attachEvent) {
      if (!spec.vertical) {
        style.marginLeft = spec.left + "px";
      } else {
        style.marginTop = spec.left + "px";
      }
    }
    return style;
  };
  innerSliderUtils.getTrackCSS = getTrackCSS;
  var getTrackAnimateCSS = function getTrackAnimateCSS2(spec) {
    checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
    var style = getTrackCSS(spec);
    if (spec.useTransform) {
      style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
      style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else {
      if (spec.vertical) {
        style.transition = "top " + spec.speed + "ms " + spec.cssEase;
      } else {
        style.transition = "left " + spec.speed + "ms " + spec.cssEase;
      }
    }
    return style;
  };
  innerSliderUtils.getTrackAnimateCSS = getTrackAnimateCSS;
  var getTrackLeft = function getTrackLeft2(spec) {
    if (spec.unslick) {
      return 0;
    }
    checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) {
      return 0;
    }
    var slidesToOffset = 0;
    if (infinite) {
      slidesToOffset = -getPreClones(spec);
      if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
        slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
      }
      if (centerMode) {
        slidesToOffset += parseInt(slidesToShow / 2);
      }
    } else {
      if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
        slidesToOffset = slidesToShow - slideCount % slidesToScroll;
      }
      if (centerMode) {
        slidesToOffset = parseInt(slidesToShow / 2);
      }
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) {
      targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    } else {
      targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    }
    if (variableWidth === true) {
      var targetSlideIndex;
      var trackElem = trackRef && trackRef.node;
      targetSlideIndex = slideIndex + getPreClones(spec);
      targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
      targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
      if (centerMode === true) {
        targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
        targetSlide = trackElem && trackElem.children[targetSlideIndex];
        targetLeft = 0;
        for (var slide2 = 0; slide2 < targetSlideIndex; slide2++) {
          targetLeft -= trackElem && trackElem.children[slide2] && trackElem.children[slide2].offsetWidth;
        }
        targetLeft -= parseInt(spec.centerPadding);
        targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
      }
    }
    return targetLeft;
  };
  innerSliderUtils.getTrackLeft = getTrackLeft;
  var getPreClones = function getPreClones2(spec) {
    if (spec.unslick || !spec.infinite) {
      return 0;
    }
    if (spec.variableWidth) {
      return spec.slideCount;
    }
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
  };
  innerSliderUtils.getPreClones = getPreClones;
  var getPostClones = function getPostClones2(spec) {
    if (spec.unslick || !spec.infinite) {
      return 0;
    }
    return spec.slideCount;
  };
  innerSliderUtils.getPostClones = getPostClones;
  var getTotalSlides = function getTotalSlides2(spec) {
    return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
  };
  innerSliderUtils.getTotalSlides = getTotalSlides;
  var siblingDirection = function siblingDirection2(spec) {
    if (spec.targetSlide > spec.currentSlide) {
      if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
        return "left";
      }
      return "right";
    } else {
      if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
        return "right";
      }
      return "left";
    }
  };
  innerSliderUtils.siblingDirection = siblingDirection;
  var slidesOnRight = function slidesOnRight2(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    if (centerMode) {
      var right = (slidesToShow - 1) / 2 + 1;
      if (parseInt(centerPadding) > 0) right += 1;
      if (rtl && slidesToShow % 2 === 0) right += 1;
      return right;
    }
    if (rtl) {
      return 0;
    }
    return slidesToShow - 1;
  };
  innerSliderUtils.slidesOnRight = slidesOnRight;
  var slidesOnLeft = function slidesOnLeft2(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    if (centerMode) {
      var left = (slidesToShow - 1) / 2 + 1;
      if (parseInt(centerPadding) > 0) left += 1;
      if (!rtl && slidesToShow % 2 === 0) left += 1;
      return left;
    }
    if (rtl) {
      return slidesToShow - 1;
    }
    return 0;
  };
  innerSliderUtils.slidesOnLeft = slidesOnLeft;
  var canUseDOM = function canUseDOM2() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
  };
  innerSliderUtils.canUseDOM = canUseDOM;
  return innerSliderUtils;
}
var track = {};
var hasRequiredTrack;
function requireTrack() {
  if (hasRequiredTrack) return track;
  hasRequiredTrack = 1;
  Object.defineProperty(track, "__esModule", {
    value: true
  });
  track.Track = void 0;
  var _react = _interopRequireDefault(React);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _innerSliderUtils = requireInnerSliderUtils();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof3(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof2 = function _typeof3(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof2(obj);
  }
  function _extends2() {
    _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
    return Constructor;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    if (superClass) _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  function ownKeys2(object2, enumerableOnly) {
    var keys = Object.keys(object2);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object2);
      if (enumerableOnly) symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys2(Object(source), true).forEach(function(key) {
          _defineProperty2(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys2(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var getSlideClasses = function getSlideClasses2(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index2;
    if (spec.rtl) {
      index2 = spec.slideCount - 1 - spec.index;
    } else {
      index2 = spec.index;
    }
    slickCloned = index2 < 0 || index2 >= spec.slideCount;
    if (spec.centerMode) {
      centerOffset = Math.floor(spec.slidesToShow / 2);
      slickCenter = (index2 - spec.currentSlide) % spec.slideCount === 0;
      if (index2 > spec.currentSlide - centerOffset - 1 && index2 <= spec.currentSlide + centerOffset) {
        slickActive = true;
      }
    } else {
      slickActive = spec.currentSlide <= index2 && index2 < spec.currentSlide + spec.slidesToShow;
    }
    var focusedSlide;
    if (spec.targetSlide < 0) {
      focusedSlide = spec.targetSlide + spec.slideCount;
    } else if (spec.targetSlide >= spec.slideCount) {
      focusedSlide = spec.targetSlide - spec.slideCount;
    } else {
      focusedSlide = spec.targetSlide;
    }
    var slickCurrent = index2 === focusedSlide;
    return {
      "slick-slide": true,
      "slick-active": slickActive,
      "slick-center": slickCenter,
      "slick-cloned": slickCloned,
      "slick-current": slickCurrent
      // dubious in case of RTL
    };
  };
  var getSlideStyle = function getSlideStyle2(spec) {
    var style = {};
    if (spec.variableWidth === void 0 || spec.variableWidth === false) {
      style.width = spec.slideWidth;
    }
    if (spec.fade) {
      style.position = "relative";
      if (spec.vertical) {
        style.top = -spec.index * parseInt(spec.slideHeight);
      } else {
        style.left = -spec.index * parseInt(spec.slideWidth);
      }
      style.opacity = spec.currentSlide === spec.index ? 1 : 0;
      if (spec.useCSS) {
        style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", visibility " + spec.speed + "ms " + spec.cssEase;
      }
    }
    return style;
  };
  var getKey = function getKey2(child, fallbackKey) {
    return child.key || fallbackKey;
  };
  var renderSlides = function renderSlides2(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = _react["default"].Children.count(spec.children);
    var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
    var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
    _react["default"].Children.forEach(spec.children, function(elem, index2) {
      var child;
      var childOnClickOptions = {
        message: "children",
        index: index2,
        slidesToScroll: spec.slidesToScroll,
        currentSlide: spec.currentSlide
      };
      if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index2) >= 0) {
        child = elem;
      } else {
        child = /* @__PURE__ */ _react["default"].createElement("div", null);
      }
      var childStyle = getSlideStyle(_objectSpread2(_objectSpread2({}, spec), {}, {
        index: index2
      }));
      var slideClass = child.props.className || "";
      var slideClasses = getSlideClasses(_objectSpread2(_objectSpread2({}, spec), {}, {
        index: index2
      }));
      slides.push(/* @__PURE__ */ _react["default"].cloneElement(child, {
        key: "original" + getKey(child, index2),
        "data-index": index2,
        className: (0, _classnames["default"])(slideClasses, slideClass),
        tabIndex: "-1",
        "aria-hidden": !slideClasses["slick-active"],
        style: _objectSpread2(_objectSpread2({
          outline: "none"
        }, child.props.style || {}), childStyle),
        onClick: function onClick2(e) {
          child.props && child.props.onClick && child.props.onClick(e);
          if (spec.focusOnSelect) {
            spec.focusOnSelect(childOnClickOptions);
          }
        }
      }));
      if (spec.infinite && spec.fade === false) {
        var preCloneNo = childrenCount - index2;
        if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
          key = -preCloneNo;
          if (key >= startIndex) {
            child = elem;
          }
          slideClasses = getSlideClasses(_objectSpread2(_objectSpread2({}, spec), {}, {
            index: key
          }));
          preCloneSlides.push(/* @__PURE__ */ _react["default"].cloneElement(child, {
            key: "precloned" + getKey(child, key),
            "data-index": key,
            tabIndex: "-1",
            className: (0, _classnames["default"])(slideClasses, slideClass),
            "aria-hidden": !slideClasses["slick-active"],
            style: _objectSpread2(_objectSpread2({}, child.props.style || {}), childStyle),
            onClick: function onClick2(e) {
              child.props && child.props.onClick && child.props.onClick(e);
              if (spec.focusOnSelect) {
                spec.focusOnSelect(childOnClickOptions);
              }
            }
          }));
        }
        if (childrenCount !== spec.slidesToShow) {
          key = childrenCount + index2;
          if (key < endIndex) {
            child = elem;
          }
          slideClasses = getSlideClasses(_objectSpread2(_objectSpread2({}, spec), {}, {
            index: key
          }));
          postCloneSlides.push(/* @__PURE__ */ _react["default"].cloneElement(child, {
            key: "postcloned" + getKey(child, key),
            "data-index": key,
            tabIndex: "-1",
            className: (0, _classnames["default"])(slideClasses, slideClass),
            "aria-hidden": !slideClasses["slick-active"],
            style: _objectSpread2(_objectSpread2({}, child.props.style || {}), childStyle),
            onClick: function onClick2(e) {
              child.props && child.props.onClick && child.props.onClick(e);
              if (spec.focusOnSelect) {
                spec.focusOnSelect(childOnClickOptions);
              }
            }
          }));
        }
      }
    });
    if (spec.rtl) {
      return preCloneSlides.concat(slides, postCloneSlides).reverse();
    } else {
      return preCloneSlides.concat(slides, postCloneSlides);
    }
  };
  var Track = /* @__PURE__ */ function(_React$PureComponent) {
    _inherits2(Track2, _React$PureComponent);
    var _super = _createSuper2(Track2);
    function Track2() {
      var _this;
      _classCallCheck2(this, Track2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty2(_assertThisInitialized2(_this), "node", null);
      _defineProperty2(_assertThisInitialized2(_this), "handleRef", function(ref) {
        _this.node = ref;
      });
      return _this;
    }
    _createClass2(Track2, [{
      key: "render",
      value: function render() {
        var slides = renderSlides(this.props);
        var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
        var mouseEvents = {
          onMouseEnter,
          onMouseOver,
          onMouseLeave
        };
        return /* @__PURE__ */ _react["default"].createElement("div", _extends2({
          ref: this.handleRef,
          className: "slick-track",
          style: this.props.trackStyle
        }, mouseEvents), slides);
      }
    }]);
    return Track2;
  }(_react["default"].PureComponent);
  track.Track = Track;
  return track;
}
var dots = {};
var hasRequiredDots;
function requireDots() {
  if (hasRequiredDots) return dots;
  hasRequiredDots = 1;
  Object.defineProperty(dots, "__esModule", {
    value: true
  });
  dots.Dots = void 0;
  var _react = _interopRequireDefault(React);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _innerSliderUtils = requireInnerSliderUtils();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof3(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof2 = function _typeof3(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof2(obj);
  }
  function ownKeys2(object2, enumerableOnly) {
    var keys = Object.keys(object2);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object2);
      if (enumerableOnly) symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys2(Object(source), true).forEach(function(key) {
          _defineProperty2(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys2(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
    return Constructor;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    if (superClass) _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  var getDotCount = function getDotCount2(spec) {
    var dots2;
    if (spec.infinite) {
      dots2 = Math.ceil(spec.slideCount / spec.slidesToScroll);
    } else {
      dots2 = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    }
    return dots2;
  };
  var Dots = /* @__PURE__ */ function(_React$PureComponent) {
    _inherits2(Dots2, _React$PureComponent);
    var _super = _createSuper2(Dots2);
    function Dots2() {
      _classCallCheck2(this, Dots2);
      return _super.apply(this, arguments);
    }
    _createClass2(Dots2, [{
      key: "clickHandler",
      value: function clickHandler(options, e) {
        e.preventDefault();
        this.props.clickHandler(options);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
        var dotCount = getDotCount({
          slideCount,
          slidesToScroll,
          slidesToShow,
          infinite
        });
        var mouseEvents = {
          onMouseEnter,
          onMouseOver,
          onMouseLeave
        };
        var dots2 = [];
        for (var i = 0; i < dotCount; i++) {
          var _rightBound = (i + 1) * slidesToScroll - 1;
          var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);
          var _leftBound = rightBound - (slidesToScroll - 1);
          var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
          var className2 = (0, _classnames["default"])({
            "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
          });
          var dotOptions = {
            message: "dots",
            index: i,
            slidesToScroll,
            currentSlide
          };
          var onClick2 = this.clickHandler.bind(this, dotOptions);
          dots2 = dots2.concat(/* @__PURE__ */ _react["default"].createElement("li", {
            key: i,
            className: className2
          }, /* @__PURE__ */ _react["default"].cloneElement(this.props.customPaging(i), {
            onClick: onClick2
          })));
        }
        return /* @__PURE__ */ _react["default"].cloneElement(this.props.appendDots(dots2), _objectSpread2({
          className: this.props.dotsClass
        }, mouseEvents));
      }
    }]);
    return Dots2;
  }(_react["default"].PureComponent);
  dots.Dots = Dots;
  return dots;
}
var arrows = {};
var hasRequiredArrows;
function requireArrows() {
  if (hasRequiredArrows) return arrows;
  hasRequiredArrows = 1;
  Object.defineProperty(arrows, "__esModule", {
    value: true
  });
  arrows.NextArrow = arrows.PrevArrow = void 0;
  var _react = _interopRequireDefault(React);
  var _classnames = _interopRequireDefault(requireClassnames());
  var _innerSliderUtils = requireInnerSliderUtils();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof3(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof2 = function _typeof3(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof2(obj);
  }
  function _extends2() {
    _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function ownKeys2(object2, enumerableOnly) {
    var keys = Object.keys(object2);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object2);
      if (enumerableOnly) symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys2(Object(source), true).forEach(function(key) {
          _defineProperty2(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys2(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
    return Constructor;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    if (superClass) _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  var PrevArrow = /* @__PURE__ */ function(_React$PureComponent) {
    _inherits2(PrevArrow2, _React$PureComponent);
    var _super = _createSuper2(PrevArrow2);
    function PrevArrow2() {
      _classCallCheck2(this, PrevArrow2);
      return _super.apply(this, arguments);
    }
    _createClass2(PrevArrow2, [{
      key: "clickHandler",
      value: function clickHandler(options, e) {
        if (e) {
          e.preventDefault();
        }
        this.props.clickHandler(options, e);
      }
    }, {
      key: "render",
      value: function render() {
        var prevClasses = {
          "slick-arrow": true,
          "slick-prev": true
        };
        var prevHandler = this.clickHandler.bind(this, {
          message: "previous"
        });
        if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
          prevClasses["slick-disabled"] = true;
          prevHandler = null;
        }
        var prevArrowProps = {
          key: "0",
          "data-role": "none",
          className: (0, _classnames["default"])(prevClasses),
          style: {
            display: "block"
          },
          onClick: prevHandler
        };
        var customProps = {
          currentSlide: this.props.currentSlide,
          slideCount: this.props.slideCount
        };
        var prevArrow;
        if (this.props.prevArrow) {
          prevArrow = /* @__PURE__ */ _react["default"].cloneElement(this.props.prevArrow, _objectSpread2(_objectSpread2({}, prevArrowProps), customProps));
        } else {
          prevArrow = /* @__PURE__ */ _react["default"].createElement("button", _extends2({
            key: "0",
            type: "button"
          }, prevArrowProps), " ", "Previous");
        }
        return prevArrow;
      }
    }]);
    return PrevArrow2;
  }(_react["default"].PureComponent);
  arrows.PrevArrow = PrevArrow;
  var NextArrow = /* @__PURE__ */ function(_React$PureComponent2) {
    _inherits2(NextArrow2, _React$PureComponent2);
    var _super2 = _createSuper2(NextArrow2);
    function NextArrow2() {
      _classCallCheck2(this, NextArrow2);
      return _super2.apply(this, arguments);
    }
    _createClass2(NextArrow2, [{
      key: "clickHandler",
      value: function clickHandler(options, e) {
        if (e) {
          e.preventDefault();
        }
        this.props.clickHandler(options, e);
      }
    }, {
      key: "render",
      value: function render() {
        var nextClasses = {
          "slick-arrow": true,
          "slick-next": true
        };
        var nextHandler = this.clickHandler.bind(this, {
          message: "next"
        });
        if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
          nextClasses["slick-disabled"] = true;
          nextHandler = null;
        }
        var nextArrowProps = {
          key: "1",
          "data-role": "none",
          className: (0, _classnames["default"])(nextClasses),
          style: {
            display: "block"
          },
          onClick: nextHandler
        };
        var customProps = {
          currentSlide: this.props.currentSlide,
          slideCount: this.props.slideCount
        };
        var nextArrow;
        if (this.props.nextArrow) {
          nextArrow = /* @__PURE__ */ _react["default"].cloneElement(this.props.nextArrow, _objectSpread2(_objectSpread2({}, nextArrowProps), customProps));
        } else {
          nextArrow = /* @__PURE__ */ _react["default"].createElement("button", _extends2({
            key: "1",
            type: "button"
          }, nextArrowProps), " ", "Next");
        }
        return nextArrow;
      }
    }]);
    return NextArrow2;
  }(_react["default"].PureComponent);
  arrows.NextArrow = NextArrow;
  return arrows;
}
const global$2 = globalThis || void 0 || self;
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key) {
        var index2 = getIndex(this.__entries__, key);
        var entry = this.__entries__[index2];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key, value) {
        var index2 = getIndex(this.__entries__, key);
        if (~index2) {
          this.__entries__[index2][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      class_1.prototype.delete = function(key) {
        var entries2 = this.__entries__;
        var index2 = getIndex(entries2, key);
        if (~index2) {
          entries2.splice(index2, 1);
        }
      };
      class_1.prototype.has = function(key) {
        return !!~getIndex(this.__entries__, key);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global$2 !== "undefined" && global$2.Math === Math) {
    return global$2;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle$1(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer) {
      if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer) {
      var observers2 = this.observers_;
      var index2 = observers2.indexOf(observer);
      if (~index2) {
        observers2.splice(index2, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer) {
        return observer.gatherActive(), observer.hasActive();
      });
      activeObservers.forEach(function(observer) {
        return observer.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
      var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key) {
        return !!~propertyName.indexOf(key);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  }()
);
var defineConfigurable = function(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position) {
    var value = styles["border-" + position + "-width"];
    return size + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles["padding-" + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles.width), height = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x,
    y,
    width,
    height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
function createRectInit(x, y, width, height) {
  return { x, y, width, height };
}
var ResizeObservation = (
  /** @class */
  function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  }()
);
var ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  }()
);
var ResizeObserverSPI = (
  /** @class */
  function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries2 = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries2, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  }()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver$1 = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserver2(callback) {
      if (!(this instanceof ResizeObserver2)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer);
    }
    return ResizeObserver2;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method) {
  ResizeObserver$1.prototype[method] = function() {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index$2 = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$1;
}();
const ResizeObserver_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index$2
}, Symbol.toStringTag, { value: "Module" }));
const require$$8 = /* @__PURE__ */ getAugmentedNamespace(ResizeObserver_es);
var hasRequiredInnerSlider;
function requireInnerSlider() {
  if (hasRequiredInnerSlider) return innerSlider;
  hasRequiredInnerSlider = 1;
  Object.defineProperty(innerSlider, "__esModule", {
    value: true
  });
  innerSlider.InnerSlider = void 0;
  var _react = _interopRequireDefault(React);
  var _initialState = _interopRequireDefault(requireInitialState());
  var _lodash = _interopRequireDefault(requireLodash_debounce());
  var _classnames = _interopRequireDefault(requireClassnames());
  var _innerSliderUtils = requireInnerSliderUtils();
  var _track = requireTrack();
  var _dots = requireDots();
  var _arrows = requireArrows();
  var _resizeObserverPolyfill = _interopRequireDefault(require$$8);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof3(obj2) {
        return typeof obj2;
      };
    } else {
      _typeof2 = function _typeof3(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
      };
    }
    return _typeof2(obj);
  }
  function _extends2() {
    _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _objectWithoutProperties2(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose2(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function ownKeys2(object2, enumerableOnly) {
    var keys = Object.keys(object2);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object2);
      if (enumerableOnly) symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys2(Object(source), true).forEach(function(key) {
          _defineProperty2(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys2(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
    return Constructor;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    if (superClass) _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p) {
    _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p2) {
      o2.__proto__ = p2;
      return o2;
    };
    return _setPrototypeOf2(o, p);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var InnerSlider = /* @__PURE__ */ function(_React$Component) {
    _inherits2(InnerSlider2, _React$Component);
    var _super = _createSuper2(InnerSlider2);
    function InnerSlider2(props) {
      var _this;
      _classCallCheck2(this, InnerSlider2);
      _this = _super.call(this, props);
      _defineProperty2(_assertThisInitialized2(_this), "listRefHandler", function(ref) {
        return _this.list = ref;
      });
      _defineProperty2(_assertThisInitialized2(_this), "trackRefHandler", function(ref) {
        return _this.track = ref;
      });
      _defineProperty2(_assertThisInitialized2(_this), "adaptHeight", function() {
        if (_this.props.adaptiveHeight && _this.list) {
          var elem = _this.list.querySelector('[data-index="'.concat(_this.state.currentSlide, '"]'));
          _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
        }
      });
      _defineProperty2(_assertThisInitialized2(_this), "componentDidMount", function() {
        _this.props.onInit && _this.props.onInit();
        if (_this.props.lazyLoad) {
          var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread2(_objectSpread2({}, _this.props), _this.state));
          if (slidesToLoad.length > 0) {
            _this.setState(function(prevState) {
              return {
                lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
              };
            });
            if (_this.props.onLazyLoad) {
              _this.props.onLazyLoad(slidesToLoad);
            }
          }
        }
        var spec = _objectSpread2({
          listRef: _this.list,
          trackRef: _this.track
        }, _this.props);
        _this.updateState(spec, true, function() {
          _this.adaptHeight();
          _this.props.autoplay && _this.autoPlay("update");
        });
        if (_this.props.lazyLoad === "progressive") {
          _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1e3);
        }
        _this.ro = new _resizeObserverPolyfill["default"](function() {
          if (_this.state.animating) {
            _this.onWindowResized(false);
            _this.callbackTimers.push(setTimeout(function() {
              return _this.onWindowResized();
            }, _this.props.speed));
          } else {
            _this.onWindowResized();
          }
        });
        _this.ro.observe(_this.list);
        document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide2) {
          slide2.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
          slide2.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
        });
        if (window.addEventListener) {
          window.addEventListener("resize", _this.onWindowResized);
        } else {
          window.attachEvent("onresize", _this.onWindowResized);
        }
      });
      _defineProperty2(_assertThisInitialized2(_this), "componentWillUnmount", function() {
        if (_this.animationEndCallback) {
          clearTimeout(_this.animationEndCallback);
        }
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
        }
        if (_this.callbackTimers.length) {
          _this.callbackTimers.forEach(function(timer) {
            return clearTimeout(timer);
          });
          _this.callbackTimers = [];
        }
        if (window.addEventListener) {
          window.removeEventListener("resize", _this.onWindowResized);
        } else {
          window.detachEvent("onresize", _this.onWindowResized);
        }
        if (_this.autoplayTimer) {
          clearInterval(_this.autoplayTimer);
        }
        _this.ro.disconnect();
      });
      _defineProperty2(_assertThisInitialized2(_this), "componentDidUpdate", function(prevProps) {
        _this.checkImagesLoad();
        _this.props.onReInit && _this.props.onReInit();
        if (_this.props.lazyLoad) {
          var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread2(_objectSpread2({}, _this.props), _this.state));
          if (slidesToLoad.length > 0) {
            _this.setState(function(prevState) {
              return {
                lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
              };
            });
            if (_this.props.onLazyLoad) {
              _this.props.onLazyLoad(slidesToLoad);
            }
          }
        }
        _this.adaptHeight();
        var spec = _objectSpread2(_objectSpread2({
          listRef: _this.list,
          trackRef: _this.track
        }, _this.props), _this.state);
        var setTrackStyle = _this.didPropsChange(prevProps);
        setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
          if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
            _this.changeSlide({
              message: "index",
              index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
              currentSlide: _this.state.currentSlide
            });
          }
          if (_this.props.autoplay) {
            _this.autoPlay("update");
          } else {
            _this.pause("paused");
          }
        });
      });
      _defineProperty2(_assertThisInitialized2(_this), "onWindowResized", function(setTrackStyle) {
        if (_this.debouncedResize) _this.debouncedResize.cancel();
        _this.debouncedResize = (0, _lodash["default"])(function() {
          return _this.resizeWindow(setTrackStyle);
        }, 50);
        _this.debouncedResize();
      });
      _defineProperty2(_assertThisInitialized2(_this), "resizeWindow", function() {
        var setTrackStyle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var isTrackMounted = Boolean(_this.track && _this.track.node);
        if (!isTrackMounted) return;
        var spec = _objectSpread2(_objectSpread2({
          listRef: _this.list,
          trackRef: _this.track
        }, _this.props), _this.state);
        _this.updateState(spec, setTrackStyle, function() {
          if (_this.props.autoplay) _this.autoPlay("update");
          else _this.pause("paused");
        });
        _this.setState({
          animating: false
        });
        clearTimeout(_this.animationEndCallback);
        delete _this.animationEndCallback;
      });
      _defineProperty2(_assertThisInitialized2(_this), "updateState", function(spec, setTrackStyle, callback) {
        var updatedState = (0, _innerSliderUtils.initializedState)(spec);
        spec = _objectSpread2(_objectSpread2(_objectSpread2({}, spec), updatedState), {}, {
          slideIndex: updatedState.currentSlide
        });
        var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
        spec = _objectSpread2(_objectSpread2({}, spec), {}, {
          left: targetLeft
        });
        var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
        if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
          updatedState["trackStyle"] = trackStyle;
        }
        _this.setState(updatedState, callback);
      });
      _defineProperty2(_assertThisInitialized2(_this), "ssrInit", function() {
        if (_this.props.variableWidth) {
          var _trackWidth = 0, _trackLeft = 0;
          var childrenWidths = [];
          var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread2(_objectSpread2(_objectSpread2({}, _this.props), _this.state), {}, {
            slideCount: _this.props.children.length
          }));
          var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread2(_objectSpread2(_objectSpread2({}, _this.props), _this.state), {}, {
            slideCount: _this.props.children.length
          }));
          _this.props.children.forEach(function(child) {
            childrenWidths.push(child.props.style.width);
            _trackWidth += child.props.style.width;
          });
          for (var i = 0; i < preClones; i++) {
            _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
            _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
          }
          for (var _i = 0; _i < postClones; _i++) {
            _trackWidth += childrenWidths[_i];
          }
          for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
            _trackLeft += childrenWidths[_i2];
          }
          var _trackStyle = {
            width: _trackWidth + "px",
            left: -_trackLeft + "px"
          };
          if (_this.props.centerMode) {
            var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
            _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
          }
          return {
            trackStyle: _trackStyle
          };
        }
        var childrenCount = _react["default"].Children.count(_this.props.children);
        var spec = _objectSpread2(_objectSpread2(_objectSpread2({}, _this.props), _this.state), {}, {
          slideCount: childrenCount
        });
        var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
        var trackWidth = 100 / _this.props.slidesToShow * slideCount;
        var slideWidth = 100 / slideCount;
        var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
        if (_this.props.centerMode) {
          trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
        }
        var trackStyle = {
          width: trackWidth + "%",
          left: trackLeft + "%"
        };
        return {
          slideWidth: slideWidth + "%",
          trackStyle
        };
      });
      _defineProperty2(_assertThisInitialized2(_this), "checkImagesLoad", function() {
        var images = _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
        var imagesCount = images.length, loadedCount = 0;
        Array.prototype.forEach.call(images, function(image) {
          var handler = function handler2() {
            return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
          };
          if (!image.onclick) {
            image.onclick = function() {
              return image.parentNode.focus();
            };
          } else {
            var prevClickHandler = image.onclick;
            image.onclick = function() {
              prevClickHandler();
              image.parentNode.focus();
            };
          }
          if (!image.onload) {
            if (_this.props.lazyLoad) {
              image.onload = function() {
                _this.adaptHeight();
                _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
              };
            } else {
              image.onload = handler;
              image.onerror = function() {
                handler();
                _this.props.onLazyLoadError && _this.props.onLazyLoadError();
              };
            }
          }
        });
      });
      _defineProperty2(_assertThisInitialized2(_this), "progressiveLazyLoad", function() {
        var slidesToLoad = [];
        var spec = _objectSpread2(_objectSpread2({}, _this.props), _this.state);
        for (var index2 = _this.state.currentSlide; index2 < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index2++) {
          if (_this.state.lazyLoadedList.indexOf(index2) < 0) {
            slidesToLoad.push(index2);
            break;
          }
        }
        for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
          if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
            slidesToLoad.push(_index);
            break;
          }
        }
        if (slidesToLoad.length > 0) {
          _this.setState(function(state) {
            return {
              lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        } else {
          if (_this.lazyLoadTimer) {
            clearInterval(_this.lazyLoadTimer);
            delete _this.lazyLoadTimer;
          }
        }
      });
      _defineProperty2(_assertThisInitialized2(_this), "slideHandler", function(index2) {
        var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange;
        var currentSlide = _this.state.currentSlide;
        var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread2(_objectSpread2(_objectSpread2({
          index: index2
        }, _this.props), _this.state), {}, {
          trackRef: _this.track,
          useCSS: _this.props.useCSS && !dontAnimate
        })), state = _slideHandler.state, nextState = _slideHandler.nextState;
        if (!state) return;
        beforeChange && beforeChange(currentSlide, state.currentSlide);
        var slidesToLoad = state.lazyLoadedList.filter(function(value) {
          return _this.state.lazyLoadedList.indexOf(value) < 0;
        });
        onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
        if (!_this.props.waitForAnimate && _this.animationEndCallback) {
          clearTimeout(_this.animationEndCallback);
          afterChange && afterChange(currentSlide);
          delete _this.animationEndCallback;
        }
        _this.setState(state, function() {
          if (asNavFor && _this.asNavForIndex !== index2) {
            _this.asNavForIndex = index2;
            asNavFor.innerSlider.slideHandler(index2);
          }
          if (!nextState) return;
          _this.animationEndCallback = setTimeout(function() {
            var animating = nextState.animating, firstBatch = _objectWithoutProperties2(nextState, ["animating"]);
            _this.setState(firstBatch, function() {
              _this.callbackTimers.push(setTimeout(function() {
                return _this.setState({
                  animating
                });
              }, 10));
              afterChange && afterChange(state.currentSlide);
              delete _this.animationEndCallback;
            });
          }, speed);
        });
      });
      _defineProperty2(_assertThisInitialized2(_this), "changeSlide", function(options) {
        var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var spec = _objectSpread2(_objectSpread2({}, _this.props), _this.state);
        var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
        if (targetSlide !== 0 && !targetSlide) return;
        if (dontAnimate === true) {
          _this.slideHandler(targetSlide, dontAnimate);
        } else {
          _this.slideHandler(targetSlide);
        }
        _this.props.autoplay && _this.autoPlay("update");
        if (_this.props.focusOnSelect) {
          var nodes = _this.list.querySelectorAll(".slick-current");
          nodes[0] && nodes[0].focus();
        }
      });
      _defineProperty2(_assertThisInitialized2(_this), "clickHandler", function(e) {
        if (_this.clickable === false) {
          e.stopPropagation();
          e.preventDefault();
        }
        _this.clickable = true;
      });
      _defineProperty2(_assertThisInitialized2(_this), "keyHandler", function(e) {
        var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
        dir !== "" && _this.changeSlide({
          message: dir
        });
      });
      _defineProperty2(_assertThisInitialized2(_this), "selectHandler", function(options) {
        _this.changeSlide(options);
      });
      _defineProperty2(_assertThisInitialized2(_this), "disableBodyScroll", function() {
        var preventDefault = function preventDefault2(e) {
          e = e || window.event;
          if (e.preventDefault) e.preventDefault();
          e.returnValue = false;
        };
        window.ontouchmove = preventDefault;
      });
      _defineProperty2(_assertThisInitialized2(_this), "enableBodyScroll", function() {
        window.ontouchmove = null;
      });
      _defineProperty2(_assertThisInitialized2(_this), "swipeStart", function(e) {
        if (_this.props.verticalSwiping) {
          _this.disableBodyScroll();
        }
        var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
        state !== "" && _this.setState(state);
      });
      _defineProperty2(_assertThisInitialized2(_this), "swipeMove", function(e) {
        var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread2(_objectSpread2(_objectSpread2({}, _this.props), _this.state), {}, {
          trackRef: _this.track,
          listRef: _this.list,
          slideIndex: _this.state.currentSlide
        }));
        if (!state) return;
        if (state["swiping"]) {
          _this.clickable = false;
        }
        _this.setState(state);
      });
      _defineProperty2(_assertThisInitialized2(_this), "swipeEnd", function(e) {
        var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread2(_objectSpread2(_objectSpread2({}, _this.props), _this.state), {}, {
          trackRef: _this.track,
          listRef: _this.list,
          slideIndex: _this.state.currentSlide
        }));
        if (!state) return;
        var triggerSlideHandler = state["triggerSlideHandler"];
        delete state["triggerSlideHandler"];
        _this.setState(state);
        if (triggerSlideHandler === void 0) return;
        _this.slideHandler(triggerSlideHandler);
        if (_this.props.verticalSwiping) {
          _this.enableBodyScroll();
        }
      });
      _defineProperty2(_assertThisInitialized2(_this), "touchEnd", function(e) {
        _this.swipeEnd(e);
        _this.clickable = true;
      });
      _defineProperty2(_assertThisInitialized2(_this), "slickPrev", function() {
        _this.callbackTimers.push(setTimeout(function() {
          return _this.changeSlide({
            message: "previous"
          });
        }, 0));
      });
      _defineProperty2(_assertThisInitialized2(_this), "slickNext", function() {
        _this.callbackTimers.push(setTimeout(function() {
          return _this.changeSlide({
            message: "next"
          });
        }, 0));
      });
      _defineProperty2(_assertThisInitialized2(_this), "slickGoTo", function(slide2) {
        var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        slide2 = Number(slide2);
        if (isNaN(slide2)) return "";
        _this.callbackTimers.push(setTimeout(function() {
          return _this.changeSlide({
            message: "index",
            index: slide2,
            currentSlide: _this.state.currentSlide
          }, dontAnimate);
        }, 0));
      });
      _defineProperty2(_assertThisInitialized2(_this), "play", function() {
        var nextIndex;
        if (_this.props.rtl) {
          nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
        } else {
          if ((0, _innerSliderUtils.canGoNext)(_objectSpread2(_objectSpread2({}, _this.props), _this.state))) {
            nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
          } else {
            return false;
          }
        }
        _this.slideHandler(nextIndex);
      });
      _defineProperty2(_assertThisInitialized2(_this), "autoPlay", function(playType) {
        if (_this.autoplayTimer) {
          clearInterval(_this.autoplayTimer);
        }
        var autoplaying = _this.state.autoplaying;
        if (playType === "update") {
          if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
            return;
          }
        } else if (playType === "leave") {
          if (autoplaying === "paused" || autoplaying === "focused") {
            return;
          }
        } else if (playType === "blur") {
          if (autoplaying === "paused" || autoplaying === "hovered") {
            return;
          }
        }
        _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
        _this.setState({
          autoplaying: "playing"
        });
      });
      _defineProperty2(_assertThisInitialized2(_this), "pause", function(pauseType) {
        if (_this.autoplayTimer) {
          clearInterval(_this.autoplayTimer);
          _this.autoplayTimer = null;
        }
        var autoplaying = _this.state.autoplaying;
        if (pauseType === "paused") {
          _this.setState({
            autoplaying: "paused"
          });
        } else if (pauseType === "focused") {
          if (autoplaying === "hovered" || autoplaying === "playing") {
            _this.setState({
              autoplaying: "focused"
            });
          }
        } else {
          if (autoplaying === "playing") {
            _this.setState({
              autoplaying: "hovered"
            });
          }
        }
      });
      _defineProperty2(_assertThisInitialized2(_this), "onDotsOver", function() {
        return _this.props.autoplay && _this.pause("hovered");
      });
      _defineProperty2(_assertThisInitialized2(_this), "onDotsLeave", function() {
        return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
      });
      _defineProperty2(_assertThisInitialized2(_this), "onTrackOver", function() {
        return _this.props.autoplay && _this.pause("hovered");
      });
      _defineProperty2(_assertThisInitialized2(_this), "onTrackLeave", function() {
        return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
      });
      _defineProperty2(_assertThisInitialized2(_this), "onSlideFocus", function() {
        return _this.props.autoplay && _this.pause("focused");
      });
      _defineProperty2(_assertThisInitialized2(_this), "onSlideBlur", function() {
        return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
      });
      _defineProperty2(_assertThisInitialized2(_this), "render", function() {
        var className2 = (0, _classnames["default"])("slick-slider", _this.props.className, {
          "slick-vertical": _this.props.vertical,
          "slick-initialized": true
        });
        var spec = _objectSpread2(_objectSpread2({}, _this.props), _this.state);
        var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
        var pauseOnHover = _this.props.pauseOnHover;
        trackProps = _objectSpread2(_objectSpread2({}, trackProps), {}, {
          onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
          onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
          onMouseOver: pauseOnHover ? _this.onTrackOver : null,
          focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
        });
        var dots2;
        if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
          var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
          var pauseOnDotsHover = _this.props.pauseOnDotsHover;
          dotProps = _objectSpread2(_objectSpread2({}, dotProps), {}, {
            clickHandler: _this.changeSlide,
            onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
            onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
            onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
          });
          dots2 = /* @__PURE__ */ _react["default"].createElement(_dots.Dots, dotProps);
        }
        var prevArrow, nextArrow;
        var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
        arrowProps.clickHandler = _this.changeSlide;
        if (_this.props.arrows) {
          prevArrow = /* @__PURE__ */ _react["default"].createElement(_arrows.PrevArrow, arrowProps);
          nextArrow = /* @__PURE__ */ _react["default"].createElement(_arrows.NextArrow, arrowProps);
        }
        var verticalHeightStyle = null;
        if (_this.props.vertical) {
          verticalHeightStyle = {
            height: _this.state.listHeight
          };
        }
        var centerPaddingStyle = null;
        if (_this.props.vertical === false) {
          if (_this.props.centerMode === true) {
            centerPaddingStyle = {
              padding: "0px " + _this.props.centerPadding
            };
          }
        } else {
          if (_this.props.centerMode === true) {
            centerPaddingStyle = {
              padding: _this.props.centerPadding + " 0px"
            };
          }
        }
        var listStyle = _objectSpread2(_objectSpread2({}, verticalHeightStyle), centerPaddingStyle);
        var touchMove = _this.props.touchMove;
        var listProps = {
          className: "slick-list",
          style: listStyle,
          onClick: _this.clickHandler,
          onMouseDown: touchMove ? _this.swipeStart : null,
          onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
          onMouseUp: touchMove ? _this.swipeEnd : null,
          onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
          onTouchStart: touchMove ? _this.swipeStart : null,
          onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
          onTouchEnd: touchMove ? _this.touchEnd : null,
          onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
          onKeyDown: _this.props.accessibility ? _this.keyHandler : null
        };
        var innerSliderProps = {
          className: className2,
          dir: "ltr",
          style: _this.props.style
        };
        if (_this.props.unslick) {
          listProps = {
            className: "slick-list"
          };
          innerSliderProps = {
            className: className2
          };
        }
        return /* @__PURE__ */ _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /* @__PURE__ */ _react["default"].createElement("div", _extends2({
          ref: _this.listRefHandler
        }, listProps), /* @__PURE__ */ _react["default"].createElement(_track.Track, _extends2({
          ref: _this.trackRefHandler
        }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots2 : "");
      });
      _this.list = null;
      _this.track = null;
      _this.state = _objectSpread2(_objectSpread2({}, _initialState["default"]), {}, {
        currentSlide: _this.props.initialSlide,
        slideCount: _react["default"].Children.count(_this.props.children)
      });
      _this.callbackTimers = [];
      _this.clickable = true;
      _this.debouncedResize = null;
      var ssrState = _this.ssrInit();
      _this.state = _objectSpread2(_objectSpread2({}, _this.state), ssrState);
      return _this;
    }
    _createClass2(InnerSlider2, [{
      key: "didPropsChange",
      value: function didPropsChange(prevProps) {
        var setTrackStyle = false;
        for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
          var key = _Object$keys[_i3];
          if (!prevProps.hasOwnProperty(key)) {
            setTrackStyle = true;
            break;
          }
          if (_typeof2(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
            continue;
          }
          if (prevProps[key] !== this.props[key]) {
            setTrackStyle = true;
            break;
          }
        }
        return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
      }
    }]);
    return InnerSlider2;
  }(_react["default"].Component);
  innerSlider.InnerSlider = InnerSlider;
  return innerSlider;
}
var camel2hyphen_1;
var hasRequiredCamel2hyphen;
function requireCamel2hyphen() {
  if (hasRequiredCamel2hyphen) return camel2hyphen_1;
  hasRequiredCamel2hyphen = 1;
  var camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match2) {
      return "-" + match2.toLowerCase();
    }).toLowerCase();
  };
  camel2hyphen_1 = camel2hyphen;
  return camel2hyphen_1;
}
var json2mq_1;
var hasRequiredJson2mq;
function requireJson2mq() {
  if (hasRequiredJson2mq) return json2mq_1;
  hasRequiredJson2mq = 1;
  var camel2hyphen = requireCamel2hyphen();
  var isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
  };
  var obj2mq = function(obj) {
    var mq = "";
    var features = Object.keys(obj);
    features.forEach(function(feature, index2) {
      var value = obj[feature];
      feature = camel2hyphen(feature);
      if (isDimension(feature) && typeof value === "number") {
        value = value + "px";
      }
      if (value === true) {
        mq += feature;
      } else if (value === false) {
        mq += "not " + feature;
      } else {
        mq += "(" + feature + ": " + value + ")";
      }
      if (index2 < features.length - 1) {
        mq += " and ";
      }
    });
    return mq;
  };
  var json2mq = function(query) {
    var mq = "";
    if (typeof query === "string") {
      return query;
    }
    if (query instanceof Array) {
      query.forEach(function(q, index2) {
        mq += obj2mq(q);
        if (index2 < query.length - 1) {
          mq += ", ";
        }
      });
      return mq;
    }
    return obj2mq(query);
  };
  json2mq_1 = json2mq;
  return json2mq_1;
}
var defaultProps = {};
var hasRequiredDefaultProps;
function requireDefaultProps() {
  if (hasRequiredDefaultProps) return defaultProps;
  hasRequiredDefaultProps = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = void 0;
    var _react = _interopRequireDefault(React);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var defaultProps2 = {
      accessibility: true,
      adaptiveHeight: false,
      afterChange: null,
      appendDots: function appendDots(dots2) {
        return /* @__PURE__ */ _react["default"].createElement("ul", {
          style: {
            display: "block"
          }
        }, dots2);
      },
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3e3,
      beforeChange: null,
      centerMode: false,
      centerPadding: "50px",
      className: "",
      cssEase: "ease",
      customPaging: function customPaging(i) {
        return /* @__PURE__ */ _react["default"].createElement("button", null, i + 1);
      },
      dots: false,
      dotsClass: "slick-dots",
      draggable: true,
      easing: "linear",
      edgeFriction: 0.35,
      fade: false,
      focusOnSelect: false,
      infinite: true,
      initialSlide: 0,
      lazyLoad: null,
      nextArrow: null,
      onEdge: null,
      onInit: null,
      onLazyLoadError: null,
      onReInit: null,
      pauseOnDotsHover: false,
      pauseOnFocus: false,
      pauseOnHover: true,
      prevArrow: null,
      responsive: null,
      rows: 1,
      rtl: false,
      slide: "div",
      slidesPerRow: 1,
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 500,
      swipe: true,
      swipeEvent: null,
      swipeToSlide: false,
      touchMove: true,
      touchThreshold: 5,
      useCSS: true,
      useTransform: true,
      variableWidth: false,
      vertical: false,
      waitForAnimate: true
    };
    var _default = defaultProps2;
    exports["default"] = _default;
  })(defaultProps);
  return defaultProps;
}
var QueryHandler_1;
var hasRequiredQueryHandler;
function requireQueryHandler() {
  if (hasRequiredQueryHandler) return QueryHandler_1;
  hasRequiredQueryHandler = 1;
  function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
  }
  QueryHandler.prototype = {
    constructor: QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup: function() {
      if (this.options.setup) {
        this.options.setup();
      }
      this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on: function() {
      !this.initialised && this.setup();
      this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off: function() {
      this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy: function() {
      this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals: function(target) {
      return this.options === target || this.options.match === target;
    }
  };
  QueryHandler_1 = QueryHandler;
  return QueryHandler_1;
}
var Util;
var hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return Util;
  hasRequiredUtil = 1;
  function each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for (i; i < length; i++) {
      cont = fn(collection[i], i);
      if (cont === false) {
        break;
      }
    }
  }
  function isArray(target) {
    return Object.prototype.toString.apply(target) === "[object Array]";
  }
  function isFunction(target) {
    return typeof target === "function";
  }
  Util = {
    isFunction,
    isArray,
    each
  };
  return Util;
}
var MediaQuery_1;
var hasRequiredMediaQuery;
function requireMediaQuery() {
  if (hasRequiredMediaQuery) return MediaQuery_1;
  hasRequiredMediaQuery = 1;
  var QueryHandler = requireQueryHandler();
  var each = requireUtil().each;
  function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self2 = this;
    this.listener = function(mql) {
      self2.mql = mql.currentTarget || mql;
      self2.assess();
    };
    this.mql.addListener(this.listener);
  }
  MediaQuery.prototype = {
    constuctor: MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler: function(handler) {
      var qh = new QueryHandler(handler);
      this.handlers.push(qh);
      this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler: function(handler) {
      var handlers = this.handlers;
      each(handlers, function(h, i) {
        if (h.equals(handler)) {
          h.destroy();
          return !handlers.splice(i, 1);
        }
      });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches: function() {
      return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */
    clear: function() {
      each(this.handlers, function(handler) {
        handler.destroy();
      });
      this.mql.removeListener(this.listener);
      this.handlers.length = 0;
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess: function() {
      var action = this.matches() ? "on" : "off";
      each(this.handlers, function(handler) {
        handler[action]();
      });
    }
  };
  MediaQuery_1 = MediaQuery;
  return MediaQuery_1;
}
var MediaQueryDispatch_1;
var hasRequiredMediaQueryDispatch;
function requireMediaQueryDispatch() {
  if (hasRequiredMediaQueryDispatch) return MediaQueryDispatch_1;
  hasRequiredMediaQueryDispatch = 1;
  var MediaQuery = requireMediaQuery();
  var Util2 = requireUtil();
  var each = Util2.each;
  var isFunction = Util2.isFunction;
  var isArray = Util2.isArray;
  function MediaQueryDispatch() {
    if (!window.matchMedia) {
      throw new Error("matchMedia not present, legacy browsers require a polyfill");
    }
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia("only all").matches;
  }
  MediaQueryDispatch.prototype = {
    constructor: MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register: function(q, options, shouldDegrade) {
      var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
      if (!queries[q]) {
        queries[q] = new MediaQuery(q, isUnconditional);
      }
      if (isFunction(options)) {
        options = { match: options };
      }
      if (!isArray(options)) {
        options = [options];
      }
      each(options, function(handler) {
        if (isFunction(handler)) {
          handler = { match: handler };
        }
        queries[q].addHandler(handler);
      });
      return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister: function(q, handler) {
      var query = this.queries[q];
      if (query) {
        if (handler) {
          query.removeHandler(handler);
        } else {
          query.clear();
          delete this.queries[q];
        }
      }
      return this;
    }
  };
  MediaQueryDispatch_1 = MediaQueryDispatch;
  return MediaQueryDispatch_1;
}
var src;
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src;
  hasRequiredSrc = 1;
  var MediaQueryDispatch = requireMediaQueryDispatch();
  src = new MediaQueryDispatch();
  return src;
}
var hasRequiredSlider;
function requireSlider() {
  if (hasRequiredSlider) return slider;
  hasRequiredSlider = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = void 0;
    var _react = _interopRequireDefault(React);
    var _innerSlider = requireInnerSlider();
    var _json2mq = _interopRequireDefault(requireJson2mq());
    var _defaultProps = _interopRequireDefault(requireDefaultProps());
    var _innerSliderUtils = requireInnerSliderUtils();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _typeof2(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof2 = function _typeof3(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof2 = function _typeof3(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof2(obj);
    }
    function _extends2() {
      _extends2 = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      return _extends2.apply(this, arguments);
    }
    function ownKeys2(object2, enumerableOnly) {
      var keys = Object.keys(object2);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object2);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function _objectSpread2(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys2(Object(source), true).forEach(function(key) {
            _defineProperty2(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    function _classCallCheck2(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _defineProperties2(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    function _createClass2(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
      return Constructor;
    }
    function _inherits2(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
      if (superClass) _setPrototypeOf2(subClass, superClass);
    }
    function _setPrototypeOf2(o, p) {
      _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p2) {
        o2.__proto__ = p2;
        return o2;
      };
      return _setPrototypeOf2(o, p);
    }
    function _createSuper2(Derived) {
      var hasNativeReflectConstruct = _isNativeReflectConstruct2();
      return function _createSuperInternal() {
        var Super = _getPrototypeOf2(Derived), result;
        if (hasNativeReflectConstruct) {
          var NewTarget = _getPrototypeOf2(this).constructor;
          result = Reflect.construct(Super, arguments, NewTarget);
        } else {
          result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn2(this, result);
      };
    }
    function _possibleConstructorReturn2(self2, call) {
      if (call && (_typeof2(call) === "object" || typeof call === "function")) {
        return call;
      }
      return _assertThisInitialized2(self2);
    }
    function _assertThisInitialized2(self2) {
      if (self2 === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return self2;
    }
    function _isNativeReflectConstruct2() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;
      try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        }));
        return true;
      } catch (e) {
        return false;
      }
    }
    function _getPrototypeOf2(o) {
      _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
        return o2.__proto__ || Object.getPrototypeOf(o2);
      };
      return _getPrototypeOf2(o);
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    var enquire = (0, _innerSliderUtils.canUseDOM)() && requireSrc();
    var Slider2 = /* @__PURE__ */ function(_React$Component) {
      _inherits2(Slider3, _React$Component);
      var _super = _createSuper2(Slider3);
      function Slider3(props) {
        var _this;
        _classCallCheck2(this, Slider3);
        _this = _super.call(this, props);
        _defineProperty2(_assertThisInitialized2(_this), "innerSliderRefHandler", function(ref) {
          return _this.innerSlider = ref;
        });
        _defineProperty2(_assertThisInitialized2(_this), "slickPrev", function() {
          return _this.innerSlider.slickPrev();
        });
        _defineProperty2(_assertThisInitialized2(_this), "slickNext", function() {
          return _this.innerSlider.slickNext();
        });
        _defineProperty2(_assertThisInitialized2(_this), "slickGoTo", function(slide2) {
          var dontAnimate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
          return _this.innerSlider.slickGoTo(slide2, dontAnimate);
        });
        _defineProperty2(_assertThisInitialized2(_this), "slickPause", function() {
          return _this.innerSlider.pause("paused");
        });
        _defineProperty2(_assertThisInitialized2(_this), "slickPlay", function() {
          return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
          breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
      }
      _createClass2(Slider3, [{
        key: "media",
        value: function media(query, handler) {
          enquire.register(query, handler);
          this._responsiveMediaHandlers.push({
            query,
            handler
          });
        }
        // handles responsive breakpoints
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;
          if (this.props.responsive) {
            var breakpoints2 = this.props.responsive.map(function(breakpt) {
              return breakpt.breakpoint;
            });
            breakpoints2.sort(function(x, y) {
              return x - y;
            });
            breakpoints2.forEach(function(breakpoint, index2) {
              var bQuery;
              if (index2 === 0) {
                bQuery = (0, _json2mq["default"])({
                  minWidth: 0,
                  maxWidth: breakpoint
                });
              } else {
                bQuery = (0, _json2mq["default"])({
                  minWidth: breakpoints2[index2 - 1] + 1,
                  maxWidth: breakpoint
                });
              }
              (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function() {
                _this2.setState({
                  breakpoint
                });
              });
            });
            var query = (0, _json2mq["default"])({
              minWidth: breakpoints2.slice(-1)[0]
            });
            (0, _innerSliderUtils.canUseDOM)() && this.media(query, function() {
              _this2.setState({
                breakpoint: null
              });
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this._responsiveMediaHandlers.forEach(function(obj) {
            enquire.unregister(obj.query, obj.handler);
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;
          var settings;
          var newProps;
          if (this.state.breakpoint) {
            newProps = this.props.responsive.filter(function(resp) {
              return resp.breakpoint === _this3.state.breakpoint;
            });
            settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread2(_objectSpread2(_objectSpread2({}, _defaultProps["default"]), this.props), newProps[0].settings);
          } else {
            settings = _objectSpread2(_objectSpread2({}, _defaultProps["default"]), this.props);
          }
          if (settings.centerMode) {
            if (settings.slidesToScroll > 1 && process$1.env.NODE_ENV !== "production") {
              console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
            }
            settings.slidesToScroll = 1;
          }
          if (settings.fade) {
            if (settings.slidesToShow > 1 && process$1.env.NODE_ENV !== "production") {
              console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
            }
            if (settings.slidesToScroll > 1 && process$1.env.NODE_ENV !== "production") {
              console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
            }
            settings.slidesToShow = 1;
            settings.slidesToScroll = 1;
          }
          var children = _react["default"].Children.toArray(this.props.children);
          children = children.filter(function(child) {
            if (typeof child === "string") {
              return !!child.trim();
            }
            return !!child;
          });
          if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
            console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
            settings.variableWidth = false;
          }
          var newChildren = [];
          var currentWidth = null;
          for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
            var newSlide = [];
            for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
              var row = [];
              for (var k = j; k < j + settings.slidesPerRow; k += 1) {
                if (settings.variableWidth && children[k].props.style) {
                  currentWidth = children[k].props.style.width;
                }
                if (k >= children.length) break;
                row.push(/* @__PURE__ */ _react["default"].cloneElement(children[k], {
                  key: 100 * i + 10 * j + k,
                  tabIndex: -1,
                  style: {
                    width: "".concat(100 / settings.slidesPerRow, "%"),
                    display: "inline-block"
                  }
                }));
              }
              newSlide.push(/* @__PURE__ */ _react["default"].createElement("div", {
                key: 10 * i + j
              }, row));
            }
            if (settings.variableWidth) {
              newChildren.push(/* @__PURE__ */ _react["default"].createElement("div", {
                key: i,
                style: {
                  width: currentWidth
                }
              }, newSlide));
            } else {
              newChildren.push(/* @__PURE__ */ _react["default"].createElement("div", {
                key: i
              }, newSlide));
            }
          }
          if (settings === "unslick") {
            var className2 = "regular slider " + (this.props.className || "");
            return /* @__PURE__ */ _react["default"].createElement("div", {
              className: className2
            }, children);
          } else if (newChildren.length <= settings.slidesToShow) {
            settings.unslick = true;
          }
          return /* @__PURE__ */ _react["default"].createElement(_innerSlider.InnerSlider, _extends2({
            style: this.props.style,
            ref: this.innerSliderRefHandler
          }, settings), newChildren);
        }
      }]);
      return Slider3;
    }(_react["default"].Component);
    exports["default"] = Slider2;
  })(slider);
  return slider;
}
var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib;
  hasRequiredLib = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = void 0;
    var _slider = _interopRequireDefault(requireSlider());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var _default = _slider["default"];
    exports["default"] = _default;
  })(lib);
  return lib;
}
var libExports = requireLib();
const Slider = /* @__PURE__ */ getDefaultExportFromCjs$1(libExports);
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r2 = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r2:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r2;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r2 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process$1.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object2.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process$1.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process$1.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process$1.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process$1.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process$1.env.NODE_ENV !== "production") {
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process$1.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process$1.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process$1.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process$1.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode2(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode2(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode2);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode2(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode2(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process$1.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs$1(propTypesExports);
const PREFIX = "nl";
const BREAKPOINTS = {
  mobileMaxWidth: 767,
  // anything above 768 will be treated as tablet
  mobileMinWidth: 375,
  tabletMaxWidth: 1279,
  // anything above 1279 will be treated as desktop,
  mobilePortrait: 414,
  mobileLandscape: 667,
  tabletPortrait: 768,
  // tablet min
  tabletLandscape: 1025,
  desktopMin: 1200,
  desktopStandard: 1920,
  desktopLarg: 2560
};
const pageTypes$1 = {
  pdpPage: "product",
  storeLocator: "store locator page",
  brandCategoryPage: "brandcategorylisting",
  eventListing: "eventlisting",
  promoListing: "promolisting",
  wishlist: "wishlist",
  shoppingCart: "cart"
};
var FeeType$1 = /* @__PURE__ */ ((FeeType2) => {
  FeeType2["ECO_FEE"] = "ECO_FEE";
  FeeType2["CORE_CHARGE"] = "CORE_CHARGE";
  FeeType2["TIRE_RECYCLE_FEE"] = "TIRE_RECYCLE_FEE";
  return FeeType2;
})(FeeType$1 || {});
const previousElementName = "data-previous-focused-ele";
const MODAL_OPEN_CLASS$1 = "modal-open";
var CardType$1 = /* @__PURE__ */ ((CardType2) => {
  CardType2["visa"] = "visa";
  CardType2["master"] = "mastercard";
  CardType2["amex"] = "amex";
  CardType2["triangle"] = "triangle";
  CardType2["paypal"] = "paypal";
  return CardType2;
})(CardType$1 || {});
var CommonClass = /* @__PURE__ */ ((CommonClass2) => {
  CommonClass2["link"] = "nl-link";
  return CommonClass2;
})(CommonClass || {});
var PaymentFlowType = /* @__PURE__ */ ((PaymentFlowType2) => {
  PaymentFlowType2["BILLING_ADDRESS"] = "BILLING_ADDRESS";
  PaymentFlowType2["PLACE_ORDER"] = "PLACE_ORDER";
  PaymentFlowType2["NORMAL"] = "NORMAL";
  return PaymentFlowType2;
})(PaymentFlowType || {});
var magicNumber = /* @__PURE__ */ ((magicNumber2) => {
  magicNumber2[magicNumber2["MINUS_FIVETHOUSAND"] = -5e3] = "MINUS_FIVETHOUSAND";
  magicNumber2[magicNumber2["MINUS_ONEHUNDREDFIFTY"] = -150] = "MINUS_ONEHUNDREDFIFTY";
  magicNumber2[magicNumber2["MINUS_NINE"] = -9] = "MINUS_NINE";
  magicNumber2[magicNumber2["MINUS_FIVE"] = -5] = "MINUS_FIVE";
  magicNumber2[magicNumber2["MINUS_FOUR"] = -4] = "MINUS_FOUR";
  magicNumber2[magicNumber2["MINUS_THREE"] = -3] = "MINUS_THREE";
  magicNumber2[magicNumber2["MINUS_TWO"] = -2] = "MINUS_TWO";
  magicNumber2[magicNumber2["MINUS_ONE"] = -1] = "MINUS_ONE";
  magicNumber2[magicNumber2["ZERO"] = 0] = "ZERO";
  magicNumber2[magicNumber2["ONE"] = 1] = "ONE";
  magicNumber2[magicNumber2["TWO"] = 2] = "TWO";
  magicNumber2[magicNumber2["THREE"] = 3] = "THREE";
  magicNumber2[magicNumber2["FOUR"] = 4] = "FOUR";
  magicNumber2[magicNumber2["FIVE"] = 5] = "FIVE";
  magicNumber2[magicNumber2["SIX"] = 6] = "SIX";
  magicNumber2[magicNumber2["SEVEN"] = 7] = "SEVEN";
  magicNumber2[magicNumber2["EIGHT"] = 8] = "EIGHT";
  magicNumber2[magicNumber2["NINE"] = 9] = "NINE";
  magicNumber2[magicNumber2["TEN"] = 10] = "TEN";
  magicNumber2[magicNumber2["ELEVEN"] = 11] = "ELEVEN";
  magicNumber2[magicNumber2["TWELVE"] = 12] = "TWELVE";
  magicNumber2[magicNumber2["THIRTEEN"] = 13] = "THIRTEEN";
  magicNumber2[magicNumber2["FOURTEEN"] = 14] = "FOURTEEN";
  magicNumber2[magicNumber2["FIFTEEN"] = 15] = "FIFTEEN";
  magicNumber2[magicNumber2["SIXTEEN"] = 16] = "SIXTEEN";
  magicNumber2[magicNumber2["EIGHTEEN"] = 18] = "EIGHTEEN";
  magicNumber2[magicNumber2["TWENTY"] = 20] = "TWENTY";
  magicNumber2[magicNumber2["TWENTYFOUR"] = 24] = "TWENTYFOUR";
  magicNumber2[magicNumber2["TWENTYFIVE"] = 25] = "TWENTYFIVE";
  magicNumber2[magicNumber2["THIRTY"] = 30] = "THIRTY";
  magicNumber2[magicNumber2["THIRTYONE"] = 31] = "THIRTYONE";
  magicNumber2[magicNumber2["THIRTYSIX"] = 36] = "THIRTYSIX";
  magicNumber2[magicNumber2["FORTY"] = 40] = "FORTY";
  magicNumber2[magicNumber2["FORTYFIVE"] = 45] = "FORTYFIVE";
  magicNumber2[magicNumber2["FIFTY"] = 50] = "FIFTY";
  magicNumber2[magicNumber2["SIXTY"] = 60] = "SIXTY";
  magicNumber2[magicNumber2["SEVENTY"] = 70] = "SEVENTY";
  magicNumber2[magicNumber2["EIGHTY"] = 80] = "EIGHTY";
  magicNumber2[magicNumber2["HUNDRED"] = 100] = "HUNDRED";
  magicNumber2[magicNumber2["ONEHUNDREDFIFTY"] = 150] = "ONEHUNDREDFIFTY";
  magicNumber2[magicNumber2["TWOHUNDRED"] = 200] = "TWOHUNDRED";
  magicNumber2[magicNumber2["THREEHUNDRED"] = 300] = "THREEHUNDRED";
  magicNumber2[magicNumber2["FOURHUNDREDFOUR"] = 404] = "FOURHUNDREDFOUR";
  magicNumber2[magicNumber2["SIXHUNDRED"] = 600] = "SIXHUNDRED";
  magicNumber2[magicNumber2["SEVENHUNDREDSIXTYEIGHT"] = 768] = "SEVENHUNDREDSIXTYEIGHT";
  magicNumber2[magicNumber2["NINEHUNDREDNINTYNINE"] = 999] = "NINEHUNDREDNINTYNINE";
  magicNumber2[magicNumber2["THOUSAND"] = 1e3] = "THOUSAND";
  magicNumber2[magicNumber2["ONETHOUSAND"] = 1e3] = "ONETHOUSAND";
  magicNumber2[magicNumber2["THOUSANDTWOHUNDRED"] = 1200] = "THOUSANDTWOHUNDRED";
  magicNumber2[magicNumber2["TWOTHOUSAND"] = 2e3] = "TWOTHOUSAND";
  magicNumber2[magicNumber2["FIVETHOUSAND"] = 5e3] = "FIVETHOUSAND";
  magicNumber2[magicNumber2["SIXTHOUSAND"] = 6e3] = "SIXTHOUSAND";
  magicNumber2[magicNumber2["TENTHOUSAND"] = 1e4] = "TENTHOUSAND";
  magicNumber2[magicNumber2["SIXTYTHOUSAND"] = 6e4] = "SIXTYTHOUSAND";
  magicNumber2[magicNumber2["ONEMILLION"] = 1e6] = "ONEMILLION";
  magicNumber2[magicNumber2["MILLISINDAY"] = 864e5] = "MILLISINDAY";
  magicNumber2[magicNumber2["MILLISINHOUR"] = 36e5] = "MILLISINHOUR";
  magicNumber2[magicNumber2["MILLISINMINUTE"] = 6e4] = "MILLISINMINUTE";
  return magicNumber2;
})(magicNumber || {});
const generateId = () => {
  return `-${Math.random().toString(magicNumber.THIRTYSIX).substr(magicNumber.TWO, magicNumber.NINE)}`;
};
const Icon = ({
  type = "ct-accounts",
  size = "lg",
  title,
  path,
  decorative = true,
  iconSpritePath = "/icon/global-icons.svg"
  // this needs to be passed from the parent component, putting a default value here for now
}) => {
  const elementRef = useRef(null);
  const divElement = elementRef.current;
  let parentElementhasLink = false;
  if (divElement) {
    const parentElement = divElement.parentElement;
    const parentElementhasAnchor = divElement.parentNode.nodeName.toLowerCase() === "a";
    if (parentElementhasAnchor) {
      parentElementhasLink = parentElement.hasAttribute("href");
    }
  }
  const hrefLink = !path ? `${iconSpritePath}#${type}` : `${path}#${type}`;
  const id = generateId();
  const useElement = title ? /* @__PURE__ */ jsx("use", { xlinkHref: hrefLink, children: /* @__PURE__ */ jsx("title", { children: title }) }) : /* @__PURE__ */ jsx("use", { xlinkHref: hrefLink });
  const renderParentLink = () => {
    return !parentElementhasLink ? /* @__PURE__ */ jsx(
      "svg",
      {
        className: `${PREFIX}-icon  ${PREFIX}-icon-${type} ${PREFIX}-icon--${size} `,
        ref: elementRef,
        "aria-labelledby": `${type}-Title${id}`,
        role: "img",
        children: useElement
      }
    ) : /* @__PURE__ */ jsx(
      "svg",
      {
        className: `${PREFIX}-icon  ${PREFIX}-icon-${type} ${PREFIX}-icon--${size} `,
        ref: elementRef,
        role: "img",
        children: useElement
      }
    );
  };
  const icon = !decorative ? renderParentLink() : /* @__PURE__ */ jsx(
    "svg",
    {
      "aria-hidden": "true",
      "data-testid": `icon-${type}-hidden`,
      className: `${PREFIX}-icon  ${PREFIX}-icon-${type} ${PREFIX}-icon--${size} `,
      ref: elementRef,
      children: useElement
    }
  );
  const showcase = icon;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    " ",
    showcase
  ] });
};
Icon.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  size: PropTypes.string,
  path: PropTypes.string,
  decorative: PropTypes.bool,
  iconSpritePath: PropTypes.string
};
Icon.displayName = "Icon";
var Size = /* @__PURE__ */ ((Size2) => {
  Size2["MINI"] = "mini";
  Size2["XXS"] = "xxs";
  Size2["XS"] = "xs";
  Size2["SMALL"] = "sm";
  Size2["MEDIUM"] = "md";
  Size2["LARGE"] = "lg";
  Size2["XL"] = "xl";
  Size2["XXL"] = "xxl";
  Size2["XXXL"] = "xxxl";
  Size2["XXXXL"] = "xxxxl";
  return Size2;
})(Size || {});
var SizeReverse = /* @__PURE__ */ ((SizeReverse2) => {
  SizeReverse2["MINI"] = "minir";
  SizeReverse2["XS"] = "xsr";
  SizeReverse2["SMALL"] = "smr";
  SizeReverse2["MEDIUM"] = "mdr";
  SizeReverse2["LARGE"] = "lgr";
  SizeReverse2["XL"] = "xlr";
  SizeReverse2["XXL"] = "xxlr";
  return SizeReverse2;
})(SizeReverse || {});
var Variation = /* @__PURE__ */ ((Variation2) => {
  Variation2["PRIMARY"] = "primary";
  Variation2["SECONDARY"] = "secondary";
  Variation2["TERTIARY"] = "tertiary";
  return Variation2;
})(Variation || {});
var Direction = /* @__PURE__ */ ((Direction2) => {
  Direction2["HORIZONTAL"] = "horizontal";
  Direction2["VERTICAL"] = "vertical";
  return Direction2;
})(Direction || {});
var Position = /* @__PURE__ */ ((Position2) => {
  Position2["LEFT"] = "left";
  Position2["RIGHT"] = "right";
  Position2["TOP"] = "top";
  Position2["BOTTOM"] = "bottom";
  Position2["ALL"] = "all";
  Position2["CENTER"] = "center";
  Position2["X_AXIS"] = "x";
  Position2["Y_AXIS"] = "y";
  return Position2;
})(Position || {});
var Display = /* @__PURE__ */ ((Display2) => {
  Display2["NONE"] = "none";
  Display2["CUSTOM"] = "custom";
  return Display2;
})(Display || {});
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["PROGRESS"] = "In Progress";
  Status2["DONE"] = "Done";
  Status2["FAILED"] = "failed";
  Status2["SUCCESS"] = "success";
  Status2["ERROR"] = "error";
  Status2["START"] = "start";
  Status2["RESET"] = "reset";
  return Status2;
})(Status || {});
var State = /* @__PURE__ */ ((State2) => {
  State2["SUCCESS"] = "success";
  State2["CAUTION"] = "caution";
  State2["CRITICAL"] = "critical";
  State2["ERROR"] = "error";
  State2["INFO"] = "information";
  State2["DEFAULT"] = "default";
  State2["ACTIVE"] = "active";
  return State2;
})(State || {});
var Animation$1 = /* @__PURE__ */ ((Animation2) => {
  Animation2["PULSE"] = "pulse";
  Animation2["BOUNCE"] = "bounce";
  Animation2["PING"] = "ping";
  Animation2["BLINK"] = "blink";
  Animation2["NONE"] = "none";
  return Animation2;
})(Animation$1 || {});
var Shapes = /* @__PURE__ */ ((Shapes2) => {
  Shapes2["CIRCLE"] = "circle";
  return Shapes2;
})(Shapes || {});
var Radius = /* @__PURE__ */ ((Radius2) => {
  Radius2["NONE"] = "none";
  Radius2["ROUNDED_XS"] = "rounded-xs";
  Radius2["ROUNDED_SM"] = "rounded-sm";
  Radius2["ROUNDED_MD"] = "rounded-md";
  Radius2["ROUNDED_LG"] = "rounded-lg";
  Radius2["ROUNDED_XL"] = "rounded-xl";
  Radius2["CIRCLE"] = "circle";
  return Radius2;
})(Radius || {});
var Shadow = /* @__PURE__ */ ((Shadow2) => {
  Shadow2["MEDIUM"] = "shadow-medium";
  Shadow2["REGULAR"] = "shadow-regular";
  Shadow2["MAXIMUM"] = "shadow-maximum";
  Shadow2["BASE"] = "drop-shadow";
  return Shadow2;
})(Shadow || {});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["BUTTON"] = "button";
  Role2["ALERT"] = "alert";
  Role2["CHECKBOX"] = "checkbox";
  Role2["DIALOG"] = "dialog";
  Role2["LINK"] = "link";
  Role2["MENUITEM"] = "menuitem";
  Role2["MENUCHECKBOX"] = "menuitemcheckbox";
  Role2["MENURADIO"] = "menuitemradio";
  Role2["OPTION"] = "option";
  Role2["PROGRESSBAR"] = "progressbar";
  Role2["RADIO"] = "radio";
  Role2["SCROLLBAR"] = "scrollbar";
  Role2["SPINBUTTON"] = "spinbutton";
  Role2["STATUS"] = "status";
  Role2["TAB"] = "tab";
  Role2["TABPANEL"] = "tabpanel";
  Role2["TABLIST"] = "tablist";
  Role2["TEXTBOX"] = "textbox";
  Role2["TOOLTIP"] = "tooltip";
  Role2["GROUP"] = "group";
  return Role2;
})(Role || {});
var Events = /* @__PURE__ */ ((Events2) => {
  Events2["CLICK"] = "click";
  Events2["KEYDOWN"] = "keydown";
  return Events2;
})(Events || {});
var Live = /* @__PURE__ */ ((Live2) => {
  Live2["ASSERTIVE"] = "assertive";
  Live2["POLITE"] = "polite";
  Live2["OFF"] = "off";
  return Live2;
})(Live || {});
const BaseIcon = ({ ...props }) => {
  const {
    shape = Shapes.CIRCLE,
    size = Size.SMALL,
    animation: { type = Animation$1.NONE, isInfinite = true },
    isOutline = false,
    position = Position.CENTER
  } = props;
  const iconClassBase = `${PREFIX}-icon`;
  const animateClassBase = `${PREFIX}-animate`;
  const iconShape = `${iconClassBase}--${shape}`;
  const iconSize = `${iconClassBase}--${size}`;
  const iconPosition = `${iconClassBase}--position-${position}`;
  const iconStyle = `${iconClassBase}--${isOutline ? "outline" : "solid"}`;
  const animationType = type !== Animation$1.NONE ? ` ${animateClassBase}--${type}` : "";
  const isAnimationInfinite = isInfinite ? ` ${animateClassBase}--infinite` : "";
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: `${iconPosition} ${iconShape} ${iconSize} ${iconStyle}${animationType}${isAnimationInfinite}`
    }
  );
};
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */
const {
  entries,
  setPrototypeOf,
  isFrozen,
  getPrototypeOf,
  getOwnPropertyDescriptor
} = Object;
let {
  freeze,
  seal,
  create
} = Object;
let {
  apply,
  construct
} = typeof Reflect !== "undefined" && Reflect;
if (!freeze) {
  freeze = function freeze2(x) {
    return x;
  };
}
if (!seal) {
  seal = function seal2(x) {
    return x;
  };
}
if (!apply) {
  apply = function apply2(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
if (!construct) {
  construct = function construct2(Func, args) {
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const arraySplice = unapply(Array.prototype.splice);
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
function unapply(func) {
  return function(thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return apply(func, thisArg, args);
  };
}
function unconstruct(func) {
  return function() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return construct(func, args);
  };
}
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    setPrototypeOf(set, null);
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === "string") {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
function cleanArray(array) {
  for (let index2 = 0; index2 < array.length; index2++) {
    const isPropertyExist = objectHasOwnProperty(array, index2);
    if (!isPropertyExist) {
      array[index2] = null;
    }
  }
  return array;
}
function clone(object2) {
  const newObject = create(null);
  for (const [property, value] of entries(object2)) {
    const isPropertyExist = objectHasOwnProperty(object2, property);
    if (isPropertyExist) {
      if (Array.isArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === "object" && value.constructor === Object) {
        newObject[property] = clone(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
function lookupGetter(object2, prop) {
  while (object2 !== null) {
    const desc = getOwnPropertyDescriptor(object2, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === "function") {
        return unapply(desc.value);
      }
    }
    object2 = getPrototypeOf(object2);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}
const html$1 = freeze(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]);
const svg$1 = freeze(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]);
const svgFilters = freeze(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]);
const svgDisallowed = freeze(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]);
const mathMl$1 = freeze(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]);
const mathMlDisallowed = freeze(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]);
const text = freeze(["#text"]);
const html = freeze(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]);
const svg$2 = freeze(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]);
const mathMl = freeze(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]);
const xml = freeze(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]);
const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm);
const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm);
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
const ARIA_ATTR = seal(/^aria-[\-\w]+$/);
const IS_ALLOWED_URI = seal(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var EXPRESSIONS = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR,
  ATTR_WHITESPACE,
  CUSTOM_ELEMENT,
  DATA_ATTR,
  DOCTYPE_NAME,
  ERB_EXPR,
  IS_ALLOWED_URI,
  IS_SCRIPT_OR_DATA,
  MUSTACHE_EXPR,
  TMPLIT_EXPR
});
const NODE_TYPE = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
};
const getGlobal = function getGlobal2() {
  return typeof window === "undefined" ? null : window;
};
const _createTrustedTypesPolicy = function _createTrustedTypesPolicy2(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") {
    return null;
  }
  let suffix = null;
  const ATTR_NAME = "data-tt-policy-suffix";
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = "dompurify" + (suffix ? "#" + suffix : "");
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html2) {
        return html2;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    console.warn("TrustedTypes policy " + policyName + " could not be created.");
    return null;
  }
};
const _createHooksMap = function _createHooksMap2() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function createDOMPurify() {
  let window2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
  const DOMPurify = (root) => createDOMPurify(root);
  DOMPurify.version = "3.2.4";
  DOMPurify.removed = [];
  if (!window2 || !window2.document || window2.document.nodeType !== NODE_TYPE.document || !window2.Element) {
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let {
    document: document2
  } = window2;
  const originalDocument = document2;
  const currentScript = originalDocument.currentScript;
  const {
    DocumentFragment,
    HTMLTemplateElement,
    Node: Node2,
    Element: Element2,
    NodeFilter,
    NamedNodeMap = window2.NamedNodeMap || window2.MozNamedAttrMap,
    HTMLFormElement,
    DOMParser,
    trustedTypes
  } = window2;
  const ElementPrototype = Element2.prototype;
  const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
  const remove = lookupGetter(ElementPrototype, "remove");
  const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
  const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
  const getParentNode = lookupGetter(ElementPrototype, "parentNode");
  if (typeof HTMLTemplateElement === "function") {
    const template = document2.createElement("template");
    if (template.content && template.content.ownerDocument) {
      document2 = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = "";
  const {
    implementation,
    createNodeIterator,
    createDocumentFragment,
    getElementsByTagName
  } = document2;
  const {
    importNode
  } = originalDocument;
  let hooks = _createHooksMap();
  DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: MUSTACHE_EXPR2,
    ERB_EXPR: ERB_EXPR2,
    TMPLIT_EXPR: TMPLIT_EXPR2,
    DATA_ATTR: DATA_ATTR2,
    ARIA_ATTR: ARIA_ATTR2,
    IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA2,
    ATTR_WHITESPACE: ATTR_WHITESPACE2,
    CUSTOM_ELEMENT: CUSTOM_ELEMENT2
  } = EXPRESSIONS;
  let {
    IS_ALLOWED_URI: IS_ALLOWED_URI$1
  } = EXPRESSIONS;
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg$2, ...mathMl, ...xml]);
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  let FORBID_TAGS = null;
  let FORBID_ATTR = null;
  let ALLOW_ARIA_ATTR = true;
  let ALLOW_DATA_ATTR = true;
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  let SAFE_FOR_TEMPLATES = false;
  let SAFE_FOR_XML = true;
  let WHOLE_DOCUMENT = false;
  let SET_CONFIG = false;
  let FORCE_BODY = false;
  let RETURN_DOM = false;
  let RETURN_DOM_FRAGMENT = false;
  let RETURN_TRUSTED_TYPE = false;
  let SANITIZE_DOM = true;
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
  let KEEP_CONTENT = true;
  let IN_PLACE = false;
  let USE_PROFILES = {};
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ["audio", "video", "img", "source", "image", "track"]);
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]);
  const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
  const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
  const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ["mi", "mo", "mn", "ms", "mtext"]);
  let HTML_INTEGRATION_POINTS = addToSet({}, ["annotation-xml"]);
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ["title", "style", "font", "a", "script"]);
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ["application/xhtml+xml", "text/html"];
  const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
  let transformCaseFunc = null;
  let CONFIG = null;
  const formElement = document2.createElement("form");
  const isRegexOrFunction = function isRegexOrFunction2(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  const _parseConfig = function _parseConfig2() {
    let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    if (!cfg || typeof cfg !== "object") {
      cfg = {};
    }
    cfg = clone(cfg);
    PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
    ALLOWED_TAGS = objectHasOwnProperty(cfg, "ALLOWED_TAGS") ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = objectHasOwnProperty(cfg, "ALLOWED_ATTR") ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
    ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, "ALLOWED_NAMESPACES") ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
    URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = objectHasOwnProperty(cfg, "ADD_DATA_URI_TAGS") ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
    FORBID_CONTENTS = objectHasOwnProperty(cfg, "FORBID_CONTENTS") ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
    FORBID_TAGS = objectHasOwnProperty(cfg, "FORBID_TAGS") ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
    FORBID_ATTR = objectHasOwnProperty(cfg, "FORBID_ATTR") ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
    USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
    RETURN_DOM = cfg.RETURN_DOM || false;
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
    FORCE_BODY = cfg.FORCE_BODY || false;
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
    IN_PLACE = cfg.IN_PLACE || false;
    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
    NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
    MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
    HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
    CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
    }
    if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
    }
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg$2);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg$2);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
    }
    if (cfg.FORBID_CONTENTS) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
    }
    if (KEEP_CONTENT) {
      ALLOWED_TAGS["#text"] = true;
    }
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ["html", "head", "body"]);
    }
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ["tbody"]);
      delete FORBID_TAGS.tbody;
    }
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      emptyHTML = trustedTypesPolicy.createHTML("");
    } else {
      if (trustedTypesPolicy === void 0) {
        trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      }
      if (trustedTypesPolicy !== null && typeof emptyHTML === "string") {
        emptyHTML = trustedTypesPolicy.createHTML("");
      }
    }
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  const _checkValidNamespace = function _checkValidNamespace2(element) {
    let parent = getParentNode(element);
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: "template"
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === "svg";
      }
      if (parent.namespaceURI === MATHML_NAMESPACE) {
        return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
      }
      return Boolean(ALL_SVG_TAGS[tagName]);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      if (parent.namespaceURI === HTML_NAMESPACE) {
        return tagName === "math";
      }
      if (parent.namespaceURI === SVG_NAMESPACE) {
        return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
      }
      return Boolean(ALL_MATHML_TAGS[tagName]);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
        return false;
      }
      return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
    }
    if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    return false;
  };
  const _forceRemove = function _forceRemove2(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      getParentNode(node).removeChild(node);
    } catch (_) {
      remove(node);
    }
  };
  const _removeAttribute = function _removeAttribute2(name, element) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: element.getAttributeNode(name),
        from: element
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: element
      });
    }
    element.removeAttribute(name);
    if (name === "is") {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {
        }
      } else {
        try {
          element.setAttribute(name, "");
        } catch (_) {
        }
      }
    }
  };
  const _initDocument = function _initDocument2(dirty) {
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = "<remove></remove>" + dirty;
    } else {
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) {
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
    }
    const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {
      }
    }
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, "template", null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document2.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  const _createNodeIterator = function _createNodeIterator2(root) {
    return createNodeIterator.call(
      root.ownerDocument || root,
      root,
      // eslint-disable-next-line no-bitwise
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION,
      null
    );
  };
  const _isClobbered = function _isClobbered2(element) {
    return element instanceof HTMLFormElement && (typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function");
  };
  const _isNode = function _isNode2(value) {
    return typeof Node2 === "function" && value instanceof Node2;
  };
  function _executeHooks(hooks2, currentNode, data) {
    arrayForEach(hooks2, (hook) => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  const _sanitizeElements = function _sanitizeElements2(currentNode) {
    let content = null;
    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    const tagName = transformCaseFunc(currentNode.nodeName);
    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }
    if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
      _forceRemove(currentNode);
      return true;
    }
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
      _forceRemove(currentNode);
      return true;
    }
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
          return false;
        }
        if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) {
          return false;
        }
      }
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
        const parentNode = getParentNode(currentNode) || currentNode.parentNode;
        const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
        if (childNodes && parentNode) {
          const childCount = childNodes.length;
          for (let i = childCount - 1; i >= 0; --i) {
            const childClone = cloneNode(childNodes[i], true);
            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
            parentNode.insertBefore(childClone, getNextSibling(currentNode));
          }
        }
      }
      _forceRemove(currentNode);
      return true;
    }
    if (currentNode instanceof Element2 && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      content = currentNode.textContent;
      arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
        content = stringReplace(content, expr, " ");
      });
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
    return false;
  };
  const _isValidAttribute = function _isValidAttribute2(lcTag, lcName, value) {
    if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document2 || value in formElement)) {
      return false;
    }
    if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR2, lcName)) ;
    else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR2, lcName)) ;
    else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))
      ) ;
      else {
        return false;
      }
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
    else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE2, ""))) ;
    else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
    else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA2, stringReplace(value, ATTR_WHITESPACE2, ""))) ;
    else if (value) {
      return false;
    } else ;
    return true;
  };
  const _isBasicCustomElement = function _isBasicCustomElement2(tagName) {
    return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT2);
  };
  const _sanitizeAttributes = function _sanitizeAttributes2(currentNode) {
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
    const {
      attributes
    } = currentNode;
    if (!attributes || _isClobbered(currentNode)) {
      return;
    }
    const hookEvent = {
      attrName: "",
      attrValue: "",
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: void 0
    };
    let l = attributes.length;
    while (l--) {
      const attr = attributes[l];
      const {
        name,
        namespaceURI,
        value: attrValue
      } = attr;
      const lcName = transformCaseFunc(name);
      let value = name === "value" ? attrValue : stringTrim(attrValue);
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = void 0;
      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
      value = hookEvent.attrValue;
      if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
        _removeAttribute(name, currentNode);
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
      }
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      _removeAttribute(name, currentNode);
      if (!hookEvent.keepAttr) {
        continue;
      }
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }
      if (SAFE_FOR_TEMPLATES) {
        arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
          value = stringReplace(value, expr, " ");
        });
      }
      const lcTag = transformCaseFunc(currentNode.nodeName);
      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }
      if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
        if (namespaceURI) ;
        else {
          switch (trustedTypes.getAttributeType(lcTag, lcName)) {
            case "TrustedHTML": {
              value = trustedTypesPolicy.createHTML(value);
              break;
            }
            case "TrustedScriptURL": {
              value = trustedTypesPolicy.createScriptURL(value);
              break;
            }
          }
        }
      }
      try {
        if (namespaceURI) {
          currentNode.setAttributeNS(namespaceURI, name, value);
        } else {
          currentNode.setAttribute(name, value);
        }
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
        } else {
          arrayPop(DOMPurify.removed);
        }
      } catch (_) {
      }
    }
    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  const _sanitizeShadowDOM = function _sanitizeShadowDOM2(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      _sanitizeElements(shadowNode);
      _sanitizeAttributes(shadowNode);
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM2(shadowNode.content);
      }
    }
    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  };
  DOMPurify.sanitize = function(dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = "<!-->";
    }
    if (typeof dirty !== "string" && !_isNode(dirty)) {
      if (typeof dirty.toString === "function") {
        dirty = dirty.toString();
        if (typeof dirty !== "string") {
          throw typeErrorCreate("dirty is not a string, aborting");
        }
      } else {
        throw typeErrorCreate("toString is not a function");
      }
    }
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    DOMPurify.removed = [];
    if (typeof dirty === "string") {
      IN_PLACE = false;
    }
    if (IN_PLACE) {
      if (dirty.nodeName) {
        const tagName = transformCaseFunc(dirty.nodeName);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
        }
      }
    } else if (dirty instanceof Node2) {
      body = _initDocument("<!---->");
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") {
        body = importedNode;
      } else if (importedNode.nodeName === "HTML") {
        body = importedNode;
      } else {
        body.appendChild(importedNode);
      }
    } else {
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf("<") === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      body = _initDocument(dirty);
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
      }
    }
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
    while (currentNode = nodeIterator.nextNode()) {
      _sanitizeElements(currentNode);
      _sanitizeAttributes(currentNode);
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }
    }
    if (IN_PLACE) {
      return dirty;
    }
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
    }
    if (SAFE_FOR_TEMPLATES) {
      arrayForEach([MUSTACHE_EXPR2, ERB_EXPR2, TMPLIT_EXPR2], (expr) => {
        serializedHTML = stringReplace(serializedHTML, expr, " ");
      });
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function() {
    let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
  };
  DOMPurify.clearConfig = function() {
    CONFIG = null;
    SET_CONFIG = false;
  };
  DOMPurify.isValidAttribute = function(tag, attr, value) {
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function(entryPoint, hookFunction) {
    if (typeof hookFunction !== "function") {
      return;
    }
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function(entryPoint, hookFunction) {
    if (hookFunction !== void 0) {
      const index2 = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index2 === -1 ? void 0 : arraySplice(hooks[entryPoint], index2, 1)[0];
    }
    return arrayPop(hooks[entryPoint]);
  };
  DOMPurify.removeHooks = function(entryPoint) {
    hooks[entryPoint] = [];
  };
  DOMPurify.removeAllHooks = function() {
    hooks = _createHooksMap();
  };
  return DOMPurify;
}
var purify = createDOMPurify();
const sanitizeStringContent = (stringContent) => {
  return purify.sanitize(stringContent);
};
const SanitizeStringContentWrapper = ({ stringContent, children }) => {
  const memoizedStringContent = useMemo(() => {
    return sanitizeStringContent(stringContent);
  }, [stringContent]);
  return children(memoizedStringContent);
};
SanitizeStringContentWrapper.displayName = "SanitizeStringContentWrapper";
const CategoryIcons = (props) => {
  const { name, url, size, type, onClick: onClick2, index: index2 } = props;
  return /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: url, children: (memoizedStringContent) => /* @__PURE__ */ jsxs("a", { href: memoizedStringContent, onClick: () => onClick2(name, index2), children: [
    /* @__PURE__ */ jsx(Icon, { size, type }),
    name
  ] }) });
};
const CarouselNavigationArrow = (props) => {
  const { className: className2, onClick: onClick2, type, size, ariaLabel, path } = props;
  return /* @__PURE__ */ jsx("button", { className: className2, onClick: onClick2, "aria-label": ariaLabel, children: /* @__PURE__ */ jsx(Icon, { type, size, path }) });
};
CarouselNavigationArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  path: PropTypes.string
};
const currencyShortForm = "CA";
const currencyFormat = "CAD";
const digitsPattern = /[^0-9]/g;
const defaultLocale$1 = "en";
const frenchLocale = "fr";
const googleMapsUrl = "http://maps.google.com?q=";
var countryCode = /* @__PURE__ */ ((countryCode2) => {
  countryCode2["ca"] = "ca";
  countryCode2["us"] = "us";
  return countryCode2;
})(countryCode || {});
const defaultCountryName = "Canada";
const autocompleteMinLength = 3;
const maximumAccountManagementLinks = 8;
const quebecIsocode = "CA-QC";
const verificationScreenInputsCount = 6;
const ariaType = "page";
const cardNumberRegEx = /^([\d\s])*$/;
const phoneNumberFormat = /^(\d{3})(\d{3})(\d{4})$/;
const phoneNumberPattern = "$1-$2-$3";
const AUTO_SERVICE_INSTALLATION_ID = "AUTO";
const formatPlaceholder = "*";
var multiLanguageLabel = /* @__PURE__ */ ((multiLanguageLabel2) => {
  multiLanguageLabel2["englishLangLabel"] = "EN";
  multiLanguageLabel2["frenchLangLabel"] = "FR";
  return multiLanguageLabel2;
})(multiLanguageLabel || {});
var linkTargetOptions = /* @__PURE__ */ ((linkTargetOptions2) => {
  linkTargetOptions2["selfTarget"] = "_self";
  linkTargetOptions2["newTarget"] = "_blank";
  return linkTargetOptions2;
})(linkTargetOptions || {});
var checkToggle = /* @__PURE__ */ ((checkToggle2) => {
  checkToggle2["yes"] = "Y";
  checkToggle2["no"] = "N";
  checkToggle2["noLabel"] = "no";
  return checkToggle2;
})(checkToggle || {});
const accountsPageUrlPattern = {
  en: "/account/",
  fr: "/compte/"
};
const myAccountsPageUrlPattern = {
  en: "/my-account/",
  fr: "/mon-compte/"
};
var dashboardBannerTypes = /* @__PURE__ */ ((dashboardBannerTypes2) => {
  dashboardBannerTypes2["dashboard"] = "dashboard";
  dashboardBannerTypes2["selectDashboard"] = "triangle-select-dashboard";
  dashboardBannerTypes2["selectAllTimeDashboard"] = "triangle-select-dashboard-allTime";
  return dashboardBannerTypes2;
})(dashboardBannerTypes || {});
const recommendationQueryParam = "?rrec=true";
const subscriptionStatus = {
  active: "A",
  expired: "E"
};
const subscriptionType = {
  freeTrial: "trial",
  regular: "regular"
};
const componentType = {
  default: "default",
  triangleSelect: "triangle-select",
  triangleSelectSubscription: "triangle-select-subscription"
};
const geocode = "geocode";
const replaceNumberFormattedPrice = /[^0-9.-]+/g;
const replaceCardValue = /x/g;
const statusLabel = {
  activateStatus: "Activate",
  activatedStatus: "Activated",
  redeemedStatus: "Redeemed",
  swapOfferStatus: "Swap"
};
var userLoginStatus = /* @__PURE__ */ ((userLoginStatus2) => {
  userLoginStatus2["fullyAuthenticatedUser"] = "AUTHORIZED";
  userLoginStatus2["partiallyAuthenticatedUser"] = "REMEMBER_ME";
  userLoginStatus2["guestUser"] = "ANONYMOUS";
  return userLoginStatus2;
})(userLoginStatus || {});
const canadaPostApi = {
  next: "Find",
  retrieve: "Retrieve",
  canadaPostAPIDebounce: 500,
  postalCodeMaxLength: 5,
  unity: 1
};
const LESS = "LESS";
const PERCENT = "[percent]";
const CUT = "[cut]";
const EMPTY_STRING = "";
const DOLLAR_SYMBOL = "$";
const FORWARD_SLASH = "/";
var colorComboType = /* @__PURE__ */ ((colorComboType2) => {
  colorComboType2["NAVY_TEAL"] = "navyTeal";
  colorComboType2["TEAL_NAVY"] = "tealNavy";
  colorComboType2["LIMESTONE_TEAL"] = "limestoneTeal";
  colorComboType2["TEAL_WHITE"] = "tealWhite";
  return colorComboType2;
})(colorComboType || {});
const colorCombos = {
  navyTeal: {
    fill: "#051C2C",
    stroke: "#00C4B8"
  },
  tealNavy: {
    fill: "#00C4B8",
    stroke: "#051C2C"
  },
  limestoneTeal: {
    fill: "#838074",
    stroke: "#BAFAF6"
  },
  tealWhite: {
    fill: "#00897D",
    stroke: "#FFFFFF"
  }
};
var OSType = /* @__PURE__ */ ((OSType2) => {
  OSType2["android"] = "android";
  OSType2["ios"] = "iOS";
  OSType2["macOS"] = "macOS";
  return OSType2;
})(OSType || {});
var BannerViewType = /* @__PURE__ */ ((BannerViewType2) => {
  BannerViewType2["DEFAULT"] = "default";
  BannerViewType2["CT_MONEY_EARNINGS"] = "ctMoneyEarnings";
  return BannerViewType2;
})(BannerViewType || {});
const baseCTFSInputStyles = {
  width: "100%",
  height: "3.25rem",
  cursor: "pointer",
  padding: "0 0 0 8px",
  border: "0",
  outline: "none",
  "font-size": "0.875rem",
  "line-height": "1.25rem",
  "font-weight": "400",
  "font-family": '"Lato", sans-serif',
  "margin-top": "0",
  "background-color": "#f8f8f8",
  placeholder: {
    color: "#505050"
  },
  valid: {
    "background-color": "#f8f8f8"
  },
  error: {
    "background-color": "#fae1e0"
  }
};
var shippingAddressErrorCodes = /* @__PURE__ */ ((shippingAddressErrorCodes2) => {
  shippingAddressErrorCodes2["addressLineOne"] = "00600";
  shippingAddressErrorCodes2["city"] = "00601";
  shippingAddressErrorCodes2["province"] = "00602";
  shippingAddressErrorCodes2["street"] = "00603";
  shippingAddressErrorCodes2["postalCode"] = "00604";
  shippingAddressErrorCodes2["addressPOBox"] = "00616";
  shippingAddressErrorCodes2["addressQuebec"] = "00618";
  return shippingAddressErrorCodes2;
})(shippingAddressErrorCodes || {});
var errorCodes = /* @__PURE__ */ ((errorCodes2) => {
  errorCodes2["error00001"] = "00001";
  errorCodes2["error00106"] = "00106";
  errorCodes2["error00211"] = "00211";
  errorCodes2["error00121"] = "00121";
  errorCodes2["error00122"] = "00122";
  errorCodes2["error00000"] = "00000";
  errorCodes2["error00055"] = "00055";
  errorCodes2["error00129"] = "00129";
  errorCodes2["error00130"] = "00130";
  errorCodes2["error00140"] = "00140";
  errorCodes2["error00141"] = "00141";
  errorCodes2["error00142"] = "00142";
  errorCodes2["error00143"] = "00143";
  errorCodes2["error00144"] = "00144";
  errorCodes2["error00145"] = "00145";
  errorCodes2["error00146"] = "00146";
  errorCodes2["error00030"] = "00030";
  errorCodes2["error00138"] = "00138";
  errorCodes2["error00043"] = "00043";
  errorCodes2["error00049"] = "00049";
  errorCodes2["error101"] = "101";
  errorCodes2["error400"] = "400";
  errorCodes2["errorPartialAuth"] = "00033";
  return errorCodes2;
})(errorCodes || {});
var errorOrderModificationCodes = /* @__PURE__ */ ((errorOrderModificationCodes2) => {
  errorOrderModificationCodes2["error00191"] = "00191";
  errorOrderModificationCodes2["error00192"] = "00192";
  errorOrderModificationCodes2["error00193"] = "00193";
  errorOrderModificationCodes2["error00194"] = "00194";
  errorOrderModificationCodes2["error00195"] = "00195";
  errorOrderModificationCodes2["error00196"] = "00196";
  errorOrderModificationCodes2["error00197"] = "00197";
  errorOrderModificationCodes2["error00198"] = "00198";
  errorOrderModificationCodes2["error00199"] = "00199";
  errorOrderModificationCodes2["error00214"] = "00214";
  return errorOrderModificationCodes2;
})(errorOrderModificationCodes || {});
var BrandingColors = /* @__PURE__ */ ((BrandingColors2) => {
  BrandingColors2["TEAL"] = "teal";
  BrandingColors2["RED"] = "red";
  BrandingColors2["BURGUNDY"] = "burgundy";
  BrandingColors2["WHITE"] = "white";
  BrandingColors2["GREY"] = "grey";
  BrandingColors2["GREEN"] = "green";
  return BrandingColors2;
})(BrandingColors || {});
const technicalDifficultiesErrCode = 500;
const localeCookieName = "CTC.locale";
const balanceCheckerScreen = {
  balanceScreen: "balanceScreen",
  errorScreen: "errorScreen",
  successScreen: "successScreen"
};
var Types = /* @__PURE__ */ ((Types2) => {
  Types2["String"] = "string";
  Types2["Number"] = "number";
  Types2["Boolean"] = "boolean";
  Types2["Object"] = "object";
  return Types2;
})(Types || {});
const dateOptions = {
  style1: {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC"
  },
  style2: {
    month: "long",
    day: "2-digit",
    year: "numeric",
    timeZone: "UTC"
  }
};
var TextInputModes = /* @__PURE__ */ ((TextInputModes2) => {
  TextInputModes2["SEARCH"] = "search";
  TextInputModes2["TEXT"] = "text";
  TextInputModes2["EMAIL"] = "email";
  TextInputModes2["TEL"] = "tel";
  TextInputModes2["URL"] = "url";
  TextInputModes2["NONE"] = "none";
  TextInputModes2["NUMERIC"] = "numeric";
  TextInputModes2["DECIMAL"] = "decimal";
  return TextInputModes2;
})(TextInputModes || {});
const hideClassName = "hide";
const dateFormatter = "do";
var CertonaConstants = /* @__PURE__ */ ((CertonaConstants2) => {
  CertonaConstants2["CURRENCY"] = "CAD";
  CertonaConstants2["STORE_ID"] = "CTR";
  return CertonaConstants2;
})(CertonaConstants || {});
var deviceTypes = /* @__PURE__ */ ((deviceTypes2) => {
  deviceTypes2["MOBILE"] = "mobile";
  deviceTypes2["TABLET"] = "tablet";
  deviceTypes2["DESKTOP"] = "desktop";
  return deviceTypes2;
})(deviceTypes || {});
const RoadRatingsImageSize = {
  width: 70,
  height: 70
};
var Symbols = /* @__PURE__ */ ((Symbols2) => {
  Symbols2["AMPERSAND"] = "&";
  Symbols2["QUESTION_MARK"] = "?";
  return Symbols2;
})(Symbols || {});
var offerTypes = /* @__PURE__ */ ((offerTypes2) => {
  offerTypes2["MULTIPLIER"] = "MULTIPLIER";
  offerTypes2["SPENDANDGET"] = "SPENDANDGET";
  return offerTypes2;
})(offerTypes || {});
const statusIcons = {
  successIcon: "ct-notification-success-green",
  cautionIcon: "ct-notification-caution",
  failureIcon: "ct-toast-error",
  infoIcon: "ct-information-blue",
  okIcon: "ct-ok"
};
const monthList = [
  { label: "01", value: "01" },
  { label: "02", value: "02" },
  { label: "03", value: "03" },
  { label: "04", value: "04" },
  { label: "05", value: "05" },
  { label: "06", value: "06" },
  { label: "07", value: "07" },
  { label: "08", value: "08" },
  { label: "09", value: "09" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" }
];
var FitmentTypeEnum = /* @__PURE__ */ ((FitmentTypeEnum2) => {
  FitmentTypeEnum2["UNIVERSAL_FIT_01"] = "01_UNIVERSAL_FIT";
  FitmentTypeEnum2["DIRECT_FIT_02"] = "02_DIRECT_FIT";
  FitmentTypeEnum2["VEH_COND_FIT_03"] = "03_VEH_COND_FIT";
  FitmentTypeEnum2["PROD_VEH_COND_FIT_04"] = "04_PROD_VEH_COND_FIT";
  FitmentTypeEnum2["PART_COND_FIT_05"] = "05_PART_COND_FIT";
  return FitmentTypeEnum2;
})(FitmentTypeEnum || {});
const BannerMapping = {
  LEQ: "LEQ",
  MRK: "MRK",
  CIRPP: "CIRPP",
  ANTU: "ANTU"
};
var commonIcons = /* @__PURE__ */ ((commonIcons2) => {
  commonIcons2["triangleMoney"] = "ct-triangleMoney";
  return commonIcons2;
})(commonIcons || {});
const PURCHASE_TYPE = "Purchase";
const REDEEM_TYPE = "Redeem";
const EMPTY_BANNER_TYPE = "DFLT";
const inflationData = {
  heliumAddOn: "HELIUM_ADDON"
};
var OtpErrorType = /* @__PURE__ */ ((OtpErrorType2) => {
  OtpErrorType2["INIT_ERROR"] = "initError";
  OtpErrorType2["PROCESSING_ERROR"] = "processingError";
  OtpErrorType2["ACTION_ERROR"] = "actionError";
  return OtpErrorType2;
})(OtpErrorType || {});
const otpErrorCodes = {
  [
    "initError"
    /* INIT_ERROR */
  ]: {
    validateUserOtp: "00242"
  },
  [
    "processingError"
    /* PROCESSING_ERROR */
  ]: {
    revokedOrInvalidToken: "400006",
    missingToken: "400002",
    maxAttemptsOnCodeReached: "00255"
  },
  [
    "actionError"
    /* ACTION_ERROR */
  ]: {
    frequencyLimitReached: "400125",
    maxAttemptsReached: "403000"
  }
};
const applyGiftCardErrorCodes = {
  invalidGiftCardNumber: 601,
  invalidGiftCardNumber610: 610,
  invalidGiftCardType: 602,
  giftCardAlreadyUsed: 604,
  incorrectGiftPin: 612
};
const daysCalculationConstants = {
  thousand: 1e3,
  totalSeconds: 3600,
  totalHours: 24,
  minutes: 60
};
const balloonEntryType = {
  prePackagedBalloonSku: "PRE_PACKAGED_BALLOON_SKU",
  preDesignedBalloonBouquet: "PRE_DESIGNED_BALLOON_BOUQUET"
};
const getCookieValue = (propertyTitle) => {
  var _a;
  const parts = document.cookie.split(";").filter((entry) => entry.includes(`${propertyTitle}=`));
  return (_a = parts.shift()) == null ? void 0 : _a.split("=").pop();
};
const getLanguage = () => {
  const htmlLang = document.documentElement.lang.toLowerCase();
  if (htmlLang !== multiLanguageLabel.frenchLangLabel.toLowerCase() && htmlLang !== multiLanguageLabel.englishLangLabel.toLowerCase()) {
    return getCookieValue(localeCookieName) || multiLanguageLabel.englishLangLabel.toLowerCase();
  } else {
    return htmlLang;
  }
};
const getCaLocale = () => getLanguage() === frenchLocale ? "fr-CA" : "en-CA";
const getUsLocale = () => getLanguage() === frenchLocale ? "fr-CA" : "en-US";
const defaultTime = "T00:00:00";
const dateDiffInDays = (date1, date2) => {
  const PER_DAY = magicNumber.THOUSAND * magicNumber.SIXTY * magicNumber.SIXTY * magicNumber.TWENTYFOUR;
  const requiredDateDifference = Math.ceil(Math.abs(Number(date2) - Number(date1)) / PER_DAY);
  return requiredDateDifference - requiredDateDifference % magicNumber.SEVEN;
};
const getDate$1 = (date) => {
  const dateFormat = /* @__PURE__ */ new Date(`${date}${defaultTime}`);
  return dateFormat.getDate();
};
const getActiveSlideIndex = (dateList, selectedDate) => {
  if ((dateList == null ? void 0 : dateList.length) && (selectedDate == null ? void 0 : selectedDate.length)) {
    return dateDiffInDays(/* @__PURE__ */ new Date(`${dateList[0].date}${defaultTime}`), /* @__PURE__ */ new Date(`${selectedDate}${defaultTime}`));
  }
  return 0;
};
const getWeekDayFormat = (date) => {
  return (/* @__PURE__ */ new Date(`${date}${defaultTime}`)).toLocaleString(getCaLocale(), { weekday: "short" }).toLocaleUpperCase().slice(0, magicNumber.THREE);
};
const getWeekDayMobileFormat = (date) => {
  return (/* @__PURE__ */ new Date(`${date}${defaultTime}`)).toLocaleString(getUsLocale(), { weekday: "short" }).toLocaleUpperCase().charAt(0);
};
const getIsMobile = () => {
  return window.innerWidth <= BREAKPOINTS.mobileMaxWidth;
};
const DatePicker = ({ ...props }) => {
  const { className: className2, selectedDate, dateList, onChangeDate } = props;
  const activeSlideIndex = useMemo(() => {
    return getActiveSlideIndex(dateList, selectedDate);
  }, [dateList, selectedDate]);
  const [isMobile2, setIsMobile] = useState(false);
  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 7,
    slidesToScroll: 7,
    nextArrow: /* @__PURE__ */ jsx(CarouselNavigationArrow, { type: "ct-chevron-right", size: "md" }),
    prevArrow: /* @__PURE__ */ jsx(CarouselNavigationArrow, { type: "ct-chevron-left", size: "md" }),
    initialSlide: activeSlideIndex
  };
  useEffect(() => {
    setIsMobile(getIsMobile());
  }, []);
  const onDateChangeHandler = (date) => {
    var _a;
    if (date.isOpen && ((_a = date.availableTimeSlotList) == null ? void 0 : _a.length) && date.date !== selectedDate) {
      onChangeDate(date.date);
    }
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Slider, { className: `date-carousel ${PREFIX}-carousel ${PREFIX}-date-carousel`, ...settings, children: dateList.map((date, i) => {
    var _a;
    return /* @__PURE__ */ jsxs("label", { "aria-label": `${date.dayOfWeek} ${date.date}`, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          "data-testid": date.date,
          type: "radio",
          name: "date",
          disabled: !(date.isOpen && ((_a = date.availableTimeSlotList) == null ? void 0 : _a.length) > 0),
          checked: date.date === selectedDate
        }
      ),
      /* @__PURE__ */ jsxs(
        "button",
        {
          className: `${PREFIX}-date__box ${className2 ? className2 : ""}`,
          onClick: () => onDateChangeHandler(date),
          "data-testid": `${date.dayOfWeek} ${date.date}__button`,
          children: [
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-week-date`, children: isMobile2 ? getWeekDayMobileFormat(date.date) : getWeekDayFormat(date.date) }),
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-numeral-date`, children: /* @__PURE__ */ jsx("span", { children: getDate$1(date.date) }) })
          ]
        }
      )
    ] }, i);
  }) }) });
};
DatePicker.propTypes = {
  className: PropTypes.string,
  selectedDate: PropTypes.string,
  dateList: PropTypes.array,
  onChangeDate: PropTypes.func
};
var classnamesExports = requireClassnames();
const classnames = /* @__PURE__ */ getDefaultExportFromCjs$1(classnamesExports);
const replaceStrWithDynamicVal = (message, dynamicVal) => message ? message.replace("[0]", `${dynamicVal}`) : "";
const replaceStrWithDynamicElement = (message, dynamicElem) => /* @__PURE__ */ jsx(Fragment, { children: (message || "").split("[0]").reduce(
  (arr, part, i, { length }) => arr.concat(/* @__PURE__ */ jsx(Fragment, { children: part })).concat(i + 1 < length ? dynamicElem : /* @__PURE__ */ jsx(Fragment, {})),
  []
) });
const replaceMultipleStrWithDynamicVal = (message, values) => {
  let finalString = message;
  values.forEach((val) => {
    finalString = replaceStrWithDynamicVal(finalString, val);
  });
  return finalString;
};
const addDynamicToken = (message, value) => message ? message.replace(value, "[0]") : "";
const collapseControl = (clickableItem, displayItem, plusIcon, minusIcon, IconHideClass, showSingleItem) => {
  const accEle = document.getElementsByClassName(clickableItem);
  const panelEle = document.getElementsByClassName(displayItem);
  const plusEle = document.getElementsByClassName(plusIcon);
  const minusEle = document.getElementsByClassName(minusIcon);
  const ariaExpanded = "aria-expanded";
  const buttonClickHandler = (buttonEle) => {
    buttonEle.onclick = function() {
      const firstEle = buttonEle.firstElementChild;
      const siblingEle = firstEle.nextElementSibling;
      const setClasses = !buttonEle.classList.contains("active");
      const nextEle = buttonEle.nextElementSibling;
      setClass(accEle, "active", "remove");
      setClass(panelEle, showSingleItem, "remove");
      setClass(plusEle, IconHideClass, "remove");
      setClass(minusEle, IconHideClass, "remove");
      if (setClasses) {
        setClass(minusEle, IconHideClass, "add");
        buttonEle.classList.toggle("active");
        buttonEle.setAttribute(ariaExpanded, "true");
        firstEle.classList.toggle(IconHideClass);
        nextEle.classList.toggle(showSingleItem);
        siblingEle.classList.remove(IconHideClass);
      } else {
        buttonEle.classList.remove("active");
        buttonEle.setAttribute(ariaExpanded, "false");
        setClass(panelEle, showSingleItem, "remove");
        setClass(minusEle, IconHideClass, "add");
        firstEle.classList.remove(IconHideClass);
        siblingEle.classList.add(IconHideClass);
      }
    };
  };
  for (let i = 0; i < accEle.length; i++) {
    const buttonEle = accEle[i];
    buttonEle.setAttribute(ariaExpanded, "false");
    buttonClickHandler(buttonEle);
  }
  const setClass = (els, className2, fnName) => {
    for (let i = 0; i < els.length; i++) {
      els[i].classList[fnName](className2);
    }
  };
};
const debounceTime = 300;
const scrollDebounceTime = 100;
const useThrottleWindowEvent = (event, time, callback) => {
  useEffect(() => {
    const throttleHandler = throttle(callback, time);
    window.addEventListener(event, throttleHandler);
    return () => window.removeEventListener(event, throttleHandler);
  }, [event, time, callback]);
};
const useWindowEvent = (event, callback) => {
  useEffect(() => {
    window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }, [event, callback]);
};
const useGlobalResizeEvent = (callback) => {
  return useThrottleWindowEvent("resize", debounceTime, callback);
};
const useGlobalScrollEvent = (callback) => {
  return useThrottleWindowEvent("scroll", scrollDebounceTime, callback);
};
const useGlobalBeforeUnloadEvent = (callback) => {
  return useWindowEvent("beforeunload", callback);
};
const throttle = (callback, time) => {
  let postponed = false;
  let isLock = false;
  const runCallBack = () => {
    try {
      isLock = true;
      callback();
    } finally {
      setTimeout(function() {
        try {
          isLock = false;
          postponed && runCallBack();
        } finally {
          postponed = false;
        }
      }, time);
    }
  };
  return () => {
    if (isLock) {
      postponed = true;
    } else {
      runCallBack();
    }
  };
};
const generateGoogleMapOnAddress = (address) => googleMapsUrl + address;
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["SET"] = "SET";
  ActionType2["REMOVE"] = "REMOVE";
  ActionType2["NEXT"] = "NEXT";
  ActionType2["PREVIOUS"] = "PREV";
  ActionType2["DOWN_ARROW"] = "DOWN";
  ActionType2["UP_ARROW"] = "UP";
  return ActionType2;
})(ActionType || {});
const menuConstantsObject = {
  unit_one: 1,
  negative_unit_one: -1
};
const keyCodes = Object.freeze({
  esc: 27,
  backspace: 8,
  shift: 16,
  ctrl: 17,
  alt: 18,
  delete: 46,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  cmd: 97,
  A: 65,
  enter: 13,
  tab: 9
});
class MenuAccessibility {
  /**
   * Base constructor
   * @param {string} menuId - div element which holds the menu items.
   */
  constructor(menuId) {
    __publicField(this, "firstItem", null);
    __publicField(this, "lastItem", null);
    __publicField(this, "menuRef");
    __publicField(this, "interactiveElements");
    __publicField(this, "menuItems");
    /**
     * @param {ActionType} actionType - "SET" or "REMOVE"
     */
    __publicField(this, "modifyTabIndex", (actionType) => {
      this.menuItems && this.menuItems.forEach((element) => {
        actionType === ActionType.SET ? element.setAttribute("tabindex", "-1") : element.removeAttribute("tabindex");
      });
    });
    /**
     * Add tab index = -1 to the menu items.
     */
    __publicField(this, "disableTabFocus", () => {
      this.modifyTabIndex(ActionType.SET);
    });
    /**
     * Set the focus to the previous Item.
     * @param {Element} currentItem - Current focused element.
     * @param {ActionType} actionType - if prev, pick the previous elements and vice versa.
     */
    __publicField(this, "setFocusToMenuItem", (currentItem, actionType) => {
      const prevStep = actionType === ActionType.NEXT;
      const addOrSubtract = prevStep ? menuConstantsObject.unit_one : menuConstantsObject.negative_unit_one;
      if (currentItem === (prevStep ? this.lastItem : this.firstItem)) {
        prevStep ? this.firstItem.focus() : this.lastItem.focus();
      } else {
        const index2 = this.menuItems.indexOf(currentItem);
        const itemToFocus = this.menuItems[index2 + addOrSubtract];
        itemToFocus.focus();
      }
    });
    /**
     * Add accessibility to the menu dropdown
     * @param {KeyboardEvent} event - current item.
     */
    __publicField(this, "addKeyBoardAccessibility", (event) => {
      switch (event.keyCode) {
        case keyCodes["upArrow"]:
          this.setFocusToMenuItem(event.target, ActionType.PREVIOUS);
          break;
        case keyCodes["downArrow"]:
          event.stopPropagation();
          event.preventDefault();
          this.setFocusToMenuItem(event.target, ActionType.NEXT);
          break;
        case keyCodes["rightArrow"]:
        case keyCodes["leftArrow"]:
          event.stopPropagation();
          event.preventDefault();
          break;
      }
    });
    /**
     * On load set the first item and last item and add keyboard listener.
     * @param {boolean} selectLastItem - param is used when user press up arrow on the account button. Behavior - last item is selected.
     */
    __publicField(this, "init", (selectLastItem) => {
      var _a, _b;
      const menuItem = this.interactiveElements && Array.from(this.interactiveElements);
      if (menuItem && menuItem.length > 0) {
        this.firstItem = menuItem[0];
        this.lastItem = menuItem[menuItem.length - menuConstantsObject.unit_one];
      }
      this.disableTabFocus();
      selectLastItem ? (_a = this.lastItem) == null ? void 0 : _a.focus() : (_b = this.firstItem) == null ? void 0 : _b.focus();
      this.menuRef && this.menuRef.addEventListener("keydown", this.addKeyBoardAccessibility);
    });
    /**
     * Remove all initiations.
     */
    __publicField(this, "destroy", () => {
      this.modifyTabIndex(ActionType.REMOVE);
      this.menuRef && this.menuRef.removeEventListener("keydown", this.addKeyBoardAccessibility);
    });
    this.menuId = menuId;
    this.menuRef = typeof menuId === "string" ? document.getElementById(menuId) : menuId;
    this.interactiveElements = this.menuRef ? this.menuRef.querySelectorAll("a,button") : null;
    this.menuItems = this.interactiveElements ? Array.from(this.interactiveElements) : null;
  }
}
const menuBarAccessibility = () => {
  let menuBarElement;
  let menuItems;
  const megaNavClassName = `.${PREFIX}-mega-navigation-container`;
  const ariaExpandedName = "aria-expanded";
  const _extractMenuBarItems = () => {
    return Array.from(menuBarElement.children).reduce((acc, curr) => {
      acc.push(curr.querySelector("a"));
      return acc;
    }, []);
  };
  const _addKeyBoardFunctionality = (event) => {
    const targetElement = event.target;
    switch (event.key) {
      case "ArrowRight":
        _setFocusToNextItem(targetElement, ActionType.NEXT);
        break;
      case "ArrowLeft":
        _setFocusToNextItem(targetElement, ActionType.PREVIOUS);
        break;
      case "ArrowDown":
        _openMenuList(targetElement, ActionType.DOWN_ARROW);
        break;
      case "ArrowUp":
        _openMenuList(targetElement, ActionType.UP_ARROW);
        break;
      case "Escape":
        const element = targetElement;
        if (!element.hasAttribute(ariaExpandedName) && element.getAttribute(ariaExpandedName) !== "false") {
          const megaNav = event.target.offsetParent;
          megaNav.removeAttribute("style");
          const anchorTag = megaNav.parentElement.previousSibling;
          anchorTag.focus();
          _setAriaExpanded(anchorTag, false);
          new MenuAccessibility(megaNav).destroy();
        }
        break;
    }
  };
  const _openMenuList = (currentElement, actionType) => {
    if (_doesElementHasMenuList(currentElement)) {
      _setAriaExpanded(currentElement, true);
      _enableMenuAccessibility(actionType === ActionType.UP_ARROW, currentElement);
    }
  };
  const _enableMenuAccessibility = (selectLastItem, currentElement) => {
    new MenuAccessibility(
      currentElement.parentElement.querySelector(megaNavClassName)
    ).init(selectLastItem);
  };
  const _setAriaExpanded = (currentElement, isExpanded) => {
    currentElement.setAttribute(ariaExpandedName, `${String(isExpanded)}`);
  };
  const _doesElementHasMenuList = (currentElement) => {
    return currentElement.getAttribute("aria-haspopup") === "true";
  };
  const _setFocusToNextItem = (currentEle, actionType) => {
    const currentElementIndex = menuItems.indexOf(currentEle);
    if (_doesElementHasMenuList(currentEle)) {
      _setAriaExpanded(currentEle, false);
    }
    const menuItemsLength = menuItems.length;
    if (actionType === ActionType.NEXT) {
      if (currentElementIndex === menuItemsLength - menuConstantsObject.unit_one) {
        menuItems[0].focus();
        return;
      }
      menuItems[currentElementIndex + menuConstantsObject.unit_one].focus();
    } else {
      if (currentElementIndex === 0) {
        menuItems[menuItemsLength - menuConstantsObject.unit_one].focus();
        return;
      }
      menuItems[currentElementIndex + menuConstantsObject.negative_unit_one].focus();
    }
  };
  const init = (menuBarId) => {
    menuBarElement = document.getElementById(menuBarId);
    menuItems = _extractMenuBarItems();
    menuBarElement.addEventListener("keydown", _addKeyBoardFunctionality);
  };
  const destroy = () => {
    menuBarElement.removeEventListener("keydown", _addKeyBoardFunctionality);
  };
  return {
    init,
    destroy
  };
};
const monthNumberAddValue = 1;
const defaultLoweLimitRangeNumber = 18;
const yearCount = 120;
const ageIdCalculation = 1;
let dropdownYearList = [];
let months = [];
const presentYear = (/* @__PURE__ */ new Date()).getFullYear();
const currentYear = presentYear - yearCount;
const yearDropdownCalculation = () => {
  dropdownYearList = [];
  for (let i = presentYear - defaultLoweLimitRangeNumber; i >= currentYear; i--) {
    dropdownYearList.push({ label: i.toString(), id: i.toString(), selected: false });
  }
  return dropdownYearList;
};
const internationalizedMonthList = () => {
  months = [];
  Array.from({ length: 12 }, (_, i) => {
    const internationalizedMonthName = new Date(presentYear, i).toLocaleDateString(getLanguage() || "en", {
      month: "long"
    });
    return months.push({
      label: internationalizedMonthName,
      id: (i + ageIdCalculation).toString(),
      selected: false,
      monthNumber: i + monthNumberAddValue
    });
  });
  return months;
};
const daysInMonth = (selectedYear, selectedMonth) => {
  const daysList = [];
  let monthYear = [];
  monthYear = months.filter((value) => value.label === selectedMonth);
  const numberofDays = new Date(
    Number(selectedYear ? selectedYear : currentYear),
    monthYear.length && monthYear[0].monthNumber ? monthYear[0].monthNumber : 0,
    0
  ).getDate();
  for (let i = 1; i <= numberofDays; i++) {
    daysList.push({ label: i.toString(), id: i.toString(), selected: false });
  }
  return daysList;
};
const checkAgeValidation = (selectedYearOfBirth, selectedMonthOfBirth, selectedDayOfBirth, minAgeForProvince) => {
  const userBirthMonth = months.filter((value) => value.label === selectedMonthOfBirth);
  const userDob = /* @__PURE__ */ new Date(
    `${Number(selectedYearOfBirth)}/${Number(userBirthMonth[0].monthNumber)}/${Number(selectedDayOfBirth)}`
  );
  const ageOfMajorityDate = /* @__PURE__ */ new Date(
    `${(/* @__PURE__ */ new Date()).getFullYear() - minAgeForProvince}/${(/* @__PURE__ */ new Date()).getMonth() + monthNumberAddValue}/${Number(
      (/* @__PURE__ */ new Date()).getDate()
    )}`
  );
  return userDob.getTime() - ageOfMajorityDate.getTime() <= 0;
};
const GetEventAnalytics = {
  interaction: "interaction",
  account: "account"
};
const GetRewardsLabel = {
  error: "error",
  rewardLinked: "rewards linked",
  completed: "completed",
  step: "step"
};
const linkRewardsAnalytics = /* @__PURE__ */ (() => {
  const _linkRewardsEvents = (linkType, stepNumber, screenName) => {
    return {
      event: GetEventAnalytics.interaction,
      eventParameters: {
        action: linkType,
        category: GetEventAnalytics.account,
        label: `${GetRewardsLabel.step} ${stepNumber} : ${screenName} ${GetRewardsLabel.completed}`
      }
    };
  };
  const _linkRewardsSuccess = (linkType) => {
    return {
      event: GetEventAnalytics.interaction,
      eventParameters: {
        action: linkType,
        category: GetEventAnalytics.account,
        label: GetRewardsLabel.rewardLinked
      }
    };
  };
  const _linkRewardsErrors = (linkType, errorType) => {
    return {
      event: GetEventAnalytics.interaction,
      eventParameters: {
        action: linkType,
        category: GetEventAnalytics.account,
        label: `${GetRewardsLabel.error} - ${errorType}`
      }
    };
  };
  return {
    linkRewardsEvents: (linkType, stepNumber, screenName) => {
      return _linkRewardsEvents(linkType, stepNumber, screenName);
    },
    linkRewardsSuccess: (linkType) => {
      return _linkRewardsSuccess(linkType);
    },
    linkRewardsErrors: (linkType, errorType) => {
      return _linkRewardsErrors(linkType, errorType);
    }
  };
})();
const validatePostalCode = (inputString) => {
  let isCheckNumber = false;
  const stringArr = inputString.split("");
  let postalCodeStr = "";
  stringArr.length && stringArr.forEach((value, index2) => {
    if (isCheckNumber) {
      if (!/^\d+$/.test(value)) {
        stringArr[index2] = "";
        return;
      }
      isCheckNumber = false;
      postalCodeStr = postalCodeStr + value;
    } else {
      if (!/^[A-Za-z]+$/.test(value)) {
        stringArr[index2] = "";
        return;
      }
      isCheckNumber = true;
      postalCodeStr = postalCodeStr + value;
    }
  });
  if (postalCodeStr.length >= magicNumber.FOUR && postalCodeStr.charAt(magicNumber.THREE) !== " ") {
    const postalCodePrefix = postalCodeStr.substring(magicNumber.ZERO, magicNumber.THREE);
    const postalCodeSuffix = postalCodeStr.substring(magicNumber.THREE, magicNumber.SIX);
    const postalCode = `${postalCodePrefix} ${postalCodeSuffix}`;
    return postalCode.toUpperCase();
  }
  return postalCodeStr.toUpperCase();
};
const isArrayNotEmpty = (object2) => {
  return Array.isArray(object2) && object2.length > 0;
};
const customDebounce = (callback, wait, debounceTimeout, setDebounceTimeout) => {
  return (...args) => {
    const next = () => callback(...args);
    clearTimeout(debounceTimeout);
    setDebounceTimeout(setTimeout(next, wait));
  };
};
const promiseQueue = (handleRecentOnly = false) => {
  const queueArr = [];
  function shouldBeHandled(pos) {
    if (handleRecentOnly) {
      return pos + magicNumber.ONE === queueArr.length;
    }
    return pos >= 0;
  }
  function pushToQueue(promise, handleResponse, handleError) {
    queueArr.push(promise);
    promise.then((data) => {
      const pos = queueArr.indexOf(promise);
      if (shouldBeHandled(pos)) {
        handleResponse(data);
        void queueArr.splice(0, pos);
      }
    }).catch((err) => {
      const pos = queueArr.indexOf(promise);
      if (shouldBeHandled(pos)) {
        handleError(err);
      }
    });
  }
  return pushToQueue;
};
const isEscPressed = (eventKey) => {
  return eventKey === stringKeyCodes.esc;
};
const isTabPressed = (eventKey) => {
  return eventKey === stringKeyCodes.tab;
};
const isEnterPressed = (eventKey) => {
  return eventKey === stringKeyCodes.enter;
};
const isSpacePressed = (eventKey) => {
  return eventKey === stringKeyCodes.space;
};
const stringKeyCodes = Object.freeze({
  esc: "Escape",
  leftArrow: "ArrowLeft",
  upArrow: "ArrowUp",
  rightArrow: "ArrowRight",
  downArrow: "ArrowDown",
  enter: "Enter",
  tab: "Tab",
  space: " ",
  backspace: "Backspace"
});
const popUpAEMHandler = (popupId, openedPopupClass, closeButtonClass) => {
  const modalButton = document.querySelector(`[href="#${popupId}"]`);
  const modal = document.getElementById(popupId);
  if (modalButton && modal) {
    const modalCloseButton = modal.querySelector(`.${closeButtonClass}`);
    const closeModalEsc = (e) => {
      if (e.key === stringKeyCodes.esc) {
        closeModal();
      }
    };
    const openModal = () => {
      modal.classList.add(openedPopupClass);
      document.body.classList.add(MODAL_OPEN_CLASS$1);
      document.body.addEventListener("keydown", closeModalEsc);
    };
    const closeModal = () => {
      modal.classList.remove(openedPopupClass);
      document.body.classList.remove(MODAL_OPEN_CLASS$1);
      document.body.removeEventListener("keydown", closeModalEsc);
    };
    modalButton.addEventListener("click", openModal);
    modalCloseButton == null ? void 0 : modalCloseButton.addEventListener("click", closeModal);
  }
};
const handleModalEventListeners = (modalSelector, overFlowHiddenClass, modalCloseIcon, modalCloseButton, redirectButton, linkForRedirection) => {
  var _a, _b, _c;
  const closeModal = () => {
    var _a2;
    (_a2 = document.querySelector(`.${modalSelector}`)) == null ? void 0 : _a2.classList.add(`${PREFIX}-md-none`, `${PREFIX}-xs-none`);
    document.body.classList.remove(overFlowHiddenClass);
  };
  (_a = document.querySelector(`${modalCloseIcon}`)) == null ? void 0 : _a.addEventListener("click", () => {
    closeModal();
  });
  (_b = document.querySelector(`${modalCloseButton}`)) == null ? void 0 : _b.addEventListener("click", () => {
    closeModal();
  });
  const handleEscapeKey = (event) => {
    if (isEscPressed(event.key)) {
      closeModal();
    }
  };
  document.addEventListener("keyup", handleEscapeKey);
  document.addEventListener("click", (e) => {
    var _a2;
    if ((_a2 = e.target) == null ? void 0 : _a2.matches(`.${modalSelector}`)) {
      closeModal();
    }
  });
  (_c = document.querySelector(`${redirectButton}`)) == null ? void 0 : _c.addEventListener("click", () => {
    window.location.href = linkForRedirection;
  });
};
const getCapitalizeString = (capitalizeString) => {
  return capitalizeString && capitalizeString.replace(
    /\w\S*/g,
    (str) => str.charAt(magicNumber.ZERO).toUpperCase() + str.substr(magicNumber.ONE).toLowerCase()
  );
};
const modalAccessibilityHandler = ({ modalOpen, modalClassName }) => {
  const ariaHiddenLabel = "aria-hidden";
  const focusableElementSelectorsString = [
    "a[href]",
    "area[href]",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    ".snapper_pane",
    "#secondaryMenuBar",
    "#legal-disclaimer-container",
    "#nl-banner-skinny__button"
  ].join(",");
  const modalContainer = document.querySelector(`.${modalClassName}`);
  const dataAttrObject = {
    "data-add-tabindex": "tabindex",
    "data-add-aria-hidden": ariaHiddenLabel
  };
  const removeAddedAttributes = (focusableElement) => {
    Object.keys(dataAttrObject).forEach((dataAttrName) => {
      focusableElement.hasAttribute(dataAttrName) && focusableElement.removeAttribute(dataAttrObject[dataAttrName]);
      focusableElement.removeAttribute(dataAttrName);
    });
  };
  document.querySelectorAll(focusableElementSelectorsString).forEach((focusableElement) => {
    const checkTabIndex = focusableElement.getAttribute("tabindex") !== "-1";
    const checkAriaHidden = focusableElement.getAttribute(ariaHiddenLabel) !== "false";
    if (modalOpen) {
      if (checkTabIndex) {
        focusableElement.setAttribute("tabindex", "-1");
        focusableElement.setAttribute("data-add-tabindex", "true");
      }
      if (checkAriaHidden) {
        focusableElement.setAttribute(ariaHiddenLabel, "true");
        focusableElement.setAttribute("data-add-aria-hidden", "true");
      }
    } else {
      removeAddedAttributes(focusableElement);
    }
  });
  if (modalOpen) {
    Array.from(modalContainer.querySelectorAll(focusableElementSelectorsString)).forEach((modalFocusableElement) => {
      removeAddedAttributes(modalFocusableElement);
    });
    const focusableElement = modalContainer.querySelector(focusableElementSelectorsString);
    focusableElement == null ? void 0 : focusableElement.focus({ preventScroll: true });
  }
};
const addModalAttribute = (event) => {
  const button = event.currentTarget;
  button.setAttribute(previousElementName, "true");
};
const extractKeyValues = (mainObj, keys) => {
  const ONE = 1;
  const _extractMultipleValues = (obj, mainKey, currentValue) => {
    var _a;
    return ((_a = currentValue == null ? void 0 : currentValue[mainKey]) == null ? void 0 : _a.map((el) => {
      var _a2;
      return ((_a2 = obj == null ? void 0 : obj[mainKey]) == null ? void 0 : _a2[el]) || "";
    })) || [];
  };
  const _extractSingleValue = (obj, array) => {
    if (array.length === ONE) {
      const [finalValue] = array;
      return obj[finalValue] || "";
    }
    const value = obj == null ? void 0 : obj[array.shift()];
    return _extractSingleValue(value, array);
  };
  return keys.reduce((accumulator, currentValue) => {
    const value = !Array.isArray(currentValue) ? _extractMultipleValues(mainObj, Object.keys(currentValue)[0], currentValue) : _extractSingleValue(mainObj, [...currentValue]);
    accumulator.push(value);
    return accumulator;
  }, []);
};
const getPriceRangePill = (minPrice, maxPrice, currentLocale) => {
  let pricePills = "";
  if (minPrice > 0 && maxPrice > 0) {
    pricePills = `${getFormattedPrice(minPrice, currentLocale)}-${getFormattedPrice(maxPrice, currentLocale)}`;
  } else if (maxPrice > 0) {
    pricePills = `${getFormattedPrice(0, currentLocale)}-${getFormattedPrice(maxPrice, currentLocale)}`;
  } else if (minPrice > 0) {
    pricePills = `${getFormattedPrice(minPrice, currentLocale)}+`;
  } else if (minPrice === null && maxPrice === null) {
    pricePills = "Price Suppression";
  }
  return pricePills;
};
const getFormattedPrice = (price, currentLocale) => {
  const language2 = `${currentLocale}-${currencyShortForm}`;
  try {
    return new Intl.NumberFormat(language2, {
      style: "currency",
      currency: currencyFormat,
      useGrouping: false,
      minimumFractionDigits: 0,
      currencyDisplay: "narrowSymbol"
    }).format(price);
  } catch {
    return new Intl.NumberFormat(language2, {
      style: "currency",
      currency: currencyFormat,
      useGrouping: false,
      minimumFractionDigits: 0,
      currencyDisplay: "symbol"
    }).format(price);
  }
};
const removeHtmlTagsFromString = (text2) => {
  return text2 ? text2.replace(/<[^>]*>?/gm, "") : "";
};
const checkKeyPresenceInArray = (mediaSet, key) => mediaSet == null ? void 0 : mediaSet.some((mediaSetObj) => Object.keys(mediaSetObj).includes(key));
const combineBadges = (skuBadges, productBadges, excludeBadgeList, originallyInstalled, isCustomBadge, skuLevelBadges) => {
  let combinedBadges = [];
  const filteredProductBadges = (productBadges == null ? void 0 : productBadges.filter((badge) => !(excludeBadgeList == null ? void 0 : excludeBadgeList.includes(badge == null ? void 0 : badge.split("|")[0])))) || [];
  if (originallyInstalled) {
    filteredProductBadges.push(originallyInstalled);
  }
  if (isCustomBadge) {
    combinedBadges = [...skuBadges || [], ...skuLevelBadges || [], ...filteredProductBadges];
  } else {
    combinedBadges = [...skuBadges || [], ...filteredProductBadges];
  }
  return Array.from(new Set(combinedBadges));
};
const selectedSKUBadge = (productSKUs, selectedProductCode) => {
  const selectedSKU = productSKUs == null ? void 0 : productSKUs.find((sku) => sku.code === selectedProductCode);
  if (selectedSKU) {
    return selectedSKU.badges;
  } else {
    return [];
  }
};
const getFormattedPhoneNumber = (phoneNumber) => {
  return phoneNumber == null ? void 0 : phoneNumber.replace(phoneNumberFormat, phoneNumberPattern);
};
const formatedPhoneNumberAccessibility = (phoneNumber) => {
  return phoneNumber == null ? void 0 : phoneNumber.split("").join(" ");
};
const getPhoneNumber = (phoneNumber) => {
  return phoneNumber ? getFormattedPhoneNumber(phoneNumber || "") : "—";
};
const getDOMElement = (parentClass) => {
  return document.querySelector(parentClass);
};
const getQueryString$1 = (params, partBy) => {
  const urlParams = new URLSearchParams(params);
  const queryString = urlParams.get(partBy);
  return queryString ? queryString : "";
};
const getQueryStringParams = (path, name) => {
  const match2 = RegExp(`[?&;]${name}=([^&;]*)`).exec(path);
  const index2 = 1;
  return match2 ? decodeURIComponent(match2[index2]) : "";
};
const getPageTitle = () => {
  let pageTitle = "";
  const metaDetails = document.querySelector("meta[name='title']");
  if (!!metaDetails) {
    pageTitle = metaDetails.getAttribute("content") || "";
  }
  return pageTitle || document.title;
};
const getBalance = (balanceAmount) => {
  const language2 = `${getLanguage()}-${currencyShortForm}`;
  return new Intl.NumberFormat(language2, {
    style: "currency",
    currency: currencyFormat
  }).format(Number(balanceAmount));
};
const isAmountGreaterThan = (value, balance) => {
  return value > balance;
};
const getDivideByAmount = (price, month) => {
  const amount = (price / month).toFixed(magicNumber.TWO);
  return getBalance(amount);
};
const getMultipleByAmount = (percentage, price) => {
  var _a;
  const amount = (_a = percentage / magicNumber.HUNDRED * price) == null ? void 0 : _a.toFixed(magicNumber.TWO);
  return getBalance(amount);
};
const cardNumberFormatted = (cardNumber, lastFourDigitsRegex, separator = " - ") => {
  return cardNumber.replace(lastFourDigitsRegex, "$& ").trim().split(" ").join(separator);
};
const maskCardNumberExceptLastFourDigits = (cardNumber, lastFourDigitsRegex, cardMasking = "•") => {
  const lastFourDigitsExcludeSpaceRegex = /\d(?=.*\d(?:\s*\d){3}\s*$)/g;
  const formatCardNumber = cardNumberFormatted(cardNumber, lastFourDigitsRegex, " ");
  return formatCardNumber.replace(lastFourDigitsExcludeSpaceRegex, cardMasking);
};
const formatCreditCard = (cardNumber, splitOn, separator, newCardLength) => {
  const regularCardLength = cardNumber.length === magicNumber.SIXTEEN;
  const customCardLength = !regularCardLength && newCardLength;
  const regex = splitOn ?? /(.{1,4})/g;
  const buildCardNumber = customCardLength ? cardNumber.padStart(newCardLength, "*").match(/(.{1,4})/g) : cardNumber;
  return buildCardNumber.toString().split(regex).join(separator ?? " ");
};
const hashCreditCard = (message, hashedValue, count, appendHash) => {
  const hashedSting = message == null ? void 0 : message.split(replaceCardValue).join(hashedValue);
  const strWithIteration = count ? hashedSting == null ? void 0 : hashedSting.slice(count) : hashedSting;
  return appendHash && count ? `${(hashedValue == null ? void 0 : hashedValue.repeat(count)) + (hashedSting == null ? void 0 : hashedSting.slice(count))}` : strWithIteration;
};
const getCardErrorCheck = (number, cardLength, regex) => {
  return number.length !== cardLength || !(regex == null ? void 0 : regex.test(number));
};
const validateCardInput = (value, lengthErrorMsg, cardNumberErrorMessage, cardLength, cardRegex, checkZeroValueEntry) => {
  if (!value || checkZeroValueEntry && Number(value) === magicNumber.ZERO) {
    return cardNumberErrorMessage;
  } else if (getCardErrorCheck(value, cardLength, cardRegex) && lengthErrorMsg) {
    return lengthErrorMsg;
  } else {
    return "";
  }
};
const sendError = (errorMsg, isValid2) => isValid2 ? errorMsg : "";
const checkValidationError = (errorCode) => {
  const errors = [
    errorCodes.error00121,
    errorCodes.error00000,
    errorCodes.error00142,
    errorCodes.error00143,
    errorCodes.error00144,
    errorCodes.error00145,
    errorCodes.error00146
  ];
  return errors.includes(errorCode) ? errorCode : "";
};
const checkSystemError = (errorCode) => {
  const errors = [
    errorCodes.error00106,
    errorCodes.error00130,
    errorCodes.error00030,
    errorCodes.error00138,
    errorCodes.error00129
  ];
  return errors.includes(errorCode) ? errorCode : "";
};
const getErrorMessage = (errorCode, code, messages) => {
  const { errorMsg, redirectError } = messages;
  const validationError = checkValidationError(errorCode);
  const systemError = checkSystemError(errorCode);
  switch (errorCode) {
    case errorCodes.error00211:
    case errorCodes.error00140:
    case errorCodes.error00122:
    case errorCodes.error00043:
      return errorMsg;
    case systemError:
      return errorCodes.error00106;
    case validationError:
      return errorCodes.error00121;
    case errorCodes.error00141:
      return errorCodes.error00141;
    case errorCodes.error00055:
      return redirectError;
    default:
      return errorMsg;
  }
};
const getLoyaltyCards = (data) => {
  var _a, _b, _c, _d, _e, _f;
  const cardNumber = (data == null ? void 0 : data.formatCardNumber) && typeof (data == null ? void 0 : data.formatCardNumber) !== Types.Boolean ? cardNumberFormatted((_b = (_a = data.userProfileData) == null ? void 0 : _a.loyalty) == null ? void 0 : _b.cardNumber, data == null ? void 0 : data.cardRegex, data == null ? void 0 : data.cardSeparator) : (_d = (_c = data.userProfileData) == null ? void 0 : _c.loyalty) == null ? void 0 : _d.cardNumber;
  let value;
  if (data == null ? void 0 : data.isLoggedInRewards) {
    value = [
      {
        icon: data.cardNumberLabelIcon,
        title: data.cardNumberLabel,
        value: cardNumber,
        showIcon: true,
        iconAlt: data == null ? void 0 : data.cardNumberLabelIconAltText
      },
      {
        icon: data.rewardsBalanceLabelIcon,
        title: data.rewardsBalanceLabel,
        value: ((_e = data == null ? void 0 : data.userProfileData) == null ? void 0 : _e.balance) !== null && getBalance((_f = data == null ? void 0 : data.userProfileData) == null ? void 0 : _f.balance),
        showIcon: true,
        iconAlt: data == null ? void 0 : data.rewardsBalanceLabelIconAltText
      }
    ];
  } else {
    value = [
      {
        icon: data == null ? void 0 : data.triangleRewardsIcon,
        title: data == null ? void 0 : data.triangleRewardsLabel,
        subtitle: data == null ? void 0 : data.rewardsUpsellingMessage,
        linkLabel: data == null ? void 0 : data.registrationCtaLabel,
        linkCta: data == null ? void 0 : data.rewardsRegisterRichText,
        iconAlt: data == null ? void 0 : data.triangleRewardsIconAltText,
        registerNowLink: data == null ? void 0 : data.registerNowLink,
        registerNowLabel: data == null ? void 0 : data.registerNowLabel,
        registerLabel: data == null ? void 0 : data.registerLabel
      }
    ];
  }
  return value;
};
const getSafePercent = (percent) => {
  return Math.min(magicNumber.HUNDRED, Math.max(percent, 0));
};
const getUnpaddedTimeFormat = (time) => {
  return time.startsWith("0") ? time.slice(magicNumber.ONE) : time;
};
const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      var _a;
      if (!(ref == null ? void 0 : ref.current) || ((_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.contains(event.target))) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    return () => document.removeEventListener("mousedown", listener);
  }, [ref, handler]);
};
const getTextWidth$1 = (text2, font) => {
  var _a, _b;
  const canvas2 = document.createElement("canvas");
  const context = canvas2.getContext("2d");
  if (context == null ? void 0 : context.font) {
    context.font = ((_a = getComputedStyle(document.body)) == null ? void 0 : _a.font) || font;
  }
  return ((_b = context == null ? void 0 : context.measureText(text2)) == null ? void 0 : _b.width) || 0;
};
const getAccountHolderName = (firstName, lastName) => {
  return !!firstName && !!lastName ? `${firstName} ${lastName}` : "";
};
const getNameDetails = (firstName, lastName) => {
  return firstName || lastName ? `${firstName || ""} ${lastName || ""}` : "—";
};
const convertDecimalImpliedFormat = (amount) => {
  const multipliedAmt = Number(amount) * magicNumber.HUNDRED || 0;
  return parseInt(multipliedAmt.toString(), 10);
};
const roundOffValue = (value, dividend) => Math.round(value / dividend) * dividend;
const getNumberOrDefault = (value) => Number(value) || 0;
const queryParameters = {
  language: "lang",
  searchQuery: "q",
  searchRequestQuery: "rq",
  divider: ";",
  count: "count",
  page: "page",
  priceUpperBound: "priceUpperBound",
  priceLowerBound: "priceLowerBound",
  store: "store",
  plpCDSDivider: "&",
  mock: "mock",
  light: "light",
  automotive: "automotive",
  tireSize: "auto.size",
  useRanks: "useRanks",
  utmParams: ["utm_source", "utm_medium", "utm_campaign", "utm_content", "mi_ecmp", "mi_u", "et_hue", "gclid"],
  isIgnoreAttributesThreshold: "isIgnoreAttributesThreshold",
  hashDivider: "#",
  aoaLinkType: "aoaLinkType",
  orderId: "orderId",
  orderIdForOrderDetailsPage: "token",
  searchResultType: "index",
  fromPackage: "fromPackage",
  branch: "branch"
};
const anyDividerRegExp = new RegExp(
  `[${queryParameters.divider}${queryParameters.plpCDSDivider}${queryParameters.hashDivider}]`
);
const getParamValue$1 = (urlSearchParam, paramKey, splitKey) => {
  var _a, _b;
  const paramArray = urlSearchParam.replace("?", "").split(splitKey);
  const noParam = -1;
  const arrayIndex = 1;
  return (_b = (_a = paramArray.find((el) => el.search(paramKey) !== noParam)) == null ? void 0 : _a.split("=")[arrayIndex]) == null ? void 0 : _b.split(";")[0];
};
const getParameterFromURL = (parameterKey) => {
  const urlParts = window.location.href.split("?");
  const queryParams = urlParts[1] || "";
  return getParamValue$1(queryParams, parameterKey, anyDividerRegExp);
};
const findParamValue = (urlSearchParam, paramKey, splitKey) => {
  const filteredParam = getParamValue$1(urlSearchParam, paramKey, splitKey);
  return filteredParam === "true";
};
const updateUrlHistory = (url, removeGig) => {
  if (removeGig) {
    removeGigParams();
  } else {
    window.history.replaceState({}, "", `${url ? url : window.location.pathname}`);
  }
};
function removeGigParams() {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  if (url.searchParams.toString() === "") {
    return;
  }
  const params = new URLSearchParams(url.searchParams);
  const newParams = Array.from(params.entries()).filter(([key]) => !key.startsWith("gig_"));
  const queryString = newParams.map(([key, value]) => {
    if (key.includes(queryParameters.searchQuery) || key === queryParameters.searchRequestQuery) {
      return `${key}=${encodeURIComponent(value).replace(/%20|\s/g, "+")}`;
    }
    return `${key}=${value}`;
  }).join("&");
  const fragment = url.hash || "";
  const newUrl = `${url.pathname}?${queryString}${fragment}`;
  window.history.replaceState({}, document.title, newUrl);
}
const pushUrlHistory = (url) => {
  if (url) {
    window.history.pushState({}, "", `${url}`);
  } else {
    window.history.pushState({}, "", window.location.pathname);
  }
};
const updateParam = (url, queryParam, paramKey, paramUpdateVal) => {
  let updatedURLParams = "";
  const paramList = url.split("?");
  const [domainName, paramURL] = paramList;
  let temp = "";
  if (paramURL) {
    const searchParamArray = paramURL.split(paramKey);
    const paramArrayLength = searchParamArray.length;
    for (let i = 0; i < paramArrayLength; i++) {
      if (searchParamArray[i].split("=")[0] !== queryParam) {
        updatedURLParams += temp + searchParamArray[i];
        temp = paramKey;
      }
    }
  }
  const updatedParam = `${temp}${queryParam}=${String(paramUpdateVal)}`;
  return `${domainName}?${updatedURLParams}${updatedParam}`;
};
const updateParameterInURL = (parameterKey, value, divider = queryParameters.plpCDSDivider, pushEntry = false) => {
  const queryParams = window.location.search;
  const newQueryParams = updateParam(queryParams, parameterKey, divider, value);
  if (pushEntry) {
    pushUrlHistory(newQueryParams);
  } else {
    updateUrlHistory(newQueryParams);
  }
};
const removeParam = (url, key, delimiter) => {
  let updatedParamsArray = [];
  let modifiedParams = "";
  const constantValue = 1;
  const queryString = url.indexOf("?") !== -1 ? url.split("?")[constantValue] : "";
  if (queryString !== "") {
    updatedParamsArray = queryString.split(delimiter);
    for (let i = updatedParamsArray.length - constantValue; i >= 0; i -= constantValue) {
      const param = updatedParamsArray[i].split("=")[0];
      if (param === key) {
        updatedParamsArray.splice(i, constantValue);
      }
    }
    const updatedParam = updatedParamsArray.length ? `?${updatedParamsArray.join(delimiter)}` : window.location.href.split("?")[0];
    modifiedParams = updatedParam;
  }
  return modifiedParams;
};
const removeParameterFromURL = (parameterKey, divider = queryParameters.divider) => {
  const queryParams = window.location.search;
  const newQueryParams = removeParam(queryParams, parameterKey, divider);
  updateUrlHistory(newQueryParams);
};
const getQueryString = (params, partBy) => {
  const urlParams = new URLSearchParams(params);
  const queryString = urlParams.get(partBy);
  return queryString ? queryString : "";
};
const updateHashInURL = (hashKey, value) => {
  window.location.hash = `${hashKey}=${value}`;
};
const checkStoreHashInURL = () => {
  var _a;
  const withoutHashSymbol = (_a = window.location.hash) == null ? void 0 : _a.replace(queryParameters.hashDivider, "");
  const storeIdFromHash = getQueryString(withoutHashSymbol, queryParameters.store);
  return Boolean(storeIdFromHash);
};
const checkStoreParamInURL = () => {
  const storeIdFromParams = getQueryString(window.location.search, queryParameters.store);
  return Boolean(storeIdFromParams);
};
const isMockParamInURL = (queryParams) => {
  const match2 = RegExp(
    `[?${queryParameters.plpCDSDivider};]${queryParameters.mock}[^${queryParameters.plpCDSDivider};]*`
  ).exec(queryParams);
  const index2 = 0;
  return !!match2 && !!match2[index2];
};
const createPaginationHref = (pageNumber) => {
  const { pathname, search } = window.location;
  const updatedQuery = pageNumber === magicNumber.ONE ? "" : updateParam(search, queryParameters.page, queryParameters.plpCDSDivider, pageNumber);
  return `${pathname}${updatedQuery}`;
};
const getSAPIRequestQueryParam = () => {
  var _a, _b;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams == null ? void 0 : urlSearchParams.entries());
  if (params.rq && params.rq.includes(queryParameters.divider)) {
    return params.rq.split(queryParameters.divider)[0];
  } else if (params.count && ((_a = params.count) == null ? void 0 : _a.includes("rq"))) {
    let rqValue = "";
    (_b = params.count) == null ? void 0 : _b.split(";").forEach((s) => {
      if (s == null ? void 0 : s.includes("rq=")) {
        rqValue = s.split("=")[magicNumber.ONE] || "";
      }
    });
    return rqValue;
  } else {
    return params.rq || "";
  }
};
const addParam = (url, param, value) => {
  return (url == null ? void 0 : url.includes("?")) ? `${url}${queryParameters.plpCDSDivider}${param}=${value}` : `${url}?${param}=${value}`;
};
const appendQueryParamsToUrl = (url, params) => {
  const queryString = Object.entries(params).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
  return (url == null ? void 0 : url.includes("?")) ? `${url}&${queryString}` : `${url}?${queryString}`;
};
const removeAllParametersFromURL = (parameterSet) => {
  let queryParam = window.location.href;
  parameterSet.forEach((param) => {
    queryParam = removeParam(queryParam, param.parameterKey, param.divider);
  });
  updateUrlHistory(queryParam);
};
const excludeUtmParams = (query) => {
  var _a;
  const paramsToRemove = [];
  const divider = ((_a = query.match(/\;/g) || query.match(/\&/g)) == null ? void 0 : _a[0]) ?? queryParameters.plpCDSDivider;
  const regexp = new RegExp(`\\${divider}`, "g");
  const plpCDSDividerRegexp = new RegExp(`${queryParameters.plpCDSDivider}`, "g");
  const params = new URLSearchParams(query.replace(regexp, queryParameters.plpCDSDivider));
  params.forEach((_value, key) => {
    if (queryParameters.utmParams.includes(key.toLowerCase())) {
      paramsToRemove.push(key);
    }
  });
  paramsToRemove.forEach((param) => {
    params.delete(param);
  });
  return `?${params.toString().replace(plpCDSDividerRegexp, divider)}`;
};
const DOBFormatConstant = {
  dateLastIndex: 2,
  monthLastIndex: 4,
  yearFirstIndex: 4
};
const getDateOfBirth = (DOBValue, monthFormat = "long") => {
  const language2 = getLanguage();
  const date = DOBValue.slice(0, DOBFormatConstant.dateLastIndex);
  const month = DOBValue.slice(DOBFormatConstant.dateLastIndex, DOBFormatConstant.monthLastIndex);
  const year = DOBValue.slice(DOBFormatConstant.yearFirstIndex);
  const formatedDOB = `${date}/${month}/${year}`;
  const objDate = new Date(formatedDOB);
  return objDate.toLocaleDateString(language2 || "en", {
    year: "numeric",
    month: monthFormat,
    day: "2-digit"
  });
};
const getLanguageCA = () => {
  return getLanguage().replace(/^([A-Za-z]+)(_CA)?$/, "$1_CA") || "en_CA";
};
var format$1 = { exports: {} };
var format = { exports: {} };
var interopRequireDefault = { exports: {} };
var hasRequiredInteropRequireDefault;
function requireInteropRequireDefault() {
  if (hasRequiredInteropRequireDefault) return interopRequireDefault.exports;
  hasRequiredInteropRequireDefault = 1;
  (function(module) {
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(interopRequireDefault);
  return interopRequireDefault.exports;
}
var isValid = { exports: {} };
var isDate = { exports: {} };
var _typeof$3 = { exports: {} };
var hasRequired_typeof;
function require_typeof() {
  if (hasRequired_typeof) return _typeof$3.exports;
  hasRequired_typeof = 1;
  (function(module) {
    function _typeof2(o) {
      "@babel/helpers - typeof";
      return module.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof2(o);
    }
    module.exports = _typeof2, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(_typeof$3);
  return _typeof$3.exports;
}
var requiredArgs = { exports: {} };
var hasRequiredRequiredArgs;
function requireRequiredArgs() {
  if (hasRequiredRequiredArgs) return requiredArgs.exports;
  hasRequiredRequiredArgs = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = requiredArgs2;
    function requiredArgs2(required, args) {
      if (args.length < required) {
        throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
      }
    }
    module.exports = exports.default;
  })(requiredArgs, requiredArgs.exports);
  return requiredArgs.exports;
}
var hasRequiredIsDate;
function requireIsDate() {
  if (hasRequiredIsDate) return isDate.exports;
  hasRequiredIsDate = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isDate2;
    var _typeof2 = _interopRequireDefault(require_typeof());
    var _index = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    function isDate2(value) {
      (0, _index.default)(1, arguments);
      return value instanceof Date || (0, _typeof2.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
    }
    module.exports = exports.default;
  })(isDate, isDate.exports);
  return isDate.exports;
}
var toDate$2 = { exports: {} };
var hasRequiredToDate$1;
function requireToDate$1() {
  if (hasRequiredToDate$1) return toDate$2.exports;
  hasRequiredToDate$1 = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = toDate2;
    var _typeof2 = _interopRequireDefault(require_typeof());
    var _index = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    function toDate2(argument) {
      (0, _index.default)(1, arguments);
      var argStr = Object.prototype.toString.call(argument);
      if (argument instanceof Date || (0, _typeof2.default)(argument) === "object" && argStr === "[object Date]") {
        return new Date(argument.getTime());
      } else if (typeof argument === "number" || argStr === "[object Number]") {
        return new Date(argument);
      } else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
          console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
          console.warn(new Error().stack);
        }
        return /* @__PURE__ */ new Date(NaN);
      }
    }
    module.exports = exports.default;
  })(toDate$2, toDate$2.exports);
  return toDate$2.exports;
}
var hasRequiredIsValid;
function requireIsValid() {
  if (hasRequiredIsValid) return isValid.exports;
  hasRequiredIsValid = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = isValid2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireIsDate());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    function isValid2(dirtyDate) {
      (0, _index3.default)(1, arguments);
      if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== "number") {
        return false;
      }
      var date = (0, _index2.default)(dirtyDate);
      return !isNaN(Number(date));
    }
    module.exports = exports.default;
  })(isValid, isValid.exports);
  return isValid.exports;
}
var subMilliseconds = { exports: {} };
var addMilliseconds = { exports: {} };
var toInteger = { exports: {} };
var hasRequiredToInteger;
function requireToInteger() {
  if (hasRequiredToInteger) return toInteger.exports;
  hasRequiredToInteger = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = toInteger2;
    function toInteger2(dirtyNumber) {
      if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
        return NaN;
      }
      var number = Number(dirtyNumber);
      if (isNaN(number)) {
        return number;
      }
      return number < 0 ? Math.ceil(number) : Math.floor(number);
    }
    module.exports = exports.default;
  })(toInteger, toInteger.exports);
  return toInteger.exports;
}
var hasRequiredAddMilliseconds;
function requireAddMilliseconds() {
  if (hasRequiredAddMilliseconds) return addMilliseconds.exports;
  hasRequiredAddMilliseconds = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = addMilliseconds2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToInteger());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    function addMilliseconds2(dirtyDate, dirtyAmount) {
      (0, _index3.default)(2, arguments);
      var timestamp = (0, _index2.default)(dirtyDate).getTime();
      var amount = (0, _index.default)(dirtyAmount);
      return new Date(timestamp + amount);
    }
    module.exports = exports.default;
  })(addMilliseconds, addMilliseconds.exports);
  return addMilliseconds.exports;
}
var hasRequiredSubMilliseconds;
function requireSubMilliseconds() {
  if (hasRequiredSubMilliseconds) return subMilliseconds.exports;
  hasRequiredSubMilliseconds = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = subMilliseconds2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireAddMilliseconds());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireToInteger());
    function subMilliseconds2(dirtyDate, dirtyAmount) {
      (0, _index2.default)(2, arguments);
      var amount = (0, _index3.default)(dirtyAmount);
      return (0, _index.default)(dirtyDate, -amount);
    }
    module.exports = exports.default;
  })(subMilliseconds, subMilliseconds.exports);
  return subMilliseconds.exports;
}
var formatters$1 = { exports: {} };
var getUTCDayOfYear = { exports: {} };
var hasRequiredGetUTCDayOfYear;
function requireGetUTCDayOfYear() {
  if (hasRequiredGetUTCDayOfYear) return getUTCDayOfYear.exports;
  hasRequiredGetUTCDayOfYear = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = getUTCDayOfYear2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var MILLISECONDS_IN_DAY = 864e5;
    function getUTCDayOfYear2(dirtyDate) {
      (0, _index2.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var timestamp = date.getTime();
      date.setUTCMonth(0, 1);
      date.setUTCHours(0, 0, 0, 0);
      var startOfYearTimestamp = date.getTime();
      var difference = timestamp - startOfYearTimestamp;
      return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
    }
    module.exports = exports.default;
  })(getUTCDayOfYear, getUTCDayOfYear.exports);
  return getUTCDayOfYear.exports;
}
var getUTCISOWeek = { exports: {} };
var startOfUTCISOWeek = { exports: {} };
var hasRequiredStartOfUTCISOWeek;
function requireStartOfUTCISOWeek() {
  if (hasRequiredStartOfUTCISOWeek) return startOfUTCISOWeek.exports;
  hasRequiredStartOfUTCISOWeek = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = startOfUTCISOWeek2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    function startOfUTCISOWeek2(dirtyDate) {
      (0, _index2.default)(1, arguments);
      var weekStartsOn = 1;
      var date = (0, _index.default)(dirtyDate);
      var day = date.getUTCDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setUTCDate(date.getUTCDate() - diff);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
    module.exports = exports.default;
  })(startOfUTCISOWeek, startOfUTCISOWeek.exports);
  return startOfUTCISOWeek.exports;
}
var startOfUTCISOWeekYear = { exports: {} };
var getUTCISOWeekYear = { exports: {} };
var hasRequiredGetUTCISOWeekYear;
function requireGetUTCISOWeekYear() {
  if (hasRequiredGetUTCISOWeekYear) return getUTCISOWeekYear.exports;
  hasRequiredGetUTCISOWeekYear = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = getUTCISOWeekYear2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireStartOfUTCISOWeek());
    function getUTCISOWeekYear2(dirtyDate) {
      (0, _index2.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var year = date.getUTCFullYear();
      var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
      fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
      fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
      var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
      var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
      fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
      fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
      var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }
    module.exports = exports.default;
  })(getUTCISOWeekYear, getUTCISOWeekYear.exports);
  return getUTCISOWeekYear.exports;
}
var hasRequiredStartOfUTCISOWeekYear;
function requireStartOfUTCISOWeekYear() {
  if (hasRequiredStartOfUTCISOWeekYear) return startOfUTCISOWeekYear.exports;
  hasRequiredStartOfUTCISOWeekYear = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = startOfUTCISOWeekYear2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireGetUTCISOWeekYear());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireStartOfUTCISOWeek());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    function startOfUTCISOWeekYear2(dirtyDate) {
      (0, _index3.default)(1, arguments);
      var year = (0, _index.default)(dirtyDate);
      var fourthOfJanuary = /* @__PURE__ */ new Date(0);
      fourthOfJanuary.setUTCFullYear(year, 0, 4);
      fourthOfJanuary.setUTCHours(0, 0, 0, 0);
      var date = (0, _index2.default)(fourthOfJanuary);
      return date;
    }
    module.exports = exports.default;
  })(startOfUTCISOWeekYear, startOfUTCISOWeekYear.exports);
  return startOfUTCISOWeekYear.exports;
}
var hasRequiredGetUTCISOWeek;
function requireGetUTCISOWeek() {
  if (hasRequiredGetUTCISOWeek) return getUTCISOWeek.exports;
  hasRequiredGetUTCISOWeek = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = getUTCISOWeek2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireStartOfUTCISOWeek());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireStartOfUTCISOWeekYear());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var MILLISECONDS_IN_WEEK = 6048e5;
    function getUTCISOWeek2(dirtyDate) {
      (0, _index4.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
      return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = exports.default;
  })(getUTCISOWeek, getUTCISOWeek.exports);
  return getUTCISOWeek.exports;
}
var getUTCWeek = { exports: {} };
var startOfUTCWeek = { exports: {} };
var defaultOptions = {};
var hasRequiredDefaultOptions;
function requireDefaultOptions() {
  if (hasRequiredDefaultOptions) return defaultOptions;
  hasRequiredDefaultOptions = 1;
  Object.defineProperty(defaultOptions, "__esModule", {
    value: true
  });
  defaultOptions.getDefaultOptions = getDefaultOptions;
  defaultOptions.setDefaultOptions = setDefaultOptions;
  var defaultOptions$1 = {};
  function getDefaultOptions() {
    return defaultOptions$1;
  }
  function setDefaultOptions(newOptions) {
    defaultOptions$1 = newOptions;
  }
  return defaultOptions;
}
var hasRequiredStartOfUTCWeek;
function requireStartOfUTCWeek() {
  if (hasRequiredStartOfUTCWeek) return startOfUTCWeek.exports;
  hasRequiredStartOfUTCWeek = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = startOfUTCWeek2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireToInteger());
    var _index4 = /* @__PURE__ */ requireDefaultOptions();
    function startOfUTCWeek2(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      (0, _index2.default)(1, arguments);
      var defaultOptions2 = (0, _index4.getDefaultOptions)();
      var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
      }
      var date = (0, _index.default)(dirtyDate);
      var day = date.getUTCDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setUTCDate(date.getUTCDate() - diff);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
    module.exports = exports.default;
  })(startOfUTCWeek, startOfUTCWeek.exports);
  return startOfUTCWeek.exports;
}
var startOfUTCWeekYear = { exports: {} };
var getUTCWeekYear = { exports: {} };
var hasRequiredGetUTCWeekYear;
function requireGetUTCWeekYear() {
  if (hasRequiredGetUTCWeekYear) return getUTCWeekYear.exports;
  hasRequiredGetUTCWeekYear = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = getUTCWeekYear2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireStartOfUTCWeek());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireToInteger());
    var _index5 = /* @__PURE__ */ requireDefaultOptions();
    function getUTCWeekYear2(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      (0, _index2.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var year = date.getUTCFullYear();
      var defaultOptions2 = (0, _index5.getDefaultOptions)();
      var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
      }
      var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
      firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
      firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
      var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
      var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
      firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
      firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
      var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }
    module.exports = exports.default;
  })(getUTCWeekYear, getUTCWeekYear.exports);
  return getUTCWeekYear.exports;
}
var hasRequiredStartOfUTCWeekYear;
function requireStartOfUTCWeekYear() {
  if (hasRequiredStartOfUTCWeekYear) return startOfUTCWeekYear.exports;
  hasRequiredStartOfUTCWeekYear = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = startOfUTCWeekYear2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireGetUTCWeekYear());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireStartOfUTCWeek());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireToInteger());
    var _index5 = /* @__PURE__ */ requireDefaultOptions();
    function startOfUTCWeekYear2(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      (0, _index2.default)(1, arguments);
      var defaultOptions2 = (0, _index5.getDefaultOptions)();
      var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
      var year = (0, _index.default)(dirtyDate, options);
      var firstWeek = /* @__PURE__ */ new Date(0);
      firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
      firstWeek.setUTCHours(0, 0, 0, 0);
      var date = (0, _index3.default)(firstWeek, options);
      return date;
    }
    module.exports = exports.default;
  })(startOfUTCWeekYear, startOfUTCWeekYear.exports);
  return startOfUTCWeekYear.exports;
}
var hasRequiredGetUTCWeek;
function requireGetUTCWeek() {
  if (hasRequiredGetUTCWeek) return getUTCWeek.exports;
  hasRequiredGetUTCWeek = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = getUTCWeek2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireStartOfUTCWeek());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireStartOfUTCWeekYear());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var MILLISECONDS_IN_WEEK = 6048e5;
    function getUTCWeek2(dirtyDate, options) {
      (0, _index4.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
      return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = exports.default;
  })(getUTCWeek, getUTCWeek.exports);
  return getUTCWeek.exports;
}
var addLeadingZeros = { exports: {} };
var hasRequiredAddLeadingZeros;
function requireAddLeadingZeros() {
  if (hasRequiredAddLeadingZeros) return addLeadingZeros.exports;
  hasRequiredAddLeadingZeros = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = addLeadingZeros2;
    function addLeadingZeros2(number, targetLength) {
      var sign = number < 0 ? "-" : "";
      var output = Math.abs(number).toString();
      while (output.length < targetLength) {
        output = "0" + output;
      }
      return sign + output;
    }
    module.exports = exports.default;
  })(addLeadingZeros, addLeadingZeros.exports);
  return addLeadingZeros.exports;
}
var lightFormatters = { exports: {} };
var hasRequiredLightFormatters;
function requireLightFormatters() {
  if (hasRequiredLightFormatters) return lightFormatters.exports;
  hasRequiredLightFormatters = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireAddLeadingZeros());
    var formatters2 = {
      // Year
      y: function y(date, token) {
        var signedYear = date.getUTCFullYear();
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.default)(token === "yy" ? year % 100 : year, token.length);
      },
      // Month
      M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _index.default)(month + 1, 2);
      },
      // Day of the month
      d: function d(date, token) {
        return (0, _index.default)(date.getUTCDate(), token.length);
      },
      // AM or PM
      a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch (token) {
          case "a":
          case "aa":
            return dayPeriodEnumValue.toUpperCase();
          case "aaa":
            return dayPeriodEnumValue;
          case "aaaaa":
            return dayPeriodEnumValue[0];
          case "aaaa":
          default:
            return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
      },
      // Hour [1-12]
      h: function h(date, token) {
        return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
      },
      // Hour [0-23]
      H: function H(date, token) {
        return (0, _index.default)(date.getUTCHours(), token.length);
      },
      // Minute
      m: function m(date, token) {
        return (0, _index.default)(date.getUTCMinutes(), token.length);
      },
      // Second
      s: function s(date, token) {
        return (0, _index.default)(date.getUTCSeconds(), token.length);
      },
      // Fraction of second
      S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _index.default)(fractionalSeconds, token.length);
      }
    };
    var _default = formatters2;
    exports.default = _default;
    module.exports = exports.default;
  })(lightFormatters, lightFormatters.exports);
  return lightFormatters.exports;
}
var hasRequiredFormatters$1;
function requireFormatters$1() {
  if (hasRequiredFormatters$1) return formatters$1.exports;
  hasRequiredFormatters$1 = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireGetUTCDayOfYear());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireGetUTCISOWeek());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireGetUTCISOWeekYear());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireGetUTCWeek());
    var _index5 = _interopRequireDefault(/* @__PURE__ */ requireGetUTCWeekYear());
    var _index6 = _interopRequireDefault(/* @__PURE__ */ requireAddLeadingZeros());
    var _index7 = _interopRequireDefault(/* @__PURE__ */ requireLightFormatters());
    var dayPeriodEnum = {
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    };
    var formatters2 = {
      // Era
      G: function G(date, token, localize2) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch (token) {
          // AD, BC
          case "G":
          case "GG":
          case "GGG":
            return localize2.era(era, {
              width: "abbreviated"
            });
          // A, B
          case "GGGGG":
            return localize2.era(era, {
              width: "narrow"
            });
          // Anno Domini, Before Christ
          case "GGGG":
          default:
            return localize2.era(era, {
              width: "wide"
            });
        }
      },
      // Year
      y: function y(date, token, localize2) {
        if (token === "yo") {
          var signedYear = date.getUTCFullYear();
          var year = signedYear > 0 ? signedYear : 1 - signedYear;
          return localize2.ordinalNumber(year, {
            unit: "year"
          });
        }
        return _index7.default.y(date, token);
      },
      // Local week-numbering year
      Y: function Y(date, token, localize2, options) {
        var signedWeekYear = (0, _index5.default)(date, options);
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        if (token === "YY") {
          var twoDigitYear = weekYear % 100;
          return (0, _index6.default)(twoDigitYear, 2);
        }
        if (token === "Yo") {
          return localize2.ordinalNumber(weekYear, {
            unit: "year"
          });
        }
        return (0, _index6.default)(weekYear, token.length);
      },
      // ISO week-numbering year
      R: function R(date, token) {
        var isoWeekYear = (0, _index3.default)(date);
        return (0, _index6.default)(isoWeekYear, token.length);
      },
      // Extended year. This is a single number designating the year of this calendar system.
      // The main difference between `y` and `u` localizers are B.C. years:
      // | Year | `y` | `u` |
      // |------|-----|-----|
      // | AC 1 |   1 |   1 |
      // | BC 1 |   1 |   0 |
      // | BC 2 |   2 |  -1 |
      // Also `yy` always returns the last two digits of a year,
      // while `uu` pads single digit years to 2 characters and returns other years unchanged.
      u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _index6.default)(year, token.length);
      },
      // Quarter
      Q: function Q(date, token, localize2) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch (token) {
          // 1, 2, 3, 4
          case "Q":
            return String(quarter);
          // 01, 02, 03, 04
          case "QQ":
            return (0, _index6.default)(quarter, 2);
          // 1st, 2nd, 3rd, 4th
          case "Qo":
            return localize2.ordinalNumber(quarter, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "QQQ":
            return localize2.quarter(quarter, {
              width: "abbreviated",
              context: "formatting"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "QQQQQ":
            return localize2.quarter(quarter, {
              width: "narrow",
              context: "formatting"
            });
          // 1st quarter, 2nd quarter, ...
          case "QQQQ":
          default:
            return localize2.quarter(quarter, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone quarter
      q: function q(date, token, localize2) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch (token) {
          // 1, 2, 3, 4
          case "q":
            return String(quarter);
          // 01, 02, 03, 04
          case "qq":
            return (0, _index6.default)(quarter, 2);
          // 1st, 2nd, 3rd, 4th
          case "qo":
            return localize2.ordinalNumber(quarter, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "qqq":
            return localize2.quarter(quarter, {
              width: "abbreviated",
              context: "standalone"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "qqqqq":
            return localize2.quarter(quarter, {
              width: "narrow",
              context: "standalone"
            });
          // 1st quarter, 2nd quarter, ...
          case "qqqq":
          default:
            return localize2.quarter(quarter, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Month
      M: function M(date, token, localize2) {
        var month = date.getUTCMonth();
        switch (token) {
          case "M":
          case "MM":
            return _index7.default.M(date, token);
          // 1st, 2nd, ..., 12th
          case "Mo":
            return localize2.ordinalNumber(month + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "MMM":
            return localize2.month(month, {
              width: "abbreviated",
              context: "formatting"
            });
          // J, F, ..., D
          case "MMMMM":
            return localize2.month(month, {
              width: "narrow",
              context: "formatting"
            });
          // January, February, ..., December
          case "MMMM":
          default:
            return localize2.month(month, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone month
      L: function L(date, token, localize2) {
        var month = date.getUTCMonth();
        switch (token) {
          // 1, 2, ..., 12
          case "L":
            return String(month + 1);
          // 01, 02, ..., 12
          case "LL":
            return (0, _index6.default)(month + 1, 2);
          // 1st, 2nd, ..., 12th
          case "Lo":
            return localize2.ordinalNumber(month + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "LLL":
            return localize2.month(month, {
              width: "abbreviated",
              context: "standalone"
            });
          // J, F, ..., D
          case "LLLLL":
            return localize2.month(month, {
              width: "narrow",
              context: "standalone"
            });
          // January, February, ..., December
          case "LLLL":
          default:
            return localize2.month(month, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Local week of year
      w: function w(date, token, localize2, options) {
        var week = (0, _index4.default)(date, options);
        if (token === "wo") {
          return localize2.ordinalNumber(week, {
            unit: "week"
          });
        }
        return (0, _index6.default)(week, token.length);
      },
      // ISO week of year
      I: function I(date, token, localize2) {
        var isoWeek = (0, _index2.default)(date);
        if (token === "Io") {
          return localize2.ordinalNumber(isoWeek, {
            unit: "week"
          });
        }
        return (0, _index6.default)(isoWeek, token.length);
      },
      // Day of the month
      d: function d(date, token, localize2) {
        if (token === "do") {
          return localize2.ordinalNumber(date.getUTCDate(), {
            unit: "date"
          });
        }
        return _index7.default.d(date, token);
      },
      // Day of year
      D: function D(date, token, localize2) {
        var dayOfYear = (0, _index.default)(date);
        if (token === "Do") {
          return localize2.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
          });
        }
        return (0, _index6.default)(dayOfYear, token.length);
      },
      // Day of week
      E: function E(date, token, localize2) {
        var dayOfWeek = date.getUTCDay();
        switch (token) {
          // Tue
          case "E":
          case "EE":
          case "EEE":
            return localize2.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "EEEEE":
            return localize2.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "EEEEEE":
            return localize2.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "EEEE":
          default:
            return localize2.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Local day of week
      e: function e(date, token, localize2, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch (token) {
          // Numerical value (Nth day of week with current locale or weekStartsOn)
          case "e":
            return String(localDayOfWeek);
          // Padded numerical value
          case "ee":
            return (0, _index6.default)(localDayOfWeek, 2);
          // 1st, 2nd, ..., 7th
          case "eo":
            return localize2.ordinalNumber(localDayOfWeek, {
              unit: "day"
            });
          case "eee":
            return localize2.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "eeeee":
            return localize2.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "eeeeee":
            return localize2.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "eeee":
          default:
            return localize2.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone local day of week
      c: function c(date, token, localize2, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch (token) {
          // Numerical value (same as in `e`)
          case "c":
            return String(localDayOfWeek);
          // Padded numerical value
          case "cc":
            return (0, _index6.default)(localDayOfWeek, token.length);
          // 1st, 2nd, ..., 7th
          case "co":
            return localize2.ordinalNumber(localDayOfWeek, {
              unit: "day"
            });
          case "ccc":
            return localize2.day(dayOfWeek, {
              width: "abbreviated",
              context: "standalone"
            });
          // T
          case "ccccc":
            return localize2.day(dayOfWeek, {
              width: "narrow",
              context: "standalone"
            });
          // Tu
          case "cccccc":
            return localize2.day(dayOfWeek, {
              width: "short",
              context: "standalone"
            });
          // Tuesday
          case "cccc":
          default:
            return localize2.day(dayOfWeek, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // ISO day of week
      i: function i(date, token, localize2) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch (token) {
          // 2
          case "i":
            return String(isoDayOfWeek);
          // 02
          case "ii":
            return (0, _index6.default)(isoDayOfWeek, token.length);
          // 2nd
          case "io":
            return localize2.ordinalNumber(isoDayOfWeek, {
              unit: "day"
            });
          // Tue
          case "iii":
            return localize2.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "iiiii":
            return localize2.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "iiiiii":
            return localize2.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "iiii":
          default:
            return localize2.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM or PM
      a: function a(date, token, localize2) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch (token) {
          case "a":
          case "aa":
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "aaa":
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "aaaaa":
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "aaaa":
          default:
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM, PM, midnight, noon
      b: function b(date, token, localize2) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) {
          dayPeriodEnumValue = dayPeriodEnum.noon;
        } else if (hours === 0) {
          dayPeriodEnumValue = dayPeriodEnum.midnight;
        } else {
          dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        }
        switch (token) {
          case "b":
          case "bb":
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "bbb":
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "bbbbb":
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "bbbb":
          default:
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // in the morning, in the afternoon, in the evening, at night
      B: function B(date, token, localize2) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) {
          dayPeriodEnumValue = dayPeriodEnum.evening;
        } else if (hours >= 12) {
          dayPeriodEnumValue = dayPeriodEnum.afternoon;
        } else if (hours >= 4) {
          dayPeriodEnumValue = dayPeriodEnum.morning;
        } else {
          dayPeriodEnumValue = dayPeriodEnum.night;
        }
        switch (token) {
          case "B":
          case "BB":
          case "BBB":
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "BBBBB":
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "BBBB":
          default:
            return localize2.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Hour [1-12]
      h: function h(date, token, localize2) {
        if (token === "ho") {
          var hours = date.getUTCHours() % 12;
          if (hours === 0) hours = 12;
          return localize2.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return _index7.default.h(date, token);
      },
      // Hour [0-23]
      H: function H(date, token, localize2) {
        if (token === "Ho") {
          return localize2.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
          });
        }
        return _index7.default.H(date, token);
      },
      // Hour [0-11]
      K: function K(date, token, localize2) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") {
          return localize2.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return (0, _index6.default)(hours, token.length);
      },
      // Hour [1-24]
      k: function k(date, token, localize2) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") {
          return localize2.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return (0, _index6.default)(hours, token.length);
      },
      // Minute
      m: function m(date, token, localize2) {
        if (token === "mo") {
          return localize2.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
          });
        }
        return _index7.default.m(date, token);
      },
      // Second
      s: function s(date, token, localize2) {
        if (token === "so") {
          return localize2.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
          });
        }
        return _index7.default.s(date, token);
      },
      // Fraction of second
      S: function S(date, token) {
        return _index7.default.S(date, token);
      },
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) {
          return "Z";
        }
        switch (token) {
          // Hours and optional minutes
          case "X":
            return formatTimezoneWithOptionalMinutes(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`
          case "XXXX":
          case "XX":
            return formatTimezone(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`
          case "XXXXX":
          case "XXX":
          // Hours and minutes with `:` delimiter
          default:
            return formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Hours and optional minutes
          case "x":
            return formatTimezoneWithOptionalMinutes(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`
          case "xxxx":
          case "xx":
            return formatTimezone(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`
          case "xxxxx":
          case "xxx":
          // Hours and minutes with `:` delimiter
          default:
            return formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (GMT)
      O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Short
          case "O":
          case "OO":
          case "OOO":
            return "GMT" + formatTimezoneShort(timezoneOffset, ":");
          // Long
          case "OOOO":
          default:
            return "GMT" + formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (specific non-location)
      z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Short
          case "z":
          case "zz":
          case "zzz":
            return "GMT" + formatTimezoneShort(timezoneOffset, ":");
          // Long
          case "zzzz":
          default:
            return "GMT" + formatTimezone(timezoneOffset, ":");
        }
      },
      // Seconds timestamp
      t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1e3);
        return (0, _index6.default)(timestamp, token.length);
      },
      // Milliseconds timestamp
      T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _index6.default)(timestamp, token.length);
      }
    };
    function formatTimezoneShort(offset, dirtyDelimiter) {
      var sign = offset > 0 ? "-" : "+";
      var absOffset = Math.abs(offset);
      var hours = Math.floor(absOffset / 60);
      var minutes = absOffset % 60;
      if (minutes === 0) {
        return sign + String(hours);
      }
      var delimiter = dirtyDelimiter;
      return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
    }
    function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
      if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
      }
      return formatTimezone(offset, dirtyDelimiter);
    }
    function formatTimezone(offset, dirtyDelimiter) {
      var delimiter = dirtyDelimiter || "";
      var sign = offset > 0 ? "-" : "+";
      var absOffset = Math.abs(offset);
      var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
      var minutes = (0, _index6.default)(absOffset % 60, 2);
      return sign + hours + delimiter + minutes;
    }
    var _default = formatters2;
    exports.default = _default;
    module.exports = exports.default;
  })(formatters$1, formatters$1.exports);
  return formatters$1.exports;
}
var longFormatters = { exports: {} };
var hasRequiredLongFormatters;
function requireLongFormatters() {
  if (hasRequiredLongFormatters) return longFormatters.exports;
  hasRequiredLongFormatters = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var dateLongFormatter = function dateLongFormatter2(pattern, formatLong2) {
      switch (pattern) {
        case "P":
          return formatLong2.date({
            width: "short"
          });
        case "PP":
          return formatLong2.date({
            width: "medium"
          });
        case "PPP":
          return formatLong2.date({
            width: "long"
          });
        case "PPPP":
        default:
          return formatLong2.date({
            width: "full"
          });
      }
    };
    var timeLongFormatter = function timeLongFormatter2(pattern, formatLong2) {
      switch (pattern) {
        case "p":
          return formatLong2.time({
            width: "short"
          });
        case "pp":
          return formatLong2.time({
            width: "medium"
          });
        case "ppp":
          return formatLong2.time({
            width: "long"
          });
        case "pppp":
        default:
          return formatLong2.time({
            width: "full"
          });
      }
    };
    var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong2) {
      var matchResult = pattern.match(/(P+)(p+)?/) || [];
      var datePattern = matchResult[1];
      var timePattern = matchResult[2];
      if (!timePattern) {
        return dateLongFormatter(pattern, formatLong2);
      }
      var dateTimeFormat;
      switch (datePattern) {
        case "P":
          dateTimeFormat = formatLong2.dateTime({
            width: "short"
          });
          break;
        case "PP":
          dateTimeFormat = formatLong2.dateTime({
            width: "medium"
          });
          break;
        case "PPP":
          dateTimeFormat = formatLong2.dateTime({
            width: "long"
          });
          break;
        case "PPPP":
        default:
          dateTimeFormat = formatLong2.dateTime({
            width: "full"
          });
          break;
      }
      return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
    };
    var longFormatters2 = {
      p: timeLongFormatter,
      P: dateTimeLongFormatter
    };
    var _default = longFormatters2;
    exports.default = _default;
    module.exports = exports.default;
  })(longFormatters, longFormatters.exports);
  return longFormatters.exports;
}
var getTimezoneOffsetInMilliseconds = { exports: {} };
var hasRequiredGetTimezoneOffsetInMilliseconds;
function requireGetTimezoneOffsetInMilliseconds() {
  if (hasRequiredGetTimezoneOffsetInMilliseconds) return getTimezoneOffsetInMilliseconds.exports;
  hasRequiredGetTimezoneOffsetInMilliseconds = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = getTimezoneOffsetInMilliseconds2;
    function getTimezoneOffsetInMilliseconds2(date) {
      var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
      utcDate.setUTCFullYear(date.getFullYear());
      return date.getTime() - utcDate.getTime();
    }
    module.exports = exports.default;
  })(getTimezoneOffsetInMilliseconds, getTimezoneOffsetInMilliseconds.exports);
  return getTimezoneOffsetInMilliseconds.exports;
}
var protectedTokens = {};
var hasRequiredProtectedTokens;
function requireProtectedTokens() {
  if (hasRequiredProtectedTokens) return protectedTokens;
  hasRequiredProtectedTokens = 1;
  Object.defineProperty(protectedTokens, "__esModule", {
    value: true
  });
  protectedTokens.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
  protectedTokens.isProtectedWeekYearToken = isProtectedWeekYearToken;
  protectedTokens.throwProtectedError = throwProtectedError;
  var protectedDayOfYearTokens = ["D", "DD"];
  var protectedWeekYearTokens = ["YY", "YYYY"];
  function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
  }
  function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
  }
  function throwProtectedError(token, format2, input) {
    if (token === "YYYY") {
      throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    } else if (token === "YY") {
      throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    } else if (token === "D") {
      throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    } else if (token === "DD") {
      throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    }
  }
  return protectedTokens;
}
var defaultLocale = { exports: {} };
var enUS = { exports: {} };
var formatDistance$2 = { exports: {} };
var hasRequiredFormatDistance;
function requireFormatDistance() {
  if (hasRequiredFormatDistance) return formatDistance$2.exports;
  hasRequiredFormatDistance = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var formatDistanceLocale2 = {
      lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
      },
      xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
      },
      halfAMinute: "half a minute",
      lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
      },
      xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
      },
      aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
      },
      xHours: {
        one: "1 hour",
        other: "{{count}} hours"
      },
      xDays: {
        one: "1 day",
        other: "{{count}} days"
      },
      aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
      },
      xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
      },
      aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
      },
      xMonths: {
        one: "1 month",
        other: "{{count}} months"
      },
      aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
      },
      xYears: {
        one: "1 year",
        other: "{{count}} years"
      },
      overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
      },
      almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
      }
    };
    var formatDistance4 = function formatDistance5(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale2[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "in " + result;
        } else {
          return result + " ago";
        }
      }
      return result;
    };
    var _default = formatDistance4;
    exports.default = _default;
    module.exports = exports.default;
  })(formatDistance$2, formatDistance$2.exports);
  return formatDistance$2.exports;
}
var formatLong$2 = { exports: {} };
var buildFormatLongFn$1 = { exports: {} };
var hasRequiredBuildFormatLongFn;
function requireBuildFormatLongFn() {
  if (hasRequiredBuildFormatLongFn) return buildFormatLongFn$1.exports;
  hasRequiredBuildFormatLongFn = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = buildFormatLongFn2;
    function buildFormatLongFn2(args) {
      return function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format2 = args.formats[width] || args.formats[args.defaultWidth];
        return format2;
      };
    }
    module.exports = exports.default;
  })(buildFormatLongFn$1, buildFormatLongFn$1.exports);
  return buildFormatLongFn$1.exports;
}
var hasRequiredFormatLong;
function requireFormatLong() {
  if (hasRequiredFormatLong) return formatLong$2.exports;
  hasRequiredFormatLong = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireBuildFormatLongFn());
    var dateFormats2 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    var timeFormats2 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    var dateTimeFormats2 = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    var formatLong2 = {
      date: (0, _index.default)({
        formats: dateFormats2,
        defaultWidth: "full"
      }),
      time: (0, _index.default)({
        formats: timeFormats2,
        defaultWidth: "full"
      }),
      dateTime: (0, _index.default)({
        formats: dateTimeFormats2,
        defaultWidth: "full"
      })
    };
    var _default = formatLong2;
    exports.default = _default;
    module.exports = exports.default;
  })(formatLong$2, formatLong$2.exports);
  return formatLong$2.exports;
}
var formatRelative$2 = { exports: {} };
var hasRequiredFormatRelative;
function requireFormatRelative() {
  if (hasRequiredFormatRelative) return formatRelative$2.exports;
  hasRequiredFormatRelative = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var formatRelativeLocale2 = {
      lastWeek: "'last' eeee 'at' p",
      yesterday: "'yesterday at' p",
      today: "'today at' p",
      tomorrow: "'tomorrow at' p",
      nextWeek: "eeee 'at' p",
      other: "P"
    };
    var formatRelative4 = function formatRelative5(token, _date, _baseDate, _options) {
      return formatRelativeLocale2[token];
    };
    var _default = formatRelative4;
    exports.default = _default;
    module.exports = exports.default;
  })(formatRelative$2, formatRelative$2.exports);
  return formatRelative$2.exports;
}
var localize$2 = { exports: {} };
var buildLocalizeFn$1 = { exports: {} };
var hasRequiredBuildLocalizeFn;
function requireBuildLocalizeFn() {
  if (hasRequiredBuildLocalizeFn) return buildLocalizeFn$1.exports;
  hasRequiredBuildLocalizeFn = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = buildLocalizeFn2;
    function buildLocalizeFn2(args) {
      return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
          var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
          var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
          valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
          var _defaultWidth = args.defaultWidth;
          var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
          valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        return valuesArray[index2];
      };
    }
    module.exports = exports.default;
  })(buildLocalizeFn$1, buildLocalizeFn$1.exports);
  return buildLocalizeFn$1.exports;
}
var hasRequiredLocalize;
function requireLocalize() {
  if (hasRequiredLocalize) return localize$2.exports;
  hasRequiredLocalize = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireBuildLocalizeFn());
    var eraValues2 = {
      narrow: ["B", "A"],
      abbreviated: ["BC", "AD"],
      wide: ["Before Christ", "Anno Domini"]
    };
    var quarterValues2 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
    };
    var monthValues2 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };
    var dayValues2 = {
      narrow: ["S", "M", "T", "W", "T", "F", "S"],
      short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    };
    var dayPeriodValues2 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      }
    };
    var formattingDayPeriodValues2 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      }
    };
    var ordinalNumber4 = function ordinalNumber5(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + "st";
          case 2:
            return number + "nd";
          case 3:
            return number + "rd";
        }
      }
      return number + "th";
    };
    var localize2 = {
      ordinalNumber: ordinalNumber4,
      era: (0, _index.default)({
        values: eraValues2,
        defaultWidth: "wide"
      }),
      quarter: (0, _index.default)({
        values: quarterValues2,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback3(quarter) {
          return quarter - 1;
        }
      }),
      month: (0, _index.default)({
        values: monthValues2,
        defaultWidth: "wide"
      }),
      day: (0, _index.default)({
        values: dayValues2,
        defaultWidth: "wide"
      }),
      dayPeriod: (0, _index.default)({
        values: dayPeriodValues2,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues2,
        defaultFormattingWidth: "wide"
      })
    };
    var _default = localize2;
    exports.default = _default;
    module.exports = exports.default;
  })(localize$2, localize$2.exports);
  return localize$2.exports;
}
var match$2 = { exports: {} };
var buildMatchFn$1 = { exports: {} };
var hasRequiredBuildMatchFn;
function requireBuildMatchFn() {
  if (hasRequiredBuildMatchFn) return buildMatchFn$1.exports;
  hasRequiredBuildMatchFn = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = buildMatchFn2;
    function buildMatchFn2(args) {
      return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) {
          return null;
        }
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex2(parsePatterns, function(pattern) {
          return pattern.test(matchedString);
        }) : findKey2(parsePatterns, function(pattern) {
          return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
          value,
          rest
        };
      };
    }
    function findKey2(object2, predicate) {
      for (var key in object2) {
        if (object2.hasOwnProperty(key) && predicate(object2[key])) {
          return key;
        }
      }
      return void 0;
    }
    function findIndex2(array, predicate) {
      for (var key = 0; key < array.length; key++) {
        if (predicate(array[key])) {
          return key;
        }
      }
      return void 0;
    }
    module.exports = exports.default;
  })(buildMatchFn$1, buildMatchFn$1.exports);
  return buildMatchFn$1.exports;
}
var buildMatchPatternFn$1 = { exports: {} };
var hasRequiredBuildMatchPatternFn;
function requireBuildMatchPatternFn() {
  if (hasRequiredBuildMatchPatternFn) return buildMatchPatternFn$1.exports;
  hasRequiredBuildMatchPatternFn = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = buildMatchPatternFn2;
    function buildMatchPatternFn2(args) {
      return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
          value,
          rest
        };
      };
    }
    module.exports = exports.default;
  })(buildMatchPatternFn$1, buildMatchPatternFn$1.exports);
  return buildMatchPatternFn$1.exports;
}
var hasRequiredMatch;
function requireMatch() {
  if (hasRequiredMatch) return match$2.exports;
  hasRequiredMatch = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireBuildMatchFn());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireBuildMatchPatternFn());
    var matchOrdinalNumberPattern2 = /^(\d+)(th|st|nd|rd)?/i;
    var parseOrdinalNumberPattern2 = /\d+/i;
    var matchEraPatterns2 = {
      narrow: /^(b|a)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(before christ|before common era|anno domini|common era)/i
    };
    var parseEraPatterns2 = {
      any: [/^b/i, /^(a|c)/i]
    };
    var matchQuarterPatterns2 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    var parseQuarterPatterns2 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    var matchMonthPatterns2 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
      wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    var parseMonthPatterns2 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    var matchDayPatterns2 = {
      narrow: /^[smtwf]/i,
      short: /^(su|mo|tu|we|th|fr|sa)/i,
      abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
      wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    var parseDayPatterns2 = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    };
    var matchDayPeriodPatterns2 = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    var parseDayPeriodPatterns2 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    };
    var match2 = {
      ordinalNumber: (0, _index2.default)({
        matchPattern: matchOrdinalNumberPattern2,
        parsePattern: parseOrdinalNumberPattern2,
        valueCallback: function valueCallback5(value) {
          return parseInt(value, 10);
        }
      }),
      era: (0, _index.default)({
        matchPatterns: matchEraPatterns2,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns2,
        defaultParseWidth: "any"
      }),
      quarter: (0, _index.default)({
        matchPatterns: matchQuarterPatterns2,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns2,
        defaultParseWidth: "any",
        valueCallback: function valueCallback5(index2) {
          return index2 + 1;
        }
      }),
      month: (0, _index.default)({
        matchPatterns: matchMonthPatterns2,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns2,
        defaultParseWidth: "any"
      }),
      day: (0, _index.default)({
        matchPatterns: matchDayPatterns2,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns2,
        defaultParseWidth: "any"
      }),
      dayPeriod: (0, _index.default)({
        matchPatterns: matchDayPeriodPatterns2,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns2,
        defaultParseWidth: "any"
      })
    };
    var _default = match2;
    exports.default = _default;
    module.exports = exports.default;
  })(match$2, match$2.exports);
  return match$2.exports;
}
var hasRequiredEnUS;
function requireEnUS() {
  if (hasRequiredEnUS) return enUS.exports;
  hasRequiredEnUS = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireFormatDistance());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireFormatLong());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireFormatRelative());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireLocalize());
    var _index5 = _interopRequireDefault(/* @__PURE__ */ requireMatch());
    var locale2 = {
      code: "en-US",
      formatDistance: _index.default,
      formatLong: _index2.default,
      formatRelative: _index3.default,
      localize: _index4.default,
      match: _index5.default,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    var _default = locale2;
    exports.default = _default;
    module.exports = exports.default;
  })(enUS, enUS.exports);
  return enUS.exports;
}
var hasRequiredDefaultLocale;
function requireDefaultLocale() {
  if (hasRequiredDefaultLocale) return defaultLocale.exports;
  hasRequiredDefaultLocale = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireEnUS());
    var _default = _index.default;
    exports.default = _default;
    module.exports = exports.default;
  })(defaultLocale, defaultLocale.exports);
  return defaultLocale.exports;
}
var hasRequiredFormat$1;
function requireFormat$1() {
  if (hasRequiredFormat$1) return format.exports;
  hasRequiredFormat$1 = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = format2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireIsValid());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireSubMilliseconds());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireToDate$1());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireFormatters$1());
    var _index5 = _interopRequireDefault(/* @__PURE__ */ requireLongFormatters());
    var _index6 = _interopRequireDefault(/* @__PURE__ */ requireGetTimezoneOffsetInMilliseconds());
    var _index7 = /* @__PURE__ */ requireProtectedTokens();
    var _index8 = _interopRequireDefault(/* @__PURE__ */ requireToInteger());
    var _index9 = _interopRequireDefault(/* @__PURE__ */ requireRequiredArgs());
    var _index10 = /* @__PURE__ */ requireDefaultOptions();
    var _index11 = _interopRequireDefault(/* @__PURE__ */ requireDefaultLocale());
    var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var escapedStringRegExp = /^'([^]*?)'?$/;
    var doubleQuoteRegExp = /''/g;
    var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
    function format2(dirtyDate, dirtyFormatStr, options) {
      var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
      (0, _index9.default)(2, arguments);
      var formatStr = String(dirtyFormatStr);
      var defaultOptions2 = (0, _index10.getDefaultOptions)();
      var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
      var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
      }
      var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
      }
      if (!locale2.localize) {
        throw new RangeError("locale must contain localize property");
      }
      if (!locale2.formatLong) {
        throw new RangeError("locale must contain formatLong property");
      }
      var originalDate = (0, _index3.default)(dirtyDate);
      if (!(0, _index.default)(originalDate)) {
        throw new RangeError("Invalid time value");
      }
      var timezoneOffset = (0, _index6.default)(originalDate);
      var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
      var formatterOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale: locale2,
        _originalDate: originalDate
      };
      var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
          var longFormatter = _index5.default[firstCharacter];
          return longFormatter(substring, locale2.formatLong);
        }
        return substring;
      }).join("").match(formattingTokensRegExp).map(function(substring) {
        if (substring === "''") {
          return "'";
        }
        var firstCharacter = substring[0];
        if (firstCharacter === "'") {
          return cleanEscapedString(substring);
        }
        var formatter = _index4.default[firstCharacter];
        if (formatter) {
          if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
            (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
          }
          if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
            (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
          }
          return formatter(utcDate, substring, locale2.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        return substring;
      }).join("");
      return result;
    }
    function cleanEscapedString(input) {
      var matched = input.match(escapedStringRegExp);
      if (!matched) {
        return input;
      }
      return matched[1].replace(doubleQuoteRegExp, "'");
    }
    module.exports = exports.default;
  })(format, format.exports);
  return format.exports;
}
var formatters = { exports: {} };
var tzIntlTimeZoneName = { exports: {} };
var hasRequiredTzIntlTimeZoneName;
function requireTzIntlTimeZoneName() {
  if (hasRequiredTzIntlTimeZoneName) return tzIntlTimeZoneName.exports;
  hasRequiredTzIntlTimeZoneName = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = tzIntlTimeZoneName2;
    function tzIntlTimeZoneName2(length, date, options) {
      var dtf = getDTF(length, options.timeZone, options.locale);
      return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
    }
    function partsTimeZone(dtf, date) {
      var formatted = dtf.formatToParts(date);
      for (var i = formatted.length - 1; i >= 0; --i) {
        if (formatted[i].type === "timeZoneName") {
          return formatted[i].value;
        }
      }
    }
    function hackyTimeZone(dtf, date) {
      var formatted = dtf.format(date).replace(/\u200E/g, "");
      var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
      return tzNameMatch ? tzNameMatch[0].substr(1) : "";
    }
    function getDTF(length, timeZone, locale2) {
      if (locale2 && !locale2.code) {
        throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
      }
      return new Intl.DateTimeFormat(locale2 ? [locale2.code, "en-US"] : void 0, {
        timeZone,
        timeZoneName: length
      });
    }
    module.exports = exports.default;
  })(tzIntlTimeZoneName, tzIntlTimeZoneName.exports);
  return tzIntlTimeZoneName.exports;
}
var tzParseTimezone = { exports: {} };
var tzTokenizeDate = { exports: {} };
var hasRequiredTzTokenizeDate;
function requireTzTokenizeDate() {
  if (hasRequiredTzTokenizeDate) return tzTokenizeDate.exports;
  hasRequiredTzTokenizeDate = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = tzTokenizeDate2;
    function tzTokenizeDate2(date, timeZone) {
      var dtf = getDateTimeFormat(timeZone);
      return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    }
    var typeToPos = {
      year: 0,
      month: 1,
      day: 2,
      hour: 3,
      minute: 4,
      second: 5
    };
    function partsOffset(dtf, date) {
      try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for (var i = 0; i < formatted.length; i++) {
          var pos = typeToPos[formatted[i].type];
          if (pos >= 0) {
            filled[pos] = parseInt(formatted[i].value, 10);
          }
        }
        return filled;
      } catch (error) {
        if (error instanceof RangeError) {
          return [NaN];
        }
        throw error;
      }
    }
    function hackyOffset(dtf, date) {
      var formatted = dtf.format(date).replace(/\u200E/g, "");
      var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
      return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
    }
    var dtfCache = {};
    function getDateTimeFormat(timeZone) {
      if (!dtfCache[timeZone]) {
        var testDateFormatted = new Intl.DateTimeFormat("en-US", {
          hour12: false,
          timeZone: "America/New_York",
          year: "numeric",
          month: "numeric",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z"));
        var hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
        dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
          hour12: false,
          timeZone,
          year: "numeric",
          month: "numeric",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
          hourCycle: "h23",
          timeZone,
          year: "numeric",
          month: "numeric",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        });
      }
      return dtfCache[timeZone];
    }
    module.exports = exports.default;
  })(tzTokenizeDate, tzTokenizeDate.exports);
  return tzTokenizeDate.exports;
}
var newDateUTC = { exports: {} };
var hasRequiredNewDateUTC;
function requireNewDateUTC() {
  if (hasRequiredNewDateUTC) return newDateUTC.exports;
  hasRequiredNewDateUTC = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = newDateUTC2;
    function newDateUTC2(fullYear, month, day, hour, minute, second, millisecond) {
      var utcDate = /* @__PURE__ */ new Date(0);
      utcDate.setUTCFullYear(fullYear, month, day);
      utcDate.setUTCHours(hour, minute, second, millisecond);
      return utcDate;
    }
    module.exports = exports.default;
  })(newDateUTC, newDateUTC.exports);
  return newDateUTC.exports;
}
var hasRequiredTzParseTimezone;
function requireTzParseTimezone() {
  if (hasRequiredTzParseTimezone) return tzParseTimezone.exports;
  hasRequiredTzParseTimezone = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = tzParseTimezone2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireTzTokenizeDate());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireNewDateUTC());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var MILLISECONDS_IN_HOUR = 36e5;
    var MILLISECONDS_IN_MINUTE = 6e4;
    var patterns = {
      timezoneZ: /^(Z)$/,
      timezoneHH: /^([+-]\d{2})$/,
      timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
    };
    function tzParseTimezone2(timezoneString, date, isUtcDate) {
      var token;
      var absoluteOffset;
      if (!timezoneString) {
        return 0;
      }
      token = patterns.timezoneZ.exec(timezoneString);
      if (token) {
        return 0;
      }
      var hours;
      token = patterns.timezoneHH.exec(timezoneString);
      if (token) {
        hours = parseInt(token[1], 10);
        if (!validateTimezone(hours)) {
          return NaN;
        }
        return -(hours * MILLISECONDS_IN_HOUR);
      }
      token = patterns.timezoneHHMM.exec(timezoneString);
      if (token) {
        hours = parseInt(token[1], 10);
        var minutes = parseInt(token[2], 10);
        if (!validateTimezone(hours, minutes)) {
          return NaN;
        }
        absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
        return hours > 0 ? -absoluteOffset : absoluteOffset;
      }
      if (isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : toUtcDate(date);
        var offset = calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
        return -fixedOffset;
      }
      return NaN;
    }
    function toUtcDate(date) {
      return (0, _index2.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function calcOffset(date, timezoneString) {
      var tokens = (0, _index.default)(date, timezoneString);
      var asUTC = (0, _index2.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
      var asTS = date.getTime();
      var over = asTS % 1e3;
      asTS -= over >= 0 ? over : 1e3 + over;
      return asUTC - asTS;
    }
    function fixOffset(date, offset, timezoneString) {
      var localTS = date.getTime();
      var utcGuess = localTS - offset;
      var o2 = calcOffset(new Date(utcGuess), timezoneString);
      if (offset === o2) {
        return offset;
      }
      utcGuess -= o2 - offset;
      var o3 = calcOffset(new Date(utcGuess), timezoneString);
      if (o2 === o3) {
        return o2;
      }
      return Math.max(o2, o3);
    }
    function validateTimezone(hours, minutes) {
      return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var validIANATimezoneCache = {};
    function isValidTimezoneIANAString(timeZoneString) {
      if (validIANATimezoneCache[timeZoneString]) return true;
      try {
        new Intl.DateTimeFormat(void 0, {
          timeZone: timeZoneString
        });
        validIANATimezoneCache[timeZoneString] = true;
        return true;
      } catch (error) {
        return false;
      }
    }
    module.exports = exports.default;
  })(tzParseTimezone, tzParseTimezone.exports);
  return tzParseTimezone.exports;
}
var hasRequiredFormatters;
function requireFormatters() {
  if (hasRequiredFormatters) return formatters.exports;
  hasRequiredFormatters = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireTzIntlTimeZoneName());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireTzParseTimezone());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var MILLISECONDS_IN_MINUTE = 60 * 1e3;
    var formatters2 = {
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function(date, token, localize2, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        if (timezoneOffset === 0) {
          return "Z";
        }
        switch (token) {
          // Hours and optional minutes
          case "X":
            return formatTimezoneWithOptionalMinutes(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimeter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`
          case "XXXX":
          case "XX":
            return formatTimezone(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimeter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`
          case "XXXXX":
          case "XXX":
          // Hours and minutes with `:` delimeter
          default:
            return formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function(date, token, localize2, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch (token) {
          // Hours and optional minutes
          case "x":
            return formatTimezoneWithOptionalMinutes(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimeter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`
          case "xxxx":
          case "xx":
            return formatTimezone(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimeter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`
          case "xxxxx":
          case "xxx":
          // Hours and minutes with `:` delimeter
          default:
            return formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (GMT)
      O: function(date, token, localize2, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch (token) {
          // Short
          case "O":
          case "OO":
          case "OOO":
            return "GMT" + formatTimezoneShort(timezoneOffset, ":");
          // Long
          case "OOOO":
          default:
            return "GMT" + formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (specific non-location)
      z: function(date, token, localize2, options) {
        var originalDate = options._originalDate || date;
        switch (token) {
          // Short
          case "z":
          case "zz":
          case "zzz":
            return (0, _index.default)("short", originalDate, options);
          // Long
          case "zzzz":
          default:
            return (0, _index.default)("long", originalDate, options);
        }
      }
    };
    function getTimeZoneOffset(timeZone, originalDate) {
      var timeZoneOffset = timeZone ? (0, _index2.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
      if (Number.isNaN(timeZoneOffset)) {
        throw new RangeError("Invalid time zone specified: " + timeZone);
      }
      return timeZoneOffset;
    }
    function addLeadingZeros2(number, targetLength) {
      var sign = number < 0 ? "-" : "";
      var output = Math.abs(number).toString();
      while (output.length < targetLength) {
        output = "0" + output;
      }
      return sign + output;
    }
    function formatTimezone(offset, dirtyDelimeter) {
      var delimeter = dirtyDelimeter || "";
      var sign = offset > 0 ? "-" : "+";
      var absOffset = Math.abs(offset);
      var hours = addLeadingZeros2(Math.floor(absOffset / 60), 2);
      var minutes = addLeadingZeros2(Math.floor(absOffset % 60), 2);
      return sign + hours + delimeter + minutes;
    }
    function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
      if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + addLeadingZeros2(Math.abs(offset) / 60, 2);
      }
      return formatTimezone(offset, dirtyDelimeter);
    }
    function formatTimezoneShort(offset, dirtyDelimeter) {
      var sign = offset > 0 ? "-" : "+";
      var absOffset = Math.abs(offset);
      var hours = Math.floor(absOffset / 60);
      var minutes = absOffset % 60;
      if (minutes === 0) {
        return sign + String(hours);
      }
      var delimeter = dirtyDelimeter;
      return sign + String(hours) + delimeter + addLeadingZeros2(minutes, 2);
    }
    var _default = formatters2;
    exports.default = _default;
    module.exports = exports.default;
  })(formatters, formatters.exports);
  return formatters.exports;
}
var toDate$1 = { exports: {} };
var tzPattern = { exports: {} };
var hasRequiredTzPattern;
function requireTzPattern() {
  if (hasRequiredTzPattern) return tzPattern.exports;
  hasRequiredTzPattern = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = void 0;
    var tzPattern2 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var _default = tzPattern2;
    exports.default = _default;
    module.exports = exports.default;
  })(tzPattern, tzPattern.exports);
  return tzPattern.exports;
}
var hasRequiredToDate;
function requireToDate() {
  if (hasRequiredToDate) return toDate$1.exports;
  hasRequiredToDate = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = toDate2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireToInteger());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireGetTimezoneOffsetInMilliseconds());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireTzParseTimezone());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireTzPattern());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var MILLISECONDS_IN_HOUR = 36e5;
    var MILLISECONDS_IN_MINUTE = 6e4;
    var DEFAULT_ADDITIONAL_DIGITS = 2;
    var patterns = {
      dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
      datePattern: /^([0-9W+-]+)(.*)/,
      // year tokens
      YY: /^(\d{2})$/,
      YYY: [
        /^([+-]\d{2})$/,
        // 0 additional digits
        /^([+-]\d{3})$/,
        // 1 additional digit
        /^([+-]\d{4})$/
        // 2 additional digits
      ],
      YYYY: /^(\d{4})/,
      YYYYY: [
        /^([+-]\d{4})/,
        // 0 additional digits
        /^([+-]\d{5})/,
        // 1 additional digit
        /^([+-]\d{6})/
        // 2 additional digits
      ],
      // date tokens
      MM: /^-(\d{2})$/,
      DDD: /^-?(\d{3})$/,
      MMDD: /^-?(\d{2})-?(\d{2})$/,
      Www: /^-?W(\d{2})$/,
      WwwD: /^-?W(\d{2})-?(\d{1})$/,
      HH: /^(\d{2}([.,]\d*)?)$/,
      HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
      HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
      // time zone tokens (to identify the presence of a tz)
      timeZone: _index4.default
    };
    function toDate2(argument, dirtyOptions) {
      if (arguments.length < 1) {
        throw new TypeError("1 argument required, but only " + arguments.length + " present");
      }
      if (argument === null) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var options = dirtyOptions || {};
      var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);
      if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
        throw new RangeError("additionalDigits must be 0, 1 or 2");
      }
      if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") {
        return new Date(argument.getTime());
      } else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") {
        return new Date(argument);
      } else if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var dateStrings = splitDateString(argument);
      var parseYearResult = parseYear(dateStrings.date, additionalDigits);
      var year = parseYearResult.year;
      var restDateString = parseYearResult.restDateString;
      var date = parseDate(restDateString, year);
      if (isNaN(date)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
          time = parseTime(dateStrings.time);
          if (isNaN(time)) {
            return /* @__PURE__ */ new Date(NaN);
          }
        }
        if (dateStrings.timeZone || options.timeZone) {
          offset = (0, _index3.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
          if (isNaN(offset)) {
            return /* @__PURE__ */ new Date(NaN);
          }
        } else {
          offset = (0, _index2.default)(new Date(timestamp + time));
          offset = (0, _index2.default)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
      } else {
        return /* @__PURE__ */ new Date(NaN);
      }
    }
    function splitDateString(dateString) {
      var dateStrings = {};
      var parts = patterns.dateTimePattern.exec(dateString);
      var timeString;
      if (!parts) {
        parts = patterns.datePattern.exec(dateString);
        if (parts) {
          dateStrings.date = parts[1];
          timeString = parts[2];
        } else {
          dateStrings.date = null;
          timeString = dateString;
        }
      } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
      }
      if (timeString) {
        var token = patterns.timeZone.exec(timeString);
        if (token) {
          dateStrings.time = timeString.replace(token[1], "");
          dateStrings.timeZone = token[1].trim();
        } else {
          dateStrings.time = timeString;
        }
      }
      return dateStrings;
    }
    function parseYear(dateString, additionalDigits) {
      var patternYYY = patterns.YYY[additionalDigits];
      var patternYYYYY = patterns.YYYYY[additionalDigits];
      var token;
      token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
      if (token) {
        var yearString = token[1];
        return {
          year: parseInt(yearString, 10),
          restDateString: dateString.slice(yearString.length)
        };
      }
      token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
      if (token) {
        var centuryString = token[1];
        return {
          year: parseInt(centuryString, 10) * 100,
          restDateString: dateString.slice(centuryString.length)
        };
      }
      return {
        year: null
      };
    }
    function parseDate(dateString, year) {
      if (year === null) {
        return null;
      }
      var token;
      var date;
      var month;
      var week;
      if (dateString.length === 0) {
        date = /* @__PURE__ */ new Date(0);
        date.setUTCFullYear(year);
        return date;
      }
      token = patterns.MM.exec(dateString);
      if (token) {
        date = /* @__PURE__ */ new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!validateDate(year, month)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        date.setUTCFullYear(year, month);
        return date;
      }
      token = patterns.DDD.exec(dateString);
      if (token) {
        date = /* @__PURE__ */ new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!validateDayOfYearDate(year, dayOfYear)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
      }
      token = patterns.MMDD.exec(dateString);
      if (token) {
        date = /* @__PURE__ */ new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!validateDate(year, month, day)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        date.setUTCFullYear(year, month, day);
        return date;
      }
      token = patterns.Www.exec(dateString);
      if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!validateWeekDate(year, week)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        return dayOfISOWeekYear(year, week);
      }
      token = patterns.WwwD.exec(dateString);
      if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!validateWeekDate(year, week, dayOfWeek)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        return dayOfISOWeekYear(year, week, dayOfWeek);
      }
      return null;
    }
    function parseTime(timeString) {
      var token;
      var hours;
      var minutes;
      token = patterns.HH.exec(timeString);
      if (token) {
        hours = parseFloat(token[1].replace(",", "."));
        if (!validateTime(hours)) {
          return NaN;
        }
        return hours % 24 * MILLISECONDS_IN_HOUR;
      }
      token = patterns.HHMM.exec(timeString);
      if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(",", "."));
        if (!validateTime(hours, minutes)) {
          return NaN;
        }
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
      }
      token = patterns.HHMMSS.exec(timeString);
      if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(",", "."));
        if (!validateTime(hours, minutes, seconds)) {
          return NaN;
        }
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1e3;
      }
      return null;
    }
    function dayOfISOWeekYear(isoWeekYear, week, day) {
      week = week || 0;
      day = day || 0;
      var date = /* @__PURE__ */ new Date(0);
      date.setUTCFullYear(isoWeekYear, 0, 4);
      var fourthOfJanuaryDay = date.getUTCDay() || 7;
      var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
      date.setUTCDate(date.getUTCDate() + diff);
      return date;
    }
    var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    function isLeapYearIndex(year) {
      return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function validateDate(year, month, date) {
      if (month < 0 || month > 11) {
        return false;
      }
      if (date != null) {
        if (date < 1) {
          return false;
        }
        var isLeapYear = isLeapYearIndex(year);
        if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
          return false;
        }
        if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
          return false;
        }
      }
      return true;
    }
    function validateDayOfYearDate(year, dayOfYear) {
      if (dayOfYear < 1) {
        return false;
      }
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear && dayOfYear > 366) {
        return false;
      }
      if (!isLeapYear && dayOfYear > 365) {
        return false;
      }
      return true;
    }
    function validateWeekDate(year, week, day) {
      if (week < 0 || week > 52) {
        return false;
      }
      if (day != null && (day < 0 || day > 6)) {
        return false;
      }
      return true;
    }
    function validateTime(hours, minutes, seconds) {
      if (hours != null && (hours < 0 || hours >= 25)) {
        return false;
      }
      if (minutes != null && (minutes < 0 || minutes >= 60)) {
        return false;
      }
      if (seconds != null && (seconds < 0 || seconds >= 60)) {
        return false;
      }
      return true;
    }
    module.exports = exports.default;
  })(toDate$1, toDate$1.exports);
  return toDate$1.exports;
}
var hasRequiredFormat;
function requireFormat() {
  if (hasRequiredFormat) return format$1.exports;
  hasRequiredFormat = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = format2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireFormat$1());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireFormatters());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireToDate());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function format2(dirtyDate, dirtyFormatStr, dirtyOptions) {
      var formatStr = String(dirtyFormatStr);
      var options = dirtyOptions || {};
      var matches = formatStr.match(tzFormattingTokensRegExp);
      if (matches) {
        var date = (0, _index3.default)(dirtyDate, options);
        formatStr = matches.reduce(function(result, token) {
          if (token[0] === "'") {
            return result;
          }
          var pos = result.indexOf(token);
          var precededByQuotedSection = result[pos - 1] === "'";
          var replaced = result.replace(token, "'" + _index2.default[token[0]](date, token, null, options) + "'");
          return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
      }
      return (0, _index.default)(dirtyDate, formatStr, options);
    }
    module.exports = exports.default;
  })(format$1, format$1.exports);
  return format$1.exports;
}
var formatInTimeZone = { exports: {} };
var cloneObject = { exports: {} };
var assign = { exports: {} };
var hasRequiredAssign;
function requireAssign() {
  if (hasRequiredAssign) return assign.exports;
  hasRequiredAssign = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = assign2;
    function assign2(target, object2) {
      if (target == null) {
        throw new TypeError("assign requires that input parameter not be null or undefined");
      }
      for (var property in object2) {
        if (Object.prototype.hasOwnProperty.call(object2, property)) {
          target[property] = object2[property];
        }
      }
      return target;
    }
    module.exports = exports.default;
  })(assign, assign.exports);
  return assign.exports;
}
var hasRequiredCloneObject;
function requireCloneObject() {
  if (hasRequiredCloneObject) return cloneObject.exports;
  hasRequiredCloneObject = 1;
  (function(module, exports) {
    var _interopRequireDefault = requireInteropRequireDefault().default;
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = cloneObject2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireAssign());
    function cloneObject2(object2) {
      return (0, _index.default)({}, object2);
    }
    module.exports = exports.default;
  })(cloneObject, cloneObject.exports);
  return cloneObject.exports;
}
var utcToZonedTime = { exports: {} };
var hasRequiredUtcToZonedTime;
function requireUtcToZonedTime() {
  if (hasRequiredUtcToZonedTime) return utcToZonedTime.exports;
  hasRequiredUtcToZonedTime = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = utcToZonedTime2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireTzParseTimezone());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireToDate());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function utcToZonedTime2(dirtyDate, timeZone, options) {
      var date = (0, _index2.default)(dirtyDate, options);
      var offsetMilliseconds = (0, _index.default)(timeZone, date, true);
      var d = new Date(date.getTime() - offsetMilliseconds);
      var resultDate = /* @__PURE__ */ new Date(0);
      resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
      resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
      return resultDate;
    }
    module.exports = exports.default;
  })(utcToZonedTime, utcToZonedTime.exports);
  return utcToZonedTime.exports;
}
var hasRequiredFormatInTimeZone;
function requireFormatInTimeZone() {
  if (hasRequiredFormatInTimeZone) return formatInTimeZone.exports;
  hasRequiredFormatInTimeZone = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = formatInTimeZone2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireCloneObject());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireFormat());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireUtcToZonedTime());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function formatInTimeZone2(date, timeZone, formatStr, options) {
      var extendedOptions = (0, _index.default)(options);
      extendedOptions.timeZone = timeZone;
      return (0, _index2.default)((0, _index3.default)(date, timeZone), formatStr, extendedOptions);
    }
    module.exports = exports.default;
  })(formatInTimeZone, formatInTimeZone.exports);
  return formatInTimeZone.exports;
}
var getTimezoneOffset = { exports: {} };
var hasRequiredGetTimezoneOffset;
function requireGetTimezoneOffset() {
  if (hasRequiredGetTimezoneOffset) return getTimezoneOffset.exports;
  hasRequiredGetTimezoneOffset = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = getTimezoneOffset2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireTzParseTimezone());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function getTimezoneOffset2(timeZone, date) {
      return -(0, _index.default)(timeZone, date);
    }
    module.exports = exports.default;
  })(getTimezoneOffset, getTimezoneOffset.exports);
  return getTimezoneOffset.exports;
}
var zonedTimeToUtc = { exports: {} };
var hasRequiredZonedTimeToUtc;
function requireZonedTimeToUtc() {
  if (hasRequiredZonedTimeToUtc) return zonedTimeToUtc.exports;
  hasRequiredZonedTimeToUtc = 1;
  (function(module, exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = zonedTimeToUtc2;
    var _index = _interopRequireDefault(/* @__PURE__ */ requireCloneObject());
    var _index2 = _interopRequireDefault(/* @__PURE__ */ requireToDate());
    var _index3 = _interopRequireDefault(/* @__PURE__ */ requireTzPattern());
    var _index4 = _interopRequireDefault(/* @__PURE__ */ requireTzParseTimezone());
    var _index5 = _interopRequireDefault(/* @__PURE__ */ requireNewDateUTC());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function zonedTimeToUtc2(date, timeZone, options) {
      if (typeof date === "string" && !date.match(_index3.default)) {
        var extendedOptions = (0, _index.default)(options);
        extendedOptions.timeZone = timeZone;
        return (0, _index2.default)(date, extendedOptions);
      }
      var d = (0, _index2.default)(date, options);
      var utc = (0, _index5.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
      var offsetMilliseconds = (0, _index4.default)(timeZone, new Date(utc));
      return new Date(utc + offsetMilliseconds);
    }
    module.exports = exports.default;
  })(zonedTimeToUtc, zonedTimeToUtc.exports);
  return zonedTimeToUtc.exports;
}
var dateFnsTz;
var hasRequiredDateFnsTz;
function requireDateFnsTz() {
  if (hasRequiredDateFnsTz) return dateFnsTz;
  hasRequiredDateFnsTz = 1;
  dateFnsTz = {
    format: /* @__PURE__ */ requireFormat(),
    formatInTimeZone: /* @__PURE__ */ requireFormatInTimeZone(),
    getTimezoneOffset: /* @__PURE__ */ requireGetTimezoneOffset(),
    toDate: /* @__PURE__ */ requireToDate(),
    utcToZonedTime: /* @__PURE__ */ requireUtcToZonedTime(),
    zonedTimeToUtc: /* @__PURE__ */ requireZonedTimeToUtc()
  };
  return dateFnsTz;
}
var dateFnsTzExports = /* @__PURE__ */ requireDateFnsTz();
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object2, predicate) {
  for (var key in object2) {
    if (object2.hasOwnProperty(key) && predicate(object2[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative$1 = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token];
};
var eraValues$1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues$1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues$1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
};
var formatDistance$1 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
var dateFormats$2 = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
};
var timeFormats$1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$2,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
var locale$1 = {
  code: "en-CA",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
};
var formatDistance2 = function formatDistance3(token, count, options) {
  var result;
  var form = formatDistanceLocale[token];
  if (typeof form === "string") {
    result = form;
  } else if (count === 1) {
    result = form.one;
  } else {
    result = form.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "dans " + result;
    } else {
      return "il y a " + result;
    }
  }
  return result;
};
var formatRelativeLocale = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
};
var formatRelative2 = function formatRelative3(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var eraValues = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
};
var quarterValues = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
};
var dayValues = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
};
var dayPeriodValues = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
};
var ordinalNumber2 = function ordinalNumber3(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number === 0) return "0";
  var feminineUnits = ["year", "week", "hour", "minute", "second"];
  var suffix;
  if (number === 1) {
    suffix = unit && feminineUnits.includes(unit) ? "ère" : "er";
  } else {
    suffix = "ème";
  }
  return number + suffix;
};
var localize = {
  ordinalNumber: ordinalNumber2,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback2(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide"
  })
};
var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns = {
  any: [/^av/i, /^ap/i]
};
var matchQuarterPatterns = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback3(value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback4(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var dateFormats$1 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "yy-MM-dd"
};
var timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var locale = {
  code: "fr-CA",
  formatDistance: formatDistance2,
  formatLong,
  formatRelative: formatRelative2,
  localize,
  match,
  // Unique for fr-CA
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const defaultFormaOptions = {
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "UTC"
};
var dateFormats = /* @__PURE__ */ ((dateFormats2) => {
  dateFormats2["YYYY_MM_DD_HH_MM"] = "yyyy-MM-dd HH:mm";
  dateFormats2["BOPIS_ETA_FR"] = "HH 'h' mm, dd MMM";
  dateFormats2["BOPIS_ETA_EN"] = "hh:mm aa, MMM dd";
  return dateFormats2;
})(dateFormats || {});
const getFormattedDateTime = (date, options = defaultFormaOptions) => {
  return new Date(date).toLocaleTimeString(getCaLocale() || "en-CA", options).split(",");
};
const getFormattedTimeDate = (date, dateFormat, isUTC = true) => {
  const formattedUTCDateTime = isUTC ? dateFnsTzExports.utcToZonedTime(new Date(date), "UTC") : new Date(date);
  const locale$2 = getLanguage() === frenchLocale ? locale : locale$1;
  const formattedDateAndTime = date ? dateFnsTzExports.format(formattedUTCDateTime, dateFormat, { locale: locale$2 }) : "";
  return formattedDateAndTime.replace(/\bAM\b/g, "a.m.").replace(/\bPM\b/g, "p.m.");
};
const getFormattedDateTimeWithYear = (date) => {
  return new Date(date).toLocaleTimeString(getLanguage() || "en", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC"
  }).split(",");
};
const getFormattedDateWithComparison = (date, storeTimeZone) => {
  var _a;
  const inputDate = new Date(date);
  const todaysDate = new Date(dateFnsTzExports.formatInTimeZone(
    /* @__PURE__ */ new Date(),
    storeTimeZone,
    "yyyy-MM-dd HH:mm"
    /* YYYY_MM_DD_HH_MM */
  ));
  const isInputDateIsToday = inputDate.setHours(0, 0, 0, 0) === todaysDate.setHours(0, 0, 0, 0);
  const isInputDateIsTommorrow = inputDate.setHours(0, 0, 0, 0) === todaysDate.setDate(todaysDate.getDate() + magicNumber.ONE);
  const formattedDate = (_a = getFormattedDateTime(date)) == null ? void 0 : _a[magicNumber.ZERO];
  return {
    date: formattedDate,
    isToday: isInputDateIsToday,
    isTomorrow: isInputDateIsTommorrow
  };
};
const getEstimatedTimeOfSendingProduct = (estimatedTimeOfSending, storeTimeZone) => {
  const etaDate = new Date(estimatedTimeOfSending);
  const customerTimeInStoreTimeZone = new Date(
    dateFnsTzExports.formatInTimeZone(
      /* @__PURE__ */ new Date(),
      storeTimeZone,
      "yyyy-MM-dd HH:mm"
      /* YYYY_MM_DD_HH_MM */
    )
  );
  const diffInMinutes = Math.abs(etaDate.getTime() - customerTimeInStoreTimeZone.getTime()) / magicNumber.SIXTYTHOUSAND;
  const hours = Math.floor(diffInMinutes / magicNumber.SIXTY);
  const minutes = Math.round(diffInMinutes % magicNumber.SIXTY);
  return [hours, minutes];
};
const checkIfDateIsOverdue = (estimatedTimeOfSending, storeTimeZone) => {
  const etaDate = new Date(estimatedTimeOfSending);
  const customerTimeInStoreTimeZone = new Date(
    dateFnsTzExports.formatInTimeZone(
      /* @__PURE__ */ new Date(),
      storeTimeZone,
      "yyyy-MM-dd HH:mm"
      /* YYYY_MM_DD_HH_MM */
    )
  );
  const diffInTime = etaDate.getTime() - customerTimeInStoreTimeZone.getTime();
  return diffInTime <= magicNumber.ZERO;
};
const getCurrentDate = () => {
  const timeElapsed = Date.now();
  return new Date(timeElapsed);
};
const getDateTime = (dateOnly = false, previousDate = 0) => {
  const currentMonth = 1;
  const numOfHours = 10;
  const newDate = /* @__PURE__ */ new Date();
  const hours = newDate.getHours();
  const minutes = newDate.getMinutes();
  const seconds = newDate.getSeconds();
  const getModifiedDate = () => {
    const startDate = newDate.setDate(newDate.getDate() - previousDate);
    const formattedStartDate = new Date(startDate);
    return formattedStartDate.getDate();
  };
  const date = previousDate > 0 ? getModifiedDate() : newDate.getDate();
  const month = newDate.getMonth() + currentMonth;
  const year = newDate.getFullYear();
  const setDate = newDate.getDate();
  const formatedDate = `${month < numOfHours ? `0${month}` : `${month}`}${date < numOfHours ? `0${setDate}` : `${setDate}`}${year}`;
  const formatedTime = `${hours < numOfHours ? `0${hours}` : `${hours}`}:${minutes < numOfHours ? `0${minutes}` : `${minutes}`}:${seconds < numOfHours ? `0${seconds}` : `${seconds}`}`;
  return dateOnly ? formatedDate : formatedDate + formatedTime;
};
const getDateFormatDDMMYY = (extendedFormatDate) => {
  const date = new Date(extendedFormatDate);
  const year = date.getFullYear().toString();
  let month = (magicNumber.ONE + date.getMonth()).toString();
  month = month.length > magicNumber.ONE ? month : `0${month}`;
  let day = date.getDate().toString();
  day = day.length > magicNumber.ONE ? day : `0${day}`;
  return day + month + year;
};
const getDateFormatter = (value) => {
  const date = value.slice(0, magicNumber.TWO);
  const month = value.slice(magicNumber.TWO, magicNumber.FOUR);
  const year = value.slice(magicNumber.FOUR);
  return `${date}/${month}/${year}`;
};
const getDiffBetweenDates = (date1, date2) => {
  const updatedDate1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const updatedDate2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  return Math.floor(
    Math.abs(updatedDate2 - updatedDate1) / (magicNumber.THOUSAND * magicNumber.SIXTY * magicNumber.SIXTY * magicNumber.TWENTYFOUR)
  );
};
const getFullYear = (year) => {
  return year > magicNumber.HUNDRED ? year : magicNumber.TWOTHOUSAND + year;
};
const getDateFormatNumericYear = (value) => {
  const language2 = getLanguage();
  const dateFormat = getDateFormatter(value);
  const objDate = new Date(dateFormat);
  const getMonthYear = objDate.toLocaleDateString(language2 || defaultLocale$1, {
    month: "long",
    year: "numeric"
  });
  const day = value.slice(magicNumber.ZERO, magicNumber.TWO);
  const getDayValue = value && dateFnsTzExports.format(new Date(day), dateFormatter);
  return `${getDayValue} ${getMonthYear}`;
};
const getSubscriptionDateTime = () => {
  return (/* @__PURE__ */ new Date()).toLocaleString("en-ca", { hour12: false }).replace(",", "").replace("24:", "00:");
};
const isCanada = (country) => {
  return (country == null ? void 0 : country.toLowerCase()) === countryCode.ca;
};
const isUSA = (country) => {
  return (country == null ? void 0 : country.toLowerCase()) === countryCode.us;
};
const isCountryWithoutRegions = (country) => {
  return !(isCanada(country) || isUSA(country));
};
const imageAttributes = (path, dataComponentName, isLazyRequire) => {
  const attributeObject = {
    "data-component-name": dataComponentName
  };
  if (isLazyRequire) {
    attributeObject["data-src"] = path;
    attributeObject.className = "lazyload";
  } else {
    attributeObject.src = path;
    attributeObject.srcSet = path;
  }
  return attributeObject;
};
const createUrlWithPolicy = (source, policyType, returnPolicy) => {
  var _a;
  return policyType ? `${(_a = source == null ? void 0 : source.toString()) == null ? void 0 : _a.split("?", magicNumber.ONE).toString()}${returnPolicy(policyType)}` : `${source}`;
};
const applyAkamaiPolicy = (imageUrl, imageComponentName, _isLazyRequire, returnPolicy) => {
  return imageAttributes(
    !!imageUrl && `${createUrlWithPolicy(imageUrl, imageComponentName, returnPolicy)}`,
    imageComponentName,
    _isLazyRequire
  );
};
const getBannerLogo = (displayBanner, bannerImageList, fallbackImageForBrandLogo, fallbackImageForBrandLogoAltText) => {
  const mutipleBanner = displayBanner == null ? void 0 : displayBanner.includes(",");
  const { bannerImagePath, bannerImageAlt } = setBannerLogo(displayBanner, bannerImageList) || {};
  const src2 = mutipleBanner ? fallbackImageForBrandLogo : bannerImagePath;
  const alt = mutipleBanner ? fallbackImageForBrandLogoAltText : bannerImageAlt;
  return { src: src2, alt };
};
const setBannerLogo = (bannerName, bannerImageList) => {
  const getBannerName = bannerName == null ? void 0 : bannerName.toString();
  return bannerImageList && bannerImageList.find((imageList) => getBannerName === imageList.bannerId);
};
const isPartialAuthError = (err) => err === errorCodes.errorPartialAuth;
const checkError101 = (errCode) => errCode === errorCodes.error101;
const checkError00001 = (errCode) => errCode === errorCodes.error00001;
const checkError400 = (errCode) => errCode === errorCodes.error400;
const offerEndDateRegex = /^(\d{2})(\d{2})(\d{4})$/;
const regexPatterns = {
  firstLetters: /(^\w)|(\s+\w)/g
};
const allWhitespace = /\s/g;
const allNotLetterNotNumber = /[^a-zA-Z0-9]+/g;
const checkoutRegexPatterns = {
  contactNumber: "[0-9\\-\\s\\+\\(\\)]*",
  ctMoneyAmount: "[0-9$,.\\s]*",
  giftCardNumberAndPin: "[0-9\\s]*"
};
const numberRegEx = "[0-9]+";
const inputFieldInvalidCharactersRegEx = /\.|,|\s/g;
const offerCodesRegEx = /[.!?;,:]/;
const colorRegex = /(?:#|0x)(?:[a-f0-9]{3}|[a-f0-9]{6})\b|(?:rgb|hsl)a?\([^)]*\)/gi;
const verificationCodeRegex = /^[0-9]{6}$/;
const getLastCharacters = (string = "", amount) => {
  return string.slice(-amount);
};
const stringToBooleanMap = {
  T: true,
  F: false,
  Y: true,
  N: false,
  true: true,
  false: false,
  on: true,
  off: false,
  undefined: false
};
const isStringInList = (list, string, delimiter = ",") => {
  var _a;
  return !!((_a = list.split(delimiter)) == null ? void 0 : _a.find((item) => item.trim().toLowerCase() === string.trim().toLowerCase()));
};
const capitalizeWords = (string = "", shouldLowercaseLetters) => {
  string = shouldLowercaseLetters ? string.toLowerCase() : string;
  return string.replace(regexPatterns.firstLetters, (letter) => letter.toUpperCase());
};
const replaceStringCharacter$1 = (string, searchValue, replaceValue) => {
  return string.split(searchValue).join(replaceValue);
};
const getStringOrDefault = (value) => typeof value === "string" ? value : "";
const generateUniqueId = () => {
  return Math.random().toString(magicNumber.THIRTYSIX).slice(magicNumber.TWO, magicNumber.ELEVEN);
};
const findStringLabel = (arrString) => Array.from(arrString).find((a) => typeof a === "string");
const stringifyElement = (content) => {
  if (typeof content === "string") {
    return content;
  } else {
    const { props } = content;
    const { children } = props;
    if (typeof children === "string") {
      return children.trim();
    } else {
      const parseChildNode = Array.isArray(children) ? children.map((child) => {
        var _a, _b;
        if (typeof ((_a = child == null ? void 0 : child.props) == null ? void 0 : _a.children) === "string") {
          return (_b = child == null ? void 0 : child.props) == null ? void 0 : _b.children;
        }
        return null;
      }).filter(Boolean) : [];
      return findStringLabel(parseChildNode).trim();
    }
  }
};
const convertEpsilonDate = (dateString = "", daysToAdd) => {
  const month = dateString.slice(0, magicNumber.TWO);
  const day = dateString.slice(magicNumber.TWO, magicNumber.FOUR);
  const year = dateString.slice(magicNumber.FOUR);
  return new Date(Date.UTC(Number(year), Number(month) - magicNumber.ONE, Number(day) + (daysToAdd || 0)));
};
const maxDaysInMonth = () => {
  return Array.from(
    new Array(magicNumber.THIRTYONE),
    (_, index2) => (
      // eslint-disable-next-line sonar/no-nested-incdec
      (++index2).toString().padStart(magicNumber.TWO, "0")
    )
  ).map((day) => {
    return { label: `${day}`, id: `${day}` };
  });
};
const getMonthList = () => {
  return monthList.map((month) => {
    return { label: `${month.label}`, id: `${month.value}` };
  });
};
const isDateValid = (selectedYear, selectedMonth, selectedDay) => {
  const year = Number(selectedYear);
  const month = Number(selectedMonth) - magicNumber.ONE;
  const day = Number(selectedDay);
  const date = new Date(year, month, day);
  return !(date.getMonth() !== month || date.getDate() !== day || date.getFullYear() !== year);
};
const getDateOptions = () => dateOptions;
const validateDateBetweenTwoDates = (fromDate, toDate2, currentDate) => {
  return new Date(currentDate) >= new Date(fromDate) && new Date(currentDate) <= new Date(toDate2);
};
const getDaysDifference = (timeStamp) => {
  const dateObj = new Date(timeStamp);
  const todayDate = /* @__PURE__ */ new Date();
  const differenceInTime = dateObj.getTime() - todayDate.getTime();
  const { thousand, totalSeconds, totalHours } = daysCalculationConstants;
  const differenceInDays = Math.floor(differenceInTime / (thousand * totalSeconds * totalHours));
  const resultDifference = differenceInDays < 0 ? 0 : differenceInDays;
  return timeStamp ? resultDifference.toString() : "";
};
const convertTicksToDate = (ticks) => {
  const ticksToMilliseconds = 1e4;
  const epochTicks = /* @__PURE__ */ new Date(0);
  epochTicks.setFullYear(1, 0, 1);
  const date = new Date(epochTicks.getTime() + ticks / ticksToMilliseconds);
  const options = {
    year: dateOptions.style2.year,
    month: dateOptions.style2.month,
    day: dateOptions.style2.day
  };
  return date.toLocaleDateString(getUsLocale(), options);
};
const isTriangleSelectMember = (tsSubscriptionStatus) => {
  return tsSubscriptionStatus === subscriptionStatus.active;
};
const wasTriangleSelectMember = (tsSubscriptionStatus) => {
  return tsSubscriptionStatus === subscriptionStatus.expired;
};
const getSubscriptionType = (tsSubscriptionType) => {
  return (tsSubscriptionType == null ? void 0 : tsSubscriptionType.toLowerCase()) === subscriptionType.freeTrial ? subscriptionType.freeTrial : subscriptionType.regular;
};
const roundOfToTwoDecimals = (num) => {
  return Math.round(Number(num) * magicNumber.HUNDRED) / magicNumber.HUNDRED;
};
const getPTEBaseTotal = (rewardsPercentage, currentPriceValue, quantity = 1) => {
  return roundOfToTwoDecimals(Number(rewardsPercentage * currentPriceValue * quantity));
};
const getTotalPteReward = (rewardValue, pteOfferValue = 0, selectRewardsValue = 0, rewardsBoostValue = 0) => {
  return rewardValue + roundOfToTwoDecimals(Number(pteOfferValue)) + roundOfToTwoDecimals(Number(selectRewardsValue)) + roundOfToTwoDecimals(Number(rewardsBoostValue));
};
const getSourceTypeData = (sourceTypes, type) => {
  return sourceTypes.find((source) => source.productSourceType === type) || {};
};
const arraysElementsAreEqual = (array1, array2) => Boolean(
  array1 && array2 && array1.length === array2.length && array1.every((element, index2) => element === array2[index2])
);
const getElementWithContent = (elements) => {
  const elementArray = Array.from(elements);
  return elementArray.find((element) => element.innerHTML.length > 0);
};
const getStringBasedOnCondition = (value1, value2, value3) => {
  return value1 ? value2 : value3;
};
const isPetroConversionTransaction = (transaction) => (transaction == null ? void 0 : transaction.banner) === BannerMapping.CIRPP && (transaction == null ? void 0 : transaction.isCirPointsConversion);
const isAnnualTopupTransaction = (transaction) => (transaction == null ? void 0 : transaction.banner) === BannerMapping.ANTU && (transaction == null ? void 0 : transaction.isAnnualTopUp);
const isPetroOrAnnualTopUpTransactions = (transaction) => {
  return isPetroConversionTransaction(transaction) || isAnnualTopupTransaction(transaction);
};
const getTransactionName = (transaction, petroPointsConversionLabel, annualTopUpLabel) => {
  const label = isPetroConversionTransaction(transaction) ? petroPointsConversionLabel : annualTopUpLabel;
  return !isPetroOrAnnualTopUpTransactions(transaction) ? transaction.storeName : label;
};
const isUrl = (url) => {
  const regexp = /^(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regexp.test(url);
};
const appendReturnUrl = (originalUrl) => {
  var _a;
  const returnURL = (_a = new URLSearchParams(window.location.search)) == null ? void 0 : _a.get("returnURL");
  return returnURL ? `${originalUrl}?returnURL=${encodeURIComponent(returnURL)}` : originalUrl;
};
const urlRedirection = (path, params, query) => {
  const updatedQuery = query && query.replace(/ /g, "+");
  const strParams = String(params);
  return updatedQuery ? `${path}?${strParams}=${updatedQuery}` : `${path}?${strParams}`;
};
const getParameterSeparator = (url) => {
  return url.includes("?") ? "&" : "?";
};
const appendTrackingInfo = (url, pcidFromLocalStorage, defaultPcid, otherTrackingInfoFromLocalStorage) => {
  const paramSeperator = getParameterSeparator(url);
  const pcidToAppend = pcidFromLocalStorage != null ? `pcid=${pcidFromLocalStorage}` : `pcid=${defaultPcid}`;
  const restTrackingInfo = otherTrackingInfoFromLocalStorage ? `&${otherTrackingInfoFromLocalStorage}` : "";
  const urlUpdatedWithPcid = url.includes("pcid") ? url : encodeURI(`${url}${paramSeperator}${pcidToAppend}`);
  return encodeURI(`${urlUpdatedWithPcid}${restTrackingInfo}`);
};
const checkReturnURL = (value) => {
  var _a;
  const returnURL = (_a = new URLSearchParams(window.location.search)) == null ? void 0 : _a.get("returnURL");
  return Boolean(returnURL == null ? void 0 : returnURL.includes(value));
};
const modifyRedirectUrlByParams = (url, ...paramNames) => {
  const requiredParams = /* @__PURE__ */ new Map();
  const queryParams = new URLSearchParams(window.location.search);
  paramNames.forEach((paramName) => {
    const paramValue = queryParams.get(paramName);
    !!paramValue && requiredParams.set(paramName, paramValue);
  });
  return requiredParams.size > magicNumber.ZERO ? appendQueryParamsToUrl(url.origin + url.pathname, Object.fromEntries(requiredParams)) : url.origin + url.pathname;
};
const checkLocalizedReturnURL = (localizedReturnURL) => {
  return checkReturnURL(localizedReturnURL.en) || checkReturnURL(localizedReturnURL.fr);
};
const redirectToPage = (url) => {
  window.location.href = encodeURI(url);
};
const checkPathname = (pathname) => {
  return window.location.pathname === pathname;
};
const checkCurrentPage = (pageLink) => {
  var _a;
  return (_a = window.location.href) == null ? void 0 : _a.includes(pageLink);
};
const appendQueryParam = (url, params) => {
  const queryString = params.map((param, key) => {
    return param && `p${key + 1}=${param}`;
  }).filter((arr) => Boolean(arr)).join("&");
  const queryParams = queryString ? `?${queryString}` : "";
  return `${url.toString()}${queryParams}`;
};
const getIconState = (state) => {
  switch (state) {
    case State.SUCCESS:
      return "ct-notification-success";
    case State.CAUTION:
      return "ct-notification-caution";
    case State.ERROR:
      return "ct-toast-error";
    case State.INFO:
      return "ct-information-blue";
    default:
      return "ct-information-details";
  }
};
const removeHtmlTagsFromStringByName = (text2, tagName) => {
  const regex = new RegExp(`<${tagName}(\\s+[^>]*)?>|</${tagName}>`, "g");
  return text2 ? text2.replace(regex, "") : text2;
};
const checkNotNullAndUndefined = (value) => {
  return value === null || value === void 0 || value === "undefined";
};
const checkValueOrNull = (value) => {
  return value === void 0 || value === null || value === "" || value === "undefined" ? "null" : value;
};
const checkNumberNotNullAndUndefined = (value) => {
  return value === void 0 || value === null ? 0 : value;
};
const changeNullToUndefined = (value, shouldTransform) => {
  return shouldTransform && value === "null" ? void 0 : value;
};
const checkEmptyValue = (value) => {
  return value === void 0 || value === "undefined" || value === null || value === "null" || value === "";
};
const checkUndefined = (value) => {
  return value === void 0;
};
const isColorStrVal = (value) => {
  const updatedValue = checkNotNullAndUndefined(value) ? value : value.trim();
  return !colorRegex.test(updatedValue);
};
const getSortVariants = (options) => {
  const variantsDataOrder = options == null ? void 0 : options.map((item) => ({
    ...item,
    variantOrder: (item == null ? void 0 : item.variantOrder) || (item == null ? void 0 : item.variantOrder) === 0 ? item == null ? void 0 : item.variantOrder : magicNumber.SIXTHOUSAND
  }));
  return variantsDataOrder == null ? void 0 : variantsDataOrder.sort((a, b) => a.variantOrder - b.variantOrder);
};
const countDownTimer = (endTime, timerTickCallback, timerEndCallback) => {
  let currentTime = (/* @__PURE__ */ new Date()).getTime();
  let difference = endTime - currentTime;
  const timer = setInterval(() => {
    currentTime = (/* @__PURE__ */ new Date()).getTime();
    difference = endTime - currentTime;
    if (difference > 0) {
      timerTickCallback(difference);
    } else {
      clearInterval(timer);
      timerEndCallback();
    }
  }, magicNumber.ONETHOUSAND);
  return timer;
};
const calculateTimeLeft = (difference) => {
  const daysLeft = Math.floor(difference / magicNumber.MILLISINDAY);
  const hoursLeft = Math.floor((difference - daysLeft * magicNumber.MILLISINDAY) / magicNumber.MILLISINHOUR);
  const minutesLeft = Math.floor(
    (difference - daysLeft * magicNumber.MILLISINDAY - hoursLeft * magicNumber.MILLISINHOUR) / magicNumber.MILLISINMINUTE
  );
  const secondsLeft = Math.floor(
    (difference - daysLeft * magicNumber.MILLISINDAY - hoursLeft * magicNumber.MILLISINHOUR - minutesLeft * magicNumber.MILLISINMINUTE) / magicNumber.ONETHOUSAND
  );
  return { daysLeft, hoursLeft, minutesLeft, secondsLeft };
};
function formatStringWithPattern(input, pattern) {
  let inputIndex = 0;
  const regexPattern = new RegExp(`\\${formatPlaceholder}`, "g");
  const placeholderCount = (pattern.match(regexPattern) || []).length;
  if (!pattern.length || !input.length || placeholderCount !== input.length) {
    return input;
  }
  return pattern.replace(regexPattern, () => {
    const { [inputIndex]: char } = input;
    inputIndex++;
    return char;
  });
}
const index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MenuAccessibility,
  addDynamicToken,
  addModalAttribute,
  addParam,
  anyDividerRegExp,
  appendQueryParam,
  appendQueryParamsToUrl,
  appendReturnUrl,
  appendTrackingInfo,
  applyAkamaiPolicy,
  calculateTimeLeft,
  capitalizeWords,
  changeNullToUndefined,
  checkAgeValidation,
  checkCurrentPage,
  checkEmptyValue,
  checkError00001,
  checkError101,
  checkError400,
  checkIfDateIsOverdue,
  checkKeyPresenceInArray,
  checkLocalizedReturnURL,
  checkNotNullAndUndefined,
  checkNumberNotNullAndUndefined,
  checkPathname,
  checkReturnURL,
  checkStoreHashInURL,
  checkStoreParamInURL,
  checkUndefined,
  checkValueOrNull,
  collapseControl,
  combineBadges,
  convertDecimalImpliedFormat,
  convertEpsilonDate,
  convertTicksToDate,
  countDownTimer,
  createPaginationHref,
  createUrlWithPolicy,
  currentYear,
  customDebounce,
  dateFormats,
  daysInMonth,
  excludeUtmParams,
  extractKeyValues,
  findParamValue,
  formatStringWithPattern,
  formatedPhoneNumberAccessibility,
  generateGoogleMapOnAddress,
  generateUniqueId,
  getAccountHolderName,
  getBannerLogo,
  getCapitalizeString,
  getCookieValue,
  getCurrentDate,
  getDOMElement,
  getDateFormatDDMMYY,
  getDateFormatNumericYear,
  getDateFormatter,
  getDateOfBirth,
  getDateOptions,
  getDaysDifference,
  getDiffBetweenDates,
  getElementWithContent,
  getEstimatedTimeOfSendingProduct,
  getFormattedDateTime,
  getFormattedDateTimeWithYear,
  getFormattedDateWithComparison,
  getFormattedPhoneNumber,
  getFormattedPrice,
  getFormattedTimeDate,
  getFullYear,
  getIconState,
  getLanguage,
  getLanguageCA,
  getLastCharacters,
  getLoyaltyCards,
  getMonthList,
  getNameDetails,
  getNumberOrDefault,
  getPTEBaseTotal,
  getPageTitle,
  getParamValue: getParamValue$1,
  getParameterFromURL,
  getPhoneNumber,
  getPriceRangePill,
  getQueryString: getQueryString$1,
  getQueryStringParams,
  getSAPIRequestQueryParam,
  getSafePercent,
  getSortVariants,
  getSourceTypeData,
  getStringBasedOnCondition,
  getStringOrDefault,
  getSubscriptionDateTime,
  getSubscriptionType,
  getTextWidth: getTextWidth$1,
  getTotalPteReward,
  getTransactionName,
  getUnpaddedTimeFormat,
  handleModalEventListeners,
  imageAttributes,
  internationalizedMonthList,
  isAnnualTopupTransaction,
  isArrayNotEmpty,
  isCanada,
  isColorStrVal,
  isCountryWithoutRegions,
  isDateValid,
  isMockParamInURL,
  isPartialAuthError,
  isPetroConversionTransaction,
  isPetroOrAnnualTopUpTransactions,
  isStringInList,
  isTriangleSelectMember,
  isUSA,
  isUrl,
  keyCodes,
  linkRewardsAnalytics,
  magicNumber,
  maxDaysInMonth,
  menuBarAccessibility,
  modalAccessibilityHandler,
  modifyRedirectUrlByParams,
  popUpAEMHandler,
  promiseQueue,
  pushUrlHistory,
  queryParameters,
  redirectToPage,
  removeAllParametersFromURL,
  removeHtmlTagsFromString,
  removeHtmlTagsFromStringByName,
  removeParam,
  removeParameterFromURL,
  replaceMultipleStrWithDynamicVal,
  replaceStrWithDynamicElement,
  replaceStrWithDynamicVal,
  replaceStringCharacter: replaceStringCharacter$1,
  roundOffValue,
  selectedSKUBadge,
  stringKeyCodes,
  stringToBooleanMap,
  stringifyElement,
  updateHashInURL,
  updateParam,
  updateParameterInURL,
  updateUrlHistory,
  urlRedirection,
  useGlobalBeforeUnloadEvent,
  useGlobalResizeEvent,
  useGlobalScrollEvent,
  useOnClickOutside,
  useThrottleWindowEvent,
  useWindowEvent,
  validateDateBetweenTwoDates,
  validatePostalCode,
  wasTriangleSelectMember,
  yearDropdownCalculation
}, Symbol.toStringTag, { value: "Module" }));
const timeConstants = {
  timeDelimiter: ":",
  hFormatReplacement: " h "
};
const getTimeFormat = (time) => {
  const unpaddedTimeFormat = getUnpaddedTimeFormat(
    new Date(time).toLocaleTimeString(getUsLocale(), {
      hour: "numeric",
      minute: "numeric"
    })
  );
  return getLanguage() === frenchLocale ? unpaddedTimeFormat.replace(timeConstants.timeDelimiter, timeConstants.hFormatReplacement) : unpaddedTimeFormat;
};
const TimePicker = ({ ...props }) => {
  const {
    isTimeSelectionAllowed,
    selectedTime,
    onChangeTime,
    morningSlots,
    afternoonSlots,
    eveningSlots,
    morningTitle,
    afternoonTitle,
    eveningTitle,
    timesAvailableTitle,
    timeSlotHoverText,
    formattedCalendarValueForTimePicker
  } = props;
  const onChangeTimeHandler = (slot) => {
    if (isTimeSelectionAllowed && onChangeTime) {
      onChangeTime(slot);
    }
  };
  const returnAvailableTimeSlots = (slotTitle, slots) => {
    if (slots.length) {
      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-time-picker__slot-wise`, children: [
        /* @__PURE__ */ jsx("h4", { className: `${PREFIX}-time-picker__slot-title`, children: slotTitle }),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row`, children: slots.map((slot) => {
          const isSlotMatchedWithSelectedTime = slot === selectedTime;
          const selectedModifier = isSlotMatchedWithSelectedTime ? `${PREFIX}-time-picker__slot-available--selected` : "";
          const slotButtonClasses = classnames(
            `${PREFIX}-time-picker__slot-available`,
            selectedModifier,
            {
              [`${PREFIX}-time-picker__slot-selectable`]: isTimeSelectionAllowed
            }
          );
          return /* @__PURE__ */ jsxs(
            "button",
            {
              className: slotButtonClasses,
              onClick: () => onChangeTimeHandler(slot),
              "data-testid": `${slot}__button`,
              "aria-label": slot,
              title: isSlotMatchedWithSelectedTime ? "" : timeSlotHoverText,
              children: [
                getTimeFormat(slot),
                /* @__PURE__ */ jsx("div", { className: `${PREFIX}-time-picker__available-effect` })
              ]
            },
            slot
          );
        }) })
      ] });
    } else {
      return null;
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-time-picker`, children: [
    /* @__PURE__ */ jsx("h4", { className: `${PREFIX}-time-picker__times-available-title`, children: `${timesAvailableTitle} ${formattedCalendarValueForTimePicker ? formattedCalendarValueForTimePicker : ""}` }),
    returnAvailableTimeSlots(morningTitle, morningSlots),
    returnAvailableTimeSlots(afternoonTitle, afternoonSlots),
    returnAvailableTimeSlots(eveningTitle, eveningSlots)
  ] });
};
TimePicker.propTypes = {
  selectedTime: PropTypes.string,
  onChangeTime: PropTypes.func.isRequired,
  morningTitle: PropTypes.string.isRequired,
  afternoonTitle: PropTypes.string.isRequired,
  eveningTitle: PropTypes.string.isRequired,
  timesAvailableTitle: PropTypes.string.isRequired,
  timeSlotHoverText: PropTypes.string.isRequired,
  formattedCalendarValueForTimePicker: PropTypes.string
};
const renderButtonSpinner = () => {
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-button__spinner` });
};
const Button = React.forwardRef(
  ({ ...props }, ref) => {
    const { quantumMetricAttribute } = props;
    const size = props.size ? `${PREFIX}-button--${props.size}` : "";
    const type = `${PREFIX}-button--${props.type}`;
    const state = props.state ? `${props.state}` : "";
    const ariaLabel = props.ariaLabel ? props.ariaLabel : "";
    const ariaDescribedBy = props.ariaDescribedBy ? props.ariaDescribedBy : "";
    const modifierClass = props.modifierClass ? `${props.modifierClass}` : "";
    const quantumMetricDataAttribute = (quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type) ? { [`data-qm-${quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type}`]: quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.value } : {};
    return /* @__PURE__ */ jsxs(
      "button",
      {
        "aria-current": props["aria-current"],
        "data-testid": props.id,
        id: props.id,
        ...quantumMetricDataAttribute,
        onClick: props.onClick,
        "aria-label": `${ariaLabel}`,
        "aria-describedby": `${ariaDescribedBy}`,
        "aria-disabled": props.disabled,
        className: `${PREFIX}-button ${type} ${size} ${state} ${modifierClass}`,
        disabled: props.disabled,
        "aria-expanded": props.ariaExpanded,
        ref,
        type: props.buttonType,
        onKeyDown: (val) => props.onKeyDown ? props.onKeyDown(val) : null,
        "dap-wac-link": props.dapWacLink,
        "dap-wac-loc": props.location,
        "dap-wac-link-section": props.linkSection,
        "dap-wac-value": props.linkValue,
        role: props.role ? props.role : "button",
        "aria-controls": props.ariaControls,
        tabIndex: props.tabIndex,
        children: [
          props.showSpinner ? renderButtonSpinner() : props.label,
          props.children
        ]
      }
    );
  }
);
Button.displayName = "Button";
Button.defaultProps = {
  type: "primary",
  buttonType: "button"
};
Button.propTypes = {
  type: PropTypes.oneOf([
    "primary",
    "primary_reverse",
    "primary_red",
    "secondary",
    "secondary_reverse",
    "tertiary",
    "tertiary_reverse",
    "icon_button",
    "secondary_reverse_light",
    "modal_button",
    "activate",
    "activated",
    "redeemed",
    "all_activated",
    "swap",
    "link",
    "call_to_action",
    "swap"
  ]),
  id: PropTypes.string,
  size: PropTypes.oneOf(["mini", "small", "medium-small", "medium", "large"]),
  state: PropTypes.oneOf(["hover", "active", "focus", "disabled"]),
  ariaLabel: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  buttonType: PropTypes.oneOf(["button", "submit", "reset"]),
  label: PropTypes.string,
  showSpinner: PropTypes.bool,
  onKeyDown: PropTypes.func,
  ariaExpanded: PropTypes.bool,
  modifierClass: PropTypes.string,
  ariaControls: PropTypes.string,
  tabIndex: PropTypes.number
};
Button.displayName = "ButtonInLib";
var ButtonType = /* @__PURE__ */ ((ButtonType2) => {
  ButtonType2["DEFAULT"] = "button";
  ButtonType2["SUBMIT"] = "submit";
  ButtonType2["RESET"] = "reset";
  return ButtonType2;
})(ButtonType || {});
var ButtonColors = /* @__PURE__ */ ((ButtonColors2) => {
  ButtonColors2["DEFAULT"] = "default";
  ButtonColors2["DEFAULT_2"] = "default-2";
  ButtonColors2["ACTIVATE"] = "activate";
  ButtonColors2["SHOP"] = "shop";
  ButtonColors2["SELECT"] = "select";
  ButtonColors2["LIGHT"] = "light";
  ButtonColors2["DARK"] = "dark";
  return ButtonColors2;
})(ButtonColors || {});
var ExpandIcon = /* @__PURE__ */ ((ExpandIcon2) => {
  ExpandIcon2["CHEVRON"] = "chevron";
  ExpandIcon2["PLUS_MINUS"] = "plus-minus";
  ExpandIcon2["PLUS_CLOSE"] = "plus-close";
  return ExpandIcon2;
})(ExpandIcon || {});
var iconSizes = /* @__PURE__ */ ((iconSizes2) => {
  iconSizes2["Small"] = "sm";
  iconSizes2["Medium"] = "md";
  iconSizes2["Large"] = "lg";
  iconSizes2["xl"] = "xl";
  iconSizes2["xxl"] = "xxl";
  return iconSizes2;
})(iconSizes || {});
const CommonButtonClass = `${PREFIX}-button2`;
const TAB_BUTTON_CLASS = `${PREFIX}-button-tab`;
const EXPAND_BUTTON_CLASS = `${PREFIX}-button2-expand`;
const BaseDefaultProps = {
  variant: Variation.PRIMARY,
  color: ButtonColors.DEFAULT,
  type: ButtonType.DEFAULT,
  size: Size.MEDIUM,
  disabled: false,
  a11y: {
    disabled: false,
    expanded: false
  }
};
const ButtonDefaultProps = {
  ...BaseDefaultProps,
  reverse: false
};
const IconDefaultProps = {
  ...BaseDefaultProps,
  icon: {
    size: iconSizes.Medium
  }
};
const SpinnerDefaultProps = {
  ...BaseDefaultProps,
  showSpinner: false,
  reverse: false
};
const TabDefaultProps = {
  disabled: false,
  state: State.DEFAULT
};
const ButtonV2 = React.forwardRef(
  ({ ...props }, ref) => {
    const {
      children,
      icon,
      variant,
      reverse,
      type,
      disabled,
      customClass,
      color,
      onClick: onClick2,
      id,
      onKeyDown,
      a11y,
      size,
      qm
    } = props;
    const variantClass = `${CommonButtonClass}--${variant} ${CommonButtonClass}--${variant}-${color}`;
    const isReverse = reverse ? ` ${CommonButtonClass}--reverse` : "";
    const customClassName = customClass ? ` ${customClass} ` : "";
    const sizeClass = size === Size.MINI ? ` ${CommonButtonClass}--${size}` : "";
    const qmData = qm ? { [`data-qm-${qm == null ? void 0 : qm.type}`]: qm == null ? void 0 : qm.value } : {};
    const keyDownHandler = (e) => {
      onKeyDown == null ? void 0 : onKeyDown(e);
    };
    return /* @__PURE__ */ jsxs(
      "button",
      {
        id,
        className: `${CommonButtonClass} ${variantClass}${customClassName}${isReverse}${sizeClass}`,
        ref,
        disabled,
        type,
        onClick: onClick2,
        onKeyDown: (e) => keyDownHandler(e),
        "aria-disabled": a11y == null ? void 0 : a11y.disabled,
        "aria-expanded": a11y == null ? void 0 : a11y.expanded,
        "aria-label": (a11y == null ? void 0 : a11y.label) ? a11y == null ? void 0 : a11y.label : "",
        "aria-controls": a11y == null ? void 0 : a11y.controls,
        ...qmData,
        ...props,
        children: [
          icon && /* @__PURE__ */ jsx(Icon, { size: icon.size, type: icon.type }),
          children && /* @__PURE__ */ jsx("span", { children })
        ]
      }
    );
  }
);
ButtonV2.displayName = "ButtonV2";
ButtonV2.defaultProps = ButtonDefaultProps;
var SpinnerStyle = /* @__PURE__ */ ((SpinnerStyle2) => {
  SpinnerStyle2["DEFAULT"] = "default";
  SpinnerStyle2["SPLIT"] = "split";
  SpinnerStyle2["SPLIT_TRAILING"] = "split-trailing";
  return SpinnerStyle2;
})(SpinnerStyle || {});
var SpinnerTypes = /* @__PURE__ */ ((SpinnerTypes2) => {
  SpinnerTypes2["TRIANGLE"] = "triangle";
  SpinnerTypes2["DEFAULT"] = "default";
  return SpinnerTypes2;
})(SpinnerTypes || {});
var Animation = /* @__PURE__ */ ((Animation2) => {
  Animation2["FLIP"] = "flip";
  return Animation2;
})(Animation || {});
const isArrayEmpty = (object2) => {
  return !Array.isArray(object2) || object2.length === 0;
};
const checkDataLength = (obj) => {
  return obj && Object.values(obj).length > 0;
};
const isFalse = (value) => false.toString() === String(value).toLocaleLowerCase();
const checkValidData = (obj) => {
  return obj && Object.values(obj).filter((item) => !!item).length > 0;
};
const checkLastItemArray = (array, index2) => {
  return array && index2 !== array.length - magicNumber.ONE;
};
const Spinner = ({ ...props }) => {
  const { color, a11yLabel, style = SpinnerStyle.DEFAULT, value } = props;
  const spinnerClass = `${PREFIX}-spinner`;
  const colorClass = isColorStrVal(color) ? color : "inline";
  const borderColor = isColorStrVal(color) ? color : `${color} ${color} ${color} transparent`;
  const spinnerAnimation = (value == null ? void 0 : value.animation) ? `${spinnerClass}--${value == null ? void 0 : value.animation}` : "";
  const spinnerStyle = () => {
    switch (style) {
      case SpinnerStyle.SPLIT_TRAILING:
        return /* @__PURE__ */ jsx("svg", { "aria-hidden": "true", className: `${spinnerClass}__container`, children: [Array(magicNumber.THREE)].map((_, i) => /* @__PURE__ */ jsx("circle", { cx: magicNumber.FIFTY, cy: magicNumber.FIFTY, r: magicNumber.TWENTYFIVE }, i)) });
      case SpinnerStyle.DEFAULT:
      default:
        return null;
    }
  };
  const innerValue = () => value == null ? void 0 : value.type.map((a, i) => /* @__PURE__ */ jsx(Icon, { type: a, size: (value == null ? void 0 : value.size) ? value == null ? void 0 : value.size : Size.XL }, i));
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": "spinner",
      "aria-label": a11yLabel,
      className: `${spinnerClass} ${spinnerClass}--${style} ${spinnerAnimation} ${color ? `${spinnerClass}--color-${colorClass}` : ""}`,
      style: color && style === SpinnerStyle.DEFAULT ? { borderColor } : {},
      children: [
        spinnerStyle(),
        !isArrayEmpty(value == null ? void 0 : value.type) && checkDataLength(value) && innerValue()
      ]
    }
  );
};
const SpinnerButton = React.forwardRef(({ ...props }, ref) => {
  const {
    color,
    spinner,
    variant,
    type,
    disabled,
    customClass,
    showSpinner,
    children,
    icon,
    onClick: onClick2,
    reverse,
    id,
    onKeyDown,
    a11y,
    size,
    qm
  } = props;
  const variantClass = `${CommonButtonClass}--${variant} ${CommonButtonClass}--${variant}-${color} `;
  const isReverse = reverse ? ` ${CommonButtonClass}--reverse` : "";
  const customClassName = customClass ? ` ${customClass} ` : "";
  const sizeClass = size === Size.MINI ? ` ${CommonButtonClass}--${size}` : "";
  const qmData = qm ? { [`data-qm-${qm == null ? void 0 : qm.type}`]: qm == null ? void 0 : qm.value } : {};
  const keyDownHandler = (e) => {
    onKeyDown == null ? void 0 : onKeyDown(e);
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      id,
      className: `${CommonButtonClass}-spinner ${variantClass}${customClassName}${isReverse}${sizeClass}`,
      ref,
      disabled,
      type,
      onClick: onClick2,
      onKeyDown: (e) => keyDownHandler(e),
      "aria-disabled": a11y == null ? void 0 : a11y.disabled,
      "aria-label": (a11y == null ? void 0 : a11y.label) ? a11y == null ? void 0 : a11y.label : "",
      "aria-expanded": a11y == null ? void 0 : a11y.expanded,
      "aria-controls": a11y == null ? void 0 : a11y.controls,
      "aria-haspopup": a11y == null ? void 0 : a11y.hasPopup,
      ...qmData,
      ...props,
      children: showSpinner ? /* @__PURE__ */ jsx(Spinner, { color: spinner == null ? void 0 : spinner.color, style: spinner == null ? void 0 : spinner.style, value: spinner == null ? void 0 : spinner.value }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        icon && /* @__PURE__ */ jsx(Icon, { size: icon.size, type: icon.type }),
        children && /* @__PURE__ */ jsx("span", { children })
      ] })
    }
  );
});
SpinnerButton.displayName = "SpinnerButton";
SpinnerButton.defaultProps = SpinnerDefaultProps;
const IconButton = React.forwardRef(({ ...props }, ref) => {
  const { variant, icon, type, disabled, customClass, color, onClick: onClick2, id, onKeyDown, a11y, size, qm } = props;
  const variantClass = `${CommonButtonClass}--${variant} ${CommonButtonClass}--${variant}-${color} `;
  const customClassName = customClass ? ` ${customClass}` : "";
  const sizeClass = size === Size.MINI ? ` ${CommonButtonClass}--${size}` : "";
  const qmData = qm ? { [`data-qm-${qm == null ? void 0 : qm.type}`]: qm == null ? void 0 : qm.value } : {};
  const keyDownHandler = (e) => {
    onKeyDown == null ? void 0 : onKeyDown(e);
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      id,
      className: `${CommonButtonClass}-icon ${variantClass}${customClassName}${sizeClass}`,
      ref,
      disabled,
      type,
      onClick: onClick2,
      onKeyDown: (e) => keyDownHandler(e),
      "aria-disabled": a11y == null ? void 0 : a11y.disabled,
      "aria-label": (a11y == null ? void 0 : a11y.label) ? a11y == null ? void 0 : a11y.label : "",
      "aria-labelledby": (a11y == null ? void 0 : a11y.label) ? a11y == null ? void 0 : a11y.label : "",
      "aria-expanded": a11y == null ? void 0 : a11y.expanded,
      "aria-controls": a11y == null ? void 0 : a11y.controls,
      ...qmData,
      ...props,
      children: /* @__PURE__ */ jsx(Icon, { size: icon == null ? void 0 : icon.size, type: icon == null ? void 0 : icon.type })
    }
  );
});
IconButton.displayName = "IconButton";
IconButton.defaultProps = IconDefaultProps;
const TabButton = React.forwardRef(({ ...props }, ref) => {
  const { children, disabled, customClass, onClick: onClick2, onKeyDown, id, a11y, qm, tabIndex, state, gap } = props;
  const customClassName = customClass ? ` ${customClass} ` : "";
  const additionalInnerClass = gap ? { className: gap } : {};
  const qmData = qm ? { [`data-qm-${qm == null ? void 0 : qm.type}`]: qm == null ? void 0 : qm.value } : {};
  const tabStateClass = state ? ` ${TAB_BUTTON_CLASS}--${state}` : "";
  return /* @__PURE__ */ jsx(
    "button",
    {
      tabIndex,
      role: Role.TAB,
      id,
      className: `${TAB_BUTTON_CLASS}${customClassName}${tabStateClass}`,
      ref,
      disabled,
      type: ButtonType.DEFAULT,
      onClick: onClick2,
      onKeyDown,
      "aria-disabled": a11y == null ? void 0 : a11y.disabled,
      "aria-label": (a11y == null ? void 0 : a11y.label) ? a11y == null ? void 0 : a11y.label : "",
      "aria-controls": a11y == null ? void 0 : a11y.controls,
      "aria-selected": (a11y == null ? void 0 : a11y.selected) ? a11y == null ? void 0 : a11y.selected : false,
      ...qmData,
      children: children && /* @__PURE__ */ jsx("span", { ...additionalInnerClass, children })
    }
  );
});
TabButton.displayName = "TabButton";
TabButton.defaultProps = TabDefaultProps;
const ExpandButton = ({ ...props }) => {
  const {
    id,
    content,
    a11y,
    isOpen = false,
    onKeyDown,
    color = ButtonColors.DEFAULT,
    variant = Variation.PRIMARY,
    size = Size.MINI,
    configs = {
      maxCollapsedVisibility: 1,
      expandIcon: ExpandIcon.CHEVRON,
      gap: Size.XS
    }
  } = props;
  const [isExpanded, setIsExpanded] = useState(isOpen);
  const [collapsedVisibility, setCollapsedVisibility] = useState(configs.maxCollapsedVisibility);
  const isOpenClass = isExpanded ? ` ${EXPAND_BUTTON_CLASS}--open` : "";
  const buttonGapGlass = `${EXPAND_BUTTON_CLASS}--gap-${configs.gap ? configs.gap : Size.XS}`;
  const sizeClass = `${EXPAND_BUTTON_CLASS}--${size ? size : Size.MINI}`;
  const accordionColor = color !== ButtonColors.DEFAULT ? `-${color}` : "";
  const accordionVariant = `${EXPAND_BUTTON_CLASS}--${variant ? variant : Variation.PRIMARY}${accordionColor}`;
  useEffect(() => {
    if (isArrayNotEmpty(content)) {
      setCollapsedVisibility(isExpanded ? content.length : configs.maxCollapsedVisibility);
    }
  }, [isExpanded, content, configs]);
  const handleButtonClick = () => {
    setIsExpanded(!isExpanded);
  };
  const renderExpandContent = () => {
    if (isArrayNotEmpty(content)) {
      const contentArray = content == null ? void 0 : content.slice(0, collapsedVisibility);
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-xs-flex ${PREFIX}-xs-flex-wrap ${buttonGapGlass} ${EXPAND_BUTTON_CLASS}--content`,
          children: contentArray == null ? void 0 : contentArray.map((item) => /* @__PURE__ */ jsxs("div", { className: `${EXPAND_BUTTON_CLASS}--content-group`, children: [
            /* @__PURE__ */ jsx("p", { children: item.title }),
            /* @__PURE__ */ jsx("p", { children: item.description })
          ] }, `${item.title}`))
        }
      );
    } else {
      return /* @__PURE__ */ jsxs("div", { className: `${EXPAND_BUTTON_CLASS}--content-group`, children: [
        /* @__PURE__ */ jsx("p", { children: content == null ? void 0 : content.title }),
        isExpanded && /* @__PURE__ */ jsx("p", { children: content == null ? void 0 : content.description })
      ] });
    }
  };
  const renderButtonIcon = () => {
    switch (configs.expandIcon) {
      case ExpandIcon.PLUS_MINUS:
        return `ct-${isExpanded ? "minimizeView" : "add"}`;
      case ExpandIcon.PLUS_CLOSE:
        return `ct-${isExpanded ? "close" : "add"}`;
      default:
        return `ct-chevron-${isExpanded ? "up" : "down"}`;
    }
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      id,
      onClick: handleButtonClick,
      onKeyDown,
      className: `${EXPAND_BUTTON_CLASS}${isOpenClass} ${sizeClass} ${accordionVariant}`,
      "aria-controls": a11y == null ? void 0 : a11y.controls,
      "aria-label": a11y == null ? void 0 : a11y.label,
      "aria-disabled": a11y == null ? void 0 : a11y.disabled,
      "aria-expanded": isExpanded,
      children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-xs-flex ${PREFIX}-xs-align-items-center ${buttonGapGlass}`, children: [
        renderExpandContent(),
        /* @__PURE__ */ jsx(Icon, { size: Size.MEDIUM, type: renderButtonIcon() })
      ] })
    }
  );
};
var CtaStyles = /* @__PURE__ */ ((CtaStyles2) => {
  CtaStyles2["BRAND_LOGO"] = "brand-logo";
  CtaStyles2["GENERIC"] = "generic";
  return CtaStyles2;
})(CtaStyles || {});
const CommonCtaClass = `${PREFIX}-cta`;
const ImageLink = React.forwardRef(({ ...props }, ref) => {
  const { children, link, commonProps } = props;
  const altLinkTitle = (link == null ? void 0 : link.label) && typeof link.label === "string" ? { title: link.label } : "";
  const linkTitle = !(link == null ? void 0 : link.title) ? altLinkTitle : { title: link.title };
  const linkTarget = (link == null ? void 0 : link.target) ? { target: link.target } : "";
  const linkRel = (link == null ? void 0 : link.rel) ? { rel: link.rel } : "";
  return /* @__PURE__ */ jsx("a", { href: link.url, ref, ...linkTitle, ...linkTarget, ...linkRel, ...commonProps, children });
});
ImageLink.displayName = "ImageLink";
const ImageButton = React.forwardRef(({ ...props }, ref) => {
  const { children } = props;
  return /* @__PURE__ */ jsx("button", { ref, ...props, children });
});
ImageButton.displayName = "ImageButton";
const ComplexCTA = ({ ...props }) => {
  const { onKeyDown, qm, customClass, id, a11y, style = CtaStyles.BRAND_LOGO, children, image, link, onClick: onClick2 } = props;
  const customClassName = customClass ? ` ${customClass}` : "";
  const componentStyle = ` ${CommonCtaClass}--${style}`;
  const qmData = qm ? { [`data-qm-${qm == null ? void 0 : qm.type}`]: qm == null ? void 0 : qm.value } : {};
  const commonProps = {
    className: `${CommonCtaClass}${componentStyle}${customClassName}`,
    id,
    onClick: onClick2,
    onKeyDown,
    ...qmData,
    "aria-disabled": a11y == null ? void 0 : a11y.disabled,
    "aria-label": a11y == null ? void 0 : a11y.label,
    "aria-labelledby": a11y == null ? void 0 : a11y.label,
    "aria-expanded": a11y == null ? void 0 : a11y.expanded,
    "aria-controls": a11y == null ? void 0 : a11y.controls
  };
  const renderImageCtaContent = () => {
    var _a;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      image && /* @__PURE__ */ jsx("div", { className: `${CommonCtaClass}__container--image`, children: /* @__PURE__ */ jsx("img", { src: image.url, alt: image.alt || "", "aria-hidden": (_a = image.a11y) == null ? void 0 : _a.hidden }) }),
      children && /* @__PURE__ */ jsx("div", { className: `${CommonCtaClass}__container--content`, children })
    ] });
  };
  const renderSelectedCTA = () => {
    if ([CtaStyles.BRAND_LOGO, CtaStyles.GENERIC].includes(style)) {
      return link ? /* @__PURE__ */ jsx(ImageLink, { commonProps, link, children: renderImageCtaContent() }) : /* @__PURE__ */ jsx(ImageButton, { ...commonProps, type: props.type, disabled: props.disabled, children: renderImageCtaContent() });
    } else {
      return null;
    }
  };
  return renderSelectedCTA();
};
ComplexCTA.displayName = "ComplexCTA";
const useClickOutsideClose = (ref, callback, when, outsideClick, disableStopPropagation) => {
  const updateClosureOnRender = useRef(callback);
  useEffect(() => {
    updateClosureOnRender.current = callback;
  });
  const handleCloseEvent = useCallback(
    (ev) => {
      if (outsideClick) {
        const node = ev.target;
        if (ref.current && !ref.current.contains(node)) {
          !disableStopPropagation && ev.stopPropagation();
          updateClosureOnRender.current(ev);
        }
      }
    },
    [outsideClick, ref]
  );
  useEffect(() => {
    if (outsideClick && when) {
      document.addEventListener("click", handleCloseEvent, true);
      return () => document.removeEventListener("click", handleCloseEvent, true);
    }
    return void 0;
  }, [when, handleCloseEvent, outsideClick]);
};
const isPrerenderOrNot = () => {
  return navigator.userAgent.toLowerCase().includes("prerender");
};
const Backdrop = ({
  tooltipModifiedStyles
}) => {
  const containerClass = !isPrerenderOrNot() ? `${PREFIX}-backdrop-tooltip` : "";
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${containerClass}
            ${tooltipModifiedStyles || ""}`,
      "data-testid": "backdrop-tooltip"
    }
  );
};
const TooltipBody = ({ children, elementClassName }) => {
  const mount = document.getElementById("modalToolTipContainer") || document.getElementsByClassName(elementClassName)[0] || document.getElementById("toastDiv") || document.body;
  return createPortal(React.createElement("div", null, children), mount);
};
const useSetCoords = (tooltipRef, setcoords, fetchCoords, handleResize, coords) => {
  useGlobalResizeEvent(handleResize);
  useEffect(() => {
    if (tooltipRef.current && window.getComputedStyle(tooltipRef.current).getPropertyValue("position") === "absolute") {
      setcoords(fetchCoords());
    }
  }, [setcoords, tooltipRef, coords, fetchCoords]);
};
const viewPortConstants = {
  divisionByTwo: 2,
  halfOfwidth: 171,
  halfOfWidthTablet: 144,
  oneThirdOfWidth: 114
};
const enableFocusLock = (focusLockRef) => {
  const popup = focusLockRef == null ? void 0 : focusLockRef.current;
  if (!popup) {
    return null;
  }
  const focusableElementsSelector = [
    "a[href]",
    "area[href]",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    "section"
  ].join(",");
  const firstElement = popup.querySelectorAll(focusableElementsSelector)[0];
  firstElement.focus({ preventScroll: true });
  const eventListener = (e) => {
    const allContent = popup.querySelectorAll(focusableElementsSelector);
    const content = [];
    if (allContent) {
      allContent.forEach((el) => {
        if (el.offsetParent !== null) {
          content.push(el);
        }
      });
    }
    const lastElement = content[content.length - magicNumber.ONE];
    const isTabPressed2 = e.key === stringKeyCodes.tab || e.keyCode === keyCodes.tab;
    if (!isTabPressed2) {
      return;
    }
    if (e.shiftKey) {
      if (document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
    }
  };
  document.addEventListener("keydown", eventListener);
  return eventListener;
};
const disableFocusLock = (e) => {
  document.removeEventListener("keydown", e);
};
const Tooltip = (props) => {
  const {
    outsideClick = true,
    headerText,
    bodyText,
    visibility,
    iconID,
    setVisibility,
    path,
    a11yCloseIconLabel,
    isTooltipOnModal,
    isModalPresent,
    isPositionSticky,
    tooltipModifiedStyles = "",
    elementClassName
  } = props;
  const coords = props.coords;
  const tooltipRef = useRef(null);
  const focusLockEventRef = useRef(null);
  const [readyToRender, setReadyToRender] = useState(false);
  const hideTooltip = () => {
    setVisibility(false);
  };
  const { divisionByTwo, halfOfwidth, oneThirdOfWidth, halfOfWidthTablet } = viewPortConstants;
  const fetchCoords = useCallback(() => {
    const rect = coords.getBoundingClientRect();
    const halfWidthForResolution = window.innerWidth > BREAKPOINTS.desktopMin ? halfOfwidth : halfOfWidthTablet;
    const isOutOfleftViewPort = rect.left - halfWidthForResolution >= 0;
    const isOutOfRightViewPort = rect.right + halfWidthForResolution <= (window.innerWidth || document.documentElement.clientWidth);
    const isInViewport = isOutOfleftViewPort && isOutOfRightViewPort;
    const position = {
      visibleInViewport: isInViewport,
      visibleInViewportRight: isOutOfRightViewPort,
      visibleInViewportLeft: isOutOfleftViewPort,
      left: 0,
      top: isPositionSticky ? "unset" : rect.top + window.scrollY + rect.height
    };
    if (!isInViewport) {
      if (!isOutOfRightViewPort) {
        position.left = rect.left + rect.width / divisionByTwo - oneThirdOfWidth;
      } else if (!isOutOfleftViewPort) {
        position.left = rect.right - rect.width / divisionByTwo + oneThirdOfWidth;
      }
    } else {
      position.left = rect.left + rect.width / divisionByTwo;
    }
    return position;
  }, [coords, divisionByTwo, halfOfWidthTablet, halfOfwidth, oneThirdOfWidth, isPositionSticky]);
  const modifierClass = isModalPresent ? `${PREFIX}-tooltip__inside--modal` : "";
  const initialState2 = {
    left: 0,
    top: 0,
    visibleInViewport: true,
    visibleInViewportRight: true,
    visibleInViewportLeft: true
  };
  const [leftTopCoords, setcoords] = useState(initialState2);
  const closeHandler = (e) => {
    var _a;
    e.stopPropagation();
    e.preventDefault();
    (_a = e.nativeEvent) == null ? void 0 : _a.stopImmediatePropagation();
    disableFocusLock(focusLockEventRef.current);
    hideTooltip();
    coords.focus();
  };
  useClickOutsideClose(tooltipRef, closeHandler, visibility, outsideClick);
  const closeModalEsc = useCallback(
    (e) => {
      if (e.keyCode === keyCodes.esc) {
        disableFocusLock(focusLockEventRef.current);
        setVisibility(false);
        coords.focus();
      }
    },
    [coords, setVisibility]
  );
  useEffect(() => {
    if (visibility) {
      document.body.addEventListener("keydown", closeModalEsc);
    } else {
      document.body.removeEventListener("keydown", closeModalEsc);
    }
  }, [visibility, closeModalEsc]);
  const handleResize = () => {
    if (tooltipRef.current && window.getComputedStyle(tooltipRef.current).getPropertyValue("position") === "absolute") {
      setcoords(fetchCoords());
    } else {
      setcoords(initialState2);
    }
  };
  useSetCoords(tooltipRef, setcoords, fetchCoords, handleResize, coords);
  const setTooltipUpArrow = useCallback(() => {
    const container = document.getElementsByClassName("nl-tooltip")[0];
    if (!leftTopCoords.visibleInViewport && !leftTopCoords.visibleInViewportRight) {
      container.classList.add("nl-tooltip--right");
    } else if (!leftTopCoords.visibleInViewport && !leftTopCoords.visibleInViewportLeft) {
      container.classList.add("nl-tooltip--left");
    }
  }, [leftTopCoords]);
  const setFocusOnTooltip = () => {
    focusLockEventRef.current && disableFocusLock(focusLockEventRef.current);
    focusLockEventRef.current = enableFocusLock(tooltipRef);
  };
  const visibleClass = useMemo(() => readyToRender ? "" : `${PREFIX}-tooltip__hide`, [readyToRender]);
  useEffect(() => {
    if (tooltipRef.current) {
      if (!isTooltipOnModal && window.getComputedStyle(tooltipRef.current).getPropertyValue("position") === "absolute") {
        tooltipRef.current.style.cssText = `left:${leftTopCoords.left}px;top:${leftTopCoords.top}px;`;
        setReadyToRender(!!leftTopCoords.left || !!leftTopCoords.top);
      } else {
        setReadyToRender(true);
      }
    }
  }, [isTooltipOnModal, leftTopCoords.left, leftTopCoords.top]);
  useEffect(() => {
    if (!!visibility && coords && readyToRender) {
      !isTooltipOnModal && window.getComputedStyle(tooltipRef.current).getPropertyValue("position") === "absolute" && setTooltipUpArrow();
      setFocusOnTooltip();
    }
  }, [coords, isTooltipOnModal, readyToRender, setTooltipUpArrow, visibility]);
  useEffect(() => {
    if (tooltipRef.current) {
      const linkList = tooltipRef.current.getElementsByTagName("a");
      linkList && Array.from(linkList).forEach((link) => link.setAttribute("target", "_blank"));
    }
  }, []);
  return /* @__PURE__ */ jsx("div", { children: !!visibility && coords && /* @__PURE__ */ jsxs(TooltipBody, { elementClassName, children: [
    !!visibility && /* @__PURE__ */ jsx(Backdrop, { tooltipModifiedStyles }),
    !!visibility && /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${PREFIX}-tooltip ${modifierClass} ${tooltipModifiedStyles} ${visibleClass} ${isPrerenderOrNot() ? `${PREFIX}-sm-none ${PREFIX}-xs-none` : ""}`,
        ref: tooltipRef,
        id: "tooltipRef",
        "data-testid": "tooltipRef",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "sr-only", role: "alert", "aria-live": "assertive", children: [
            headerText,
            " ",
            bodyText
          ] }),
          /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-tooltip__header ${PREFIX}-pb-sm`, children: [
            /* @__PURE__ */ jsx("span", { className: `${PREFIX}-tooltip__header--text`, children: headerText }),
            !!iconID && !!iconID.length && /* @__PURE__ */ jsx(
              "button",
              {
                onClick: closeHandler,
                "aria-label": a11yCloseIconLabel,
                "data-testid": "tooltip-close-button",
                children: /* @__PURE__ */ jsx(Icon, { type: iconID, title: `${a11yCloseIconLabel}`, size: "md", path })
              }
            )
          ] }),
          /* @__PURE__ */ jsx("div", { className: `${PREFIX}-tooltip__body ${PREFIX}-body-xs`, "data-testid": "tooltip-body", children: bodyText })
        ]
      }
    )
  ] }) });
};
Tooltip.propTypes = {
  headerText: PropTypes.string,
  bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  visibility: PropTypes.bool,
  iconID: PropTypes.string,
  setVisibility: PropTypes.func,
  path: PropTypes.string,
  coords: PropTypes.any,
  outsideClick: PropTypes.any,
  a11yCloseIconLabel: PropTypes.string,
  isTooltipOnModal: PropTypes.bool,
  isPositionSticky: PropTypes.bool
};
Tooltip.displayName = "TooltipInLib";
var FeeType = /* @__PURE__ */ ((FeeType2) => {
  FeeType2["ECO_FEE"] = "ECO_FEE";
  FeeType2["CORE_CHARGE"] = "CORE_CHARGE";
  FeeType2["TIRE_RECYCLE_FEE"] = "TIRE_RECYCLE_FEE";
  return FeeType2;
})(FeeType || {});
const localization = (() => {
  const _constructLocale = (language2, currencyShortForm2) => {
    return `${language2}-${currencyShortForm2}`;
  };
  const formattedPrice = (language2, amount, currencyShortForm2, currencyFormat2, maximumFractionDigits = magicNumber.TWO, minimumFractionDigits = magicNumber.TWO) => {
    var _a, _b;
    const numberFormatOptions = {
      style: "currency",
      currency: currencyFormat2,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits,
      minimumFractionDigits
    };
    try {
      return (_a = new Intl.NumberFormat(_constructLocale(language2, currencyShortForm2), numberFormatOptions)) == null ? void 0 : _a.format(
        amount
      );
    } catch {
      return (_b = new Intl.NumberFormat(_constructLocale(language2, currencyShortForm2), {
        ...numberFormatOptions,
        currencyDisplay: "symbol"
      })) == null ? void 0 : _b.format(amount);
    }
  };
  const formattedDate = (options, date, language2) => {
    try {
      return new Intl.DateTimeFormat(_constructLocale(language2, currencyShortForm), options).format(
        new Date(date)
      );
    } catch {
      return new Date(date).toLocaleString(_constructLocale(language2, currencyShortForm), options);
    }
  };
  const isEnglish = Boolean(getLanguage() === defaultLocale$1);
  const isFrench = Boolean(getLanguage() === frenchLocale);
  return {
    formattedPrice,
    formattedDate,
    isEnglish,
    isFrench
  };
})();
const checkInstanceOf = (value) => {
  if (value && (!Object.keys(value).includes("minPrice") || !value.minPrice)) {
    return value.formattedValue;
  } else if (value && Object.keys(value).includes("minPrice")) {
    value = value;
    return `${value.minPrice.formattedValue} - ${value.maxPrice.formattedValue}`;
  } else {
    return "";
  }
};
const checkInstanceOfPrice = (priceValue, currentLanguage, quantity, isZeroPriceShown = false) => {
  const initialPriceVal = {
    value: 0,
    minPrice: 0
  };
  const { value, minPrice } = !!priceValue ? priceValue : initialPriceVal;
  if (isZeroPriceShown ? value >= 0 : value) {
    return getFormattedPriceValue(currentLanguage, quantity ? quantity * value : value);
  } else if (isZeroPriceShown ? minPrice >= 0 : minPrice) {
    return `${getFormattedPriceValue(currentLanguage, quantity ? quantity * minPrice : minPrice)}`;
  } else {
    return "";
  }
};
const checkInstanceOfMaxPrice = (priceValue, currentLanguage, quantity) => {
  const initialPriceVal = {
    maxPrice: 0
  };
  const { maxPrice } = !!priceValue ? priceValue : initialPriceVal;
  return `${getFormattedPriceValue(currentLanguage, maxPrice)}`;
};
const getFormattedPriceValue = (currentLanguage, price) => {
  return localization.formattedPrice(currentLanguage, price, currencyShortForm, currencyFormat);
};
const SET_OF_FOUR_MULTIPLAYER = 4;
const wasPriceTestId = "was-price-wrapper-id";
const rangeDash = " - ";
const ONE_CENT = 0.01;
const isPriceNumbersEquil = (...prices) => {
  const areAllNumbers = prices.every((item) => typeof item === "number");
  const priceCopy = areAllNumbers ? prices : prices.map((item) => item == null ? void 0 : item.toString());
  const equality = areAllNumbers ? (x, y) => Math.abs(x - y) < ONE_CENT : (a, b) => a === b;
  return priceCopy.reduce(
    (accumulator, item) => accumulator && !priceCopy.find((item2) => !equality(item, item2)),
    true
  );
};
const isRangePrice = (price) => Boolean(price.maxPrice && price.minPrice);
const convertZeroRangeIntoMonoPrice = (price) => {
  let newPrice = price;
  if (price && isRangePrice(price) && isPriceNumbersEquil(price.maxPrice, price.minPrice)) {
    newPrice = {
      minPrice: null,
      maxPrice: null,
      value: price.minPrice
    };
  }
  return newPrice;
};
const normalizePrice = (price) => {
  return convertZeroRangeIntoMonoPrice(price);
};
const checkWasCurrentPrice = (currentPrice, originalPrice, language2) => {
  return currentPrice && Object.keys(currentPrice).length ? checkInstanceOfPrice(currentPrice, language2) : checkInstanceOfPrice(originalPrice, language2);
};
const checkTotalPriceComponent = (isMoreQuantityCartPage, priceValue, currentPrice, originalPrice, language2, showDiscountedPrice, totalPrice, isZeroPriceShown = false) => {
  return isMoreQuantityCartPage ? checkInstanceOfPrice(priceValue, language2, void 0, isZeroPriceShown) : (
    // eslint-disable-next-line sonar/no-nested-conditional
    showDiscountedPrice && isValidPrice(totalPrice) ? checkInstanceOfPrice(totalPrice, language2, void 0, isZeroPriceShown) : (
      // eslint-disable-next-line sonar/no-nested-conditional
      currentPrice && Object.keys(currentPrice).length ? checkInstanceOfPrice(currentPrice, language2, void 0, isZeroPriceShown) : checkInstanceOfPrice(originalPrice, language2, void 0, isZeroPriceShown)
    )
  );
};
const getTotalPriceMax = (isMoreQuantityCartPage, priceValue, currentPrice, originalPrice, language2, showDiscountedPrice, totalPrice) => {
  return isMoreQuantityCartPage ? checkInstanceOfMaxPrice(priceValue, language2) : (
    // eslint-disable-next-line sonar/no-nested-conditional
    showDiscountedPrice && isValidPrice(totalPrice) ? checkInstanceOfMaxPrice(totalPrice, language2) : (
      // eslint-disable-next-line sonar/no-nested-conditional
      currentPrice && Object.keys(currentPrice).length ? checkInstanceOfMaxPrice(currentPrice, language2) : checkInstanceOfMaxPrice(originalPrice, language2)
    )
  );
};
const getNowWasLabel = (displayWasLabel, originalPrice, unitPriceLabel, wasFromLabel, fromLabel, isRangeView, showToLabel) => {
  const fromApplicable = !(originalPrice == null ? void 0 : originalPrice.value) && (!isRangeView || !(originalPrice == null ? void 0 : originalPrice.maxPrice));
  return displayWasLabel ? fromApplicable ? wasFromLabel : unitPriceLabel : fromApplicable ? fromLabel : "";
};
const isValidPrice = (price) => {
  return typeof ((price == null ? void 0 : price.value) ?? (price == null ? void 0 : price.minPrice)) === "number";
};
const areAllParamsValid = (...params) => {
  return params.reduce((paramA, paramB) => paramA && paramB);
};
const isAtleastOneParamValid = (...params) => {
  return params.reduce((paramA, paramB) => paramA || paramB);
};
const WrapPriceByLabel = ({ inputPrice, label, language: language2 }) => {
  const isFrenchLabel = (language2 == null ? void 0 : language2.toUpperCase()) === multiLanguageLabel.frenchLangLabel;
  if (!inputPrice) {
    return null;
  }
  if (typeof label === "string" && label.includes("[0]")) {
    return /* @__PURE__ */ jsx(Fragment, { children: label.replace("[0]", inputPrice) });
  } else if (isFrenchLabel) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      inputPrice,
      label
    ] });
  } else {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      label,
      inputPrice
    ] });
  }
};
WrapPriceByLabel.displayName = "WrapPriceByLabel";
const RangePriceOrFromPrice = ({
  price,
  language: language2,
  isRangeView = false,
  fromLabel,
  toLabel,
  showToNow
}) => {
  const normalizedPrice = normalizePrice(price);
  const toShowRange = isRangeView && (normalizedPrice == null ? void 0 : normalizedPrice.maxPrice);
  const priceInstance = checkInstanceOfPrice(normalizedPrice, language2);
  const maxPriceInstance = checkInstanceOfMaxPrice(normalizedPrice, language2);
  return /* @__PURE__ */ jsx(Fragment, {
    // eslint-disable-next-line sonar/expression-complexity
    children: toShowRange ? (
      // eslint-disable-next-line sonar/no-nested-conditional
      showToNow && fromLabel && toLabel ? /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-price__price-range`, children: [
        /* @__PURE__ */ jsx(WrapPriceByLabel, { inputPrice: priceInstance, label: fromLabel, language: language2 }),
        /* @__PURE__ */ jsx(WrapPriceByLabel, { inputPrice: maxPriceInstance, label: toLabel, language: language2 })
      ] }) : /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-price__price-range`, children: [
        priceInstance,
        /* @__PURE__ */ jsx("span", { className: "range-dash", "data-testId": "price-range-dash", children: rangeDash }),
        maxPriceInstance
      ] })
    ) : priceInstance
  });
};
RangePriceOrFromPrice.displayName = "RangePriceOrFromPrice";
const TotalRangePriceOrFromPrice = ({
  isMoreQuantityCartPage,
  priceValue,
  currentPrice,
  originalPrice,
  language: language2,
  showDiscountedPrice,
  totalPrice,
  isAppliedPromoExist,
  isRangeView = false,
  fromLabel,
  toLabel,
  showToNow
}) => {
  const normalizedPriceValue = normalizePrice(priceValue);
  const normalizedCurrentPrice = normalizePrice(currentPrice);
  const normalizedOriginalPrice = normalizePrice(originalPrice);
  const normalizedTotalPrice = normalizePrice(totalPrice);
  const showRange = isRangeView && [normalizedPriceValue, normalizedCurrentPrice, normalizedOriginalPrice].filter((item) => item == null ? void 0 : item.minPrice).find((item) => item.maxPrice);
  const totalPriceInstance = checkTotalPriceComponent(
    isMoreQuantityCartPage,
    normalizedPriceValue,
    normalizedCurrentPrice,
    normalizedOriginalPrice,
    language2,
    showDiscountedPrice,
    normalizedTotalPrice,
    isAppliedPromoExist
  );
  const maxTotalPriceInstance = getTotalPriceMax(
    isMoreQuantityCartPage,
    normalizedPriceValue,
    normalizedCurrentPrice,
    normalizedOriginalPrice,
    language2,
    showDiscountedPrice,
    normalizedTotalPrice
  );
  return /* @__PURE__ */ jsx(Fragment, {
    // eslint-disable-next-line sonar/expression-complexity
    children: showRange && totalPriceInstance && maxTotalPriceInstance ? (
      // eslint-disable-next-line sonar/no-nested-conditional
      showToNow && fromLabel && toLabel ? /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-price__price-range`, children: [
        /* @__PURE__ */ jsx(WrapPriceByLabel, { inputPrice: totalPriceInstance, label: fromLabel, language: language2 }),
        /* @__PURE__ */ jsx(WrapPriceByLabel, { inputPrice: maxTotalPriceInstance, label: toLabel, language: language2 })
      ] }) : /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-price__price-range`, children: [
        totalPriceInstance,
        /* @__PURE__ */ jsx("span", { className: "range-dash", children: rangeDash }),
        maxTotalPriceInstance
      ] })
    ) : totalPriceInstance
  });
};
TotalRangePriceOrFromPrice.displayName = "TotalRangePriceOrFromPrice";
const Price = ({
  priceStyle,
  unitPriceLabel,
  clearancePriceLabel,
  a11yPriceRangeFrom,
  a11yPriceRangeTo,
  a11yStrikeOutPrice,
  a11yStrikeOutPriceRange,
  a11yTooltipIcon,
  a11yCloseIconLabel,
  feeTitle,
  feeDisclaimerMessage,
  feeDisclaimerTitle,
  originalPrice,
  currentPrice,
  displayWasLabel,
  language: language2,
  isMoreQuantityCartPage,
  eachLabel,
  priceValue,
  priceMessage,
  isAutomotiveEachLabel,
  feeDisclaimerType,
  scrollToFooter: scrollToFooter2,
  a11yRecycleFeesTriangleIcon,
  wasFromLabel,
  wasToLabel,
  fromLabel,
  toLabel,
  nowFromLabel,
  nowToLabel,
  isVehicleInformationSaved,
  isWheelOrTirePDP,
  totalCurrentPrice: totalCurrentPrice2,
  totalOriginalPrice,
  setOfFourLabel,
  setOfFourNowLabel,
  setOfTwoLabel,
  setOfTwoNowLabel,
  isWheelOrTire,
  productSkus,
  isStaggered,
  isStaggeredFront,
  showFromNow,
  showToNow,
  isRebate,
  isShoppingCartPage,
  showEachTextForSaveLabel,
  overridePriceHeight,
  hideSaveLabel,
  saveMessage,
  showDiscountedPrice,
  highlightDiscountedPrice,
  discountValue,
  totalPrice,
  isAppliedPromoExist,
  enablePdpPricingEnhancement,
  a11yClickToReadFootnote,
  accessibilityPriceId,
  isOnSaleOrClearance,
  fromAutomotiveSpecification,
  plusMinusSymbol,
  isProductLevelPDP,
  isModalPresent,
  staggeredfulfillmentData,
  displayBadgeComponentBesidePrice,
  isOnSale = false,
  isRangeView = false
}) => {
  const [isMobile2, setIsMobile] = useState(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  const isFrenchLabel = (language2 == null ? void 0 : language2.toUpperCase()) === multiLanguageLabel.frenchLangLabel;
  const isGenmerchPDP = !isAutomotiveEachLabel && enablePdpPricingEnhancement;
  const canShowFrom = (...prices) => {
    var _a;
    return !isRangeView || !((_a = prices == null ? void 0 : prices.filter(Boolean)) == null ? void 0 : _a.find((item) => item.maxPrice));
  };
  const handleResize = () => {
    setIsMobile(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  };
  useGlobalResizeEvent(handleResize);
  const checkRange = (str) => {
    return !!str && str.includes("-");
  };
  const screenReaderPrice = (actualPrice) => {
    const rangeToIndex = 1;
    return checkRange(actualPrice) ? a11yPriceRangeFrom && a11yPriceRangeTo && `${a11yPriceRangeFrom} ${actualPrice.split("-")[0]} ${a11yPriceRangeTo} ${actualPrice.split("-")[rangeToIndex]}` : actualPrice;
  };
  const cartPageOrMoreQuantity = isShoppingCartPage || isMoreQuantityCartPage;
  const isShowNowLabelVisible = () => {
    return (
      // eslint-disable-next-line sonar/expression-complexity
      isPromoGivesAdditionalDiscountOnItem() || cartPageOrMoreQuantity && !isStaggered || !cartPageOrMoreQuantity && isWheelOrTire
    );
  };
  const renderShowNowLabel = () => {
    return isShowNowLabelVisible() && // eslint-disable-next-line sonarjs/no-nested-template-literals
    /* @__PURE__ */ jsx("div", { className: `${showNowLabel() ? `${PREFIX}-price--now` : `${PREFIX}-xs-none`}`, children: showNowLabel() });
  };
  const renderShowNowToLabel = () => {
    return isShowNowLabelVisible() && // eslint-disable-next-line sonarjs/no-nested-template-literals
    /* @__PURE__ */ jsx("div", { className: `${showNowToLabel() ? `${PREFIX}-price--now` : `${PREFIX}-xs-none`}`, children: showNowToLabel() });
  };
  const renderEachLable = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-price__each-label`, children: eachLabel });
  };
  const renderCurrentPrice = () => {
    let currentPriceCls = priceStyle ? `${priceStyle}` : `${PREFIX}-price__value`;
    currentPriceCls = `${currentPriceCls} ${overridePriceHeight ? "current-price--min-height" : ""}`;
    const label = renderShowNowLabel();
    const labelTo = renderShowNowToLabel();
    const selectedPrice = currentPrice && Object.keys(currentPrice).length ? currentPrice : originalPrice;
    const justPrice = () => /* @__PURE__ */ jsx(
      RangePriceOrFromPrice,
      {
        price: selectedPrice,
        language: language2,
        isRangeView,
        fromLabel: label,
        toLabel: labelTo,
        showToNow
      }
    );
    const enlishPriceLabel = () => canShowFrom(selectedPrice) && !isFrenchLabel && label;
    const frenchPriceLabel = () => canShowFrom(selectedPrice) && isFrenchLabel && label;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "aria-label": screenReaderPrice(checkWasCurrentPrice(currentPrice, originalPrice, language2)),
        className: `${currentPriceCls} ${isOnSaleOrClearance ? definePriceStyle() : ""}`,
        "data-testid": "price",
        children: [
          enlishPriceLabel(),
          justPrice(),
          frenchPriceLabel(),
          isMoreQuantityCartPage && renderEachLable()
        ]
      }
    );
  };
  const [visibility, setVisibility] = useState(false);
  const buttonRef = useRef();
  const [saveTooltipVisibility, setSaveTooltipVisibility] = useState(false);
  const saveTooltipButtonRef = useRef();
  const toolTipText = (tooltipDesc) => {
    return /* @__PURE__ */ jsx("div", { "data-testid": "tooltip-text", dangerouslySetInnerHTML: { __html: tooltipDesc } });
  };
  const toolTipButtonHandler = (e, visibilitySetter, currentVisibility) => {
    e.stopPropagation();
    e.preventDefault();
    addModalAttribute(e);
    visibilitySetter(!currentVisibility);
  };
  const toolTipButtonKeyboardHandler = (e, visibilitySetter, currentVisibility) => {
    isEnterPressed(e.key) && toolTipButtonHandler(e, visibilitySetter, currentVisibility);
  };
  const feesComponent = () => {
    return feeTitle && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-price__eco-fee ${overridePriceHeight ? "eco-fee--min-height" : ""}`, children: [
      feeDisclaimerType === FeeType.TIRE_RECYCLE_FEE ? isAtleastOneParamValid(!isStaggered, !showFromNow, fromAutomotiveSpecification) && /* @__PURE__ */ jsxs(
        "div",
        {
          ref: buttonRef,
          onClick: scrollToFooter2,
          onKeyPress: scrollToFooter2,
          className: `${PREFIX}-price__tire-fee-tooltip-btn`,
          role: "link",
          tabIndex: magicNumber.ZERO,
          "data-testid": "tire-recycle-fee",
          "aria-label": feeTitle.concat("-", a11yClickToReadFootnote),
          children: [
            feeTitle.trim(),
            /* @__PURE__ */ jsx("sup", { "aria-hidden": "true", children: a11yRecycleFeesTriangleIcon })
          ]
        }
      ) : feeDisclaimerMessage && /* @__PURE__ */ jsxs(Fragment, { children: [
        feeTitle,
        /* @__PURE__ */ jsx(
          "button",
          {
            ref: buttonRef,
            className: `${PREFIX}-price__eco-fee-tooltip-btn`,
            onClick: (event) => toolTipButtonHandler(event, setVisibility, visibility),
            onKeyDown: (event) => toolTipButtonKeyboardHandler(event, setVisibility, visibility),
            "data-testid": "eco-fee",
            "aria-label": a11yTooltipIcon,
            children: /* @__PURE__ */ jsx(
              "span",
              {
                className: visibility ? `${PREFIX}-price__eco-fee-tooltip-btn--active` : "",
                children: /* @__PURE__ */ jsx(Icon, { type: "ct-information-details", size: "sm" })
              }
            )
          }
        )
      ] }),
      !!visibility && /* @__PURE__ */ jsx(
        Tooltip,
        {
          visibility,
          setVisibility,
          iconID: "ct-close",
          headerText: feeDisclaimerTitle,
          bodyText: toolTipText(feeDisclaimerMessage),
          coords: buttonRef.current,
          a11yCloseIconLabel,
          isModalPresent
        }
      )
    ] });
  };
  let wasPriceClass = feeTitle ? `${PREFIX}-price--was-eco` : `${PREFIX}-price--was`;
  wasPriceClass = overridePriceHeight ? `${wasPriceClass} ${PREFIX}-price--was-price--min-height` : wasPriceClass;
  const showEachLabel = () => {
    return isAutomotiveEachLabel && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-price--each`, children: eachLabel });
  };
  const checkIfOriginalPriceAvailable = () => {
    return !!((originalPrice == null ? void 0 : originalPrice.value) || (originalPrice == null ? void 0 : originalPrice.minPrice));
  };
  const getA11yPriceWasLabel = () => {
    return (originalPrice == null ? void 0 : originalPrice.minPrice) && (currentPrice == null ? void 0 : currentPrice.minPrice) ? a11yStrikeOutPriceRange : a11yStrikeOutPrice;
  };
  const renderNowWasLabel = (nowWasLabel, index2) => {
    const nowWasPriceLabel = nowWasLabel == null ? void 0 : nowWasLabel.split("[0]")[index2];
    return !!nowWasPriceLabel && /* @__PURE__ */ jsxs("span", { "aria-hidden": "true", children: [
      `${nowWasPriceLabel}`,
      !!(originalPrice == null ? void 0 : originalPrice.value) && /* @__PURE__ */ jsx("sup", { "aria-hidden": "true", children: plusMinusSymbol })
    ] });
  };
  const priceAndEachLabel = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        RangePriceOrFromPrice,
        {
          price: originalPrice,
          language: language2,
          isRangeView,
          fromLabel,
          toLabel,
          showToNow
        }
      ),
      !isProductLevelPDP && showEachLabel()
    ] });
  };
  const wasPriceComponent = () => {
    const priceLabel = getA11yPriceWasLabel();
    const nowWasLabel = getNowWasLabel(
      displayWasLabel,
      originalPrice,
      unitPriceLabel,
      wasFromLabel,
      fromLabel,
      isRangeView
    );
    const nowWasToLabel = getNowWasLabel(
      displayWasLabel,
      originalPrice,
      unitPriceLabel,
      wasToLabel,
      toLabel,
      isRangeView
    );
    const fromNowWasLabelPart = /* @__PURE__ */ jsxs(Fragment, { children: [
      renderNowWasLabel(nowWasLabel, 0),
      " ",
      renderNowWasLabel(nowWasLabel, 1),
      " "
    ] });
    const toNowWasLabelPart = /* @__PURE__ */ jsxs(Fragment, { children: [
      renderNowWasLabel(nowWasToLabel, 0),
      " ",
      renderNowWasLabel(nowWasToLabel, 1),
      " "
    ] });
    const innerPrice = () => /* @__PURE__ */ jsx(Fragment, { children: isVehicleInformationSaved ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        RangePriceOrFromPrice,
        {
          price: totalOriginalPrice,
          language: language2,
          isRangeView,
          fromLabel: fromNowWasLabelPart,
          toLabel: toNowWasLabelPart,
          showToNow
        }
      ),
      /* @__PURE__ */ jsx(
        RangePriceOrFromPrice,
        {
          price: originalPrice,
          language: language2,
          isRangeView,
          fromLabel: fromNowWasLabelPart,
          toLabel: toNowWasLabelPart,
          showToNow
        }
      ),
      eachLabel
    ] }) : priceAndEachLabel() });
    if (checkIfOriginalPriceAvailable() && !isStaggered) {
      if (language2.toUpperCase() === multiLanguageLabel.frenchLangLabel && (nowWasLabel == null ? void 0 : nowWasLabel.includes("[0]"))) {
        return /* @__PURE__ */ jsxs("div", { className: wasPriceClass, "data-tesId": wasPriceTestId, children: [
          /* @__PURE__ */ jsx("s", { "aria-hidden": "true", children: innerPrice() }),
          fromNowWasLabelPart,
          /* @__PURE__ */ jsx("span", { className: "sr-only", children: priceLabel ? `${priceLabel} ${screenReaderPrice(checkInstanceOfPrice(originalPrice, language2))}` : "" })
        ] });
      } else {
        return /* @__PURE__ */ jsxs("div", { className: wasPriceClass, children: [
          fromNowWasLabelPart,
          /* @__PURE__ */ jsx("s", { "aria-hidden": "true", children: innerPrice() }),
          /* @__PURE__ */ jsx("span", { className: "sr-only", children: priceLabel ? `${priceLabel} ${screenReaderPrice(checkInstanceOfPrice(originalPrice, language2))}` : "" })
        ] });
      }
    } else {
      return null;
    }
  };
  const showNowLabel = () => {
    return getNowWasLabel(displayWasLabel, currentPrice, clearancePriceLabel, nowFromLabel, fromLabel, isRangeView);
  };
  const showNowToLabel = () => {
    return getNowWasLabel(displayWasLabel, currentPrice, clearancePriceLabel, nowToLabel, toLabel, isRangeView);
  };
  const renderCartWasNowLabel = (cartPriceLabel) => {
    const containerClassName = cartPriceLabel ? `${PREFIX}-price--now` : `${PREFIX}-xs-none`;
    return !isMoreQuantityCartPage && !isPromoGivesAdditionalDiscountOnItem() && /* @__PURE__ */ jsx("div", { className: `${containerClassName}`, children: !isStaggered && cartPriceLabel });
  };
  const hasDiscount = () => {
    return Boolean(discountValue == null ? void 0 : discountValue.value);
  };
  const definePriceStyle = () => {
    if (hasDiscount() && highlightDiscountedPrice) {
      return `${PREFIX}-price--total--bold`;
    } else if (isOnSaleOrClearance) {
      return `${PREFIX}-price--total--red`;
    } else if (isOnSale) {
      return `${PREFIX}-price--total--bold--red`;
    } else {
      return `${PREFIX}-price--total`;
    }
  };
  const totalPriceCartComponent = () => {
    const cartPriceLabel = showNowLabel();
    const updatedFromLabel = renderCartWasNowLabel(cartPriceLabel);
    const updatedToLabel = showNowToLabel();
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-price--charge`, children: /* @__PURE__ */ jsxs("div", { className: definePriceStyle(), "data-testid": "priceTotal", children: [
      !isFrenchLabel && canShowFrom(priceValue, currentPrice, originalPrice, totalPrice) && updatedFromLabel,
      /* @__PURE__ */ jsx(
        TotalRangePriceOrFromPrice,
        {
          ...{
            isMoreQuantityCartPage,
            priceValue,
            currentPrice,
            originalPrice,
            language: language2,
            showDiscountedPrice,
            totalPrice,
            isAppliedPromoExist,
            isRangeView,
            fromLabel: updatedFromLabel,
            toLabel: updatedToLabel,
            showToNow
          }
        }
      ),
      isFrenchLabel && canShowFrom(priceValue, currentPrice, originalPrice, totalPrice) && updatedFromLabel,
      showEachLabel()
    ] }) });
  };
  const renderWasNowFromLabel = (priceLabel, index2) => {
    const containerClassName = priceLabel ? `${PREFIX}-price--now` : `${PREFIX}-xs-none`;
    return !isMoreQuantityCartPage && !!priceLabel && !isPromoGivesAdditionalDiscountOnItem() && /* @__PURE__ */ jsx("span", { className: `${containerClassName}`, children: !isStaggered && priceLabel.split("[0]")[index2] });
  };
  const totalPriceComponent = () => {
    const priceLabel = showNowLabel();
    const priceToLabel = showNowToLabel();
    if (language2.toUpperCase() === multiLanguageLabel.frenchLangLabel && (priceLabel == null ? void 0 : priceLabel.includes("[0]"))) {
      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-price--charge`, children: [
        renderWasNowFromLabel(priceLabel, 0),
        /* @__PURE__ */ jsx("span", { className: definePriceStyle(), "data-testid": "priceTotal", children: /* @__PURE__ */ jsx(
          TotalRangePriceOrFromPrice,
          {
            ...{
              isMoreQuantityCartPage,
              priceValue,
              currentPrice,
              originalPrice,
              language: language2,
              showDiscountedPrice,
              totalPrice,
              isAppliedPromoExist,
              isRangeView,
              fromLabel: priceLabel,
              toLabel: priceToLabel,
              showToNow
            }
          }
        ) }),
        " ",
        renderWasNowFromLabel(priceLabel, magicNumber.ONE),
        showEachLabel()
      ] });
    } else {
      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-price--charge`, children: [
        renderWasNowFromLabel(priceLabel, 0),
        renderWasNowFromLabel(priceLabel, magicNumber.ONE),
        /* @__PURE__ */ jsxs("span", { className: definePriceStyle(), "data-testid": "priceTotal", children: [
          /* @__PURE__ */ jsx(
            TotalRangePriceOrFromPrice,
            {
              ...{
                isMoreQuantityCartPage,
                priceValue,
                currentPrice,
                originalPrice,
                language: language2,
                showDiscountedPrice,
                totalPrice,
                isAppliedPromoExist,
                isRangeView,
                fromLabel: priceLabel,
                toLabel: priceToLabel,
                showToNow
              }
            }
          ),
          showEachLabel()
        ] }),
        displayBadgeComponentBesidePrice
      ] });
    }
  };
  const displaySetOfLabel = () => {
    var _a, _b;
    const frontSkuDisplayWasLabel = productSkus && ((_a = productSkus[magicNumber.ZERO]) == null ? void 0 : _a.displayWasLabel);
    const rearSkuDisplayWasLabel = productSkus && ((_b = productSkus[magicNumber.ONE]) == null ? void 0 : _b.displayWasLabel);
    if (isArrayNotEmpty(staggeredfulfillmentData)) {
      if (staggeredfulfillmentData.length === 2) {
        return frontSkuDisplayWasLabel && rearSkuDisplayWasLabel ? setOfFourNowLabel : setOfFourLabel;
      } else {
        return frontSkuDisplayWasLabel || rearSkuDisplayWasLabel ? setOfTwoNowLabel : setOfTwoLabel;
      }
    } else {
      return displayWasLabel ? setOfFourNowLabel : setOfFourLabel;
    }
  };
  const renderSetOfFromPrice = (updatedFromLabel, updatedToLabel) => {
    const splitIndex = Number(isFrenchLabel);
    const splitedUpdatedFromLabel = updatedFromLabel == null ? void 0 : updatedFromLabel.split("[0]")[splitIndex];
    const totalPriceCalculated = currentPrice ? Object.entries(currentPrice).reduce((acc, [key, value]) => {
      acc[key] = value ? value * SET_OF_FOUR_MULTIPLAYER : null;
      return acc;
    }, {}) : { value: null, maxPrice: null, minPrice: null };
    const setOfPrice = !isStaggered ? totalPriceCalculated : totalCurrentPrice2;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      canShowFrom(setOfPrice) && !isFrenchLabel && splitedUpdatedFromLabel,
      /* @__PURE__ */ jsx(
        RangePriceOrFromPrice,
        {
          price: setOfPrice,
          language: language2,
          isRangeView: !isStaggered && isRangeView,
          fromLabel: updatedFromLabel,
          toLabel: updatedToLabel,
          showToNow
        }
      ),
      canShowFrom(setOfPrice) && isFrenchLabel && splitedUpdatedFromLabel
    ] });
  };
  const renderFromLabelForPcodePDP = (pcodeFromLabel, pcodeToLabel) => {
    const isFrench = language2.toUpperCase() === multiLanguageLabel.frenchLangLabel;
    const splitFromIndex = Number((pcodeFromLabel == null ? void 0 : pcodeFromLabel.includes("[0]")) && isFrench);
    const splitToIndex = Number((pcodeToLabel == null ? void 0 : pcodeToLabel.includes("[0]")) && isFrench);
    const pcodeFromLabelElement = /* @__PURE__ */ jsx("span", { className: `${PREFIX}-price__set-of-four__from-label-${isFrench ? "french" : "english"}`, children: pcodeFromLabel == null ? void 0 : pcodeFromLabel.split("[0]")[splitFromIndex] });
    const pcodeToLabelElement = /* @__PURE__ */ jsx("span", { className: `${PREFIX}-price__set-of-four__from-label-${isFrench ? "french" : "english"}`, children: pcodeToLabel == null ? void 0 : pcodeToLabel.split("[0]")[splitToIndex] });
    return /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-price__price-range`, children: [
      canShowFrom(currentPrice, originalPrice, totalPrice, priceValue) && !isFrench && pcodeFromLabelElement,
      /* @__PURE__ */ jsx(
        TotalRangePriceOrFromPrice,
        {
          ...{
            isMoreQuantityCartPage,
            priceValue,
            currentPrice,
            originalPrice,
            language: language2,
            showDiscountedPrice,
            totalPrice,
            isAppliedPromoExist,
            fromLabel,
            pcodefromLabel: pcodeFromLabelElement,
            toLabel: pcodeToLabelElement,
            showToNow,
            isRangeView
          }
        }
      ),
      canShowFrom(currentPrice, originalPrice, totalPrice, priceValue) && isFrench && pcodeFromLabelElement
    ] });
  };
  const currentPriceWithEachLabel = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-price__set-of-four__total-price`, children: /* @__PURE__ */ jsxs(
      "span",
      {
        className: classnames(`${PREFIX}-price__set-of-four__current-price`, {
          [definePriceStyle()]: isOnSaleOrClearance
        }),
        children: [
          isProductLevelPDP ? renderFromLabelForPcodePDP(fromLabel, toLabel) : /* @__PURE__ */ jsx(
            TotalRangePriceOrFromPrice,
            {
              ...{
                isMoreQuantityCartPage,
                priceValue,
                currentPrice,
                originalPrice,
                language: language2,
                showDiscountedPrice,
                totalPrice,
                isAppliedPromoExist,
                fromLabel,
                toLabel,
                showToNow,
                isRangeView
              }
            }
          ),
          !isProductLevelPDP && /* @__PURE__ */ jsx("span", { className: ` ${PREFIX}-price__set-of-four__each-label`, children: isWheelOrTire && !isMoreQuantityCartPage && ` ${eachLabel}` })
        ]
      }
    ) });
  };
  const setOfFourTire = () => {
    const [updatedFromLabel, updatedToLabel] = (totalCurrentPrice2 == null ? void 0 : totalCurrentPrice2.minPrice) && !(totalCurrentPrice2 == null ? void 0 : totalCurrentPrice2.value) ? [fromLabel, toLabel] : ["", ""];
    return (
      // eslint-disable-next-line sonarjs/no-nested-template-literals
      /* @__PURE__ */ jsxs("div", { className: classnames(`${PREFIX}-price__set-of-four`, { [`${PREFIX}-price__staggered-text`]: isStaggered }), children: [
        !isStaggered && currentPriceWithEachLabel(),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classnames(
              `${PREFIX}-price__set-of-four__text`,
              {
                [`${PREFIX}-price__set-of-four__updateLable`]: (updatedFromLabel == null ? void 0 : updatedFromLabel.length) > 0,
                [`${PREFIX}-price__set-of-four__no-margin-text`]: isStaggered
              }
            ),
            children: [
              isWheelOrTire && !showFromNow ? setOfFourLabel : displaySetOfLabel(),
              " ",
              renderSetOfFromPrice(updatedFromLabel, updatedToLabel)
            ]
          }
        )
      ] })
    );
  };
  const renderPriceMessage = () => {
    var _a, _b;
    if (!((_a = priceMessage == null ? void 0 : priceMessage[0]) == null ? void 0 : _a.label)) {
      return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-price__without-message`, "data-testid": "priceTotal" });
    }
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-price__message`, "data-testid": "priceTotal", children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: isMobile2 ? "sm" : "lg" }),
      /* @__PURE__ */ jsx("p", { className: `${PREFIX}-price__message-text`, role: "alert", "aria-atomic": "true", children: (_b = priceMessage == null ? void 0 : priceMessage[0]) == null ? void 0 : _b.label })
    ] });
  };
  const isPromoGivesAdditionalDiscountOnItem = () => {
    return !isMoreQuantityCartPage && isAppliedPromoExist && (currentPrice == null ? void 0 : currentPrice.value) !== (totalPrice == null ? void 0 : totalPrice.value) && (currentPrice == null ? void 0 : currentPrice.value) !== (originalPrice == null ? void 0 : originalPrice.value);
  };
  const isCurrentPriceShown = () => {
    return isMoreQuantityCartPage || isPromoGivesAdditionalDiscountOnItem();
  };
  const renderSaveStory = () => {
    const addCls = overridePriceHeight ? `${PREFIX}-price__save-story--min-height` : "";
    const onSaleCls = isOnSale ? `${PREFIX}-price__save-story-label--bold` : "";
    return !hideSaveLabel && isArrayNotEmpty(priceMessage) && !isStaggered ? priceMessage == null ? void 0 : priceMessage.map((item, index2) => {
      return item.label ? /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-price__save-story ${addCls}`, children: [
        showEachTextForSaveLabel ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-price__save-story-label ${onSaleCls}`, children: item.label }) : null,
        item.tooltip && /* @__PURE__ */ jsx(
          "button",
          {
            ref: saveTooltipButtonRef,
            className: `${PREFIX}-price__eco-fee-tooltip-btn`,
            onClick: (event) => toolTipButtonHandler(event, setSaveTooltipVisibility, saveTooltipVisibility),
            onKeyDown: (event) => toolTipButtonKeyboardHandler(
              event,
              setSaveTooltipVisibility,
              saveTooltipVisibility
            ),
            "data-testid": "eco-fee",
            "aria-label": a11yTooltipIcon,
            children: /* @__PURE__ */ jsx(
              "span",
              {
                className: saveTooltipVisibility ? `${PREFIX}-price__eco-fee-tooltip-btn--active` : "",
                children: /* @__PURE__ */ jsx(Icon, { type: "ct-information", size: "sm" })
              }
            )
          }
        ),
        !!saveTooltipVisibility && /* @__PURE__ */ jsx(
          Tooltip,
          {
            visibility: saveTooltipVisibility,
            setVisibility: setSaveTooltipVisibility,
            iconID: "ct-close",
            headerText: item.label,
            bodyText: item.tooltip,
            coords: saveTooltipButtonRef.current,
            a11yCloseIconLabel,
            isModalPresent
          }
        )
      ] }, `${item.label}-${index2}`) : null;
    }) : null;
  };
  const renderSaveMessage = () => {
    const addCls = overridePriceHeight ? `${PREFIX}-price__save-story--min-height` : "";
    return !hideSaveLabel && !!saveMessage ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-price__save-story ${addCls}`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-price__save-story-label`, children: saveMessage }) }, `${saveMessage}`) : null;
  };
  const renderProductPricing = () => {
    return (
      // eslint-disable-next-line sonar/expression-complexity
      !isStaggeredFront && (isWheelOrTirePDP || isWheelOrTire ? setOfFourTire() : (
        // eslint-disable-next-line sonar/no-nested-conditional
        cartPageOrMoreQuantity ? totalPriceCartComponent() : totalPriceComponent()
      ))
    );
  };
  const renderPrice = () => {
    const priceMargingClass = !isRebate ? `${PREFIX}-price__margin` : "";
    const priceContainerClass = isGenmerchPDP ? `${PREFIX}-price__container ${PREFIX}-row` : "";
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${priceMargingClass} ${PREFIX}-price ${overridePriceHeight ? `${PREFIX}-price--min-height` : ""} ${priceContainerClass}`,
        id: accessibilityPriceId,
        children: [
          renderProductPricing(),
          !isStaggered && feesComponent(),
          isCurrentPriceShown() && renderCurrentPrice(),
          wasPriceComponent(),
          renderSaveMessage(),
          renderSaveStory(),
          isStaggered && feesComponent()
        ]
      }
    );
  };
  return checkInstanceOfPrice(originalPrice, language2) === "" && checkInstanceOfPrice(currentPrice, language2) === "" ? renderPriceMessage() : renderPrice();
};
Price.defaultProps = {
  showEachTextForSaveLabel: true,
  hideSaveLabel: false
};
Price.displayName = "Price";
Price.propTypes = {
  priceStyle: PropTypes.string,
  promotionalPriceLabel: PropTypes.string,
  thresholdValue: PropTypes.number,
  unitPriceLabel: PropTypes.string,
  clearancePriceLabel: PropTypes.string,
  a11yPriceRangeFrom: PropTypes.string,
  a11yPriceRangeTo: PropTypes.string,
  hideSaveLabel: PropTypes.bool,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  a11yTooltipIcon: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string,
  feeTitle: PropTypes.string,
  feeDisclaimerMessage: PropTypes.string,
  feeDisclaimerTitle: PropTypes.string,
  originalPrice: PropTypes.any,
  currentPrice: PropTypes.any,
  priceValue: PropTypes.any,
  displayWasLabel: PropTypes.bool,
  language: PropTypes.string,
  eachLabel: PropTypes.string,
  isMoreQuantityCartPage: PropTypes.bool,
  priceMessage: PropTypes.any,
  isAutomotiveEachLabel: PropTypes.bool,
  a11yRecycleFeesTriangleIcon: PropTypes.string,
  nowFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  feeDisclaimerType: PropTypes.string,
  isWheelOrTirePDP: PropTypes.bool,
  totalCurrentPrice: PropTypes.any,
  totalOriginalPrice: PropTypes.any,
  setOfFourLabel: PropTypes.string,
  setOfFourNowLabel: PropTypes.string,
  isWheelOrTire: PropTypes.bool,
  isStaggered: PropTypes.bool,
  isStaggeredFront: PropTypes.bool,
  showFromNow: PropTypes.bool,
  isRebate: PropTypes.bool,
  isShoppingCartPage: PropTypes.bool,
  showEachTextForSaveLabel: PropTypes.bool,
  overridePriceHeight: PropTypes.bool,
  isAppliedPromoExist: PropTypes.bool,
  enablePdpPricingEnhancement: PropTypes.bool,
  accessibilityPriceId: PropTypes.string
};
const getTextInputClassNames = (error, isFocused, isErrorFocus, componentClassName2, disabled, success, reqFieldsFilled) => {
  const errorClass = error ? `${componentClassName2}__container--error` : "";
  const focusClass = isFocused || success ? `${componentClassName2}__container--focus` : "";
  const disabledClass = disabled ? `${componentClassName2}__container--disabled` : "";
  let errorFocusClass = `${errorClass} ${focusClass} ${disabledClass} ${reqFieldsFilled}`;
  if (isErrorFocus) {
    if (error) {
      errorFocusClass = errorClass;
    } else if (isFocused) {
      errorFocusClass = focusClass;
    } else if (disabled) {
      errorFocusClass = disabledClass;
    } else if (reqFieldsFilled) {
      errorFocusClass = reqFieldsFilled;
    }
  }
  return errorFocusClass;
};
const TextInput = (props) => {
  const {
    id,
    label,
    disabled,
    assistiveText,
    isAssistiveTextAlwaysVisible,
    icon,
    error,
    success,
    successMessage,
    size,
    placeholder,
    path,
    value,
    onChange,
    errorIcon,
    successIcon,
    displaySuccessIcon,
    maxLength,
    type,
    onBlur,
    onFocus,
    onKeyDown,
    customOnChange,
    isErrorFocus,
    ariaRequired,
    quantumMetricAttribute,
    autoComplete,
    tabIndex,
    inputMode,
    pattern,
    textInputRef,
    a11yRequiredLabel,
    isAllReqFieldFilled,
    noTextError,
    ariaDescribedBy,
    ariaLabelledBy,
    isErrorForSrOnly,
    onPaste,
    children
  } = props;
  const [isFocused, setIsFocused] = useState(false);
  const componentClassName2 = `${PREFIX}-textinput`;
  const quantumMetricDataAttribute = (quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type) ? { [`data-qm-${quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type}`]: quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.value } : {};
  const reqFieldsFilled = isAllReqFieldFilled ? `${componentClassName2}__container--req` : "";
  const errorFocusClass = getTextInputClassNames(
    error,
    isFocused,
    isErrorFocus,
    componentClassName2,
    disabled,
    success,
    reqFieldsFilled
  );
  const onBlurEvent = (ev) => {
    setIsFocused(false);
    onBlur && onBlur(ev);
  };
  const onFocusEvent = (ev) => {
    setIsFocused(true);
    onFocus && onFocus(ev);
  };
  const onChangeEvent = (event) => {
    customOnChange ? onChange(event) : onChange(event.target.value);
  };
  const returnAccessibilityFieldErrorClass = () => error ? `${PREFIX}-accessibility-field--error` : "";
  const renderInputContainer = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__input-container`, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          id,
          "data-testid": id,
          ...quantumMetricDataAttribute,
          type: type || "text",
          className: `${componentClassName2}__input ${returnAccessibilityFieldErrorClass()} ${value ? "" : `${PREFIX}-accessibility-field-empty-class--error`}`,
          autoComplete,
          disabled,
          placeholder,
          value,
          onChange: onChangeEvent,
          onFocus: (event) => onFocusEvent(event),
          onBlur: (event) => onBlurEvent(event),
          maxLength,
          onKeyDown: (val) => onKeyDown ? onKeyDown(val) : null,
          "aria-required": ariaRequired,
          tabIndex,
          "aria-labelledby": `${id}_id ${ariaLabelledBy ? ariaLabelledBy : ""}`,
          "aria-describedby": `${id}_textError ${ariaDescribedBy ? ariaDescribedBy : ""}`,
          inputMode,
          pattern,
          ref: textInputRef,
          onPaste
        }
      ),
      /* @__PURE__ */ jsxs("label", { id: `${id}_id`, className: `${componentClassName2}__label`, htmlFor: id, children: [
        label,
        " ",
        a11yRequiredLabel
      ] }),
      children
    ] });
  };
  const renderErrorField = () => {
    return error && !noTextError && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__msg ${isErrorForSrOnly ? "sr-only" : ""}`, role: "alert", children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, { type: errorIcon, size: "sm", path }) }),
      /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__msg-text`, id: `${id}_textError`, children: error })
    ] });
  };
  const renderSuccessField = () => {
    return success && successMessage && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__msg`, role: "alert", children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm", path }) }),
      /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__msg-text`, children: successMessage })
    ] });
  };
  const stateClass = error ? `${componentClassName2}--error` : success ? `${componentClassName2}--success` : "";
  const isRenderAssistiveText = () => isAssistiveTextAlwaysVisible || !error && assistiveText;
  return /* @__PURE__ */ jsxs("div", { className: `${componentClassName2} ${componentClassName2}--${size} ${stateClass}`, children: [
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__container ${errorFocusClass}`, "data-testid": "input-container", children: [
      renderInputContainer(),
      icon && /* @__PURE__ */ jsx("button", { className: `${componentClassName2}__icon`, "aria-label": "textinput-icon", children: /* @__PURE__ */ jsx(Icon, { type: icon, size: "md", path }) })
    ] }),
    isRenderAssistiveText() && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__assistive-text`, children: [
      displaySuccessIcon && /* @__PURE__ */ jsx(Icon, { type: successIcon, size: "sm", path }),
      assistiveText
    ] }),
    renderErrorField(),
    renderSuccessField()
  ] });
};
TextInput.defaultProps = {
  disabled: false,
  size: "default",
  placeholder: " ",
  errorIcon: "ct-input-error",
  successIcon: "ct-checkmark",
  displaySuccessIcon: false
};
TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  assistiveText: PropTypes.string,
  icon: PropTypes.string,
  error: PropTypes.string,
  success: PropTypes.bool,
  successMessage: PropTypes.string,
  size: PropTypes.oneOf(["mini", "small", "medium", "large", "default"]),
  placeholder: PropTypes.string,
  path: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errorIcon: PropTypes.string,
  successIcon: PropTypes.string,
  displaySuccessIcon: PropTypes.bool,
  maxLength: PropTypes.number,
  type: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  customOnChange: PropTypes.bool,
  isErrorFocus: PropTypes.bool,
  ariaRequired: PropTypes.bool,
  inputMode: PropTypes.oneOf(["search", "text", "email", "tel", "url", "none", "numeric", "decimal"]),
  pattern: PropTypes.string,
  noTextError: PropTypes.bool,
  ariaDescribedBy: PropTypes.string
};
const Switch = (props) => {
  const { checked, label, icon, path, handleInputChange, mainClass } = props;
  const [switchState, setSwitchState] = useState(false);
  useEffect(() => {
    setSwitchState(checked);
  }, [checked]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: mainClass, children: /* @__PURE__ */ jsxs(
      "button",
      {
        className: `${PREFIX}-switch ${PREFIX}-switch-${checked ? "on" : "off"}`,
        type: "button",
        "data-testid": "toggle-switch",
        role: "switch",
        "aria-checked": switchState,
        onClick: () => {
          setSwitchState((previousState) => !previousState);
          handleInputChange();
        },
        children: [
          /* @__PURE__ */ jsx("span", { children: label }),
          /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-switch__slider`, children: [
            /* @__PURE__ */ jsx("span", { className: `${PREFIX}-switch__slider-focus` }),
            checked && /* @__PURE__ */ jsx(Icon, { size: "xs", type: "ct-checkmark", path })
          ] })
        ]
      }
    ) }),
    icon && /* @__PURE__ */ jsx(Icon, { type: icon, size: "sm", path })
  ] });
};
Switch.defaultProps = {
  label: "",
  icon: "",
  mainClass: ""
};
Switch.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.string,
  path: PropTypes.string,
  handleInputChange: PropTypes.func,
  mainClass: PropTypes.string
};
const Tag = ({ ...props }) => {
  const tagClass = `${PREFIX}-tag`;
  const type = props.type ? `${tagClass}--${props.type}` : "";
  const subType = props.subType ? `${tagClass}--${props.subType}` : "";
  const tagSizeModifier = props.isLarge ? `${tagClass}--large` : "";
  const badgeUrl = props.badgeUrl;
  const isClickable = typeof badgeUrl !== "undefined" && badgeUrl !== null;
  const tagClickableModifier = isClickable ? `${tagClass}--clickable` : "";
  const anchorTag = () => {
    return /* @__PURE__ */ jsx(
      "a",
      {
        href: `${badgeUrl}`,
        target: "_blank",
        rel: "noreferrer",
        "data-link-value": props.analyticsLabelValue,
        className: `${tagClass} ${type} ${subType} ${tagSizeModifier} ${tagClickableModifier}`,
        children: props.withBorder ? /* @__PURE__ */ jsx("span", { className: `${tagClass}__inner-border`, "data-testid": "tagWithBorder", children: props.children }) : props.children
      }
    );
  };
  const spanTag = () => {
    return /* @__PURE__ */ jsx("span", { className: `${tagClass} ${type} ${subType} ${tagSizeModifier} `, children: props.withBorder ? /* @__PURE__ */ jsx("span", { className: `${tagClass}__inner-border`, "data-testid": "tagWithBorder", children: props.children }) : props.children });
  };
  return isClickable ? anchorTag() : spanTag();
};
Tag.propTypes = {
  type: PropTypes.oneOf(["product", "availability-bullet", "search-input"]),
  subType: PropTypes.string,
  withBorder: PropTypes.bool,
  isLarge: PropTypes.bool,
  children: PropTypes.node,
  badgeUrl: PropTypes.string
};
const getHeader = (tableData) => {
  const [firstRow] = tableData;
  const keys = Object.keys(firstRow);
  return keys.map((key) => {
    return /* @__PURE__ */ jsx("th", { children: key }, key);
  });
};
const getCell = (rowData) => {
  return Object.keys(rowData).map((key) => {
    const content = rowData[key];
    return /* @__PURE__ */ jsx("td", { children: content }, key);
  });
};
const getArray = (rowData, colspan) => {
  return rowData.map((key) => {
    const data = key;
    if (data == null ? void 0 : data.a11Hidden) {
      return /* @__PURE__ */ jsxs("td", { children: [
        /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: data.label }),
        /* @__PURE__ */ jsx("span", { className: "sr-only", children: replaceStrWithDynamicVal(data.a11Label, data.label) })
      ] }, data.label);
    }
    return /* @__PURE__ */ jsx("td", { colSpan: colspan, children: key }, key);
  });
};
const getRowsData = (tableData, headerType, tableRichText) => {
  return tableData.map((row, index2) => {
    if (headerType.toUpperCase() === "COLUMN") {
      const columnKey = Object.keys(row);
      const columnKeyString = columnKey.toString();
      const tableHeader = tableRichText ? /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: columnKeyString, children: (memoizedStringContent) => /* @__PURE__ */ jsx("th", { dangerouslySetInnerHTML: { __html: memoizedStringContent } }) }) : /* @__PURE__ */ jsxs("th", { children: [
        " ",
        columnKey,
        " "
      ] });
      return /* @__PURE__ */ jsxs("tr", { className: index2 === magicNumber.ZERO ? "first-row" : "", children: [
        tableHeader,
        getArray(row[columnKey[0]], row == null ? void 0 : row.colspan)
      ] }, index2);
    } else {
      return /* @__PURE__ */ jsx("tr", { children: getCell(row) }, index2);
    }
  });
};
const Table = ({ ...props }) => {
  const { tableType, tableData, headerType, tableRichText, ariaLabel, tableModifierClass = "", tableId } = props;
  const tableClass = `${PREFIX}-table`;
  const type = tableType && `${PREFIX}-table--${tableType}`;
  return /* @__PURE__ */ jsxs("table", { className: `${tableClass} ${type} ${tableModifierClass}`, "aria-label": ariaLabel, id: tableId, children: [
    /* @__PURE__ */ jsx("thead", { children: headerType.toUpperCase() === "ROW" && /* @__PURE__ */ jsx("tr", { children: getHeader(tableData) }) }),
    /* @__PURE__ */ jsx("tbody", { children: getRowsData(tableData, headerType, tableRichText) })
  ] });
};
Table.defaultProps = {
  tableType: "bordered",
  headerType: "row"
};
Table.propTypes = {
  tableType: PropTypes.string,
  tableRichText: PropTypes.bool,
  tableData: PropTypes.any,
  headerType: PropTypes.oneOf(["row", "column"]),
  ariaLabel: PropTypes.string,
  tableModifierClass: PropTypes.string,
  tableId: PropTypes.string
};
Table.displayName = "TableInLib";
const Modal = ({ ...props }) => {
  const headerTitle = props.modalHeaderTitle ? props.modalHeaderTitle : "";
  const title = props.modalTitle ? props.modalTitle : headerTitle;
  const titleClass = props.modalTitle ? `${PREFIX}-modal__header ${PREFIX}-modal__cta-header` : `${PREFIX}-modal__header`;
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-modal`, children: [
    /* @__PURE__ */ jsx("button", { className: `${PREFIX}-modal__close`, "aria-label": "Close Modal", children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "md", path: props.path }) }),
    title && /* @__PURE__ */ jsx("h4", { className: `${titleClass}`, children: title }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-modal__body`, children: [
      /* @__PURE__ */ jsx("p", { className: `${PREFIX}-modal__sub-header`, children: props.subTitle }),
      /* @__PURE__ */ jsx("p", { className: `${PREFIX}-modal__description`, children: props.description })
    ] }),
    props.cta && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-modal__footer`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-modal__cta-btn`, children: /* @__PURE__ */ jsx(Button, { type: "primary", size: "small", children: props.btnText }) }),
      /* @__PURE__ */ jsx("a", { href: "/", className: `${PREFIX}-modal__link`, "data-link-value": props.linkText, children: props.linkText })
    ] })
  ] });
};
Modal.propTypes = {
  modalHeaderTitle: PropTypes.string,
  modalTitle: PropTypes.string,
  path: PropTypes.string,
  subTitle: PropTypes.string,
  description: PropTypes.string,
  btnText: PropTypes.string,
  cta: PropTypes.string,
  linkText: PropTypes.string
};
const Accordion = ({ ...props }) => {
  const {
    children,
    path,
    isHeaderOpen,
    isHeaderHidden,
    title,
    hideControls,
    collapseControl: collapseControl2,
    disableOnClick = false,
    collapseLabel,
    expandLabel,
    subtitle,
    id,
    collapsedText,
    showSubtitle,
    collapseAccordion,
    setCollapseAccordion,
    isChevronIcon = false,
    ariaLabel
  } = props;
  const [isOpen, setIsOpen] = useState(isHeaderOpen);
  const hideIcons = hideControls ? hideControls : false;
  const displaySubtitle = showSubtitle || Boolean(!isOpen && subtitle);
  useEffect(() => {
    setIsOpen(isHeaderOpen);
    if (collapseAccordion) {
      setIsOpen(false);
      setCollapseAccordion(false);
    }
  }, [isHeaderOpen, collapseAccordion, setCollapseAccordion]);
  const onAccordionClick = () => {
    if (!disableOnClick) {
      setIsOpen(!isOpen);
    }
    if (collapseControl2) {
      collapseControl2(!isOpen);
    }
  };
  const iconType = () => {
    if (isChevronIcon) {
      return isOpen ? "ct-chevron-up" : "ct-chevron-down";
    }
    return isOpen ? "ct-subtract" : "ct-plus";
  };
  const renderAccordionButton = () => {
    const buttonStateClass = isOpen ? `${PREFIX}-accordion__button--expanded` : "";
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
      "button",
      {
        "aria-label": ariaLabel,
        id,
        className: `${PREFIX}-accordion__button ${buttonStateClass}`,
        "data-testid": "accordion-button",
        type: "button",
        "data-qm-allow": "true",
        "aria-expanded": isOpen,
        onClick: onAccordionClick,
        disabled: disableOnClick,
        children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: `${PREFIX}-accordion__title ${displaySubtitle ? `${PREFIX}-xs-col-row ${PREFIX}-xs-align-items-start` : ""}`,
              children: [
                title,
                displaySubtitle && /* @__PURE__ */ jsx("p", { className: `${PREFIX}-accordion__title--stacked`, children: subtitle })
              ]
            }
          ),
          !hideIcons && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-accordion__icon`, "aria-label": isOpen ? expandLabel : collapseLabel, children: /* @__PURE__ */ jsx(Icon, { type: iconType(), size: "lg", path }) })
        ]
      }
    ) });
  };
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-accordion`, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-accordion__item ${isOpen ? `${PREFIX}-accordion--expanded` : `${PREFIX}-accordion--minimize`}
                `,
      children: [
        !isHeaderHidden && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-accordion__header`, children: renderAccordionButton() }),
        !isOpen && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-accordion__collapsedText`, children: collapsedText }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `${PREFIX}-accordion__panel ${isOpen ? `${PREFIX}-accordion__panel--show` : `${PREFIX}-accordion__panel--hidden`}`,
            role: "region",
            children
          }
        )
      ]
    }
  ) });
};
Accordion.propTypes = {
  children: PropTypes.element,
  path: PropTypes.string,
  isHeaderOpen: PropTypes.bool,
  title: PropTypes.string.isRequired,
  collapseControl: PropTypes.any,
  hideControls: PropTypes.bool,
  isHeaderHidden: PropTypes.bool,
  disableOnClick: PropTypes.bool,
  collapseLabel: PropTypes.string,
  expandLabel: PropTypes.string,
  collapseAccordion: PropTypes.bool
};
const Resources = ({
  heading,
  resourceBody,
  defaultState = false,
  isPrerender
}) => {
  function renderResourceBody() {
    return /* @__PURE__ */ jsx(Fragment, { children: resourceBody.map((value, index2) => {
      return value.description && /* @__PURE__ */ jsx(
        "div",
        {
          className: ` ${PREFIX}-pr-sm ${PREFIX}-col-sm-6 ${PREFIX}-col-md-3 ${PREFIX}-col-lg-3 ${PREFIX}-col-xs-6 ${PREFIX}-resources__container`,
          children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-resources__body`, children: [
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-resources__icon`, children: /* @__PURE__ */ jsx(Icon, { type: value.iconId }) }),
            /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-resources__details`, children: [
              /* @__PURE__ */ jsx("h3", { className: `${PREFIX}-resources__label`, children: value.iconLabel }),
              /* @__PURE__ */ jsx("p", { className: `${PREFIX}-resources__text`, children: value.description }),
              renderResourceLinks(value)
            ] })
          ] })
        },
        `${value.iconId}${value.iconLabel}${index2}`
      );
    }) });
  }
  function renderResourceLinks(resourceObj) {
    return /* @__PURE__ */ jsx(Fragment, { children: isArrayNotEmpty(resourceObj.linkPlaceholder) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-resources__links`, children: resourceObj.linkPlaceholder.map((link, index2) => {
      const isDownloadReq = !((link == null ? void 0 : link.linkURL) && (link == null ? void 0 : link.linkURL.includes(".html")));
      return (link == null ? void 0 : link.linkURL) && /* @__PURE__ */ jsx(
        "a",
        {
          className: `${PREFIX}-resources__link ${PREFIX}-pb-base`,
          href: `${link.linkURL}`,
          target: link.openTarget,
          "data-link-value": link.link,
          download: !!isDownloadReq,
          children: link.link
        },
        `${link.linkURL}${index2}`
      );
    }) }) });
  }
  const [isMobile2, setIsMobile] = useState(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  };
  useGlobalResizeEvent(handleResize);
  const renderResources = () => {
    const prerenderClass = isPrerender ? `${PREFIX}-md-none` : "";
    return isMobile2 ? /* @__PURE__ */ jsx("div", { id: "resources", className: `${PREFIX}-resources ${PREFIX}-section`, children: /* @__PURE__ */ jsx(Accordion, { title: heading, isHeaderOpen: defaultState, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row`, children: isArrayNotEmpty(resourceBody) && renderResourceBody() }) }) }) : /* @__PURE__ */ jsx("div", { id: "resources", className: `${PREFIX}-resources ${PREFIX}-section ${prerenderClass}`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row`, children: isArrayNotEmpty(resourceBody) && renderResourceBody() }) });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: renderResources() });
};
Resources.propTypes = {
  heading: PropTypes.string.isRequired,
  resourceBody: PropTypes.array.isRequired,
  defaultState: PropTypes.bool,
  isPrerender: PropTypes.bool
};
const compareTwoArrays = (source, target) => {
  return target.every((v) => source.includes(v));
};
const getSkuArray = (variantIds, options) => {
  let getSkuArr = [];
  let isInitialSetDone;
  const intersect = (arr1 = [], arr2 = []) => arr1.filter((n) => ~arr2.indexOf(n));
  variantIds && variantIds.forEach((variantid) => {
    options.forEach((option) => {
      option.values.forEach((value) => {
        if (value.id === variantid) {
          if (isInitialSetDone) {
            getSkuArr = intersect(getSkuArr, value.skuCodes);
          } else {
            getSkuArr.push(...value.skuCodes);
            isInitialSetDone = true;
          }
        }
      });
    });
  });
  return getSkuArr;
};
const variantsConstant$1 = {
  timeoutValue: 1e3,
  maxHeight: 212,
  variantLabel: "Variant",
  firstVariantName: "firstVariant",
  secondVariantName: "secondVariant",
  thirdVariantName: "thirdVariant",
  hideVariantClass: "hide",
  showVariantClass: "show",
  colorCodeParam: "colorCode",
  SIZE: "SIZE"
};
const COLOR = "COLOUR";
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
const getInteractiveElements = (node) => {
  return node.querySelectorAll('button, [href], input, [data-accessibility="true"], [role="tab"]');
};
const getNextInteractiveElement = (currentIndex, list) => {
  const lastIndex = list.length - magicNumber.ONE;
  return currentIndex === lastIndex ? list[magicNumber.ZERO] : list[currentIndex + magicNumber.ONE];
};
const getPreviousInteractiveElement = (currentIndex, list) => {
  const lastIndex = list.length - magicNumber.ONE;
  return currentIndex === magicNumber.ZERO ? list[lastIndex] : list[currentIndex - magicNumber.ONE];
};
const selectionTypeChecked = "checked";
const arrowActionIdentifier$1 = {
  NEXT: "next",
  PREVIOUS: "previous"
};
const resetTabindex = (list) => {
  list.forEach((item) => {
    item.setAttribute("tabindex", "-1");
  });
};
const resetAriaSelected = (list) => {
  list.forEach((item) => {
    item.setAttribute("aria-selected", "false");
  });
};
const resetAriaChecked = (list) => {
  list.forEach((item) => {
    item.setAttribute("aria-checked", "false");
  });
};
const isSelectionTypeChecked = (selectionType) => {
  return selectionType === selectionTypeChecked;
};
const handleArrowsAccessibility = (event, action, currentIndex, listNode) => {
  event.preventDefault();
  event.stopPropagation();
  const list = getInteractiveElements(listNode);
  resetTabindex(list);
  let interactiveElement;
  if (action === arrowActionIdentifier$1.NEXT) {
    interactiveElement = getNextInteractiveElement(currentIndex, list);
  }
  if (action === arrowActionIdentifier$1.PREVIOUS) {
    interactiveElement = getPreviousInteractiveElement(currentIndex, list);
  }
  interactiveElement == null ? void 0 : interactiveElement.setAttribute("tabindex", "0");
  interactiveElement == null ? void 0 : interactiveElement.focus();
};
const handleClickOrEnterAccessibility = (event, currentIndex, listNode, selectionType) => {
  event.preventDefault();
  event.stopPropagation();
  const list = getInteractiveElements(listNode);
  resetTabindex(list);
  isSelectionTypeChecked(selectionType) ? resetAriaChecked(list) : resetAriaSelected(list);
  list[currentIndex].setAttribute("tabindex", "0");
  list[currentIndex].setAttribute(
    `${isSelectionTypeChecked(selectionType) ? "aria-checked" : "aria-selected"}`,
    "true"
  );
};
const outsideActionHandler = (listNode, selectionType) => {
  var _a;
  const list = getInteractiveElements(listNode);
  resetTabindex(list);
  const selectedItem = listNode == null ? void 0 : listNode.querySelector(
    isSelectionTypeChecked(selectionType) ? '[aria-checked="true"]' : '[aria-selected="true"]'
  );
  selectedItem ? selectedItem.setAttribute("tabindex", "0") : (_a = list[magicNumber.ZERO]) == null ? void 0 : _a.setAttribute("tabindex", "0");
};
const useOnKeyDownOutside = (ref, handler, parentRef) => {
  useEffect(() => {
    const parentRefNode = (parentRef == null ? void 0 : parentRef.current) || document;
    const listener = (event) => {
      var _a;
      if (!(ref == null ? void 0 : ref.current) || ((_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.contains(event.target))) {
        return;
      }
      handler(event);
    };
    parentRefNode.addEventListener("keydown", listener);
    return () => parentRefNode.removeEventListener("keydown", listener);
  }, [ref, handler, parentRef]);
};
const {
  maxHeight: maxHeight$1,
  variantLabel,
  firstVariantName,
  secondVariantName,
  thirdVariantName,
  hideVariantClass,
  showVariantClass,
  colorCodeParam
} = variantsConstant$1;
const listItems = (variantsData, variantData, setSelectedFirstVariantValue, firstVariantStyleItem, setSelectedFirstVariantIdValue, setSelectedSecondVariantValue, setSelectedSecondVariantIdValue, setSelectedThirdVariantValue, setSelectedThirdVariantIdValue, variantKey, variantValue, variantId, isAddToCartClicked, isNoSkuFindStoreClicked, variantRef, setIsFirstVariantClicked, variantClickHandler, isColourSwatchesActive, variantsProductSkuData, checkOutOfStock, enableHidingFirstVariantWhereAllSkusOOS, selectedProductCode, isAutomotive, inStockLabel, outOfStockLabel, a11yVariantsSelectedCount, areAllVariantsSelected, variantsListRef, enableOnlyAvailableOnline, availableOnlinePurchaseLabel, onlyAvailableOnlineAtLabel, preferredStoreDetails, noUrlUpdates, limitedStockMessage, isLimitedStock, setSelectedVariantByUserClick) => {
  const setVariant = (selectedItem) => {
    variantClickHandler();
    setSelectedVariantByUserClick && setSelectedVariantByUserClick(true);
    if (!firstVariantStyleItem) {
      switch (variantKey) {
        case firstVariantName:
          setSelectedFirstVariantValue(selectedItem.name, selectedItem.displayNameForVariants);
          setSelectedFirstVariantIdValue(selectedItem.id);
          setIsFirstVariantClicked(true);
          setSelectedColorCodeToUrl(selectedItem.id);
          break;
        case secondVariantName:
          setSelectedSecondVariantValue(selectedItem.name);
          setSelectedSecondVariantIdValue(selectedItem.id);
          setIsFirstVariantClicked(false);
          break;
        default:
          setSelectedThirdVariantValue(selectedItem.name);
          setSelectedThirdVariantIdValue(selectedItem.id);
          setIsFirstVariantClicked(false);
      }
    }
  };
  const setSelectedColorCodeToUrl = (selectedColor) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (!noUrlUpdates) {
      urlSearchParams.set(colorCodeParam, selectedColor);
      updateUrlHistory(`?${decodeURIComponent(urlSearchParams.toString())}`);
    }
  };
  const getVariantClass = (isUnavailableVariant) => {
    if (isUnavailableVariant) {
      if (variantRef === magicNumber.ONE && variantKey === firstVariantName) {
        return showVariantClass;
      } else {
        return hideVariantClass;
      }
    } else {
      return showVariantClass;
    }
  };
  const isPillsSelected = (item) => {
    var _a;
    return isAutomotive ? (_a = item == null ? void 0 : item.skuCodes) == null ? void 0 : _a.includes(selectedProductCode) : (item == null ? void 0 : item.id) === variantId;
  };
  const isWarningVariant = Boolean((isAddToCartClicked || isNoSkuFindStoreClicked) && !variantValue);
  const getVariantAssignedClass = (item) => {
    const isColorSwathesStylesNeeded = isColourSwatchesActive && !!item.colourSwatchImageUrl;
    const colourSwathesClass = isColorSwathesStylesNeeded ? `${PREFIX}-variants__variant--colour-swatches` : "";
    const outOfStockClass = item.isUnavailableDueToStock || (variantsProductSkuData == null ? void 0 : variantsProductSkuData.skus) && checkOutOfStock(item, variantKey) ? `${PREFIX}-variants__disabled` : "";
    const defaultClass = `${firstVariantStyleItem ? firstVariantStyleItem : `${PREFIX}-variants__variant ${colourSwathesClass}`} ${outOfStockClass}`;
    const warningClass = isWarningVariant ? `${PREFIX}-variants__variant--warning` : "";
    return isPillsSelected(item) ? `${defaultClass} ${PREFIX}-variants__variant--selected` : `${defaultClass} ${PREFIX}-variants__variant--unselected ${warningClass}`;
  };
  const getAriaLabel = (variantObj) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
    const variantsSelectedCount = a11yVariantsSelectedCount;
    const variantsLength = variantKey === firstVariantName ? variantData == null ? void 0 : variantData.length : variantData == null ? void 0 : variantData.filter((variantInfo) => !variantInfo.isUnavailable).length;
    const inStockValue = (_d = (_c = (_b = (_a = variantsProductSkuData == null ? void 0 : variantsProductSkuData.skus) == null ? void 0 : _a.find((variant) => variant.code === selectedProductCode)) == null ? void 0 : _b.fulfillment) == null ? void 0 : _c.availability) == null ? void 0 : _d.quantity;
    const storeShelfLoc = (_h = (_g = (_f = (_e = variantsProductSkuData == null ? void 0 : variantsProductSkuData.skus) == null ? void 0 : _e.find((variant) => variant.code === selectedProductCode)) == null ? void 0 : _f.fulfillment) == null ? void 0 : _g.availability) == null ? void 0 : _h.storeShelfLocation;
    const getStoreShelfLoc = typeof storeShelfLoc === "string" ? `- ${storeShelfLoc}` : "";
    const corporateQuantityValue = (_m = (_l = (_k = (_j = (_i = variantsProductSkuData == null ? void 0 : variantsProductSkuData.skus) == null ? void 0 : _i.find(
      (variant) => variant.code === selectedProductCode
    )) == null ? void 0 : _j.fulfillment) == null ? void 0 : _k.availability) == null ? void 0 : _l.Corporate) == null ? void 0 : _m.Quantity;
    const quantityValue = (
      // eslint-disable-next-line sonar/expression-complexity
      inStockValue > magicNumber.ZERO ? (
        // eslint-disable-next-line sonar/no-nested-conditional
        isLimitedStock ? ` ${replaceStrWithDynamicVal(limitedStockMessage, inStockValue)} ${getStoreShelfLoc}` : ` ${inStockValue} ${inStockLabel} ${getStoreShelfLoc}`
      ) : (
        // eslint-disable-next-line sonar/no-nested-conditional
        corporateQuantityValue > magicNumber.ZERO ? (
          // eslint-disable-next-line sonar/no-nested-conditional
          enableOnlyAvailableOnline ? ` ${onlyAvailableOnlineAtLabel} ${preferredStoreDetails} ` : availableOnlinePurchaseLabel
        ) : ` ${outOfStockLabel}`
      )
    );
    const quantityMsg = checkOutOfStock(variantObj, variantKey) ? `${outOfStockLabel}` : `${inStockLabel}`;
    return isVariantSelected(variantObj) ? (
      // eslint-disable-next-line sonar/no-nested-conditional
      areAllVariantsSelected ? `${variantsData == null ? void 0 : variantsData.display}: ${variantObj == null ? void 0 : variantObj.name} ${replaceStrWithDynamicVal(
        variantsSelectedCount,
        variantsLength
      )}`.concat(quantityValue) : `${variantsData == null ? void 0 : variantsData.display}: ${variantObj == null ? void 0 : variantObj.name} ${replaceStrWithDynamicVal(
        variantsSelectedCount,
        variantsLength
      )}`
    ) : `${variantObj == null ? void 0 : variantObj.name} `.concat(quantityMsg);
  };
  const handleClickOrEnter = (event, currentIndex, variant) => {
    handleClickOrEnterAccessibility(event, currentIndex, variantsListRef.current, selectionTypeChecked);
    setVariant(variant);
  };
  const handleKeyDown = (event, currentIndex, variant) => {
    if (event.key === stringKeyCodes.rightArrow) {
      handleArrowsAccessibility(event, arrowActionIdentifier$1.NEXT, currentIndex, variantsListRef.current);
    } else if (event.key === stringKeyCodes.leftArrow) {
      handleArrowsAccessibility(event, arrowActionIdentifier$1.PREVIOUS, currentIndex, variantsListRef.current);
    } else if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.space) {
      handleClickOrEnter(event, currentIndex, variant);
    }
  };
  const returnColorVariantImage = (isColorSwathesStylesNeeded, variantObj) => {
    return isColorSwathesStylesNeeded ? /* @__PURE__ */ jsx("img", { src: variantObj.colourSwatchImageUrl, alt: variantObj.name }) : null;
  };
  const returnColorVariantSpan = (isColorSwathesStylesNeeded, variantObj) => {
    return isColorSwathesStylesNeeded ? null : /* @__PURE__ */ jsx("span", { className: `${PREFIX}-variants__variant-text`, children: isAutomotive ? variantObj.displayNameForVariants : variantObj.name });
  };
  const isFirstVariantOOS = (variantObj) => areAllParamsValid(
    secondVariantName in variantObj,
    checkOutOfStock(variantObj, variantKey),
    enableHidingFirstVariantWhereAllSkusOOS
  );
  const isVariantSelected = (variantObj) => (variantObj == null ? void 0 : variantObj.id) === variantId;
  const filteredVariantData = variantData.filter((variantObj) => {
    if (isFirstVariantOOS(variantObj) && !isVariantSelected(variantObj)) {
      return false;
    }
    return getVariantClass(variantObj.isUnavailable) === "show";
  });
  return isArrayNotEmpty(variantData) && variantData.map((variantObj, index2) => {
    const currentIndex = filteredVariantData.indexOf(variantObj);
    const isColorSwathesStylesNeeded = isColourSwatchesActive && !!variantObj.colourSwatchImageUrl;
    const disabledColourSwathes = () => isColorSwathesStylesNeeded && checkOutOfStock(variantObj, variantKey);
    if (isFirstVariantOOS(variantObj)) {
      if (!isVariantSelected(variantObj)) {
        return null;
      }
      const firstAvailableVariant = variantData == null ? void 0 : variantData.find(
        (variant) => !checkOutOfStock(variant, variantKey)
      );
      setSelectedFirstVariantValue(firstAvailableVariant == null ? void 0 : firstAvailableVariant.name, firstAvailableVariant == null ? void 0 : firstAvailableVariant.displayNameForVariants);
      setSelectedFirstVariantIdValue(firstAvailableVariant == null ? void 0 : firstAvailableVariant.id);
    }
    return /* @__PURE__ */ jsxs(
      "li",
      {
        className: firstVariantStyleItem ? `${PREFIX}-variants__color-list--list` : `${PREFIX}-variants__variant-item ${getVariantClass(variantObj.isUnavailable)}`,
        role: "presentation",
        children: [
          disabledColourSwathes() && /* @__PURE__ */ jsx("div", { className: "colour-swathes--disable" }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: getVariantAssignedClass(variantObj),
              "aria-label": getAriaLabel(variantObj),
              "data-testid": `${variantLabel}${index2}`,
              "data-accessibility": currentIndex > magicNumber.MINUS_ONE ? "true" : "false",
              role: currentIndex > magicNumber.MINUS_ONE ? "radio" : "",
              "aria-checked": isPillsSelected(variantObj) ? "true" : "false",
              onKeyDown: (event) => {
                handleKeyDown(event, currentIndex, variantObj);
              },
              onClick: (event) => {
                handleClickOrEnter(event, currentIndex, variantObj);
              },
              children: [
                returnColorVariantImage(isColorSwathesStylesNeeded, variantObj),
                firstVariantStyleItem && /* @__PURE__ */ jsx(
                  "img",
                  {
                    className: `${PREFIX}-variants__variant-image`,
                    alt: "ColourVariant",
                    src: variantObj.name
                  }
                ),
                returnColorVariantSpan(isColorSwathesStylesNeeded, variantObj)
              ]
            }
          )
        ]
      },
      index2
    );
  });
};
const Variants = (props) => {
  const {
    areAllVariantsSelected,
    variantsData,
    selectedFirstVariant,
    selectedFirstVariantDisplayName,
    setSelectedFirstVariantValue,
    firstVariantStyle,
    firstVariantStyleItem,
    setSelectedFirstVariantIdValue,
    selectedFirstVariantId,
    selectedSecondVariantId,
    selectedThirdVariantId,
    variantOptions,
    path,
    viewMoreLabel,
    viewLessLabel,
    setSelectedSecondVariantValue,
    setSelectedSecondVariantIdValue,
    setSelectedThirdVariantValue,
    setSelectedThirdVariantIdValue,
    setIsVariantSelected,
    variantKey,
    variantDetails,
    selectedSecondVariant,
    selectedThirdVariant,
    isAddToCartClicked,
    isNoSkuFindStoreClicked,
    isFirstVariantClicked,
    setIsFirstVariantClicked,
    variantClickHandler,
    isColourSwatchesActive,
    setShowSizeChart,
    showSizeChart,
    isSizeChartAvailable,
    sizeChartButtonTitle,
    isOnlyOneVariant,
    variantsProductSkuData,
    checkOutOfStock,
    enableHidingFirstVariantWhereAllSkusOOS,
    selectedProductCode,
    isAutomotive,
    a11yVariantsSelectedCount,
    inStockLabel,
    outOfStockLabel,
    enableOnlyAvailableOnline,
    availableOnlinePurchaseLabel,
    onlyAvailableOnlineAtLabel,
    preferredStoreDetails,
    limitedStockMessage,
    noUrlUpdates,
    isLimitedStock,
    setSelectedVariantByUserClick
  } = props;
  const [showViewMore, setShowViewMore] = useState(false);
  const [showViewMoreOrLess, setShowViewMoreOrLess] = useState(true);
  const variantData = useRef(variantsData == null ? void 0 : variantsData.values);
  const variantValue = useRef("");
  const variantDisplayName = useRef("");
  const variantId = useRef("");
  const variantsListRef = useRef(null);
  const viewMoreVariantClass = !showViewMore ? `${PREFIX}-variants__variant-list--expanded` : `${PREFIX}-variants__variant-list--collapsed`;
  const variantEle = document.querySelector(`.${PREFIX}-variants__${variantKey}`);
  const selectedElemt = document.querySelector(
    `.${PREFIX}-variants__${variantKey} .${PREFIX}-variants__variant--selected`
  );
  const variantRef = useRef(0);
  const { firstVariant, secondVariant, thirdVariant } = variantDetails || {};
  const previousSelectedFirstVariantId = usePrevious(selectedFirstVariantId);
  const previousSelectedSecondVariantId = usePrevious(selectedSecondVariantId);
  const previousSelectedThirdVariantId = usePrevious(selectedThirdVariantId);
  const previousShowViewMore = usePrevious(showViewMore);
  const previousIsFirstVariantClicked = usePrevious(isFirstVariantClicked);
  const previousSelectedFirstVariant = usePrevious(selectedFirstVariant);
  useEffect(() => {
    if (variantEle instanceof HTMLElement) {
      setShowViewMoreOrLess(variantEle && variantEle.scrollHeight > maxHeight$1);
      const variantEleTop = (variantEle == null ? void 0 : variantEle.getBoundingClientRect().top) || 0;
      const selectedElemtTop = (selectedElemt == null ? void 0 : selectedElemt.getBoundingClientRect().top) || 0;
      selectedElemtTop > maxHeight$1 + variantEleTop ? setShowViewMore(false) : setShowViewMore(true);
    }
  }, [setShowViewMoreOrLess, setShowViewMore, variantEle, variantData.current, selectedElemt, variantsProductSkuData]);
  const getVariantData = useCallback(() => {
    var _a;
    return isArrayNotEmpty(variantData.current) && ((_a = firstVariant == null ? void 0 : firstVariant.values) == null ? void 0 : _a.find((item) => (item == null ? void 0 : item.id) === selectedFirstVariantId));
  }, [firstVariant, selectedFirstVariantId, variantData.current]);
  const setFilteredFirstData = useCallback(() => {
    const getSelectedFirstVariant = getVariantData();
    switch (variantKey) {
      case secondVariantName:
        getSelectedFirstVariant && secondVariant && (variantData.current = [...getSelectedFirstVariant.secondVariant]);
        break;
      case thirdVariantName:
        getSelectedFirstVariant && thirdVariant && (variantData.current = [...getSelectedFirstVariant.thirdVariant]);
        break;
    }
  }, [getVariantData, secondVariant, thirdVariant, variantKey]);
  useEffect(() => {
    if ((selectedFirstVariant !== previousSelectedFirstVariant || isFirstVariantClicked !== previousIsFirstVariantClicked) && (variantRef.current === magicNumber.ZERO || isFirstVariantClicked)) {
      setFilteredFirstData();
    }
  }, [
    isFirstVariantClicked,
    previousIsFirstVariantClicked,
    previousSelectedFirstVariant,
    selectedFirstVariant,
    setFilteredFirstData
  ]);
  useEffect(() => {
    showViewMore && showViewMore !== previousShowViewMore && variantEle && variantEle.scrollTo && variantEle.scrollTo({
      top: 0
    });
  }, [showViewMore, previousShowViewMore, variantEle, variantData.current]);
  const getSelectedVariantValue = useCallback(() => {
    switch (variantKey) {
      case firstVariantName:
        variantValue.current = selectedFirstVariant;
        variantDisplayName.current = selectedFirstVariantDisplayName;
        variantId.current = selectedFirstVariantId;
        break;
      case secondVariantName:
        variantValue.current = selectedSecondVariant;
        variantId.current = selectedSecondVariantId;
        break;
      default:
        variantValue.current = selectedThirdVariant;
        variantId.current = selectedThirdVariantId;
    }
  }, [
    selectedFirstVariant,
    selectedSecondVariant,
    selectedThirdVariant,
    variantKey,
    selectedFirstVariantId,
    selectedSecondVariantId,
    selectedThirdVariantId,
    selectedFirstVariantDisplayName
  ]);
  const getAvailableVariantOption = useCallback(() => {
    const variantArr = [selectedFirstVariantId];
    selectedSecondVariantId && variantArr.push(selectedSecondVariantId);
    selectedThirdVariantId && variantArr.push(selectedThirdVariantId);
    const getSkuArr = getSkuArray(variantArr, variantOptions);
    if (variantKey === firstVariantName) {
      const getFirstVatiants = variantData.current.map((firstVariantValue) => {
        return {
          ...firstVariantValue,
          isUnavailable: !firstVariantValue.skuCodes.some((sku) => getSkuArr.includes(sku))
        };
      });
      getFirstVatiants && (variantData.current = getFirstVatiants);
    }
    variantRef.current = magicNumber.ONE;
  }, [
    selectedFirstVariantId,
    selectedSecondVariantId,
    selectedThirdVariantId,
    variantData.current,
    variantKey,
    variantOptions
  ]);
  useEffect(() => {
    if (
      // eslint-disable-next-line sonar/expression-complexity
      variantData.current && selectedFirstVariantId && (selectedSecondVariantId || selectedThirdVariantId) && (selectedFirstVariantId !== previousSelectedFirstVariantId || selectedSecondVariantId !== previousSelectedSecondVariantId || selectedThirdVariantId !== previousSelectedThirdVariantId)
    ) {
      getAvailableVariantOption();
    }
    getSelectedVariantValue();
  }, [
    getAvailableVariantOption,
    getSelectedVariantValue,
    previousSelectedFirstVariantId,
    previousSelectedSecondVariantId,
    previousSelectedThirdVariantId,
    selectedFirstVariantId,
    selectedSecondVariantId,
    selectedThirdVariantId,
    variantData.current
  ]);
  useEffect(() => {
    if (
      // eslint-disable-next-line sonar/expression-complexity
      variantData.current && selectedFirstVariantId && variantKey === secondVariantName && (selectedFirstVariantId !== previousSelectedFirstVariantId || selectedThirdVariantId !== previousSelectedThirdVariantId)
    ) {
      const variantArr = [selectedFirstVariantId, selectedThirdVariantId];
      const getSkuArr = getSkuArray(variantArr, variantOptions);
      const getSizeVariants = variantData.current.map((size) => {
        return {
          ...size,
          isUnavailable: !size.skuCodes.some((sku) => getSkuArr.includes(sku))
        };
      });
      const isAvailable = Boolean(getSizeVariants.find((item) => !item.isUnavailable));
      if (isArrayNotEmpty(getSizeVariants) && !isAvailable) {
        setIsVariantSelected(true);
        setSelectedSecondVariantIdValue("");
        setSelectedSecondVariantValue("");
      } else {
        setIsVariantSelected(false);
      }
      getSizeVariants && (variantData.current = getSizeVariants);
    }
  }, [
    selectedFirstVariantId,
    selectedThirdVariantId,
    previousSelectedFirstVariantId,
    previousSelectedThirdVariantId,
    setIsVariantSelected,
    setSelectedSecondVariantIdValue,
    setSelectedSecondVariantValue,
    variantData.current,
    variantKey,
    variantOptions
  ]);
  useEffect(() => {
    if (
      // eslint-disable-next-line sonar/expression-complexity
      variantData.current && selectedFirstVariantId && selectedSecondVariantId && variantKey === thirdVariantName && (selectedFirstVariantId !== previousSelectedFirstVariantId || selectedSecondVariantId !== previousSelectedSecondVariantId)
    ) {
      const variantArr = [selectedFirstVariantId, selectedSecondVariantId];
      const getSkuArr = getSkuArray(variantArr, variantOptions);
      const getDynamicVatiants = variantData.current.map((dynamicItem) => {
        return {
          ...dynamicItem,
          isUnavailable: !dynamicItem.skuCodes.some((sku) => getSkuArr.includes(sku))
        };
      });
      const isAvailable = Boolean(getDynamicVatiants.find((item) => !item.isUnavailable));
      if (isArrayNotEmpty(getDynamicVatiants) && !isAvailable) {
        setIsVariantSelected(true);
        setSelectedThirdVariantIdValue("");
        setSelectedThirdVariantValue("");
      } else {
        setIsVariantSelected(false);
      }
      getDynamicVatiants && (variantData.current = getDynamicVatiants);
    }
  }, [
    selectedFirstVariantId,
    selectedSecondVariantId,
    previousSelectedFirstVariantId,
    previousSelectedSecondVariantId,
    setIsVariantSelected,
    setSelectedThirdVariantIdValue,
    setSelectedThirdVariantValue,
    variantData.current,
    variantKey,
    variantOptions
  ]);
  const getVariantLabel = () => {
    const isSizeChartButtonVisible = isOnlyOneVariant ? variantKey === firstVariantName : variantKey === secondVariantName;
    const sizeChart = isSizeChartButtonVisible && isSizeChartAvailable ? /* @__PURE__ */ jsx("button", { onClick: () => setShowSizeChart(!showSizeChart), className: `${PREFIX}-variants__size-chart`, children: sizeChartButtonTitle }) : null;
    return !firstVariantStyle && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-variants__label`, children: [
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-variants__label__position`, children: [
        /* @__PURE__ */ jsxs("label", { className: `${PREFIX}-h4--sm`, id: `variant-type-label-${variantKey}`, children: [
          variantsData == null ? void 0 : variantsData.display,
          ":"
        ] }),
        /* @__PURE__ */ jsx("p", { className: `${PREFIX}-body-md ${PREFIX}-variants__label__text`, children: isAutomotive ? variantDisplayName.current : variantValue.current })
      ] }),
      sizeChart
    ] });
  };
  const showVariantWarningMessage = (variantName) => {
    return (isAddToCartClicked || isNoSkuFindStoreClicked) && !variantValue.current && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-variants__warning`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "lg" }),
      variantName && /* @__PURE__ */ jsx("p", { className: `${PREFIX}-body-sm ${PREFIX}-variants__warning__text`, children: replaceStrWithDynamicVal(props.variantWarningLabel, variantName) })
    ] });
  };
  useEffect(() => {
    var _a;
    if (variantKey === firstVariantName || selectedSecondVariant === "") {
      return;
    }
    const selectedVariant = (_a = variantData.current) == null ? void 0 : _a.find((item) => (item == null ? void 0 : item.id) === variantId.current);
    if (selectedVariant == null ? void 0 : selectedVariant.isUnavailable) {
      if (variantKey === thirdVariantName && selectedThirdVariant !== "") {
        setSelectedThirdVariantIdValue("");
        setSelectedThirdVariantValue("");
      } else {
        setSelectedSecondVariantIdValue("");
        setSelectedSecondVariantValue("");
      }
      setFilteredFirstData();
    }
  }, [
    setSelectedSecondVariantIdValue,
    setSelectedSecondVariantValue,
    setSelectedThirdVariantIdValue,
    setSelectedThirdVariantValue,
    variantData.current,
    variantDetails,
    variantKey,
    variantId.current,
    setFilteredFirstData
  ]);
  const variantsOutsideActionHandler = useCallback(() => {
    outsideActionHandler(variantsListRef.current, selectionTypeChecked);
  }, []);
  useOnClickOutside(variantsListRef, variantsOutsideActionHandler);
  useOnKeyDownOutside(variantsListRef, variantsOutsideActionHandler);
  useEffect(() => {
    if (variantsListRef.current) {
      outsideActionHandler(variantsListRef.current, selectionTypeChecked);
    }
  });
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-col-md-12 ${PREFIX}-col-sm-9 ${PREFIX}-col-xs-6`, children: isArrayNotEmpty(variantData.current) ? /* @__PURE__ */ jsxs(Fragment, { children: [
    getVariantLabel(),
    showVariantWarningMessage(variantsData == null ? void 0 : variantsData.display),
    /* @__PURE__ */ jsx(
      "ul",
      {
        "aria-labelledby": `variant-type-label-${variantKey}`,
        className: firstVariantStyle ? firstVariantStyle : `${PREFIX}-variants__variant-list ${viewMoreVariantClass} ${PREFIX}-variants__${variantKey}`,
        role: "radiogroup",
        ref: variantsListRef,
        children: listItems(
          variantsData,
          variantData.current,
          setSelectedFirstVariantValue,
          firstVariantStyleItem,
          setSelectedFirstVariantIdValue,
          setSelectedSecondVariantValue,
          setSelectedSecondVariantIdValue,
          setSelectedThirdVariantValue,
          setSelectedThirdVariantIdValue,
          variantKey,
          variantValue.current,
          variantId.current,
          isAddToCartClicked,
          isNoSkuFindStoreClicked,
          variantRef.current,
          setIsFirstVariantClicked,
          variantClickHandler,
          isColourSwatchesActive,
          variantsProductSkuData,
          checkOutOfStock,
          enableHidingFirstVariantWhereAllSkusOOS,
          selectedProductCode,
          isAutomotive,
          inStockLabel,
          outOfStockLabel,
          a11yVariantsSelectedCount,
          areAllVariantsSelected,
          variantsListRef,
          enableOnlyAvailableOnline,
          availableOnlinePurchaseLabel,
          onlyAvailableOnlineAtLabel,
          preferredStoreDetails,
          noUrlUpdates,
          limitedStockMessage,
          isLimitedStock,
          setSelectedVariantByUserClick
        )
      }
    ),
    showViewMoreOrLess && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-variants__view-more`, children: /* @__PURE__ */ jsxs(Button, { type: "tertiary", size: "mini", onClick: () => setShowViewMore(!showViewMore), children: [
      showViewMore ? viewMoreLabel : viewLessLabel,
      " ",
      /* @__PURE__ */ jsx(Icon, { type: showViewMore ? "ct-chevron-down" : "ct-chevron-up", size: "md", path })
    ] }) })
  ] }) : "" });
};
Variants.propTypes = {
  enableOnlyAvailableOnline: PropTypes.bool,
  availableOnlinePurchaseLabel: PropTypes.string,
  onlyAvailableOnlineAtLabel: PropTypes.string,
  preferredStoreDetails: PropTypes.string,
  limitedStockMessage: PropTypes.string,
  isLimitedStock: PropTypes.bool,
  areAllVariantsSelected: PropTypes.bool,
  a11yVariantsSelectedCount: PropTypes.string,
  inStockLabel: PropTypes.string,
  outOfStockLabel: PropTypes.string,
  variantsData: PropTypes.any,
  selectedFirstVariant: PropTypes.string,
  selectedFirstVariantDisplayName: PropTypes.string,
  setSelectedFirstVariantValue: PropTypes.func,
  firstVariantStyle: PropTypes.string,
  firstVariantStyleItem: PropTypes.string,
  selectedSecondVariant: PropTypes.string,
  selectedThirdVariant: PropTypes.string,
  setSelectedFirstVariantIdValue: PropTypes.func,
  selectedFirstVariantId: PropTypes.string,
  selectedSecondVariantId: PropTypes.string,
  selectedThirdVariantId: PropTypes.string,
  variantOptions: PropTypes.array,
  path: PropTypes.string,
  viewMoreLabel: PropTypes.string,
  viewLessLabel: PropTypes.string,
  setSelectedSecondVariantValue: PropTypes.func,
  setSelectedSecondVariantIdValue: PropTypes.func,
  setSelectedThirdVariantValue: PropTypes.func,
  setSelectedThirdVariantIdValue: PropTypes.func,
  variantKey: PropTypes.string,
  variantDetails: PropTypes.any,
  setIsVariantSelected: PropTypes.func,
  variantWarningLabel: PropTypes.string,
  isAddToCartClicked: PropTypes.bool,
  isFirstVariantClicked: PropTypes.bool,
  setIsFirstVariantClicked: PropTypes.func,
  enableHidingFirstVariantWhereAllSkusOOS: PropTypes.bool,
  isAutomotive: PropTypes.bool
};
Variants.displayName = "VariantsInLib";
const enableDestructOnUndefinedData = (data) => data || {};
const FIRST_VARIANT_INDEX = 0;
const SECOND_VARIANT_INDEX = 1;
const THIRD_VARIANT_INDEX = 2;
const COLOR_VARIANT = "COLOUR";
const variantsConstant = {
  maxHeight: 212,
  variantLabel: "Variant",
  hideVariantClass: "hide",
  showVariantClass: "show",
  colorCodeParam: "colorCode"
};
const Variant = (props) => {
  const {
    variant,
    availability,
    variantIndex,
    isOnlyOneVariant,
    selectedOptionId,
    sizeChartButtonTitle = "",
    variantWarningLabel = "",
    viewMoreLabel = "",
    viewLessLabel = "",
    selectedProductCode,
    a11yVariantsSelectedCount,
    outOfStockLabel = "",
    inStockLabel = "",
    availableOnlinePurchaseLabel = "",
    onlyAvailableOnlineAtLabel = "",
    limitedStockMessage,
    preferredStoreDetails,
    path,
    isSizeChartAvailable,
    isSizeChartDisplayed,
    isAddToCartClicked,
    isNoSkuFindStoreClicked,
    isColourSwatchesActive = false,
    isUrlUpdatesEnabled = false,
    isAutomotive = false,
    isProductUrgentLowStock,
    areAllVariantsSelected,
    enableOnlyAvailableOnline = false,
    enableHidingFirstVariantWhereAllSkusOOS,
    isClickedByUser,
    setIsClickedByUser,
    setShowSizeChart,
    setSelectedVariantOptionId,
    checkOutOfStock
  } = props;
  const [isShowMoreExpanded, setIsShowMoreExpanded] = useState(false);
  const [isViewMoreOrLessShown, setIsViewMoreOrLessShown] = useState(true);
  const previousIsShowMoreExpanded = usePrevious(isShowMoreExpanded);
  const { maxHeight: maxHeight2, hideVariantClass: hideVariantClass2, showVariantClass: showVariantClass2, variantLabel: variantLabel2, colorCodeParam: colorCodeParam2 } = variantsConstant;
  const optionsListRef = useRef(null);
  const selectedVariantRef = useRef(null);
  const viewMoreVariantClass = !isShowMoreExpanded ? `${PREFIX}-variants__variant-list--expanded` : `${PREFIX}-variants__variant-list--collapsed`;
  const variantsOutsideActionHandler = useCallback(() => {
    outsideActionHandler(optionsListRef.current, selectionTypeChecked);
  }, []);
  useOnClickOutside(optionsListRef, variantsOutsideActionHandler);
  useOnKeyDownOutside(optionsListRef, variantsOutsideActionHandler);
  const isColorVariant = variant.id === COLOR_VARIANT;
  const isWarningVariant = (isAddToCartClicked || isNoSkuFindStoreClicked) && !selectedOptionId;
  const isColorSwathesStylesNeeded = (option) => isColourSwatchesActive && !!option.colourSwatchImageUrl;
  const areColourSwathesDisabled = (option) => isColorSwathesStylesNeeded(option) && checkOutOfStock(variantIndex, option);
  const isSelectedOption = (option) => isAutomotive ? option.skus.includes(selectedProductCode) : option.id === selectedOptionId;
  const showLabel = () => {
    const isSizeChartButtonAvailable = isOnlyOneVariant ? variantIndex === FIRST_VARIANT_INDEX : variantIndex === SECOND_VARIANT_INDEX;
    const sizeChartButton = isSizeChartButtonAvailable && isSizeChartAvailable ? /* @__PURE__ */ jsx(
      "button",
      {
        onClick: () => setShowSizeChart(!isSizeChartDisplayed),
        className: `${PREFIX}-variants__size-chart`,
        children: sizeChartButtonTitle
      }
    ) : null;
    const selectedOption = variant == null ? void 0 : variant.options.find((item) => item.id === selectedOptionId);
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-variants__label`, children: [
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-variants__label__position`, children: [
        /* @__PURE__ */ jsxs("label", { className: `${PREFIX}-h4--sm`, id: `variant-type-label-${variant.id}`, children: [
          variant == null ? void 0 : variant.displayName,
          ":"
        ] }),
        /* @__PURE__ */ jsx("p", { className: `${PREFIX}-body-md ${PREFIX}-variants__label__text`, children: selectedOption == null ? void 0 : selectedOption.value })
      ] }),
      sizeChartButton
    ] });
  };
  const showWarningMessage = () => {
    return isWarningVariant && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-variants__warning`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "lg" }),
      /* @__PURE__ */ jsx("p", { className: `${PREFIX}-body-sm ${PREFIX}-variants__warning__text`, children: replaceStrWithDynamicVal(variantWarningLabel, variant.displayName) })
    ] });
  };
  const isOptionHidenWhenOOS = (option) => areAllParamsValid(
    variantIndex === FIRST_VARIANT_INDEX,
    checkOutOfStock(variantIndex, option),
    enableHidingFirstVariantWhereAllSkusOOS
  );
  const getOptionClass = (option) => {
    if (variantIndex === FIRST_VARIANT_INDEX) {
      return showVariantClass2;
    }
    return option.isUnavailable ? hideVariantClass2 : showVariantClass2;
  };
  const getOptionAssignedClass = (option) => {
    const colourSwathesClass = isColorSwathesStylesNeeded(option) ? `${PREFIX}-variants__variant--colour-swatches` : "";
    const outOfStockClass = option.isUnavailableDueToStock || checkOutOfStock(variantIndex, option) ? `${PREFIX}-variants__disabled` : "";
    const defaultClass = `${PREFIX}-variants__variant ${colourSwathesClass} ${outOfStockClass}`;
    const warningClass = isWarningVariant ? `${PREFIX}-variants__variant--warning` : "";
    return isSelectedOption(option) ? `${defaultClass} ${PREFIX}-variants__variant--selected` : `${defaultClass} ${PREFIX}-variants__variant--unselected ${warningClass}`;
  };
  const getVariantImage = (option) => isColorSwathesStylesNeeded(option) ? /* @__PURE__ */ jsx("img", { src: option.colourSwatchImageUrl, alt: option.value }) : null;
  const getVariantText = (option) => {
    return isColorSwathesStylesNeeded(option) ? null : /* @__PURE__ */ jsx("span", { className: `${PREFIX}-variants__variant-text`, children: isAutomotive ? option.displayNameForVariants : option.value });
  };
  const handleKeyDown = (event, currentIndex, option) => {
    switch (event.key) {
      case stringKeyCodes.rightArrow:
        handleArrowsAccessibility(event, arrowActionIdentifier$1.NEXT, currentIndex, optionsListRef.current);
        break;
      case stringKeyCodes.leftArrow:
        handleArrowsAccessibility(event, arrowActionIdentifier$1.PREVIOUS, currentIndex, optionsListRef.current);
        break;
      case stringKeyCodes.enter:
      case stringKeyCodes.space:
        handleClickOrEnter(event, currentIndex, option);
        break;
    }
  };
  const setSelectedColorCodeToUrl = (selectedColor) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (isUrlUpdatesEnabled) {
      urlSearchParams.set(colorCodeParam2, selectedColor);
      updateUrlHistory(`?${decodeURIComponent(urlSearchParams.toString())}`);
    }
  };
  const handleClickOrEnter = (event, currentIndex, option) => {
    handleClickOrEnterAccessibility(event, currentIndex, optionsListRef.current, selectionTypeChecked);
    isColorVariant && setSelectedColorCodeToUrl(option.value);
    setSelectedVariantOptionId(variantIndex, option.id);
    setIsClickedByUser(variantIndex !== FIRST_VARIANT_INDEX);
  };
  const getQuantityValue = (inStockValue, corporateQuantityValue, storeShelfLabel) => {
    if (inStockValue > 0) {
      return isProductUrgentLowStock ? ` ${replaceStrWithDynamicVal(limitedStockMessage, inStockValue)} ${storeShelfLabel}` : ` ${inStockValue} ${inStockLabel} ${storeShelfLabel}`;
    } else if (corporateQuantityValue > 0) {
      return enableOnlyAvailableOnline ? ` ${onlyAvailableOnlineAtLabel} ${preferredStoreDetails} ` : availableOnlinePurchaseLabel;
    } else {
      return ` ${outOfStockLabel}`;
    }
  };
  const getAriaLabel = (option) => {
    const variantsSelectedCount = a11yVariantsSelectedCount;
    const optionsLength = isColorVariant ? variant.options.length : variant.options.filter((item) => !item.isUnavailable).length;
    const {
      quantity: inStockValue = 0,
      storeShelfLocation,
      Corporate: { Quantity: corporateQuantityValue = 0 } = {}
    } = enableDestructOnUndefinedData(availability);
    const storeShelfLabel = storeShelfLocation ? `- ${storeShelfLocation}` : "";
    const quantityMsg = checkOutOfStock(variantIndex, option) ? outOfStockLabel : inStockLabel;
    const selectedOptionMsg = `${variant.displayName}: ${option.value} ${replaceStrWithDynamicVal(
      variantsSelectedCount,
      optionsLength
    )}`;
    if (isSelectedOption(option)) {
      return areAllVariantsSelected ? selectedOptionMsg.concat(getQuantityValue(inStockValue, corporateQuantityValue, storeShelfLabel)) : selectedOptionMsg;
    } else {
      return `${option == null ? void 0 : option.value} ${quantityMsg}`;
    }
  };
  const filteredOptions = variant.options.filter((option) => {
    if (isOptionHidenWhenOOS(option) && !isSelectedOption(option)) {
      return false;
    }
    return getOptionClass(option) === "show";
  });
  useEffect(() => {
    if (optionsListRef.current) {
      outsideActionHandler(optionsListRef.current, selectionTypeChecked);
    }
  });
  useEffect(() => {
    var _a;
    const { current: listElement } = optionsListRef;
    if (listElement) {
      setIsViewMoreOrLessShown(listElement.scrollHeight > maxHeight2);
      const variantEleTop = listElement.getBoundingClientRect().top || 0;
      const selectedElemtTop = ((_a = selectedVariantRef.current) == null ? void 0 : _a.getBoundingClientRect().top) || 0;
      setIsShowMoreExpanded(selectedElemtTop < maxHeight2 + variantEleTop);
    }
  }, [maxHeight2]);
  useEffect(() => {
    const isOnlyOneOptionAvailable = filteredOptions.length === 1 && !selectedOptionId;
    if (isOnlyOneOptionAvailable && !isClickedByUser) {
      const firstAvailableOption = filteredOptions[0];
      if (!checkOutOfStock(variantIndex, firstAvailableOption)) {
        setSelectedVariantOptionId(variantIndex, filteredOptions[0].id);
      }
    }
    const selectedOption = filteredOptions.find((option) => option.id === selectedOptionId);
    if (selectedOptionId && !selectedOption) {
      setSelectedVariantOptionId(variantIndex, "");
    }
  }, [
    checkOutOfStock,
    isClickedByUser,
    filteredOptions,
    getOptionClass,
    hideVariantClass2,
    selectedOptionId,
    setSelectedVariantOptionId,
    variant,
    variantIndex
  ]);
  useEffect(() => {
    const { current } = optionsListRef;
    isShowMoreExpanded && isShowMoreExpanded !== previousIsShowMoreExpanded && (current == null ? void 0 : current.scrollTo({
      top: 0
    }));
  }, [isShowMoreExpanded, previousIsShowMoreExpanded]);
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-col-md-12 ${PREFIX}-col-sm-9 ${PREFIX}-col-xs-6`, children: [
    showLabel(),
    showWarningMessage(),
    /* @__PURE__ */ jsx(
      "ul",
      {
        "aria-labelledby": `variant-type-label-${variant.id}`,
        className: `${PREFIX}-variants__variant-list ${viewMoreVariantClass} ${PREFIX}-variants__${variant.id}`,
        role: "radiogroup",
        ref: optionsListRef,
        children: variant.options.filter((option) => !isOptionHidenWhenOOS(option)).map((option, index2) => {
          const selectableOptionIndex = filteredOptions.indexOf(option);
          return /* @__PURE__ */ jsxs(
            "li",
            {
              className: `${PREFIX}-variants__variant-item ${getOptionClass(option)}`,
              role: "presentation",
              children: [
                areColourSwathesDisabled(option) && /* @__PURE__ */ jsx("div", { className: "colour-swathes--disable" }),
                /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: getOptionAssignedClass(option),
                    "aria-label": getAriaLabel(option),
                    "data-testid": `${variantLabel2}${index2}`,
                    "data-accessibility": selectableOptionIndex >= 0,
                    role: selectableOptionIndex >= 0 ? "radio" : "",
                    "aria-checked": isSelectedOption(option),
                    onKeyDown: (event) => {
                      handleKeyDown(event, selectableOptionIndex, option);
                    },
                    onClick: (event) => {
                      handleClickOrEnter(event, selectableOptionIndex, option);
                    },
                    children: [
                      getVariantImage(option),
                      getVariantText(option)
                    ]
                  }
                )
              ]
            },
            option.id
          );
        })
      }
    ),
    isViewMoreOrLessShown && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-variants__view-more`, children: /* @__PURE__ */ jsxs(Button, { type: "tertiary", size: "mini", onClick: () => setIsShowMoreExpanded(!isShowMoreExpanded), children: [
      isShowMoreExpanded ? viewMoreLabel : viewLessLabel,
      " ",
      /* @__PURE__ */ jsx(Icon, { type: isShowMoreExpanded ? "ct-chevron-down" : "ct-chevron-up", size: "md", path })
    ] }) })
  ] }, variant.id);
};
const VariantsAlt = (props) => {
  const {
    variants,
    availability,
    selectedVariantsOptionIds,
    sizeChartButtonTitle,
    variantWarningLabel,
    viewMoreLabel,
    viewLessLabel,
    a11yVariantsSelectedCount,
    outOfStockLabel,
    inStockLabel,
    availableOnlinePurchaseLabel,
    onlyAvailableOnlineAtLabel,
    preferredStoreDetails,
    selectedProductCode,
    path,
    isSizeChartAvailable,
    isSizeChartDisplayed,
    isAddToCartClicked,
    isNoSkuFindStoreClicked,
    isColourSwatchesActive,
    isUrlUpdatesEnabled,
    isAutomotive,
    isProductUrgentLowStock,
    areAllVariantsSelected,
    enableOnlyAvailableOnline,
    enableHidingFirstVariantWhereAllSkusOOS = true,
    setSelectedVariantOptionId,
    setShowSizeChart,
    checkOutOfStock
  } = props;
  const [productVariants, setProductVariants] = useState(variants);
  const [isClickedByUser, setIsClickedByUser] = useState(false);
  const getAvailableSkus = useCallback(
    (selectedOptionIds) => {
      var _a;
      const initialSkus = ((_a = variants[FIRST_VARIANT_INDEX].options.find(
        (option) => option.id === selectedOptionIds[FIRST_VARIANT_INDEX]
      )) == null ? void 0 : _a.skus) || [];
      return selectedOptionIds.slice(1).filter(Boolean).reduce((accSkus, selectedOptionId) => {
        var _a2, _b;
        const skus = ((_b = (_a2 = variants.find((variant) => variant.options.find((option) => option.id === selectedOptionId))) == null ? void 0 : _a2.options.find((option) => option.id === selectedOptionId)) == null ? void 0 : _b.skus) || [];
        return accSkus.filter((sku) => skus.includes(sku));
      }, initialSkus);
    },
    [variants]
  );
  const getAvailableSkusForVariant = useCallback(
    (variantIndex) => {
      switch (variantIndex) {
        case SECOND_VARIANT_INDEX:
          return getAvailableSkus([
            selectedVariantsOptionIds[FIRST_VARIANT_INDEX],
            selectedVariantsOptionIds[THIRD_VARIANT_INDEX]
          ]);
        case THIRD_VARIANT_INDEX:
          return getAvailableSkus([
            selectedVariantsOptionIds[FIRST_VARIANT_INDEX],
            selectedVariantsOptionIds[SECOND_VARIANT_INDEX]
          ]);
        default:
          return getAvailableSkus(selectedVariantsOptionIds.slice(1));
      }
    },
    [getAvailableSkus, selectedVariantsOptionIds]
  );
  useEffect(() => {
    const updatedVariants = variants.map((variant, index2) => {
      const availableSkus = getAvailableSkusForVariant(index2);
      return {
        ...variant,
        options: variant.options.map((option) => {
          return { ...option, isUnavailable: !option.skus.some((sku) => availableSkus.includes(sku)) };
        })
      };
    });
    setProductVariants(updatedVariants);
  }, [variants, getAvailableSkusForVariant]);
  return /* @__PURE__ */ jsx(Fragment, { children: productVariants.map((variant, index2) => /* @__PURE__ */ jsx(
    Variant,
    {
      variant,
      variantIndex: index2,
      isOnlyOneVariant: productVariants.length === 1,
      sizeChartButtonTitle,
      variantWarningLabel,
      isSizeChartAvailable,
      isSizeChartDisplayed,
      isAddToCartClicked,
      isNoSkuFindStoreClicked,
      setShowSizeChart,
      selectedOptionId: selectedVariantsOptionIds[index2],
      isColourSwatchesActive,
      setSelectedVariantOptionId,
      checkOutOfStock,
      viewLessLabel,
      viewMoreLabel,
      path,
      isUrlUpdatesEnabled,
      selectedProductCode,
      isAutomotive,
      availability,
      a11yVariantsSelectedCount,
      outOfStockLabel,
      inStockLabel,
      availableOnlinePurchaseLabel,
      isProductUrgentLowStock,
      areAllVariantsSelected,
      enableOnlyAvailableOnline,
      onlyAvailableOnlineAtLabel,
      preferredStoreDetails,
      enableHidingFirstVariantWhereAllSkusOOS,
      isClickedByUser,
      setIsClickedByUser
    },
    variant.id
  )) });
};
const Overlay = () => {
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-overlay`, "data-testid": "overlay" });
};
const ARROW_UP_KEYCODE = 38;
const ARROW_DOWN_KEYCODE = 40;
const ESCAPE_KEYCODE = 27;
const CHANGE_INDEX$1 = 1;
const TAB_KEYCODE = 9;
const UPPERCASE_A_KEYCODE = 65;
const UPPERCASE_Z_KEYCODE = 90;
const LOWERCASE_A_KEYCODE = 97;
const LOWERCASE_Z_KEYCODE = 122;
const DropdownItem = ({ ...props }) => {
  const {
    isFilter,
    item,
    isMobile: isMobile2,
    currentItem,
    index: index2,
    itemSelect,
    itemSelectKeyBoardEvent,
    path,
    dropdownId,
    buttonContent
  } = props;
  const currentClass = () => {
    if (currentItem === index2) {
      if (!isMobile2) {
        return `${PREFIX}-dropdown__content--active`;
      }
    } else if (item.isUnavailable) {
      return `${PREFIX}-dropdown__content--not-selected`;
    } else {
      return `${PREFIX}-dropdown__content--default`;
    }
  };
  const renderFilterButtonContent = () => {
    return buttonContent ? /* @__PURE__ */ jsx(
      "button",
      {
        onClick: itemSelect,
        onKeyDown: itemSelectKeyBoardEvent,
        id: `${dropdownId}${index2}`,
        "data-testid": `drpItem${index2}`,
        role: "option",
        "data-qm-allow": "true",
        "aria-selected": item.selected,
        className: `${PREFIX}-dropdown__content-button ${currentClass()}`,
        tabIndex: -1,
        children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-dropdown__content-button--colour-swatch`, "aria-hidden": "true", children: /* @__PURE__ */ jsxs(Fragment, { children: [
          buttonContent(item.hexNumber),
          item.label
        ] }) })
      }
    ) : /* @__PURE__ */ jsxs(
      "button",
      {
        onClick: itemSelect,
        onKeyDown: itemSelectKeyBoardEvent,
        "data-testid": `drpItem${index2}`,
        id: `${dropdownId}${index2}`,
        type: "button",
        "data-qm-allow": "true",
        className: `${!isMobile2 ? `${PREFIX}-dropdown__content-button` : `${PREFIX}-dropdown__filter-button`} ${currentClass()}`,
        role: "option",
        "aria-selected": item.selected,
        tabIndex: -1,
        children: [
          item.selected && currentItem === index2 && isMobile2 ? /* @__PURE__ */ jsx(Icon, { size: "sm", type: "ct-confirm", path }) : null,
          item.label
        ]
      }
    );
  };
  return /* @__PURE__ */ jsx("li", { children: isFilter ? renderFilterButtonContent() : /* @__PURE__ */ jsx(
    "button",
    {
      onClick: itemSelect,
      onKeyDown: itemSelectKeyBoardEvent,
      id: `${dropdownId}${index2}`,
      "data-testid": `drpItem${index2}`,
      type: "button",
      "data-qm-allow": "true",
      className: `${PREFIX}-dropdown__content-button ${currentClass()}`,
      role: "option",
      "aria-selected": item.selected,
      children: item.label
    }
  ) }, `${dropdownId}${index2}`);
};
DropdownItem.propTypes = {
  index: PropTypes.number,
  item: PropTypes.any,
  itemSelect: PropTypes.any,
  currentItem: PropTypes.any,
  isFilter: PropTypes.bool,
  isMobile: PropTypes.bool,
  path: PropTypes.string,
  itemSelectKeyBoardEvent: PropTypes.any,
  dropdownId: PropTypes.string,
  buttonContent: PropTypes.func
};
const DropdownButton = ({ ...props }) => {
  const {
    isFilter,
    transformLabel,
    dropdownClick,
    keyDownEvent,
    filterTitle,
    title,
    icon,
    path,
    opened,
    isDsm,
    errorClass,
    disabled,
    hexNumber,
    ariaLabel,
    buttonContent,
    quantumMetricAttribute,
    id,
    dropdownId
  } = props;
  const quantumMetricDataAttribute = (quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type) ? { [`data-qm-${quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type}`]: quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.value } : {};
  const getDisabledClass = () => {
    return disabled ? `${PREFIX}-dropdown__button--disable` : "";
  };
  const getDropdownTitle = () => {
    return buttonContent ? /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-dropdown__content-button--colour-swatch ${transformLabel ? `${PREFIX}-dropdown__button--text-sort` : `${PREFIX}-dropdown__button--text-normal`}`,
        children: /* @__PURE__ */ jsxs(Fragment, { children: [
          hexNumber && buttonContent(hexNumber),
          title && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-dropdown__button--text`, ...quantumMetricDataAttribute, children: title })
        ] })
      }
    ) : title && /* @__PURE__ */ jsx(
      "span",
      {
        className: `${PREFIX}-dropdown__button--text ${transformLabel ? `${PREFIX}-dropdown__button--text-sort` : `${PREFIX}-dropdown__button--text-normal`}`,
        children: title
      }
    );
  };
  const ariaDescribedByLabel = () => {
    return id ? `${id}__error` : "";
  };
  const defaultAriaLabel = () => {
    return !title ? filterTitle : `${filterTitle} ${title}`;
  };
  return /* @__PURE__ */ jsxs(
    "button",
    {
      ...quantumMetricDataAttribute,
      className: `${PREFIX}-dropdown__button ${isFilter && transformLabel ? `${PREFIX}-dropdown__button--sort-button` : ""} ${errorClass} ${getDisabledClass()}`,
      onClick: dropdownClick,
      onKeyDownCapture: keyDownEvent,
      type: "button",
      "data-qm-allow": "true",
      role: "combobox",
      "aria-controls": dropdownId,
      disabled,
      "aria-expanded": !!opened,
      "aria-label": ariaLabel || defaultAriaLabel(),
      ref: props.dropdownButtonref,
      "aria-describedby": ariaDescribedByLabel(),
      children: [
        isFilter ? /* @__PURE__ */ jsx(
          "span",
          {
            className: `${PREFIX}-dropdown__button--title ${transformLabel ? `${PREFIX}-dropdown__button--title-still` : `${PREFIX}-dropdown__button--title-move`}`,
            children: filterTitle
          }
        ) : null,
        isFilter ? getDropdownTitle() : /* @__PURE__ */ jsx(Fragment, { children: !isDsm ? /* @__PURE__ */ jsx("span", { className: `${PREFIX}-dropdown__button--text`, children: title }) : /* @__PURE__ */ jsx("span", { className: `${PREFIX}-dropdown__button--text ${PREFIX}-dropdown__button--text-content`, children: title }) }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: `${PREFIX}-dropdown__button--icon ${transformLabel ? `${PREFIX}-dropdown__button--icon-sort` : `${PREFIX}-dropdown__button--icon-normal`}`,
            children: /* @__PURE__ */ jsx(Icon, { size: "lg", type: icon, path })
          }
        )
      ]
    }
  );
};
DropdownButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  path: PropTypes.string,
  dropdownClick: PropTypes.any,
  transformLabel: PropTypes.bool,
  isFilter: PropTypes.bool,
  filterTitle: PropTypes.string,
  opened: PropTypes.bool,
  keyDownEvent: PropTypes.any,
  isDsm: PropTypes.bool,
  errorClass: PropTypes.string,
  disabled: PropTypes.bool,
  hexNumber: PropTypes.string,
  buttonContent: PropTypes.func,
  dropdownButtonref: PropTypes.any,
  ariaLabel: PropTypes.string
};
const useIsMobile = (breakpoint = BREAKPOINTS.mobileMaxWidth) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const resizeWindow = () => {
    setWindowWidth(window.innerWidth);
  };
  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);
  return windowWidth <= breakpoint;
};
const Dropdown = ({ ...props }) => {
  var _a;
  const {
    dropdownTitle,
    dropdownList,
    dropdownIcon,
    size,
    dropdownId,
    path,
    onDropdownClick,
    selectedItem,
    type,
    filterTitle,
    isFilter,
    closeButtonLabel,
    isMobile: isMobile2,
    error,
    isDatePicker,
    isDsm,
    isOnlyErrorStyle = false,
    disabled,
    isChangeColourDropdown,
    buttonContent,
    resetDropdown,
    ariaLabel,
    enableEmptySelection,
    prePopulateFirstItem,
    quantumMetricAttribute,
    a11yDropDownNotSelected,
    disableFocus = false
  } = props;
  const isMobileView = useIsMobile();
  const getTitle = useCallback(() => {
    if (isFilter) {
      let selectedTitle = "";
      const dropdownSelectedItem = dropdownList == null ? void 0 : dropdownList.find((item) => item.selected);
      if (dropdownSelectedItem) {
        selectedTitle = dropdownSelectedItem.label;
      }
      return selectedTitle;
    }
    return dropdownTitle;
  }, [dropdownList, isFilter, dropdownTitle]);
  const setIndex = () => {
    if (isFilter) {
      let currentIndex = dropdownList == null ? void 0 : dropdownList.findIndex((item) => item.selected);
      if (enableEmptySelection) {
        currentIndex = currentIndex + magicNumber.ONE;
      }
      return currentIndex;
    }
    return null;
  };
  const [selected, setSelected] = useState(getTitle);
  const [opened, setOpened] = useState(isChangeColourDropdown || false);
  const [transformed, setTransformClass] = useState(false);
  const [currentItem, setCurrentItem] = useState(setIndex);
  const [selectedCurrentItem, setSelectedCurrentItem] = useState(setIndex);
  const dropdownRef = useRef(null);
  const dropdownButtonref = useRef(null);
  const [shadowClass, setShadowClass] = useState("");
  const [sortOption, setSortOption] = useState(null);
  const [dropIcon, setDropIcon] = useState(dropdownIcon);
  const [hexNumber, setHexNumber] = useState("");
  const dropdownListUpdate = dropdownList;
  const updatedSelectedTitle = getTitle();
  const interactiveElements = (_a = dropdownRef == null ? void 0 : dropdownRef.current) == null ? void 0 : _a.querySelectorAll("a,button");
  const quantumMetricDataAttribute = (quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type) ? { [`data-qm-${quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type}`]: quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.value } : {};
  const closeDropdown = () => {
    setOpened(false);
  };
  const dropdownListDependency = JSON.stringify(dropdownList);
  useClickOutsideClose(dropdownRef, closeDropdown, opened, !isMobile2);
  useEffect(() => {
    if (enableEmptySelection) {
      const emptyItem = {
        id: "-1",
        label: "",
        selected: false
      };
      dropdownList.unshift(emptyItem);
    }
  }, [enableEmptySelection, dropdownList]);
  useEffect(() => {
    if (!resetDropdown) {
      setSelected(dropdownTitle);
    }
  }, [resetDropdown, dropdownTitle]);
  useEffect(() => {
    var _a2;
    !opened && !disableFocus && ((_a2 = dropdownButtonref == null ? void 0 : dropdownButtonref.current) == null ? void 0 : _a2.focus());
  }, [disableFocus, opened]);
  useEffect(() => {
    if (!isDatePicker && updatedSelectedTitle && updatedSelectedTitle.length && updatedSelectedTitle !== dropdownTitle) {
      setSelected(updatedSelectedTitle);
    } else {
      setSelected(getTitle());
      setTransformClass(false);
    }
  }, [dropdownListDependency, getTitle, dropdownTitle, updatedSelectedTitle, isDatePicker]);
  useEffect(() => {
    setDropIcon(opened ? "ct-chevron-up" : "ct-chevron-down");
    if (opened && type === "primary") {
      setShadowClass(`${PREFIX}-shadow--small`);
    } else if (type !== "primary") {
      setShadowClass(`${PREFIX}-shadow--small`);
    } else {
      setShadowClass("");
    }
    if (isFilter && !opened && selected) {
      setTransformClass(true);
    }
  }, [type, opened, selected, isFilter]);
  useEffect(() => {
    if (isDatePicker) {
      setSelected("");
      setCurrentItem(null);
      setSelectedCurrentItem(null);
      setTransformClass(false);
    }
  }, [isDatePicker, dropdownList]);
  const runOnce = useRef(0);
  const itemSelect = useCallback(
    (item, index2) => {
      if (item.id === "-1") {
        item.id = "";
      }
      if (isMobile2) {
        if (!isFilter) {
          setOpened(false);
          selectedItem(item);
        } else {
          setSortOption(item);
        }
      } else {
        setOpened(false);
        selectedItem(item);
      }
      setCurrentItem(index2);
      setSelectedCurrentItem(index2);
      setSelected(item.label);
      isChangeColourDropdown && setHexNumber(item.hexNumber);
      dropdownListUpdate.forEach((value) => value.selected = value.label === item.label);
    },
    [dropdownListUpdate, isChangeColourDropdown, isFilter, isMobile2, selectedItem]
  );
  useEffect(() => {
    if (runOnce.current === magicNumber.ZERO && (dropdownListUpdate == null ? void 0 : dropdownListUpdate.length) === magicNumber.ONE && !dropdownListUpdate[0].selected && prePopulateFirstItem) {
      itemSelect(dropdownListUpdate[magicNumber.ZERO], magicNumber.ZERO);
      runOnce.current = 1;
    }
  }, [itemSelect, dropdownListUpdate, prePopulateFirstItem]);
  const dropdownClicked = () => {
    if (isFilter && !opened && selected) {
      setTransformClass(!transformed);
    }
    setOpened(!opened);
    if (isMobile2 && isFilter) {
      document.body.classList.add("modal-open");
    }
  };
  const keyboardeventHandler = (event) => {
    if (event.which === ARROW_DOWN_KEYCODE) {
      handleArrowDownKeycode(event);
    } else if (event.which === ESCAPE_KEYCODE || event.which === TAB_KEYCODE) {
      if (!selected) {
        setCurrentItem(null);
      }
      setOpened(false);
    } else if (event.which >= UPPERCASE_A_KEYCODE && event.which <= UPPERCASE_Z_KEYCODE || event.which >= LOWERCASE_A_KEYCODE && event.which <= LOWERCASE_Z_KEYCODE) {
      handleLetterKeycode(event);
    }
  };
  const handleArrowDownKeycode = (event) => {
    if (opened) {
      interactiveElements.forEach((element) => {
        element.setAttribute("tabindex", "-1");
      });
      event.preventDefault();
      const item = document.getElementById(`${dropdownId}${selectedCurrentItem}`);
      if (item) {
        item.focus();
      } else {
        const nextItem = selectedCurrentItem ? selectedCurrentItem + CHANGE_INDEX$1 : 0;
        setSelectedCurrentItem(nextItem);
        const nextitem = document.getElementById(`${dropdownId}${nextItem}`);
        nextitem.focus();
      }
    } else {
      setOpened(true);
    }
  };
  const handleLetterKeycode = (event) => {
    const keyPressed = String.fromCharCode(event.which);
    if (opened) {
      selectNextMatchedItem(event, keyPressed);
    } else {
      setOpened(true);
    }
  };
  const selectNextMatchedItem = (event, keyPressed) => {
    let itemToFocusIndex = 0;
    interactiveElements.forEach((element) => {
      if (element.textContent.startsWith(keyPressed)) {
        event.preventDefault();
        setSelectedCurrentItem(itemToFocusIndex);
        const itemToFocus = document.getElementById(`${dropdownId}${itemToFocusIndex}`);
        itemToFocus.focus();
      } else {
        itemToFocusIndex++;
      }
    });
  };
  const itemSelectKeyboardHandler = (event) => {
    if (event.which === ARROW_DOWN_KEYCODE && selectedCurrentItem < dropdownListUpdate.length - CHANGE_INDEX$1) {
      event.preventDefault();
      const nextItem = selectedCurrentItem + CHANGE_INDEX$1;
      setSelectedCurrentItem(nextItem);
      const item = document.getElementById(`${dropdownId}${nextItem}`);
      item.focus();
    } else if (event.which === ARROW_UP_KEYCODE && selectedCurrentItem > 0) {
      event.preventDefault();
      const previousItem = selectedCurrentItem - CHANGE_INDEX$1;
      setSelectedCurrentItem(previousItem);
      const item = document.getElementById(`${dropdownId}${previousItem}`);
      item.focus();
    } else if (event.which === ESCAPE_KEYCODE || event.which === TAB_KEYCODE) {
      if (!selected) {
        setCurrentItem(null);
      }
      setOpened(false);
    }
  };
  const closeClick = () => {
    if (isMobile2) {
      document.body.classList.remove("modal-open");
    }
    setOpened(!opened);
    selectedItem(sortOption);
  };
  const isFilterSection = () => {
    return isMobile2 && isFilter;
  };
  const errorClass = () => error || isOnlyErrorStyle ? `${PREFIX}-dropdown__button--error ${PREFIX}-accessibility-field--error` : "";
  const showError = () => error && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-dropdown__error ${PREFIX}-dropdown-native__error`, children: [
    /* @__PURE__ */ jsx(Icon, { type: "ct-input-error", size: "sm", path }),
    /* @__PURE__ */ jsx(
      "span",
      {
        className: `${PREFIX}-dropdown__error-text ${PREFIX}-dropdown-native__error-text`,
        id: `${dropdownId}__error`,
        children: error
      }
    )
  ] });
  const closeButtonMobile = () => isFilter && closeButtonLabel && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-dropdown__filter-close`, children: /* @__PURE__ */ jsx(
    Button,
    {
      type: "tertiary",
      size: "small",
      onClick: () => {
        closeClick();
      },
      children: closeButtonLabel
    }
  ) });
  const getModifierClass = () => {
    return !!props.modifierClass ? props.modifierClass : "";
  };
  const handleDropdownClick = () => {
    onDropdownClick() && dropdownClicked();
  };
  const showClass = `${isMobileView ? "mobile" : "desktop"}`;
  const renderCustomDropdown = () => {
    const sizeClass = size === "default" ? `${PREFIX}-dropdown--${size}-${showClass}` : `${PREFIX}-dropdown--${size}`;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${PREFIX}-dropdown ${shadowClass} ${getModifierClass()} ${isDsm ? `${PREFIX}-dropdown--highlight` : ""} ${sizeClass}`,
        ...quantumMetricDataAttribute,
        id: dropdownId,
        children: [
          /* @__PURE__ */ jsx(
            DropdownButton,
            {
              title: selected,
              icon: dropIcon,
              path,
              disabled,
              dropdownId: `${dropdownId}-dropdown`,
              dropdownClick: () => {
                onDropdownClick ? handleDropdownClick() : dropdownClicked();
              },
              keyDownEvent: (event) => {
                keyboardeventHandler(event);
              },
              transformLabel: transformed,
              filterTitle,
              isFilter,
              opened,
              isDsm,
              errorClass: errorClass(),
              hexNumber,
              buttonContent,
              dropdownButtonref,
              ariaLabel,
              quantumMetricAttribute,
              id: error ? dropdownId : ""
            }
          ),
          isFilterSection() && opened ? /* @__PURE__ */ jsx(Overlay, {}) : null,
          /* @__PURE__ */ jsxs(
            "ol",
            {
              id: `${dropdownId}-dropdown`,
              role: "listbox",
              className: ` ${isFilterSection() ? `${PREFIX}-dropdown__filter` : `${PREFIX}-dropdown__content`} ${PREFIX}-shadow--small ${isFilter ? `${PREFIX}-dropdown__content-sort` : ""}
                ${opened ? "show" : "hide"}`,
              ref: dropdownRef,
              children: [
                isFilterSection() ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-dropdown__filter-title`, children: filterTitle }) : null,
                dropdownListUpdate == null ? void 0 : dropdownListUpdate.map((item, index2) => /* @__PURE__ */ jsx(
                  DropdownItem,
                  {
                    index: index2,
                    path,
                    item,
                    currentItem,
                    itemSelect: () => {
                      itemSelect(item, index2);
                    },
                    isMobile: isMobile2,
                    isFilter,
                    itemSelectKeyBoardEvent: (event) => {
                      itemSelectKeyboardHandler(event);
                    },
                    dropdownId,
                    buttonContent,
                    a11yAriaLabel: (item == null ? void 0 : item.id) === "-1" ? a11yDropDownNotSelected : item.label
                  },
                  index2
                )),
                closeButtonMobile()
              ]
            }
          ),
          showError()
        ]
      }
    );
  };
  return /* @__PURE__ */ jsx(Fragment, { children: renderCustomDropdown() });
};
Dropdown.propTypes = {
  dropdownTitle: PropTypes.string,
  dropdownList: PropTypes.any,
  dropdownIcon: PropTypes.string,
  size: PropTypes.oneOf(["mini", "small", "medium", "large", "default", "xsmall"]),
  outsideClick: PropTypes.any,
  dropdownId: PropTypes.string,
  path: PropTypes.string,
  selectedItem: PropTypes.func,
  type: PropTypes.string,
  filterTitle: PropTypes.string,
  isFilter: PropTypes.bool,
  closeButtonLabel: PropTypes.string,
  index: PropTypes.number,
  isMobile: PropTypes.bool,
  error: PropTypes.string,
  isDatePicker: PropTypes.bool,
  isDsm: PropTypes.bool,
  isDropdownValueSelected: PropTypes.string,
  isOnlyErrorStyle: PropTypes.bool,
  disabled: PropTypes.bool,
  isChangeColourDropdown: PropTypes.bool,
  buttonContent: PropTypes.func,
  resetDropdown: PropTypes.bool,
  ariaLabel: PropTypes.string,
  enableEmptySelection: PropTypes.bool,
  prePopulateFirstItem: PropTypes.bool,
  modifierClass: PropTypes.string
};
const useClickOrFocusOutsideForCallback = (refs, callback, isEnabled) => {
  const updateClosureOnRender = useRef(callback);
  const handleIfTargetOutside = useCallback(
    (target) => {
      let matchingRef = false;
      if (refs instanceof Array) {
        matchingRef = Boolean(
          refs.find((refItem) => refItem.current && refItem.current.contains(target))
        );
      } else {
        matchingRef = refs.current && refs.current.contains(target);
      }
      if (!matchingRef) {
        updateClosureOnRender.current();
      }
    },
    [refs]
  );
  const handleClickEvent = useCallback(
    (ev) => handleIfTargetOutside(ev.target),
    [handleIfTargetOutside]
  );
  const handleFocusEvent = useCallback(
    () => handleIfTargetOutside(document.activeElement),
    [handleIfTargetOutside]
  );
  useEffect(() => {
    updateClosureOnRender.current = callback;
  });
  useEffect(() => {
    if (isEnabled) {
      document.addEventListener("click", handleClickEvent, true);
      document.addEventListener("focus", handleFocusEvent, true);
      return () => {
        document.removeEventListener("click", handleClickEvent, true);
        document.removeEventListener("focus", handleFocusEvent, true);
      };
    } else {
      return void 0;
    }
  }, [isEnabled, handleClickEvent, handleFocusEvent]);
};
const CHANGE_INDEX = 1;
const OptionListSize = {
  SMALL: "small",
  // 5 options
  MEDIUM: "medium",
  // 10 options
  LARGE: "large"
  // 20 options
};
const includesRankKey = "includes";
const HiddenLabel = ({
  children,
  className: className2 = "",
  textClassName: textClassName2 = "",
  a11yReadable = false,
  labelText = "input"
}) => {
  const objAriaHidden = a11yReadable ? { "aria-hidden": false } : {};
  return /* @__PURE__ */ jsxs("label", { className: className2, children: [
    /* @__PURE__ */ jsx("span", { className: textClassName2, hidden: true, ...objAriaHidden, children: labelText }),
    children
  ] });
};
const JumpListSearch = ({ ...props }) => {
  const {
    id,
    dropIcon,
    path,
    dropIconSize,
    searchBoxPlaceholder,
    showClearButton,
    clearLabel,
    searchMaxLength,
    allyClearIconLabel,
    allyCloseIconLabel,
    onChange,
    onClose,
    keyDownEvent,
    searchContainerRef
  } = props;
  const searchInputRef = useRef(null);
  const [filterValue, setFilterValue] = useState("");
  const handleChange = (event) => {
    const value = event.target.value;
    setFilterValue(value);
    onChange(value);
  };
  const clearInput = () => {
    setFilterValue("");
    searchInputRef.current.focus();
    onChange("");
  };
  useEffect(() => {
    searchInputRef.current.focus();
    searchInputRef.current.select();
  }, []);
  return /* @__PURE__ */ jsx("div", { ref: searchContainerRef, className: `${PREFIX}-jumplist-search`, "data-testid": "jumplist-search-panel", children: /* @__PURE__ */ jsxs(HiddenLabel, { className: `${PREFIX}-row`, labelText: searchBoxPlaceholder, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        id,
        ref: searchInputRef,
        enterKeyHint: "search",
        placeholder: searchBoxPlaceholder,
        className: `${PREFIX}-jumplist-search__input`,
        value: filterValue,
        maxLength: searchMaxLength,
        onChange: (e) => handleChange(e),
        onKeyDownCapture: keyDownEvent,
        "data-testid": id,
        autoComplete: "off"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-jumplist-search__buttons`, "aria-hidden": "true", children: [
      showClearButton && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-jumplist-search__button`, children: /* @__PURE__ */ jsx(Button, { type: "tertiary", ariaLabel: allyClearIconLabel, onClick: clearInput, id: "clear-btn", children: clearLabel }) }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-jumplist-search__button ${PREFIX}-jumplist-search__button__collapse`, children: /* @__PURE__ */ jsx(
        Button,
        {
          onClick: onClose,
          ariaExpanded: true,
          ariaLabel: allyCloseIconLabel,
          type: "icon_button",
          id: "collapse-btn",
          children: /* @__PURE__ */ jsx(Icon, { type: dropIcon, path, size: dropIconSize })
        }
      ) })
    ] })
  ] }) });
};
JumpListSearch.propTypes = {
  dropIcon: PropTypes.string,
  path: PropTypes.string,
  dropIconSize: PropTypes.string,
  id: PropTypes.string,
  searchBoxPlaceholder: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  keyDownEvent: PropTypes.any,
  showClearButton: PropTypes.bool,
  clearLabel: PropTypes.string,
  allyClearIconLabel: PropTypes.string,
  allyCloseIconLabel: PropTypes.string,
  searchMaxLength: PropTypes.number
};
const sortNumbersInAscendingOrder = (a, b) => a - b;
const filterByRank = (list, searchTerm) => {
  const searchResultByRankMap = /* @__PURE__ */ new Map();
  const ranks = /* @__PURE__ */ new Set();
  const queryWithoutExtraSpaces = searchTerm.toLowerCase().replace(allWhitespace, " ").trim();
  const queryByChunks = queryWithoutExtraSpaces.split(allNotLetterNotNumber).filter(Boolean);
  const searchTerms = [queryWithoutExtraSpaces, queryByChunks.join(""), ...queryByChunks];
  list.forEach((item) => {
    const { label } = item;
    const words = label.toLowerCase().split(allNotLetterNotNumber);
    for (let wordNumber = 0; wordNumber < words.length; wordNumber++) {
      const word = words[wordNumber];
      const primaryRankingMatch = searchWithDividers(word, searchTerms, "startsWith");
      if (primaryRankingMatch.match) {
        ranks.add(wordNumber);
        const rankingMap = searchResultByRankMap.get(wordNumber) ?? /* @__PURE__ */ new Map();
        const rankList = rankingMap.get(primaryRankingMatch.rank) ?? [];
        searchResultByRankMap.set(wordNumber, rankingMap.set(primaryRankingMatch.rank, [...rankList, item]));
        break;
      }
      const isLastWord = wordNumber === words.length - 1;
      if (isLastWord) {
        const secondaryRankingMatch = searchWithDividers(label.toLowerCase(), searchTerms, "includes");
        if (secondaryRankingMatch.match) {
          const includesRankingMap = searchResultByRankMap.get(includesRankKey) ?? /* @__PURE__ */ new Map();
          const includesRankList2 = includesRankingMap.get(secondaryRankingMatch.rank) ?? [];
          searchResultByRankMap.set(
            includesRankKey,
            includesRankingMap.set(secondaryRankingMatch.rank, [...includesRankList2, item])
          );
        }
      }
    }
  });
  const searchResultByRank = Array.from(ranks).sort(sortNumbersInAscendingOrder).reduce((prev, rank) => {
    const primaryRankMap = searchResultByRankMap.get(rank);
    const rankList = Array.from(primaryRankMap.keys()).sort(sortNumbersInAscendingOrder).flatMap((searchRank) => primaryRankMap.get(searchRank) ?? []);
    return [...prev, ...rankList];
  }, []);
  const includesRankMap = searchResultByRankMap.get(includesRankKey);
  const includesRankList = Array.from((includesRankMap == null ? void 0 : includesRankMap.keys()) ?? []).sort(sortNumbersInAscendingOrder).flatMap((searchRank) => includesRankMap.get(searchRank) ?? []);
  return [...searchResultByRank, ...includesRankList];
};
const searchWithDividers = (label, searchTerms, matchMethod) => {
  const labelWithoutDividers = label.replace(allNotLetterNotNumber, "");
  for (let searchTermNumber = 0; searchTermNumber < searchTerms.length; searchTermNumber++) {
    const searchTerm = searchTerms[searchTermNumber];
    if (label[matchMethod](searchTerm) || labelWithoutDividers[matchMethod](searchTerm)) {
      return { rank: searchTermNumber, match: true };
    }
  }
  return { match: false };
};
const NO_RESULTS_ID = String(magicNumber.MINUS_ONE);
const NVDA_DELAY = magicNumber.ONETHOUSAND;
const JumpList = ({ ...props }) => {
  const {
    dropdownId,
    dropdownTitle,
    dropdownList,
    dropdownIcon,
    size,
    path,
    type,
    isFilter,
    filterTitle,
    selectedItem,
    error,
    isOnlyErrorStyle = false,
    disabled,
    resetDropdown,
    prePopulateFirstItem,
    noResultsMessage,
    singleResultMessage,
    manyResultsMessage,
    searchMaxLength,
    searchPlaceholder,
    modifierClass,
    ariaLabel,
    allyDropDownNotSelected,
    allyClearIcon,
    allyCloseIcon,
    clearLabel,
    openDropdownList = false,
    focusDropdown = true
  } = props;
  const [opened, setOpened] = useState(false);
  const [transformed, setTransformClass] = useState(false);
  const [currentHighlightedItem, setCurrentHighlightedItem] = useState(magicNumber.MINUS_ONE);
  const dropdownRef = useRef(null);
  const searchContainerRef = useRef(null);
  const dropdownButtonRef = useRef(null);
  const [shadowClass, setShadowClass] = useState("");
  const [dropIcon, setDropIcon] = useState(dropdownIcon);
  const updatedDropdownList = dropdownList;
  const [displayList, setDisplayList] = useState(updatedDropdownList);
  const runOnce = useRef(0);
  const [showClearButton, setShowClearButton] = useState(false);
  const [suggestionLength, setSuggestionLength] = useState(null);
  const displayListAriaLabel = useMemo(() => {
    switch (suggestionLength) {
      case null:
        return String(suggestionLength);
      case magicNumber.ZERO:
        return noResultsMessage;
      case magicNumber.ONE:
        return singleResultMessage;
      default:
        return manyResultsMessage == null ? void 0 : manyResultsMessage.replace("[number]", String(suggestionLength));
    }
  }, [suggestionLength, noResultsMessage, singleResultMessage, manyResultsMessage]);
  const getTitle = useCallback(() => {
    var _a;
    if (isFilter) {
      let selectedTitle = "";
      const dropdownSelectedItem = updatedDropdownList == null ? void 0 : updatedDropdownList.find((item) => item.selected);
      if (dropdownSelectedItem) {
        selectedTitle = dropdownSelectedItem.label;
        (_a = dropdownButtonRef == null ? void 0 : dropdownButtonRef.current) == null ? void 0 : _a.blur();
      }
      return selectedTitle;
    }
    return dropdownTitle;
  }, [updatedDropdownList, isFilter, dropdownTitle]);
  const updatedSelectedTitle = getTitle();
  const [selected, setSelected] = useState(updatedSelectedTitle);
  const selectedIndex = useMemo(
    () => Math.max(
      displayList == null ? void 0 : displayList.findIndex((item) => item.selected),
      magicNumber.ZERO
    ),
    [displayList]
  );
  const scrollIndexToSeeFirst = Math.max(selectedIndex - CHANGE_INDEX, magicNumber.ZERO);
  const closeDropdown = () => {
    setShowClearButton(false);
    setCurrentHighlightedItem(magicNumber.MINUS_ONE);
    setOpened(false);
    setShowClearButton(false);
    setSuggestionLength(null);
  };
  const dropdownListDependency = JSON.stringify(dropdownList);
  useClickOrFocusOutsideForCallback([dropdownRef, searchContainerRef], closeDropdown, opened);
  const itemSelect = useCallback(
    (item, index2) => {
      if (item.id !== "") {
        setOpened(false);
        if (item.label !== selected) {
          selectedItem == null ? void 0 : selectedItem(item);
        }
        setShowClearButton(false);
        const currIndex = index2;
        setCurrentHighlightedItem(currIndex);
        setSelected(item.label);
        updatedDropdownList.forEach((value) => value.selected = value.label === item.label);
      }
    },
    [selectedItem, updatedDropdownList, selected]
  );
  useEffect(() => {
    setDisplayList(updatedDropdownList);
  }, [updatedDropdownList]);
  useEffect(() => {
    if (openDropdownList && !disabled && updatedDropdownList.length > magicNumber.ONE && !updatedDropdownList.find((item) => item.selected)) {
      setOpened(true);
    }
  }, [openDropdownList, disabled, updatedDropdownList]);
  useEffect(() => {
    if (!resetDropdown) {
      setSelected(dropdownTitle);
    }
  }, [resetDropdown, dropdownTitle]);
  useEffect(() => {
    var _a;
    !opened && ((_a = dropdownButtonRef == null ? void 0 : dropdownButtonRef.current) == null ? void 0 : _a.focus({ preventScroll: true }));
  }, [opened, selected]);
  useEffect(() => {
    var _a;
    !disabled && focusDropdown && ((_a = dropdownButtonRef == null ? void 0 : dropdownButtonRef.current) == null ? void 0 : _a.focus({ preventScroll: true }));
  }, [disabled, focusDropdown]);
  useEffect(() => {
    if (updatedSelectedTitle && updatedSelectedTitle.length && updatedSelectedTitle !== dropdownTitle) {
      setSelected(updatedSelectedTitle);
    } else {
      setSelected(getTitle());
      setTransformClass(false);
    }
  }, [dropdownListDependency, getTitle, dropdownTitle, updatedSelectedTitle]);
  useEffect(() => {
    setDropIcon(opened ? "ct-chevron-up" : "ct-chevron-down");
    if (opened && type === "primary") {
      setShadowClass(`${PREFIX}-shadow--small`);
    } else if (type !== "primary") {
      setShadowClass(`${PREFIX}-shadow--small`);
    } else {
      setShadowClass("");
    }
    if (isFilter && !opened && selected) {
      setTransformClass(true);
    }
  }, [type, opened, selected, isFilter]);
  useEffect(() => {
    if (runOnce.current === magicNumber.ZERO && (updatedDropdownList == null ? void 0 : updatedDropdownList.length) === magicNumber.ONE && !updatedDropdownList[0].selected && prePopulateFirstItem) {
      itemSelect(updatedDropdownList[magicNumber.ZERO], magicNumber.ZERO);
      runOnce.current = 1;
    }
  }, [itemSelect, updatedDropdownList, prePopulateFirstItem]);
  useEffect(() => {
    if (opened) {
      const handler = setTimeout(() => {
        var _a;
        ((_a = displayList[0]) == null ? void 0 : _a.id) === NO_RESULTS_ID ? setSuggestionLength(0) : setSuggestionLength(displayList.length);
      }, NVDA_DELAY);
      return () => {
        clearTimeout(handler);
      };
    }
    return void 0;
  }, [displayList, opened]);
  const dropdownButtonClicked = () => {
    setDisplayList(updatedDropdownList);
    setCurrentHighlightedItem(magicNumber.MINUS_ONE);
    setOpened(!opened);
    scrollToSelected();
  };
  const scrollToSelected = useCallback(() => {
    const item = document.getElementById(`${dropdownId}${scrollIndexToSeeFirst}`);
    if (item) {
      item.parentElement.scrollTop = item.offsetTop;
    }
  }, [dropdownId, scrollIndexToSeeFirst]);
  useEffect(() => {
    if (opened && displayList.length > magicNumber.FIVE) {
      scrollToSelected();
    }
  }, [displayList, opened, scrollToSelected]);
  const dropdownButtonKeyboardEventHandler = (event) => {
    if (event.which === keyCodes.downArrow) {
      event.preventDefault();
      setDisplayList(updatedDropdownList);
      setCurrentHighlightedItem(magicNumber.MINUS_ONE);
      setOpened(true);
      scrollToSelected();
    }
    if (event.which === keyCodes.esc) {
      event.preventDefault();
      closeDropdown();
    }
  };
  const jumpListItemKeyboardHandler = (event) => {
    if (event.which === keyCodes.downArrow) {
      event.preventDefault();
      const nextItem = currentHighlightedItem === magicNumber.MINUS_ONE ? selectedIndex : Math.min(currentHighlightedItem + CHANGE_INDEX, updatedDropdownList.length - CHANGE_INDEX);
      setCurrentHighlightedItem(nextItem);
      const item = document.getElementById(`${dropdownId}${nextItem}`);
      item.focus();
    }
    if (event.which === keyCodes.upArrow) {
      event.preventDefault();
      const previousItemIndex = currentHighlightedItem - CHANGE_INDEX;
      const supposedElementId = previousItemIndex >= 0 ? `${dropdownId}${previousItemIndex}` : `search_${dropdownId}`;
      const item = document.getElementById(supposedElementId);
      setCurrentHighlightedItem(Math.max(previousItemIndex, magicNumber.MINUS_ONE));
      item.focus();
    }
    if (event.which === keyCodes.esc) {
      if (opened) {
        event.stopPropagation();
      }
      event.preventDefault();
      closeDropdown();
    }
  };
  const errorClass = () => error || isOnlyErrorStyle ? `${PREFIX}-jumplist__button--error` : "";
  const showError = () => error && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-jumplist ${PREFIX}-jumplist-native__error`, role: "alert", "aria-label": error, children: [
    /* @__PURE__ */ jsx(Icon, { type: "ct-input-error", size: "sm", path }),
    /* @__PURE__ */ jsx(
      "span",
      {
        className: `${PREFIX}-jumplist-text ${PREFIX}-jumplist-native__error-text`,
        id: `${dropdownId}__error`,
        children: error
      }
    )
  ] });
  const getModifierClass = () => {
    return !!modifierClass ? modifierClass : "";
  };
  const currentItemClass = (item) => {
    if (item.selected) {
      return `${PREFIX}-jumplist__content--active`;
    } else if (item.isUnavailable) {
      return `${PREFIX}-jumplist__content--not-selected`;
    } else {
      return `${PREFIX}-jumplist__content--default`;
    }
  };
  const filterDisplayList = (value) => {
    setShowClearButton(Boolean(value));
    let filteredList;
    setCurrentHighlightedItem(magicNumber.MINUS_ONE);
    if (value === "") {
      filteredList = updatedDropdownList || [];
    } else {
      filteredList = filterByRank(updatedDropdownList, value);
    }
    if (!filteredList.length) {
      filteredList.push({
        id: NO_RESULTS_ID,
        label: noResultsMessage,
        selected: false
      });
    }
    setDisplayList(filteredList);
  };
  const renderJumpListItem = (item, index2) => {
    return /* @__PURE__ */ jsx(
      "button",
      {
        onClick: () => {
          itemSelect(item, index2);
        },
        onKeyDownCapture: jumpListItemKeyboardHandler,
        id: `${dropdownId}${index2}`,
        "data-testid": `drpItem${index2}`,
        type: "button",
        "data-qm-allow": "true",
        "aria-selected": item.selected,
        role: "option",
        disabled: (item == null ? void 0 : item.id) === NO_RESULTS_ID,
        className: `${PREFIX}-jumplist__content-button ${currentItemClass(item)}`,
        "aria-label": (item == null ? void 0 : item.id) === NO_RESULTS_ID ? allyDropDownNotSelected : item == null ? void 0 : item.label,
        title: (item == null ? void 0 : item.id) === NO_RESULTS_ID ? allyDropDownNotSelected : item == null ? void 0 : item.label,
        children: item == null ? void 0 : item.label
      },
      index2
    );
  };
  const renderJumpList = () => {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${PREFIX}-jumplist ${shadowClass} ${getModifierClass()} ${size === "default" ? `${PREFIX}-jumplist--${size}-desktop` : `${PREFIX}-jumplist--${size}`}`,
        id: dropdownId,
        "data-testid": `open_jumplist_${dropdownId}`,
        children: [
          opened ? /* @__PURE__ */ jsx(
            JumpListSearch,
            {
              id: `search_${dropdownId}`,
              searchBoxPlaceholder: searchPlaceholder,
              dropIcon,
              path,
              dropIconSize: "lg",
              clearLabel,
              showClearButton,
              onChange: filterDisplayList,
              onClose: closeDropdown,
              keyDownEvent: jumpListItemKeyboardHandler,
              searchMaxLength,
              allyClearIconLabel: allyClearIcon,
              allyCloseIconLabel: allyCloseIcon,
              searchContainerRef
            }
          ) : /* @__PURE__ */ jsx(
            DropdownButton,
            {
              title: selected,
              icon: dropIcon,
              path,
              disabled,
              dropdownClick: () => {
                dropdownButtonClicked();
              },
              keyDownEvent: (event) => {
                dropdownButtonKeyboardEventHandler(event);
              },
              transformLabel: transformed,
              filterTitle,
              isFilter,
              opened,
              errorClass: errorClass(),
              dropdownButtonref: dropdownButtonRef,
              ariaLabel,
              id: error ? dropdownId : ""
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "sr-only",
              "aria-atomic": true,
              "aria-live": suggestionLength === magicNumber.ONE ? "polite" : "assertive",
              children: displayListAriaLabel
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: `${PREFIX}-jumplist__content ${PREFIX}-jumplist__content--${props == null ? void 0 : props.optionListSize} ${opened ? "show" : "hide"}`,
              role: "listbox",
              ref: dropdownRef,
              children: displayList == null ? void 0 : displayList.map((item, index2) => renderJumpListItem(item, index2))
            }
          ),
          showError()
        ]
      }
    );
  };
  return /* @__PURE__ */ jsx(Fragment, { children: renderJumpList() });
};
JumpList.defaultProps = {
  optionListSize: OptionListSize.SMALL
};
JumpList.propTypes = {
  dropdownId: PropTypes.string,
  dropdownTitle: PropTypes.string,
  dropdownList: PropTypes.any,
  dropdownIcon: PropTypes.string,
  size: PropTypes.oneOf(["mini", "xsmall", "small", "medium", "large", "default"]),
  path: PropTypes.string,
  type: PropTypes.string,
  isFilter: PropTypes.bool,
  filterTitle: PropTypes.string,
  selectedItem: PropTypes.func,
  error: PropTypes.string,
  isOnlyErrorStyle: PropTypes.bool,
  disabled: PropTypes.bool,
  resetDropdown: PropTypes.bool,
  prePopulateFirstItem: PropTypes.bool,
  noResultsMessage: PropTypes.string,
  singleResultMessage: PropTypes.string,
  manyResultsMessage: PropTypes.string,
  searchMaxLength: PropTypes.number,
  searchPlaceholder: PropTypes.string,
  modifierClass: PropTypes.string,
  ariaLabel: PropTypes.string,
  allyDropDownNotSelected: PropTypes.string,
  allyClearIcon: PropTypes.string,
  allyCloseIcon: PropTypes.string,
  clearLabel: PropTypes.string
};
JumpList.displayName = "JumpList";
const SubtitleItem = ({ ...props }) => {
  const { title, subtitle, ClassName } = props;
  return /* @__PURE__ */ jsxs("div", { className: `${ClassName}__subtitle--block`, children: [
    /* @__PURE__ */ jsx("h4", { className: `${PREFIX}-body-xl`, children: title }),
    subtitle && /* @__PURE__ */ jsx("p", { className: `${PREFIX}-body-sm`, children: subtitle })
  ] });
};
SubtitleItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  ClassName: PropTypes.string
};
const externalNavigation = (value) => {
  return !(value == null ? void 0 : value.startsWith("/"));
};
const CascadingDropdown = ({ ...props }) => {
  const { link, title, index: index2, isItemCascading = false, subMenu, subtitle, ClassName, isSubItem } = props;
  const [showDropdown, setShowDropdown] = useState(false);
  const contentRef = useRef(null);
  useClickOutsideClose(contentRef, () => onDropdownButtonClickHandler(), true, true);
  const onDropdownButtonClickHandler = () => {
    setShowDropdown(!showDropdown);
  };
  const menuEscapeHandler = useCallback((e) => {
    if (e.key === stringKeyCodes["esc"]) {
      setShowDropdown(false);
    }
  }, []);
  const addKeyBoardAccessibility = useCallback((firstItem, lastItem, e) => {
    const elem = document.activeElement;
    if (
      // eslint-disable-next-line sonar/expression-complexity
      e.key === stringKeyCodes["tab"] && elem === lastItem && !e.shiftKey || elem === firstItem && e.shiftKey && e.key === stringKeyCodes["tab"]
    ) {
      e.stopPropagation();
      e.preventDefault();
      setShowDropdown(false);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("keyup", menuEscapeHandler);
    return () => {
      document.removeEventListener("keyup", menuEscapeHandler);
    };
  }, [menuEscapeHandler]);
  useEffect(() => {
    let firstItem = null;
    let lastItem = null;
    if (showDropdown) {
      const menuDropDownParent = document.getElementsByClassName(
        `${PREFIX}-primary-navigation__subitems`
      )[0];
      const interactiveElements = menuDropDownParent == null ? void 0 : menuDropDownParent.querySelectorAll("a,button");
      const menuItems = interactiveElements && Array.from(interactiveElements);
      if (menuItems && menuItems.length > 0) {
        firstItem = menuItems[0];
        lastItem = menuItems[menuItems.length - magicNumber.ONE];
      }
      menuDropDownParent && // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      menuDropDownParent.addEventListener("keydown", addKeyBoardAccessibility.bind(null, firstItem, lastItem));
    }
    return () => {
      document.removeEventListener("keydown", addKeyBoardAccessibility.bind(null, firstItem, lastItem));
    };
  }, [showDropdown, addKeyBoardAccessibility]);
  const subMenuItemsRender = () => {
    return subMenu && showDropdown ? /* @__PURE__ */ jsx("nav", { className: `${ClassName}__subitems`, ref: contentRef, children: subMenu.map((item, i) => /* @__PURE__ */ jsx(
      CascadingDropdown,
      {
        index: i,
        title: item.title,
        link: item.link,
        subtitle: item.subtitle,
        ClassName: `${ClassName}`,
        isSubItem: true,
        isItemCascading: !!(item.subLevelItems && item.subLevelItems.length),
        subMenu: item.subLevelItems
      },
      `${index2}-${i}`
    )) }) : null;
  };
  const externalLinkItemRender = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${ClassName}--item__external-link-value ${PREFIX}-display-2`, children: [
      title,
      /* @__PURE__ */ jsx(Icon, { type: "ct-north-east" })
    ] });
  };
  const isItemActive = () => {
    const currentUrl = window.location.href;
    if (!isItemCascading && currentUrl && currentUrl.includes(decodeURIComponent(link))) {
      return `${ClassName}--item__active`;
    }
    return "";
  };
  const cascadingDropdownRender = () => {
    const subItemElement = externalNavigation(link) ? externalLinkItemRender() : /* @__PURE__ */ jsx(SubtitleItem, { title, subtitle, ClassName: `${ClassName}` });
    return isItemCascading ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(
        Button,
        {
          "data-index": index2,
          onClick: onDropdownButtonClickHandler,
          type: "link",
          ariaExpanded: showDropdown,
          children: [
            title,
            /* @__PURE__ */ jsx(Icon, { type: `ct-chevron-${showDropdown ? "up" : "down"}` })
          ]
        }
      ),
      subMenuItemsRender()
    ] }) : /* @__PURE__ */ jsx("a", { href: link, "data-index": index2, target: `${externalNavigation(link) ? "_blank" : "_self"}`, children: isSubItem ? subItemElement : title });
  };
  const externalLinkClassName = externalNavigation(link) ? "__external-link" : "";
  return /* @__PURE__ */ jsx("div", { className: `${ClassName}--item${externalLinkClassName} ${isItemActive()}`, children: cascadingDropdownRender() });
};
CascadingDropdown.propTypes = {
  link: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  index: PropTypes.number,
  isItemCascading: PropTypes.bool,
  subMenu: PropTypes.array,
  ClassName: PropTypes.string,
  isSubItem: PropTypes.bool,
  subLevelItems: PropTypes.array
};
const ServiceInstallation = ({ ...props }) => {
  const {
    availabilityLabel,
    installLabel,
    installIcon,
    toolTipIcon,
    toolTipTitle,
    toolTipDesc,
    path,
    a11yCloseIconLabel,
    phone,
    checkNearbyStoreCTAHandler
  } = props;
  const [showViewMore, setShowViewMore] = useState(true);
  const [visibility, setVisibility] = useState(false);
  const buttonRef = useRef();
  const phoneNumber = getFormattedPhoneNumber(phone);
  const renderViewMoreContents = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-installation__shopping-store`, children: [
      /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: props.autoshoppingAtText } }),
      /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: phone, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
        "a",
        {
          className: `${PREFIX}-md-none`,
          href: `tel:${memoizedStringContent}`,
          "data-link-value": phone,
          children: phoneNumber
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-xs-none ${PREFIX}-md-block`, children: phoneNumber })
    ] });
  };
  const showViewMoreLess = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      !showViewMore && renderViewMoreContents(),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-installation__check-nearby`, children: /* @__PURE__ */ jsxs(Button, { type: "tertiary", size: "mini", onClick: () => setShowViewMore(!showViewMore), children: [
        showViewMore ? props.viewMoreLabel : props.viewLessLabel,
        " "
      ] }) })
    ] });
  };
  const renderCheckNearByCTA = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-installation__check-nearby`, children: /* @__PURE__ */ jsx(Button, { id: "store-cta-btn", type: "tertiary", onClick: checkNearbyStoreCTAHandler, children: props.checkNearByCTALabel }) });
  };
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-installation`, children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-installation__container`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-installation__icon`, children: /* @__PURE__ */ jsx(Icon, { type: installIcon, size: "lg", path }) }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-installation__detail`, children: [
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-installation__header`, children: [
        /* @__PURE__ */ jsx("h4", { className: `${PREFIX}-installation-msg__title`, children: installLabel }),
        /* @__PURE__ */ jsx(
          "button",
          {
            ref: buttonRef,
            className: `${PREFIX}-installation__tooltip-btn`,
            onClick: () => {
              setVisibility(!visibility);
            },
            "aria-label": "information",
            children: /* @__PURE__ */ jsx("span", { className: visibility ? `${PREFIX}-installation__tooltip-btn--active` : "", children: /* @__PURE__ */ jsx(Icon, { type: toolTipIcon, size: "md", path }) })
          }
        ),
        !!visibility && /* @__PURE__ */ jsx(
          Tooltip,
          {
            visibility,
            setVisibility,
            iconID: "ct-close",
            headerText: toolTipTitle,
            bodyText: toolTipDesc,
            path,
            coords: buttonRef.current,
            a11yCloseIconLabel
          }
        )
      ] }),
      availabilityLabel,
      props.isAutoPartOrTire ? (
        // eslint-disable-next-line sonar/no-nested-conditional
        phone ? !props.isAOAUpdationRequire && showViewMoreLess() : renderCheckNearByCTA()
      ) : null
    ] })
  ] }) });
};
ServiceInstallation.propTypes = {
  availabilityLabel: PropTypes.element,
  installLabel: PropTypes.string,
  installIcon: PropTypes.string,
  toolTipIcon: PropTypes.string,
  toolTipTitle: PropTypes.string,
  toolTipDesc: PropTypes.string,
  closeIcon: PropTypes.string,
  path: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string,
  phone: PropTypes.string,
  autoshoppingAtText: PropTypes.string,
  checkNearByCTALabel: PropTypes.string,
  viewMoreLabel: PropTypes.string,
  viewLessLabel: PropTypes.string,
  checkNearbyStoreCTAHandler: PropTypes.func,
  isAutoPartOrTire: PropTypes.bool,
  isAOAUpdationRequire: PropTypes.bool
};
if (typeof window !== "undefined") {
  window.analyticsLayer = window.analyticsLayer || [];
}
const StickyTOC = ({ ...props }) => {
  const {
    isStickyTOCEnabled,
    sectionHeaders,
    moreSectionsLabel,
    moreSectionsIcon,
    setStickyTOCInView,
    isTires,
    roadRatings,
    stickyBuyBarHeight,
    scrollTOCHandler,
    stickyTOCRef
  } = props;
  const [menuItems, setMenuItems] = useState([]);
  const [selectItems, setSelectItems] = useState([]);
  const [showSelect, setshowSelect] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [activeTab, setActiveTab] = useState(null);
  const [offsetElementIndex, setOffsetElementIndex] = useState(null);
  const [currentWindowWidth, setCurrentWindowWidth] = useState(window.innerWidth);
  const [blockScrollEvent, setBlockScrollEvent] = useState(false);
  const stickyNav = document.getElementById(`${PREFIX}-nav`);
  const activeTabClass = `${PREFIX}-Scrollspy-nav-ul-link-label__active`;
  const previousSectionHeaders = usePrevious(sectionHeaders);
  const previousActiveTab = usePrevious(activeTab);
  const previousOffsetElementIndex = usePrevious(offsetElementIndex);
  const previousMenuItems = usePrevious(menuItems);
  const getSelectItem = useCallback(
    (item) => {
      setBlockScrollEvent(true);
      const itemId = item.id;
      const el = document.getElementById(itemId);
      setActiveTab(itemId);
      if (el) {
        scrollTOCHandler(el);
        setBlockScrollEvent(false);
      }
    },
    [scrollTOCHandler]
  );
  const itemClicked = useCallback(
    (item) => {
      window.analyticsLayer.push({
        event: "interaction",
        eventParameters: {
          action: "click on internal link",
          category: "interaction",
          label: item.label,
          value: "",
          location: "sticky toc"
        }
      });
      getSelectItem(item);
    },
    [getSelectItem]
  );
  const createMenuItems = useCallback(
    (tabs, id) => {
      return tabs.map((link) => {
        link.isActive = link.id === id;
        return /* @__PURE__ */ jsx(
          "li",
          {
            "data-id": link.id,
            className: `${PREFIX}-Scrollspy-nav-ul-link`,
            "data-testid": link.id,
            children: /* @__PURE__ */ jsx(
              "button",
              {
                className: `${PREFIX}-Scrollspy-nav-ul-link-label ${link.isActive ? activeTabClass : ""}`,
                tabIndex: magicNumber.MINUS_ONE,
                onClick: () => itemClicked(link),
                children: link.label
              }
            )
          },
          link.id
        );
      });
    },
    [activeTabClass, itemClicked]
  );
  const [isSticky, setSticky] = useState(false);
  let buyBoxCompEL;
  const handleScroll = () => {
    buyBoxCompEL = document.getElementById(`${PREFIX}-buy-box`) || null;
    const buyBoxCompELHeight = (buyBoxCompEL == null ? void 0 : buyBoxCompEL.clientHeight) || 0;
    const buyBoxCompELTop = (buyBoxCompEL == null ? void 0 : buyBoxCompEL.offsetTop) || 0;
    const buyBoxContentHeight = buyBoxCompELHeight + buyBoxCompELTop;
    setStickyComponent(buyBoxContentHeight);
    onScrollEvent();
  };
  const setStickyComponent = (buyBoxContentHeight) => {
    window.pageYOffset > buyBoxContentHeight ? setSticky(true) : setSticky(false);
  };
  useEffect(() => {
    setStickyTOCInView(isSticky);
  }, [isSticky, setStickyTOCInView]);
  useEffect(() => {
    if (
      // eslint-disable-next-line sonar/expression-complexity
      (sectionHeaders !== previousSectionHeaders || activeTab !== previousActiveTab || offsetElementIndex !== previousOffsetElementIndex) && sectionHeaders && (sectionHeaders == null ? void 0 : sectionHeaders.length)
    ) {
      const filteredHeaders = sectionHeaders.filter((header) => {
        return header.id !== "road-rating" || header.id === "road-rating" && isTires && isArrayNotEmpty(roadRatings);
      });
      const menuItemsEl = createMenuItems(filteredHeaders, activeTab || sectionHeaders[0].id);
      setMenuItems(menuItemsEl);
      if (offsetElementIndex) {
        setshowSelect(true);
        const dropDownItems = filteredHeaders.slice(offsetElementIndex).map((header) => {
          return {
            id: header.id,
            label: header.label
          };
        });
        const menuTabs = createMenuItems(
          filteredHeaders.slice(0, offsetElementIndex),
          activeTab || sectionHeaders[0].id
        );
        setSelectItems(dropDownItems);
        setMenuItems(menuTabs);
      }
    }
  }, [
    sectionHeaders,
    activeTab,
    offsetElementIndex,
    previousSectionHeaders,
    previousActiveTab,
    previousOffsetElementIndex,
    createMenuItems,
    isTires,
    roadRatings
  ]);
  const resize = useCallback(() => {
    if (currentWindowWidth < window.innerWidth && offsetElementIndex) {
      setshowSelect(false);
      setOffsetElementIndex(null);
    }
    if (window.innerWidth <= BREAKPOINTS.tabletMaxWidth) {
      setOffsetElementIndex(null);
      setshowSelect(false);
    }
    setCurrentWindowWidth(window.innerWidth);
  }, [currentWindowWidth, offsetElementIndex]);
  useEffect(() => {
    menuItems !== previousMenuItems && resize();
  }, [menuItems, previousMenuItems, resize]);
  const onScrollEvent = () => {
    const currPossY = window.scrollY;
    prevScrollPos < currPossY ? setIsScrollingDown(true) : setIsScrollingDown(false);
    const findAllTabs = () => {
      const tabsId = sectionHeaders.map((el) => el.id);
      return tabsId.map((id) => document.getElementById(id)).filter((el) => el).map((el) => {
        return { id: el.id, position: el.offsetTop, distance: Math.abs(el.offsetTop - currPossY) };
      });
    };
    const tabs = findAllTabs();
    const tabsPositions = tabs.map((tab) => tab.distance);
    const closerDistance = Math.min(...tabsPositions);
    const closerTab = tabs.filter((tab) => tab.distance === closerDistance);
    setPrevScrollPos(currPossY);
    !blockScrollEvent && setActiveTab(closerTab[0].id);
  };
  useGlobalScrollEvent(handleScroll);
  useGlobalResizeEvent(resize);
  const enableStickyTOC = useCallback(() => {
    if (stickyNav) {
      stickyNav == null ? void 0 : stickyNav.setAttribute("style", `top: ${stickyBuyBarHeight}px`);
    }
  }, [stickyBuyBarHeight, stickyNav]);
  const disableStickyTOC = useCallback(() => {
    if (stickyNav) {
      stickyNav.setAttribute("style", "top: -100%");
    }
  }, [stickyNav]);
  useEffect(() => {
    if (isStickyTOCEnabled) {
      enableStickyTOC();
      setStickyTOCInView(isStickyTOCEnabled);
    } else {
      disableStickyTOC();
    }
  }, [isStickyTOCEnabled, isScrollingDown, stickyBuyBarHeight, enableStickyTOC, setStickyTOCInView, disableStickyTOC]);
  return /* @__PURE__ */ jsx(
    "nav",
    {
      id: `${PREFIX}-nav`,
      ref: stickyTOCRef,
      "data-testid": "sticky-scroll",
      className: `${PREFIX}-Scrollspy-nav ${PREFIX}-full-width-container ${isSticky ? `${PREFIX}-Scrollspy-sticky` : `${PREFIX}-xs-none`}`,
      children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-container`, children: [
        /* @__PURE__ */ jsx("ul", { id: "teleporter", className: `${PREFIX}-Scrollspy-nav-ul`, "aria-hidden": "true", children: menuItems }),
        showSelect && /* @__PURE__ */ jsx(
          Dropdown,
          {
            selectedItem: (item) => getSelectItem(item),
            dropdownTitle: moreSectionsLabel,
            dropdownList: selectItems,
            dropdownIcon: moreSectionsIcon,
            resetDropdown: isStickyTOCEnabled,
            size: "mini",
            dropdownId: "receiver"
          }
        )
      ] })
    }
  );
};
StickyTOC.propTypes = {
  isStickyTOCEnabled: PropTypes.bool,
  sectionHeaders: PropTypes.any,
  moreSectionsLabel: PropTypes.string,
  moreSectionsIcon: PropTypes.string,
  setStickyTOCInView: PropTypes.func.isRequired,
  isTires: PropTypes.bool,
  ratingsContainer: PropTypes.string,
  reviewsContainer: PropTypes.string,
  roadRatings: PropTypes.string
};
const Checkbox = ({ ...props }) => {
  const {
    facetId,
    disabled,
    checked,
    label,
    value,
    onChange,
    path,
    ariaLabel,
    setAutofocus,
    assistiveText,
    displaySuccessIcon,
    errorIcon,
    error,
    successIcon,
    componentClassName: componentClassName2
  } = props;
  const facteId = facetId !== void 0 ? `-${facetId}` : "";
  const id = props.id ? `${PREFIX}-checkbox__${props.id}${facteId}` : "";
  const erroClass = error ? `${componentClassName2}__check--error` : "";
  const hover = props.hover ? `${props.hover}` : "";
  const checkboxRef = useRef(null);
  useEffect(() => {
    var _a;
    if (setAutofocus) {
      (_a = checkboxRef.current) == null ? void 0 : _a.focus();
    }
  }, [setAutofocus]);
  const successRender = () => {
    return !error && assistiveText && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__assistive-text`, children: [
      displaySuccessIcon && /* @__PURE__ */ jsx(Icon, { type: successIcon, size: "lg", path }),
      assistiveText
    ] });
  };
  const errorRender = () => {
    return error && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__error`, role: "alert", children: [
      /* @__PURE__ */ jsx(Icon, { type: errorIcon, size: "sm", path }),
      /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__error-text`, children: error })
    ] });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-checkbox ${hover}`, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          id: `${id}`,
          type: "checkbox",
          className: `${PREFIX}-checkbox__input`,
          disabled,
          defaultChecked: checked,
          value,
          onChange,
          "data-testid": id,
          "aria-label": ariaLabel,
          ref: checkboxRef,
          "aria-checked": checked
        }
      ),
      /* @__PURE__ */ jsxs("label", { htmlFor: `${id}`, className: `${PREFIX}-checkbox__label-container`, children: [
        /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__check ${erroClass}`, children: checked && /* @__PURE__ */ jsx(Icon, { size: "xs", type: "ct-checkmark", path }) }),
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-checkbox__text ${disabled ? "disabled" : ""}`, children: label })
      ] })
    ] }),
    successRender(),
    errorRender()
  ] });
};
Checkbox.defaultProps = {
  label: "Checkbox Label",
  id: "checkbox_label",
  errorIcon: "ct-warning-triangle-sm",
  successIcon: "ct-checkmark",
  displaySuccessIcon: false,
  componentClassName: `${PREFIX}-checkbox`
};
Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  hover: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  path: PropTypes.string,
  ariaLabel: PropTypes.string,
  setAutofocus: PropTypes.bool,
  errorIcon: PropTypes.string,
  successIcon: PropTypes.string,
  displaySuccessIcon: PropTypes.bool,
  assistiveText: PropTypes.string,
  componentClassName: PropTypes.string
};
const Radio = ({ ...props }) => {
  const { quantumMetricAttribute, error } = props;
  const componentClassName2 = `${PREFIX}-radio`;
  const id = props.id ? `${componentClassName2}__${props.id}` : "";
  const name = props.name ? `${componentClassName2}__${props.name}` : "";
  const [visibility, setVisibility] = useState(false);
  const buttonRef = useRef(null);
  const returnErrorClass = () => {
    return error ? `${componentClassName2}__check--error` : "";
  };
  const erroClass = returnErrorClass();
  const labelClasses = (() => {
    return `${componentClassName2}__label-container ${props.disabled ? "disabled" : ""} ${props.isBaselineAlignment ? `${componentClassName2}__label-baseline` : ""}`;
  })();
  const getQmDataAttribute = () => (quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type) ? { [`data-qm-${quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.type}`]: quantumMetricAttribute == null ? void 0 : quantumMetricAttribute.value } : {};
  const quantumMetricDataAttribute = getQmDataAttribute();
  return /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}`, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        id: `${id}`,
        "data-testid": id,
        type: "radio",
        name: `${name}`,
        className: `${componentClassName2}__input`,
        onChange: props.onChange,
        disabled: props.disabled,
        checked: props.checked,
        value: props.value,
        "aria-label": props.ariaLabel,
        defaultChecked: props.defaultChecked
      }
    ),
    /* @__PURE__ */ jsxs("label", { htmlFor: `${id}`, className: labelClasses, children: [
      /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__check ${erroClass} ${props.disabled ? "disabled" : ""}`, children: (props.checked || props.defaultChecked) && /* @__PURE__ */ jsx(Icon, { size: "xs", type: "ct-radio-selected" }) }),
      /* @__PURE__ */ jsxs(
        "span",
        {
          ...quantumMetricDataAttribute,
          className: `${componentClassName2}__text ${props.disabled ? "disabled" : ""}`,
          children: [
            props.label,
            props.hasTooltip && /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                "data-qm-allow": "true",
                "data-testid": "info-icon",
                className: `${componentClassName2}__tooltip-icon`,
                ref: buttonRef,
                onClick: () => setVisibility(!visibility),
                "aria-label": props.information,
                children: /* @__PURE__ */ jsx(Icon, { size: "md", type: "ct-information-details" })
              }
            ),
            props.caption
          ]
        }
      )
    ] }),
    !!visibility && /* @__PURE__ */ jsx(
      Tooltip,
      {
        visibility,
        setVisibility,
        iconID: "ct-close",
        headerText: props.option.bulkTooltipTitle,
        bodyText: props.option.bulkTooltipDesc,
        a11yCloseIconLabel: props.a11yCloseIconLabel,
        coords: buttonRef.current,
        tooltipModifiedStyles: props.tooltipModifiedStyles
      }
    )
  ] });
};
Radio.defaultProps = {
  label: "Radio Label",
  id: "radio_label"
};
Radio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  hasTooltip: PropTypes.bool,
  information: PropTypes.string,
  option: PropTypes.shape({
    bulkTooltipTitle: PropTypes.string,
    bulkTooltipDesc: PropTypes.string
  }),
  a11yCloseIconLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
  isBaselineAlignment: PropTypes.bool
};
const useOnKeyUpOutside = (ref, handler, parentRef) => {
  useEffect(() => {
    const parentRefNode = (parentRef == null ? void 0 : parentRef.current) || document;
    const listener = (event) => {
      var _a;
      if (!(ref == null ? void 0 : ref.current) || ((_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.contains(event.target))) {
        return;
      }
      handler(event);
    };
    parentRefNode == null ? void 0 : parentRefNode.addEventListener("keyup", listener);
    return () => parentRefNode.removeEventListener("keyup", listener);
  }, [ref, handler, parentRef]);
};
const CustomDropdown = (props) => {
  const {
    id,
    children,
    label,
    showIcon = true,
    filterRow,
    filterPanelRef,
    forSEOOnLoad,
    isMaxHeightRemove,
    disabled,
    shouldClose,
    setShouldClose,
    placeholder,
    isSearchable,
    searchChangeHandler,
    searchInputClassname
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    if (setShouldClose && shouldClose) {
      if (isOpen) {
        setIsOpen(false);
        setSearchValue("");
      }
      setShouldClose(false);
    }
  }, [shouldClose, isOpen, setShouldClose]);
  useEffect(() => {
    const dropdownNode = dropdownPanelRef == null ? void 0 : dropdownPanelRef.current;
    if (dropdownNode) {
      dropdownNode.addEventListener("keydown", (event) => {
        var _a;
        if (isEscPressed(event.key)) {
          setIsOpen(false);
          setSearchValue("");
          (_a = mainRef == null ? void 0 : mainRef.current) == null ? void 0 : _a.focus();
        }
      });
    }
  }, []);
  const filterRef = useRef();
  const mainRef = useRef();
  const dropdownPanelRef = useRef();
  const customDropdownPanelOpen = isMaxHeightRemove ? "custom-dropdown-panel--open custom-dropdown-panel--remove-max-height" : "custom-dropdown-panel--open";
  const customDropdownPanel = "custom-dropdown-panel";
  const dropdownTestId = id ? `custom-dropdown_${id}` : "custom-dropdown";
  const handleClick = (e) => {
    var _a;
    e.preventDefault();
    if ((_a = dropdownPanelRef == null ? void 0 : dropdownPanelRef.current) == null ? void 0 : _a.contains(e.target)) {
      return;
    }
    setIsOpen(!isOpen);
    setSearchValue("");
    !isOpen && searchChangeHandler && searchChangeHandler("");
  };
  const clickOutsideHandler = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
      setSearchValue("");
    }
  }, [isOpen]);
  useOnClickOutside(filterRef, clickOutsideHandler);
  const closeDropDown = useCallback((event) => {
    if (isEscPressed(event.key) || isSpacePressed(event.key) || isEnterPressed(event.key)) {
      setIsOpen(false);
      setSearchValue("");
    }
  }, []);
  useOnKeyDownOutside(filterRef, closeDropDown, filterRow);
  const closeDropDownOnTab = useCallback((event) => {
    if (isTabPressed(event.key)) {
      setIsOpen(false);
      setSearchValue("");
    }
  }, []);
  useOnKeyUpOutside(filterRow, closeDropDownOnTab, filterPanelRef);
  useEffect(() => {
    const filterRowNode = filterRow == null ? void 0 : filterRow.current;
    if (filterRowNode) {
      filterRowNode.addEventListener("keydown", (event) => {
        const firstInteractiveElement = getInteractiveElements(filterRowNode)[magicNumber.ZERO];
        if (firstInteractiveElement === event.target && event.shiftKey && isTabPressed(event.key)) {
          setIsOpen(false);
          setSearchValue("");
        }
      });
    }
  }, [filterRow]);
  const handleKeyDown = (event) => {
    if (isEscPressed(event.key)) {
      setIsOpen(false);
      setSearchValue("");
    }
  };
  const renderSearchButton = () => {
    return /* @__PURE__ */ jsxs("div", { className: searchInputClassname, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          value: isOpen ? searchValue : String(label),
          id,
          placeholder,
          "data-testid": dropdownTestId,
          disabled,
          onChange: (event) => {
            searchChangeHandler && searchChangeHandler(event.currentTarget.value);
            setSearchValue(event.currentTarget.value);
          },
          onClick: !isOpen && handleClick
        }
      ),
      showIcon ? /* @__PURE__ */ jsx("button", { disabled, onClick: handleClick, "aria-label": String(label), children: /* @__PURE__ */ jsx(Icon, { type: isOpen ? "ct-chevron-up" : "ct-chevron-down" }) }) : null
    ] });
  };
  const shouldRenderSearch = useCallback(() => {
    return isSearchable && searchChangeHandler;
  }, [searchChangeHandler, isSearchable]);
  return /* @__PURE__ */ jsxs("div", { ref: filterRef, children: [
    shouldRenderSearch() ? renderSearchButton() : /* @__PURE__ */ jsx(
      "button",
      {
        className: "custom-dropdown",
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        ref: mainRef,
        disabled,
        "data-testid": dropdownTestId,
        id,
        "aria-expanded": isOpen,
        children: /* @__PURE__ */ jsxs("div", { className: "custom-dropdown__label", children: [
          label,
          showIcon ? /* @__PURE__ */ jsx(Icon, { type: isOpen ? "ct-chevron-up" : "ct-chevron-down" }) : null
        ] })
      }
    ),
    /* @__PURE__ */ jsx("div", { ref: dropdownPanelRef, className: isOpen ? customDropdownPanelOpen : customDropdownPanel, children: (isOpen || forSEOOnLoad) && children })
  ] });
};
CustomDropdown.propTypes = {
  children: PropTypes.element.isRequired,
  label: PropTypes.element.isRequired,
  showIcon: PropTypes.bool,
  disabled: PropTypes.bool
};
const StyleCodes = ({ styleCode, key, index: index2 }) => {
  return /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product__sku`, children: `${index2 ? ", " : " "}#${styleCode}` }, `style code ${key}`);
};
const ProductInformation = ({
  brand,
  title,
  sku,
  isStyleCodeExist,
  titleStyle,
  titleContainerStyle,
  hideDescription,
  isSKUVisible,
  partNumber,
  partLabel,
  isSticky,
  accessibilityTitleId,
  ariaHidden,
  brandUrl,
  boldBrand = false
}) => {
  const productTitleClamp = (newTitle) => {
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: newTitle, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
      "div",
      {
        id: accessibilityTitleId,
        className: titleStyle,
        dangerouslySetInnerHTML: { __html: memoizedStringContent }
      }
    ) }) });
  };
  const productTitleDisplay = () => {
    const label = typeof brand === "string" ? brand : brand == null ? void 0 : brand.label;
    let newTitle = "";
    if (boldBrand && label && title.toLowerCase().includes(label.toLowerCase())) {
      const indexOfBrand = title.toLowerCase().indexOf(label.toLowerCase());
      const brandInTitle = title.substring(indexOfBrand, indexOfBrand + label.length);
      newTitle = `${title.substring(
        0,
        indexOfBrand
      )}<span class="${PREFIX}-product__brand--bold">${brandInTitle}</span>${title.substring(
        indexOfBrand + label.length
      )}`;
    } else {
      newTitle = title;
    }
    if (titleStyle && titleContainerStyle) {
      return productTitleClamp(newTitle);
    }
    if (isSticky) {
      return /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: newTitle, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
        "h3",
        {
          className: `${PREFIX}-product-info__title`,
          dangerouslySetInnerHTML: { __html: memoizedStringContent }
        }
      ) });
    }
    return /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: title, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
      "h1",
      {
        className: `${PREFIX}-product__title`,
        dangerouslySetInnerHTML: { __html: memoizedStringContent }
      }
    ) });
  };
  const renderSKUAndPartNumber = () => {
    return !isSKUVisible && !!sku && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product__sku`, "aria-hidden": ariaHidden ? ariaHidden : false, children: [
      isStyleCodeExist ? Array.isArray(sku) && sku.map((styleCode, index2) => /* @__PURE__ */ jsx(StyleCodes, { styleCode, index: index2 }, `style_code_key-${styleCode}`)) : `#${sku.toString()}`,
      partNumber && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product__sku-seprator`, children: "|" }),
        partLabel,
        " #",
        partNumber
      ] })
    ] });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: !hideDescription && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product`, children: [
    !!brand && !titleStyle && (!!brandUrl ? /* @__PURE__ */ jsx(
      "a",
      {
        className: `${PREFIX}-product__brand  ${PREFIX}-product__brand--link`,
        tabIndex: 0,
        href: brandUrl,
        children: brand
      }
    ) : /* @__PURE__ */ jsx("p", { className: `${PREFIX}-product__brand`, children: brand })),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-title-sku`, children: [
      productTitleDisplay(),
      renderSKUAndPartNumber()
    ] })
  ] }) });
};
ProductInformation.propTypes = {
  brand: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.exact({
      label: PropTypes.string,
      url: PropTypes.string
    })
  ]),
  brandUrl: PropTypes.string,
  title: PropTypes.string,
  sku: PropTypes.string,
  titleStyle: PropTypes.string,
  titleContainerStyle: PropTypes.string,
  hideDescription: PropTypes.bool,
  isSKUVisible: PropTypes.bool,
  partNumber: PropTypes.string,
  partLabel: PropTypes.string,
  isSticky: PropTypes.bool,
  accessibilityTitleId: PropTypes.string
};
const getFormattedPriceWithLocale = (price, maximumFractionDigits, minimumFractionDigits) => {
  const language2 = getLanguage();
  return localization.formattedPrice(
    language2,
    price,
    currencyShortForm,
    currencyFormat,
    maximumFractionDigits,
    minimumFractionDigits
  );
};
const getNumberFromFormattedPrice = (currency) => Number(currency.replace(replaceNumberFormattedPrice, ""));
const getNumberFromFormattedPriceWithLocale = (currency) => {
  if (multiLanguageLabel.frenchLangLabel.toLowerCase() === getLanguage()) {
    currency = currency.replace(/,/g, ".");
  }
  return Number(currency.replace(replaceNumberFormattedPrice, ""));
};
const useGenerateSaveMessage = (saleCut, originalPrice, saleMessagesRules, currentPrice) => {
  const [saveMessage, setSaveMessage] = useState("");
  const showSaveMessage = isArrayNotEmpty(saleMessagesRules) && !!(saleCut == null ? void 0 : saleCut.value);
  useEffect(() => {
    if (showSaveMessage) {
      setSaveMessage(generateSaveMessage(saleCut, saleMessagesRules, originalPrice, currentPrice));
    } else {
      setSaveMessage("");
    }
  }, [showSaveMessage, originalPrice, saleCut, saleMessagesRules, currentPrice]);
  return saveMessage;
};
const generateSaveMessage = (saleCut, saleMessagesRules, originalPrice, currentPrice) => {
  var _a;
  const roundedPercentage = Math.round(Number(saleCut == null ? void 0 : saleCut.percentage));
  const saleCutValue = Number(saleCut == null ? void 0 : saleCut.value);
  const roundedSaleCutValue = getFormattedPriceWithLocale(Number((_a = saleCut == null ? void 0 : saleCut.value) == null ? void 0 : _a.toFixed(magicNumber.TWO))) ?? "";
  const roundedSaleCutValueWithoutDollarSymbol = roundedSaleCutValue == null ? void 0 : roundedSaleCutValue.replace(DOLLAR_SYMBOL, EMPTY_STRING);
  const messageReplacer = (message) => {
    var _a2;
    return (_a2 = message == null ? void 0 : message.replace(PERCENT, `${roundedPercentage}`)) == null ? void 0 : _a2.replace(CUT, `${roundedSaleCutValueWithoutDollarSymbol}`);
  };
  const saleMessagesRule = saleMessagesRules == null ? void 0 : saleMessagesRules.find((rule) => {
    var _a2;
    const percentage = Number((_a2 = saleCut == null ? void 0 : saleCut.percentage) == null ? void 0 : _a2.toFixed(magicNumber.TWO));
    return percentage <= rule.maxPercent && percentage >= rule.minPercent && (rule.absoluteCutType === LESS ? rule.absoluteValueThreshold > saleCutValue : rule.absoluteValueThreshold < saleCutValue);
  });
  return !!(originalPrice == null ? void 0 : originalPrice.minPrice) || !!(currentPrice == null ? void 0 : currentPrice.minPrice) ? messageReplacer(saleMessagesRule == null ? void 0 : saleMessagesRule.upToSaveMessage) : messageReplacer(saleMessagesRule == null ? void 0 : saleMessagesRule.saveMessage);
};
const getETATimeOptions = (etaTimeOptions) => {
  if (getLanguage().toLowerCase() === multiLanguageLabel.frenchLangLabel.toLowerCase()) {
    etaTimeOptions.hour12 = false;
  }
  return etaTimeOptions;
};
const UrgencyMessage = ({ ...props }) => {
  const { saleEndDaySoonMessage, salePriceEndDate, saleEndDisableShift = false } = props;
  const baseOptions = {
    month: "long",
    day: "numeric",
    year: "numeric"
  };
  const dateOptions2 = saleEndDisableShift ? baseOptions : {
    ...baseOptions,
    timeZone: "UTC"
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("strong", { children: saleEndDaySoonMessage }),
    " ",
    localization.formattedDate(getETATimeOptions(dateOptions2), salePriceEndDate, getLanguage())
  ] });
};
UrgencyMessage.propTypes = {
  saleEndDaySoonMessage: PropTypes.string,
  salePriceEndDate: PropTypes.string,
  saleEndDisableShift: PropTypes.bool
};
const StickyBuyBar = (props) => {
  const {
    brandUrl,
    brand,
    title,
    desktopATCLabel,
    unitPriceLabel,
    clearancePriceLabel,
    productImageUrl,
    a11yStrikeOutPrice,
    a11yStrikeOutPriceRange,
    onlineOrdering,
    feeTitle,
    originalPrice,
    currentPrice,
    displayWasLabel,
    language: language2,
    addToCartClickHandler,
    showAddToCartOnStickyBuyBox,
    priceMessage,
    a11yRecycleFeesTriangleIcon,
    feeDisclaimerType,
    feeDisclaimerMessage,
    feeDisclaimerTitle,
    setIsStickyBBInView,
    showBBSpinner,
    productId,
    isOOSCurrentStore,
    saleCut,
    saleMessagesRules,
    isBrowseOnlyMode,
    a11yClickToReadFootnote,
    scrollToReviewsHandler,
    saleEndDaySoonMessage,
    productSaleEndDate,
    stickyBuyBarRatingRef,
    hasSaleOrClearanceBadge,
    plusMinusSymbol,
    isRangeView = false,
    isShowBuyNowBtn,
    buyNowCTALabel,
    buyNowClickHandler,
    showSBBBuyNowBtnSpinner
  } = props;
  const [isSticky, setSticky] = useState(false);
  let buyBoxCompEL;
  const removeStickyClassName = "--sticky-none";
  const buttonType = isOOSCurrentStore ? "primary" : "call_to_action";
  const handleScroll = () => {
    buyBoxCompEL = document.getElementById(`${PREFIX}-buy-box`) || null;
    const buyBoxCompELHeight = (buyBoxCompEL == null ? void 0 : buyBoxCompEL.clientHeight) || 0;
    const buyBoxCompELTop = (buyBoxCompEL == null ? void 0 : buyBoxCompEL.offsetTop) || 0;
    const buyBoxContentHeight = buyBoxCompELHeight + buyBoxCompELTop;
    setStickyComponent(buyBoxContentHeight);
  };
  const getPrimaryNavHeight = () => {
    const primaryNav = document.querySelector(`.${PREFIX}-primary-navigation`) || null;
    return (primaryNav == null ? void 0 : primaryNav.clientHeight) || 0;
  };
  const setStickyComponent = (buyBoxContentHeight) => {
    window.pageYOffset > buyBoxContentHeight - getPrimaryNavHeight() ? setSticky(true) : setSticky(false);
  };
  useGlobalScrollEvent(handleScroll);
  const renderReviewComp = () => {
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref: stickyBuyBarRatingRef,
        className: `${PREFIX}-sticky-buy-bar__reviews`,
        "data-bv-show": "rating_summary",
        "data-bv-seo": "false",
        "data-bv-product-id": productId,
        role: "link",
        onClick: scrollToReviewsHandler,
        onKeyPress: scrollToReviewsHandler,
        tabIndex: 0
      }
    );
  };
  const checkAllPropsAreNull = (price) => Object.values(price).filter((val) => !!val).length === 0;
  const isSupressedPrice = currentPrice || originalPrice ? checkAllPropsAreNull(currentPrice) && checkAllPropsAreNull(originalPrice) : false;
  const isDisabledATC = isSupressedPrice;
  const showDesktopATCLabel = () => {
    return showAddToCartOnStickyBuyBox && !isBrowseOnlyMode && onlineOrdering && /* @__PURE__ */ jsx(
      Button,
      {
        id: "add-to-cart-sticky-buy-bar",
        type: buttonType,
        size: "large",
        onClick: addToCartClickHandler,
        disabled: isDisabledATC,
        label: desktopATCLabel,
        showSpinner: showBBSpinner
      }
    );
  };
  const showDesktopBuyNowLabel = () => {
    return isShowBuyNowBtn && /* @__PURE__ */ jsx(
      Button,
      {
        id: "buy-now-sticky",
        type: "primary",
        onClick: buyNowClickHandler,
        size: "large",
        label: buyNowCTALabel,
        modifierClass: "buy-now-btn",
        showSpinner: showSBBBuyNowBtnSpinner
      }
    );
  };
  const saveMessage = useGenerateSaveMessage(saleCut, originalPrice, saleMessagesRules, currentPrice);
  const showPriceComponent = () => {
    return /* @__PURE__ */ jsx(
      Price,
      {
        unitPriceLabel,
        clearancePriceLabel,
        a11yStrikeOutPrice,
        a11yStrikeOutPriceRange,
        feeTitle,
        originalPrice,
        currentPrice,
        displayWasLabel,
        language: language2,
        priceMessage,
        feeDisclaimerType,
        a11yRecycleFeesTriangleIcon,
        nowFromLabel: props.nowFromLabel,
        saveFromLabel: props.saveFromLabel,
        wasFromLabel: props.wasFromLabel,
        fromLabel: props.fromLabel,
        feeDisclaimerMessage,
        feeDisclaimerTitle,
        eachLabel: props.eachLabel,
        showFromNow: true,
        isRangeView,
        saveMessage,
        a11yClickToReadFootnote,
        isOnSaleOrClearance: hasSaleOrClearanceBadge,
        plusMinusSymbol
      }
    );
  };
  const renderUrgencyMessage2 = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-sticky-buy-bar__sale-ends-message`, children: /* @__PURE__ */ jsx(UrgencyMessage, { saleEndDaySoonMessage, salePriceEndDate: productSaleEndDate }) });
  };
  const productInformation = () => {
    return /* @__PURE__ */ jsx(ProductInformation, { brand, brandUrl, title, isSticky: true });
  };
  useEffect(() => {
    setIsStickyBBInView(isSticky);
  }, [isSticky, setIsStickyBBInView]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-sticky-buy-bar-hide-content`, children: /* @__PURE__ */ jsx(
    "div",
    {
      "data-testid": "sticky-bar",
      id: `${PREFIX}-sticky-buy-bar`,
      className: `${PREFIX}-row ${PREFIX}-sticky-buy-bar ${PREFIX}-sticky-buy-bar${isSticky ? "--sticky" : removeStickyClassName} ${PREFIX}-full-width-container `,
      children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-container ${PREFIX}-sticky-buy-bar__container`, children: [
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-sticky-buy-bar__product-img`, children: /* @__PURE__ */ jsx(
          "img",
          {
            "data-component-name": "sticky-buy-box",
            src: productImageUrl,
            alt: brand,
            className: `${PREFIX}-sticky-buy-bar__responsive-img`
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-sticky-buy-bar__wrapper`, children: [
          /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-sticky-buy-bar__product-info`, children: [
            productInformation(),
            " ",
            renderReviewComp()
          ] }),
          /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-sticky-buy-bar__price-section`, children: [
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-sticky-buy-bar__product-price`, children: showPriceComponent() }),
            productSaleEndDate ? renderUrgencyMessage2() : null
          ] })
        ] }),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-sticky-buy-bar__cta`, children: showDesktopATCLabel() }),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-sticky-buy-bar__buy-now`, children: showDesktopBuyNowLabel() })
      ] })
    }
  ) }) });
};
StickyBuyBar.propTypes = {
  brandUrl: PropTypes.string,
  brand: PropTypes.string,
  title: PropTypes.string,
  desktopATCLabel: PropTypes.string,
  unitPriceLabel: PropTypes.string,
  clearancePriceLabel: PropTypes.string,
  productImageUrl: PropTypes.string,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  onlineOrdering: PropTypes.bool,
  feeTitle: PropTypes.string,
  originalPrice: PropTypes.any,
  currentPrice: PropTypes.any,
  displayWasLabel: PropTypes.bool,
  language: PropTypes.string,
  addToCartClickHandler: PropTypes.func.isRequired,
  showAddToCartOnStickyBuyBox: PropTypes.bool.isRequired,
  priceMessage: PropTypes.array,
  a11yRecycleFeesTriangleIcon: PropTypes.string,
  nowFromLabel: PropTypes.string,
  saveFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  feeDisclaimerType: PropTypes.string,
  feeDisclaimerMessage: PropTypes.string,
  feeDisclaimerTitle: PropTypes.string,
  eachLabel: PropTypes.string.isRequired,
  setIsStickyBBInView: PropTypes.func.isRequired,
  showBBSpinner: PropTypes.bool,
  isOOSCurrentStore: PropTypes.bool,
  isBrowseOnlyMode: PropTypes.bool,
  a11yClickToReadFootnote: PropTypes.string,
  scrollToReviewsHandler: PropTypes.func.isRequired,
  saleEndDaySoonMessage: PropTypes.string,
  productSaleEndDate: PropTypes.string,
  isRangeView: PropTypes.bool
};
StickyBuyBar.displayName = "StickyBuyBar";
const getAccessibilityId = (componentId, skuId) => `${componentId}-${skuId || ""}`;
const getAccessibilityTitleId = (id) => `title__${id}`;
const wishlistPrefixId = (id) => `wishlist__${id}`;
const getAccessibilityPriceId = (id) => `price__${id}`;
const getAccessibilityAvailabilityId = (id) => `availability__${id}`;
const getAccessibilityPromoId = (id) => `promo__${id}`;
const getPageType = () => {
  var _a;
  return ((_a = document.getElementsByTagName("body")[0]) == null ? void 0 : _a.getAttribute("data-pagetype")) || "";
};
const checkNavigationUrl = (navigation) => {
  const currentUrl = window.location.href;
  return navigation && navigation.findIndex((item) => currentUrl.includes(decodeURIComponent(item.navigationRedirectionLink)));
};
const scrollToElement = (element) => {
  var _a, _b;
  const stickyNav = document.getElementById(`${PREFIX}-nav`);
  const primaryNav = document.getElementsByClassName(`${PREFIX}-primary-navigation-bar`)[0];
  const primaryNavHeight = (primaryNav == null ? void 0 : primaryNav.clientHeight) || 0;
  const primaryNavPos = (primaryNav == null ? void 0 : primaryNav.getBoundingClientRect().y) || 0;
  const secondaryNavHeight = ((_a = document.getElementsByClassName(`${PREFIX}-secondary-navigation-bar`)[0]) == null ? void 0 : _a.clientHeight) || 0;
  const stickyBuyBar = document.getElementById(`${PREFIX}-sticky-buy-bar`);
  const stickyBuyBarHeight = (stickyBuyBar == null ? void 0 : stickyBuyBar.clientHeight) || 0;
  const shiftStickyBuyBar = stickyBuyBarHeight * magicNumber.TWO;
  const elementOffSet = (_b = element == null ? void 0 : element.getClientRects()[0]) == null ? void 0 : _b.top;
  const scrollPos = document.documentElement.scrollTop;
  if (element) {
    const isRoadRated = element.id === "road-rating";
    const sectionTop = isRoadRated ? (
      // eslint-disable-next-line sonar/no-nested-conditional
      stickyBuyBar ? elementOffSet - shiftStickyBuyBar : elementOffSet
    ) : (
      // eslint-disable-next-line sonar/no-nested-conditional
      stickyNav ? elementOffSet - secondaryNavHeight - primaryNavPos - primaryNavHeight - stickyNav.clientHeight : elementOffSet - secondaryNavHeight - primaryNavPos - primaryNavHeight
    );
    window.scroll({
      top: sectionTop + scrollPos,
      behavior: "smooth"
    });
    isRoadRated && element.setAttribute("tabindex", `${magicNumber.MINUS_ONE}`);
    element == null ? void 0 : element.focus();
  }
};
const scrollToFooterHandler = (event) => {
  event.stopPropagation();
  event.preventDefault();
  const element = document.getElementById("legal-disclaimer-container");
  scrollToElement(element);
};
const scrollToFooter = scrollToFooterHandler;
const LOYALTY_BADGE_WEB = "LOYALTYWEB";
const renderUrgencyMessage = (saleEndDaySoonMessage, salePriceEndDate, saleEndDisableShift) => {
  return /* @__PURE__ */ jsx(
    UrgencyMessage,
    {
      saleEndDaySoonMessage,
      salePriceEndDate,
      saleEndDisableShift
    }
  );
};
const renderSaleEndDaySoonMessageComp = (salePriceEndDate, isOnSale, isUrgentLowStock, isShoppingCart, hideSaleEndDaySoonMessage, saleEndDaySoonMessage, saleEndDisableShift) => {
  const saleBadgeDisplay = salePriceEndDate ? (
    // eslint-disable-next-line sonar/no-nested-conditional
    `${PREFIX}-shopping-cart__product__sale-end-day-soon-message${isOnSale && !isUrgentLowStock ? "--red" : ""}`
  ) : `${PREFIX}-shopping-cart__product__sale-end-day-soon-message--hide`;
  return salePriceEndDate && (!!isShoppingCart ? /* @__PURE__ */ jsx("div", { className: saleBadgeDisplay, children: renderUrgencyMessage(saleEndDaySoonMessage, salePriceEndDate, saleEndDisableShift) }) : (
    // eslint-disable-next-line sonar/no-nested-conditional
    hideSaleEndDaySoonMessage ? null : /* @__PURE__ */ jsx("div", { className: `${PREFIX}-buy-box__sale-end-day-soon-message`, children: /* @__PURE__ */ jsx("p", { className: `${PREFIX}-body-md`, children: renderUrgencyMessage(saleEndDaySoonMessage, salePriceEndDate, saleEndDisableShift) }) })
  ));
};
const replaceStringCharacter = (existingBadgeLabel, loyaltyValue, customClass) => {
  var _a;
  return replaceStrWithDynamicElement(
    existingBadgeLabel,
    /* @__PURE__ */ jsxs("span", { className: customClass, children: [
      (_a = loyaltyValue == null ? void 0 : loyaltyValue.Bonus) == null ? void 0 : _a.OfferRewardValue,
      " "
    ] })
  );
};
const getMaxPrioritizedBadges = (badgeIds, priorityAndColour, maxBadgesToDisplay) => {
  const priorityAndColourCopy = [...priorityAndColour];
  priorityAndColourCopy.sort((badge1, badge2) => badge1.priority - badge2.priority);
  const availableBadges = priorityAndColourCopy.filter((badge) => badgeIds.includes(badge.badgeId));
  return availableBadges.slice(0, maxBadgesToDisplay);
};
const updateDynamicBadges = (badges, priorityAndColour, enableRewardValBadge, loyaltyValue) => {
  const deLimiter = "|";
  const idxForMultipler = 1;
  const updatedBadges = [...badges];
  const updatedpriorityAndColour = priorityAndColour.map((item) => ({ ...item }));
  const isLoyaltyValueEmpty = !checkDataLength(loyaltyValue);
  isArrayNotEmpty(updatedBadges) && updatedBadges.forEach(function(badge, index2, updatedBadgesArr) {
    const badgewithMultiplier = badge == null ? void 0 : badge.split(deLimiter);
    if (isArrayNotEmpty(badgewithMultiplier) && badgewithMultiplier.length > idxForMultipler) {
      const bonusBadge = areAllParamsValid(enableRewardValBadge, !isLoyaltyValueEmpty) ? LOYALTY_BADGE_WEB : badgewithMultiplier == null ? void 0 : badgewithMultiplier[0];
      updatedBadgesArr[index2] = bonusBadge;
      const multiplierLabel = badgewithMultiplier == null ? void 0 : badgewithMultiplier[idxForMultipler];
      const idxDynamicBadge = updatedpriorityAndColour == null ? void 0 : updatedpriorityAndColour.findIndex((item) => item.badgeId === bonusBadge);
      if (idxDynamicBadge >= 0) {
        const existingBadgeLabel = updatedpriorityAndColour[idxDynamicBadge].badgeLabel;
        const bonusBadgeLabel = replaceStringCharacter(
          existingBadgeLabel,
          loyaltyValue,
          `${PREFIX}-loyalty-crv`
        );
        updatedpriorityAndColour[idxDynamicBadge].badgeLabel = areAllParamsValid(
          enableRewardValBadge,
          !isLoyaltyValueEmpty
        ) ? bonusBadgeLabel : `${multiplierLabel} ${existingBadgeLabel}`;
      }
    }
  });
  return { updatedBadges, updatedpriorityAndColour };
};
const Badges = ({ ...props }) => {
  const {
    badges,
    badgesAndPriorities,
    hideDisclaimer = false,
    clickable = false,
    saleEndDaySoonMessage = null,
    salePriceEndDate = null,
    isShoppingCart = false,
    analyticsLabelValue = null,
    saleEndDisableShift = false,
    hideSaleEndDaySoonMessage,
    isOnSale = false,
    isUrgentLowStock = false,
    loyaltyValue
  } = props;
  const [badgesToShow, setBadgesToShow] = useState([]);
  useEffect(() => {
    if (badges && badges.length) {
      const { maxNumberToDisplay, priorityAndColour = [], enableRewardValBadge } = badgesAndPriorities || {};
      const { updatedBadges, updatedpriorityAndColour } = updateDynamicBadges(
        badges,
        priorityAndColour,
        enableRewardValBadge,
        loyaltyValue
      );
      setBadgesToShow(getMaxPrioritizedBadges(updatedBadges, updatedpriorityAndColour, maxNumberToDisplay));
    } else {
      setBadgesToShow([]);
    }
  }, [badges, badgesAndPriorities, loyaltyValue]);
  const badgeWithDisclaimer = badgesToShow.filter((badge) => badge.disclaimer)[0];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    badgesToShow.map((badge) => /* @__PURE__ */ jsx(
      Tag,
      {
        type: "product",
        subType: badge.colorId ? `product--${badge.colorId}` : "",
        withBorder: badge.colorId === "tested",
        badgeUrl: clickable ? badge.badgeUrl : null,
        analyticsLabelValue: (analyticsLabelValue == null ? void 0 : analyticsLabelValue[badge.badgeId]) ?? "",
        children: badge.badgeLabel
      },
      badge.badgeId
    )),
    !isOnSale && renderSaleEndDaySoonMessageComp(
      salePriceEndDate,
      isOnSale,
      isUrgentLowStock,
      isShoppingCart,
      hideSaleEndDaySoonMessage,
      saleEndDaySoonMessage,
      saleEndDisableShift
    ),
    !hideDisclaimer && badgeWithDisclaimer && /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-badge-disclaimer`,
        dangerouslySetInnerHTML: { __html: sanitizeStringContent(badgeWithDisclaimer.disclaimer) }
      }
    )
  ] });
};
Badges.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.string).isRequired,
  badgesAndPriorities: PropTypes.any,
  hideDisclaimer: PropTypes.bool,
  clickable: PropTypes.bool,
  saleEndDaySoonMessage: PropTypes.string,
  salePriceEndDate: PropTypes.string,
  isShoppingCart: PropTypes.bool,
  analyticsLabelValue: PropTypes.any,
  saleEndDisableShift: PropTypes.bool
};
const constantValues = {
  acceptedBadges: ["PROMO", "CLEARANCE", "SALE"]
};
const ProductListCard = (props) => {
  var _a, _b;
  const {
    productProps: { ratingsAndReview, a11yPriceRangeFrom, a11yPriceRangeTo },
    product,
    title,
    badgePriorities,
    saleEndDisableShift,
    brand,
    url,
    badges,
    discount,
    hideDescription,
    hideSaveLabel,
    a11yStrikeOutPrice,
    a11yStrikeOutPriceRange,
    a11yCloseIconLabel,
    a11yTooltipIcon,
    images,
    currentPrice,
    originalPrice,
    displayWasLabel,
    language: language2,
    feeTitle,
    feeDisclaimerMessage,
    feeDisclaimerTitle,
    priceMessage,
    nowFromLabel,
    saveFromLabel,
    wasFromLabel,
    fromLabel,
    feeDisclaimerType,
    imageDataComponentName,
    returnPolicy,
    overridePriceHeight,
    unitPriceLabel,
    clearancePriceLabel,
    promotionalPriceLabel,
    thresholdValue,
    enableSaveStory,
    isWheelOrTirePDP,
    eachLabel,
    isLazyRequire,
    productDataId,
    saleMessagesRules,
    a11yClickToReadFootnote,
    accessibilityId,
    addToCartClickHandler,
    isYouNeedThis,
    isProductAdded,
    addedToCartLabel,
    plusMinusSymbol,
    isOnSale,
    isMultiSkuProduct,
    optionsCTA,
    isPriceRangeViewEnabled = false,
    showSpinner,
    atcClickedProductCode,
    optionsAriaLabel,
    addToCartLabel,
    isOutOfStock,
    enableMiniPDPFlyoutInDigiFlyer = false,
    optionClickHandler,
    earnCTMLabel,
    isFetchingData,
    clickedOptionsProductCode
  } = props;
  const selectedProductCode = (_b = (_a = product == null ? void 0 : product.skus) == null ? void 0 : _a[magicNumber.ZERO]) == null ? void 0 : _b.code;
  const imageAttributes2 = (path, dataComponentName) => {
    const attributeObject = {
      "data-component-name": dataComponentName
    };
    if (isLazyRequire) {
      attributeObject["data-src"] = path;
      attributeObject.className = "lazyload";
    } else {
      attributeObject.src = path;
    }
    return attributeObject;
  };
  const createUrlWithPolicy2 = (source, policyType) => {
    var _a2;
    return policyType ? `${(_a2 = source == null ? void 0 : source.toString()) == null ? void 0 : _a2.split("?", magicNumber.ONE).toString()}${returnPolicy(policyType)}` : `${source}`;
  };
  const ratingsView = () => {
    return ratingsAndReview && /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-reviews__list`,
        "data-bv-show": "inline_rating",
        "data-bv-product-id": productDataId,
        "data-bv-seo": "false",
        "aria-hidden": true
      }
    );
  };
  const renderEarnCTMLabel = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-list-card__earn-ctm`, children: /* @__PURE__ */ jsx("span", { children: earnCTMLabel }) });
  };
  const currentLevelData = useMemo(() => {
    return {
      ...product,
      originalPrice,
      currentPrice,
      badges,
      displayWasLabel,
      priceMessage
    };
  }, [product, originalPrice, currentPrice, badges, displayWasLabel, priceMessage]);
  const saveMessage = useGenerateSaveMessage(
    currentLevelData == null ? void 0 : currentLevelData.saleCut,
    currentLevelData == null ? void 0 : currentLevelData.originalPrice,
    saleMessagesRules,
    currentLevelData == null ? void 0 : currentLevelData.currentPrice
  );
  const getBadgeComponent = () => {
    const badgeList = (product == null ? void 0 : product.isOnSale) && (product == null ? void 0 : product.badges) ? product == null ? void 0 : product.badges.filter((badge) => constantValues.acceptedBadges.includes(badge)) : [];
    if (isArrayNotEmpty(badgeList)) {
      return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-list-card__cart-badges`, children: /* @__PURE__ */ jsx(
        Badges,
        {
          badges: badgeList,
          badgesAndPriorities: badgePriorities,
          hideDisclaimer: true,
          saleEndDaySoonMessage: props.saleEndDaySoonMessage,
          isShoppingCart: false,
          saleEndDisableShift,
          isOnSale
        }
      ) });
    }
    return null;
  };
  const renderPriceComponent = () => {
    return /* @__PURE__ */ jsx(
      Price,
      {
        isRangeView: isPriceRangeViewEnabled,
        discountValue: discount,
        promotionalPriceLabel: discount ? promotionalPriceLabel : null,
        thresholdValue,
        unitPriceLabel,
        clearancePriceLabel,
        a11yPriceRangeFrom,
        a11yPriceRangeTo,
        hideSaveLabel,
        a11yStrikeOutPrice,
        a11yStrikeOutPriceRange,
        a11yTooltipIcon,
        a11yCloseIconLabel,
        feeTitle,
        feeDisclaimerTitle,
        feeDisclaimerMessage,
        currentPrice: currentLevelData == null ? void 0 : currentLevelData.currentPrice,
        originalPrice: currentLevelData == null ? void 0 : currentLevelData.originalPrice,
        displayWasLabel: currentLevelData == null ? void 0 : currentLevelData.displayWasLabel,
        language: language2,
        priceMessage: currentLevelData == null ? void 0 : currentLevelData.priceMessage,
        scrollToFooter,
        nowFromLabel,
        saveFromLabel,
        wasFromLabel,
        fromLabel,
        feeDisclaimerType,
        overridePriceHeight,
        showEachTextForSaveLabel: enableSaveStory,
        isAutomotiveEachLabel: isWheelOrTirePDP,
        eachLabel,
        saveMessage,
        a11yClickToReadFootnote,
        accessibilityPriceId: getAccessibilityPriceId(accessibilityId),
        ariaHidden: true,
        highlightDiscountedPrice: true,
        plusMinusSymbol,
        isOnSale,
        displayBadgeComponentBesidePrice: getBadgeComponent()
      }
    );
  };
  const handleAddToCart = () => {
    var _a2, _b2, _c, _d;
    addToCartClickHandler((_b2 = (_a2 = product == null ? void 0 : product.skus) == null ? void 0 : _a2[magicNumber.ZERO]) == null ? void 0 : _b2.code, (_d = (_c = product == null ? void 0 : product.skus) == null ? void 0 : _c[magicNumber.ZERO]) == null ? void 0 : _d.productType);
  };
  const showUpdatedATCSpinner = (productCode) => {
    return atcClickedProductCode === productCode ? showSpinner : false;
  };
  const onClickFunction = (event) => {
    if (enableMiniPDPFlyoutInDigiFlyer && (isMultiSkuProduct || isOutOfStock)) {
      optionClickHandler(product == null ? void 0 : product.code, false);
      const optionButton = event.currentTarget;
      optionButton.setAttribute(previousElementName, "true");
    } else if (isMultiSkuProduct) {
      window.location.href = sanitizeStringContent(url);
    } else {
      !showUpdatedATCSpinner(selectedProductCode) && handleAddToCart();
    }
  };
  const showOptionsSpinner = () => {
    const removeCharacters = (code) => code.replace(/\D/g, "");
    return isFetchingData && removeCharacters(clickedOptionsProductCode) === selectedProductCode;
  };
  const renderAddToCartButton = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: !isProductAdded || enableMiniPDPFlyoutInDigiFlyer ? /* @__PURE__ */ jsx(
      SpinnerButton,
      {
        size: Size.MINI,
        color: enableMiniPDPFlyoutInDigiFlyer ? ButtonColors.DARK : ButtonColors.DEFAULT,
        variant: enableMiniPDPFlyoutInDigiFlyer ? Variation.PRIMARY : Variation.SECONDARY,
        onClick: (event) => {
          event.preventDefault();
          onClickFunction(event);
        },
        a11y: {
          label: isMultiSkuProduct || isOutOfStock ? optionsAriaLabel : addToCartLabel
        },
        showSpinner: showOptionsSpinner() || showUpdatedATCSpinner(selectedProductCode),
        spinner: enableMiniPDPFlyoutInDigiFlyer && {
          color: "#fff"
        },
        icon: enableMiniPDPFlyoutInDigiFlyer && !isOutOfStock ? {
          type: "ct-cart",
          size: "md"
        } : null,
        children: isMultiSkuProduct || isOutOfStock ? optionsCTA : addToCartLabel
      }
    ) : /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-list-card__btn-added-to-cart`, role: "alert", "aria-live": "polite", children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }),
      addedToCartLabel
    ] }) });
  };
  const handleRedirection = (event) => {
    if (enableMiniPDPFlyoutInDigiFlyer) {
      event.preventDefault();
      optionClickHandler(product == null ? void 0 : product.code, true);
    }
  };
  return /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: url, children: (memoizedStringContent) => {
    var _a2, _b2, _c;
    return /* @__PURE__ */ jsxs(
      "a",
      {
        className: `${PREFIX}-product-list-card`,
        "aria-labelledby": `title__${accessibilityId} price__${accessibilityId}`,
        href: memoizedStringContent,
        onClick: handleRedirection,
        children: [
          /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-list-card__image-wrap`, children: /* @__PURE__ */ jsx(
            "img",
            {
              alt: title,
              ...imageAttributes2(
                isArrayNotEmpty(images) && `${createUrlWithPolicy2((_a2 = images == null ? void 0 : images[0]) == null ? void 0 : _a2.url, imageDataComponentName)}`,
                imageDataComponentName
              )
            }
          ) }),
          /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-list-card__product-details`, children: [
            /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-info`, children: [
              " ",
              /* @__PURE__ */ jsx(
                ProductInformation,
                {
                  brand,
                  title,
                  hideDescription,
                  titleStyle: `${PREFIX}-product-card__title`,
                  titleContainerStyle: `${PREFIX}-product-card__title-container`,
                  accessibilityTitleId: getAccessibilityTitleId(accessibilityId),
                  sku: enableMiniPDPFlyoutInDigiFlyer && ((_c = (_b2 = product == null ? void 0 : product.skus) == null ? void 0 : _b2[magicNumber.ZERO]) == null ? void 0 : _c.formattedCode)
                }
              )
            ] }),
            ratingsView(),
            renderPriceComponent(),
            !!earnCTMLabel && renderEarnCTMLabel(),
            isYouNeedThis && renderAddToCartButton()
          ] })
        ]
      }
    );
  } });
};
ProductListCard.propTypes = {
  productProps: PropTypes.any,
  product: PropTypes.any,
  title: PropTypes.string,
  brand: PropTypes.string,
  url: PropTypes.string,
  badges: PropTypes.array,
  discount: PropTypes.any,
  hideDescription: PropTypes.bool,
  hideSaveLabel: PropTypes.bool,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string,
  a11yTooltipIcon: PropTypes.string,
  images: PropTypes.array,
  currentPrice: PropTypes.shape({
    value: PropTypes.number.isRequired,
    minPrice: PropTypes.number.isRequired,
    maxPrice: PropTypes.number.isRequired
  }),
  originalPrice: PropTypes.shape({
    value: PropTypes.number.isRequired,
    minPrice: PropTypes.number.isRequired,
    maxPrice: PropTypes.number.isRequired
  }),
  displayWasLabel: PropTypes.bool,
  language: PropTypes.string,
  feeTitle: PropTypes.string,
  feeDisclaimerMessage: PropTypes.string,
  feeDisclaimerTitle: PropTypes.string,
  priceMessage: PropTypes.array,
  nowFromLabel: PropTypes.string,
  saveFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  feeDisclaimerType: PropTypes.string,
  imageDataComponentName: PropTypes.string,
  returnPolicy: PropTypes.func,
  overridePriceHeight: PropTypes.bool,
  unitPriceLabel: PropTypes.string,
  clearancePriceLabel: PropTypes.string,
  promotionalPriceLabel: PropTypes.string,
  thresholdValue: PropTypes.number,
  enableSaveStory: PropTypes.bool,
  isWheelOrTirePDP: PropTypes.bool,
  eachLabel: PropTypes.string,
  isLazyRequire: PropTypes.bool,
  productDataId: PropTypes.string,
  saleMessagesRules: PropTypes.array,
  a11yClickToReadFootnote: PropTypes.string,
  accessibilityId: PropTypes.string,
  addToCartClickHandler: PropTypes.func,
  isYouNeedThis: PropTypes.bool,
  isProductAdded: PropTypes.bool,
  addedToCartLabel: PropTypes.string
};
const showOptionsBtn = (productData) => {
  const { fulfillment, sellable, orderable } = productData;
  const qty = fulfillment == null ? void 0 : fulfillment.quantity;
  const isCorpObj = fulfillment == null ? void 0 : fulfillment.Corporate;
  const DCQty = isCorpObj ? isCorpObj.Quantity : 0;
  const isProductSellable = sellable === true;
  const isProductOrderable = orderable === true;
  const isProductInStock = qty > 0 || DCQty > 0 && isProductOrderable;
  return !(isProductSellable && isProductInStock && isGenMerchSingleSku(productData));
};
const isGenMerchSingleSku = (productData) => {
  const { fitmentTypeCode, productWheelType, isMultiSku } = productData;
  return areAllParamsValid(!fitmentTypeCode, !productWheelType, !isMultiSku);
};
const RecommendationsList = (props) => {
  const {
    title,
    productList,
    path,
    priceProps,
    productCardClick,
    maximumNumberOfRecommendations,
    a11yStrikeOutPrice,
    a11yStrikeOutPriceRange,
    badgePriorities,
    language: language2,
    imageDataComponentName,
    enableBadges,
    enableSaveStory,
    returnPolicy,
    a11yClickToReadFootnote,
    selectedSchemaId,
    addToCartClickHandler,
    addToCartLabel,
    addedToCartLabel,
    isYouNeedThis,
    miniCartData,
    plusMinusSymbol,
    enableATCFlyOut,
    optionsCTA,
    showSpinner,
    atcClickedProductCode,
    optionsAriaLabel,
    itemsLabel,
    enableMiniPDPFlyoutInDigiFlyer,
    optionClickHandler,
    isFetchingData,
    clickedOptionsProductCode
  } = props;
  const {
    unitPriceLabel,
    clearancePriceLabel,
    promotionalPriceLabel,
    threshold,
    nowFromLabel,
    saveFromLabel,
    wasFromLabel,
    fromLabel
  } = priceProps;
  const productProps = {
    ratingsAndReview: true,
    featureHeaderLabel: "",
    variantAvailableMsg: "",
    moreLabel: "",
    unitPriceLabel,
    clearancePriceLabel,
    promotionalPriceLabel,
    thresholdValue: threshold,
    nowFromLabel,
    saveFromLabel,
    wasFromLabel,
    fromLabel
  };
  const getProductCarouselList = () => {
    return productList.slice(0, maximumNumberOfRecommendations).map((product, index2) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
      let isProductAdded = false;
      const {
        type,
        title: productTitle,
        brand,
        images,
        rating,
        ratingsCount,
        price,
        featureBullets,
        discount,
        badges,
        priceMessage,
        currentPrice,
        originalPrice,
        displayWasLabel,
        feeMessages,
        url,
        code,
        skus,
        isMultiSku,
        isOnSale = false
      } = product;
      const selectedProductCode = (skus == null ? void 0 : skus.length) === 1 ? (_a = skus == null ? void 0 : skus[0]) == null ? void 0 : _a.code : code.slice(0, -1);
      if (checkDataLength(miniCartData) && ((_b = miniCartData == null ? void 0 : miniCartData.orderEntries) == null ? void 0 : _b.some((cartData) => (cartData == null ? void 0 : cartData.code) === selectedProductCode))) {
        isProductAdded = true;
      }
      const productBadges = enableBadges ? badges : [];
      const pageType = getPageType();
      const urlParams = {
        rrecName: title,
        rrecReferrer: pageType,
        rrecProductId: code,
        rrecProductSlot: index2 + magicNumber.ONE,
        rrecSchemeId: selectedSchemaId,
        rrec: true
      };
      let isMultiSkuProduct = isMultiSku;
      if (enableATCFlyOut) {
        isMultiSkuProduct = areAllParamsValid(!isGenMerchSingleSku(product), enableATCFlyOut);
      }
      const isOutOfStock = enableMiniPDPFlyoutInDigiFlyer && showOptionsBtn(product);
      return /* @__PURE__ */ jsx(
        ProductListCard,
        {
          product,
          url: appendQueryParamsToUrl(url, urlParams),
          productProps,
          path,
          idx: index2,
          cardType: "grid",
          title: productTitle,
          type,
          code: ((_c = product == null ? void 0 : product.skus) == null ? void 0 : _c.length) === magicNumber.ONE ? (_e = (_d = product == null ? void 0 : product.skus) == null ? void 0 : _d[0]) == null ? void 0 : _e.formattedCode : "",
          brand,
          images,
          rating,
          ratingsCount: ratingsCount || 0,
          price,
          discount,
          featureBullets,
          productCardClick: (event, productdata, idx) => productCardClick(event, productdata, idx),
          a11yStrikeOutPrice,
          a11yStrikeOutPriceRange,
          showRatingSection: true,
          badges: productBadges,
          badgePriorities,
          language: language2,
          feeTitle: ((_f = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _f.value) ? replaceStrWithDynamicVal(
            addDynamicToken((_g = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _g.feeTitle, "$x"),
            getFormattedPriceValue(language2, (_h = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _h.value)
          ) : "",
          feeDisclaimerType: (_i = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _i.type,
          feeDisclaimerMessage: (_j = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _j.feeDisclaimerMessage,
          feeDisclaimerTitle: (_k = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _k.feeDisclaimerTitle,
          currentPrice,
          originalPrice,
          priceMessage,
          nowFromLabel,
          saveFromLabel,
          wasFromLabel,
          fromLabel,
          displayWasLabel,
          imageDataComponentName,
          returnPolicy,
          unitPriceLabel,
          promotionalPriceLabel,
          clearancePriceLabel,
          thresholdValue: threshold,
          enableSaveStory,
          productDataId: code,
          a11yClickToReadFootnote,
          addToCartClickHandler,
          accessibilityId: getAccessibilityId(
            selectedSchemaId,
            ((_m = (_l = product == null ? void 0 : product.skus) == null ? void 0 : _l[0]) == null ? void 0 : _m.code) ? (_o = (_n = product == null ? void 0 : product.skus) == null ? void 0 : _n[0]) == null ? void 0 : _o.code : code
          ),
          addToCartLabel,
          addedToCartLabel,
          isYouNeedThis,
          isProductAdded,
          plusMinusSymbol,
          isMultiSkuProduct,
          optionsCTA,
          showSpinner,
          atcClickedProductCode,
          optionsAriaLabel,
          isOnSale,
          isOutOfStock,
          enableMiniPDPFlyoutInDigiFlyer,
          optionClickHandler,
          isFetchingData,
          clickedOptionsProductCode
        },
        index2
      );
    });
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-recommendations`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-recommendations__title`, "data-testid": "recommendations-title", children: /* @__PURE__ */ jsx("h2", { children: title }) }),
    enableMiniPDPFlyoutInDigiFlyer && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-recommendations__count`, children: replaceStrWithDynamicVal(itemsLabel, productList.length) }),
    productList && productList.length > 0 && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product__list-view ${PREFIX}-product__list-items`, children: getProductCarouselList() })
  ] });
};
RecommendationsList.propTypes = {
  title: PropTypes.string,
  productList: PropTypes.array,
  path: PropTypes.string,
  priceProps: PropTypes.object,
  productCardClick: PropTypes.func,
  maximumNumberOfRecommendations: PropTypes.number,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  language: PropTypes.string.isRequired,
  imageDataComponentName: PropTypes.string,
  enableBadges: PropTypes.bool,
  enableSaveStory: PropTypes.bool,
  returnPolicy: PropTypes.func,
  a11yClickToReadFootnote: PropTypes.string,
  selectedSchemaId: PropTypes.string
};
const maxHeight = 160;
const getViewMoreDescriptionClass = (isViewMoreOrLess, showProductDescription, ProductDescriptionClass) => {
  return isViewMoreOrLess && showProductDescription ? ProductDescriptionClass : "";
};
const Overview = (props) => {
  const { bodyText, path, viewMoreDetailsLabel, viewLessDetailsLabel } = props;
  const isMobile2 = window.innerWidth <= BREAKPOINTS.tabletMaxWidth;
  const [showViewMoreOrLess, setShowViewMoreOrLess] = useState(false);
  const [viewMoreOrLess, setViewMoreOrLess] = useState(true);
  const buttonRef = useRef();
  const roadRatedSpecsEleLength = document.querySelectorAll(`.${PREFIX}-overviewcontent__roadratingspecs`).length;
  const isRoadRatedSpecs = document.querySelector(`.${PREFIX}-overviewcontent__roadratingspecs`);
  const isShowViewMoreOrLessBtn = isRoadRatedSpecs ? roadRatedSpecsEleLength > magicNumber.ONE : showViewMoreOrLess && isMobile2;
  const viewMoreDescriptionClass = getViewMoreDescriptionClass(
    viewMoreOrLess,
    isShowViewMoreOrLessBtn,
    `${PREFIX}-overviewcontent--collapsed`
  );
  const viewMoreRoadRatingSpecsClass = getViewMoreDescriptionClass(
    viewMoreOrLess,
    isShowViewMoreOrLessBtn,
    `${PREFIX}-overviewcontent--roadratingspecs-collapsed`
  );
  const descriptionEle = document.querySelector(`.${PREFIX}-overviewcontent`);
  useEffect(() => {
    if (descriptionEle instanceof HTMLElement) {
      setShowViewMoreOrLess(descriptionEle && descriptionEle.scrollHeight > maxHeight);
    }
  }, [setShowViewMoreOrLess, descriptionEle]);
  const viewMoreOrLessBtnClick = () => {
    var _a, _b;
    setViewMoreOrLess(!viewMoreOrLess);
    viewMoreOrLess ? (_a = buttonRef.current) == null ? void 0 : _a.classList.add("view-more-less-btn-focus") : (_b = buttonRef.current) == null ? void 0 : _b.classList.remove("view-more-less-btn-focus");
  };
  const showViewMoreOrLessBtn = () => {
    return isShowViewMoreOrLessBtn && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-overviewcontent__viewmoreorlessbtn`, children: /* @__PURE__ */ jsxs(Button, { type: "tertiary", onClick: () => viewMoreOrLessBtnClick(), ref: buttonRef, children: [
      viewMoreOrLess ? viewMoreDetailsLabel : viewLessDetailsLabel,
      /* @__PURE__ */ jsx(Icon, { type: viewMoreOrLess ? "ct-chevron-down" : "ct-chevron-up", size: "sm", path })
    ] }) });
  };
  const displayRoadRatedSpecifications = (iconType, iconTitle, iconDescription) => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-col-sm-12 ${PREFIX}-col-md-4 ${PREFIX}-col-xs-12 ${PREFIX}-display-content`, children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-overviewcontent__roadratingspecs`, children: [
      /* @__PURE__ */ jsx(Icon, { type: iconType, size: "lg" }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h4", { id: `head-${iconType}`, className: `${PREFIX}-overviewcontent__icon-title`, children: iconTitle }),
        /* @__PURE__ */ jsx("p", { children: iconDescription })
      ] })
    ] }) });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { id: "overview", className: `${PREFIX}-overviewcontent`, "data-testid": "overview", children: [
    checkDataLength(bodyText.longDescription) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-col-sm-12 ${PREFIX}-overviewcontent__grid`, children: /* @__PURE__ */ jsx("p", { className: `${PREFIX}-overviewcontent__description ${viewMoreDescriptionClass}`, children: bodyText.longDescription }) }),
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row ${viewMoreRoadRatingSpecsClass}`, children: /* @__PURE__ */ jsxs(
      "div",
      {
        className: viewMoreOrLess ? `${PREFIX}-overviewcontent--hidden` : `${PREFIX}-overviewcontent--display-content-wrapper`,
        children: [
          checkDataLength(props.isSnowPeakRated) && displayRoadRatedSpecifications(
            "ct-snwpeak",
            props.isSnowPeakRated.title,
            props.isSnowPeakRated.discription
          ),
          checkDataLength(props.isMudSnowRated) && displayRoadRatedSpecifications(
            "ct-madandsnow",
            props.isMudSnowRated.title,
            props.isMudSnowRated.discription
          ),
          checkDataLength(props.isLowResistanceRated) && displayRoadRatedSpecifications(
            "ct-lowresistance",
            props.isLowResistanceRated.title,
            props.isLowResistanceRated.discription
          ),
          checkDataLength(props.isAcceptStuds) && displayRoadRatedSpecifications(
            "ct-acceptstuds",
            props.isAcceptStuds.title,
            props.isAcceptStuds.discription
          )
        ]
      }
    ) }),
    showViewMoreOrLessBtn()
  ] }) });
};
Overview.propTypes = {
  bodyText: PropTypes.any,
  isSnowPeakRated: PropTypes.any,
  isMudSnowRated: PropTypes.any,
  isLowResistanceRated: PropTypes.any,
  isAcceptStuds: PropTypes.any
};
const Specifications = ({ ...props }) => {
  const {
    tableData,
    specificationContent,
    path,
    defaultState = true,
    mobileAccordionMode = true,
    specificationTitle,
    isPrerender
  } = props;
  const defaultSpecifications = useMemo(
    () => tableData.slice(0, specificationContent.rowsOnLoad),
    [tableData, specificationContent.rowsOnLoad]
  );
  const isDefaultSpecificationsEven = () => {
    return defaultSpecifications.length % magicNumber.TWO === 0;
  };
  const expandedSpecifications = useMemo(
    () => tableData.slice(specificationContent.rowsOnLoad),
    [tableData, specificationContent.rowsOnLoad]
  );
  const [isExpanded, setIsExpanded] = useState(isPrerender);
  const toggleExpandedStatus = () => {
    setIsExpanded(!isExpanded);
  };
  const getSpecificationsExpandButtonText = () => {
    return isExpanded ? specificationContent.showLessLabel : specificationContent.showMoreLabel;
  };
  const getSpecificationsExpandIcon = () => {
    return /* @__PURE__ */ jsx(Icon, { size: "sm", type: isExpanded ? "ct-chevron-up" : "ct-chevron-down", path });
  };
  const getSpecificationsTableElement = (tableDataLocal, ariaLabel, tableModifierClass, tableId) => {
    return /* @__PURE__ */ jsx(
      Table,
      {
        tableType: "stripped",
        headerType: "column",
        tableData: tableDataLocal,
        ariaLabel,
        tableModifierClass,
        tableId
      }
    );
  };
  const getSpecifications2 = () => {
    const tableModifierClass = isDefaultSpecificationsEven() ? "" : `${PREFIX}-table--expanded-specifications`;
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-specifications-table`, children: [
      getSpecificationsTableElement(
        defaultSpecifications,
        specificationTitle,
        isExpanded ? `${PREFIX}-table--default-specifications` : ""
      ),
      tableData.length > specificationContent.rowsOnLoad && /* @__PURE__ */ jsxs(
        Button,
        {
          type: "tertiary",
          onClick: toggleExpandedStatus,
          ariaExpanded: isExpanded,
          ariaControls: "expanded-specifications",
          modifierClass: `${PREFIX}-button--expand-specifications`,
          children: [
            getSpecificationsExpandButtonText(),
            getSpecificationsExpandIcon()
          ]
        }
      ),
      isExpanded ? getSpecificationsTableElement(
        expandedSpecifications,
        specificationContent.expandedSpecificationsTitle,
        tableModifierClass,
        "expanded-specifications"
      ) : null
    ] });
  };
  const [isMobile2, setIsMobile] = useState(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  };
  useGlobalResizeEvent(handleResize);
  const renderSpecifications = () => {
    const prerenderClass = isPrerender ? `${PREFIX}-md-none` : "";
    return isMobile2 && mobileAccordionMode ? /* @__PURE__ */ jsx("div", { id: "specifications", className: `${PREFIX}-section ${PREFIX}-specification`, children: /* @__PURE__ */ jsx(Accordion, { title: specificationTitle, isHeaderOpen: defaultState, children: getSpecifications2() }) }) : /* @__PURE__ */ jsx("div", { id: "specifications", className: `${PREFIX}-section ${PREFIX}-specification ${prerenderClass}`, children: getSpecifications2() });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: renderSpecifications() });
};
Specifications.propTypes = {
  tableData: PropTypes.any,
  specificationContent: PropTypes.any,
  path: PropTypes.string,
  defaultState: PropTypes.bool,
  isPrerender: PropTypes.bool
};
const useFocusedTable = () => {
  const tableRef = useRef(null);
  const handleKeyDown = (event) => {
    var _a;
    const table = tableRef.current;
    const activeElement = document.activeElement;
    const activeElementPath = activeElement && getXPathFromElement(activeElement);
    const tablePath = table && getXPathFromElement(table);
    if (tablePath && activeElementPath.startsWith(tablePath)) {
      const { key } = event;
      let newActiveElementPath = activeElementPath;
      switch (key) {
        case "ArrowUp":
          newActiveElementPath = activeElementPath.replace(
            /tr\[(\d+)\]/,
            (_, i) => `tr[${+i - magicNumber.ONE}]`
          );
          break;
        case "ArrowDown":
          newActiveElementPath = activeElementPath.replace(
            /tr\[(\d+)\]/,
            (_, i) => `tr[${+i + magicNumber.ONE}]`
          );
          break;
        case "ArrowLeft":
          newActiveElementPath = activeElementPath.replace(
            /td\[(\d+)\]/,
            (_, i) => `td[${+i - magicNumber.ONE}]`
          );
          break;
        case "ArrowRight":
          newActiveElementPath = activeElementPath.replace(
            /td\[(\d+)\]/,
            (_, i) => `td[${+i + magicNumber.ONE}]`
          );
          break;
        default:
          return;
      }
      event.preventDefault();
      (_a = getElementFromXPath(newActiveElementPath)) == null ? void 0 : _a.focus();
    }
  };
  return {
    ref: tableRef,
    onKeyDown: handleKeyDown
  };
};
const getXPathFromElement = (element) => {
  var _a;
  if (element && element.nodeType === Node.ELEMENT_NODE) {
    const siblingsWithSameTag = Array.from(((_a = element.parentNode) == null ? void 0 : _a.children) || []).filter(
      (child) => child.tagName === element.tagName
    );
    const tagIndex = siblingsWithSameTag.indexOf(element) + magicNumber.ONE;
    const elementTag = element.tagName.toLowerCase();
    const xpathIndex = siblingsWithSameTag.length > magicNumber.ONE ? `[${tagIndex}]` : "";
    return `${getXPathFromElement(element.parentNode)}/${elementTag}${xpathIndex}`;
  } else {
    return "";
  }
};
const getElementFromXPath = (xpathString) => {
  const result = document.evaluate(xpathString, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
  const element = result.singleNodeValue;
  return element ? element : null;
};
const expandCollapseIcon = (isExpanded) => {
  return /* @__PURE__ */ jsx(Icon, { size: "sm", type: isExpanded ? "ct-chevron-up" : "ct-chevron-down" });
};
const expandCollapseButton = (action, buttonLabel, modifierClass, isExpanded) => {
  return /* @__PURE__ */ jsxs(
    Button,
    {
      type: "tertiary",
      ariaExpanded: isExpanded,
      ariaLabel: buttonLabel,
      onClick: () => {
        action();
      },
      modifierClass: `${PREFIX}${modifierClass}`,
      children: [
        buttonLabel,
        expandCollapseIcon(isExpanded)
      ]
    }
  );
};
const SeoTable = ({ ...props }) => {
  const { headerLabel, headers: headers2, rows, viewMoreLabel, viewLessLabel, viewMoreRowStepNumber, cellWrapper } = props;
  const [rowsCounter, setRowsCounter] = useState(viewMoreRowStepNumber);
  const arrowHandling = useFocusedTable();
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  const handleResize = () => {
    setIsMobileOrTablet(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  };
  useGlobalResizeEvent(handleResize);
  const getHeader2 = (headersData) => {
    return headersData.map((label, index2) => {
      return /* @__PURE__ */ jsx("th", { dangerouslySetInnerHTML: { __html: label } }, index2);
    });
  };
  const getCell2 = (cell, row, key) => {
    return /* @__PURE__ */ jsx("td", { children: cellWrapper == null ? void 0 : cellWrapper(cell, row) }, key);
  };
  const getRow = (rowData) => {
    return rowData.map((cell, index2) => {
      return getCell2(cell, rowData, index2);
    });
  };
  const getRows = (rowsData) => {
    return rowsData.map((row, index2) => {
      if (rowsCounter <= index2) {
        return /* @__PURE__ */ jsx("tr", { style: { display: "none" }, children: getRow(row) }, index2);
      }
      return /* @__PURE__ */ jsx("tr", { children: getRow(row) }, index2);
    });
  };
  const setFocusOn = (componentSelector, position) => {
    const htmlElement = document.querySelector(componentSelector);
    setTimeout(() => {
      if (htmlElement && typeof (htmlElement == null ? void 0 : htmlElement.scrollIntoView) === "function") {
        htmlElement == null ? void 0 : htmlElement.scrollIntoView({
          behavior: "smooth",
          block: position
        });
      }
    }, magicNumber.HUNDRED);
  };
  const expandRowsAction = () => {
    setRowsCounter(rows.length);
    setFocusOn(`.${PREFIX}-seotable`, "end");
  };
  const collapseRowsAction = () => {
    setRowsCounter(viewMoreRowStepNumber);
    setFocusOn(`.${PREFIX}-seotable`, "start");
  };
  const renderButton = () => {
    return rowsCounter === rows.length ? expandCollapseButton(collapseRowsAction, viewLessLabel, "-button--collapse-seotable", true) : expandCollapseButton(expandRowsAction, viewMoreLabel, "-button--expand-seotable", false);
  };
  const getSeoTable = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-seotable-table`, children: [
      /* @__PURE__ */ jsxs("table", { className: `${tableClass} ${type}`, ...arrowHandling, children: [
        /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsx("tr", { children: getHeader2(headers2) }) }),
        /* @__PURE__ */ jsx("tbody", { children: getRows(rows) })
      ] }),
      rows.length > viewMoreRowStepNumber && renderButton()
    ] });
  };
  const tableClass = `${PREFIX}-table`;
  const type = `${PREFIX}-table--stripped`;
  const renderSeoTable = () => {
    return isMobileOrTablet ? /* @__PURE__ */ jsx("div", { id: "seotable", className: `${PREFIX}-section ${PREFIX}-seotable`, children: /* @__PURE__ */ jsx(Accordion, { title: headerLabel, isHeaderOpen: false, children: getSeoTable() }) }) : /* @__PURE__ */ jsx("div", { id: "seotable", className: `${PREFIX}-section ${PREFIX}-seotable`, children: /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("h2", { className: `${PREFIX}-seotable__heading`, children: headerLabel }),
      getSeoTable()
    ] }) });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: renderSeoTable() });
};
const RoadRating = ({ ...props }) => {
  const { ratings, aggregateValue, title, roadRatingDescription, roadRatedLabel } = props;
  return /* @__PURE__ */ jsxs("div", { id: "road-rating", className: `${PREFIX}-section ${PREFIX}-road-rating`, children: [
    /* @__PURE__ */ jsx("h2", { className: `${PREFIX}-road-rating__heading`, id: "roadRatingHeading", children: title }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-road-rating__description-container`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-road-rating__aggregate-icon`, children: aggregateValue }),
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-road-rating__bar-and-labels`, children: [
        /* @__PURE__ */ jsxs("h3", { className: `${PREFIX}-road-rating__subheader`, children: [
          roadRatedLabel,
          " ",
          aggregateValue
        ] }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `${PREFIX}-road-rating__description`,
            dangerouslySetInnerHTML: { __html: roadRatingDescription }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { children: ratings instanceof Array && ratings.map((rating) => {
      return renderRating(rating);
    }) })
  ] });
};
const renderRating = (rating) => {
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-road-rating__rating-container`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-road-rating__icon-container`, children: /* @__PURE__ */ jsx(
      "img",
      {
        className: `${PREFIX}-road-rating__icon`,
        alt: "icon",
        src: `${rating.image}`,
        style: { color: rating.color },
        width: RoadRatingsImageSize.width,
        height: RoadRatingsImageSize.height
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-road-rating__bar-and-labels`, children: [
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-road-rating__labels`, children: [
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-road-rating__type-label`, children: rating.label }),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-road-rating__value-label`, children: rating.value })
      ] }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-road-rating__bar-container`, children: /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-road-rating__bar-filler`,
          style: { backgroundColor: rating.color, width: `${rating.value}%` }
        }
      ) })
    ] })
  ] }, `${rating.roadRatedID}`);
};
RoadRating.propTypes = {
  ratings: PropTypes.any,
  aggregateValue: PropTypes.number,
  title: PropTypes.string,
  roadRatingDescription: PropTypes.string,
  roadRatedLabel: PropTypes.string
};
RoadRating.displayName = "RoadRatingInLib";
const renderItem = (name, item) => {
  return Object.keys(item).map((key, index2) => {
    return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("p", { className: `${PREFIX}-features__information`, children: item[key] }) }, `${name}-${index2}`);
  });
};
const Features = ({ ...props }) => {
  const { featureList, title, isShowTitle, defaultState = true, mobileAccordionMode = false } = props;
  const getFeatures = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row`, children: isArrayNotEmpty(featureList) && /* @__PURE__ */ jsx("ul", { "data-testid": "features", className: `${PREFIX}-features__list`, children: featureList.map((item) => {
      return renderItem("featureList", item);
    }) }) });
  };
  const [isMobile2, setIsMobile] = useState(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  };
  useGlobalResizeEvent(handleResize);
  return isMobile2 && mobileAccordionMode ? /* @__PURE__ */ jsx("div", { id: "features", className: `${PREFIX}-features ${PREFIX}-section`, children: /* @__PURE__ */ jsx(Accordion, { title, isHeaderOpen: defaultState, children: getFeatures() }) }) : /* @__PURE__ */ jsxs("div", { id: "features", className: `${PREFIX}-features`, children: [
    isShowTitle && /* @__PURE__ */ jsx("h3", { className: `${PREFIX}-features__header`, children: title }),
    getFeatures()
  ] });
};
Features.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  path: PropTypes.string,
  featureList: PropTypes.any
};
const VariantsWrapper = ({ ...props }) => {
  const {
    setSelectedFirstVariantValue,
    setSelectedFirstVariantIdValue,
    setSelectedSecondVariantValue,
    setSelectedSecondVariantIdValue,
    setSelectedThirdVariantValue,
    setSelectedThirdVariantIdValue,
    variantDetails,
    selectedProductCode,
    selectedColorCode,
    variantsProductSkuData,
    selectedFirstVariantId,
    selectedSecondVariantId,
    variantOptions,
    isColourSwatchesActive,
    setShowSizeChart,
    showSizeChart,
    isSizeChartAvailable,
    sizeChartButtonTitle,
    isOnlyOneVariant,
    isFirstVariantClicked,
    setIsFirstVariantClicked,
    checkOutOfStock,
    a11yVariantsSelectedCount,
    inStockLabel,
    outOfStockLabel,
    checkIfAllVariantsSelected,
    enableOnlyAvailableOnline,
    availableOnlinePurchaseLabel,
    onlyAvailableOnlineAtLabel,
    preferredStoreDetails,
    limitedStockMessage,
    isLimitedStock,
    enableCustomOrder,
    variantDetailsOrder,
    setSelectedVariantByUserClick
  } = props;
  const { firstVariant, secondVariant } = variantDetails || {};
  const variantsRef = useRef(0);
  const variantClickedRef = useRef(0);
  const variantClickHandler = () => {
    variantClickedRef.current = magicNumber.ONE;
  };
  const getIndexBySelectedCode = () => {
    var _a;
    return (_a = firstVariant == null ? void 0 : firstVariant.values) == null ? void 0 : _a.findIndex((skuObj) => skuObj == null ? void 0 : skuObj.skuCodes.includes(selectedProductCode));
  };
  const getIndexBySelectedColorCode = () => {
    var _a;
    return (_a = firstVariant == null ? void 0 : firstVariant.values) == null ? void 0 : _a.findIndex((skuObj) => (skuObj == null ? void 0 : skuObj.id) === selectedColorCode);
  };
  const getIndexByDefaultColor = () => {
    var _a;
    return isColourSwatchesActive && firstVariant.descriptor === COLOR ? (_a = firstVariant == null ? void 0 : firstVariant.values) == null ? void 0 : _a.findIndex((item) => item.isDefaultColour) : magicNumber.MINUS_ONE;
  };
  const getIndexByAvailability = () => {
    var _a, _b, _c, _d, _e, _f;
    if ((variantOptions == null ? void 0 : variantOptions.length) === magicNumber.ONE && !isFirstVariantClicked) {
      (_a = variantsProductSkuData == null ? void 0 : variantsProductSkuData.skus) == null ? void 0 : _a.sort((skuobj1, skuobj2) => {
        var _a2, _b2;
        return (
          // eslint-disable-next-line no-unsafe-optional-chaining
          ((_a2 = firstVariant == null ? void 0 : firstVariant.values) == null ? void 0 : _a2.findIndex((obj) => obj.skuCodes[magicNumber.ZERO] === skuobj1.code)) - // eslint-disable-next-line no-unsafe-optional-chaining
          ((_b2 = firstVariant == null ? void 0 : firstVariant.values) == null ? void 0 : _b2.findIndex((obj) => obj.skuCodes[magicNumber.ZERO] === skuobj2.code))
        );
      });
      const availableVariant = (_b = variantsProductSkuData == null ? void 0 : variantsProductSkuData.skus) == null ? void 0 : _b.find(
        (variant) => variant.fulfillment.availability.quantity > 0
      );
      if (availableVariant) {
        const skuIndex = (_c = firstVariant == null ? void 0 : firstVariant.values) == null ? void 0 : _c.findIndex(
          (skuObj) => skuObj == null ? void 0 : skuObj.skuCodes.includes(availableVariant == null ? void 0 : availableVariant.code)
        );
        if (selectedFirstVariantId !== ((_e = (_d = firstVariant == null ? void 0 : firstVariant.values) == null ? void 0 : _d[skuIndex]) == null ? void 0 : _e.id)) {
          variantsRef.current = 0;
        }
        return skuIndex;
      }
    } else if ((variantOptions == null ? void 0 : variantOptions.length) !== magicNumber.ONE && variantClickedRef.current === 0) {
      const isVariantAvailable = (variant) => {
        var _a2;
        return (_a2 = variantsProductSkuData == null ? void 0 : variantsProductSkuData.skus) == null ? void 0 : _a2.filter((skus) => {
          return variant.skuCodes.some((variantSkuCode) => {
            return variantSkuCode === skus.code;
          });
        }).some(
          (skuCode) => skuCode.fulfillment.availability.quantity > 0 || skuCode.fulfillment.availability.Corporate.Quantity > 0 && skuCode.orderable
        );
      };
      const skuIndex = firstVariant == null ? void 0 : firstVariant.values.findIndex(isVariantAvailable);
      if (skuIndex !== magicNumber.MINUS_ONE && selectedFirstVariantId !== ((_f = firstVariant == null ? void 0 : firstVariant.values[skuIndex]) == null ? void 0 : _f.id)) {
        variantsRef.current = magicNumber.ZERO;
      }
      return skuIndex;
    }
    return magicNumber.MINUS_ONE;
  };
  const getOrderVariants = (variantDetailsData) => {
    if (enableCustomOrder && isArrayNotEmpty(variantDetailsOrder)) {
      return variantDetailsOrder;
    } else {
      return Object.keys(variantDetailsData);
    }
  };
  useEffect(() => {
    var _a, _b, _c;
    let skuIndex = getIndexBySelectedCode();
    if (skuIndex === magicNumber.MINUS_ONE) {
      skuIndex = getIndexBySelectedColorCode();
    }
    if (skuIndex === magicNumber.MINUS_ONE) {
      skuIndex = getIndexByDefaultColor();
    }
    if (skuIndex === magicNumber.MINUS_ONE) {
      skuIndex = getIndexByAvailability();
    }
    if (skuIndex === magicNumber.MINUS_ONE) {
      skuIndex = magicNumber.ZERO;
    }
    if (variantDetails && variantsRef.current === 0) {
      setSelectedFirstVariantValue(
        (_a = firstVariant.values[skuIndex]) == null ? void 0 : _a.name,
        (_b = firstVariant.values[skuIndex]) == null ? void 0 : _b.displayNameForVariants
      );
      setSelectedFirstVariantIdValue((_c = firstVariant.values[skuIndex]) == null ? void 0 : _c.id);
      variantsRef.current = 1;
    }
  }, [
    variantDetails,
    selectedProductCode,
    firstVariant,
    variantOptions,
    variantsProductSkuData,
    isFirstVariantClicked,
    selectedFirstVariantId,
    setSelectedFirstVariantValue,
    setSelectedFirstVariantIdValue
  ]);
  useEffect(() => {
    var _a, _b, _c, _d, _e, _f;
    if (variantDetails == null ? void 0 : variantDetails.secondVariant) {
      const selectedFirstVariant = (_b = (_a = variantDetails == null ? void 0 : variantDetails.firstVariant) == null ? void 0 : _a.values) == null ? void 0 : _b.find(
        (variant) => (variant == null ? void 0 : variant.id) === selectedFirstVariantId
      );
      const selectedSecondVariant = (_c = selectedFirstVariant == null ? void 0 : selectedFirstVariant.secondVariant) == null ? void 0 : _c.find(
        (variant) => variant == null ? void 0 : variant.skuCodes.includes(selectedFirstVariant.skuCodes[magicNumber.ZERO])
      );
      const secondVariantLength = (_d = selectedFirstVariant == null ? void 0 : selectedFirstVariant.secondVariant) == null ? void 0 : _d.filter(
        (variant) => !variant.isUnavailable
      ).length;
      if (secondVariantLength === magicNumber.ONE) {
        setSelectedSecondVariantValue(selectedSecondVariant.name);
        setSelectedSecondVariantIdValue(selectedSecondVariant.id);
      }
      if (variantDetails == null ? void 0 : variantDetails.thirdVariant) {
        const thirdVariantLength = (_e = selectedFirstVariant == null ? void 0 : selectedFirstVariant.thirdVariant) == null ? void 0 : _e.filter(
          (variant) => !variant.isUnavailable
        ).length;
        if (thirdVariantLength === magicNumber.ONE) {
          const selectedThirdVariant = (_f = selectedFirstVariant == null ? void 0 : selectedFirstVariant.thirdVariant) == null ? void 0 : _f.find(
            (variant) => variant == null ? void 0 : variant.skuCodes.includes(selectedFirstVariant.skuCodes[magicNumber.ZERO])
          );
          setSelectedThirdVariantValue(selectedThirdVariant.name);
          setSelectedThirdVariantIdValue(selectedThirdVariant.id);
        }
      }
    }
  }, [
    variantDetails,
    selectedFirstVariantId,
    selectedSecondVariantId,
    setSelectedSecondVariantIdValue,
    setSelectedSecondVariantValue,
    setSelectedThirdVariantIdValue,
    setSelectedThirdVariantValue,
    secondVariant
  ]);
  const showVariants = variantDetails && (variantsProductSkuData && isArrayNotEmpty(variantsProductSkuData == null ? void 0 : variantsProductSkuData.skus) || !checkDataLength(variantsProductSkuData));
  return /* @__PURE__ */ jsx(Fragment, { children: showVariants && getOrderVariants(variantDetails).map((variant, index2) => {
    return /* @__PURE__ */ jsx(
      Variants,
      {
        isLimitedStock,
        preferredStoreDetails,
        onlyAvailableOnlineAtLabel,
        enableOnlyAvailableOnline,
        availableOnlinePurchaseLabel,
        limitedStockMessage,
        areAllVariantsSelected: checkIfAllVariantsSelected,
        outOfStockLabel,
        inStockLabel,
        a11yVariantsSelectedCount,
        variantsData: variantDetails[variant],
        variantKey: variant,
        isFirstVariantClicked,
        setIsFirstVariantClicked,
        variantClickHandler,
        setShowSizeChart,
        showSizeChart,
        isSizeChartAvailable,
        sizeChartButtonTitle,
        isOnlyOneVariant,
        checkOutOfStock,
        setSelectedVariantByUserClick,
        ...props
      },
      index2
    );
  }) });
};
VariantsWrapper.propTypes = {
  setSelectedFirstVariantIdValue: PropTypes.func,
  variantDetails: PropTypes.any,
  selectedProductCode: PropTypes.string,
  a11yVariantsSelectedCount: PropTypes.string,
  enableOnlyAvailableOnline: PropTypes.bool,
  availableOnlinePurchaseLabel: PropTypes.string,
  onlyAvailableOnlineAtLabel: PropTypes.string,
  preferredStoreDetails: PropTypes.string,
  limitedStockMessage: PropTypes.string,
  isLimitedStock: PropTypes.bool,
  checkIfAllVariantsSelected: PropTypes.bool,
  inStockLabel: PropTypes.string,
  outOfStockLabel: PropTypes.string
};
VariantsWrapper.displayName = "VariantsWrapper";
const StaticProductTitle = ({ title }) => {
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-static-title-wrapper`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-information-wrapper`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-title-sku`, children: /* @__PURE__ */ jsx("h1", { className: `${PREFIX}-product__title`, children: title }) }) }) }) });
};
StaticProductTitle.propTypes = {
  title: PropTypes.string
};
const negativeCursorValue = -1;
const unityValue = 1;
const ARROW_UP = "ArrowUp";
const ARROW_DOWN = "ArrowDown";
const ENTER = "Enter";
const ESC = "Escape";
const Review = ({ ...props }) => {
  const { path, numberOfReviews, averageRating, displayReviews = true } = props;
  const ratings = [];
  const stars = ["1", "2", "3", "4", "5"];
  const decimal = averageRating - Math.floor(averageRating);
  stars.forEach((starCounter) => {
    let ratingClass = "";
    const ratingVal = decimal.toFixed(unityValue);
    if (Number(starCounter) <= Math.floor(averageRating)) {
      ratingClass = "ct-reviews-active";
    } else if (decimal && Number(starCounter) === Math.ceil(averageRating) && Number(ratingVal) > 0) {
      ratingClass = Number(ratingVal) === magicNumber.ONE ? "ct-reviews-active" : `ct-reviews-${ratingVal}-active`;
    } else {
      ratingClass = "ct-reviews-inactive";
    }
    ratings.push(/* @__PURE__ */ jsx(Icon, { size: "lg", type: ratingClass, path }, starCounter));
  });
  return /* @__PURE__ */ jsx("span", { className: `${PREFIX}-reviews__list`, children: /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-reviews__list-stars`, children: [
    ratings,
    displayReviews && /* @__PURE__ */ jsxs("span", { "aria-hidden": "true", className: `${PREFIX}-button ${PREFIX}-button--tertiary`, children: [
      "(",
      numberOfReviews,
      ")"
    ] })
  ] }) });
};
Review.propTypes = {
  path: PropTypes.string,
  numberOfReviews: PropTypes.number,
  averageRating: PropTypes.number,
  displayReviews: PropTypes.bool
};
const Rebate = ({ ...props }) => {
  const { title, greyCopyMsg, pdfLink, tooltipMessage, a11yTooltipIcon, hideGreyCopyMessage, ariaHidden } = props;
  const [rebateVisibility, setRebateVisibility] = useState(false);
  const buttonRebateRef = useRef();
  const rebateClass = `${PREFIX}-rebate`;
  const showRebateTooltip = () => {
    setRebateVisibility(!rebateVisibility);
  };
  const toolTipText = (tooltipDesc) => {
    return /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: tooltipDesc, children: (memoizedStringContent) => /* @__PURE__ */ jsx("div", { "data-testid": "tooltip-text", dangerouslySetInnerHTML: { __html: memoizedStringContent } }) });
  };
  const greyCopyClicked = (event) => {
    event.stopPropagation();
  };
  return /* @__PURE__ */ jsxs("div", { className: `${rebateClass}__wrapper`, "aria-hidden": ariaHidden ? ariaHidden : false, children: [
    /* @__PURE__ */ jsxs("div", { className: `${rebateClass}__section`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-offer", size: "sm" }),
      /* @__PURE__ */ jsxs("div", { className: `${rebateClass}-header`, children: [
        title,
        tooltipMessage && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              ref: buttonRebateRef,
              className: `${rebateClass}-icon`,
              onClick: showRebateTooltip,
              "data-testid": "rebate-tooltip-btn",
              "aria-label": a11yTooltipIcon,
              children: /* @__PURE__ */ jsx(Icon, { type: "ct-information-details", title: `${tooltipMessage}`, size: "sm" })
            }
          ),
          !!rebateVisibility && /* @__PURE__ */ jsx(
            Tooltip,
            {
              visibility: rebateVisibility,
              setVisibility: setRebateVisibility,
              iconID: "ct-close",
              headerText: title,
              bodyText: toolTipText(tooltipMessage),
              coords: buttonRebateRef.current
            }
          )
        ] })
      ] })
    ] }),
    !hideGreyCopyMessage && greyCopyMsg ? (
      // eslint-disable-next-line sonar/no-nested-conditional
      pdfLink ? /* @__PURE__ */ jsx("div", { className: `${rebateClass}__grey-copy-msg`, children: /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: pdfLink, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
        "a",
        {
          className: `${rebateClass}__grey-copy-msg--link`,
          href: memoizedStringContent,
          target: "_blank",
          rel: "noreferrer",
          onClick: (event) => greyCopyClicked(event),
          children: greyCopyMsg
        }
      ) }) }) : /* @__PURE__ */ jsx("div", { className: `${rebateClass}__grey-copy-msg`, children: greyCopyMsg })
    ) : null
  ] });
};
Rebate.propTypes = {
  title: PropTypes.string.isRequired,
  tooltipMessage: PropTypes.string,
  index: PropTypes.number,
  a11yTooltipIcon: PropTypes.string,
  greyCopyMsg: PropTypes.string,
  rebateIcon: PropTypes.string,
  pdfLink: PropTypes.string,
  hideGreyCopyMessage: PropTypes.bool,
  ariaHidden: PropTypes.bool
};
const pageTypes = {
  searchPage: "search",
  pdpPage: "product",
  productPage: "product",
  brandPage: "brandlisting",
  brandCategoryPage: "brandcategorylisting",
  plp: "categorylevelN",
  categoryPages: ["categorylevel1", "categorylevel2", "categorylevelN"],
  // dlp, clp, cplp
  wishlist: "wishlist",
  shoppingCart: "cart",
  flyer: "flyer",
  allBrandsPage: "allbrands",
  errorPage: "error",
  account: "account",
  weeklyOffer: "offers",
  webOrderHistory: "orderhistory",
  accountSetting: "accountsettings",
  accountDasboard: "accountdashboard",
  emailOfferActivation: "emailofferactive",
  checkoutPage: "checkout",
  promoListing: "promolisting"
};
const pageNumberConstants = {
  pageNumber: 1
};
const isAccountPageType = (pagetype) => {
  const accountPageList = [
    pageTypes.account,
    pageTypes.weeklyOffer,
    pageTypes.webOrderHistory,
    pageTypes.accountSetting,
    pageTypes.accountDasboard
  ];
  return Boolean(accountPageList == null ? void 0 : accountPageList.find((account) => account === pagetype));
};
const grid = "grid";
const minOptionsArrayLength = 0;
const scrollRestorationKey = "scroll-position-product-id-marker";
const plpUrl = "#plp";
const saleOrClearanceBadge = ["PROMO", "CLEARANCE"];
const pagesForScrollRestoration = [
  pageTypes.searchPage,
  pageTypes.plp,
  pageTypes.brandPage,
  pageTypes.brandCategoryPage,
  pageTypes.promoListing
];
const PRODUCT_CARD_COUNT = 4;
const calculateHeaderHeight = () => {
  var _a, _b;
  let primaryNavHeight = (_a = document.getElementsByClassName(`${PREFIX}-primary-navigation-bar`)[0]) == null ? void 0 : _a.clientHeight;
  const checkoutNavHeight = (_b = document.getElementsByClassName(`${PREFIX}-simple-header-checkout`)[0]) == null ? void 0 : _b.clientHeight;
  const secondaryNav = document.getElementsByClassName(`${PREFIX}-secondary-navigation-bar`);
  const notificationBanner = document.getElementsByClassName(`${PREFIX}-notification-banner__body`);
  const notificationBannerHeight = notificationBanner && notificationBanner.length ? notificationBanner[0].clientHeight : 0;
  let secondaryNavHeight = 0;
  let secondaryNavPos = 0;
  if (secondaryNav && secondaryNav.length) {
    secondaryNavHeight = secondaryNav[0].clientHeight;
    secondaryNavPos = secondaryNav[0].getBoundingClientRect().top;
  }
  if (!primaryNavHeight) {
    primaryNavHeight = checkoutNavHeight;
  }
  const headerHeight = secondaryNavPos >= primaryNavHeight ? secondaryNavHeight + primaryNavHeight : primaryNavHeight;
  return headerHeight + notificationBannerHeight;
};
const calculateHeaderHeightWithStickyStoreLocator = () => {
  var _a, _b, _c, _d;
  const headersHeight = Number(((_a = document.getElementsByClassName(`${PREFIX}-primary-navigation`)[0]) == null ? void 0 : _a.clientHeight) || 0);
  const infoBannerHeight = isInformationBanner() ? Number(((_b = document.getElementsByClassName(`${PREFIX}-information-banner`)[0]) == null ? void 0 : _b.clientHeight) || 0) : 0;
  const storeLocatorHeight = Number(
    ((_c = document.getElementsByClassName("store-locator-pencil-banner")[0]) == null ? void 0 : _c.clientHeight) || 0
  );
  const stickyStoreLocatorHeight = Number(
    ((_d = document.getElementsByClassName(`${PREFIX}-primary-navigation__sticky_store-locator`)[0]) == null ? void 0 : _d.clientHeight) || 0
  );
  const scrolledStoreLocatorHeight = stickyStoreLocatorHeight > 0 ? 0 : stickyStoreLocatorHeight;
  return headersHeight + infoBannerHeight + storeLocatorHeight + scrolledStoreLocatorHeight;
};
const isInformationBanner = () => {
  const infoBanner = document.getElementsByClassName(`${PREFIX}-information-banner`);
  if (!!infoBanner && !!infoBanner[0]) {
    const rect = infoBanner[0].getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  }
  return false;
};
const scrollToTarget$1 = (event) => {
  var _a;
  event.stopPropagation();
  event.preventDefault();
  const element = event.targetElement || event.target;
  const { top: bodyTop } = document.body.getBoundingClientRect();
  const { top: elemTop } = element.getBoundingClientRect();
  const offset = elemTop - bodyTop;
  const filterHeight = (_a = document.getElementsByClassName(`${PREFIX}-filters`)[0]) == null ? void 0 : _a.clientHeight;
  const headerHeight = calculateHeaderHeight();
  const isSticky = !document.getElementsByClassName(`${PREFIX}-filters--filters-sticky`)[0];
  const focusAbleElems = [`${PREFIX}-product-card__no-button`, `${PREFIX}-product-card__content`];
  const isProductCard = Array.from(element.classList).some((r2) => focusAbleElems.includes(r2));
  const isMobile2 = window.innerWidth <= BREAKPOINTS.tabletMaxWidth;
  if (isSticky && isProductCard && !isMobile2) {
    window.scroll({
      top: offset - headerHeight - filterHeight - magicNumber.SIXTEEN,
      behavior: "smooth"
    });
  }
};
const productCardScrollToTop = scrollToTarget$1;
const PromoMessage = ({
  a11yTooltipIcon,
  a11yCloseIconLabel,
  promoMessage,
  ariaHidden,
  isModalPresent
}) => {
  const [saveTooltipVisibility, setSaveTooltipVisibility] = useState(false);
  const saveTooltipButtonRef = useRef();
  const toolTipButtonHandler = (e, visibilitySetter, currentVisibility) => {
    e.stopPropagation();
    e.preventDefault();
    addModalAttribute(e);
    visibilitySetter(!currentVisibility);
  };
  const toolTipButtonKeyboardHandler = (e, visibilitySetter, currentVisibility) => {
    isEnterPressed(e.key) && toolTipButtonHandler(e, visibilitySetter, currentVisibility);
  };
  return promoMessage.label ? /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-promo__message`,
      "aria-hidden": ariaHidden ? ariaHidden : false,
      children: [
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-promo__message-label`, children: promoMessage.label }),
        promoMessage.tooltip && /* @__PURE__ */ jsx(
          "button",
          {
            ref: saveTooltipButtonRef,
            className: `${PREFIX}-promo__tooltip-btn`,
            onClick: (event) => toolTipButtonHandler(event, setSaveTooltipVisibility, saveTooltipVisibility),
            onKeyDown: (event) => toolTipButtonKeyboardHandler(event, setSaveTooltipVisibility, saveTooltipVisibility),
            "aria-label": a11yTooltipIcon,
            children: /* @__PURE__ */ jsx("span", { className: saveTooltipVisibility ? `${PREFIX}-promo__tooltip-btn--active` : "", children: /* @__PURE__ */ jsx(Icon, { type: "ct-information-details", size: "md" }) })
          }
        ),
        !!saveTooltipVisibility && /* @__PURE__ */ jsx(
          Tooltip,
          {
            visibility: saveTooltipVisibility,
            setVisibility: setSaveTooltipVisibility,
            iconID: "ct-close",
            headerText: promoMessage.label,
            bodyText: promoMessage.tooltip,
            coords: saveTooltipButtonRef.current,
            a11yCloseIconLabel,
            isModalPresent
          }
        )
      ]
    },
    `${promoMessage.label}-${promoMessage.tooltip}`
  ) : null;
};
const RestrictedPromoMessage = ({
  a11yTooltipIcon,
  a11yCloseIconLabel,
  restrictedPromoMessage,
  isModalPresent
}) => {
  const [saveTooltipVisibility, setSaveTooltipVisibility] = useState(false);
  const saveTooltipButtonRef = useRef();
  const toolTipButtonHandler = (e, visibilitySetter, currentVisibility) => {
    e.stopPropagation();
    e.preventDefault();
    addModalAttribute(e);
    visibilitySetter(!currentVisibility);
  };
  const toolTipButtonKeyboardHandler = (e, visibilitySetter, currentVisibility) => {
    isEnterPressed(e.key) && toolTipButtonHandler(e, visibilitySetter, currentVisibility);
  };
  return restrictedPromoMessage.label ? /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-promo__message`,
      children: [
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-promo__message-label`, children: restrictedPromoMessage.label }),
        restrictedPromoMessage.tooltip && /* @__PURE__ */ jsx(
          "button",
          {
            ref: saveTooltipButtonRef,
            className: `${PREFIX}-promo__tooltip-btn`,
            onClick: (event) => toolTipButtonHandler(event, setSaveTooltipVisibility, saveTooltipVisibility),
            onKeyDown: (event) => toolTipButtonKeyboardHandler(event, setSaveTooltipVisibility, saveTooltipVisibility),
            "aria-label": a11yTooltipIcon,
            children: /* @__PURE__ */ jsx("span", { className: saveTooltipVisibility ? `${PREFIX}-promo__tooltip-btn--active` : "", children: /* @__PURE__ */ jsx(Icon, { type: "ct-information-details", size: "md" }) })
          }
        ),
        !!saveTooltipVisibility && /* @__PURE__ */ jsx(
          Tooltip,
          {
            visibility: saveTooltipVisibility,
            setVisibility: setSaveTooltipVisibility,
            iconID: "ct-close",
            headerText: restrictedPromoMessage.label,
            bodyText: restrictedPromoMessage.tooltip,
            coords: saveTooltipButtonRef.current,
            a11yCloseIconLabel,
            isModalPresent
          }
        )
      ]
    },
    `${restrictedPromoMessage.label}-${restrictedPromoMessage.tooltip}`
  ) : null;
};
const AppliedPromo = ({ ...props }) => {
  const { appliedPromoPrefix, appliedPromoLabel } = props;
  return appliedPromoLabel ? /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-applied-promo`, children: [
    /* @__PURE__ */ jsx(Icon, { type: "g-confirm", size: "lg" }),
    /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-applied-promo__text`, children: [
      appliedPromoPrefix,
      " ",
      appliedPromoLabel
    ] })
  ] }) : null;
};
const PromoMessages = ({
  isProductLevel,
  productPromoMessages,
  productRestrictedPromoMessages,
  skuPromoMessages,
  skuRestrictedPromoMessages,
  appliedPromoMessages,
  appliedPromoPrefix,
  isStaggered,
  a11yTooltipIcon,
  a11yCloseIconLabel,
  ariaHidden,
  isModalPresent
}) => {
  const [promoMessages, setPromoMessages] = useState(productPromoMessages);
  const [restrictedPromoMessages, setRestrictedPromoMessages] = useState(productRestrictedPromoMessages);
  const [appliedPromos, setAppliedPromos] = useState(appliedPromoMessages);
  useEffect(() => {
    if (isProductLevel) {
      setPromoMessages(productPromoMessages);
      setRestrictedPromoMessages(productRestrictedPromoMessages);
      setAppliedPromos(appliedPromoMessages);
    } else {
      setPromoMessages(skuPromoMessages);
      setRestrictedPromoMessages(skuRestrictedPromoMessages);
    }
  }, [
    isProductLevel,
    productPromoMessages,
    productRestrictedPromoMessages,
    skuPromoMessages,
    skuRestrictedPromoMessages,
    appliedPromoMessages
  ]);
  const isPromoMessagesNotEmpty = (promos) => {
    return !!(promos == null ? void 0 : promos.length);
  };
  const renderPromoMessage = () => {
    return promoMessages == null ? void 0 : promoMessages.map((promoMessage) => {
      return /* @__PURE__ */ jsx(
        "div",
        {
          "aria-hidden": ariaHidden ? ariaHidden : false,
          children: /* @__PURE__ */ jsx(
            PromoMessage,
            {
              promoMessage,
              a11yTooltipIcon,
              a11yCloseIconLabel,
              isModalPresent
            }
          )
        },
        `${promoMessage.label}-${promoMessage.tooltip}`
      );
    });
  };
  const renderRestrictedPromoMessages = () => {
    return restrictedPromoMessages == null ? void 0 : restrictedPromoMessages.map((restrictedPromoMessage) => {
      return /* @__PURE__ */ jsx(
        "div",
        {
          "aria-hidden": ariaHidden ? ariaHidden : false,
          children: /* @__PURE__ */ jsx(
            RestrictedPromoMessage,
            {
              restrictedPromoMessage,
              a11yTooltipIcon,
              a11yCloseIconLabel,
              isModalPresent
            }
          )
        },
        `${restrictedPromoMessage.label}-${restrictedPromoMessage.tooltip}`
      );
    });
  };
  const renderAppliedPromoMessages = () => {
    return appliedPromos == null ? void 0 : appliedPromos.map((appliedPromoMessage) => {
      return /* @__PURE__ */ jsx(
        "div",
        {
          "aria-hidden": ariaHidden ? ariaHidden : false,
          children: /* @__PURE__ */ jsx(
            AppliedPromo,
            {
              appliedPromoPrefix,
              appliedPromoLabel: appliedPromoMessage.label
            }
          )
        },
        `${appliedPromoMessage.label}-${appliedPromoMessage.tooltip}`
      );
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !isStaggered ? /* @__PURE__ */ jsxs(Fragment, { children: [
      isPromoMessagesNotEmpty(promoMessages) ? renderPromoMessage() : null,
      isPromoMessagesNotEmpty(restrictedPromoMessages) ? renderRestrictedPromoMessages() : null
    ] }) : null,
    isPromoMessagesNotEmpty(appliedPromos) ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-applied-promo-messages-wrapper`, children: renderAppliedPromoMessages() }) : null
  ] });
};
const arrowActionIdentifier = {
  NEXT: "next",
  PREVIOUS: "previous"
};
const ProductCardColorSwatches = ({
  colors,
  onColorChange,
  selectedValue,
  display
}) => {
  const [numberOfColorsToDisplay, setNumberOfColorsToDisplay] = useState(magicNumber.FIVE);
  const variantsListRef = useRef(null);
  const onVariantClick = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    onColorChange(value);
  };
  const getColorsCount = useCallback(() => {
    let count = magicNumber.FIVE;
    if (window.innerWidth < BREAKPOINTS.tabletMaxWidth) {
      count = magicNumber.FOUR;
    }
    if (window.innerWidth < BREAKPOINTS.mobileMaxWidth) {
      count = magicNumber.THREE;
    }
    setNumberOfColorsToDisplay(count);
  }, []);
  const additionalColorsCount = useMemo(() => {
    return colors.length - numberOfColorsToDisplay;
  }, [colors.length, numberOfColorsToDisplay]);
  useEffect(() => {
    getColorsCount();
  }, [getColorsCount]);
  useGlobalResizeEvent(getColorsCount);
  const variantsOutsideActionHandler = useCallback(() => {
    var _a, _b;
    const variantsList = getInteractiveElements(variantsListRef == null ? void 0 : variantsListRef.current);
    resetTabindexForVariants(variantsList);
    (_b = (_a = variantsListRef == null ? void 0 : variantsListRef.current) == null ? void 0 : _a.querySelector('[aria-checked="true"]')) == null ? void 0 : _b.setAttribute("tabindex", "0");
  }, []);
  useOnClickOutside(variantsListRef, variantsOutsideActionHandler);
  useOnKeyDownOutside(variantsListRef, variantsOutsideActionHandler);
  const getImageUrl = (url) => {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  };
  const resetTabindexForVariants = (variantsList) => {
    variantsList.forEach((item) => {
      item.setAttribute("tabindex", "-1");
    });
  };
  const resetAriaCheckedForVariants = (variantsList) => {
    variantsList.forEach((item) => {
      item.setAttribute("aria-checked", "false");
    });
  };
  const handleArrowsForVariants = (event, action, currentIndex) => {
    event.preventDefault();
    event.stopPropagation();
    const variantsList = getInteractiveElements(variantsListRef == null ? void 0 : variantsListRef.current);
    resetTabindexForVariants(variantsList);
    let interactiveElement;
    if (action === arrowActionIdentifier.NEXT) {
      interactiveElement = getNextInteractiveElement(currentIndex, variantsList);
    }
    if (action === arrowActionIdentifier.PREVIOUS) {
      interactiveElement = getPreviousInteractiveElement(currentIndex, variantsList);
    }
    interactiveElement == null ? void 0 : interactiveElement.setAttribute("tabindex", "0");
    interactiveElement == null ? void 0 : interactiveElement.focus();
  };
  const handleKeyDownForVariants = (event, currentIndex, variant) => {
    if (event.key === stringKeyCodes.rightArrow || event.key === stringKeyCodes.upArrow) {
      handleArrowsForVariants(event, arrowActionIdentifier.NEXT, currentIndex);
    } else if (event.key === stringKeyCodes.leftArrow || event.key === stringKeyCodes.downArrow) {
      handleArrowsForVariants(event, arrowActionIdentifier.PREVIOUS, currentIndex);
    } else if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.space) {
      triggerVariantChange(event, currentIndex, variant);
    }
  };
  const triggerVariantChange = (event, currentIndex, variant) => {
    const variantsList = getInteractiveElements(variantsListRef == null ? void 0 : variantsListRef.current);
    resetTabindexForVariants(variantsList);
    resetAriaCheckedForVariants(variantsList);
    variantsList[currentIndex].setAttribute("tabindex", "0");
    variantsList[currentIndex].setAttribute("aria-checked", "true");
    onVariantClick(event, variant);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "ul",
      {
        role: "radiogroup",
        ref: variantsListRef,
        "aria-label": display,
        className: `${PREFIX}-variants__variant-list ${PREFIX}-variants__plp-color-swatches`,
        children: colors.slice(magicNumber.ZERO, numberOfColorsToDisplay).map((color, currentIndex) => {
          const isVariantSelected = selectedValue === color.id;
          const isSelectedClass = isVariantSelected ? `${PREFIX}-variants__variant--selected` : `${PREFIX}-variants__variant--unselected`;
          return /* @__PURE__ */ jsx("li", { role: "presentation", className: "nl-variants__variant-item", children: /* @__PURE__ */ jsx(
            "div",
            {
              role: currentIndex > magicNumber.MINUS_ONE ? "radio" : "",
              "data-accessibility": currentIndex > magicNumber.MINUS_ONE ? "true" : "false",
              "aria-checked": currentIndex ? "false" : "true",
              "aria-label": color.value,
              onClick: (event) => {
                triggerVariantChange(event, currentIndex, color);
              },
              onKeyDown: (event) => {
                handleKeyDownForVariants(event, currentIndex, color);
              },
              className: `nl-variants__variant nl-variants__variant--colour-swatches nl-variants__variant-plp--colour-swatches ${isSelectedClass}`,
              children: /* @__PURE__ */ jsx("img", { src: getImageUrl(color.swatchImage), alt: color.value })
            }
          ) }, color.id);
        })
      }
    ),
    additionalColorsCount > 0 ? /* @__PURE__ */ jsxs("button", { className: `${PREFIX}-variants__plp-show-more`, children: [
      "+",
      additionalColorsCount
    ] }) : null
  ] });
};
const getDeviceOS = () => {
  const userAgent = navigator.userAgent;
  if (/android/i.test(userAgent)) {
    return OSType.android;
  } else if (/iPad|iPhone|iPod/.test(userAgent)) {
    return OSType.ios;
  } else if (/Mac/.test(userAgent)) {
    return OSType.macOS;
  } else {
    return void 0;
  }
};
const useScrollRestoration = () => {
  const restorationRef = useRef(null);
  const saveDataAsScrollRestorationId = (dataAsStringId) => {
    sessionStorage.setItem(scrollRestorationKey, dataAsStringId);
  };
  const getScrollRestorationId = () => sessionStorage.getItem(scrollRestorationKey);
  const removeScrollRestorationId = () => sessionStorage.removeItem(scrollRestorationKey);
  const restoreScroll = () => {
    const restorationId = getScrollRestorationId();
    const product = restorationRef.current || document.getElementById(restorationId);
    if (product) {
      const deviceOS = getDeviceOS();
      const isIOS = deviceOS === OSType.macOS || deviceOS === OSType.ios;
      product.scrollIntoView(isIOS ? void 0 : { behavior: "smooth", block: "center" });
      product.focus();
      removeScrollRestorationId();
    }
  };
  return {
    restorationRef,
    getScrollRestorationId,
    saveDataAsScrollRestorationId,
    removeScrollRestorationId,
    restoreScroll
  };
};
const cartClass = `${PREFIX}-shopping-cart__item`;
const getBuyItAgainCta = (label, url, productname) => {
  return /* @__PURE__ */ jsx("div", { className: `${cartClass}__buy-again-button ${PREFIX}-row`, children: /* @__PURE__ */ jsx(
    Button,
    {
      id: "buy-again-button",
      type: "secondary",
      size: "mini",
      ariaLabel: `${label}: ${productname}`,
      onClick: () => {
        window.location.href = encodeURI(url);
      },
      children: label
    }
  ) });
};
const renderItemPrice = (quantity, currentprice, totalprice) => {
  return quantity > magicNumber.ONE ? totalprice : currentprice;
};
var productWheelTypes$1 = /* @__PURE__ */ ((productWheelTypes2) => {
  productWheelTypes2["Tire"] = "TIRE";
  productWheelTypes2["Wheel"] = "WHEEL";
  productWheelTypes2["WinterTire"] = "WINTER_TIRE";
  return productWheelTypes2;
})(productWheelTypes$1 || {});
const isProductTire = (product) => {
  var _a, _b;
  return (product == null ? void 0 : product.productWheelType) && (((_a = product == null ? void 0 : product.productWheelType) == null ? void 0 : _a.toUpperCase()) === "TIRE" || ((_b = product == null ? void 0 : product.productWheelType) == null ? void 0 : _b.toUpperCase()) === "WINTER_TIRE") ? true : false;
};
const isProductWheel = (product) => {
  var _a;
  return (product == null ? void 0 : product.productWheelType) && ((_a = product == null ? void 0 : product.productWheelType) == null ? void 0 : _a.toUpperCase()) === "WHEEL";
};
const isTireOrWheelProduct = (product) => {
  return isProductTire(product) || isProductWheel(product);
};
const openMiniPDPAnalyticValue = "Open mini PDP";
const atcSingleSkuPDPAnalyticValue = "ATC single sku";
const ProductCardATC = (props) => {
  const {
    showAtcBtnSpinner,
    product,
    addToCartBtnClick,
    idx,
    addButton,
    optionsButton,
    enableAddToCartOptions,
    enableMiniPdpFlyoutSupport,
    enableATCForSingleSkuMiniPdp,
    addToCartLabel,
    selectedColorVariantData,
    quickLookLabel,
    componentName
  } = props;
  const { showATCButton, isMultiSku, hasAtcQuickLookFlow } = product || {};
  const hasAtcQuickLookBtn = useMemo(
    () => enableMiniPdpFlyoutSupport || hasAtcQuickLookFlow,
    [enableMiniPdpFlyoutSupport, hasAtcQuickLookFlow]
  );
  const hasAtcOptionsBtn = useMemo(() => enableAddToCartOptions, [enableAddToCartOptions]);
  const atcQuickLookLabel = useMemo(
    () => isMultiSku || enableATCForSingleSkuMiniPdp ? quickLookLabel : addToCartLabel,
    [isMultiSku, enableATCForSingleSkuMiniPdp, quickLookLabel, addToCartLabel]
  );
  const componentNameForAnalytic = useMemo(() => componentName ?? getPageType(), [componentName]);
  const handleATCKeyDown = (event) => {
    if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.spacing) {
      addToCartBtnClick(event, product, idx, isTireOrWheelProduct(product));
    }
  };
  const renderATCLabel = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: showATCButton ? /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-product-card__atc-button-label`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-cart", size: "md" }),
      addButton
    ] }) : /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__atc-button-label`, children: optionsButton }) });
  };
  if (hasAtcQuickLookBtn) {
    const hasAtcIcon = !isMultiSku && !enableATCForSingleSkuMiniPdp;
    const dapWacLinkValue = hasAtcIcon ? atcSingleSkuPDPAnalyticValue : openMiniPDPAnalyticValue;
    return /* @__PURE__ */ jsx(
      Button,
      {
        size: "mini",
        ariaLabel: atcQuickLookLabel,
        showSpinner: showAtcBtnSpinner,
        modifierClass: classnames(
          `${PREFIX}-product-card__atc-button`,
          `${PREFIX}-product-card__atc-button--quick-look`
        ),
        onKeyDown: handleATCKeyDown,
        onClick: (event) => {
          addToCartBtnClick(
            event,
            product,
            idx,
            isTireOrWheelProduct(product),
            `${(selectedColorVariantData == null ? void 0 : selectedColorVariantData.id) || ""}|${(selectedColorVariantData == null ? void 0 : selectedColorVariantData.value) || ""}`
          );
        },
        dapWacLink: "true",
        location: componentNameForAnalytic,
        linkValue: dapWacLinkValue,
        children: !showAtcBtnSpinner && /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-product-card__atc-button-label`, children: [
          hasAtcIcon && /* @__PURE__ */ jsx(Icon, { type: "ct-cart", size: "md" }),
          atcQuickLookLabel
        ] })
      }
    );
  }
  return hasAtcOptionsBtn ? /* @__PURE__ */ jsx(
    Button,
    {
      size: "mini",
      ariaLabel: showATCButton ? addToCartLabel : optionsButton,
      showSpinner: showAtcBtnSpinner,
      modifierClass: `${PREFIX}-product-card__atc-button`,
      onKeyDown: (event) => showATCButton ? handleATCKeyDown(event) : "",
      onClick: (event) => showATCButton ? addToCartBtnClick(
        event,
        product,
        idx,
        isTireOrWheelProduct(product),
        `${(selectedColorVariantData == null ? void 0 : selectedColorVariantData.id) || ""}|${(selectedColorVariantData == null ? void 0 : selectedColorVariantData.value) || ""}`
      ) : "",
      location: getPageType(),
      children: !showAtcBtnSpinner && renderATCLabel()
    }
  ) : null;
};
ProductCardATC.propTypes = {
  showAtcBtnSpinner: PropTypes.bool,
  product: PropTypes.object.isRequired,
  addToCartBtnClick: PropTypes.func,
  idx: PropTypes.number,
  addButton: PropTypes.string,
  optionsButton: PropTypes.string,
  enableAddToCartOptions: PropTypes.bool,
  enableMiniPdpFlyoutSupport: PropTypes.bool,
  addToCartLabel: PropTypes.string
};
const ProductCardWishlist = (props) => {
  const {
    isWishlistEligible,
    a11yWishlistIcon,
    showWishlistBtnSpinner,
    product,
    isWishlistItemActive,
    idx,
    addProductItemToWishlist,
    isWishlistToShow
  } = props;
  const handleWishlistKeyDown = (event) => {
    if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.spacing) {
      addProductItemToWishlist(event, product, isWishlistItemActive, idx);
    }
  };
  return isWishlistToShow && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__wishlist`, children: isWishlistEligible && /* @__PURE__ */ jsx(
    Button,
    {
      modifierClass: `${PREFIX}-product-card__wishlist--icon`,
      ariaLabel: a11yWishlistIcon,
      showSpinner: showWishlistBtnSpinner,
      onKeyDown: (event) => handleWishlistKeyDown(event),
      onClick: (event) => addProductItemToWishlist(event, product, isWishlistItemActive, idx),
      children: !showWishlistBtnSpinner && /* @__PURE__ */ jsx(
        Icon,
        {
          type: isWishlistItemActive ? "ct-favorite-active" : "ct-favorite-inactive",
          size: "lg"
        }
      )
    }
  ) });
};
ProductCardWishlist.propTypes = {
  isWishlistEligible: PropTypes.bool,
  a11yWishlistIcon: PropTypes.string,
  showWishlistBtnSpinner: PropTypes.bool,
  product: PropTypes.object.isRequired,
  isWishlistItemActive: PropTypes.bool,
  idx: PropTypes.number,
  addProductItemToWishlist: PropTypes.func
};
ProductCardWishlist.displayName = "ProductCardWishlist";
const CompareCheckbox = (props) => {
  const {
    addProductItemToCompare,
    product,
    idx,
    isCompareProductChecked,
    compareProductsLabel,
    showCompareCheckbox
  } = props;
  const handleCompareKeyDown = (event) => {
    if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.spacing) {
      addProductItemToCompare(event, product, idx, isCompareProductChecked);
    }
  };
  return showCompareCheckbox && /* @__PURE__ */ jsx(
    "div",
    {
      className: `${PREFIX}-product-card__compare-checkbox`,
      role: "checkbox",
      "aria-checked": false,
      tabIndex: 0,
      onKeyDown: (event) => handleCompareKeyDown(event),
      onClick: (event) => addProductItemToCompare(event, product, idx, isCompareProductChecked),
      children: /* @__PURE__ */ jsx(
        Checkbox,
        {
          id: "checkbox",
          label: compareProductsLabel,
          checked: isCompareProductChecked ? true : false,
          ariaLabel: compareProductsLabel
        }
      )
    }
  );
};
const useCalculatedLoyaltyValue = (loyaltyObj, isStaggered, productQuantity) => {
  const {
    frontQuantitySelected = 0,
    rearQuantitySelected = 0,
    quantitySelected = 0,
    qtySelectorInput = 0
  } = productQuantity;
  const { OfferRewardValue = "", RewardPercentage, OfferRule } = (loyaltyObj == null ? void 0 : loyaltyObj.Bonus) || {};
  const calculatedLoyaltyValue = useCallback(() => {
    let quantity;
    if (isStaggered) {
      if (qtySelectorInput === frontQuantitySelected) {
        quantity = frontQuantitySelected;
      } else {
        quantity = rearQuantitySelected ?? quantitySelected;
      }
    } else {
      quantity = qtySelectorInput;
    }
    return {
      ...loyaltyObj,
      Bonus: {
        OfferRewardValue: getFormattedPriceWithLocale(Math.trunc(Number(OfferRewardValue) * quantity), 0, 0),
        OfferRule: OfferRule || "",
        RewardPercentage: RewardPercentage || ""
      }
    };
  }, [
    OfferRewardValue,
    OfferRule,
    RewardPercentage,
    frontQuantitySelected,
    isStaggered,
    loyaltyObj,
    qtySelectorInput,
    quantitySelected,
    rearQuantitySelected
  ]);
  return calculatedLoyaltyValue();
};
const ProductCard = ({
  productProps: {
    ratingsAndReview,
    featureHeaderLabel,
    variantAvailableMsg,
    a11yPriceRangeFrom,
    a11yPriceRangeTo,
    fulfillment,
    sellable,
    orderable,
    enableAddToCartOptions,
    addButton,
    optionsButton,
    hideSaleEndDaySoonMessage
  },
  isInBuyBox,
  product,
  idx,
  cardType,
  title,
  brand,
  code,
  inImageBadgePriorities,
  badgePriorities,
  badges,
  showBadge = true,
  discount,
  hideDisclaimer,
  hideDescription,
  productCardClick,
  hideSaveLabel,
  a11yStrikeOutPrice,
  a11yStrikeOutPriceRange,
  a11yCloseIconLabel,
  a11yTooltipIcon,
  images,
  featureBullets,
  options,
  currentPrice,
  originalPrice,
  displayWasLabel,
  language: language2,
  feeTitle,
  feeDisclaimerMessage,
  feeDisclaimerTitle,
  showFBTComponent,
  priceMessage,
  rebateIcon,
  rebate,
  nowFromLabel,
  saveFromLabel,
  wasFromLabel,
  fromLabel,
  feeDisclaimerType,
  imageDataComponentName,
  returnPolicy,
  isMultiSku,
  inStockOnlineLabel,
  outOfStockLabel,
  inStorePurchaseLabel,
  inStockAisleLabel,
  checkAvailabilityLabel,
  checkOtherStoresLabel,
  overridePriceHeight,
  unitPriceLabel,
  clearancePriceLabel,
  promotionalPriceLabel,
  thresholdValue,
  enableSaveStory,
  enableMiniPdpFlyoutSupport,
  enableATCForSingleSkuMiniPdp,
  url,
  isUrgentLowStock,
  isUrgentLowStockLabel,
  isWheelOrTirePDP,
  eachLabel,
  isAutomotiveProduct,
  isScrollingRequired,
  isLazyRequire,
  productDataId,
  saleEndDaySoonMessage,
  isColourSwatchesActive,
  saleMessagesRules,
  saleEndDisableShift,
  a11yVariantSelected,
  a11yVariantUnSelected,
  a11yClickToReadFootnote,
  accessibilityId,
  plusMinusSymbol,
  boldBrand,
  isOnSale,
  enableBadges,
  showSaleClearanceBadge,
  addToCartBtnClick,
  showAtcBtnSpinner,
  addToCartLabel,
  sectionTitle,
  componentName,
  swiperLazyLoading,
  sponsoredLabel,
  addProductItemToWishlist,
  isWishlistItemActive,
  isWishlistEligible,
  showWishlistBtnSpinner,
  a11yWishlistIcon,
  quickLookLabel,
  isWishlistToShow,
  addProductItemToCompare,
  isCompareProductChecked,
  compareProductsLabel,
  isWestPriceLazyLoadEnabled,
  showCloseBtn,
  removeCompareProductCard,
  closeLabel,
  isPriceRangeViewEnabled = false,
  isFullModalOpen = false,
  isHalfModalOpen = false,
  isSticky = false,
  showCompareCheckbox
}) => {
  var _a, _b;
  const GridView2 = cardType === grid;
  const isMobile2 = useIsMobile();
  const colorVariant = useMemo(() => {
    return options == null ? void 0 : options.find((variant) => {
      return variant.descriptor === COLOR;
    });
  }, [options]);
  const defaultColorSwatch = (_a = colorVariant == null ? void 0 : colorVariant.values) == null ? void 0 : _a.find((items) => items == null ? void 0 : items.defaultSelect);
  const [currentColorVariantData, setCurrentColorVariantData] = useState(
    defaultColorSwatch || ((_b = colorVariant == null ? void 0 : colorVariant.values) == null ? void 0 : _b[0])
  );
  const [isColorChanged, setIsColorChanged] = useState(false);
  const compareCheckboxClass = showCompareCheckbox ? `${PREFIX}-product-card__compare-check-box` : "";
  const loyaltyValue = useCalculatedLoyaltyValue(product == null ? void 0 : product.loyalty, false, {
    qtySelectorInput: 1
  });
  const currentLevelData = useMemo(() => {
    var _a2, _b2;
    if (colorVariant) {
      const currentColor = currentColorVariantData || ((_a2 = colorVariant == null ? void 0 : colorVariant.values) == null ? void 0 : _a2[0]);
      const selectedSku = (_b2 = product == null ? void 0 : product.skus) == null ? void 0 : _b2.find((sku) => sku.code === currentColor.skuCodes[0]);
      isWestPriceLazyLoadEnabled && !!selectedSku && Object.assign(currentColor, {
        ...selectedSku
      });
      return currentColor;
    }
    return {
      ...product,
      originalPrice,
      currentPrice,
      badges,
      displayWasLabel,
      priceMessage,
      isOnSale
    };
  }, [
    colorVariant,
    product,
    originalPrice,
    currentPrice,
    badges,
    displayWasLabel,
    priceMessage,
    isOnSale,
    currentColorVariantData,
    isWestPriceLazyLoadEnabled
  ]);
  const saveMessage = useGenerateSaveMessage(
    currentLevelData == null ? void 0 : currentLevelData.saleCut,
    currentLevelData == null ? void 0 : currentLevelData.originalPrice,
    saleMessagesRules,
    currentLevelData == null ? void 0 : currentLevelData.currentPrice
  );
  const { restorationRef, getScrollRestorationId, restoreScroll, saveDataAsScrollRestorationId } = useScrollRestoration();
  const onProductClick = (event, selectedColorId) => {
    if (GridView2) {
      saveDataAsScrollRestorationId(productDataId);
    }
    productCardClick(event, product, idx, null, selectedColorId);
  };
  const createUrlWithPolicy2 = (source, policyType) => {
    var _a2;
    return policyType ? `${(_a2 = source == null ? void 0 : source.toString()) == null ? void 0 : _a2.split("?", magicNumber.ONE).toString()}${returnPolicy(policyType)}` : `${source}`;
  };
  const isAcceptablePage = useCallback(() => {
    return pagesForScrollRestoration == null ? void 0 : pagesForScrollRestoration.includes(getPageType());
  }, [pagesForScrollRestoration]);
  useEffect(() => {
    const savedDataAsScrollRestorationId = getScrollRestorationId();
    const isIdsMatched = productDataId === savedDataAsScrollRestorationId;
    if (isIdsMatched && isAcceptablePage()) {
      restoreScroll();
    }
  }, [restorationRef.current, productDataId, getScrollRestorationId, restoreScroll, isAcceptablePage]);
  const handleMouseEvent = (_e, productImage) => {
    var _a2, _b2;
    if (((_b2 = (_a2 = _e.target) == null ? void 0 : _a2.parentElement) == null ? void 0 : _b2.className) === `${PREFIX}-product-card__image-wrap` && productImage) {
      _e.target["src"] = `${createUrlWithPolicy2(productImage, imageDataComponentName)}`;
    }
  };
  const renderAvailabilityStatement = () => {
    if (fulfillment) {
      const quantityFlag = fulfillment.availability.quantity;
      const corporateQuantityFlag = fulfillment.availability.Corporate.Quantity;
      const sellableFlag = sellable;
      const orderableFlag = orderable;
      return getAvailabilityMessage(quantityFlag, corporateQuantityFlag, sellableFlag, orderableFlag);
    }
    return null;
  };
  const renderUrgencyLowStockMessage = (quantityFlag) => {
    const urgencyMsg = isUrgentLowStockLabel ? replaceStrWithDynamicVal(isUrgentLowStockLabel, quantityFlag == null ? void 0 : quantityFlag.toString()) : "";
    return /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__urgentLowStock`, children: urgencyMsg }) });
  };
  const getAvailabilityMessage = (quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag) => {
    let availabilityLabel = replaceStrWithDynamicVal(
      inStockAisleLabel,
      (quantityFlag == null ? void 0 : quantityFlag.toString()) ?? ""
    );
    if (isSellableAndInStock(quantityFlag, isSellableFlag)) {
      if (isUrgentLowStock) {
        availabilityLabel = renderUrgencyLowStockMessage(quantityFlag);
      }
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-product-card__availability-message`,
          id: getAccessibilityAvailabilityId(accessibilityId),
          children: /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }) }),
            availabilityLabel
          ] })
        }
      );
    } else if (isNotSellableAndInStock(quantityFlag, isSellableFlag)) {
      if (isUrgentLowStock) {
        availabilityLabel = renderUrgencyLowStockMessage(quantityFlag);
      }
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${PREFIX}-product-card__availability-message`,
          id: getAccessibilityAvailabilityId(accessibilityId),
          children: [
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }) }),
              availabilityLabel
            ] }),
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }) }),
              inStorePurchaseLabel
            ] })
          ]
        }
      );
    } else if (isSellableAndOrderable(quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag)) {
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-product-card__availability-message`,
          id: getAccessibilityAvailabilityId(accessibilityId),
          children: /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }) }),
            inStockOnlineLabel
          ] })
        }
      );
    } else if (checkOtherStores(quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag)) {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${PREFIX}-product-card__availability-message`,
          id: getAccessibilityAvailabilityId(accessibilityId),
          children: [
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: "ct-prohibited", size: "sm" }) }),
              availabilityLabel
            ] }),
            corporateQuantityFlag > 0 && /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }) }),
              /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__link-text`, children: checkOtherStoresLabel })
            ] })
          ]
        }
      );
    } else if (isMultiSku) {
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-product-card__availability-message`,
          id: getAccessibilityAvailabilityId(accessibilityId),
          children: /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }) }),
            /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__link-text`, children: checkAvailabilityLabel })
          ] })
        }
      );
    } else if (isOutOfStock(quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag)) {
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-product-card__availability-message`,
          id: getAccessibilityAvailabilityId(accessibilityId),
          children: /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: "ct-prohibited", size: "sm" }) }),
            outOfStockLabel
          ] })
        }
      );
    } else {
      return null;
    }
  };
  const isSellableAndInStock = (quantityFlag, isSellableFlag) => {
    return !isMultiSku && quantityFlag > 0 && isSellableFlag === true;
  };
  const isNotSellableAndInStock = (quantityFlag, isSellableFlag) => {
    return !isMultiSku && quantityFlag > 0 && isSellableFlag === false;
  };
  const isSellableAndOrderable = (quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag) => {
    const isQtyValid = quantityFlag === 0 && corporateQuantityFlag > 0;
    return !isMultiSku && isQtyValid && isSellableFlag === true && isOrderableFlag === true;
  };
  const checkOtherStores = (quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag) => {
    return !isMultiSku && (isInStockCheckOtherStores(quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag) || isNotInStockCheckOtherStores(quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag));
  };
  const isInStockCheckOtherStores = (quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag) => {
    return (
      // eslint-disable-next-line sonar/expression-complexity
      quantityFlag === 0 && corporateQuantityFlag > 0 && (isSellableFlag === true && isOrderableFlag === false || isSellableFlag === false && isOrderableFlag === true || isSellableFlag === false && isOrderableFlag === false)
    );
  };
  const isNotInStockCheckOtherStores = (quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag) => {
    return (
      // eslint-disable-next-line sonar/expression-complexity
      quantityFlag === 0 && !corporateQuantityFlag && (isSellableFlag === true && isOrderableFlag === true || isSellableFlag === true && isOrderableFlag === false)
    );
  };
  const isOutOfStock = (quantityFlag, corporateQuantityFlag, isSellableFlag, isOrderableFlag) => {
    return (
      // eslint-disable-next-line sonar/expression-complexity
      isMultiSku && quantityFlag === 0 && corporateQuantityFlag > 0 && isSellableFlag === true && isOrderableFlag === false
    );
  };
  const ratingsView = () => {
    return ratingsAndReview ? /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-reviews__list`,
        "data-bv-show": "inline_rating",
        "data-bv-product-id": productDataId,
        "data-bv-seo": "false",
        "aria-hidden": true
      }
    ) : null;
  };
  const renderPriceComponent = () => {
    return /* @__PURE__ */ jsx(
      Price,
      {
        isRangeView: isPriceRangeViewEnabled,
        discountValue: discount,
        promotionalPriceLabel: discount ? promotionalPriceLabel : null,
        thresholdValue,
        unitPriceLabel,
        clearancePriceLabel,
        a11yPriceRangeFrom,
        a11yPriceRangeTo,
        hideSaveLabel,
        a11yStrikeOutPrice,
        a11yStrikeOutPriceRange,
        a11yTooltipIcon,
        a11yCloseIconLabel,
        feeTitle,
        feeDisclaimerTitle,
        feeDisclaimerMessage,
        currentPrice: currentLevelData == null ? void 0 : currentLevelData.currentPrice,
        originalPrice: currentLevelData == null ? void 0 : currentLevelData.originalPrice,
        displayWasLabel: currentLevelData == null ? void 0 : currentLevelData.displayWasLabel,
        language: language2,
        priceMessage: currentLevelData == null ? void 0 : currentLevelData.priceMessage,
        scrollToFooter,
        nowFromLabel,
        saveFromLabel,
        wasFromLabel,
        fromLabel,
        feeDisclaimerType,
        overridePriceHeight,
        showEachTextForSaveLabel: enableSaveStory,
        isAutomotiveEachLabel: isWheelOrTirePDP,
        eachLabel,
        saveMessage,
        a11yClickToReadFootnote,
        accessibilityPriceId: getAccessibilityPriceId(accessibilityId),
        ariaHidden: true,
        highlightDiscountedPrice: true,
        plusMinusSymbol,
        isOnSaleOrClearance: currentLevelData == null ? void 0 : currentLevelData.isOnSale
      }
    );
  };
  const renderColorSwatches = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__color-swatches`, children: colorVariant && /* @__PURE__ */ jsx(
      ProductCardColorSwatches,
      {
        colors: colorVariant.values,
        onColorChange,
        selectedValue: currentColorVariantData == null ? void 0 : currentColorVariantData.id,
        a11yVariantSelected,
        a11yVariantUnSelected,
        display: colorVariant.display
      }
    ) });
  };
  const onColorChange = useCallback((currentVariant) => {
    setCurrentColorVariantData({ ...currentVariant });
    setIsColorChanged(true);
  }, []);
  const { message, greyCopyMsg, pdfLink } = rebate || {};
  const renderPromoMessages = () => {
    const promoMessages = currentLevelData == null ? void 0 : currentLevelData.promoMessages;
    const restrictedPromoMessages = currentLevelData == null ? void 0 : currentLevelData.restrictedPromoMessages;
    const isRenderPromoMessages = checkDataLength(promoMessages) || checkDataLength(restrictedPromoMessages);
    return isRenderPromoMessages ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-promo-messages-wrapper`, id: getAccessibilityPromoId(accessibilityId), children: /* @__PURE__ */ jsx(
      PromoMessages,
      {
        isProductLevel: true,
        productPromoMessages: promoMessages,
        productRestrictedPromoMessages: restrictedPromoMessages,
        a11yTooltipIcon,
        a11yCloseIconLabel
      }
    ) }) : null;
  };
  const getDisclaimerData = () => !(colorVariant == null ? void 0 : colorVariant.showDisclaimer) || hideDisclaimer;
  const productCodeDisplay = () => {
    return code && /* @__PURE__ */ jsxs("p", { className: `${PREFIX}-product__code`, "aria-hidden": true, children: [
      "#",
      code
    ] });
  };
  const renderPriceBadge = () => {
    const saleEndDate = (currentColorVariantData == null ? void 0 : currentColorVariantData.saleEndDate) || (currentLevelData == null ? void 0 : currentLevelData.saleEndDate);
    const badgesToDisplay = currentLevelData == null ? void 0 : currentLevelData.badges;
    return enableBadges && showSaleClearanceBadge && !isInBuyBox ? /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-price-badge-wrapper`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-carousel-price`, children: renderPriceComponent() }),
      renderPromoMessages(),
      areAllParamsValid(!isSticky, showBadge, checkDataLength(badgesToDisplay)) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-plp-badges`, "aria-hidden": true, children: /* @__PURE__ */ jsx(
        Badges,
        {
          badges: badgesToDisplay,
          badgesAndPriorities: badgePriorities,
          hideDisclaimer: getDisclaimerData(),
          saleEndDaySoonMessage,
          salePriceEndDate: saleEndDate,
          saleEndDisableShift,
          hideSaleEndDaySoonMessage,
          loyaltyValue
        }
      ) })
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      renderPriceComponent(),
      renderPromoMessages(),
      areAllParamsValid(!isSticky, showBadge, checkDataLength(badgesToDisplay)) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-plp-badges`, "aria-hidden": true, children: /* @__PURE__ */ jsx(
        Badges,
        {
          badges: badgesToDisplay,
          badgesAndPriorities: badgePriorities,
          hideDisclaimer: getDisclaimerData(),
          saleEndDaySoonMessage,
          salePriceEndDate: saleEndDate,
          saleEndDisableShift,
          hideSaleEndDaySoonMessage,
          loyaltyValue
        }
      ) })
    ] });
  };
  const productInfoTitle = () => {
    return /* @__PURE__ */ jsx(
      ProductInformation,
      {
        brand,
        title,
        hideDescription,
        titleStyle: `${PREFIX}-product-card__title ${PREFIX}-product--trim`,
        titleContainerStyle: `${PREFIX}-product-card__title-container`,
        accessibilityTitleId: getAccessibilityTitleId(accessibilityId),
        boldBrand
      }
    );
  };
  const productInfoComponent = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__product-information ${compareCheckboxClass}`, children: [
      !showFBTComponent && productInfoTitle(),
      showFBTComponent && isMobile2 && productInfoTitle(),
      !showFBTComponent && ratingsView(),
      !GridView2 && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__wishlist-section`, children: [
        /* @__PURE__ */ jsx(
          ProductCardATC,
          {
            showAtcBtnSpinner,
            product,
            addToCartBtnClick,
            idx,
            addButton,
            optionsButton,
            enableAddToCartOptions,
            enableMiniPdpFlyoutSupport,
            enableATCForSingleSkuMiniPdp,
            addToCartLabel,
            selectedColorVariantData: currentColorVariantData,
            quickLookLabel
          }
        ),
        /* @__PURE__ */ jsx(
          ProductCardWishlist,
          {
            isWishlistEligible,
            a11yWishlistIcon,
            showWishlistBtnSpinner,
            addProductItemToWishlist,
            isWishlistItemActive: Boolean(isWishlistItemActive),
            product,
            idx,
            isWishlistToShow
          }
        )
      ] }),
      renderPriceBadge(),
      showFBTComponent && ratingsView(),
      !showFBTComponent && productCodeDisplay(),
      rebate && Object.keys(rebate).length && /* @__PURE__ */ jsx(
        Rebate,
        {
          title: message,
          rebateIcon,
          greyCopyMsg,
          pdfLink,
          ariaHidden: true
        }
      ),
      renderAvailabilityStatement(),
      // eslint-disable-next-line sonar/expression-complexity
      variantAvailableMsg && Array.isArray(options) && options.length > minOptionsArrayLength && !isAutomotiveProduct && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-product-card__colors ${PREFIX}-product-card__colour-label`,
          "aria-hidden": true,
          children: /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__show-colour`, children: variantAvailableMsg })
        }
      )
    ] });
  };
  const featureSection = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: !GridView2 && featureBullets && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__features`, "data-testid": "product-card-features", children: [
      /* @__PURE__ */ jsx("h4", { className: `${PREFIX}-product-card__features-heading`, children: featureHeaderLabel }),
      /* @__PURE__ */ jsx("ul", { className: ` ${PREFIX}-product-card__features-deck`, children: featureBullets.slice(0, magicNumber.THREE).map((value, index2) => {
        return /* @__PURE__ */ jsx("li", { children: value.description }, index2.toString() + value.description);
      }) }),
      /* @__PURE__ */ jsx(
        CompareCheckbox,
        {
          addProductItemToCompare,
          product: {
            ...product,
            isWishlistToShow,
            isWishlistEligible,
            isWishlistItemActive: Boolean(isWishlistItemActive)
          },
          idx,
          isCompareProductChecked,
          compareProductsLabel,
          showCompareCheckbox
        }
      )
    ] }) });
  };
  const imageAttributes2 = (path, dataComponentName) => {
    const attributeObject = {
      "data-component-name": dataComponentName
    };
    if (isLazyRequire && !isColorChanged) {
      attributeObject["data-src"] = path;
      attributeObject.className = "lazyload";
    } else {
      attributeObject.src = path;
    }
    return attributeObject;
  };
  const getPrimaryProductImage = () => {
    var _a2, _b2, _c, _d, _e;
    return ((_b2 = (_a2 = currentColorVariantData == null ? void 0 : currentColorVariantData.mediaSet) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.url) ? (_d = (_c = currentColorVariantData == null ? void 0 : currentColorVariantData.mediaSet) == null ? void 0 : _c[0]) == null ? void 0 : _d.url : (_e = images == null ? void 0 : images[0]) == null ? void 0 : _e.url;
  };
  const getAltText = () => {
    var _a2, _b2, _c;
    return ((_b2 = (_a2 = currentColorVariantData == null ? void 0 : currentColorVariantData.mediaSet) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.altText) || ((_c = images == null ? void 0 : images[0]) == null ? void 0 : _c.altText) || title || "";
  };
  const getSecondaryProductImage = () => {
    var _a2, _b2, _c, _d, _e;
    return ((_b2 = (_a2 = currentColorVariantData == null ? void 0 : currentColorVariantData.mediaSet) == null ? void 0 : _a2[1]) == null ? void 0 : _b2.url) ? (_d = (_c = currentColorVariantData == null ? void 0 : currentColorVariantData.mediaSet) == null ? void 0 : _c[1]) == null ? void 0 : _d.url : (_e = images == null ? void 0 : images[1]) == null ? void 0 : _e.url;
  };
  const renderImage = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__image-wrap`, "aria-hidden": true, children: /* @__PURE__ */ jsx(
      "img",
      {
        alt: getAltText(),
        onMouseEnter: (e) => handleMouseEvent(e, getSecondaryProductImage()),
        onMouseLeave: (e) => handleMouseEvent(e, getPrimaryProductImage()),
        ...imageAttributes2(
          `${createUrlWithPolicy2(getPrimaryProductImage(), imageDataComponentName)}`,
          imageDataComponentName
        ),
        loading: swiperLazyLoading ? "lazy" : null
      }
    ) });
  };
  const colorVariantUrl = (url == null ? void 0 : url.includes("?")) ? `${url}&colorCode=${currentColorVariantData == null ? void 0 : currentColorVariantData.id}${plpUrl}` : `${url}?colorCode=${currentColorVariantData == null ? void 0 : currentColorVariantData.id}${plpUrl}`;
  const modifiedUrl = (currentColorVariantData == null ? void 0 : currentColorVariantData.id) ? colorVariantUrl : url;
  const handleKeyUp = (event, key, scrollingRequired) => {
    if (key === stringKeyCodes.tab && scrollingRequired) {
      productCardScrollToTop(event);
    }
  };
  const handleKeyDown = (event, key, selectedColorId) => {
    if (key === stringKeyCodes.enter) {
      onProductClick(event, selectedColorId);
    }
  };
  const handleRemoveCompareProductKeyDown = (event) => {
    if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.spacing) {
      removeCompareProductCard(event, product);
    }
  };
  const renderATCButton = () => {
    return areAllParamsValid(isFullModalOpen, isSticky) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__wishlist-section`, children: renderProductCardATCComponent(true) });
  };
  const renderProductCardATCComponent = (isEnableAddToCartOptions) => {
    return /* @__PURE__ */ jsx(
      ProductCardATC,
      {
        showAtcBtnSpinner,
        product,
        addToCartBtnClick,
        idx,
        addButton,
        optionsButton,
        enableAddToCartOptions: isEnableAddToCartOptions,
        enableMiniPdpFlyoutSupport,
        enableATCForSingleSkuMiniPdp,
        addToCartLabel,
        selectedColorVariantData: currentColorVariantData,
        quickLookLabel,
        componentName
      }
    );
  };
  const renderProductCardLink = () => {
    const selectedColorId = (currentColorVariantData == null ? void 0 : currentColorVariantData.id) ?? null;
    const sponsoredA11yId = (product == null ? void 0 : product.isSponsored) ? `sponsored_${product == null ? void 0 : product.code}` : "";
    const badgesToDisplay = currentLevelData == null ? void 0 : currentLevelData.badges;
    const priorityAndName = inImageBadgePriorities == null ? void 0 : inImageBadgePriorities.priorityAndName;
    const priorityAndColourWithIconLabel = priorityAndName == null ? void 0 : priorityAndName.map((badge) => ({
      ...badge,
      badgeLabel: /* @__PURE__ */ jsx("img", { src: badge == null ? void 0 : badge.badgeIconUrl, alt: badge == null ? void 0 : badge.badgeId }),
      colorId: ""
    }));
    return /* @__PURE__ */ jsx(
      "a",
      {
        href: `${modifiedUrl}`,
        ref: restorationRef,
        "aria-labelledby": `title__${accessibilityId} ${sponsoredA11yId} price__${accessibilityId} promo__${accessibilityId} availability__${accessibilityId} `,
        className: `${PREFIX}-product-card__no-button prod-link`,
        onClick: (event) => onProductClick(event, selectedColorId),
        onKeyUp: (event) => handleKeyUp(event, event.key, isScrollingRequired),
        onKeyPress: (event) => handleKeyDown(event, event.key, selectedColorId),
        "dap-wac-link-section": sectionTitle,
        "dap-wac-value": title,
        children: /* @__PURE__ */ jsxs("div", { "data-testid": `product-card-container${idx}`, className: `${PREFIX}-product-card__content`, children: [
          /* @__PURE__ */ jsx("div", { className: `${PREFIX}-plp-in-image-badges`, children: /* @__PURE__ */ jsx(
            Badges,
            {
              badges: badgesToDisplay,
              badgesAndPriorities: {
                ...inImageBadgePriorities,
                priorityAndColour: priorityAndColourWithIconLabel
              },
              hideDisclaimer: getDisclaimerData()
            }
          ) }),
          areAllParamsValid(GridView2, !isFullModalOpen, !isHalfModalOpen) && /* @__PURE__ */ jsx(
            ProductCardWishlist,
            {
              isWishlistEligible,
              a11yWishlistIcon,
              showWishlistBtnSpinner,
              addProductItemToWishlist,
              isWishlistItemActive,
              product,
              idx,
              isWishlistToShow
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__primary-details`, children: [
            renderImage(),
            /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__cta`, children: [
              GridView2 && renderProductCardATCComponent(enableAddToCartOptions),
              isColourSwatchesActive && renderColorSwatches(),
              productInfoComponent(),
              renderATCButton()
            ] }),
            showCloseBtn && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__close-btn-container`, children: /* @__PURE__ */ jsxs(
              Button,
              {
                modifierClass: `${PREFIX}-product-card__close-btn`,
                ariaLabel: closeLabel,
                onKeyDown: handleRemoveCompareProductKeyDown,
                onClick: (event) => removeCompareProductCard(event, product),
                children: [
                  " ",
                  /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "md" })
                ]
              }
            ) })
          ] }),
          areAllParamsValid(GridView2, product == null ? void 0 : product.isSponsored) && /* @__PURE__ */ jsx(
            "small",
            {
              id: sponsoredA11yId,
              "aria-label": sponsoredLabel,
              "aria-hidden": "true",
              className: `${PREFIX}-product-card__sponsored`,
              children: sponsoredLabel
            }
          ),
          featureSection(),
          GridView2 && /* @__PURE__ */ jsx(
            CompareCheckbox,
            {
              addProductItemToCompare,
              product: {
                ...product,
                isWishlistToShow,
                isWishlistEligible,
                isWishlistItemActive: Boolean(isWishlistItemActive)
              },
              idx,
              isCompareProductChecked,
              compareProductsLabel,
              showCompareCheckbox
            }
          ),
          areAllParamsValid(isFullModalOpen, !isSticky) && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__wishlist-section`, children: [
            renderProductCardATCComponent(true),
            /* @__PURE__ */ jsx(
              ProductCardWishlist,
              {
                isWishlistEligible,
                a11yWishlistIcon,
                showWishlistBtnSpinner,
                addProductItemToWishlist,
                isWishlistItemActive: Boolean(isWishlistItemActive),
                product,
                idx,
                isWishlistToShow
              }
            )
          ] })
        ] })
      }
    );
  };
  return showFBTComponent ? /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": `product-card-container-fbt${idx}`,
      className: `${PREFIX}-product-card__content`,
      "aria-labelledby": `title__${accessibilityId} price__${accessibilityId} availability__${accessibilityId}`,
      children: [
        !isMobile2 && productInfoTitle(),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__image-wrap`, children: /* @__PURE__ */ jsx(
          "img",
          {
            "aria-hidden": true,
            onMouseEnter: (e) => {
              var _a2;
              return handleMouseEvent(e, (_a2 = images[1]) == null ? void 0 : _a2.url);
            },
            onMouseLeave: (e) => {
              var _a2;
              return handleMouseEvent(e, (_a2 = images[0]) == null ? void 0 : _a2.url);
            },
            alt: title,
            ...imageAttributes2(
              `${createUrlWithPolicy2(getPrimaryProductImage(), imageDataComponentName)}`,
              imageDataComponentName
            ),
            loading: swiperLazyLoading ? "lazy" : null
          }
        ) }),
        productInfoComponent()
      ]
    }
  ) : renderProductCardLink();
};
ProductCard.defaultProps = {
  showFBTComponent: false
};
ProductCard.propTypes = {
  path: PropTypes.string,
  productProps: PropTypes.any,
  idx: PropTypes.number.isRequired,
  cardType: PropTypes.string.isRequired,
  type: PropTypes.string,
  title: PropTypes.string.isRequired,
  code: PropTypes.string,
  brand: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.exact({
      label: PropTypes.string,
      url: PropTypes.string
    })
  ]).isRequired,
  rating: PropTypes.number.isRequired,
  ratingsCount: PropTypes.number.isRequired,
  priceShortMessage: PropTypes.string,
  priceLongMessage: PropTypes.string,
  longDescription: PropTypes.string,
  timeTestedPrice: PropTypes.any,
  permanentMarkdown: PropTypes.bool,
  sellable: PropTypes.bool,
  assemblyRequired: PropTypes.bool,
  inStock: PropTypes.bool,
  onlineOnly: PropTypes.bool,
  onFloor: PropTypes.bool,
  bopisOnly: PropTypes.bool,
  productCardClick: PropTypes.func,
  redirectAfterProductCardClick: PropTypes.func,
  badgePriorities: PropTypes.any,
  badges: PropTypes.array,
  showBadge: PropTypes.bool,
  discount: PropTypes.any,
  hideDisclaimer: PropTypes.bool,
  hideDescription: PropTypes.bool,
  hideSaveLabel: PropTypes.bool,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  a11yTooltipIcon: PropTypes.string,
  images: PropTypes.array,
  featureBullets: PropTypes.array,
  a11yCloseIconLabel: PropTypes.string,
  ecoFeeTitleChange: PropTypes.func,
  options: PropTypes.array,
  skus: PropTypes.array,
  currentPrice: PropTypes.any,
  originalPrice: PropTypes.any,
  displayWasLabel: PropTypes.bool,
  language: PropTypes.string,
  feeTitle: PropTypes.string,
  feeDisclaimerMessage: PropTypes.string,
  feeDisclaimerTitle: PropTypes.string,
  selectedProduct: PropTypes.bool,
  showFBTComponent: PropTypes.bool,
  priceMessage: PropTypes.any,
  rebate: PropTypes.any,
  rebateIcon: PropTypes.string,
  scrollToFooter: PropTypes.func,
  nowFromLabel: PropTypes.string,
  saveFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  feeDisclaimerType: PropTypes.string,
  imageDataComponentName: PropTypes.string,
  returnPolicy: PropTypes.func,
  inStockLabel: PropTypes.string,
  inStockOnlineLabel: PropTypes.string,
  outOfStockLabel: PropTypes.string,
  inStorePurchaseLabel: PropTypes.string,
  inStockAisleLabel: PropTypes.string,
  checkAvailabilityLabel: PropTypes.string,
  checkOtherStoresLabel: PropTypes.string,
  overridePriceHeight: PropTypes.bool,
  unitPriceLabel: PropTypes.string,
  clearancePriceLabel: PropTypes.string,
  promotionalPriceLabel: PropTypes.string,
  thresholdValue: PropTypes.number,
  enableSaveStory: PropTypes.bool,
  a11yReviewRating: PropTypes.string,
  url: PropTypes.string,
  isUrgentLowStock: PropTypes.bool,
  isUrgentLowStockLabel: PropTypes.string,
  productWheelType: PropTypes.string,
  isWheelOrTirePDP: PropTypes.bool,
  eachLabel: PropTypes.string,
  isAutomotiveProduct: PropTypes.bool,
  isScrollingRequired: PropTypes.bool,
  isLazyRequire: PropTypes.bool,
  product: PropTypes.object.isRequired,
  productDataId: PropTypes.string,
  saleEndDaySoonMessage: PropTypes.string,
  a11yClickToReadFootnote: PropTypes.string,
  addToCartBtnClick: PropTypes.func,
  showAtcBtnSpinner: PropTypes.bool,
  sponsoredLabel: PropTypes.string
};
ProductCard.displayName = "ProductCard";
var BannerType$1 = /* @__PURE__ */ ((BannerType2) => {
  BannerType2["Fit"] = "Fit";
  BannerType2["PartialFit"] = "PartialFit";
  BannerType2["NotFit"] = "NotFit";
  BannerType2["UnKnown"] = "UnKnown";
  return BannerType2;
})(BannerType$1 || {});
var productWheelTypes = /* @__PURE__ */ ((productWheelTypes2) => {
  productWheelTypes2["Tire"] = "TIRE";
  productWheelTypes2["Wheel"] = "WHEEL";
  productWheelTypes2["WinterTire"] = "WINTER_TIRE";
  productWheelTypes2["TiresAndWheels"] = "TIRES_AND_WHEELS";
  return productWheelTypes2;
})(productWheelTypes || {});
var CtaType = /* @__PURE__ */ ((CtaType2) => {
  CtaType2["normal"] = "normal";
  CtaType2["dropDown"] = "dropdown";
  return CtaType2;
})(CtaType || {});
const minimumVariantsLength = 1;
const staggeredSkuLength = 2;
const setOfFourCount = 4;
const minimumSpecificationCount = 0;
const maximumSpecificationCount = 3;
const productCardVehicleClassPrefix = `${PREFIX}-product-card-vehicle`;
const setOfTwoCount = 2;
const iconTypes = {
  checkmark: "checkmark",
  prohibited: "prohibited"
};
const CommonWarningToast = ({ ...props }) => {
  const toastCTAClickHandler = (event) => {
    addModalAttribute(event);
    props.toastCTAHandler && props.toastCTAHandler(true);
    props.actionCTAHandler && props.actionCTAHandler();
  };
  const serviceAddOnClass = props.isAddOn ? `${PREFIX}-warning-toast--add-on` : "";
  const renderToastButton = () => {
    return props.isLink ? /* @__PURE__ */ jsx(
      "a",
      {
        className: `${PREFIX}-add-compatible-button`,
        href: props.createPackageRedirectHandler && props.createPackageRedirectHandler(),
        onClick: (event) => props.createPackageAndNavigate(event),
        children: props.checkNearByText
      }
    ) : /* @__PURE__ */ jsx(Button, { type: "tertiary", size: "mini", onClick: toastCTAClickHandler, buttonType: "button", children: props.checkNearByText });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-warning-toast ${PREFIX}-warning-toast__${props.bgType} ${serviceAddOnClass}`,
      role: "alert",
      "aria-atomic": "true",
      children: [
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-warning-toast__text-container`, children: [
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-warning-toast__icon`, children: /* @__PURE__ */ jsx(Icon, { type: props.icon, size: "lg" }) }),
          props.label !== "" ? /* @__PURE__ */ jsx("p", { className: `${PREFIX}-warning-toast__label`, children: props.label }) : props.children
        ] }),
        !!props.checkNearByText && renderToastButton()
      ]
    }
  );
};
CommonWarningToast.propTypes = {
  icon: PropTypes.string,
  bgType: PropTypes.string,
  label: PropTypes.string,
  checkNearByText: PropTypes.string.isRequired,
  toastCTAHandler: PropTypes.func.isRequired,
  isAddOn: PropTypes.bool,
  actionCTAHandler: PropTypes.func,
  children: PropTypes.element
};
var AvailabilityBullet = /* @__PURE__ */ ((AvailabilityBullet2) => {
  AvailabilityBullet2["InStock"] = "availability-bullet--in-stock";
  AvailabilityBullet2["LowStock"] = "availability-bullet--low-stock";
  AvailabilityBullet2["NoStock"] = "availability-bullet--out-of-stock";
  return AvailabilityBullet2;
})(AvailabilityBullet || {});
const incrementOne = 1;
const prePackagedBallonBouquet = "Pre-packaged bouquet";
var eEntryType = /* @__PURE__ */ ((eEntryType2) => {
  eEntryType2["PRODUCT"] = "PRODUCT (PRO)";
  eEntryType2["SERVICE_ADDON"] = "SERVICE_ADDON (SER_ADD)";
  eEntryType2["SERVICE_STANDALONE"] = "STANDALONE (SER_STA)";
  return eEntryType2;
})(eEntryType || {});
var CartOrderDeliveryModes = /* @__PURE__ */ ((CartOrderDeliveryModes2) => {
  CartOrderDeliveryModes2["BOPIS"] = "BOPIS";
  CartOrderDeliveryModes2["STH"] = "STH";
  CartOrderDeliveryModes2["CURBSIDE"] = "CURBSIDE";
  CartOrderDeliveryModes2["EXPRESS"] = "EXPRESS";
  return CartOrderDeliveryModes2;
})(CartOrderDeliveryModes || {});
var ProductSourceTypes = /* @__PURE__ */ ((ProductSourceTypes2) => {
  ProductSourceTypes2["INSTORE"] = "INSTORE";
  ProductSourceTypes2["DC"] = "DC";
  return ProductSourceTypes2;
})(ProductSourceTypes || {});
var DeliveryStatusSTH = /* @__PURE__ */ ((DeliveryStatusSTH2) => {
  DeliveryStatusSTH2["SHIPPED"] = "SHIPPED";
  DeliveryStatusSTH2["IN_PROGRESS_STH"] = "IN_PROGRESS";
  DeliveryStatusSTH2["DELIVERED"] = "DELIVERED";
  DeliveryStatusSTH2["CANCELLATION_PENDING"] = "CANCELLATION_PENDING";
  DeliveryStatusSTH2["CANCELLED"] = "CANCELLED";
  return DeliveryStatusSTH2;
})(DeliveryStatusSTH || {});
var OptionsOnCartItem = /* @__PURE__ */ ((OptionsOnCartItem2) => {
  OptionsOnCartItem2["WISHLIST"] = "WISHLIST";
  OptionsOnCartItem2["CHECK_NEAR_BY"] = "CHECK_NEAR_BY";
  OptionsOnCartItem2["UPDATED_TEXT"] = "UPDATED_TEXT";
  OptionsOnCartItem2["PRICE_AND_QUANTITY"] = "PRICE_AND_QUANTITY";
  OptionsOnCartItem2["AVAILABILITY_INFO"] = "AVAILABILITY_INFO";
  OptionsOnCartItem2["ADD_TO_CART"] = "ADD_TO_CART";
  OptionsOnCartItem2["IN_STOCK_TAG"] = "IN_STOCK_TAG";
  OptionsOnCartItem2["STOCK_INFO"] = "STOCK_INFO";
  OptionsOnCartItem2["OUT_OF_STOCK"] = "OUT_OF_STOCK";
  OptionsOnCartItem2["COMING_SOON"] = "COMING_SOON";
  OptionsOnCartItem2["IN_STOCK_FOR_PICK_UP"] = "IN_STOCK_FOR_PICK_UP";
  OptionsOnCartItem2["IN_STOCK_FOR_PURCHASE"] = "IN_STOCK_FOR_PURCHASE";
  return OptionsOnCartItem2;
})(OptionsOnCartItem || {});
var FulfillmentErrorType = /* @__PURE__ */ ((FulfillmentErrorType2) => {
  FulfillmentErrorType2["FULFILLMENT_STH_ERROR"] = "FULFILLMENT_STH_ERROR";
  FulfillmentErrorType2["FULFILLMENT_BOPIS_ERROR"] = "FULFILLMENT_BOPIS_ERROR";
  return FulfillmentErrorType2;
})(FulfillmentErrorType || {});
var FulfillmentMethods = /* @__PURE__ */ ((FulfillmentMethods2) => {
  FulfillmentMethods2["STH"] = "STH";
  FulfillmentMethods2["BOPIS"] = "BOPIS";
  return FulfillmentMethods2;
})(FulfillmentMethods || {});
const productCartItems = {
  // Min value for qty selector input
  oneProductQuantity: 1,
  // unit quantity value
  cartDebounceTimeOut: 3e3,
  etaTimeOptions: {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "UTC"
  },
  etaDateOptions: {
    month: "short",
    day: "numeric",
    timeZone: "UTC"
  }
};
const badgesTypes = {
  onlineOnly: "ONLINEONLY"
};
const saveForLaterParam = "moveToSFL";
const createNewPackageLabel = "createNewPackageLabel";
const createNewPackageCTA = "createNewPackageCTA";
const isOrderSTH = (orderEntry) => {
  var _a, _b;
  return ((_a = orderEntry.fulfillment) == null ? void 0 : _a.deliveryMode) === CartOrderDeliveryModes.STH || ((_b = orderEntry.fulfillment) == null ? void 0 : _b.deliveryMode) === CartOrderDeliveryModes.EXPRESS;
};
const isOrderBOPIS = (orderEntry) => {
  var _a, _b;
  return ((_a = orderEntry.fulfillment) == null ? void 0 : _a.deliveryMode) === CartOrderDeliveryModes.BOPIS || ((_b = orderEntry.fulfillment) == null ? void 0 : _b.deliveryMode) === CartOrderDeliveryModes.CURBSIDE;
};
const isSthOrExpressHasError = (props, isBulk) => {
  var _a, _b;
  const errorMessage = { expressErrMsg: "", sthErrMsg: "", qtyExceedMsg: "" };
  if (!(props == null ? void 0 : props.isSelectedDeliveryAvailable)) {
    if ((_a = props == null ? void 0 : props.selectedDeliveryMode) == null ? void 0 : _a.isExpress) {
      errorMessage.expressErrMsg = isBulk ? props == null ? void 0 : props.expressDeliveryDoesNotSupportHeavyOversizedMsg : props == null ? void 0 : props.itemNotEligibleForExpressDeliveryMsg;
    } else if ((_b = props == null ? void 0 : props.selectedDeliveryMode) == null ? void 0 : _b.isSTH) {
      errorMessage.sthErrMsg = props == null ? void 0 : props.itemNotEligibleForStandardDeliveryMsg;
    }
  }
  return errorMessage;
};
const getExpressDeliveryRelatedErrorMsg = (props, isBulk) => {
  const { expressErrMsg, sthErrMsg, qtyExceedMsg } = isSthOrExpressHasError(props, isBulk);
  return expressErrMsg || sthErrMsg || qtyExceedMsg;
};
const renderWarningToast = (props, itemAvailabilityInfo, productData) => {
  var _a;
  const fulfillmentDeliverError = itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.fulfillmentDeliverError;
  const isNotApplicableForSelectedDeliveryMethod = getExpressDeliveryRelatedErrorMsg(props, productData == null ? void 0 : productData.isBulk);
  const inlineErrorMsg = (itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) ? itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.errorMessage : replaceStrWithDynamicVal(props == null ? void 0 : props.exceededMsgBar, props == null ? void 0 : props.checkErrorMessage().exceededValue);
  const errorMsg = Boolean(isNotApplicableForSelectedDeliveryMethod) ? isNotApplicableForSelectedDeliveryMethod : inlineErrorMsg;
  const isNearBy = (_a = itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed) == null ? void 0 : _a.includes(OptionsOnCartItem.CHECK_NEAR_BY);
  const nearByCTA = (itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) && isNearBy ? props.nearbyAvailabilityCTALabel : "";
  const bopisErrorLabel = fulfillmentDeliverError === FulfillmentErrorType.FULFILLMENT_BOPIS_ERROR ? props == null ? void 0 : props.changeShipToHomeCTALabel : props == null ? void 0 : props.pickAtStoreCTALabel;
  const deliveryChangeCTA = !!fulfillmentDeliverError && !isNearBy ? bopisErrorLabel : null;
  const { entryNumber } = productData;
  const isShipHome = isOrderSTH(productData);
  const isFulfillmentChange = () => {
    !!fulfillmentDeliverError && props.onChangeFulfillmentOption(isShipHome ? FulfillmentMethods.BOPIS : FulfillmentMethods.STH, entryNumber);
  };
  const toastCTAHandler = (isClicked) => {
    if (isClicked) {
      if (nearByCTA) {
        const isBouquet = (productData == null ? void 0 : productData.balloonEntryType) === balloonEntryType.preDesignedBalloonBouquet || (productData == null ? void 0 : productData.balloonEntryType) === balloonEntryType.prePackagedBalloonSku;
        props == null ? void 0 : props.checkNearByCTAHandler(productData == null ? void 0 : productData.code, isBouquet);
      } else {
        isFulfillmentChange();
      }
    }
  };
  return /* @__PURE__ */ jsx(
    CommonWarningToast,
    {
      icon: "ct-notification-caution",
      bgType: "orange",
      label: errorMsg,
      checkNearByText: deliveryChangeCTA || nearByCTA,
      toastCTAHandler
    }
  );
};
const showWishListIcon = (error, optionToDisplay) => {
  if (error) {
    return optionToDisplay.includes(OptionsOnCartItem.WISHLIST);
  }
  return true;
};
const filterSpecification = (specification, specificationsFromProps) => {
  const specificationFromPropsArr = specificationsFromProps == null ? void 0 : specificationsFromProps.split(",");
  const specificationFromPropsCaps = isArrayNotEmpty(specificationFromPropsArr) ? specificationFromPropsArr == null ? void 0 : specificationFromPropsArr.map((spec) => spec == null ? void 0 : spec.toUpperCase()) : [];
  return specification == null ? void 0 : specification.filter(
    (eachSpec) => {
      var _a;
      return specificationFromPropsCaps == null ? void 0 : specificationFromPropsCaps.includes((_a = eachSpec == null ? void 0 : eachSpec.code) == null ? void 0 : _a.toUpperCase());
    }
  );
};
if (typeof window !== "undefined") {
  window.analyticsLayer = window.analyticsLayer || [];
}
const cancellationAnalytics = (event, cancelType, cancelLocation, cancellationReason) => {
  window.analyticsLayer = window.analyticsLayer || [];
  window.analyticsLayer.push({
    event,
    cancelType,
    cancelLocation
  });
};
const showHideWasLabel = (isOrderDetails, displayWasLabel) => {
  return !isOrderDetails && displayWasLabel;
};
const showHideSaleInfo = (originalPrice, isDetailsPage) => {
  return originalPrice && !!originalPrice.value && isDetailsPage ? false : true;
};
const getFeeTitle = (feeMessageValue, feeMessage, language2) => {
  return feeMessageValue ? replaceStrWithDynamicVal(
    addDynamicToken(feeMessage == null ? void 0 : feeMessage.feeTitle, "$x"),
    getFormattedPriceValue(language2, feeMessageValue)
  ) : "";
};
const isBalloonProduct = (product) => {
  var _a, _b;
  if (!!(product == null ? void 0 : product.balloonData) && checkDataLength(product == null ? void 0 : product.balloonData)) {
    return ((_b = (_a = product == null ? void 0 : product.balloonData) == null ? void 0 : _a.balloonType) == null ? void 0 : _b.toLowerCase()) === prePackagedBallonBouquet.toLowerCase();
  }
  return false;
};
const checkIsStockInAllStore = (currentStoreQuantity, dcQuantity, orderableFromDC) => {
  const _discontinuedAndOOSInStore = () => Boolean(!currentStoreQuantity);
  const _isStockinDCNotOrderable = () => Boolean(_discontinuedAndOOSInStore() && dcQuantity && !orderableFromDC);
  const _isOOSInDC = () => Boolean(_discontinuedAndOOSInStore() && !dcQuantity);
  const _isOutOfStock = () => Boolean(_isStockinDCNotOrderable() || _isOOSInDC());
  return {
    _isOutOfStock
  };
};
const getEstimatedDeliveryDateLabelAvailability = (badges, productSourceType, isBulk, fulfillment, isShowedEstimatedDeliveryDateBetween, estimatedDeliveryDate) => {
  var _a, _b, _c, _d, _e;
  const isOnlineOnly = badges == null ? void 0 : badges.includes(badgesTypes.onlineOnly);
  const isStoreAvailabelQuantity = !!((_a = fulfillment == null ? void 0 : fulfillment.stockItemAvailability) == null ? void 0 : _a.storeQuantity);
  const isSourceAvailabelQuantity = ((_c = (_b = fulfillment == null ? void 0 : fulfillment.sourceTypes) == null ? void 0 : _b[0]) == null ? void 0 : _c.productSourceType) === productSourceType && !!((_e = (_d = fulfillment == null ? void 0 : fulfillment.sourceTypes) == null ? void 0 : _d[0]) == null ? void 0 : _e.quantity);
  const isAvailabelQuantity = isStoreAvailabelQuantity ? isStoreAvailabelQuantity : isSourceAvailabelQuantity;
  const isEstimatedDeliveryDateAvailableBetween = isShowedEstimatedDeliveryDateBetween && estimatedDeliveryDate;
  return isEstimatedDeliveryDateAvailableBetween && !isBulk && isAvailabelQuantity && !isOnlineOnly;
};
const addOrRemoveWishlist = (props, isInWishList, productData) => {
  isInWishList ? props.removeitemFromWishlist(productData) : props.addItemToWishlist(productData);
};
const renderWishListIconComponent = (isInWishList) => {
  return /* @__PURE__ */ jsx(Icon, { type: isInWishList ? "ct-favorite-active" : "ct-favorite-inactive", size: "lg" });
};
const checkIsInWishList = (wishlistProducts, code) => {
  return !!(wishlistProducts == null ? void 0 : wishlistProducts.some((item) => item.code === code));
};
const validation = (wishList, confirmationPage) => {
  return wishList || confirmationPage ? true : false;
};
const setQuantityExceedErrForExpressDeliveryProduct = (isQuantityExceedThanStoreQty, qtyExceededFlag, setQtyExceededErr, selectedDeliveryMode, isSelectedDeliveryAvailable, isAllExpressProducts, updateQtyExceed, setInlineToastError) => {
  if (isQuantityExceedThanStoreQty) {
    !qtyExceededFlag && setQtyExceededErr(isQuantityExceedThanStoreQty);
    if (isSelectedDeliveryAvailable) {
      setInlineToastError(true);
      isAllExpressProducts && updateQtyExceed && updateQtyExceed(true);
    }
  } else if (isAtleastOneParamValid(selectedDeliveryMode == null ? void 0 : selectedDeliveryMode.isSTH, !isQuantityExceedThanStoreQty)) {
    setQtyExceededErr(isQuantityExceedThanStoreQty);
    setInlineToastError(false);
    isAllExpressProducts && updateQtyExceed && updateQtyExceed(false);
  }
};
const buildEstematedDeliveryDateSplitQty = (quantity, estimatedDeliveryDateBetween) => {
  return `${estimatedDeliveryDateBetween.slice(
    magicNumber.ZERO,
    magicNumber.THREE
  )}${quantity} ${estimatedDeliveryDateBetween.slice(magicNumber.THREE)}`;
};
const checkDeliveryMethodType = (isShipToHome, isExpressDeliverySelected, deliveryMode) => {
  const expressOrSthDelivery = isExpressDeliverySelected || deliveryMode === CartOrderDeliveryModes.EXPRESS ? CartOrderDeliveryModes.EXPRESS : FulfillmentMethods.STH;
  return !isShipToHome ? expressOrSthDelivery : FulfillmentMethods.BOPIS;
};
const storeMaxQuantityInfo = (maxQuanity, storeQuantity) => {
  return maxQuanity || storeQuantity;
};
const renderHeliumInflationUnInflationText = (isHeliumInflatedUnInflatedShown, heliumInflationUnInflationText) => {
  return isHeliumInflatedUnInflatedShown ? /* @__PURE__ */ jsx("p", { children: heliumInflationUnInflationText }) : null;
};
const renderHeliumAppointmentInfoMessage = (infoClassName, isHeliumInflationOptionSelected, heliumAppointmentInfoMessage, isHeliumInflatedUnInflatedShown) => {
  return isHeliumInflationOptionSelected && isHeliumInflatedUnInflatedShown ? /* @__PURE__ */ jsxs("p", { className: `${infoClassName}__service-disclaimer`, children: [
    /* @__PURE__ */ jsx(Icon, { type: "ct-information-grey", size: "sm" }),
    /* @__PURE__ */ jsx("span", { "data-testid": "heliumAppointmentInfoMessage", children: heliumAppointmentInfoMessage })
  ] }) : null;
};
const isProductFromPackage = (packages = [], product) => {
  return packages.some((cartPackage) => cartPackage.items.includes(product));
};
const isPackageMainProduct = (packages = [], product) => {
  return packages.some((cartPackage) => cartPackage.items[0] === product);
};
const showInflationLabelsOnOrderConfirmationPage = (supportedStoreServices, showInflationLabels) => {
  const isHeliumAddonSupported = supportedStoreServices == null ? void 0 : supportedStoreServices.some((service) => service.value === inflationData.heliumAddOn);
  return areAllParamsValid(isHeliumAddonSupported, showInflationLabels);
};
const showProductYouMayAlsoLikeBtn = (productEntryType, isProductService, isService, enableCartAccessoriesFlyout) => {
  return productEntryType === eEntryType.PRODUCT && !isProductService && !isService && enableCartAccessoriesFlyout;
};
const getSpecifications = (specifications) => {
  let listSpecifications = "";
  if (specifications == null ? void 0 : specifications.length) {
    specifications.forEach((specification) => {
      listSpecifications += `<span><b>${specification == null ? void 0 : specification.label}</b>: ${specification == null ? void 0 : specification.value}</span>`;
    });
  }
  return listSpecifications;
};
const checkMinPriceAndValue = (priceValue, quantity) => {
  const initialPriceVal = {
    value: 0,
    minPrice: 0,
    maxPrice: 0
  };
  const { value, minPrice, maxPrice } = !!priceValue ? priceValue : initialPriceVal;
  if (value) {
    return value * (quantity ? quantity : setOfTwoCount);
  } else if (minPrice) {
    return minPrice * (quantity ? quantity : setOfTwoCount);
  } else if (maxPrice) {
    return maxPrice * (quantity ? quantity : setOfTwoCount);
  } else {
    return null;
  }
};
const getSetOfFourPriceForStaggered = (skus, isStaggeredState, frontQuantity, rearQuantity) => {
  if (isStaggeredState) {
    const isFullStaggered = skus.length === 2;
    const frontTirePrice = isArrayNotEmpty(skus) && checkMinPriceAndValue(skus[0].currentPrice, frontQuantity);
    const rearTirePrice = isArrayNotEmpty(skus) && isFullStaggered && checkMinPriceAndValue(skus[1].currentPrice, rearQuantity);
    return isFullStaggered ? frontTirePrice + rearTirePrice : frontTirePrice;
  } else {
    return 0;
  }
};
const getSetOfFourPriceForNonStaggered = (skus, isStaggeredState) => {
  if (!isStaggeredState) {
    return isArrayNotEmpty(skus) && checkMinPriceAndValue(skus[0].currentPrice) * setOfTwoCount;
  } else {
    return 0;
  }
};
const totalCurrentPrice = (skus, currentPrice, isStaggeredState, vehicleInformationPresent, tireInformationPresent) => {
  const productPrice = {
    // eslint-disable-next-line no-unsafe-optional-chaining
    minPrice: (currentPrice == null ? void 0 : currentPrice.minPrice) * setOfFourCount,
    // eslint-disable-next-line no-unsafe-optional-chaining
    maxPrice: (currentPrice == null ? void 0 : currentPrice.maxPrice) * setOfFourCount,
    // eslint-disable-next-line no-unsafe-optional-chaining
    value: (currentPrice == null ? void 0 : currentPrice.value) * setOfFourCount
  };
  const staggeredPrice = {
    minPrice: getSetOfFourPriceForStaggered(skus, isStaggeredState),
    maxPrice: getSetOfFourPriceForStaggered(skus, isStaggeredState),
    value: getSetOfFourPriceForStaggered(skus, isStaggeredState)
  };
  const skuPrices = {
    minPrice: getSetOfFourPriceForNonStaggered(skus, isStaggeredState),
    maxPrice: getSetOfFourPriceForNonStaggered(skus, isStaggeredState),
    value: getSetOfFourPriceForNonStaggered(skus, isStaggeredState)
  };
  const productOrSkuPrice = checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? skuPrices : productPrice;
  return isStaggeredState ? staggeredPrice : productOrSkuPrice;
};
const vehicleContextTotalPrice = (skus) => {
  return isArrayNotEmpty(skus) && skus[0].totalCurrentPrice;
};
const setOf4Price = (skus, totalSetOf4Price, isStaggeredState, vehicleInformationPresent, tireInformationPresent) => {
  const notStaggeredPrice = checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? vehicleContextTotalPrice(skus) : totalSetOf4Price;
  return isStaggeredState ? {
    minPrice: getSetOfFourPriceForStaggered(skus, isStaggeredState),
    maxPrice: getSetOfFourPriceForStaggered(skus, isStaggeredState),
    value: getSetOfFourPriceForStaggered(skus, isStaggeredState)
  } : notStaggeredPrice;
};
const vehicleRearLabelValue = (staggeredState, perTireLabel, vehicleRearLabel) => {
  return staggeredState ? vehicleRearLabel : perTireLabel;
};
const rearTireSpecification = (skus, specification, staggeredState, productCardSpecifications) => {
  var _a;
  const specifications = filterSpecification(
    staggeredState ? (_a = skus == null ? void 0 : skus[minimumVariantsLength]) == null ? void 0 : _a.specifications : specification,
    productCardSpecifications
  );
  return getSpecifications(specifications);
};
const rearTireCode = (skus, code, staggeredState, vehicleInformationPresent, tireInformationPresent) => {
  const productCode = checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? skus[0].formattedCode : code;
  return staggeredState ? isArrayNotEmpty(skus) && (skus == null ? void 0 : skus[minimumVariantsLength].formattedCode) : productCode;
};
const rearTireCurrentPrice = (skus, currentPrice, staggeredState, vehicleInformationPresent, tireInformationPresent) => {
  return staggeredState ? isArrayNotEmpty(skus) && (skus == null ? void 0 : skus[minimumVariantsLength].currentPrice) : (
    // eslint-disable-next-line sonar/no-nested-conditional
    checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? skus[0].currentPrice : (
      // eslint-disable-next-line sonar/no-nested-conditional
      checkDataLength(currentPrice) ? currentPrice : {
        value: null,
        minPrice: null,
        maxPrice: null
      }
    )
  );
};
const frontTireSpecification = (skus, staggeredState, productCardSpecifications, productSpecifications) => {
  var _a;
  let specificationValueFront = [];
  specificationValueFront = (_a = skus == null ? void 0 : skus[magicNumber.ZERO]) == null ? void 0 : _a.specifications;
  const skuSpecificationForFront = specificationValueFront == null ? void 0 : specificationValueFront.slice();
  if (isArrayNotEmpty(productSpecifications)) {
    skuSpecificationForFront.push(
      ...productSpecifications.filter(
        (fromSpec) => !skuSpecificationForFront.find(
          (finaSpec) => finaSpec.code === fromSpec.code
        )
      )
    );
  }
  const specifications = filterSpecification(skuSpecificationForFront, productCardSpecifications);
  return staggeredState && getSpecifications(specifications);
};
const rearTireDisplayWasLabel = (skus, displayWasLabel, staggeredState, vehicleInformationPresent, tireInformationPresent) => {
  const notStaggeredWasLabel = checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? skus[0].displayWasLabel : displayWasLabel;
  return staggeredState ? isArrayNotEmpty(skus) && (skus == null ? void 0 : skus[minimumVariantsLength].displayWasLabel) : notStaggeredWasLabel;
};
const rearTireOriginalPrice = (skus, originalPrice, staggeredState, vehicleInformationPresent, tireInformationPresent) => {
  return staggeredState ? isArrayNotEmpty(skus) && (skus == null ? void 0 : skus[minimumVariantsLength].originalPrice) : (
    // eslint-disable-next-line sonar/no-nested-conditional
    checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? skus[0].originalPrice : (
      // eslint-disable-next-line sonar/no-nested-conditional
      checkDataLength(originalPrice) ? originalPrice : {
        value: null,
        minPrice: null,
        maxPrice: null
      }
    )
  );
};
const getSKUFeeValue = (skus, position) => {
  var _a, _b;
  return isArrayNotEmpty(skus) && ((_a = skus[position]) == null ? void 0 : _a.feeValue) ? ((_b = skus[position]) == null ? void 0 : _b.feeValue) * setOfTwoCount : 0;
};
const staggeredFeeValue = (skus, isStaggeredState) => {
  if (isStaggeredState && isArrayNotEmpty(skus)) {
    const frontFeeValue = getSKUFeeValue(skus, 0);
    const rearFeeValue = getSKUFeeValue(skus, magicNumber.ONE);
    return frontFeeValue + rearFeeValue;
  } else {
    return 0;
  }
};
const checkVehicleOrTirePresent = (vehicleInformationPresent, tireInformationPresent) => {
  return vehicleInformationPresent || tireInformationPresent;
};
const getFeeValue = (skus, value, staggeredState, vehicleInformationPresent, tireInformationPresent) => {
  const notStaggeredFeeValue = checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) ? getSKUFeeValue(skus, 0) * setOfTwoCount : value * setOfFourCount;
  return staggeredState ? staggeredFeeValue(skus, staggeredState) : notStaggeredFeeValue;
};
const rearPriceMessage = (skus, priceMessage, staggeredState, vehicleInformationPresent, tireInformationPresent) => {
  const notStaggeredPriceMessage = checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? skus[0].priceMessage : priceMessage;
  return staggeredState ? isArrayNotEmpty(skus) && (skus == null ? void 0 : skus[minimumVariantsLength].priceMessage) : notStaggeredPriceMessage;
};
const getFitmentNote = (skus, isTireProduct) => {
  var _a, _b;
  if (isTireProduct) {
    const tirefitmentNote = (_a = skus == null ? void 0 : skus.fitment) == null ? void 0 : _a.tireWheelFitment;
    return Array.isArray(tirefitmentNote) ? (_b = tirefitmentNote == null ? void 0 : tirefitmentNote[0]) == null ? void 0 : _b.note : tirefitmentNote == null ? void 0 : tirefitmentNote.note;
  } else {
    return "";
  }
};
const rearBadgeList = (skus, badges, staggeredState, vehicleInformationPresent, tireInformationPresent, exclude, isTireProduct) => {
  const notStaggeredBadgeList = checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? combineBadges(skus[0].badges, badges, exclude, getFitmentNote(skus[0], isTireProduct)) : badges;
  return staggeredState ? isArrayNotEmpty(skus) && combineBadges(
    skus[minimumVariantsLength].badges,
    badges,
    exclude,
    getFitmentNote(skus[minimumVariantsLength], isTireProduct)
  ) : notStaggeredBadgeList;
};
const getRebateDetails = (skus, rebate, staggeredState, vehicleInformationPresent, tireInformationPresent) => {
  var _a;
  const notStaggeredRebate = checkVehicleOrTirePresent(vehicleInformationPresent, tireInformationPresent) && isArrayNotEmpty(skus) ? (_a = skus[0]) == null ? void 0 : _a.rebate : rebate;
  return !staggeredState ? notStaggeredRebate : rebate;
};
const ProductFitmentMessage = ({
  customClass,
  fitmentIcon,
  fitmentMessage,
  accessibilityId,
  isStaggered = false
}) => {
  const vehicleFitmentContainerClass = `${productCardVehicleClassPrefix}--fitment-container`;
  const staggeredFitmentClass = `${vehicleFitmentContainerClass}__staggered`;
  return /* @__PURE__ */ jsxs("div", { className: classnames(vehicleFitmentContainerClass, { [staggeredFitmentClass]: isStaggered }, customClass), children: [
    /* @__PURE__ */ jsx(Icon, { type: fitmentIcon, size: "sm" }),
    /* @__PURE__ */ jsx(
      "div",
      {
        id: `fitment__${accessibilityId}`,
        className: `${vehicleFitmentContainerClass}__fitment-message`,
        dangerouslySetInnerHTML: { __html: sanitizeStringContent(fitmentMessage) }
      }
    )
  ] });
};
ProductFitmentMessage.displayName = "ProductFitmentMessage";
const VehicleProductInformationBadgesTestId = "plp-badges-id";
const VehicleProductInformation = (props) => {
  var _a, _b;
  const staggeredState = ((_a = props.skus) == null ? void 0 : _a.length) === staggeredSkuLength && props.vehicleInformationPresent;
  const { message, greyCopyMsg, pdfLink } = props.rebate || {};
  const productBadges = (badgesList, loyaltyBadges) => {
    return isArrayNotEmpty(badgesList) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-plp-badges`, "data-testId": VehicleProductInformationBadgesTestId, children: /* @__PURE__ */ jsx(
      Badges,
      {
        badges: badgesList,
        badgesAndPriorities: props.badgePriorities,
        hideDisclaimer: props.hideDisclaimer,
        loyaltyValue: loyaltyBadges ? loyaltyBadges : props.loyaltyValue
      }
    ) });
  };
  const renderProductFitmentMessage = () => {
    return !props.isTireDataExist && props.fitmentMessageToggle ? /* @__PURE__ */ jsx(
      ProductFitmentMessage,
      {
        accessibilityId: props.accessibilityId,
        fitmentIcon: props.fitmentIcon,
        fitmentMessage: props.fitmentMessage,
        isStaggered: staggeredState
      }
    ) : null;
  };
  const renderFrontTireCode = () => {
    return /* @__PURE__ */ jsx(
      "div",
      {
        "aria-hidden": true,
        className: `${productCardVehicleClassPrefix}--per-tire__code ${!props.badges && !props.frontTireSpecification ? `${productCardVehicleClassPrefix}--per-tire__code--top-margin` : ""} ${props.isNonStaggeredGrid ? `${productCardVehicleClassPrefix}--per-tire__grid-code` : ""}
            `,
        children: props.frontTireCode && `#${props.frontTireCode}`
      }
    );
  };
  const loyaltyBadgeFront = useCalculatedLoyaltyValue((_b = props == null ? void 0 : props.skus[0]) == null ? void 0 : _b.loyalty, staggeredState, {
    frontQuantitySelected: 1,
    rearQuantitySelected: 1,
    qtySelectorInput: 1
  });
  const frontTire = () => {
    var _a2, _b2, _c, _d, _e;
    return /* @__PURE__ */ jsxs("div", { className: `${productCardVehicleClassPrefix}--per-tire`, children: [
      /* @__PURE__ */ jsxs("div", { className: `${productCardVehicleClassPrefix}--per-tire__text`, children: [
        props.vehicleFrontLabel,
        " "
      ] }),
      /* @__PURE__ */ jsxs("div", { className: `${productCardVehicleClassPrefix}--per-tire__price-code`, children: [
        /* @__PURE__ */ jsx(
          Price,
          {
            isRangeView: props.isPriceRangeViewEnabled,
            currentPrice: props.skus[0].currentPrice,
            originalPrice: props.skus[0].originalPrice,
            language: props.language,
            isAutomotiveEachLabel: true,
            eachLabel: props.eachLabel,
            nowFromLabel: props.nowFromLabel,
            saveFromLabel: props.saveFromLabel,
            wasFromLabel: props.wasFromLabel,
            fromLabel: props.fromLabel,
            priceMessage: props.skus[0].priceMessage,
            displayWasLabel: props.skus[0].displayWasLabel,
            promotionalPriceLabel: props.promotionalPriceLabel,
            unitPriceLabel: props.unitPriceLabel,
            clearancePriceLabel: props.clearancePriceLabel,
            a11yStrikeOutPrice: props.a11yStrikeOutPrice,
            a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
            ariaHidden: props.ariaHidden,
            a11yTooltipIcon: props.a11yTooltipIcon,
            a11yCloseIconLabel: props.a11yCloseIconLabel,
            plusMinusSymbol: props.plusMinusSymbol,
            isOnSaleOrClearance: (_a2 = props.skus[0]) == null ? void 0 : _a2.isOnSale
          }
        ),
        productBadges(
          combineBadges(
            ((_c = (_b2 = props.skus) == null ? void 0 : _b2[0]) == null ? void 0 : _c.badges) || [],
            props.productLevelBadges,
            props.excludeBadges,
            getFitmentNote(props.skus[0], props.isTireProduct)
          ),
          props.skus[0].loyalty && loyaltyBadgeFront
        ),
        (props.vehicleFitType === BannerType$1.Fit || props.vehicleInformationPresent || props.tireInformationPresent) && /* @__PURE__ */ jsx(
          "div",
          {
            "aria-hidden": true,
            className: `${productCardVehicleClassPrefix}--per-tire__specification ${!isArrayNotEmpty((_e = (_d = props.skus) == null ? void 0 : _d[0]) == null ? void 0 : _e.badges) && props.frontTireSpecification ? `${productCardVehicleClassPrefix}--per-tire__specification--extra-space` : `${productCardVehicleClassPrefix}--per-tire__specification--space`}`,
            dangerouslySetInnerHTML: { __html: props.frontTireSpecification }
          }
        ),
        renderFrontTireCode(),
        props.frontAvailability
      ] })
    ] });
  };
  const renderRearTireCode = () => {
    return /* @__PURE__ */ jsx(
      "div",
      {
        "aria-hidden": true,
        className: `${productCardVehicleClassPrefix}--per-tire__code ${!isArrayNotEmpty(props.badges) && !props.rearTireSpecification ? `${productCardVehicleClassPrefix}--per-tire__code--top-margin` : ""} ${props.isNonStaggeredGrid ? `${productCardVehicleClassPrefix}--per-tire__grid-code` : ""}
            `,
        children: props.rearTireCode && `#${props.rearTireCode}`
      }
    );
  };
  const getStaggeredModifirClass = () => {
    return props.isNonStaggeredGrid ? `${productCardVehicleClassPrefix}--text-visibility` : "";
  };
  const renderFitmentMessageForNonStaggered = () => {
    return !staggeredState ? renderProductFitmentMessage() : null;
  };
  const onSaleValue = useMemo(() => {
    if (props.skus.length === 1) {
      return props.skus[0].isOnSale;
    } else if (props.skus.length === 2) {
      return props.skus[1].isOnSale;
    } else {
      return props.isOnSale;
    }
  }, [props.isOnSale, props.skus]);
  const perTire = () => {
    const showPerTireSpecification = (props.vehicleFitType === BannerType$1.Fit || props.vehicleInformationPresent || props.tireInformationPresent) && props.rearTireSpecification;
    return /* @__PURE__ */ jsxs("div", { className: `${productCardVehicleClassPrefix}--per-tire ${getStaggeredModifirClass()}`, children: [
      !props.isSRPPage && /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${productCardVehicleClassPrefix}--per-tire__text ${props.isNonStaggeredGrid ? `${productCardVehicleClassPrefix}--per-tire__grid-text` : ""}`,
          children: [
            props.vehicleRearLabel,
            " "
          ]
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: `${productCardVehicleClassPrefix}--per-tire__price-code`, children: [
        /* @__PURE__ */ jsx(
          Price,
          {
            isRangeView: props.isPriceRangeViewEnabled,
            currentPrice: props.rearTireCurrentPrice,
            language: props.language,
            isAutomotiveEachLabel: true,
            eachLabel: props.eachLabel,
            nowFromLabel: props.nowFromLabel,
            saveFromLabel: props.saveFromLabel,
            wasFromLabel: props.wasFromLabel,
            fromLabel: props.fromLabel,
            originalPrice: props.rearTireOriginalPrice,
            discountValue: props.discount,
            promotionalPriceLabel: props.promotionalPriceLabel,
            unitPriceLabel: props.unitPriceLabel,
            displayWasLabel: props.rearTireDisplayWasLabel,
            clearancePriceLabel: props.clearancePriceLabel,
            priceMessage: props.priceMessage,
            a11yStrikeOutPrice: props.a11yStrikeOutPrice,
            a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
            ariaHidden: props.ariaHidden,
            a11yCloseIconLabel: props.a11yCloseIconLabel,
            a11yTooltipIcon: props.a11yTooltipIcon,
            isOnSaleOrClearance: onSaleValue
          }
        ),
        productBadges(props.badges),
        renderFitmentMessageForNonStaggered(),
        showPerTireSpecification && /* @__PURE__ */ jsx(
          "div",
          {
            "aria-hidden": true,
            className: `${productCardVehicleClassPrefix}--per-tire__specification ${!isArrayNotEmpty(props.badges) && props.rearTireSpecification ? `${productCardVehicleClassPrefix}--per-tire__specification--extra-space` : `${productCardVehicleClassPrefix}--per-tire__specification--space`}`,
            dangerouslySetInnerHTML: { __html: props.rearTireSpecification }
          }
        ),
        renderRearTireCode(),
        staggeredState ? props.rearAvailability : props.perAvailability
      ] })
    ] });
  };
  const setOfFourTire = () => {
    var _a2, _b2, _c, _d;
    const displayWasLabel = staggeredState && ((_b2 = (_a2 = props.skus) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.displayWasLabel) ? (_d = (_c = props.skus) == null ? void 0 : _c[0]) == null ? void 0 : _d.displayWasLabel : props.rearTireDisplayWasLabel;
    return /* @__PURE__ */ jsxs("div", { className: `${productCardVehicleClassPrefix}--set-of-four`, children: [
      /* @__PURE__ */ jsx("div", { className: `${productCardVehicleClassPrefix}--set-of-four__text`, children: props.setOfFourLabel }),
      /* @__PURE__ */ jsxs("div", { className: `${productCardVehicleClassPrefix}--set-of-four__product-information`, children: [
        /* @__PURE__ */ jsx(
          Price,
          {
            isRangeView: props.isPriceRangeViewEnabled,
            currentPrice: props.totalCurrentPrice,
            language: props.language,
            feeTitle: props.feeTitle,
            nowFromLabel: props.nowFromLabel,
            saveFromLabel: props.saveFromLabel,
            wasFromLabel: props.wasFromLabel,
            fromLabel: props.fromLabel,
            feeDisclaimerType: props.feeDisclaimerType,
            feeDisclaimerMessage: props.feeDisclaimerMessage,
            feeDisclaimerTitle: props.feeDisclaimerTitle,
            displayWasLabel,
            promotionalPriceLabel: props.promotionalPriceLabel,
            unitPriceLabel: props.unitPriceLabel,
            clearancePriceLabel: props.clearancePriceLabel,
            scrollToFooter: props.scrollToFooter,
            a11yStrikeOutPrice: props.a11yStrikeOutPrice,
            a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
            a11yClickToReadFootnote: props.a11yClickToReadFootnote,
            ariaHidden: props.ariaHidden,
            a11yTooltipIcon: props.a11yTooltipIcon,
            a11yCloseIconLabel: props.a11yCloseIconLabel
          }
        ),
        props.rebate && Object.keys(props.rebate).length && /* @__PURE__ */ jsx(
          Rebate,
          {
            title: message,
            rebateIcon: props.rebateIcon,
            greyCopyMsg,
            pdfLink,
            ariaHidden: true
          }
        )
      ] })
    ] });
  };
  return /* @__PURE__ */ jsxs("div", { className: `${productCardVehicleClassPrefix}`, id: getAccessibilityPriceId(props.accessibilityId), children: [
    !props.isSRPPage && staggeredState && renderProductFitmentMessage(),
    !props.isSRPPage && staggeredState && frontTire(),
    perTire(),
    !props.isSRPPage && setOfFourTire()
  ] });
};
VehicleProductInformation.propTypes = {
  skus: PropTypes.array,
  vehicleRearLabel: PropTypes.string,
  rearTireCode: PropTypes.string,
  rearTireCurrentPrice: PropTypes.any,
  frontTireSpecification: PropTypes.string,
  totalCurrentPrice: PropTypes.any,
  frontTireCode: PropTypes.string,
  setOfFourLabel: PropTypes.string,
  vehicleFrontLabel: PropTypes.string,
  language: PropTypes.string,
  feeTitle: PropTypes.string,
  vehicleFitType: PropTypes.any,
  rebate: PropTypes.any,
  rebateIcon: PropTypes.string,
  eachLabel: PropTypes.string,
  isNonStaggeredGrid: PropTypes.bool,
  rearTireSpecification: PropTypes.string,
  badgePriorities: PropTypes.any,
  badges: PropTypes.array,
  productLevelBadges: PropTypes.array,
  hideDisclaimer: PropTypes.bool,
  nowFromLabel: PropTypes.string,
  saveFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  promotionalPriceLabel: PropTypes.string,
  unitPriceLabel: PropTypes.string,
  displayWasLabel: PropTypes.bool,
  clearancePriceLabel: PropTypes.string,
  originalPrice: PropTypes.any,
  discount: PropTypes.any,
  feeDisclaimerType: PropTypes.string,
  feeDisclaimerMessage: PropTypes.string,
  isSRPPage: PropTypes.bool,
  priceMessage: PropTypes.array,
  vehicleInformationPresent: PropTypes.bool,
  feeDisclaimerTitle: PropTypes.string,
  rearTireOriginalPrice: PropTypes.shape({
    value: PropTypes.number.isRequired,
    maxPrice: PropTypes.number.isRequired,
    minPrice: PropTypes.number.isRequired
  }),
  rearTireDisplayWasLabel: PropTypes.bool,
  tireInformationPresent: PropTypes.bool,
  scrollToFooter: PropTypes.func,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  excludeBadges: PropTypes.array,
  frontAvailability: PropTypes.any,
  rearAvailability: PropTypes.any,
  perAvailability: PropTypes.any,
  a11yClickToReadFootnote: PropTypes.string,
  accessibilityId: PropTypes.string,
  ariaHidden: PropTypes.bool,
  a11yTooltipIcon: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string
};
VehicleProductInformation.displayName = "VehicleProductInformation";
var DisplayViewType = /* @__PURE__ */ ((DisplayViewType2) => {
  DisplayViewType2["grid"] = "Grid";
  DisplayViewType2["list"] = "List";
  return DisplayViewType2;
})(DisplayViewType || {});
var fitmentTypeCodeValue = /* @__PURE__ */ ((fitmentTypeCodeValue2) => {
  fitmentTypeCodeValue2["universalFit"] = "01_UNIVERSAL_FIT";
  fitmentTypeCodeValue2["directFit"] = "02_DIRECT_FIT";
  fitmentTypeCodeValue2["vehCondFit"] = "03_VEH_COND_FIT";
  fitmentTypeCodeValue2["prodVehCondFit"] = "04_PROD_VEH_COND_FIT";
  fitmentTypeCodeValue2["partCondFit"] = "05_PART_COND_FIT";
  return fitmentTypeCodeValue2;
})(fitmentTypeCodeValue || {});
var autoPartSkuFitmentTypes = /* @__PURE__ */ ((autoPartSkuFitmentTypes2) => {
  autoPartSkuFitmentTypes2["FIT"] = "directFit";
  autoPartSkuFitmentTypes2["PARTIAL"] = "partialFit";
  autoPartSkuFitmentTypes2["UNIVERSAL"] = "universal";
  return autoPartSkuFitmentTypes2;
})(autoPartSkuFitmentTypes || {});
const AutoPartsProductInformation = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const feeMessage = (_a = props.feeMessages) == null ? void 0 : _a[0];
  const productBadges = () => {
    var _a2;
    return isArrayNotEmpty(props.badges) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-plp-badges`, children: /* @__PURE__ */ jsx(
      Badges,
      {
        badges: props.vehicleInformationPresent ? (_a2 = props.selectedSKUData) == null ? void 0 : _a2.badges : props.badges,
        badgesAndPriorities: props.badgePriorities,
        hideDisclaimer: props.hideDisclaimer,
        loyaltyValue: props.loyaltyValue
      }
    ) });
  };
  const getFeeMessage = () => {
    return props.vehicleInformationPresent ? feeMessage == null ? void 0 : feeMessage.feeTitle : props.feeTitle;
  };
  const getFeeTitle2 = () => {
    var _a2;
    const feeValue = props.vehicleInformationPresent ? (_a2 = props.selectedSKUData) == null ? void 0 : _a2.feeValue : props.feeValue;
    return feeValue ? replaceStrWithDynamicVal(
      addDynamicToken(getFeeMessage(), "$x"),
      getFormattedPriceValue(props.language, feeValue)
    ) : "";
  };
  const checkIfSelectedSKUDataAvailable = () => {
    return !!(props.vehicleInformationPresent && props.selectedSKUData);
  };
  const onSaleValue = useMemo(
    () => {
      var _a2;
      return ((_a2 = props.skus) == null ? void 0 : _a2.length) === 1 ? props.skus[0].isOnSale : props.isOnSale;
    },
    [props.isOnSale, props.skus]
  );
  const legacyFitmentMessage = useMemo(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2;
    if (props.fitmentMessageToggle && props.fitmentTypeCode === FitmentTypeEnum.DIRECT_FIT_02 && ((_c2 = (_b2 = (_a2 = props.skus) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.fitment) == null ? void 0 : _c2.autoPartsFit) !== autoPartSkuFitmentTypes.UNIVERSAL) {
      const fitmentMessageClass = `${productCardVehicleClassPrefix}--fitment-container`;
      const isFit = ((_f2 = (_e2 = (_d2 = props.skus) == null ? void 0 : _d2[0]) == null ? void 0 : _e2.fitment) == null ? void 0 : _f2.autoPartsFit) === autoPartSkuFitmentTypes.FIT;
      const dynamicMessageElement = replaceStrWithDynamicElement(
        isFit ? props.fitMessageOnCard : props.partialFitMessageOnCard,
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-vehicle-information`, children: props.vehicleString })
      );
      return /* @__PURE__ */ jsxs("div", { className: fitmentMessageClass, children: [
        /* @__PURE__ */ jsx(
          Icon,
          {
            type: isFit ? "ct-notification-success-green" : "ct-notification-caution-orange",
            size: "sm",
            decorative: false
          }
        ),
        /* @__PURE__ */ jsx("div", { id: `fitment__${props.accessibilityId}`, className: `${fitmentMessageClass}__fitment-message`, children: isFit ? dynamicMessageElement : /* @__PURE__ */ jsx("span", { className: `${PREFIX}-not-fit-message`, children: dynamicMessageElement }) })
      ] });
    } else {
      return /* @__PURE__ */ jsx(Fragment, {});
    }
  }, [
    productCardVehicleClassPrefix,
    props.fitMessageOnCard,
    props.fitmentMessageToggle,
    props.partialFitMessageOnCard,
    props.skus,
    props.vehicleString,
    props.fitmentTypeCode,
    props.accessibilityId
  ]);
  const fitmentMessage = useMemo(() => {
    if (props.fitmentMessageToggle || props.fitmentMessageToggleUniversal) {
      const fitmentMessageClass = `${productCardVehicleClassPrefix}--fitment-container`;
      const {
        confirmFitMessageUniversalOnCard,
        fitMessageUniversalOnCard,
        partialFitMessageOnCard,
        fitMessageOnCard
      } = props;
      const getFitmentMessagePlaceHolder = (key) => ({
        confirmFitMessageUniversalOnCard: props.fitmentMessageToggleUniversal && confirmFitMessageUniversalOnCard,
        fitMessageUniversalOnCard: props.fitmentMessageToggleUniversal && fitMessageUniversalOnCard,
        partialFitMessageOnCard: props.fitmentMessageToggle && partialFitMessageOnCard,
        fitMessageOnCard: props.fitmentMessageToggle && fitMessageOnCard
      })[key] || "";
      const messagePlaceholder = getFitmentMessagePlaceHolder(props.product.fitmentCompatibilityKey || "");
      const dynamicMessageElement = messagePlaceholder && replaceStrWithDynamicElement(
        messagePlaceholder,
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-vehicle-information`, children: props.vehicleString })
      );
      const iconTypes2 = {
        fitmentIcon001: "ct-notification-success-green",
        fitmentIcon002: "ct-notification-caution-orange",
        fitmentIcon003: "ct-information-blue"
      };
      const iconType = iconTypes2[props.product.fitmentMarkKey || ""];
      const fitmentClassMap = {
        confirmFitMessageUniversalOnCard: ` ${fitmentMessageClass}__fitment-message--bold`,
        fitMessageUniversalOnCard: ` ${fitmentMessageClass}__fitment-message--bold`,
        partialFitMessageOnCard: ` ${fitmentMessageClass}__fitment-message--bold`,
        fitMessageOnCard: ""
      };
      const extraFitmentClass = fitmentClassMap[props.product.fitmentCompatibilityKey];
      return dynamicMessageElement ? /* @__PURE__ */ jsxs("div", { className: fitmentMessageClass, children: [
        iconType && /* @__PURE__ */ jsx(Icon, { type: iconType, size: "sm", decorative: false }),
        /* @__PURE__ */ jsx(
          "div",
          {
            id: `fitment__${props.accessibilityId}`,
            className: `${fitmentMessageClass}__fitment-message ${extraFitmentClass}`,
            children: dynamicMessageElement
          }
        )
      ] }) : legacyFitmentMessage;
    } else {
      return /* @__PURE__ */ jsx(Fragment, {});
    }
  }, [props, productCardVehicleClassPrefix, legacyFitmentMessage]);
  return /* @__PURE__ */ jsx("div", { className: `${productCardVehicleClassPrefix}`, children: /* @__PURE__ */ jsx("div", { className: `${productCardVehicleClassPrefix}--per-tire`, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${productCardVehicleClassPrefix}--per-tire__price-code`,
      id: getAccessibilityPriceId(props.accessibilityId),
      children: [
        /* @__PURE__ */ jsx(
          Price,
          {
            isRangeView: props.isPriceRangeViewEnabled,
            unitPriceLabel: (_b = props.productProps) == null ? void 0 : _b.unitPriceLabel,
            clearancePriceLabel: (_c = props.productProps) == null ? void 0 : _c.clearancePriceLabel,
            a11yPriceRangeFrom: (_d = props.productProps) == null ? void 0 : _d.a11yPriceRangeFrom,
            a11yPriceRangeTo: (_e = props.productProps) == null ? void 0 : _e.a11yPriceRangeTo,
            a11yStrikeOutPrice: props.a11yStrikeOutPrice,
            a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
            a11yTooltipIcon: props.a11yTooltipIcon,
            a11yCloseIconLabel: props.a11yCloseIconLabel,
            feeTitle: getFeeTitle2(),
            feeDisclaimerTitle: checkIfSelectedSKUDataAvailable() ? feeMessage == null ? void 0 : feeMessage.feeDisclaimerTitle : props.feeDisclaimerTitle,
            feeDisclaimerMessage: checkIfSelectedSKUDataAvailable() ? feeMessage == null ? void 0 : feeMessage.feeDisclaimerMessage : props.feeDisclaimerMessage,
            currentPrice: checkIfSelectedSKUDataAvailable() ? (_f = props.selectedSKUData) == null ? void 0 : _f.currentPrice : props.currentPrice,
            originalPrice: checkIfSelectedSKUDataAvailable() ? (_g = props.selectedSKUData) == null ? void 0 : _g.originalPrice : props.originalPrice,
            displayWasLabel: checkIfSelectedSKUDataAvailable() ? (_h = props.selectedSKUData) == null ? void 0 : _h.displayWasLabel : props.displayWasLabel,
            language: props.language,
            priceMessage: checkIfSelectedSKUDataAvailable() ? (_i = props.selectedSKUData) == null ? void 0 : _i.priceMessage : props.priceMessage,
            nowFromLabel: props.nowFromLabel,
            saveFromLabel: props.saveFromLabel,
            wasFromLabel: props.wasFromLabel,
            fromLabel: props.fromLabel,
            overridePriceHeight: props.overridePriceHeight,
            plusMinusSymbol: props.plusMinusSymbol,
            isOnSaleOrClearance: onSaleValue
          }
        ),
        productBadges(),
        fitmentMessage
      ]
    }
  ) }) });
};
AutoPartsProductInformation.propTypes = {
  productProps: PropTypes.any,
  currentPrice: PropTypes.shape({
    value: PropTypes.number.isRequired,
    maxPrice: PropTypes.number.isRequired,
    minPrice: PropTypes.number.isRequired
  }),
  originalPrice: PropTypes.shape({
    value: PropTypes.number.isRequired,
    maxPrice: PropTypes.number.isRequired,
    minPrice: PropTypes.number.isRequired
  }),
  language: PropTypes.string,
  feeTitle: PropTypes.string,
  badgePriorities: PropTypes.any,
  badges: PropTypes.array,
  hideDisclaimer: PropTypes.bool,
  priceMessage: PropTypes.array,
  feeDisclaimerMessage: PropTypes.string,
  displayWasLabel: PropTypes.bool,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  feeDisclaimerTitle: PropTypes.string,
  a11yTooltipIcon: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string,
  nowFromLabel: PropTypes.string,
  saveFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  feeValue: PropTypes.number,
  vehicleInformationPresent: PropTypes.bool,
  selectedSKUData: PropTypes.any,
  overridePriceHeight: PropTypes.bool,
  feeMessages: PropTypes.array
};
AutoPartsProductInformation.displayName = "AutoPartsProductInformation";
if (typeof window !== "undefined") {
  window.analyticsLayer = window.analyticsLayer || [];
}
const roadRatingSkeletonTestId = "road-rating-badge-skeleton-id";
const roadRatingTestId = "road-rating-badge-id";
const RoadRatingBadgeSkeleton = () => /* @__PURE__ */ jsx("div", { "data-testid": roadRatingSkeletonTestId, className: `${PREFIX}-road-rating-badge-skeleton` });
const RoadRatingBadge = ({ ...props }) => {
  const roadRatingBadgeClick = () => {
    window.analyticsLayer = window.analyticsLayer || [];
    window.analyticsLayer.push({
      event: "interaction",
      eventParameters: {
        action: "click on internal link",
        category: "interaction",
        label: "road rating badge",
        value: "",
        location: "pdp - road rating badge"
        // sample output: 'pdp - header'
      }
    });
    props.scrollToRoadRating();
  };
  return props.aggregateValue ? /* @__PURE__ */ jsx(
    "div",
    {
      "data-testid": roadRatingTestId,
      ref: (node) => {
        var _a;
        (_a = props == null ? void 0 : props.updateRoadRatingRef) == null ? void 0 : _a.call(props, node);
      },
      "aria-hidden": props.ariaHidden ? props.ariaHidden : false,
      role: "link",
      tabIndex: props.ariaHidden ? magicNumber.MINUS_ONE : magicNumber.ZERO,
      className: classnames(`${PREFIX}-road-rating-badge`, `${PREFIX}-road-rating-badge-btn`, {
        [`${PREFIX}-road-rating-badge--avaialble`]: Boolean(props.isReviewAvailable)
      }),
      onClick: roadRatingBadgeClick,
      onKeyPress: roadRatingBadgeClick,
      children: `${props.roadRatedLabel} - ${props.aggregateValue}`
    }
  ) : /* @__PURE__ */ jsx(RoadRatingBadgeSkeleton, {});
};
RoadRatingBadge.propTypes = {
  roadRatedLabel: PropTypes.string,
  aggregateValue: PropTypes.number,
  scrollToRoadRating: PropTypes.func,
  isReviewAvailable: PropTypes.bool
};
RoadRatingBadge.displayName = "RoadRatingBadge";
RoadRatingBadgeSkeleton.displayName = "RoadRatingBadgeSkeleton";
var dist$1 = {};
var useResize = {};
var hasRequiredUseResize;
function requireUseResize() {
  if (hasRequiredUseResize) return useResize;
  hasRequiredUseResize = 1;
  Object.defineProperty(useResize, "__esModule", {
    value: true
  });
  useResize.default = useResize$1;
  var _react = React;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var defaultThrottleRate = 200;
  function debounce(fn, ms) {
    var timer = void 0;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(function() {
        timer = null;
        fn();
      }, ms);
    };
  }
  function useResize$1(handler) {
    var throttleRate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultThrottleRate;
    _react2.default.useEffect(function() {
      var debouncedHandleResize = debounce(handler, throttleRate);
      window.addEventListener("resize", debouncedHandleResize);
      return function() {
        window.removeEventListener("resize", debouncedHandleResize);
      };
    });
  }
  return useResize;
}
var constants$3 = {};
var hasRequiredConstants$3;
function requireConstants$3() {
  if (hasRequiredConstants$3) return constants$3;
  hasRequiredConstants$3 = 1;
  Object.defineProperty(constants$3, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  constants$3.setTag = setTag;
  var block = constants$3.block = { display: "block" };
  constants$3.sizerWrapperStyles = _extends2({}, block, {
    position: "absolute",
    left: "-20000px",
    width: "100%"
  });
  constants$3.spreaderStyles = _extends2({}, block, {
    overflow: "hidden",
    height: "0px",
    width: "100%"
  });
  constants$3.wrapperStyles = _extends2({}, block, {
    position: "relative",
    overflow: "hidden"
  });
  constants$3.childrenStyles = _extends2({}, block, {
    width: "100%"
  });
  var tagWhitelist = ["div", "p", "h1", "h2", "h3", "h4", "h5", "h6", "span", "a"];
  function setTag(tagName) {
    if (!tagName) {
      return "div";
    }
    var foundTag = tagWhitelist.find(function(tag) {
      return tagName === tag;
    });
    return foundTag || "div";
  }
  return constants$3;
}
var hasRequiredDist$1;
function requireDist$1() {
  if (hasRequiredDist$1) return dist$1;
  hasRequiredDist$1 = 1;
  Object.defineProperty(dist$1, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _slicedToArray = /* @__PURE__ */ function() {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
    return function(arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
  var _react = React;
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = /* @__PURE__ */ requirePropTypes();
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _useResize = requireUseResize();
  var _useResize2 = _interopRequireDefault(_useResize);
  var _constants = requireConstants$3();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var Shiitake2 = function Shiitake3(props) {
    var allChildren = typeof props.children === "string" ? props.children : "";
    var sizerEl = _react2.default.useRef();
    var spreaderEl = _react2.default.useRef();
    var testChildrenEl = _react2.default.useRef();
    var handlingResize = _react2.default.useRef(true);
    var searchStart = _react2.default.useRef(0);
    var searchEnd = _react2.default.useRef(allChildren.length);
    var className2 = props.className, throttleRate = props.throttleRate, overflowNode = props.overflowNode, onTruncationChange = props.onTruncationChange;
    var tagNames = { main: (0, _constants.setTag)(props.tagName) };
    var _React$useState = _react2.default.useState(""), _React$useState2 = _slicedToArray(_React$useState, 2), testChildren = _React$useState2[0], setTestChildren = _React$useState2[1];
    var _React$useState3 = _react2.default.useState(allChildren), _React$useState4 = _slicedToArray(_React$useState3, 2), children = _React$useState4[0], setChildren = _React$useState4[1];
    var _React$useState5 = _react2.default.useState(-1), _React$useState6 = _slicedToArray(_React$useState5, 2), lastCalculatedWidth = _React$useState6[0], setLastCalculatedWidth = _React$useState6[1];
    var testChildrenRange = function testChildrenRange2(start, end) {
      searchStart.current = start;
      searchEnd.current = end;
      setTestChildren(allChildren.substring(0, end));
    };
    var calculationComplete = function calculationComplete2() {
      var newChildren = allChildren;
      if (testChildren.length < allChildren.length) {
        newChildren = testChildren.split(" ").slice(0, -1).join(" ");
      }
      handlingResize.current = false;
      setChildren(newChildren);
      if (newChildren.length !== children.length) {
        var wasTruncatedBefore = children.length !== allChildren.length;
        var isTruncatedNow = newChildren.length !== allChildren.length;
        if (wasTruncatedBefore !== isTruncatedNow && typeof onTruncationChange === "function") {
          onTruncationChange(isTruncatedNow);
        }
      }
    };
    var checkHeight = function checkHeight2() {
      var contentHeight = testChildrenEl.current.offsetHeight;
      var halfWay = Math.round((searchEnd.current - searchStart.current) / 2);
      var targetHeight = sizerEl.current ? sizerEl.current.offsetHeight : void 0;
      var linear = searchEnd.current - searchStart.current < 6;
      if (contentHeight > targetHeight) {
        if (linear) {
          testChildrenRange(testChildren.length, testChildren.length - 1);
        } else {
          testChildrenRange(searchStart.current, searchEnd.current - halfWay);
        }
      } else if (testChildren.length === allChildren.length) {
        calculationComplete();
      } else if (linear) {
        if (searchStart.current > searchEnd.current) {
          calculationComplete();
        } else {
          testChildrenRange(testChildren.length, testChildren.length + 1);
        }
      } else {
        testChildrenRange(searchEnd.current, searchEnd.current + halfWay);
      }
    };
    var startCalculation = function startCalculation2() {
      searchStart.current = 0;
      searchEnd.current = allChildren.length;
      setLastCalculatedWidth(spreaderEl.current.offsetWidth);
      handlingResize.current = true;
      setTestChildren(allChildren);
    };
    var recalculate = function recalculate2() {
      setTestChildren("");
    };
    var handleResize = function handleResize2() {
      if (!spreaderEl.current) {
        return;
      }
      if (spreaderEl.current.offsetWidth !== lastCalculatedWidth && !handlingResize.current) {
        recalculate();
      }
    };
    (0, _useResize2.default)(handleResize, throttleRate);
    _react2.default.useEffect(function() {
      if (testChildren === "" && sizerEl.current) {
        startCalculation();
      } else {
        checkHeight();
      }
    }, [testChildren, sizerEl.current]);
    _react2.default.useEffect(function() {
      if (testChildren !== "") {
        recalculate();
      }
    }, [props.lines]);
    _react2.default.useEffect(function() {
      if (testChildren !== "") {
        recalculate();
      }
    }, [allChildren]);
    var vertSpacers = [];
    for (var i = 0; i < props.lines; i++) {
      vertSpacers.push(_react2.default.createElement(
        "span",
        { style: _constants.block, key: i },
        "W"
      ));
    }
    var maxHeight2 = (sizerEl.current ? sizerEl.current.offsetHeight : 0) + "px";
    var overflow = testChildren.length < allChildren.length ? overflowNode : null;
    return _react2.default.createElement(
      tagNames.main,
      _extends2({ className: className2 }, props.attributes),
      _react2.default.createElement(
        "span",
        { style: _extends2({}, _constants.wrapperStyles, { maxHeight: maxHeight2 }) },
        _react2.default.createElement(
          "span",
          { className: "shiitake-children", style: _constants.childrenStyles },
          children,
          overflow
        ),
        _react2.default.createElement(
          "span",
          { ref: spreaderEl, style: _constants.spreaderStyles, "aria-hidden": "true" },
          allChildren
        ),
        _react2.default.createElement(
          "span",
          { style: _constants.sizerWrapperStyles, "aria-hidden": "true" },
          _react2.default.createElement(
            "span",
            { ref: sizerEl, style: _constants.block },
            vertSpacers
          ),
          _react2.default.createElement(
            "span",
            { className: "shiitake-test-children", ref: testChildrenEl, style: _constants.block },
            testChildren,
            overflow
          )
        )
      )
    );
  };
  Shiitake2.propTypes = {
    className: _propTypes2.default.string,
    lines: _propTypes2.default.number.isRequired,
    attributes: _propTypes2.default.object,
    // eslint-disable-line react/forbid-prop-types
    children: _propTypes2.default.string.isRequired,
    throttleRate: _propTypes2.default.number,
    tagName: _propTypes2.default.string,
    overflowNode: _propTypes2.default.node,
    onTruncationChange: _propTypes2.default.func
  };
  Shiitake2.defaultProps = {
    className: "",
    attributes: {},
    throttleRate: void 0,
    tagName: void 0,
    overflowNode: "…",
    children: "",
    onTruncationChange: void 0
  };
  dist$1.default = _react2.default.memo(Shiitake2);
  return dist$1;
}
var distExports$1 = requireDist$1();
const Shiitake = /* @__PURE__ */ getDefaultExportFromCjs$1(distExports$1);
const ClampLinesEllipsis = ({
  text: text2,
  lines,
  className: className2,
  innerElement
}) => {
  const props = {
    lines,
    throttleRate: 200,
    className: className2,
    tagName: `${innerElement}`
  };
  return React.createElement(Shiitake, props, text2);
};
ClampLinesEllipsis.propTypes = {
  text: PropTypes.string.isRequired,
  lines: PropTypes.number.isRequired,
  className: PropTypes.string,
  innerElement: PropTypes.string
};
const returnStockIcon$1 = (iconType) => {
  return /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: `ct-${iconType ? iconType : iconTypes.checkmark}`, size: "sm" }) });
};
const showInStockOnlineLabel = (sellable, orderable, quantity, corpQuantity, isWheelOrTire) => {
  if (sellable && orderable && corpQuantity) {
    if (isWheelOrTire) {
      return quantity < 4;
    } else {
      return quantity === 0;
    }
  } else {
    return false;
  }
};
const showOutOfStockLabel = (quantity, corpQuantity) => {
  return !quantity && !corpQuantity;
};
const showInStockAisleLabel = (sellable, quantity, isWheelOrTire) => {
  return sellable && (isWheelOrTire ? quantity >= 4 : quantity > 0);
};
function LegacyVehicleAvailabilitySection({
  skuData,
  checkAvailabilityLabel,
  inStockAisleLabel,
  inStockOnlineLabel,
  outOfStockLabel,
  isUrgentLowStockLabel,
  isAutoPartPlp,
  accessibilityId,
  isWheelOrTirePDP,
  isUrgentLowStock
}) {
  if (!(skuData == null ? void 0 : skuData.fulfillment)) {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__availability-message` });
  }
  const getAvailabilityLabel = (quantityFlag) => {
    const limitedStockMessage = isUrgentLowStockLabel;
    if (isUrgentLowStock) {
      const urgencyMsg = limitedStockMessage ? replaceStrWithDynamicVal(limitedStockMessage, quantityFlag == null ? void 0 : quantityFlag.toString()) : "";
      return /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__urgentLowStock`, children: urgencyMsg }) });
    } else {
      return replaceStrWithDynamicVal(inStockAisleLabel, (quantityFlag == null ? void 0 : quantityFlag.toString()) ?? "");
    }
  };
  const { sellable, orderable, fulfillment } = skuData;
  const availability = fulfillment == null ? void 0 : fulfillment.availability;
  const quantity = availability == null ? void 0 : availability.quantity;
  const Corporate = availability == null ? void 0 : availability.Corporate;
  const corpQuantity = Corporate == null ? void 0 : Corporate.Quantity;
  const getTitle = () => {
    switch (true) {
      case showOutOfStockLabel(quantity, corpQuantity):
        return outOfStockLabel;
      case showInStockOnlineLabel(sellable, orderable, quantity, corpQuantity, isWheelOrTirePDP):
        return inStockOnlineLabel;
      case showInStockAisleLabel(sellable, quantity, isWheelOrTirePDP):
        return inStockAisleLabel;
      default:
        return checkAvailabilityLabel;
    }
  };
  const label = getTitle();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-product-card__availability-message`,
      id: isAutoPartPlp ? getAccessibilityAvailabilityId(accessibilityId) : void 0,
      children: [
        label === outOfStockLabel ? returnStockIcon$1(iconTypes.prohibited) : returnStockIcon$1(),
        label === inStockAisleLabel ? getAvailabilityLabel(quantity) : label
      ]
    }
  );
}
const choose = () => {
  let defaultValue = null;
  let chosen;
  let isChosen = false;
  let whenHappens = false;
  function get() {
    return isChosen ? chosen == null ? void 0 : chosen() : defaultValue;
  }
  function defaultThen(supplier) {
    defaultValue = supplier;
    return { get };
  }
  function when(predicate) {
    whenHappens = whenHappens || predicate();
    return { then };
  }
  function then(supplier) {
    if (!isChosen && whenHappens) {
      chosen = supplier;
      isChosen = true;
    }
    return { when, get, defaultThen };
  }
  return { when };
};
const returnStockIcon = (iconType) => {
  return /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__availability-icon`, children: /* @__PURE__ */ jsx(Icon, { type: `ct-${iconType ? iconType : iconTypes.checkmark}`, size: "sm" }) });
};
function VehicleAvailabilitySection(props) {
  const {
    skuData,
    checkOtherStoresLabel,
    inStockAisleLabel,
    inStockOnlineLabel,
    outOfStockLabel,
    isUrgentLowStockLabel,
    isAutoPartPlp,
    accessibilityId,
    isUrgentLowStock,
    inStorePurchaseLabel
  } = props;
  const getAvailabilityLabel = (quantityFlag) => {
    const limitedStockMessage = isUrgentLowStockLabel;
    if (isUrgentLowStock) {
      const urgencyMsg = limitedStockMessage ? replaceStrWithDynamicVal(limitedStockMessage, quantityFlag == null ? void 0 : quantityFlag.toString()) : "";
      return /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__urgentLowStock`, children: urgencyMsg }) });
    } else {
      return replaceStrWithDynamicVal(inStockAisleLabel, (quantityFlag == null ? void 0 : quantityFlag.toString()) ?? "");
    }
  };
  const { sellable, orderable, fulfillment } = skuData;
  const availability = fulfillment == null ? void 0 : fulfillment.availability;
  const quantity = availability == null ? void 0 : availability.quantity;
  const Corporate = availability == null ? void 0 : availability.Corporate;
  const corpQuantity = Corporate == null ? void 0 : Corporate.Quantity;
  const wrap = (elem) => /* @__PURE__ */ jsx(
    "div",
    {
      className: `${PREFIX}-product-card__availability-message`,
      id: isAutoPartPlp ? getAccessibilityAvailabilityId(accessibilityId) : void 0,
      children: elem
    }
  );
  const getMessage = () => choose().when(() => props.isUseLegacyLogicOfVehicleCheckAvailability).then(() => /* @__PURE__ */ jsx(LegacyVehicleAvailabilitySection, { ...props })).when(() => !(skuData == null ? void 0 : skuData.fulfillment)).then(() => /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__availability-message` })).when(() => quantity > 0 && !sellable && !orderable).then(() => /* @__PURE__ */ jsxs(Fragment, { children: [
    wrap(
      /* @__PURE__ */ jsxs(Fragment, { children: [
        returnStockIcon(),
        getAvailabilityLabel(quantity)
      ] })
    ),
    wrap(
      /* @__PURE__ */ jsxs(Fragment, { children: [
        returnStockIcon(),
        inStorePurchaseLabel
      ] })
    )
  ] })).when(() => !quantity && corpQuantity > 0 && !orderable && !sellable).then(() => /* @__PURE__ */ jsxs(Fragment, { children: [
    wrap(
      /* @__PURE__ */ jsxs(Fragment, { children: [
        returnStockIcon(iconTypes.prohibited),
        getAvailabilityLabel(0)
      ] })
    ),
    wrap(
      /* @__PURE__ */ jsxs(Fragment, { children: [
        returnStockIcon(),
        checkOtherStoresLabel
      ] })
    )
  ] })).when(() => !quantity && !corpQuantity).then(() => /* @__PURE__ */ jsx(Fragment, { children: wrap(
    /* @__PURE__ */ jsxs(Fragment, { children: [
      returnStockIcon(iconTypes.prohibited),
      outOfStockLabel
    ] })
  ) })).when(() => quantity > 0 && sellable).then(() => /* @__PURE__ */ jsx(Fragment, { children: wrap(
    /* @__PURE__ */ jsxs(Fragment, { children: [
      returnStockIcon(),
      getAvailabilityLabel(quantity)
    ] })
  ) })).when(() => !quantity && corpQuantity > 0 && sellable).then(() => /* @__PURE__ */ jsx(Fragment, { children: wrap(
    /* @__PURE__ */ jsxs(Fragment, { children: [
      returnStockIcon(),
      inStockOnlineLabel
    ] })
  ) })).when(() => !sellable && !orderable && (quantity > 0 || corpQuantity > 0)).then(() => /* @__PURE__ */ jsx(Fragment, { children: wrap(
    /* @__PURE__ */ jsxs(Fragment, { children: [
      returnStockIcon(),
      checkOtherStoresLabel
    ] })
  ) })).defaultThen(() => {
    console.error(
      `Unexpected values: quantity=${quantity} corpQuantity=${corpQuantity}  sellable=${String(
        sellable
      )} orderable=${String(orderable)}`
    );
    return null;
  }).get();
  return /* @__PURE__ */ jsx(Fragment, { children: getMessage() });
}
VehicleAvailabilitySection.displayName = "VehicleAvailabilitySection";
const VehicleProductCard = (props) => {
  var _a, _b, _c, _d, _e;
  const {
    addToCartBtnClick,
    product,
    idx,
    productProps,
    showAtcBtnSpinner,
    addToCartLabel,
    addProductItemToWishlist,
    isWishlistItemActive,
    isWishlistEligible,
    showWishlistBtnSpinner,
    sponsoredLabel,
    a11yWishlistIcon,
    isWishlistToShow,
    addProductItemToCompare,
    isCompareProductChecked,
    compareProductsLabel,
    isPriceRangeViewEnabled = false,
    showCompareCheckbox
  } = props;
  const GridView2 = props.cardType === DisplayViewType.grid.toLowerCase();
  const ratingsAndReview = productProps.ratingsAndReview;
  const { fitmentCriticalNotesLabel, vehicleSpecificFitLabel, enableAddToCartOptions } = productProps;
  const [updatedFitmentNotesList, setFitmentNotes] = useState(null);
  const [selectedSKUData, setSelectedSkuData] = useState();
  const isStaggeredState = areAllParamsValid(
    ((_a = props.skus) == null ? void 0 : _a.length) === staggeredSkuLength,
    props.vehicleInformationPresent
  );
  const returnPolicy = props.returnPolicy;
  const isLazyRequire = props.isLazyRequire;
  const isAvailabilityVisible = () => {
    var _a2;
    return Boolean(props.isAutoPartPlp && props.showAvailabilityMessage && ((_a2 = props.skus) == null ? void 0 : _a2[0]));
  };
  const productImageRendering = () => {
    var _a2, _b2;
    return (_b2 = (_a2 = props.images) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.url;
  };
  const loyaltyValue = useCalculatedLoyaltyValue(
    isStaggeredState ? (_c = (_b = props == null ? void 0 : props.skus) == null ? void 0 : _b[minimumVariantsLength]) == null ? void 0 : _c.loyalty : (_e = (_d = props == null ? void 0 : props.skus) == null ? void 0 : _d[0]) == null ? void 0 : _e.loyalty,
    isStaggeredState,
    { frontQuantitySelected: 1, rearQuantitySelected: 1, qtySelectorInput: 1 }
  );
  useEffect(() => {
    var _a2, _b2;
    if (props.isAutoPartPlp) {
      const sku = (_a2 = props.skus) == null ? void 0 : _a2[0];
      const fitment = sku == null ? void 0 : sku.fitment;
      const fitmentData = [];
      if (fitment) {
        setSelectedSkuData(sku);
        (_b2 = fitment.fitmentNotes) == null ? void 0 : _b2.forEach((fitmentNote) => {
          fitmentData.push({ sku: fitment.sku, title: fitmentNote == null ? void 0 : fitmentNote.title, note: fitmentNote == null ? void 0 : fitmentNote.note });
          return isArrayNotEmpty(fitmentData) ? fitmentData : null;
        });
      }
      setFitmentNotes(fitmentData.length ? fitmentData : null);
    }
  }, [props.isAutoPartPlp, props.skus]);
  const ratingsView = () => {
    return ratingsAndReview && /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-reviews__list`,
        "data-bv-show": "inline_rating",
        "data-bv-product-id": props.productDataId,
        "data-bv-seo": "false",
        "aria-hidden": true
      }
    );
  };
  const showRating = () => {
    var _a2, _b2;
    return props.showRatingSection && /* @__PURE__ */ jsxs(Fragment, { children: [
      ratingsView(),
      ((_a2 = props.productWheelType) == null ? void 0 : _a2.toUpperCase()) === productWheelTypes.Tire && /* @__PURE__ */ jsx(
        RoadRatingBadge,
        {
          updateRoadRatingRef: props == null ? void 0 : props.updateRoadRatingRef,
          roadRatedLabel: props.roadRatedLabel,
          aggregateValue: (_b2 = props.roadRating) == null ? void 0 : _b2.aggregateValue,
          isReviewAvailable: props.ratingsCount > 0,
          ariaHidden: true
        }
      )
    ] });
  };
  const codeValueForVehicle = () => {
    var _a2, _b2;
    return ((_b2 = (_a2 = props.skus) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.formattedCode) || "";
  };
  const getSponsoredA11yId = () => {
    return (product == null ? void 0 : product.isSponsored) ? `sponsored_${product == null ? void 0 : product.code}` : "";
  };
  const codeValueForAutoParts = () => {
    var _a2, _b2, _c2, _d2, _e2, _f;
    const formattedCode = codeValueForVehicle();
    if (isArrayNotEmpty(props.skus) && props.isAutoPartPlp) {
      if ((_b2 = (_a2 = props.skus) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.partNumber) {
        if (GridView2) {
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${PREFIX}-product__grid-code`,
                children: `${props.partNumberLabel}: ${(_d2 = (_c2 = props.skus) == null ? void 0 : _c2[0]) == null ? void 0 : _d2.partNumber}`
              }
            ),
            /* @__PURE__ */ jsx("div", { children: `#${formattedCode}` })
          ] });
        } else {
          return `#${formattedCode} | ${props.partNumberLabel} ${(_f = (_e2 = props.skus) == null ? void 0 : _e2[0]) == null ? void 0 : _f.partNumber}`;
        }
      } else {
        return `#${formattedCode}`;
      }
    } else {
      return "";
    }
  };
  const code = props.isAutoPartPlp ? codeValueForAutoParts() : null;
  const productCodeDisplay = () => {
    return code && /* @__PURE__ */ jsx("p", { className: `${PREFIX}-product__code`, "aria-hidden": true, children: code });
  };
  const displayFitmentDetails = (displayNote, displayName) => {
    return /* @__PURE__ */ jsxs("li", { children: [
      /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-product-card__fitment-label`, children: [
        displayName,
        ": "
      ] }),
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__fitment-value`, children: displayNote })
    ] }, displayNote);
  };
  const displayUsageOrPositionDetails = (displayList, displayName) => {
    return displayList == null ? void 0 : displayList.map((usageValue) => {
      return displayFitmentDetails(usageValue.note, displayName);
    });
  };
  const fitmentDetailsPresent = (fitment) => {
    return (
      // eslint-disable-next-line sonar/expression-complexity
      fitment && (isArrayNotEmpty(fitment == null ? void 0 : fitment.fitmentNotes) || isArrayNotEmpty(fitment == null ? void 0 : fitment.position) || isArrayNotEmpty(fitment == null ? void 0 : fitment.tireWheelFitment) || isArrayNotEmpty(fitment == null ? void 0 : fitment.usage))
    );
  };
  const shouldDisplayFitmentTitle = (fitment) => {
    return fitment && (fitmentDetailsPresent(fitment) || (fitment == null ? void 0 : fitment.suggestedQty) > 1);
  };
  const specifications = () => {
    var _a2, _b2, _c2;
    const updatedFitmentNotes = updatedFitmentNotesList == null ? void 0 : updatedFitmentNotesList.slice(minimumSpecificationCount, maximumSpecificationCount);
    const fitment = (_b2 = (_a2 = props.skus) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.fitment;
    return props.isAutoPartPlp && checkValidData(fitment) && !GridView2 ? /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__specific-information`, "aria-hidden": true, children: [
      shouldDisplayFitmentTitle(fitment) && /* @__PURE__ */ jsx("p", { className: `${PREFIX}-product-card__critical-fitment`, children: fitmentCriticalNotesLabel }),
      /* @__PURE__ */ jsxs("ul", { className: `${PREFIX}-product-card__fitment-list`, children: [
        displayUsageOrPositionDetails(fitment == null ? void 0 : fitment.usage, props.attributeUsageLabel),
        displayUsageOrPositionDetails(fitment == null ? void 0 : fitment.position, props.attributePositionLabel),
        (fitment == null ? void 0 : fitment.suggestedQty) && Number(fitment == null ? void 0 : fitment.suggestedQty) > magicNumber.ONE && displayFitmentDetails(fitment == null ? void 0 : fitment.suggestedQty, props.suggestedQuantityLabel),
        updatedFitmentNotes == null ? void 0 : updatedFitmentNotes.map((value) => {
          return /* @__PURE__ */ jsxs("li", { children: [
            value.title && /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-product-card__fitment-label`, children: [
              value.title,
              ": "
            ] }),
            /* @__PURE__ */ jsx("span", { className: `${PREFIX}-product-card__fitment-value`, children: value.note })
          ] }, value.note);
        })
      ] })
    ] }) : /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__specific-information`, "aria-hidden": true, children: /* @__PURE__ */ jsxs("ul", { className: `${PREFIX}-product-card__fitment-grid`, children: [
      displayUsageOrPositionDetails(fitment == null ? void 0 : fitment.usage, props.attributeUsageLabel),
      displayUsageOrPositionDetails(fitment == null ? void 0 : fitment.position, props.attributePositionLabel),
      (_c2 = updatedFitmentNotes == null ? void 0 : updatedFitmentNotes.slice(magicNumber.ZERO, magicNumber.TWO)) == null ? void 0 : _c2.map((value) => {
        return /* @__PURE__ */ jsxs("li", { children: [
          value.title && /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-product-card__fitment-label`, children: [
            value.title,
            ": "
          ] }),
          /* @__PURE__ */ jsx(
            ClampLinesEllipsis,
            {
              text: value.note,
              lines: magicNumber.TWO,
              className: `${PREFIX}-product-card__fitment-value--shiitake`
            }
          )
        ] }, value.note);
      })
    ] }) });
  };
  const productVehicleCardData = () => {
    var _a2, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j;
    const feeValue = getFeeValue(
      props.skus,
      props.feeValue,
      isStaggeredState,
      props.vehicleInformationPresent,
      props.tireInformationPresent
    );
    return props.isAutoPartPlp ? /* @__PURE__ */ jsx(
      AutoPartsProductInformation,
      {
        ...props,
        isVehicleFullState: props.vehicleInformationPresent,
        selectedSKUData,
        a11yStrikeOutPrice: props.a11yStrikeOutPrice,
        a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
        overridePriceHeight: props.overridePriceHeight,
        feeMessages: props.feeMessages,
        accessibilityId: props.accessibilityId,
        plusMinusSymbol: props.plusMinusSymbol,
        isOnSale: props.isOnSale,
        fitmentIcon: props.fitmentIcon,
        fitmentMessageToggle: props.fitmentMessageToggle,
        fitmentMessageToggleUniversal: props.fitmentMessageToggleUniversal,
        fitMessageOnCard: props.fitMessageOnCard,
        vehicleString: props.vehicleString,
        partialFitMessageOnCard: props.partialFitMessageOnCard,
        confirmFitMessageUniversalOnCard: props.confirmFitMessageUniversalOnCard,
        fitMessageUniversalOnCard: props.fitMessageUniversalOnCard,
        fitmentTypeCode: props.fitmentTypeCode,
        loyaltyValue
      }
    ) : /* @__PURE__ */ jsx(
      VehicleProductInformation,
      {
        vehicleRearLabel: vehicleRearLabelValue(isStaggeredState, props.perTireLabel, props.vehicleRearLabel),
        rearTireSpecification: rearTireSpecification(
          props.skus,
          props.specification,
          isStaggeredState,
          props.productCardSpecifications
        ),
        rearTireCode: rearTireCode(
          props.skus,
          codeValueForVehicle(),
          isStaggeredState,
          props.vehicleInformationPresent,
          props.tireInformationPresent
        ),
        rearTireCurrentPrice: rearTireCurrentPrice(
          props.skus,
          props.currentPrice,
          isStaggeredState,
          props.vehicleInformationPresent,
          props.tireInformationPresent
        ),
        rearTireOriginalPrice: rearTireOriginalPrice(
          props.skus,
          props.originalPrice,
          isStaggeredState,
          props.vehicleInformationPresent,
          props.tireInformationPresent
        ),
        frontTireSpecification: frontTireSpecification(
          props.skus,
          isStaggeredState,
          props.productCardSpecifications,
          props.specification
        ),
        totalCurrentPrice: setOf4Price(
          props.skus,
          props.totalCurrentPrice,
          isStaggeredState,
          props.vehicleInformationPresent,
          props.tireInformationPresent
        ),
        frontTireCode: (_b2 = (_a2 = props.skus) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.formattedCode,
        setOfFourLabel: props.setOfFourLabel,
        skus: props.skus,
        vehicleFrontLabel: props.vehicleFrontLabel,
        language: props.language,
        feeTitle: feeValue ? replaceStrWithDynamicVal(
          addDynamicToken(props.feeTitle, "$x"),
          getFormattedPriceValue(props.language, feeValue)
        ) : "",
        vehicleFitType: props.vehicleFitType,
        rebate: getRebateDetails(
          props.skus,
          props.rebate,
          isStaggeredState,
          props.vehicleInformationPresent,
          props.tireInformationPresent
        ),
        rebateIcon: props.rebateIcon,
        eachLabel: props.eachLabel,
        isNonStaggeredGrid: isNonStaggeredGrid(),
        badges: rearBadgeList(
          props.skus,
          props.badges,
          isStaggeredState,
          props.vehicleInformationPresent,
          props.tireInformationPresent,
          props.exclude,
          isProductTire(props.product)
        ),
        productLevelBadges: props.badges,
        badgePriorities: props.badgePriorities,
        hideDisclaimer: props.hideDisclaimer,
        originalPrice: props.originalPrice,
        feeDisclaimerMessage: props.feeDisclaimerMessage,
        nowFromLabel: props.nowFromLabel,
        saveFromLabel: props.saveFromLabel,
        wasFromLabel: props.wasFromLabel,
        fromLabel: props.fromLabel,
        discount: props.discount,
        promotionalPriceLabel: props.promotionalPriceLabel,
        unitPriceLabel: props.unitPriceLabel,
        displayWasLabel: props.displayWasLabel,
        rearTireDisplayWasLabel: rearTireDisplayWasLabel(
          props.skus,
          props.displayWasLabel,
          isStaggeredState,
          props.vehicleInformationPresent,
          props.tireInformationPresent
        ),
        clearancePriceLabel: props.clearancePriceLabel,
        feeDisclaimerType: props.feeDisclaimerType,
        isSRPPage: props.isSRPPage,
        priceMessage: rearPriceMessage(
          props.skus,
          props.priceMessage,
          isStaggeredState,
          props.vehicleInformationPresent,
          props.tireInformationPresent
        ),
        vehicleInformationPresent: props.vehicleInformationPresent,
        feeDisclaimerTitle: props.feeDisclaimerTitle,
        scrollToFooter: props.scrollToFooter,
        tireInformationPresent: props.tireInformationPresent,
        a11yStrikeOutPrice: props.a11yStrikeOutPrice,
        a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
        excludeBadges: props.exclude,
        frontAvailability: hasMultipleSkus((_c2 = props == null ? void 0 : props.skus) == null ? void 0 : _c2.length) && ((_d2 = props == null ? void 0 : props.skus) == null ? void 0 : _d2[0]) ? /* @__PURE__ */ jsx(
          VehicleAvailabilitySection,
          {
            skuData: (_e2 = props == null ? void 0 : props.skus) == null ? void 0 : _e2[0],
            accessibilityId: props.accessibilityId,
            inStockAisleLabel: props.inStockAisleLabel,
            inStockOnlineLabel: props.inStockOnlineLabel,
            isUrgentLowStock: props.isUrgentLowStock,
            isWheelOrTirePDP: props.isWheelOrTirePDP,
            isAutoPartPlp: props.isAutoPartPlp,
            isUrgentLowStockLabel: props.isUrgentLowStockLabel,
            outOfStockLabel: props.outOfStockLabel,
            checkAvailabilityLabel: props.checkAvailabilityLabel,
            checkOtherStoresLabel: props.checkOtherStoresLabel,
            ...props
          }
        ) : null,
        rearAvailability: hasMultipleSkus((_f = props == null ? void 0 : props.skus) == null ? void 0 : _f.length) && ((_g = props == null ? void 0 : props.skus) == null ? void 0 : _g[magicNumber.ONE]) ? /* @__PURE__ */ jsx(
          VehicleAvailabilitySection,
          {
            skuData: (_h = props == null ? void 0 : props.skus) == null ? void 0 : _h[magicNumber.ONE],
            accessibilityId: props.accessibilityId,
            inStockAisleLabel: props.inStockAisleLabel,
            inStockOnlineLabel: props.inStockOnlineLabel,
            isUrgentLowStock: props.isUrgentLowStock,
            isWheelOrTirePDP: props.isWheelOrTirePDP,
            isAutoPartPlp: props.isAutoPartPlp,
            isUrgentLowStockLabel: props.isUrgentLowStockLabel,
            outOfStockLabel: props.outOfStockLabel,
            checkAvailabilityLabel: props.checkAvailabilityLabel,
            checkOtherStoresLabel: props.checkOtherStoresLabel,
            ...props
          }
        ) : null,
        perAvailability: ((_i = props == null ? void 0 : props.skus) == null ? void 0 : _i[0]) && /* @__PURE__ */ jsx(
          VehicleAvailabilitySection,
          {
            skuData: (_j = props == null ? void 0 : props.skus) == null ? void 0 : _j[0],
            accessibilityId: props.accessibilityId,
            inStockAisleLabel: props.inStockAisleLabel,
            inStockOnlineLabel: props.inStockOnlineLabel,
            isUrgentLowStock: props.isUrgentLowStock,
            isWheelOrTirePDP: props.isWheelOrTirePDP,
            isAutoPartPlp: props.isAutoPartPlp,
            isUrgentLowStockLabel: props.isUrgentLowStockLabel,
            outOfStockLabel: props.outOfStockLabel,
            checkAvailabilityLabel: props.checkAvailabilityLabel,
            checkOtherStoresLabel: props.checkOtherStoresLabel,
            ...props
          }
        ),
        a11yClickToReadFootnote: props.a11yClickToReadFootnote,
        accessibilityId: props.accessibilityId,
        ariaHidden: true,
        a11yTooltipIcon: props.a11yTooltipIcon,
        a11yCloseIconLabel: props.a11yCloseIconLabel,
        plusMinusSymbol: props.plusMinusSymbol,
        isTireProduct: isProductTire(props.product),
        isTireDataExist: props.isTireDataExist,
        fitmentMessage: props.fitmentMessageOnProductLevel,
        fitmentIcon: props.fitmentIcon,
        fitmentMessageToggle: props.fitmentMessageToggle,
        isOnSale: props.isOnSale,
        isPriceRangeViewEnabled,
        loyaltyValue
      }
    );
  };
  const getVehicleFitLabel = (specificationsList) => {
    const vehicleFitType = specificationsList == null ? void 0 : specificationsList.find(
      (specification) => [vehicleSpecificFitLabel].includes(specification.code)
    );
    return vehicleFitType == null ? void 0 : vehicleFitType.value;
  };
  const productInfoComponent = () => {
    var _a2;
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__product-information`, children: [
      /* @__PURE__ */ jsx(
        ProductInformation,
        {
          brand: props.brand,
          title: props.title,
          hideDescription: props.hideDescription,
          titleStyle: `${PREFIX}-product-card__title ${PREFIX}-product--trim`,
          titleContainerStyle: `${PREFIX}-product-card__title-container`,
          isFitmentRequired: props.isFitmentRequired,
          tireCategory: props.tireCategory,
          isAutoPartPlp: props.isAutoPartPlp,
          ariaHidden: true,
          vehicleFitLabel: props.vehicleInformationPresent ? getVehicleFitLabel((_a2 = props == null ? void 0 : props.skus[0]) == null ? void 0 : _a2.specifications) : getVehicleFitLabel(props == null ? void 0 : props.specification),
          accessibilityTitleId: getAccessibilityTitleId(props.accessibilityId),
          boldBrand: props.boldBrand
        }
      ),
      showRating(),
      !GridView2 && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__wishlist-section`, children: [
        /* @__PURE__ */ jsx(
          ProductCardATC,
          {
            showAtcBtnSpinner,
            product,
            addToCartBtnClick,
            idx,
            addButton: productProps.addButton,
            optionsButton: productProps.optionsButton,
            enableAddToCartOptions,
            enableMiniPdpFlyoutSupport: false,
            enableATCForSingleSkuMiniPdp: false,
            addToCartLabel
          }
        ),
        /* @__PURE__ */ jsx(
          ProductCardWishlist,
          {
            isWishlistEligible,
            a11yWishlistIcon,
            showWishlistBtnSpinner,
            addProductItemToWishlist,
            isWishlistItemActive: Boolean(isWishlistItemActive),
            product,
            idx,
            isWishlistToShow
          }
        )
      ] })
    ] });
  };
  const isNonStaggeredGrid = () => {
    var _a2;
    return GridView2 && ((_a2 = props.skus) == null ? void 0 : _a2.length) !== staggeredSkuLength;
  };
  const getAutoMotiveWrapperClass = () => {
    const autoPartPlpClass = props.vehicleFitType === BannerType$1.Fit ? `${PREFIX}-product-card__full-vehicle` : `${PREFIX}-product-card__partial-vehicle`;
    return props.isAutoPartPlp ? autoPartPlpClass : `${PREFIX}-product-card__automotive-content`;
  };
  const hasMultipleSkus = (skuQuantity) => {
    const singleSkuNumber = 1;
    return skuQuantity > singleSkuNumber;
  };
  const fitmentClass = props.isAutoPartPlp ? `${PREFIX}-product-card__price-fitment_grid--auto-parts` : "";
  const modifierClass = !isArrayNotEmpty(updatedFitmentNotesList) && props.isAutoPartPlp ? `${PREFIX}-product-card__auto-info--no-critical-fitmnet` : "";
  const imageAttributes2 = (path, dataComponentName) => {
    const attributeObject = {
      "data-component-name": dataComponentName
    };
    if (isLazyRequire) {
      attributeObject["data-src"] = path;
      attributeObject.className = "lazyload";
    } else {
      attributeObject.src = path;
    }
    return attributeObject;
  };
  const createUrlWithPolicy2 = (source, policyType) => {
    var _a2;
    return policyType ? `${(_a2 = source == null ? void 0 : source.toString()) == null ? void 0 : _a2.split("?", magicNumber.ONE).toString()}${returnPolicy(policyType)}` : `${source}`;
  };
  const shouldRenderSpecification = () => {
    var _a2, _b2;
    const fitment = (_b2 = (_a2 = props.skus) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.fitment;
    return fitmentDetailsPresent(fitment) && specifications();
  };
  const renderListViewSpecifications = () => {
    return !GridView2 && shouldRenderSpecification();
  };
  const renderGridViewSpecifications = () => {
    return GridView2 && shouldRenderSpecification();
  };
  const handleKeyUp = (event, key, scrollingRequired) => {
    if (key === stringKeyCodes.tab && scrollingRequired) {
      productCardScrollToTop(event);
    }
  };
  const handleKeyDown = (event, key) => {
    if (key === stringKeyCodes.enter) {
      props.productCardClick(event, props.product, props.idx);
    }
  };
  const renderGridWishlistSection = () => {
    return GridView2 && /* @__PURE__ */ jsx(
      ProductCardWishlist,
      {
        isWishlistEligible,
        a11yWishlistIcon,
        showWishlistBtnSpinner,
        addProductItemToWishlist,
        isWishlistItemActive: Boolean(isWishlistItemActive),
        product,
        idx,
        isWishlistToShow
      }
    );
  };
  const renderSponsoredLabel = () => {
    return GridView2 && (product == null ? void 0 : product.isSponsored) && /* @__PURE__ */ jsx(
      "small",
      {
        id: getSponsoredA11yId(),
        "aria-label": sponsoredLabel,
        "aria-hidden": "true",
        className: `${PREFIX}-product-card__sponsored`,
        children: sponsoredLabel
      }
    );
  };
  return /* @__PURE__ */ jsxs(
    "a",
    {
      href: props.url,
      onKeyPress: (event) => {
        handleKeyDown(event, event.key);
      },
      "aria-labelledby": `title__${props.accessibilityId} ${getSponsoredA11yId()} price__${props.accessibilityId} availability__${props.accessibilityId}`,
      onClick: (event) => props.productCardClick(event, props.product, props.idx),
      tabIndex: 0,
      onKeyUp: (event) => {
        handleKeyUp(event, event.key, props.isScrollingRequired);
      },
      "data-testid": `product-card-container${props.idx}`,
      className: classnames(`${PREFIX}-product-card__content`, getAutoMotiveWrapperClass(), props.className),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${PREFIX}-product-card__automotive-wrap ${!props.isWheelOrTirePDP ? `${PREFIX}-product-card__automotive-wrap--no-wrap` : ""}`,
            children: [
              renderGridWishlistSection(),
              /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__auto-primary-details`, children: [
                /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__auto-primary-details-right`, children: [
                  /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product-card__image-wrap`, "aria-hidden": true, children: /* @__PURE__ */ jsx(
                    "img",
                    {
                      "aria-hidden": true,
                      alt: "",
                      ...imageAttributes2(
                        `${createUrlWithPolicy2(productImageRendering(), props.imageDataComponentName)}`,
                        props.imageDataComponentName
                      )
                    }
                  ) }),
                  /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__cta`, children: [
                    GridView2 && /* @__PURE__ */ jsx(
                      ProductCardATC,
                      {
                        showAtcBtnSpinner,
                        product,
                        addToCartBtnClick,
                        idx,
                        addButton: productProps.addButton,
                        optionsButton: productProps.optionsButton,
                        enableAddToCartOptions,
                        enableMiniPdpFlyoutSupport: false,
                        enableATCForSingleSkuMiniPdp: false,
                        addToCartLabel
                      }
                    ),
                    productInfoComponent()
                  ] })
                ] }),
                /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__price-fitment_grid ${fitmentClass}`, children: [
                  /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-product-card__auto-info ${modifierClass}`, children: [
                    productVehicleCardData(),
                    renderGridViewSpecifications(),
                    productCodeDisplay(),
                    isAvailabilityVisible() && /* @__PURE__ */ jsx(
                      VehicleAvailabilitySection,
                      {
                        skuData: props.skus[0],
                        accessibilityId: props.accessibilityId,
                        inStockAisleLabel: props.inStockAisleLabel,
                        inStockOnlineLabel: props.inStockOnlineLabel,
                        isUrgentLowStock: props.isUrgentLowStock,
                        isWheelOrTirePDP: props.isWheelOrTirePDP,
                        isAutoPartPlp: props.isAutoPartPlp,
                        isUrgentLowStockLabel: props.isUrgentLowStockLabel,
                        outOfStockLabel: props.outOfStockLabel,
                        checkAvailabilityLabel: props.checkAvailabilityLabel,
                        checkOtherStoresLabel: props.checkOtherStoresLabel,
                        ...props
                      }
                    )
                  ] }),
                  renderListViewSpecifications(),
                  /* @__PURE__ */ jsx(
                    CompareCheckbox,
                    {
                      addProductItemToCompare,
                      product,
                      idx,
                      isCompareProductChecked,
                      compareProductsLabel,
                      showCompareCheckbox
                    }
                  )
                ] })
              ] })
            ]
          }
        ),
        renderSponsoredLabel()
      ]
    }
  );
};
VehicleProductCard.propTypes = {
  path: PropTypes.string,
  productProps: PropTypes.any,
  idx: PropTypes.number.isRequired,
  cardType: PropTypes.string.isRequired,
  type: PropTypes.string,
  title: PropTypes.string.isRequired,
  code: PropTypes.string,
  brand: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.exact({
      label: PropTypes.string,
      url: PropTypes.string
    })
  ]).isRequired,
  rating: PropTypes.number.isRequired,
  ratingsCount: PropTypes.number.isRequired,
  priceShortMessage: PropTypes.string,
  priceLongMessage: PropTypes.string,
  longDescription: PropTypes.string,
  productCardClick: PropTypes.func,
  redirectAfterProductCardClick: PropTypes.func,
  hideDescription: PropTypes.bool,
  images: PropTypes.array,
  showRatingSection: PropTypes.bool,
  ecoFeeTitleChange: PropTypes.func,
  skus: PropTypes.array,
  currentPrice: PropTypes.any,
  originalPrice: PropTypes.any,
  language: PropTypes.string,
  feeTitle: PropTypes.string,
  rebate: PropTypes.any,
  rebateIcon: PropTypes.string,
  tireCategory: PropTypes.string,
  roadRating: PropTypes.any,
  isFitmentRequired: PropTypes.bool,
  specification: PropTypes.any,
  setOfFourLabel: PropTypes.string,
  perTireLabel: PropTypes.string,
  vehicleFrontLabel: PropTypes.string,
  vehicleRearLabel: PropTypes.string,
  roadRatedLabel: PropTypes.string,
  vehicleFitType: PropTypes.any,
  eachLabel: PropTypes.string,
  badgePriorities: PropTypes.any,
  badges: PropTypes.array,
  hideDisclaimer: PropTypes.bool,
  isAutoPartPlp: PropTypes.bool,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string,
  a11yTooltipIcon: PropTypes.string,
  fitmentTypeCode: PropTypes.any,
  vehicleList: PropTypes.array,
  options: PropTypes.array,
  partNumber: PropTypes.string,
  fitmentNotes: PropTypes.array,
  productWheelType: PropTypes.string,
  feeDisclaimerMessage: PropTypes.string,
  nowFromLabel: PropTypes.string,
  saveFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  promotionalPriceLabel: PropTypes.string,
  unitPriceLabel: PropTypes.string,
  displayWasLabel: PropTypes.bool,
  clearancePriceLabel: PropTypes.string,
  discount: PropTypes.any,
  feeDisclaimerType: PropTypes.string,
  isSRPPage: PropTypes.bool,
  feeValue: PropTypes.number,
  priceMessage: PropTypes.array,
  vehicleInformationPresent: PropTypes.bool,
  feeDisclaimerTitle: PropTypes.string,
  tireInformationPresent: PropTypes.bool,
  scrollToFooter: PropTypes.func,
  isWheelOrTirePDP: PropTypes.bool,
  inStockLabel: PropTypes.string,
  inStockOnlineLabel: PropTypes.string,
  outOfStockLabel: PropTypes.string,
  inStorePurchaseLabel: PropTypes.string,
  inStockAisleLabel: PropTypes.string,
  checkAvailabilityLabel: PropTypes.string,
  checkOtherStoresLabel: PropTypes.string,
  isUseLegacyLogicOfVehicleCheckAvailability: PropTypes.bool,
  partNumberLabel: PropTypes.string,
  exclude: PropTypes.array,
  overridePriceHeight: PropTypes.bool,
  a11yReviewRating: PropTypes.string,
  url: PropTypes.string,
  feeMessages: PropTypes.array,
  productCardSpecifications: PropTypes.string,
  isUrgentLowStock: PropTypes.bool,
  isUrgentLowStockLabel: PropTypes.string,
  totalCurrentPrice: PropTypes.any,
  imageDataComponentName: PropTypes.string,
  attributePositionLabel: PropTypes.string,
  suggestedQuantityLabel: PropTypes.string,
  attributeUsageLabel: PropTypes.string,
  isScrollingRequired: PropTypes.bool,
  returnPolicy: PropTypes.func,
  isLazyRequire: PropTypes.bool,
  product: PropTypes.object.isRequired,
  productDataId: PropTypes.string,
  a11yClickToReadFootnote: PropTypes.string,
  showAvailabilityMessage: PropTypes.bool,
  sponsoredLabel: PropTypes.string
};
VehicleProductCard.displayName = "VehicleProductCard";
const SkeletonThemeContext = React.createContext({});
const defaultEnableAnimation = true;
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, customHighlightBackground }) {
  const style = {};
  if (direction === "rtl")
    style["--animation-direction"] = "reverse";
  if (typeof duration === "number")
    style["--animation-duration"] = `${duration}s`;
  if (!enableAnimation)
    style["--pseudo-element-display"] = "none";
  if (typeof width === "string" || typeof width === "number")
    style.width = width;
  if (typeof height === "string" || typeof height === "number")
    style.height = height;
  if (typeof borderRadius === "string" || typeof borderRadius === "number")
    style.borderRadius = borderRadius;
  if (circle)
    style.borderRadius = "50%";
  if (typeof baseColor !== "undefined")
    style["--base-color"] = baseColor;
  if (typeof highlightColor !== "undefined")
    style["--highlight-color"] = highlightColor;
  if (typeof customHighlightBackground === "string")
    style["--custom-highlight-background"] = customHighlightBackground;
  return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
  var _a, _b, _c;
  const contextStyleOptions = React.useContext(SkeletonThemeContext);
  const propsStyleOptions = { ...originalPropsStyleOptions };
  for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
    if (typeof value === "undefined") {
      delete propsStyleOptions[key];
    }
  }
  const styleOptions = {
    ...contextStyleOptions,
    ...propsStyleOptions,
    circle
  };
  const style = {
    ...styleProp,
    ...styleOptionsToCssProperties(styleOptions)
  };
  let className2 = "react-loading-skeleton";
  if (customClassName)
    className2 += ` ${customClassName}`;
  const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
  const elements = [];
  const countCeil = Math.ceil(count);
  for (let i = 0; i < countCeil; i++) {
    let thisStyle = style;
    if (countCeil > count && i === countCeil - 1) {
      const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : "100%";
      const fractionalPart = count % 1;
      const fractionalWidth = typeof width === "number" ? width * fractionalPart : `calc(${width} * ${fractionalPart})`;
      thisStyle = { ...thisStyle, width: fractionalWidth };
    }
    const skeletonSpan = React.createElement("span", { className: className2, style: thisStyle, key: i }, "‌");
    if (inline) {
      elements.push(skeletonSpan);
    } else {
      elements.push(React.createElement(
        React.Fragment,
        { key: i },
        skeletonSpan,
        React.createElement("br", null)
      ));
    }
  }
  return React.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper ? elements.map((el, i) => React.createElement(Wrapper, { key: i }, el)) : elements);
}
const SkeletonComponent = ({ ...props }) => {
  const { count, isCircle, height, width, duration, skeletonClass, dataTestId } = props;
  return /* @__PURE__ */ jsx(
    Skeleton,
    {
      className: `${PREFIX}-skeleton ${String(skeletonClass)}`,
      count,
      circle: isCircle,
      height,
      width,
      duration,
      inline: true,
      containerTestId: dataTestId
    }
  );
};
SkeletonComponent.propTypes = {
  isCircle: PropTypes.bool,
  skeletonClass: PropTypes.string,
  count: PropTypes.number,
  duration: PropTypes.number,
  width: PropTypes.string || PropTypes.number,
  height: PropTypes.string || PropTypes.number
};
SkeletonComponent.displayName = "SkeletonComponent";
const LARGE_DESKTOP_PRODUCT_PER_ROW = 5;
const STANDART_DESKTOP_PRODUCT_PER_ROW = 6;
const MIN_DESKTOP_PRODUCT_PER_ROW = 5;
const PORTRAIT_TABLET_PRODUCT_PER_ROW = 4;
const LANDSCAPE_MOBILE_PRODUCT_PER_ROW = 3;
const DEFAULT_PRODUCT_PER_ROW = 2;
const getProductPerRowCount = () => {
  switch (true) {
    case window.innerWidth >= BREAKPOINTS.desktopLarg:
      return LARGE_DESKTOP_PRODUCT_PER_ROW;
    case window.innerWidth > BREAKPOINTS.desktopStandard:
      return STANDART_DESKTOP_PRODUCT_PER_ROW;
    case window.innerWidth >= BREAKPOINTS.desktopMin:
      return MIN_DESKTOP_PRODUCT_PER_ROW;
    case window.innerWidth >= BREAKPOINTS.tabletPortrait:
      return PORTRAIT_TABLET_PRODUCT_PER_ROW;
    case window.innerWidth >= BREAKPOINTS.mobileLandscape:
      return LANDSCAPE_MOBILE_PRODUCT_PER_ROW;
    default:
      return DEFAULT_PRODUCT_PER_ROW;
  }
};
function useRoadRatingsRef() {
  const map = useRef(null);
  const getMap = useCallback(() => {
    if (!map.current) {
      map.current = /* @__PURE__ */ new Map();
    }
    return map.current;
  }, []);
  const updateRef = useCallback(
    (key) => (node) => {
      const nodes = getMap();
      if (nodes.has(key)) {
        nodes.get(key).offsetHeight;
      }
      if (node) {
        nodes.set(key, node);
      } else {
        nodes.delete(key);
      }
    },
    [getMap]
  );
  useEffect(() => {
    const roadRatingNodes = getMap();
    return () => roadRatingNodes.clear();
  }, [getMap]);
  return { updateRef, getMap };
}
const AdsGridCardView = ({
  id,
  backgroundImage,
  backgroundImageAltText,
  redirectUrl,
  redirectTarget,
  buttonText,
  buttonBackgroundColor,
  buttonTextColor,
  sponsoredLabel,
  adOnClickEvent,
  ariaLabel,
  altAdText
}) => {
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-adds__content`, children: [
    /* @__PURE__ */ jsxs(
      "a",
      {
        href: redirectUrl,
        target: redirectTarget,
        onClick: (event) => {
          adOnClickEvent(event, redirectUrl, redirectTarget);
        },
        children: [
          /* @__PURE__ */ jsx(
            "img",
            {
              className: `${PREFIX}-adds__content-img`,
              alt: backgroundImageAltText || altAdText,
              "aria-hidden": true,
              src: backgroundImage
            }
          ),
          /* @__PURE__ */ jsx(
            ButtonV2,
            {
              className: `${PREFIX}-adds-grid-btn`,
              a11y: { label: ariaLabel },
              style: {
                backgroundColor: buttonBackgroundColor,
                color: buttonTextColor
              },
              children: buttonText
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "small",
      {
        id,
        "aria-label": sponsoredLabel,
        "aria-hidden": "true",
        className: `${PREFIX}-adds-grid-card__sponsored`,
        children: sponsoredLabel
      }
    )
  ] });
};
const AdsCard = ({
  advertisements,
  adsViewPartElligibleForRefresh,
  adsRefreshTime,
  enableAdsRefresh,
  sponsoredLabel,
  altAdText
}) => {
  const [currentAdsIndex, setCurrentAdsIndex] = useState(0);
  const [timeAfterLastAdsSwitch, setTimeAfterLastAdsSwitch] = useState(0);
  const [isAdsSwitchTimerRunning, setIsAdsSwitchTimerRunning] = useState(false);
  const targetRef = useRef(null);
  const intervalRef = useRef(null);
  const adsItemToDisplay = useMemo(() => advertisements[currentAdsIndex] ?? null, [currentAdsIndex, advertisements]);
  const {
    id,
    ariaLabel,
    backgroundImage,
    backgroundImageAltText,
    redirectUrl,
    redirectTarget,
    footerText,
    footerBackgroundColor,
    footerTextColor,
    onLoadSideEffect,
    onViewSideEffect,
    onClickSideEffect
  } = adsItemToDisplay;
  const handleOnClick = (event, url, target) => {
    event.preventDefault();
    onClickSideEffect();
    window.open(url, target);
  };
  useEffect(() => {
    if (adsItemToDisplay) {
      onLoadSideEffect();
    }
  }, [adsItemToDisplay]);
  useEffect(() => {
    if (!targetRef.current) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => setIsAdsSwitchTimerRunning(entry.intersectionRatio >= adsViewPartElligibleForRefresh / 100),
      { threshold: adsViewPartElligibleForRefresh / 100 }
    );
    observer.observe(targetRef.current);
    return () => {
      observer.disconnect();
    };
  }, [adsViewPartElligibleForRefresh]);
  useEffect(() => {
    if (!enableAdsRefresh) {
      return;
    }
    if (isAdsSwitchTimerRunning) {
      if (intervalRef.current === null) {
        intervalRef.current = setInterval(() => {
          setTimeAfterLastAdsSwitch((prev) => prev + 1);
        }, 1e3);
      }
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isAdsSwitchTimerRunning, adsRefreshTime, enableAdsRefresh]);
  useEffect(() => {
    if (enableAdsRefresh) {
      if (timeAfterLastAdsSwitch === 1) {
        onViewSideEffect();
      } else if (timeAfterLastAdsSwitch >= adsRefreshTime) {
        setCurrentAdsIndex((prevIndex) => (prevIndex + 1) % advertisements.length);
        setTimeAfterLastAdsSwitch(0);
      }
    }
  }, [timeAfterLastAdsSwitch, adsRefreshTime, enableAdsRefresh, advertisements.length]);
  return adsItemToDisplay ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-adds__main__content`, ref: targetRef, children: /* @__PURE__ */ jsx(
    AdsGridCardView,
    {
      id,
      backgroundImage,
      backgroundImageAltText,
      redirectUrl,
      redirectTarget,
      buttonText: footerText,
      buttonBackgroundColor: footerBackgroundColor,
      buttonTextColor: footerTextColor,
      sponsoredLabel,
      adOnClickEvent: handleOnClick,
      ariaLabel,
      altAdText
    }
  ) }) : null;
};
const productGridWrapperClassName = `${PREFIX}-product`;
const roadRatingSkeletonClassName = "with-road-rating-skeleton";
const GridView = ({
  path,
  productProps,
  ProductCardData,
  productCardClick,
  redirectAfterProductCardClick,
  viewType,
  badgePriority,
  inImageBadgePriority,
  a11yStrikeOutPrice,
  a11yStrikeOutPriceRange,
  inclCoreChargesLbl,
  plusCoreChargesLbl,
  coreChargesTooltipTitle,
  coreChargesTooltipParagraph,
  a11yTooltipIcon,
  language: language2,
  a11yCloseIconLabel,
  isProductCardLoading,
  skeletonItems,
  rebateIcon,
  isFitmentRequired,
  setOfFourLabel,
  perTireLabel,
  vehicleFrontLabel,
  vehicleRearLabel,
  roadRatedLabel,
  vehicleFitType,
  eachLabel,
  nowFromLabel,
  saveFromLabel,
  wasFromLabel,
  fromLabel,
  isAutoPartPlp,
  vehicleList = null,
  productWheelType,
  promotionalPriceLabel,
  unitPriceLabel,
  clearancePriceLabel,
  isSRPPage,
  vehicleInformationPresent,
  observeProducts,
  tireInformationPresent,
  scrollToFooter: scrollToFooter2,
  isWheelOrTirePDP,
  partNumberLabel,
  inStockLabel,
  inStockOnlineLabel,
  outOfStockLabel,
  inStorePurchaseLabel,
  inStockAisleLabel,
  checkAvailabilityLabel,
  checkOtherStoresLabel,
  isUseLegacyLogicOfVehicleCheckAvailability,
  exclude,
  thresholdValue,
  overridePriceHeight,
  a11yReviewRating,
  productCardSpecifications,
  isUrgentLowStockLabel,
  isWheelOrTireFunc,
  isAutomotiveProduct,
  imageDataComponentName,
  returnPolicy,
  attributePositionLabel,
  suggestedQuantityLabel,
  attributeUsageLabel,
  isLazyRequire,
  saleEndDaySoonMessage,
  isColourSwatchesActive,
  saleMessageRules,
  saleEndDisableShift,
  a11yVariantSelected,
  a11yVariantUnSelected,
  a11yClickToReadFootnote,
  pageType,
  plusMinusSymbol,
  enableBoldedBrandName = false,
  enableMiniPdpFlyoutSupport,
  enableATCForSingleSkuMiniPdp,
  isTireDataExist,
  fitmentMessageOnProductLevel,
  fitmentIcon,
  fitmentMessageToggle,
  fitmentMessageToggleUniversal,
  fitMessageOnCard,
  partialFitMessageOnCard,
  vehicleString,
  addToCartBtnClick,
  showAtcBtnSpinner,
  clickedATCCardIdx,
  addToCartLabel,
  sponsoredLabel,
  confirmFitMessageUniversalOnCard,
  fitMessageUniversalOnCard,
  addProductItemToWishlist,
  wishlistItems,
  isWishlistToShow,
  showWishlistBtnSpinner,
  clickedWishlistIdx,
  a11yWishlistIcon,
  quickLookLabel,
  addProductItemToCompare,
  compareProductsList,
  enableComparisonOfProducts,
  enableComparisonTool,
  compareProductsLabel,
  isBrowseOnlyMode,
  isWestPriceLazyLoadEnabled,
  isPriceRangeViewEnabled = false
}) => {
  const isMobile2 = useIsMobile();
  const renderProductCardSkeleton = (skeletonCount) => {
    return /* @__PURE__ */ jsx(Fragment, { children: [...Array(skeletonCount)].map((index2) => /* @__PURE__ */ jsx("li", { className: `${PREFIX}-product__content`, children: /* @__PURE__ */ jsx(SkeletonComponent, { skeletonClass: `${PREFIX}-product-card__grid-card-skeleton` }) }, index2)) });
  };
  const checkSkusAvailability = () => {
    return Boolean(ProductCardData == null ? void 0 : ProductCardData.filter((item) => {
      var _a;
      return ((_a = item.skus) == null ? void 0 : _a.length) > magicNumber.ZERO;
    }).length);
  };
  const generateAccessibilityId = (skus, skuId, code) => {
    var _a;
    if ((_a = skus == null ? void 0 : skus[0]) == null ? void 0 : _a.code) {
      return getAccessibilityId(pageType, skus == null ? void 0 : skus[0].code);
    } else if (skuId) {
      return getAccessibilityId(pageType, skuId);
    } else {
      return getAccessibilityId(pageType, code);
    }
  };
  const showUpdatedATCSpinner = (idx) => {
    return clickedATCCardIdx === idx ? showAtcBtnSpinner : false;
  };
  const showUpdatedWishlistSpinner = (idx) => {
    return clickedWishlistIdx === idx ? showWishlistBtnSpinner : false;
  };
  const getProductSkuCode = (skus, code) => {
    var _a;
    return (skus == null ? void 0 : skus.length) === 1 ? (_a = skus == null ? void 0 : skus[0]) == null ? void 0 : _a.code : code.toUpperCase().replace("P", "");
  };
  const isSingleSkuProduct = (skus, options) => {
    return (skus == null ? void 0 : skus.length) === 1 || isArrayEmpty(skus) && isArrayEmpty(options);
  };
  const isWishlistActive = (skus, code) => {
    var _a;
    return (_a = wishlistItems == null ? void 0 : wishlistItems.products) == null ? void 0 : _a.some((wishlist) => wishlist.code === getProductSkuCode(skus, code));
  };
  const isProductChecked = (code) => {
    return compareProductsList == null ? void 0 : compareProductsList.some((compareProduct) => compareProduct.code === code);
  };
  const productPerRowInGrid = getProductPerRowCount();
  const { updateRef, getMap } = useRoadRatingsRef();
  const roadRatingSkeletonProductIndexes = useMemo(() => {
    var _a, _b;
    if (isFitmentRequired && isArrayNotEmpty(ProductCardData)) {
      const enableSkeletonForIndexes = /* @__PURE__ */ new Map();
      let isThereRoadRatingInRow = false;
      let currentRowNumber = 1;
      let skeletonHeight = 0;
      const tempIndexes = /* @__PURE__ */ new Set();
      const roadRatingNodes = getMap();
      for (let i = 0; i < ProductCardData.length; i++) {
        enableSkeletonForIndexes.set(i, { height: 0 });
        if ("roadRating" in ProductCardData[i] && ((_a = ProductCardData[i].roadRating) == null ? void 0 : _a.aggregateValue)) {
          isThereRoadRatingInRow = true;
          skeletonHeight = Math.max(((_b = roadRatingNodes.get(i)) == null ? void 0 : _b.offsetHeight) || 0, skeletonHeight);
        } else {
          tempIndexes.add(i);
        }
        if (i === productPerRowInGrid * currentRowNumber - 1 || i === ProductCardData.length - 1) {
          if (isThereRoadRatingInRow) {
            tempIndexes.forEach((index2) => enableSkeletonForIndexes.set(index2, { height: skeletonHeight }));
          }
          tempIndexes.clear();
          currentRowNumber++;
          isThereRoadRatingInRow = false;
          skeletonHeight = 0;
        }
      }
      return enableSkeletonForIndexes;
    } else {
      return /* @__PURE__ */ new Map();
    }
  }, [ProductCardData, isFitmentRequired, productPerRowInGrid, getMap]);
  return /* @__PURE__ */ jsx("ul", { className: `${PREFIX}-product__${viewType}-view ${PREFIX}-product__${viewType}-items`, children: /* @__PURE__ */ jsxs(Fragment, { children: [
    ProductCardData.map((value, idx) => {
      var _a, _b, _c, _d, _e, _f;
      if ("isAdvertisement" in value) {
        const key = `ads-key${value.id}`;
        return /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx("li", { id: value.id, className: `${PREFIX}-product__content`, children: /* @__PURE__ */ jsx(
          AdsCard,
          {
            advertisements: value.advertisements,
            adsViewPartElligibleForRefresh: value.adsViewPartElligibleForRefresh,
            adsRefreshTime: value.adsRefreshTime,
            enableAdsRefresh: value.enableAdsRefresh,
            altAdText: value.altAdText,
            sponsoredLabel
          }
        ) }, key) }, `product-content-${key}`);
      } else {
        const singleSkuCurrentPrice = (_b = (_a = value.skus) == null ? void 0 : _a[magicNumber.ZERO]) == null ? void 0 : _b.currentPrice;
        const singleSkuOriginalPrice = (_d = (_c = value.skus) == null ? void 0 : _c[magicNumber.ZERO]) == null ? void 0 : _d.originalPrice;
        const isSingleSkuPricesAvailable = () => {
          var _a2;
          return ((_a2 = value.skus) == null ? void 0 : _a2.length) === magicNumber.ONE && isAtleastOneParamValid(!!singleSkuCurrentPrice, !!singleSkuOriginalPrice);
        };
        const isNoOptionsProduct = areAllParamsValid(isWestPriceLazyLoadEnabled, !((_e = value.options) == null ? void 0 : _e.length));
        const singleSkuPrices = isAtleastOneParamValid(isSingleSkuPricesAvailable(), isNoOptionsProduct) ? {
          currentPrice: singleSkuCurrentPrice,
          originalPrice: singleSkuOriginalPrice
        } : {};
        const {
          type,
          title,
          code,
          brand,
          options,
          rating,
          ratingsCount,
          timeTestedPrice,
          priceShortMessage,
          priceLongMessage,
          longDescription,
          packagePrice,
          badges,
          salePrice,
          discount,
          onlineOnly,
          inStock,
          coreCharge,
          coreChargeIncluded,
          images,
          featureBullets,
          skus,
          originalPrice,
          currentPrice,
          displayWasLabel,
          feeMessages,
          priceMessage,
          rebate,
          categoryLevel,
          roadRating,
          specifications,
          partNumber,
          fitmentNotes,
          fitmentTypeCode,
          sellable,
          orderable,
          url,
          isUrgentLowStock,
          totalCurrentPrice: totalCurrentPrice2,
          skuId,
          isOnSale
        } = { ...value, ...singleSkuPrices };
        const feeMessage = isArrayNotEmpty(feeMessages) ? feeMessages == null ? void 0 : feeMessages[0] : {};
        const isWheelOrTire = isWheelOrTireFunc && isWheelOrTireFunc(value == null ? void 0 : value.productWheelType);
        const isAutomotiveProductFlag = isAutomotiveProduct && isAutomotiveProduct(fitmentTypeCode, value.productWheelType);
        const isWishlistItemActive = areAllParamsValid(isWishlistToShow, isWishlistActive(skus, code));
        const isWishlistEligible = areAllParamsValid(
          isWishlistToShow,
          isSingleSkuProduct(skus, options)
        );
        const isCompareProductChecked = isProductChecked(code);
        const fulfillment = isWheelOrTire && vehicleInformationPresent ? (
          // eslint-disable-next-line sonar/no-nested-conditional
          skus.length === magicNumber.TWO ? null : (_f = skus == null ? void 0 : skus[0]) == null ? void 0 : _f.fulfillment
        ) : value == null ? void 0 : value.fulfillment;
        const showCompareCheckbox = areAllParamsValid(
          !isMobile2,
          value == null ? void 0 : value.comparisonEnabled,
          enableComparisonOfProducts,
          enableComparisonTool,
          !isBrowseOnlyMode
        );
        return /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(
          "li",
          {
            id: code,
            ref: (node) => {
              observeProducts == null ? void 0 : observeProducts(node);
            },
            className: `${PREFIX}-product__content`,
            "data-testid": "product-grids",
            children: !isFitmentRequired ? /* @__PURE__ */ jsx(
              ProductCard,
              {
                product: value,
                productProps: {
                  ...productProps,
                  fulfillment,
                  sellable,
                  orderable
                },
                productCardClick,
                redirectAfterProductCardClick,
                path,
                idx,
                cardType: viewType,
                title,
                type,
                code: skuId,
                brand,
                rating,
                ratingsCount,
                timeTestedPrice,
                salePrice,
                discount,
                priceShortMessage,
                priceLongMessage,
                longDescription,
                inStock,
                onlineOnly,
                packagePrice,
                badgePriorities: badgePriority,
                inImageBadgePriorities: inImageBadgePriority,
                badges,
                a11yStrikeOutPrice,
                a11yStrikeOutPriceRange,
                plusCoreChargesLbl,
                inclCoreChargesLbl,
                coreCharge,
                coreChargeIncluded,
                coreChargesTooltipTitle,
                coreChargesTooltipParagraph,
                a11yTooltipIcon,
                images,
                featureBullets,
                feeTitle: (feeMessage == null ? void 0 : feeMessage.value) ? replaceStrWithDynamicVal(
                  addDynamicToken(feeMessage == null ? void 0 : feeMessage.feeTitle, "$x"),
                  getFormattedPriceValue(language2, feeMessage == null ? void 0 : feeMessage.value)
                ) : "",
                feeDisclaimerTitle: feeMessage == null ? void 0 : feeMessage.feeDisclaimerTitle,
                feeDisclaimerMessage: feeMessage == null ? void 0 : feeMessage.feeDisclaimerMessage,
                options,
                skus,
                originalPrice,
                currentPrice,
                displayWasLabel,
                language: language2,
                a11yCloseIconLabel,
                priceMessage,
                rebateIcon,
                rebate,
                scrollToFooter: scrollToFooter2,
                nowFromLabel,
                saveFromLabel,
                wasFromLabel,
                fromLabel,
                hideDisclaimer: !isArrayNotEmpty(options),
                feeDisclaimerType: feeMessage == null ? void 0 : feeMessage.type,
                inStockLabel,
                inStockOnlineLabel,
                outOfStockLabel,
                inStorePurchaseLabel,
                inStockAisleLabel,
                checkAvailabilityLabel,
                checkOtherStoresLabel,
                overridePriceHeight,
                promotionalPriceLabel,
                unitPriceLabel,
                clearancePriceLabel,
                thresholdValue,
                a11yReviewRating,
                url,
                isUrgentLowStock,
                isUrgentLowStockLabel,
                productWheelType: value.productWheelType,
                isWheelOrTirePDP: isWheelOrTire,
                eachLabel,
                imageDataComponentName,
                returnPolicy,
                isAutomotiveProduct: isAutomotiveProductFlag,
                isScrollingRequired: true,
                isLazyRequire,
                productDataId: code,
                saleEndDaySoonMessage,
                isColourSwatchesActive,
                saleMessagesRules: saleMessageRules,
                saleEndDisableShift,
                a11yVariantSelected,
                a11yVariantUnSelected,
                accessibilityId: generateAccessibilityId(skus, skuId, code),
                plusMinusSymbol,
                boldBrand: enableBoldedBrandName,
                isOnSale,
                addToCartBtnClick,
                enableMiniPdpFlyoutSupport,
                enableATCForSingleSkuMiniPdp,
                showAtcBtnSpinner: showUpdatedATCSpinner(idx),
                addToCartLabel,
                sponsoredLabel,
                addProductItemToWishlist,
                isWishlistItemActive,
                isWishlistEligible,
                isWishlistToShow,
                showWishlistBtnSpinner: showUpdatedWishlistSpinner(idx),
                a11yWishlistIcon,
                quickLookLabel,
                addProductItemToCompare,
                isCompareProductChecked,
                compareProductsLabel,
                isWestPriceLazyLoadEnabled,
                isPriceRangeViewEnabled,
                showCompareCheckbox
              }
            ) : /* @__PURE__ */ jsx(
              VehicleProductCard,
              {
                className: classnames({
                  [`${roadRatingSkeletonClassName}-${roadRatingSkeletonProductIndexes.get(idx).height}`]: roadRatingSkeletonProductIndexes.has(idx)
                }),
                isPriceRangeViewEnabled,
                updateRoadRatingRef: updateRef(idx),
                product: value,
                productProps: {
                  ...productProps,
                  fulfillment,
                  sellable,
                  orderable
                },
                idx,
                productCardClick,
                redirectAfterProductCardClick,
                cardType: viewType,
                title,
                code,
                brand,
                rating,
                images,
                ratingsCount,
                showRatingSection: true,
                skus,
                currentPrice,
                language: language2,
                feeTitle: feeMessage == null ? void 0 : feeMessage.feeTitle,
                rebateIcon,
                rebate,
                tireCategory: categoryLevel,
                isFitmentRequired,
                setOfFourLabel,
                perTireLabel,
                vehicleFrontLabel,
                vehicleRearLabel,
                roadRatedLabel,
                vehicleFitType,
                eachLabel,
                roadRating,
                specification: specifications,
                badgePriorities: badgePriority,
                badges,
                originalPrice,
                displayWasLabel,
                discount,
                isAutoPartPlp,
                priceMessage,
                feeDisclaimerTitle: feeMessage == null ? void 0 : feeMessage.feeDisclaimerTitle,
                feeDisclaimerMessage: feeMessage == null ? void 0 : feeMessage.feeDisclaimerMessage,
                a11yStrikeOutPrice,
                a11yStrikeOutPriceRange,
                a11yCloseIconLabel,
                a11yTooltipIcon,
                fitmentTypeCode,
                vehicleList,
                options,
                partNumber,
                fitmentNotes,
                productWheelType,
                feeValue: feeMessage == null ? void 0 : feeMessage.value,
                nowFromLabel,
                saveFromLabel,
                wasFromLabel,
                fromLabel,
                promotionalPriceLabel,
                unitPriceLabel,
                clearancePriceLabel,
                feeDisclaimerType: feeMessage == null ? void 0 : feeMessage.type,
                scrollToFooter: scrollToFooter2,
                isSRPPage,
                vehicleInformationPresent,
                tireInformationPresent,
                isWheelOrTirePDP,
                partNumberLabel,
                inStockLabel,
                inStockOnlineLabel,
                outOfStockLabel,
                inStorePurchaseLabel,
                inStockAisleLabel,
                checkAvailabilityLabel,
                checkOtherStoresLabel,
                isUseLegacyLogicOfVehicleCheckAvailability,
                exclude,
                overridePriceHeight,
                a11yReviewRating,
                url,
                feeMessages,
                productCardSpecifications,
                isUrgentLowStock,
                isUrgentLowStockLabel,
                totalCurrentPrice: totalCurrentPrice2,
                imageDataComponentName,
                returnPolicy,
                attributePositionLabel,
                suggestedQuantityLabel,
                attributeUsageLabel,
                isScrollingRequired: true,
                isLazyRequire,
                productDataId: code,
                a11yClickToReadFootnote,
                showAvailabilityMessage: checkSkusAvailability(),
                accessibilityId: generateAccessibilityId(skus, skuId, code),
                plusMinusSymbol,
                boldBrand: enableBoldedBrandName,
                isTireDataExist,
                fitmentMessageOnProductLevel,
                fitmentIcon,
                fitmentMessageToggle,
                fitmentMessageToggleUniversal,
                isOnSale,
                fitMessageOnCard,
                partialFitMessageOnCard,
                confirmFitMessageUniversalOnCard,
                fitMessageUniversalOnCard,
                vehicleString,
                addToCartBtnClick,
                showAtcBtnSpinner: showUpdatedATCSpinner(idx),
                sponsoredLabel,
                addToCartLabel,
                addProductItemToWishlist,
                isWishlistItemActive,
                isWishlistEligible,
                isWishlistToShow,
                showWishlistBtnSpinner: showUpdatedWishlistSpinner(idx),
                a11yWishlistIcon,
                addProductItemToCompare,
                isCompareProductChecked,
                compareProductsLabel,
                showCompareCheckbox
              }
            )
          },
          code
        ) }, `product-content-${code}`);
      }
    }),
    isProductCardLoading && renderProductCardSkeleton(skeletonItems)
  ] }) });
};
GridView.propTypes = {
  path: PropTypes.string,
  productProps: PropTypes.any,
  ProductCardData: PropTypes.any,
  viewType: PropTypes.string,
  productCardClick: PropTypes.func,
  redirectAfterProductCardClick: PropTypes.func,
  badgePriority: PropTypes.any,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  plusCoreChargesLbl: PropTypes.string,
  inclCoreChargesLbl: PropTypes.string,
  coreChargesTooltipTitle: PropTypes.string,
  coreChargesTooltipParagraph: PropTypes.string,
  a11yTooltipIcon: PropTypes.string,
  language: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string,
  isProductCardLoading: PropTypes.bool,
  skeletonItems: PropTypes.number,
  rebateIcon: PropTypes.string,
  isFitmentRequired: PropTypes.bool,
  setOfFourLabel: PropTypes.string,
  perTireLabel: PropTypes.string,
  vehicleFrontLabel: PropTypes.string,
  vehicleRearLabel: PropTypes.string,
  roadRatedLabel: PropTypes.string,
  vehicleFitType: PropTypes.any,
  eachLabel: PropTypes.string,
  isAutoPartPlp: PropTypes.bool,
  vehicleList: PropTypes.array,
  productWheelType: PropTypes.string,
  nowFromLabel: PropTypes.string,
  saveFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  promotionalPriceLabel: PropTypes.string,
  unitPriceLabel: PropTypes.string,
  clearancePriceLabel: PropTypes.string,
  isSRPPage: PropTypes.bool,
  vehicleInformationPresent: PropTypes.bool,
  tireInformationPresent: PropTypes.bool,
  scrollToFooter: PropTypes.func,
  isWheelOrTirePDP: PropTypes.bool,
  isAutomotiveProduct: PropTypes.func,
  inStockLabel: PropTypes.string,
  inStockOnlineLabel: PropTypes.string,
  outOfStockLabel: PropTypes.string,
  inStorePurchaseLabel: PropTypes.string,
  inStockAisleLabel: PropTypes.string,
  checkAvailabilityLabel: PropTypes.string,
  checkOtherStoresLabel: PropTypes.string,
  isUseLegacyLogicOfVehicleCheckAvailability: PropTypes.bool,
  partNumberLabel: PropTypes.string,
  exclude: PropTypes.array,
  thresholdValue: PropTypes.number,
  overridePriceHeight: PropTypes.bool,
  a11yReviewRating: PropTypes.string,
  productCardSpecifications: PropTypes.string,
  isUrgentLowStockLabel: PropTypes.string,
  isWheelOrTireFunc: PropTypes.func,
  imageDataComponentName: PropTypes.string,
  returnPolicy: PropTypes.func,
  attributePositionLabel: PropTypes.string,
  suggestedQuantityLabel: PropTypes.string,
  attributeUsageLabel: PropTypes.string,
  isLazyRequire: PropTypes.bool,
  a11yClickToReadFootnote: PropTypes.string,
  pageType: PropTypes.string,
  addToCartBtnClick: PropTypes.func,
  showAtcBtnSpinner: PropTypes.bool,
  clickedATCCardIdx: PropTypes.number,
  addToCartLabel: PropTypes.string,
  sponsoredLabel: PropTypes.string
};
GridView.displayName = "GridView";
const ProductGridView = (props) => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row ${PREFIX}-container`, children: /* @__PURE__ */ jsx("div", { className: productGridWrapperClassName, children: /* @__PURE__ */ jsx(GridView, { ...props }) }) }) });
};
ProductGridView.propTypes = {
  path: PropTypes.string,
  productProps: PropTypes.any,
  ProductCardData: PropTypes.any,
  viewType: PropTypes.string,
  productCardClick: PropTypes.func,
  redirectAfterProductCardClick: PropTypes.func,
  badgePriority: PropTypes.any,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  plusCoreChargesLbl: PropTypes.string,
  inclCoreChargesLbl: PropTypes.string,
  coreCharge: PropTypes.any,
  coreChargeIncluded: PropTypes.bool,
  coreChargesTooltipTitle: PropTypes.string,
  coreChargesTooltipParagraph: PropTypes.string,
  a11yTooltipIcon: PropTypes.string,
  language: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string,
  isProductCardLoading: PropTypes.bool,
  skeletonItems: PropTypes.number,
  rebateIcon: PropTypes.string,
  isFitmentRequired: PropTypes.bool,
  setOfFourLabel: PropTypes.string,
  perTireLabel: PropTypes.string,
  vehicleFrontLabel: PropTypes.string,
  vehicleRearLabel: PropTypes.string,
  roadRatedLabel: PropTypes.string,
  vehicleFitType: PropTypes.any,
  eachLabel: PropTypes.string,
  isAutoPartPlp: PropTypes.bool,
  fitmentTypeCode: PropTypes.any,
  vehicleList: PropTypes.array,
  productWheelType: PropTypes.string,
  nowFromLabel: PropTypes.string,
  saveFromLabel: PropTypes.string,
  wasFromLabel: PropTypes.string,
  fromLabel: PropTypes.string,
  promotionalPriceLabel: PropTypes.string,
  unitPriceLabel: PropTypes.string,
  clearancePriceLabel: PropTypes.string,
  isSRPPage: PropTypes.bool,
  vehicleInformationPresent: PropTypes.bool,
  tireInformationPresent: PropTypes.bool,
  scrollToFooter: PropTypes.func,
  partNumberLabel: PropTypes.string,
  exclude: PropTypes.array,
  thresholdValue: PropTypes.number,
  overridePriceHeight: PropTypes.bool,
  a11yReviewRating: PropTypes.string,
  productCardSpecifications: PropTypes.string,
  isUrgentLowStockLabel: PropTypes.string,
  imageDataComponentName: PropTypes.string,
  returnPolicy: PropTypes.func,
  isLazyRequire: PropTypes.bool,
  saleEndDaySoonMessage: PropTypes.string,
  addToCartBtnClick: PropTypes.func,
  showAtcBtnSpinner: PropTypes.bool,
  clickedATCCardIdx: PropTypes.number,
  addToCartLabel: PropTypes.string
};
ProductGridView.displayName = "ProductGridView";
const ButtonToggle = ({ ...props }) => {
  const defaultView = props.defaultView;
  const [selectedListView, setSelectedListView] = useState(false);
  const handleClick = (event) => {
    const node = event.currentTarget;
    const toggle = node.dataset.toggle;
    setSelectedListView(toggle.toLowerCase() === DisplayViewType.list.toLowerCase());
    props.handleDispatchClick(toggle);
  };
  useEffect(() => {
    setSelectedListView((defaultView == null ? void 0 : defaultView.toLowerCase()) === DisplayViewType.list.toLowerCase());
  }, [defaultView]);
  return /* @__PURE__ */ jsx(Fragment, { children: props.productCardListView ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-buttontoggle`, children: selectedListView ? /* @__PURE__ */ jsxs(
    "button",
    {
      "data-toggle": "Grid",
      onClick: handleClick,
      name: "Grid",
      "aria-label": `${props.a11yViewTypeLabel} ${props.gridViewLabel}`,
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-grid", size: "lg", path: props.path }),
        props.gridViewLabel
      ]
    }
  ) : /* @__PURE__ */ jsxs(
    "button",
    {
      "data-toggle": "List",
      onClick: handleClick,
      name: "List",
      "aria-label": `${props.a11yViewTypeLabel} ${props.listViewLabel}`,
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-list-view", size: "lg", path: props.path }),
        props.listViewLabel
      ]
    }
  ) }) : null });
};
ButtonToggle.defaultProps = {
  isFitmentRequired: false
};
ButtonToggle.propTypes = {
  productCardListView: PropTypes.bool,
  handleDispatchClick: PropTypes.func,
  gridViewLabel: PropTypes.string,
  listViewLabel: PropTypes.string,
  a11ySelectedLabel: PropTypes.string,
  allyUnselectedLabel: PropTypes.string,
  path: PropTypes.string,
  isFitmentRequired: PropTypes.bool,
  defaultView: PropTypes.string
};
const timeOutValue = 6e3;
const secondaryNavigation = `${PREFIX}-secondary-navigation`;
const primaryNavigationAEMClassName = `${PREFIX}-primary-navigation`;
const checkoutSimpleHeaderAEMClassName = `${PREFIX}-simple-header-checkout`;
const headers = [
  "pencil-banner",
  primaryNavigationAEMClassName,
  secondaryNavigation,
  `${PREFIX}-information-banner`,
  checkoutSimpleHeaderAEMClassName
];
const headersOnScroll = [primaryNavigationAEMClassName, secondaryNavigation, checkoutSimpleHeaderAEMClassName];
const stickyHeadersOnScroll = [
  primaryNavigationAEMClassName,
  secondaryNavigation,
  checkoutSimpleHeaderAEMClassName
];
const calculateToastHeight = (headers2) => {
  let height = 0;
  headers2.forEach((el) => {
    const topElement = document.body.getElementsByClassName(el)[0];
    topElement && window.getComputedStyle(topElement, null).display !== "none" && (height = height + topElement.clientHeight);
  });
  return height;
};
const calculateNavigationHeight = (headersOnScroll2) => {
  let navigationHeight = 0;
  headersOnScroll2.forEach((element) => {
    const topElement = document.getElementsByClassName(element)[0];
    if (topElement && window.getComputedStyle(topElement, null).display !== "none") {
      navigationHeight = navigationHeight + topElement.getBoundingClientRect().height;
    }
  });
  return navigationHeight;
};
const calculatePrimaryNavigationTopValue = () => {
  const primaryNavigation = document.querySelector(`.${primaryNavigationAEMClassName}`) || document.querySelector(`.${checkoutSimpleHeaderAEMClassName}`);
  return primaryNavigation && primaryNavigation.getBoundingClientRect().top | 0;
};
const defaultToastTopPosition = () => {
  var _a;
  return (_a = document.querySelector(`.${PREFIX}-toast`)) == null ? void 0 : _a.getBoundingClientRect().top;
};
const ToastMount = ({ children, elementClassName }) => {
  const mount = !!elementClassName && document.getElementsByClassName(elementClassName)[0] || document.body;
  const el = document.createElement("div");
  el.id = "toastContainer";
  useEffect(() => {
    mount.appendChild(el);
    return () => {
      if (mount.contains(el)) {
        mount.removeChild(el);
      }
    };
  }, [el, mount]);
  return createPortal(children, el);
};
const Toast = (props) => {
  const {
    options,
    success,
    toastUndoFunction,
    toastCloseFunction,
    hideUndoLabel = false,
    resetPageVariables,
    hideCTA = false,
    toastMountClassName,
    modifierClass,
    failed = false,
    enableTimer = true,
    isCloseFunctionWorksOnlyByClick,
    toastTimeOutValue,
    information = false,
    toastUnMountFunction
  } = props;
  const [visibility, setVisibility] = useState(true);
  const [clearTime, setClearTime] = useState(false);
  const [stickyHeadersHeight] = useState(calculateNavigationHeight(stickyHeadersOnScroll));
  const [stickyPrimaryHeaderHeight] = useState(
    calculateNavigationHeight([primaryNavigationAEMClassName, checkoutSimpleHeaderAEMClassName])
  );
  const [headersHeight] = useState(calculateNavigationHeight(headersOnScroll));
  const [toastHeight, setToastHeight] = useState(calculateToastHeight(headers));
  const [primaryNavigationHeight] = useState(calculatePrimaryNavigationTopValue());
  const {
    toastCloseLabel,
    toastErrorIcon,
    toastErrorMessage,
    toastSuccessIcon,
    toastSuccessMessage,
    toastUndoLabel,
    toastWishListLabel,
    toastWishListLabelURL,
    toastATCLabel,
    toastATCLabelUrl,
    toastSaveForLaterLabel,
    toastSaveForLaterURL
  } = options;
  const toastSuccessOrFailure = success ? "success" : "error";
  const toastMessage = success ? toastSuccessMessage : toastErrorMessage;
  const toastIcon = success ? toastSuccessIcon : toastErrorIcon;
  const toastUndoCloseLabel = success ? toastUndoLabel : toastCloseLabel;
  const disableUndo = success ? hideUndoLabel : false;
  const toastTimers = toastTimeOutValue ? toastTimeOutValue : timeOutValue;
  const callToastCloseFunc = useCallback(() => {
    typeof toastCloseFunction === "function" && toastCloseFunction();
  }, [toastCloseFunction]);
  useEffect(() => {
    let timeOut;
    const visibilityFunction = () => {
      timeOut = setTimeout(() => {
        if (isCloseFunctionWorksOnlyByClick) {
          setVisibility(false);
        } else {
          callToastCloseFunc();
          setVisibility(false);
        }
      }, toastTimers);
    };
    setVisibility(true);
    enableTimer && visibilityFunction();
    return () => clearTimeout(timeOut);
  }, [callToastCloseFunc, enableTimer, isCloseFunctionWorksOnlyByClick, props, toastTimers]);
  const toastHeightHandler = (toastElement, topHeadersValue, toastTopValue) => {
    toastElement.style.top = `${topHeadersValue + toastTopValue}px`;
  };
  const checkSecondaryNavigation = (scrollHeadersHeight, defaultHeight) => {
    return Boolean(document.querySelector(`.${secondaryNavigation}__sticky`)) ? scrollHeadersHeight : defaultHeight;
  };
  const onScrollToastHeightHandler = useCallback(
    (toastElement, toastTopValue) => {
      const windowScrollValue = window.scrollY;
      if (windowScrollValue === 0) {
        toastHeightHandler(toastElement, toastHeight, toastTopValue);
      } else if (windowScrollValue > 0 && windowScrollValue <= primaryNavigationHeight) {
        toastElement.style.top = `${headersHeight + calculatePrimaryNavigationTopValue() + toastTopValue}px`;
      } else {
        const dynamicHeight = checkSecondaryNavigation(stickyHeadersHeight, stickyPrimaryHeaderHeight);
        toastElement.style.top = `${dynamicHeight + toastTopValue}px`;
      }
    },
    [headersHeight, primaryNavigationHeight, stickyHeadersHeight, stickyPrimaryHeaderHeight, toastHeight]
  );
  const onLoadToastHeight = useCallback(
    (toastElement, toastDefaultValue) => {
      if (toastElement && !toastMountClassName) {
        onScrollToastHeightHandler(toastElement, toastDefaultValue);
        window.addEventListener("scroll", () => onScrollToastHeightHandler(toastElement, toastDefaultValue));
      }
    },
    [onScrollToastHeightHandler, toastMountClassName]
  );
  useEffect(() => {
    const toastDefaultTopValue = defaultToastTopPosition();
    const toast = document.getElementsByClassName(`${PREFIX}-toast`)[0];
    const calculatedToastHeight = calculateToastHeight(headers);
    if (toastHeight !== calculatedToastHeight) {
      setToastHeight(calculatedToastHeight);
    }
    onLoadToastHeight(toast, toastDefaultTopValue);
    return () => !toastMountClassName && window.removeEventListener("scroll", () => onScrollToastHeightHandler(toast, toastDefaultTopValue));
  }, [props, visibility, toastHeight, onLoadToastHeight, toastMountClassName, onScrollToastHeightHandler]);
  useEffect(() => {
    if (!visibility && resetPageVariables) {
      resetPageVariables();
    }
  }, [resetPageVariables, visibility]);
  useEffect(() => {
    return () => toastUnMountFunction && toastUnMountFunction();
  }, [toastUnMountFunction]);
  const toastUndoFunc = () => {
    setVisibility(!visibility);
    setClearTime(!clearTime);
    toastUndoFunction && toastUndoFunction();
  };
  const toastCloseFunc = () => {
    callToastCloseFunc();
    setVisibility(false);
  };
  const toastUndoCloseComponent = () => {
    return !disableUndo && toastUndoCloseLabel && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-toast__action--right`, children: /* @__PURE__ */ jsx(
      "button",
      {
        "data-testid": "undo",
        "data-dismiss": "toast",
        className: `${PREFIX}-button ${PREFIX}-button--tertiary `,
        onClick: success ? () => toastUndoFunc() : () => toastCloseFunc(),
        children: toastUndoCloseLabel || ""
      }
    ) });
  };
  const toastRightContainer = () => {
    const toastLabel = toastSaveForLaterLabel || toastWishListLabel || toastATCLabel;
    return !hideCTA && (toastLabel || toastUndoCloseLabel) && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-toast__rightcontainer`, children: [
      toastLabel && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-toast__action--left`, children: /* @__PURE__ */ jsx(
        "a",
        {
          href: toastWishListLabelURL || toastSaveForLaterURL || toastATCLabelUrl,
          "data-link-value": toastLabel,
          children: toastLabel
        }
      ) }),
      toastUndoCloseComponent()
    ] });
  };
  const errorContainer = `${PREFIX}-toast__${toastSuccessOrFailure}-container`;
  const toastClassNameType = () => {
    if (failed) {
      return `${errorContainer}--error`;
    } else if (information) {
      return `${errorContainer}--info`;
    } else {
      return `${errorContainer}--warning`;
    }
  };
  const getModifierClass = () => {
    return !!modifierClass ? modifierClass : "";
  };
  return visibility && /* @__PURE__ */ jsx(ToastMount, { elementClassName: toastMountClassName, children: /* @__PURE__ */ jsx(
    "div",
    {
      "aria-live": "assertive",
      role: "alert",
      "aria-atomic": "true",
      "data-testid": "toast",
      className: `${PREFIX}-toast ${getModifierClass()}`,
      children: /* @__PURE__ */ jsxs("div", { className: `${errorContainer} ${toastClassNameType()}`, children: [
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-toast__leftcontainer`, children: [
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-toast__${toastSuccessOrFailure}-icon`, children: /* @__PURE__ */ jsx(Icon, { type: toastIcon, size: "lg" }) }),
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-toast__message`, children: toastMessage })
        ] }),
        toastRightContainer()
      ] })
    }
  ) });
};
Toast.defaultProps = {
  success: true,
  isCloseFunctionWorksOnlyByClick: false
};
Toast.propTypes = {
  success: PropTypes.bool,
  options: PropTypes.shape({
    toastSuccessMessage: PropTypes.string,
    toastErrorMessage: PropTypes.string,
    toastSuccessIcon: PropTypes.string,
    toastErrorIcon: PropTypes.string,
    toastWishListLabel: PropTypes.string,
    toastWishListLabelURL: PropTypes.string,
    toastSaveForLaterLabel: PropTypes.string,
    toastSaveForLaterURL: PropTypes.string,
    toastUndoLabel: PropTypes.string,
    toastCloseLabel: PropTypes.string
  }),
  toastUndoFunction: PropTypes.func,
  toastCloseFunction: PropTypes.func,
  hideUndoLabel: PropTypes.bool,
  resetPageVariables: PropTypes.func,
  toastMountClassName: PropTypes.string,
  hideCTA: PropTypes.bool,
  enableTimer: PropTypes.bool,
  failed: PropTypes.bool,
  isCloseFunctionWorksOnlyByClick: PropTypes.bool,
  toastTimeOutValue: PropTypes.number,
  toastUnMountFunction: PropTypes.func
};
const searchConstants = Object.freeze({
  // These "raw"  types are the suggestion.type property stored in the redux store
  SUGGESTION_RAW_KEYWORD_TYPE: "queryText",
  SUGGESTION_RAW_CATEGORY_TYPE: "category",
  SUGGESTION_RAW_HISTORY_TYPE: "history",
  // These types are used for GA "type" property
  SUGGESTION_TYPE_KEYWORD: "keyword",
  SUGGESTION_TYPE_CATEGORY: "category",
  SUGGESTION_TYPE_HISTORY: "history",
  // These types are used for GA user journey
  SUGGESTION_TYPE_UJ_KEYWORD: "selectedKeyword",
  SUGGESTION_TYPE_UJ_CATEGORY: "selectedCategory",
  SUGGESTION_TYPE_UJ_HISTORY: "selectedHistory",
  ANALYTICS_EVENT: "partial-search",
  BLOOMREACH: "bloomreach",
  USER_INPUTTED: "user search",
  SEARCH_SUGGESTION: "suggested search",
  TRUE: "true",
  INTERACT_CLICK: "click",
  INTERACT_ENTER: "enter",
  COMPLETE_SEARCH_EVENT_DATA: "search_analytics",
  COMPLETE_SEARCH_EVENT_EVENT: "complete-search",
  SUGGESTION_CACHE_DATA: "suggestion_cache_data",
  AUTO_UNIVERSAL_PRODUCTS_FILTER: "auto.isUniversalDisabled"
});
const Suggestions = (props) => {
  const {
    handleMobileFillTypeahead,
    a11yUpdateQueryIconLabel,
    headerLabel,
    suggestedList,
    currentSuggestionIndex,
    handleMouseover,
    handleSuggestionClick,
    handleSuggestionEnter,
    originalSearchValue,
    clearHistory,
    searchHistoryClearLabel,
    indexMargin,
    type,
    showTypeahead,
    a11yArrowButtonsAriaLabel,
    setShowSuggestionPanel,
    currentSuggestionRef,
    isPromoSearch
  } = props;
  const highlightKeyword = useCallback(
    (label) => {
      if (originalSearchValue && label) {
        const regexp = new RegExp(
          originalSearchValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").trim().replace("\\*", ""),
          "ig"
        );
        label = label.replace(regexp, "<br>$&<br>");
        const [firstPart, matchingPart, secondPart] = label.split("<br>");
        label = /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-suggestion-text__highlighted`, children: firstPart }),
          matchingPart,
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-suggestion-text__highlighted`, children: secondPart })
        ] });
      }
      return /* @__PURE__ */ jsx("span", { className: `${PREFIX}-suggestion-text`, children: label });
    },
    [originalSearchValue]
  );
  const closeSuggessionPanel = (event) => {
    var _a;
    if (event.key === stringKeyCodes.esc || event.key === stringKeyCodes.tab && ((_a = document.activeElement) == null ? void 0 : _a.id) === `'trigger-typeahead-icon'_${suggestedList.length}` && !document.getElementById("clear-history-icon")) {
      setShowSuggestionPanel(false);
    }
  };
  const currentIndexComparison = (index2) => {
    return index2 + indexMargin === currentSuggestionIndex;
  };
  const renderTypeaheadButton = (label, index2) => /* @__PURE__ */ jsx(
    Button,
    {
      type: "icon_button",
      onClick: () => handleMobileFillTypeahead(label),
      id: `'trigger-typeahead-icon'_${index2 + magicNumber.ONE}`,
      ariaLabel: `${a11yUpdateQueryIconLabel || ""} ${label.concat(" ", a11yArrowButtonsAriaLabel)}`,
      buttonType: "button",
      onKeyDown: closeSuggessionPanel,
      children: /* @__PURE__ */ jsx(Icon, { type: "ct-arrow-typeahead" })
    }
  );
  return isArrayNotEmpty(suggestedList) && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-suggested-${type}-panel`, children: [
    !isPromoSearch && /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${PREFIX}-suggestion-grid-title${showTypeahead ? "" : ` ${PREFIX}-suggestion-grid-title__big-margin`}`,
        children: [
          headerLabel,
          searchHistoryClearLabel && clearHistory && /* @__PURE__ */ jsx(
            Button,
            {
              id: "clear-history-icon",
              type: "tertiary",
              onClick: clearHistory,
              "data-props": { style: "float: right" },
              onKeyDown: (event) => {
                if (event.key === stringKeyCodes.tab) {
                  setShowSuggestionPanel(false);
                }
              },
              children: searchHistoryClearLabel
            }
          )
        ]
      }
    ),
    suggestedList.map((keyword, i) => {
      const keywordData = { ...keyword, type, index: i + indexMargin };
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: { marginBottom: showTypeahead ? "0" : "1rem" },
          className: `${PREFIX}-suggestion-wrapper`,
          children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                role: "button",
                tabIndex: magicNumber.MINUS_ONE,
                className: `${PREFIX}-suggestion ${PREFIX}-suggested-${type}${i + indexMargin === currentSuggestionIndex ? " selected" : ""}`,
                "data-testid": `${type}_${i + indexMargin}`,
                onMouseEnter: () => handleMouseover(keywordData),
                onClick: () => handleSuggestionClick(keywordData),
                onKeyDown: (e) => handleSuggestionEnter(e),
                ref: currentIndexComparison(i) ? currentSuggestionRef : null,
                children: highlightKeyword(keyword.label)
              }
            ),
            showTypeahead && renderTypeaheadButton(keyword.label, i)
          ]
        },
        `${type}_${i}`
      );
    })
  ] });
};
Suggestions.propTypes = {
  handleMobileFillTypeahead: PropTypes.func.isRequired,
  a11yUpdateQueryIconLabel: PropTypes.string,
  headerLabel: PropTypes.string.isRequired,
  suggestedList: PropTypes.arrayOf(
    PropTypes.exact({
      isRedirect: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
      searchUrl: PropTypes.string.isRequired,
      type: PropTypes.string,
      index: PropTypes.number
    })
  ).isRequired,
  currentSuggestionIndex: PropTypes.number.isRequired,
  handleMouseover: PropTypes.func.isRequired,
  handleSuggestionClick: PropTypes.func.isRequired,
  handleSuggestionEnter: PropTypes.func.isRequired,
  originalSearchValue: PropTypes.string,
  clearHistory: PropTypes.func,
  searchHistoryClearLabel: PropTypes.string,
  indexMargin: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  showTypeahead: PropTypes.bool.isRequired,
  setShowSuggestionPanel: PropTypes.func
};
const getSuggestionGAType = (rawType) => {
  switch (rawType) {
    case searchConstants.SUGGESTION_RAW_KEYWORD_TYPE:
      return searchConstants.SUGGESTION_TYPE_KEYWORD;
    case searchConstants.SUGGESTION_RAW_CATEGORY_TYPE:
      return searchConstants.SUGGESTION_TYPE_CATEGORY;
    case searchConstants.SUGGESTION_RAW_HISTORY_TYPE:
      return searchConstants.SUGGESTION_TYPE_HISTORY;
    default:
      return searchConstants.SUGGESTION_TYPE_KEYWORD;
  }
};
const ButtonGroup = React.forwardRef(({ ...props }, ref) => {
  const {
    children,
    direction = Direction.HORIZONTAL,
    customClass,
    isWrap = true,
    a11y,
    isReverse = false,
    gap = Display.NONE,
    position = Position.TOP
  } = props;
  const customClassName = customClass ? ` ${customClass}` : "";
  const isVertical = Boolean(direction === Direction.VERTICAL);
  const componentClass = `${PREFIX}-button-group`;
  const buttonDirection = ` ${PREFIX}-xs${isVertical ? "-column" : "-row"}${isReverse ? "-reverse" : ""}`;
  const buttonWrap = ` ${PREFIX}-xs-flex-${isWrap ? "wrap" : "nowrap"}`;
  const buttonGap = gap !== Display.NONE ? ` ${componentClass}--gap-${gap}` : "";
  const a11yLabelledBy = (a11y == null ? void 0 : a11y.labelledBy) ? { ["aria-labelledby"]: a11y == null ? void 0 : a11y.labelledBy } : {};
  const buttonAlignment = () => {
    const commonAlignmentClass = ` ${PREFIX}-xs-align-items`;
    if (!isVertical) {
      switch (position) {
        case Position.BOTTOM:
          return `${commonAlignmentClass}-end`;
        case Position.CENTER:
          return `${commonAlignmentClass}-center`;
        case Display.NONE:
          return `${commonAlignmentClass}-unset`;
        default:
          return `${commonAlignmentClass}-start`;
      }
    } else {
      return position === Display.NONE ? "" : `${commonAlignmentClass}-start`;
    }
  };
  const commonClass = `${componentClass} ${PREFIX}-xs-flex${buttonAlignment()}`;
  return /* @__PURE__ */ jsx(
    "section",
    {
      ref,
      role: (a11y == null ? void 0 : a11y.role) ? a11y == null ? void 0 : a11y.role : Role.GROUP,
      className: `${commonClass}${customClassName}${buttonDirection}${buttonWrap}${buttonGap}`,
      "aria-label": (a11y == null ? void 0 : a11y.label) ? a11y == null ? void 0 : a11y.label : `${direction}-group`,
      ...a11yLabelledBy,
      children
    }
  );
});
ButtonGroup.displayName = "ButtonGroup";
const getSearchingString = (isPromoSearch) => {
  const urlParams = new URLSearchParams(window.location.search.replace(/;/g, "&"));
  const queryString = isPromoSearch ? urlParams.get("qfilter") : urlParams.get("q");
  return !queryString || queryString === "undefined" ? "" : queryString;
};
const SearchBar = (props) => {
  const searchBarEl = useRef(null);
  const modalRef = useRef(null);
  const ariaLiveRef = useRef(null);
  const {
    path,
    searchIconSize,
    a11ySearchIconLabel,
    allyCloseIconLabel,
    a11yUpdateQueryIconLabel,
    id,
    suggestionPannel,
    searchBoxPlaceholder,
    searchLabel,
    categoriesLabel,
    didYouMeanLabel,
    searchHistoryTitle,
    isCodeLookup,
    suggestedBrandList,
    suggestedKeywordList,
    suggestedCategoryList,
    getSearchHistoryList,
    addSearchHistory,
    clearSearchHistoryList,
    searchHistoryClearLabel,
    showModal,
    searchCallBack,
    searchPagePath,
    pushAnalyticsData,
    closeModal,
    delay,
    pushQueue,
    minChars,
    topHit,
    showCloseButton,
    a11yArrowButtonsAriaLabel,
    a11ySuggestionsAvailableLabel,
    searchInputVal,
    setSearchInputVal,
    setInputAtPageLoad,
    isPromoSearch,
    isOfferSearch,
    clearUrl,
    setIsSearchInputClearClicked,
    topBrandsLabel,
    sponsoredLabel
  } = props;
  const searchingString = getSearchingString(isPromoSearch);
  const MIN_REQUIRED_CHARACTERS = minChars;
  const MINUS_ONE = magicNumber.MINUS_ONE;
  const ONE = magicNumber.ONE;
  const [originalSearchValue, setOriginalSearchValue] = useState("");
  const [showSuggestionPanel, setShowSuggestionPanel] = useState(false);
  const [showClearButton, setShowClearButton] = useState(false);
  const [currentSuggestionIndex, setCurrentSuggestionIndex] = useState(MINUS_ONE);
  const [keyboardNavigationMode, setKeyboardNavigationMode] = useState(false);
  const [searchHistoryList, setSearchHistoryList] = useState([]);
  const [debounceTimeOut, setDebounceTimeOut] = useState(null);
  const [notFilterHistory, setNotFilterHistory] = useState(true);
  const [filteredHistoryList, setFilteredHistoryList] = useState([]);
  const [searchSuggHeight, setSearchSuggHeight] = useState(0);
  const [isPromoSearchIconClicked, setIsPromoSearchIconClicked] = useState(false);
  const isTypeaheadUsed = useRef(false);
  const setSearchHistoryRunOnce = useRef(0);
  const RunTriggerSuggestForMobileOnce = useRef(0);
  const pageType = getPageType();
  const currentSuggestionRef = useRef(null);
  const enableSearchPageParameter = useCallback(
    () => pageType === pageTypes$1.brandCategoryPage || // Added this logic because after a successful search, when the page was reloaded,
    // the clear button in the search input was not being shown.
    !isPromoSearch && pageType === pageTypes$1.promoListing || pageType === pageTypes$1.eventListing,
    [pageType]
  );
  const onCloseTassModal = useCallback(() => {
    setShowSuggestionPanel(false);
  }, []);
  const resetPanel = useCallback(() => {
    setCurrentSuggestionIndex(MINUS_ONE);
    setKeyboardNavigationMode(false);
  }, [MINUS_ONE]);
  const triggerSuggest = useCallback(() => {
    var _a;
    const searchTerm = (_a = searchBarEl == null ? void 0 : searchBarEl.current) == null ? void 0 : _a.value.trim();
    if (searchTerm && searchTerm.length >= MIN_REQUIRED_CHARACTERS) {
      resetPanel();
      pushQueue(searchTerm);
      setOriginalSearchValue(searchTerm);
    }
    setShowSuggestionPanel(true);
    setCurrentSuggestionIndex(MINUS_ONE);
    isPromoSearch && setIsPromoSearchIconClicked(false);
  }, [MINUS_ONE, MIN_REQUIRED_CHARACTERS, pushQueue, resetPanel]);
  const throttledTriggerSuggest = useMemo(() => {
    var _a;
    const searchTerm = (_a = searchBarEl == null ? void 0 : searchBarEl.current) == null ? void 0 : _a.value;
    if (searchTerm && searchTerm.length >= MIN_REQUIRED_CHARACTERS) {
      setOriginalSearchValue(searchTerm);
    }
    return customDebounce(triggerSuggest, delay, debounceTimeOut, setDebounceTimeOut);
  }, [debounceTimeOut, triggerSuggest, MIN_REQUIRED_CHARACTERS, delay]);
  useEffect(() => {
    if (searchInputVal && !notFilterHistory && !isOfferSearch) {
      setFilteredHistoryList(
        searchHistoryList.filter((it) => {
          var _a;
          return (_a = it == null ? void 0 : it.label) == null ? void 0 : _a.toLowerCase().includes(searchInputVal.toLowerCase());
        })
      );
    } else {
      !isOfferSearch && setFilteredHistoryList(searchHistoryList);
    }
  }, [searchHistoryList, searchInputVal, notFilterHistory, isOfferSearch]);
  const distOnScroll = document.querySelector(`.${PREFIX}-primary-navigation-bar__search-bar`);
  const scrollEvent = useCallback(() => {
    setSearchSuggHeight(distOnScroll == null ? void 0 : distOnScroll.getBoundingClientRect().top);
  }, [distOnScroll]);
  useEffect(() => {
    if (!getIsMobile()) {
      window == null ? void 0 : window.addEventListener(
        "scroll",
        () => {
          scrollEvent();
        },
        { passive: true }
      );
      if (searchSuggHeight <= magicNumber.MINUS_ONEHUNDREDFIFTY) {
        setShowSuggestionPanel(false);
      }
    }
  }, [scrollEvent, searchSuggHeight]);
  useEffect(() => {
    if (searchingString && searchingString !== "*" && !enableSearchPageParameter()) {
      setOriginalSearchValue(searchingString);
      setShowClearButton(true);
      isPromoSearch && setIsPromoSearchIconClicked(true);
    } else {
      isPromoSearch && setShowClearButton(false);
      setIsSearchInputClearClicked && getIsMobile() && setIsSearchInputClearClicked(false);
    }
  }, [searchingString, enableSearchPageParameter, isPromoSearch, setIsSearchInputClearClicked]);
  useEffect(() => {
    if (showCloseButton && showModal && RunTriggerSuggestForMobileOnce.current === magicNumber.ZERO) {
      setOriginalSearchValue(searchBarEl.current.value);
      throttledTriggerSuggest();
      searchBarEl.current.focus();
      RunTriggerSuggestForMobileOnce.current++;
    }
  }, [showModal, throttledTriggerSuggest, showCloseButton]);
  const focusAndOpenKeyboard = useCallback(
    (inputElement) => {
      if (inputElement && showModal) {
        const __tempEl__ = document.createElement("input");
        __tempEl__.style.position = "absolute";
        __tempEl__.style.top = `${String(inputElement.offsetTop + 7)}px`;
        __tempEl__.style.left = `${String(inputElement.offsetLeft)}px`;
        __tempEl__.style.height = "0";
        __tempEl__.style.opacity = "0";
        document.body.appendChild(__tempEl__);
        __tempEl__.focus();
        setTimeout(function() {
          inputElement.focus();
          document.body.removeChild(__tempEl__);
        }, 100);
      }
    },
    [showModal]
  );
  const callbackRef = useCallback(
    (inputElement) => {
      searchBarEl.current = inputElement;
      getIsMobile() && focusAndOpenKeyboard(inputElement);
    },
    [focusAndOpenKeyboard]
  );
  const setIsTypeaheadUsed = useCallback((val) => {
    isTypeaheadUsed.current = val;
  }, []);
  const clearInput = useCallback(() => {
    setIsTypeaheadUsed(false);
    setSearchInputVal("");
    searchBarEl.current.value = "";
    setOriginalSearchValue("");
    setShowClearButton(false);
    throttledTriggerSuggest();
    searchBarEl.current.focus();
    setIsSearchInputClearClicked && getIsMobile() && !showSuggestionPanel && setIsSearchInputClearClicked(true);
    if (isPromoSearchIconClicked && isPromoSearch) {
      searchCallBack(clearUrl, isPromoSearchIconClicked);
      setIsPromoSearchIconClicked(false);
    }
  }, [
    setIsTypeaheadUsed,
    setSearchInputVal,
    throttledTriggerSuggest,
    setIsSearchInputClearClicked,
    showSuggestionPanel,
    isPromoSearchIconClicked,
    isPromoSearch,
    searchCallBack,
    clearUrl
  ]);
  useEffect(() => {
    if (setSearchHistoryRunOnce.current === 0 && !isOfferSearch) {
      setSearchHistoryList(getSearchHistoryList());
      setSearchHistoryRunOnce.current++;
    }
  }, [getSearchHistoryList]);
  const suggestionsLength = useMemo(() => {
    return (suggestedKeywordList == null ? void 0 : suggestedKeywordList.length) + (suggestedCategoryList == null ? void 0 : suggestedCategoryList.length) + filteredHistoryList.length;
  }, [suggestedKeywordList, suggestedCategoryList, filteredHistoryList]);
  useEffect(() => {
    if (showSuggestionPanel && !isOfferSearch) {
      setTimeout(() => {
        if (ariaLiveRef.current) {
          ariaLiveRef.current.innerHTML = searchInputVal === "" ? replaceStrWithDynamicVal(
            `${a11ySuggestionsAvailableLabel ?? ""}.`,
            String(suggestionsLength)
          ) : replaceStrWithDynamicVal(a11ySuggestionsAvailableLabel, String(suggestionsLength));
        }
      }, magicNumber.ONEHUNDREDFIFTY);
    }
  }, [a11ySuggestionsAvailableLabel, showSuggestionPanel, suggestionsLength, searchInputVal, isOfferSearch]);
  const handleChange = useCallback(
    (event) => {
      const inputValue = event.target.value;
      setShowClearButton(inputValue && inputValue.length > 0);
      setSearchInputVal(inputValue);
      setInputAtPageLoad && setInputAtPageLoad(false);
      notFilterHistory && setNotFilterHistory(false);
      if (!inputValue) {
        setOriginalSearchValue("");
        setIsTypeaheadUsed(false);
      }
      if (!delay) {
        triggerSuggest();
      } else {
        throttledTriggerSuggest();
      }
    },
    [
      setSearchInputVal,
      setInputAtPageLoad,
      notFilterHistory,
      delay,
      setIsTypeaheadUsed,
      triggerSuggest,
      throttledTriggerSuggest
    ]
  );
  const suggestionList = document.getElementById("suggestion-panel");
  const searchBarEle = document.getElementById("mobile-search-bar");
  const searchBarMobileView = useCallback(() => {
    if (getIsMobile() && searchBarEle) {
      return Number((searchBarEle == null ? void 0 : searchBarEle.clientHeight) || magicNumber.ZERO);
    }
    return magicNumber.ZERO;
  }, [searchBarEle]);
  useEffect(() => {
    var _a, _b;
    const headersHeight = Number(
      ((_a = document.getElementsByClassName(`${PREFIX}-primary-navigation`)[magicNumber.ZERO]) == null ? void 0 : _a.clientHeight) || magicNumber.ZERO
    );
    const allInfoBanner = document.querySelectorAll(`.${PREFIX}-information-banner`);
    let infoBannerTotalHeight = magicNumber.ZERO;
    allInfoBanner == null ? void 0 : allInfoBanner.forEach((item) => {
      infoBannerTotalHeight = infoBannerTotalHeight + item.clientHeight;
      return infoBannerTotalHeight || magicNumber.ZERO;
    });
    const pencilBannerHeight = Number(
      ((_b = document.getElementsByClassName("pencilBanner")[magicNumber.ZERO]) == null ? void 0 : _b.clientHeight) || magicNumber.ZERO
    );
    if (suggestionList) {
      if (getIsMobile()) {
        suggestionList.style.maxHeight = `calc(${magicNumber.HUNDRED}vh - ${searchBarMobileView()}px)`;
      } else {
        suggestionList.style.maxHeight = `calc(${magicNumber.HUNDRED}vh - ${headersHeight + infoBannerTotalHeight + pencilBannerHeight}px)`;
      }
    }
  }, [suggestionList, searchBarMobileView]);
  const handleSuggestionKeyboardNavigation = (index2) => {
    const highlightedSuggestion = getSelectedSuggestion(index2);
    setIsTypeaheadUsed(false);
    setSearchInputVal((highlightedSuggestion == null ? void 0 : highlightedSuggestion.label) || originalSearchValue);
    !showClearButton && setShowClearButton(true);
    setNotFilterHistory(true);
  };
  const handleScrollWithKeyboard = () => {
    setTimeout(() => {
      var _a;
      (_a = currentSuggestionRef == null ? void 0 : currentSuggestionRef.current) == null ? void 0 : _a.scrollIntoView({
        behavior: "smooth",
        block: "end"
      });
    }, magicNumber.HUNDRED);
  };
  const handleArrowDown = () => {
    if (keyboardNavigationMode) {
      setIsTypeaheadUsed(false);
      const newIndex = (currentSuggestionIndex + ONE) % (suggestedKeywordList.length + suggestedCategoryList.length + searchHistoryList.length);
      setCurrentSuggestionIndex(newIndex);
      handleSuggestionKeyboardNavigation(newIndex);
      handleScrollWithKeyboard();
    } else {
      setKeyboardNavigationMode(true);
      setIsTypeaheadUsed(false);
      if (!isArrayEmpty(suggestedKeywordList) || !isArrayEmpty(suggestedCategoryList) || !isArrayEmpty(searchHistoryList)) {
        const newIndex = (currentSuggestionIndex + ONE) % (suggestedKeywordList.length + suggestedCategoryList.length + searchHistoryList.length);
        setCurrentSuggestionIndex(newIndex);
        handleSuggestionKeyboardNavigation(newIndex);
      }
    }
  };
  const handleArrowUp = () => {
    if (!keyboardNavigationMode) {
      setKeyboardNavigationMode(true);
    }
    setIsTypeaheadUsed(false);
    const newIndex = (currentSuggestionIndex - ONE) % (suggestedKeywordList.length + suggestedCategoryList.length + searchHistoryList.length) < 0 ? suggestedKeywordList.length + suggestedCategoryList.length + searchHistoryList.length - ONE : (currentSuggestionIndex - ONE) % (suggestedKeywordList.length + suggestedCategoryList.length + searchHistoryList.length);
    setCurrentSuggestionIndex(newIndex);
    handleSuggestionKeyboardNavigation(newIndex);
    handleScrollWithKeyboard();
  };
  const getSelectedSuggestion = useCallback(
    (index2) => {
      const useIndex = index2 || index2 === 0 ? index2 : currentSuggestionIndex;
      if (useIndex === MINUS_ONE) {
        return null;
      } else if (useIndex < suggestedKeywordList.length) {
        return suggestedKeywordList[useIndex];
      } else if (useIndex < suggestedKeywordList.length + suggestedCategoryList.length) {
        return suggestedCategoryList[useIndex - suggestedKeywordList.length];
      } else {
        return searchHistoryList[useIndex - suggestedKeywordList.length - suggestedCategoryList.length];
      }
    },
    [currentSuggestionIndex, suggestedKeywordList, suggestedCategoryList, searchHistoryList, MINUS_ONE]
  );
  const recordAnalytics = useCallback(
    // eslint-disable-next-line complexity, sonar/cyclomatic-complexity
    (enterPressed, searchType, selectedSuggestionIndex) => {
      var _a;
      const selectedSuggestion = getSelectedSuggestion(selectedSuggestionIndex);
      if (keyboardNavigationMode && selectedSuggestion) {
        searchType = searchConstants.SEARCH_SUGGESTION;
      }
      const compareLabelWithSearchValue = (label) => {
        let labelValue = label;
        try {
          labelValue = decodeURI(label);
        } catch (error) {
          console.error(error);
        }
        return originalSearchValue.trim() === labelValue.trim();
      };
      const isFastSubmit = originalSearchValue ? !((_a = topHit == null ? void 0 : topHit.some) == null ? void 0 : _a.call(topHit, (it) => compareLabelWithSearchValue(it.label))) : false;
      const suggestionType = selectedSuggestion && (!isFastSubmit || !originalSearchValue) ? getSuggestionGAType(selectedSuggestion.type) : "";
      if (!keyboardNavigationMode && !originalSearchValue && !searchInputVal && !selectedSuggestion) {
        return;
      }
      pushAnalyticsData && pushAnalyticsData(
        originalSearchValue.trim(),
        searchType,
        suggestionType,
        isFastSubmit && originalSearchValue ? null : selectedSuggestion,
        void 0,
        void 0,
        enterPressed ? searchConstants.INTERACT_ENTER : searchConstants.INTERACT_CLICK,
        isTypeaheadUsed.current
      );
    },
    [getSelectedSuggestion, keyboardNavigationMode, originalSearchValue, pushAnalyticsData, searchInputVal, topHit]
  );
  const triggerSearch = (enterPressed, searchType) => {
    const searchTerm = isPromoSearch ? searchInputVal.trim() : searchBarEl.current.value.trim();
    addToHistory(searchTerm);
    recordAnalytics(enterPressed, searchType);
    setShowSuggestionPanel(false);
    if (keyboardNavigationMode) {
      const selectedSuggestion = getSelectedSuggestion();
      if (selectedSuggestion && (selectedSuggestion == null ? void 0 : selectedSuggestion.type) === searchConstants.SUGGESTION_TYPE_CATEGORY) {
        navigateToUrl(`${searchPagePath}${selectedSuggestion.searchUrl}`);
        return;
      }
    }
    if (searchTerm) {
      searchCallBack(searchTerm);
      isPromoSearch && setIsPromoSearchIconClicked(true);
    }
    closeModal && closeModal();
  };
  const keyboardEnterKeyPressed = () => {
    triggerSearch(true, searchConstants.USER_INPUTTED);
    setShowSuggestionPanel(false);
  };
  const handleKeyDown = (event) => {
    switch (event.key) {
      case stringKeyCodes.enter:
        keyboardEnterKeyPressed();
        break;
      case stringKeyCodes.downArrow:
        handleArrowDown();
        break;
      case stringKeyCodes.upArrow:
        handleArrowUp();
        break;
      case stringKeyCodes.esc:
        setShowSuggestionPanel(false);
        break;
      case stringKeyCodes.tab:
        setShowSuggestionPanel(false);
        if (event.shiftKey) {
          setShowSuggestionPanel(false);
        }
        break;
    }
  };
  const addToHistory = useCallback(
    (searchTerm, data) => {
      const historyList = addSearchHistory(searchTerm.trim().toLowerCase(), data);
      setSearchHistoryList(historyList);
    },
    [addSearchHistory, setSearchHistoryList]
  );
  const clearHistory = useCallback(() => {
    clearSearchHistoryList();
    setSearchHistoryList([]);
  }, [clearSearchHistoryList, setSearchHistoryList]);
  const navigateToUrl = useCallback((url) => {
    var _a;
    const windowOrigin = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.origin;
    window.location.href = windowOrigin + url;
  }, []);
  const handleSuggestionClick = useCallback(
    (suggestion) => {
      setCurrentSuggestionIndex(suggestion.index);
      addToHistory(suggestion.label, suggestion);
      recordAnalytics(false, searchConstants.SEARCH_SUGGESTION, suggestion.index);
      setShowSuggestionPanel(false);
      searchCallBack(suggestion.label);
      closeModal && closeModal();
    },
    [recordAnalytics, addToHistory, searchCallBack]
  );
  const handleCategoryClick = useCallback(
    (category) => {
      setCurrentSuggestionIndex(category.index);
      addToHistory(category.label, category);
      recordAnalytics(false, searchConstants.SEARCH_SUGGESTION, category.index);
      setShowSuggestionPanel(false);
      navigateToUrl(`${searchPagePath}${category.searchUrl}`);
    },
    [addToHistory, recordAnalytics, navigateToUrl, searchPagePath]
  );
  const handleSuggestionEnter = useCallback(
    (event) => {
      event.preventDefault();
      setShowSuggestionPanel(false);
    },
    [setShowSuggestionPanel]
  );
  const handleHistoryClick = useCallback(
    (history) => {
      setCurrentSuggestionIndex(history.index);
      recordAnalytics(false, searchConstants.SEARCH_SUGGESTION, history.index);
      searchCallBack(history.label);
      setShowSuggestionPanel(false);
    },
    [recordAnalytics, searchCallBack, setShowSuggestionPanel]
  );
  const handleHistoryEnter = useCallback(
    (event) => {
      event.preventDefault();
      setShowSuggestionPanel(false);
    },
    [setShowSuggestionPanel]
  );
  const showCloseIcon = useCallback(() => showSuggestionPanel || showModal, [showSuggestionPanel, showModal]);
  const handleMobileFillTypeahead = useCallback(
    (value) => {
      setIsTypeaheadUsed(true);
      setOriginalSearchValue(value);
      setSearchInputVal(value);
      setShowClearButton(true);
      searchBarEl.current.focus();
      if (!delay) {
        triggerSuggest();
      } else {
        throttledTriggerSuggest();
      }
    },
    [setIsTypeaheadUsed, setSearchInputVal, delay, triggerSuggest, throttledTriggerSuggest]
  );
  const renderSuggestions = (list, header, indexMargin, type, showTypeahead = false, onClick2, onKeyDown, clrHistory, historyClearLabel) => /* @__PURE__ */ jsx(
    Suggestions,
    {
      handleMobileFillTypeahead,
      headerLabel: header,
      suggestedList: list,
      currentSuggestionIndex,
      indexMargin,
      handleMouseover: () => {
        setIsTypeaheadUsed(false);
      },
      handleSuggestionClick: onClick2 || handleSuggestionClick,
      handleSuggestionEnter: onKeyDown || handleSuggestionEnter,
      a11yUpdateQueryIconLabel,
      originalSearchValue: searchInputVal,
      clearHistory: clrHistory,
      searchHistoryClearLabel: historyClearLabel,
      type,
      showTypeahead,
      setShowSuggestionPanel,
      a11yArrowButtonsAriaLabel,
      currentSuggestionRef,
      isPromoSearch
    }
  );
  const renderBrandShop = () => {
    return isArrayNotEmpty(suggestedBrandList) && originalSearchValue && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-suggested-brand-panel`, children: [
      suggestedBrandList.length > 1 && renderSuggestionBrandHeader(),
      /* @__PURE__ */ jsx(ButtonGroup, { gap: Size.SMALL, customClass: `${PREFIX}-suggestion-brand-buttons`, children: suggestedBrandList.map((brand) => {
        const { image, url, name } = brand;
        const brandImage = {
          url: image,
          alt: name,
          a11y: {
            hidden: true
          }
        };
        const brandLink = {
          url,
          title: name
        };
        return /* @__PURE__ */ jsx(ComplexCTA, { image: brandImage, link: brandLink, children: name }, name);
      }) })
    ] });
  };
  const renderSuggestionBrandHeader = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-suggestion-brand-header`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-suggestion-brand-title ${PREFIX}-suggestion-brand-title--no-margin`, children: replaceStrWithDynamicVal(topBrandsLabel, originalSearchValue) }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-suggestion-brand__sponsored`, children: sponsoredLabel })
    ] });
  };
  const renderTassInner = () => {
    const keyword = renderSuggestions(
      suggestedKeywordList,
      didYouMeanLabel,
      0,
      searchConstants.SUGGESTION_TYPE_KEYWORD,
      true
    );
    const category = renderSuggestions(
      suggestedCategoryList,
      categoriesLabel,
      suggestedKeywordList.length,
      searchConstants.SUGGESTION_TYPE_CATEGORY,
      false,
      handleCategoryClick
    );
    const history = renderSuggestions(
      filteredHistoryList,
      searchHistoryTitle,
      suggestedKeywordList.length + suggestedCategoryList.length,
      searchConstants.SUGGESTION_TYPE_HISTORY,
      false,
      handleHistoryClick,
      handleHistoryEnter,
      clearHistory,
      searchHistoryClearLabel
    );
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-suggestion-panel`, children: [
      !isPromoSearch && renderBrandShop(),
      keyword,
      !isPromoSearch && category,
      !isPromoSearch && history
    ] });
  };
  const useOnClickOutside2 = (ref, handler) => {
    useEffect(() => {
      const listener = (event) => {
        var _a;
        if (!(ref == null ? void 0 : ref.current) || ((_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.contains(event.target))) {
          return;
        }
        if (event.target.innerText !== searchHistoryClearLabel && !showModal) {
          handler(event);
        }
        if (suggestionPannel) {
          setShowSuggestionPanel(false);
        }
      };
      document.addEventListener("mousedown", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
      };
    }, [ref, handler]);
  };
  const clearButton = () => {
    if (areAllParamsValid(!isOfferSearch, showClearButton, showModal || (isPromoSearch ? true : !getIsMobile()))) {
      return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-search__button`, children: /* @__PURE__ */ jsx(Button, { type: "tertiary", onClick: clearInput, "data-testid": "clear-btn", children: searchHistoryClearLabel }) });
    }
    return null;
  };
  useOnClickOutside2(modalRef, () => {
    setShowSuggestionPanel(false);
  });
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      var _a, _b, _c, _d, _e, _f;
      const searchInput = (_a = document == null ? void 0 : document.querySelector(".nl-primary-navigation-bar__search-bar")) == null ? void 0 : _a.getElementsByTagName("input");
      const searchInputLabel = (_b = document == null ? void 0 : document.querySelector(".nl-primary-navigation-bar__search-bar")) == null ? void 0 : _b.getElementsByTagName("label");
      const searchIconId = document.querySelectorAll('[data-testid="trigger-search-icon"]');
      if (searchIconId) {
        searchIconId.forEach((el, index2) => {
          el.setAttribute("id", `trigger-search-icon-${index2}`);
        });
      }
      if (searchInput && searchInputLabel) {
        (_c = searchInput[magicNumber.ZERO]) == null ? void 0 : _c.setAttribute("id", `search-input-${magicNumber.ZERO}`);
        (_d = searchInput[magicNumber.ONE]) == null ? void 0 : _d.setAttribute("id", `search-input-${magicNumber.ONE}`);
        (_e = searchInputLabel[magicNumber.ZERO]) == null ? void 0 : _e.setAttribute("for", `search-input-${magicNumber.ZERO}`);
        (_f = searchInputLabel[magicNumber.ONE]) == null ? void 0 : _f.setAttribute("for", `search-input-${magicNumber.ONE}`);
      }
    }, magicNumber.HUNDRED);
    if (areAllParamsValid(!isOfferSearch, getIsMobile(), !showCloseIcon())) {
      searchBarEl.current.setAttribute("tabindex", `-${magicNumber.ONE}`);
      searchBarEl.current.setAttribute("aria-hidden", "true");
      const searchIconBtn = document.querySelectorAll(
        '.nl-header__mobile-search [data-testid="trigger-search-icon"]'
      );
      searchIconBtn.forEach((el) => {
        el.removeAttribute("aria-label");
        el.setAttribute("aria-hidden", "true");
        el.setAttribute("tabindex", `-${magicNumber.ONE}`);
      });
    }
    return () => clearTimeout(timeoutId);
  }, [showCloseIcon]);
  useEffect(() => {
    if (isPromoSearch && searchingString && searchingString !== "*") {
      setSearchInputVal(searchingString);
    } else {
      const searchingStr = searchingString || "";
      setSearchInputVal(searchingStr);
    }
  }, [searchingString]);
  let shouldShowSuggestions = false;
  if (showSuggestionPanel) {
    if (isPromoSearch) {
      shouldShowSuggestions = !!(suggestedKeywordList == null ? void 0 : suggestedKeywordList.length);
    } else {
      shouldShowSuggestions = isAtleastOneParamValid(
        !!(suggestedBrandList == null ? void 0 : suggestedBrandList.length),
        !!(suggestedKeywordList == null ? void 0 : suggestedKeywordList.length),
        !!(suggestedCategoryList == null ? void 0 : suggestedCategoryList.length),
        !!(filteredHistoryList == null ? void 0 : filteredHistoryList.length)
      );
    }
  }
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-search-bar`, "data-testid": "suggestion-panel", id: props.mobileSearchBarId, children: [
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-search ${PREFIX}-row`, children: [
      areAllParamsValid(!isOfferSearch, showCloseIcon(), getIsMobile()) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-search__searchbutton ${PREFIX}-search__searchbutton__close`, children: /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => {
            onCloseTassModal();
            closeModal && closeModal();
          },
          "aria-label": allyCloseIconLabel,
          type: "icon_button",
          id: "close-btn",
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-left", size: "md", path })
        }
      ) }),
      /* @__PURE__ */ jsx("label", { htmlFor: id, className: "sr-only", children: searchLabel }),
      /* @__PURE__ */ jsx(
        "input",
        {
          id,
          "data-qm-allow": "true",
          ref: callbackRef,
          enterKeyHint: "search",
          placeholder: searchBoxPlaceholder,
          className: `${PREFIX}-search__input`,
          value: searchInputVal,
          "data-iscodelookup": isCodeLookup,
          onClick: (e) => {
            e.preventDefault();
            notFilterHistory && setNotFilterHistory(false);
            setShowSuggestionPanel(true);
            isPromoSearch && setIsPromoSearchIconClicked(false);
          },
          onChange: (e) => handleChange(e),
          onKeyDown: handleKeyDown,
          "data-testid": id,
          autoComplete: "off"
        }
      ),
      clearButton(),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-search__searchbutton`, children: /* @__PURE__ */ jsx(
        Button,
        {
          "data-qm-allow": "true",
          type: "icon_button",
          onClick: () => triggerSearch(false, searchConstants.USER_INPUTTED),
          id: "trigger-search-icon",
          ariaLabel: a11ySearchIconLabel,
          buttonType: "submit",
          quantumMetricAttribute: { type: "allow", value: "true" },
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-search", size: searchIconSize, path })
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "sr-only", ref: ariaLiveRef, "aria-live": "polite", "aria-atomic": "true", role: "status" }),
    shouldShowSuggestions ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-tass-panel-row`, ref: modalRef, "data-testid": "suggestion-panel-row", children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-tass-panel`, id: "suggestion-panel", children: renderTassInner() }) }) : null
  ] });
};
SearchBar.defaultProps = {
  id: "search-input"
};
SearchBar.propTypes = {
  searchIconSize: PropTypes.string,
  path: PropTypes.string,
  a11ySearchIconLabel: PropTypes.string,
  allyCloseIconLabel: PropTypes.string,
  a11yUpdateQueryIconLabel: PropTypes.string,
  id: PropTypes.string,
  searchBoxPlaceholder: PropTypes.string,
  searchLabel: PropTypes.string,
  categoriesLabel: PropTypes.string,
  didYouMeanLabel: PropTypes.string,
  searchHistoryTitle: PropTypes.string,
  isCodeLookup: PropTypes.bool,
  suggestedKeywordList: PropTypes.array,
  suggestedCategoryList: PropTypes.array,
  getSearchHistoryList: PropTypes.func,
  addSearchHistory: PropTypes.func,
  clearSearchHistoryList: PropTypes.func,
  searchCallBack: PropTypes.func,
  pushAnalyticsData: PropTypes.func,
  closeModal: PropTypes.func,
  searchHistoryClearLabel: PropTypes.string,
  showModal: PropTypes.bool,
  suggestionPannel: PropTypes.bool,
  delay: PropTypes.number,
  pushQueue: PropTypes.func,
  topHit: PropTypes.arrayOf(
    PropTypes.exact({
      isRedirect: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
      searchUrl: PropTypes.string.isRequired,
      type: PropTypes.string,
      index: PropTypes.number
    })
  ).isRequired,
  a11yArrowButtonsAriaLabel: PropTypes.string,
  a11ySuggestionsAvailableLabel: PropTypes.string
};
const DataGrid = (props) => {
  const { data, config, className: className2, renderSubHeaders, dataGridRef } = props;
  const tableClassName = className2 ? className2 : `${PREFIX}-data-grid`;
  const headerRow = config.map((column) => {
    return column.label ? /* @__PURE__ */ jsx(
      "th",
      {
        className: column == null ? void 0 : column.thClassName,
        style: { width: column == null ? void 0 : column.width, minWidth: column == null ? void 0 : column.minWidth },
        colSpan: column.colSpan,
        rowSpan: column.rowSpan,
        children: column.label
      },
      column.label
    ) : null;
  });
  const bodyData = data == null ? void 0 : data.map((rowData, index2) => {
    return /* @__PURE__ */ jsx("tr", { children: config.map((column, configIndex) => {
      const value = column.render(rowData);
      const spans = (column == null ? void 0 : column.getSpans) && column.getSpans(rowData);
      const colSpan = (spans == null ? void 0 : spans.colSpan) ?? magicNumber.ONE;
      const rowSpan = (spans == null ? void 0 : spans.rowSpan) ?? magicNumber.ONE;
      const tdClassName = (column == null ? void 0 : column.getClassName) && column.getClassName(rowData);
      if (checkUndefined(value)) {
        return null;
      }
      return /* @__PURE__ */ jsx("td", { className: tdClassName, colSpan, rowSpan, children: value }, configIndex);
    }) }, index2);
  });
  return /* @__PURE__ */ jsx("div", { className: tableClassName, children: /* @__PURE__ */ jsxs("table", { ref: dataGridRef, children: [
    /* @__PURE__ */ jsxs("thead", { children: [
      renderSubHeaders && renderSubHeaders(),
      /* @__PURE__ */ jsx("tr", { children: headerRow })
    ] }),
    /* @__PURE__ */ jsx("tbody", { children: bodyData })
  ] }) });
};
const FIRST_NAV_ITEM = 1;
const MIN_PAGE_SIZE = 2;
const MAX_SIZE_BOTTOM_EDGE = 5;
const MAX_ITEM_FOR_DOTS = 7;
const MAX_SIZE_UPPER_EDGE = 4;
const DOTS_NAV_ITEM = "...";
const PREV_NAV_ITEM = "<";
const NEXT_NAV_ITEM = ">";
const Pagination$1 = (props) => {
  const { сurrentPage, navSize, pageSize, message, totalArticles, onPrevClick, onNextClick, onItemClick } = props;
  const pagesToNavigate = Math.ceil(totalArticles / pageSize);
  const isPrevDisabled = сurrentPage === FIRST_NAV_ITEM;
  const isNextDisabled = сurrentPage === pagesToNavigate;
  const articlesFrom = (сurrentPage - FIRST_NAV_ITEM) * pageSize + FIRST_NAV_ITEM;
  const articleTo = Math.min(сurrentPage * pageSize, totalArticles);
  const isBottomEdgeReached = сurrentPage < MAX_SIZE_BOTTOM_EDGE;
  const shouldRenderMiddleItems = сurrentPage >= MAX_SIZE_BOTTOM_EDGE && сurrentPage <= pagesToNavigate - MAX_SIZE_UPPER_EDGE;
  const isUpperEdgeReached = сurrentPage > pagesToNavigate - MAX_SIZE_UPPER_EDGE && сurrentPage >= MAX_SIZE_BOTTOM_EDGE;
  const generateNavItems = useCallback(
    (increment, limit) => {
      return Array.from(Array(limit).keys()).map((value) => {
        const pageNumber = value + increment;
        return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
          "button",
          {
            "aria-label": `Page ${pageNumber}`,
            value: pageNumber,
            className: `${PREFIX}-pagination__navigation-item ${сurrentPage === pageNumber ? `${PREFIX}-pagination__navigation-item--active` : ""}`,
            onClick: onItemClick,
            children: pageNumber
          }
        ) }, pageNumber);
      });
    },
    [сurrentPage, onItemClick]
  );
  const renderNavPrevEdge = useCallback(() => {
    const shouldRenderNavigationDots = (shouldRenderMiddleItems || isUpperEdgeReached) && pagesToNavigate !== MIN_PAGE_SIZE && pagesToNavigate > MAX_ITEM_FOR_DOTS;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        "button",
        {
          disabled: isPrevDisabled,
          "aria-label": "Previous",
          className: `${PREFIX}-pagination__navigation-item ${isPrevDisabled ? `${PREFIX}-pagination__navigation-item--disabled` : ""}`,
          onClick: onPrevClick,
          children: PREV_NAV_ITEM
        }
      ) }),
      /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        "button",
        {
          value: FIRST_NAV_ITEM,
          className: `${PREFIX}-pagination__navigation-item ${сurrentPage === FIRST_NAV_ITEM ? `${PREFIX}-pagination__navigation-item--active` : ""}`,
          onClick: onItemClick,
          children: FIRST_NAV_ITEM
        }
      ) }),
      shouldRenderNavigationDots && /* @__PURE__ */ jsx("li", { className: `${PREFIX}-pagination__navigation-item ${PREFIX}-pagination__navigation-item--dots`, children: DOTS_NAV_ITEM })
    ] });
  }, [
    isPrevDisabled,
    shouldRenderMiddleItems,
    сurrentPage,
    isUpperEdgeReached,
    pagesToNavigate,
    onPrevClick,
    onItemClick
  ]);
  const renderNavNextEdge = useCallback(() => {
    const shouldRenderNavigationDots = (shouldRenderMiddleItems || isBottomEdgeReached) && pagesToNavigate !== MIN_PAGE_SIZE && pagesToNavigate > MAX_ITEM_FOR_DOTS;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      shouldRenderNavigationDots && /* @__PURE__ */ jsx("li", { className: `${PREFIX}-pagination__navigation-item ${PREFIX}-pagination__navigation-item--dots`, children: DOTS_NAV_ITEM }),
      /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        "button",
        {
          value: pagesToNavigate,
          className: `${PREFIX}-pagination__navigation-item ${сurrentPage === pagesToNavigate ? `${PREFIX}-pagination__navigation-item--active` : ""}`,
          onClick: onItemClick,
          children: pagesToNavigate
        }
      ) }),
      /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        "button",
        {
          "aria-label": "Next",
          disabled: isNextDisabled,
          className: `${PREFIX}-pagination__navigation-item ${isNextDisabled ? `${PREFIX}-pagination__navigation-item--disabled` : ""}`,
          onClick: onNextClick,
          children: NEXT_NAV_ITEM
        }
      ) })
    ] });
  }, [
    isNextDisabled,
    сurrentPage,
    shouldRenderMiddleItems,
    isBottomEdgeReached,
    pagesToNavigate,
    onNextClick,
    onItemClick
  ]);
  const renderMiddleNavItems = useCallback(() => {
    if (pagesToNavigate !== MIN_PAGE_SIZE) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        isBottomEdgeReached && generateNavItems(
          MIN_PAGE_SIZE,
          pagesToNavigate - MIN_PAGE_SIZE <= MAX_SIZE_UPPER_EDGE ? pagesToNavigate - MIN_PAGE_SIZE : MAX_SIZE_UPPER_EDGE
        ),
        shouldRenderMiddleItems && generateNavItems(сurrentPage - FIRST_NAV_ITEM, navSize),
        isUpperEdgeReached && generateNavItems(
          Math.max(pagesToNavigate - MAX_SIZE_UPPER_EDGE, MIN_PAGE_SIZE),
          pagesToNavigate - MAX_SIZE_UPPER_EDGE < MIN_PAGE_SIZE ? MAX_SIZE_UPPER_EDGE - FIRST_NAV_ITEM : MAX_SIZE_UPPER_EDGE
        )
      ] });
    }
    return null;
  }, [
    сurrentPage,
    generateNavItems,
    isBottomEdgeReached,
    isUpperEdgeReached,
    navSize,
    pagesToNavigate,
    shouldRenderMiddleItems
  ]);
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-pagination`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-pagination__message`, children: replaceMultipleStrWithDynamicVal(message, [
      String(articlesFrom),
      String(articleTo),
      String(totalArticles)
    ]) }),
    /* @__PURE__ */ jsxs("ul", { className: `${PREFIX}-pagination__navigation`, children: [
      renderNavPrevEdge(),
      renderMiddleNavItems(),
      renderNavNextEdge()
    ] })
  ] });
};
const noOfOtherStoresToShow = 3;
var GetPlaceDetailsParamType = /* @__PURE__ */ ((GetPlaceDetailsParamType2) => {
  GetPlaceDetailsParamType2["ADDRESS"] = "address";
  GetPlaceDetailsParamType2["PLACE_ID"] = "placeId";
  GetPlaceDetailsParamType2["COMPONENT_RESTRICTIONS"] = "componentRestrictions";
  return GetPlaceDetailsParamType2;
})(GetPlaceDetailsParamType || {});
const googlePlaceServices = (window2) => {
  let setPredictions;
  let setGeometryDetails;
  let sessionToken = "";
  let saveInput = "";
  const _generateSessionToken = () => {
    if (window2.google === void 0) {
      return void 0;
    }
    return new window2.google.maps.places.AutocompleteSessionToken();
  };
  const _updateSessionToken = () => {
    sessionToken = _generateSessionToken();
  };
  const _findInvalidCode = (placeDetails, status) => {
    if (status === window2.google.maps.places.PlacesServiceStatus.OK) {
      const {
        formatted_address: description,
        place_id: placeId,
        address_components: {
          [0]: { types }
        }
      } = placeDetails[0];
      if (description !== defaultCountryName) {
        setPredictions([
          {
            description,
            place_id: placeId,
            reference: placeId,
            matched_substrings: [],
            structured_formatting: {},
            terms: [],
            types
          }
        ]);
        return;
      }
    }
    setGeometryDetails({});
    setPredictions([]);
  };
  const _getPredictions = (predictions, status) => {
    if (window2.google === void 0) {
      return;
    }
    if (status !== window2.google.maps.places.PlacesServiceStatus.OK) {
      if (!(predictions == null ? void 0 : predictions.length) && saveInput) {
        _getPlaceDetails(
          {
            type: GetPlaceDetailsParamType.ADDRESS,
            value: `${saveInput}, ${defaultCountryName}`
          },
          _findInvalidCode
        );
        saveInput = "";
      } else {
        setGeometryDetails({});
        setPredictions([]);
      }
      return;
    }
    setPredictions(predictions);
  };
  const _getLatLong = (placeDetails, status) => {
    if (window2.google === void 0) {
      return;
    }
    if (status !== window2.google.maps.places.PlacesServiceStatus.OK) {
      return;
    }
    const [result] = placeDetails;
    const { lat, lng } = result.geometry.location;
    setGeometryDetails({
      lat: lat(),
      long: lng()
    });
  };
  const _getPlaceDetails = (requestPayload, customCallback = null, region = "") => {
    if (window2.google === void 0) {
      return;
    }
    const { type, value } = requestPayload;
    const geoCoder = new window2.google.maps.Geocoder();
    void geoCoder.geocode(
      {
        [type]: value,
        region
      },
      customCallback || _getLatLong
    );
  };
  const _autoSuggestions = (searchQuery) => {
    if (window2.google === void 0) {
      return;
    }
    const autoComplete = new window2.google.maps.places.AutocompleteService();
    saveInput = searchQuery;
    void autoComplete.getPlacePredictions(
      {
        input: searchQuery,
        sessionToken,
        componentRestrictions: {
          country: countryCode.ca
          // passing this param to get address only in canada.
        },
        types: [geocode]
      },
      _getPredictions
    );
  };
  const _setStorageVariables = async ({ storePredictions, storeLocationDetails }, setIsPlacesLoaded) => {
    try {
      await window2.google.maps.importLibrary("places");
      setIsPlacesLoaded && setIsPlacesLoaded(true);
    } catch (error) {
      console.warn(error);
    }
    setPredictions = storePredictions;
    setGeometryDetails = storeLocationDetails;
    sessionToken = _generateSessionToken();
  };
  return {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises,sonarjs/no-misused-promises
    setStorageVariables: _setStorageVariables,
    autoSuggestion: _autoSuggestions,
    getPlaceDetails: _getPlaceDetails,
    updateSessionToken: _updateSessionToken
  };
};
const googlePlaceServices$1 = googlePlaceServices(window);
const AutoCompleteItem = ({
  item,
  onSelectItem,
  isHighlighted,
  renderItem: renderItem2
}) => {
  return /* @__PURE__ */ jsx(
    "li",
    {
      className: `${PREFIX}-autocomplete-container__list-item ${isHighlighted ? `${PREFIX}-autocomplete-container__list-item__active` : ""}`,
      children: /* @__PURE__ */ jsx(
        "button",
        {
          className: `${PREFIX}-autocomplete-container__list-button `,
          "data-testid": "autocomplete-button",
          onClick: onSelectItem,
          children: renderItem2 == null ? void 0 : renderItem2({ ...item })
        }
      )
    }
  );
};
AutoCompleteItem.propTypes = {
  item: PropTypes.any,
  onSelectItem: PropTypes.func,
  isHighlighted: PropTypes.bool,
  renderItem: PropTypes.func
};
const Autocomplete = ({ ...props }) => {
  const {
    suggestions = [],
    onSelect,
    label,
    onAutocompleteChange,
    id,
    imageUrl,
    imageAltText,
    renderItem: renderItem2,
    autocompleteText = "",
    error = "",
    onBlur,
    maxLength,
    placeholder,
    showSearchIcon,
    a11ySearchIconLabel,
    searchCallBack,
    selectedAddress,
    onFocusHandler,
    a11ySuggestionResultAvailable,
    addressElementRef
  } = props;
  const [isVisible, setVisibility] = useState(false);
  const [search, setSearch] = useState(autocompleteText);
  const [cursor, setCursor] = useState(negativeCursorValue);
  const searchContainer = useRef(null);
  const searchResultRef = useRef(null);
  const [suggestionsList, setSuggestions] = useState([]);
  const prevSuggestions = usePrevious(suggestions);
  useEffect(() => {
    setCursor(negativeCursorValue);
    scrollIntoView(0);
  }, [search]);
  useEffect(() => {
    if (Array.isArray(suggestions) && suggestions.length && suggestions !== prevSuggestions) {
      setSuggestions(suggestions);
      if (search) {
        showSuggestion();
      }
    }
  }, [search, suggestions, prevSuggestions]);
  useEffect(() => {
    if (autocompleteText == null ? void 0 : autocompleteText.length) {
      setSearch(autocompleteText);
    } else {
      setSearch("");
    }
  }, [autocompleteText]);
  const searchSuggestionsCallback = (event) => {
    var _a;
    showSearchIcon && searchCallBack(((_a = suggestions[cursor]) == null ? void 0 : _a.description) || event.target.value);
  };
  const keyboardNavigation = (event) => {
    switch (event.key) {
      case ARROW_DOWN: {
        isVisible ? setCursor((c) => c < suggestions.length - unityValue ? c + unityValue : c) : null;
        break;
      }
      case ARROW_UP: {
        setCursor((c) => c > 0 ? c - unityValue : 0);
        break;
      }
      case ENTER: {
        if (cursor > negativeCursorValue || showSearchIcon) {
          setSearch(onSelect(suggestions[cursor], !showSearchIcon));
          event.preventDefault();
          hideSuggestion();
          searchSuggestionsCallback(event);
        }
        break;
      }
      case ESC: {
        hideSuggestion();
        break;
      }
    }
  };
  const showSuggestion = () => setVisibility(true);
  const hideSuggestion = () => setVisibility(false);
  const onListItemClick = (value) => {
    hideSuggestion();
    setSearch(onSelect(value));
  };
  const handleInputChange = (value) => {
    setSearch(value);
    if (suggestions.length && value.length) {
      showSuggestion();
    } else {
      hideSuggestion();
    }
    onAutocompleteChange(value);
  };
  useEffect(() => {
    !suggestions.length ? hideSuggestion() : showSuggestion();
  }, [suggestions]);
  useEffect(() => {
    setSearch(selectedAddress);
    hideSuggestion();
  }, [selectedAddress]);
  useClickOutsideClose(searchContainer, hideSuggestion, isVisible, true);
  const scrollIntoView = (position) => {
    const searchElem = searchResultRef.current;
    if (searchElem) {
      searchElem.scrollTo({
        top: position,
        behavior: "smooth"
      });
    }
  };
  useEffect(() => {
    if (cursor < 0 || cursor > suggestions.length || !searchResultRef) {
      return;
    }
    const listItems2 = Array.from(searchResultRef.current.children);
    listItems2[cursor] && scrollIntoView(listItems2[cursor].offsetTop);
  }, [suggestions.length, cursor]);
  const footerImageSection = () => {
    return isVisible && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-autocomplete-container__footer-post`, children: /* @__PURE__ */ jsx("img", { src: imageUrl, alt: imageAltText }) });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-autocomplete-container`, ref: searchContainer, children: [
    /* @__PURE__ */ jsx("div", { className: "sr-only", children: /* @__PURE__ */ jsxs("div", { "aria-atomic": "true", "aria-live": "polite", role: "status", children: [
      isVisible && suggestionsList && suggestionsList.length,
      " ",
      isVisible && a11ySuggestionResultAvailable
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-autocomplete-container__text`, children: [
      /* @__PURE__ */ jsx(
        TextInput,
        {
          id,
          label,
          value: search,
          onChange: handleInputChange,
          maxLength,
          onKeyDown: keyboardNavigation,
          error,
          onBlur,
          placeholder,
          quantumMetricAttribute: { type: "encrypt", value: "true" },
          onFocus: (ev) => onFocusHandler && onFocusHandler(ev),
          textInputRef: addressElementRef
        }
      ),
      showSearchIcon && /* @__PURE__ */ jsx(
        "button",
        {
          className: `${PREFIX}-autocomplete-container__search-btn`,
          onClick: () => searchCallBack(selectedAddress),
          "aria-label": a11ySearchIconLabel,
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-search", size: "md" })
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-autocomplete-container__search-result ${!isVisible ? `${PREFIX}-autocomplete-container__invisible` : ""}`,
        children: /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx("ul", { ref: searchResultRef, id: "scroll-list", children: suggestionsList && suggestionsList.length && suggestionsList.map((item, index2) => {
            return /* @__PURE__ */ jsx(
              AutoCompleteItem,
              {
                onSelectItem: (event) => {
                  event.preventDefault();
                  onListItemClick(item);
                },
                isHighlighted: cursor === index2,
                item,
                renderItem: renderItem2
              },
              index2
            );
          }) }),
          footerImageSection()
        ] })
      }
    )
  ] }) });
};
Autocomplete.propTypes = {
  suggestions: PropTypes.array,
  onSelect: PropTypes.func,
  onAutocompleteChange: PropTypes.func,
  label: PropTypes.string,
  language: PropTypes.string,
  id: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAltText: PropTypes.string,
  renderItem: PropTypes.func,
  setRegionDropdownReset: PropTypes.func,
  autocompleteText: PropTypes.string,
  error: PropTypes.string,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  showSearchIcon: PropTypes.bool,
  searchCallBack: PropTypes.func,
  selectedAddress: PropTypes.string,
  a11ySearchIconLabel: PropTypes.string
};
const GoogleAutocomplete = ({
  searchInputPH,
  a11ySearchIconAriaLabel,
  a11ySuggestionResultAvailable,
  fetchNearbyStoreListOnSearch,
  inputMaxLength,
  setIsInputInValid,
  searchStoreAnalyticsHandler,
  onFocusHandler
}) => {
  const [predictions, setPredictions] = useState([]);
  const [locationDetails, setLocationDetails] = useState({});
  const [debounceTimeOut, setDebounceTimeOut] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [externalPlaceService] = useState(googlePlaceServices$1);
  const [isPlacesLoaded, setIsPlacesLoaded] = useState(false);
  useEffect(() => {
    externalPlaceService.setStorageVariables(
      {
        storePredictions: setPredictions,
        storeLocationDetails: setLocationDetails
      },
      setIsPlacesLoaded
    );
  }, []);
  useEffect(() => {
    if (locationDetails && Object.keys(locationDetails).length > 0) {
      const { lat, long } = locationDetails;
      fetchNearbyStoreListOnSearch(lat, long);
    } else {
      selectedAddress && setIsInputInValid(true);
    }
  }, [locationDetails]);
  const onAddressSelect = (data, invokeStoreDetails) => {
    const { description: address } = data || {};
    if (address) {
      setIsInputInValid(false);
      setSelectedAddress(address);
      invokeStoreDetails && searchCallBack(address);
      externalPlaceService.updateSessionToken();
      return address;
    }
    return selectedAddress;
  };
  const searchCallBack = (existingAddress) => {
    if (!!existingAddress && existingAddress.trim().length && isArrayNotEmpty(predictions)) {
      let address = "";
      const isAddressExistInPredictions = predictions.find(
        (prediction) => prediction.description.trim().toString() === existingAddress.trim().toString()
      );
      if (isAddressExistInPredictions) {
        address = isAddressExistInPredictions.description;
        setSelectedAddress(existingAddress);
      } else {
        address = predictions[0].description;
        setSelectedAddress(predictions[0].description);
      }
      if (isPlacesLoaded) {
        externalPlaceService.getPlaceDetails({
          type: GetPlaceDetailsParamType.ADDRESS,
          // can pass either address or placeId
          value: address
          // selected Address from auto complete api
        });
      }
      searchStoreAnalyticsHandler();
      setIsInputInValid(false);
    }
  };
  const handleInputChange = (inputValue) => {
    setSelectedAddress(inputValue);
    if (!inputValue) {
      setPredictions([]);
      return;
    }
    if (inputValue.length >= autocompleteMinLength && isPlacesLoaded) {
      const waitTime = 1e3;
      customDebounce(
        () => externalPlaceService.autoSuggestion(inputValue),
        waitTime,
        debounceTimeOut,
        setDebounceTimeOut
      )();
      setIsInputInValid(false);
      setPredictions([]);
    }
  };
  const renderItem2 = (singlePredictions) => {
    const { description } = singlePredictions;
    const autocompleteClass = `${PREFIX}-autocomplete-container`;
    return /* @__PURE__ */ jsx("div", { className: `${autocompleteClass}__item`, children: /* @__PURE__ */ jsx("span", { className: `${autocompleteClass}__clamp-text--mobile`, children: description }) });
  };
  return /* @__PURE__ */ jsx(
    Autocomplete,
    {
      suggestions: predictions,
      label: searchInputPH,
      language: document.documentElement.lang,
      id: `${PREFIX}-store-locator-search-box`,
      renderItem: renderItem2,
      onSelect: (address, invokeStoreDetails = true) => {
        return onAddressSelect(address, invokeStoreDetails);
      },
      maxLength: Number(inputMaxLength),
      placeholder: " ",
      showSearchIcon: true,
      a11ySearchIconLabel: a11ySearchIconAriaLabel,
      searchCallBack,
      onAutocompleteChange: handleInputChange,
      selectedAddress,
      onFocusHandler: (ev) => onFocusHandler && onFocusHandler(ev),
      a11ySuggestionResultAvailable
    }
  );
};
const isAutoServiceAvailableInStore = (store) => {
  var _a;
  return !!((_a = store == null ? void 0 : store.storeServices) == null ? void 0 : _a.find((service) => service.name === AUTO_SERVICE_INSTALLATION_ID));
};
const getCurrentDay = (language2, type = "long") => (/* @__PURE__ */ new Date()).toLocaleDateString(language2, { weekday: type }).toLowerCase();
const getStoreTimings = (params) => {
  var _a;
  const currentDay = getCurrentDay(getLanguage());
  const { openingHours } = params || {};
  const weekdayHours = (_a = openingHours == null ? void 0 : openingHours.weekDayOpeningList) == null ? void 0 : _a.find(
    (day) => {
      var _a2;
      return ((_a2 = day.weekDay) == null ? void 0 : _a2.toLowerCase()) === currentDay;
    }
  );
  const weekdayHoursUpdate = checkNeedUpdateWeekdayHours(params, weekdayHours);
  return weekdayHoursUpdate || {};
};
const calculateClosedClosesInStore = (store, weekdayHours) => {
  var _a, _b, _c, _d, _e, _f;
  const currentDay = getCurrentDay(getLanguage());
  const isCurrentDay = ((_a = weekdayHours == null ? void 0 : weekdayHours.weekDay) == null ? void 0 : _a.toLowerCase()) === currentDay;
  const storeTimezone = store.storeTimezone || "";
  const currentTime = storeTimezone && dateFnsTzExports.formatInTimeZone(/* @__PURE__ */ new Date(), storeTimezone, "HH:mm");
  const formattedCloseTime = formattedTime((_b = weekdayHours == null ? void 0 : weekdayHours.closingTime) == null ? void 0 : _b.hour, (_c = weekdayHours == null ? void 0 : weekdayHours.closingTime) == null ? void 0 : _c.minute);
  const formattedOpenTime = formattedTime((_d = weekdayHours == null ? void 0 : weekdayHours.openingTime) == null ? void 0 : _d.hour, (_e = weekdayHours == null ? void 0 : weekdayHours.openingTime) == null ? void 0 : _e.minute);
  const isClosed = isCurrentDay && currentTime ? isClosedStore(currentTime, formattedOpenTime, formattedCloseTime) : weekdayHours == null ? void 0 : weekdayHours.closed;
  const closesIn = (
    // eslint-disable-next-line no-unsafe-optional-chaining
    isCurrentDay && currentTime ? ((_f = weekdayHours == null ? void 0 : weekdayHours.closingTime) == null ? void 0 : _f.hour) - timeStringToNumber(currentTime) : null
  );
  return { currentTime, isClosed, closesIn };
};
const formattedTime = (hour, minute) => {
  const hourAsString = hour ? hour.toString() : "";
  let minuteAsString = "00";
  if (minute !== void 0 && minute > magicNumber.ZERO) {
    minuteAsString = `${minute}`;
  }
  const checkValue = (value) => {
    return value.length === magicNumber.ONE ? `0${value}` : value;
  };
  return `${checkValue(hourAsString)}:${checkValue(minuteAsString)}`;
};
const isClosedStore = (currentTime, formattedOpenTime, formattedCloseTime) => {
  return currentTime < formattedOpenTime || currentTime > formattedCloseTime;
};
const timeStringToNumber = (time) => {
  const hoursMinutes = time.split(/[.:]/);
  const hours = parseInt(hoursMinutes[0], 10);
  const minutes = hoursMinutes[magicNumber.ONE] ? parseInt(hoursMinutes[magicNumber.ONE], 10) : 0;
  return Math.ceil(hours + minutes / magicNumber.SIXTY);
};
const checkNeedUpdateWeekdayHours = (store, weekdayHours) => {
  const calcProperties = calculateClosedClosesInStore(store, weekdayHours);
  if (calcProperties.currentTime) {
    weekdayHours = {
      ...weekdayHours,
      closed: calcProperties.isClosed,
      closesIn: calcProperties.closesIn
    };
  }
  return weekdayHours;
};
const getNextDayStoreTimings = (store) => {
  var _a, _b, _c;
  const currentDay = getCurrentDay(getLanguage());
  const { openingHours } = store || {};
  const weekdayHoursIndex = (_a = openingHours == null ? void 0 : openingHours.weekDayOpeningList) == null ? void 0 : _a.findIndex(
    (day) => {
      var _a2;
      return ((_a2 = day.weekDay) == null ? void 0 : _a2.toLowerCase()) === currentDay;
    }
  );
  const nextIndex = (
    // eslint-disable-next-line no-unsafe-optional-chaining
    weekdayHoursIndex === ((_b = openingHours == null ? void 0 : openingHours.weekDayOpeningList) == null ? void 0 : _b.length) - magicNumber.ONE ? magicNumber.ZERO : weekdayHoursIndex + magicNumber.ONE
  );
  const nextDayHours = (_c = openingHours == null ? void 0 : openingHours.weekDayOpeningList) == null ? void 0 : _c[nextIndex];
  return nextDayHours || {};
};
const HeaderStoreLocator = (props) => {
  const {
    path,
    openLabel,
    opensLabel,
    closedLabel,
    closesLabel,
    a11yHeaderStorePreferred,
    a11yHeaderStoreCurrently,
    a11yHeaderStoreAt,
    preferredStoreId,
    onlineOrdersNotAcceptedMsg,
    storeLocatorList,
    fetchNearbyStoreListOnSearch,
    fetchStoreListOnLoad,
    inputMaxLength,
    viewMoreAnalytics,
    mapIconOnClickHandler,
    windowRef,
    setPreferredStore,
    searchStoreAnalyticsHandler,
    storeSuccessfullySelectedMsg,
    renderAutoAppointmentButton,
    baseStoreId,
    storeAPITriangulationFail,
    forcePreferredStoreMsg,
    selectAStoreLabel,
    storeLocationLabel,
    currentUserLocation,
    sideNavigationIsOpen,
    dispatchStoreLocatorPopupState,
    maxNumberOfStores
  } = props;
  const [showFlyOut, setShowFlyOut] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [sortedStoreData, setSortedStoreData] = useState({
    preferredStore: {},
    otherStores: []
  });
  const [isFlyoutAlreadyOpen, setIsFlyoutAlreadyOpen] = useState(false);
  const flyoutRef = useRef(null);
  const componentName = `${PREFIX}-store-locator`;
  const {
    setPreferredStoreCTALabel,
    preferredStoreLabel,
    searchInputPH,
    a11ySearchIconAriaLabel,
    a11yCurrentLocationCTAAriaLabel,
    seeMoreCTALabel,
    seeMoreCTAURL,
    closeLabel,
    searchInputErrorMsg
  } = props.storeLocatorGlobalPropData || {};
  const [isMobile2, setIsMobile] = useState(window.innerWidth <= BREAKPOINTS.mobileMaxWidth);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= BREAKPOINTS.mobileMaxWidth);
  };
  useGlobalResizeEvent(handleResize);
  const [isPreferredStoreChanged, setIsPreferredStoreChanged] = useState(false);
  const [showSuccess, setShowSucces] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const weekdayHours = selectedStore && getStoreTimings(selectedStore);
  const nextDayHours = selectedStore && getNextDayStoreTimings(selectedStore);
  const { closingTime, closed } = enableDestructOnUndefinedData(weekdayHours);
  const { openingTime } = enableDestructOnUndefinedData(nextDayHours);
  const timeText = closed ? `⋅ ${opensLabel} ${" "} ${openingTime == null ? void 0 : openingTime.formattedHour}` : `⋅ ${closesLabel} ${" "} ${closingTime == null ? void 0 : closingTime.formattedHour}`;
  const storeTimingsPresent = closed ? openingTime == null ? void 0 : openingTime.formattedHour : closingTime == null ? void 0 : closingTime.formattedHour;
  const hideStoreLocatorFlyOut = useCallback(
    (closeFlyout) => {
      dispatchStoreLocatorPopupState(false);
      if (!isFlyoutAlreadyOpen || closeFlyout) {
        setShowFlyOut(false);
      }
    },
    [dispatchStoreLocatorPopupState, isFlyoutAlreadyOpen]
  );
  const checkIfStoresApiFails = () => {
    var _a;
    return !((_a = props.preferredStoreDetails) == null ? void 0 : _a.id) && !!storeAPITriangulationFail;
  };
  const isStoresApiFailed = checkIfStoresApiFails();
  useEffect(() => {
    if (isStoresApiFailed) {
      setShowFlyOut(true);
    }
  }, [isStoresApiFailed]);
  useEffect(() => {
    if (sideNavigationIsOpen) {
      hideStoreLocatorFlyOut(true);
    }
  }, [sideNavigationIsOpen, hideStoreLocatorFlyOut]);
  const getAllyStoreLocatorLabel = () => {
    const a11yHeaderStorePreferredLabel = replaceStrWithDynamicVal(a11yHeaderStorePreferred, selectedStore == null ? void 0 : selectedStore.name);
    const a11yHeaderStoreCurrentlyLabel = replaceStrWithDynamicVal(
      a11yHeaderStoreCurrently,
      closed ? closedLabel : openLabel
    );
    const a11yHeaderStoreAtLabel = replaceMultipleStrWithDynamicVal(a11yHeaderStoreAt, [
      closed ? opensLabel : closesLabel,
      closed ? openingTime == null ? void 0 : openingTime.formattedHour : closingTime == null ? void 0 : closingTime.formattedHour
    ]);
    return `${a11yHeaderStorePreferredLabel}, ${a11yHeaderStoreCurrentlyLabel}, ${a11yHeaderStoreAtLabel}`;
  };
  const showStoreLocatorFlyOut = () => {
    dispatchStoreLocatorPopupState(true);
    setShowFlyOut(true);
    setIsFlyoutAlreadyOpen(true);
    if (!isArrayNotEmpty(storeLocatorList) || storeLocatorList.length < maxNumberOfStores) {
      if (currentUserLocation) {
        const { latitude, longitude } = currentUserLocation;
        fetchNearbyStoreListOnSearch(latitude, longitude);
      } else {
        fetchStoreListOnLoad();
      }
    }
  };
  const sortStoreDataList = useCallback(
    (storeList, preferredStore) => {
      const excludePreferredStoreFromList = storeList == null ? void 0 : storeList.filter((storeItem) => {
        var _a;
        if (((_a = storeItem == null ? void 0 : storeItem.id) == null ? void 0 : _a.toString()) === preferredStoreId) {
          if (isPreferredStoreChanged && isMobile2) {
            hideStoreLocatorFlyOut(true);
            setShowSucces(true);
            setShowToast(true);
          }
        } else {
          return storeItem;
        }
      });
      return {
        preferredStore,
        otherStores: excludePreferredStoreFromList == null ? void 0 : excludePreferredStoreFromList.slice(0, noOfOtherStoresToShow)
      };
    },
    [hideStoreLocatorFlyOut, isMobile2, isPreferredStoreChanged, preferredStoreId]
  );
  const displayToast = () => {
    const options = {
      toastSuccessMessage: storeSuccessfullySelectedMsg,
      toastSuccessIcon: "ct-notification-success-green",
      toastErrorIcon: "ct-notification-caution",
      toastCloseLabel: "Close"
    };
    return showToast && options.toastSuccessMessage ? /* @__PURE__ */ jsx(
      Toast,
      {
        success: showSuccess,
        failed: !showSuccess,
        options,
        resetPageVariables: () => setShowToast(false),
        toastCloseFunction: () => {
          setShowToast(false);
        },
        hideCTA: showSuccess,
        enableTimer: true
      }
    ) : /* @__PURE__ */ jsx(Fragment, {});
  };
  const handlePreferredStoreChange = (store) => {
    setPreferredStore(store, setSortedStoreData, sortStoreDataList);
    setIsPreferredStoreChanged(true);
    hideStoreLocatorFlyOut(true);
  };
  const calculateTopPosition = () => {
    return calculateHeaderHeightWithStickyStoreLocator();
  };
  useEffect(() => {
    setSelectedStore(props.preferredStoreDetails);
    setSortedStoreData(sortStoreDataList(storeLocatorList, props.preferredStoreDetails));
  }, [sortStoreDataList, preferredStoreId, storeLocatorList, props.preferredStoreDetails]);
  useClickOutsideClose(
    flyoutRef,
    () => hideStoreLocatorFlyOut(true),
    showFlyOut,
    !storeAPITriangulationFail && !isMobile2
  );
  const formatAddress = (line1, line2, town, regionName, postalCode) => {
    return `${line1 ?? ""} ${line2 ?? ""}, ${town ? `${town},` : ""} ${regionName ? `${regionName},` : ""} ${postalCode ?? ""}`;
  };
  const renderStoreDetails = (showCTA, store, index2) => {
    const {
      id,
      name,
      address: { phone, line1, line2, town, region, postalCode },
      onlineOrdering,
      url
    } = store;
    const storeLocatorListClassName = `${componentName}__list`;
    const preferredStoreClass = showCTA ? `${storeLocatorListClassName}__store--normal` : `${storeLocatorListClassName}__store--preferred`;
    return /* @__PURE__ */ jsxs("div", { className: `${storeLocatorListClassName} ${preferredStoreClass}`, children: [
      /* @__PURE__ */ jsx("a", { className: `${storeLocatorListClassName}-item__name`, href: `${url}`, "data-link-value": name, children: name }),
      /* @__PURE__ */ jsx(
        SanitizeStringContentWrapper,
        {
          stringContent: generateGoogleMapOnAddress(`${line1 ?? ""} ${line2 ?? ""},${postalCode ?? ""}`),
          children: (memoizedStringContent) => /* @__PURE__ */ jsx(
            "a",
            {
              className: `${storeLocatorListClassName}-item__address__line`,
              target: "_blank",
              rel: "noreferrer",
              href: memoizedStringContent,
              children: formatAddress(line1, line2, town, region == null ? void 0 : region.name, postalCode)
            }
          )
        }
      ),
      !onlineOrdering && /* @__PURE__ */ jsxs("div", { className: `${storeLocatorListClassName}__store--status`, children: [
        /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, { type: "ct-notification-caution-stroked", size: "md" }) }),
        /* @__PURE__ */ jsx("span", { className: `${storeLocatorListClassName}__store--status-message`, children: onlineOrdersNotAcceptedMsg })
      ] }),
      showCTA ? baseStoreId && baseStoreId === store.baseStoreId && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        "button",
        {
          className: `${storeLocatorListClassName}-item__other-store`,
          "aria-label": setPreferredStoreCTALabel,
          onClick: () => handlePreferredStoreChange(store),
          "data-testid": `store-locator-preferred${index2}`,
          children: setPreferredStoreCTALabel
        }
      ) }) : /* @__PURE__ */ jsx("div", { className: `${storeLocatorListClassName}-item__number`, children: /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: phone, children: (memoizedStringContent) => /* @__PURE__ */ jsx("a", { href: `tel:${memoizedStringContent}`, "data-link-value": phone, children: getFormattedPhoneNumber(phone) }) }) })
    ] }, id);
  };
  const renderStoreFlyoutTitle = () => {
    return /* @__PURE__ */ jsx("div", { className: `${componentName}__fly-out__mobile-close-bar__store_flyout_title`, children: isMobile2 && !isStoresApiFailed ? storeLocationLabel : selectAStoreLabel });
  };
  const onFocusHandler = (event) => {
    if (flyoutRef && flyoutRef.current && isMobile2) {
      flyoutRef.current.style.top = "0px";
      flyoutRef.current.style.height = "100vh";
      event.currentTarget.classList.add(`${PREFIX}-textinput__input_outline`);
    }
  };
  const StoreLocatorList = () => {
    const [isInputInValid, setIsInputInValid] = useState(false);
    const googleAutoCompleteProps = {
      a11ySearchIconAriaLabel,
      searchInputPH,
      fetchNearbyStoreListOnSearch,
      inputMaxLength,
      setIsInputInValid,
      windowRef,
      searchStoreAnalyticsHandler,
      onFocusHandler
    };
    const renderInvalidAddressWarningMessage = () => {
      return isInputInValid ? /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-store-selector-flyout__error-message`, children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "lg" }),
        /* @__PURE__ */ jsx(
          "p",
          {
            className: `${PREFIX}-body-sm ${PREFIX}-store-selector-flyout__error-message__text`,
            role: "alert",
            "aria-atomic": "true",
            children: searchInputErrorMsg
          }
        )
      ] }) : null;
    };
    useEffect(() => {
      if (isMobile2) {
        const overFlowHiddenClass = "modal-open-not-scroll";
        document.body.classList.add(overFlowHiddenClass);
        return () => {
          document.body.classList.remove(overFlowHiddenClass);
        };
      }
    }, []);
    const showPreferredStoreErrorMsg = () => {
      return !!isStoresApiFailed ? /* @__PURE__ */ jsxs("div", { className: `${componentName}__fly-out__error`, children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "md", path }),
        /* @__PURE__ */ jsx("span", { className: `${componentName}__fly-out__error__description`, children: forcePreferredStoreMsg })
      ] }) : null;
    };
    const hasInfoBanner = document.querySelector(`.${PREFIX}-information-banner`) !== null;
    const mobileWithBanner = hasInfoBanner && isMobile2 ? `${componentName}__fly-out--with-banner` : "";
    const mobileWExpanded = isMobile2 ? `${componentName}__fly-out--expanded` : "";
    const errorClass = storeAPITriangulationFail ? `${componentName}__search-error` : "";
    const showSearchCloseBar = !isMobile2 && !!isStoresApiFailed || isMobile2;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      !!isStoresApiFailed && /* @__PURE__ */ jsx("div", { className: "nl-overlay" }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${componentName}__fly-out ${mobileWithBanner} ${mobileWExpanded}`,
          ref: flyoutRef,
          id: "headerStoreLocatorFlyout",
          style: mobileWExpanded ? { top: `${calculateTopPosition()}px` } : {},
          children: [
            showSearchCloseBar && /* @__PURE__ */ jsxs("div", { className: `${componentName}__fly-out__mobile-close-bar`, children: [
              renderStoreFlyoutTitle(),
              !isStoresApiFailed && /* @__PURE__ */ jsx(
                "button",
                {
                  className: `${componentName}__fly-out-close--mobile`,
                  "aria-label": closeLabel,
                  onClick: () => hideStoreLocatorFlyOut(true),
                  "data-testid": "store-locator-close-mobile",
                  children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "md", path })
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: `${componentName}__fly-out__content`, children: [
              !storeAPITriangulationFail && /* @__PURE__ */ jsxs("div", { className: `${componentName}__preferred-store`, children: [
                /* @__PURE__ */ jsxs("div", { className: `${componentName}__fly-out-row`, children: [
                  /* @__PURE__ */ jsxs("div", { className: `${componentName}__fly-out-row__title-section`, children: [
                    /* @__PURE__ */ jsx(Icon, { type: "ct-star", size: "md", path }),
                    /* @__PURE__ */ jsx("span", { className: `${componentName}__preferred-store-title`, children: preferredStoreLabel })
                  ] }),
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      className: `${componentName}__fly-out-close--desktop`,
                      "aria-label": closeLabel,
                      onClick: () => hideStoreLocatorFlyOut(true),
                      "data-testid": "store-locator-close",
                      children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "md", path })
                    }
                  )
                ] }),
                sortedStoreData.preferredStore && Object.keys(sortedStoreData.preferredStore).length > 0 && renderStoreDetails(false, sortedStoreData.preferredStore),
                isAutoServiceAvailableInStore(sortedStoreData.preferredStore) && renderAutoAppointmentButton()
              ] }),
              /* @__PURE__ */ jsxs("div", { className: `${componentName}__store-list ${errorClass}`, children: [
                /* @__PURE__ */ jsxs("div", { className: `${componentName}__search-bar-section`, children: [
                  /* @__PURE__ */ jsx(GoogleAutocomplete, { ...googleAutoCompleteProps }),
                  !isStoresApiFailed && /* @__PURE__ */ jsx(
                    "button",
                    {
                      className: `${componentName}__search-bar-section__map-icon`,
                      onClick: () => mapIconOnClickHandler(true),
                      "aria-label": a11yCurrentLocationCTAAriaLabel,
                      children: /* @__PURE__ */ jsx(Icon, { type: "ct-location", size: "md", path })
                    }
                  )
                ] }),
                renderInvalidAddressWarningMessage(),
                showPreferredStoreErrorMsg(),
                isArrayNotEmpty(sortedStoreData.otherStores) && sortedStoreData.otherStores.map(
                  (store, index2) => renderStoreDetails(true, store, index2)
                )
              ] }),
              isArrayNotEmpty(sortedStoreData.otherStores) && !isStoresApiFailed && /* @__PURE__ */ jsxs("div", { className: `${componentName}__see-more`, children: [
                /* @__PURE__ */ jsx(
                  "a",
                  {
                    href: seeMoreCTAURL,
                    onClick: () => viewMoreAnalytics(seeMoreCTALabel),
                    "data-link-value": seeMoreCTALabel,
                    children: seeMoreCTALabel
                  }
                ),
                /* @__PURE__ */ jsx(Icon, { path, size: "md", type: "ct-chevron-right" })
              ] })
            ] })
          ]
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-store-locator`, children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        "dap-wac-link-section": "top-nav",
        "dap-wac-value": "Store Locator",
        className: `${PREFIX}-store-locator__icon ${PREFIX}-md-none`,
        "aria-label": "Store Locator Icon",
        onClick: showStoreLocatorFlyOut,
        "data-testid": "header-store-locator-icon",
        children: /* @__PURE__ */ jsx(Icon, { type: "ct-location", size: "lg", path })
      }
    ),
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-store-locator__row`, "data-testid": "header-store-locator-section", children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-store-locator--section`, children: /* @__PURE__ */ jsxs(
      "button",
      {
        "dap-wac-link-section": "top-nav",
        "dap-wac-value": "Store Locator",
        className: `${PREFIX}-store-locator--section-button`,
        "data-testid": "header-store-locator-section-button",
        onClick: showStoreLocatorFlyOut,
        children: [
          /* @__PURE__ */ jsx("span", { className: "sr-only", children: getAllyStoreLocatorLabel() }),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: `${PREFIX}-store-locator__icon 
                            ${PREFIX}-store-locator__icon_md ${PREFIX}-md-inline`,
              children: /* @__PURE__ */ jsx(Icon, { type: "ct-location", size: "lg", path })
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-store-locator--section-name`, children: [
            /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: `${PREFIX}-store-locator--selected-store`, children: selectedStore == null ? void 0 : selectedStore.name }),
            storeTimingsPresent && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-store-locator--timing`, children: [
              /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: closed ? closedLabel : openLabel }),
              /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: `${PREFIX}-store-locator--timing-end`, children: timeText })
            ] })
          ] })
        ]
      }
    ) }) }),
    showFlyOut && /* @__PURE__ */ jsx(StoreLocatorList, {}),
    displayToast()
  ] });
};
HeaderStoreLocator.propTypes = {
  path: PropTypes.string,
  openLabel: PropTypes.string,
  opensLabel: PropTypes.string,
  closedLabel: PropTypes.string,
  closesLabel: PropTypes.string,
  a11yHeaderStorePreferred: PropTypes.string.isRequired,
  a11yHeaderStoreCurrently: PropTypes.string.isRequired,
  a11yHeaderStoreAt: PropTypes.string.isRequired,
  storeLocatorList: PropTypes.array,
  preferredStoreId: PropTypes.string,
  onlineOrdersNotAcceptedMsg: PropTypes.string.isRequired,
  storeLocatorGlobalPropData: PropTypes.any,
  fetchNearbyStoreListOnSearch: PropTypes.func.isRequired,
  fetchStoreListOnLoad: PropTypes.func.isRequired,
  inputMaxLength: PropTypes.number.isRequired,
  viewMoreAnalytics: PropTypes.func,
  mapIconOnClickHandler: PropTypes.func.isRequired,
  windowRef: PropTypes.object.isRequired,
  setPreferredStore: PropTypes.func.isRequired,
  searchStoreAnalyticsHandler: PropTypes.func.isRequired,
  storeSuccessfullySelectedMsg: PropTypes.string.isRequired,
  renderAutoAppointmentButton: PropTypes.func.isRequired,
  preferredStoreDetails: PropTypes.object.isRequired,
  currentUserLocation: PropTypes.object.isRequired,
  baseStoreId: PropTypes.string,
  storeAPITriangulationFail: PropTypes.bool,
  forcePreferredStoreMsg: PropTypes.string,
  selectAStoreLabel: PropTypes.string,
  sideNavigationIsOpen: PropTypes.bool.isRequired,
  dispatchStoreLocatorPopupState: PropTypes.func.isRequired
};
const SearchTitle = ({ ...props }) => {
  const {
    searchTitle,
    searchString,
    suggestiveMessage,
    didYouMean,
    suggestiveQueryClickCallback,
    lastSelectedCategory,
    similarProductsMessage,
    showCorrectedText,
    correctedMessage,
    isSrpPromoIcon,
    noResultSubTitle,
    isProductDataAvailable,
    isPromoSearchBar
  } = props;
  const searchQuery = searchString ? `${searchTitle} "${searchString}" ` : "";
  const shouldShowMessage = (isPromoSearchBarEnabled, isMessageAvailable, hasProductData) => {
    return isPromoSearchBarEnabled ? isMessageAvailable && hasProductData : isMessageAvailable;
  };
  const showSimiliarProductMsg = shouldShowMessage(isPromoSearchBar, !!similarProductsMessage, isProductDataAvailable);
  const showDidYouMeanMsg = shouldShowMessage(isPromoSearchBar, isArrayNotEmpty(didYouMean), isProductDataAvailable);
  const getSuggestiveSearchQueries = () => {
    return didYouMean.map((suggestion, index2) => {
      return /* @__PURE__ */ jsx(
        Button,
        {
          type: "tertiary",
          onClick: () => {
            suggestiveQueryClickCallback(suggestion);
          },
          children: suggestion
        },
        index2
      );
    });
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-srp`, "data-testid": "search-title", children: [
    showCorrectedText && /* @__PURE__ */ jsx("p", { className: `${PREFIX}-srp__noproduct-msg`, children: correctedMessage }),
    /* @__PURE__ */ jsxs("h2", { className: `${PREFIX}-srp__title`, children: [
      searchQuery && /* @__PURE__ */ jsx("div", { children: searchQuery }),
      lastSelectedCategory && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-srp__category`, children: lastSelectedCategory })
    ] }),
    showSimiliarProductMsg && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-srp__similar-products-message`, children: similarProductsMessage }),
    showDidYouMeanMsg && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-srp__suggestive-message`, children: [
      suggestiveMessage,
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-srp__suggestive-option`, children: getSuggestiveSearchQueries() })
    ] }),
    isSrpPromoIcon && noResultSubTitle && /* @__PURE__ */ jsx("p", { className: `${PREFIX}-srp__sub-msg`, children: noResultSubTitle })
  ] });
};
SearchTitle.propTypes = {
  searchTitle: PropTypes.string,
  searchString: PropTypes.string,
  suggestiveMessage: PropTypes.string,
  didYouMean: PropTypes.array,
  suggestiveQueryClickCallback: PropTypes.func,
  lastSelectedCategory: PropTypes.string,
  similarProductsMessage: PropTypes.string
};
var InteractiveElementEvents = /* @__PURE__ */ ((InteractiveElementEvents2) => {
  InteractiveElementEvents2["CHANGE"] = "change";
  InteractiveElementEvents2["BLUR"] = "blur";
  InteractiveElementEvents2["MINUS_BUTTON"] = "minus_button";
  InteractiveElementEvents2["PLUS_BUTTON"] = "plus_button";
  return InteractiveElementEvents2;
})(InteractiveElementEvents || {});
const minInputVal = 1;
const maxInputVal = 99;
const incrementDecrementVal = 1;
const QuantitySelector = ({ ...props }) => {
  const {
    setQtySelectorInput,
    qtySelectorInput,
    defaultQty,
    maxQty,
    maxInputValue = maxInputVal,
    minInputValue = minInputVal,
    maximumQuantityError,
    path,
    quantityExceeded,
    disableErrors = false,
    disableErrorIcon = true,
    limitLabel = "",
    limitLabelShow = false,
    checkBannerMaxError,
    addToCartErrorData,
    disabled,
    id,
    limitMsg = "",
    disableMinQuantityReachedMessage = false,
    incrementDecrementValue = incrementDecrementVal,
    infoMessage,
    formatQuantity = false,
    a11yUpdatedQuantityText,
    setInteractiveElementEvent
  } = props;
  const inputRef = useRef(null);
  const [minQuantityReached, setMinQuantityReached] = useState(false);
  const language2 = getLanguage();
  const isAddErrorClass = useMemo(() => {
    return quantityExceeded || minQuantityReached;
  }, [minQuantityReached, quantityExceeded]);
  const errorClass = isAddErrorClass ? `${PREFIX}-qty-selector--error` : "";
  useEffect(() => {
    const inputEle = inputRef.current;
    if (formatQuantity) {
      inputEle.setAttribute("pattern", numberRegEx);
    } else {
      const preventNonNumericKeys = (event) => {
        if (invalidChars.indexOf(event.key) >= 0) {
          event.preventDefault();
        }
      };
      const invalidChars = ["-", "+", "e", "E", "."];
      inputEle.addEventListener("keydown", preventNonNumericKeys);
      return () => {
        inputEle.removeEventListener("keydown", preventNonNumericKeys);
      };
    }
    return void 0;
  }, [formatQuantity]);
  const qtySelectorInputOnChange = (val) => {
    const strValue = val.target.value.replace(inputFieldInvalidCharactersRegEx, "");
    const updatedVal = isNaN(Number(strValue)) ? qtySelectorInput : Number(strValue);
    val.target.value = String(updatedVal);
    if (updatedVal > maxInputValue) {
      return inputMaxRender(true);
    }
    inputMaxRender(false);
    setQtySelectorInput(updatedVal, true, inputRef);
    setInteractiveElementEvent && setInteractiveElementEvent(InteractiveElementEvents.CHANGE);
  };
  const onInputBlur = (val) => {
    const strValue = val.target.value.replace(inputFieldInvalidCharactersRegEx, "");
    const updatedVal = isNaN(Number(strValue)) ? qtySelectorInput : Number(strValue);
    val.target.value = formatQuantity ? updatedVal.toLocaleString(language2) : String(updatedVal);
    if (isNaN(updatedVal) || updatedVal < minInputValue) {
      setQtySelectorInput(defaultQty);
    }
    setInteractiveElementEvent && setInteractiveElementEvent(InteractiveElementEvents.BLUR);
  };
  const inputMaxRender = (value) => {
    if (checkBannerMaxError) {
      checkBannerMaxError(value);
    }
  };
  const decrementVal = () => {
    if (qtySelectorInput > minInputValue) {
      setQtySelectorInput(qtySelectorInput - incrementDecrementValue);
      inputMaxRender(false);
    } else {
      setMinQuantityReached(true);
    }
    setInteractiveElementEvent && setInteractiveElementEvent(InteractiveElementEvents.MINUS_BUTTON);
  };
  const incrementVal = () => {
    if (qtySelectorInput < maxInputValue) {
      setQtySelectorInput(qtySelectorInput + incrementDecrementValue);
    } else {
      inputMaxRender(true);
    }
    setInteractiveElementEvent && setInteractiveElementEvent(InteractiveElementEvents.PLUS_BUTTON);
  };
  const limitMessageDisplay = () => {
    if (!quantityExceeded && (limitLabel == null ? void 0 : limitLabel.length) && limitLabelShow) {
      return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-qty-error`, children: /* @__PURE__ */ jsx("p", { className: `${PREFIX}-qty-error__message`, "data-testid": "limitLabel", children: limitLabel }) });
    }
    return null;
  };
  const quantityExceededMessageDisplay = () => {
    if (quantityExceeded) {
      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-qty-error`, role: "alert", "aria-atomic": "true", children: [
        !disableErrorIcon && /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "md", path }),
        /* @__PURE__ */ jsx("p", { className: `${PREFIX}-qty-error__message`, children: replaceStrWithDynamicVal(maximumQuantityError, maxQty) })
      ] });
    }
    return null;
  };
  const addToCartErrorDataMessageDisplay = () => {
    if (addToCartErrorData) {
      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-qty-error`, role: "alert", "aria-atomic": "true", children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "md", path }),
        /* @__PURE__ */ jsx("p", { className: `${PREFIX}-qty-error__message`, children: replaceStrWithDynamicVal(maximumQuantityError, addToCartErrorData) })
      ] });
    }
    return null;
  };
  const showInlineMessage = (message, information) => {
    const infoMessageClassname = `${PREFIX}-qty-info`;
    if (checkDataLength(message)) {
      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-qty-error ${infoMessageClassname}`, role: "alert", "aria-atomic": "true", children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-information-blue-outline", size: "md", path }),
        /* @__PURE__ */ jsx("p", { className: `${PREFIX}-qty-error__message`, children: message })
      ] });
    }
    return null;
  };
  const minQuantityReachedMessageDisplay = () => {
    if (minQuantityReached && qtySelectorInput !== minInputValue) {
      setMinQuantityReached(false);
    }
    if (minQuantityReached) {
      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-qty-error`, role: "alert", "aria-atomic": "true", children: [
        !disableErrorIcon && /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "md", path }),
        /* @__PURE__ */ jsx("p", { className: `${PREFIX}-qty-error__message`, children: replaceStrWithDynamicVal(props.a11yMinQuantityReached, qtySelectorInput) })
      ] });
    }
    return null;
  };
  const inputValue = formatQuantity ? qtySelectorInput.toLocaleString(language2) : qtySelectorInput;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-qty-selector ${errorClass}`, "data-qm-allow": "true", children: [
      /* @__PURE__ */ jsx(
        "button",
        {
          "aria-label": props.a11yQuantityDecrementLabel,
          className: `${PREFIX}-qty-selector__minus-btn`,
          onClick: decrementVal,
          disabled,
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-subtract", size: "sm", path })
        }
      ),
      /* @__PURE__ */ jsx(
        "input",
        {
          "aria-label": props.a11yQuantityInputAriaLabel,
          className: `${PREFIX}-qty-selector__text-input`,
          id,
          "data-testid": id,
          max: maxInputValue,
          min: minInputValue,
          onBlur: onInputBlur,
          onChange: qtySelectorInputOnChange,
          ref: inputRef,
          type: formatQuantity ? "text" : "number",
          disabled,
          value: inputValue
        }
      ),
      /* @__PURE__ */ jsx(
        "button",
        {
          "aria-label": props.a11yQuantityIncrementLabel,
          className: `${PREFIX}-qty-selector__plus-btn`,
          onClick: incrementVal,
          "aria-disabled": disabled,
          disabled,
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-plus", size: "sm", path })
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { id: `quantity-update-${id}`, className: "sr-only", role: "status", "aria-live": "polite", children: replaceStrWithDynamicVal(a11yUpdatedQuantityText, qtySelectorInput) }),
    limitMsg && limitMsg.length && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-qty-selector__pdp-label`, children: limitMsg }),
    !disableErrors && /* @__PURE__ */ jsxs(Fragment, { children: [
      limitMessageDisplay(),
      quantityExceededMessageDisplay(),
      addToCartErrorDataMessageDisplay(),
      !disableMinQuantityReachedMessage && minQuantityReachedMessageDisplay(),
      infoMessage && showInlineMessage(infoMessage)
    ] })
  ] });
};
QuantitySelector.defaultProps = {
  disabled: false,
  id: "inputBox"
};
QuantitySelector.propTypes = {
  setQtySelectorInput: PropTypes.func,
  qtySelectorInput: PropTypes.number,
  defaultQty: PropTypes.number,
  maxQty: PropTypes.number,
  maxInputValue: PropTypes.number,
  maximumQuantityError: PropTypes.string,
  path: PropTypes.string,
  quantityExceeded: PropTypes.bool,
  disableErrors: PropTypes.bool,
  disableErrorIcon: PropTypes.bool,
  limitLabel: PropTypes.string,
  limitLabelShow: PropTypes.bool,
  checkBannerMaxError: PropTypes.func,
  addToCartErrorData: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  a11yQuantityDecrementLabel: PropTypes.string.isRequired,
  a11yQuantityIncrementLabel: PropTypes.string.isRequired,
  a11yQuantityInputAriaLabel: PropTypes.string,
  a11yQuantityLabel: PropTypes.string.isRequired,
  a11yMinQuantityReached: PropTypes.string,
  limitMsg: PropTypes.string,
  disableMinQuantityReachedMessage: PropTypes.bool
};
const MODAL_OPEN_CLASS = "modal-open";
const MODAL_OPEN_CLASS_NOT_SCROLL = "modal-open-not-scroll";
const ReactModal = (props) => {
  const modalHeightClass = props.isHeightFix ? `${PREFIX}-react-modal__modal-container--height-fix` : `${PREFIX}-react-modal__modal-container--height-not-fix`;
  const packageClass = !props.isModalPadding ? "" : `${PREFIX}-react-modal__modal-container--auto-package`;
  const { closeHandler, type } = props;
  const closeModalEscRef = useRef(null);
  const modalRef = useRef(null);
  const focusLockEventRef = useRef();
  useEffect(() => {
    const modalClass = props.notScroll ? MODAL_OPEN_CLASS_NOT_SCROLL : MODAL_OPEN_CLASS;
    if (props.isOpen) {
      document.body.classList.add(modalClass);
    } else {
      document.body.classList.remove(modalClass);
    }
    return () => {
      document.body.classList.remove(modalClass);
    };
  }, [props.isOpen, props.notScroll]);
  const closeModalEsc = useCallback(
    (e) => {
      if (e.keyCode === keyCodes.esc) {
        closeHandler();
      }
    },
    [closeHandler]
  );
  useEffect(() => {
    if (props.isOpen) {
      if (closeModalEscRef.current) {
        document.body.removeEventListener("keydown", closeModalEscRef.current);
      }
      document.body.addEventListener("keydown", closeModalEsc);
      closeModalEscRef.current = closeModalEsc;
    } else {
      document.body.removeEventListener("keydown", closeModalEscRef.current);
    }
  }, [props.isOpen, closeModalEsc]);
  useEffect(() => {
    if (props.isOpen) {
      focusLockEventRef.current = enableFocusLock(modalRef);
    } else {
      disableFocusLock(focusLockEventRef.current);
    }
  }, [props.isOpen]);
  return props.isOpen && /* @__PURE__ */ jsx(
    "div",
    {
      onClick: props.closeModalOnOutsideClick ? closeHandler : null,
      role: "presentation",
      className: `${PREFIX}-react-modal ${PREFIX}-overlay`,
      children: /* @__PURE__ */ jsx(
        "div",
        {
          ref: modalRef,
          className: `${PREFIX}-react-modal__modal-container ${PREFIX}-react-modal--${type} ${modalHeightClass} ${packageClass}`,
          role: props.role,
          "aria-modal": props.ariaModal,
          children: props.children
        }
      )
    }
  );
};
ReactModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  isHeightFix: PropTypes.bool,
  isModalPadding: PropTypes.bool,
  notScroll: PropTypes.bool,
  closeHandler: PropTypes.func,
  role: PropTypes.string,
  ariaModal: PropTypes.bool,
  type: PropTypes.oneOf(["bottom-sheet", ""])
};
const HEADER_ELEMENT_ID = "modal-header";
const FOOTER_ELEMENT_ID = "modal-footer";
const HEADER_SHADOW_CLASS = "header-shadow";
const FOOTER_SHADOW_CLASS = "footer-shadow";
const RichTextModal = ({ ...props }) => {
  const {
    closeRichTextModal,
    isRichTextModalOpen,
    overlayHeaderLabel,
    overlaySubHeaderLabel,
    overlayContent,
    overlayContinueLabel,
    overlayCancelLabel,
    path,
    overlayChildren,
    onContinueClicked,
    heightNotFixed,
    hideFooterCTA,
    closeModalOnOutsideClick
  } = props;
  const componentClassName2 = `${PREFIX}-safety-modal`;
  const contentEle = useRef(null);
  useEffect(() => {
    if (isRichTextModalOpen && contentEle && contentEle.current) {
      const { scrollHeight, clientHeight } = contentEle.current;
      if (scrollHeight > clientHeight) {
        const footerEle = document.getElementById(FOOTER_ELEMENT_ID);
        footerEle.classList.add(FOOTER_SHADOW_CLASS);
      }
    }
  }, [isRichTextModalOpen]);
  const contentRef = useRef(null);
  const onContentScroll = (e) => {
    const headerEle = document.getElementById(HEADER_ELEMENT_ID);
    const footerEle = document.getElementById(FOOTER_ELEMENT_ID);
    const {
      currentTarget: { scrollTop, scrollHeight, clientHeight }
    } = e;
    const delta = 1;
    const hasReachedBottom = scrollHeight - scrollTop <= clientHeight + delta;
    if (scrollTop > 0) {
      headerEle.classList.add(HEADER_SHADOW_CLASS);
    } else {
      headerEle.classList.remove(HEADER_SHADOW_CLASS);
    }
    if (hasReachedBottom) {
      footerEle.classList.remove(FOOTER_SHADOW_CLASS);
    } else {
      footerEle.classList.add(FOOTER_SHADOW_CLASS);
    }
  };
  const modalClassName = `${PREFIX}-react-modal`;
  const previousElement = document.querySelector(`button[${previousElementName}]`);
  const onCloseSafetyModal = (isContinueClicked) => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    closeRichTextModal(isContinueClicked);
    if (!isContinueClicked && previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  const onWarningModalContinueClicked = () => {
    onContinueClicked && onContinueClicked();
    onCloseSafetyModal(true);
  };
  const isHeightFixed = !!heightNotFixed ? false : true;
  const packageMarginClass = props.isPackageModal ? `${componentClassName2}__subheader-package` : "";
  const contentSlimModifier = props.hideFooterCTA ? `${componentClassName2}__content--slim` : "";
  const footerSlimModifier = props.hideFooterCTA ? `${componentClassName2}__footer--slim` : "";
  const handlePrevent = (e) => {
    e.stopPropagation();
  };
  return /* @__PURE__ */ jsx(
    ReactModal,
    {
      closeHandler: () => onCloseSafetyModal(false),
      isOpen: isRichTextModalOpen,
      isHeightFix: isHeightFixed,
      closeModalOnOutsideClick,
      isModalPadding: props.isPackageModal,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          onClick: closeModalOnOutsideClick ? handlePrevent : null,
          role: "presentation",
          className: componentClassName2,
          ref: contentRef,
          children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: `${componentClassName2}__header-container`,
                id: HEADER_ELEMENT_ID,
                "data-testid": HEADER_ELEMENT_ID,
                children: [
                  /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__close-container`, children: /* @__PURE__ */ jsx(
                    "button",
                    {
                      "data-testid": "rich-close-modal",
                      className: `${componentClassName2}__close-btn`,
                      onClick: () => onCloseSafetyModal(false),
                      "aria-label": "close",
                      children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg", path })
                    }
                  ) }),
                  /* @__PURE__ */ jsx("h3", { className: `${componentClassName2}__header-text`, children: overlayHeaderLabel })
                ]
              }
            ),
            overlayChildren ? /* @__PURE__ */ jsxs(
              "div",
              {
                className: `${componentClassName2}__content ${contentSlimModifier}`,
                onScroll: onContentScroll,
                ref: contentEle,
                "data-testid": "content",
                children: [
                  /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__subheader-text ${packageMarginClass}`, children: overlaySubHeaderLabel }),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: `${componentClassName2}__subheader-description ${packageMarginClass}`,
                      dangerouslySetInnerHTML: { __html: overlayContent }
                    }
                  ),
                  overlayChildren
                ]
              }
            ) : /* @__PURE__ */ jsx(
              "div",
              {
                className: `${componentClassName2}__content ${contentSlimModifier}`,
                dangerouslySetInnerHTML: { __html: overlayContent },
                onScroll: onContentScroll,
                ref: contentEle,
                "data-testid": "content"
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${componentClassName2}__footer ${footerSlimModifier}`,
                id: FOOTER_ELEMENT_ID,
                "data-testid": FOOTER_ELEMENT_ID,
                children: !hideFooterCTA && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(Button, { id: "rich-modal-continue", onClick: onWarningModalContinueClicked, size: "large", children: overlayContinueLabel }),
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      id: "btn-Warning",
                      type: "tertiary",
                      onClick: () => onCloseSafetyModal(false),
                      ariaLabel: "cancel",
                      children: overlayCancelLabel
                    }
                  )
                ] })
              }
            )
          ]
        }
      )
    }
  );
};
RichTextModal.propTypes = {
  closeRichTextModal: PropTypes.func.isRequired,
  isRichTextModalOpen: PropTypes.bool.isRequired,
  overlayHeaderLabel: PropTypes.string,
  overlayContent: PropTypes.string,
  overlayContinueLabel: PropTypes.string,
  overlayCancelLabel: PropTypes.string,
  overlaySubHeaderLabel: PropTypes.string,
  path: PropTypes.string,
  overlayChildren: PropTypes.element,
  onContinueClicked: PropTypes.func,
  heightNotFixed: PropTypes.bool,
  isPackageModal: PropTypes.bool
};
var SeparatorSize = /* @__PURE__ */ ((SeparatorSize2) => {
  SeparatorSize2["FULL_WIDTH"] = "full-width";
  SeparatorSize2["THREE_QUARTER_WIDTH"] = "three-quarter-width";
  SeparatorSize2["TWO_THIRD_WIDTH"] = "two-third-width";
  SeparatorSize2["HALF_WIDTH"] = "half-width";
  SeparatorSize2["QUARTER_WIDTH"] = "quarter-width";
  SeparatorSize2["THIRD_WIDTH"] = "third-width";
  SeparatorSize2["EIGHTH_WIDTH"] = "eighth-width";
  SeparatorSize2["SIXTEENTH_WIDTH"] = "sixteenth-width";
  return SeparatorSize2;
})(SeparatorSize || {});
var SeparatorStyle = /* @__PURE__ */ ((SeparatorStyle2) => {
  SeparatorStyle2["SKEW"] = "skew";
  SeparatorStyle2["VERTICAL"] = "vertical";
  SeparatorStyle2["HORIZONTAL"] = "horizontal";
  return SeparatorStyle2;
})(SeparatorStyle || {});
const Separator = ({ ...props }) => {
  const sepratorClass = `${PREFIX}-separator`;
  const { colors, size, style, reverseStyle = false } = props;
  const separatorColor = () => {
    return colors.map((color, i) => /* @__PURE__ */ jsx("div", { className: `${sepratorClass}__line ${sepratorClass}__line-${color}` }, i));
  };
  return /* @__PURE__ */ jsx("section", { className: `${sepratorClass}`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-${size}-wrapper`, children: /* @__PURE__ */ jsx(
    "div",
    {
      className: `${sepratorClass}__container ${sepratorClass}__${style}${reverseStyle ? "--reverse" : ""}`,
      children: separatorColor()
    }
  ) }) });
};
Separator.defaultProps = {
  size: SeparatorSize.FULL_WIDTH,
  style: SeparatorStyle.VERTICAL
};
Separator.propTypes = {
  size: PropTypes.oneOf([
    SeparatorSize.FULL_WIDTH,
    SeparatorSize.THREE_QUARTER_WIDTH,
    SeparatorSize.TWO_THIRD_WIDTH,
    SeparatorSize.HALF_WIDTH,
    SeparatorSize.QUARTER_WIDTH,
    SeparatorSize.THIRD_WIDTH,
    SeparatorSize.EIGHTH_WIDTH,
    SeparatorSize.SIXTEENTH_WIDTH
  ]),
  colors: PropTypes.arrayOf(PropTypes.oneOf([BrandingColors.TEAL, BrandingColors.RED, BrandingColors.BURGUNDY])).isRequired,
  style: PropTypes.oneOf([SeparatorStyle.SKEW, SeparatorStyle.VERTICAL, SeparatorStyle.HORIZONTAL])
};
const LinkRewardsBackground = ({ ...props }) => {
  const { children, dynamicBackground } = props;
  const { dynamicBGContent, dynamicImg, separator } = dynamicBackground || {};
  const mobileRow = window.innerWidth <= BREAKPOINTS.tabletMaxWidth ? "" : `${PREFIX}-row ${PREFIX}-row--no-gutters`;
  const renderTop = () => {
    return separator ? /* @__PURE__ */ jsx(Separator, { colors: separator.colors, style: separator.style, size: separator.size }) : /* @__PURE__ */ jsx("div", { className: `${PREFIX}-link-background__logo` });
  };
  const renderDynamicBgChild = () => {
    return dynamicBGContent ? dynamicBGContent : /* @__PURE__ */ jsx(Fragment, {});
  };
  const renderDynamicBg = () => {
    const isDynamicBg = dynamicImg ? { backgroundImage: `url(${dynamicImg})` } : {};
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-link-background__dynamic-bg`, style: isDynamicBg, children: renderDynamicBgChild() });
  };
  const separatorClass = separator ? `${mobileRow}` : "";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-link-background ${separatorClass} ${PREFIX}-full-width-container`,
      "data-testid": "link-background",
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${separator ? `${PREFIX}-col-sm-12 ${PREFIX}-col-md-9` : `${PREFIX}-link-background__wrapper`}`,
            children: [
              renderTop(),
              /* @__PURE__ */ jsx("div", { className: `${PREFIX}-link-background__content`, children }),
              renderTop()
            ]
          }
        ),
        checkDataLength(dynamicBackground) && /* @__PURE__ */ jsx("section", { className: `${PREFIX}-col-sm-12 ${PREFIX}-col-md-3`, children: renderDynamicBg() })
      ]
    }
  );
};
LinkRewardsBackground.propTypes = {
  children: PropTypes.element,
  path: PropTypes.string,
  dynamicBackground: PropTypes.object
};
const LinkRewardsCard = ({ ...props }) => {
  const { children, path, dynamicBackground } = props;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(LinkRewardsBackground, { path, dynamicBackground, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-link-card`, "data-testid": "link-card", children }) }) });
};
LinkRewardsCard.propTypes = {
  children: PropTypes.element,
  path: PropTypes.string,
  dynamicBackground: PropTypes.object
};
var CardType = /* @__PURE__ */ ((CardType2) => {
  CardType2["loyalty"] = "loyalty";
  CardType2["master"] = "master";
  CardType2["linkmaster"] = "master-link";
  return CardType2;
})(CardType || {});
const cardTypes = [
  {
    type: "loyalty",
    pattern: /(\d{1,4})(\d{1,4})(\d{1,4})/,
    readOnlyValue: "6365",
    placeholder: "0000 0000 0000",
    maxLength: 14
  },
  // Object used for details and validations of Loyalty Card
  {
    type: "master",
    pattern: /^[0-9]{4}/,
    readOnlyValue: "**** - **** - **** -",
    placeholder: "0000",
    maxLength: 4
  },
  // Object used for details and  validations of Master Card with masking character and placeholder
  {
    type: "master-link",
    pattern: /^[0-9]{4}/,
    readOnlyValue: null,
    placeholder: null,
    maxLength: 4
  }
  // Object used for details and  validations of Master Card without masking character and placeholder
];
const eventKeys = {
  enter: "Enter"
};
const CardInput = (props) => {
  const { id, label, cardType, value, onChange, cardImage, cardImageAltText, tooltip, inlineValidation, iconSize } = props;
  const [selectedCardType] = cardTypes.filter((item) => item.type === cardType);
  const { pattern, readOnlyValue, placeholder, maxLength } = selectedCardType;
  const [isFocused, setIsFocused] = useState(false);
  const cardInputRef = useRef(null);
  const componentClassName2 = `${PREFIX}-cardinput`;
  const validationClass = inlineValidation.msg ? `${componentClassName2}__container--${inlineValidation.style}` : "";
  const focusClass = isFocused ? `${componentClassName2}__container--focus` : "";
  const [visibility, setVisibility] = useState(false);
  const buttonRef = useRef();
  const checkIsNumeric = (e) => {
    if (!/^\d*$/.test(e.key) && e.key !== eventKeys.enter) {
      e.preventDefault();
    }
  };
  const formatCardNumber = (cardNumber) => {
    if (cardType === CardType.master || cardType === CardType.linkmaster) {
      return cardNumber;
    }
    const execResult = pattern.exec(cardNumber.split(" ").join(""));
    if (execResult) {
      const rangeStart = 1;
      const rangeEnd = 3;
      return execResult.splice(rangeStart, rangeEnd).filter((x) => x).join(" ");
    }
    return cardNumber;
  };
  const onCardInputChange = (changedValue) => {
    if (!cardNumberRegEx.test(changedValue)) {
      return;
    }
    cardInputRef.current.value = formatCardNumber(changedValue);
    onChange(cardInputRef.current.value);
  };
  const onCardInputKeyPress = (e) => {
    const inputValue = e.target.value;
    checkIsNumeric(e);
    if (inputValue) {
      const valueLength = inputValue.split(" ").join("").length;
      if (valueLength > maxLength) {
        e.preventDefault();
      }
    }
  };
  const toolTipButtonHandler = () => {
    setVisibility(!visibility);
  };
  return /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}`, children: [
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__container ${focusClass} ${validationClass}`, children: [
      /* @__PURE__ */ jsx("label", { className: `${componentClassName2}__label`, htmlFor: id, children: label }),
      /* @__PURE__ */ jsx("label", { className: `${componentClassName2}__disabled-label`, children: readOnlyValue }),
      /* @__PURE__ */ jsx(
        "input",
        {
          id,
          "data-testid": id,
          ref: cardInputRef,
          type: "tel",
          className: `${componentClassName2}__input`,
          placeholder,
          value,
          onChange: (e) => onCardInputChange(e.target.value),
          onFocus: () => setIsFocused(true),
          onBlur: () => setIsFocused(false),
          onKeyUp: (e) => onCardInputKeyPress(e),
          maxLength
        }
      ),
      cardImage && /* @__PURE__ */ jsx("img", { className: `${componentClassName2}__card-img`, src: cardImage, alt: cardImageAltText }),
      !!(tooltip == null ? void 0 : tooltip.showTooltip) && /* @__PURE__ */ jsx(
        Button,
        {
          ref: buttonRef,
          modifierClass: `${componentClassName2}__tooltip--btn`,
          type: "icon_button",
          "data-qm-allow": "true",
          onClick: toolTipButtonHandler,
          "data-testid": "tooltip-btn",
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-information-details", size: "md" })
        }
      ),
      !!visibility && /* @__PURE__ */ jsx(
        Tooltip,
        {
          visibility,
          setVisibility,
          iconID: "ct-close",
          headerText: tooltip.tooltipHeaderText,
          bodyText: tooltip.tooltipBodyText,
          coords: buttonRef.current
        }
      )
    ] }),
    (inlineValidation == null ? void 0 : inlineValidation.msg) && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__${inlineValidation.style}`, role: "alert", children: [
      /* @__PURE__ */ jsx(Icon, { type: inlineValidation.icon, size: iconSize, path: inlineValidation.path }),
      /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__${inlineValidation.style}-text`, children: inlineValidation.msg })
    ] })
  ] });
};
CardInput.defaultProps = {
  cardType: "loyalty",
  iconSize: "sm",
  inlineValidation: {
    icon: "ct-input-error",
    style: "error"
  }
};
CardInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  cardType: PropTypes.string,
  path: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  cardImage: PropTypes.string,
  cardImageAltText: PropTypes.string
};
const Wishlist = (props) => {
  const {
    wishlistUrl,
    a11yWishlist,
    ariaLabelWishlist,
    wishlistCount,
    maximumCount,
    path,
    label,
    featureType,
    isSideNav
  } = props;
  const wishlistLabel = () => !!label && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-wishlist__label`, children: label });
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-wishlist${isSideNav ? "-nav" : ""}`, "data-testid": "header-wishlist", children: /* @__PURE__ */ jsxs(
    "a",
    {
      href: wishlistUrl,
      "aria-label": ariaLabelWishlist,
      "data-link-value": a11yWishlist,
      "data-feature-type": featureType,
      children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-favorite-inactive", title: "a11yWishlist", size: "lg", path, decorative: true }),
        wishlistCount > 0 && /* @__PURE__ */ jsx(Fragment, { children: wishlistCount > maximumCount ? /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-wishlist-badge ${PREFIX}-wishlist-max`, children: [
          maximumCount,
          "+"
        ] }) : /* @__PURE__ */ jsx("span", { className: `${PREFIX}-wishlist-badge`, children: wishlistCount }) }),
        wishlistLabel()
      ]
    }
  ) });
};
Wishlist.defaultProps = {
  label: ""
};
Wishlist.propTypes = {
  wishlistUrl: PropTypes.string,
  a11yWishlist: PropTypes.string,
  wishlistCount: PropTypes.number,
  path: PropTypes.string,
  maximumCount: PropTypes.number,
  label: PropTypes.string,
  featureType: PropTypes.string,
  ariaLabelWishlist: PropTypes.string
};
const Cart = (props) => {
  const { cartUrl, a11yCart, ariaLabelCart, cartCount, maximumCount, path, featureType, isCartStoreSelectorModal } = props;
  const renderCartIcon = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-cart", size: "lg", path, decorative: true }),
      cartCount > 0 && /* @__PURE__ */ jsx(Fragment, { children: cartCount > maximumCount ? /* @__PURE__ */ jsxs("span", { className: `${PREFIX}-cart-badge ${PREFIX}-cart-max`, children: [
        maximumCount,
        "+"
      ] }) : /* @__PURE__ */ jsx("span", { className: `${PREFIX}-cart-badge`, children: cartCount }) }),
      isCartStoreSelectorModal && /* @__PURE__ */ jsx("span", { className: `${PREFIX}-cart-badge ${PREFIX}-all-in-stock` })
    ] });
  };
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-cart`, "data-testid": "header-cart", children: cartUrl ? /* @__PURE__ */ jsx("a", { href: cartUrl, "aria-label": ariaLabelCart, "data-link-value": a11yCart, "data-feature-type": featureType, children: renderCartIcon() }) : renderCartIcon() });
};
Cart.propTypes = {
  cartUrl: PropTypes.string,
  a11yCart: PropTypes.string,
  cartCount: PropTypes.number,
  maximumCount: PropTypes.number,
  path: PropTypes.string,
  featureType: PropTypes.string,
  ariaLabelCart: PropTypes.string
};
const componentClassName$2 = `${PREFIX}-facet-modal`;
const renderFlyoutModalFooter = (enableVerticalFilterToggle, isMobileOrTablet, enableSortByFacet, mSortByCTALabel, modifiedCloseFlyout, ctaLabel) => {
  return enableVerticalFilterToggle && !isMobileOrTablet ? null : /* @__PURE__ */ jsx("div", { className: `${componentClassName$2}__footer`, children: enableSortByFacet ? /* @__PURE__ */ jsx(Button, { id: "add-to-cart", type: "primary", size: "large", onClick: modifiedCloseFlyout, children: mSortByCTALabel }) : /* @__PURE__ */ jsx(Button, { size: "large", onClick: modifiedCloseFlyout, children: ctaLabel }) });
};
const renderFlyoutModalHeader = (enableVerticalFilterToggle, isMobileOrTablet, isTriangleOffer, renderTitleFacet, modifiedCloseFlyout, closeBtnLabel, path) => {
  return enableVerticalFilterToggle && !isMobileOrTablet ? null : /* @__PURE__ */ jsxs("div", { className: `${componentClassName$2}__header`, children: [
    !isTriangleOffer && renderTitleFacet(),
    /* @__PURE__ */ jsx(
      "button",
      {
        className: `${componentClassName$2}__close-btn`,
        onClick: modifiedCloseFlyout,
        "aria-label": closeBtnLabel,
        title: closeBtnLabel,
        children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg", path })
      }
    )
  ] });
};
const isVerticalFilters = (enableVerticalFilterToggle, isMobileOrTablet) => {
  return enableVerticalFilterToggle && !isMobileOrTablet;
};
const FlyoutModalComponent = ({
  children,
  closeFlyout,
  isOpen,
  modalTriggeredElement,
  disableCloseByEscOrOutsideClick = false,
  title,
  isStoreSelectorModalUsed,
  isPrerender,
  enableVerticalFilterToggle
}) => {
  const flyOutContent = useRef(null);
  const modalClassName = `${PREFIX}-flyout-modal-overlay`;
  const undoAccessibilityProps = useMemo(
    () => ({
      modalOpen: false,
      modalClassName
    }),
    [modalClassName]
  );
  const previousElement = document.querySelector(`button[${previousElementName}]`) || modalTriggeredElement;
  const focusLockEventRef = useRef();
  const isMobileOrTablet = useIsMobile(BREAKPOINTS.tabletMaxWidth);
  const closeHandler = useCallback(
    (event) => {
      if ((event == null ? void 0 : event.target).contains(flyOutContent.current) || (event == null ? void 0 : event.keyCode) === keyCodes.esc && !disableCloseByEscOrOutsideClick) {
        modalAccessibilityHandler(undoAccessibilityProps);
        closeFlyout();
        if (previousElement) {
          previousElement.focus();
          previousElement.removeAttribute(previousElementName);
        }
      }
    },
    [closeFlyout, previousElement, undoAccessibilityProps, disableCloseByEscOrOutsideClick]
  );
  useEffect(() => {
    if (isOpen) {
      document.body.style.position = "relative";
    }
    return () => {
      document.body.style.position = "unset";
    };
  }, [isOpen]);
  const closeModalEsc = useCallback(
    (e) => {
      closeHandler(e);
    },
    [closeHandler]
  );
  useEffect(() => {
    if (isOpen) {
      flyOutContent.current.addEventListener("keydown", closeModalEsc);
    } else {
      flyOutContent.current.removeEventListener("keydown", closeModalEsc);
    }
  }, [isOpen, closeModalEsc]);
  useEffect(() => {
    if (open) {
      if (!isStoreSelectorModalUsed && !isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet)) {
        focusLockEventRef.current = enableFocusLock(flyOutContent);
      }
    } else {
      !isStoreSelectorModalUsed && disableFocusLock(focusLockEventRef.current);
    }
  }, [isOpen, isStoreSelectorModalUsed]);
  useClickOutsideClose(flyOutContent, closeHandler, isOpen, !disableCloseByEscOrOutsideClick, true);
  const verticalAlignFiltersClass = isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet) ? `${PREFIX}-flyout-modal-component--vertical-align-filters` : "";
  const prerenderClass = isPrerender ? `${PREFIX}-sm-none ${PREFIX}-xs-none` : "";
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet) ? `${verticalAlignFiltersClass}--sticky` : `${PREFIX}-overlay ${modalClassName} ${prerenderClass} `,
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-flyout-modal-component ${verticalAlignFiltersClass}`,
          ref: flyOutContent,
          role: isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet) ? "region" : "dialog",
          "aria-modal": "true",
          "aria-label": isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet) ? "" : title,
          children
        }
      )
    }
  );
};
FlyoutModalComponent.displayName = "FlyoutModalComponent";
const CartServicesComponent = ({ ...props }) => {
  const {
    path,
    serviceAddOnLabel,
    serviceAddOnNextSteps,
    serviceAddOnIcon,
    serviceAddOnAvailableLabel,
    addServiceToCartLabel,
    cartServices,
    addedServiceToCart,
    serviceAddToCartHandler,
    serviceDescription,
    onFlyout,
    parentProduct
  } = props;
  const parentClass = `${PREFIX}-cart-services`;
  const serviceLength = 1;
  const singleService = cartServices.length === serviceLength;
  const initialServiceSelectValue = singleService ? cartServices[0].name : "";
  const [serviceSelect, setServiceSelect] = useState(initialServiceSelectValue);
  const [code, setCode] = useState({});
  const titleComponent = () => {
    const flyoutLabel = (addedServiceToCart == null ? void 0 : addedServiceToCart.success) ? serviceAddOnLabel : serviceAddOnAvailableLabel;
    const description = !(addedServiceToCart == null ? void 0 : addedServiceToCart.success) ? serviceDescription : `${serviceSelect}`;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-installation__icon`, children: /* @__PURE__ */ jsx(Icon, { type: serviceAddOnIcon, size: "lg", path }) }),
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-service__title`, children: [
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-service__title-name`, children: onFlyout ? flyoutLabel : serviceAddOnLabel }),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-service__title-description`, children: onFlyout ? description : replaceStrWithDynamicVal(serviceDescription, cartServices.length) })
      ] })
    ] });
  };
  const addServiceToCartHandler = () => {
    const selectedServiceCode = singleService ? cartServices : [code];
    serviceAddToCartHandler(selectedServiceCode, parentProduct);
  };
  const onSelectService = (sku, serviceItem) => {
    setServiceSelect(sku);
    setCode(serviceItem);
  };
  const panelClass = singleService ? `${parentClass}__panel--single` : `${parentClass}__panel`;
  const singleServiceComponent = (singleServiceItem) => {
    return !onFlyout && singleService && /* @__PURE__ */ jsx("div", { className: `${parentClass}__single-service-title`, children: singleServiceItem });
  };
  const formatPrice = localization.formattedPrice;
  const language2 = getLanguage();
  const renderServices = () => {
    return !(addedServiceToCart == null ? void 0 : addedServiceToCart.success) ? /* @__PURE__ */ jsx(Fragment, { children: cartServices.map((serviceItem, i) => /* @__PURE__ */ jsxs("div", { className: panelClass, children: [
      /* @__PURE__ */ jsxs("div", { className: `${panelClass}__not-on-flyout`, children: [
        !singleService && /* @__PURE__ */ jsx(
          Radio,
          {
            id: `${serviceItem.sku}_${parentProduct.entryNumber}`,
            label: serviceItem.name,
            name: "service-installation",
            checked: serviceSelect === serviceItem.sku,
            onChange: () => onSelectService(serviceItem.sku, serviceItem)
          }
        ),
        singleServiceComponent(serviceItem.name),
        /* @__PURE__ */ jsxs("div", { className: `${parentClass}__panel-content`, children: [
          /* @__PURE__ */ jsx("p", { className: `${parentClass}__description`, children: serviceItem == null ? void 0 : serviceItem.shortDescription }),
          onFlyout && /* @__PURE__ */ jsx("span", { className: `${parentClass}__price`, children: formatPrice(language2, serviceItem == null ? void 0 : serviceItem.price, currencyShortForm, currencyFormat) })
        ] })
      ] }),
      !onFlyout && /* @__PURE__ */ jsx("span", { className: `${parentClass}__price`, children: formatPrice(language2, serviceItem == null ? void 0 : serviceItem.price, currencyShortForm, currencyFormat) })
    ] }, i)) }) : /* @__PURE__ */ jsxs("div", { className: `${parentClass}__service-next-steps`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-information-details  ", size: "lg", path }),
      /* @__PURE__ */ jsx("span", { className: `${parentClass}__service-next-steps-label`, children: serviceAddOnNextSteps })
    ] });
  };
  const accordionSettings = (singleService || (addedServiceToCart == null ? void 0 : addedServiceToCart.success)) && onFlyout;
  const accordionSettingsClassName = `${parentClass} ${parentClass}--single`;
  return /* @__PURE__ */ jsx("div", { className: `${accordionSettings ? accordionSettingsClassName : parentClass}`, children: /* @__PURE__ */ jsx(
    Accordion,
    {
      title: titleComponent(),
      hideControls: accordionSettings,
      isHeaderOpen: accordionSettings,
      disableOnClick: accordionSettings,
      children: /* @__PURE__ */ jsxs(Fragment, { children: [
        renderServices(),
        (serviceSelect || singleService) && !(addedServiceToCart == null ? void 0 : addedServiceToCart.success) && /* @__PURE__ */ jsx(Button, { type: "secondary", buttonType: "button", size: "small", onClick: addServiceToCartHandler, children: addServiceToCartLabel })
      ] })
    }
  ) });
};
CartServicesComponent.defaultProps = {
  onFlyout: true
};
CartServicesComponent.propTypes = {
  path: PropTypes.string,
  cartServices: PropTypes.array,
  addServiceToCartLabel: PropTypes.string,
  serviceAddOnAvailableLabel: PropTypes.string,
  serviceAddOnIcon: PropTypes.string,
  serviceAddOnLabel: PropTypes.string,
  serviceAddOnNextSteps: PropTypes.string,
  addedServiceToCart: PropTypes.any,
  serviceAddToCartHandler: PropTypes.func,
  serviceDescription: PropTypes.string,
  onFlyout: PropTypes.bool,
  parentProduct: PropTypes.object
};
const ServiceInstallationMessage = ({ ...props }) => {
  const { installLabel, serviceAvailabiity, children } = props;
  const availabilityClass = serviceAvailabiity ? `${PREFIX}-installation-msg--available` : `${PREFIX}-installation-msg--not-available`;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${PREFIX}-installation-msg ${availabilityClass} ${!props.isCartFlyout ? `${PREFIX}-col-sm-6` : ""}`,
      children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-installation-msg__detail`, children: [
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-installation-msg__header`, children: /* @__PURE__ */ jsx("h4", { className: `${PREFIX}-installation-msg__title`, children: installLabel }) }),
        children
      ] })
    }
  );
};
ServiceInstallationMessage.propTypes = {
  installLabel: PropTypes.string,
  serviceAvailabiity: PropTypes.bool,
  isCartFlyout: PropTypes.bool,
  children: PropTypes.element
};
const SnippetCard = ({ ...props }) => {
  const {
    title,
    description,
    imageOffSet,
    image,
    imageAlt,
    children,
    separatorProps,
    footerContent,
    customClass = "",
    iconType,
    customSectionClass = "",
    hideShadow,
    imageAlignment,
    contentVerticalAlignment = "start"
  } = props;
  const classname = `${PREFIX}-snippet-card`;
  const shadowClassName = hideShadow ? `${classname}$--no-shadow` : "";
  const separatorColors = (separatorProps == null ? void 0 : separatorProps.colors) ? separatorProps.colors : [BrandingColors.RED, BrandingColors.BURGUNDY, BrandingColors.TEAL];
  const separatorStyle = (separatorProps == null ? void 0 : separatorProps.style) ? separatorProps.style : SeparatorStyle.SKEW;
  const renderCardDetails = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    title && /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: title, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
      "div",
      {
        className: `${classname}__title`,
        dangerouslySetInnerHTML: { __html: memoizedStringContent }
      }
    ) }),
    description && /* @__PURE__ */ jsx("div", { className: `${classname}__label`, dangerouslySetInnerHTML: { __html: description } })
  ] });
  const renderIcon = () => {
    if (iconType) {
      return /* @__PURE__ */ jsx("div", { className: `${classname}__icon`, children: /* @__PURE__ */ jsx(Icon, { type: iconType, size: "lg" }) });
    }
    return null;
  };
  const renderImageOrIcon = () => {
    const offsetClass = `${classname}__img${imageOffSet ? "--offset" : ""}`;
    const alignmentClass = imageAlignment ? `${PREFIX}-${imageAlignment.size}-align-self-${imageAlignment.alignment}` : "";
    return image ? /* @__PURE__ */ jsx("img", { className: `${offsetClass} ${alignmentClass}`, src: image, alt: imageAlt, "aria-hidden": "true" }) : /* @__PURE__ */ jsx(Fragment, { children: renderIcon() });
  };
  return /* @__PURE__ */ jsxs("section", { className: `${classname} ${shadowClassName} ${customSectionClass}`, children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${PREFIX}-xs-flex ${customClass} ${PREFIX}-xs-align-items-${contentVerticalAlignment} ${classname}__container${imageOffSet ? "--offset" : ""}`,
        children: [
          renderImageOrIcon(),
          /* @__PURE__ */ jsxs("div", { className: `${classname}__details${imageOffSet ? "--offset" : ""}`, children: [
            renderCardDetails(),
            children
          ] })
        ]
      }
    ),
    footerContent,
    separatorProps && /* @__PURE__ */ jsx(Separator, { colors: separatorColors, style: separatorStyle })
  ] });
};
const CartFlyout = (props) => {
  const {
    isOpen,
    certonaInitialization,
    path,
    closeFlyout,
    addToCartSingularLabel,
    addToCartPluralLabel,
    cartButtonLabel,
    continueLinkLabel,
    cartModifications,
    finalCartModifications,
    closeBtnLabel,
    cartServices,
    serviceAddOnLabel,
    serviceAddOnAvailableLabel,
    addServiceToCartLabel,
    serviceAddOnNextSteps,
    serviceAddToCartHandler,
    addedServiceToCart,
    serviceDescription,
    recommendationsCarousel,
    serviceInstallationProps,
    isAutoInstallationReq,
    autoPackagesDiffTireLabel,
    autoPackageChooseWheelCTA,
    autoPackageChooseTireCTA,
    autoPackagesDiffWheelLabel,
    currentSelectedContainer,
    nextSelectedPackage,
    changeSelectedLink,
    autoPackagesUpdatedTiresTitle,
    autoPackagesUpdatedWheelsTitle,
    chooseCTAHandler,
    selectDiffTireWheel,
    tireData,
    wheelData,
    continueToCart,
    isWheelOrTire,
    isPackageFlow,
    cartCount,
    renderPackageUpselling,
    renderPackageCompleteMessage,
    createPackageAndNavigate,
    enableCustomOrder,
    heliumInflationAddToCartEnabled,
    isHeliumInflationOptionEnabled,
    heliumFilledButtonLabel,
    uninflatedButtonLabel,
    inflationButtonLabel,
    balloonAddonOptionsComponent,
    triggerAddToCartBundleApi,
    setShouldCloseFlyout,
    isSendBundleApi,
    renderNewAOAServiceMessage
  } = props;
  const numberOfItems = useRef(cartModifications.numberOfItems);
  const images = useRef(cartModifications.entry.images);
  const name = useRef(cartModifications.entry.name);
  const options = useRef(cartModifications.entry.options);
  const code = useRef(cartModifications.entry.code);
  const {
    installLabel,
    shoppingAtText,
    storeName,
    phone,
    serviceAvailabiity,
    availabilityLabel,
    enableAOAFlowMessaging
  } = serviceInstallationProps;
  const serviceInstallationMessageProps = {
    installLabel,
    serviceAvailabiity,
    isCartFlyout: true
  };
  const componentClassName2 = `${PREFIX}-cart-flyout`;
  const singleItemNumber = 1;
  const totalProductCount = numberOfItems.current + Number(cartCount);
  const itemsQuantityAdded = (addedServiceToCart == null ? void 0 : addedServiceToCart.success) ? totalProductCount + singleItemNumber : totalProductCount;
  const labelToReplace = itemsQuantityAdded === singleItemNumber ? addToCartSingularLabel : addToCartPluralLabel;
  const addedToCartTitle = replaceStrWithDynamicVal(labelToReplace, itemsQuantityAdded);
  const { iconType, title, description, CTA, CTALink } = renderPackageUpselling || {};
  const goToCartPage = (buttonName) => {
    setShowSpinner(true);
    if (isSendBundleApi) {
      triggerAddToCartBundleApi();
    } else {
      continueToCart(buttonName);
    }
  };
  const modalClassName = `${PREFIX}-flyout-modal-overlay`;
  const addToCartBtnElem = document.getElementById("add-to-cart");
  const modifiedCloseFlyout = () => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    certonaInitialization == null ? void 0 : certonaInitialization(`${code.current}P`);
    if (isSendBundleApi) {
      triggerAddToCartBundleApi();
      setShouldCloseFlyout(true);
    } else {
      closeFlyout();
    }
    if (addToCartBtnElem) {
      addToCartBtnElem.focus();
      addToCartBtnElem.removeAttribute(previousElementName);
    }
  };
  const renderballoonAddonOptionsComponent = () => {
    return /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__recommendations_carousel`, children: balloonAddonOptionsComponent });
  };
  const [showSpinner, setShowSpinner] = useState(false);
  const renderRecommendationsComponent = () => {
    return /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__recommendations_carousel`, children: recommendationsCarousel });
  };
  const renderServiceComponentChildren = () => {
    const isChildrenVisible = !enableAOAFlowMessaging || !serviceAvailabiity || !isWheelOrTire && serviceAvailabiity;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      isChildrenVisible && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-installation-msg__shopping-at`, children: [
          shoppingAtText,
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-installation-msg__shopping-at__store`, children: storeName })
        ] }),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-installation-msg__phone`, children: /* @__PURE__ */ jsx("a", { href: `tel:${phone}`, children: phone }) })
      ] }),
      availabilityLabel && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-installation-msg__desc`, children: availabilityLabel })
    ] });
  };
  const renderServiceComponent = () => {
    if (isAutoInstallationReq) {
      if (renderNewAOAServiceMessage) {
        return renderNewAOAServiceMessage();
      }
      return /* @__PURE__ */ jsx(ServiceInstallationMessage, { ...serviceInstallationMessageProps, children: renderServiceComponentChildren() });
    }
    if ((addedServiceToCart == null ? void 0 : addedServiceToCart.success) || isArrayNotEmpty(cartServices)) {
      return /* @__PURE__ */ jsx(
        CartServicesComponent,
        {
          cartServices,
          serviceAddOnLabel,
          serviceAddOnAvailableLabel,
          addServiceToCartLabel,
          serviceAddOnIcon: "ct-tools",
          serviceAddOnNextSteps,
          serviceAddToCartHandler,
          addedServiceToCart,
          serviceDescription,
          parentProduct: cartModifications.entry
        }
      );
    }
    return null;
  };
  const renderFooterButton = (buttonName, handleClickMethod) => {
    return /* @__PURE__ */ jsx(
      Button,
      {
        id: "footer-btn",
        onClick: () => {
          handleClickMethod(buttonName);
        },
        size: "large",
        ariaLabel: buttonName,
        label: buttonName,
        showSpinner
      }
    );
  };
  const handleFooterButton = () => {
    if (!nextSelectedPackage) {
      if (currentSelectedContainer === productWheelTypes.Tire) {
        return renderFooterButton(autoPackageChooseWheelCTA, chooseCTAHandler);
      } else if (currentSelectedContainer === productWheelTypes.Wheel) {
        return renderFooterButton(autoPackageChooseTireCTA, chooseCTAHandler);
      }
    } else if (nextSelectedPackage) {
      return renderFooterButton(cartButtonLabel, goToCartPage);
    }
    return null;
  };
  const renderTireWheelLabel = (selectedPackage) => {
    const selectDiffLabel = selectedPackage === productWheelTypes.Tire ? autoPackagesDiffTireLabel : autoPackagesDiffWheelLabel;
    return /* @__PURE__ */ jsx(
      Button,
      {
        id: "diff-wheel-btn",
        type: "tertiary",
        size: "mini",
        onClick: () => selectDiffTireWheel(selectedPackage, selectDiffLabel),
        children: selectDiffLabel
      }
    );
  };
  const checkTireWheelData = (tireContainerData, wheelContainerData) => {
    return tireContainerData && Object.values(tireContainerData).length > 0 || wheelContainerData && Object.values(wheelContainerData).length > 0;
  };
  const renderChangeLabel = (selectedPackage) => {
    if (selectedPackage === productWheelTypes.Tire && changeSelectedLink && checkTireWheelData(tireData, wheelData)) {
      return /* @__PURE__ */ jsx(Fragment, { children: autoPackagesUpdatedTiresTitle });
    } else if (selectedPackage === productWheelTypes.Wheel && changeSelectedLink && checkTireWheelData(tireData, wheelData)) {
      return /* @__PURE__ */ jsx(Fragment, { children: autoPackagesUpdatedWheelsTitle });
    } else {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "md" }),
        addedToCartTitle
      ] });
    }
  };
  const handleChangeLabel = () => renderChangeLabel(!nextSelectedPackage ? currentSelectedContainer : nextSelectedPackage);
  const checkPackageFlowConditions = () => {
    return isPackageFlow && isWheelOrTire && getPageType() === pageTypes$1.pdpPage;
  };
  const handlePlpLabel = (item) => {
    var _a;
    if (currentSelectedContainer && !nextSelectedPackage && checkPackageFlowConditions()) {
      return renderTireWheelLabel(currentSelectedContainer);
    } else if (nextSelectedPackage && checkPackageFlowConditions()) {
      return renderTireWheelLabel(nextSelectedPackage);
    } else {
      const filteredOptions = (_a = item ? item.entry.options : options.current) == null ? void 0 : _a.filter(
        (option) => !props.hideVariants.includes(option.descriptor)
      );
      const optionsForRender = enableCustomOrder ? getSortVariants(filteredOptions) : filteredOptions;
      return isArrayNotEmpty(optionsForRender) && /* @__PURE__ */ jsx(Fragment, { children: optionsForRender.map((option, index2) => {
        return /* @__PURE__ */ jsxs("p", { className: `${componentClassName2}__product-variant`, children: [
          option.display,
          ": ",
          option.value
        ] }, index2);
      }) });
    }
  };
  const getHeliumInflationLabel = (selectedStoreServices, supportedStoreServices) => {
    const isHeliumAddonSupported = supportedStoreServices == null ? void 0 : supportedStoreServices.some(
      (service) => service.value === inflationData.heliumAddOn
    );
    if (heliumInflationAddToCartEnabled && selectedStoreServices && isHeliumAddonSupported) {
      let label = "";
      const isHeliumAddonSelected = selectedStoreServices == null ? void 0 : selectedStoreServices.some((item) => item.value === inflationData.heliumAddOn);
      if (isHeliumAddonSelected && isHeliumInflationOptionEnabled) {
        label = heliumFilledButtonLabel;
      } else {
        label = uninflatedButtonLabel;
      }
      return /* @__PURE__ */ jsxs("p", { className: `${componentClassName2}__product-variant`, children: [
        inflationButtonLabel,
        ": ",
        label
      ] });
    }
    return null;
  };
  const getFBTProductAddedToCart = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: finalCartModifications.map((item) => {
      var _a;
      const { images: productImages, name: productName } = item.entry;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__product-details`, children: [
          /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__image-wrap`, children: /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: (_a = productImages == null ? void 0 : productImages[0]) == null ? void 0 : _a.url, children: (memoizedStringContent) => {
            var _a2;
            return /* @__PURE__ */ jsx(
              "img",
              {
                src: memoizedStringContent,
                alt: (_a2 = productImages == null ? void 0 : productImages[0]) == null ? void 0 : _a2.altText,
                className: `${componentClassName2}__image`
              }
            );
          } }) }),
          /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__details-wrap`, children: [
            /* @__PURE__ */ jsx("p", { className: `${componentClassName2}__product-title`, children: productName }),
            handlePlpLabel(item)
          ] })
        ] }),
        /* @__PURE__ */ jsx("hr", { className: `${componentClassName2}__hr` })
      ] });
    }) });
  };
  const renderPackageCompletionMessage = () => {
    return /* @__PURE__ */ jsxs(SnippetCard, { imageOffSet: false, iconType: renderPackageCompleteMessage.iconType, children: [
      /* @__PURE__ */ jsx(
        "h4",
        {
          "aria-label": renderPackageCompleteMessage.title,
          className: `${PREFIX}-snippet-card__completion-title`,
          children: renderPackageCompleteMessage.title
        }
      ),
      /* @__PURE__ */ jsx("p", { className: `${PREFIX}-snippet-card__completion-description`, children: renderPackageCompleteMessage.description })
    ] });
  };
  const renderProductSummarySection = () => {
    var _a, _b, _c, _d;
    return finalCartModifications.length > 1 ? getFBTProductAddedToCart() : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__product-details`, children: [
        /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__image-wrap`, children: /* @__PURE__ */ jsx(
          "img",
          {
            src: (_b = (_a = images.current) == null ? void 0 : _a[0]) == null ? void 0 : _b.url,
            alt: (_d = (_c = images.current) == null ? void 0 : _c[0]) == null ? void 0 : _d.altText,
            className: `${componentClassName2}__image`
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__details-wrap`, children: [
          /* @__PURE__ */ jsx("p", { className: `${componentClassName2}__product-title`, children: name.current }),
          handlePlpLabel(),
          getHeliumInflationLabel(
            cartModifications.entry.selectedStoreServices,
            cartModifications.entry.supportedStoreServices
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx("hr", { className: `${componentClassName2}__hr` })
    ] });
  };
  const isNotGoToCartButton = !!((nextSelectedPackage || currentSelectedContainer) && isWheelOrTire && isPackageFlow);
  return /* @__PURE__ */ jsx(
    FlyoutModalComponent,
    {
      isOpen,
      closeFlyout: modifiedCloseFlyout,
      isStoreSelectorModalUsed: false,
      title: addedToCartTitle,
      children: /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__container`, children: [
        /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__header`, children: [
          /* @__PURE__ */ jsx("h2", { className: `${componentClassName2}__title`, children: handleChangeLabel() }),
          /* @__PURE__ */ jsx(
            "button",
            {
              "data-testid": "close-btn",
              className: `${componentClassName2}__close-btn`,
              onClick: modifiedCloseFlyout,
              "aria-label": closeBtnLabel,
              title: closeBtnLabel,
              children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg", path })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__body`, children: [
          renderProductSummarySection(),
          CTA && /* @__PURE__ */ jsxs(SnippetCard, { imageOffSet: false, iconType, children: [
            /* @__PURE__ */ jsx("h3", { "aria-label": CTA, className: `${PREFIX}-snippet-card__title`, children: title }),
            /* @__PURE__ */ jsx("p", { className: `${PREFIX}-snippet-card__label`, children: description }),
            /* @__PURE__ */ jsx(
              "a",
              {
                className: `${componentClassName2}__compatible-button ${PREFIX}-button--mini`,
                "data-testid": "package-button",
                href: CTALink,
                onClick: (event) => createPackageAndNavigate(event, CTALink),
                "aria-label": CTA,
                children: CTA
              }
            )
          ] }),
          checkDataLength(renderPackageCompleteMessage) && renderPackageCompletionMessage(),
          renderServiceComponent(),
          renderballoonAddonOptionsComponent(),
          renderRecommendationsComponent()
        ] }),
        /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__footer`, children: [
          isNotGoToCartButton ? handleFooterButton() : renderFooterButton(cartButtonLabel, goToCartPage),
          /* @__PURE__ */ jsx(
            Button,
            {
              id: "continue-btn",
              type: "tertiary",
              onClick: () => {
                modifiedCloseFlyout();
                closeFlyout(continueLinkLabel);
              },
              ariaLabel: continueLinkLabel,
              children: continueLinkLabel
            }
          )
        ] })
      ] })
    }
  );
};
CartFlyout.propTypes = {
  addToCartSingularLabel: PropTypes.string.isRequired,
  addToCartPluralLabel: PropTypes.string.isRequired,
  cartButtonLabel: PropTypes.string.isRequired,
  continueLinkLabel: PropTypes.string.isRequired,
  colorLabel: PropTypes.string.isRequired,
  sizeLabel: PropTypes.string.isRequired,
  closeBtnLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeFlyout: PropTypes.func.isRequired,
  cartModifications: PropTypes.any,
  path: PropTypes.string,
  cartServices: PropTypes.array,
  addServiceToCartLabel: PropTypes.string,
  serviceAddOnAvailableLabel: PropTypes.string,
  serviceAddOnErrorMessage: PropTypes.string,
  serviceAddOnLabel: PropTypes.string,
  serviceAddOnMultipleAvailableLabel: PropTypes.string,
  serviceAddOnNextSteps: PropTypes.string,
  serviceAddToCartHandler: PropTypes.func,
  addedServiceToCart: PropTypes.any,
  serviceDescription: PropTypes.string,
  resetPageVariables: PropTypes.func,
  serviceInstallationProps: PropTypes.object,
  isAutoInstallationReq: PropTypes.bool,
  autoPackagesDiffTireLabel: PropTypes.string,
  autoPackageChooseWheelCTA: PropTypes.string,
  autoPackageChooseTireCTA: PropTypes.string,
  autoPackagesDiffWheelLabel: PropTypes.string,
  changeSelectedLink: PropTypes.bool,
  currentSelectedContainer: PropTypes.string,
  nextSelectedPackage: PropTypes.string,
  autoPackagesUpdatedTiresTitle: PropTypes.string,
  chooseCTAHandler: PropTypes.func,
  selectDiffTireWheel: PropTypes.func,
  autoPackagesUpdatedWheelsTitle: PropTypes.string,
  tireData: PropTypes.any,
  wheelData: PropTypes.any,
  continueToCart: PropTypes.func,
  isWheelOrTire: PropTypes.bool,
  isPackageFlow: PropTypes.bool,
  hideVariants: PropTypes.array
};
CartFlyout.displayName = "CartFlyout";
const NavigationFlyout = ({ ...props }) => {
  const { flyoutOpen = false, closeFlyout, children, profileState, a11yLabel } = props;
  const componentClass = `${PREFIX}-navigation-flyout`;
  const FlyOutModalComponentProps = {
    isOpen: flyoutOpen,
    closeFlyout,
    title: a11yLabel,
    isStoreSelectorModalUsed: false
  };
  return /* @__PURE__ */ jsx("div", { className: `${componentClass}__wrapper ${componentClass}__${profileState.toLowerCase()}`, children: /* @__PURE__ */ jsxs(FlyoutModalComponent, { ...FlyOutModalComponentProps, children: [
    /* @__PURE__ */ jsx(Button, { "data-testid": "close-button", type: "icon_button", onClick: closeFlyout, children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" }) }),
    children
  ] }) });
};
NavigationFlyout.propTypes = {
  flyoutOpen: PropTypes.bool.isRequired,
  closeFlyout: PropTypes.func,
  children: PropTypes.element,
  profileState: PropTypes.string
};
const Pill = (props) => {
  const { path, onCloseClick, pillLabel } = props;
  const handleCloseClick = () => {
    onCloseClick(pillLabel);
  };
  return /* @__PURE__ */ jsxs("button", { className: `${PREFIX}-pill-container ${PREFIX}-pill-button`, onClick: handleCloseClick, children: [
    /* @__PURE__ */ jsxs("span", { className: "sr-only", children: [
      props.filterType,
      ": ",
      pillLabel,
      " ",
      props.a11yRemoveFilter
    ] }),
    /* @__PURE__ */ jsx("span", { className: `${PREFIX}-pill-container__label`, "aria-hidden": "true", children: pillLabel }),
    /* @__PURE__ */ jsx("span", { className: `${PREFIX}-pill-container__icon`, "aria-hidden": "true", children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "md", path }) })
  ] });
};
Pill.propTypes = {
  path: PropTypes.string,
  onCloseClick: PropTypes.func,
  pillLabel: PropTypes.string.isRequired
};
const BannerDisclaimer = ({ ...props }) => {
  const buttonRef = useRef();
  const [visibility, setVisibility] = useState(false);
  const { disclaimerFormat, disclaimerText, disclaimerTitle, tooltipField } = props;
  const toolTipButtonHandler = () => {
    setVisibility(!visibility);
  };
  const renderDisclaimerText = () => {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-banner__disclaimer-content`,
        dangerouslySetInnerHTML: { __html: disclaimerText || "" }
      }
    );
  };
  const getDisclaimerTooltip = (tooltipText) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      tooltipText && /* @__PURE__ */ jsx(
        "button",
        {
          className: `${PREFIX}-banner__links`,
          type: "button",
          ref: buttonRef,
          "data-testid": "banner-tooltip-field",
          onClick: toolTipButtonHandler,
          children: tooltipText
        }
      ),
      tooltipText && /* @__PURE__ */ jsx(
        Tooltip,
        {
          visibility,
          setVisibility,
          iconID: "ct-close",
          headerText: disclaimerTitle,
          bodyText: /* @__PURE__ */ jsx(
            "div",
            {
              "data-testid": "tooltip-text",
              className: `${PREFIX}-banner__disclaimer__content`,
              dangerouslySetInnerHTML: { __html: disclaimerText || "" }
            }
          ),
          coords: buttonRef.current
        }
      )
    ] });
  };
  const renderDisclaimerTooltip = () => {
    const tooltipText = tooltipField;
    return getDisclaimerTooltip(tooltipText);
  };
  return /* @__PURE__ */ jsx(Fragment, { children: disclaimerFormat === "Tooltip" ? renderDisclaimerTooltip() : renderDisclaimerText() });
};
BannerDisclaimer.propTypes = {
  disclaimerFormat: PropTypes.string,
  disclaimerText: PropTypes.string,
  disclaimerTitle: PropTypes.string,
  tooltipField: PropTypes.string.isRequired
};
const CommonCardWrapper = ({ ...props }) => {
  const { children, headerChildren, noPadding, title } = props;
  const noPaddingClass = noPadding ? `${PREFIX}-common-wrapper--no-padding` : `${PREFIX}-common-wrapper`;
  const renderCardComponent = () => {
    if (!!title || !!headerChildren) {
      if (title) {
        return /* @__PURE__ */ jsx("h1", { className: `${PREFIX}-common-wrapper__title`, children: title });
      }
      if (headerChildren) {
        return /* @__PURE__ */ jsx(Fragment, { children: headerChildren });
      }
      return /* @__PURE__ */ jsx(SkeletonComponent, { skeletonClass: `${PREFIX}-common-skeleton-title` });
    }
    return null;
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-common-wrapper ${noPaddingClass}`, children: [
    renderCardComponent(),
    getPageType() === pageTypes.checkoutPage && /* @__PURE__ */ jsx("div", { id: "order-summary-root", className: `${PREFIX}-order-summary-root` }),
    children
  ] });
};
CommonCardWrapper.propTypes = {
  children: PropTypes.element,
  title: PropTypes.string,
  headerChildren: PropTypes.element,
  noPadding: PropTypes.bool
};
CommonCardWrapper.displayName = "CommonCardWrapper";
const CommonCard = ({ ...props }) => {
  const { children, showWarningToast, propClass, noPadding, isSTS } = props;
  const commonCardClass = noPadding ? `${PREFIX}-common-card__no-padding` : `${PREFIX}-common-card`;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: showWarningToast ? `${commonCardClass} ${PREFIX}-common--error` : isSTS ? `${commonCardClass} ${PREFIX}-${propClass} ${PREFIX}-common-card-sts` : `${commonCardClass} ${PREFIX}-${propClass}`,
      children
    }
  );
};
CommonCard.defaultProps = {
  showWarningToast: false
};
CommonCard.propTypes = {
  children: PropTypes.element,
  showWarningToast: PropTypes.bool,
  propClass: PropTypes.string,
  noPadding: PropTypes.bool
};
CommonCard.displayName = "CommonCard";
const getStoreTimeLabel = (isPDPPage, closed, opensLabel, closesLabel, openingTime, closingTime) => {
  return isPDPPage ? closed ? replaceStrWithDynamicVal(opensLabel, openingTime) : replaceStrWithDynamicVal(closesLabel, closingTime) : closed ? `${opensLabel} ${openingTime}` : `${closesLabel} ${closingTime}`;
};
const StoreTooltip = ({ ...props }) => {
  const {
    storeData,
    openLabel,
    opensLabel,
    closesLabel,
    closeLabel,
    storeDetailsCTALabel,
    onlineOrdering,
    onlineOrdersNotAcceptedMsg,
    storeDetailsPageLinkClicked,
    isPDPPage
  } = props;
  const { address, url } = storeData || {};
  const weekdayHours = getStoreTimings(storeData);
  const nextWeekDayHours = getNextDayStoreTimings(storeData);
  const { closingTime, closed } = weekdayHours || {};
  const { openingTime } = nextWeekDayHours || {};
  const storeTimingsPresent = closed ? openingTime == null ? void 0 : openingTime.formattedHour : closingTime == null ? void 0 : closingTime.formattedHour;
  const tooltipTimeText = getStoreTimeLabel(
    isPDPPage,
    closed,
    opensLabel,
    closesLabel,
    openingTime == null ? void 0 : openingTime.formattedHour,
    closingTime == null ? void 0 : closingTime.formattedHour
  );
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-order-summary__tooltip`, children: [
    /* @__PURE__ */ jsx("p", { children: address == null ? void 0 : address.line1 }),
    /* @__PURE__ */ jsx("p", { children: address == null ? void 0 : address.postalCode }),
    storeTimingsPresent && /* @__PURE__ */ jsxs("p", { children: [
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-order-summary__tooltip__open-text`, children: closed ? closeLabel : openLabel }),
      ` ⋅ ${tooltipTimeText}`
    ] }),
    /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: url, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
      "a",
      {
        href: memoizedStringContent,
        onClick: storeDetailsPageLinkClicked,
        className: `${PREFIX}-order-summary__tooltip__store-link`,
        children: storeDetailsCTALabel
      }
    ) }),
    !onlineOrdering && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-order-summary__tooltip__store-status`, children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, { type: "ct-notification-caution-stroked", size: "md" }) }),
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-order-summary__tooltip__store-status_message`, children: onlineOrdersNotAcceptedMsg })
    ] })
  ] });
};
const StoreDetails = ({ ...props }) => {
  const {
    pickAtStoreTitle,
    freePickUpOrderThreshold,
    freePickUpOverLabel,
    servicesTitle,
    shipToHomeTitle,
    changeCTALabel,
    onlineOrdering,
    onlineOrdersNotAcceptedMsg,
    isShipToHome,
    isFreePickUpAtStore,
    storeDetailsCTALabel,
    curbsidePickupMessage,
    curbsidePickupLearnMoreLabel,
    storeData,
    curbsideText,
    path,
    closeLabel,
    openLabel,
    opensLabel,
    closesLabel,
    isStoreEligibleForCurbside,
    onChangeAddress,
    openModal,
    a11yCloseIconLabel,
    a11yStoreDetailsInformation,
    a11yChangePickupStoreLabel,
    popUpTitleId,
    a11yTooltipIcon,
    isExpressDelivery,
    expressDeliveryLabel,
    deliveryPostalCode = ""
  } = props;
  const { address, displayName } = storeData || {};
  const buttonRef = useRef();
  const [visibility, setVisibility] = useState(false);
  const [isCurbSideModalOpen, setIsCurbSideModalOpen] = useState(false);
  const componentClassName2 = `${PREFIX}-curbside-modal`;
  const expressLabelClassName = isExpressDelivery ? `${PREFIX}-shopping-cart__express-label` : "";
  const storeClass = `${PREFIX}-shopping-cart__store-details`;
  const storeAddressClass = isShipToHome ? `${storeClass} ${storeClass}__address` : `${storeClass}`;
  const isBopisCheck = isFreePickUpAtStore && isStoreEligibleForCurbside;
  const modalClassName = `${PREFIX}-previous-element`;
  const previousElement = document.querySelector(`button[${previousElementName}]`);
  const createPickUpAtStoreTitle = () => {
    if (freePickUpOrderThreshold) {
      const formattedOrderThreshold = getFormattedPrice(freePickUpOrderThreshold, getLanguage());
      return replaceStrWithDynamicVal(freePickUpOverLabel, formattedOrderThreshold);
    }
    return pickAtStoreTitle;
  };
  const shipmentTitle = () => {
    let title = "";
    if (isShipToHome) {
      title = shipToHomeTitle;
    } else if (isFreePickUpAtStore) {
      title = createPickUpAtStoreTitle();
    } else if (isExpressDelivery) {
      title = expressDeliveryLabel;
    } else {
      title = servicesTitle;
    }
    return title;
  };
  const isCurbsideText = () => {
    return isBopisCheck && /* @__PURE__ */ jsxs("div", { className: `${storeClass}__curbside-text`, children: [
      /* @__PURE__ */ jsx("span", { "data-testid": "curbside-pickup", id: "curbside-pickup", children: curbsidePickupMessage }),
      /* @__PURE__ */ jsx(
        "button",
        {
          className: `${storeClass}__curbside-text--learn-more-btn`,
          "aria-describedby": "curbside-pickup",
          onClick: (e) => {
            addModalAttribute(e);
            setIsCurbSideModalOpen(!isCurbSideModalOpen);
          },
          type: "button",
          "data-qm-allow": "true",
          children: /* @__PURE__ */ jsx("span", { className: `${storeClass}__curbside-text--learn-more-text`, children: curbsidePickupLearnMoreLabel })
        }
      )
    ] });
  };
  const isStoreAddress = () => {
    const onChangeButtonAction = (e) => {
      if (isShipToHome) {
        onChangeAddress(true);
      } else {
        addModalAttribute(e);
        openModal();
      }
    };
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      renderStoreNameAddress(isShipToHome ? address == null ? void 0 : address.postalCode : displayName),
      isFreePickUpAtStore && /* @__PURE__ */ jsx(
        "button",
        {
          className: `${storeClass}__store-icon`,
          type: "button",
          "data-qm-allow": "true",
          ref: buttonRef,
          onClick: (e) => {
            addModalAttribute(e);
            setVisibility(!visibility);
          },
          "aria-label": a11yTooltipIcon,
          "aria-describedby": `${storeClass}__store-name-address-id`,
          children: /* @__PURE__ */ jsx(Icon, { size: "md", title: `${a11yStoreDetailsInformation}`, type: "ct-information-details" })
        }
      ),
      (isFreePickUpAtStore || isShipToHome && onlineOrdering) && /* @__PURE__ */ jsx(
        "button",
        {
          className: `${storeClass}__change-link-btn ${storeClass}__change-link`,
          type: "button",
          "data-qm-allow": "true",
          onClick: onChangeButtonAction,
          "aria-label": a11yChangePickupStoreLabel,
          children: changeCTALabel
        }
      )
    ] });
  };
  const renderStoreNameAddress = (postalCode) => {
    return postalCode ? /* @__PURE__ */ jsx("span", { id: `${storeClass}__store-name-address-id`, className: `${storeClass}__store-name-address`, children: postalCode }) : null;
  };
  const closeHandler = () => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    setIsCurbSideModalOpen(false);
    previousElement == null ? void 0 : previousElement.focus();
    previousElement == null ? void 0 : previousElement.removeAttribute(previousElementName);
  };
  return /* @__PURE__ */ jsxs("div", { className: `${storeAddressClass} ${expressLabelClassName}`, children: [
    /* @__PURE__ */ jsx("h2", { className: `${storeClass}__store-name`, children: shipmentTitle() }),
    isExpressDelivery && renderStoreNameAddress(deliveryPostalCode),
    (isFreePickUpAtStore || isShipToHome) && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: `${storeClass}__store-address`, children: isStoreAddress() }),
      isCurbsideText()
    ] }),
    !!visibility && /* @__PURE__ */ jsx(
      Tooltip,
      {
        visibility,
        setVisibility,
        iconID: "ct-close",
        headerText: displayName,
        a11yCloseIconLabel,
        bodyText: /* @__PURE__ */ jsx(
          StoreTooltip,
          {
            storeData,
            openLabel,
            opensLabel,
            closesLabel,
            closeLabel,
            storeDetailsCTALabel,
            onlineOrdering,
            onlineOrdersNotAcceptedMsg
          }
        ),
        coords: buttonRef.current
      }
    ),
    /* @__PURE__ */ jsx(ReactModal, { closeHandler, isOpen: isCurbSideModalOpen, children: /* @__PURE__ */ jsxs("div", { role: "dialog", "aria-labelledby": popUpTitleId, "aria-modal": "true", className: componentClassName2, children: [
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__close-container`, children: /* @__PURE__ */ jsx(
        "button",
        {
          className: `${componentClassName2}__close-btn`,
          onClick: closeHandler,
          "aria-label": closeLabel,
          "data-testid": "curbSideModalCloseButton",
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg", path })
        }
      ) }),
      curbsideText && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${componentClassName2}__content`,
          dangerouslySetInnerHTML: { __html: curbsideText }
        }
      )
    ] }) })
  ] });
};
StoreDetails.propTypes = {
  pickAtStoreTitle: PropTypes.string,
  freePickUpOrderThreshold: PropTypes.number,
  freePickUpOverLabel: PropTypes.string,
  servicesTitle: PropTypes.string,
  shipToHomeTitle: PropTypes.string,
  changeCTALabel: PropTypes.string,
  curbsideLearnMoreCTALabel: PropTypes.string,
  onlineOrdering: PropTypes.bool,
  onlineOrdersNotAcceptedMsg: PropTypes.string,
  isShipToHome: PropTypes.bool,
  isFreePickUpAtStore: PropTypes.bool,
  storeDetailsCTALabel: PropTypes.string,
  curbsidePickupMessage: PropTypes.string,
  curbsidePickupLearnMoreLabel: PropTypes.string,
  storeData: PropTypes.any,
  path: PropTypes.string,
  curbsideText: PropTypes.string,
  closeLabel: PropTypes.string,
  openLabel: PropTypes.string,
  opensLabel: PropTypes.string,
  closesLabel: PropTypes.string,
  isStoreEligibleForCurbside: PropTypes.bool,
  onChangeAddress: PropTypes.func,
  openModal: PropTypes.func,
  a11yCloseIconLabel: PropTypes.string,
  a11yStoreDetailsInformation: PropTypes.string,
  a11yChangePickupStoreLabel: PropTypes.string
};
StoreDetails.displayName = "StoreDetails";
const checkForMobileLayout = () => window.innerWidth <= BREAKPOINTS.mobileMaxWidth;
const checkForDesktopLayout = () => window.innerWidth > BREAKPOINTS.tabletMaxWidth;
const useMobileLayoutState = () => {
  const [isMobileLayout, setIsMobileLayout] = useState(checkForMobileLayout());
  const handleResize = () => {
    setIsMobileLayout(checkForMobileLayout());
  };
  useGlobalResizeEvent(handleResize);
  return [isMobileLayout, setIsMobileLayout];
};
const useDesktopLayoutState = () => {
  const [isDesktopLayout, setIsDesktopLayout] = useState(checkForDesktopLayout());
  const handleResize = () => {
    setIsDesktopLayout(checkForDesktopLayout());
  };
  useGlobalResizeEvent(handleResize);
  return [isDesktopLayout, setIsDesktopLayout];
};
const ProductItemInfo = ({ ...props }) => {
  var _a;
  const {
    isFreePickUpAtStore,
    isShipToHome,
    onlineOrdering,
    isServices,
    productData,
    onChangeFulfillmentOption,
    availableShipLabel,
    isProductService,
    productServiceTitle,
    serviceData,
    itemAvailabilityInfo,
    bulkLabel,
    isWishList,
    cartModal,
    totalLabel,
    mmQtyLabel,
    renderRebate,
    reviewsContainerId,
    hideQuantitySelector,
    qtyAbbrLabel,
    changeBrowserBackUrl,
    getChangeFulfillmentOption,
    isDetailPage,
    availabilityBulletSubtype,
    getStockInfoMessage,
    limitedStockMessage,
    a11yStrikeOutPrice,
    a11yStrikeOutPriceRange,
    singleShippingMethodOption,
    a11yCloseIconLabel,
    a11yTooltipIcon,
    appliedPromoPrefix,
    saveLabel,
    isSTS,
    saleMessagesRules,
    enableShowPromotionsAndRomanceCopy,
    enableCustomOrder,
    heliumInflationUnInflationText,
    showInflationLabels,
    saleEndDaySoonMessage,
    isShoppingCartPage,
    hideSaleEndDaySoonMessage,
    saleEndDisableShift,
    isPriceRangeViewEnabled = false
  } = props;
  const {
    name,
    baseProduct,
    brand,
    isBulk,
    rebate,
    quantity: itemQuantity,
    totalPrice,
    options,
    url,
    productWheelType,
    basePrice,
    adjustedPrice,
    basePriceValue,
    adjustedPriceValue,
    supportedStoreServices,
    isOnSale,
    salePriceEndDate,
    isUrgentLowStock
  } = productData;
  const infoClass = `${PREFIX}-shopping-cart__product`;
  const unfinishedPkgClass = `${PREFIX}-unfinished-package__product`;
  const serviceClass = isServices ? `${infoClass}__service-title` : "";
  const serviceInfoClass = isServices ? `${infoClass}__service-info` : "";
  const mergeModalClass = `${PREFIX}-merge-cart-modal`;
  const orderConfirmationClass = `${PREFIX}-order-confirmation`;
  const promoMessagesStyleClassDesktop = `${PREFIX}-md-block ${PREFIX}-xs-none ${PREFIX}-sm-none ${PREFIX}-promo-messages-wrapper`;
  const [isMobileLayout] = useMobileLayoutState();
  const showHeliumInflationLabels = useMemo(
    () => showInflationLabelsOnOrderConfirmationPage(supportedStoreServices, showInflationLabels),
    [supportedStoreServices, showInflationLabels]
  );
  const specificationsArr = filterSpecification(
    productData == null ? void 0 : productData.specifications,
    (_a = props.specificationsFromProps) == null ? void 0 : _a[props.isUnfinishedPackage ? magicNumber.ONE : magicNumber.ZERO]
  );
  const renderBulkItems = () => {
    return isBulk && /* @__PURE__ */ jsxs("div", { className: `${infoClass}__bulk-label-container`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-error", size: "md" }),
      /* @__PURE__ */ jsx("span", { className: `${infoClass}__bulk-label`, children: bulkLabel })
    ] });
  };
  const checkIfAvailable = () => {
    return !((itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) && !itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.AVAILABILITY_INFO));
  };
  const isAvailabilityPosition = (showChangeFulfillmentOption) => {
    return (
      // eslint-disable-next-line sonar/expression-complexity
      isDetailPage && !(!!showChangeFulfillmentOption && onlineOrdering) && !isArrayNotEmpty(options) && !(rebate && Object.keys(rebate).length)
    );
  };
  const isRenderPromoMessages = () => {
    const isMessagePresent = isAtleastOneParamValid(
      isArrayNotEmpty(productData == null ? void 0 : productData.promoMessages),
      isArrayNotEmpty(productData == null ? void 0 : productData.restrictedPromoMessages),
      isArrayNotEmpty(productData == null ? void 0 : productData.appliedPromoMessages)
    );
    return isMessagePresent && (!isWishList || enableShowPromotionsAndRomanceCopy);
  };
  const renderAvailability = () => {
    const showChangeFulfillmentOption = getChangeFulfillmentOption();
    const availabilityPositionClass = isAvailabilityPosition(showChangeFulfillmentOption) ? `${infoClass}__availability-position` : "";
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: `${infoClass}--desktop`, children: renderUrgencyLimitedStock() }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${infoClass} ${infoClass}__availability_section ${PREFIX}-md-block ${PREFIX}-xs-none ${PREFIX}-sm-none ${availabilityPositionClass}`,
          children: [
            isOnSale && renderSaleEndDaySoonMessageComp(
              salePriceEndDate,
              isOnSale,
              isUrgentLowStock,
              isShoppingCartPage,
              hideSaleEndDaySoonMessage,
              saleEndDaySoonMessage,
              saleEndDisableShift
            ),
            !isDetailPage && /* @__PURE__ */ jsx("ul", { className: `${infoClass}__availability`, children: availableShipLabel() }),
            isServiceDisclaimer(),
            !singleShippingMethodOption && !!showChangeFulfillmentOption && onlineOrdering && /* @__PURE__ */ jsx(
              "button",
              {
                "data-testid": "fulfillment-btn",
                className: `${infoClass}__fulfillment-btn`,
                onClick: (e) => {
                  addModalAttribute(e);
                  onChangeFulfillmentOption(
                    !isShipToHome ? FulfillmentMethods.STH : FulfillmentMethods.BOPIS,
                    productData == null ? void 0 : productData.entryNumber
                  );
                },
                children: showChangeFulfillmentOption
              }
            ),
            !isServices && renderRebate()
          ]
        }
      )
    ] });
  };
  const rebateAndInStockLabelforWishList = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${infoClass} ${PREFIX}-md-block ${isWishList ? `${PREFIX}-sm-block` : `${PREFIX}-sm-none`} ${PREFIX}-xs-none`,
          children: isWishList && availabilityBulletSubtype && itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.IN_STOCK_TAG) ? /* @__PURE__ */ jsx(Tag, { type: "availability-bullet", subType: `${availabilityBulletSubtype()}`, isLarge: true, children: getStockInfoMessage() }) : null
        }
      ),
      isWishList ? /* @__PURE__ */ jsx("div", { className: `${infoClass} ${PREFIX}-md-block ${PREFIX}-xs-none ${PREFIX}-sm-none`, children: renderRebate() }) : null
    ] });
  };
  const renderUrgencyLimitedStock = () => {
    var _a2, _b;
    const productQty = (_b = (_a2 = productData == null ? void 0 : productData.fulfillment) == null ? void 0 : _a2.stockItemAvailability) == null ? void 0 : _b.storeQuantity;
    return limitedStockMessage && (productData == null ? void 0 : productData.isUrgentLowStock) && !!productQty ? /* @__PURE__ */ jsx("div", { className: `${infoClass}__limitedStock`, children: replaceStrWithDynamicVal(limitedStockMessage, productQty) }) : null;
  };
  const isProductInfo = () => {
    const optionsForRender = enableCustomOrder ? getSortVariants(options) : options;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      renderBulkItems(),
      isArrayNotEmpty(optionsForRender) && /* @__PURE__ */ jsx("div", { className: `${infoClass}__colour`, children: optionsForRender.map((option) => {
        return /* @__PURE__ */ jsxs("div", { children: [
          option.display,
          ": ",
          option.value
        ] }, option.value);
      }) }),
      isRenderPromoMessages() ? /* @__PURE__ */ jsx("div", { className: promoMessagesStyleClassDesktop, children: renderPromoMessages() }) : null,
      checkIfAvailable() && renderAvailability()
    ] });
  };
  const unfinishedPackageClass = props.isUnfinishedPackage ? `${PREFIX}-unfinished-package__product-name` : "";
  const mergeCartModalTitleClamp = () => {
    return /* @__PURE__ */ jsx("div", { className: `${!isMobileLayout ? unfinishedPackageClass : ""}`, children: /* @__PURE__ */ jsx(
      "div",
      {
        className: `${isMobileLayout ? `${infoClass}__title--mobile-ellipsis` : `${infoClass}__title--desktop-ellipsis`}`,
        children: name
      }
    ) });
  };
  const packageClass = props.isUnfinishedPackage ? `${infoClass}__package` : "";
  const unfinishedSizeClass = props.isUnfinishedPackage ? `${infoClass}__colour ${packageClass}-colour ${unfinishedPkgClass}-colour` : `${infoClass}__specification`;
  const renderSpecifications = () => {
    return isArrayNotEmpty(specificationsArr) && /* @__PURE__ */ jsx("div", { className: `${unfinishedSizeClass}`, children: specificationsArr.map((spec) => /* @__PURE__ */ jsx("div", { children: `${spec == null ? void 0 : spec.label}: ${spec == null ? void 0 : spec.value}` }, spec.code)) });
  };
  const showSpecificationBelowName = () => {
    return props.isPackage || props.isUnfinishedPackage;
  };
  const titleComponent = () => {
    const productLink = isProductService ? serviceData == null ? void 0 : serviceData.url : url;
    return /* @__PURE__ */ jsxs("div", { className: `${infoClass}__title ${serviceClass} ${packageClass}-title`, children: [
      !isWishList ? (
        // eslint-disable-next-line sonar/no-nested-conditional
        productLink ? /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: isProductService ? serviceData.url : url, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
          "a",
          {
            "data-testid": "product-title",
            href: memoizedStringContent,
            className: `${infoClass}__title-link`,
            onClick: () => {
              hideQuantitySelector && changeBrowserBackUrl();
            },
            children: displayproductName()
          }
        ) }) : displayproductName()
      ) : (
        // eslint-disable-next-line no-warning-comments
        // TODO: Interface for name should be changed to string
        // Changing the name.label to name.
        /* @__PURE__ */ jsx(
          "a",
          {
            href: url,
            className: `${infoClass}__title-link`,
            "data-link-value": name,
            id: wishlistPrefixId(productData == null ? void 0 : productData.code),
            children: name
          }
        )
      ),
      showSpecificationBelowName() && renderSpecifications()
    ] });
  };
  const displayproductName = () => {
    const productName = cartModal ? mergeCartModalTitleClamp() : name;
    return isProductService ? serviceData == null ? void 0 : serviceData.name : productName;
  };
  const checkServices = () => {
    return isServices && isProductService;
  };
  const renderVariantDetails = () => {
    const optionsForRender = enableCustomOrder ? getSortVariants(options) : options;
    return isWishList && !productWheelType && isArrayNotEmpty(optionsForRender) ? /* @__PURE__ */ jsx("ul", { className: `${infoClass}__variants`, children: optionsForRender.map((item, index2) => /* @__PURE__ */ jsx(
      "li",
      {
        className: `${infoClass}__colour ${infoClass}__colour--wishlist`,
        children: `${item == null ? void 0 : item.display}: ${item == null ? void 0 : item.value}`
      },
      `${index2}${item == null ? void 0 : item.display}`
    )) }) : null;
  };
  const renderReview = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: isWishList && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-buy-box__rating`, children: /* @__PURE__ */ jsx("a", { href: `${url}#${reviewsContainerId}`, className: `${PREFIX}-buy-box__ratings-btn`, children: /* @__PURE__ */ jsx(
      "div",
      {
        "data-bv-show": "inline_rating",
        "data-bv-product-id": baseProduct,
        "data-bv-seo": "false"
      }
    ) }) }) });
  };
  const packageQuantity = props.isUnfinishedPackage ? `${mergeModalClass}_package-quantity` : "";
  const showTotalPrice = !props.isPackage && !props.isUnfinishedPackage;
  const calculateSavePercentage = (basePricevalue, adjustedPricevalue) => {
    const savePercent = 100;
    const percent = (basePricevalue - adjustedPricevalue) / basePricevalue * savePercent;
    return Math.round(percent);
  };
  const calculateSavedDollarValue = (basePricevalue, adjustedPricevalue) => {
    return Math.round(basePricevalue - adjustedPricevalue);
  };
  const saveMessage = useGenerateSaveMessage(
    productData.saleCut,
    productData == null ? void 0 : productData.originalPrice,
    saleMessagesRules,
    productData == null ? void 0 : productData.currentPrice
  );
  const mergeCardTotal = () => {
    return cartModal ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: `${mergeModalClass}_quantity ${packageQuantity}`, children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: isSTS ? `${PREFIX}-xs-none ${PREFIX}-sm-block ${PREFIX}-price-margin-bottom-sts` : `${PREFIX}-xs-none ${PREFIX}-sm-block`,
            children: `${mmQtyLabel} ${itemQuantity}`
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: isSTS ? `${PREFIX}-sm-none ${PREFIX}-xs-block ${mergeModalClass}__quantity-xs-margin ${PREFIX}-price-margin-bottom-sts` : `${PREFIX}-sm-none ${PREFIX}-xs-block ${mergeModalClass}__quantity-xs-margin`,
            children: `${mmQtyLabel} ${itemQuantity}`
          }
        ),
        isSTS && /* @__PURE__ */ jsxs(Fragment, { children: [
          !adjustedPriceValue && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${PREFIX}-xs-none
                                        ${PREFIX}-sm-block ${PREFIX}-price-info`,
                children: basePrice
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${PREFIX}-sm-none
                                        ${PREFIX}-xs-block ${mergeModalClass}__quantity-xs-margin
                                        ${PREFIX}-price-info`,
                children: basePrice
              }
            )
          ] }),
          adjustedPriceValue && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${PREFIX}-xs-none
                                        ${PREFIX}-sm-block`,
                children: adjustedPrice
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${PREFIX}-sm-none
                                        ${PREFIX}-xs-block ${mergeModalClass}__quantity-xs-margin`,
                children: adjustedPrice
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${PREFIX}-xs-none
                                        ${PREFIX}-sm-block ${PREFIX}-price-info-sts`,
                children: basePrice
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${PREFIX}-sm-none
                                        ${PREFIX}-xs-block ${mergeModalClass}__quantity-xs-margin
                                        ${PREFIX}-price-info-sts`,
                children: basePrice
              }
            ),
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-xs-none ${PREFIX}-sm-block`, children: `${saveLabel} ${calculateSavePercentage(
              basePriceValue,
              adjustedPriceValue
            )}% ($${calculateSavedDollarValue(basePriceValue, adjustedPriceValue)})` }),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${PREFIX}-sm-none
                                        ${PREFIX}-xs-block ${mergeModalClass}__quantity-xs-margin`,
                children: `${saveLabel} ${calculateSavePercentage(
                  basePriceValue,
                  adjustedPriceValue
                )}% ($${calculateSavedDollarValue(basePriceValue, adjustedPriceValue)})`
              }
            )
          ] })
        ] }),
        props.isUnfinishedPackage && /* @__PURE__ */ jsx("div", { className: `${mergeModalClass}_package-price`, children: /* @__PURE__ */ jsx(
          Price,
          {
            isRangeView: isPriceRangeViewEnabled,
            currentPrice: totalCurrentPrice(
              props.skus,
              productData == null ? void 0 : productData.currentPrice,
              props.isStaggered,
              props.vehicleInformationPresent,
              props.tireInformationPresent
            ),
            language: props.language,
            a11yStrikeOutPrice,
            a11yStrikeOutPriceRange,
            saveMessage,
            a11yCloseIconLabel,
            a11yTooltipIcon,
            isOnSale
          }
        ) })
      ] }),
      showTotalPrice && totalPrice && /* @__PURE__ */ jsxs("div", { className: `${mergeModalClass}_price`, children: [
        totalLabel,
        " ",
        /* @__PURE__ */ jsx(
          Price,
          {
            isRangeView: isPriceRangeViewEnabled,
            currentPrice: totalPrice,
            language: getLanguage(),
            a11yStrikeOutPrice,
            a11yStrikeOutPriceRange,
            a11yCloseIconLabel,
            a11yTooltipIcon,
            isOnSale
          }
        )
      ] })
    ] }) : null;
  };
  const renderQuantity2 = () => {
    return hideQuantitySelector ? /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${orderConfirmationClass}__quantity ${isServices ? `${orderConfirmationClass}__quantity--service` : ""}`,
        children: [
          `${qtyAbbrLabel}`,
          " ",
          isProductService ? serviceData.quantity : itemQuantity
        ]
      }
    ) : null;
  };
  const isServiceDisclaimer = () => {
    const isServiceSellable = serviceData ? serviceData.sellable : true;
    return isServices && isServiceSellable ? /* @__PURE__ */ jsx(
      "p",
      {
        className: `${infoClass}__service-disclaimer ${infoClass} ${PREFIX}-md-block ${PREFIX}-xs-block ${PREFIX}-sm-block`,
        children: props.servicesDisclaimer
      }
    ) : isShipToHome && isBulk && /* @__PURE__ */ jsxs(
      "p",
      {
        className: `${infoClass}__service-disclaimer ${infoClass} ${PREFIX}-md-block ${PREFIX}-xs-block ${PREFIX}-sm-block`,
        children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-information-details", size: "sm" }),
          props.productDisclaimer
        ]
      }
    );
  };
  const packageProduct = props.isUnfinishedPackage ? `${PREFIX}-unfinished-package__product` : "";
  const renderPromoMessages = () => {
    return /* @__PURE__ */ jsx(
      PromoMessages,
      {
        isProductLevel: true,
        productPromoMessages: productData == null ? void 0 : productData.promoMessages,
        productRestrictedPromoMessages: productData == null ? void 0 : productData.restrictedPromoMessages,
        appliedPromoPrefix,
        appliedPromoMessages: productData == null ? void 0 : productData.appliedPromoMessages,
        a11yTooltipIcon,
        a11yCloseIconLabel
      }
    );
  };
  const isRenderProductInfo = () => {
    return (isFreePickUpAtStore || isShipToHome) && !isProductService;
  };
  const renderHeliumInflationLabels = () => {
    return showHeliumInflationLabels && /* @__PURE__ */ jsx("p", { children: heliumInflationUnInflationText });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${infoClass} ${serviceInfoClass} ${packageProduct} ${PREFIX}-col-md-8 ${PREFIX}-col-sm-12 ${PREFIX}-col-xs-6`,
      children: [
        !isServices && /* @__PURE__ */ jsx("div", { className: `${infoClass}__brand} ${packageClass}-brand ${unfinishedPkgClass}-brand`, children: brand == null ? void 0 : brand.label }),
        checkServices() && /* @__PURE__ */ jsx("div", { className: `${infoClass}__brand`, children: productServiceTitle }),
        titleComponent(),
        renderReview(),
        renderHeliumInflationLabels(),
        renderQuantity2(),
        renderVariantDetails(),
        isRenderProductInfo() && isProductInfo(),
        mergeCardTotal(),
        isRenderPromoMessages() && !isRenderProductInfo() ? /* @__PURE__ */ jsx("div", { className: promoMessagesStyleClassDesktop, children: renderPromoMessages() }) : null,
        // eslint-disable-next-line sonar/expression-complexity
        !showSpecificationBelowName() && !cartModal && productData.specifications && Object.keys(productData.specifications).length > 0 && renderSpecifications(),
        rebateAndInStockLabelforWishList()
      ]
    }
  );
};
ProductItemInfo.defaultProps = {
  isProductService: false
};
ProductItemInfo.propTypes = {
  changeShipToHomeCTALabel: PropTypes.string,
  betweenLabel: PropTypes.string,
  availableLabel: PropTypes.string,
  pickAtStoreCTALabel: PropTypes.string,
  isFreePickUpAtStore: PropTypes.bool,
  isShipToHome: PropTypes.bool,
  onlineOrdering: PropTypes.bool,
  isServices: PropTypes.bool,
  servicesDisclaimer: PropTypes.string,
  homePageLink: PropTypes.string,
  productData: PropTypes.object,
  onChangeFulfillmentOption: PropTypes.func,
  receiveBetweenLabel: PropTypes.string,
  availableShipLabel: PropTypes.func,
  getChangeFulfillmentOption: PropTypes.func,
  isProductService: PropTypes.bool,
  productServiceTitle: PropTypes.string,
  serviceData: PropTypes.any,
  itemAvailabilityInfo: PropTypes.object.isRequired,
  bulkLabel: PropTypes.string,
  isWishList: PropTypes.bool,
  cartModal: PropTypes.bool,
  a11yTooltipIcon: PropTypes.string,
  totalLabel: PropTypes.string,
  mmQtyLabel: PropTypes.string,
  renderRebate: PropTypes.func,
  productColorLabel: PropTypes.string,
  PDPLink: PropTypes.string,
  reviewsContainerId: PropTypes.string,
  a11yReviewRating: PropTypes.string,
  hideQuantitySelector: PropTypes.bool,
  productDisclaimer: PropTypes.string,
  qtyAbbrLabel: PropTypes.string,
  changeBrowserBackUrl: PropTypes.func,
  isDetailPage: PropTypes.bool,
  isPackage: PropTypes.bool,
  outOfStockLabel: PropTypes.string,
  discontinuedLabel: PropTypes.string,
  roadRatedLabel: PropTypes.string,
  isUnfinishedPackage: PropTypes.bool,
  language: PropTypes.string,
  attributeOffsetLabel: PropTypes.string,
  skus: PropTypes.array,
  isStaggered: PropTypes.bool,
  vehicleInformationPresent: PropTypes.bool,
  tireInformationPresent: PropTypes.bool,
  availabilityBulletSubtype: PropTypes.func,
  getStockInfoMessage: PropTypes.func,
  showOrderDetailDisclaimer: PropTypes.func,
  specificationsFromProps: PropTypes.array,
  limitedStockMessage: PropTypes.string,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  singleShippingMethodOption: PropTypes.bool,
  saveLabel: PropTypes.string
};
const extractServiceBasedOnSku = (productItemIdentifier, selectedService, isOrderDetailsPage, parentProductStatus, deliveryMode) => {
  if (!isOrderDetailsPage) {
    return selectedService == null ? void 0 : selectedService.filter(
      (singleItem) => {
        var _a, _b, _c;
        return !!((_a = singleItem.cartEntryReference) == null ? void 0 : _a.split(",").includes(productItemIdentifier)) && (deliveryMode ? (deliveryMode == null ? void 0 : deliveryMode.toUpperCase()) === ((_c = (_b = singleItem == null ? void 0 : singleItem.fulfillment) == null ? void 0 : _b.deliveryMode) == null ? void 0 : _c.toUpperCase()) : true);
      }
    );
  } else {
    return selectedService == null ? void 0 : selectedService.filter(
      (singleItem) => {
        var _a;
        return !!((_a = singleItem.cartEntryReference) == null ? void 0 : _a.split(",").includes(productItemIdentifier)) && singleItem.status === parentProductStatus;
      }
    );
  }
};
const getPriceValue = (serviceData, currentPrice, totalPrice, oneProductQuantity, itemQuantity, isWheelOrTire) => {
  const otherPriceValue = !!serviceData ? serviceData.quantity > oneProductQuantity ? serviceData.totalPrice : serviceData.currentPrice : itemQuantity > oneProductQuantity ? totalPrice : currentPrice;
  const newPrice = (currentPrice == null ? void 0 : currentPrice.value) * magicNumber.FOUR;
  const autoPartsPrice = { ...currentPrice, value: newPrice };
  return isWheelOrTire ? autoPartsPrice : otherPriceValue;
};
const ProductImageComponent = ({ ...props }) => {
  const {
    itemAvailabilityInfo,
    isService,
    a11yServiceInstallation,
    servicesIcon,
    images,
    changeBrowserBackUrl,
    hideQuantitySelector,
    url,
    isUnfinishedPackage,
    name
  } = props;
  const primaryImage = Array.isArray(images) ? images[0] : images;
  const { grayOutImage } = itemAvailabilityInfo || {};
  const cartClass2 = `${PREFIX}-shopping-cart__item`;
  const availabilityInfoClass = grayOutImage ? `${cartClass2}__image-container--gray-out` : "";
  const unfinishedPackage = isUnfinishedPackage ? `${cartClass2}__image-container--package` : "";
  const rendersServiceIconComp = () => {
    return isService ? /* @__PURE__ */ jsx("div", { className: `${cartClass2}__service-icon-container`, children: /* @__PURE__ */ jsx("div", { className: `${cartClass2}__service-icon`, "aria-label": a11yServiceInstallation, children: /* @__PURE__ */ jsx(Icon, { type: servicesIcon, size: "lg" }) }) }) : (
      // eslint-disable-next-line sonar/no-nested-conditional
      url ? /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: url, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
        "a",
        {
          "data-testid": "render-service-btn",
          href: memoizedStringContent,
          onClick: () => {
            hideQuantitySelector && changeBrowserBackUrl();
          },
          "aria-hidden": "true",
          tabIndex: -1,
          children: /* @__PURE__ */ jsx(
            "img",
            {
              className: `${PREFIX}-product-img`,
              src: primaryImage == null ? void 0 : primaryImage.url,
              alt: name || (primaryImage == null ? void 0 : primaryImage.altText)
            }
          )
        }
      ) }) : /* @__PURE__ */ jsx("img", { className: `${PREFIX}-product-img`, src: primaryImage == null ? void 0 : primaryImage.url, alt: name || (primaryImage == null ? void 0 : primaryImage.altText) })
    );
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${cartClass2}__image-container ${PREFIX}-col-md-3 ${PREFIX}-col-sm-3 ${availabilityInfoClass} ${unfinishedPackage}`,
      children: rendersServiceIconComp()
    }
  );
};
const renderQuantity = ({ qtyAbbrLabel, quantity }) => {
  const orderConfirmationClass = `${PREFIX}-order-confirmation`;
  return /* @__PURE__ */ jsx("div", { className: `${orderConfirmationClass}__quantity`, children: `${qtyAbbrLabel} ${quantity}` });
};
const AutomotiveAddonCard = (props) => {
  const {
    brand,
    url,
    images,
    name,
    sku,
    price,
    dpBuyAgainLabel,
    isDetailPage,
    productData,
    serviceAdded,
    checkoutButtonClick,
    warningToastProps,
    setErrorInfoHandler,
    errorAnalyticsForInlineToast
  } = props;
  const [checked, setChecked] = useState(true);
  const infoClass = `${PREFIX}-shopping-cart__product`;
  const cartClass2 = `${PREFIX}-shopping-cart__item`;
  const automotiveClass = `${PREFIX}-automotive-card`;
  const [quantity, setQuantity] = useState(props.quantity);
  const [inlineToastError, setInlineToastError] = useState(false);
  const itemAvailabilityInfo = productData == null ? void 0 : productData.itemAvailabilityInfo;
  const quantityChangeHandler = (incrementValue) => {
    setQuantity(incrementValue);
  };
  const checkAvailableQuantity = () => {
    var _a;
    const { orderableFromDC } = (productData == null ? void 0 : productData.fulfillment) || {};
    const { dcQuantity, storeQuantity } = ((_a = productData == null ? void 0 : productData.fulfillment) == null ? void 0 : _a.stockItemAvailability) || {};
    if (orderableFromDC && dcQuantity) {
      return dcQuantity + storeQuantity;
    }
    return storeQuantity;
  };
  const {
    errorMessage: itemAvailabilityErrMsg,
    showInlineError: itemAvailabilityShowInlineError,
    hardStopError: itemAvailabilityShowHardStopError,
    optionsToBeDisplayed: itemAvailabilityOptionsToBeDisplayed
  } = itemAvailabilityInfo || {};
  const previousItemAvailabilityErrMsg = usePrevious(itemAvailabilityErrMsg);
  useEffect(() => {
    setInlineToastError(!!itemAvailabilityErrMsg && checkoutButtonClick);
  }, [itemAvailabilityErrMsg, checkoutButtonClick]);
  useEffect(() => {
    if (itemAvailabilityErrMsg && itemAvailabilityErrMsg !== previousItemAvailabilityErrMsg) {
      itemAvailabilityShowInlineError && !!errorAnalyticsForInlineToast && errorAnalyticsForInlineToast(itemAvailabilityErrMsg);
      !!itemAvailabilityShowHardStopError && (setErrorInfoHandler == null ? void 0 : setErrorInfoHandler(itemAvailabilityShowInlineError, false));
      itemAvailabilityShowInlineError && !!itemAvailabilityOptionsToBeDisplayed.includes(OptionsOnCartItem.UPDATED_TEXT) && (setErrorInfoHandler == null ? void 0 : setErrorInfoHandler(false, true));
    }
  }, [
    itemAvailabilityErrMsg,
    itemAvailabilityShowInlineError,
    itemAvailabilityShowHardStopError,
    itemAvailabilityOptionsToBeDisplayed,
    setErrorInfoHandler,
    errorAnalyticsForInlineToast,
    previousItemAvailabilityErrMsg
  ]);
  const checkboxChanged = (isChecked) => {
    setChecked(!isChecked);
    !isChecked ? props.selectService(sku) : props.removeService(sku);
  };
  const showWarningToast = () => {
    return quantity > checkAvailableQuantity() && checkAvailableQuantity() < maxInputVal;
  };
  const renderProductInfo = () => {
    return /* @__PURE__ */ jsxs("div", { className: infoClass, children: [
      /* @__PURE__ */ jsx("div", { className: `${infoClass}__brand`, children: brand == null ? void 0 : brand.label }),
      /* @__PURE__ */ jsx("div", { className: `${infoClass}__title`, children: /* @__PURE__ */ jsx("a", { href: url, className: `${infoClass}__title-link`, "data-link-value": name, children: name }) }),
      serviceAdded && /* @__PURE__ */ jsx(renderQuantity, { qtyAbbrLabel: props.qtyAbbrLabel, quantity })
    ] });
  };
  const renderButtons = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${cartClass2}__icon`, children: [
      showWishListIcon(
        itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError,
        itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed
      ) && /* @__PURE__ */ jsx(
        "button",
        {
          className: `${cartClass2}__icon--wishlist`,
          "aria-label": props.a11yWishlistIcon,
          "data-testid": "cartWishlistIcon",
          onClick: () => props.addItemToWishlist(productData),
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-favorite-inactive", size: "lg" })
        }
      ),
      /* @__PURE__ */ jsx(
        "button",
        {
          className: `${cartClass2}__icon--close`,
          "data-testid": "cartCloseIcon",
          onClick: () => props.onRemoveCartItem(false, productData),
          "aria-label": props.a11yRemoveLabel,
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" })
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsx("div", { className: `${automotiveClass}__item-addon`, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-auto-wrapper ${inlineToastError && (itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.hardStopError) ? `${PREFIX}-hard-stop-wrapper` : ""}`,
      children: [
        (showWarningToast() || !!(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError)) && renderWarningToast(warningToastProps, itemAvailabilityInfo, productData),
        /* @__PURE__ */ jsxs("div", { className: `${cartClass2} ${automotiveClass}__item`, children: [
          /* @__PURE__ */ jsx(ProductImageComponent, { itemAvailabilityInfo, images, name }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: `${cartClass2}__text-container ${!serviceAdded ? `${PREFIX}-col-md-8 ${PREFIX}-col-sm-8` : ""}`,
              children: [
                /* @__PURE__ */ jsxs(
                  "div",
                  {
                    className: `${cartClass2}__product-item-wrapper ${!serviceAdded ? `${PREFIX}-justify-content` : ""}`,
                    children: [
                      renderProductInfo(),
                      (!(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) || (itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed.includes(
                        OptionsOnCartItem.PRICE_AND_QUANTITY
                      ))) && /* @__PURE__ */ jsxs("div", { className: `${automotiveClass}__price-quantity`, children: [
                        /* @__PURE__ */ jsx("div", { className: `${cartClass2}__quantity`, children: serviceAdded && !showWarningToast() && /* @__PURE__ */ jsx(
                          QuantitySelector,
                          {
                            setQtySelectorInput: quantityChangeHandler,
                            qtySelectorInput: 1,
                            defaultQty: 1,
                            maxQty: 1,
                            disabled: true,
                            a11yQuantityLabel: props.accessibilityGlobalProps.a11yQuantityLabel,
                            a11yQuantityDecrementLabel: props.accessibilityGlobalProps.a11yQuantityDecrementLabel,
                            a11yQuantityIncrementLabel: props.accessibilityGlobalProps.a11yQuantityIncrementLabel,
                            a11yMinQuantityReached: props.accessibilityGlobalProps.a11yMinQuantityReached,
                            a11yQuantityInputAriaLabel: props.accessibilityGlobalProps.a11yQuantityInputAriaLabel,
                            id: props.quantitySelectorId
                          }
                        ) }),
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: `${cartClass2}__price ${!serviceAdded ? `${PREFIX}-margin-top` : ""}`,
                            children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-price--total`, children: getFormattedPrice(price, props.language) })
                          }
                        )
                      ] })
                    ]
                  }
                ),
                !serviceAdded && /* @__PURE__ */ jsx(
                  Checkbox,
                  {
                    id: sku,
                    onChange: () => {
                      checkboxChanged(checked);
                    },
                    label: "",
                    checked
                  }
                ),
                serviceAdded && renderButtons(),
                isDetailPage && getBuyItAgainCta(dpBuyAgainLabel, url)
              ]
            }
          )
        ] })
      ]
    }
  ) });
};
const AutomotiveAddonsList = (props) => {
  const [selectedProducts, setSelectedProducts] = useState(props.addons);
  const selectService = useCallback(
    (selectedSku) => {
      setSelectedProducts((prevstate) => [...prevstate, props.addons.find((product) => (product == null ? void 0 : product.sku) === selectedSku)]);
    },
    [props.addons]
  );
  const removeService = useCallback(
    (selectedSku) => {
      const updatedArray = selectedProducts.filter((item) => {
        return (item == null ? void 0 : item.sku) !== selectedSku;
      });
      setSelectedProducts([...updatedArray]);
    },
    [selectedProducts]
  );
  const addServiceToCartHandler = () => {
    props.serviceAddToCartHandler(selectedProducts, props.productData);
    props.hideAccordion(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    props.addons.map((addon, index2) => /* @__PURE__ */ jsx(
      AutomotiveAddonCard,
      {
        hideQuantitySelector: props.hideQuantitySelector,
        brand: addon.brand,
        url: addon.url,
        images: addon.images,
        sku: addon.sku,
        price: addon.price,
        name: addon.name,
        PDPLink: props.PDPLink,
        language: props.language,
        selectService,
        removeService,
        quantity: addon.maxQuantity,
        dpBuyAgainLabel: props.dpBuyAgainLabel,
        isDetailPage: props.isDetailPage,
        qtyAbbrLabel: props.qtyAbbrLabel
      },
      index2
    )),
    !props.hideQuantitySelector && selectedProducts.length ? /* @__PURE__ */ jsx(Button, { type: "primary_reverse", size: "medium", onClick: addServiceToCartHandler, children: props.hardwareAddToCartCTALabel }) : null
  ] });
};
const AutomotiveAddonsListWrapper = (props) => {
  return isArrayNotEmpty(props.addons) && /* @__PURE__ */ jsx(
    Accordion,
    {
      title: props.hardwareTitle,
      isHeaderHidden: false,
      hideControls: false,
      disableOnClick: false,
      isHeaderOpen: props.isCollapsed,
      children: /* @__PURE__ */ jsx(
        AutomotiveAddonsList,
        {
          ...props,
          addons: props.addons,
          hideAccordion: props.setHideAccordionAfterRemove
        }
      )
    }
  );
};
AutomotiveAddonsListWrapper.propTypes = {
  addons: PropTypes.array,
  hardwareTitle: PropTypes.string,
  isCollapsed: PropTypes.bool,
  setHideAccordionAfterRemove: PropTypes.func
};
const STHDeliveryLabels = (props) => {
  var _a;
  const {
    cart,
    productData,
    isBulk,
    isShowedEstimatedDeliveryDateBetween,
    selectedDeliveryMode,
    singleShippingMethodOption,
    renderAllAvailabilityInfo,
    isShoppingCartPage,
    isOrderConfirmationPage,
    isLimitedStockAndAvailableInDc,
    receiveBetweenLabel,
    betweenLabelSTH,
    getETAForRange,
    getBetweenSTHLabel,
    etaTimeOfDelivery,
    estimatedDeliveryDateBetween
  } = props;
  const { fulfillment } = productData;
  const estimatedDeliveryDate = isShoppingCartPage ? productData.estimatedDeliveryDate : {
    startDate: productData.eddMin,
    endDate: productData.eddMax
  };
  const isExpressDeliveryModeForOrder = ((_a = productData == null ? void 0 : productData.fulfillment) == null ? void 0 : _a.deliveryMode) === CartOrderDeliveryModes.EXPRESS;
  const isPackageNotMainItem = () => {
    const isPackageItem = isProductFromPackage(cart == null ? void 0 : cart.sthPackages, productData);
    const isMainProductInPackage = isPackageMainProduct(cart == null ? void 0 : cart.sthPackages, productData);
    return isPackageItem && !isMainProductInPackage;
  };
  const getBetweenLabel = (storePickup) => {
    const modifiedBetweenLabel = betweenLabelSTH == null ? void 0 : betweenLabelSTH.split("-")[magicNumber.ZERO];
    return storePickup.etaEarliest && storePickup.etaLatest ? betweenLabelSTH : modifiedBetweenLabel;
  };
  const createLi = (cartItemFulfillmentSource) => {
    var _a2;
    return /* @__PURE__ */ jsx("li", { children: replaceMultipleStrWithDynamicVal(
      props.isShoppingCartPage ? receiveBetweenLabel : getBetweenLabel(cartItemFulfillmentSource),
      [
        (_a2 = cartItemFulfillmentSource.quantity) == null ? void 0 : _a2.toString(),
        getETAForRange(cartItemFulfillmentSource.etaEarliest),
        getETAForRange(cartItemFulfillmentSource.etaLatest)
      ]
    ) });
  };
  const rendersEstimatedDeliveryDate = (cartItemFulfillmentSource) => {
    var _a2;
    const quantity = (_a2 = cartItemFulfillmentSource == null ? void 0 : cartItemFulfillmentSource.quantity) == null ? void 0 : _a2.toString();
    return /* @__PURE__ */ jsx(
      "li",
      {
        dangerouslySetInnerHTML: {
          __html: quantity ? buildEstematedDeliveryDateSplitQty(quantity, estimatedDeliveryDateBetween) : estimatedDeliveryDateBetween || EMPTY_STRING
        }
      }
    );
  };
  const renderETAForRange = (storePickupDC2, storePickupInStore2, isEstimatedDeliveryDateAvailable2, isOrderFromInStoreAndDC2) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      checkIsEstimatedDeliveryDateAvailableSplitQty(
        isEstimatedDeliveryDateAvailable2,
        isOrderFromInStoreAndDC2
      ) ? rendersEstimatedDeliveryDate(storePickupInStore2) : createLi(storePickupInStore2),
      createLi(storePickupDC2)
    ] });
  };
  const renderETAInfo = (etaTime) => {
    return etaTime ? /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("b", { children: `${getBetweenSTHLabel()} ${getETAForRange(etaTime)}` }) }) : null;
  };
  const renderSTHBetweenRangeLabel = () => {
    const { sourceTypes: sourceTypes2 = [] } = fulfillment || {};
    const storePickupDC2 = getSourceTypeData(sourceTypes2, ProductSourceTypes.DC);
    return /* @__PURE__ */ jsx("li", { children: `${getBetweenSTHLabel()} ${getETAForRange(storePickupDC2.etaEarliest)} - ${getETAForRange(
      storePickupDC2.etaLatest
    )}` });
  };
  const checkOnlyDCStock = (dcQuantity2, inStoreQuantity, sourceDC, sourceStore) => {
    return props.isShoppingCartPage ? Boolean(dcQuantity2 && !inStoreQuantity) : Boolean(!Object.keys(sourceStore).length && Object.keys(sourceDC).length);
  };
  const { dcQuantity, storeQuantity: currentSelectedStoreQuantity } = (fulfillment == null ? void 0 : fulfillment.stockItemAvailability) || {};
  const isEstimatedDeliveryDateAvailable = getEstimatedDeliveryDateLabelAvailability(
    props.productData.badges,
    ProductSourceTypes.INSTORE,
    isBulk,
    fulfillment,
    isShowedEstimatedDeliveryDateBetween,
    !checkNotNullAndUndefined(estimatedDeliveryDate)
  );
  const { sourceTypes = [] } = fulfillment || {};
  const storePickupDC = getSourceTypeData(sourceTypes, ProductSourceTypes.DC);
  const storePickupInStore = getSourceTypeData(sourceTypes, ProductSourceTypes.INSTORE);
  const isOrderFromInStoreAndDC = checkIsOrderFromInStoreAndDC(storePickupDC, storePickupInStore);
  const isSTH = (selectedDeliveryMode == null ? void 0 : selectedDeliveryMode.isSTH) || !(selectedDeliveryMode == null ? void 0 : selectedDeliveryMode.isExpress);
  const renderSTHLabels = () => {
    if (singleShippingMethodOption) {
      return renderAllAvailabilityInfo();
    } else if (checkIsEstimatedDeliveryDateAvailableNotSplitQty(
      isEstimatedDeliveryDateAvailable,
      isOrderFromInStoreAndDC
    ) && isShowEstimatedDeliveryDateLabel(isShoppingCartPage, isOrderConfirmationPage, isSTH) && !isExpressDeliveryModeForOrder) {
      return rendersEstimatedDeliveryDate();
    } else if (checkOnlyDCStock(dcQuantity, currentSelectedStoreQuantity, storePickupDC, storePickupInStore)) {
      return renderSTHBetweenRangeLabel();
    } else if (isLimitedStockAndAvailableInDc) {
      return renderETAForRange(
        storePickupDC,
        storePickupInStore,
        isEstimatedDeliveryDateAvailable,
        isOrderFromInStoreAndDC
      );
    }
    return renderETAInfo(etaTimeOfDelivery);
  };
  return isPackageNotMainItem() ? null : renderSTHLabels();
};
const checkForQuantityAvailability = (product, enableAddTireWheelsByFourFromWishlist, isWheelOrTire) => {
  var _a, _b;
  if (enableAddTireWheelsByFourFromWishlist) {
    if (isWheelOrTire) {
      return ((_a = product.availableActions) == null ? void 0 : _a.isAddToCartEnabled) && ((_b = product == null ? void 0 : product.fulfillment) == null ? void 0 : _b.availability.quantity) >= magicNumber.FOUR;
    } else {
      return true;
    }
  } else {
    return !isWheelOrTire;
  }
};
const checkProductDataServicesListAvailability = (productData, extractSelectedServiceList) => {
  return productData.servicesList && productData.servicesList.length && !(extractSelectedServiceList == null ? void 0 : extractSelectedServiceList.length);
};
const checkServiceList = (productData, addOnServices) => {
  return productData.itemAvailabilityInfo && !productData.itemAvailabilityInfo.hardStopError && isArrayNotEmpty(addOnServices);
};
const checkIsOrderFromInStoreAndDC = (storePickupDC, storePickupInStore) => {
  return Boolean(Object.keys(storePickupDC).length) && Boolean(Object.keys(storePickupInStore).length);
};
const checkIsEstimatedDeliveryDateAvailableNotSplitQty = (isEstimatedDeliveryDateAvailable, isOrderFromInStoreAndDC) => {
  return isEstimatedDeliveryDateAvailable && !isOrderFromInStoreAndDC;
};
const checkIsEstimatedDeliveryDateAvailableSplitQty = (isEstimatedDeliveryDateAvailable, isOrderFromInStoreAndDC) => {
  return isEstimatedDeliveryDateAvailable && isOrderFromInStoreAndDC;
};
const isShowEstimatedDeliveryDateLabel = (isShoppingCartPage, isOrderConfirmationPage, isSTH) => {
  return isShoppingCartPage && isSTH || isOrderConfirmationPage;
};
const ProductCartItem = ({ ...props }) => {
  var _a, _b, _c, _d, _e;
  const {
    cart,
    availableLabel,
    changeShipToHomeCTALabel,
    pickAtStoreCTALabel,
    betweenLabel,
    inStorePurchaseOnlyMsg,
    isFreePickUpAtStore,
    isShipToHome,
    isServices,
    servicesDisclaimer,
    homePageLink,
    productData,
    addItemToWishlist,
    a11yWishlistIcon,
    a11yRemoveLabel,
    onChangeFulfillmentOption,
    onRemoveCartItem,
    exceededTotalAvailableMsg,
    updateCartData,
    eachLabel,
    limitOfLabel,
    exceededMsg,
    receiveBetweenLabel,
    availableByLabel,
    availableBetweenLabel,
    checkoutButtonClick,
    warningToastShow,
    exceededMsgBar,
    cartItemAnalytics,
    badgePriorities,
    inImageBadgePriorities,
    a11yServiceInstallation,
    serviceAddToCartHandler,
    selectedServiceList,
    quantitySelectorId,
    accessibilityGlobalProps,
    itemAvailabilityInfo,
    bulkLabel,
    updatedLabel,
    isWishList,
    PDPLink,
    rebateIcon,
    productColorLabel,
    inStockLabel,
    wishlistInStockLabel,
    addToCartLabel,
    addToCart,
    reviewsContainerId,
    onRemoveWishlistItem,
    onlineOrdering,
    language: language2,
    saveLabel,
    thresholdValue,
    hideQuantitySelector,
    productDisclaimer,
    qtyAbbrLabel,
    dpBuyAgainLabel,
    dpLearnMoreLabel,
    discScheduleDelivery,
    discServiceInstallation,
    discCannotTrack,
    isDetailPage,
    changeBrowserBackUrl,
    a11yStrikeOutPrice,
    a11yStrikeOutPriceRange,
    scrollToFooter: scrollToFooter2,
    feeDisclaimerType,
    cancelProductLabel,
    getEntriesInfo,
    customerSelfServiceCancelEnabled,
    enablePartialOrderCancellation,
    disableAvailabilityMessages,
    urgentLowStock,
    saveForLaterTitle,
    addItemToSaveForLater,
    saveForLaterFlagEnabled,
    betweenLabelOrderConf,
    isPostPOSOrderDetails,
    betweenLabelSTH,
    deliveryMode,
    singleShippingMethodOption,
    shipsIn,
    shipsInForEA,
    pickUpIn,
    availableForPickUpIn,
    unavailableForBOPIS,
    unavailableAtStoreForBOPIS,
    saleEndDisableShift,
    a11yCloseIconLabel,
    unavailableForSTH,
    bannerMaxPurchasableQuantity: maxInputVal$1 = maxInputVal,
    estimatedDeliveryDateBetween,
    removeitemFromWishlist,
    isShowedEstimatedDeliveryDateBetween,
    saleMessagesRules,
    showDiscountedPrice,
    highlightDiscountedPrice,
    isSelectedDeliveryAvailable,
    selectedDeliveryMode,
    itemNotEligibleForExpressDeliveryMsg,
    itemNotEligibleForStandardDeliveryMsg,
    expressDeliveryDoesNotSupportHeavyOversizedMsg,
    inStockOnlineLabel,
    isAvailableOnlyInDC,
    insufficientQuantityOfProductForExpressDeliveryMsg,
    setIsQtyExceed,
    isAllExpressProducts,
    a11yClickToReadFootnote,
    readyToDeliverLabel,
    wishlistProducts,
    etaTimeOfDelivery,
    isAuthUser,
    loginPageLink,
    cartPageLink,
    storeData,
    expressDeliveryAvailableNotification,
    expressDeliveryUnavailableNotification,
    isExpressDeliverySelected,
    plusMinusSymbol,
    displayRomanceCopyWithWasLabel,
    ssoHandler,
    enableSingleSignOn,
    isHeliumInflatedUnInflatedShown,
    heliumInflationUnInflationText,
    heliumAppointmentInfoMessage,
    showInflationLabels,
    isBouquetPackage,
    productYouMayNeedBtnClick,
    enableCartAccessoriesFlyout = false,
    prodYouMayAlsoNeedLabel,
    saleEndDaySoonMessage,
    isShoppingCartPage,
    hideSaleEndDaySoonMessage,
    cartItemsData
  } = props;
  const {
    images,
    quantity: itemQuantity,
    maxPurchaseQty: maxQuantity,
    totalPrice,
    name,
    fulfillment,
    sellable,
    rebate,
    originalPrice,
    currentPrice,
    discount,
    feeMessages,
    entryNumber,
    isBulk,
    priceMessage,
    url,
    saleCut,
    isOnSale,
    salePriceEndDate,
    isUrgentLowStock,
    isPriceRangeViewEnabled = false
  } = productData;
  const isShipHome = isOrderSTH(productData);
  const { a11yTooltipIcon } = accessibilityGlobalProps;
  const { oneProductQuantity } = productCartItems;
  const [qtySelectorInput, setQtySelectorInput] = useState(itemQuantity);
  const [fromInput, setFromInput] = useState(void 0);
  const [inputElementRef, setInputElementRef] = useState(null);
  const [prevQuantity, setPrevQuantity] = useState(itemQuantity);
  const cardClass = `${PREFIX}-common-card`;
  const cartClass2 = `${PREFIX}-shopping-cart__item`;
  const infoClass = `${PREFIX}-shopping-cart__product`;
  const balloonProductClass = isBalloonProduct(props.productData) ? `${PREFIX}-product-cart-item` : "";
  const promoMessagesStyleClassMobile = `${PREFIX}-md-none ${PREFIX}-xs-block ${PREFIX}-sm-block ${PREFIX}-promo-messages-wrapper`;
  const [globalBannerMaxVal, setGlobalBannerMax] = useState(false);
  const [inlineToastError, setInlineToastError] = useState(false);
  const [debounceTimeOut, setDebounceTimeOut] = useState(null);
  const showHideDiscountInfo = showHideSaleInfo(productData.originalPrice, isPostPOSOrderDetails);
  const storeMaxQuantity = Math.min(
    (_a = fulfillment == null ? void 0 : fulfillment.stockItemAvailability) == null ? void 0 : _a.storeQuantity,
    maxQuantity || ((_b = fulfillment == null ? void 0 : fulfillment.stockItemAvailability) == null ? void 0 : _b.storeQuantity)
  );
  const isQuantityExceedThanStoreQty = Boolean(qtySelectorInput > storeMaxQuantity);
  const quantitySelectorMaxInput = (selectedDeliveryMode == null ? void 0 : selectedDeliveryMode.isExpress) ? storeMaxQuantity : maxQuantity;
  const isExpressDeliveryModeForOrder = ((_c = productData == null ? void 0 : productData.fulfillment) == null ? void 0 : _c.deliveryMode) === CartOrderDeliveryModes.EXPRESS;
  const [extractSelectedServiceList, setExtractSelectedServiceList] = useState(
    extractServiceBasedOnSku(
      productData.code,
      selectedServiceList,
      isDetailPage,
      productData.status,
      (_d = productData.fulfillment) == null ? void 0 : _d.deliveryMode
    )
  );
  const { cartDebounceTimeOut } = productCartItems;
  const counterRef = useRef(0);
  const enableBalloonAddons = !!props.enableRecommendedBalloonProducts;
  const previousSelectedServiceList = usePrevious(selectedServiceList);
  const runErrorAnalyticsFlowOnlyOnce = useRef(0);
  const [qtyExceededErr, setQtyExceededErr] = useState(false);
  const isInWishList = checkIsInWishList(wishlistProducts, productData.code);
  const loyaltyValue = useCalculatedLoyaltyValue(productData == null ? void 0 : productData.loyalty, false, {
    qtySelectorInput: 1
  });
  const loyaltyProp = isShoppingCartPage ? { loyaltyValue } : {};
  useEffect(() => {
    var _a2;
    if (selectedServiceList !== previousSelectedServiceList) {
      const addOnServices = extractServiceBasedOnSku(
        productData.code,
        selectedServiceList,
        isDetailPage,
        productData.status,
        (_a2 = productData.fulfillment) == null ? void 0 : _a2.deliveryMode
      );
      setExtractSelectedServiceList(addOnServices);
      if (checkServiceList(props, addOnServices)) {
        addOnServices.forEach((service) => {
          var _a3;
          if (!service.sellable) {
            (_a3 = props.setErrorInfoHandler) == null ? void 0 : _a3.call(props, true, false);
          }
        });
      }
    }
  }, [
    isDetailPage,
    productData.code,
    productData.fulfillment,
    productData.status,
    props,
    selectedServiceList,
    previousSelectedServiceList
  ]);
  const optionsToBeDisplayed = itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed;
  useEffect(() => {
    var _a2, _b2;
    if (runErrorAnalyticsFlowOnlyOnce.current === 0 && props.itemAvailabilityInfo) {
      runErrorAnalyticsFlowOnlyOnce.current = 1;
      const { errorMessage, showInlineError, hardStopError, isShowETAToast } = props.itemAvailabilityInfo;
      showInlineError && !!props.errorAnalyticsForInlineToast && props.errorAnalyticsForInlineToast(errorMessage);
      !!hardStopError && ((_a2 = props.setErrorInfoHandler) == null ? void 0 : _a2.call(props, showInlineError, false));
      isShowETAToast && !!(optionsToBeDisplayed == null ? void 0 : optionsToBeDisplayed.includes(OptionsOnCartItem.UPDATED_TEXT)) && ((_b2 = props.setErrorInfoHandler) == null ? void 0 : _b2.call(props, false, true, true));
    }
  }, [optionsToBeDisplayed, props]);
  const priceIncrementHandler = (incrementValue, fromInputUpdate, inputRef) => {
    setQtySelectorInput(incrementValue);
    setFromInput(fromInputUpdate);
    setInputElementRef(inputRef);
    !!qtySelectorInput && setPrevQuantity(qtySelectorInput);
    counterRef.current = magicNumber.ONE;
  };
  const informationErrorMessage = (errorMessage, errorMessageShow, exceededValue) => {
    return {
      errorMsg: errorMessage,
      quantityExceeded: errorMessageShow,
      exceededValue
    };
  };
  const checkAvailableQuantity = () => {
    const { dcQuantity, storeQuantity } = (fulfillment == null ? void 0 : fulfillment.stockItemAvailability) || {};
    if (singleShippingMethodOption) {
      return deliveryMode === "BOPIS" ? storeQuantity : dcQuantity;
    }
    return (fulfillment == null ? void 0 : fulfillment.orderableFromDC) && dcQuantity ? dcQuantity + storeQuantity : storeQuantity;
  };
  const checkMaxQuantityError = () => {
    const isExpressDeliveryHasQtyExceedErr = Boolean(
      (storeData == null ? void 0 : storeData.isExpressDeliveryEligible) && (selectedDeliveryMode == null ? void 0 : selectedDeliveryMode.isExpress) && isQuantityExceedThanStoreQty
    );
    return maxQuantity && qtySelectorInput > maxQuantity && maxQuantity <= checkAvailableQuantity() || isExpressDeliveryHasQtyExceedErr;
  };
  const validateQuantityRequest = () => {
    return qtySelectorInput > checkAvailableQuantity() && checkAvailableQuantity() < maxInputVal$1;
  };
  const checkGlobalBannerMax = () => {
    return qtySelectorInput > maxInputVal$1 && checkAvailableQuantity() > maxInputVal$1;
  };
  const renderUpdatedText = () => {
    var _a2;
    return ((_a2 = itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed) == null ? void 0 : _a2.includes(OptionsOnCartItem.UPDATED_TEXT)) && /* @__PURE__ */ jsx("p", { className: `${infoClass}__updated-text`, children: updatedLabel });
  };
  const getBetweenSTHLabel = () => {
    const label = props.isShoppingCartPage ? betweenLabel : betweenLabelOrderConf;
    return isExpressDeliveryModeForOrder ? readyToDeliverLabel : label;
  };
  const prepareShipsInMessage = () => {
    return (fulfillment == null ? void 0 : fulfillment.isEndlessAisle) && !!shipsInForEA ? shipsInForEA : shipsIn;
  };
  const renderExpressDeliveryNotification = () => {
    var _a2, _b2, _c2;
    const expressDeliveryAvailability = ((_a2 = productData.fulfillment) == null ? void 0 : _a2.isEligibleForExpressDelivery) && ((_c2 = (_b2 = productData.fulfillment) == null ? void 0 : _b2.stockItemAvailability) == null ? void 0 : _c2.storeQuantity) ? expressDeliveryAvailableNotification : expressDeliveryUnavailableNotification;
    return (storeData == null ? void 0 : storeData.isExpressDeliveryEligible) ? /* @__PURE__ */ jsx("li", { children: expressDeliveryAvailability }) : null;
  };
  const renderAllAvailabilityInfo = () => {
    var _a2;
    const { isEligibleToPickupFromStore, isEligibleToShipHome, stockItemAvailability } = fulfillment || {};
    const isBopisCart = deliveryMode === "BOPIS";
    const bopisAvailability = (
      // eslint-disable-next-line sonar/expression-complexity
      !isEligibleToPickupFromStore || !sellable ? unavailableForBOPIS : (
        // eslint-disable-next-line sonar/no-nested-conditional
        !(stockItemAvailability == null ? void 0 : stockItemAvailability.storeQuantity) ? replaceStrWithDynamicVal(unavailableAtStoreForBOPIS, (_a2 = cart == null ? void 0 : cart.storeData) == null ? void 0 : _a2.displayName) : (
          // eslint-disable-next-line sonar/no-nested-conditional
          isBopisCart ? pickUpIn : availableForPickUpIn
        )
      )
    );
    const sthAvailability = isEligibleToShipHome && sellable && (stockItemAvailability == null ? void 0 : stockItemAvailability.dcQuantity) ? prepareShipsInMessage() : unavailableForSTH;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("li", { children: bopisAvailability }),
      /* @__PURE__ */ jsx("li", { children: sthAvailability }),
      renderExpressDeliveryNotification()
    ] });
  };
  const shipToHomeLabel = () => {
    const { dcQuantity, storeQuantity: currentSelectedStoreQuantity } = (fulfillment == null ? void 0 : fulfillment.stockItemAvailability) || {};
    const { sourceTypes = [] } = fulfillment || {};
    const storePickupDC = getSourceTypeData(sourceTypes, ProductSourceTypes.DC);
    const storePickupInStore = getSourceTypeData(sourceTypes, ProductSourceTypes.INSTORE);
    const isLimitedStockAndAvailableInDc = limitedStockAndAvailableInDc(
      dcQuantity,
      currentSelectedStoreQuantity,
      storePickupDC,
      storePickupInStore
    );
    return /* @__PURE__ */ jsx(
      STHDeliveryLabels,
      {
        cart,
        productData,
        isBulk,
        selectedDeliveryMode,
        isShowedEstimatedDeliveryDateBetween,
        singleShippingMethodOption,
        isShoppingCartPage: props.isShoppingCartPage,
        isOrderConfirmationPage: props.isOrderConfirmationPage,
        receiveBetweenLabel,
        betweenLabelSTH,
        etaTimeOfDelivery,
        renderAllAvailabilityInfo,
        isLimitedStockAndAvailableInDc,
        getETAForRange,
        getBetweenSTHLabel,
        estimatedDeliveryDateBetween
      }
    );
  };
  const checkOnlyDCStock = (dcQuantity, inStoreQuantity, sourceDC, sourceStore) => {
    return props.isShoppingCartPage ? Boolean(dcQuantity && !inStoreQuantity) : Boolean(!Object.keys(sourceStore).length && Object.keys(sourceDC).length);
  };
  const limitedStockAndAvailableInDc = (dcQuantity, inStoreQuantity, sourceDC, sourceStore) => {
    const actualQty = isExpressDeliveryModeForOrder && itemQuantity > inStoreQuantity ? inStoreQuantity : itemQuantity;
    return props.isShoppingCartPage ? Boolean(dcQuantity && inStoreQuantity < actualQty) : Boolean(Object.keys(sourceDC).length && Object.keys(sourceStore).length);
  };
  const checkOnlyStore = (storeQty, sourceStore) => {
    return props.isShoppingCartPage ? Boolean(storeQty) : Boolean(Object.keys(sourceStore).length);
  };
  const getETATime = (date) => {
    if (!date) {
      return "";
    }
    const options = getETATimeOptions(productCartItems.etaTimeOptions);
    const intlDate = localization.formattedDate(options, date, language2);
    return intlDate.split(",").reverse().map((item) => item.trim()).join(", ").replace(/\./g, "").replace("  ", "");
  };
  const getETAForRange = (date) => {
    if (!date) {
      return "";
    }
    const options = productCartItems.etaDateOptions;
    const intlDate = localization.formattedDate(options, date, language2);
    return intlDate.replace(/\./g, "");
  };
  const inStorePickup = (hideAvailabilityLabelForHeliumProduct, cartData) => {
    var _a2;
    const isPackageItem = isProductFromPackage(cartData == null ? void 0 : cartData.bopisPackages, productData);
    if (isAtleastOneParamValid(isPackageItem, hideAvailabilityLabelForHeliumProduct)) {
      return null;
    }
    const { dcQuantity, storeQuantity: inStore } = (fulfillment == null ? void 0 : fulfillment.stockItemAvailability) || {};
    const { sourceTypes = [] } = fulfillment || {};
    const storePickupDC = sourceTypes.find((source) => source.productSourceType === ProductSourceTypes.DC) || {};
    const storePickupInStore = sourceTypes.find((source) => source.productSourceType === ProductSourceTypes.INSTORE) || {};
    if (singleShippingMethodOption) {
      return renderAllAvailabilityInfo();
    } else if (checkOnlyDCStock(dcQuantity, inStore, storePickupDC, storePickupInStore)) {
      return /* @__PURE__ */ jsx("li", { children: replaceMultipleStrWithDynamicVal(availableBetweenLabel, [
        getETAForRange(storePickupDC.etaEarliest),
        getETAForRange(storePickupDC.etaLatest)
      ]) });
    } else if (limitedStockAndAvailableInDc(dcQuantity, inStore, storePickupDC, storePickupInStore)) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("li", { children: `${storePickupInStore.quantity} ${availableLabel} ${getETATime(
          storePickupInStore.etaEarliest
        )}` }),
        /* @__PURE__ */ jsx("li", { children: replaceMultipleStrWithDynamicVal(availableByLabel, [
          (_a2 = storePickupDC.quantity) == null ? void 0 : _a2.toString(),
          getETAForRange(storePickupDC.etaEarliest),
          getETAForRange(storePickupDC.etaLatest)
        ]) })
      ] });
    } else if (checkOnlyStore(inStore, storePickupInStore)) {
      return /* @__PURE__ */ jsxs("li", { children: [
        " ",
        `${availableLabel} ${getETATime(storePickupInStore.etaEarliest)}`
      ] });
    } else {
      return null;
    }
  };
  const availableShipLabel = () => {
    var _a2, _b2, _c2, _d2;
    const isHeliumInflationOptionSelected = (_a2 = productData == null ? void 0 : productData.selectedStoreServices) == null ? void 0 : _a2.some(
      (service) => service.value === inflationData.heliumAddOn
    );
    const cartData = cart || cartItemsData;
    const hideAvailabilityLabelForHeliumProduct = isHeliumInflationOptionSelected && (isHeliumInflatedUnInflatedShown || showInflationLabels) || ((_d2 = (_c2 = (_b2 = cartData == null ? void 0 : cartData.cart) == null ? void 0 : _b2.bookedAppointments) == null ? void 0 : _c2[magicNumber.ZERO]) == null ? void 0 : _d2.isPickupAllItemsTogether);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      renderHeliumInflationUnInflationText(isHeliumInflatedUnInflatedShown, heliumInflationUnInflationText),
      !hideQuantitySelector && !singleShippingMethodOption && renderUpdatedText(),
      onlineOrdering ? isShipHome ? shipToHomeLabel() : inStorePickup(hideAvailabilityLabelForHeliumProduct, cartData) : /* @__PURE__ */ jsx("li", { children: inStorePurchaseOnlyMsg }),
      renderHeliumAppointmentInfoMessage(
        infoClass,
        isHeliumInflationOptionSelected,
        heliumAppointmentInfoMessage,
        isHeliumInflatedUnInflatedShown
      )
    ] });
  };
  const checkErrorMessage = () => {
    var _a2, _b2, _c2;
    const isLimitQtyToast = (itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.hardStopError) ? false : true;
    if (isServices) {
      return informationErrorMessage("", false, "");
    } else if (checkMaxQuantityError()) {
      (_a2 = props.setErrorInfoHandler) == null ? void 0 : _a2.call(props, true, false, false, isLimitQtyToast);
      return informationErrorMessage(
        replaceStrWithDynamicVal(exceededMsg, storeMaxQuantity),
        true,
        `${storeMaxQuantityInfo(maxQuantity, storeMaxQuantity)} `
      );
    } else if (validateQuantityRequest()) {
      (_b2 = props.setErrorInfoHandler) == null ? void 0 : _b2.call(props, true, false, false, isLimitQtyToast);
      return informationErrorMessage(
        replaceStrWithDynamicVal(exceededTotalAvailableMsg, checkAvailableQuantity()),
        true,
        `${checkAvailableQuantity()} `
      );
    } else if (checkGlobalBannerMax() || globalBannerMaxVal) {
      (_c2 = props.setErrorInfoHandler) == null ? void 0 : _c2.call(props, true, false, false, isLimitQtyToast);
      return informationErrorMessage(
        replaceStrWithDynamicVal(exceededMsg, maxInputVal$1),
        true,
        maxInputVal$1.toString()
      );
    }
    return informationErrorMessage("", false, "");
  };
  const isQuantityExceeded = (_e = checkErrorMessage()) == null ? void 0 : _e.quantityExceeded;
  const previousQtySelectorInput = usePrevious(qtySelectorInput);
  const previousFromInput = usePrevious(fromInput);
  const previousInputElementRef = usePrevious(inputElementRef);
  useEffect(() => {
    setQuantityExceedErrForExpressDeliveryProduct(
      isQuantityExceedThanStoreQty,
      qtyExceededErr,
      setQtyExceededErr,
      selectedDeliveryMode,
      isSelectedDeliveryAvailable,
      isAllExpressProducts,
      setIsQtyExceed,
      setInlineToastError
    );
  }, [
    isAllExpressProducts,
    qtyExceededErr,
    isQuantityExceeded,
    isSelectedDeliveryAvailable,
    selectedDeliveryMode,
    setQtyExceededErr,
    setIsQtyExceed,
    fulfillment,
    isQuantityExceedThanStoreQty
  ]);
  useEffect(() => {
    if (
      // eslint-disable-next-line sonar/expression-complexity
      (previousQtySelectorInput !== qtySelectorInput || previousFromInput !== fromInput || previousInputElementRef !== inputElementRef) && !!qtySelectorInput && !isQuantityExceeded && prevQuantity !== qtySelectorInput
    ) {
      const isAdd = Boolean(prevQuantity < qtySelectorInput);
      updateCartData(qtySelectorInput, isAdd, entryNumber, fromInput, inputElementRef);
      counterRef.current = 0;
    }
  }, [
    qtySelectorInput,
    fromInput,
    inputElementRef,
    isQuantityExceeded,
    prevQuantity,
    updateCartData,
    entryNumber,
    previousQtySelectorInput,
    previousFromInput,
    previousInputElementRef,
    isQuantityExceedThanStoreQty
  ]);
  const limitLabelCheck = (isProductService) => {
    if (maxQuantity && !isProductService) {
      return {
        limitLabel: replaceStrWithDynamicVal(limitOfLabel, maxQuantity),
        limitLabelShow: true
      };
    }
    return {
      limitLabel: "",
      limitLabelShow: false
    };
  };
  useEffect(() => {
    if (counterRef.current === 0) {
      setQtySelectorInput(itemQuantity);
      setPrevQuantity(itemQuantity);
    }
  }, [itemQuantity]);
  const globalBannerMaxErrorCheck = (value) => {
    setGlobalBannerMax(value);
  };
  const renderRebateSection = () => {
    if (rebate && Object.keys(rebate).length) {
      const { message, tooltipMessage, greyCopyMsg, pdfLink } = rebate;
      return /* @__PURE__ */ jsx("div", { className: `${infoClass} __rebate-info ${PREFIX}-col-sm-12`, children: /* @__PURE__ */ jsx(
        Rebate,
        {
          title: message || "",
          tooltipMessage,
          greyCopyMsg,
          a11yTooltipIcon,
          rebateIcon,
          pdfLink
        }
      ) });
    }
    return null;
  };
  const renderRemoveButton = (removeService, isProductService, selectedServiceData) => {
    return /* @__PURE__ */ jsxs(
      "button",
      {
        className: `${cartClass2}__icon--close`,
        "data-testid": "cartCloseIcon",
        "aria-label": a11yRemoveLabel,
        "aria-describedby": wishlistPrefixId(productData == null ? void 0 : productData.code),
        onClick: (e) => cartCloseHandler(
          e,
          removeService,
          isProductService,
          selectedServiceData,
          extractSelectedServiceList
        ),
        children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" }),
          saveForLaterFlagEnabled ? /* @__PURE__ */ jsx(
            "span",
            {
              className: `${infoClass}__title-link ${infoClass}__title-link--space ${infoClass}__title-link--align`,
              children: a11yRemoveLabel
            }
          ) : null
        ]
      }
    );
  };
  const onClickForSfl = (isProductService, redirectToClp) => {
    if (redirectToClp) {
      ssoHandler(true);
    }
    addItemToSaveForLater(productData, extractSelectedServiceList, true, isProductService);
  };
  const renderSaveForLaterButtonForURL = (isProductService) => {
    return /* @__PURE__ */ jsx(
      SanitizeStringContentWrapper,
      {
        stringContent: urlRedirection(
          urlRedirection(loginPageLink, "returnURL", cartPageLink),
          saveForLaterParam,
          "true"
        ),
        children: (memoizedStringContent) => /* @__PURE__ */ jsxs(
          "a",
          {
            className: `${cartClass2}__icon--sfl`,
            "data-testid": "saveForLaterIcon",
            href: memoizedStringContent,
            onClick: () => onClickForSfl(isProductService, false),
            "data-link-value": saveForLaterTitle,
            "aria-label": saveForLaterTitle,
            children: [
              /* @__PURE__ */ jsx(Icon, { type: "ct-save-for-later", size: "lg" }),
              renderSaveForLaterTitle()
            ]
          }
        )
      }
    );
  };
  const renderSaveForLaterTitle = () => {
    return /* @__PURE__ */ jsx(
      "span",
      {
        className: `${infoClass}__title-link ${infoClass}__title-link--space ${infoClass}__title-link--align`,
        children: saveForLaterTitle
      }
    );
  };
  const renderSflButton = (isProductService, useSingleSignOn) => {
    return /* @__PURE__ */ jsxs(
      "button",
      {
        className: `${cartClass2}__icon--sfl`,
        "data-testid": "saveForLaterIcon",
        "aria-label": saveForLaterTitle,
        onClick: () => onClickForSfl(isProductService, useSingleSignOn),
        children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-save-for-later", size: "lg" }),
          renderSaveForLaterTitle()
        ]
      }
    );
  };
  const renderSaveForLaterButton = (isProductService) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      isAuthUser && renderSflButton(isProductService, false),
      !isAuthUser && enableSingleSignOn && renderSflButton(isProductService, true),
      !isAuthUser && !enableSingleSignOn && renderSaveForLaterButtonForURL(isProductService)
    ] });
  };
  const renderProductYouMayAlsoNeed = (isProductService, isService) => {
    return /* @__PURE__ */ jsx(Fragment, { children: showProductYouMayAlsoLikeBtn(
      productData.entryType,
      isProductService,
      isService,
      enableCartAccessoriesFlyout
    ) && /* @__PURE__ */ jsxs(
      "button",
      {
        className: `${cartClass2}__icon--product-you-may-need`,
        onClick: (e) => {
          var _a2;
          addModalAttribute(e);
          productYouMayNeedBtnClick(productData == null ? void 0 : productData.code, (_a2 = productData == null ? void 0 : productData.fulfillment) == null ? void 0 : _a2.deliveryMode);
        },
        children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-product-you-may-like", size: "lg" }),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: `${infoClass}__title-link ${infoClass}__title-link--space ${infoClass}__title-link--align`,
              children: prodYouMayAlsoNeedLabel
            }
          )
        ]
      }
    ) });
  };
  const renderButtons = (isService, removeService, isProductService, selectedServiceData, isWishlistSection = true) => {
    return isWishlistSection ? /* @__PURE__ */ jsxs("div", { className: `${cartClass2}__icon`, children: [
      showWishListIcon(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError, itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed) && !isWishList && !isService && /* @__PURE__ */ jsx(
        "button",
        {
          className: `${cartClass2}__icon--wishlist`,
          "aria-label": a11yWishlistIcon,
          "data-testid": "cartWishlistIcon",
          onClick: () => addOrRemoveWishlist(addOrRemoveWishlistProps, isInWishList, productData),
          children: renderWishListIconComponent(isInWishList)
        }
      ),
      !saveForLaterFlagEnabled && renderRemoveButton(removeService, isProductService, selectedServiceData)
    ] }) : /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${cartClass2}__icon ${cartClass2}__icon--bottom ${cartClass2}__icon--bottom-container ${cartClass2}__icon--sfl-${saveForLaterFlagEnabled ? "enabled" : "disabled"} ${showProductYouMayAlsoLikeBtn(
          productData.entryType,
          isProductService,
          isService,
          enableCartAccessoriesFlyout
        ) ? `${cartClass2}__icon--cart-accessories-flyout` : ""}`,
        "data-testid": "productCartItemBottomIcon",
        children: [
          renderProductYouMayAlsoNeed(isProductService, isService),
          saveForLaterFlagEnabled ? /* @__PURE__ */ jsxs(Fragment, { children: [
            renderSaveForLaterButton(isProductService),
            renderRemoveButton(removeService, isProductService, selectedServiceData)
          ] }) : null
        ]
      }
    );
  };
  const displyFullfilment = (isProductService) => {
    return (isFreePickUpAtStore || isShipToHome) && !isProductService;
  };
  const getChangeFulfillmentLabel = () => {
    const isBOPISPackageItem = isProductFromPackage(cart == null ? void 0 : cart.bopisPackages, productData);
    const isSTHPackageItem = isProductFromPackage(cart == null ? void 0 : cart.sthPackages, productData);
    if (isShipHome) {
      return (fulfillment == null ? void 0 : fulfillment.isEligibleToPickupFromStore) && !isSTHPackageItem && pickAtStoreCTALabel;
    }
    return ((fulfillment == null ? void 0 : fulfillment.isEligibleToShipHome) || (fulfillment == null ? void 0 : fulfillment.isEligibleForExpressDelivery)) && !isBOPISPackageItem && changeShipToHomeCTALabel;
  };
  const checkIfAvailable = () => {
    return !((itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) && !itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.AVAILABILITY_INFO));
  };
  const renderDisclaimerAndRebate = (isService) => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      renderRebateSection(),
      renderDisclaimer(isService)
    ] });
  };
  const renderDisclaimer = (isService) => {
    return /* @__PURE__ */ jsx(Fragment, { children: isService ? /* @__PURE__ */ jsx("p", { className: `${infoClass}__service-disclaimer`, children: servicesDisclaimer }) : isShipHome && isBulk && /* @__PURE__ */ jsxs("p", { className: `${infoClass}__service-disclaimer`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-information-grey", size: "sm" }),
      productDisclaimer
    ] }) });
  };
  const renderChangeFulfillmentButton = () => {
    const showChangeFulfillmentOption = getChangeFulfillmentLabel();
    return /* @__PURE__ */ jsx(
      Button,
      {
        id: "show-fulfillment",
        type: "tertiary",
        size: "mini",
        onClick: () => onChangeFulfillmentOption(
          checkDeliveryMethodType(isShipToHome, isExpressDeliverySelected, deliveryMode),
          productData == null ? void 0 : productData.entryNumber
        ),
        children: showChangeFulfillmentOption
      }
    );
  };
  const renderUrgencyLimitedStock = (isTablet) => {
    var _a2, _b2;
    const productQty = (_b2 = (_a2 = productData == null ? void 0 : productData.fulfillment) == null ? void 0 : _a2.stockItemAvailability) == null ? void 0 : _b2.storeQuantity;
    return /* @__PURE__ */ jsx(Fragment, { children: props.limitedStockMessage && (productData == null ? void 0 : productData.isUrgentLowStock) && !!productQty && /* @__PURE__ */ jsx("div", { className: `${infoClass}__limitedStock ${infoClass}__limitedStock${isTablet}`, children: replaceStrWithDynamicVal(props.limitedStockMessage, productQty) }) });
  };
  const isChangeFulfillmentAllowed = () => {
    return !singleShippingMethodOption && getChangeFulfillmentLabel() && onlineOrdering;
  };
  const renderAvailability = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: `${infoClass} ${PREFIX}-md-none ${PREFIX}-xs-none ${PREFIX}-sm-block`, children: [
      /* @__PURE__ */ jsx("div", { children: renderUrgencyLimitedStock("--tabletStock") }),
      isOnSale && renderSaleEndDaySoonMessageComp(
        salePriceEndDate,
        isOnSale,
        isUrgentLowStock,
        isShoppingCartPage,
        hideSaleEndDaySoonMessage,
        saleEndDaySoonMessage,
        saleEndDisableShift
      ),
      !isDetailPage && /* @__PURE__ */ jsx("ul", { className: `${infoClass}__availability`, children: availableShipLabel() }),
      renderDisclaimerAndRebate(isServices),
      !singleShippingMethodOption && isChangeFulfillmentAllowed() && renderChangeFulfillmentButton()
    ] }) });
  };
  const isProductAvailabilityInfo = (isService, isProductService) => {
    const showChangeFulfillmentOption = getChangeFulfillmentLabel();
    return checkIfAvailable() && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: `${infoClass} ${PREFIX}-md-none ${PREFIX}-xs-block ${PREFIX}-sm-none`, children: [
        /* @__PURE__ */ jsx("div", { children: renderUrgencyLimitedStock() }),
        // eslint-disable-next-line sonar/expression-complexity
        displyFullfilment(isProductService) && /* @__PURE__ */ jsxs(Fragment, { children: [
          isOnSale && renderSaleEndDaySoonMessageComp(
            salePriceEndDate,
            isOnSale,
            isUrgentLowStock,
            isShoppingCartPage,
            hideSaleEndDaySoonMessage,
            saleEndDaySoonMessage,
            saleEndDisableShift
          ),
          !isDetailPage && /* @__PURE__ */ jsx("ul", { className: `${infoClass}__availability`, children: availableShipLabel() }),
          renderDisclaimerAndRebate(isService),
          !hideQuantitySelector && !singleShippingMethodOption && showChangeFulfillmentOption && renderChangeFulfillmentButton()
        ] })
      ] }),
      !displyFullfilment(isProductService) && renderDisclaimer(isService)
    ] });
  };
  useEffect(() => {
    var _a2;
    if (isQuantityExceeded && checkoutButtonClick) {
      setInlineToastError(true);
      warningToastShow(true);
    } else if (!!(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.errorMessage) && checkoutButtonClick) {
      setInlineToastError(true);
    } else if (!isSelectedDeliveryAvailable && !!(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.errorMessage)) {
      setInlineToastError(true);
      (_a2 = props.setErrorInfoHandler) == null ? void 0 : _a2.call(props, true, false);
    } else if (!isQuantityExceeded && !(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.errorMessage)) {
      setInlineToastError(false);
    }
  }, [
    isQuantityExceeded,
    checkoutButtonClick,
    itemAvailabilityInfo,
    isSelectedDeliveryAvailable,
    warningToastShow,
    props.setErrorInfoHandler,
    props
  ]);
  const checkQunatityReduced = useCallback(
    (removedAnItem) => {
      if (removedAnItem) {
        return qtySelectorInput;
      }
      return qtySelectorInput < itemQuantity ? itemQuantity - qtySelectorInput : qtySelectorInput - itemQuantity;
    },
    [itemQuantity, qtySelectorInput]
  );
  const getBadgeComponent = (isProductService) => {
    return productData.badges && productData.badges.length > 0 && !isProductService && /* @__PURE__ */ jsx("div", { className: `${cartClass2}__cart-badges`, children: /* @__PURE__ */ jsx(
      Badges,
      {
        badges: productData.badges,
        badgesAndPriorities: badgePriorities,
        hideDisclaimer: true,
        saleEndDaySoonMessage: props.saleEndDaySoonMessage,
        salePriceEndDate: productData == null ? void 0 : productData.salePriceEndDate,
        isShoppingCart: props.isShoppingCartPage,
        saleEndDisableShift,
        isOnSale,
        ...loyaltyProp
      }
    ) });
  };
  const isProductRemoved = (serviceAddonList, isServiceRemoved) => {
    return isServiceRemoved ? isServiceRemoved : isArrayNotEmpty(serviceAddonList);
  };
  const cartCloseHandler = (event, isServiceRemoved, isProductService, removedServiceData, addedServiceAddons) => {
    if (isWishList) {
      onRemoveWishlistItem(productData);
    } else if (!isProductService) {
      const removedItemData = productData;
      cartItemAnalytics(removedItemData, checkQunatityReduced(true));
      onRemoveCartItem(
        isProductRemoved(addedServiceAddons, isProductService),
        productData,
        extractSelectedServiceList,
        qtySelectorInput
      );
    } else {
      addModalAttribute(event);
      onRemoveCartItem(!isServiceRemoved, removedServiceData);
    }
  };
  const callAnalytics = useCallback(() => {
    const maxQtyReached = maxQuantity && qtySelectorInput > maxQuantity;
    if (qtySelectorInput > itemQuantity) {
      cartItemAnalytics(props.productData, checkQunatityReduced(), "addToCart", maxQtyReached);
    } else if (qtySelectorInput < itemQuantity) {
      cartItemAnalytics(props.productData, checkQunatityReduced());
    }
  }, [cartItemAnalytics, checkQunatityReduced, itemQuantity, maxQuantity, props.productData, qtySelectorInput]);
  useEffect(() => {
    if (qtySelectorInput !== previousQtySelectorInput) {
      customDebounce(callAnalytics, cartDebounceTimeOut, debounceTimeOut, setDebounceTimeOut)();
    }
  }, [callAnalytics, cartDebounceTimeOut, debounceTimeOut, qtySelectorInput, previousQtySelectorInput]);
  const serviceInstallationComponent = () => {
    if (checkProductDataServicesListAvailability(productData, extractSelectedServiceList)) {
      return /* @__PURE__ */ jsx("div", { className: `${cartClass2}__service-installation`, children: /* @__PURE__ */ jsx(
        CartServicesComponent,
        {
          cartServices: productData.servicesList,
          serviceAddOnLabel: props.addonTitle,
          addServiceToCartLabel: props.addServicesCTALabel,
          serviceAddOnIcon: "ct-tools",
          serviceAddOnNextSteps: servicesDisclaimer,
          serviceAddToCartHandler,
          serviceDescription: props.serviceAvailableMsg,
          parentProduct: productData,
          onFlyout: false
        }
      ) });
    }
    return null;
  };
  const productServiceComponent = (selectedService) => {
    return cartItemComponent({
      isService: true,
      isProductService: true,
      productServiceTitle: props.addonTitle,
      selectedServiceData: selectedService,
      disableQuantitySelector: true,
      removeService: true,
      showBorder: false
    });
  };
  const quantitySelectorComponent = (isProductService, selectedServiceData, disableQuantitySelector) => {
    return !isWishList && onlineOrdering && !hideQuantitySelector ? /* @__PURE__ */ jsx("div", { className: `${cartClass2}__quantity ${PREFIX}-col-md-4 ${PREFIX}-col-sm-3`, children: /* @__PURE__ */ jsx(
      QuantitySelector,
      {
        setQtySelectorInput: priceIncrementHandler,
        qtySelectorInput: isProductService ? selectedServiceData.quantity : qtySelectorInput,
        defaultQty: isProductService ? selectedServiceData.quantity : itemQuantity,
        maxQty: isProductService ? selectedServiceData.maxQuantity : quantitySelectorMaxInput,
        maximumQuantityError: checkErrorMessage().errorMsg,
        quantityExceeded: checkErrorMessage().quantityExceeded,
        limitLabel: limitLabelCheck(isProductService).limitLabel,
        limitLabelShow: limitLabelCheck(isProductService).limitLabelShow,
        checkBannerMaxError: globalBannerMaxErrorCheck,
        disabled: disableQuantitySelector,
        a11yQuantityLabel: accessibilityGlobalProps.a11yQuantityLabel,
        a11yQuantityDecrementLabel: accessibilityGlobalProps.a11yQuantityDecrementLabel,
        a11yQuantityIncrementLabel: accessibilityGlobalProps.a11yQuantityIncrementLabel,
        a11yQuantityInputAriaLabel: accessibilityGlobalProps.a11yQuantityInputAriaLabel,
        a11yMinQuantityReached: accessibilityGlobalProps.a11yMinQuantityReached,
        id: isProductService ? `quantity - selector - ${selectedServiceData.code} ` : quantitySelectorId,
        a11yUpdatedQuantityText: accessibilityGlobalProps.a11yUpdatedQuantityText
      }
    ) }) : null;
  };
  const saveMessage = useGenerateSaveMessage(saleCut, originalPrice, saleMessagesRules, currentPrice);
  const renderProductServicePrice = (isService, serviceData) => {
    var _a2, _b2, _c2, _d2;
    const priceValue = getPriceValue(
      serviceData,
      currentPrice,
      totalPrice,
      oneProductQuantity,
      itemQuantity,
      props.isWheelOrTire
    );
    const checkDisplayWasLabel = showHideWasLabel(isPostPOSOrderDetails, productData.displayWasLabel);
    const hideSaveLabel = checkDisplayWasLabel && !displayRomanceCopyWithWasLabel;
    const feeMessage = isArrayNotEmpty(feeMessages) ? feeMessages == null ? void 0 : feeMessages[0] : {};
    const feeMessageValue = (
      // eslint-disable-next-line no-unsafe-optional-chaining
      isWishList && props.isWheelOrTire ? (feeMessage == null ? void 0 : feeMessage.value) * magicNumber.FOUR : feeMessage == null ? void 0 : feeMessage.value
    );
    return isService ? /* @__PURE__ */ jsx(
      Price,
      {
        isRangeView: isPriceRangeViewEnabled,
        scrollToFooter: scrollToFooter2,
        priceValue,
        currentPrice: serviceData.currentPrice,
        language: language2,
        eachLabel,
        isMoreQuantityCartPage: serviceData.quantity > oneProductQuantity,
        a11yStrikeOutPrice,
        a11yStrikeOutPriceRange,
        nowFromLabel: props.nowFromLabel,
        saveFromLabel: props.saveFromLabel,
        wasFromLabel: props.wasFromLabel,
        fromLabel: props.fromLabel,
        feeDisclaimerType,
        saveMessage,
        isAppliedPromoExist: !!((_b2 = (_a2 = props.productData) == null ? void 0 : _a2.appliedPromoMessages) == null ? void 0 : _b2.length),
        a11yClickToReadFootnote,
        a11yCloseIconLabel,
        a11yTooltipIcon,
        isOnSale
      }
    ) : /* @__PURE__ */ jsx(
      Price,
      {
        isRangeView: isPriceRangeViewEnabled,
        scrollToFooter: scrollToFooter2,
        priceValue,
        originalPrice: !isPostPOSOrderDetails && originalPrice,
        currentPrice,
        displayWasLabel: checkDisplayWasLabel,
        hideSaveLabel,
        discountValue: discount,
        language: language2,
        eachLabel,
        isMoreQuantityCartPage: props.isWheelOrTire || itemQuantity > oneProductQuantity,
        promotionalPriceLabel: saveLabel,
        clearancePriceLabel: props.clearancePriceLabel,
        unitPriceLabel: props.unitPriceLabel,
        thresholdValue,
        a11yStrikeOutPrice,
        a11yStrikeOutPriceRange,
        feeTitle: getFeeTitle(feeMessageValue, feeMessage, language2),
        feeDisclaimerTitle: feeMessage == null ? void 0 : feeMessage.feeDisclaimerTitle,
        feeDisclaimerMessage: feeMessage == null ? void 0 : feeMessage.feeDisclaimerMessage,
        nowFromLabel: props.nowFromLabel,
        saveFromLabel: props.saveFromLabel,
        wasFromLabel: props.wasFromLabel,
        fromLabel: props.fromLabel,
        feeDisclaimerType: feeMessage == null ? void 0 : feeMessage.type,
        priceMessage: !isPostPOSOrderDetails && priceMessage,
        setOfFourLabel: props.setOfFourLabel,
        isWishList: props.isWishList,
        isWheelOrTire: props.isWheelOrTire,
        isAutomotiveEachLabel: props.isWheelOrTire,
        isShoppingCartPage: props.isShoppingCartPage,
        showDiscountedPrice,
        highlightDiscountedPrice,
        totalPrice,
        saveMessage,
        isAppliedPromoExist: !!((_d2 = (_c2 = props.productData) == null ? void 0 : _c2.appliedPromoMessages) == null ? void 0 : _d2.length),
        a11yClickToReadFootnote,
        a11yCloseIconLabel,
        a11yTooltipIcon,
        plusMinusSymbol,
        isOnSale
      }
    );
  };
  const overAllPriceComponent = (itemAvailabilityInfoForPrice, isProductService, selectedServiceData, disableQuantitySelector) => {
    return (!(itemAvailabilityInfoForPrice == null ? void 0 : itemAvailabilityInfoForPrice.showInlineError) || itemAvailabilityInfoForPrice.optionsToBeDisplayed.includes(OptionsOnCartItem.PRICE_AND_QUANTITY)) && /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${cartClass2}__price-quantity ${validation(isWishList, hideQuantitySelector) ? `${cartClass2}__price-quantity--wishlist` : ""} ${PREFIX}-col-md-4 ${PREFIX}-col-sm-12`,
        children: [
          quantitySelectorComponent(isProductService, selectedServiceData, disableQuantitySelector),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: `${cartClass2}__price  ${PREFIX}-col-md-7 ${PREFIX}-col-sm-8 ${isWishList ? `${cartClass2}__price--wishlist` : ""} `,
              children: [
                renderProductServicePrice(isProductService, selectedServiceData),
                isRenderPromoMessages() ? /* @__PURE__ */ jsx("div", { className: promoMessagesStyleClassMobile, children: renderPromoMessages() }) : null,
                showHideDiscountInfo && getBadgeComponent(isProductService)
              ]
            }
          )
        ]
      }
    );
  };
  const renderPromoMessages = () => {
    return /* @__PURE__ */ jsx(
      PromoMessages,
      {
        isProductLevel: true,
        productPromoMessages: productData == null ? void 0 : productData.promoMessages,
        productRestrictedPromoMessages: productData == null ? void 0 : productData.restrictedPromoMessages,
        appliedPromoPrefix: props.appliedPromoPrefix,
        appliedPromoMessages: productData == null ? void 0 : productData.appliedPromoMessages,
        a11yTooltipIcon: props.a11yTooltipIcon,
        a11yCloseIconLabel
      }
    );
  };
  const isRenderPromoMessages = useCallback(() => {
    const isMessagePresent = isAtleastOneParamValid(
      isArrayNotEmpty(productData == null ? void 0 : productData.promoMessages),
      isArrayNotEmpty(productData == null ? void 0 : productData.restrictedPromoMessages),
      isArrayNotEmpty(productData == null ? void 0 : productData.appliedPromoMessages)
    );
    return isMessagePresent && (!isWishList || props.enableShowPromotionsAndRomanceCopy);
  }, [productData, isWishList, props.enableShowPromotionsAndRomanceCopy]);
  const showBuyAgainText = (isService) => {
    return isService ? dpLearnMoreLabel : dpBuyAgainLabel;
  };
  const showBuyAgainTextAriaLabel = (isService, isProductService, selectedServiceData) => {
    const productName = isProductService ? selectedServiceData == null ? void 0 : selectedServiceData.name : name;
    return isService ? `${dpLearnMoreLabel}: ${productName}` : `${dpBuyAgainLabel}: ${productName}`;
  };
  const handleCancelProductClick = (isProductService, selectedServiceData) => {
    const { entryNumber: cancelEntryNumber, name: cancelName } = isProductService ? selectedServiceData : productData;
    getEntriesInfo(
      true,
      "GM",
      cancelEntryNumber,
      itemQuantity,
      cancelName,
      productData == null ? void 0 : productData.balloonEntryType,
      isBouquetPackage
    );
    cancellationAnalytics("cancel_order", "partial", "Order Details");
  };
  const cancellationClass = customerSelfServiceCancelEnabled ? `${cartClass2}__cancellation` : "";
  const availabilityBulletSubtype = () => {
    var _a2, _b2;
    const { availability } = fulfillment || {};
    const checkInStock = checkIsStockInAllStore(
      availability == null ? void 0 : availability.quantity,
      (_a2 = availability == null ? void 0 : availability.Corporate) == null ? void 0 : _a2.Quantity,
      (_b2 = availability == null ? void 0 : availability.Corporate) == null ? void 0 : _b2.orderableFromDC
    );
    if (checkInStock._isOutOfStock() || itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.COMING_SOON)) {
      return AvailabilityBullet.NoStock;
    }
    return AvailabilityBullet.InStock;
  };
  const getMessageForStockInfo = () => {
    return isWishList && isAvailableOnlyInDC ? inStockOnlineLabel : itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.OUT_OF_STOCK) ? props.outOfStockLabel : itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.COMING_SOON) ? props.comingSoonStockLabel : itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.IN_STOCK_FOR_PICK_UP) ? props.wishlistInStockPickUpLabel : (
      // eslint-disable-next-line sonar/no-nested-conditional
      itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.IN_STOCK_FOR_PURCHASE) ? props.wishlistInStockPurchaseLabel : props.discontinuedLabel
    );
  };
  const getStockInfoMessage = () => {
    var _a2, _b2, _c2, _d2;
    if (itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.STOCK_INFO)) {
      return getMessageForStockInfo();
    }
    const storeShelfLocation = ((_a2 = fulfillment == null ? void 0 : fulfillment.availability) == null ? void 0 : _a2.storeShelfLocation) || "";
    const modifiedInStockLabel = ((_b2 = fulfillment == null ? void 0 : fulfillment.availability) == null ? void 0 : _b2.storeShelfLocation) ? inStockLabel : inStockLabel == null ? void 0 : inStockLabel.split("-")[magicNumber.ZERO];
    const preferredInStockLabel = wishlistInStockLabel || replaceMultipleStrWithDynamicVal(modifiedInStockLabel, [
      (_d2 = (_c2 = fulfillment == null ? void 0 : fulfillment.availability) == null ? void 0 : _c2.quantity) == null ? void 0 : _d2.toString(),
      storeShelfLocation
    ]);
    return /* @__PURE__ */ jsx("span", { children: preferredInStockLabel });
  };
  const showOrderDetailDisclaimer = (isService) => {
    var _a2;
    const cannotTrackCondition = () => {
      var _a3;
      return isShipToHome && ((_a3 = props.productData) == null ? void 0 : _a3.status) === DeliveryStatusSTH.SHIPPED && !productData.trackingID;
    };
    return /* @__PURE__ */ jsx(Fragment, {
      // eslint-disable-next-line sonar/expression-complexity
      children: isService ? /* @__PURE__ */ jsx("p", { className: `${infoClass}__service-disclaimer`, children: discServiceInstallation }) : isShipToHome && isBulk && ((_a2 = props.productData) == null ? void 0 : _a2.status) === DeliveryStatusSTH.IN_PROGRESS_STH ? /* @__PURE__ */ jsxs("p", { className: `${infoClass}__service-disclaimer`, children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-information-grey", size: "sm" }),
        discScheduleDelivery
      ] }) : cannotTrackCondition() ? /* @__PURE__ */ jsxs("p", { className: `${infoClass}__service-disclaimer`, children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-information-grey", size: "sm" }),
        discCannotTrack
      ] }) : null
    });
  };
  const renderCancelButton = (isProductService, selectedServiceData) => {
    const isCancelButtonDisabled = isProductService ? !selectedServiceData.cancellable : !productData.cancellable;
    return isShipToHome && isCancelButtonDisabled ? null : customerSelfServiceCancelEnabled && enablePartialOrderCancellation ? /* @__PURE__ */ jsx("div", { className: `${cartClass2}__cta-cancel`, children: /* @__PURE__ */ jsx(
      Button,
      {
        id: "get-info-button",
        type: "tertiary",
        size: "mini",
        disabled: isCancelButtonDisabled,
        onClick: () => {
          handleCancelProductClick(isProductService, selectedServiceData);
        },
        children: cancelProductLabel
      }
    ) }) : null;
  };
  const cartItemComponent = ({
    isService,
    isProductService,
    productServiceTitle,
    selectedServiceData,
    disableQuantitySelector,
    removeService,
    showBorder
  }) => {
    const showInlineError = !(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError);
    const isAddOnNotSellable = isProductService && !selectedServiceData.sellable && !hideQuantitySelector;
    let cartItemAvailabilityInfo = itemAvailabilityInfo;
    if (isAddOnNotSellable) {
      cartItemAvailabilityInfo = {
        showInlineError: true,
        errorMessage: props.serviceAddOnNotAvailableLabel,
        grayOutImage: true,
        optionsToBeDisplayed: [],
        fulfillmentDeliverError: "",
        hardStopError: true
      };
    } else if (isProductService && selectedServiceData.sellable) {
      cartItemAvailabilityInfo = {
        showInlineError: false,
        errorMessage: "",
        grayOutImage: false,
        optionsToBeDisplayed: [],
        fulfillmentDeliverError: "",
        hardStopError: false
      };
    }
    const priorityAndName = inImageBadgePriorities == null ? void 0 : inImageBadgePriorities.priorityAndName;
    const priorityAndColourWithIconLabel = priorityAndName == null ? void 0 : priorityAndName.map((badge) => ({
      ...badge,
      badgeLabel: /* @__PURE__ */ jsx("img", { src: badge == null ? void 0 : badge.badgeIconUrl, alt: badge == null ? void 0 : badge.badgeId }),
      colorId: ""
    }));
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: `${cancellationClass} ${PREFIX}-row`, children: [
      isAddOnNotSellable && /* @__PURE__ */ jsx(
        CommonWarningToast,
        {
          icon: "ct-notification-caution",
          bgType: "orange",
          label: cartItemAvailabilityInfo.errorMessage,
          checkNearByText: "",
          isAddOn: true
        }
      ),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${cartClass2} ${PREFIX}-row ${isProductService ? `${cartClass2}__product-service` : ""} ${showBorder && showInlineError ? `${cartClass2}--add-padding` : ""} ${isAddOnNotSellable ? `${cartClass2}--add-on` : ""} `,
          children: [
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-in-image-badges`, children: /* @__PURE__ */ jsx(
              Badges,
              {
                badges: productData.badges,
                badgesAndPriorities: {
                  ...inImageBadgePriorities,
                  priorityAndColour: priorityAndColourWithIconLabel
                },
                hideDisclaimer: true,
                isOnSale,
                ...loyaltyProp
              }
            ) }),
            renderCancelButton(isProductService, selectedServiceData),
            /* @__PURE__ */ jsx(
              ProductImageComponent,
              {
                itemAvailabilityInfo: cartItemAvailabilityInfo,
                isService,
                a11yServiceInstallation,
                servicesIcon: "ct-tools",
                images,
                name,
                changeBrowserBackUrl,
                hideQuantitySelector,
                url
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: `${cartClass2}__text-container ${PREFIX}-col-md-8 ${PREFIX}-col-sm-8`, children: [
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: `${cartClass2}__product-item-wrapper  ${PREFIX}-col-md-12 ${PREFIX}-col-sm-12`,
                  children: [
                    /* @__PURE__ */ jsx(
                      ProductItemInfo,
                      {
                        changeBrowserBackUrl,
                        hideQuantitySelector,
                        changeShipToHomeCTALabel,
                        pickAtStoreCTALabel,
                        availableLabel,
                        betweenLabel,
                        isFreePickUpAtStore,
                        isShipToHome,
                        servicesDisclaimer,
                        isServices: isService,
                        discScheduleDelivery,
                        discServiceInstallation,
                        discCannotTrack,
                        isDetailPage,
                        homePageLink,
                        productData,
                        serviceData: selectedServiceData,
                        onChangeFulfillmentOption,
                        receiveBetweenLabel,
                        availableByLabel,
                        availableShipLabel,
                        getChangeFulfillmentOption: getChangeFulfillmentLabel,
                        isProductService,
                        productServiceTitle,
                        itemAvailabilityInfo: cartItemAvailabilityInfo,
                        bulkLabel,
                        updatedLabel,
                        accessibilityGlobalProps,
                        isWishList,
                        PDPLink,
                        renderRebate: renderRebateSection,
                        productColorLabel,
                        inStockLabel,
                        reviewsContainerId,
                        onlineOrdering,
                        productDisclaimer,
                        qtyAbbrLabel,
                        availabilityBulletSubtype,
                        getStockInfoMessage,
                        urgentLowStock,
                        limitedStockMessage: props.limitedStockMessage,
                        showOrderDetailDisclaimer: (service) => showOrderDetailDisclaimer(service),
                        a11yCloseIconLabel,
                        a11yTooltipIcon,
                        saleMessagesRules,
                        heliumInflationUnInflationText,
                        showInflationLabels,
                        saleEndDisableShift,
                        ...props
                      }
                    ),
                    overAllPriceComponent(
                      cartItemAvailabilityInfo,
                      isProductService,
                      selectedServiceData,
                      disableQuantitySelector
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsxs("div", { className: `${cartClass2}__availability-container ${PREFIX}-xs-block ${PREFIX}-row`, children: [
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: `${infoClass} ${PREFIX}-xs-block  ${PREFIX}-sm-none  ${PREFIX}-md-none`,
                    children: isWishList && itemAvailabilityInfo.optionsToBeDisplayed.includes(
                      OptionsOnCartItem.IN_STOCK_TAG
                    ) ? /* @__PURE__ */ jsx(
                      Tag,
                      {
                        type: "availability-bullet",
                        subType: `${availabilityBulletSubtype()} `,
                        isLarge: true,
                        children: getStockInfoMessage()
                      }
                    ) : null
                  }
                ),
                // eslint-disable-next-line sonar/expression-complexity
                isWishList ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: `${infoClass} ${PREFIX}-xs-block  ${PREFIX}-sm-none  ${PREFIX}-md-none`,
                    children: renderRebateSection()
                  }
                ) }) : (
                  // render availaibility for mobile view
                  (!isAddOnNotSellable && productData.entryType !== eEntryType.SERVICE_STANDALONE || hideQuantitySelector) && isProductAvailabilityInfo(isService, isProductService)
                ),
                !isProductService && productData.entryType !== eEntryType.SERVICE_STANDALONE && checkIfAvailable() && renderAvailability(),
                props.isShoppingCartPage && !isProductService && productData.entryType === eEntryType.SERVICE_STANDALONE && renderDisclaimer(isServices)
              ] })
            ] }),
            isDetailPage && /* @__PURE__ */ jsx("div", { className: `${cartClass2}__buy-again-button ${PREFIX}-row`, children: /* @__PURE__ */ jsx(
              Button,
              {
                id: "learn-more",
                type: "secondary",
                size: "mini",
                ariaLabel: showBuyAgainTextAriaLabel(
                  // eslint-disable-next-line sonar/arguments-order,sonarjs/arguments-order
                  isProductService,
                  isService,
                  selectedServiceData
                ),
                onClick: () => {
                  window.location.href = encodeURI(url);
                },
                children: showBuyAgainText(isService)
              }
            ) }),
            !hideQuantitySelector && renderButtons(isService, removeService, isProductService, selectedServiceData),
            // eslint-disable-next-line sonar/expression-complexity
            isWishList && onlineOrdering && itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.ADD_TO_CART) && checkForQuantityAvailability(
              productData,
              props.enableAddTireWheelsByFourFromWishlist,
              props.isWheelOrTire
            ) && /* @__PURE__ */ jsx("div", { className: `${cartClass2}__add-to-cart-button ${PREFIX}-row`, children: /* @__PURE__ */ jsx(
              Button,
              {
                "test-id": "checkButton",
                id: "checkButton",
                type: "primary",
                size: "mini",
                onClick: () => addToCart(productData),
                children: addToCartLabel
              }
            ) }),
            renderButtons(isService, removeService, isProductService, selectedServiceData, false)
          ]
        }
      )
    ] }) });
  };
  const showWarningToast = () => {
    return (inlineToastError || !!(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError)) && !hideQuantitySelector && !disableAvailabilityMessages;
  };
  const isProductDataExist = () => productData && Object.keys(productData).length;
  const warningToastProps = {
    changeShipToHomeCTALabel,
    pickAtStoreCTALabel,
    exceededMsgBar,
    nearbyAvailabilityCTALabel: props.nearbyAvailabilityCTALabel,
    onChangeFulfillmentOption,
    checkNearByCTAHandler: props.checkNearByCTAHandler,
    checkErrorMessage,
    isSelectedDeliveryAvailable,
    selectedDeliveryMode,
    itemNotEligibleForExpressDeliveryMsg,
    itemNotEligibleForStandardDeliveryMsg,
    expressDeliveryDoesNotSupportHeavyOversizedMsg,
    insufficientQuantityOfProductForExpressDeliveryMsg,
    isQtyExceeded: qtyExceededErr
  };
  const addOrRemoveWishlistProps = {
    addItemToWishlist,
    removeitemFromWishlist
  };
  const renderBalloonAddons = () => {
    return isBalloonProduct(props.productData) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-automotive`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-automotive-card`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-automotive-card-wrapper`, children: /* @__PURE__ */ jsx(AutomotiveAddonsListWrapper, { ...props, isCollapsed: true }) }) }) });
  };
  const renderProductCartItemComp = () => {
    return (
      // eslint-disable-next-line sonar/expression-complexity
      isProductDataExist && /* @__PURE__ */ jsxs(Fragment, { children: [
        cartItemComponent({
          isService: isServices,
          isProductService: false,
          removeService: !isArrayNotEmpty(extractSelectedServiceList),
          showBorder: isArrayNotEmpty(productData.servicesList) || isArrayNotEmpty(extractSelectedServiceList)
        }),
        isArrayNotEmpty(extractSelectedServiceList) && /* @__PURE__ */ jsx("div", { className: `${cartClass2}__existing-services`, children: extractSelectedServiceList.map((singleService) => productServiceComponent(singleService)) }),
        productData.entryType !== eEntryType.SERVICE_STANDALONE && isArrayNotEmpty(productData.servicesList) && serviceInstallationComponent()
      ] })
    );
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(CommonCard, { showWarningToast: inlineToastError && (itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.hardStopError), children: [
    /* @__PURE__ */ jsxs("div", { className: `${balloonProductClass} ${cardClass}__content`, children: [
      showWarningToast() && renderWarningToast(warningToastProps, itemAvailabilityInfo, productData),
      renderProductCartItemComp()
    ] }),
    enableBalloonAddons && renderBalloonAddons()
  ] }) });
};
ProductCartItem.displayName = "ProductCartItem";
var FacetTypes = /* @__PURE__ */ ((FacetTypes2) => {
  FacetTypes2["BREADCRUMB"] = "breadcrumb";
  FacetTypes2["RADIO"] = "radio";
  FacetTypes2["MULTISELECT"] = "multiselect";
  FacetTypes2["RANGE"] = "range";
  FacetTypes2["RATING"] = "rating";
  FacetTypes2["COLOURPICKER"] = "colourPicker";
  FacetTypes2["CUSTOM_PRICE"] = "custom_price";
  FacetTypes2["CATEGORY_ID"] = "category_ast";
  FacetTypes2["CUSTOM_RANGE"] = "custom_range";
  return FacetTypes2;
})(FacetTypes || {});
const sortFacetType = "sort";
const categoryFacetType = "category";
const errorScreenClearCTAId = "error-screen-clear-filter-cta";
const ShowMoreLessButton = (props) => {
  const { totalResults, setShowAllRows, showAllRows, listData, showMoreThreshold, buttonRef, showLessLabel } = props;
  const componentClassName2 = `${PREFIX}-show-more-btn`;
  return totalResults.length > showMoreThreshold && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__view-link`, children: /* @__PURE__ */ jsxs(
    Button,
    {
      ariaExpanded: listData.link === showLessLabel,
      ref: buttonRef,
      type: "tertiary",
      onClick: () => setShowAllRows(!showAllRows),
      children: [
        /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__view-label`, children: listData.link }),
        /* @__PURE__ */ jsx(Icon, { size: "md", type: listData.icon })
      ]
    }
  ) });
};
ShowMoreLessButton.propTypes = {
  totalResults: PropTypes.array,
  setShowAllRows: PropTypes.func,
  showAllRows: PropTypes.bool,
  listData: PropTypes.shape({
    link: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
  }).isRequired,
  showMoreThreshold: PropTypes.number
};
const SortFacet = (props) => {
  const {
    selectedFacetType,
    sortings,
    onSortChange,
    sortLabel,
    showMoreThreshold,
    showMoreLabel,
    showLessLabel,
    enableFilterFacetsEnhancement
  } = props;
  const updatedShowMoreLabel = replaceStrWithDynamicVal(showMoreLabel, sortings.length - showMoreThreshold);
  const { current: rowsToShow } = useRef(sortings.slice(0, showMoreThreshold));
  const isSortOpen = selectedFacetType === sortFacetType;
  const componentClassName2 = `${PREFIX}-facet-modal`;
  const [showAllRows, setShowAllRows] = useState(false);
  const [listData, setListData] = useState({
    listViewData: rowsToShow,
    icon: "ct-chevron-down",
    link: updatedShowMoreLabel
  });
  const [sortFacetOpen, setSortFacetOpen] = useState(isSortOpen);
  useEffect(() => {
    if (showAllRows) {
      setListData({
        listViewData: sortings,
        icon: "ct-chevron-up",
        link: showLessLabel
      });
    } else {
      setListData({
        listViewData: rowsToShow,
        icon: "ct-chevron-down",
        link: updatedShowMoreLabel
      });
    }
  }, [rowsToShow, showAllRows, showLessLabel, sortings, updatedShowMoreLabel]);
  const onSortAccordionChange = (isAccOpen) => {
    setSortFacetOpen(isAccOpen);
  };
  const getTitle = () => {
    const selectedSortOption = sortings.filter((sort) => sort.selected).map((sortOption) => sortOption.title);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-facet-name`, children: sortLabel }),
      !sortFacetOpen && selectedSortOption && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-facet-selection`, children: selectedSortOption.join(",") })
    ] });
  };
  const sortExpandedClass = sortFacetOpen ? `${componentClassName2}__sort-facet--expanded` : "";
  return /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__sort-facet ${sortExpandedClass}`, children: /* @__PURE__ */ jsx(
    Accordion,
    {
      title: getTitle(),
      isHeaderOpen: isSortOpen,
      collapseControl: onSortAccordionChange,
      isHeaderHidden: enableFilterFacetsEnhancement && selectedFacetType === "sort",
      children: /* @__PURE__ */ jsxs("ul", { children: [
        listData.listViewData.map((sortOption) => /* @__PURE__ */ jsx("li", { className: `${componentClassName2}__sort-options`, children: /* @__PURE__ */ jsx(
          Radio,
          {
            id: sortOption.title,
            label: sortOption.title,
            name: "sortings",
            checked: sortOption.selected,
            onChange: onSortChange,
            value: sortOption.title
          }
        ) }, sortOption.title)),
        /* @__PURE__ */ jsx(
          ShowMoreLessButton,
          {
            totalResults: sortings,
            setShowAllRows,
            showAllRows,
            listData,
            showMoreThreshold
          }
        )
      ] })
    }
  ) });
};
SortFacet.propTypes = {
  selectedFacetType: PropTypes.string,
  sortings: PropTypes.array,
  onSortChange: PropTypes.func,
  sortLabel: PropTypes.string,
  showMoreThreshold: PropTypes.number,
  showMoreLabel: PropTypes.string,
  showLessLabel: PropTypes.string
};
const rangeFilterInputId = "range";
const rangeErrorIcon = "ct-warning-triangle-sm";
const uomFont = "14px Lato, sans-serif";
const pixelText = "px";
const contextType = "2d";
const canvasTagName = "canvas";
const suffixUomTestId = {
  minSuffixUomId: "min-input-suffix-uom",
  maxSuffixUomId: "max-input-suffix-uom"
};
const getRangeFacetValues = (facet) => {
  const { min, max, minSelected, maxSelected } = facet;
  return {
    startVal: minSelected || `${min}`,
    endVal: maxSelected || `${max}`
  };
};
const getRangeFacetUom = (facet) => {
  const { value, uom } = facet;
  if (value.startsWith(uom)) {
    return {
      prefix: uom
    };
  } else {
    return {
      suffix: uom
    };
  }
};
const getValueWithUOM = (value, uom) => {
  const { prefix = "", suffix = "" } = uom;
  return `${prefix} ${value} ${suffix}`.trim();
};
const inputValGreaterThanMaxVal = (inputVal, maxVal) => {
  return Number(inputVal) > Number(maxVal);
};
const inputValLessThanMinVal = (inputVal, minVal) => {
  return Number(inputVal) < Number(minVal);
};
const getTextWidth = (text2, font, canvasRef) => {
  const canvas2 = canvasRef.current;
  const context = canvas2.getContext(contextType);
  context.font = font;
  const metrics = context.measureText(text2);
  return metrics.width;
};
const isInputValid = (inputValue) => {
  return /^\d*(\.\d*)?$/.test(inputValue);
};
const rangeValueOffset = 0.2;
const rangeValuePixel = 10;
const knobOffset = 1.5;
const getMinRoundOff = (min) => {
  return Math.floor(min);
};
const getMaxRoundOff = (max) => {
  return Math.ceil(max);
};
const RangeSlider = ({ ...props }) => {
  const { range, values, onChange, uom, disabled, updateUOMPosition, error, isErrorChecked } = props;
  const { min, max } = range;
  const [showMinSpan, setShowMinSpan] = useState(false);
  const [showMaxSpan, setShowMaxSpan] = useState(false);
  const [zIndex, setZindex] = useState(0);
  const minSliderRef = useRef(null);
  const maxSliderRef = useRef(null);
  const rangeTrackRef = useRef(null);
  const leftRangeValueRef = useRef(null);
  const rightRangeValueRef = useRef(null);
  const leftKnobRef = useRef(null);
  const rightKnobRef = useRef(null);
  const valuesRef = useRef(values);
  const getStartAndEndValues = () => {
    if (isErrorChecked) {
      if (error) {
        return valuesRef.current;
      } else {
        valuesRef.current = values;
        return valuesRef.current;
      }
    } else {
      return valuesRef.current;
    }
  };
  const { startValue, endValue } = getStartAndEndValues();
  const setInputZindex = (input) => {
    setZindex(zIndex + 1);
    input.current.style.zIndex = String(zIndex + 1);
  };
  const setRangePosition = useCallback(
    (input, container, knob) => {
      const inputElement = input.current;
      const containerElement = container.current;
      const knobElement = knob == null ? void 0 : knob.current;
      const value = Number(inputElement.value);
      const inputMin = Number(inputElement.min);
      const inputMax = Number(inputElement.max);
      const newValue = (value - inputMin) * 100 / (inputMax - inputMin);
      const newPosition = rangeValuePixel - newValue * rangeValueOffset;
      containerElement.style.left = `calc(${newValue}% + (${newPosition}px))`;
      if (knobElement) {
        if (minSliderRef.current.value === maxSliderRef.current.value) {
          leftKnobRef.current.style.left = `calc(${newValue + knobOffset}% + (${newPosition}px))`;
        } else {
          knobElement.style.left = `calc(${newValue}% + (${newPosition}px))`;
        }
        knobElement.style.left = `calc(${newValue}% + (${newPosition}px))`;
      }
    },
    [minSliderRef, maxSliderRef, leftKnobRef]
  );
  useEffect(() => {
    if (updateUOMPosition) {
      updateUOMPosition(minSliderRef, maxSliderRef);
    }
  }, [updateUOMPosition, minSliderRef, maxSliderRef]);
  useEffect(() => {
    if (
      // eslint-disable-next-line sonar/expression-complexity
      !rangeTrackRef.current || !minSliderRef.current || !maxSliderRef.current || !leftKnobRef.current || !rightKnobRef.current
    ) {
      return;
    }
    const startPercent = (Number(minSliderRef.current.value) - min) / (max - min) * 100;
    const trackWidthPercent = (
      // eslint-disable-next-line no-magic-numbers
      (Number(maxSliderRef.current.value) - Number(minSliderRef.current.value)) / (max - min) * 100
    );
    rangeTrackRef.current.style.left = `${startPercent}%`;
    rangeTrackRef.current.style.width = `${trackWidthPercent}%`;
    setRangePosition(minSliderRef, leftRangeValueRef, leftKnobRef);
    setRangePosition(maxSliderRef, rightRangeValueRef, rightKnobRef);
  }, [
    startValue,
    endValue,
    max,
    min,
    minSliderRef,
    maxSliderRef,
    rangeTrackRef,
    leftRangeValueRef,
    rightRangeValueRef,
    leftKnobRef,
    rightKnobRef,
    setRangePosition
  ]);
  const handleChange = (value, id) => {
    const sliderRef = id === minSliderRef.current.id ? minSliderRef : maxSliderRef;
    setInputZindex(sliderRef);
    onChange(value, id);
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-container`, "aria-hidden": true, children: [
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-container__values`, children: [
      /* @__PURE__ */ jsx("span", { children: getValueWithUOM(getMinRoundOff(min), uom) }),
      /* @__PURE__ */ jsx("span", { children: getValueWithUOM(getMaxRoundOff(max), uom) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-container__progress-bar`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-range-container__progress-bar--slider`, ref: rangeTrackRef }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-range-knob`, ref: leftKnobRef, id: "left-knob", children: /* @__PURE__ */ jsx(Icon, { type: "ct-range-knob-left", size: "md" }) }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-range-knob`, ref: rightKnobRef, id: "right-knob", children: /* @__PURE__ */ jsx(Icon, { type: "ct-range-knob-right", size: "md" }) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-container__slider`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-range-container__slider--range-value`, id: "rangeMin", ref: leftRangeValueRef, children: showMinSpan && /* @__PURE__ */ jsx("span", { "data-testid": "range-value-min", children: getValueWithUOM(getMinRoundOff(Number(startValue)), uom) }) }),
      /* @__PURE__ */ jsx(
        "input",
        {
          type: "range",
          id: "min-range",
          className: `${PREFIX}-range-slider-input`,
          min,
          max,
          value: Number(startValue),
          onChange: (e) => handleChange(e.target.value, e.target.id),
          onPointerDown: () => setShowMinSpan(true),
          onPointerUp: () => setShowMinSpan(false),
          onTouchStart: () => setShowMinSpan(true),
          onTouchEnd: () => setShowMinSpan(false),
          ref: minSliderRef,
          disabled,
          tabIndex: -1
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-range-container__slider--range-value`,
          id: "rangeMax",
          ref: rightRangeValueRef,
          children: showMaxSpan && /* @__PURE__ */ jsx("span", { "data-testid": "range-value-max", children: getValueWithUOM(getMaxRoundOff(Number(endValue)), uom) })
        }
      ),
      /* @__PURE__ */ jsx(
        "input",
        {
          type: "range",
          id: "max-range",
          className: `${PREFIX}-range-slider-input`,
          min,
          max,
          value: Number(endValue),
          onChange: (e) => handleChange(e.target.value, e.target.id),
          onPointerDown: () => setShowMaxSpan(true),
          onPointerUp: () => setShowMaxSpan(false),
          onTouchStart: () => setShowMaxSpan(true),
          onTouchEnd: () => setShowMaxSpan(false),
          ref: maxSliderRef,
          disabled,
          tabIndex: -1
        }
      )
    ] })
  ] });
};
RangeSlider.defaultProps = {
  disabled: false
};
RangeSlider.propTypes = {
  onChange: PropTypes.func,
  uom: PropTypes.object,
  disabled: PropTypes.bool
};
const RangeFilter = ({ ...props }) => {
  const {
    facet,
    applyCTALabel,
    minLabel,
    maxLabel,
    onFilterChange,
    rangeFilterInputLabelId,
    ariaLabelApplyRangeFilterCTA,
    minValGreaterThanMaxValError,
    invalidMinAndMaxError
  } = props;
  const { min, max, urlFormat, minParameter, maxParameter, label } = facet;
  const rangeFacetValues = getRangeFacetValues(facet);
  const { startVal, endVal } = rangeFacetValues;
  const range = {
    min,
    max
  };
  const inputId = rangeFilterInputId;
  const [value, setValue] = useState({ minValue: startVal, maxValue: endVal });
  const { minValue, maxValue } = value;
  const { prefix = "", suffix = "" } = getRangeFacetUom(facet);
  const valueWithUom = `${prefix}${minValue} - ${maxValue} ${suffix}`;
  const minValueNumber = Number(minValue);
  const maxValueNumber = Number(maxValue);
  const [error, setError] = useState("");
  const [isErrorChecked, setIsErrorChecked] = useState(false);
  const minInputRef = useRef(null);
  const maxInputRef = useRef(null);
  const minInputUomSuffixRef = useRef(null);
  const maxInputUomSuffixRef = useRef(null);
  const canvasRef = useRef(document.createElement(canvasTagName));
  const rangeFilterInputcontainerRef = useRef(null);
  const updatePrefix = useCallback(
    (input) => {
      if (!isInputValid(input.current.value)) {
        return;
      }
      const width = getTextWidth(prefix, uomFont, canvasRef);
      input.current.style.left = String(width) + pixelText;
    },
    [prefix]
  );
  const updateSuffix = (input, suffixRef) => {
    if (!isInputValid(input.current.value)) {
      return;
    }
    const width = getTextWidth(input.current.value, uomFont, canvasRef);
    if (suffixRef.current) {
      suffixRef.current.style.left = String(width) + pixelText;
    }
  };
  const setUOMPositionOnValueChange = useCallback(
    (minInput, maxInput) => {
      if (prefix) {
        const updateMinPrefix = () => {
          updatePrefix(minInput);
        };
        const updateMaxPrefix = () => {
          updatePrefix(maxInput);
        };
        updateMinPrefix();
        updateMaxPrefix();
        minInput.current.addEventListener("input", updateMinPrefix);
        maxInput.current.addEventListener("input", updateMaxPrefix);
        return () => {
          minInput.current.removeEventListener("input", updateMinPrefix);
          maxInput.current.removeEventListener("input", updateMaxPrefix);
        };
      } else {
        const updateMinSuffix = () => {
          updateSuffix(minInput, minInputUomSuffixRef);
        };
        const updateMaxSuffix = () => {
          updateSuffix(maxInput, maxInputUomSuffixRef);
        };
        updateMinSuffix();
        updateMaxSuffix();
        minInput.current.addEventListener("input", updateMinSuffix);
        maxInput.current.addEventListener("input", updateMaxSuffix);
        return () => {
          minInput.current.removeEventListener("input", updateMinSuffix);
          maxInput.current.removeEventListener("input", updateMaxSuffix);
        };
      }
    },
    [prefix, updatePrefix]
  );
  useEffect(() => {
    setUOMPositionOnValueChange(minInputRef, maxInputRef);
  }, [setUOMPositionOnValueChange]);
  const renderPrefixUOM = () => {
    return prefix ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-range-input__input-with-uom-wrapper--prefix-uom`, children: prefix }) : null;
  };
  const renderSuffixUOM = (inputRef, testId) => {
    return suffix ? /* @__PURE__ */ jsx(
      "div",
      {
        ref: inputRef,
        "data-testid": testId,
        className: `${PREFIX}-range-input__input-with-uom-wrapper--suffix-uom`,
        children: suffix
      }
    ) : null;
  };
  useEffect(() => {
    setValue({ minValue: startVal, maxValue: endVal });
  }, [startVal, endVal]);
  const getSearchReqUrl = () => {
    let searchReqUrl = urlFormat;
    if (min <= minValueNumber && minValueNumber <= max) {
      searchReqUrl = searchReqUrl.replace(`${minParameter}`, `${minValue}`);
    } else {
      searchReqUrl = searchReqUrl.replace(`${minParameter}`, `${min}`);
    }
    if (min <= maxValueNumber && maxValueNumber <= max) {
      searchReqUrl = searchReqUrl.replace(`${maxParameter}`, `${maxValue}`);
    } else {
      searchReqUrl = searchReqUrl.replace(`${maxParameter}`, `${max}`);
    }
    return searchReqUrl;
  };
  const applyFilter = () => {
    var _a;
    if (error) {
      const firstErrorElement = (_a = rangeFilterInputcontainerRef.current) == null ? void 0 : _a.querySelector(
        `.${PREFIX}-accessibility-field--error`
      );
      firstErrorElement && firstErrorElement.focus();
    } else {
      onFilterChange(getSearchReqUrl(), valueWithUom, label, true);
      const element = document.getElementById(`${PREFIX}-filters`);
      scrollToElement(element);
    }
  };
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    if (!isInputValid(inputValue)) {
      return;
    }
    setError("");
    setIsErrorChecked(false);
    const textInputId = event.target.id;
    if (textInputId === `${inputId}-minValue`) {
      setValue((prevValue) => {
        return { ...prevValue, minValue: inputValue };
      });
    } else {
      setValue((prevValue) => {
        return { ...prevValue, maxValue: inputValue };
      });
    }
  };
  useEffect(() => {
    if (minValue === "" || minValue === "." || maxValue === "" || maxValue === ".") {
      setIsErrorChecked(true);
      return;
    }
    if (min <= minValueNumber && minValueNumber <= max || min <= maxValueNumber && maxValueNumber <= max) {
      if (minValueNumber > maxValueNumber) {
        setError(minValGreaterThanMaxValError);
      }
    } else {
      setError(invalidMinAndMaxError);
    }
    setIsErrorChecked(true);
  }, [
    min,
    max,
    minValueNumber,
    maxValueNumber,
    minValGreaterThanMaxValError,
    invalidMinAndMaxError,
    minValue,
    maxValue
  ]);
  const updateRangeSlider = (rangeValue, id) => {
    if (id === "min-range") {
      if (inputValGreaterThanMaxVal(rangeValue, value.maxValue)) {
        return;
      }
      setError("");
      setIsErrorChecked(false);
      setValue((prevValue) => {
        return { ...prevValue, minValue: rangeValue };
      });
    } else {
      if (inputValLessThanMinVal(rangeValue, value.minValue)) {
        return;
      }
      setError("");
      setIsErrorChecked(false);
      setValue((prevValue) => {
        return { ...prevValue, maxValue: rangeValue };
      });
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-slider-container`, children: [
    /* @__PURE__ */ jsx(
      RangeSlider,
      {
        range,
        values: {
          startValue: value.minValue,
          endValue: value.maxValue
        },
        uom: getRangeFacetUom(facet),
        onChange: updateRangeSlider,
        error,
        isErrorChecked,
        updateUOMPosition: setUOMPositionOnValueChange
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-input`, children: [
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-input__container`, ref: rangeFilterInputcontainerRef, children: [
        /* @__PURE__ */ jsx("span", { id: `${rangeFilterInputLabelId}-min`, className: "sr-only", children: facet.label }),
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-input__input-with-uom-wrapper`, children: [
          renderPrefixUOM(),
          /* @__PURE__ */ jsx(
            TextInput,
            {
              id: `${inputId}-minValue`,
              label: minLabel,
              value: `${value.minValue}`,
              onChange: handleInputChange,
              customOnChange: true,
              maxLength: 7,
              size: "small",
              textInputRef: minInputRef,
              ariaLabelledBy: `${rangeFilterInputLabelId}-min`,
              error,
              errorIcon: rangeErrorIcon
            }
          ),
          renderSuffixUOM(minInputUomSuffixRef, suffixUomTestId.minSuffixUomId)
        ] }),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-range-input__separator`, children: "-" }),
        /* @__PURE__ */ jsx("span", { id: `${rangeFilterInputLabelId}-max`, className: "sr-only", children: facet.label }),
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-range-input__input-with-uom-wrapper`, children: [
          renderPrefixUOM(),
          /* @__PURE__ */ jsx(
            TextInput,
            {
              id: `${inputId}-maxValue`,
              label: maxLabel,
              value: `${value.maxValue}`,
              onChange: handleInputChange,
              customOnChange: true,
              maxLength: 7,
              size: "small",
              textInputRef: maxInputRef,
              ariaLabelledBy: `${rangeFilterInputLabelId}-max`,
              error,
              errorIcon: rangeErrorIcon,
              isErrorForSrOnly: true
            }
          ),
          renderSuffixUOM(maxInputUomSuffixRef, suffixUomTestId.maxSuffixUomId)
        ] })
      ] }),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "secondary",
          size: "small",
          onClick: applyFilter,
          ariaLabel: replaceStrWithDynamicVal(ariaLabelApplyRangeFilterCTA, facet.label),
          children: applyCTALabel
        }
      )
    ] })
  ] });
};
const MultiSelectCheckBoxes = (props) => {
  const { multiSelectData, onChange, title, customClass } = props;
  return multiSelectData.length > 0 ? /* @__PURE__ */ jsxs("fieldset", { className: `${PREFIX}-multi-select`, children: [
    title && /* @__PURE__ */ jsx("legend", { className: `${PREFIX}-multi-select__title`, children: title }),
    /* @__PURE__ */ jsx("div", { className: customClass ? `${PREFIX}-${customClass}` : "", children: /* @__PURE__ */ jsx("ul", { className: `${PREFIX}-multi-select__list`, children: multiSelectData.map((item) => {
      const { id, multiSelectElement, selected } = item;
      const selectedClass = selected ? `${PREFIX}-multi-select__item--selected` : "";
      const multiSelectId = `multi-select-${id}`;
      return /* @__PURE__ */ jsxs("li", { className: `${PREFIX}-multi-select__item ${selectedClass}`, children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            id: multiSelectId,
            type: "checkbox",
            className: `${PREFIX}-multi-select__input sr-only`,
            onChange: (event) => onChange(event, item),
            checked: selected
          }
        ),
        /* @__PURE__ */ jsx("label", { htmlFor: multiSelectId, className: `${PREFIX}-multi-select__label`, children: multiSelectElement })
      ] }, multiSelectId);
    }) }) })
  ] }) : null;
};
MultiSelectCheckBoxes.propTypes = {
  multiSelectData: PropTypes.arrayOf(
    PropTypes.exact({
      multiSelectElement: PropTypes.node.isRequired,
      id: PropTypes.string.isRequired,
      selected: PropTypes.bool,
      url: PropTypes.string,
      clearUrl: PropTypes.string
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  customClass: PropTypes.string
};
const Filters = (props) => {
  const {
    selectedFacetType,
    facet,
    showMoreThreshold,
    showMoreLabel,
    showLessLabel,
    onFilterChange,
    currentLocale,
    minPriceErrorMessage,
    maxPriceErrorMessage,
    minPriceLabel,
    maxPriceLabel,
    customPriceFacet,
    isTriangleOffer,
    getFilterOnly,
    // to get only filter without accordion
    showSearch,
    enableFilterFacetsEnhancement,
    searchInputPlaceholderText,
    noSearchResults,
    isCategoryPage,
    closeLabel,
    suggestionsAvailableLabel,
    goCtaLabel,
    minLabel,
    maxLabel,
    applyCTALabel,
    rangeFilterInputLabelId,
    ariaLabelApplyRangeFilterCTA,
    minValGreaterThanMaxValError,
    invalidMinAndMaxError,
    filterByAriaLabel,
    isVerticalFilters: isVerticalFilters2
  } = props;
  const [filterExpanded, setFilterExpanded] = useState(selectedFacetType === facet.label);
  const filterListRef = useRef(null);
  const showMoreLessButtonRef = useRef(null);
  const element = document.getElementById(`${PREFIX}-filters`);
  const componentClassName2 = `${PREFIX}-filter-section`;
  const componentMultiSelect = `${PREFIX}-multi-select`;
  const getFacetValues = (facetObj) => {
    return facetObj.values;
  };
  const facetValues = useMemo(() => {
    return getFacetValues(facet);
  }, [facet]);
  const facetValuesShownList = useMemo(() => facetValues == null ? void 0 : facetValues.filter((facVal) => facVal.count > 0), [facetValues]);
  const [searchValue, setSearchValue] = useState("");
  const rowsToShow = useMemo(
    () => !enableFilterFacetsEnhancement || searchValue === "" && selectedFacetType ? facetValues == null ? void 0 : facetValues.slice(0, showMoreThreshold) : facetValues == null ? void 0 : facetValues.slice(0, facetValuesShownList.length),
    [
      enableFilterFacetsEnhancement,
      facetValues,
      facetValuesShownList,
      searchValue,
      showMoreThreshold,
      selectedFacetType
    ]
  );
  const [showAllRows, setShowAllRows] = useState(isPrerenderOrNot());
  const [minimumPrice, setMinimumPrice] = useState("$");
  const [maximumPrice, setMaximumPrice] = useState("$");
  const [selectedMinPrice, setSelectedMinPrice] = useState(void 0);
  const [selectedMaxPrice, setSelectedMaxPrice] = useState(void 0);
  const [minPriceError, setMinPriceError] = useState("");
  const [maxPriceError, setMaxPriceError] = useState("");
  const filteredData = useMemo(
    () => rowsToShow == null ? void 0 : rowsToShow.filter((item) => {
      return item.label && item.label.toLowerCase().indexOf(searchValue.toLowerCase()) !== magicNumber.MINUS_ONE || !searchValue;
    }),
    [rowsToShow, searchValue]
  );
  const mainRef = useRef();
  const updatedShowMoreLabel = !enableFilterFacetsEnhancement || searchValue === "" ? (
    // eslint-disable-next-line no-unsafe-optional-chaining
    replaceStrWithDynamicVal(showMoreLabel, (facetValuesShownList == null ? void 0 : facetValuesShownList.length) - showMoreThreshold)
  ) : (
    // eslint-disable-next-line no-unsafe-optional-chaining
    replaceStrWithDynamicVal(showMoreLabel, (filteredData == null ? void 0 : filteredData.length) - showMoreThreshold)
  );
  const [listData, setListData] = useState({
    listViewData: filteredData,
    icon: "ct-chevron-down",
    link: updatedShowMoreLabel
  });
  const getFormattedPriceValue2 = useCallback(
    (price) => {
      const formattedPrice = getFormattedPrice(price, currentLocale);
      return currentLocale === defaultLocale$1 ? formattedPrice.split("$").join("$ ") : formattedPrice;
    },
    [currentLocale]
  );
  const updatePriceRangeValues = useCallback(() => {
    const { min = 0, max = 0 } = customPriceFacet || {};
    setMinimumPrice(getFormattedPriceValue2(min));
    setMaximumPrice(getFormattedPriceValue2(max));
    setSelectedMinPrice(min);
    setSelectedMaxPrice(max);
  }, [customPriceFacet, getFormattedPriceValue2]);
  useEffect(() => {
    if (showAllRows) {
      setListData({
        listViewData: enableFilterFacetsEnhancement && searchValue !== "" ? filteredData : facetValues,
        icon: "ct-chevron-up",
        link: showLessLabel
      });
    } else {
      setListData({
        listViewData: enableFilterFacetsEnhancement && searchValue !== "" && selectedFacetType ? filteredData.slice(0, showMoreThreshold) : filteredData,
        icon: "ct-chevron-down",
        link: updatedShowMoreLabel
      });
    }
    if ((facet == null ? void 0 : facet.type) === FacetTypes.RANGE) {
      updatePriceRangeValues();
    }
  }, [
    showAllRows,
    facetValues,
    searchValue,
    facet,
    updatePriceRangeValues,
    enableFilterFacetsEnhancement,
    filteredData,
    showLessLabel,
    selectedFacetType,
    showMoreThreshold,
    updatedShowMoreLabel
  ]);
  const getSelectedValues = (facetObj) => {
    if (facetObj.type === FacetTypes.CUSTOM_RANGE) {
      const { minSelected, maxSelected, uom, selected } = facetObj;
      const appliedRangeFilterLabel = (
        // eslint-disable-next-line sonar/expression-complexity
        selected && minSelected && maxSelected && uom ? `${minSelected} - ${maxSelected} ${uom}` : ""
      );
      return [appliedRangeFilterLabel];
    } else {
      const facetVals = getFacetValues(facetObj);
      return facetVals == null ? void 0 : facetVals.filter((facVal) => facVal.selected).map((val) => (val == null ? void 0 : val.name) ? val.name : val.label);
    }
  };
  const getTitleComponent = () => {
    const selectedFacetOptions = getSelectedValues(facet);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-facet-name`, children: facet.label }),
      !filterExpanded && selectedFacetOptions && selectedFacetOptions.length ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-facet-selection`, children: selectedFacetOptions.join(", ") }) : null
    ] });
  };
  const multiSelectOnChange = (_, val) => {
    onFilterChange(val.selected ? val.clearUrl : val.url, val.label, facet.label, !val.selected);
    if (isVerticalFilters2) {
      scrollToElement(element);
    }
  };
  const getPriceValue2 = () => {
    return facet.type === FacetTypes.RANGE && (selectedMinPrice || selectedMaxPrice) !== 0;
  };
  const onPriceRangeSelection = useCallback(
    (minPrice, maxPrice) => {
      const pricePills = getPriceRangePill(minPrice, maxPrice, currentLocale);
      onFilterChange(
        pricePills ? `?mock&facet=${pricePills}` : "",
        `${pricePills}`,
        facet.label,
        true,
        true,
        minPrice,
        maxPrice,
        (customPriceFacet == null ? void 0 : customPriceFacet.url) ?? ""
      );
    },
    [currentLocale, facet.label, onFilterChange, customPriceFacet]
  );
  const validateMinMaxPrice = useCallback(
    (minPrice, maxPrice, errorSetter, errorMessage, check) => {
      let errorMsg = "";
      if (typeof minPrice === "number" && typeof maxPrice === "number") {
        errorMsg = minPrice > maxPrice ? errorMessage : "";
      }
      errorSetter(errorMsg);
      setMaxPriceError(errorMsg !== "" ? maxPriceErrorMessage : "");
      if (errorMsg === "" && check) {
        onPriceRangeSelection(minPrice, maxPrice);
        scrollToElement(element);
      }
    },
    [maxPriceErrorMessage, onPriceRangeSelection]
  );
  const updateMinimumPrice = (value) => {
    const price = Number(value.replace(digitsPattern, ""));
    setSelectedMinPrice(price);
    setMinimumPrice(getFormattedPriceValue2(price));
  };
  const updateMaximumPrice = (value) => {
    const price = Number(value.replace(digitsPattern, ""));
    setSelectedMaxPrice(price);
    setMaximumPrice(getFormattedPriceValue2(price));
  };
  const renderPriceFacet = () => {
    const priceId = "price-range";
    const onValidateHandler = (keyAccessCheck) => validateMinMaxPrice(
      selectedMinPrice,
      selectedMaxPrice,
      setMinPriceError,
      minPriceErrorMessage,
      keyAccessCheck
    );
    return /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__price-range`, children: [
      /* @__PURE__ */ jsx(
        TextInput,
        {
          disabled: getSelectedValues(facet).length !== 0,
          id: `${priceId}-minPrice`,
          label: minPriceLabel,
          value: minimumPrice,
          onChange: updateMinimumPrice,
          maxLength: 7,
          error: minPriceError,
          size: "small",
          onBlur: () => onValidateHandler(false)
        }
      ),
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__price-range__separator`, children: "-" }),
      /* @__PURE__ */ jsx(
        TextInput,
        {
          disabled: getSelectedValues(facet).length !== 0,
          id: `${priceId}-maxPrice`,
          label: maxPriceLabel,
          value: maximumPrice,
          onChange: updateMaximumPrice,
          maxLength: 7,
          error: maxPriceError,
          size: "small",
          onBlur: () => onValidateHandler(false)
        }
      ),
      /* @__PURE__ */ jsx(Button, { type: "secondary", size: "small", onClick: () => onValidateHandler(true), children: goCtaLabel })
    ] });
  };
  const highlightKeyword = useCallback(
    (labels) => {
      const regex = searchValue.replace(/[.*+?^${}()|[]\\]/g, "\\$&");
      const searchTerms = labels.split(new RegExp(`(${regex})`, "gi"));
      return /* @__PURE__ */ jsx("span", { children: searchTerms.map((searchTerm, i) => /* @__PURE__ */ jsx(
        "span",
        {
          className: searchTerm.toLowerCase() !== regex.toLowerCase() ? `${PREFIX}-suggestion-text__highlighted` : "",
          children: searchTerm
        },
        i
      )) });
    },
    [searchValue]
  );
  const renderShowMoreLessButton = () => {
    return /* @__PURE__ */ jsx(
      ShowMoreLessButton,
      {
        totalResults: searchValue === "" ? facetValuesShownList : filteredData,
        setShowAllRows,
        showAllRows,
        listData,
        showMoreThreshold,
        buttonRef: showMoreLessButtonRef,
        showLessLabel
      }
    );
  };
  const filterLiveRef = useRef(null);
  useEffect(() => {
    if (showSearch) {
      setTimeout(() => {
        var _a;
        if (filterLiveRef.current) {
          filterLiveRef.current.innerHTML = `${(_a = listData == null ? void 0 : listData.listViewData) == null ? void 0 : _a.length} ${suggestionsAvailableLabel ?? ""}`;
        }
      }, magicNumber.THOUSAND);
    }
  }, [suggestionsAvailableLabel, listData, showSearch]);
  const renderBannerList = () => {
    var _a;
    let listItem = [];
    listItem = (_a = listData == null ? void 0 : listData.listViewData) == null ? void 0 : _a.map((val) => {
      var _a2, _b;
      if ((val == null ? void 0 : val.brandImageData) && !!(val == null ? void 0 : val.count)) {
        const id = replaceStringCharacter$1(val.label, " ", "-");
        const selectedClass = val.selected ? `${componentMultiSelect}--selected` : "";
        const multiSelectElement = /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: `${componentMultiSelect}__container ${selectedClass}`, children: /* @__PURE__ */ jsx(
            "img",
            {
              className: `${componentMultiSelect}__logo`,
              alt: (_a2 = val == null ? void 0 : val.brandImageData) == null ? void 0 : _a2.bannerImageAlt,
              src: (_b = val == null ? void 0 : val.brandImageData) == null ? void 0 : _b.bannerImagePath
            }
          ) }),
          /* @__PURE__ */ jsxs("span", { children: [
            " ",
            val.count
          ] })
        ] });
        return { id, multiSelectElement, val, selected: val.selected };
      }
    });
    return listItem == null ? void 0 : listItem.filter((arr) => Boolean(arr));
  };
  const multiCheckboxChange = (_, item) => {
    multiSelectOnChange(_, item == null ? void 0 : item.val);
  };
  const renderMultiCheckbox = () => {
    return isArrayNotEmpty(renderBannerList()) ? /* @__PURE__ */ jsx(
      MultiSelectCheckBoxes,
      {
        multiSelectData: renderBannerList(),
        customClass: "multi-select__brand-filter",
        onChange: multiCheckboxChange
      }
    ) : /* @__PURE__ */ jsx(Fragment, {});
  };
  const renderMultiSelection = () => {
    var _a, _b;
    return /* @__PURE__ */ jsxs("div", { ref: mainRef, children: [
      facet.type === FacetTypes.RANGE && renderPriceFacet(),
      enableFilterFacetsEnhancement && showSearch && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__search-brand-icon`, children: [
        /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__search-brand-button`, children: /* @__PURE__ */ jsx(
          Button,
          {
            type: "icon_button",
            id: `trigger-search-icon-${facet.label.split(" ").join("-")}`,
            ariaLabel: searchInputPlaceholderText,
            children: /* @__PURE__ */ jsx(Icon, { type: "ct-search", size: "md" })
          }
        ) }),
        /* @__PURE__ */ jsx("label", { htmlFor: `search_${facet.label.split(" ").join("-")}`, className: "sr-only", children: searchInputPlaceholderText }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: "sr-only",
            ref: filterLiveRef,
            "aria-live": "polite",
            "aria-atomic": "true",
            role: "status"
          }
        ),
        /* @__PURE__ */ jsx(
          "input",
          {
            id: `search_${facet.label.split(" ").join("-")}`,
            type: "text",
            className: searchValue !== "" ? `${componentClassName2}__close-search` : `${componentClassName2}__search-brand`,
            placeholder: searchInputPlaceholderText,
            onChange: (e) => setSearchValue(e.target.value),
            autoComplete: "off",
            value: searchValue,
            onKeyDown: (event) => {
              if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.space) {
                event.preventDefault();
                setSearchValue(`${searchValue} `);
              }
            }
          }
        ),
        searchValue !== "" && /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__search-brand-button`, children: /* @__PURE__ */ jsx(
          Button,
          {
            onClick: () => setSearchValue(""),
            type: "icon_button",
            id: "close-btn",
            ariaLabel: closeLabel,
            children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "md" })
          }
        ) })
      ] }),
      renderMultiCheckbox(),
      /* @__PURE__ */ jsxs("ul", { ref: filterListRef, children: [
        enableFilterFacetsEnhancement && showSearch && ((_a = listData == null ? void 0 : listData.listViewData) == null ? void 0 : _a.length) === 0 && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__search-no-match`, children: noSearchResults }),
        // eslint-disable-next-line sonar/function-return-type
        (_b = listData == null ? void 0 : listData.listViewData) == null ? void 0 : _b.map((val) => {
          var _a2;
          const labelComponent = /* @__PURE__ */ jsxs("span", { children: [
            areAllParamsValid(enableFilterFacetsEnhancement, searchValue !== "") ? highlightKeyword(val.label) : val.name || val.label,
            /* @__PURE__ */ jsxs("span", { className: `${componentClassName2}__count`, children: [
              " (",
              val.count,
              ")"
            ] })
          ] });
          const checkboxId = `${isTriangleOffer && !val.label ? (_a2 = val == null ? void 0 : val.count) == null ? void 0 : _a2.toString() : val.label}${getFilterOnly ? " custom" : ""}`;
          return val.count > 0 && !val.brandImageData && /* @__PURE__ */ jsx(
            "li",
            {
              className: `${componentClassName2}__multiselect-item`,
              children: /* @__PURE__ */ jsx(
                Checkbox,
                {
                  disabled: getPriceValue2(),
                  facetId: facet == null ? void 0 : facet.id,
                  label: labelComponent,
                  id: checkboxId,
                  checked: val.selected,
                  value: val.label,
                  onChange: (e) => multiSelectOnChange(e, val)
                }
              )
            },
            isTriangleOffer && !val.label ? val.count.toString() : val.label
          );
        })
      ] }),
      selectedFacetType && renderShowMoreLessButton()
    ] });
  };
  const onFilterAccordionChange = (isOpen) => {
    setFilterExpanded(isOpen);
  };
  const shouldRenderFacet = () => {
    if (facet.type === FacetTypes.CUSTOM_RANGE) {
      return true;
    } else {
      const facetVals = getFacetValues(facet);
      const totalResultCount = facetVals == null ? void 0 : facetVals.reduce((count, val) => count + val.count, 0);
      return totalResultCount > 0;
    }
  };
  const stars = ["1", "2", "3", "4", "5"];
  useEffect(() => {
    var _a;
    if (filterListRef.current && listData.link === showLessLabel) {
      const listElements = getInteractiveElements(filterListRef.current);
      (_a = listElements[showMoreThreshold]) == null ? void 0 : _a.focus();
    }
  }, [listData, showLessLabel, showMoreThreshold]);
  const renderRatingFacet = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("ul", { ref: filterListRef, children: listData.listViewData.map((val) => {
        var _a;
        const labelComponent = /* @__PURE__ */ jsxs("span", { className: `${componentClassName2}__rating-review`, children: [
          stars.map((_item, index2) => {
            return index2 < Number(val.value) ? /* @__PURE__ */ jsx(Icon, { size: "lg", type: "ct-reviews-active" }, index2) : /* @__PURE__ */ jsx(Icon, { size: "lg", type: "ct-reviews-inactive" }, index2);
          }),
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-radio__label-container`, children: val.label })
        ] });
        const radioId = `${isTriangleOffer && !val.label ? (_a = val == null ? void 0 : val.count) == null ? void 0 : _a.toString() : val.label}${getFilterOnly ? " custom" : ""}`;
        return val.count > 0 && /* @__PURE__ */ jsx("li", { className: `${componentClassName2}__multiselect-item`, children: /* @__PURE__ */ jsx(
          Radio,
          {
            label: facet.type === FacetTypes.RATING ? labelComponent : val.label,
            id: radioId,
            name: "facets",
            checked: val.selected,
            onChange: (e) => multiSelectOnChange(e, val)
          }
        ) }, val.label);
      }) }),
      selectedFacetType && /* @__PURE__ */ jsx(
        ShowMoreLessButton,
        {
          totalResults: facetValuesShownList,
          setShowAllRows,
          showAllRows,
          listData,
          showMoreThreshold,
          buttonRef: showMoreLessButtonRef,
          showLessLabel
        }
      )
    ] });
  };
  const breadCrumbOnChange = (val) => {
    onFilterChange(val.selected ? val.clearUrl : val.url, val.label, facet.label, !val.selected);
  };
  const parentCategoryClicked = () => {
    var _a, _b;
    onFilterChange((_a = facet == null ? void 0 : facet.current) == null ? void 0 : _a.clearUrl, (_b = facet == null ? void 0 : facet.current) == null ? void 0 : _b.label, facet.label, false);
  };
  const renderParentCategory = () => {
    var _a, _b, _c;
    return ((_a = facet == null ? void 0 : facet.current) == null ? void 0 : _a.label) ? /* @__PURE__ */ jsxs(
      "div",
      {
        role: "button",
        onKeyDown: (event) => {
          if (event.key === stringKeyCodes.enter) {
            parentCategoryClicked();
          }
        },
        onClick: parentCategoryClicked,
        tabIndex: 0,
        className: `${componentClassName2}__parent-category-wrapper`,
        children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-left", size: "md" }),
          /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__parent-category-label`, children: facet.values.length !== 0 ? (_b = facet == null ? void 0 : facet.current) == null ? void 0 : _b.label : (_c = facet == null ? void 0 : facet.parent) == null ? void 0 : _c.label })
        ]
      }
    ) : null;
  };
  const renderCategoriesFacet = () => {
    var _a;
    return !isCategoryPage ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("ul", { ref: filterListRef, children: [
        renderParentCategory(),
        facet.values.length === 0 ? /* @__PURE__ */ jsx("li", { className: `${componentClassName2}__multiselect-item`, children: /* @__PURE__ */ jsxs(
          "span",
          {
            "data-testid": "categories-facet",
            role: "button",
            className: `${componentClassName2}__breadcrumb-category`,
            children: [
              facet.current.label,
              /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__count`, children: " " })
            ]
          }
        ) }) : (_a = listData == null ? void 0 : listData.listViewData) == null ? void 0 : _a.map((val) => {
          const labelComponent = /* @__PURE__ */ jsxs(
            "span",
            {
              "data-testid": "categories-facet",
              role: "button",
              onKeyDown: (event) => {
                if (event.key === stringKeyCodes.enter) {
                  breadCrumbOnChange(val);
                }
              },
              onClick: () => breadCrumbOnChange(val),
              tabIndex: 0,
              className: `${componentClassName2}__breadcrumb-item`,
              children: [
                val.label,
                /* @__PURE__ */ jsxs("span", { className: `${componentClassName2}__count`, children: [
                  " (",
                  val.count,
                  ")"
                ] })
              ]
            }
          );
          return val.count > 0 && /* @__PURE__ */ jsx("li", { className: `${componentClassName2}__multiselect-item`, children: labelComponent }, val.label);
        })
      ] }),
      selectedFacetType && /* @__PURE__ */ jsx(
        ShowMoreLessButton,
        {
          totalResults: facetValuesShownList,
          setShowAllRows,
          showAllRows,
          listData,
          showMoreThreshold,
          buttonRef: showMoreLessButtonRef,
          showLessLabel
        }
      )
    ] }) : null;
  };
  const getFilter = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    (facet.type === FacetTypes.MULTISELECT || facet.type === FacetTypes.RANGE || facet.type === FacetTypes.COLOURPICKER) && renderMultiSelection(),
    (facet.type === FacetTypes.RATING || facet.type === FacetTypes.RADIO) && renderRatingFacet(),
    facet.id === FacetTypes.CATEGORY_ID && renderCategoriesFacet(),
    facet.type === FacetTypes.CUSTOM_RANGE && /* @__PURE__ */ jsx(
      RangeFilter,
      {
        facet,
        minLabel,
        maxLabel,
        applyCTALabel,
        onFilterChange,
        rangeFilterInputLabelId,
        ariaLabelApplyRangeFilterCTA,
        minValGreaterThanMaxValError,
        invalidMinAndMaxError
      }
    )
  ] });
  if (getFilterOnly) {
    return getFilter();
  }
  return isCategoryPage && facet.id === FacetTypes.CATEGORY_ID ? null : shouldRenderFacet() && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    Accordion,
    {
      title: getTitleComponent(),
      isHeaderOpen: filterExpanded,
      collapseControl: onFilterAccordionChange,
      ariaLabel: filterByAriaLabel ? `${filterByAriaLabel} ${facet.label}` : `${facet.label}`,
      children: getFilter()
    }
  ) });
};
Filters.propTypes = {
  selectedFacetType: PropTypes.string,
  facet: PropTypes.any,
  showMoreThreshold: PropTypes.number,
  showMoreLabel: PropTypes.string,
  showLessLabel: PropTypes.string,
  onFilterChange: PropTypes.func,
  currentLocale: PropTypes.string,
  minPriceErrorMessage: PropTypes.string,
  maxPriceErrorMessage: PropTypes.string,
  minPriceLabel: PropTypes.string,
  maxPriceLabel: PropTypes.string,
  customPriceFacet: PropTypes.any,
  getFilterOnly: PropTypes.bool
};
const megaNavIdentifier = "mega-nav-";
const categoryURLIdentifier = "cat";
const createShopAllUrl = (categoryUrl, shopAllPlaceholderUrl) => {
  return categoryUrl.toString().replace(
    `${FORWARD_SLASH}${language}${FORWARD_SLASH}cat${FORWARD_SLASH}`,
    `${FORWARD_SLASH}${language}${FORWARD_SLASH}${shopAllPlaceholderUrl}${FORWARD_SLASH}cat${FORWARD_SLASH}`
  );
};
const language = getLanguage();
const currentPath = window.location.pathname;
const categoryShopAllLink = (categoryId, categoryUrl, shopAllPlaceholderUrl, enableShopAllLabel, shopAllExclusionIds, shopAllLinkLabel, ariaLabelShopAll, shopAllLinkStyle) => {
  const shopAllUrl = shopAllPlaceholderUrl && createShopAllUrl(categoryUrl, shopAllPlaceholderUrl);
  return enableShopAllLabel && !(shopAllExclusionIds == null ? void 0 : shopAllExclusionIds.includes(categoryId)) ? /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: shopAllUrl, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
    "a",
    {
      className: shopAllLinkStyle,
      "aria-label": ariaLabelShopAll,
      "data-automationid": `${megaNavIdentifier}${categoryId}`,
      href: memoizedStringContent,
      children: shopAllLinkLabel
    }
  ) }) : null;
};
const isL1ShopAllPage = (shopAllLabel) => {
  const L1shopAllRegExPattern = new RegExp(`${language}/${shopAllLabel}/${categoryURLIdentifier}/(?:(?!/).)+.html$`);
  return L1shopAllRegExPattern.test(currentPath);
};
const createShopAllLink = (url, shopAllLabel) => {
  const patternToBeReplaced = `${language}/`;
  const patternReplacer = `${language}/${shopAllLabel}/`;
  return isL1ShopAllPage(shopAllLabel) ? url.replace(patternToBeReplaced, patternReplacer) : url;
};
const Heading = ({ ...props }) => {
  const { variant, size, children, componentClass = EMPTY_STRING } = props;
  const [headingRef, setHeadingRef] = useState(null);
  const handleSize = useCallback(() => {
    switch (size) {
      case "4xl":
        return "display-1";
      case "3xl":
        return "h1";
      case "2xl":
        return "h2";
      case "xl":
        return "h3";
      case "lg":
        return "display-2";
      case "md":
        return "h4";
      case "sm":
        return "body-sm";
      case "xs":
        return "body-xs";
      default:
        return "";
    }
  }, [size]);
  const handleSizeClass = size ? `${PREFIX}-${handleSize()}` : EMPTY_STRING;
  useEffect(() => {
    if (headingRef) {
      headingRef.innerHTML = children;
    }
  }, [headingRef, children]);
  return createElement$1(variant, {
    className: `${componentClass} ${handleSizeClass}`,
    ref: setHeadingRef
  });
};
Heading.propTypes = {
  variant: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl"]),
  componentClass: PropTypes.string
};
const FacetPanelModal = (props) => {
  const {
    isOpen,
    path,
    closeFlyout,
    closeBtnLabel,
    title,
    viewResultsLabel,
    filtersLabel,
    mSortByCTALabel,
    clearAllLabel,
    resultCount,
    sortings = [],
    facets,
    onSortChange,
    selectedFacetType,
    sortLabel,
    refineByLabel,
    categoryLabel,
    showMoreThreshold,
    showMoreLabel,
    showLessLabel,
    selectedLabel,
    onFilterChange,
    clearAllLink,
    currentLocale,
    minPriceErrorMessage,
    maxPriceErrorMessage,
    minPriceLabel,
    maxPriceLabel,
    isClientSideFilter,
    isTriangleOffer,
    enableFilterFacetsEnhancement,
    searchInputPlaceholderText,
    noSearchResults,
    categoryData,
    showCategoryDropdown,
    isCategoryPage,
    isPrerender,
    resultAvailable,
    suggestionsAvailableLabel,
    goCtaLabel,
    minLabel,
    maxLabel,
    applyCTALabel,
    ariaLabelApplyRangeFilterCTA,
    minValGreaterThanMaxValError,
    invalidMinAndMaxError,
    shopAllLabel,
    enableVerticalFilterToggle,
    filterByAriaLabel,
    isDefaultFocus = true
  } = props;
  const componentClassName2 = `${PREFIX}-facet-modal`;
  const enableSortByFacet = enableFilterFacetsEnhancement && selectedFacetType === "sort";
  const getFacetTitle = () => {
    return enableSortByFacet ? sortLabel : title;
  };
  const flyoutModalComponentProps = {
    isOpen,
    isPrerender,
    closeFlyout,
    title: getFacetTitle(),
    isStoreSelectorModalUsed: false,
    enableVerticalFilterToggle: !!enableVerticalFilterToggle
  };
  const updatedShowMoreLabel = replaceStrWithDynamicVal(showMoreLabel, (categoryData == null ? void 0 : categoryData.length) - showMoreThreshold);
  const { current: rowsToShow } = useRef(categoryData == null ? void 0 : categoryData.slice(0, showMoreThreshold));
  const [showAllCategories, setShowAllCategories] = useState(isPrerenderOrNot());
  const [listData, setListData] = useState({
    listViewData: rowsToShow,
    icon: "ct-chevron-down",
    link: updatedShowMoreLabel
  });
  const categoryListRef = useRef(null);
  const categoryShowMoreLessButtonRef = useRef(null);
  const isMobileOrTablet = useIsMobile(BREAKPOINTS.tabletMaxWidth);
  const DEFAULT_SCROLL_DEBOUNCE_TIME = 1500;
  useEffect(() => {
    if (showAllCategories) {
      setListData({
        listViewData: categoryData,
        icon: "ct-chevron-up",
        link: showLessLabel
      });
    } else {
      setListData({
        listViewData: rowsToShow,
        icon: "ct-chevron-down",
        link: updatedShowMoreLabel
      });
    }
  }, [showAllCategories, categoryData, showLessLabel, updatedShowMoreLabel, rowsToShow]);
  const ctaLabel = replaceStrWithDynamicVal(viewResultsLabel, resultCount);
  const modalClassName = isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet) ? `${PREFIX}-flyout-modal-component` : `${PREFIX}-flyout-modal-overlay`;
  const previousElement = document.querySelector(`button[${previousElementName}`);
  const errorScreenClearCTA = document.getElementById(errorScreenClearCTAId);
  const factetFilterSearchThreshold = magicNumber.FIFTEEN;
  const modifiedCloseFlyout = () => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    closeFlyout();
    if (errorScreenClearCTA) {
      errorScreenClearCTA.focus();
    }
    if (previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  useEffect(() => {
    if (!isPrerender && !isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet)) {
      modalAccessibilityHandler({ modalOpen: isDefaultFocus, modalClassName });
    }
  }, [modalClassName, sortings, isPrerender, enableVerticalFilterToggle, isMobileOrTablet, isDefaultFocus]);
  const scrollTimeoutRef = useRef(null);
  const debounceScroll = () => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    scrollTimeoutRef.current = window.setTimeout(() => {
      scrollIntoView();
      scrollTimeoutRef.current = null;
    }, DEFAULT_SCROLL_DEBOUNCE_TIME);
  };
  const scrollIntoView = () => {
    const expanded = document.getElementsByClassName("nl-accordion--expanded")[0];
    if (expanded) {
      expanded.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };
  useEffect(() => {
    if (!isClientSideFilter) {
      debounceScroll();
    }
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
        scrollTimeoutRef.current = null;
      }
    };
  }, [debounceScroll, facets, isClientSideFilter]);
  const showClearAllLabel = () => {
    return clearAllLink && facets && !!facets.filter((facet) => isTriangleOffer ? facet.values.some((item) => item.selected) : facet.selected).length;
  };
  const renderSortFacet = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: isArrayNotEmpty(sortings) && /* @__PURE__ */ jsx(
      SortFacet,
      {
        selectedFacetType,
        sortings,
        onSortChange,
        sortLabel,
        showMoreThreshold,
        showMoreLabel,
        showLessLabel,
        enableFilterFacetsEnhancement
      }
    ) });
  };
  const renderTitleFacet = () => {
    return /* @__PURE__ */ jsx("h2", { className: `${componentClassName2}__title`, children: getFacetTitle() });
  };
  const renderFilterFacet = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${componentClassName2}__filters-heading ${isSortAvailable} ${enableFilterFacetsEnhancement ? "featured-heading" : ""}`,
          children: [
            /* @__PURE__ */ jsx(
              Heading,
              {
                variant: isTriangleOffer ? "h2" : "h3",
                componentClass: `${componentClassName2}__filters-title`,
                children: filtersLabel
              }
            ),
            showClearAllLabel() && /* @__PURE__ */ jsx(Button, { type: "tertiary", onClick: clearAllClickHandler, children: clearAllLabel })
          ]
        }
      ),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-filter-section`, children: facets.map((facet) => {
        var _a;
        return /* @__PURE__ */ jsx(
          Filters,
          {
            facet,
            onFilterChange,
            customPriceFacet: facets.find((oneFacet) => oneFacet.type === FacetTypes.CUSTOM_PRICE),
            isTriangleOffer,
            ...filtersLabelsProps,
            showSearch: facet.type !== FacetTypes.RANGE && ((_a = facet == null ? void 0 : facet.values) == null ? void 0 : _a.length) > factetFilterSearchThreshold ? true : false,
            enableFilterFacetsEnhancement,
            searchInputPlaceholderText,
            noSearchResults,
            isCategoryPage,
            closeLabel: closeBtnLabel,
            a11ySuggestionResultAvailable: resultAvailable,
            suggestionsAvailableLabel,
            minLabel,
            maxLabel,
            applyCTALabel,
            rangeFilterInputLabelId: `facet-modal-${facet.label}`.replace(/ /g, ""),
            minValGreaterThanMaxValError,
            invalidMinAndMaxError,
            filterByAriaLabel: isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet) && filterByAriaLabel,
            isVerticalFilters: isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet)
          },
          facet.label
        );
      }) })
    ] });
  };
  const shouldRenderCategoryDropdown = () => {
    return listData.listViewData.length > 0;
  };
  const filtersLabelsProps = {
    selectedFacetType,
    showMoreThreshold,
    showMoreLabel,
    showLessLabel,
    selectedLabel,
    currentLocale,
    minPriceErrorMessage,
    maxPriceErrorMessage,
    minPriceLabel,
    maxPriceLabel,
    goCtaLabel,
    ariaLabelApplyRangeFilterCTA
  };
  const clearAllClickHandler = () => {
    onFilterChange(clearAllLink, clearAllLabel, "", false, "", "", false);
  };
  useEffect(() => {
    var _a;
    if (categoryListRef.current && listData.link === showLessLabel) {
      const listElements = getInteractiveElements(categoryListRef.current);
      (_a = listElements[showMoreThreshold]) == null ? void 0 : _a.focus();
    }
  }, [listData, showLessLabel, showMoreThreshold]);
  const renderCategoryDropDown = () => {
    return showCategoryDropdown && isCategoryPage && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__filters-heading`, children: /* @__PURE__ */ jsx("h3", { className: `${componentClassName2}__filters-title`, children: refineByLabel }) }),
      /* @__PURE__ */ jsxs(
        Accordion,
        {
          title: categoryLabel,
          isHeaderOpen: selectedFacetType === categoryFacetType,
          ariaLabel: isVerticalFilters(enableVerticalFilterToggle, isMobileOrTablet) && filterByAriaLabel ? `${filterByAriaLabel} ${categoryLabel}` : `${categoryLabel}`,
          children: [
            /* @__PURE__ */ jsx("ul", { ref: categoryListRef, children: listData.listViewData.map((val) => {
              const labelComponent = /* @__PURE__ */ jsx(
                "a",
                {
                  "aria-label": shopAllLabel && isL1ShopAllPage(shopAllLabel) ? `${shopAllLabel} ${val.label}` : "",
                  "data-testid": "categories-facet",
                  href: val.url,
                  tabIndex: 0,
                  className: `${PREFIX}-filter-section__breadcrumb-item`,
                  children: val.label
                }
              );
              return /* @__PURE__ */ jsx("li", { className: `${PREFIX}-filter-section__multiselect-item`, children: labelComponent }, val.label);
            }) }),
            /* @__PURE__ */ jsx(
              ShowMoreLessButton,
              {
                totalResults: categoryData,
                setShowAllRows: setShowAllCategories,
                showAllRows: showAllCategories,
                listData,
                showMoreThreshold,
                buttonRef: categoryShowMoreLessButtonRef,
                showLessLabel
              }
            )
          ]
        }
      )
    ] });
  };
  const isSortAvailable = !isArrayNotEmpty(sortings) ? `${componentClassName2}__filters-border` : "";
  return /* @__PURE__ */ jsx(FlyoutModalComponent, { ...flyoutModalComponentProps, children: /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__container`, children: [
    renderFlyoutModalHeader(
      enableVerticalFilterToggle,
      isMobileOrTablet,
      isTriangleOffer,
      renderTitleFacet,
      modifiedCloseFlyout,
      closeBtnLabel,
      path
    ),
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__body`, children: [
      enableFilterFacetsEnhancement && shouldRenderCategoryDropdown() && selectedFacetType !== "sort" ? renderCategoryDropDown() : renderSortFacet(),
      !enableSortByFacet && isArrayNotEmpty(facets) ? renderFilterFacet() : null
    ] }),
    renderFlyoutModalFooter(
      enableVerticalFilterToggle,
      isMobileOrTablet,
      enableSortByFacet,
      mSortByCTALabel,
      modifiedCloseFlyout,
      ctaLabel
    )
  ] }) });
};
FacetPanelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeFlyout: PropTypes.func.isRequired,
  closeBtnLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  viewResultsLabel: PropTypes.string.isRequired,
  filtersLabel: PropTypes.string.isRequired,
  clearAllLabel: PropTypes.string.isRequired,
  sortLabel: PropTypes.string,
  refineByLabel: PropTypes.string,
  categoryLabel: PropTypes.string,
  showMoreThreshold: PropTypes.number,
  showMoreLabel: PropTypes.string,
  showLessLabel: PropTypes.string,
  resultCount: PropTypes.number,
  sortings: PropTypes.array,
  facets: PropTypes.array,
  path: PropTypes.string,
  onSortChange: PropTypes.func,
  selectedFacetType: PropTypes.string,
  selectedLabel: PropTypes.string,
  onFilterChange: PropTypes.func,
  clearAllLink: PropTypes.string,
  currentLocale: PropTypes.string,
  minPriceErrorMessage: PropTypes.string,
  maxPriceErrorMessage: PropTypes.string,
  minPriceLabel: PropTypes.string,
  maxPriceLabel: PropTypes.string,
  isClientSideFilter: PropTypes.bool,
  enableFilterFacetsEnhancement: PropTypes.bool,
  isPrerender: PropTypes.bool
};
const mapControls = {
  mapType: "roadmap",
  mapZoomControl: true,
  mapTypeControl: false,
  mapFullscreenControl: false
};
const markerProps = {
  initialMarkerIndex: 0,
  markerWidth: 36,
  markerHeight: 52,
  markerLabelFontSize: "16px",
  markerLabelFontWeight: "800",
  markerLabelXPos: 18,
  markerLabelYPos: 18,
  shape: {
    coords: ["1, 1, 52, 52"],
    type: "rect"
  }
};
const locationProps = {
  lat: 0,
  lng: 0
};
const locateMeControlStyles = {
  locationButtonstylebackgroundColor: "#fff",
  locationButtonstyleborder: "none",
  locationButtonstyleoutline: "none",
  locationButtonstylewidth: "40px",
  locationButtonstyleheight: "40px",
  locationButtonstyleborderRadius: "0px",
  locationButtonstyleboxShadow: "0 1px 4px rgba(0,0,0,0.3)",
  locationButtonstylecursor: "pointer",
  locationButtonstylemarginRight: "10px",
  locationButtonstylepadding: "0px",
  locationButtonInnerstylemargin: "12px",
  locationButtonInnerstylewidth: "18px",
  locationButtonInnerstyleheight: "18px",
  locationButtonInnerstylebackgroundImage: "url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)",
  locationButtonInnerstylebackgroundSize: "180px 18px",
  locationButtonInnerstylebackgroundPosition: "0px 0px",
  locationButtonInnerstylebackgroundRepeat: "no-repeat",
  locationButtonInnerid: "your_location_img"
};
const currentLocationButtonClass = "nl-current-location-button";
const Map$1 = (props) => {
  const {
    locations,
    windowRef,
    mapId,
    mapZoom,
    setMapZoom,
    setMarkerClickHandler,
    markerClickHandler,
    setPreferredStoreOnMapIconClicked,
    userGeoLocation,
    isWindowGoogleLoaded,
    center,
    a11yMapLocateMeButtonLabel
  } = props;
  const {
    markerWidth,
    markerHeight,
    initialMarkerIndex,
    markerLabelFontSize,
    markerLabelFontWeight,
    markerLabelXPos,
    markerLabelYPos,
    shape
  } = markerProps;
  const { lat, lng } = locationProps;
  const { mapType, mapZoomControl, mapTypeControl, mapFullscreenControl } = mapControls;
  const runOnce = useRef(0);
  const [mapLoaded, setMapLoaded] = useState(false);
  const getStoreCords = () => {
    const firstMarkerIndex = initialMarkerIndex;
    if ((markerClickHandler == null ? void 0 : markerClickHandler.geoPoint) || (markerClickHandler == null ? void 0 : markerClickHandler.latitude) && (markerClickHandler == null ? void 0 : markerClickHandler.longitude)) {
      return markerClickHandler.geoPoint ? markerClickHandler.geoPoint : markerClickHandler;
    } else {
      return locations[firstMarkerIndex];
    }
  };
  const getFirstMarkerPosition = () => {
    let latLongPosition = { lat, lng };
    if (isArrayNotEmpty(locations)) {
      const { latitude, longitude } = getStoreCords();
      latLongPosition = { lat: latitude, lng: longitude };
    }
    return latLongPosition;
  };
  const latLong = getFirstMarkerPosition();
  const isMapLoadingConditionsMet = useCallback(() => {
    var _a;
    return isWindowGoogleLoaded && mapLoaded && isArrayNotEmpty(locations) && !!((_a = windowRef == null ? void 0 : windowRef.google) == null ? void 0 : _a.maps);
  }, [isWindowGoogleLoaded, locations, mapLoaded, windowRef]);
  const initMap = useCallback(async () => {
    try {
      await windowRef.google.maps.importLibrary("maps");
      setMapLoaded(true);
    } catch (error) {
      console.warn("error", error);
    }
  }, [windowRef]);
  useEffect(() => {
    void initMap();
  }, [initMap]);
  useEffect(() => {
    if (isMapLoadingConditionsMet()) {
      const centerControlDiv = document.createElement("div");
      const userCurrentLocation = userGeoLocation && Object.values(userGeoLocation).includes(void 0) ? latLong : userGeoLocation;
      const map = new windowRef.google.maps.Map(document.getElementById(mapId), {
        disableDefaultUI: true,
        center: center ?? (userCurrentLocation || latLong),
        zoom: mapZoom,
        mapTypeId: mapType,
        zoomControl: mapZoomControl,
        mapTypeControl,
        fullscreenControl: mapFullscreenControl
      });
      const locateMeButton = (controlDiv, googleMap) => {
        var _a, _b, _c;
        const locationButton = document.createElement("button");
        locationButton.style.backgroundColor = locateMeControlStyles.locationButtonstylebackgroundColor;
        locationButton.style.border = locateMeControlStyles.locationButtonstyleborder;
        locationButton.style.outline = locateMeControlStyles.locationButtonstyleoutline;
        locationButton.style.width = locateMeControlStyles.locationButtonstylewidth;
        locationButton.style.height = locateMeControlStyles.locationButtonstyleheight;
        locationButton.style.borderRadius = locateMeControlStyles.locationButtonstyleborderRadius;
        locationButton.style.boxShadow = locateMeControlStyles.locationButtonstyleboxShadow;
        locationButton.style.cursor = locateMeControlStyles.locationButtonstylecursor;
        locationButton.style.marginRight = locateMeControlStyles.locationButtonstylemarginRight;
        locationButton.style.padding = locateMeControlStyles.locationButtonstylepadding;
        controlDiv.appendChild(locationButton);
        const locationButtonInner = document.createElement("div");
        locationButtonInner.style.margin = locateMeControlStyles.locationButtonInnerstylemargin;
        locationButtonInner.style.width = locateMeControlStyles.locationButtonInnerstylewidth;
        locationButtonInner.style.height = locateMeControlStyles.locationButtonInnerstyleheight;
        locationButtonInner.style.backgroundImage = locateMeControlStyles.locationButtonInnerstylebackgroundImage;
        locationButtonInner.style.backgroundSize = locateMeControlStyles.locationButtonInnerstylebackgroundSize;
        locationButtonInner.style.backgroundPosition = locateMeControlStyles.locationButtonInnerstylebackgroundPosition;
        locationButtonInner.style.backgroundRepeat = locateMeControlStyles.locationButtonInnerstylebackgroundRepeat;
        locationButtonInner.id = locateMeControlStyles.locationButtonInnerid;
        locationButton.setAttribute("aria-label", a11yMapLocateMeButtonLabel);
        locationButton.setAttribute("class", currentLocationButtonClass);
        locationButton.appendChild(locationButtonInner);
        locationButton.addEventListener("click", () => {
          setPreferredStoreOnMapIconClicked == null ? void 0 : setPreferredStoreOnMapIconClicked();
        });
        googleMap.controls[(_c = (_b = (_a = windowRef == null ? void 0 : windowRef.google) == null ? void 0 : _a.maps) == null ? void 0 : _b.ControlPosition) == null ? void 0 : _c.RIGHT_BOTTOM].push(controlDiv);
      };
      if (locations[initialMarkerIndex].name !== "") {
        const bounds = new windowRef.google.maps.LatLngBounds();
        locateMeButton(centerControlDiv, map);
        const infoWindow = new windowRef.google.maps.InfoWindow();
        locations.forEach((marker) => {
          const { storeMarker, storeMarkerLabel, latitude, longitude, name, markerColor } = marker;
          const position = { lat: latitude, lng: longitude };
          const markerNew = new windowRef.google.maps.Marker({
            position,
            map,
            setMyLocationButtonEnabled: true,
            title: name,
            icon: {
              url: storeMarker,
              scaledSize: new windowRef.google.maps.Size(markerWidth, markerHeight),
              labelOrigin: { x: markerLabelXPos, y: markerLabelYPos }
            },
            label: {
              color: markerColor,
              fontSize: markerLabelFontSize,
              fontWeight: markerLabelFontWeight,
              text: `${storeMarkerLabel}`
            },
            shape,
            zIndex: `${storeMarkerLabel}` === " " ? magicNumber.ONE : magicNumber.ZERO
          });
          markerNew.addListener("click", () => {
            marker.isSelected = true;
            setMarkerClickHandler == null ? void 0 : setMarkerClickHandler(marker);
            infoWindow.close();
            infoWindow.setContent(marker.address);
            infoWindow.open(map, markerNew);
          });
          bounds.extend(new windowRef.google.maps.LatLng(latitude, longitude));
        });
        if (runOnce.current === 0) {
          map.fitBounds(bounds);
          runOnce.current = magicNumber.ONE;
        }
        map.addListener("zoom_changed", () => {
          setMapZoom == null ? void 0 : setMapZoom(map == null ? void 0 : map.getZoom());
        });
      }
    }
  }, [
    locations,
    mapLoaded,
    isWindowGoogleLoaded,
    center,
    initialMarkerIndex,
    windowRef,
    userGeoLocation,
    latLong,
    mapId,
    mapZoom,
    mapType,
    mapZoomControl,
    mapTypeControl,
    mapFullscreenControl,
    markerWidth,
    markerHeight,
    markerLabelXPos,
    markerLabelYPos,
    markerLabelFontSize,
    markerLabelFontWeight,
    shape,
    setMarkerClickHandler,
    setMapZoom,
    setPreferredStoreOnMapIconClicked,
    a11yMapLocateMeButtonLabel,
    isMapLoadingConditionsMet
  ]);
  return isWindowGoogleLoaded ? /* @__PURE__ */ jsx("div", { id: mapId, className: `${PREFIX}-map` }) : /* @__PURE__ */ jsx(SkeletonComponent, { skeletonClass: `${PREFIX}-map__skeleton-wrapper` });
};
Map$1.propTypes = {
  mapId: PropTypes.string.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object.isRequired),
  windowRef: PropTypes.any,
  setMapZoom: PropTypes.func,
  mapZoom: PropTypes.number,
  setMarkerClickHandler: PropTypes.func,
  markerClickHandler: PropTypes.object,
  setPreferredStoreOnMapIconClicked: PropTypes.func,
  userGeoLocation: PropTypes.exact({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }),
  isWindowGoogleLoaded: PropTypes.bool,
  center: PropTypes.exact({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }),
  a11yMapLocateMeButtonLabel: PropTypes.string
};
Map$1.displayName = "GoogleMap";
const confirmationModalConstant = {
  close: "profile",
  yes: "yes",
  no: "no"
};
const ConfirmationModal = (props) => {
  const {
    confirmationHeading,
    isConfirmationModalOpen,
    confirmationSubHeading,
    yesButtonLabel,
    noButtonLabel,
    path,
    closeConfirmationModal,
    a11yCloseLabel,
    confirmationModalClickHandler,
    mirrorButtonActions,
    notScroll,
    displayCloseButton = true,
    buttonSize = "small",
    shouldCloseModalOnSubmit = true,
    showSubHeading
  } = props;
  const componentClassName2 = `${PREFIX}-confirmation-modal`;
  const componentModificationClassName = displayCloseButton ? "" : `${componentClassName2}--padding`;
  const previousElement = document.querySelector(`button[${previousElementName}]`);
  const { close, yes, no } = confirmationModalConstant;
  const modalClassName = `${PREFIX}-react-modal`;
  const confirmationModalRef = useRef(null);
  const closeModal = (isContinueClicked, isCarryOn) => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    closeConfirmationModal(isContinueClicked, isCarryOn);
    if (previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  const closeHandler = () => {
    closeModal(close);
    previousElement == null ? void 0 : previousElement.focus();
    previousElement == null ? void 0 : previousElement.removeAttribute(previousElementName);
  };
  useClickOutsideClose(confirmationModalRef, closeHandler, isConfirmationModalOpen, true);
  const noButtonProps = {
    // eslint-disable-next-line no-warning-comments
    // TODO: going forword need to remove no and use only boolean value
    id: "no-modal",
    onClick: () => closeModal(no, false)
  };
  const yesButtonProps = {
    // eslint-disable-next-line no-warning-comments
    // TODO: going forword need to remove yes and use only boolean value
    id: "yes-modal",
    onClick: () => {
      shouldCloseModalOnSubmit && closeModal(yes, true);
      confirmationModalClickHandler && confirmationModalClickHandler();
    }
  };
  let leftButtonLabel = noButtonLabel;
  let rightButtonLabel = yesButtonLabel;
  let leftButtonProps = noButtonProps;
  let rightButtonProps = yesButtonProps;
  if (mirrorButtonActions) {
    leftButtonProps = yesButtonProps;
    leftButtonLabel = yesButtonLabel;
    rightButtonProps = noButtonProps;
    rightButtonLabel = noButtonLabel;
  }
  return /* @__PURE__ */ jsx(ReactModal, { closeHandler: () => closeModal(close), isOpen: isConfirmationModalOpen, notScroll, children: /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}  ${componentModificationClassName}`, ref: confirmationModalRef, children: [
    displayCloseButton && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__close-container`, children: /* @__PURE__ */ jsx(
      "button",
      {
        "data-testid": "confirm-modal-close-btn",
        className: `${componentClassName2}__close-btn`,
        "aria-label": a11yCloseLabel,
        onClick: () => closeModal(close),
        children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg", path })
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__heading`, children: [
      /* @__PURE__ */ jsx("h3", { className: `${componentClassName2}__header-text`, children: confirmationHeading }),
      /* @__PURE__ */ jsx(
        "p",
        {
          className: `${componentClassName2}__subheader-text`,
          dangerouslySetInnerHTML: { __html: confirmationSubHeading }
        }
      ),
      showSubHeading
    ] }),
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__button-container`, children: [
      leftButtonLabel && /* @__PURE__ */ jsx(Button, { type: "tertiary", size: buttonSize, ...leftButtonProps, children: leftButtonLabel }),
      rightButtonLabel && /* @__PURE__ */ jsx(Button, { type: "primary", size: buttonSize, ...rightButtonProps, children: rightButtonLabel })
    ] })
  ] }) });
};
ConfirmationModal.propTypes = {
  confirmationHeading: PropTypes.string.isRequired,
  confirmationSubHeading: PropTypes.string.isRequired,
  yesButtonLabel: PropTypes.string.isRequired,
  noButtonLabel: PropTypes.string,
  path: PropTypes.string,
  isConfirmationModalOpen: PropTypes.bool,
  closeConfirmationModal: PropTypes.func,
  a11yCloseLabel: PropTypes.string,
  confirmationModalClickHandler: PropTypes.func,
  mirrorButtonActions: PropTypes.bool,
  notScroll: PropTypes.bool,
  displayCloseButton: PropTypes.bool
};
ConfirmationModal.displayName = "ConfirmationModal";
const specialKeysArray = ["backspace", "shift", "ctrl", "cmd", "alt", "delete"];
const navigationalKeysArray = ["upArrow", "downArrow", "leftArrow", "rightArrow"];
const textAreaInputHandler = (event, setCharCount, textAreaRef, onInputChange, hasMaxLimit, maxCharacters) => {
  const inputText = textAreaRef.current.innerText;
  setCharCount(
    inputText.length > 0 && inputText.includes("\n") ? inputText.replace("/\n/g/", "") : inputText
  );
  onInputChange(inputText);
  const utils = {
    special: {},
    navigational: {},
    isSpecial(e) {
      return typeof this.special[e.keyCode] !== "undefined";
    },
    isNavigational(e) {
      return typeof this.navigational[e.keyCode] !== "undefined";
    }
  };
  specialKeysArray.forEach((key) => {
    utils.special[keyCodes[key]] = true;
  });
  navigationalKeysArray.forEach((navKey) => {
    utils.navigational[keyCodes[navKey]] = true;
  });
  let hasSelection = false;
  const selection = window.getSelection();
  const isSpecial = utils.isSpecial(event);
  const isNavigational = utils.isNavigational(event);
  if (selection) {
    hasSelection = !!selection.toString();
  }
  if (isSpecial || isNavigational) {
    return true;
  }
  const len = textAreaRef.current.innerText.length > 0 && textAreaRef.current.innerText.includes("\n") ? textAreaRef.current.innerText.replace("/\n/g", "").length : textAreaRef.current.innerText.length;
  if (hasMaxLimit && len >= maxCharacters && !hasSelection) {
    event.preventDefault();
    return false;
  }
  return false;
};
const onFocusInputHandler = (setIsFocused, id) => {
  setIsFocused(true);
  if (window.getSelection) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(document.getElementById(id));
    selection.removeAllRanges();
    selection.addRange(range);
  }
};
const onFocusOutHandler = (setIsFocused) => {
  setIsFocused(false);
  window.getSelection().removeAllRanges();
};
const TextArea = ({
  id,
  error,
  errorIcon,
  label,
  hasMaxLimit,
  maxCharacters,
  onInputChange,
  path,
  value,
  isErrorFocus
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [charCount, setCharCount] = useState("");
  const componentClassName2 = `${PREFIX}-textarea`;
  const nonInputSectionClassName = `${componentClassName2}-non-input-section`;
  const errorFocusClass = getTextInputClassNames(error, isFocused, isErrorFocus, componentClassName2);
  const noTextClass = charCount === "" ? `${componentClassName2}__input-no-text` : "";
  const assessibilityErrorClass = error ? `${PREFIX}-accessibility-field--error` : "";
  const textAreaRef = useRef(null);
  const valueRef = useRef(value);
  const onInputChangeRef = useRef(onInputChange);
  const inputHandler = useCallback(
    (event) => {
      textAreaInputHandler(event, setCharCount, textAreaRef, onInputChangeRef.current, hasMaxLimit, maxCharacters);
    },
    [textAreaRef, hasMaxLimit, maxCharacters, onInputChangeRef]
  );
  const onPasteHandler = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text").slice(0, Number(maxCharacters));
    textAreaRef.current.innerText = pastedText;
    setCharCount(pastedText);
  };
  useEffect(() => {
    const textAreaRefValue = textAreaRef.current;
    textAreaRefValue.innerText = valueRef.current;
    setCharCount(valueRef.current);
    textAreaRefValue.addEventListener("keydown", inputHandler);
    textAreaRefValue.addEventListener("keyup", inputHandler);
    return () => {
      textAreaRefValue.removeEventListener("keydown", inputHandler);
      textAreaRefValue.removeEventListener("keyup", inputHandler);
    };
  }, [inputHandler, valueRef]);
  useEffect(() => {
    const elementInput = document.querySelector(`.${componentClassName2}__input`);
    const elementLabel = document.querySelector(`.${componentClassName2}__label`);
    elementInput.style.marginTop = `${elementLabel.offsetHeight}px`;
  }, [componentClassName2]);
  return /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}`, children: [
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__container ${errorFocusClass}`, "data-testid": "textarea-container", children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          ref: textAreaRef,
          id,
          "data-testid": id,
          className: `${componentClassName2}__input ${noTextClass} ${assessibilityErrorClass}`,
          onFocus: () => onFocusInputHandler(setIsFocused, id),
          onBlur: () => onFocusOutHandler(setIsFocused),
          onPaste: onPasteHandler,
          role: "textbox",
          contentEditable: "true",
          "aria-label": label
        }
      ),
      /* @__PURE__ */ jsx("label", { className: `${componentClassName2}__label`, htmlFor: id, children: label })
    ] }),
    (hasMaxLimit || error) && /* @__PURE__ */ jsxs("div", { className: nonInputSectionClassName, children: [
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__error`, role: "alert", children: error && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Icon, { type: errorIcon, size: "sm", path }),
        /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__error-text`, children: error })
      ] }) }),
      hasMaxLimit && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${nonInputSectionClassName}-char-count`,
          children: `${charCount.length}/${maxCharacters}`
        }
      )
    ] })
  ] });
};
TextArea.defaultProps = {
  errorIcon: "ct-input-error"
};
const EmptyCartWishlist = (props) => {
  const { emptyScreenProps } = props;
  const {
    title,
    subTitle,
    ctaContinueLabel,
    ctaPrimaryLabel,
    cta1Link,
    cta2Link,
    isCartEmpty,
    isLoggedIn,
    isWishlistPage = false,
    ssoHandler,
    isGigyaLoaded
  } = emptyScreenProps;
  const displayLinkSignIn = () => {
    return !!ssoHandler && !isLoggedIn ? /* @__PURE__ */ jsx(
      Button,
      {
        modifierClass: `${PREFIX}-empty-cart__wishlist-link`,
        onClick: () => ssoHandler(false),
        ariaLabel: ctaPrimaryLabel,
        children: ctaPrimaryLabel
      }
    ) : /* @__PURE__ */ jsx("a", { className: `${PREFIX}-empty-cart__wishlist-link`, href: cta1Link, "data-link-value": ctaPrimaryLabel, children: ctaPrimaryLabel });
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-empty-cart`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-empty-cart__title`, children: title }),
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-empty-cart__message`, children: subTitle }),
    isCartEmpty && !isLoggedIn && !isGigyaLoaded ? null : displayLinkSignIn(),
    isCartEmpty && isLoggedIn && isWishlistPage ? null : /* @__PURE__ */ jsx("a", { className: `${PREFIX}-empty-cart__continue-link`, href: cta2Link, "data-link-value": ctaContinueLabel, children: ctaContinueLabel })
  ] });
};
EmptyCartWishlist.propTypes = {
  emptyScreenProps: PropTypes.object.isRequired
};
const PostalCodeModal = ({ ...props }) => {
  const {
    isOpen,
    modalTitle,
    modalInputPlaceholder,
    primaryButtonLabel,
    tertiaryButtonLabel,
    a11ypcmCloseLabel,
    setPCM,
    onChangePCAction,
    selectedPostalCode,
    modalSecondaryTitle,
    pcmErrorMsg,
    emptyPostalCodeMessage,
    postalCodeRegex,
    showDescription,
    validatePostalCode: validatePostalCode2,
    showPCMSpinner,
    setPCMErrorMsg,
    popUpTitleId
  } = props;
  const [postalCode, setPostalCode] = useState(selectedPostalCode);
  const [postalInputCode, setPostalInputCode] = useState("");
  const [errorMsg, setErrorMsg] = useState(pcmErrorMsg);
  const componentClassName2 = `${PREFIX}-postal-code-modal`;
  const onPCChangeClick = () => {
    if (postalCode) {
      const validate = postalCodeRegex.test(postalCode);
      setErrorMsg(!validate ? emptyPostalCodeMessage : "");
      if (onChangePCAction && validate) {
        setPCMErrorMsg && setPCMErrorMsg("");
        onChangePCAction(postalCode);
      }
    } else {
      setErrorMsg(emptyPostalCodeMessage);
    }
  };
  useEffect(() => {
    if (isOpen && (!selectedPostalCode || pcmErrorMsg)) {
      setPostalCode(postalInputCode || postalCode);
    } else {
      setPostalInputCode("");
    }
    setErrorMsg(pcmErrorMsg ? pcmErrorMsg : "");
  }, [isOpen, pcmErrorMsg, postalInputCode, selectedPostalCode, postalCode]);
  useEffect(() => {
    setPostalCode(selectedPostalCode);
    !selectedPostalCode && setErrorMsg("");
  }, [isOpen, selectedPostalCode]);
  useEffect(() => {
    setErrorMsg(pcmErrorMsg);
  }, [pcmErrorMsg]);
  const closeHandler = () => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName: `${PREFIX}-react-modal` });
    setPCM();
    const previousElement = document.querySelector(`button[${previousElementName}]`);
    if (previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  const modalRef = useRef(null);
  useClickOutsideClose(modalRef, closeHandler, isOpen, true);
  const onKeyDownHandler = (event) => {
    if (event.key === stringKeyCodes.enter) {
      onPCChangeClick();
    }
  };
  return /* @__PURE__ */ jsx(ReactModal, { closeHandler, isOpen, children: /* @__PURE__ */ jsxs(
    "div",
    {
      role: "dialog",
      "aria-labelledby": popUpTitleId,
      "aria-modal": "true",
      className: componentClassName2,
      ref: modalRef,
      children: [
        /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__close-container`, children: /* @__PURE__ */ jsx(
          "button",
          {
            className: `${componentClassName2}__close-btn`,
            onClick: closeHandler,
            "data-testid": "postal-code-close-handler",
            "aria-label": a11ypcmCloseLabel,
            children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" })
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__content`, children: [
          /* @__PURE__ */ jsx("h3", { id: popUpTitleId, className: `${componentClassName2}__title`, children: selectedPostalCode ? modalSecondaryTitle : modalTitle }),
          showDescription && /* @__PURE__ */ jsx(
            "p",
            {
              className: `${componentClassName2}__description`,
              dangerouslySetInnerHTML: { __html: modalSecondaryTitle }
            }
          ),
          /* @__PURE__ */ jsx(
            TextInput,
            {
              id: "postal-code-modal",
              label: modalInputPlaceholder,
              value: (postalInputCode == null ? void 0 : postalInputCode.length) ? postalInputCode : postalCode,
              error: errorMsg,
              maxLength: 7,
              onChange: (val) => setPostalCode(validatePostalCode2(val)),
              size: "default",
              quantumMetricAttribute: { type: "encrypt", value: "true" },
              onKeyDown: onKeyDownHandler
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__footer-buttons`, children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                size: "medium",
                onClick: onPCChangeClick,
                label: primaryButtonLabel,
                showSpinner: showPCMSpinner
              }
            ),
            /* @__PURE__ */ jsx(Button, { type: "tertiary", onClick: closeHandler, children: tertiaryButtonLabel })
          ] })
        ] })
      ]
    }
  ) });
};
PostalCodeModal.defaultProps = {
  showDescription: false
};
PostalCodeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired,
  modalDescription: PropTypes.string,
  modalInputPlaceholder: PropTypes.string.isRequired,
  primaryButtonLabel: PropTypes.string.isRequired,
  tertiaryButtonLabel: PropTypes.string.isRequired,
  pcmErrorMsg: PropTypes.string.isRequired,
  a11ypcmCloseLabel: PropTypes.string.isRequired,
  setPCM: PropTypes.func,
  onChangePostalCode: PropTypes.func,
  onChangePCAction: PropTypes.func,
  selectedPostalCode: PropTypes.string,
  modalSecondaryTitle: PropTypes.string.isRequired,
  emptyPostalCodeMessage: PropTypes.string.isRequired,
  postalCodeRegex: PropTypes.instanceOf(RegExp).isRequired,
  showDescription: PropTypes.bool,
  validatePostalCode: PropTypes.func,
  showPCMSpinner: PropTypes.bool,
  setPCMErrorMsg: PropTypes.func
};
const EstimateFeesModal = ({ ...props }) => {
  const {
    isOpen,
    modalTitle,
    modalDescription,
    modalDisclaimer,
    modalInputPlaceholder,
    modalEstimatedFees,
    modalEstimatedFeesPrice,
    modalContinueLabel,
    modalCancelLabel,
    a11ypcmCloseLabel,
    emptyPostalCodeMessage,
    onCloseEFAction,
    onContinueEFAction,
    onPostalCodeUpdateAction,
    pcmErrorMsg,
    selectedPostalCode,
    estimateFeesSuccessMsg,
    postalCodeRegex,
    validatePostalCode: validatePostalCode2,
    showEstimatedFees,
    showEFSpinner,
    isExpressDeliveryEnabledForProduct,
    enableExpressDeliveryOption,
    estimateFeesDisclaimerExpressDelivery,
    modalEstimatedFeesPriceExpressDelivery,
    standardShippingFeesText,
    expressShippingFeesText,
    notAvailableShippingFeesText,
    isExpressDeliveryEligibleForPostalCode,
    setIsEstimateFeeBtnPressed,
    isInMiniPDPFlyout,
    backBtnLabel
  } = props;
  const [postalCode, setPostalCode] = useState(selectedPostalCode);
  const [isUpdateBtnClicked, setIsUpdateBtnClicked] = useState(false);
  const [errorMsg, setErrorMsg] = useState(pcmErrorMsg);
  const [isSmallWindow, setIsSmallWindow] = useState(false);
  const componentClassName2 = `${PREFIX}-postal-code-modal`;
  const smallWindowClass = `${componentClassName2}__small-window`;
  const minHeight = 650;
  const isExpressDeliveryAvailable = enableExpressDeliveryOption && isExpressDeliveryEnabledForProduct;
  const [previousPostalCode, setPreviousPostalCode] = useState(postalCode);
  const isPostalCodeValid = areAllParamsValid(isUpdateBtnClicked, postalCodeRegex.test(postalCode));
  const previousPostalCodeValue = usePrevious(previousPostalCode);
  const onPCChangeClick = useCallback(() => {
    setPreviousPostalCode(postalCode);
    if (previousPostalCodeValue === postalCode) {
      return false;
    }
    if (postalCode) {
      const validate = postalCodeRegex.test(postalCode);
      setErrorMsg(!validate ? emptyPostalCodeMessage : "");
      setIsUpdateBtnClicked(true);
      if (onContinueEFAction && validate) {
        setIsEstimateFeeBtnPressed(true);
        onContinueEFAction(postalCode);
      }
    } else {
      setIsEstimateFeeBtnPressed(false);
      setErrorMsg(emptyPostalCodeMessage);
    }
  }, [
    previousPostalCodeValue,
    postalCode,
    postalCodeRegex,
    emptyPostalCodeMessage,
    onContinueEFAction,
    setIsEstimateFeeBtnPressed
  ]);
  useEffect(() => {
    setPostalCode(postalCode);
    setIsUpdateBtnClicked(false);
  }, [postalCode]);
  useEffect(() => {
    setPostalCode(selectedPostalCode);
    !selectedPostalCode && setErrorMsg("");
  }, [isOpen, selectedPostalCode]);
  useEffect(() => {
    const isOpenAndNoErrors = isOpen && !pcmErrorMsg;
    if (isOpenAndNoErrors && selectedPostalCode && postalCode && !showEstimatedFees) {
      onPCChangeClick();
    }
  }, [isOpen, selectedPostalCode, postalCode, pcmErrorMsg, showEstimatedFees, onPCChangeClick]);
  useEffect(() => {
    setErrorMsg(pcmErrorMsg);
  }, [pcmErrorMsg]);
  const closeHandler = () => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName: `${PREFIX}-react-modal` });
    onCloseEFAction();
    setIsEstimateFeeBtnPressed(false);
    setPreviousPostalCode("");
    onPostalCodeUpdateAction();
    const previousElement = document.querySelector(`button[${previousElementName}]`);
    if (previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  const handleResize = () => {
    setIsSmallWindow(window.innerHeight <= minHeight);
  };
  useGlobalResizeEvent(handleResize);
  const modalRef = useRef(null);
  useClickOutsideClose(modalRef, closeHandler, isOpen, true);
  const renderEstimateFees = () => {
    if (isPostalCodeValid) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        estimateFeesSuccessMsg && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__success`, role: "alert", children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }),
          /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__success-text`, children: estimateFeesSuccessMsg })
        ] }),
        modalEstimatedFees && modalEstimatedFeesPrice && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__price`, children: [
          /* @__PURE__ */ jsxs("span", { children: [
            modalEstimatedFees,
            ":"
          ] }),
          /* @__PURE__ */ jsx("span", { children: modalEstimatedFeesPrice })
        ] })
      ] });
    }
    return null;
  };
  const renderEstimateFeesExpressDelivery = () => {
    if (isPostalCodeValid) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        estimateFeesSuccessMsg && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__success`, role: "alert", children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-checkmark", size: "sm" }),
          /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__success-text`, children: estimateFeesSuccessMsg })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__price-info`, children: [
          standardShippingFeesText && modalEstimatedFeesPrice && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__price--standard ${PREFIX}-xs-flex`, children: [
            /* @__PURE__ */ jsxs("span", { children: [
              standardShippingFeesText,
              ":"
            ] }),
            /* @__PURE__ */ jsx("span", { children: modalEstimatedFeesPrice })
          ] }),
          expressShippingFeesText && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__price--express ${PREFIX}-xs-flex`, children: [
            /* @__PURE__ */ jsxs("span", { children: [
              expressShippingFeesText,
              ":"
            ] }),
            /* @__PURE__ */ jsx("span", { children: isExpressDeliveryEligibleForPostalCode ? modalEstimatedFeesPriceExpressDelivery : notAvailableShippingFeesText })
          ] })
        ] })
      ] });
    }
    return null;
  };
  const isMobile2 = navigator.userAgent.toLowerCase().includes("mobi");
  return /* @__PURE__ */ jsx(ReactModal, { closeHandler, isOpen, isHeightFix: true, children: /* @__PURE__ */ jsxs("div", { role: "dialog", "aria-label": modalTitle, className: `${componentClassName2}`, ref: modalRef, children: [
    isInMiniPDPFlyout ? /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__back-container`, children: /* @__PURE__ */ jsx(
      ButtonV2,
      {
        variant: Variation.TERTIARY,
        customClass: `${componentClassName2}__back-btn`,
        a11y: { label: backBtnLabel },
        onClick: closeHandler,
        icon: {
          size: iconSizes.Large,
          type: "ct-chevron-left"
        },
        children: backBtnLabel
      }
    ) }) : /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__close-container`, children: /* @__PURE__ */ jsx(
      "button",
      {
        className: `${componentClassName2}__close-btn`,
        onClick: closeHandler,
        "aria-label": a11ypcmCloseLabel,
        children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" })
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__content`, children: [
      /* @__PURE__ */ jsx("h2", { className: `${componentClassName2}__title`, children: modalTitle }),
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__description`, children: /* @__PURE__ */ jsx("p", { children: modalDescription }) }),
      /* @__PURE__ */ jsx(
        TextInput,
        {
          id: "postal-code-modal",
          label: modalInputPlaceholder,
          value: postalCode,
          error: errorMsg,
          success: showEstimatedFees,
          maxLength: 7,
          onChange: (val) => setPostalCode(validatePostalCode2(val)),
          size: "default"
        }
      ),
      isExpressDeliveryAvailable ? showEstimatedFees && renderEstimateFeesExpressDelivery() : showEstimatedFees && renderEstimateFees(),
      /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__footer-buttons ${isSmallWindow ? smallWindowClass : ""}`, children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `${componentClassName2}__disclaimer`,
            "data-testid": "tooltip-text",
            dangerouslySetInnerHTML: {
              __html: isExpressDeliveryAvailable ? estimateFeesDisclaimerExpressDelivery : modalDisclaimer
            }
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${componentClassName2}__buttons ${isMobile2 ? `${componentClassName2}__footer-buttons-mobile-fixed` : ""}`,
            children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  type: "secondary",
                  size: "small",
                  onClick: closeHandler,
                  label: modalCancelLabel
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  modifierClass: `${componentClassName2}__update-btn`,
                  type: "primary",
                  size: "small",
                  onClick: onPCChangeClick,
                  label: modalContinueLabel,
                  showSpinner: showEFSpinner
                }
              )
            ]
          }
        )
      ] })
    ] })
  ] }) });
};
EstimateFeesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string,
  modalDescription: PropTypes.string,
  modalDisclaimer: PropTypes.string,
  modalInputPlaceholder: PropTypes.string,
  modalEstimatedFees: PropTypes.string,
  modalEstimatedFeesPrice: PropTypes.string,
  modalContinueLabel: PropTypes.string,
  modalCancelLabel: PropTypes.string,
  a11ypcmCloseLabel: PropTypes.string,
  emptyPostalCodeMessage: PropTypes.string,
  pcmErrorMsg: PropTypes.string,
  selectedPostalCode: PropTypes.string,
  estimateFeesSuccessMsg: PropTypes.string,
  onCloseEFAction: PropTypes.func,
  onContinueEFAction: PropTypes.func,
  onPostalCodeUpdateAction: PropTypes.func,
  postalCodeRegex: PropTypes.instanceOf(RegExp).isRequired,
  validatePostalCode: PropTypes.func,
  showEstimatedFees: PropTypes.bool,
  showEFSpinner: PropTypes.bool
};
const ConfirmationScreen = (props) => {
  const {
    title,
    description,
    imagePath,
    imageAlt,
    buttonLabel,
    buttonLink,
    success,
    successLinkTarget,
    formDetails,
    errorCallback
  } = props;
  const componentName = `${PREFIX}-confirmation-screen`;
  const confirmationButtonHandler = () => {
    if (success) {
      window.open(buttonLink, successLinkTarget, "noopener");
    } else {
      errorCallback(formDetails);
    }
  };
  return /* @__PURE__ */ jsx("div", { className: componentName, children: /* @__PURE__ */ jsxs("div", { className: `${componentName}-container`, children: [
    /* @__PURE__ */ jsx("img", { src: imagePath, alt: imageAlt, className: `${componentName}-image` }),
    /* @__PURE__ */ jsx("div", { className: `${componentName}-title`, children: title }),
    /* @__PURE__ */ jsx("div", { className: `${componentName}-description`, dangerouslySetInnerHTML: { __html: description } }),
    /* @__PURE__ */ jsx(Button, { type: "primary", size: "medium", onClick: confirmationButtonHandler, children: buttonLabel })
  ] }) });
};
ConfirmationScreen.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  imagePath: PropTypes.string,
  imageAlt: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonLink: PropTypes.string,
  success: PropTypes.bool,
  successLinkTarget: PropTypes.string,
  formDetails: PropTypes.exact({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    emailSubject: PropTypes.string,
    subject: PropTypes.string,
    subjectOptions: PropTypes.string,
    subjectOptionDetails: PropTypes.string,
    orderNumber: PropTypes.string,
    comment: PropTypes.string
  }),
  errorCallback: PropTypes.func
};
const orderNumberRegex = /^[0-9]*$/;
const scrollToTarget = (sectionId, isDesktop) => {
  var _a;
  const sectionElem = document.getElementById(sectionId);
  const navHeaderHeight = ((_a = document.getElementById("primary-navigation")) == null ? void 0 : _a.clientHeight) || 0;
  const offsetTopValue = isDesktop ? sectionElem == null ? void 0 : sectionElem.offsetTop : (sectionElem == null ? void 0 : sectionElem.offsetTop) - navHeaderHeight;
  window.scroll({
    top: sectionId ? offsetTopValue : 0,
    behavior: "smooth"
  });
};
const scrollToElementIfExists = (headerSelector, selectors) => {
  var _a;
  const header = ((_a = document.querySelector(headerSelector)) == null ? void 0 : _a.clientHeight) || 0;
  let element = null;
  selectors.some((selector) => {
    element = document.querySelector(selector);
    return Boolean(element);
  });
  if (element) {
    window.scroll({
      top: element.offsetTop - header,
      behavior: "smooth"
    });
  }
};
const scrollBetweenElements = (topElementId, bottomElementId) => {
  const topElement = document.getElementById(topElementId);
  const bottomElement = document.getElementById(bottomElementId);
  topElement == null ? void 0 : topElement.scrollIntoView({ behavior: "smooth", block: "start" });
  bottomElement == null ? void 0 : bottomElement.scrollIntoView({ behavior: "smooth", block: "end" });
};
const scrollToTop$1 = scrollToTarget;
const validateTextFieldHandler = (selectedVal, regex, errorSetter, emptyErrorMsg, incorrectErrorMsg) => {
  let errorMsg = "";
  if (!selectedVal) {
    errorMsg = emptyErrorMsg;
  } else if (regex) {
    const validate = regex.test(selectedVal);
    errorMsg = !validate ? incorrectErrorMsg : "";
  }
  errorSetter(errorMsg);
};
const validateDropdownHandler = (selectedVal, errorSetter, emptyErrorMsg) => {
  const errorMsg = !selectedVal ? emptyErrorMsg : "";
  errorSetter(errorMsg);
};
const updateDropDownObjectFn = (selectedDropDownLabel, setPersistDropDown, persistDropDown) => {
  const dropDownList = persistDropDown;
  dropDownList.forEach((dropDownItem) => {
    dropDownItem.selected = dropDownItem.id === selectedDropDownLabel;
  });
  setPersistDropDown(dropDownList);
};
const getNextAccordionItems = ({
  selectedValue
}) => {
  if (selectedValue.accordionItems2) {
    return selectedValue.accordionItems2;
  }
  if (selectedValue.accordionItems3) {
    return selectedValue.accordionItems3;
  }
  return null;
};
const ContactUsByEmail = (props) => {
  const {
    title,
    firstNameLabel,
    lastNameLabel,
    emailLabel,
    emailPatternLabel,
    isAssistiveTextAlwaysVisible,
    yourMessageTitle,
    subjectLabel,
    orderNumberLabel,
    additionalInfoLabel,
    additionalInfoMaxCount,
    noteText,
    submitCTALabel,
    esDescription,
    ssTitle,
    ssDescription,
    esTitle,
    ssCTAPath,
    esImagePath,
    esImageAlt,
    ssImagePath,
    esCTALabel,
    ssImageAlt,
    ssCTALabel,
    accordionItems,
    ssCTATarget,
    icon,
    emailMessageTitle,
    headingLevel,
    content,
    submitContactUsCallBack,
    resetContactUsCallBack,
    contactUsSuccess,
    contactUsFailure,
    firstNameEmptyMessage,
    firstNameInvalidMessage,
    lastNameEmptyMessage,
    lastNameInvalidMessage,
    emailEmptyMessage,
    emailInvalidMessage,
    additionalInfoEmptyMsg,
    firstNameRegEx,
    lastNameRegEx,
    emailRegEx,
    orderNumberEmptyMessage,
    optionEmptyMessage1,
    optionEmptyMessage2,
    optionEmptyMessage3,
    invalidOrderNumberMessage
  } = props;
  const [isDropdownOptions] = useState(!!accordionItems.length);
  const dropdownListMapFn = ({ subjectDropDownLabel, subjectDropDownID, ...others }) => {
    return { label: subjectDropDownLabel, id: subjectDropDownID, selected: false, ...others };
  };
  const dropdownList = isDropdownOptions ? accordionItems.map(dropdownListMapFn) : [];
  const [dropdownList2, setDropdownList2] = useState([]);
  const [dropdownList3, setDropdownList3] = useState([]);
  const [displayOrderNumber, setDisplayOrderNumber] = useState("false");
  const [displayText, setDisplayText] = useState(null);
  const [level2Display, setLevel2Display] = useState("false");
  const [level3Display, setLevel3Display] = useState("false");
  const [formDetails, setFormDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    emailSubject: "",
    subject: "",
    subjectOptions: "",
    subjectOptionDetails: "",
    comment: ""
  });
  const [emailSubjectItems, setEmailSubjectItems] = useState({
    subject1: "",
    subject2: "",
    subject3: ""
  });
  const [changedFormField, setChangedFormField] = useState({
    firstName: false,
    lastName: false,
    email: false,
    emailSubject: false,
    subject: false,
    subjectOptions: false,
    subjectOptionDetails: false,
    orderNumber: false,
    comment: false
  });
  const [showConfirmationScreen, setShowConfirmationScreen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [persistDropDown, setPersistDropDown] = useState(dropdownList);
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [subject2Error, setSubject2Error] = useState("");
  const [subject3Error, setSubject3Error] = useState("");
  const [orderNumberError, setOrderNumberError] = useState("");
  const [additionalInfoError, setAdditionalInfoError] = useState("");
  const [isSendButtonClicked, setIsSendButtonClicked] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isSendButtonTriggered, setIsSendButtonTriggered] = useState(false);
  const componentName = `${PREFIX}-contact-us-by-email`;
  const emailBodyClassName = `${componentName}-email-body`;
  const [showSpinner, setShowSpinner] = useState(false);
  const onSelectHandler = (level) => {
    return (selectedValue) => {
      handleDropdownCall(level, selectedValue);
    };
  };
  const dropdownIcon = "ct-chevron-down";
  const dropdownLevel1 = 1;
  const dropdownLevel2 = 2;
  const dropdownLevel3 = 3;
  const [dropdownProps2, setDropdownProps2] = useState({
    dropdownTitle: subjectLabel,
    dropdownList: dropdownList2,
    dropdownIcon,
    size: "default",
    dropdownId: "subjectOptions",
    selectedItem: onSelectHandler(dropdownLevel2),
    isFilter: true,
    filterTitle: subjectLabel,
    type: "primary"
  });
  const [dropdownProps3, setDropdownProps3] = useState({
    dropdownTitle: subjectLabel,
    dropdownList: dropdownList3,
    dropdownIcon,
    size: "default",
    dropdownId: "subjectOptionDetails",
    selectedItem: onSelectHandler(dropdownLevel3),
    isFilter: true,
    filterTitle: subjectLabel,
    type: "primary"
  });
  const contactUsByEmailFormRef = useRef(null);
  useEffect(() => {
    setShowConfirmationScreen(contactUsSuccess || contactUsFailure);
    setIsSuccess(contactUsSuccess);
    if (contactUsFailure) {
      setShowSpinner(false);
    }
  }, [contactUsSuccess, contactUsFailure]);
  const validateTextField = useCallback(validateTextFieldHandler, []);
  const validateDropdown = useCallback(validateDropdownHandler, []);
  const generateEmailSubject = useCallback(
    (subject1, subject2, subject3, subject) => {
      const secondSubject = subject2.length ? `- ${subject2}` : "";
      const thirdSubject = subject3.length ? `- ${subject3}` : "";
      return isDropdownOptions ? `${subject1} ${secondSubject} ${thirdSubject}` : subject;
    },
    [isDropdownOptions]
  );
  useEffect(() => {
    setFormDetails((prevState) => {
      return {
        ...prevState,
        emailSubject: generateEmailSubject(
          emailSubjectItems.subject1,
          emailSubjectItems.subject2,
          emailSubjectItems.subject3,
          formDetails.subject
        )
      };
    });
  }, [
    generateEmailSubject,
    formDetails.subject,
    formDetails.subjectOptions,
    formDetails.subjectOptionDetails,
    emailSubjectItems.subject1,
    emailSubjectItems.subject2,
    emailSubjectItems.subject3
  ]);
  useEffect(() => {
    validateTextField(
      formDetails.firstName,
      firstNameRegEx,
      setFirstNameError,
      firstNameEmptyMessage,
      firstNameInvalidMessage
    );
  }, [formDetails.firstName, firstNameEmptyMessage, firstNameInvalidMessage, validateTextField, firstNameRegEx]);
  useEffect(() => {
    validateTextField(
      formDetails.lastName,
      lastNameRegEx,
      setLastNameError,
      lastNameEmptyMessage,
      lastNameInvalidMessage
    );
  }, [formDetails.lastName, lastNameEmptyMessage, lastNameInvalidMessage, validateTextField, lastNameRegEx]);
  useEffect(() => {
    validateTextField(formDetails.email, emailRegEx, setEmailError, emailEmptyMessage, emailInvalidMessage);
  }, [formDetails.email, emailEmptyMessage, emailInvalidMessage, validateTextField, emailRegEx]);
  useEffect(() => {
    if (displayOrderNumber === "true") {
      validateTextField(
        formDetails.orderNumber,
        orderNumberRegex,
        setOrderNumberError,
        orderNumberEmptyMessage,
        invalidOrderNumberMessage
      );
    } else {
      setOrderNumberError(null);
    }
  }, [
    formDetails.orderNumber,
    orderNumberEmptyMessage,
    invalidOrderNumberMessage,
    validateTextField,
    displayOrderNumber
  ]);
  useEffect(() => {
    validateTextField(formDetails.comment, null, setAdditionalInfoError, additionalInfoEmptyMsg);
  }, [formDetails.comment, additionalInfoEmptyMsg, validateTextField]);
  useEffect(() => {
    validateDropdown(formDetails.subject, setSubjectError, optionEmptyMessage1);
  }, [formDetails.subject, optionEmptyMessage1, validateDropdown]);
  useEffect(() => {
    if (level2Display === "true") {
      validateDropdown(formDetails.subjectOptions, setSubject2Error, optionEmptyMessage2);
    } else {
      setSubject2Error(null);
    }
  }, [formDetails.subjectOptions, optionEmptyMessage2, validateDropdown, level2Display]);
  useEffect(() => {
    if (level3Display === "true") {
      validateDropdown(formDetails.subjectOptionDetails, setSubject3Error, optionEmptyMessage3);
    } else {
      setSubject3Error(null);
    }
  }, [formDetails.subjectOptionDetails, optionEmptyMessage3, validateDropdown, level3Display]);
  useEffect(() => {
    setIsSendButtonClicked(false);
  }, [formDetails]);
  const sendError2 = (changedField, errorMsg) => {
    if (isFormErrorExist().includes(errorMsg) && isSubmitButtonClicked || changedFormField[changedField]) {
      return errorMsg;
    }
    return "";
  };
  const onChangeHandler = (inputFieldName, value) => {
    value && setChangedFormField((prevState) => {
      return {
        ...prevState,
        [inputFieldName]: true
      };
    });
    setFormDetails((prevState) => {
      return {
        ...prevState,
        [inputFieldName]: value
      };
    });
  };
  const onBlurHandler = (inputFieldName, e) => {
    const { value } = e.target;
    if (value) {
      setFormDetails((prevState) => {
        return {
          ...prevState,
          [inputFieldName]: value.trim()
        };
      });
    }
  };
  const setNextLevelDropdown = useCallback(
    (nextLevelDropdownItems, nextLevel, nextDropdownHeading) => {
      var _a, _b;
      const items = nextLevelDropdownItems.map(dropdownListMapFn);
      const nextLevelProps = {
        2: {
          ...dropdownProps2,
          dropdownList: items,
          filterTitle: nextDropdownHeading
        },
        3: {
          ...dropdownProps3,
          dropdownList: items,
          filterTitle: nextDropdownHeading
        }
      };
      const listHandlers = {
        2: setDropdownList2,
        3: setDropdownList3
      };
      const propsHandlers = {
        2: setDropdownProps2,
        3: setDropdownProps3
      };
      listHandlers[nextLevel](items);
      if (nextLevel === dropdownLevel2 && ((_a = nextLevelProps[nextLevel]) == null ? void 0 : _a.filterTitle) !== dropdownProps2.filterTitle || nextLevel === dropdownLevel3 && ((_b = nextLevelProps[nextLevel]) == null ? void 0 : _b.filterTitle) !== dropdownProps3.filterTitle) {
        propsHandlers[nextLevel](nextLevelProps[nextLevel]);
      }
    },
    [dropdownProps2, dropdownProps3]
  );
  const handleDropdownLevel1 = (selectedValue) => {
    setFormDetails((prevState) => {
      return {
        ...prevState,
        subject: selectedValue.label,
        subjectOptions: "",
        subjectOptionDetails: ""
      };
    });
    setEmailSubjectItems((prevState) => {
      return {
        ...prevState,
        subject1: selectedValue.id,
        subject2: "",
        subject3: ""
      };
    });
    setLevel3Display("false");
    setDropdownList2([]);
    setDropdownList3([]);
    setDropDownSelectedValues({
      level: 2,
      selectedValue
    });
    setDisplayText(selectedValue.displayText);
  };
  const handleDropdownLevel2 = (selectedValue) => {
    setFormDetails((prevState) => {
      return {
        ...prevState,
        subjectOptions: selectedValue.label,
        subjectOptionDetails: ""
      };
    });
    setEmailSubjectItems((prevState) => {
      return {
        ...prevState,
        subject2: selectedValue.id,
        subject3: ""
      };
    });
    setDropdownList3([]);
    setDropDownSelectedValues({
      level: 3,
      selectedValue
    });
  };
  const handleDropdownLevel3 = (selectedValue) => {
    setFormDetails((prevState) => {
      return {
        ...prevState,
        subjectOptionDetails: selectedValue.label
      };
    });
    setEmailSubjectItems((prevState) => {
      return {
        ...prevState,
        subject3: selectedValue.id
      };
    });
  };
  const handleDropdownCall = (level, selectedValue) => {
    const handlers = {
      1: handleDropdownLevel1,
      2: handleDropdownLevel2,
      3: handleDropdownLevel3
    };
    handlers[level](selectedValue);
    if (selectedValue.displayOrderNumber !== void 0) {
      setDisplayOrderNumber(selectedValue.displayOrderNumber);
    } else {
      setDisplayOrderNumber("false");
    }
  };
  const [dropDownSelectedValues, setDropDownSelectedValues] = useState(null);
  useEffect(() => {
    const showNextLevelContact = ({
      selectedValue,
      level
    }) => {
      const nextLevelHeading = {
        2: selectedValue.level2Heading,
        3: selectedValue.level3Heading
      };
      const nextLevelDisplayProp = {
        2: selectedValue.level2Available,
        3: selectedValue.level3Available
      };
      const nextLevelDisplayFn = {
        2: setLevel2Display,
        3: setLevel3Display
      };
      const nextHeading = nextLevelHeading[level];
      nextLevelDisplayFn[level](nextLevelDisplayProp[level]);
      const nextLevelItems = getNextAccordionItems({ selectedValue });
      if (nextLevelItems) {
        setNextLevelDropdown(nextLevelItems, level, nextHeading);
      }
    };
    dropDownSelectedValues && showNextLevelContact(dropDownSelectedValues);
  }, [dropDownSelectedValues, setNextLevelDropdown]);
  const isFormErrorExist = () => {
    return [
      firstNameError,
      lastNameError,
      emailError,
      subjectError,
      subject2Error,
      subject3Error,
      orderNumberError,
      additionalInfoError
    ].filter((err) => err);
  };
  const focusFirstErrorElement = useCallback(() => {
    var _a;
    const firstErrorElement = (_a = contactUsByEmailFormRef.current) == null ? void 0 : _a.querySelector(
      `.${PREFIX}-accessibility-field--error`
    );
    firstErrorElement && firstErrorElement.focus();
  }, []);
  useEffect(() => {
    focusFirstErrorElement();
  }, [isSendButtonTriggered, focusFirstErrorElement]);
  const onSubmitHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isSendButtonClicked) {
      setIsSubmitButtonClicked(true);
      setIsSendButtonClicked(true);
    }
    const isError = isFormErrorExist().length;
    if (!isError) {
      setShowSpinner(true);
      submitContactUsCallBack(formDetails);
      scrollToTop$1();
    }
    setIsSendButtonTriggered((prevState) => !prevState);
  };
  const showValidationError = (fieldName, errorText) => {
    return isSendButtonClicked ? errorText : sendError2(fieldName, errorText);
  };
  const dropdownProps = {
    dropdownTitle: subjectLabel,
    dropdownList: persistDropDown,
    dropdownIcon,
    size: "default",
    dropdownId: "subject",
    selectedItem: onSelectHandler(dropdownLevel1),
    isFilter: true,
    filterTitle: subjectLabel,
    type: "primary",
    error: showValidationError("subject", subjectError)
  };
  const updateDropDownObject = (selectedDropDownLabel) => updateDropDownObjectFn(selectedDropDownLabel, setPersistDropDown, persistDropDown);
  const contactFormErrorHandler = (userFormDetails) => {
    resetContactUsCallBack();
    setShowConfirmationScreen(false);
    setFormDetails(userFormDetails);
    updateDropDownObject(userFormDetails.subject);
  };
  const confirmationScreenProps = {
    title: isSuccess ? ssTitle : esTitle,
    description: isSuccess ? ssDescription : esDescription,
    imagePath: isSuccess ? ssImagePath : esImagePath,
    imageAlt: isSuccess ? ssImageAlt : esImageAlt,
    buttonLabel: isSuccess ? ssCTALabel : esCTALabel,
    buttonLink: ssCTAPath,
    success: isSuccess,
    successLinkTarget: ssCTATarget,
    formDetails,
    errorCallback: contactFormErrorHandler
  };
  const getEmailHeadingComp = () => {
    const HeadingTagLevel = headingLevel;
    return /* @__PURE__ */ jsx(
      HeadingTagLevel,
      {
        className: `${PREFIX}-customer-service__title ${PREFIX}-customer-service__title--with-icon`,
        children: emailMessageTitle
      }
    );
  };
  const fieldsetContainer = isDropdownOptions ? /* @__PURE__ */ jsx("fieldset", { children: /* @__PURE__ */ jsxs("div", { className: emailBodyClassName, children: [
    /* @__PURE__ */ jsx("h2", { className: `${emailBodyClassName}-title`, children: yourMessageTitle }),
    /* @__PURE__ */ jsx(Dropdown, { ...dropdownProps }),
    displayText ? /* @__PURE__ */ jsx(
      "div",
      {
        className: `${componentName}-dropdown-info`,
        dangerouslySetInnerHTML: { __html: displayText }
      }
    ) : null,
    dropdownList2.length && level2Display === "true" ? /* @__PURE__ */ jsx(Dropdown, { ...dropdownProps2, error: showValidationError("subjectOptions", subject2Error) }) : null,
    dropdownList3.length && level3Display === "true" ? /* @__PURE__ */ jsx(Dropdown, { ...dropdownProps3, error: showValidationError("subjectOptionDetail", subject3Error) }) : null,
    displayOrderNumber === "true" ? /* @__PURE__ */ jsx(
      TextInput,
      {
        value: formDetails.orderNumber,
        id: "orderNumber",
        label: orderNumberLabel,
        onChange: (val) => onChangeHandler("orderNumber", val),
        maxLength: 16,
        error: showValidationError("orderNumber", orderNumberError),
        isErrorFocus: true,
        quantumMetricAttribute: { type: "encrypt", value: "true" }
      }
    ) : null,
    /* @__PURE__ */ jsx(
      TextArea,
      {
        id: "comment",
        label: additionalInfoLabel,
        onInputChange: (val) => onChangeHandler("comment", val),
        maxCharacters: Number(additionalInfoMaxCount),
        hasMaxLimit: true,
        value: formDetails.comment,
        error: showValidationError("comment", additionalInfoError),
        isErrorFocus: true
      }
    ),
    /* @__PURE__ */ jsx(
      "article",
      {
        className: `${emailBodyClassName}-note`,
        dangerouslySetInnerHTML: { __html: noteText }
      }
    )
  ] }) }) : /* @__PURE__ */ jsx("fieldset", { children: /* @__PURE__ */ jsxs("div", { className: emailBodyClassName, children: [
    /* @__PURE__ */ jsx("h2", { className: `${emailBodyClassName}-title`, children: yourMessageTitle }),
    /* @__PURE__ */ jsx("div", { className: `${componentName}-subject`, children: /* @__PURE__ */ jsx(
      TextInput,
      {
        value: formDetails.subject,
        id: "subject",
        label: subjectLabel,
        onChange: (val) => onChangeHandler("subject", val),
        onBlur: (val) => onBlurHandler("subject", val),
        maxLength: 50,
        error: showValidationError("subject", subjectError),
        isErrorFocus: true,
        quantumMetricAttribute: { type: "encrypt", value: "true" }
      }
    ) }),
    /* @__PURE__ */ jsx(
      TextArea,
      {
        id: "comment",
        label: additionalInfoLabel,
        onInputChange: (val) => onChangeHandler("comment", val),
        maxCharacters: Number(additionalInfoMaxCount),
        hasMaxLimit: true,
        value: formDetails.comment,
        error: showValidationError("comment", additionalInfoError),
        isErrorFocus: true
      }
    ),
    /* @__PURE__ */ jsx(
      "article",
      {
        className: `${emailBodyClassName}-note`,
        dangerouslySetInnerHTML: { __html: noteText }
      }
    )
  ] }) });
  return /* @__PURE__ */ jsx(Fragment, { children: showConfirmationScreen ? /* @__PURE__ */ jsx(ConfirmationScreen, { ...confirmationScreenProps }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: componentName, children: [
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-customer-service__heading`, children: [
      !!icon && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-customer-service__icon-container`, children: /* @__PURE__ */ jsx(Icon, { type: icon }) }),
      getEmailHeadingComp(),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-customer-service__subtitle`,
          dangerouslySetInnerHTML: { __html: content }
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("form", { ref: contactUsByEmailFormRef, children: [
      /* @__PURE__ */ jsxs("fieldset", { children: [
        /* @__PURE__ */ jsx("h2", { className: `${componentName}-form-title`, children: title }),
        /* @__PURE__ */ jsxs("div", { className: `${componentName}-name-details`, children: [
          /* @__PURE__ */ jsx(
            TextInput,
            {
              value: formDetails.firstName,
              id: "firstName",
              label: firstNameLabel,
              onChange: (val) => onChangeHandler("firstName", val),
              onBlur: (val) => onBlurHandler("firstName", val),
              maxLength: 50,
              error: showValidationError("firstName", firstNameError),
              isErrorFocus: true,
              quantumMetricAttribute: { type: "encrypt", value: "true" }
            }
          ),
          /* @__PURE__ */ jsx(
            TextInput,
            {
              value: formDetails.lastName,
              id: "lastName",
              label: lastNameLabel,
              onChange: (val) => onChangeHandler("lastName", val),
              onBlur: (val) => onBlurHandler("lastName", val),
              maxLength: 50,
              error: showValidationError("lastName", lastNameError),
              isErrorFocus: true,
              quantumMetricAttribute: { type: "encrypt", value: "true" }
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: `${componentName}-email`, children: /* @__PURE__ */ jsx(
          TextInput,
          {
            value: formDetails.email,
            type: "email",
            id: "email",
            label: emailLabel,
            onChange: (val) => onChangeHandler("email", val),
            onBlur: (val) => onBlurHandler("email", val),
            maxLength: 256,
            error: showValidationError("email", emailError),
            isErrorFocus: true,
            quantumMetricAttribute: { type: "encrypt", value: "true" },
            assistiveText: emailPatternLabel,
            isAssistiveTextAlwaysVisible
          }
        ) })
      ] }),
      fieldsetContainer,
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "small",
          onClick: onSubmitHandler,
          buttonType: "submit",
          label: submitCTALabel,
          showSpinner
        }
      )
    ] })
  ] }) }) });
};
ContactUsByEmail.propTypes = {
  title: PropTypes.string,
  firstNameLabel: PropTypes.string,
  lastNameLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  yourMessageTitle: PropTypes.string,
  subjectLabel: PropTypes.string,
  orderNumberLabel: PropTypes.string,
  additionalInfoLabel: PropTypes.string,
  additionalInfoMaxCount: PropTypes.number,
  noteText: PropTypes.string,
  submitCTALabel: PropTypes.string,
  ssCTATarget: PropTypes.string,
  esDescription: PropTypes.string,
  ssTitle: PropTypes.string,
  esCTAPath: PropTypes.string,
  ssDescription: PropTypes.string,
  additionalInfoEmptyMsg: PropTypes.string,
  lastNameInvalidMessage: PropTypes.string,
  esTitle: PropTypes.string,
  ssCTAPath: PropTypes.string,
  esImagePath: PropTypes.string,
  emailInvalidMessage: PropTypes.string,
  firstNameEmptyMessage: PropTypes.string,
  lastNameEmptyMessage: PropTypes.string,
  esImageAlt: PropTypes.string,
  ssImagePath: PropTypes.string,
  esCTALabel: PropTypes.string,
  ssImageAlt: PropTypes.string,
  destinationEmail: PropTypes.string,
  ssCTALabel: PropTypes.string,
  esCTATarget: PropTypes.string,
  emailEmptyMessage: PropTypes.string,
  firstNameInvalidMessage: PropTypes.string,
  accordionItems: PropTypes.array,
  icon: PropTypes.string,
  emailMessageTitle: PropTypes.string,
  headingLevel: PropTypes.string,
  content: PropTypes.string,
  submitContactUsCallBack: PropTypes.func,
  resetContactUsCallBack: PropTypes.func,
  contactUsSuccess: PropTypes.bool,
  contactUsFailure: PropTypes.bool,
  firstNameRegEx: PropTypes.any,
  lastNameRegEx: PropTypes.any,
  emailRegEx: PropTypes.any,
  orderNumberEmptyMessage: PropTypes.string,
  optionEmptyMessage1: PropTypes.string,
  optionEmptyMessage2: PropTypes.string,
  optionEmptyMessage3: PropTypes.string,
  invalidOrderNumberMessage: PropTypes.string
};
const BrandFooter = ({ ...props }) => {
  const { image, classname, showDivider } = props;
  const customClass = classname ? classname : "";
  const componentName = `${PREFIX}-brand-footer`;
  return image && /* @__PURE__ */ jsxs("div", { className: `${componentName} ${customClass}`, children: [
    showDivider && /* @__PURE__ */ jsx("hr", {}),
    /* @__PURE__ */ jsx("img", { className: `${componentName}__img`, src: image, alt: "" })
  ] });
};
const ErrorScreen = ({ ...props }) => {
  const { data } = props;
  const { headerLogo, errorMessageHeader, errorMessageSubHeader, footer, errorDescription, ctaList } = data;
  const componentName = `${PREFIX}-error-card`;
  const renderCta = (cta, i) => {
    var _a, _b;
    return cta.url ? /* @__PURE__ */ jsx(
      "a",
      {
        href: cta.url,
        className: `${PREFIX}-button2
                     ${PREFIX}-button2--${cta.variant || Variation.PRIMARY}
                     ${PREFIX}-button2--${cta.variant || Variation.PRIMARY}-${cta.color || ButtonColors.DEFAULT}
                     ${componentName}__link}`,
        "data-link-value": cta.children,
        children: cta.children
      },
      i
    ) : /* @__PURE__ */ jsx(
      SpinnerButton,
      {
        variant: cta.variant || Variation.PRIMARY,
        id: cta.id,
        color: cta.color,
        size: cta.size,
        ref: cta.ref,
        onClick: cta.onClick,
        showSpinner: Boolean(cta.showSpinner),
        a11y: {
          label: (_a = cta.a11y) == null ? void 0 : _a.label,
          describedBy: (_b = cta.a11y) == null ? void 0 : _b.describedBy
        },
        children: cta.children
      },
      i
    );
  };
  const renderCtaList = () => {
    return ctaList == null ? void 0 : ctaList.map((cta, i) => renderCta(cta, i));
  };
  return /* @__PURE__ */ jsxs("div", { className: `${componentName}`, children: [
    /* @__PURE__ */ jsx("div", { className: `${componentName}__error-img`, children: /* @__PURE__ */ jsx("img", { src: `${headerLogo == null ? void 0 : headerLogo.image}`, alt: `${headerLogo == null ? void 0 : headerLogo.imageAlt}` }) }),
    /* @__PURE__ */ jsxs("div", { className: `${componentName}__content`, children: [
      errorMessageHeader && /* @__PURE__ */ jsx("p", { className: `${componentName}__title`, dangerouslySetInnerHTML: { __html: errorMessageHeader } }),
      errorMessageSubHeader && /* @__PURE__ */ jsx(
        "p",
        {
          className: `${componentName}__subtitle`,
          dangerouslySetInnerHTML: { __html: errorMessageSubHeader }
        }
      )
    ] }),
    errorDescription && /* @__PURE__ */ jsx(
      "div",
      {
        className: `${componentName}__sub-content`,
        dangerouslySetInnerHTML: { __html: errorDescription }
      }
    ),
    (ctaList == null ? void 0 : ctaList.length) > 1 ? /* @__PURE__ */ jsx("div", { className: `${componentName}__cta`, children: renderCtaList() }) : renderCtaList(),
    (footer == null ? void 0 : footer.bannerImage) && /* @__PURE__ */ jsx(
      BrandFooter,
      {
        image: footer.bannerImage,
        altText: footer.bannerImageAltText,
        showDivider: footer.showDivider
      }
    )
  ] });
};
ErrorScreen.propTypes = {
  data: propTypesExports.exact({
    headerLogo: propTypesExports.exact({ image: propTypesExports.string, imageAlt: propTypesExports.string }),
    errorMessageHeader: propTypesExports.string,
    errorMessageSubHeader: propTypesExports.string,
    ctaList: propTypesExports.array
  }).isRequired
};
const PasswordVisibilityToggle = ({
  ...props
}) => {
  const { showLabel, hideLabel, inputField } = props;
  const [shouldShowPassword, setShowPassword] = useState(false);
  const componentClassName2 = "pwd-visibility-toggle";
  const iconType = shouldShowPassword ? "ct-hide" : "ct-show";
  const displayLabel = shouldShowPassword ? hideLabel : showLabel;
  useEffect(() => {
    inputField.current.type = shouldShowPassword ? "text" : "password";
  }, [inputField, shouldShowPassword]);
  const handleClick = () => {
    setShowPassword(!shouldShowPassword);
  };
  return /* @__PURE__ */ jsx("div", { className: componentClassName2, "aria-live": "polite", children: /* @__PURE__ */ jsx(
    ButtonV2,
    {
      variant: Variation.TERTIARY,
      onClick: handleClick,
      a11y: { label: displayLabel },
      icon: { size: "lg", type: `${iconType}` },
      children: displayLabel
    }
  ) });
};
const PasswordsForm = ({ ...props }) => {
  const { passwordFields, ctaList, onFormSubmit, afterSubmitError, visibilityToggle } = props;
  const { shouldShow = false, showLabel = "", hideLabel = "" } = visibilityToggle || {};
  const componentClassName2 = `${PREFIX}-passwords-form`;
  const renderPasswordFields = () => {
    return passwordFields == null ? void 0 : passwordFields.map((field, i) => {
      const inputRef = createRef();
      return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row ${PREFIX}-xs-flex-nowrap ${componentClassName2}__field`, children: /* @__PURE__ */ jsx(
        TextInput,
        {
          id: field.id,
          label: field.label,
          value: field.value,
          onChange: field.onChange,
          error: field.error,
          textInputRef: inputRef,
          children: shouldShow && /* @__PURE__ */ jsx(
            PasswordVisibilityToggle,
            {
              showLabel,
              hideLabel,
              inputField: inputRef
            }
          )
        }
      ) }, i);
    });
  };
  const renderCtaList = () => {
    return ctaList == null ? void 0 : ctaList.map((cta, i) => {
      return (cta == null ? void 0 : cta.children) && /* @__PURE__ */ jsx(
        ButtonV2,
        {
          variant: cta.variant || Variation.PRIMARY,
          onClick: cta.onClick,
          color: cta.color || ButtonColors.DEFAULT,
          type: cta.type || ButtonType.DEFAULT,
          children: cta.children
        },
        i
      );
    });
  };
  const renderAfterSubmitError = () => {
    return afterSubmitError && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-textinput__msg`, role: "alert", children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, { type: "ct-warning-triangle-sm", size: "sm" }) }),
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-textinput__msg-text`, children: afterSubmitError })
    ] });
  };
  return /* @__PURE__ */ jsxs("form", { className: componentClassName2, onSubmit: onFormSubmit, children: [
    renderPasswordFields(),
    renderAfterSubmitError(),
    ctaList && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row ${PREFIX}-xs-flex-nowrap ${componentClassName2}__cta`, children: renderCtaList() })
  ] });
};
const unavailableIndex = -1;
const titleDataTetsId = "store-selector-title";
const allItemsInStock = "allItemsInStock";
const StoreDetailsModal = (props) => {
  const { renderMaxNumberOfStores, storeList, markerClickHandler } = props;
  const componentClassName2 = `${PREFIX}-store-details-modal`;
  const { selectedIndex } = markerClickHandler;
  const selectedStore = storeList.find((store) => (markerClickHandler == null ? void 0 : markerClickHandler.id) === (store == null ? void 0 : store.id));
  return /* @__PURE__ */ jsx("div", { className: `${componentClassName2}`, children: renderMaxNumberOfStores(selectedStore, selectedIndex) });
};
StoreDetailsModal.propTypes = {
  markerClickHandler: PropTypes.any,
  renderMaxNumberOfStores: PropTypes.func,
  storeList: PropTypes.any
};
const ToggleTabs = ({ ...props }) => {
  const [activeBtn, setActiveBtn] = useState(false);
  const firstBtnSelectedClassName = !activeBtn ? `${PREFIX}-first-btn--selected` : `${PREFIX}-first-btn--unselected`;
  const secondBtnSelectedClassName = activeBtn ? `${PREFIX}-second-btn--selected` : `${PREFIX}-second-btn--unselected`;
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-toggle-btn`, children: [
    /* @__PURE__ */ jsxs(
      Button,
      {
        size: "mini",
        type: "secondary",
        modifierClass: firstBtnSelectedClassName,
        onClick: () => {
          setActiveBtn(false);
          props.onFirstBtnClick();
        },
        ariaLabel: props.firstBtnAriaLabel,
        children: [
          props.showIcon && /* @__PURE__ */ jsx(Icon, { type: props.firstBtnIconType, size: "lg", path: props.path }),
          props.firstBtnLabel
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      Button,
      {
        size: "mini",
        type: "secondary",
        modifierClass: secondBtnSelectedClassName,
        onClick: () => {
          setActiveBtn(true);
          props.onSecondBtnClick();
        },
        ariaLabel: props.secondBtnAriaLabel,
        children: [
          props.showIcon && /* @__PURE__ */ jsx(Icon, { type: props.secondBtnIconType, size: "lg", path: props.path }),
          props.secondBtnLabel
        ]
      }
    )
  ] });
};
const afternoonHours = 12;
const StoreSelectorModal = (props) => {
  const {
    path,
    closeFlyout,
    closeBtnLabel = "",
    storeList,
    allStores,
    isShowAvailability,
    closeLabel,
    closesAtLabel,
    openLabel,
    openingAtLabel,
    title,
    wishlistCartOnlyTitle,
    pdpOnlyTitle,
    headerOnlyTitle,
    searchInputPH,
    a11ySearchIconAriaLabel,
    a11yCurrentLocationCTAAriaLabel,
    closeIconLabel,
    mapViewLabel,
    listViewLabel,
    preferredStoreLabel,
    setPreferredStoreCTALabel,
    storeDetailsCTALabel,
    inStockLabel,
    outOfStockLabel,
    showFilter,
    filterByLabel,
    setPreferredStore,
    preferredStoreId,
    setPreferredStoreOnMapIconClicked,
    indentPreferredStart,
    showClose = false,
    isInMiniPDPFlyout,
    backBtnLabel,
    analyticMiniPDPLocation,
    setStoreDisplay,
    setCurrentPage,
    searchInputErrorMsg,
    storeFilters,
    selectedFilter,
    filterStoreList,
    addressMaxLength,
    onStoreViewChangesAnalytics,
    newMapProps,
    setHasMoreStores,
    setMarkerClickHandler,
    markerClickHandler,
    pageType,
    searchStoreAnalyticsHandler,
    fetchNearbyStoreListOnSearch,
    onlineOrdersNotAcceptedMsg,
    sku,
    renderAutoAppointmentButton,
    baseStoreId,
    isStaggeredProduct,
    staggeredSkus,
    isHeaderStoreLocator,
    seeMoreCTAURL,
    seeMoreCTALabel,
    viewMoreAnalytics,
    noResultForPostalCodeTitle = "",
    noResultsForInStoreInventoryDescription,
    noResultForPostalCodeDescription = "",
    getStoreSelectorAnalyticsLocation,
    forcePreferredStoreMsg,
    isStoresApiFailed,
    storeErrorResponse,
    maxRadiusErrorCode,
    isShowEmptyStoresToggle,
    showInStockFilterLabel,
    a11yTelephoneAriaLabel,
    inStockOnlineLabel,
    inStockDCOnlyEnabled,
    a11ySuggestionResultAvailable,
    a11yMapLocateMeButtonLabel,
    isOpen,
    a11yListViewAriaLabel,
    a11yMapViewAriaLabel,
    enableInStockOnlineInFlyout,
    a11yStoresAvailableLabel,
    noResultFoundTitle,
    noResultForCartInStoreInventoryTitle,
    noResultForCartInStoreInventoryDescription,
    noResultForCartTitle,
    noResultForCartDescription,
    fetchNearbyStoresWithAvailability,
    allItemsInStockMsg,
    isStoreLocator
  } = props;
  const componentClassName2 = `${PREFIX}-store-selector-flyout`;
  const storeClassName = `${componentClassName2}__stores-list`;
  const toggleButtonClassName = !showFilter ? `${PREFIX}-toggle-tab-btn` : "";
  const isMobile2 = window.innerWidth <= BREAKPOINTS.mobileMaxWidth;
  const isTablet = window.innerWidth > BREAKPOINTS.mobileMaxWidth && window.innerWidth <= BREAKPOINTS.tabletMaxWidth;
  const [isMapView, setIsMapView] = useState(false);
  const selectedstoreClassName = `${PREFIX}-store-selector-flyout__stores-list--selected`;
  const storesRefArray = useRef([]);
  const preferredStore = storeList == null ? void 0 : storeList.find((item) => (item == null ? void 0 : item.id) === preferredStoreId);
  const isTabletOnStoreLocatorPage = () => isTablet && pageType === pageTypes$1.storeLocator;
  const isTabletNotOnStoreLocatorPage = () => isTablet && pageType !== pageTypes$1.storeLocator;
  const [showInStock, setShowInStock] = useState(false);
  const storesWithInventoryOrPreferred = [];
  const storesLocationWithInventoryOrPreferred = [];
  const storesIdsWithInventoryOrPreferred = [];
  const allStoresLocations = newMapProps.locations;
  const storeSelectorModalRef = useRef(null);
  const focusLockEventRef = useRef();
  const storeCloseByRef = useRef(null);
  const isPdpPageType = pageType === pageTypes$1.pdpPage;
  const isCartPage = pageType === pageTypes$1.shoppingCart;
  const inFlyoutLinkTarget = useMemo(() => isInMiniPDPFlyout ? "_blank" : "_self", [isInMiniPDPFlyout]);
  const visibleTitle = useMemo(() => {
    if (isHeaderStoreLocator || isStoresApiFailed) {
      return headerOnlyTitle;
    } else if (isInMiniPDPFlyout || isPdpPageType) {
      return pdpOnlyTitle;
    } else if (pageType === pageTypes$1.wishlist || pageType === pageTypes$1.shoppingCart) {
      return wishlistCartOnlyTitle;
    } else {
      return title;
    }
  }, [
    isInMiniPDPFlyout,
    isHeaderStoreLocator,
    isStoresApiFailed,
    isPdpPageType,
    pageType,
    headerOnlyTitle,
    pdpOnlyTitle,
    wishlistCartOnlyTitle,
    title
  ]);
  const viewStoreDetailsLinkLocation = () => {
    if (pageType === pageTypes$1.storeLocator) {
      return pageType;
    } else {
      return getStoreSelectorAnalyticsLocation();
    }
  };
  useEffect(() => {
    if (!isMobile2 && pageType) {
      storeList.forEach((store) => {
        store.isSelected = (markerClickHandler == null ? void 0 : markerClickHandler.id) === store.id;
      });
      const selStore = isArrayNotEmpty(storesRefArray.current) && storesRefArray.current.find(
        (ref) => {
          var _a;
          return (ref == null ? void 0 : ref.id) === ((_a = markerClickHandler == null ? void 0 : markerClickHandler.id) == null ? void 0 : _a.toString());
        }
      );
      selStore && (selStore == null ? void 0 : selStore.scrollIntoView({ behavior: "smooth", block: "nearest" }));
    }
  }, [markerClickHandler, isMobile2, pageType, storeList]);
  useEffect(() => {
    if (isOpen) {
      focusLockEventRef.current = enableFocusLock(storeSelectorModalRef);
    } else {
      disableFocusLock(focusLockEventRef.current);
    }
  }, [isOpen]);
  const loadMoreStores = () => {
    var _a;
    const storeListParent = document.querySelector(`.${PREFIX}-store-selector-flyout__body`);
    const storeListElement = storeListParent == null ? void 0 : storeListParent.firstElementChild;
    if (((_a = storeListElement == null ? void 0 : storeListElement.lastElementChild) == null ? void 0 : _a.getBoundingClientRect().y) < (storeListParent == null ? void 0 : storeListParent.clientHeight) && !isMapView) {
      setCurrentPage(storeListElement.children.length);
      setHasMoreStores(true);
    }
  };
  const onSelectHandler = (selectedValue) => {
    filterStoreList == null ? void 0 : filterStoreList(selectedValue.id);
  };
  useEffect(() => {
    if (isHeaderStoreLocator || isStoresApiFailed) {
      const overFlowHiddenClass = "modal-open-not-scroll";
      document.body.classList.add(overFlowHiddenClass);
      return () => {
        document.body.classList.remove(overFlowHiddenClass);
      };
    }
    return void 0;
  }, [isHeaderStoreLocator, isStoresApiFailed]);
  useEffect(() => {
    var _a;
    if (isInMiniPDPFlyout) {
      const overFlowHiddenClass = "modal-open-store-selector-not-scroll";
      const miniPDPFlyoutClass = `${PREFIX}-store-selector-flyout__container`;
      const miniPDPFlyout = (_a = document.querySelector(`.${miniPDPFlyoutClass}`)) == null ? void 0 : _a.parentElement;
      miniPDPFlyout == null ? void 0 : miniPDPFlyout.classList.add(overFlowHiddenClass);
      return () => {
        miniPDPFlyout == null ? void 0 : miniPDPFlyout.classList.remove(overFlowHiddenClass);
      };
    }
    return void 0;
  }, [isInMiniPDPFlyout]);
  const setFilters = () => {
    if (storeFilters) {
      return storeFilters.map((filter) => {
        if (filter.id === selectedFilter) {
          filter.selected = true;
        } else {
          filter.selected = false;
        }
        return filter;
      });
    } else {
      return [];
    }
  };
  const dropdownProps = {
    dropdownTitle: filterByLabel,
    dropdownList: setFilters(),
    dropdownIcon: "ct-chevron-down",
    size: "default",
    dropdownId: "Filter",
    selectedItem: onSelectHandler,
    filterTitle: filterByLabel,
    isFilter: true,
    type: "primary"
  };
  const modalClassName = `${PREFIX}-flyout-modal-overlay`;
  const previousElement = document.querySelector(`button[${previousElementName}`);
  const accessibilityHandler = () => {
    if (previousElement && previousElement.hasAttribute(previousElementName)) {
      modalAccessibilityHandler({ modalOpen: false, modalClassName });
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  const modifiedCloseFlyout = () => {
    closeFlyout == null ? void 0 : closeFlyout();
    accessibilityHandler();
  };
  const redirectToGoogleMaps = (address) => {
    return generateGoogleMapOnAddress(`${address.line1 ?? ""} ${address.line2 ?? ""},${address.postalCode ?? ""}`);
  };
  const formatAddress = (line1, line2) => {
    const comma = isHeaderStoreLocator || isStoresApiFailed ? "," : "";
    return `${line1 ?? ""} ${line2 ?? ""}${comma}`;
  };
  const switchStoreViewlist = () => {
    setIsMapView(false);
    const selectedViewLabel = listViewLabel;
    setStoreDisplay == null ? void 0 : setStoreDisplay(selectedViewLabel);
    onStoreViewChangesAnalytics == null ? void 0 : onStoreViewChangesAnalytics(isMapView);
    const updatedClickHandler = {
      ...markerClickHandler,
      isSelected: false,
      selectedIndex: null
    };
    markerClickHandler.isSelected = false;
    setMarkerClickHandler(updatedClickHandler);
  };
  const switchStoreViewMap = () => {
    setIsMapView(true);
    const selectedViewLabel = mapViewLabel;
    setStoreDisplay == null ? void 0 : setStoreDisplay(selectedViewLabel);
    onStoreViewChangesAnalytics == null ? void 0 : onStoreViewChangesAnalytics(isMapView);
    const updatedClickHandler = {
      ...markerClickHandler,
      isSelected: false,
      selectedIndex: null
    };
    markerClickHandler.isSelected = false;
    setMarkerClickHandler(updatedClickHandler);
  };
  const renderListAndMapComponent = () => {
    return /* @__PURE__ */ jsx(
      ToggleTabs,
      {
        firstBtnLabel: listViewLabel,
        secondBtnLabel: mapViewLabel,
        firstBtnAriaLabel: a11yListViewAriaLabel,
        secondBtnAriaLabel: a11yMapViewAriaLabel,
        onFirstBtnClick: switchStoreViewlist,
        onSecondBtnClick: switchStoreViewMap,
        firstBtnIconType: "ct-list-view-dark",
        secondBtnIconType: "ct-map-marker-black",
        showIcon: !isMobile2
      }
    );
  };
  const renderInventoryStock = (store, inStockQty) => {
    const dcQuantity = getDCQuantity(store, sku);
    const isEnoughQty = dcQuantity && dcQuantity > magicNumber.ZERO;
    const isInStockOnline = inStockDCOnlyEnabled && isEnoughQty || enableInStockOnlineInFlyout && isEnoughQty;
    const bulletType = inStockQty > magicNumber.ZERO || isInStockOnline ? "availability-bullet--in-stock" : "availability-bullet--out-of-stock";
    const stockLabel = isInStockOnline ? inStockOnlineLabel : outOfStockLabel;
    const label = inStockQty > magicNumber.ZERO ? replaceStrWithDynamicVal(inStockLabel, inStockQty) : stockLabel;
    return /* @__PURE__ */ jsx(Tag, { type: "availability-bullet", subType: bulletType, children: label });
  };
  const renderIndentedText = (store, index2) => {
    return !isMobile2 ? /* @__PURE__ */ jsx("div", { className: `${storeClassName}__item__number`, children: preferredStore ? (
      // eslint-disable-next-line sonar/no-nested-conditional
      isPreferredStore(store) ? /* @__PURE__ */ jsx(Icon, { type: "ct-star", size: "md", path }) : `${index2}.`
    ) : `${index2 + magicNumber.ONE}.` }) : null;
  };
  const renderUnIndentedPreferredStar = (store, index2) => {
    return isPreferredStore(store) && /* @__PURE__ */ jsx("div", { className: `${storeClassName}__item__preferred-store-label`, children: !index2 && /* @__PURE__ */ jsxs(Fragment, { children: [
      (!indentPreferredStart || isMobile2) && /* @__PURE__ */ jsx(Icon, { type: "ct-star", size: "md", path }),
      preferredStoreLabel
    ] }) });
  };
  const closeStoreDetailsModal = () => {
    const updatedClickHandler = {
      ...markerClickHandler,
      isSelected: false,
      selectedIndex: null
    };
    setMarkerClickHandler(updatedClickHandler);
  };
  const renderUnIndentedPreferredStarMapView = (store, index2) => {
    const showPreferedStoreLabel = isPreferredStore(store) && index2 > unavailableIndex;
    return /* @__PURE__ */ jsxs("div", { className: `${storeClassName}__item__preferred-store-map-view`, children: [
      showPreferedStoreLabel && /* @__PURE__ */ jsxs(Fragment, { children: [
        (!indentPreferredStart || isMobile2) && /* @__PURE__ */ jsx(Icon, { type: "ct-star", size: "md", path }),
        preferredStoreLabel
      ] }),
      markerClickHandler.isSelected && /* @__PURE__ */ jsx(
        "button",
        {
          className: `${componentClassName2}__close-btn-map-view`,
          onClick: closeStoreDetailsModal,
          "aria-label": closeIconLabel,
          title: closeBtnLabel,
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg", path })
        }
      )
    ] });
  };
  const setPreferredStoreButton = (event, store, isClosed) => {
    event.stopPropagation();
    event.preventDefault();
    setPreferredStore(store, isClosed);
    accessibilityHandler();
    const currentStore = document.querySelector(`.${selectedstoreClassName}`);
    if (currentStore) {
      currentStore.classList.remove(selectedstoreClassName);
    }
    document.getElementById(store.id.toString()).classList.add(selectedstoreClassName);
  };
  const renderStoreName = (store, index2) => {
    return !isHeaderStoreLocator && !checkNotNullAndUndefined(showFilter) ? /* @__PURE__ */ jsx(
      "button",
      {
        onClick: () => storeDetailClickHandler(store),
        className: `${storeClassName}__item__name main-store-link main-link-${index2}`,
        children: store.name
      }
    ) : /* @__PURE__ */ jsx("h3", { className: `${storeClassName}__item__name`, id: `store-${index2}`, children: store.name });
  };
  const renderIndividualStoreDetails = (store, timeText, address, isClosed, closeOrOpenTime, index2) => {
    var _a;
    return /* @__PURE__ */ jsxs("div", { className: `${storeClassName}__item__label card-${index2}`, "data-component": "card", children: [
      !!closeOrOpenTime && /* @__PURE__ */ jsxs("div", { className: `${storeClassName}__item__time`, children: [
        /* @__PURE__ */ jsx("span", { children: isClosed ? closeLabel : openLabel }),
        " . ",
        timeText
      ] }),
      /* @__PURE__ */ jsx("div", { className: `${storeClassName}__item__address`, children: /* @__PURE__ */ jsxs(
        "a",
        {
          className: `${storeClassName}__item__address__line`,
          href: redirectToGoogleMaps(address),
          target: inFlyoutLinkTarget,
          "data-link-value": address.line1,
          children: [
            /* @__PURE__ */ jsx("span", { className: "sr-only", "aria-labelledby": `store-${index2}` }),
            formatAddress(address.line1, address.line2),
            !isHeaderStoreLocator && !isStoresApiFailed && /* @__PURE__ */ jsx("br", {}),
            address.town,
            ", ",
            (_a = address.region) == null ? void 0 : _a.name,
            ", ",
            address.postalCode
          ]
        }
      ) }),
      address.phone && /* @__PURE__ */ jsx(
        "a",
        {
          href: `tel://${address.phone}`,
          "aria-label": `${a11yTelephoneAriaLabel} ${formatedPhoneNumberAccessibility(address.phone)}`,
          className: `${storeClassName}__item__phone-no`,
          target: inFlyoutLinkTarget,
          "data-link-value": address.phone,
          children: getFormattedPhoneNumber(address == null ? void 0 : address.phone)
        }
      ),
      /* @__PURE__ */ jsx(
        "a",
        {
          href: `${store.url}`,
          className: `${storeClassName}__item__view-stores ${storeClassName}__item__view-stores-link`,
          "data-link-value": storeDetailsCTALabel,
          "dap-wac-link": "true",
          "dap-wac-loc": viewStoreDetailsLinkLocation(),
          "dap-wac-value": "View Store Details",
          target: inFlyoutLinkTarget,
          "aria-label": `${storeDetailsCTALabel}, ${store.name}`,
          children: storeDetailsCTALabel
        }
      )
    ] });
  };
  const showStoreTime = (closed, closingTime, openingTime) => {
    return closed ? replaceStrWithDynamicVal(openingAtLabel, openingTime == null ? void 0 : openingTime.formattedHour) : replaceStrWithDynamicVal(closesAtLabel, closingTime == null ? void 0 : closingTime.formattedHour);
  };
  const isPreferredStore = (store) => {
    return Boolean(preferredStoreId === store.id);
  };
  const renderStoreDetails = (store, index2, timeText, address, inStockQty, isClosed, closeOrOpenTime) => {
    const showPreferredStoreButton = baseStoreId ? baseStoreId === store.baseStoreId : true;
    const showPreferedStoreLabel = isPreferredStore(store) && indentPreferredStart && !isMobile2 && !index2;
    return /* @__PURE__ */ jsx("div", { className: `${storeClassName}__item__content`, children: /* @__PURE__ */ jsxs(Fragment, { children: [
      showPreferedStoreLabel && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${storeClassName}__item__preferred-store-label`,
          role: "alert",
          "aria-live": "assertive",
          children: `${preferredStoreLabel}`
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: `${storeClassName}__availability`, children: [
        renderStoreName(store, index2),
        isShowAvailability && renderInventoryStock(store, inStockQty)
      ] }),
      /* @__PURE__ */ jsxs("div", { className: `${storeClassName}__store-details`, children: [
        renderAllItemInStock(store),
        renderIndividualStoreDetails(store, timeText, address, isClosed, closeOrOpenTime, index2)
      ] }),
      !store.onlineOrdering && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__store-status`, children: [
        /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, { type: "ct-notification-caution-stroked", size: "md" }) }),
        /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__store-status-message`, children: onlineOrdersNotAcceptedMsg })
      ] }),
      isPreferredStore(store) ? renderAutoAppointmentButton == null ? void 0 : renderAutoAppointmentButton(store.id) : showPreferredStoreButton && /* @__PURE__ */ jsx("div", { className: `${storeClassName}__item__set-preferred-store`, children: /* @__PURE__ */ jsx(
        Button,
        {
          size: "mini",
          type: "primary",
          onClick: (e) => setPreferredStoreButton(e, store, isClosed),
          children: setPreferredStoreCTALabel
        }
      ) })
    ] }) });
  };
  const storeDetailClickHandler = (store) => {
    store.isSelected = markerClickHandler.isSelected;
    store.selectedIndex = markerClickHandler.selectedIndex;
    setMarkerClickHandler(store);
  };
  const renderStoreListItem = (store, index2, timeText, address, inStockQty, isClosed, closeOrOpenTime) => {
    const selStoreClass = store.isSelected ? `${PREFIX}-store-selector-flyout__stores-list--selected` : "";
    return /* @__PURE__ */ jsx(
      "li",
      {
        id: store.id.toString(),
        ref: (ref) => {
          storesRefArray.current[index2] = ref;
        },
        className: `${storeClassName}__item ${selStoreClass}`,
        children: /* @__PURE__ */ jsxs("div", { className: `${storeClassName}__item__wrapper`, children: [
          indentPreferredStart && renderIndentedText(store, index2),
          isMapView ? renderUnIndentedPreferredStarMapView(store, index2) : (!indentPreferredStart || isMobile2) && renderUnIndentedPreferredStar(store, index2),
          renderStoreDetails(store, index2, timeText, address, inStockQty, isClosed, closeOrOpenTime)
        ] })
      },
      store.id
    );
  };
  const getInventory = (store, selectedSku) => {
    var _a, _b, _c;
    if (isStaggeredProduct) {
      const staggeredSkusList = staggeredSkus == null ? void 0 : staggeredSkus.map((strgSku) => {
        return strgSku.code;
      });
      const inventoryStaggeredSkus = (_a = store == null ? void 0 : store.inventory) == null ? void 0 : _a.map((storeInv) => {
        if (storeInv == null ? void 0 : storeInv.Quantity) {
          return storeInv.sku;
        }
      });
      if (!!(staggeredSkusList == null ? void 0 : staggeredSkusList.every((skuValue) => inventoryStaggeredSkus == null ? void 0 : inventoryStaggeredSkus.includes(skuValue)))) {
        return (_b = store == null ? void 0 : store.inventory) == null ? void 0 : _b.find((inv) => inv.sku === staggeredSkusList[0] && inv.Quantity);
      }
    }
    return (_c = store == null ? void 0 : store.inventory) == null ? void 0 : _c.find((inv) => inv.sku === selectedSku);
  };
  const getInStockQty = (store, selectedSku) => {
    const storeInventory = getInventory(store, selectedSku);
    return storeInventory == null ? void 0 : storeInventory.Quantity;
  };
  const getDCQuantity = (store, selectedSku) => {
    var _a;
    const storeInventory = getInventory(store, selectedSku);
    return (storeInventory == null ? void 0 : storeInventory.orderable) ? (_a = storeInventory == null ? void 0 : storeInventory.Corporate) == null ? void 0 : _a.Quantity : magicNumber.ZERO;
  };
  const renderMaxNumberOfStores = (store, index2) => {
    const inStockQty = getInStockQty(store, sku);
    const { address } = store || {};
    const weekdayHours = getStoreTimings(store);
    const { closingTime, closed } = weekdayHours;
    const nextWeekDayHours = getNextDayStoreTimings(store);
    const { openingTime } = (/* @__PURE__ */ new Date()).getHours() < afternoonHours ? weekdayHours : nextWeekDayHours;
    const storeOpenOrCloseLabel = closed ? openingTime == null ? void 0 : openingTime.formattedHour : closingTime == null ? void 0 : closingTime.formattedHour;
    const timeText = showStoreTime(closed, closingTime, openingTime);
    return store && renderStoreListItem(store, index2, timeText, address, inStockQty, closed, storeOpenOrCloseLabel);
  };
  const rendersNearbyStoreComp = (stores) => {
    return /* @__PURE__ */ jsx("ul", {
      className: `${storeClassName}`,
      // eslint-disable-next-line sonar/function-return-type
      children: stores.map((store, index2) => {
        return store && Object.keys(store).length && renderMaxNumberOfStores(store, index2);
      })
    });
  };
  const renderInvalidAddressWarningMessage = () => {
    return isInputInValid ? /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__error-message`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "lg" }),
      /* @__PURE__ */ jsx(
        "p",
        {
          className: `${PREFIX}-body-sm ${componentClassName2}__error-message__text`,
          role: "alert",
          "aria-atomic": "true",
          children: searchInputErrorMsg
        }
      )
    ] }) : null;
  };
  const renderStoreView = () => {
    return !isHeaderStoreLocator && (showFilter !== void 0 ? /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__header__toggle-btn-show-filter`, children: /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__header__toggle-options ${toggleButtonClassName}`, children: [
      showFilter && /* @__PURE__ */ jsx(Dropdown, { ...dropdownProps }),
      isMobile2 && renderListAndMapComponent()
    ] }) }) : /* @__PURE__ */ jsx(
      "div",
      {
        className: isMapView || !isShowEmptyStoresToggle ? `${componentClassName2}__header__toggle-btn ${componentClassName2}__header__toggle-btn_mapview` : `${componentClassName2}__header__toggle-btn`,
        children: /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__header__toggle-options`, children: renderListAndMapComponent() })
      }
    ));
  };
  const renderViewMoreStores = () => {
    return (isHeaderStoreLocator || isInMiniPDPFlyout) && /* @__PURE__ */ jsxs("div", { className: `${storeClassName}__item__wrapper ${storeClassName}__item__wrapper__see-more`, children: [
      /* @__PURE__ */ jsx(
        "a",
        {
          className: `${storeClassName}__item__view-stores ${storeClassName}__item__view-stores-link`,
          href: seeMoreCTAURL,
          onClick: () => viewMoreAnalytics == null ? void 0 : viewMoreAnalytics(seeMoreCTALabel),
          "data-link-value": seeMoreCTALabel,
          target: inFlyoutLinkTarget,
          "dap-wac-link": "true",
          "dap-wap-loc": "header",
          "dap-wac-value": "View More Stores",
          children: seeMoreCTALabel
        }
      ),
      /* @__PURE__ */ jsx(Icon, { path, size: "md", type: "ct-chevron-right" })
    ] });
  };
  const onChangeButtonAction = () => {
    if (showInStock) {
      setShowInStock(!showInStock);
      fetchNearbyStoresWithAvailability();
    }
  };
  const cartInStoreInventoryErrorDescription = () => {
    const cartErrorDescription = noResultForCartInStoreInventoryDescription.split("[0]");
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("p", { children: [
      cartErrorDescription[0],
      /* @__PURE__ */ jsx(
        Button,
        {
          modifierClass: `${PREFIX}-check-nearby-stores-btn`,
          onClick: onChangeButtonAction,
          type: "tertiary",
          children: wishlistCartOnlyTitle
        }
      ),
      cartErrorDescription[1]
    ] }) });
  };
  const inStoreInventoryErrorDescriptionMsg = () => {
    return isCartPage ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: "no-result-error", children: noResultForCartInStoreInventoryTitle }),
      cartInStoreInventoryErrorDescription()
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: "no-result-error", children: noResultFoundTitle }),
      /* @__PURE__ */ jsx("p", { children: noResultsForInStoreInventoryDescription })
    ] });
  };
  const errorMessage = () => {
    var _a;
    const errorCode = (_a = storeErrorResponse == null ? void 0 : storeErrorResponse.data) == null ? void 0 : _a.errCode;
    if (showInStock) {
      return /* @__PURE__ */ jsx(Fragment, { children: inStoreInventoryErrorDescriptionMsg() });
    }
    if (errorCode === maxRadiusErrorCode) {
      return /* @__PURE__ */ jsx(Fragment, { children: isCartPage ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: "no-result-error", children: noResultForCartTitle }),
        /* @__PURE__ */ jsx("p", { children: noResultForCartDescription })
      ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: "no-result-error", children: noResultForPostalCodeTitle }),
        /* @__PURE__ */ jsx("p", { children: noResultForPostalCodeDescription })
      ] }) });
    } else {
      if (isStoresApiFailed) {
        return null;
      }
    }
  };
  const renderAllItemInStock = (store) => {
    return isCartPage && store.allItemsInStock && /* @__PURE__ */ jsxs("div", { className: `${storeClassName}__item__all-in-stock`, children: [
      /* @__PURE__ */ jsx(Cart, { isCartStoreSelectorModal: true }),
      /* @__PURE__ */ jsx("span", { className: `${storeClassName}__item__all-in-stock__text`, children: allItemsInStockMsg })
    ] });
  };
  const getStoresWithInventoryOrPreferred = () => {
    if (isArrayEmpty(storesWithInventoryOrPreferred)) {
      allStores.forEach((store) => {
        if (store.hasOwnProperty(allItemsInStock)) {
          store.allItemsInStock && storesWithInventoryOrPreferred.push(store);
        } else {
          if (!!getInStockQty(store, sku)) {
            storesWithInventoryOrPreferred.push(store);
          }
        }
      });
    }
    return storesWithInventoryOrPreferred;
  };
  const getStoresIdsWithInventoryOrPreferred = () => {
    if (isArrayEmpty(storesIdsWithInventoryOrPreferred)) {
      getStoresWithInventoryOrPreferred().forEach((store) => {
        storesIdsWithInventoryOrPreferred.push(store.id);
      });
    }
    return storesIdsWithInventoryOrPreferred;
  };
  const getStoresLocationWithInventoryOrPreferred = () => {
    if (isArrayEmpty(storesLocationWithInventoryOrPreferred)) {
      const storesId = getStoresIdsWithInventoryOrPreferred();
      newMapProps == null ? void 0 : newMapProps.locations.forEach((location) => {
        if (storesId.includes(location.id)) {
          storesLocationWithInventoryOrPreferred.push(location);
        }
      });
    }
    return storesLocationWithInventoryOrPreferred;
  };
  const filterStores = (stores) => {
    if (showInStock) {
      return getStoresWithInventoryOrPreferred();
    }
    return stores;
  };
  const filterMapLocations = (mapProps) => {
    mapProps.locations = isShowEmptyStoresToggle && showInStock ? getStoresLocationWithInventoryOrPreferred() : allStoresLocations;
    return mapProps;
  };
  const renderStoreDetailsModal = () => {
    const storeLocatorComp = document.querySelector(`.${PREFIX}-store-locator-comp`);
    if (storeLocatorComp) {
      window.scroll({
        top: storeLocatorComp.offsetTop,
        behavior: "smooth"
      });
    }
    return /* @__PURE__ */ jsx(
      StoreDetailsModal,
      {
        renderMaxNumberOfStores,
        storeList: allStores,
        markerClickHandler
      }
    );
  };
  const shouldShowSpinner = () => {
    var _a;
    return !((_a = storeErrorResponse == null ? void 0 : storeErrorResponse.data) == null ? void 0 : _a.errCode) && !isHeaderStoreLocator && isPdpPageType;
  };
  useEffect(() => {
    if (storeCloseByRef.current) {
      storeCloseByRef.current.innerHTML = " ";
      setTimeout(() => {
        if (storeCloseByRef.current) {
          storeCloseByRef.current.innerHTML = replaceStrWithDynamicVal(
            a11yStoresAvailableLabel,
            storeList.length
          );
        }
      }, magicNumber.ONEHUNDREDFIFTY);
    }
  }, [storeList, a11yStoresAvailableLabel]);
  const noResultErrorMessage = () => {
    return /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__no-results`, children: inStoreInventoryErrorDescriptionMsg() });
  };
  const renderNearByStoreListOrNoResultsComp = () => {
    if (isArrayNotEmpty(storeList)) {
      if (!isMapView) {
        return showInStock && isArrayEmpty(getStoresWithInventoryOrPreferred()) ? noResultErrorMessage() : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${componentClassName2}__list-view`,
            onScroll: loadMoreStores,
            "data-testid": "contentModal",
            children: [
              rendersNearbyStoreComp(filterStores(storeList)),
              renderViewMoreStores()
            ]
          }
        ) });
      } else {
        return showInStock && isArrayEmpty(getStoresWithInventoryOrPreferred()) ? noResultErrorMessage() : /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__body`, onScroll: loadMoreStores, children: [
          /* @__PURE__ */ jsx(
            Map$1,
            {
              ...filterMapLocations(newMapProps),
              setMarkerClickHandler,
              setPreferredStoreOnMapIconClicked,
              a11yMapLocateMeButtonLabel
            }
          ),
          markerClickHandler.isSelected && markerClickHandler.selectedIndex > unavailableIndex ? renderStoreDetailsModal() : null
        ] });
      }
    } else {
      return /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__no-results`, children: [
        shouldShowSpinner() ? /* @__PURE__ */ jsx(Spinner, {}) : null,
        errorMessage()
      ] });
    }
  };
  const renderHeaderText = () => {
    return isStoreLocator ? /* @__PURE__ */ jsx("h1", { "data-testId": titleDataTetsId, className: `${componentClassName2}__header__title`, children: visibleTitle }) : /* @__PURE__ */ jsx("h2", { "data-testId": titleDataTetsId, className: `${componentClassName2}__header__title`, children: visibleTitle });
  };
  const isSelected = markerClickHandler == null ? void 0 : markerClickHandler.isSelected;
  useEffect(() => {
    if (isMobile2 && isMapView) {
      const locator = document.querySelector(`.${PREFIX}-store-selector-flyout__body`);
      const locatorHeader = document.querySelector(`.${PREFIX}-store-selector-flyout__header`);
      const locatorHeaderHeight = (locatorHeader == null ? void 0 : locatorHeader.clientHeight) || 0;
      const detailsModal = document.querySelector(`.${PREFIX}-store-details-modal`);
      const detailsModalHeight = detailsModal ? detailsModal.clientHeight : 0;
      const mapHeight = window.innerHeight - locatorHeaderHeight - detailsModalHeight;
      const map = document.querySelector(`.${PREFIX}-map`);
      map == null ? void 0 : map.setAttribute("style", `height:${mapHeight}px`);
      locator == null ? void 0 : locator.setAttribute("style", `height:${mapHeight + detailsModalHeight}px`);
    }
  }, [isMobile2, isMapView, isSelected]);
  const [isInputInValid, setIsInputInValid] = useState(false);
  const googleAutoCompleteProps = {
    a11ySearchIconAriaLabel,
    a11ySuggestionResultAvailable,
    searchInputPH,
    fetchNearbyStoreListOnSearch,
    inputMaxLength: addressMaxLength,
    setIsInputInValid,
    windowRef: window,
    searchStoreAnalyticsHandler
  };
  const getSearchBarStyle = () => {
    if (pageType === pageTypes$1.storeLocator) {
      return `${componentClassName2}__header__search-bar ${PREFIX}-search-column`;
    } else {
      return `${componentClassName2}__header__search-bar`;
    }
  };
  const toggleStoreRef = useRef(false);
  const renderToggleStore = () => {
    const toggleHandler = () => {
      var _a, _b;
      setShowInStock((prevState) => !prevState);
      toggleStoreRef.current = !toggleStoreRef.current;
      let storesLength;
      if (((_a = getStoresWithInventoryOrPreferred()) == null ? void 0 : _a.length) > magicNumber.ZERO) {
        if (toggleStoreRef.current) {
          storesLength = (_b = getStoresWithInventoryOrPreferred()) == null ? void 0 : _b.length;
        } else {
          storesLength = storeList == null ? void 0 : storeList.length;
        }
        storeCloseByRef.current.innerHTML = replaceStrWithDynamicVal(a11yStoresAvailableLabel, storesLength);
      } else {
        if (toggleStoreRef.current) {
          storeCloseByRef.current.innerHTML = noResultForCartTitle;
        } else {
          storesLength = storeList == null ? void 0 : storeList.length;
          if (storesLength) {
            storeCloseByRef.current.innerHTML = replaceStrWithDynamicVal(
              a11yStoresAvailableLabel,
              storesLength
            );
          }
        }
      }
    };
    return isShowEmptyStoresToggle && !isMapView ? /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__header__in-store-toggle`, children: /* @__PURE__ */ jsx(Switch, { handleInputChange: toggleHandler, label: showInStockFilterLabel, checked: showInStock }) }) : null;
  };
  const errorClass = isStoresApiFailed ? `${PREFIX}-search-error` : `${PREFIX}-search`;
  const showPreferredStoreErrorMsg = () => {
    return !!isStoresApiFailed ? /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__error-block`, children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-warning", size: "md", path }),
      /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__error-block__description`, children: forcePreferredStoreMsg })
    ] }) : null;
  };
  const renderCurrentLocationIcon = () => {
    return !isStoresApiFailed && /* @__PURE__ */ jsx(
      "button",
      {
        className: `${componentClassName2}__map-icon`,
        onClick: setPreferredStoreOnMapIconClicked,
        "aria-label": a11yCurrentLocationCTAAriaLabel,
        children: /* @__PURE__ */ jsx(Icon, { type: "ct-geo-location", size: "lg", path })
      }
    );
  };
  const renderCurrentLocationLink = () => {
    return !isStoresApiFailed && /* @__PURE__ */ jsx(Button, { type: "tertiary", onClick: setPreferredStoreOnMapIconClicked, children: a11yCurrentLocationCTAAriaLabel });
  };
  return /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__container`, ref: storeSelectorModalRef, children: [
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__header`, children: [
      isInMiniPDPFlyout && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__back-btn-container`, children: /* @__PURE__ */ jsxs(
        "button",
        {
          className: `${componentClassName2}__back-btn`,
          onClick: closeFlyout,
          "aria-label": backBtnLabel,
          "dap-wac-link": "true",
          "dap-wac-loc": analyticMiniPDPLocation,
          "dap-wac-value": backBtnLabel,
          children: [
            /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-left", size: "lg" }),
            backBtnLabel
          ]
        }
      ) }),
      /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__header__label`, children: [
        renderHeaderText(),
        showClose && /* @__PURE__ */ jsx(
          "button",
          {
            "data-testid": "close-flyout-btn",
            className: `${componentClassName2}__close-btn`,
            onClick: modifiedCloseFlyout,
            "aria-label": closeIconLabel,
            title: closeBtnLabel,
            children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg", path })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: `${getSearchBarStyle()}`, children: [
        /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__header__autocomplete ${errorClass}`, children: /* @__PURE__ */ jsx(GoogleAutocomplete, { ...googleAutoCompleteProps }) }),
        (!isTablet || isTabletNotOnStoreLocatorPage()) && renderCurrentLocationIcon(),
        isTabletOnStoreLocatorPage() && renderCurrentLocationLink()
      ] }),
      renderInvalidAddressWarningMessage(),
      showPreferredStoreErrorMsg(),
      /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__header__selector-container`, children: [
        renderToggleStore(),
        !isStoresApiFailed && renderStoreView()
      ] })
    ] }),
    /* @__PURE__ */ jsx("span", { className: "sr-only", ref: storeCloseByRef, "aria-live": "polite", "aria-atomic": "true", role: "status" }),
    renderNearByStoreListOrNoResultsComp()
  ] });
};
var MediaTypeValue = /* @__PURE__ */ ((MediaTypeValue2) => {
  MediaTypeValue2["image"] = "image";
  MediaTypeValue2["video"] = "video";
  return MediaTypeValue2;
})(MediaTypeValue || {});
const mediaGalleryClassName = `${PREFIX}-media-gallery`;
const mediaGalleryViewerClassName = `${mediaGalleryClassName}-viewer`;
const staticImageContainerClassName = `${PREFIX}-static_image_container`;
const hideAkamaiViewerImageClassName = "hide_akamai-viewer-image";
const mediaGalleryNoPaddingClassName = "media-gallery-no-padding";
const thumbnailImageCountMobile$1 = 3;
const thumbnailNavWidthMobile = 245;
const thumbnailNavWidthTablet = 346;
const ELEMENT_NOT_FOUND = -1;
const ONE_ELEMENT_LENGTH = 1;
const ALL_MEDIA_SELECTOR = "img, video";
const THUMBNAIL_MEDIA_SELECTOR = `.snapper_nav ${ALL_MEDIA_SELECTOR}`;
const AKAMAI_IMAGE_LOAD_EVENT = "akamai_image_load_event";
const mediaGalleryConstants = {
  minimumImageLength: 1,
  // minimum number of images length
  thumbnailPrevArrowClass: `${mediaGalleryViewerClassName}__thumb-prev`,
  thumbnailNextArrowClass: `${mediaGalleryViewerClassName}__thumb-next`,
  thumbnailPlayButtonClass: `${mediaGalleryViewerClassName}__play-icon`,
  playButtonIcon: "ct-play",
  prevArrowIcon: "ct-chevron-left",
  nextArrowIcon: "ct-chevron-right",
  minimumThumbnailCount: 2,
  maximumThumbnailCount: 4,
  defaultStaticImageSize: 1244,
  defaultAkamaiTagname: "akamai-untagged",
  mediaGalleryThumbnailImageWidth: 68,
  limitThreshold: 1e6,
  mediaGalleryViewerClassNameFullscreen: `${PREFIX}-media-gallery-viewer--fullscreen`
};
const isMobile = window.innerWidth <= BREAKPOINTS.tabletMaxWidth;
const thumbnailNavWidth = isMobile ? thumbnailNavWidthMobile : thumbnailNavWidthTablet;
const setThumbnailHeightMobile = (thumbnailDiv) => {
  const navInner = thumbnailDiv && thumbnailDiv.querySelector(".snapper_nav_inner");
  navInner && navInner.setAttribute("style", `width:${thumbnailNavWidth}px`);
};
const videoGalleryViewerClassName = `${PREFIX}-video-gallery-viewer`;
const thumbnailImageCountMobile = 1;
const thumbnailImageCountTablet = 3;
const thumbnailImageCountTabletLandscape = 4;
const thumbnailImageCountDesktop = 6;
const videoGalleryConstants = {
  thumbnailPrevArrowClass: `${videoGalleryViewerClassName}__thumb-prev`,
  thumbnailNextArrowClass: `${videoGalleryViewerClassName}__thumb-next`,
  thumbnailPlayButtonClass: `${videoGalleryViewerClassName}__play-icon`,
  playButtonIcon: "ct-play",
  videoPlayButtonClass: `${videoGalleryViewerClassName}__play-icon`
};
const { prevArrowIcon, nextArrowIcon, minimumImageLength, minimumThumbnailCount } = mediaGalleryConstants;
let thumbnailScrollWidth = 0;
const getPrevArrowButton = (thumbnailPrevArrowClass, a11yCarouselPreviousLabel) => {
  return {
    className: thumbnailPrevArrowClass,
    ariaLabel: a11yCarouselPreviousLabel,
    type: prevArrowIcon,
    size: "md"
  };
};
const getNextArrowButton = (thumbnailNextArrowClass, a11yCarouselNextLabel) => {
  return {
    className: thumbnailNextArrowClass,
    ariaLabel: a11yCarouselNextLabel,
    type: nextArrowIcon,
    size: "md"
  };
};
const getImagePath = (icon, path) => {
  return !path ? `#${icon}` : `${path}#${icon}`;
};
const thumbnailArrowClick = (isPrevArrowClicked, thumbnailImageCount, mediaClassName, mediaGalleryClick) => {
  const snapperNavEle = document.querySelector(`.${mediaClassName} .focused .snapper_nav_inner`);
  const navInner = snapperNavEle || document.querySelector(`.${mediaClassName} .snapper_nav_inner`);
  const navInnerWidth = navInner.clientWidth;
  const thumbnailInnerDiv = document.querySelector(`.${mediaClassName} .snapper_nav_inner a`);
  const thumbnailImageMargin = window.getComputedStyle(thumbnailInnerDiv).getPropertyValue("margin-right");
  const thumbnailImageMarginValue = parseFloat(thumbnailImageMargin) - (thumbnailImageCount === minimumImageLength ? -1 : minimumThumbnailCount);
  const thumbnailNavWidth2 = navInner.scrollWidth - thumbnailImageMarginValue;
  if (isPrevArrowClicked) {
    const scrollToThumbnail = thumbnailScrollWidth < navInnerWidth ? 0 : thumbnailScrollWidth - navInnerWidth - thumbnailImageMarginValue;
    thumbnailScrollWidth = thumbnailScrollWidth <= 0 ? thumbnailNavWidth2 - navInnerWidth + thumbnailImageMarginValue : scrollToThumbnail;
  } else {
    const nextThumbScrollValue = thumbnailScrollWidth + navInnerWidth + thumbnailImageMarginValue;
    thumbnailScrollWidth = nextThumbScrollValue >= thumbnailNavWidth2 ? 0 : nextThumbScrollValue;
  }
  navInner.scrollTo({
    left: Math.round(thumbnailScrollWidth),
    behavior: "smooth"
  });
  mediaGalleryClick && mediaGalleryClick();
};
const insertDynamicButtons = (dynamicButton) => {
  const { elementRef, position, className: className2, ariaLabel, type, iconHrefLink, buttonId, size } = dynamicButton;
  elementRef.insertAdjacentHTML(
    position,
    `<button class=${className2} aria-label=${ariaLabel} id=${buttonId}> 
            <svg class='${PREFIX}-icon ${PREFIX}-icon-${type} ${PREFIX}-icon--${size}'>
                <use href=${sanitizeStringContent(iconHrefLink)} />
            </svg>
        </button>`
  );
};
const addNavigationArrowButtons = (elementRef, leftArrowId, rightArrowId, prevArrowHrefLink, nextArrowHrefLink, a11yCarouselPreviousLabel, a11yCarouselNextLabel, thumbnailPrevArrowClass, thumbnailNextArrowClass) => {
  const prevArrowButton = getPrevArrowButton(thumbnailPrevArrowClass, a11yCarouselPreviousLabel);
  const nextArrowButton = getNextArrowButton(thumbnailNextArrowClass, a11yCarouselNextLabel);
  const thumbnailArrowButtons = [
    Object.assign(prevArrowButton, {
      elementRef,
      position: "afterbegin",
      iconHrefLink: prevArrowHrefLink,
      buttonId: leftArrowId
    }),
    Object.assign(nextArrowButton, {
      elementRef,
      position: "beforeend",
      iconHrefLink: nextArrowHrefLink,
      buttonId: rightArrowId
    })
  ];
  thumbnailArrowButtons.forEach((arrowButtons) => insertDynamicButtons({ ...arrowButtons }));
};
const getMediaIfTagExist = (productImages, tagValue) => {
  return productImages == null ? void 0 : productImages.filter((image) => {
    var _a;
    return (_a = image.tags) == null ? void 0 : _a.includes(tagValue);
  });
};
const getMediaIfUrlExist = (productImages) => {
  return productImages == null ? void 0 : productImages.filter((media) => !!media.url);
};
const checkIfMediaSetExist = (tagValue, selectedProductCode, isAutomotive, productImages, productDataCode) => {
  const selectedTag = isAutomotive ? selectedProductCode : tagValue;
  const filteredImagesArr = getMediaIfTagExist(productImages, selectedTag);
  const filteredProductLevelImagesArr = getMediaIfTagExist(productImages, productDataCode);
  const mediaSetExist = getMediaIfUrlExist(filteredImagesArr);
  const productLevelMediaSetExist = getMediaIfUrlExist(filteredProductLevelImagesArr);
  return !isArrayNotEmpty(mediaSetExist) && !isArrayNotEmpty(productLevelMediaSetExist);
};
const getThumbnailCount = () => {
  const windowInnerWidth = window.innerWidth;
  if (windowInnerWidth > BREAKPOINTS.tabletMaxWidth) {
    return thumbnailImageCountDesktop;
  }
  if (windowInnerWidth >= BREAKPOINTS.tabletLandscape) {
    return thumbnailImageCountTabletLandscape;
  }
  if (windowInnerWidth >= BREAKPOINTS.tabletPortrait) {
    return thumbnailImageCountTablet;
  }
  return thumbnailImageCountMobile;
};
const customizeAkamai = (akamai) => {
  const activeItemAttributes = akamai.Carousel.prototype._activeItemAttributes;
  akamai.Carousel.prototype._activeItemAttributes = function() {
    activeItemAttributes.call(this);
    const $img = this._$el.find(".snapper_item").eq(this.getIndex()).find("img");
    if (!$img.attr("src")) {
      const src2 = $img.attr("data-src");
      const srcset = $img.attr("data-srcset");
      const alt = $img.attr("data-alt");
      $img.attr({ src: src2, srcset, alt });
      $img.on("load", () => {
        const akamaiImageLoadEvent = new CustomEvent(AKAMAI_IMAGE_LOAD_EVENT);
        window.dispatchEvent(akamaiImageLoadEvent);
      });
    }
  };
  const magnifierRender = akamai.Magnifier.render;
  akamai.Magnifier.render = function(imageData, options) {
    const snapperItemInnerHtml = magnifierRender(imageData, options);
    if (!snapperItemInnerHtml.includes("data-src") && !imageData.isSingleImage) {
      return snapperItemInnerHtml.replace("src=", 'src="" data-src=').replace("srcset=", 'srcset="" data-srcset=').replace("alt=", 'alt="" data-alt=');
    }
    return snapperItemInnerHtml;
  };
  const viewerTrigger = akamai.Viewer.prototype._trigger;
  akamai.Viewer.prototype._trigger = function(eventName) {
    const spinnerContainerClass = `${PREFIX}-spinner-container`;
    const addedSpinners = document.querySelectorAll(`.${spinnerContainerClass}`);
    if (!addedSpinners.length) {
      const snapperImgs = document.querySelectorAll(".snapper_item img");
      snapperImgs.forEach((img) => {
        if (img.getAttribute("src")) {
          return;
        }
        const spinnerContainer = document.createElement("div");
        spinnerContainer.className = spinnerContainerClass;
        const root = ReactDOM.createRoot(spinnerContainer);
        root.render(/* @__PURE__ */ jsx(Spinner, {}));
        img.before(spinnerContainer);
        img.addEventListener("load", function() {
          spinnerContainer.remove();
        });
        img.addEventListener("error", function(event) {
          const srcValue = event.currentTarget.getAttribute("src");
          if (srcValue) {
            spinnerContainer.remove();
          }
        });
      });
    }
    return viewerTrigger.call(this, eventName);
  };
  akamai.Viewer.prototype.switchTag = function(tag) {
    const tags = this.getTags();
    const tagEscapedValue = akamai.Util.escapeJSONVals(tag);
    if (tags.indexOf(tagEscapedValue) === ELEMENT_NOT_FOUND) {
      akamai.Util.log(`tag: ${tag} is not present in the data for this viewer`, "error");
      return;
    }
    const selector = `[${this.constructor._tagAttr}="${tag}"]`;
    const $taggedViewer = this._$el.find(selector);
    if (!$taggedViewer.length) {
      const $currViewer = this._$el.find(`[${this.constructor._tagAttr}]`);
      const options = this._resolveBreakpointOptions();
      const carouselOptions = akamai.Viewer._extendCarouselOptions(options);
      const tagImages = this._tagMapping[tagEscapedValue];
      const tagSingleImage = tagImages.length === ONE_ELEMENT_LENGTH;
      if (tagSingleImage) {
        tagImages[0].isSingleImage = true;
      }
      const $markup = window.$(this.constructor._renderTag(tagImages, carouselOptions, true));
      const mediaSelector = tagSingleImage ? ALL_MEDIA_SELECTOR : THUMBNAIL_MEDIA_SELECTOR;
      const $loadables = $markup.find(mediaSelector);
      const loadableCount = $loadables.length;
      let loaded = 0;
      $markup.css("display", "none");
      $loadables.bind(
        "load loadedmetadata",
        (function() {
          if (++loaded !== loadableCount) {
            return;
          }
          $loadables.unbind("load loadedmetadata");
          const carousels = akamai.Carousel.createMany($markup[0], carouselOptions);
          carousels.forEach(function(carousel) {
            carousel.goto(carousel.getIndex());
          });
          if (this._options.carousel.removeOnTagSwitch) {
            $currViewer.remove();
            this._carousels.pop();
          }
          this._carousels = this._carousels.concat(carousels);
          this._showViewer($markup, carousels);
        }).bind(this)
      );
      this._$el.append($markup);
    } else {
      this._showViewer($taggedViewer);
    }
  };
  return akamai;
};
const getDeviceType = () => {
  const userAgent = navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent) ? deviceTypes.TABLET : (
    // eslint-disable-next-line sonar/no-nested-conditional
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      userAgent
    ) ? deviceTypes.MOBILE : deviceTypes.DESKTOP
  );
};
const MediaGalleryViewer = (props) => {
  const {
    inImageBadgePriorities,
    productImages,
    windowRef,
    hostNames,
    path,
    a11yCarouselNextLabel,
    a11yCarouselPreviousLabel,
    thumbnailImageCount,
    mediaGalleryClick,
    selectedVariant,
    selectedVariantId,
    selectedProductCode,
    buyboxHeight,
    productDataCode,
    productDataBadges,
    isAutomotive,
    fullscreenEnable,
    enablePDPZoomEnhancement,
    watchFullScreenLabel,
    setMagnifierOptions,
    enableFasterPdpLogic,
    mobileStaticImageSize,
    desktopStaticImageSize,
    thumbnailImageCountAriaLabel
  } = props;
  const mediaGalleryRef = useRef(null);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
  const [akamaiViewerRef, setAkamaiViewerRef] = useState(null);
  const [isAkamaiCarouselInit, setIsAkamaiCarouselInit] = useState(false);
  const [isCarouselGotoTriggered, setIsCarouselGotoTriggered] = useState(false);
  const [isAkamaiImageLoaded, setIsAkamaiImageLoaded] = useState(false);
  const currentImageSrc = useRef(null);
  const {
    thumbnailPrevArrowClass,
    thumbnailNextArrowClass,
    prevArrowIcon: prevArrowIcon2,
    nextArrowIcon: nextArrowIcon2,
    minimumImageLength: minimumImageLength2,
    minimumThumbnailCount: minimumThumbnailCount2,
    maximumThumbnailCount,
    playButtonIcon,
    thumbnailPlayButtonClass,
    defaultAkamaiTagname,
    mediaGalleryThumbnailImageWidth,
    mediaGalleryViewerClassNameFullscreen,
    defaultStaticImageSize
  } = mediaGalleryConstants;
  const playButton = useMemo(
    () => ({
      className: thumbnailPlayButtonClass,
      type: playButtonIcon,
      size: "md"
    }),
    [thumbnailPlayButtonClass, playButtonIcon]
  );
  const playButtonHrefLink = getImagePath(playButtonIcon, path);
  const variantTag = selectedProductCode || defaultAkamaiTagname;
  const tagValue = isAutomotive ? variantTag : (selectedVariant == null ? void 0 : selectedVariant.toLowerCase()) || variantTag;
  const checkIfTagValueExist = productImages == null ? void 0 : productImages.find((image) => {
    var _a;
    return (_a = image.tags) == null ? void 0 : _a.includes(tagValue);
  });
  const selectedTagValue = !!checkIfTagValueExist ? tagValue : productDataCode;
  const previousSelectedTagValue = usePrevious(selectedTagValue);
  const thumbnailCount = isMobileOrTablet ? thumbnailImageCountMobile$1 : thumbnailImageCount;
  const thumbnailInnerImages = document.querySelectorAll(".snapper_nav_inner a img");
  thumbnailInnerImages.forEach((item, index2) => {
    item.setAttribute(
      "alt",
      `${replaceMultipleStrWithDynamicVal(thumbnailImageCountAriaLabel, [
        index2 + magicNumber.ONE,
        thumbnailInnerImages.length
      ])}`
    );
    item.removeAttribute("title");
  });
  const handleResize = () => {
    setIsMobileOrTablet(window.innerWidth <= BREAKPOINTS.tabletMaxWidth);
    setMediaGalleryHeight();
  };
  const playVideoInFullScreen = () => {
    const video = document.querySelector(
      `.${mediaGalleryViewerClassName} [data-akamai-carousel-item-active] video`
    );
    const svgElement = document.querySelector(
      `.${mediaGalleryViewerClassName} [data-akamai-carousel-item-active] svg`
    );
    svgElement == null ? void 0 : svgElement.classList.add("is-hidden");
    video == null ? void 0 : video.setAttribute("controls", "controls");
    if (video && video.requestFullscreen) {
      void video.requestFullscreen();
      void video.play();
    } else if (video && video.webkitRequestFullScreen) {
      video.webkitRequestFullScreen();
      void video.play();
    } else if (video && video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
      void video.play();
    }
  };
  useGlobalResizeEvent(handleResize);
  const prevArrowHrefLink = getImagePath(prevArrowIcon2, path);
  const nextArrowHrefLink = getImagePath(nextArrowIcon2, path);
  const getLastThumbnailImageMargin = useCallback(
    (thumbnailImageMargin) => {
      const thumbnailMargin = parseFloat(thumbnailImageMargin);
      switch (thumbnailCount) {
        case maximumThumbnailCount:
          return thumbnailMargin - (maximumThumbnailCount + minimumThumbnailCount2);
        // get last image margin in the row for thumbnail count is 4
        case minimumThumbnailCount2:
          return maximumThumbnailCount * minimumThumbnailCount2;
        // get last image margin in the row for thumbnail count is 2
        case minimumImageLength2:
          return minimumThumbnailCount2;
        // get last image margin in the row for thumbnail count is 1
        default:
          return thumbnailMargin / minimumThumbnailCount2;
      }
    },
    [maximumThumbnailCount, minimumImageLength2, minimumThumbnailCount2, thumbnailCount]
  );
  const addVideoPlayButton = useCallback(
    (elementRef, position) => {
      insertDynamicPlayButtons(
        Object.assign(playButton, {
          elementRef,
          position,
          iconHrefLink: playButtonHrefLink,
          buttonId: "play-button"
        })
      );
    },
    [playButton, playButtonHrefLink]
  );
  const insertDynamicPlayButtons = (dynamicButton) => {
    const { elementRef, position, className: className2, type, iconHrefLink, size } = dynamicButton;
    elementRef.insertAdjacentHTML(
      position,
      `<svg class='${className2} ${PREFIX}-icon ${PREFIX}-icon-${type} ${PREFIX}-icon--${size}' alt='Play video'>
            <use href=${iconHrefLink} />
            </svg>`
    );
  };
  const insertPlayButtonToVideo = useCallback(() => {
    const thumbnailDiv = document.querySelectorAll(
      `.${mediaGalleryViewerClassName} [data-akamai-viewer-tag='${selectedTagValue}'] .snapper_nav .snapper_nav_inner a`
    );
    thumbnailDiv && thumbnailDiv.forEach((video) => {
      if (video.getAttribute("data-akamai-carousel-thumb-type") === MediaTypeValue.video) {
        addVideoPlayButton(video, "beforeend");
      }
    });
  }, [selectedTagValue, addVideoPlayButton]);
  const addThumbnailNavigationArrows = useCallback(
    (thumbnailDiv) => {
      const thumbnailImages = thumbnailDiv == null ? void 0 : thumbnailDiv.querySelectorAll(".snapper_nav_inner a");
      const isThumbnailArrowsExist = thumbnailDiv == null ? void 0 : thumbnailDiv.querySelector(`.${thumbnailPrevArrowClass}`);
      const variantSelected = selectedVariantId || selectedProductCode;
      const isNotLastThumbnail = thumbnailDiv && thumbnailImages.length > thumbnailCount && variantSelected && !isThumbnailArrowsExist;
      isNotLastThumbnail && addNavigationArrowButtons(
        thumbnailDiv,
        `thumb-prev-arrow-id-${variantSelected}`,
        `thumb-next-arrow-id-${variantSelected}`,
        prevArrowHrefLink,
        nextArrowHrefLink,
        a11yCarouselPreviousLabel,
        a11yCarouselNextLabel,
        thumbnailPrevArrowClass,
        thumbnailNextArrowClass
      );
    },
    [
      a11yCarouselNextLabel,
      a11yCarouselPreviousLabel,
      nextArrowHrefLink,
      prevArrowHrefLink,
      selectedProductCode,
      selectedVariantId,
      thumbnailCount,
      thumbnailNextArrowClass,
      thumbnailPrevArrowClass
    ]
  );
  const addListenerToNavigationArrows = useCallback(
    (thumbnailDiv) => {
      const mediaGalleryFullscreenEle = document.querySelector(`.${PREFIX}-media-gallery-viewer--fullscreen`);
      const modalClassName = mediaGalleryFullscreenEle ? mediaGalleryViewerClassNameFullscreen : mediaGalleryViewerClassName;
      const prevArrowBtn = thumbnailDiv && document.getElementById(`thumb-prev-arrow-id-${selectedVariantId || selectedProductCode}`);
      if (prevArrowBtn && prevArrowBtn.getAttribute("listener") !== "true") {
        prevArrowBtn.addEventListener(
          "click",
          () => thumbnailArrowClick(true, thumbnailCount, modalClassName, mediaGalleryClick)
        );
        prevArrowBtn.setAttribute("listener", "true");
      }
      const nextArrowBtn = thumbnailDiv && document.getElementById(`thumb-next-arrow-id-${selectedVariantId || selectedProductCode}`);
      if (nextArrowBtn && nextArrowBtn.getAttribute("listener") !== "true") {
        nextArrowBtn.addEventListener(
          "click",
          () => thumbnailArrowClick(false, thumbnailCount, modalClassName, mediaGalleryClick)
        );
        nextArrowBtn.setAttribute("listener", "true");
      }
    },
    [
      mediaGalleryClick,
      mediaGalleryViewerClassNameFullscreen,
      selectedProductCode,
      selectedVariantId,
      thumbnailCount
    ]
  );
  const setThumbnailHeight = useCallback(
    (thumbnailDiv) => {
      const snapperNavInnersFocused = document.querySelector(
        `.${mediaGalleryViewerClassName} .focused .snapper_nav_inner a`
      );
      const thumbnailInnerDiv = snapperNavInnersFocused || document.querySelector(`.${mediaGalleryViewerClassName} .snapper_nav_inner a`);
      const thumbnailImageWidth = thumbnailInnerDiv && thumbnailInnerDiv.offsetWidth || mediaGalleryThumbnailImageWidth;
      const thumbnailImageMargin = thumbnailInnerDiv && window.getComputedStyle(thumbnailInnerDiv).getPropertyValue("margin-right");
      const thumbnailNavWidth2 = (thumbnailCount - minimumImageLength2) * (parseFloat(thumbnailImageMargin) + thumbnailImageWidth);
      const lastImageMargin = getLastThumbnailImageMargin(thumbnailImageMargin);
      const navInner = thumbnailDiv && thumbnailDiv.querySelector(".snapper_nav_inner");
      navInner && navInner.setAttribute("style", `width:${thumbnailNavWidth2 + lastImageMargin + thumbnailImageWidth}px`);
    },
    [getLastThumbnailImageMargin, mediaGalleryThumbnailImageWidth, minimumImageLength2, thumbnailCount]
  );
  const addThumbnailArrows = useCallback(() => {
    const snapperNavEle = selectedVariant && document.querySelector(
      `.${mediaGalleryViewerClassName} [data-akamai-viewer-tag='${selectedTagValue}'] .snapper_nav`
    );
    const thumbnailDiv = snapperNavEle ? snapperNavEle : document.querySelector(`.${mediaGalleryViewerClassName} .snapper_nav`);
    const isDesktop = window.innerWidth > BREAKPOINTS.tabletMaxWidth;
    if (isDesktop) {
      setThumbnailHeight(thumbnailDiv);
    } else {
      setThumbnailHeightMobile(thumbnailDiv);
    }
    addThumbnailNavigationArrows(thumbnailDiv);
    addListenerToNavigationArrows(thumbnailDiv);
  }, [
    addListenerToNavigationArrows,
    addThumbnailNavigationArrows,
    selectedTagValue,
    selectedVariant,
    setThumbnailHeight
  ]);
  const createMediaGalleryViewer = useCallback(
    (elementRef) => {
      const widthParam = "imdensity=1&imwidth";
      const policyParam = isMobileOrTablet ? "mZoom" : "gZoom";
      const allWidths = [
        mobileStaticImageSize || defaultStaticImageSize,
        desktopStaticImageSize || defaultStaticImageSize
      ];
      const magnifierOption = {
        button: true,
        enabled: enablePDPZoomEnhancement,
        placement: "inline",
        magnification: magicNumber.TWO,
        image: {
          widths: allWidths,
          widthParam,
          policy: policyParam
        }
      };
      if (elementRef.current) {
        magnifierOption.image["sizes"] = `${elementRef.current.offsetWidth}px`;
      }
      const zoomEnhancement = {
        hoverZoomWithoutClick: getDeviceType() === deviceTypes.DESKTOP ? false : true,
        fullscreen: {
          enabled: fullscreenEnable
        }
      };
      const breakpointOptions = {
        [BREAKPOINTS.tabletMaxWidth]: {
          magnifier: {
            hoverZoomWithoutClick: false
          }
        }
      };
      const magnifierOptions = enablePDPZoomEnhancement ? { ...magnifierOption, ...zoomEnhancement } : magnifierOption;
      const Akamai = customizeAkamai(windowRef.Akamai);
      const akamaiViewer = new Akamai.Viewer(elementRef.current, {
        items: {
          hostnames: hostNames,
          data: productImages,
          limit: mediaGalleryConstants.limitThreshold
        },
        breakpoints: breakpointOptions,
        carousel: {
          arrows: true,
          thumbnail: {
            placement: "bottom",
            policy: "thumbnail"
          },
          aspectratio: 66.9,
          removeOnTagSwitch: true,
          images: {
            widths: allWidths,
            widthParam
          }
        },
        magnifier: magnifierOptions,
        video: {
          autoplay: !enablePDPZoomEnhancement
        }
      });
      setAkamaiViewerRef(akamaiViewer);
      if (setMagnifierOptions && typeof setMagnifierOptions === "function") {
        setMagnifierOptions(magnifierOptions);
      }
    },
    [
      isMobileOrTablet,
      enablePDPZoomEnhancement,
      fullscreenEnable,
      windowRef.Akamai,
      hostNames,
      productImages,
      setMagnifierOptions,
      defaultStaticImageSize,
      mobileStaticImageSize,
      desktopStaticImageSize
    ]
  );
  const showSkeleton = useCallback(
    (mediaClassName) => {
      var _a;
      if (checkIfMediaSetExist(
        selectedTagValue,
        selectedProductCode,
        isAutomotive,
        productImages,
        productDataCode
      )) {
        const tagEle = document.querySelector(
          `.${mediaClassName} [data-akamai-viewer-tag='${selectedTagValue}']`
        );
        (_a = tagEle == null ? void 0 : tagEle.classList) == null ? void 0 : _a.add(`${PREFIX}-skeleton`, `${PREFIX}-media-gallery__skeleton`);
      }
    },
    [isAutomotive, productDataCode, productImages, selectedProductCode, selectedTagValue]
  );
  const setSwitchTag = useCallback(
    (mediaClassName, viewerRef) => {
      const tagAlreadyExist = document.querySelector(
        `.${mediaClassName} [data-akamai-viewer-tag='${selectedTagValue}']`
      );
      if (tagAlreadyExist) {
        document.querySelectorAll(`.${mediaClassName} [data-akamai-viewer-tag]`).forEach((viewerTag) => {
          viewerTag.setAttribute("style", "display:none");
        });
        tagAlreadyExist.setAttribute("style", "display:block");
      } else {
        selectedTagValue && selectedTagValue !== previousSelectedTagValue && viewerRef.switchTag(selectedTagValue);
        const tagExist = document.querySelector(
          `.${mediaClassName} [data-akamai-viewer-tag='${selectedTagValue}']`
        );
        const filteredImagesArr = productImages == null ? void 0 : productImages.filter(
          (image) => {
            var _a;
            return (_a = image.tags) == null ? void 0 : _a.includes(selectedTagValue);
          }
        );
        if (tagExist) {
          document.querySelectorAll(`.${mediaClassName} [data-akamai-viewer-tag]`).forEach((viewerTag) => {
            viewerTag.setAttribute("style", "display:none");
          });
          tagExist == null ? void 0 : tagExist.setAttribute("style", "display:block");
        }
        filteredImagesArr.length > thumbnailCount && addThumbnailArrows();
        const mainProductImage = document.querySelector(
          `.${mediaClassName} [data-akamai-viewer-tag='${selectedTagValue}'] .snapper_items`
        );
        if (mainProductImage) {
          insertPlayButtonToVideo();
        }
      }
      showSkeleton(mediaClassName);
    },
    [
      addThumbnailArrows,
      insertPlayButtonToVideo,
      productImages,
      selectedTagValue,
      previousSelectedTagValue,
      showSkeleton,
      thumbnailCount
    ]
  );
  const isVariantSelected = isAutomotive ? selectedProductCode || selectedVariant : !!selectedVariant;
  const previousSelectedVariant = usePrevious(selectedVariant);
  const previousAkamaiViewerRef = usePrevious(akamaiViewerRef);
  const previousSelectedProductCode = usePrevious(selectedProductCode);
  const previousProductImages = usePrevious(productImages);
  const [isVideoActive, setIsVideoActive] = useState(false);
  const insertWatchFullScreenCTA = useCallback(() => {
    const mediaContainer = document.querySelector(`.${mediaGalleryViewerClassName} .snapper_nextprev_contain`);
    mediaContainer == null ? void 0 : mediaContainer.insertAdjacentHTML(
      "afterend",
      `<div id ="${mediaGalleryViewerClassName}-btn" class="${mediaGalleryViewerClassName}-btn"><button
        class="${mediaGalleryViewerClassName}-btn-cta"
        type="button">            
        ${watchFullScreenLabel}
    </button></div>`
    );
    const fullScreenCTA = document.querySelector(`.${mediaGalleryViewerClassName}-btn`);
    fullScreenCTA == null ? void 0 : fullScreenCTA.classList.add("hide");
    fullScreenCTA == null ? void 0 : fullScreenCTA.addEventListener("click", () => playVideoInFullScreen());
    handleCarouselEvent();
  }, [watchFullScreenLabel]);
  const handleCarouselEvent = () => {
    setIsCarouselGotoTriggered(true);
    const video = document.querySelector(
      `.${mediaGalleryViewerClassName} [data-akamai-carousel-item-active] video`
    );
    video ? setIsVideoActive(true) : setIsVideoActive(false);
  };
  useEffect(() => {
    if (isAkamaiCarouselInit) {
      insertWatchFullScreenCTA();
      setIsAkamaiCarouselInit(false);
    }
  }, [insertWatchFullScreenCTA, isAkamaiCarouselInit]);
  useEffect(() => {
    const fullScreenCTA = document.getElementById(`${mediaGalleryViewerClassName}-btn`);
    isVideoActive ? fullScreenCTA == null ? void 0 : fullScreenCTA.classList.remove("hide") : fullScreenCTA == null ? void 0 : fullScreenCTA.classList.add("hide");
    if (isCarouselGotoTriggered) {
      setIsCarouselGotoTriggered(false);
    }
  }, [isVideoActive, isCarouselGotoTriggered]);
  useEffect(() => {
    windowRef.addEventListener("akamai-carousel-init", () => {
      setIsAkamaiCarouselInit(true);
    });
    windowRef.addEventListener("akamai-carousel-goto", handleCarouselEvent, false);
  }, [windowRef]);
  useEffect(() => {
    const isPreviouslySelectedVariantChanged = previousSelectedVariant !== selectedVariant || previousSelectedTagValue !== selectedTagValue;
    if (isPreviouslySelectedVariantChanged || previousAkamaiViewerRef !== akamaiViewerRef || previousSelectedProductCode !== selectedProductCode || previousProductImages !== productImages) {
      if (akamaiViewerRef && productImages && !!isVariantSelected) {
        setSwitchTag(mediaGalleryViewerClassName, akamaiViewerRef);
      } else {
        showSkeleton(mediaGalleryViewerClassName);
      }
    }
  }, [
    selectedVariant,
    akamaiViewerRef,
    selectedProductCode,
    productImages,
    previousSelectedVariant,
    previousAkamaiViewerRef,
    previousSelectedProductCode,
    previousProductImages,
    isVariantSelected,
    setSwitchTag,
    showSkeleton,
    previousSelectedTagValue,
    selectedTagValue
  ]);
  const swipeCarouselCallback = useCallback(() => {
    windowRef.addEventListener("akamai-carousel-goto", (event) => {
      var _a, _b, _c;
      const mediaGalleryId = (_b = (_a = event == null ? void 0 : event.target) == null ? void 0 : _a.offsetParent) == null ? void 0 : _b.id;
      const currentImageSource = mediaGalleryId ? (_c = document.querySelector(
        `.${mediaGalleryId} .snapper_nav .snapper_nav_inner .snapper_nav_item-selected img`
      )) == null ? void 0 : _c["currentSrc"] : "";
      if ((mediaGalleryId === `${mediaGalleryViewerClassName}` || mediaGalleryId === `${mediaGalleryViewerClassName}--fullscreen`) && currentImageSource !== currentImageSrc.current) {
        currentImageSrc.current = currentImageSource;
        mediaGalleryClick(mediaGalleryId === `${mediaGalleryViewerClassName}--fullscreen`);
      }
    });
  }, [mediaGalleryClick, windowRef]);
  const parentRef = useRef(null);
  const setMediaGalleryHeight = useCallback(() => {
    var _a, _b, _c;
    const parent = (_c = (_b = (_a = parentRef.current) == null ? void 0 : _a.parentElement) == null ? void 0 : _b.parentElement) == null ? void 0 : _c.parentElement;
    const isMediaGalleryContainer = (parent == null ? void 0 : parent.classList.contains("mediagallery")) ?? false;
    const isDesktop = document.body.clientWidth > BREAKPOINTS.tabletMaxWidth;
    if (!isDesktop && isMediaGalleryContainer) {
      parent.style.minHeight = "";
    }
    if (isDesktop && buyboxHeight && isMediaGalleryContainer) {
      parent.style.minHeight = `${buyboxHeight}px`;
    }
  }, [buyboxHeight]);
  useEffect(() => {
    setMediaGalleryHeight();
  }, [buyboxHeight, setMediaGalleryHeight]);
  useEffect(() => {
    if (productImages !== previousProductImages && isArrayNotEmpty(productImages) && windowRef.Akamai) {
      createMediaGalleryViewer(mediaGalleryRef);
      const mainProductImage = document.querySelector(".snapper_items");
      if (mainProductImage) {
        insertPlayButtonToVideo();
      }
      const snapperPane = document.querySelector(".snapper_pane");
      if (!enablePDPZoomEnhancement) {
        snapperPane.classList.add("enlarge_pane__feature");
      }
      swipeCarouselCallback();
      if (productImages.length > thumbnailCount) {
        addThumbnailArrows();
      }
    }
  }, [
    addThumbnailArrows,
    createMediaGalleryViewer,
    insertPlayButtonToVideo,
    previousProductImages,
    productImages,
    swipeCarouselCallback,
    thumbnailCount,
    windowRef.Akamai,
    enablePDPZoomEnhancement,
    fullscreenEnable
  ]);
  useEffect(() => {
    if (enableFasterPdpLogic) {
      windowRef.addEventListener(AKAMAI_IMAGE_LOAD_EVENT, handleAkamaiImageLoadEvent, { once: true });
    }
  }, [enableFasterPdpLogic, windowRef]);
  const handleAkamaiImageLoadEvent = () => {
    setIsAkamaiImageLoaded(true);
  };
  useEffect(() => {
    if (enableFasterPdpLogic) {
      const akamaiViewerElement = document.getElementsByClassName(mediaGalleryViewerClassName)[0];
      const mediaGalleryElement = document.getElementsByClassName(mediaGalleryClassName)[0];
      const staticImageElement = document.getElementsByClassName(staticImageContainerClassName)[0];
      akamaiViewerElement.classList.add(hideAkamaiViewerImageClassName);
      if (isAkamaiImageLoaded) {
        staticImageElement.parentNode.removeChild(staticImageElement);
        akamaiViewerElement.classList.remove(hideAkamaiViewerImageClassName);
        mediaGalleryElement.classList.remove(mediaGalleryNoPaddingClassName);
      }
    }
  }, [isAkamaiImageLoaded, enableFasterPdpLogic]);
  const isMobile2 = useIsMobile();
  const priorityAndName = inImageBadgePriorities == null ? void 0 : inImageBadgePriorities.priorityAndName;
  const priorityAndColourWithIconLabel = useMemo(
    () => priorityAndName == null ? void 0 : priorityAndName.map((badge) => ({
      ...badge,
      badgeLabel: /* @__PURE__ */ jsx("img", { src: badge == null ? void 0 : badge.badgeIconUrl, alt: badge == null ? void 0 : badge.badgeId }),
      colorId: ""
    })),
    [priorityAndName, isMobile2]
  );
  const fasterPdpLogicClassName = enableFasterPdpLogic ? mediaGalleryNoPaddingClassName : "";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-media-gallery ${fasterPdpLogicClassName}`,
      "data-testid": "media-gallery",
      ref: parentRef,
      children: [
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-pdp-in-image-badges`, children: /* @__PURE__ */ jsx(
          Badges,
          {
            badges: productDataBadges,
            badgesAndPriorities: {
              ...inImageBadgePriorities,
              priorityAndColour: priorityAndColourWithIconLabel
            },
            hideDisclaimer: true
          }
        ) }),
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-akamai-viewer": true,
            ref: mediaGalleryRef,
            className: `${mediaGalleryViewerClassName}`,
            id: `${mediaGalleryViewerClassName}`
          }
        )
      ]
    }
  );
};
MediaGalleryViewer.propTypes = {
  productImages: PropTypes.array,
  windowRef: PropTypes.any,
  hostNames: PropTypes.array,
  path: PropTypes.string,
  a11yCarouselNextLabel: PropTypes.string,
  a11yCarouselPreviousLabel: PropTypes.string,
  thumbnailImageCount: PropTypes.number,
  mediaGalleryClick: PropTypes.func,
  selectedVariant: PropTypes.string,
  selectedVariantId: PropTypes.number,
  selectedProductCode: PropTypes.string,
  buyboxHeight: PropTypes.number,
  productDataCode: PropTypes.string,
  productDataBadges: PropTypes.array,
  isAutomotive: PropTypes.bool,
  fullscreenEnable: PropTypes.bool,
  enablePDPZoomEnhancement: PropTypes.bool,
  watchFullScreenLabel: PropTypes.string,
  enableFasterPdpLogic: PropTypes.bool
};
const MergeCartModal = ({ ...props }) => {
  const { productData, getSelectedCartItems, index: index2, isCheckboxDisabled, isSTS } = props;
  const { images, name } = productData || {};
  const mergeModalClass = `${PREFIX}-merge-cart-modal`;
  const getCheckbox = () => {
    return !isCheckboxDisabled ? /* @__PURE__ */ jsx(
      Checkbox,
      {
        id: `${index2}`,
        label: "",
        checked: productData.selected,
        onChange: () => {
          getSelectedCartItems(!productData.selected, productData);
        },
        "data-testid": "merge-cart"
      }
    ) : null;
  };
  return /* @__PURE__ */ jsx(CommonCard, { isSTS, children: /* @__PURE__ */ jsxs("div", { className: `${mergeModalClass}_header`, children: [
    (productData.entryType === eEntryType.SERVICE_ADDON || productData.entryType === eEntryType.SERVICE_STANDALONE) && !(productData == null ? void 0 : productData.productWheelType) ? /* @__PURE__ */ jsx(
      ProductImageComponent,
      {
        isService: true,
        a11yServiceInstallation: props.a11yServiceInstallation,
        servicesIcon: "ct-tools"
      }
    ) : /* @__PURE__ */ jsx(ProductImageComponent, { images, name }),
    /* @__PURE__ */ jsx(
      ProductItemInfo,
      {
        productData,
        cartModal: true,
        totalLabel: props.totalLabel,
        mmQtyLabel: props.mmQtyLabel,
        isUnfinishedPackage: props.isUnfinishedPackage,
        language: props.language,
        a11yStrikeOutPrice: props.a11yStrikeOutPrice,
        a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
        singleShippingMethodOption: true,
        saveLabel: props.saveLabel,
        isSTS
      }
    ),
    getCheckbox()
  ] }) });
};
var ItemColorType = /* @__PURE__ */ ((ItemColorType2) => {
  ItemColorType2["highlight"] = "highlight";
  ItemColorType2["standard"] = "standard";
  return ItemColorType2;
})(ItemColorType || {});
const getAriaPath = (url) => {
  return Boolean(RegExp(url).exec(window.location.pathname));
};
const getAriaCurrentValue = (categoryData) => {
  var _a;
  return getAriaPath(
    typeof categoryData.url === "string" ? encodeURI(categoryData.url) : encodeURI((_a = categoryData.url) == null ? void 0 : _a.url)
  );
};
const scrollToTop = () => {
  const sideMenuContainerElem = document.querySelector(`.${PREFIX}-side-menu__container`);
  if (!!sideMenuContainerElem) {
    sideMenuContainerElem.scrollTop = 0;
  }
};
const MegaNavigationList = ({ ...props }) => {
  const {
    categoryMapData,
    path,
    onCategoryClicked,
    currentView,
    style,
    megaNavClicked,
    listRef,
    currentIndexRef,
    forwardActionRef
  } = props;
  const renderListOfUrl = (index2, value) => {
    var _a;
    return /* @__PURE__ */ jsx(
      "a",
      {
        className: `${PREFIX}-mega-navigation__no-button ${PREFIX}-mega-navigation__link ${style === "bold" && "text-bold"} ${getActiveCategoryClass(value, true)}`,
        href: typeof value.url === "string" ? encodeURI(value.url) : encodeURI((_a = value.url) == null ? void 0 : _a.url),
        tabIndex: 0,
        "data-testid": `mega-navigation-list-item-${currentView}-${index2}`,
        onClick: () => {
          currentIndexRef.current[currentView] = index2;
          return true;
        },
        children: value.name
      }
    );
  };
  const getActiveCategoryClass = (value, isLink) => {
    const isUrlMatched = value.url === window.location.pathname;
    const isL3View = currentView.toUpperCase() === "L3" || !value.categories;
    if (isLink) {
      return isUrlMatched ? `${PREFIX}-mega-navigation__link--active` : "";
    } else {
      return isUrlMatched && isL3View ? `${PREFIX}-mega-navigation__link--active` : "";
    }
  };
  const getEncodedUri = (url) => {
    return typeof url === "string" ? encodeURI(url) : encodeURI(url == null ? void 0 : url.url);
  };
  const renderListOrShopList = () => {
    return /* @__PURE__ */ jsx(
      "ul",
      {
        ref: listRef,
        className: `${PREFIX}-mega-navigation__categories-section`,
        "data-testid": `mega-navigation-list-${currentView}`,
        children: categoryMapData.map((value, index2) => {
          const { style: colorType, categories, url, name } = value;
          const highlightedClass = !!colorType && colorType === ItemColorType.highlight ? "highlight-item" : "standard-item";
          return /* @__PURE__ */ jsx("li", { className: highlightedClass, children: !isArrayNotEmpty(categories) ? renderListOfUrl(index2, value) : /* @__PURE__ */ jsxs(
            "button",
            {
              className: `${PREFIX}-mega-navigation__no-button ${style === "bold" ? "text-bold" : ""} ${getActiveCategoryClass(value, false)}`,
              "data-testid": `mega-navigation-list-item-${currentView}-${index2}`,
              "aria-current": getAriaPath(getEncodedUri(url)) ? ariaType : false,
              onClick: () => {
                megaNavClicked && megaNavClicked(name);
                if (currentView === "L3" || !categories) {
                  window.location.href = getEncodedUri(url);
                } else {
                  onCategoryClicked(value, currentView);
                }
                scrollToTop();
                currentIndexRef.current[currentView] = index2;
                forwardActionRef.current = true;
              },
              children: [
                name,
                !!categories && isArrayNotEmpty(categories) && currentView !== "L3" && /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-right", size: "lg", path })
              ]
            }
          ) }, `${name}${index2}`);
        })
      }
    );
  };
  return renderListOrShopList();
};
MegaNavigationList.propTypes = {
  categoryMapData: PropTypes.any,
  path: PropTypes.string,
  onCategoryClicked: PropTypes.func,
  currentView: PropTypes.string,
  style: PropTypes.oneOf(["normal", "bold"]),
  megaNavClicked: PropTypes.func
};
const MegaNavigationTile = ({ ...props }) => {
  const { tileData } = props;
  const SaleCategoriesTypeClasses = {
    sale: `${PREFIX}-mega-navigation-tile--sale`,
    clearance: `${PREFIX}-mega-navigation-tile--clearance`,
    arrival: `${PREFIX}-mega-navigation-tile--arrival`,
    autoService: `${PREFIX}-mega-navigation-tile--auto-service`
  };
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-mega-navigation-tile`, children: tileData.map((tile, index2) => {
    const { name, url, buttonCtaText } = tile;
    return /* @__PURE__ */ jsxs("div", { className: `${SaleCategoriesTypeClasses[tile.type]}`, children: [
      /* @__PURE__ */ jsx("div", { className: `${SaleCategoriesTypeClasses[tile.type]}__title`, children: name }, `${index2}${name}`),
      /* @__PURE__ */ jsx(
        "a",
        {
          "aria-current": getAriaPath(encodeURI(url)) ? ariaType : false,
          className: `${PREFIX}-button`,
          href: encodeURI(url),
          "data-link-value": buttonCtaText,
          children: buttonCtaText
        }
      )
    ] }, `${index2}${name}`);
  }) });
};
MegaNavigationTile.propTypes = {
  tileData: PropTypes.arrayOf(
    PropTypes.exact({
      type: PropTypes.string
    }).isRequired
  ).isRequired
};
const MegaNavigation = ({ ...props }) => {
  const {
    categoryData,
    path,
    onCategoryClicked,
    onBackLabelClicked,
    currentView,
    megaNavClicked,
    enableShopAllLabel,
    shopAllPlaceholderUrl,
    shopAllLinkLabel,
    shopAllExclusionIds,
    ariaLabelShopAll
  } = props;
  const listRef = useRef(null);
  const currentIndexRef = useRef({});
  const backActionRef = useRef(false);
  const forwardActionRef = useRef(false);
  const backButtonRef = useRef(null);
  useEffect(() => {
    var _a;
    if (backActionRef.current && listRef.current && currentIndexRef.current && currentIndexRef.current[currentView] > -1) {
      const interactiveElements = getInteractiveElements(listRef.current);
      (_a = interactiveElements[currentIndexRef.current[currentView]]) == null ? void 0 : _a.focus();
    }
    backActionRef.current = false;
  }, [currentView]);
  useEffect(() => {
    if (backButtonRef.current && forwardActionRef.current) {
      const firstInteractiveElement = getInteractiveElements(backButtonRef.current)[0];
      firstInteractiveElement == null ? void 0 : firstInteractiveElement.focus();
    }
    forwardActionRef.current = false;
  }, [currentView]);
  const renderListOrShopList = () => {
    var _a;
    if (categoryData && Array.isArray(categoryData)) {
      return /* @__PURE__ */ jsx(
        MegaNavigationList,
        {
          path,
          categoryMapData: categoryData,
          onCategoryClicked,
          currentView,
          style: "bold",
          listRef,
          currentIndexRef,
          forwardActionRef
        }
      );
    } else {
      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-mega-navigation--mobile`, ref: backButtonRef, children: [
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-mega-navigation__back-section`, children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-left", size: "md", path }),
          /* @__PURE__ */ jsx(
            Button,
            {
              type: "tertiary",
              onClick: () => {
                onBackLabelClicked();
                backActionRef.current = true;
              },
              id: `mega-navigation-list-${currentView}-back`,
              children: categoryData.backLinkLabel
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-mega-navigation__shopall-section`, children: [
          /* @__PURE__ */ jsx(
            "a",
            {
              "aria-current": getAriaCurrentValue(categoryData) ? ariaType : false,
              href: `${typeof categoryData.url === "string" ? encodeURI(categoryData.url) : encodeURI((_a = categoryData.url) == null ? void 0 : _a.url)}`,
              children: categoryData.name
            }
          ),
          categoryShopAllLink(
            categoryData == null ? void 0 : categoryData.id,
            categoryData.url,
            shopAllPlaceholderUrl,
            enableShopAllLabel,
            shopAllExclusionIds,
            shopAllLinkLabel,
            ariaLabelShopAll == null ? void 0 : ariaLabelShopAll.concat(" ", categoryData.name),
            `${PREFIX}-mega-navigation__shopall-section__link`
          )
        ] }),
        /* @__PURE__ */ jsx(
          MegaNavigationList,
          {
            style: "normal",
            path,
            categoryMapData: [...categoryData.categories],
            onCategoryClicked,
            currentView,
            megaNavClicked,
            listRef,
            currentIndexRef,
            forwardActionRef
          }
        ),
        categoryData.saleCategories && currentView === "L2" ? /* @__PURE__ */ jsx(MegaNavigationTile, { tileData: categoryData.saleCategories }) : null
      ] });
    }
  };
  return /* @__PURE__ */ jsx(Fragment, { children: renderListOrShopList() });
};
MegaNavigation.propTypes = {
  categoryData: PropTypes.any,
  path: PropTypes.string,
  onCategoryClicked: PropTypes.func,
  onBackLabelClicked: PropTypes.func,
  currentView: PropTypes.string,
  backToLabel: PropTypes.string,
  shopAllLabel: PropTypes.string,
  megaNavClicked: PropTypes.func,
  autoServiceButton: PropTypes.func
};
const SubCategories = ({
  catalog,
  InteractionAnalytics,
  eventName,
  actionName,
  enableShopAllLabel,
  shopAllPlaceholderUrl,
  shopAllLinkLabel,
  shopAllExclusionIds,
  ariaLabelShopAll
}) => {
  var _a;
  return /* @__PURE__ */ jsxs("div", { className: classnames(`${PREFIX}-row`, `${PREFIX}-sub-categories`), children: [
    (_a = catalog == null ? void 0 : catalog.categories) == null ? void 0 : _a.map((chunk, index2) => {
      return /* @__PURE__ */ jsx("div", { className: classnames(`${PREFIX}-col-sm-2`, `${PREFIX}-sub-categories__padding`), children: chunk.map((category) => {
        var _a2, _b;
        return /* @__PURE__ */ jsxs("ul", { children: [
          /* @__PURE__ */ jsx("li", { className: classnames(`${PREFIX}-sub-categories__category--l2`), children: /* @__PURE__ */ jsx(
            InteractionAnalytics,
            {
              componentName: "MegaNavigation",
              label: category.name,
              eventName,
              actionName,
              children: /* @__PURE__ */ jsx(
                "a",
                {
                  "aria-current": getAriaCurrentValue(category) ? ariaType : false,
                  "data-link-value": category.name,
                  href: encodeURI(
                    typeof (category == null ? void 0 : category.url) === "string" ? category == null ? void 0 : category.url : (_a2 = category == null ? void 0 : category.url) == null ? void 0 : _a2.url
                  ),
                  children: category.name
                }
              )
            }
          ) }),
          (_b = category == null ? void 0 : category.categories) == null ? void 0 : _b.map((cat) => {
            var _a3;
            return /* @__PURE__ */ jsx("li", { className: classnames(`${PREFIX}-sub-categories__category`), children: /* @__PURE__ */ jsx(
              InteractionAnalytics,
              {
                componentName: "MegaNavigation",
                label: cat.name,
                eventName,
                actionName,
                children: /* @__PURE__ */ jsx(
                  "a",
                  {
                    "aria-current": getAriaCurrentValue(cat) ? ariaType : false,
                    "data-link-value": cat.name,
                    href: encodeURI(
                      typeof (cat == null ? void 0 : cat.url) === "string" ? cat == null ? void 0 : cat.url : (_a3 = cat == null ? void 0 : cat.url) == null ? void 0 : _a3.url
                    ),
                    children: cat.name
                  }
                )
              }
            ) }, cat.name);
          }),
          categoryShopAllLink(
            category.id,
            category.url,
            shopAllPlaceholderUrl,
            enableShopAllLabel,
            shopAllExclusionIds,
            shopAllLinkLabel,
            ariaLabelShopAll == null ? void 0 : ariaLabelShopAll.concat(" ", category.name),
            `${PREFIX}-mega-navigation__shopall--link`
          )
        ] }, category.name);
      }) }, index2);
    }),
    catalog.saleCategories && /* @__PURE__ */ jsx("div", { className: classnames(`${PREFIX}-col-sm-2`), children: /* @__PURE__ */ jsx(MegaNavigationTile, { tileData: catalog.saleCategories }) })
  ] });
};
const NavExpansionPanel = ({ catalog }) => {
  var _a;
  const formatList = (list) => {
    var _a2;
    const count = Number(catalog.subNavItemLimit);
    if (list && list.length > count) {
      const resultList = list.slice(0, count);
      resultList.push({
        subNavLabel: catalog.viewMoreLabel,
        subNavLink: encodeURI(typeof (catalog == null ? void 0 : catalog.url) === "string" ? catalog == null ? void 0 : catalog.url : (_a2 = catalog == null ? void 0 : catalog.url) == null ? void 0 : _a2.url),
        subNavLinkTarget: ""
      });
      return resultList;
    } else {
      return list;
    }
  };
  return /* @__PURE__ */ jsx("div", { className: classnames(`${PREFIX}-row`, `${PREFIX}-sub-categories`), children: /* @__PURE__ */ jsx("div", { className: classnames(`${PREFIX}-sub-categories__right-spacing`), children: /* @__PURE__ */ jsx("ul", { children: (_a = formatList(catalog == null ? void 0 : catalog.subSectionTab)) == null ? void 0 : _a.map((subNavItem, columnIndex) => /* @__PURE__ */ jsx(
    "li",
    {
      className: classnames(
        `${PREFIX}-sub-categories__category${columnIndex > catalog.subNavItemLimit - 1 ? "--underline" : ""}`
      ),
      children: /* @__PURE__ */ jsx("a", { "data-link-value": subNavItem == null ? void 0 : subNavItem.subNavLabel, href: subNavItem == null ? void 0 : subNavItem.subNavLink, children: subNavItem == null ? void 0 : subNavItem.subNavLabel })
    },
    columnIndex
  )) }) }) });
};
const MegaNavigationDesktop = ({
  catalog,
  InteractionAnalytics,
  eventName,
  actionName,
  isKp,
  enableShopAllLabel,
  shopAllPlaceholderUrl,
  shopAllLinkLabel,
  shopAllExclusionIds,
  ariaLabelShopAll
}) => {
  const getNavExpandedPanel = () => {
    if (isKp) {
      return /* @__PURE__ */ jsx(NavExpansionPanel, { catalog });
    } else {
      return /* @__PURE__ */ jsx(
        SubCategories,
        {
          catalog,
          InteractionAnalytics,
          eventName,
          actionName,
          enableShopAllLabel,
          shopAllPlaceholderUrl,
          shopAllLinkLabel,
          shopAllExclusionIds,
          ariaLabelShopAll
        }
      );
    }
  };
  const getRenderContent = () => {
    var _a, _b;
    if (isKp) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "a",
          {
            "data-link-value": catalog == null ? void 0 : catalog.megaNavTitle,
            href: encodeURI(typeof (catalog == null ? void 0 : catalog.url) === "string" ? catalog == null ? void 0 : catalog.url : (_a = catalog == null ? void 0 : catalog.url) == null ? void 0 : _a.url),
            children: catalog == null ? void 0 : catalog.megaNavTitle
          }
        ),
        " "
      ] });
    } else {
      return /* @__PURE__ */ jsxs(
        InteractionAnalytics,
        {
          componentName: "MegaNavigation",
          label: catalog == null ? void 0 : catalog.megaNavTitle,
          eventName,
          actionName,
          children: [
            /* @__PURE__ */ jsx(
              "a",
              {
                "aria-current": getAriaCurrentValue(catalog) ? ariaType : false,
                "data-link-value": catalog == null ? void 0 : catalog.megaNavTitle,
                href: encodeURI(typeof (catalog == null ? void 0 : catalog.url) === "string" ? catalog == null ? void 0 : catalog.url : (_b = catalog == null ? void 0 : catalog.url) == null ? void 0 : _b.url),
                children: catalog == null ? void 0 : catalog.name
              }
            ),
            " ",
            /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-right", size: "md" })
          ]
        }
      );
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: classnames(`${PREFIX}-mega-navigation`, `${PREFIX}-row `), children: [
    /* @__PURE__ */ jsxs("div", { className: classnames(`${PREFIX}-col-sm-12`, `${PREFIX}-mega-navigation__padding`), children: [
      /* @__PURE__ */ jsx("h3", { children: getRenderContent() }),
      categoryShopAllLink(
        catalog == null ? void 0 : catalog.id,
        catalog.url,
        shopAllPlaceholderUrl,
        enableShopAllLabel,
        shopAllExclusionIds,
        shopAllLinkLabel,
        ariaLabelShopAll == null ? void 0 : ariaLabelShopAll.concat(" ", catalog.name),
        `${PREFIX}-sub-categories__category--l2 ${PREFIX}-mega-navigation__shopall--link`
      )
    ] }),
    !isKp && /* @__PURE__ */ jsx("hr", {}),
    /* @__PURE__ */ jsx(Fragment, { children: getNavExpandedPanel() })
  ] });
};
MegaNavigationDesktop.propTypes = {
  InteractionAnalytics: PropTypes.node,
  catalog: PropTypes.object
};
const NotificationBadge = ({ ...props }) => {
  const {
    value,
    notificationClass,
    a11y,
    color = State.ERROR,
    size = Size.SMALL,
    radius = {
      size: Radius.CIRCLE,
      position: Position.ALL
    }
  } = props;
  const customClass = notificationClass ? `${notificationClass} ` : "";
  const componentClass = `${PREFIX}-notification-badge`;
  const radiusPosition = (radius == null ? void 0 : radius.position) === Position.ALL ? "" : `-${radius == null ? void 0 : radius.position}`;
  const showRadius = (radius == null ? void 0 : radius.size) === Radius.NONE ? "" : ` ${componentClass}--${radius == null ? void 0 : radius.size}${radiusPosition}`;
  const defaultA11yLabel = "notification status";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: Role.STATUS,
      "aria-label": (a11y == null ? void 0 : a11y.label) ? a11y.label : defaultA11yLabel,
      className: `${customClass}${componentClass}${showRadius} ${componentClass}__${color} ${componentClass}--${size}`,
      children: [
        (a11y == null ? void 0 : a11y.label) && /* @__PURE__ */ jsx("span", { className: "sr-only", children: a11y == null ? void 0 : a11y.label }),
        /* @__PURE__ */ jsx("span", { "aria-hidden": (a11y == null ? void 0 : a11y.hidden) ? a11y.hidden : false, children: value })
      ]
    }
  );
};
const AccountsDropdown = ({
  accountButton,
  accountOptions,
  accountsLabel,
  featureType,
  isAccountDashboard,
  isDashboard,
  isFlyout,
  isGigyaLoaded,
  isLoggedIn,
  isShowTriangle,
  menuEscapeHandler,
  mobileNavigation,
  onSignInButtonClickHandler,
  orText = "",
  registerLabel = "",
  registerLink = "",
  selectLastMenuItem,
  signInLabel = "",
  signOutButtonClick,
  signOutLabel = "",
  unActivatedOffersCount,
  weeklyOffersLink,
  ctaList,
  isSwapOffersTourComplete
}) => {
  const className2 = `${PREFIX}-pencil-banner`;
  const runOnce = useRef(0);
  const cleanUpRef = useRef(null);
  useEffect(() => {
    var _a;
    if (!isAccountDashboard && runOnce.current === 0) {
      runOnce.current++;
      const menuDropDownParent = isShowTriangle ? "accountsMenuDropDown" : "accountMenuDropDown";
      const menuList = new MenuAccessibility(menuDropDownParent);
      menuList.init(selectLastMenuItem);
      document.addEventListener("keydown", menuEscapeHandler);
      cleanUpRef.current = () => {
        document.removeEventListener("keydown", menuEscapeHandler);
        menuList.destroy();
      };
      (_a = accountButton == null ? void 0 : accountButton.current) == null ? void 0 : _a.focus();
    }
  }, [isAccountDashboard, selectLastMenuItem, menuEscapeHandler, isShowTriangle, accountButton]);
  useEffect(() => {
    return () => {
      const cleanUp = cleanUpRef.current;
      if (cleanUp !== null) {
        cleanUp();
      }
    };
  }, []);
  const renderHorizontalLine = () => isAccountDashboard ? /* @__PURE__ */ jsx("hr", {}) : null;
  const accountOptionsAfterRemovingExtraRecords = () => {
    const isAccountOptions = accountOptions ? accountOptions.length : 0;
    return !isShowTriangle && isAccountOptions > maximumAccountManagementLinks ? accountOptions.slice(0, -(accountOptions.length - maximumAccountManagementLinks)) : accountOptions;
  };
  const showSignIn = () => {
    return !isLoggedIn && (isGigyaLoaded ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: `${className2}__authentication`, children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            role: "menuitem",
            className: `${className2}__authentication--sign-in`,
            onClick: onSignInButtonClickHandler,
            "data-link-value": signInLabel,
            "data-feature-type": featureType,
            children: signInLabel
          }
        ),
        /* @__PURE__ */ jsx("span", { className: `${className2}__middle-text`, children: orText }),
        /* @__PURE__ */ jsx(
          "a",
          {
            role: "menuitem",
            href: registerLink,
            className: `${className2}__authentication--register`,
            "data-link-value": registerLabel,
            "data-feature-type": featureType,
            children: registerLabel
          }
        )
      ] }),
      renderHorizontalLine()
    ] }) : /* @__PURE__ */ jsx("div", { className: `${className2}__sigin-in-skeleton`, children: /* @__PURE__ */ jsx(SkeletonComponent, {}) }));
  };
  const showRewardsSection = () => {
    return !isShowTriangle && /* @__PURE__ */ jsxs(Fragment, { children: [
      showSignIn(),
      renderHorizontalLine()
    ] });
  };
  const renderBadge = useCallback(
    (isWeeklyOffer) => {
      const showBadge = isWeeklyOffer && (unActivatedOffersCount && unActivatedOffersCount !== 0 || isSwapOffersTourComplete);
      if (showBadge) {
        return /* @__PURE__ */ jsx(
          NotificationBadge,
          {
            value: "",
            notificationClass: `${PREFIX}-account-settings__warning`,
            color: State.ERROR,
            size: "none"
          }
        );
      }
      return null;
    },
    [isSwapOffersTourComplete, unActivatedOffersCount]
  );
  const renderMobileNavigation = (items) => {
    return items.map((item, i) => /* @__PURE__ */ jsx(
      "li",
      {
        className: `${className2}__account-options-item${externalNavigation(item.linkUrl) ? "__external" : ""}`,
        children: /* @__PURE__ */ jsxs(
          "a",
          {
            className: `${PREFIX}-xs-inline-block`,
            href: item.linkUrl,
            title: item.linkLabel,
            "data-link-value": item.linkLabel,
            target: `${externalNavigation(item.linkUrl) ? "_blank" : "_self"}`,
            children: [
              item.linkLabel,
              externalNavigation(item.linkUrl) && /* @__PURE__ */ jsx(Icon, { type: "ct-north-east", size: "lg" })
            ]
          }
        )
      },
      i
    ));
  };
  const renderMobileNavigationItems = () => {
    if (isFlyout && !!mobileNavigation) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("h4", { className: `${className2}__header ${PREFIX}-body-lg`, children: mobileNavigation.categoryTitle }),
        /* @__PURE__ */ jsx("ul", { className: `${className2}__account-options`, children: renderMobileNavigation(mobileNavigation.categoryItems) })
      ] });
    }
    return null;
  };
  const accountsDropDownSection = `${className2}__dropdown${isShowTriangle ? "--triangle" : "--dashboard"}`;
  const linkActive = (showDashboad, link) => showDashboad && link.isActive ? `${className2}__account-options-item--active` : "";
  const buttonType = isShowTriangle ? "secondary_reverse" : "secondary";
  const renderCTA = () => {
    return checkDataLength(ctaList) && (ctaList == null ? void 0 : ctaList.map((cta, i) => {
      return renderV2Cta(cta, i);
    }));
  };
  const renderV2Cta = (cta, i) => {
    return /* @__PURE__ */ jsx("div", { className: `${className2}__cta`, children: cta.url ? /* @__PURE__ */ jsxs(
      "a",
      {
        href: cta.url,
        id: cta.id,
        className: `${PREFIX}-button2
                     ${PREFIX}-button2--${cta.variant || "primary"}
                     ${PREFIX}-button2--${cta.variant || "primary"}-${cta.color || "default"}
                     ${PREFIX}-xs-justify-center
                     ${cta.customClass ?? ""}`,
        children: [
          cta.children,
          cta.icon && /* @__PURE__ */ jsx(Icon, { type: "ct-right-arrow-black", size: cta.size })
        ]
      },
      i
    ) : /* @__PURE__ */ jsx(
      ButtonV2,
      {
        variant: Variation.PRIMARY,
        customClass: cta.customClass ? `${cta.customClass} ${PREFIX}-xs-justify-center ${PREFIX}-xs-flex` : "",
        color: cta == null ? void 0 : cta.color,
        size: Size.MEDIUM,
        onClick: cta.onClick,
        reverse: true,
        icon: cta.icon ? { type: "ct-right-arrow-black", size: "lg" } : null,
        a11y: cta.a11y,
        children: cta.children
      },
      i
    ) });
  };
  return /* @__PURE__ */ jsxs("div", { id: "accountsMenuDropDown", "aria-labelledby": "accountButton", className: accountsDropDownSection, children: [
    showRewardsSection(),
    /* @__PURE__ */ jsxs("div", { className: `${className2}__container${isShowTriangle ? "--triangle" : ""}`, children: [
      areAllParamsValid(isFlyout, !!accountsLabel) && /* @__PURE__ */ jsx(
        "h4",
        {
          className: `${isShowTriangle ? `${className2}__header` : `${className2}__section-header`} ${PREFIX}-body-lg`,
          children: accountsLabel
        }
      ),
      Array.isArray(accountOptionsAfterRemovingExtraRecords()) && /* @__PURE__ */ jsx("ul", { className: `${className2}__account-options`, children: accountOptionsAfterRemovingExtraRecords().map((link) => {
        const isWeeklyOffer = Boolean(link.navigationRedirectionLink === weeklyOffersLink);
        return /* @__PURE__ */ jsx(
          "li",
          {
            className: `${linkActive(isDashboard, link)} ${className2}__account-options-item${isShowTriangle && externalNavigation(link.navigationRedirectionLink) ? "__external" : ""}`,
            children: /* @__PURE__ */ jsxs(
              "a",
              {
                "aria-current": linkActive(isDashboard, link) ? "page" : null,
                href: link.navigationRedirectionLink,
                target: link.navigationOptionsTarget,
                "data-link-value": link.navigationOptionsLabel,
                "data-feature-type": featureType,
                className: `${PREFIX}-xs-flex`,
                children: [
                  link.navigationOptionsLabel,
                  isShowTriangle && externalNavigation(link.navigationRedirectionLink) && /* @__PURE__ */ jsx(Icon, { type: "ct-north-east", size: "lg" }),
                  renderBadge(isWeeklyOffer)
                ]
              }
            )
          },
          link.navigationOptionsLabel
        );
      }) }),
      renderMobileNavigationItems(),
      isLoggedIn && /* @__PURE__ */ jsxs(Fragment, { children: [
        renderCTA(),
        /* @__PURE__ */ jsx("div", { className: `${className2}__sign-out`, children: /* @__PURE__ */ jsx(Button, { type: buttonType, size: "mini", onClick: signOutButtonClick, children: signOutLabel }) })
      ] })
    ] })
  ] });
};
const minimumBreadcrumbLength = 1;
const breadcrumbClassName = `${PREFIX}-breadcrumbs`;
const listClassName = `${breadcrumbClassName}__list`;
const listItemClassName = `${breadcrumbClassName}__list-item`;
const pipeItemClassName = `${breadcrumbClassName}__list-item--pipe`;
const listPipeItemClassName = `${listItemClassName} ${pipeItemClassName}`;
const textClassName = `${breadcrumbClassName}__text`;
const linkClassName = `${breadcrumbClassName}__link`;
const breadcrumbGradient = `${breadcrumbClassName}--gradient`;
const listScroll = `${breadcrumbClassName}__list-scroll`;
const breadcrumbListIcon = `${listItemClassName}-icon`;
const breadcrumbLength = 28;
const refNoFollow = (nofollow = false) => nofollow ? { rel: "nofollow" } : {};
const InteractiveLink = ({ link, name, nofollow, ariaLabel, breadCrumbLabel, analyticsValue }) => {
  const dapWacValue = analyticsValue ? analyticsValue : name;
  return /* @__PURE__ */ jsx(
    "a",
    {
      className: linkClassName,
      href: link,
      "data-link-value": name,
      "aria-label": ariaLabel,
      "dap-wac-link": "true",
      "dap-wac-loc": breadCrumbLabel,
      "dap-wac-value": dapWacValue,
      ...refNoFollow(nofollow),
      children: name
    }
  );
};
const NotInteractiveLink = ({ link, name, pName, nofollow }) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("span", { className: "sr-only", "aria-current": "page", children: pName }),
    /* @__PURE__ */ jsx("span", { className: textClassName, "aria-hidden": true, ...refNoFollow(nofollow), children: name }, link)
  ] });
};
const BreadcrumbLink = ({
  link,
  name,
  isLastLinkAndNotInteractive: isLastLinkAndNotInteractive2,
  pName,
  showPipeIcon,
  nofollow,
  index: index2,
  ariaLabel,
  breadCrumbLabel,
  analyticsValue
}) => {
  const isPDPPage = getPageType() === pageTypes.pdpPage;
  const plpBreadcrumbClassName = getPageType() === pageTypes.plp ? `${breadcrumbListIcon}-sm` : "";
  const pdpBreadcrumbClassNames = () => {
    const stickyItemClassName = index2 === 0 ? `${listItemClassName}-sticky` : "";
    const pipeIconClassName = showPipeIcon ? `${breadcrumbListIcon}-pdp ${stickyItemClassName}` : `${breadcrumbListIcon}-sm`;
    return isPDPPage ? pipeIconClassName : `${breadcrumbListIcon}-md`;
  };
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: `${showPipeIcon ? `${listPipeItemClassName}` : `${listItemClassName}`} ${pdpBreadcrumbClassNames()} ${plpBreadcrumbClassName}`,
      children: [
        /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-left", size: "lg" }),
        isLastLinkAndNotInteractive2 ? /* @__PURE__ */ jsx(NotInteractiveLink, { name, link, pName: pName ? pName : ariaLabel, nofollow }) : /* @__PURE__ */ jsx(
          InteractiveLink,
          {
            link,
            name,
            nofollow,
            ariaLabel,
            breadCrumbLabel,
            analyticsValue
          }
        )
      ]
    },
    link
  );
};
const isLastLinkAndNotInteractive = (linksCount, index2, isLastElementInteractive) => index2 === linksCount - minimumBreadcrumbLength && !isLastElementInteractive;
const isPdpOrPlpPage = getPageType() === pageTypes.pdpPage || getPageType() === pageTypes.plp;
const getBreadcrumbName = (name) => {
  return name.length > breadcrumbLength && isPdpOrPlpPage ? `${name.substring(0, breadcrumbLength)}...` : name;
};
const Breadcrumb = ({
  links,
  showPipeIcon,
  isLastElementInteractive,
  breadCrumbLabel,
  analyticsLabel,
  analyticsValue
}) => /* @__PURE__ */ jsx("nav", { className: `${breadcrumbClassName} ${breadcrumbGradient}`, "aria-label": breadCrumbLabel, children: /* @__PURE__ */ jsx("ol", { className: `${listClassName} ${listScroll}`, children: links.map(({ link, name, pName }, index2) => {
  const isLastAndNotInteractive = isLastLinkAndNotInteractive(
    links.length,
    index2,
    isLastElementInteractive
  );
  return /* @__PURE__ */ jsx(
    BreadcrumbLink,
    {
      link,
      ariaLabel: name,
      name: name ? getBreadcrumbName(name) : name,
      isLastLinkAndNotInteractive: isLastAndNotInteractive,
      pName,
      showPipeIcon,
      index: index2,
      breadCrumbLabel: analyticsLabel ? analyticsLabel : breadCrumbLabel,
      analyticsValue
    },
    link
  );
}) }) });
const VideoGalleryViewer = (props) => {
  const {
    videoList,
    windowRef,
    hostNames,
    a11yCarouselPreviousLabel,
    path,
    a11yCarouselNextLabel,
    videoNowPlayingLabel,
    videoAnalytics
  } = props;
  const videoGalleryRef = useRef(null);
  const {
    thumbnailPrevArrowClass,
    thumbnailNextArrowClass,
    thumbnailPlayButtonClass,
    playButtonIcon,
    videoPlayButtonClass
  } = videoGalleryConstants;
  const { prevArrowIcon: prevArrowIcon2, nextArrowIcon: nextArrowIcon2 } = mediaGalleryConstants;
  const playButton = useMemo(
    () => ({
      className: thumbnailPlayButtonClass,
      type: playButtonIcon,
      size: "md"
    }),
    [thumbnailPlayButtonClass, playButtonIcon]
  );
  const prevArrowHrefLink = getImagePath(prevArrowIcon2, path);
  const nextArrowHrefLink = getImagePath(nextArrowIcon2, path);
  const playButtonHrefLink = getImagePath(playButtonIcon, path);
  const [thumbnailImageCount, setThumbnailImageCount] = useState(getThumbnailCount());
  const [showThumbnailButton, setShowThumbnailButton] = useState(false);
  const runOnce = useRef(0);
  const insertDynamicPlayButtons = useCallback((dynamicButton) => {
    const { elementRef, position, className: className2, type, iconHrefLink, size } = dynamicButton;
    elementRef.insertAdjacentHTML(
      position,
      `<svg class='${className2} ${PREFIX}-icon ${PREFIX}-icon-${type} ${PREFIX}-icon--${size}' alt='Play video'>
                <use href=${iconHrefLink} />
            </svg>`
    );
  }, []);
  const handleResize = () => {
    setThumbnailImageCount(getThumbnailCount());
    const thumbnailDiv = document.querySelector(`.${videoGalleryViewerClassName} .snapper_nav .snapper_nav_inner`);
    const showNav = (thumbnailDiv == null ? void 0 : thumbnailDiv.scrollWidth) > (thumbnailDiv == null ? void 0 : thumbnailDiv.clientWidth) ? true : false;
    setShowThumbnailButton(showNav);
  };
  useGlobalResizeEvent(handleResize);
  const addVideoPlayButton = useCallback(
    (elementRef, position) => {
      insertDynamicPlayButtons(
        Object.assign(playButton, {
          elementRef,
          position,
          iconHrefLink: playButtonHrefLink,
          buttonId: "play-button"
        })
      );
    },
    [playButton, insertDynamicPlayButtons, playButtonHrefLink]
  );
  const createVideoGalleryViewer = useCallback(
    (elementRef) => {
      new windowRef.Akamai.AsyncViewer(elementRef.current, {
        items: {
          hostnames: hostNames,
          data: videoList
        }
      });
    },
    [hostNames, videoList, windowRef.Akamai.AsyncViewer]
  );
  const handleVideoPlayButtonClick = useCallback(
    (videoUrl) => {
      const parentVideoDiv = document.querySelectorAll(
        `.${videoGalleryViewerClassName} .snapper_nextprev_contain .snapper_items .snapper_item`
      );
      parentVideoDiv.forEach((ele) => {
        const playIconEle = ele.querySelector(`.${videoPlayButtonClass}`);
        if (playIconEle && !playIconEle.classList.contains("is-hidden")) {
          playIconEle.classList.add("is-hidden");
        }
      });
      videoAnalytics(videoUrl);
    },
    [videoAnalytics, videoPlayButtonClass]
  );
  const handleThumbnailClick = useCallback(
    (elementRef) => {
      const thumbnailDiv = document.querySelectorAll(
        `.${videoGalleryViewerClassName} .snapper_nav .snapper_nav_inner a`
      );
      thumbnailDiv.forEach((thumbEle) => {
        const element = thumbEle.querySelector(".nl-video-gallery-viewer__now-playing");
        const playIconEle = thumbEle.querySelector(`.${videoPlayButtonClass}`);
        if (thumbEle.isEqualNode(elementRef) && !playIconEle.classList.contains("is-hidden")) {
          element.classList.add(`${videoGalleryViewerClassName}__now-playing-visible`);
          playIconEle && playIconEle.classList.add("hide");
        } else {
          element.classList.remove(`${videoGalleryViewerClassName}__now-playing-visible`);
          playIconEle && playIconEle.classList.remove("hide");
        }
      });
    },
    [videoPlayButtonClass]
  );
  const addThumbnailDescription = useCallback(
    (videoListData) => {
      const thumbnailDiv = document.querySelectorAll(
        `.${videoGalleryViewerClassName} .snapper_nav .snapper_nav_inner a`
      );
      const thumbnailDeatils = document.querySelectorAll(`.${videoGalleryViewerClassName}__thumb-category`);
      const thumbnailTitle = document.querySelectorAll(`.${videoGalleryViewerClassName}__thumb-title`);
      thumbnailDeatils == null ? void 0 : thumbnailDeatils.forEach((thumbnail, index2) => {
        thumbnail.remove();
        thumbnailTitle[index2].remove();
      });
      thumbnailDiv.forEach((thumbnail, index2) => {
        var _a, _b;
        const nowPlayingClass = index2 === 0 ? `${videoGalleryViewerClassName}__now-playing-visible` : "";
        const thumbnailImg = thumbnail.querySelector("img");
        thumbnailImg.setAttribute("aria-hidden", "true");
        thumbnail.insertAdjacentHTML(
          "beforeend",
          `<span class="${videoGalleryViewerClassName}__thumb-category"><span class="${videoGalleryViewerClassName}__now-playing ${nowPlayingClass}">${videoNowPlayingLabel} . </span>${(_a = videoListData[index2]) == null ? void 0 : _a.category}</span><p class="${videoGalleryViewerClassName}__thumb-title">${(_b = videoListData[index2]) == null ? void 0 : _b.title}</p>`
        );
        addVideoPlayButton(thumbnail, "beforeend");
        if (index2 === 0) {
          const playIconEle = thumbnail.querySelector(`.${videoPlayButtonClass}`);
          playIconEle == null ? void 0 : playIconEle.classList.add("hide");
        }
        thumbnail.addEventListener("click", () => handleThumbnailClick(thumbnail));
      });
      const parentVideoDiv = document.querySelectorAll(
        `.${videoGalleryViewerClassName} .snapper_nextprev_contain .snapper_items .snapper_item`
      );
      const videoDetailsDiv = document.querySelectorAll(
        `.${videoGalleryViewerClassName} .snapper_nextprev_contain .snapper_items .snapper_item .${videoGalleryViewerClassName}__videoDetails`
      );
      if (videoDetailsDiv) {
        videoDetailsDiv.forEach((ele) => ele.remove());
      }
      parentVideoDiv.forEach((video, index2) => {
        var _a, _b, _c, _d;
        const videoUrl = (_a = videoListData[index2]) == null ? void 0 : _a.url;
        const videoEle = video.querySelector("video");
        addVideoPlayButton(videoEle, "afterend");
        video.insertAdjacentHTML(
          "beforeend",
          `<div class="${videoGalleryViewerClassName}__videoDetails"><span class="${videoGalleryViewerClassName}__category">${(_b = videoListData[index2]) == null ? void 0 : _b.category}</span><p class="${videoGalleryViewerClassName}__video-info"><span class="${videoGalleryViewerClassName}__title">${(_c = videoListData[index2]) == null ? void 0 : _c.title}</span><span class="${videoGalleryViewerClassName}__description">${(_d = videoListData[index2]) == null ? void 0 : _d.description}</span></p></div>`
        );
        video.addEventListener("click", () => handleVideoPlayButtonClick(videoUrl));
      });
    },
    [
      addVideoPlayButton,
      handleThumbnailClick,
      handleVideoPlayButtonClick,
      videoNowPlayingLabel,
      videoPlayButtonClass
    ]
  );
  const addThumbnailArrows = useCallback(() => {
    const thumbnailDiv = document.querySelector(`.${videoGalleryViewerClassName} .snapper_nav`);
    if (thumbnailDiv) {
      addNavigationArrowButtons(
        thumbnailDiv,
        "video-thumb-prev-arrow-id",
        "video-thumb-next-arrow-id",
        prevArrowHrefLink,
        nextArrowHrefLink,
        a11yCarouselPreviousLabel,
        a11yCarouselNextLabel,
        thumbnailPrevArrowClass,
        thumbnailNextArrowClass
      );
      document.querySelector("#video-thumb-prev-arrow-id").addEventListener(
        "click",
        () => thumbnailArrowClick(true, thumbnailImageCount, videoGalleryViewerClassName)
      );
      document.querySelector("#video-thumb-next-arrow-id").addEventListener(
        "click",
        () => thumbnailArrowClick(false, thumbnailImageCount, videoGalleryViewerClassName)
      );
    }
  }, [
    prevArrowHrefLink,
    nextArrowHrefLink,
    a11yCarouselPreviousLabel,
    a11yCarouselNextLabel,
    thumbnailPrevArrowClass,
    thumbnailNextArrowClass,
    thumbnailImageCount
  ]);
  useEffect(() => {
    if (isArrayNotEmpty(videoList) && windowRef.Akamai) {
      createVideoGalleryViewer(videoGalleryRef);
      addThumbnailDescription(videoList);
      const snapperPane = document.querySelector(".nl-video-gallery-viewer .snapper_pane");
      snapperPane == null ? void 0 : snapperPane.removeAttribute("tabindex");
    }
  }, [videoList, windowRef.Akamai, addThumbnailDescription, createVideoGalleryViewer]);
  useEffect(() => {
    if (isArrayNotEmpty(videoList) && windowRef.Akamai && videoList.length > thumbnailImageCount && runOnce.current === 0) {
      addThumbnailArrows();
      setShowThumbnailButton(true);
      runOnce.current = 1;
    }
  }, [videoList, windowRef.Akamai, addThumbnailArrows, thumbnailImageCount]);
  useEffect(() => {
    const navButtons = document.querySelectorAll(`.${videoGalleryViewerClassName} .snapper_nav button`);
    if (showThumbnailButton) {
      navButtons.forEach((el) => el.classList.remove("hide"));
    } else {
      navButtons.forEach((el) => el.classList.add("hide"));
    }
  }, [showThumbnailButton]);
  return /* @__PURE__ */ jsx("div", { className: `${videoGalleryViewerClassName}`, "data-testid": "video-gallery", children: /* @__PURE__ */ jsx("div", { "data-akamai-viewer": true, ref: videoGalleryRef, className: `${videoGalleryViewerClassName}` }) });
};
VideoGalleryViewer.propTypes = {
  windowRef: PropTypes.any,
  hostNames: PropTypes.array,
  path: PropTypes.string,
  a11yCarouselNextLabel: PropTypes.string,
  a11yCarouselPreviousLabel: PropTypes.string,
  videoList: PropTypes.array,
  videoNowPlayingLabel: PropTypes.string,
  videoAnalytics: PropTypes.func
};
const refDisplayName = "ReferenceComponent";
const ReferenceComponent = React.forwardRef(
  (props, ref) => {
    const { htmlStr, renderReactComponent } = props;
    const previousHtmlStr = usePrevious(htmlStr);
    const stripScriptsTag = (targetedScript) => {
      const result = targetedScript.replace(/<script\b[^>]*>/g, "");
      return result.replace(/<\/script\b[^>]*>/g, "");
    };
    useEffect(() => {
      !!htmlStr && htmlStr !== previousHtmlStr && renderReactComponent(htmlStr);
      const extractScriptRegex = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g;
      if (htmlStr.includes("script")) {
        const extractScript = htmlStr.match(extractScriptRegex);
        (extractScript == null ? void 0 : extractScript.length) && extractScript.map((targetedScript) => {
          const scriptContent = stripScriptsTag(targetedScript);
          Function(scriptContent)();
        });
      }
    }, [htmlStr, previousHtmlStr, renderReactComponent]);
    return /* @__PURE__ */ jsx("div", { ref, dangerouslySetInnerHTML: { __html: htmlStr } });
  }
);
ReferenceComponent.displayName = refDisplayName;
ReferenceComponent.propTypes = {
  htmlStr: PropTypes.string.isRequired,
  renderReactComponent: PropTypes.func.isRequired
};
const CommonStatusToast = ({ ...props }) => {
  const toastCTAClickHandler = (event) => {
    addModalAttribute(event);
    props.toastCTAHandler();
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-warning-toast ${PREFIX}-warning-toast__${props.bgType}`,
      role: "alert",
      "aria-atomic": "true",
      children: [
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-warning-toast__text-container`, children: [
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-warning-toast__icon`, children: /* @__PURE__ */ jsx(Icon, { type: props.icon, size: "lg" }) }),
          /* @__PURE__ */ jsx("p", { className: `${PREFIX}-warning-toast__label`, dangerouslySetInnerHTML: { __html: props.label } })
        ] }),
        !!props.urlLabel && /* @__PURE__ */ jsx("a", { href: props.url, title: props.urlLabel, "aria-label": props.urlA11yLabel, children: props.urlLabel }),
        !!props.checkNearByText && /* @__PURE__ */ jsx(Button, { type: "primary", size: "mini", onClick: toastCTAClickHandler, buttonType: "button", children: props.checkNearByText }),
        !!props.linkCTAText && /* @__PURE__ */ jsx(
          "button",
          {
            className: `${PREFIX}__item-status-cta-link`,
            type: "button",
            "data-qm-allow": "true",
            onClick: props.linkCTAHandler,
            children: props.linkCTAText
          }
        )
      ]
    }
  );
};
CommonStatusToast.propTypes = {
  icon: PropTypes.string.isRequired,
  bgType: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checkNearByText: PropTypes.string,
  toastCTAHandler: PropTypes.func,
  linkCTAText: PropTypes.string,
  linkCTAHandler: PropTypes.func,
  isAddOn: PropTypes.bool,
  actionCTAHandler: PropTypes.func
};
const LanguageToggle = ({ ...props }) => {
  const { languageLabel, alternateLanguageA11y, getAlternateUrl, featureType, fontStyle } = props;
  const font = fontStyle ? `${fontStyle}` : "";
  const onClickHandler = (event) => {
    event.preventDefault();
    document.cookie = `preferred-language=${languageLabel.toLowerCase()}`;
    window.location.href = encodeURI(getAlternateUrl());
  };
  return !checkEmptyValue(languageLabel) ? /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: getAlternateUrl(), children: (memoizedStringContent) => /* @__PURE__ */ jsx(
    "a",
    {
      className: `${PREFIX}-pencil-banner__language ${font}`,
      href: memoizedStringContent,
      onClick: onClickHandler,
      "aria-label": alternateLanguageA11y,
      "data-link-value": languageLabel,
      "data-feature-type": featureType,
      lang: getLanguage(),
      children: languageLabel
    }
  ) }) : null;
};
LanguageToggle.propTypes = {
  languageLabel: PropTypes.string,
  alternateLanguageA11y: PropTypes.string,
  getAlternateUrl: PropTypes.func,
  featureType: PropTypes.string,
  fontStyle: PropTypes.string
};
const CategoryCard = (props) => {
  const {
    href,
    linkTarget,
    image,
    label,
    cardClicked,
    linkClass,
    imageClass,
    labelClass,
    cardKeyDown,
    sectionTitle,
    isPdpCategoryCarousel,
    categoryId,
    categoryCardClicked,
    buttonClass,
    buttonImgClass,
    buttonLabelClass,
    labelLineClampClass,
    imageDataComponentName
  } = props;
  const tileRef = useRef();
  useEffect(() => {
    if (tileRef && props.imagePolicies) {
      props.imagePolicies(tileRef.current);
    }
  }, [tileRef, props]);
  return isPdpCategoryCarousel ? /* @__PURE__ */ jsxs(
    Button,
    {
      modifierClass: buttonClass,
      ariaLabel: label,
      type: "tertiary",
      onClick: () => categoryCardClicked(label, categoryId, href),
      children: [
        /* @__PURE__ */ jsx(
          "img",
          {
            ref: tileRef,
            "data-component-name": "dynamic-category-featured-list",
            src: image,
            alt: "",
            className: buttonImgClass
          }
        ),
        /* @__PURE__ */ jsx("span", { className: buttonLabelClass, children: label })
      ]
    }
  ) : /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: href, children: (memoizedStringContent) => /* @__PURE__ */ jsxs(
    "a",
    {
      target: linkTarget,
      onClick: () => cardClicked(label),
      onKeyDown: (event) => cardKeyDown(event),
      className: linkClass,
      "data-testid": "category-link",
      href: memoizedStringContent,
      "dap-wac-link": "true",
      "dap-wac-loc": sectionTitle,
      "dap-wac-value": label,
      children: [
        /* @__PURE__ */ jsx(
          "img",
          {
            ref: tileRef,
            "data-component-name": imageDataComponentName ? `${imageDataComponentName}` : "dynamic-category-featured-list",
            src: image,
            alt: "",
            className: imageClass
          }
        ),
        /* @__PURE__ */ jsx("span", { className: labelClass, children: labelLineClampClass ? /* @__PURE__ */ jsx("span", { className: labelLineClampClass, children: label }) : label })
      ]
    }
  ) });
};
CategoryCard.propTypes = {
  href: PropTypes.string,
  linkTarget: PropTypes.string,
  image: PropTypes.string,
  label: PropTypes.string,
  cardClicked: PropTypes.func,
  linkClass: PropTypes.string,
  imageClass: PropTypes.string,
  labelClass: PropTypes.string,
  imagePolicies: PropTypes.func
};
const VehicleBanner = (props) => {
  var _a, _b;
  const [titleCtasState, setTitleCtasState] = useState({});
  const { isAdditionalInfo, setDefaultSelectedCard } = props;
  const prevDefaultCtasStateRef = useRef({});
  const prevIsTiresDataAvailable = useRef(props.isTiresDataAvailable);
  const flyOutRef = useRef();
  const noBorderBannerClass = props.bannerType !== BannerType$1.PartialFit ? `${PREFIX}-vehicle-banner__no-border` : "";
  const additionalInfoClass = props.isAdditionalInfo ? `${PREFIX}-vehicle-banner__additional-info` : noBorderBannerClass;
  useEffect(() => {
    if (prevDefaultCtasStateRef.current !== props.defaultCtasState || prevIsTiresDataAvailable.current !== props.isTiresDataAvailable) {
      const prevCtaState = props.isTiresDataAvailable ? { 0: false } : titleCtasState;
      setTitleCtasState({ ...prevCtaState, ...props.defaultCtasState });
      prevDefaultCtasStateRef.current = props.defaultCtasState;
      prevIsTiresDataAvailable.current = props.isTiresDataAvailable;
    }
  }, [props.defaultCtasState, props.isTiresDataAvailable, titleCtasState]);
  useEffect(() => {
    if (Object.keys(titleCtasState).length && isAdditionalInfo) {
      setDefaultSelectedCard("");
    }
  }, [titleCtasState, isAdditionalInfo, setDefaultSelectedCard]);
  const titleCtaAction = (ctaIndex, state) => {
    var _a2;
    setTitleCtasState({ [0]: !state, [ctaIndex]: state });
    (_a2 = props == null ? void 0 : props.closeClickHandler) == null ? void 0 : _a2.call(props, true);
  };
  const getVehicleBannerIcon = () => {
    return props.bannerType === BannerType$1.NotFit ? (
      // eslint-disable-next-line sonar/no-nested-conditional
      props.isAdditionalInfo ? /* @__PURE__ */ jsx(Icon, { type: "ct-notification-caution", size: "lg" }) : props.pageType === pageTypes$1.pdpPage && /* @__PURE__ */ jsx(Icon, { type: "ct-toast-error", size: "lg" })
    ) : (
      // eslint-disable-next-line sonar/no-nested-conditional
      props.bannerType === BannerType$1.PartialFit ? /* @__PURE__ */ jsx(Icon, { type: "ct-notification-caution", size: "lg" }) : !props.isNotShowIcon && /* @__PURE__ */ jsx(Icon, { type: "ct-notification-success", size: "lg" })
    );
  };
  const closeHandler = () => {
    setTitleCtasState({});
    props == null ? void 0 : props.closeManageVehiclesDropdown();
  };
  useClickOutsideClose(flyOutRef, closeHandler, !props.showPackageInfoPopup, true);
  const toggleVehicleSelectorBannerVisibility = () => {
    if (!props.hideVehicleSelectorBannerState) {
      const margingClasss = props.pageType === pageTypes$1.pdpPage && `${PREFIX}-pdp-margin`;
      return `${PREFIX}-vehicle-banner ${margingClasss}`;
    } else {
      return `${PREFIX}-xs-none`;
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-container`, children: (_a = props.showVehicleInfo) == null ? void 0 : _a.call(props) }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classnames(
          props.pageType !== pageTypes$1.pdpPage && additionalInfoClass,
          `${PREFIX}-full-width-container`,
          {
            [`${PREFIX}-vehicle-banner--may-not-fit`]: props.bannerType === BannerType$1.PartialFit,
            [`${PREFIX}-vehicle-banner--not-fit`]: props.bannerType === BannerType$1.NotFit && props.pageType === pageTypes$1.pdpPage,
            [`${PREFIX}-vehicle-banner--margin-remove`]: !!props.isPackageFlow || props.pageType === pageTypes$1.pdpPage
          },
          toggleVehicleSelectorBannerVisibility()
        ),
        children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-container`, children: [
          getVehicleBannerIcon() && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-icon-container`, children: getVehicleBannerIcon() }),
          /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-text-container`, children: [
            /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-text-container-banner`, children: [
              /* @__PURE__ */ jsxs("section", { children: [
                /* @__PURE__ */ jsx("div", { className: `${PREFIX}-text-container-banner-heading`, children: props.title }),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: `${PREFIX}-ctas-container ${props.isAdditionalInfo ? `${PREFIX}-ctas-container__additional-info` : ""}`,
                    children: props == null ? void 0 : props.ctas.map((cta, index2) => {
                      const { AfterActionUi } = cta;
                      return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-ctas-container__cta-container`, children: [
                        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-ctas-container__button-group`, children: /* @__PURE__ */ jsxs(
                          Button,
                          {
                            id: (cta == null ? void 0 : cta.ctaId) ? cta == null ? void 0 : cta.ctaId : "title-btn",
                            type: "tertiary",
                            onClick: (cta == null ? void 0 : cta.ctaAction) ? cta.ctaAction : () => {
                              titleCtaAction(
                                `${index2}`,
                                !titleCtasState[`${index2}`]
                              );
                            },
                            children: [
                              cta.text,
                              cta.ctaType === CtaType.dropDown ? /* @__PURE__ */ jsx(
                                Icon,
                                {
                                  type: titleCtasState[`${index2}`] ? "ct-chevron-up" : "ct-chevron-down",
                                  size: "lg"
                                }
                              ) : ""
                            ]
                          }
                        ) }),
                        titleCtasState[`${index2}`] && AfterActionUi ? /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: `${PREFIX}-ctas-container__action-ui-container`,
                            ref: flyOutRef,
                            children: /* @__PURE__ */ jsx(AfterActionUi, { index: index2, ...cta.uiProps })
                          }
                        ) : ""
                      ] }, index2);
                    })
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs("section", { children: [
                props.showSubtitle ? /* @__PURE__ */ jsx("span", { className: `${PREFIX}-vehicle-banner__disclaimer-text`, children: props.subTitle }) : null,
                /* @__PURE__ */ jsx("div", { className: `${PREFIX}-ctas-container`, children: (_b = props == null ? void 0 : props.subCtas) == null ? void 0 : _b.map((cta, index2) => {
                  const { AfterActionUi } = cta;
                  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-ctas-container__view-button`, children: [
                    /* @__PURE__ */ jsx(
                      Button,
                      {
                        id: "sub-title-btn",
                        type: "tertiary",
                        onClick: () => {
                          var _a2;
                          (_a2 = cta == null ? void 0 : cta.ctaAction) == null ? void 0 : _a2.call(cta);
                        },
                        children: cta.text
                      }
                    ),
                    AfterActionUi ? /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: `${PREFIX}-ctas-container__action-ui-container-disclaimer`,
                        children: /* @__PURE__ */ jsx(AfterActionUi, { index: index2, ...cta.uiProps })
                      }
                    ) : ""
                  ] }, index2);
                }) })
              ] })
            ] }),
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-vehicle-banner__auto-service-button`, children: props.renderAutoAppointmentButton() })
          ] })
        ] })
      }
    )
  ] });
};
VehicleBanner.propTypes = {
  bannerType: PropTypes.oneOf(Object.values(BannerType$1)),
  title: PropTypes.string,
  subTitle: PropTypes.string,
  showSubtitle: PropTypes.bool,
  ctas: PropTypes.any,
  subCtas: PropTypes.any,
  defaultCtasState: PropTypes.any,
  showVehicleInfo: PropTypes.func,
  isNotShowIcon: PropTypes.bool,
  isAdditionalInfo: PropTypes.bool,
  closeClickHandler: PropTypes.func,
  pageType: PropTypes.string,
  isPackageFlow: PropTypes.bool,
  hideVehicleSelectorBannerState: PropTypes.bool,
  renderAutoAppointmentButton: PropTypes.func.isRequired,
  setDefaultSelectedCard: PropTypes.func,
  isTiresDataAvailable: PropTypes.bool,
  showPackageInfoPopup: PropTypes.bool
};
const VehicleHeader = (props) => {
  const newVehicleBannerClass = `${PREFIX}-vehicle-banner`;
  return /* @__PURE__ */ jsxs("div", { className: `${newVehicleBannerClass}__details__header`, children: [
    /* @__PURE__ */ jsx("div", { className: `${newVehicleBannerClass}__details__header__sub-title`, children: props.shoppingForTitle }),
    /* @__PURE__ */ jsx("h2", { className: `${newVehicleBannerClass}__details__header__title`, children: props.vehicleDetails })
  ] });
};
VehicleHeader.propTypes = {
  shoppingForTitle: PropTypes.string.isRequired,
  vehicleDetails: PropTypes.string.isRequired
};
VehicleHeader.displayName = "VehicleHeader";
var BannerType = /* @__PURE__ */ ((BannerType2) => {
  BannerType2["Fit"] = "Fit";
  BannerType2["PartialFit"] = "PartialFit";
  BannerType2["NotFit"] = "NotFit";
  BannerType2["Unknown"] = "UnKnown";
  return BannerType2;
})(BannerType || {});
const NewVehicleBanner = (props) => {
  var _a;
  const [titleCtasState, setTitleCtasState] = useState({});
  const { isAdditionalInfo, setDefaultSelectedCard } = props;
  const prevDefaultCtasStateRef = useRef({});
  const prevIsTiresDataAvailable = useRef(props.isTiresDataAvailable);
  const flyOutRef = useRef();
  const newVehicleBannerClass = `${PREFIX}-vehicle-banner`;
  useEffect(() => {
    if (prevDefaultCtasStateRef.current !== props.defaultCtasState || prevIsTiresDataAvailable.current !== props.isTiresDataAvailable) {
      const prevCtaState = props.isTiresDataAvailable ? { 0: false } : titleCtasState;
      setTitleCtasState({ ...prevCtaState, ...props.defaultCtasState });
      prevDefaultCtasStateRef.current = props.defaultCtasState;
      prevIsTiresDataAvailable.current = props.isTiresDataAvailable;
    }
  }, [props.defaultCtasState, props.isTiresDataAvailable, titleCtasState]);
  useEffect(() => {
    if (Object.keys(titleCtasState).length && isAdditionalInfo) {
      setDefaultSelectedCard("");
    }
  }, [titleCtasState, isAdditionalInfo, setDefaultSelectedCard]);
  const manageVehiclesButton = document.getElementById("manage-vehicles");
  const titleCtaAction = (ctaIndex, state) => {
    var _a2;
    setTitleCtasState({ [0]: !state, [ctaIndex]: state });
    (_a2 = props == null ? void 0 : props.closeClickHandler) == null ? void 0 : _a2.call(props, true);
    manageVehiclesButton == null ? void 0 : manageVehiclesButton.setAttribute("aria-expanded", "true");
  };
  const closeHandler = () => {
    setTitleCtasState({});
    props == null ? void 0 : props.closeManageVehiclesDropdown();
    manageVehiclesButton == null ? void 0 : manageVehiclesButton.setAttribute("aria-expanded", "false");
  };
  useClickOutsideClose(flyOutRef, closeHandler, !props.showPackageInfoPopup, true);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: !props.hideVehicleSelectorBannerState ? newVehicleBannerClass : `${PREFIX}-xs-none`, children: [
    !((_a = props.vehicleDetails) == null ? void 0 : _a.replace(allWhitespace, "")) ? /* @__PURE__ */ jsxs("div", { className: `${newVehicleBannerClass}__not-fit-label`, children: [
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, { type: "ct-notification-caution", size: "lg" }) }),
      /* @__PURE__ */ jsx("div", { className: `${newVehicleBannerClass}__not-fit-label__text`, children: props.mayNotFitLabel })
    ] }) : /* @__PURE__ */ jsxs("div", { className: `${newVehicleBannerClass}__details`, children: [
      /* @__PURE__ */ jsx("div", { children: props.vehicleImage ? /* @__PURE__ */ jsx(
        "img",
        {
          src: props.vehicleImage,
          alt: props.vehicleImageAltText,
          className: `${newVehicleBannerClass}__image`
        }
      ) : /* @__PURE__ */ jsx("div", { className: `${newVehicleBannerClass}__default-image`, children: /* @__PURE__ */ jsx(Icon, { type: props.defaultImage, size: "lg" }) }) }),
      /* @__PURE__ */ jsx(
        VehicleHeader,
        {
          shoppingForTitle: props.shoppingForTitle,
          vehicleDetails: props.vehicleDetails
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: `${newVehicleBannerClass}__buttons`, children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-ctas-container ${props.isAdditionalInfo ? `${PREFIX}-ctas-container__additional-info` : ""}`,
          children: props == null ? void 0 : props.ctas.map((cta, index2) => {
            const { AfterActionUi } = cta;
            return /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  id: (cta == null ? void 0 : cta.ctaId) ? cta == null ? void 0 : cta.ctaId : "title-btn",
                  type: "secondary",
                  size: "small",
                  ariaExpanded: false,
                  onClick: (cta == null ? void 0 : cta.ctaAction) ? cta.ctaAction : () => {
                    titleCtaAction(`${index2}`, !titleCtasState[`${index2}`]);
                  },
                  children: cta.text
                }
              ),
              titleCtasState[`${index2}`] && AfterActionUi ? /* @__PURE__ */ jsx(
                "div",
                {
                  className: `${PREFIX}-ctas-container__action-ui-container`,
                  ref: flyOutRef,
                  children: /* @__PURE__ */ jsx(AfterActionUi, { index: index2, ...cta.uiProps })
                }
              ) : ""
            ] });
          })
        }
      ),
      /* @__PURE__ */ jsx("div", { className: `${newVehicleBannerClass}__buttons__appointemnt`, children: props.renderAutoAppointmentButton() })
    ] })
  ] }) });
};
NewVehicleBanner.displayName = "NewVehicleBanner";
NewVehicleBanner.propTypes = {
  bannerType: PropTypes.oneOf(Object.values(BannerType)),
  title: PropTypes.string,
  subTitle: PropTypes.string,
  showSubtitle: PropTypes.bool,
  ctas: PropTypes.any,
  subCtas: PropTypes.any,
  defaultCtasState: PropTypes.any,
  showVehicleInfo: PropTypes.func,
  isNotShowIcon: PropTypes.bool,
  isAdditionalInfo: PropTypes.bool,
  closeClickHandler: PropTypes.func,
  pageType: PropTypes.string,
  isPackageFlow: PropTypes.bool,
  hideVehicleSelectorBannerState: PropTypes.bool,
  renderAutoAppointmentButton: PropTypes.func.isRequired,
  setDefaultSelectedCard: PropTypes.func,
  isTiresDataAvailable: PropTypes.bool,
  showPackageInfoPopup: PropTypes.bool,
  defaultImage: PropTypes.string,
  vehicleImage: PropTypes.string,
  vehicleImageAltText: PropTypes.string,
  shoppingForTitle: PropTypes.string,
  vehicleDetails: PropTypes.string
};
NewVehicleBanner.displayName = "NewVehicleBanner";
const FullPageSpinner = ({ ...props }) => {
  const { showSpinner, spinnerCounter, globalSpinnerColor, style = SpinnerStyle.DEFAULT, value } = props;
  return showSpinner || spinnerCounter > 0 ? /* @__PURE__ */ jsxs("div", { role: "alert", className: `${PREFIX}-spinner__full`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-spinner__backdrop` }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-spinner__content`, children: [
      /* @__PURE__ */ jsx("span", { className: "sr-only", children: props.a11yLoadingSpinnerLabel }),
      /* @__PURE__ */ jsx(Spinner, { color: globalSpinnerColor, style, value })
    ] })
  ] }) : null;
};
FullPageSpinner.displayName = "FullPageSpinnerInLib";
const InformationModal = ({ ...props }) => {
  const {
    closeInformationModal,
    isInformationModalOpen,
    enableOutSideClick,
    path,
    tabs,
    title,
    subtitle,
    description,
    indexSelected,
    a11yCloseIconLabel
  } = props;
  const unity = 1;
  const [selectedIndex, setSelectedIndex] = useState(indexSelected || unity);
  const componentClassName2 = `${PREFIX}-information-modal`;
  const contentRef = useRef(null);
  const modalClassName = `${PREFIX}-react-modal`;
  const previousElement = document.querySelector(`button[${previousElementName}]`);
  const onInformationModal = () => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    closeInformationModal();
    if (previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  useClickOutsideClose(contentRef, () => onInformationModal(), isInformationModalOpen, enableOutSideClick);
  return /* @__PURE__ */ jsx(ReactModal, { closeHandler: () => onInformationModal(), isOpen: isInformationModalOpen, children: /* @__PURE__ */ jsxs("div", { className: componentClassName2, ref: contentRef, children: [
    /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__close-container`, children: /* @__PURE__ */ jsx(
      Button,
      {
        id: "info-button",
        type: "icon_button",
        ariaLabel: a11yCloseIconLabel,
        onClick: () => onInformationModal(),
        children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg", path })
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("h1", { className: `${componentClassName2}__header-text`, children: title }),
      tabs ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__tabs`, children: tabs.map((item, index2) => {
          const activeClass = selectedIndex === index2 ? `${componentClassName2}__tab-button--active` : "";
          return /* @__PURE__ */ jsx(
            "div",
            {
              className: `${componentClassName2}__tab-button ${activeClass}`,
              role: "button",
              tabIndex: 0,
              onKeyDown: () => {
                setSelectedIndex(index2);
              },
              onClick: () => {
                setSelectedIndex(index2);
              },
              children: item.tabTitle
            },
            index2
          );
        }) }),
        /* @__PURE__ */ jsx("div", { children: tabs[selectedIndex].tableData ? /* @__PURE__ */ jsx(
          Table,
          {
            tableType: "stripped",
            headerType: "column",
            tableData: tabs[selectedIndex].tableData
          }
        ) : /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__text-container`, children: [
          /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__subtitle`, children: tabs[selectedIndex].subtitle }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: `${componentClassName2}__content`,
              dangerouslySetInnerHTML: { __html: tabs[selectedIndex].description }
            }
          )
        ] }) })
      ] }) : /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__text-container`, children: [
        /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__subtitle`, children: subtitle }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `${componentClassName2}__content`,
            dangerouslySetInnerHTML: { __html: description }
          }
        )
      ] })
    ] })
  ] }) });
};
InformationModal.displayName = "InformationModal";
InformationModal.defaultProps = {
  enableOutSideClick: false
};
InformationModal.propTypes = {
  closeInformationModal: PropTypes.func,
  isInformationModalOpen: PropTypes.bool,
  enableOutSideClick: PropTypes.bool,
  indexSelected: PropTypes.number,
  path: PropTypes.string,
  tabs: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string
};
const InlineToast = ({ ...props }) => {
  const componentClass = `${PREFIX}-inline-toast`;
  const {
    a11y,
    id,
    orientation,
    gap,
    type = Variation.SECONDARY,
    state = State.INFO,
    children,
    ctaList = {
      position: Position.RIGHT,
      isInline: true
    },
    iconConfigs = {
      includesIcon: true,
      gap: Size.SMALL
    }
  } = props;
  const toastTypeClass = `${componentClass}--${type}`;
  const toastStateClass = `${componentClass}--${state}`;
  const toastContentClass = `${PREFIX}-xs-flex ${PREFIX}-sm-align-items-center ${PREFIX}-xs-align-items-start`;
  const toastContentGapClass = iconConfigs.gap !== Display.NONE ? ` ${componentClass}__content--gap-${iconConfigs.gap}` : "";
  const ctaNotInlinePosition = () => {
    if (ctaList.isInline) {
      return `${PREFIX}-xs-justify-flex-end`;
    } else {
      switch (ctaList.position) {
        case Position.LEFT:
          return `${PREFIX}-xs-justify-start`;
        case Position.CENTER:
          return `${PREFIX}-xs-justify-center`;
        default:
          return `${PREFIX}-xs-justify-flex-end`;
      }
    }
  };
  const iconToastPositionClass = () => (iconConfigs == null ? void 0 : iconConfigs.position) === Position.CENTER ? "center" : "start";
  const toastIconState = () => (iconConfigs == null ? void 0 : iconConfigs.customIcon) ? iconConfigs == null ? void 0 : iconConfigs.customIcon : getIconState(state);
  const toastContentOrientation = () => orientation === Direction.VERTICAL ? ` ${PREFIX}-xs-column` : "";
  const getToastGapClass = () => {
    const inlineClass = `${PREFIX}-xs-justify-space-between ${PREFIX}-sm-flex-nowrap ${PREFIX}-xs-flex-wrap`;
    const columnClass = `${PREFIX}-xs-column`;
    const defaultGap = gap !== Display.NONE ? ` ${componentClass}--gap-${gap}` : "";
    const componentGap = gap ? defaultGap : ` ${componentClass}--gap-${Size.MEDIUM}`;
    return `${PREFIX}-xs-flex ${ctaList.isInline ? inlineClass : columnClass}${componentGap}`;
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id,
      className: `${componentClass} ${getToastGapClass()} ${toastTypeClass} ${toastStateClass}`,
      "aria-atomic": (a11y == null ? void 0 : a11y.atomic) ? a11y == null ? void 0 : a11y.atomic : true,
      "aria-live": (a11y == null ? void 0 : a11y.live) ? a11y == null ? void 0 : a11y.live : Live.ASSERTIVE,
      role: (a11y == null ? void 0 : a11y.role) ? a11y == null ? void 0 : a11y.role : Role.ALERT,
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${componentClass}__content${toastContentGapClass}${toastContentOrientation()} ${toastContentClass}`,
            children: [
              iconConfigs.includesIcon && /* @__PURE__ */ jsx(
                "div",
                {
                  className: `${componentClass}__icon--wrapper ${PREFIX}-sm-align-content-${iconToastPositionClass()}`,
                  children: /* @__PURE__ */ jsx(Icon, { size: "lg", type: toastIconState() })
                }
              ),
              children
            ]
          }
        ),
        (ctaList == null ? void 0 : ctaList.cta) && /* @__PURE__ */ jsx(
          ButtonGroup,
          {
            position: Position.CENTER,
            isWrap: false,
            gap: ctaList.gap || Size.MEDIUM,
            customClass: ctaNotInlinePosition(),
            children: ctaList == null ? void 0 : ctaList.cta
          }
        )
      ]
    }
  );
};
const AutomotiveProductCard = (props) => {
  var _a, _b;
  const {
    productData,
    checkoutButtonClick,
    saveForLaterTitle,
    a11yRemoveLabel,
    a11yWishlistIcon,
    saveForLaterFlagEnabled,
    addItemToSaveForLater,
    addItemToWishlist,
    onRemoveCartItem,
    getEntriesInfo,
    isShoppingCartPage,
    betweenLabel,
    betweenLabelOrderConf,
    betweenLabelSTH,
    receiveBetweenLabel,
    removeitemFromWishlist,
    isBulk,
    isShowedEstimatedDeliveryDateBetween,
    estimatedDeliveryDateBetween,
    // pickAtStoreCTALabel,
    // changeShipToHomeCTALabel,
    // onChangeFulfillmentOption,
    // onlineOrdering,
    errorAnalyticsForInlineToast,
    setErrorInfoHandler,
    updateCartData,
    cartItemAnalytics,
    wishlistProducts,
    isAuthUser,
    cartPageLink,
    loginPageLink,
    productsRequirePackageCreationMessage,
    productWheelType,
    packagedItem,
    isCartPackageToggle,
    createNewPackageLabelTire,
    createNewPackageLabelWheel,
    createNewPackageCTATire,
    createNewPackageCTAWheel,
    enableSingleSignOn,
    ssoHandler,
    createPackageAndNavigate,
    a11yCloseIconLabel,
    appliedPromoPrefix,
    a11yTooltipIcon,
    isWishList,
    enableShowPromotionsAndRomanceCopy,
    saleEndDaySoonMessage,
    hideSaleEndDaySoonMessage,
    saleEndDisableShift,
    isPriceRangeViewEnabled = false,
    shouldShowAoaMessage = false
  } = props;
  const { salePriceEndDate, isOnSale, isUrgentLowStock } = productData;
  const [quantity, setQuantity] = useState(productData.quantity);
  const { fulfillment, estimatedDeliveryDate } = productData;
  const [inlineToastError, setInlineToastError] = useState(false);
  const specificationsArr = filterSpecification(
    productData == null ? void 0 : productData.specifications,
    (_a = props.specificationsFromProps) == null ? void 0 : _a[magicNumber.ZERO]
  );
  const [prevQuantity, setPrevQuantity] = useState(productData.quantity);
  const [globalBannerMaxVal, setGlobalBannerMax] = useState(false);
  const [fromInput, setFromInput] = useState(void 0);
  const [inputElementRef, setInputElementRef] = useState(null);
  const [hideAccordionAfterRemove, setHideAccordionAfterRemove] = useState(props.hasSelectedAddOn);
  const maxQuantity = productData.maxPurchaseQty;
  const infoClass = `${PREFIX}-shopping-cart__product`;
  const cartClass2 = `${PREFIX}-shopping-cart__item`;
  const automotiveClass = `${PREFIX}-automotive-card`;
  const customerSelfServiceCancelEnabled = props.customerSelfServiceCancelEnabled;
  const feeMessage = isArrayNotEmpty(productData.feeMessages) ? (_b = productData.feeMessages) == null ? void 0 : _b[0] : {};
  const { oneProductQuantity } = productCartItems;
  const itemAvailabilityInfo = productData == null ? void 0 : productData.itemAvailabilityInfo;
  const { cartDebounceTimeOut } = productCartItems;
  const [debounceTimeOut, setDebounceTimeOut] = useState(null);
  const counterRef = useRef(0);
  const isShipHome = isOrderSTH(productData);
  const isInWishList = checkIsInWishList(wishlistProducts, productData.code);
  const promoMessagesClass = "${PREFIX}-promo-messages-wrapper";
  const isMobile2 = useIsMobile();
  useEffect(() => {
    if (counterRef.current === 0) {
      setQuantity(productData.quantity);
    }
  }, [productData]);
  const limitedStockAndAvailableInDc = (dcQuantity, inStoreQuantity, sourceDC, sourceStore) => {
    return props.isShoppingCartPage ? Boolean(dcQuantity && inStoreQuantity < productData.quantity) : Boolean(Object.keys(sourceDC).length && Object.keys(sourceStore).length);
  };
  const loyaltyValue = useCalculatedLoyaltyValue(productData == null ? void 0 : productData.loyalty, false, {
    qtySelectorInput: 1
  });
  const loyaltyProp = isShoppingCartPage ? { loyaltyValue } : {};
  const checkOnlyStore = (storeQty, sourceStore) => {
    return props.isShoppingCartPage ? Boolean(storeQty) : Boolean(Object.keys(sourceStore).length);
  };
  const getETATime = (date) => {
    if (!date) {
      return "";
    }
    const options = getETATimeOptions(productCartItems.etaTimeOptions);
    const intlDate = localization.formattedDate(options, date, props.language);
    return intlDate.split(",").reverse().map((item) => item.trim()).join(", ").replace(/\./g, "").replace(" ", "");
  };
  const getETAForRange = (date) => {
    if (!date) {
      return "";
    }
    const options = productCartItems.etaDateOptions;
    const intlDate = localization.formattedDate(options, date, props.language);
    return intlDate.replace(/\./g, "");
  };
  const checkOnlyDCStock = (dcQuantity, inStoreQuantity, sourceDC, sourceStore) => {
    return props.isShoppingCartPage ? Boolean(dcQuantity && !inStoreQuantity) : Boolean(!Object.keys(sourceStore).length && Object.keys(sourceDC).length);
  };
  const getAvailableBetween = (etaEarliestData, etaLatestData) => {
    return /* @__PURE__ */ jsx("li", { children: replaceMultipleStrWithDynamicVal(props.availableBetweenLabel, [
      getETAForRange(etaEarliestData),
      getETAForRange(etaLatestData)
    ]) });
  };
  const getAvailableData = (etaEarliestDate) => {
    return /* @__PURE__ */ jsxs("li", { children: [
      " ",
      `${props.availableLabel} ${getETATime(etaEarliestDate)}`
    ] });
  };
  const getEtaLabel = () => {
    return props.sameEtaForSameYMM.etaEarliest && props.sameEtaForSameYMM.etaLatest ? getAvailableBetween(props.sameEtaForSameYMM.etaEarliest, props.sameEtaForSameYMM.etaLatest) : getAvailableData(props.sameEtaForSameYMM.etaEarliest);
  };
  const inStorePickup = () => {
    var _a2, _b2;
    const { dcQuantity, storeQuantity: inStore } = ((_a2 = productData.fulfillment) == null ? void 0 : _a2.stockItemAvailability) || {};
    const { sourceTypes = [] } = productData.fulfillment || {};
    const storePickupDC = sourceTypes.find((source) => source.productSourceType === ProductSourceTypes.DC) || {};
    const storePickupInStore = sourceTypes.find((source) => source.productSourceType === ProductSourceTypes.INSTORE) || {};
    if (props.sameEtaForSameYMM) {
      return getEtaLabel();
    } else if (checkOnlyDCStock(dcQuantity, inStore, storePickupDC, storePickupInStore)) {
      return getAvailableBetween(storePickupDC.etaEarliest, storePickupDC.etaLatest);
    } else if (limitedStockAndAvailableInDc(dcQuantity, inStore, storePickupDC, storePickupInStore)) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("li", { children: `${storePickupInStore.quantity} ${props.availableLabel} ${getETATime(
          storePickupInStore.etaEarliest
        )}` }),
        /* @__PURE__ */ jsx("li", { children: replaceMultipleStrWithDynamicVal(props.availableByLabel, [
          (_b2 = storePickupDC.quantity) == null ? void 0 : _b2.toString(),
          getETAForRange(storePickupDC.etaEarliest),
          getETAForRange(storePickupDC.etaLatest)
        ]) })
      ] });
    } else if (checkOnlyStore(inStore, storePickupInStore)) {
      return getAvailableData(storePickupInStore.etaEarliest);
    } else {
      return null;
    }
  };
  const getBetweenSTHLabel = () => {
    return isShoppingCartPage ? betweenLabel : betweenLabelOrderConf;
  };
  const getBetweenLabel = (storePickup) => {
    const modifiedBetweenLabel = betweenLabelSTH == null ? void 0 : betweenLabelSTH.split("-")[magicNumber.ZERO];
    return storePickup.etaEarliest && storePickup.etaLatest ? betweenLabelSTH : modifiedBetweenLabel;
  };
  const buildEstimatedDeliveryDateBetweenLabel = (product, inStoreQuantity) => {
    var _a2, _b2;
    const startDate = isShoppingCartPage ? (_a2 = product.estimatedDeliveryDate) == null ? void 0 : _a2.startDate : product.eddMin;
    const endDate = isShoppingCartPage ? (_b2 = product.estimatedDeliveryDate) == null ? void 0 : _b2.endDate : product.eddMax;
    const label = replaceMultipleStrWithDynamicVal(estimatedDeliveryDateBetween, [
      getFormattedDateTime(startDate)[magicNumber.ZERO],
      getFormattedDateTime(endDate)[magicNumber.ZERO]
    ]);
    return inStoreQuantity ? buildEstematedDeliveryDateSplitQty(inStoreQuantity, label) : label;
  };
  const shipToHomeLabel = () => {
    var _a2, _b2, _c;
    const { dcQuantity, storeQuantity: currentSelectedStoreQuantity } = ((_a2 = productData.fulfillment) == null ? void 0 : _a2.stockItemAvailability) || {};
    const { sourceTypes = [] } = productData.fulfillment || {};
    const isEstimatedDeliveryDateAvailable = getEstimatedDeliveryDateLabelAvailability(
      props.productData.badges,
      ProductSourceTypes.INSTORE,
      isBulk,
      fulfillment,
      isShowedEstimatedDeliveryDateBetween,
      !checkNotNullAndUndefined(estimatedDeliveryDate)
    );
    const storePickupDC = getSourceTypeData(sourceTypes, ProductSourceTypes.DC);
    const storePickupInStore = getSourceTypeData(sourceTypes, ProductSourceTypes.INSTORE);
    const estimatedDeliveryDateRange = `${getETAForRange(storePickupDC == null ? void 0 : storePickupDC.etaEarliest)} - ${getETAForRange(
      storePickupDC == null ? void 0 : storePickupDC.etaLatest
    )}`;
    const isOrderFromInStoreAndDC = checkIsOrderFromInStoreAndDC(storePickupDC, storePickupInStore);
    if (checkIsEstimatedDeliveryDateAvailableNotSplitQty(isEstimatedDeliveryDateAvailable, isOrderFromInStoreAndDC)) {
      return /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: buildEstimatedDeliveryDateBetweenLabel(props.productData), children: (memoizedStringContent) => /* @__PURE__ */ jsx("li", { dangerouslySetInnerHTML: { __html: memoizedStringContent } }) });
    }
    if (checkOnlyDCStock(dcQuantity, currentSelectedStoreQuantity, storePickupDC, storePickupInStore)) {
      return /* @__PURE__ */ jsx("li", { children: `${getBetweenSTHLabel()} ${getETAForRange(storePickupDC.etaEarliest)} - ${getETAForRange(
        storePickupDC.etaLatest
      )}` });
    } else if (limitedStockAndAvailableInDc(dcQuantity, currentSelectedStoreQuantity, storePickupDC, storePickupInStore)) {
      if (checkIsEstimatedDeliveryDateAvailableSplitQty(isEstimatedDeliveryDateAvailable, isOrderFromInStoreAndDC)) {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            SanitizeStringContentWrapper,
            {
              stringContent: buildEstimatedDeliveryDateBetweenLabel(
                props.productData,
                storePickupInStore.quantity.toString()
              ),
              children: (memoizedStringContent) => /* @__PURE__ */ jsx("li", { dangerouslySetInnerHTML: { __html: memoizedStringContent } })
            }
          ),
          /* @__PURE__ */ jsx("li", { children: `${storePickupDC.quantity} ${betweenLabel} ${estimatedDeliveryDateRange}` })
        ] });
      }
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("li", { children: replaceMultipleStrWithDynamicVal(
          isShoppingCartPage ? receiveBetweenLabel : getBetweenLabel(storePickupInStore),
          [
            (_b2 = storePickupInStore.quantity) == null ? void 0 : _b2.toString(),
            getETAForRange(storePickupInStore.etaEarliest),
            getETAForRange(storePickupInStore.etaLatest)
          ]
        ) }),
        /* @__PURE__ */ jsx("li", { children: replaceMultipleStrWithDynamicVal(
          isShoppingCartPage ? receiveBetweenLabel : getBetweenLabel(storePickupDC),
          [
            (_c = storePickupDC.quantity) == null ? void 0 : _c.toString(),
            getETAForRange(storePickupDC.etaEarliest),
            getETAForRange(storePickupDC.etaLatest)
          ]
        ) })
      ] });
    }
    return /* @__PURE__ */ jsx("li", { children: `${getBetweenSTHLabel()} ${getETAForRange(storePickupInStore.etaEarliest)}` });
  };
  const quantityChangeHandler = (incrementValue, fromInputUpdate, inputRef) => {
    setQuantity(incrementValue);
    setPrevQuantity(quantity);
    setFromInput(fromInputUpdate);
    setInputElementRef(inputRef);
    counterRef.current = magicNumber.ONE;
  };
  const globalBannerMaxErrorCheck = (value) => {
    setGlobalBannerMax(value);
  };
  const limitLabelCheck = () => {
    return {
      limitLabel: maxQuantity ? replaceStrWithDynamicVal(props.limitOfLabel, maxQuantity) : "",
      limitLabelShow: !!maxQuantity
    };
  };
  const checkMaxQuantityError = () => {
    return maxQuantity && quantity > maxQuantity && maxQuantity <= checkAvailableQuantity();
  };
  const informationErrorMessage = (errorMessage, errorMessageShow, exceededValue) => {
    return {
      errorMsg: errorMessage,
      quantityExceeded: errorMessageShow,
      exceededValue
    };
  };
  const checkAvailableQuantity = () => {
    var _a2;
    const { orderableFromDC } = productData.fulfillment || {};
    const { dcQuantity, storeQuantity } = ((_a2 = productData.fulfillment) == null ? void 0 : _a2.stockItemAvailability) || {};
    return orderableFromDC && dcQuantity ? dcQuantity + storeQuantity : storeQuantity;
  };
  const validateQuantityRequest = () => {
    return !maxQuantity && quantity > checkAvailableQuantity() && checkAvailableQuantity() < maxInputVal;
  };
  const checkGlobalBannerMax = () => {
    return !maxQuantity && quantity > maxInputVal && checkAvailableQuantity() > maxInputVal;
  };
  const checkErrorMessage = () => {
    if (checkMaxQuantityError()) {
      props.setErrorInfoHandler(true, false);
      return informationErrorMessage(
        replaceStrWithDynamicVal(props.exceededMsg, maxQuantity),
        true,
        `${maxQuantity}`
      );
    } else if (validateQuantityRequest()) {
      props.setErrorInfoHandler(true, false);
      return informationErrorMessage(
        replaceStrWithDynamicVal(props.exceededTotalAvailableMsg, checkAvailableQuantity()),
        true,
        `${checkAvailableQuantity()}`
      );
    } else if (checkGlobalBannerMax() || globalBannerMaxVal) {
      props.setErrorInfoHandler(true, false);
      return informationErrorMessage(
        replaceStrWithDynamicVal(props.exceededMsg, maxInputVal),
        true,
        maxInputVal.toString()
      );
    } else {
      return informationErrorMessage("", false, "");
    }
  };
  const renderFrontRear = () => {
    return productData.staggeredGroup ? /* @__PURE__ */ jsx("div", { className: `${automotiveClass}__front-rear`, children: productData.isFront ? props.attributeFrontLabel : props.attributeRearLabel }) : null;
  };
  const isCollapsed = () => {
    return !props.hasSelectedAddOn && !hideAccordionAfterRemove;
  };
  const addOns = props.getSelectedAddOn;
  if (isArrayNotEmpty(addOns) && isArrayNotEmpty(props.addons)) {
    addOns.forEach((addon) => {
      const index2 = props.addons.findIndex((hardware) => hardware.sku === addon.code);
      if (index2 !== magicNumber.MINUS_ONE) {
        props.addons.splice(index2, magicNumber.ONE);
      }
    });
  }
  const warningToastProps = {
    changeShipToHomeCTALabel: props.changeShipToHomeCTALabel,
    pickAtStoreCTALabel: props.pickAtStoreCTALabel,
    exceededMsgBar: props.exceededMsgBar,
    nearbyAvailabilityCTALabel: props.nearbyAvailabilityCTALabel,
    onChangeFulfillmentOption: props.onChangeFulfillmentOption,
    checkNearByCTAHandler: props.checkNearByCTAHandler,
    checkErrorMessage
  };
  const addOrRemoveWishlistProps = {
    addItemToWishlist,
    removeitemFromWishlist
  };
  const isQuantityExceeded = checkErrorMessage().quantityExceeded;
  useEffect(() => {
    if (quantity && prevQuantity !== quantity && !isQuantityExceeded && counterRef.current !== 0) {
      const isAdd = Boolean(prevQuantity < quantity);
      updateCartData(quantity, isAdd, productData.entryNumber, fromInput, inputElementRef);
      counterRef.current = 0;
    }
  }, [
    updateCartData,
    prevQuantity,
    quantity,
    isQuantityExceeded,
    fromInput,
    inputElementRef,
    productData.entryNumber
  ]);
  const renderUpdatedText = () => {
    var _a2;
    return ((_a2 = itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed) == null ? void 0 : _a2.includes(OptionsOnCartItem.UPDATED_TEXT)) && /* @__PURE__ */ jsx("p", { className: `${infoClass}__updated-text`, children: props.updatedLabel });
  };
  const renderUrgencyLimitedStock = () => {
    var _a2, _b2;
    const productQty = (_b2 = (_a2 = productData == null ? void 0 : productData.fulfillment) == null ? void 0 : _a2.stockItemAvailability) == null ? void 0 : _b2.storeQuantity;
    return props.limitedStockMessage && (productData == null ? void 0 : productData.isUrgentLowStock) && !!productQty ? /* @__PURE__ */ jsx("div", { className: `${infoClass}__limitedStock`, children: replaceStrWithDynamicVal(props.limitedStockMessage, productQty) }) : null;
  };
  const isRenderPromoMessages = useMemo(() => {
    const isMessagePresent = isAtleastOneParamValid(
      isArrayNotEmpty(productData == null ? void 0 : productData.promoMessages),
      isArrayNotEmpty(productData == null ? void 0 : productData.restrictedPromoMessages),
      isArrayNotEmpty(productData == null ? void 0 : productData.appliedPromoMessages)
    );
    return isMessagePresent && (!isWishList || enableShowPromotionsAndRomanceCopy);
  }, [
    productData == null ? void 0 : productData.appliedPromoMessages,
    productData == null ? void 0 : productData.promoMessages,
    productData == null ? void 0 : productData.restrictedPromoMessages,
    enableShowPromotionsAndRomanceCopy,
    isWishList
  ]);
  const renderAvailability = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      (productData == null ? void 0 : productData.isOnSale) && renderSaleEndDaySoonMessageComp(
        salePriceEndDate,
        isOnSale,
        isUrgentLowStock,
        isShoppingCartPage,
        hideSaleEndDaySoonMessage,
        saleEndDaySoonMessage,
        saleEndDisableShift
      ),
      !props.isDetailPage && /* @__PURE__ */ jsxs("ul", { className: `${infoClass}__availability`, children: [
        !props.hideQuantitySelector && renderUpdatedText(),
        isShipHome ? shipToHomeLabel() : inStorePickup()
      ] }),
      renderRebateSection()
    ] });
  };
  const renderProductInfo = () => {
    var _a2;
    return /* @__PURE__ */ jsxs("div", { className: `${infoClass} ${PREFIX}-col-md-8 ${PREFIX}-col-sm-8`, children: [
      /* @__PURE__ */ jsx("div", { className: `${infoClass}__brand`, children: (_a2 = productData == null ? void 0 : productData.brand) == null ? void 0 : _a2.label }),
      /* @__PURE__ */ jsx("div", { className: `${infoClass}__title`, children: productData.url ? /* @__PURE__ */ jsx(
        "a",
        {
          href: productData.url,
          className: `${infoClass}__title-link`,
          "data-link-value": productData.name,
          children: productData.name
        }
      ) : productData.name }),
      props.hideQuantitySelector && /* @__PURE__ */ jsx(renderQuantity, { qtyAbbrLabel: props.qtyAbbrLabel, quantity }),
      isArrayNotEmpty(specificationsArr) && /* @__PURE__ */ jsx("div", { className: `${infoClass}__colour`, children: specificationsArr.map((spec) => /* @__PURE__ */ jsx("div", { children: `${spec == null ? void 0 : spec.label}: ${spec == null ? void 0 : spec.value}` }, spec.code)) }),
      isRenderPromoMessages && renderPromoMessages(!isMobile2),
      /* @__PURE__ */ jsx("div", { className: `${infoClass}--desktop`, children: renderUrgencyLimitedStock() }),
      !((itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) && !(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed.includes(OptionsOnCartItem.AVAILABILITY_INFO))) && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${infoClass} ${infoClass}__availability_section  ${PREFIX}-md-block ${PREFIX}-xs-none ${PREFIX}-sm-none`,
          children: renderAvailability()
        }
      )
    ] });
  };
  const isParentProduct = isArrayNotEmpty(addOns) && productData.entryType === eEntryType.PRODUCT && !productData.cartEntryReference;
  const renderRemoveButton = () => {
    return /* @__PURE__ */ jsxs(
      "button",
      {
        className: `${cartClass2}__icon--close`,
        "data-testid": "cartCloseIcon",
        onClick: () => {
          onRemoveCartItem(isParentProduct, productData);
          !isParentProduct && setHideAccordionAfterRemove(true);
        },
        "aria-label": a11yRemoveLabel,
        children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" }),
          saveForLaterFlagEnabled ? /* @__PURE__ */ jsx(
            "span",
            {
              className: `${infoClass}__title-link ${infoClass}__title-link--space ${infoClass}__title-link--align`,
              children: a11yRemoveLabel
            }
          ) : null
        ]
      }
    );
  };
  const onClickForSfl = (redirectToClp) => {
    if (redirectToClp) {
      ssoHandler(true);
    }
    addItemToSaveForLater(productData, addOns, true);
  };
  const renderSaveForLaterTitle = () => {
    return /* @__PURE__ */ jsx(
      "span",
      {
        className: `${infoClass}__title-link ${infoClass}__title-link--space ${infoClass}__title-link--align`,
        children: saveForLaterTitle
      }
    );
  };
  const renderSflButton = (useSingleSignOn) => {
    return /* @__PURE__ */ jsxs(
      "button",
      {
        className: `${cartClass2}__icon--sfl`,
        "data-testid": "saveForLaterIcon",
        "aria-label": saveForLaterTitle,
        onClick: () => onClickForSfl(useSingleSignOn),
        children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-save-for-later", size: "lg" }),
          renderSaveForLaterTitle()
        ]
      }
    );
  };
  const renderSaveForLaterButtonForURL = () => {
    return /* @__PURE__ */ jsx(
      SanitizeStringContentWrapper,
      {
        stringContent: urlRedirection(
          urlRedirection(loginPageLink, "returnURL", cartPageLink),
          saveForLaterParam,
          "true"
        ),
        children: (memoizedStringContent) => /* @__PURE__ */ jsxs(
          "a",
          {
            className: `${cartClass2}__icon--sfl`,
            "data-testid": "saveForLaterIcon",
            href: memoizedStringContent,
            onClick: () => onClickForSfl(false),
            "data-link-value": saveForLaterTitle,
            "aria-label": saveForLaterTitle,
            children: [
              /* @__PURE__ */ jsx(Icon, { type: "ct-save-for-later", size: "lg" }),
              renderSaveForLaterTitle()
            ]
          }
        )
      }
    );
  };
  const renderSaveForLaterButton = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      isAuthUser && renderSflButton(false),
      !isAuthUser && enableSingleSignOn && renderSflButton(true),
      !isAuthUser && !enableSingleSignOn && renderSaveForLaterButtonForURL()
    ] });
  };
  const renderButtons = (isWishlistSection = true) => {
    return isWishlistSection ? /* @__PURE__ */ jsxs("div", { className: `${cartClass2}__icon`, children: [
      showWishListIcon(
        itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError,
        itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed
      ) && /* @__PURE__ */ jsx(
        "button",
        {
          className: `${cartClass2}__icon--wishlist`,
          "aria-label": a11yWishlistIcon,
          "data-testid": "cartWishlistIcon",
          onClick: () => addOrRemoveWishlist(addOrRemoveWishlistProps, isInWishList, productData),
          children: renderWishListIconComponent(isInWishList)
        }
      ),
      !saveForLaterFlagEnabled && renderRemoveButton()
    ] }) : /* @__PURE__ */ jsx(
      "div",
      {
        className: `${cartClass2}__icon ${cartClass2}__icon--bottom ${cartClass2}__icon--bottom-container ${cartClass2}__icon--sfl-${saveForLaterFlagEnabled ? "enabled" : "disabled"}`,
        children: saveForLaterFlagEnabled ? /* @__PURE__ */ jsxs(Fragment, { children: [
          renderSaveForLaterButton(),
          renderRemoveButton()
        ] }) : null
      }
    );
  };
  const renderRebateSection = () => {
    if (productData.rebate && Object.keys(productData.rebate).length) {
      const { message, tooltipMessage, greyCopyMsg, pdfLink } = productData.rebate || {};
      return /* @__PURE__ */ jsx("div", { className: `${infoClass}__rebate-info`, children: /* @__PURE__ */ jsx(
        Rebate,
        {
          title: message || "",
          tooltipMessage,
          greyCopyMsg,
          a11yTooltipIcon: props.a11yTooltipIcon,
          pdfLink
        }
      ) });
    }
    return null;
  };
  const handleCancelProductClick = () => {
    getEntriesInfo(true, "TIRES", productData.entryNumber, productData.quantity, productData.name);
    cancellationAnalytics("cancel_order", "partial", "Order Details");
  };
  const isTireOrWheel = (productType) => {
    return isProductTire({ productWheelType: productType }) || isProductWheel({ productWheelType: productType });
  };
  const compatiblePackageName = (productWheelTypeCurrent, labelOrLink) => {
    if (productWheelType) {
      let oppositeWheelType;
      switch (productWheelTypeCurrent) {
        case productWheelTypes$1.Tire:
        case productWheelTypes$1.WinterTire:
          oppositeWheelType = labelOrLink === createNewPackageLabel ? createNewPackageLabelWheel : createNewPackageCTAWheel;
          break;
        case productWheelTypes$1.Wheel:
          oppositeWheelType = labelOrLink === createNewPackageLabel ? createNewPackageLabelTire : createNewPackageCTATire;
          break;
        default:
          oppositeWheelType = "";
          break;
      }
      return oppositeWheelType;
    }
    return "";
  };
  const renderPackageCreationToast = () => {
    const isToastVisible = productsRequirePackageCreationMessage && !productData.staggeredGroup && isTireOrWheel(productWheelType) && !packagedItem;
    return isToastVisible && /* @__PURE__ */ jsx(
      CommonWarningToast,
      {
        icon: "ct-information-blue",
        isLink: true,
        bgType: "blue",
        label: compatiblePackageName(productWheelType, createNewPackageLabel),
        checkNearByText: compatiblePackageName(productWheelType, createNewPackageCTA),
        createPackageRedirectHandler: () => props.createPackageRedirect && props.createPackageRedirect(productWheelType),
        createPackageAndNavigate: (event) => createPackageAndNavigate(event, productData)
      }
    );
  };
  const renderAoaToast = () => {
    return /* @__PURE__ */ jsx(InlineToast, { state: State.INFO, type: Variation.SECONDARY, children: props.bookAoaMessage });
  };
  const renderNoVehicleToast = () => {
    const isToastVisible = !((productData == null ? void 0 : productData.vehicleInformation) && Object.keys(productData == null ? void 0 : productData.vehicleInformation).length) && props.isTire && !props.hideQuantitySelector;
    return isToastVisible && /* @__PURE__ */ jsx(
      CommonWarningToast,
      {
        icon: "ct-notification-caution",
        bgType: "orange",
        label: props.autoNoGuaranteeFitMsg
      }
    );
  };
  const checkQunatityReduced = useCallback(
    (removedAnItem) => {
      if (removedAnItem) {
        return quantity;
      }
      if (quantity < productData.quantity) {
        return productData.quantity - quantity;
      } else {
        return quantity - productData.quantity;
      }
    },
    [productData.quantity, quantity]
  );
  const callAnalytics = useCallback(() => {
    const maxQtyReached = maxQuantity && quantity > maxQuantity;
    if (quantity > productData.quantity) {
      cartItemAnalytics(productData, checkQunatityReduced(), "addToCart", maxQtyReached);
    } else if (quantity < productData.quantity) {
      cartItemAnalytics(productData, checkQunatityReduced());
    }
  }, [checkQunatityReduced, maxQuantity, cartItemAnalytics, productData, quantity]);
  const previousQuantity = usePrevious(quantity);
  useEffect(() => {
    if (quantity !== previousQuantity) {
      customDebounce(callAnalytics, cartDebounceTimeOut, debounceTimeOut, setDebounceTimeOut)();
    }
  }, [callAnalytics, cartDebounceTimeOut, debounceTimeOut, setDebounceTimeOut, quantity, previousQuantity]);
  const renderQuantitySelector = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: !props.hideQuantitySelector && /* @__PURE__ */ jsx("div", { className: `${cartClass2}__quantity ${PREFIX}-col-md-4 ${PREFIX}-col-sm-3`, children: /* @__PURE__ */ jsx(
      QuantitySelector,
      {
        setQtySelectorInput: quantityChangeHandler,
        qtySelectorInput: quantity,
        defaultQty: productData.quantity,
        maxQty: maxQuantity,
        maximumQuantityError: checkErrorMessage().errorMsg,
        quantityExceeded: checkErrorMessage().quantityExceeded,
        limitLabel: limitLabelCheck().limitLabel,
        limitLabelShow: limitLabelCheck().limitLabelShow,
        checkBannerMaxError: globalBannerMaxErrorCheck,
        disabled: !(productData.entryType === eEntryType.PRODUCT && !productData.cartEntryReference),
        a11yQuantityLabel: props.accessibilityGlobalProps.a11yQuantityLabel,
        a11yQuantityDecrementLabel: props.accessibilityGlobalProps.a11yQuantityDecrementLabel,
        a11yQuantityIncrementLabel: props.accessibilityGlobalProps.a11yQuantityIncrementLabel,
        a11yMinQuantityReached: props.accessibilityGlobalProps.a11yMinQuantityReached,
        a11yQuantityInputAriaLabel: props.accessibilityGlobalProps.a11yQuantityInputAriaLabel,
        id: props.quantitySelectorId
      }
    ) }) });
  };
  const renderPromoMessages = (isVisible) => {
    return isVisible ? /* @__PURE__ */ jsx("div", { className: promoMessagesClass, children: /* @__PURE__ */ jsx(
      PromoMessages,
      {
        isProductLevel: true,
        productPromoMessages: productData == null ? void 0 : productData.promoMessages,
        productRestrictedPromoMessages: productData == null ? void 0 : productData.restrictedPromoMessages,
        appliedPromoPrefix,
        appliedPromoMessages: productData == null ? void 0 : productData.appliedPromoMessages,
        a11yTooltipIcon,
        a11yCloseIconLabel
      }
    ) }) : null;
  };
  const {
    errorMessage: itemAvailabilityErrMsg,
    showInlineError: itemAvailabilityShowInlineError,
    hardStopError: itemAvailabilityShowHardStopError,
    optionsToBeDisplayed: itemAvailabilityOptionsToBeDisplayed,
    isShowETAToast: itemAvailabilityInfoShowETAToast
  } = itemAvailabilityInfo || {};
  const previousItemAvailabilityInfoErrMsg = usePrevious(itemAvailabilityErrMsg);
  useEffect(() => {
    if (itemAvailabilityErrMsg && itemAvailabilityErrMsg !== previousItemAvailabilityInfoErrMsg) {
      itemAvailabilityShowInlineError && !!errorAnalyticsForInlineToast && errorAnalyticsForInlineToast(itemAvailabilityErrMsg);
      !!itemAvailabilityShowHardStopError && setErrorInfoHandler(itemAvailabilityShowInlineError, false);
      itemAvailabilityInfoShowETAToast && !!itemAvailabilityOptionsToBeDisplayed.includes(OptionsOnCartItem.UPDATED_TEXT) && setErrorInfoHandler(false, true, true);
    }
  }, [
    errorAnalyticsForInlineToast,
    setErrorInfoHandler,
    itemAvailabilityErrMsg,
    itemAvailabilityShowInlineError,
    itemAvailabilityShowHardStopError,
    itemAvailabilityOptionsToBeDisplayed,
    previousItemAvailabilityInfoErrMsg,
    itemAvailabilityInfoShowETAToast
  ]);
  const cancellationClass = customerSelfServiceCancelEnabled ? `${automotiveClass}__cancellation` : "";
  useEffect(() => {
    if (isQuantityExceeded && checkoutButtonClick) {
      setInlineToastError(true);
    } else if (!!itemAvailabilityErrMsg && checkoutButtonClick) {
      setInlineToastError(true);
    } else if (!isQuantityExceeded && !itemAvailabilityErrMsg) {
      setInlineToastError(false);
    }
  }, [isQuantityExceeded, checkoutButtonClick, itemAvailabilityErrMsg]);
  const isAvailabilityError = !!(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) || inlineToastError;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-auto-wrapper ${inlineToastError && (itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.hardStopError) ? `${PREFIX}-hard-stop-wrapper` : ""}`,
      children: [
        isAvailabilityError && renderWarningToast(warningToastProps, itemAvailabilityInfo, productData),
        renderNoVehicleToast(),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-automotive-inner-wrapper ${PREFIX}-row`, children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${cartClass2} ${PREFIX}-row ${automotiveClass}__item ${cancellationClass}  ${!!(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) ? "error-card" : ""}`,
            children: [
              /* @__PURE__ */ jsx("div", { children: isCartPackageToggle && renderPackageCreationToast() }),
              /* @__PURE__ */ jsx("div", { children: shouldShowAoaMessage && renderAoaToast() }),
              !productData.packageId && renderFrontRear(),
              /* @__PURE__ */ jsxs("div", { className: `${automotiveClass}__item-wrapper ${PREFIX}-row`, children: [
                customerSelfServiceCancelEnabled ? /* @__PURE__ */ jsx("div", { className: `${cartClass2}__cta-cancel ${cartClass2}__icon`, children: /* @__PURE__ */ jsx(
                  Button,
                  {
                    id: "cancel-product-btn",
                    type: "tertiary",
                    size: "mini",
                    disabled: !productData.cancellable,
                    onClick: () => {
                      handleCancelProductClick();
                    },
                    children: props.cancelProductLabel
                  }
                ) }) : null,
                /* @__PURE__ */ jsx(
                  ProductImageComponent,
                  {
                    itemAvailabilityInfo,
                    isService: false,
                    a11yServiceInstallation: props.a11yServiceInstallation,
                    servicesIcon: "ct-tools",
                    images: productData.images,
                    name: productData.name,
                    url: productData.url
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: `${cartClass2}__text-container ${PREFIX}-col-md-8 ${PREFIX}-col-sm-8`, children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: `${cartClass2}__product-item-wrapper ${PREFIX}-col-md-12 ${PREFIX}-col-sm-12`,
                      children: [
                        renderProductInfo(),
                        (!(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) || (itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed.includes(
                          OptionsOnCartItem.PRICE_AND_QUANTITY
                        ))) && /* @__PURE__ */ jsxs(
                          "div",
                          {
                            className: `${(props == null ? void 0 : props.isOrderPage) ? `${automotiveClass}__price-quantity-alignment` : ""} ${automotiveClass}__price-quantity ${PREFIX}-col-md-4 ${PREFIX}-col-sm-12`,
                            children: [
                              renderQuantitySelector(),
                              /* @__PURE__ */ jsxs("div", { className: `${cartClass2}__price ${PREFIX}-col-md-7 ${PREFIX}-col-sm-8`, children: [
                                /* @__PURE__ */ jsx(
                                  Price,
                                  {
                                    isRangeView: isPriceRangeViewEnabled,
                                    priceValue: renderItemPrice(
                                      quantity,
                                      productData.currentPrice,
                                      productData.totalPrice
                                    ),
                                    currentPrice: productData.currentPrice,
                                    originalPrice: productData.originalPrice,
                                    displayWasLabel: productData.displayWasLabel,
                                    hideSaveLabel: false,
                                    language: props.language,
                                    eachLabel: props.eachLabel,
                                    isMoreQuantityCartPage: quantity > oneProductQuantity,
                                    promotionalPriceLabel: props.saveLabel,
                                    clearancePriceLabel: props.clearancePriceLabel,
                                    unitPriceLabel: props.unitPriceLabel,
                                    thresholdValue: props.thresholdValue,
                                    a11yStrikeOutPrice: props.a11yStrikeOutPrice,
                                    a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
                                    feeTitle: (feeMessage == null ? void 0 : feeMessage.value) ? replaceStrWithDynamicVal(
                                      addDynamicToken(feeMessage == null ? void 0 : feeMessage.feeTitle, "$x"),
                                      getFormattedPriceValue(props.language, feeMessage == null ? void 0 : feeMessage.value)
                                    ) : "",
                                    feeDisclaimerTitle: feeMessage == null ? void 0 : feeMessage.feeDisclaimerTitle,
                                    feeDisclaimerMessage: feeMessage == null ? void 0 : feeMessage.feeDisclaimerMessage,
                                    feeDisclaimerType: feeMessage == null ? void 0 : feeMessage.type,
                                    nowFromLabel: props.nowFromLabel,
                                    saveFromLabel: props.saveFromLabel,
                                    wasFromLabel: props.wasFromLabel,
                                    fromLabel: props.fromLabel,
                                    scrollToFooter: props.scrollToFooter,
                                    priceMessage: productData == null ? void 0 : productData.priceMessage,
                                    isShoppingCartPage: props.isShoppingCartPage,
                                    a11yClickToReadFootnote: props.a11yClickToReadFootnote,
                                    a11yTooltipIcon: props.a11yTooltipIcon,
                                    isOnSale: productData == null ? void 0 : productData.isOnSale
                                  }
                                ),
                                isRenderPromoMessages && renderPromoMessages(isMobile2),
                                isArrayNotEmpty(productData.badges) && /* @__PURE__ */ jsx("div", { className: `${cartClass2}__cart-badges`, children: /* @__PURE__ */ jsx(
                                  Badges,
                                  {
                                    badges: productData.badges,
                                    badgesAndPriorities: props.badgePriorities,
                                    saleEndDaySoonMessage: props.saleEndDaySoonMessage,
                                    salePriceEndDate: productData == null ? void 0 : productData.salePriceEndDate,
                                    isShoppingCart: props.isShoppingCartPage,
                                    isOnSale: productData == null ? void 0 : productData.isOnSale,
                                    ...loyaltyProp
                                  }
                                ) })
                              ] })
                            ]
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx("div", { className: `${infoClass}--mobile`, children: renderUrgencyLimitedStock() }),
                  /* @__PURE__ */ jsxs("div", { className: `${cartClass2}__availability-container ${PREFIX}-row`, children: [
                    !((itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) && !(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed.includes(
                      OptionsOnCartItem.AVAILABILITY_INFO
                    ))) && /* @__PURE__ */ jsxs(
                      "div",
                      {
                        className: `${infoClass} ${PREFIX}-md-none ${PREFIX}-xs-none ${PREFIX}-sm-block`,
                        children: [
                          isOnSale && renderSaleEndDaySoonMessageComp(
                            salePriceEndDate,
                            isOnSale,
                            isUrgentLowStock,
                            isShoppingCartPage,
                            hideSaleEndDaySoonMessage,
                            saleEndDaySoonMessage,
                            saleEndDisableShift
                          ),
                          !props.isDetailPage && /* @__PURE__ */ jsxs("ul", { className: `${infoClass}__availability`, children: [
                            !props.hideQuantitySelector && renderUpdatedText(),
                            isShipHome ? shipToHomeLabel() : inStorePickup()
                          ] }),
                          renderRebateSection()
                        ]
                      }
                    ),
                    !((itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.showInlineError) && !(itemAvailabilityInfo == null ? void 0 : itemAvailabilityInfo.optionsToBeDisplayed.includes(
                      OptionsOnCartItem.AVAILABILITY_INFO
                    ))) && /* @__PURE__ */ jsxs(
                      "div",
                      {
                        className: `${infoClass}  ${PREFIX}-md-none ${PREFIX}-xs-block ${PREFIX}-sm-none`,
                        children: [
                          isOnSale && renderSaleEndDaySoonMessageComp(
                            salePriceEndDate,
                            isOnSale,
                            isUrgentLowStock,
                            isShoppingCartPage,
                            hideSaleEndDaySoonMessage,
                            saleEndDaySoonMessage,
                            saleEndDisableShift
                          ),
                          !props.isDetailPage && /* @__PURE__ */ jsx("ul", { className: `${infoClass}__availability`, children: isShipHome ? shipToHomeLabel() : inStorePickup() }),
                          renderRebateSection()
                        ]
                      }
                    )
                  ] })
                ] }),
                props.isDetailPage && getBuyItAgainCta(props.dpBuyAgainLabel, productData == null ? void 0 : productData.url, productData.name),
                !props.hideQuantitySelector && renderButtons(),
                renderButtons(false)
              ] })
            ]
          }
        ) }),
        /* @__PURE__ */ jsx(
          AutomotiveAddonsListWrapper,
          {
            ...props,
            isCollapsed: isCollapsed(),
            setHideAccordionAfterRemove
          }
        )
      ]
    }
  );
};
const productsCountWhenPackageIsIncomplete = 1;
const AutomotiveProductCardsWrapper = (props) => {
  const [availabilityWarning, setAvailabilityWarning] = useState({ display: false, label: "" });
  const automotiveClass = `${PREFIX}-automotive-card`;
  const productData = props.products[0];
  const { body = "", make = "", model = "", options = "", year = "" } = (productData == null ? void 0 : productData.vehicleInformation) || {};
  const [isAddCompatibleBtn, setAddCompatibleBtn] = useState(false);
  const renderAvailabilityWarning = () => availabilityWarning.display && /* @__PURE__ */ jsx(CommonWarningToast, { icon: "ct-notification-caution", bgType: "orange", label: availabilityWarning.label });
  const isLastProduct = (index2, products) => {
    const resultIndex = index2 + incrementOne;
    return resultIndex === products.length;
  };
  const getExtraHardware = (hardwareServices) => {
    const vehicleInfoId = `${year}${make}${model}${body}${options}`.toLowerCase();
    const filteredHardwareServices = hardwareServices[vehicleInfoId] ? hardwareServices[vehicleInfoId] : [];
    return filteredHardwareServices.slice(0, props.maxNumberOfExtraHardware);
  };
  const hasSelectedAddOn = () => {
    var _a;
    return ((_a = props.products[props.products.length - magicNumber.ONE]) == null ? void 0 : _a.entryType) === eEntryType.PRODUCT && !!props.products[props.products.length - magicNumber.ONE].cartEntryReference;
  };
  const getSelectedAddOn = () => {
    return props.products.filter(
      (product) => product.entryType === eEntryType.PRODUCT && !!product.cartEntryReference
    );
  };
  const checkHardErrors = () => {
    var _a;
    return (_a = props.products[0].itemAvailabilityInfo) == null ? void 0 : _a.hardStopError;
  };
  const initiatePackage = (event, productDataValue) => {
    props.createPackageAndNavigate(event, productDataValue);
    setAddCompatibleBtn(true);
  };
  const renderCompletePackageToast = () => {
    const isToastVisible = (productData == null ? void 0 : productData.isPackagedItem) && !isAddCompatibleBtn && props.products.length === productsCountWhenPackageIsIncomplete && !checkHardErrors();
    return isToastVisible && /* @__PURE__ */ jsx(
      CommonWarningToast,
      {
        icon: "ct-notification-caution",
        bgType: "orange",
        label: props.packageIsNotCompleteMsg,
        checkNearByText: props.completePackageMsg,
        actionCTAHandler: () => props.completePackage && props.completePackage(
          productData.productWheelType,
          productData.packageId,
          productData.vehicleInformation
        )
      }
    );
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    renderAvailabilityWarning(),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-common-card ${automotiveClass}`, children: [
      (productData == null ? void 0 : productData.isPackagedItem) || (productData == null ? void 0 : productData.isPackageItem) ? /* @__PURE__ */ jsx("h3", { className: `${automotiveClass}__package-label`, children: props.packagedItemLabel }) : null,
      renderCompletePackageToast(),
      /* @__PURE__ */ jsx("div", { className: `${automotiveClass}-wrapper`, children: props.products.map((product, index2) => /* @__PURE__ */ jsx(
        AutomotiveProductCard,
        {
          onlineOrdering: props.onlineOrdering,
          productData: product,
          ...props,
          ...product,
          setAvailabilityWarning,
          addons: isLastProduct(index2, props.products) && props.hasWheels ? getExtraHardware(props.hardwareServices) : [],
          hasSelectedAddOn: hasSelectedAddOn(),
          getSelectedAddOn: getSelectedAddOn(),
          a11yStrikeOutPrice: props.a11yStrikeOutPrice,
          a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange,
          isTire: isProductTire(product),
          sameEtaForSameYMM: props.sameEtaForSameYMM,
          a11yClickToReadFootnote: props.a11yClickToReadFootnote,
          productsRequirePackageCreationMessage: props.productsRequirePackageCreationMessage,
          a11yTooltipIcon: props.a11yTooltipIcon,
          quantitySelectorId: `${props.quantitySelectorId}-${index2}`,
          createPackageAndNavigate: (event) => initiatePackage(event, productData),
          shouldShowAoaMessage: index2 === 0 && props.shouldShowAoaMessage
        },
        index2
      )) })
    ] })
  ] });
};
const renderVehicleInfo = (productData) => {
  var _a;
  if ((productData == null ? void 0 : productData.vehicleInformation) && ((_a = productData == null ? void 0 : productData.vehicleInformation) == null ? void 0 : _a.year) && Object.keys(productData == null ? void 0 : productData.vehicleInformation).length) {
    const { body = "", make = "", model = "", options = "", year = "" } = productData == null ? void 0 : productData.vehicleInformation;
    return `${year} ${make} ${model} ${body || ""} ${options || ""}`;
  } else {
    return null;
  }
};
const AutomotiveProductCardsVehicleContextWrapper = (props) => {
  var _a;
  const [availabilityWarning, setAvailabilityWarning] = useState({ display: false, label: "" });
  const productData = props.products[0][0];
  const renderAvailabilityWarning = () => availabilityWarning.display && /* @__PURE__ */ jsx(CommonWarningToast, { icon: "ct-notification-caution", bgType: "orange", label: availabilityWarning.label });
  const hasWheels = (products) => {
    const filteredWheels = products.filter((product) => isProductWheel(product));
    return filteredWheels.length > 0;
  };
  const shouldShowAoaMessage = useMemo(() => {
    let hasTireOrWheel = false;
    const aoaEillgible = props.shouldShowAoaMessage && props.bookAoaMessage && props.products.every(
      (productsPerVehicleContext) => productsPerVehicleContext.every((product) => {
        var _a2;
        if (isTireOrWheelProduct(product)) {
          hasTireOrWheel = true;
          return !((_a2 = product.itemAvailabilityInfo) == null ? void 0 : _a2.showInlineError);
        }
        return true;
      })
    );
    return hasTireOrWheel && aoaEillgible;
  }, [props.products, props.bookAoaMessage]);
  return isArrayNotEmpty(props.products) && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-automotive`, children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-vehicle-context`, children: [
    renderAvailabilityWarning(),
    renderVehicleInfo(productData) && /* @__PURE__ */ jsx("h2", { className: `${PREFIX}-automotive-card__car-mark-header`, children: renderVehicleInfo(productData) }),
    (_a = props.products) == null ? void 0 : _a.map((productsPerVehicleContext, index2) => /* @__PURE__ */ jsx(
      AutomotiveProductCardsWrapper,
      {
        setAvailabilityWarning,
        hasWheels: hasWheels(productsPerVehicleContext),
        ...props,
        quantitySelectorId: `${props.quantitySelectorId}-${index2}`,
        products: productsPerVehicleContext,
        a11yClickToReadFootnote: props.a11yClickToReadFootnote,
        a11yTooltipIcon: props.a11yTooltipIcon,
        createPackageAndNavigate: props.createPackageAndNavigate,
        shouldShowAoaMessage: index2 === 0 && shouldShowAoaMessage
      },
      index2
    ))
  ] }) });
};
const Tab = ({ ...props }) => {
  let tabClass = `${PREFIX}-tabs__tab`;
  const tabClassLabel = `${tabClass}__label`;
  if (props.activeTab === props.label) {
    tabClass += ` ${tabClass}--active`;
  }
  return /* @__PURE__ */ jsx("li", { className: tabClass, role: "presentation", children: /* @__PURE__ */ jsx(
    "div",
    {
      "data-testid": props.dataTestId,
      className: tabClassLabel,
      role: "tab",
      "aria-selected": props.currentIndex ? "false" : "true",
      tabIndex: props.currentIndex ? magicNumber.MINUS_ONE : magicNumber.ZERO,
      onKeyDown: (event) => {
        props.handleKeyDown(event, props.currentIndex, props.label);
      },
      onClick: (event) => {
        props.handleClickOrEnter(event, props.currentIndex, props.label);
      },
      children: props.label
    }
  ) });
};
Tab.propTypes = {
  activeTab: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  currentIndex: PropTypes.number.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  handleClickOrEnter: PropTypes.func.isRequired,
  dataTestId: PropTypes.string
};
const Tabs = ({ ...props }) => {
  var _a, _b;
  const children = props.children.filter((child) => child.props.label);
  const activeLabel = props.selectedTab || ((_b = (_a = children[0]) == null ? void 0 : _a.props) == null ? void 0 : _b.label);
  const [activeTab, setActiveTab] = useState(activeLabel);
  const tablistRef = useRef(null);
  useEffect(() => {
    setActiveTab(activeLabel);
  }, [activeLabel]);
  const tabsOutsideActionHandler = useCallback(() => outsideActionHandler(tablistRef.current), []);
  useOnClickOutside(tablistRef, tabsOutsideActionHandler);
  useOnKeyDownOutside(tablistRef, tabsOutsideActionHandler);
  const onClickTabItem = (tab) => {
    setActiveTab(tab);
    if (props.tabClickedCallBack) {
      props.tabClickedCallBack(tab);
    }
  };
  const getTabData = () => {
    return children.map((child, index2) => {
      return /* @__PURE__ */ jsx(
        Tab,
        {
          dataTestId: `testid-${index2}`,
          activeTab,
          label: child.props.label,
          currentIndex: index2,
          handleKeyDown,
          handleClickOrEnter
        },
        child.props.label
      );
    });
  };
  const handleKeyDown = (event, currentIndex, label) => {
    if (event.key === stringKeyCodes.rightArrow) {
      handleArrowsAccessibility(event, arrowActionIdentifier$1.NEXT, currentIndex, tablistRef.current);
    } else if (event.key === stringKeyCodes.leftArrow) {
      handleArrowsAccessibility(event, arrowActionIdentifier$1.PREVIOUS, currentIndex, tablistRef.current);
    } else if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.space) {
      handleClickOrEnter(event, currentIndex, label);
    }
  };
  const handleClickOrEnter = (event, currentIndex, label) => {
    handleClickOrEnterAccessibility(event, currentIndex, tablistRef.current);
    onClickTabItem(label);
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-tabs`, children: [
    /* @__PURE__ */ jsx("ul", { ref: tablistRef, className: `${PREFIX}-tabs__list`, role: "tablist", children: getTabData() }),
    /* @__PURE__ */ jsx("div", {
      className: `${PREFIX}-tabs__content`,
      role: "tabpanel",
      // eslint-disable-next-line sonar/function-return-type
      children: props.children.map((child) => {
        if (!props.isPrerender && child.props.label !== activeTab) {
          return null;
        }
        return child.props.children;
      })
    })
  ] });
};
Tabs.propTypes = {
  children: PropTypes.any,
  tabClickedCallBack: PropTypes.func,
  isPrerender: PropTypes.bool
};
Tabs.displayName = "Tabs";
var TabVariants = /* @__PURE__ */ ((TabVariants2) => {
  TabVariants2["DEFAULT"] = "default";
  TabVariants2["SHADOW_BOX"] = "shadow-box";
  TabVariants2["OUTLINE"] = "outline";
  return TabVariants2;
})(TabVariants || {});
const TabV2 = ({ ...props }) => {
  const { index: index2, children, isActive, label, gap } = props;
  const tabIndex = index2 ? index2 : 0;
  const isActiveState = useMemo(() => isActive ? State.ACTIVE : State.DEFAULT, [isActive]);
  const a11yTabs = {
    controls: `${Role.TABPANEL}-${tabIndex}`,
    selected: isActive
  };
  return /* @__PURE__ */ jsx(
    TabButton,
    {
      tabIndex: isActive ? 0 : -1,
      id: `tab-${tabIndex}`,
      a11y: a11yTabs,
      onClick: (e) => {
        props.onSwitchTab(e, index2, label);
      },
      onKeyDown: (e) => {
        props.onSwitchTab(e, index2, label);
      },
      state: isActiveState,
      ...gap ? { gap } : {},
      children
    }
  );
};
const TabsV2 = ({ ...props }) => {
  const {
    selected,
    isPrerenderMode,
    id,
    children,
    tabCallback,
    style = {
      direction: Direction.HORIZONTAL,
      position: Position.TOP,
      variant: TabVariants.DEFAULT,
      color: Display.NONE,
      tabGap: Size.MINI,
      tabsGap: Size.LARGE,
      tabContentGap: Size.XS
    }
  } = props;
  const componentClass = `${PREFIX}-tabs`;
  const labelList = children.map((child) => {
    var _a;
    return (_a = child == null ? void 0 : child.props) == null ? void 0 : _a.label;
  });
  const initActiveTab = useMemo(() => selected || stringifyElement(labelList[0]), [labelList, selected]);
  const [activeTab, setActiveTab] = useState(initActiveTab);
  const tabsRef = useRef(null);
  const outsideActionCallback = useCallback(() => outsideActionHandler(tabsRef.current), []);
  const tabColor = style.color !== Display.NONE ? `-${style.color}` : "";
  const tabVariant = `${PREFIX}-tab__list--${style.variant}${tabColor}`;
  const tabsGap = style.tabsGap !== Display.NONE && !checkNotNullAndUndefined(style.tabsGap) ? ` ${componentClass}--gap-${style.tabsGap}` : "";
  const tabContentGap = style.tabContentGap !== Display.NONE && !checkNotNullAndUndefined(style.tabContentGap) ? `${PREFIX}-xs-flex ${PREFIX}-xs-align-items-center ${PREFIX}-tab--gap-${style.tabContentGap}` : "";
  const tabPosition = () => {
    const defaultPosition = `${componentClass}--${style.position} ${PREFIX}-xs-flex`;
    switch (style.position) {
      case Position.LEFT:
        return defaultPosition;
      case Position.BOTTOM:
        return `${defaultPosition} ${PREFIX}-xs-column-reverse`;
      case Position.RIGHT:
        return `${defaultPosition} ${PREFIX}-xs-row-reverse`;
      case Position.TOP:
      default:
        return `${defaultPosition} ${PREFIX}-xs-column`;
    }
  };
  useEffect(() => {
    setActiveTab(initActiveTab);
  }, [initActiveTab]);
  useOnClickOutside(tabsRef, outsideActionCallback);
  useOnKeyDownOutside(tabsRef, outsideActionCallback);
  const handleSwitchTab = (e, index2, label) => {
    if (e.type === Events.CLICK) {
      handleClickOrEnterAccessibility(e, index2, tabsRef.current);
      handleSwitchEvent(label);
      tabCallback(label);
    } else if (e.type === Events.KEYDOWN) {
      handleKeyDown(e, index2, label);
    } else ;
  };
  const handleKeyDown = (e, index2, label) => {
    const { key } = e;
    const { rightArrow, leftArrow, enter, space } = stringKeyCodes;
    const { NEXT, PREVIOUS } = arrowActionIdentifier$1;
    switch (key) {
      case rightArrow:
        handleArrowsAccessibility(e, NEXT, index2, tabsRef.current);
        break;
      case leftArrow:
        handleArrowsAccessibility(e, PREVIOUS, index2, tabsRef.current);
        break;
      case enter:
      case space:
        handleSwitchTab(e, index2, label);
        break;
    }
  };
  const handleSwitchEvent = (selectedTab) => setActiveTab(selectedTab);
  const renderTabList = () => labelList.map((label, i) => {
    const insertContentGap = typeof label !== "string" ? { gap: tabContentGap } : {};
    return /* @__PURE__ */ jsx(
      TabV2,
      {
        isActive: Boolean(stringifyElement(label) === activeTab),
        onSwitchTab: handleSwitchTab,
        label: stringifyElement(label),
        index: i,
        ...insertContentGap,
        children: label
      },
      id ? `${Role.TAB}-${id}-${i}` : `${Role.TAB}label-${i}`
    );
  });
  return /* @__PURE__ */ jsxs("section", { className: `${componentClass} ${tabPosition()}${tabsGap}`, id, children: [
    /* @__PURE__ */ jsx(
      ButtonGroup,
      {
        ref: tabsRef,
        gap: style.tabGap,
        direction: style.direction,
        customClass: `${tabVariant}`,
        position: Display.NONE,
        a11y: { role: Role.TABLIST, labelledBy: `${Role.TABLIST}-${id ? id : 1}` },
        children: renderTabList()
      }
    ),
    children.map(
      (child, i) => !isPrerenderMode && stringifyElement(child.props.label) !== activeTab ? null : /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-tab__content`,
          id: `${Role.TABPANEL}-${i}`,
          "aria-labelledby": `tab-${i}`,
          role: Role.TABPANEL,
          children: child.props.children
        },
        id ? `${Role.TABPANEL}-${id}-${i}` : `${Role.TABPANEL}label-${i}`
      )
    )
  ] });
};
const ProductDoesNotFit = ({ ...props }) => {
  const doesNotFitClassName = `${PREFIX}-product-does-not-fit`;
  const vehicleNameHtmlString = `<b>${props.vehicleOrTireName}</b>`;
  const productDoesNotFitMessage = replaceStrWithDynamicVal(props.productDoesNotFitPrompt, vehicleNameHtmlString);
  const redirectToProductList = (productListLink, seeProductFitVehicleCTAButton) => {
    props.productFitAnalytics(seeProductFitVehicleCTAButton);
    window.location.href = encodeURI(productListLink);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: `${doesNotFitClassName}`, children: [
      /* @__PURE__ */ jsx("div", { className: `${doesNotFitClassName}-title`, children: /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: productDoesNotFitMessage } }) }),
      /* @__PURE__ */ jsx("div", { className: `${doesNotFitClassName}-content`, children: props.productDoesNotFitCopy })
    ] }),
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-buy-box__add-cart-wishlist`, children: /* @__PURE__ */ jsx(
      Button,
      {
        id: "redirect-to-product",
        disabled: false,
        type: "primary",
        size: "large",
        onClick: () => redirectToProductList(props.productListLink, props.seeProductFitVehicleCTAButton),
        label: props.seeProductFitVehicleCTAButton
      }
    ) })
  ] });
};
ProductDoesNotFit.propTypes = {
  productDoesNotFitPrompt: PropTypes.string,
  productDoesNotFitCopy: PropTypes.string,
  seeProductFitVehicleCTAButton: PropTypes.string,
  vehicleOrTireName: PropTypes.string,
  productListLink: PropTypes.string,
  productFitAnalytics: PropTypes.func
};
const checkNestedProps = (obj, ...args) => {
  return args.reduce((innerObj, level) => innerObj && innerObj[level], obj);
};
const getParamValue = (urlSearchParam, paramKey, splitKey) => {
  var _a;
  const paramArray = urlSearchParam.replace("?", "").split(splitKey);
  return (_a = paramArray.find((el) => el.startsWith(`${paramKey}=`))) == null ? void 0 : _a.split("=")[magicNumber.ONE];
};
const getFileNameFromUrl = (videoUrl) => {
  const index2 = videoUrl.lastIndexOf("/") + magicNumber.ONE;
  const imageName = videoUrl.substring(index2);
  return imageName.split(".").slice(magicNumber.ZERO, magicNumber.MINUS_ONE).join(".");
};
const generateDOBStr = (day, month, year) => {
  const singleDigitLength = 1;
  const monthToPass = (month == null ? void 0 : month.toString().length) === singleDigitLength ? `0${month}` : `${month}`;
  const dayToPass = day.toString().length === singleDigitLength ? `0${day}` : `${day}`;
  return `${year}-${monthToPass}-${dayToPass}`;
};
const generateDayMonthYearFromDOBStr = (dob) => {
  const monthIndex = 1;
  const dayIndex = 2;
  const valStrings = dob.split("-");
  return {
    year: Number(valStrings[0]),
    month: Number(valStrings[monthIndex]),
    day: Number(valStrings[dayIndex])
  };
};
const CustomTextArea = ({ ...props }) => {
  const { id, name, placeholderText, disabled } = props;
  const componentClassName2 = `${PREFIX}-custom-text-area`;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "textarea",
    {
      className: `${componentClassName2}`,
      "data-testid": id,
      id,
      name,
      disabled,
      placeholder: placeholderText,
      onChange: props.onChange,
      value: props.description
    }
  ) });
};
CustomTextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholderText: PropTypes.string,
  onChange: PropTypes.func,
  description: PropTypes.string,
  disabled: PropTypes.bool
};
const AutomotiveErrorCard = (props) => {
  const { image, imageAltText, title, description, question, ctaLabel, ctaClickHandler, linkLabel, linkUrl } = props;
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-automotive-error-card`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-automotive-error-card__error-img`, children: /* @__PURE__ */ jsx("img", { src: `${image}`, alt: `${imageAltText}` }) }),
    /* @__PURE__ */ jsx("h3", { className: `${PREFIX}-automotive-error-card__title`, children: title }),
    /* @__PURE__ */ jsx("p", { className: `${PREFIX}-automotive-error-card__content`, children: description }),
    !!question && /* @__PURE__ */ jsx("p", { className: `${PREFIX}-automotive-error-card__content`, children: question }),
    /* @__PURE__ */ jsx(
      Button,
      {
        id: "automotive-error",
        type: "primary",
        size: "medium",
        onClick: () => ctaClickHandler(ctaLabel),
        label: ctaLabel
      }
    ),
    !!linkUrl && !!linkLabel && /* @__PURE__ */ jsx("a", { href: linkUrl, rel: "noopener noreferrer", className: `${PREFIX}-automotive-error-card__link`, children: linkLabel })
  ] });
};
AutomotiveErrorCard.propTypes = {
  image: PropTypes.string,
  imageAltText: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  question: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaClickHandler: PropTypes.func,
  linkLabel: PropTypes.string,
  linkUrl: PropTypes.string
};
AutomotiveErrorCard.displayName = "AutomotiveErrorCard";
const UnfinishedPackageCard = ({
  ...props
}) => {
  const { images, name } = props.productData || {};
  const componentName = `${PREFIX}-unfinished-package`;
  const cardClickableClass = props.servicesIcon ? `${componentName}-card-clickable` : "";
  const isMobile2 = window.innerWidth <= BREAKPOINTS.mobileMaxWidth;
  const addToPackageButton = () => {
    return /* @__PURE__ */ jsx("div", { className: `${componentName}-button`, children: /* @__PURE__ */ jsx(
      Button,
      {
        id: "add-to-package-button",
        type: "secondary",
        size: isMobile2 ? "medium" : "small",
        onClick: () => props.completePackage(props.productData.productWheelType, props.productData.packageId),
        children: props.createPackageTitle
      }
    ) });
  };
  const startNewPackage = () => {
    props.servicesIcon && props.createNewPackage();
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      "data-testid": "unfinishedPackage",
      className: `${componentName}-card ${cardClickableClass}`,
      onClick: () => startNewPackage(),
      onKeyPress: () => startNewPackage(),
      role: props.servicesIcon ? "button" : "",
      tabIndex: 0,
      children: !props.servicesIcon ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { className: `${componentName}__product-detail`, children: [
          /* @__PURE__ */ jsx(ProductImageComponent, { images, name, isUnfinishedPackage: true }),
          /* @__PURE__ */ jsx(
            ProductItemInfo,
            {
              productData: props.productData,
              cartModal: true,
              totalLabel: props.totalLabel,
              mmQtyLabel: props.mmQtyLabel,
              isUnfinishedPackage: true,
              language: props.language,
              productSizeLabel: `${props.productSizeLabel}:`,
              attributeOffsetLabel: props.attributeOffsetLabel,
              specificationsFromProps: props.specificationsFromProps,
              a11yStrikeOutPrice: props.a11yStrikeOutPrice,
              a11yStrikeOutPriceRange: props.a11yStrikeOutPriceRange
            }
          )
        ] }),
        addToPackageButton()
      ] }) : /* @__PURE__ */ jsxs("div", { className: `${componentName}__icon-container`, children: [
        /* @__PURE__ */ jsx("div", { className: `${componentName}__start-package-icon`, children: /* @__PURE__ */ jsx(Icon, { type: props.servicesIcon, size: "lg" }) }),
        /* @__PURE__ */ jsx("div", { className: `${componentName}-new-package`, children: props.startNewPackageCTA })
      ] })
    }
  );
};
const addClass = (selector, className2) => {
  if (selector instanceof Element) {
    selector.classList.add(className2);
  } else if (typeof selector === "string") {
    document.querySelector(selector).classList.add(className2);
  }
};
const removeClass = (selector, classNames) => {
  if (selector instanceof Element) {
    selector.classList.remove(...classNames);
  } else if (typeof selector === "string") {
    document.querySelector(selector).classList.remove(...classNames);
  }
};
const addAndRemoveHideClass = (addToElement, removeFromElement) => {
  addToElement && addClass(addToElement, hideClassName);
  removeFromElement && removeClass(removeFromElement, [hideClassName]);
};
const userGreetingClassName = `${PREFIX}-welcome-header`;
const UserGreeting = ({ ...props }) => {
  const {
    greetingTitle,
    greetingSubtitle,
    userName,
    logo,
    hasLoyalty,
    isGreetingSummary,
    componentMode,
    isReverseStyle,
    stepLabel
  } = props;
  const getTriangleSelectTemplate = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${userGreetingClassName}`, children: [
      logo && /* @__PURE__ */ jsxs("div", { className: `${userGreetingClassName}__image`, children: [
        /* @__PURE__ */ jsx("img", { src: logo, alt: "" }),
        /* @__PURE__ */ jsx("hr", { className: `${userGreetingClassName}__border` })
      ] }),
      stepLabel && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${userGreetingClassName}__stepLabel`,
          dangerouslySetInnerHTML: { __html: stepLabel }
        }
      ),
      greetingTitle && /* @__PURE__ */ jsx(
        "h3",
        {
          className: `${userGreetingClassName}__title`,
          dangerouslySetInnerHTML: { __html: greetingTitle }
        }
      ),
      greetingSubtitle && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${userGreetingClassName}__subtitle`,
          dangerouslySetInnerHTML: { __html: greetingSubtitle }
        }
      )
    ] });
  };
  const getDefaultTemplate = () => {
    const logoClassName = logo && greetingTitle ? `${PREFIX}-row` : "";
    return /* @__PURE__ */ jsxs("div", { className: `${userGreetingClassName} ${logoClassName}`, children: [
      greetingTitle && getDefaultGreetingContent(),
      logo && /* @__PURE__ */ jsx("div", { className: `${userGreetingClassName}__image`, children: /* @__PURE__ */ jsx("img", { src: logo, alt: "" }) })
    ] });
  };
  const getDefaultGreetingContent = () => {
    const reverseStyleClass = isReverseStyle ? `${PREFIX}-xs-none ${PREFIX}-sm-none ${PREFIX}-md-block` : "";
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${isGreetingSummary ? `${userGreetingClassName}__wrapper` : `${userGreetingClassName}__content`} ${reverseStyleClass}`,
        children: [
          /* @__PURE__ */ jsx(
            Heading,
            {
              variant: isGreetingSummary ? "h1" : "h2",
              componentClass: `${isGreetingSummary ? `${userGreetingClassName}__header` : `${userGreetingClassName}__title ${PREFIX}-body-xl`} `,
              children: greetingTitle
            }
          ),
          userName && /* @__PURE__ */ jsx(Heading, { variant: "h2", componentClass: `${userGreetingClassName}__user ${PREFIX}-body-xl`, children: userName }),
          hasLoyalty && greetingSubtitle && /* @__PURE__ */ jsx(
            "p",
            {
              className: `${isGreetingSummary ? `${userGreetingClassName}__desc` : `${userGreetingClassName}__subtitle`}`,
              dangerouslySetInnerHTML: { __html: greetingSubtitle }
            }
          )
        ]
      }
    );
  };
  return [componentType.triangleSelect, componentType.triangleSelectSubscription].includes(componentMode) ? getTriangleSelectTemplate() : getDefaultTemplate();
};
UserGreeting.propTypes = {
  greetingTitle: PropTypes.string,
  greetingSubtitle: PropTypes.string,
  componentMode: PropTypes.string
};
const LoyaltyCards = ({ ...props }) => {
  const { loyalty, hasLoyalty, isDashboard, isNotTriangle } = props;
  const loyaltyImgWidth = 86;
  const loyaltyImgHeight = 53;
  const greetingsClass = `${userGreetingClassName}__card-items--${hasLoyalty ? "loyalty" : "no-loyalty"}`;
  const renderItemContent = (item) => {
    return typeof (item == null ? void 0 : item.value) !== Types.Boolean ? /* @__PURE__ */ jsxs("div", { className: `${userGreetingClassName}--dashboard-loyalty__content`, children: [
      /* @__PURE__ */ jsx(Heading, { variant: "h3", componentClass: `${PREFIX}-body-${isDashboard ? "md" : "sm"}`, children: item == null ? void 0 : item.title }),
      /* @__PURE__ */ jsx("p", { className: `${userGreetingClassName}__balance ${PREFIX}-body-${isDashboard ? "lg" : "xl"}`, children: item == null ? void 0 : item.value })
    ] }) : null;
  };
  return /* @__PURE__ */ jsx("div", { className: `${greetingsClass}`, children: isArrayNotEmpty(loyalty) && (loyalty == null ? void 0 : loyalty.map((item, i) => /* @__PURE__ */ jsx(
    "div",
    {
      className: `${userGreetingClassName}__item ${isDashboard && hasLoyalty ? `${PREFIX}-row` : ""}`,
      children: hasLoyalty ? /* @__PURE__ */ jsxs(Fragment, { children: [
        isDashboard && /* @__PURE__ */ jsx("div", { className: `${userGreetingClassName}--dashboard-loyalty__image`, children: /* @__PURE__ */ jsx(
          "img",
          {
            src: item == null ? void 0 : item.icon,
            width: loyaltyImgWidth,
            height: loyaltyImgHeight,
            alt: ""
          }
        ) }),
        renderItemContent(item)
      ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("div", { className: `${userGreetingClassName}--no-loyalty__image`, children: [
          /* @__PURE__ */ jsx("img", { src: item == null ? void 0 : item.icon, alt: "" }),
          /* @__PURE__ */ jsx(
            "h6",
            {
              className: `${PREFIX}-body-lg ${PREFIX}-xs-inline-block`,
              dangerouslySetInnerHTML: { __html: item == null ? void 0 : item.title }
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `${PREFIX}-body-md`,
            dangerouslySetInnerHTML: { __html: isDashboard ? item == null ? void 0 : item.subtitle : item == null ? void 0 : item.linkCta }
          }
        ),
        isNotTriangle && /* @__PURE__ */ jsx("div", { className: `${userGreetingClassName}__register-button`, children: /* @__PURE__ */ jsx(
          "a",
          {
            "data-link-value": item == null ? void 0 : item.registerLabel,
            href: item == null ? void 0 : item.registerNowLink,
            className: `${PREFIX}-button ${PREFIX}-button--primary`,
            children: item == null ? void 0 : item.registerNowLabel
          }
        ) })
      ] })
    },
    i
  ))) });
};
const SignOut = ({ ...props }) => {
  const { onSignInButtonClickHandler, title } = props;
  return /* @__PURE__ */ jsx("div", { className: `${userGreetingClassName}-content-auth__buttons`, children: /* @__PURE__ */ jsx(Button, { onClick: onSignInButtonClickHandler, type: "secondary", id: "side-bar-sign-in-button", size: "small", children: /* @__PURE__ */ jsx("span", { className: `${PREFIX}-user-profile__title`, children: title }) }) });
};
const SignInDropDownItem = (props) => {
  const { item, type, onClickHandler, onFlyout = false } = props;
  const renderSignInOptionsComp = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      !onFlyout && /* @__PURE__ */ jsx("img", { className: `${PREFIX}-right-dropdown__image`, src: item.ctaLogo, alt: item.ctaLogoAltText }),
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-right-dropdown__label`, children: item.ctaLabel }),
      externalNavigation(item.ctaUrl) && /* @__PURE__ */ jsx(Icon, { type: "ct-external", size: "md" })
    ] });
  };
  const itemRender = () => {
    return type ? /* @__PURE__ */ jsx(Button, { type: "tertiary", size: "mini", id: "sign-in-button", ariaLabel: item.ctaLabel, onClick: onClickHandler, children: renderSignInOptionsComp() }) : /* @__PURE__ */ jsx(
      "a",
      {
        href: item.ctaUrl,
        target: item.ctaLinkTarget,
        className: `${PREFIX}-right-dropdown__link ${CommonClass.link} ${CommonClass.link}--md ${CommonClass.link}--primary`,
        children: renderSignInOptionsComp()
      }
    );
  };
  return itemRender();
};
SignInDropDownItem.propTypes = {
  item: PropTypes.object,
  type: PropTypes.bool,
  onClickHandler: PropTypes.func,
  onFlyout: PropTypes.bool
};
const SignInDropDown = (props) => {
  const {
    signInCtaLabel,
    isLoggedIn,
    onSignInButtonClickHandler,
    changeButtonType,
    onFlyout,
    ctaA11ySignInLabel,
    showIcon
  } = props;
  const buttonColor = changeButtonType ? changeButtonType : ButtonColors.LIGHT;
  const [showDropDown, setShowDropDown] = useState(false);
  const contentRef = useRef(null);
  useClickOutsideClose(contentRef, () => onSignInButtonClick(), true, true);
  const onSignInButtonClick = () => {
    setShowDropDown(!showDropDown);
  };
  const onDropDownItemClick = () => {
    onSignInButtonClickHandler();
    setShowDropDown(!showDropDown);
  };
  const menuEscapeHandler = useCallback((e) => {
    if (e.key === stringKeyCodes["esc"]) {
      setShowDropDown(false);
    }
  }, []);
  const addKeyBoardAccessibility = useCallback((firstItem, lastItem, e) => {
    const elem = document.activeElement;
    if (
      // eslint-disable-next-line sonar/expression-complexity
      e.key === stringKeyCodes["tab"] && elem === lastItem && !e.shiftKey || elem === firstItem && e.shiftKey && e.key === stringKeyCodes["tab"]
    ) {
      e.stopPropagation();
      e.preventDefault();
      setShowDropDown(false);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("keyup", menuEscapeHandler);
    return () => {
      document.removeEventListener("keyup", menuEscapeHandler);
    };
  }, [menuEscapeHandler]);
  useEffect(() => {
    let firstItem = null;
    let lastItem = null;
    if (showDropDown) {
      const menuDropDownParent = document.getElementsByClassName(
        `${PREFIX}-right-dropdown__content`
      )[0];
      const interactiveElements = menuDropDownParent == null ? void 0 : menuDropDownParent.querySelectorAll("a,button");
      const menuItems = interactiveElements && Array.from(interactiveElements);
      if (menuItems && menuItems.length > 0) {
        firstItem = menuItems[0];
        lastItem = menuItems[menuItems.length - magicNumber.ONE];
      }
      menuDropDownParent && menuDropDownParent.addEventListener("keydown", addKeyBoardAccessibility.bind(null, firstItem, lastItem));
    }
    return () => {
      document.removeEventListener("keydown", addKeyBoardAccessibility.bind(null, firstItem, lastItem));
    };
  }, [showDropDown, addKeyBoardAccessibility]);
  const renderDropdownContent = () => {
    return /* @__PURE__ */ jsx("nav", { className: `${PREFIX}-right-dropdown__content ${PREFIX}-row ${PREFIX}-col-xs-6`, ref: contentRef, children: props.ctaList.map((item, i) => /* @__PURE__ */ jsx(
      SignInDropDownItem,
      {
        item,
        type: item.ctaLinkTarget === linkTargetOptions.selfTarget,
        onClickHandler: onDropDownItemClick,
        onFlyout
      },
      i
    )) });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: !isLoggedIn && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-right-dropdown ${PREFIX}-right-dropdown__container`, children: [
    /* @__PURE__ */ jsx(
      ButtonV2,
      {
        onClick: showIcon ? onSignInButtonClick : onSignInButtonClickHandler,
        a11y: {
          label: ctaA11ySignInLabel,
          expanded: showDropDown
        },
        icon: showIcon && { size: Size.LARGE, type: `ct-chevron-${showDropDown ? "up" : "down"}` },
        variant: Variation.SECONDARY,
        color: buttonColor,
        reverse: true,
        children: signInCtaLabel
      }
    ),
    showDropDown && renderDropdownContent()
  ] }) });
};
SignInDropDown.propTypes = {
  onSignInButtonClickHandler: PropTypes.func
};
const SelectBanner = (props) => {
  const {
    backgroundImageDesktop = "",
    backgroundImageMobile = "",
    ctaLabel,
    ctaLinkTarget,
    backgroundImageAlt,
    ctaUrl,
    ctaA11yLabel,
    bgImg,
    bgImgAlt,
    logoImage,
    logoAltText,
    description,
    triangleIcon,
    ctMoneyLabel,
    ctMoneyAmount,
    view = BannerViewType.DEFAULT,
    className: className2 = `${PREFIX}-selectbanner`,
    isDesktop,
    handleResize,
    renderExpiryStatus,
    dashBoardBanner
  } = props;
  useGlobalResizeEvent(handleResize);
  const handleButtonClick = () => {
    window.open(ctaUrl, ctaLinkTarget, "noopener");
  };
  const ctaTextContainer = () => {
    return (
      /**
       * Render a button if the dashboard banner type is 'dashboard', otherwise render a link
       */
      /* @__PURE__ */ jsx("div", { className: `${className2}-ctaLabel`, children: dashBoardBanner === dashboardBannerTypes.dashboard ? /* @__PURE__ */ jsx(
        ButtonV2,
        {
          variant: Variation.PRIMARY,
          color: ButtonColors.SELECT,
          a11y: { label: ctaA11yLabel },
          onClick: handleButtonClick,
          customClass: `${className2}__dashboard-button `,
          icon: { size: Size.LARGE, type: "ct-right-arrow-black" },
          reverse: true,
          children: ctaLabel
        }
      ) : /* @__PURE__ */ jsxs("a", { href: ctaUrl, target: ctaLinkTarget, "aria-label": ctaA11yLabel, children: [
        /* @__PURE__ */ jsx("span", { children: ctaLabel }),
        ctaLinkTarget === linkTargetOptions.newTarget ? /* @__PURE__ */ jsxs(Fragment, { children: [
          " ",
          /* @__PURE__ */ jsx(Icon, { size: "lg", type: "ct-north-east-white" })
        ] }) : null
      ] }) })
    );
  };
  const renderDefaultView = () => {
    const imageUrl = isDesktop ? backgroundImageDesktop : backgroundImageMobile;
    return /* @__PURE__ */ jsx("section", { className: `${className2}-container`, children: /* @__PURE__ */ jsx(
      "div",
      {
        className: `${className2}-container--${isDesktop ? "desktop" : "mobile"}`,
        style: { backgroundImage: `url(${imageUrl})` },
        "aria-label": backgroundImageAlt,
        children: ctaTextContainer()
      }
    ) });
  };
  const renderCtMoneyEarningsView = () => {
    const iconHeight = 40;
    const iconWidth = 228;
    return /* @__PURE__ */ jsx("section", { className: `${className2}-container`, children: /* @__PURE__ */ jsx(
      "div",
      {
        className: `${className2}-container--${isDesktop ? "desktop" : "mobile"} ${className2}-container--ctm`,
        style: isDesktop || bgImg ? { backgroundImage: `url(${bgImg})` } : {},
        "aria-label": bgImgAlt,
        children: /* @__PURE__ */ jsxs("div", { className: `${className2}__ctm`, children: [
          logoImage && /* @__PURE__ */ jsx(
            "img",
            {
              src: logoImage,
              alt: logoAltText,
              className: `${className2}__ctm-logo`,
              height: iconHeight,
              width: iconWidth
            }
          ),
          /* @__PURE__ */ jsx("p", { className: `${className2}__ctm-description`, children: description }),
          ctMoneyLabel && /* @__PURE__ */ jsxs("p", { className: `${className2}__ctm-amount`, children: [
            /* @__PURE__ */ jsx(Icon, { type: triangleIcon, size: "md" }),
            /* @__PURE__ */ jsx("span", { children: `${ctMoneyAmount}` }),
            ctMoneyLabel
          ] }),
          renderExpiryStatus && renderExpiryStatus()
        ] })
      }
    ) });
  };
  return view === BannerViewType.CT_MONEY_EARNINGS ? renderCtMoneyEarningsView() : renderDefaultView();
};
const LinkOptionsCard = ({
  cardId,
  cardImage,
  cardName,
  cardImageAltText,
  redirectToOption
}) => {
  return /* @__PURE__ */ jsx(Button, { type: "tertiary", "data-testid": cardId, onClick: redirectToOption, children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-popup-link-loyalty-card`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-popup-link-loyalty-card__image-wrap`, children: /* @__PURE__ */ jsx("img", { "data-component-name": "link-master-card", src: `${cardImage}`, alt: cardImageAltText }) }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-popup-link-loyalty-card__item-title`,
        dangerouslySetInnerHTML: { __html: cardName }
      }
    )
  ] }) });
};
LinkOptionsCard.propTypes = {
  cardId: propTypesExports.string.isRequired,
  cardImage: propTypesExports.string.isRequired,
  cardName: propTypesExports.string.isRequired,
  cardImageAltText: propTypesExports.string.isRequired,
  redirectToOption: propTypesExports.func
};
const TermsAndConditions = ({
  tncTitle,
  tncAgreeLabel,
  tncAgreeLinkUrl,
  tncAgreeLinkLabel,
  tncCancelBtnLabel,
  tncRegisterBtnLabel,
  rtContent,
  mapCard,
  goToPreviousScreen
}) => {
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-terms-conditions testterms`, children: [
    /* @__PURE__ */ jsx("h3", { className: `${PREFIX}-terms-conditions-heading`, children: tncTitle }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-terms-conditions-content`,
        dangerouslySetInnerHTML: { __html: rtContent },
        "data-testid": "rtContent"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-terms-conditions-register`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-terms-conditions-register__label`, children: tncAgreeLabel }),
      /* @__PURE__ */ jsx(
        "a",
        {
          className: `${PREFIX}-terms-conditions-register__link`,
          rel: "noopener noreferrer",
          href: tncAgreeLinkUrl,
          target: "_blank",
          "data-link-value": tncAgreeLabel,
          children: tncAgreeLinkLabel
        }
      ),
      /* @__PURE__ */ jsx(Button, { type: "primary", onClick: mapCard, size: "large", children: tncRegisterBtnLabel }),
      /* @__PURE__ */ jsx(Button, { type: "tertiary", onClick: goToPreviousScreen, children: tncCancelBtnLabel })
    ] })
  ] });
};
TermsAndConditions.propTypes = {
  tncTitle: propTypesExports.string,
  tncAgreeLabel: propTypesExports.string,
  tncAgreeLinkUrl: propTypesExports.string,
  tncAgreeLinkLabel: propTypesExports.string,
  tncCancelBtnLabel: propTypesExports.string,
  tncRegisterBtnLabel: propTypesExports.string,
  rtContent: propTypesExports.string,
  goToPreviousScreen: propTypesExports.func,
  mapCard: propTypesExports.func
};
const ActiveOwnership = ({
  activeOwnershipClass,
  title,
  subTitle,
  formSubmit,
  firstBtn,
  secondBtn,
  isBtnClicked,
  textInputId,
  textInputLabel,
  textInputVal,
  textInputChangeHandler,
  textError,
  textInputMaxLength,
  yearOfBirthError,
  yearOfBirthTitle,
  yearOfBirthID,
  selectedYearOfBirth,
  yearInputMaxLength,
  yearOfBirthInputChangeHandler
}) => {
  const sendError2 = (errorMsg) => isBtnClicked ? errorMsg : "";
  const renderFirstBtn = () => checkDataLength(firstBtn) && /* @__PURE__ */ jsx(
    Button,
    {
      id: firstBtn == null ? void 0 : firstBtn.id,
      type: "primary",
      size: "large",
      buttonType: "submit",
      quantumMetricAttribute: { type: "allow", value: "true" },
      label: firstBtn == null ? void 0 : firstBtn.label,
      showSpinner: firstBtn == null ? void 0 : firstBtn.showSpinner
    }
  );
  const renderSecondBtn = () => checkDataLength(secondBtn) && /* @__PURE__ */ jsx(Button, { id: secondBtn == null ? void 0 : secondBtn.id, type: "tertiary", onClick: secondBtn == null ? void 0 : secondBtn.clickHandler, children: secondBtn == null ? void 0 : secondBtn.label });
  return /* @__PURE__ */ jsxs("div", { className: `${activeOwnershipClass}`, children: [
    /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: title, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
      "div",
      {
        className: `${activeOwnershipClass}__title`,
        dangerouslySetInnerHTML: { __html: memoizedStringContent }
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: `${activeOwnershipClass}__subTitle`, dangerouslySetInnerHTML: { __html: subTitle } }),
    /* @__PURE__ */ jsxs("form", { className: `${activeOwnershipClass}__form`, onSubmit: formSubmit, children: [
      /* @__PURE__ */ jsx(
        TextInput,
        {
          id: textInputId,
          label: textInputLabel || "",
          value: textInputVal,
          onChange: textInputChangeHandler,
          error: sendError2(textError),
          maxLength: textInputMaxLength
        }
      ),
      /* @__PURE__ */ jsx(
        TextInput,
        {
          id: yearOfBirthID,
          label: yearOfBirthTitle,
          value: selectedYearOfBirth,
          onChange: (value) => {
            yearOfBirthInputChangeHandler(value);
          },
          error: sendError2(yearOfBirthError),
          maxLength: yearInputMaxLength
        }
      ),
      renderFirstBtn(),
      renderSecondBtn()
    ] })
  ] });
};
ActiveOwnership.propTypes = {
  activeOwnershipClass: propTypesExports.string,
  title: propTypesExports.string,
  subTitle: propTypesExports.string,
  formSubmit: propTypesExports.func,
  firstBtn: propTypesExports.any,
  secondBtn: propTypesExports.any,
  isBtnClicked: propTypesExports.bool,
  textInputId: propTypesExports.string,
  textInputLabel: propTypesExports.string,
  textInputVal: propTypesExports.string,
  textInputChangeHandler: propTypesExports.func,
  textError: propTypesExports.string,
  textInputMaxLength: propTypesExports.number,
  yearOfBirthError: propTypesExports.string,
  yearOfBirthTitle: propTypesExports.string,
  yearOfBirthID: propTypesExports.string
};
var IVariant = /* @__PURE__ */ ((IVariant2) => {
  IVariant2["H1"] = "h1";
  IVariant2["H2"] = "h2";
  IVariant2["H3"] = "h3";
  IVariant2["H4"] = "h4";
  IVariant2["H5"] = "h5";
  IVariant2["H6"] = "h6";
  return IVariant2;
})(IVariant || {});
const SuccessScreen = ({ ...props }) => {
  const {
    headerBrandLogo,
    footerBrandLogo,
    successLogo,
    successMessageHeader,
    successMessageSubHeader,
    labelValueArray,
    successScreenContent,
    successScreenFooterContent,
    isDivider,
    stackedView,
    ctaList,
    headingVariant,
    isPetroInitiatedFlow
  } = props.data;
  const { children } = props;
  const componentName = `${PREFIX}-success-card`;
  const successMessageHeaderVariant = headingVariant ? headingVariant : IVariant.H2;
  const renderBranding = (image, altText, classname, showDivider) => /* @__PURE__ */ jsx(BrandFooter, { image, altText, classname, showDivider });
  const renderImageHeader = () => /* @__PURE__ */ jsxs(Fragment, { children: [
    headerBrandLogo && renderBranding(headerBrandLogo.image, headerBrandLogo.imageAlt, `${componentName}__header`),
    /* @__PURE__ */ jsx("div", { className: `${componentName}__logo`, children: /* @__PURE__ */ jsx("img", { src: successLogo.image, alt: successLogo.imageAlt }) })
  ] });
  const renderLabelValuePairs = () => {
    return labelValueArray.map((item, index2) => {
      return /* @__PURE__ */ jsxs("div", { className: `${componentName}__info-pair${stackedView ? "--stacked" : ""}`, children: [
        stackedView ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("p", { "aria-hidden": item == null ? void 0 : item.a11LabelHidden, dangerouslySetInnerHTML: { __html: item.label } }),
          (item == null ? void 0 : item.a11AriaLabel) && /* @__PURE__ */ jsx("span", { className: "sr-only", children: item == null ? void 0 : item.a11AriaLabel })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { "aria-hidden": item == null ? void 0 : item.a11LabelHidden, dangerouslySetInnerHTML: { __html: item.label } }),
          (item == null ? void 0 : item.a11AriaLabel) && /* @__PURE__ */ jsx("span", { className: "sr-only", children: item == null ? void 0 : item.a11AriaLabel })
        ] }),
        /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              "aria-hidden": item == null ? void 0 : item.a11ValueHidden,
              className: `${componentName}__info-pair-value`,
              dangerouslySetInnerHTML: { __html: item.value }
            }
          ),
          (item == null ? void 0 : item.a11AriaValueLabel) && /* @__PURE__ */ jsx("span", { className: "sr-only", children: item == null ? void 0 : item.a11AriaValueLabel })
        ] })
      ] }, index2);
    });
  };
  const renderV1Cta = (cta, i) => {
    return cta.url ? /* @__PURE__ */ jsxs(
      "a",
      {
        href: cta.url,
        target: cta.target,
        "aria-label": cta.a11yLabel,
        className: `${PREFIX}-button ${PREFIX}-button--${cta.type || "primary"} ${cta.ctaClassName ?? ""}`,
        children: [
          cta.label,
          cta.target === linkTargetOptions.newTarget && /* @__PURE__ */ jsx(Icon, { type: "ct-north-east", size: "lg" })
        ]
      },
      i
    ) : /* @__PURE__ */ jsxs(
      Button,
      {
        type: cta.type || "primary",
        size: cta.size || "large",
        onClick: cta.btnFunc,
        showSpinner: Boolean(cta.showSpinner),
        ariaLabel: cta.a11yLabel,
        children: [
          cta.label,
          cta.target === linkTargetOptions.newTarget && /* @__PURE__ */ jsx(Icon, { type: "ct-north-east", size: "lg" })
        ]
      },
      i
    );
  };
  const renderV2Cta = (cta, i) => {
    return cta.url ? /* @__PURE__ */ jsxs(
      "a",
      {
        href: cta.url,
        target: cta.target,
        "aria-label": cta.a11yLabel,
        className: `${PREFIX}-button2
                     ${PREFIX}-button2--${cta.variant || "primary"}
                     ${PREFIX}-button2--${cta.variant || "primary"}-${cta.color || "default"}
                     ${cta.ctaClassName ?? ""}`,
        children: [
          cta.label,
          cta.target === linkTargetOptions.newTarget && /* @__PURE__ */ jsx(Icon, { type: "ct-north-east", size: "lg" })
        ]
      },
      i
    ) : /* @__PURE__ */ jsxs(
      SpinnerButton,
      {
        variant: cta.variant || Variation.PRIMARY,
        color: cta.color,
        size: Size.MEDIUM,
        onClick: cta.btnFunc,
        showSpinner: Boolean(cta.showSpinner),
        icon: cta.target === linkTargetOptions.newTarget ? { type: "ct-north-east", size: "lg" } : null,
        a11y: {
          label: cta.a11yLabel
        },
        children: [
          cta.showBaseIcon && /* @__PURE__ */ jsx(BaseIcon, { animation: { type: Animation$1.PULSE }, size: Size.XL, isOutline: true }),
          cta.label
        ]
      },
      i
    );
  };
  const renderCTA = () => {
    return ctaList == null ? void 0 : ctaList.map((cta, i) => {
      const btnV2 = Boolean(cta.btnVersion === 2);
      return btnV2 ? renderV2Cta(cta, i) : renderV1Cta(cta, i);
    });
  };
  const getComponentClassName = () => {
    return isPetroInitiatedFlow ? `${componentName} ${componentName}__petro` : componentName;
  };
  const parentClassName = getComponentClassName();
  return /* @__PURE__ */ jsxs("div", { className: parentClassName, children: [
    /* @__PURE__ */ jsxs("div", { className: `${componentName}__content-wrapper`, children: [
      renderImageHeader(),
      successMessageHeader && /* @__PURE__ */ jsx(Heading, { variant: successMessageHeaderVariant, componentClass: `${componentName}__title`, children: successMessageHeader }),
      successMessageSubHeader && /* @__PURE__ */ jsx(
        "p",
        {
          className: `${componentName}__subtitle`,
          dangerouslySetInnerHTML: { __html: successMessageSubHeader }
        }
      ),
      /* @__PURE__ */ jsx("section", { className: isPetroInitiatedFlow ? `${componentName}__petro-info` : "", children: labelValueArray && renderLabelValuePairs() }),
      children,
      successScreenContent && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${componentName}__content`,
          dangerouslySetInnerHTML: { __html: successScreenContent }
        }
      ),
      ctaList.length > magicNumber.ONE ? /* @__PURE__ */ jsx("div", { className: `${componentName}__cta`, children: renderCTA() }) : renderCTA(),
      successScreenFooterContent && /* @__PURE__ */ jsx(
        "div",
        {
          className: `${componentName}__content`,
          dangerouslySetInnerHTML: { __html: successScreenFooterContent }
        }
      )
    ] }),
    footerBrandLogo && renderBranding(footerBrandLogo.image, footerBrandLogo.imageAlt, `${componentName}__footer`, isDivider)
  ] });
};
const SuccessScreenModal = ({ ...props }) => {
  const { isOpen, closeHandler, modalClassName, successScreenDataProps, children, closeButtonAriaLabel } = props;
  return /* @__PURE__ */ jsx(
    ReactModal,
    {
      isOpen,
      closeHandler,
      closeModalOnOutsideClick: true,
      role: "dialog",
      ariaModal: true,
      children: /* @__PURE__ */ jsxs("div", { role: "presentation", onClick: (e) => e.stopPropagation(), children: [
        /* @__PURE__ */ jsx("div", { className: `${modalClassName}__close-container ${PREFIX}-xs-flex ${PREFIX}-xs-justify-flex-end`, children: /* @__PURE__ */ jsx(
          Button,
          {
            ariaLabel: closeButtonAriaLabel,
            type: "icon_button",
            id: "modal-close-button",
            onClick: closeHandler,
            children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "md" })
          }
        ) }),
        /* @__PURE__ */ jsx(SuccessScreen, { data: successScreenDataProps, children })
      ] })
    }
  );
};
function getStepPosition(steps, stepIndex) {
  return magicNumber.HUNDRED / (steps - magicNumber.ONE) * stepIndex;
}
function getAllStepPositions(numberOfSteps, sidePadding) {
  const stepPositions = [];
  for (let i = 0; i < numberOfSteps; i++) {
    if (i === 0) {
      stepPositions.push(sidePadding);
    } else if (i === numberOfSteps - magicNumber.ONE) {
      stepPositions.push(magicNumber.HUNDRED - sidePadding);
    } else {
      stepPositions.push(positionByIndex(numberOfSteps, sidePadding, i));
    }
  }
  return stepPositions;
}
function positionByIndex(numberOfSteps, sidePadding, index2) {
  return (magicNumber.HUNDRED - magicNumber.TWO * sidePadding) / (numberOfSteps - magicNumber.ONE) * index2 + sidePadding;
}
function calculateAndSetPercentage(numberOfSteps, currentStep, sidePadding, setterFunction) {
  if (currentStep === 0) {
    setterFunction(sidePadding);
  } else if (currentStep === numberOfSteps + magicNumber.ONE) {
    setterFunction(magicNumber.HUNDRED);
  } else {
    setterFunction(positionByIndex(numberOfSteps, sidePadding, currentStep));
  }
}
const defaultFilledColor = "#262626";
const defaultUnfilledColor = "#D4D4D4";
const ProgressBar = (props) => {
  const {
    children,
    unfilledBackground = defaultUnfilledColor,
    filledBackground = defaultFilledColor,
    thickness = "auto",
    currentStep = 0,
    sidePadding = 0,
    vertical,
    nextStepProgress,
    nextStepStyleOverride = {}
  } = props;
  const [stepPercentage, setStepPercentage] = useState(0);
  const stepPositions = getAllStepPositions(children.length, sidePadding);
  useEffect(() => {
    calculateAndSetPercentage(children.length, currentStep, sidePadding, setStepPercentage);
  }, [currentStep, sidePadding, children.length]);
  const safePercent = getSafePercent(stepPercentage);
  const lastStep = children.length - magicNumber.ONE === currentStep;
  const verticalClass = vertical ? `${PREFIX}-progress-bar--vertical` : "";
  const sizeProp = vertical ? "width" : "height";
  const progressionSizeProp = vertical ? "height" : "width";
  const progressionPositionProp = vertical ? "top" : "left";
  const singleStepSize = stepPositions[magicNumber.ONE];
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${PREFIX}-progress-bar ${verticalClass}`,
      "data-testid": `${PREFIX}-progress-bar`,
      style: { background: unfilledBackground, [sizeProp]: thickness },
      children: [
        React.Children.map(children, (step, index2) => {
          const position = stepPositions.length > 0 ? stepPositions[index2] : getStepPosition(React.Children.count(children), index2);
          return React.cloneElement(step, {
            completed: position < safePercent,
            position,
            index: index2,
            vertical
          });
        }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `${PREFIX}-progress-bar__progression`,
            "data-testid": `${PREFIX}-progress-bar__progression`,
            style: {
              background: filledBackground,
              [sizeProp]: thickness,
              [progressionSizeProp]: `${safePercent}%`
            }
          }
        ),
        nextStepProgress && !lastStep && /* @__PURE__ */ jsx(
          "div",
          {
            className: `${PREFIX}-progress-bar__progression`,
            "data-testid": `${PREFIX}-progress-bar__progression`,
            style: {
              background: filledBackground,
              [sizeProp]: thickness,
              [progressionSizeProp]: `${singleStepSize}%`,
              [progressionPositionProp]: `${safePercent}%`,
              ...nextStepStyleOverride
            }
          }
        )
      ]
    }
  );
};
ProgressBar.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  unfilledBackground: PropTypes.string,
  filledBackground: PropTypes.string,
  thickness: PropTypes.string,
  sidePadding: PropTypes.number,
  currentStep: PropTypes.number,
  vertical: PropTypes.bool,
  nextStepProgress: PropTypes.bool,
  nextStepStyleOverride: PropTypes.object
};
ProgressBar.displayName = "ProgressBar";
const Step = ({ ...props }) => {
  const {
    completed,
    position,
    index: index2,
    children,
    transitionDuration = magicNumber.THREEHUNDRED,
    vertical,
    customClass
  } = props;
  const safePosition = getSafePercent(position);
  const progressionPositionProp = vertical ? "top" : "left";
  const style = {
    [progressionPositionProp]: `${safePosition}%`,
    transitionDuration: `${transitionDuration}ms`
  };
  const verticalClass = vertical ? `${PREFIX}-progress-bar__step--vertical` : "";
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${PREFIX}-progress-bar__step ${verticalClass} ${customClass}`,
      "data-testid": `${PREFIX}-progress-bar__step`,
      style,
      children: children ? children({
        index: index2,
        completed,
        position: safePosition
      }) : ""
    }
  );
};
Step.propTypes = {
  completed: PropTypes.bool,
  position: PropTypes.number,
  index: PropTypes.number,
  transitionDuration: PropTypes.number,
  children: PropTypes.func
};
Step.displayName = "Step";
const getButtonStatus = (status, type, labels) => {
  const { activated, activate, redeemed, allActivated, swap } = type;
  const { activatedLabel, activateLabel, redeemedLabel, allActivatedLabel, swapOfferCTALabel } = labels;
  const lowerCase = (item) => item == null ? void 0 : item.toLocaleLowerCase();
  const { activateStatus, activatedStatus, redeemedStatus, swapOfferStatus } = statusLabel;
  const confirmIcon = "ct-confirm";
  switch (lowerCase(status)) {
    case lowerCase(activatedStatus):
      return {
        class: lowerCase(activated),
        label: activatedLabel,
        icon: confirmIcon
      };
    case lowerCase(activateStatus):
      return {
        class: lowerCase(activate),
        label: activateLabel,
        icon: "ct-plus"
      };
    case lowerCase(redeemedStatus):
      return {
        class: lowerCase(redeemed),
        label: redeemedLabel,
        icon: "ct-gift"
      };
    case lowerCase(allActivatedLabel):
      return {
        class: lowerCase(allActivated),
        label: allActivatedLabel,
        icon: confirmIcon
      };
    case lowerCase(swapOfferStatus):
      return {
        class: lowerCase(swap),
        label: swapOfferCTALabel,
        icon: "ct-swap"
      };
    default:
      return void 0;
  }
};
const isOtpErrorCode = (errorCode = "", errorType = OtpErrorType.INIT_ERROR) => {
  return Object.values(otpErrorCodes[errorType]).includes(errorCode);
};
const getValueByComponent = (multiField, component, componentList) => {
  if (!multiField || !component) {
    return "";
  }
  let result;
  const chainOfComponents = recursiveSearch(componentList, component);
  chainOfComponents == null ? void 0 : chainOfComponents.push(componentType.default);
  chainOfComponents == null ? void 0 : chainOfComponents.every((title) => {
    result = multiField.find((field) => title === field.component);
    return !result;
  });
  return result ? result.value : "";
};
const recursiveSearch = (currentObj, component, path = []) => {
  for (const key in currentObj) {
    if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
      const value = currentObj[key];
      const newPath = [key, ...path];
      if (newPath.length > magicNumber.ONE) {
        newPath[0] = newPath[1].concat(`.${newPath[0]}`);
      }
      if (key === component) {
        return newPath;
      }
      if (typeof value === "object" && value !== null) {
        const result = recursiveSearch(value, component, newPath);
        if (result) {
          return result;
        }
      }
    }
  }
  return null;
};
const offerConstants = {
  offerCode: "offerCode",
  maxRewardsCount: magicNumber.ONETHOUSAND,
  currentPageInitialValue: magicNumber.ONE,
  view: "view",
  click: "click",
  loyaltyOffersAppearedTimes: "loyaltyOffersAppearedTimes",
  loyaltyOffersWereExpanded: "loyaltyOffersWereExpanded",
  loyaltyOffersPanelDismiss: "loyaltyOffersPanelDismiss",
  flatrate: "FLATRATE",
  zeroMultiplier: "0X",
  percent: "%",
  activated: "ACTIVATED",
  activate: "ACTIVATE",
  redeemed: "REDEEMED",
  swap: "SWAP",
  offersCardImgComponentName: "offers-card",
  bannerLogoImgComponentName: "banner-logo",
  yes: "Y",
  ctLogo: "https://media-www.canadiantire.ca/logo/ct-brandmark-standard-primary-rgw-pos-hex-5f6ce5ad-aadc-44da-9d55-a06d4c6273bb.svg",
  coachmark: "coachmark",
  search: "Search",
  offerPoolType: "S"
};
var offerComponentLocation = /* @__PURE__ */ ((offerComponentLocation2) => {
  offerComponentLocation2["accountOffers"] = "accountOffers";
  offerComponentLocation2["pdpWidget"] = "pdpWidget";
  offerComponentLocation2["loyaltyOffer"] = "loyaltyOffer";
  offerComponentLocation2["pdpOffers"] = "pdpOffers";
  offerComponentLocation2["carouselOffers"] = "carouselOffers";
  return offerComponentLocation2;
})(offerComponentLocation || {});
const learnMoreModalData = {
  learnMorePopupId: "learnMoreModal",
  learnMorePopupCloseButtonClass: `${PREFIX}-informative-modal__close-container`,
  trianglePopupOpenedClass: `${PREFIX}-react-modal--opened`
};
const EmptyScreen = (props) => {
  const {
    image,
    imageAltText,
    title,
    subtitle,
    mainClass,
    CTALabel,
    CTALink,
    toggleView,
    isSideView,
    onClickHandler,
    imageHeight,
    imageWidth
  } = props;
  const renderStackedView = () => {
    const toggleViewClass = !toggleView ? `${mainClass}-content` : `${mainClass}-details`;
    return /* @__PURE__ */ jsxs("div", { className: `${mainClass} ${toggleViewClass}`, children: [
      /* @__PURE__ */ jsx(
        "img",
        {
          className: `${mainClass}--img`,
          src: image,
          alt: imageAltText,
          height: imageHeight,
          width: imageWidth
        }
      ),
      /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: title, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
        "h4",
        {
          className: `${mainClass}--heading`,
          dangerouslySetInnerHTML: { __html: memoizedStringContent }
        }
      ) }),
      /* @__PURE__ */ jsx("p", { className: `${mainClass}--content`, dangerouslySetInnerHTML: { __html: subtitle } }),
      CTALabel && /* @__PURE__ */ jsx("a", { className: `${PREFIX}-button ${PREFIX}-button--primary ${PREFIX}-button--small`, href: CTALink, children: CTALabel })
    ] });
  };
  const renderSideView = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${mainClass} ${PREFIX}-row`, children: [
      /* @__PURE__ */ jsx("div", { className: `${mainClass}__container-image`, children: /* @__PURE__ */ jsx(
        "img",
        {
          className: `${mainClass}__image`,
          src: image,
          alt: imageAltText,
          height: imageHeight,
          width: imageWidth
        }
      ) }),
      /* @__PURE__ */ jsxs("div", { className: `${mainClass}__container-content`, children: [
        /* @__PURE__ */ jsx("h3", { className: `${mainClass}__heading`, children: title }),
        /* @__PURE__ */ jsx("p", { className: `${mainClass}__description`, children: subtitle }),
        CTALabel && /* @__PURE__ */ jsx(Button, { type: "primary", size: "small", onClick: onClickHandler, children: CTALabel })
      ] })
    ] });
  };
  return isSideView ? renderSideView() : renderStackedView();
};
EmptyScreen.propTypes = {
  image: PropTypes.string.isRequired,
  imageAltText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onClickHandler: PropTypes.func,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number
};
const getColorClass = (className2) => {
  var _a, _b, _c, _d;
  switch (className2) {
    case ((_a = statusLabel.activateStatus) == null ? void 0 : _a.toLocaleLowerCase()):
      return ButtonColors.ACTIVATE;
    case ((_b = statusLabel.activatedStatus) == null ? void 0 : _b.toLocaleLowerCase()):
      return ButtonColors.LIGHT;
    case ((_c = statusLabel.swapOfferStatus) == null ? void 0 : _c.toLocaleLowerCase()):
      return ButtonColors.DARK;
    case ((_d = statusLabel.redeemedStatus) == null ? void 0 : _d.toLocaleLowerCase()):
      return ButtonColors.LIGHT;
    default:
      return ButtonColors.DEFAULT;
  }
};
const getOfferCardExpiryDate = (offer, offerEndsTodayLabel, offerEndsInLabel, offerEndsLabel, isDateInNumeric = false) => {
  var _a;
  const offerExpiryInDaysForm = Number(offer.daysLeft) < 1 ? offerEndsTodayLabel : replaceMultipleStrWithDynamicVal(offerEndsInLabel, [offer.daysLeft]);
  const offerExpiryInDateForm = isDateInNumeric ? `${(_a = offer == null ? void 0 : offer.offerEndDate) == null ? void 0 : _a.replace(offerEndDateRegex, "$1/$2/$3")}` : getDateOfBirth(offer == null ? void 0 : offer.offerEndDate, dateOptions.style1.month);
  return Number(offer.daysLeft) > 7 ? `${offerEndsLabel} ${offerExpiryInDateForm}` : offerExpiryInDaysForm;
};
const OfferCard = (props) => {
  const {
    offer,
    bannerImageList,
    offerEndsLabel,
    isFlyout,
    activateOffer,
    modalLabel,
    classNameSubtitle,
    classNameDates = "",
    classNameAlign,
    classNameCarousel,
    closeModal,
    offerEndsTodayLabel,
    offerEndsDateLabel,
    columns = {},
    status,
    openModal,
    shouldStaticOffersBeShown = false,
    updateOfferState,
    component,
    filteredOffers,
    akamaiPolicy,
    moreDetailsLabel,
    isAccordionOpen,
    alidaAppId,
    offersSortBy,
    recomendationList,
    swapLimit = {},
    condensedClass,
    showSwapCTA = true,
    condensedView = false,
    loyaltyCardNumber,
    needToRefreshOffers,
    isBackButtonEnabled = false,
    maxRewardsCount
  } = props;
  const { md, sm, xs } = columns;
  const { details, displayBanner, offerQuantity, offerCode } = offer || {};
  const { numberOfOffersLeftText, a11yNumberOfOffersLeft, numberOfOffersLeftBadgeLimit } = swapLimit;
  const {
    returnPolicy,
    offersCardImgComponentName,
    bannerLogoImgComponentName,
    fallbackOfferImageUrl,
    fallbackImageForBrandLogo,
    fallbackImageForBrandLogoAltText
  } = akamaiPolicy || {};
  const colSizes = `${PREFIX}-col-md-${md} ${PREFIX}-col-sm-${sm} ${PREFIX}-col-xs-${xs}`;
  const setBannerLogo2 = (bannerName) => {
    const getBannerName = bannerName == null ? void 0 : bannerName.toString();
    return bannerImageList && bannerImageList.find((imageList) => getBannerName === imageList.bannerId);
  };
  const mutipleBanner = displayBanner == null ? void 0 : displayBanner.includes(",");
  const { bannerImagePath, bannerImageAlt } = setBannerLogo2(displayBanner) || {};
  const brandImage = mutipleBanner ? fallbackImageForBrandLogo : bannerImagePath;
  const brandImageAlt = mutipleBanner ? fallbackImageForBrandLogoAltText : bannerImageAlt;
  const componentClassName2 = `${PREFIX}-offers-card`;
  const newDate = getOfferCardExpiryDate(offer, offerEndsTodayLabel, offerEndsLabel, offerEndsDateLabel, true);
  const modalHeader = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-offers-card__modal--header`, children: [
      /* @__PURE__ */ jsx("h2", { className: `${PREFIX}-offers-card__modal--title`, children: modalLabel }),
      !isBackButtonEnabled && /* @__PURE__ */ jsx(Button, { type: "icon_button", size: "mini", id: "close-modal", onClick: () => closeModal(false), children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" }) })
    ] });
  };
  const renderOfferSubtitle = () => {
    return isFlyout ? /* @__PURE__ */ jsx(
      Heading,
      {
        variant: "h3",
        componentClass: `${PREFIX}-offers-card__modal--subtitle ${classNameSubtitle ? classNameSubtitle : ""}`,
        children: details == null ? void 0 : details.offerShortDesc
      }
    ) : /* @__PURE__ */ jsx("div", { className: `${PREFIX}-offers-card__wrapper--subtitle`, children: /* @__PURE__ */ jsx(
      "p",
      {
        title: details == null ? void 0 : details.offerShortDesc,
        className: `${PREFIX}-offers-card__wrapper--subtitle-description ${classNameSubtitle ? classNameSubtitle : ""}`,
        children: details == null ? void 0 : details.offerShortDesc
      }
    ) });
  };
  const renderOfferTitleAndDate = () => /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-offers-card__${isFlyout ? "modal-align" : "wrapper-align"} ${classNameAlign}`, children: [
    renderOfferSubtitle(),
    renderOffersLoyaltyContent()
  ] });
  const renderBodyDescription = () => /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__details-desc`, children: [
    isFlyout && renderOfferTitleAndDate(),
    /* @__PURE__ */ jsx("p", { className: `${PREFIX}-h4`, children: details == null ? void 0 : details.bonusDescription })
  ] });
  const renderOffersLoyaltyContent = () => {
    const flyoutClassName = isFlyout ? "modal" : "wrapper";
    return !shouldStaticOffersBeShown && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-offers-card__wrapper-end`, children: [
      /* @__PURE__ */ jsx(
        "span",
        {
          className: `${PREFIX}-offers-card__${flyoutClassName}--dates ${classNameDates}`,
          title: newDate,
          children: newDate
        }
      ),
      condensedView && renderFooter()
    ] });
  };
  const renderNotificationBadge = () => {
    return !!offerQuantity && Number(offerQuantity) < numberOfOffersLeftBadgeLimit && /* @__PURE__ */ jsx(
      NotificationBadge,
      {
        value: replaceStrWithDynamicVal(numberOfOffersLeftText, offerQuantity),
        a11y: { label: replaceStrWithDynamicVal(a11yNumberOfOffersLeft, offerQuantity) },
        notificationClass: `${componentClassName2}__notification`,
        color: State.ACTIVE,
        size: Size.MEDIUM,
        radius: { size: Radius.CIRCLE, position: Position.RIGHT }
      }
    );
  };
  const renderBody = () => {
    const containerClassName = isFlyout ? `${PREFIX}-offers-card__modal-content` : "";
    return /* @__PURE__ */ jsxs("div", { className: `${containerClassName}`, children: [
      /* @__PURE__ */ jsxs(
        ButtonV2,
        {
          variant: Variation.TERTIARY,
          color: ButtonColors.LIGHT,
          "aria-haspopup": "true",
          id: `offer-${offerCode}`,
          disabled: isFlyout,
          customClass: `${componentClassName2}--btn`,
          onClick: (e) => {
            const elem = e.currentTarget;
            elem.setAttribute(previousElementName, "true");
            !isFlyout && openModal(offer, e);
          },
          children: [
            /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__banner`, children: [
              /* @__PURE__ */ jsx(
                "img",
                {
                  className: `${componentClassName2}__logo`,
                  alt: brandImageAlt,
                  ...applyAkamaiPolicy(brandImage, bannerLogoImgComponentName, false, returnPolicy)
                }
              ),
              /* @__PURE__ */ jsx(
                "img",
                {
                  className: `${componentClassName2}__logo`,
                  alt: "",
                  ...applyAkamaiPolicy(
                    details == null ? void 0 : details.badgeImageUrl,
                    bannerLogoImgComponentName,
                    false,
                    returnPolicy
                  )
                }
              )
            ] }),
            !condensedView && /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__image-container`, children: [
              /* @__PURE__ */ jsxs("picture", { children: [
                /* @__PURE__ */ jsx(
                  "source",
                  {
                    type: "image/png",
                    ...applyAkamaiPolicy(
                      details == null ? void 0 : details.thumbnailUrl,
                      offersCardImgComponentName,
                      false,
                      returnPolicy
                    )
                  }
                ),
                /* @__PURE__ */ jsx(
                  "img",
                  {
                    className: `${componentClassName2}__img`,
                    alt: "",
                    ...applyAkamaiPolicy(
                      fallbackOfferImageUrl,
                      offersCardImgComponentName,
                      false,
                      returnPolicy
                    )
                  }
                )
              ] }),
              renderNotificationBadge()
            ] }),
            !isFlyout && renderOfferTitleAndDate()
          ]
        }
      ),
      isFlyout && renderBodyDescription()
    ] });
  };
  const renderFooter = () => {
    var _a, _b, _c, _d, _e;
    return !shouldStaticOffersBeShown && showSwapCTA && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__footer`, children: /* @__PURE__ */ jsx(
      ButtonV2,
      {
        id: `activate-cta-${offerCode}`,
        variant: Variation.PRIMARY,
        size: Size.MINI,
        customClass: ` ${(status == null ? void 0 : status.class) === ((_a = statusLabel.activatedStatus) == null ? void 0 : _a.toLocaleLowerCase()) ? `${componentClassName2}__cta-icon` : ""}`,
        color: getColorClass(status == null ? void 0 : status.class),
        disabled: (status == null ? void 0 : status.class) === ((_b = statusLabel.activatedStatus) == null ? void 0 : _b.toLocaleLowerCase()) || (status == null ? void 0 : status.class) === ((_c = statusLabel.redeemedStatus) == null ? void 0 : _c.toLocaleLowerCase()),
        a11y: {
          disabled: (status == null ? void 0 : status.class) === ((_d = statusLabel.activatedStatus) == null ? void 0 : _d.toLocaleLowerCase()) || (status == null ? void 0 : status.class) === ((_e = statusLabel.redeemedStatus) == null ? void 0 : _e.toLocaleLowerCase())
        },
        onClick: (e) => {
          e.stopPropagation();
          activateOffer(offer, updateOfferState, filteredOffers, component, alidaAppId || offersSortBy, {
            maxRewardsCount,
            loyaltyCardNumber,
            needToFetchOffers: needToRefreshOffers
          });
        },
        icon: { type: status == null ? void 0 : status.icon, size: "lg" },
        children: status == null ? void 0 : status.label
      }
    ) });
  };
  const renderAccordion = () => /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__modal--more-details`, children: /* @__PURE__ */ jsx(Accordion, { title: moreDetailsLabel, isHeaderOpen: isAccordionOpen, children: /* @__PURE__ */ jsx("p", { className: `${PREFIX}-body-sm`, children: details == null ? void 0 : details.bonusDetailedDescription }) }) });
  const renderRecommendationsComponent = () => /* @__PURE__ */ jsx(
    RecommendationsList,
    {
      title: recomendationList.title,
      productList: recomendationList == null ? void 0 : recomendationList.productList,
      priceProps: recomendationList == null ? void 0 : recomendationList.priceProps,
      a11yStrikeOutPrice: recomendationList.a11yStrikeOutPrice,
      a11yStrikeOutPriceRange: recomendationList.a11yStrikeOutPriceRange,
      language: recomendationList.language,
      returnPolicy,
      selectedSchemaId: recomendationList.selectedSchemaId,
      isYouNeedThis: false,
      badgePriorities: recomendationList.badgePriorities,
      enableBadges: true,
      maximumNumberOfRecommendations: recomendationList.maximumNumberOfRecommendations
    }
  );
  const renderBodyAndFooter = () => /* @__PURE__ */ jsx(
    "div",
    {
      className: `${isFlyout ? `${componentClassName2}__details` : `${colSizes} ${classNameCarousel} ${componentClassName2}__tile ${condensedClass}`}`,
      "data-testid": "weekly-offers-card",
      children: /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__${isFlyout ? "modal-wrapper" : "wrapper"}`, children: [
        renderBody(),
        isFlyout && renderAccordion(),
        isFlyout && (recomendationList == null ? void 0 : recomendationList.productList) && renderRecommendationsComponent(),
        !condensedView && renderFooter()
      ] })
    }
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isFlyout && modalHeader(),
    renderBodyAndFooter()
  ] });
};
OfferCard.propTypes = {
  classNameAlign: PropTypes.string,
  classNameCarousel: PropTypes.string
};
OfferCard.defaultProps = {
  classNameAlign: "",
  classNameCarousel: ""
};
const TemplateCard = ({ ...props }) => {
  const { columns, swapOfferCTALabel, dummyOffer, akamaiPolicy, isSwapList, customClass } = props;
  const { md, sm, xs } = columns;
  const { offersCardImgComponentName, returnPolicy } = akamaiPolicy;
  const componentClassName2 = `${PREFIX}-template-card`;
  const customModifyClass = customClass ? `${PREFIX}-${customClass}` : "";
  const renderBody = (offer) => /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__container`, children: [
    /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__banner`, children: /* @__PURE__ */ jsx(
      "img",
      {
        className: `${componentClassName2}__logo`,
        alt: "",
        ...applyAkamaiPolicy(offer == null ? void 0 : offer.bannerLogo, offersCardImgComponentName, false, returnPolicy)
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__img-container`, children: /* @__PURE__ */ jsxs("picture", { children: [
      /* @__PURE__ */ jsx(
        "source",
        {
          type: "image/png",
          ...applyAkamaiPolicy(
            offer == null ? void 0 : offer.swapOffersTourBannerImg,
            offersCardImgComponentName,
            false,
            returnPolicy
          )
        }
      ),
      /* @__PURE__ */ jsx(
        "img",
        {
          className: `${componentClassName2}__img`,
          alt: (offer == null ? void 0 : offer.swapOffersTourBannerImgAltText) || "",
          ...applyAkamaiPolicy(
            offer == null ? void 0 : offer.swapOffersTourBannerImg,
            offersCardImgComponentName,
            false,
            returnPolicy
          )
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__wrapper-align`, children: [
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__wrapper--subtitle`, children: /* @__PURE__ */ jsx(
        "p",
        {
          title: (offer == null ? void 0 : offer.swapOffersTourBannerHeading) || "",
          className: `${componentClassName2}__wrapper--subtitle-description`,
          children: (offer == null ? void 0 : offer.swapOffersTourBannerHeading) || ""
        }
      ) }),
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__wrapper-end`, children: /* @__PURE__ */ jsx(
        "span",
        {
          className: `${componentClassName2}__wrapper--dates`,
          title: (offer == null ? void 0 : offer.swapOffersTourOfferExpiryLabel) || "",
          children: (offer == null ? void 0 : offer.swapOffersTourOfferExpiryLabel) || ""
        }
      ) })
    ] })
  ] });
  const renderFooter = () => /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__footer`, children: /* @__PURE__ */ jsxs(
    ButtonV2,
    {
      size: Size.MINI,
      variant: Variation.PRIMARY,
      color: isSwapList ? ButtonColors.DARK : ButtonColors.LIGHT,
      customClass: !isSwapList ? `${componentClassName2}__cta-icon` : "",
      icon: { size: Size.LARGE, type: isSwapList ? "ct-swap" : "ct-confirm" },
      a11y: { disabled: true },
      disabled: true,
      children: [
        isSwapList && /* @__PURE__ */ jsx(BaseIcon, { animation: { type: Animation$1.PULSE }, size: Size.XL, isOutline: true }),
        isSwapList ? swapOfferCTALabel || "" : statusLabel == null ? void 0 : statusLabel.activatedStatus
      ]
    }
  ) });
  return /* @__PURE__ */ jsx(
    "section",
    {
      className: `${PREFIX}-col-md-${md} ${PREFIX}-col-sm-${sm} ${PREFIX}-col-xs-${xs} ${componentClassName2}__tile ${customModifyClass}`,
      children: /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__wrapper`, children: [
        renderBody(dummyOffer),
        renderFooter()
      ] })
    }
  );
};
const OfferFlyout = ({ ...props }) => {
  const {
    isOpen,
    setIsFlyoutOpen,
    offer,
    activateOffer,
    status,
    columns,
    modalLabel,
    activationOfferClickHandler,
    alidaAppId,
    offersSortBy,
    recomendationList,
    swapLimit,
    maxRewardsCount
  } = props;
  const contentRef = useRef(null);
  const modalClassName = `${PREFIX}-previous-element`;
  const previousElement = document.querySelector(`button[${previousElementName}]`) || document.querySelector(`div[${previousElementName}]`);
  useEffect(() => {
    if (props.isOpen) {
      document.body.classList.add(MODAL_OPEN_CLASS$1);
    } else {
      document.body.classList.remove(MODAL_OPEN_CLASS$1);
    }
    return () => {
      document.body.classList.remove(MODAL_OPEN_CLASS$1);
    };
  }, [props.isOpen]);
  const closeFlyout = (isCloseClicked) => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    setIsFlyoutOpen(isCloseClicked);
    activationOfferClickHandler && activationOfferClickHandler();
    if (previousElement) {
      setTimeout(() => {
        previousElement == null ? void 0 : previousElement.focus();
        previousElement == null ? void 0 : previousElement.removeAttribute(previousElementName);
      }, magicNumber.ZERO);
    }
  };
  const flyoutModalProps = {
    isOpen,
    closeFlyout,
    isStoreSelectorModalUsed: false
  };
  useClickOutsideClose(contentRef, () => closeFlyout(false), isOpen, true);
  return /* @__PURE__ */ jsx(FlyoutModalComponent, { ...flyoutModalProps, children: /* @__PURE__ */ jsx("div", { ref: contentRef, className: `${PREFIX}-offers-card__flyout`, children: /* @__PURE__ */ jsx(
    OfferCard,
    {
      ...props,
      modalLabel,
      offer,
      isFlyout: true,
      alidaAppId: alidaAppId ? alidaAppId : "",
      activateOffer,
      closeModal: closeFlyout,
      status,
      columns,
      offersSortBy,
      recomendationList,
      swapLimit,
      maxRewardsCount
    },
    "offer_card_flyout"
  ) }) });
};
const getOfferSorting = (label, brand, category) => {
  return brand ? [
    {
      label,
      id: label,
      selected: true
    },
    {
      label: brand,
      id: brand,
      selected: false
    },
    {
      label: category,
      id: category,
      selected: false
    }
  ] : [
    {
      label,
      id: label,
      selected: true
    },
    {
      label: category,
      id: category,
      selected: false
    }
  ];
};
const CardItemRow = ({ ...props }) => {
  const { label, value, enteredField, informationField } = props;
  return /* @__PURE__ */ jsxs(
    "dl",
    {
      className: `${PREFIX}-row ${PREFIX}-information-card__info-size ${PREFIX}-mt-xs ${PREFIX}-mb-xs`,
      "aria-label": `${enteredField} ${label} ${informationField}`,
      children: [
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-col-xs-6 ${PREFIX}-col-sm-4 ${PREFIX}-col-md-4  `, children: /* @__PURE__ */ jsx("dt", { className: `${PREFIX}-information-card__dt-text-gray`, children: label }) }),
        /* @__PURE__ */ jsx("div", { className: `${PREFIX}-col-xs-6 ${PREFIX}-col-sm-8 ${PREFIX}-col-md-8 `, children: /* @__PURE__ */ jsx("dd", { className: `${PREFIX}-information-card__dd-text-black`, children: value }) })
      ]
    }
  );
};
CardItemRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  enteredField: PropTypes.string,
  informationField: PropTypes.string
};
const InformationCard = ({ ...props }) => {
  const {
    header,
    data,
    actionButtonLabel,
    onActionButtonClick,
    enteredField,
    informationField,
    inApp,
    vehicleHeader,
    locationHeader
  } = props;
  const filteredData = data.filter((item) => !!item.value);
  const isVehicleOrLocationHeader = header === vehicleHeader || header === locationHeader;
  return /* @__PURE__ */ jsx(Fragment, { children: filteredData.length > 0 && /* @__PURE__ */ jsx(CommonCardWrapper, { noPadding: true, children: /* @__PURE__ */ jsx(CommonCard, { children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-information-card`, children: [
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-row`, children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-information-card__section-header ${PREFIX}-col-md-4 ${PREFIX}-col-xs-4`,
          children: header
        }
      ),
      !(inApp && isVehicleOrLocationHeader) && actionButtonLabel ? /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-information-card__text-end ${PREFIX}-col-md-8 ${PREFIX}-col-xs-2 `,
          children: /* @__PURE__ */ jsx(
            Button,
            {
              "data-testid": "changeButton",
              ariaLabel: `${actionButtonLabel} ${enteredField} ${header}`,
              type: "tertiary",
              size: "mini",
              onClick: onActionButtonClick,
              children: actionButtonLabel
            }
          )
        }
      ) : /* @__PURE__ */ jsx("span", { "data-testid": "blankField" })
    ] }),
    filteredData.map(({ label, value }, index2) => /* @__PURE__ */ jsx(
      CardItemRow,
      {
        label,
        value,
        enteredField,
        informationField
      },
      index2
    ))
  ] }) }) }) });
};
InformationCard.propTypes = {
  header: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    }).isRequired
  ).isRequired,
  actionButtonLabel: PropTypes.string.isRequired,
  onActionButtonClick: PropTypes.func.isRequired,
  enteredField: PropTypes.string,
  informationField: PropTypes.string,
  inApp: PropTypes.bool,
  vehicleHeader: PropTypes.string,
  locationHeader: PropTypes.string
};
const MessageCard = ({
  icon,
  primaryText,
  renderComplementaryText,
  renderDescription
}) => /* @__PURE__ */ jsx(CommonCardWrapper, { children: /* @__PURE__ */ jsx(CommonCard, { children: /* @__PURE__ */ jsxs("article", { className: `${PREFIX}-message-card`, children: [
  /* @__PURE__ */ jsx(Icon, { type: icon, size: "lg" }),
  primaryText && /* @__PURE__ */ jsx("h1", { className: `${PREFIX}-message-card__title ${PREFIX}-mt-sm`, children: primaryText }),
  renderComplementaryText && renderComplementaryText(),
  renderDescription && renderDescription()
] }) }) });
MessageCard.propTypes = {
  primaryText: PropTypes.string,
  icon: PropTypes.string.isRequired,
  renderComplementaryText: PropTypes.func,
  renderDescription: PropTypes.func
};
const offerZeroMultiplierFilter = (offer) => offer.details.awardValue === offerConstants.zeroMultiplier;
const percentsSavingOffersFilter = (offer) => {
  var _a;
  return (_a = offer.details.bonusDescription) == null ? void 0 : _a.includes(offerConstants.percent);
};
const remainingOffersFilter = (offer) => {
  var _a;
  return !((_a = offer.details.bonusDescription) == null ? void 0 : _a.includes(offerConstants.percent));
};
const compareByAwardValue = (offer1, offer2) => {
  return parseInt(offer2.details.awardValue, 10) - parseInt(offer1.details.awardValue, 10);
};
const compareByDaysLeft = (offer1, offer2) => {
  return parseInt(offer1.daysLeft, 10) - parseInt(offer2.daysLeft, 10);
};
const compareByAwardValueAndDaysLeft = (offer1, offer2) => {
  const awardComparison = compareByAwardValue(offer1, offer2);
  if (awardComparison === 0) {
    return compareByDaysLeft(offer1, offer2);
  }
  return awardComparison;
};
const sortOffers = (offers) => {
  const redeemedOffers = offers.filter(
    (offer) => (offer == null ? void 0 : offer.offerStatus) === offerConstants.redeemed && (offer == null ? void 0 : offer.redeemed) === checkToggle.yes
  );
  const redeemedSpentAndGetOffers = redeemedOffers.filter(
    (offer) => offer.details.bonusType === offerConstants.flatrate
  );
  const redeemedmultiplierOffers = redeemedOffers.filter((offer) => !redeemedSpentAndGetOffers.includes(offer));
  const allOffersExceptRedeemed = offers.filter((offer) => !redeemedOffers.includes(offer));
  const spentAndGetOffers = allOffersExceptRedeemed.filter(
    (offer) => offer.details.bonusType === offerConstants.flatrate
  );
  const nonSpentAndGetOffers = allOffersExceptRedeemed.filter((offer) => !spentAndGetOffers.includes(offer));
  const notActivatedOffers = nonSpentAndGetOffers.filter(
    (offer) => offer.offerActivated !== checkToggle.yes && offer.offerActivationRequired !== checkToggle.no
  );
  const zeroMultiplierNotActivatedOffers = notActivatedOffers.filter(offerZeroMultiplierFilter);
  const multiplierNotActivatedOffers = notActivatedOffers.filter(
    (offer) => !zeroMultiplierNotActivatedOffers.includes(offer)
  );
  const percentsSavingNotActivatedOffers = zeroMultiplierNotActivatedOffers.filter(percentsSavingOffersFilter);
  const remainingNotActivatedOffers = zeroMultiplierNotActivatedOffers.filter(remainingOffersFilter);
  const activatedOffers = nonSpentAndGetOffers.filter((offer) => !notActivatedOffers.includes(offer));
  const zeroMultiplierActiveOffers = activatedOffers.filter(offerZeroMultiplierFilter);
  const multiplierActiveOffers = activatedOffers.filter((offer) => !zeroMultiplierActiveOffers.includes(offer));
  const percentsSavingOffers = zeroMultiplierActiveOffers.filter(percentsSavingOffersFilter);
  const remainingOffers = zeroMultiplierActiveOffers.filter(remainingOffersFilter);
  const spentAndGetNotActivatedOffers = spentAndGetOffers.filter(
    (offer) => offer.offerActivated !== checkToggle.yes && offer.offerActivationRequired !== checkToggle.no
  );
  const spentAndGetActivatedOffers = spentAndGetOffers.filter((offer) => !spentAndGetNotActivatedOffers.includes(offer));
  spentAndGetNotActivatedOffers.sort(compareByAwardValueAndDaysLeft);
  spentAndGetActivatedOffers.sort(compareByAwardValueAndDaysLeft);
  multiplierNotActivatedOffers.sort(compareByAwardValueAndDaysLeft);
  percentsSavingNotActivatedOffers.sort(compareByDaysLeft);
  multiplierActiveOffers.sort(compareByAwardValueAndDaysLeft);
  percentsSavingOffers.sort(compareByDaysLeft);
  redeemedSpentAndGetOffers.sort(compareByAwardValueAndDaysLeft);
  redeemedmultiplierOffers.sort(compareByAwardValueAndDaysLeft);
  return [
    ...spentAndGetNotActivatedOffers,
    ...multiplierNotActivatedOffers,
    ...percentsSavingNotActivatedOffers,
    ...remainingNotActivatedOffers,
    ...spentAndGetActivatedOffers,
    ...multiplierActiveOffers,
    ...percentsSavingOffers,
    ...remainingOffers,
    ...redeemedSpentAndGetOffers,
    ...redeemedmultiplierOffers
  ];
};
const isMultiplierOffer = (offerType) => {
  return Boolean(offerType === offerTypes.MULTIPLIER);
};
const stringToDescending = (offer1, offer2) => {
  return parseInt(offer2, 10) - parseInt(offer1, 10);
};
const getMultiplierLabel = (OfferType) => {
  return OfferType == null ? void 0 : OfferType.map((offer) => {
    var _a, _b;
    if (isMultiplierOffer((_a = offer == null ? void 0 : offer.details) == null ? void 0 : _a.bonusType)) {
      return (_b = offer.details) == null ? void 0 : _b.multiplierValue;
    }
  });
};
const getSpendAndGetLabel = (OfferType) => {
  return OfferType == null ? void 0 : OfferType.map((offer) => {
    var _a, _b;
    if (!isMultiplierOffer((_a = offer == null ? void 0 : offer.details) == null ? void 0 : _a.bonusType)) {
      return (_b = offer.details) == null ? void 0 : _b.bonusType;
    }
  });
};
const getOfferTypeStatus = (offer, offerType) => {
  var _a, _b;
  const bonusType = (_a = offer == null ? void 0 : offer.details) == null ? void 0 : _a.bonusType;
  return isMultiplierOffer(bonusType) ? Boolean(((_b = offer.details) == null ? void 0 : _b.multiplierValue) !== offerType) : Boolean(bonusType !== offerType);
};
const getOfferTypeData = (offerValue, offerType) => {
  var _a, _b;
  const bonusType = (_a = offerValue == null ? void 0 : offerValue.details) == null ? void 0 : _a.bonusType;
  return isMultiplierOffer(bonusType) ? ((_b = offerValue.details) == null ? void 0 : _b.multiplierValue) === offerType : bonusType === offerType;
};
const PreviewDetail = ({ ...props }) => {
  const {
    detail,
    title,
    isSecurityInfo,
    statusInProgress,
    changeClass,
    isRowWithTwoColumnsOnMobile,
    shouldRenderWithoutDetail,
    a11yLabel
  } = props;
  const securedTextClass = isSecurityInfo ? `${PREFIX}-profile-info__secured-text` : "";
  const progressStatusClass = statusInProgress ? `${PREFIX}-profile-info__status-progress` : "";
  const ClassNameTitle = changeClass ? `${PREFIX}-col-md-5 ${PREFIX}-col-sm-5` : `${PREFIX}-col-md-3 ${PREFIX}-col-sm-3`;
  const ClassNameDetail = changeClass ? `${PREFIX}-col-md-7 ${PREFIX}-col-sm-7` : `${PREFIX}-col-md-9 ${PREFIX}-col-sm-9`;
  const mobileClass = isRowWithTwoColumnsOnMobile ? `${PREFIX}-col-xs-3` : `${PREFIX}-col-xs-6`;
  return /* @__PURE__ */ jsx(Fragment, { children: (detail || isSecurityInfo || shouldRenderWithoutDetail) && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-row ${PREFIX}-row--no-gutters ${PREFIX}-profile-info__row`, children: [
    /* @__PURE__ */ jsx("div", { className: `${ClassNameTitle} ${mobileClass}`, children: /* @__PURE__ */ jsx("p", { "aria-hidden": Boolean(a11yLabel), className: `${PREFIX}-profile-info__label`, children: title }) }),
    /* @__PURE__ */ jsx("div", { className: `${ClassNameDetail} ${mobileClass}`, children: /* @__PURE__ */ jsx(
      "p",
      {
        "aria-hidden": Boolean(a11yLabel),
        className: `${PREFIX}-profile-info__detail ${securedTextClass} ${progressStatusClass}`,
        children: detail
      }
    ) }),
    a11yLabel && /* @__PURE__ */ jsx("span", { className: "sr-only", children: a11yLabel })
  ] }) });
};
PreviewDetail.propTypes = {
  detail: PropTypes.string,
  title: PropTypes.string.isRequired,
  isSecurityInfo: PropTypes.bool,
  statusInProgress: PropTypes.bool,
  changeClass: PropTypes.bool
};
const isAccountPage = () => {
  const currentPage = window.location.href;
  return currentPage.includes(accountsPageUrlPattern.en) || currentPage.includes(accountsPageUrlPattern.fr) || currentPage.includes(myAccountsPageUrlPattern.en) || currentPage.includes(myAccountsPageUrlPattern.fr);
};
const signoutRedirection = (redirectionURL) => {
  if (isAccountPage()) {
    window.location.href = redirectionURL;
  }
};
const signoutRedirectionList = (urlList) => {
  const currentPage = window.location.href;
  const redirectUrl = urlList == null ? void 0 : urlList.reduce(
    (acc, current) => currentPage.includes(current.redirectFrom) ? current.redirectTo : acc,
    ""
  );
  if (checkDataLength(redirectUrl)) {
    window.location.href = redirectUrl;
  }
};
const preProcessSvgUseTag = (svgClass, useTagAttribute) => {
  const jsIcon = document.getElementsByClassName(svgClass);
  Array.from(jsIcon).forEach(function(el) {
    const useTagElement = el.children[0];
    const dataIconValue = useTagElement.getAttribute(useTagAttribute) || "";
    useTagElement.setAttribute("href", dataIconValue);
  });
};
const getOfferData = (selectedOffersArray, filters, label, offers, filterLabel) => {
  let offersData = [];
  if (!!checkNestedProps(filters, label)) {
    filters[label].forEach((el) => {
      offersData = selectedOffersArray == null ? void 0 : selectedOffersArray.concat(
        ...offersData,
        offers.filter((offer) => {
          const getOfferBanner = Array.isArray(offer.banner) ? offer.banner.includes(el) : offer.banner === el;
          if (label === filterLabel.brand) {
            return getOfferBanner;
          } else if (label === filterLabel.category) {
            return offer.details.categoryLevel1 === el;
          } else {
            return getOfferTypeData(offer, el);
          }
        })
      );
    });
  }
  return offersData;
};
const getOffersCount = (filterdData, facetSelected, initialOfferData, offerLabel, offerTypes2, facetFilter, filterLabel) => {
  let combinedFilteredData = [];
  const { brand, category, offerType } = filterLabel;
  if (facetSelected === offerLabel) {
    let filteredList;
    switch (offerLabel) {
      case category:
        filteredList = getCategoryFilter(filterLabel, facetFilter, initialOfferData);
        break;
      case offerType:
        filteredList = getOfferFilter(filterLabel, facetFilter, initialOfferData);
        break;
      case brand:
        filteredList = getBrandFilter(filterLabel, facetFilter, initialOfferData);
        break;
      default:
        filteredList = [];
    }
    const distinctFilter = getDistinctOffer(filteredList);
    combinedFilteredData = isArrayNotEmpty(distinctFilter) ? distinctFilter : initialOfferData;
  } else {
    combinedFilteredData = filterdData ? filterdData : initialOfferData;
  }
  const offerCount = combinedFilteredData == null ? void 0 : combinedFilteredData.filter((offerValue) => {
    const getOfferBanner = Array.isArray(offerValue.banner) ? offerValue.banner.includes(offerTypes2) : offerValue.banner === offerTypes2;
    if (offerLabel === filterLabel.brand) {
      return getOfferBanner;
    } else if (offerLabel === filterLabel.category) {
      return offerValue.details.categoryLevel1 === offerTypes2;
    } else {
      return getOfferTypeData(offerValue, offerTypes2);
    }
  });
  return offerCount == null ? void 0 : offerCount.length;
};
const getDistinctOffer = (filteredList) => {
  return isArrayNotEmpty(filteredList) && (filteredList == null ? void 0 : filteredList.filter((items, index2) => {
    return filteredList.findIndex((item) => item === items) === index2;
  }));
};
const getBrandFilter = (filterLabel, facetFilter, initialOfferData) => {
  const { category, offerType } = filterLabel;
  const unprettifyOfferType = offerType == null ? void 0 : offerType.replace(/\s/g, "");
  let filteredList = [];
  if (isArrayNotEmpty(facetFilter[unprettifyOfferType]) && !isArrayNotEmpty(facetFilter[filterLabel.category])) {
    filteredList = getOfferData(filteredList, facetFilter, unprettifyOfferType, initialOfferData, filterLabel);
  }
  if (isArrayNotEmpty(facetFilter[category]) && !isArrayNotEmpty(facetFilter[unprettifyOfferType])) {
    filteredList = getOfferData(filteredList, facetFilter, category, initialOfferData, filterLabel);
  }
  if (isArrayNotEmpty(facetFilter[category]) && isArrayNotEmpty(facetFilter[unprettifyOfferType])) {
    let catergoriesData = [];
    let offerTypeData = [];
    catergoriesData = getOfferData(catergoriesData, facetFilter, category, initialOfferData, filterLabel);
    offerTypeData = getOfferData(offerTypeData, facetFilter, unprettifyOfferType, initialOfferData, filterLabel);
    catergoriesData.forEach((item) => {
      const checkbox = offerTypeData.find((offerItem) => offerItem === item);
      if (checkbox != void 0) {
        filteredList.push(checkbox);
      }
    });
  }
  if (isArrayNotEmpty(facetFilter[filterLabel.brand]) && !isArrayNotEmpty(facetFilter[unprettifyOfferType]) && !isArrayNotEmpty(facetFilter[filterLabel.category])) {
    filteredList = initialOfferData;
  }
  return filteredList;
};
const getOfferFilter = (filterLabel, facetFilter, initialOfferData) => {
  const { brand, category, offerType } = filterLabel;
  const unprettifyOfferType = offerType == null ? void 0 : offerType.replace(/\s/g, "");
  let filteredList = [];
  if (isArrayNotEmpty(facetFilter[filterLabel.brand]) && !isArrayNotEmpty(facetFilter[filterLabel.category])) {
    filteredList = getOfferData(filteredList, facetFilter, brand, initialOfferData, filterLabel);
  }
  if (isArrayNotEmpty(facetFilter[filterLabel.category]) && !isArrayNotEmpty(facetFilter[filterLabel.brand])) {
    filteredList = getOfferData(filteredList, facetFilter, category, initialOfferData, filterLabel);
  }
  if (isArrayNotEmpty(facetFilter[filterLabel.category]) && isArrayNotEmpty(facetFilter[filterLabel.brand])) {
    let bannerList = [];
    let categoryList = [];
    bannerList = getOfferData(bannerList, facetFilter, brand, initialOfferData, filterLabel);
    categoryList = getOfferData(categoryList, facetFilter, category, initialOfferData, filterLabel);
    bannerList.forEach((item) => {
      const checkbox = categoryList.find((array2Item) => array2Item === item);
      if (checkbox != void 0) {
        filteredList.push(checkbox);
      }
    });
  }
  if (isArrayNotEmpty(facetFilter[unprettifyOfferType]) && !isArrayNotEmpty(facetFilter[filterLabel.brand]) && !isArrayNotEmpty(facetFilter[filterLabel.category])) {
    filteredList = initialOfferData;
  }
  return filteredList;
};
const getCategoryFilter = (filterLabel, facetFilter, initialOfferData) => {
  const { brand, offerType } = filterLabel;
  const unprettifyOfferType = offerType == null ? void 0 : offerType.replace(/\s/g, "");
  let filteredList = [];
  if (isArrayNotEmpty(facetFilter[filterLabel.brand]) && !isArrayNotEmpty(facetFilter[unprettifyOfferType])) {
    filteredList = getOfferData(filteredList, facetFilter, brand, initialOfferData, filterLabel);
  }
  if (isArrayNotEmpty(facetFilter[unprettifyOfferType]) && !isArrayNotEmpty(facetFilter[filterLabel.brand])) {
    filteredList = getOfferData(filteredList, facetFilter, unprettifyOfferType, initialOfferData, filterLabel);
  }
  if (isArrayNotEmpty(facetFilter[unprettifyOfferType]) && isArrayNotEmpty(facetFilter[filterLabel.brand])) {
    let bannerList = [];
    let offerTypeList = [];
    bannerList = getOfferData(bannerList, facetFilter, brand, initialOfferData, filterLabel);
    offerTypeList = getOfferData(offerTypeList, facetFilter, unprettifyOfferType, initialOfferData, filterLabel);
    bannerList.forEach((item) => {
      const checkbox = offerTypeList.find((array2Item) => array2Item === item);
      if (checkbox !== void 0) {
        filteredList.push(checkbox);
      }
    });
  }
  if (isArrayNotEmpty(facetFilter[filterLabel.category]) && !isArrayNotEmpty(facetFilter[filterLabel.brand]) && !isArrayNotEmpty(facetFilter[unprettifyOfferType])) {
    filteredList = initialOfferData;
  }
  return filteredList;
};
const isDisabledStatus = (filteredOffers, offerLabel, offerType, filterLabel) => {
  let status;
  filteredOffers == null ? void 0 : filteredOffers.forEach((offer) => {
    if (offerLabel === filterLabel.brand) {
      status = Array.isArray(offer.banner) ? !offer.banner.includes(offerType) : offer.banner !== offerType;
    } else if (offerLabel === filterLabel.category) {
      status = offer.details.categoryLevel1 !== offerType;
    } else {
      status = getOfferTypeStatus(offer, offerType);
    }
    return status;
  });
  return status;
};
const getOfferFilteredData = (offerData, facetSelected, initialOfferData, offerLabel, facetFilter, prettifyLabelList, prettifyOfferType, filterLabel, filteredOffers, currentBannerId) => {
  return offerData == null ? void 0 : offerData.map((offer) => {
    const unprettifyLabel = offerLabel == null ? void 0 : offerLabel.replace(/\s/g, "");
    let beautifiedLabel;
    let offerNameLabel;
    let brandImage;
    let filteredBannerId;
    if (offerLabel === filterLabel.brand) {
      if (currentBannerId === BannerMapping.LEQ && offer.toLowerCase() === BannerMapping.MRK.toLowerCase()) {
        filteredBannerId = BannerMapping.LEQ;
      } else {
        filteredBannerId = offer;
      }
      beautifiedLabel = prettifyLabelList == null ? void 0 : prettifyLabelList.find(
        (banner) => banner.bannerId === filteredBannerId
      );
      offerNameLabel = beautifiedLabel ? beautifiedLabel == null ? void 0 : beautifiedLabel.bannerName : offer;
      const { bannerImagePath, bannerImageAlt } = beautifiedLabel || {};
      brandImage = areAllParamsValid(beautifiedLabel, !!bannerImagePath) ? { bannerImagePath, bannerImageAlt } : null;
    } else {
      beautifiedLabel = prettifyOfferType == null ? void 0 : prettifyOfferType.find(
        (banner) => banner.offerTypeId === offer
      );
      offerNameLabel = beautifiedLabel ? beautifiedLabel == null ? void 0 : beautifiedLabel.offerName : offer;
    }
    return {
      name: offerNameLabel,
      label: offer,
      count: getOffersCount(
        checkDataLength(filteredOffers) && filteredOffers,
        facetSelected,
        initialOfferData,
        offerLabel,
        offer,
        facetFilter,
        filterLabel
      ),
      disabled: isDisabledStatus(filteredOffers, offerLabel, offer, filterLabel),
      selected: checkNestedProps(facetFilter, unprettifyLabel) ? facetFilter[unprettifyLabel].some((e) => e === offer) : false,
      brandImageData: brandImage
    };
  });
};
const brandFilter = (brandOffers, facetSelected, facetFilter, brandsLabel, prettifyLabelList, filterLabel, filteredBrandOffers, offersSortBy, currentBannerId) => {
  let brands = brandOffers == null ? void 0 : brandOffers.map((offer) => {
    var _a, _b, _c;
    return ((_a = offer.banner) == null ? void 0 : _a.toString().includes(",")) ? (_b = offer.banner) == null ? void 0 : _b.toString().split(",") : (_c = offer.banner) == null ? void 0 : _c.toString();
  });
  brands = brands == null ? void 0 : brands.flatMap((banner) => banner);
  brands = brands == null ? void 0 : brands.filter((b, i) => {
    return brands.indexOf(b) === i;
  });
  const brandFacet = getOfferFilteredData(
    brands,
    facetSelected,
    brandOffers,
    brandsLabel,
    facetFilter,
    prettifyLabelList,
    [],
    filterLabel,
    filteredBrandOffers,
    currentBannerId
  );
  const sortItem = sortByBrandsOrCategory(brandFacet, offersSortBy, false, true);
  if (isArrayNotEmpty(sortItem)) {
    return sortItem;
  } else {
    return [];
  }
};
const categoryFilter = (categoryOffers, facetSelected, facetFilter, categoriesLabel, filterLabel, filteredCategoryOffers, offersSortBy) => {
  let categories = categoryOffers == null ? void 0 : categoryOffers.map((offer) => {
    return offer.details.categoryLevel1;
  });
  categories = categories == null ? void 0 : categories.filter((value, index2) => {
    return categories.indexOf(value) === index2;
  });
  const categoryFacet = getOfferFilteredData(
    categories,
    facetSelected,
    categoryOffers,
    categoriesLabel,
    facetFilter,
    [],
    [],
    filterLabel,
    filteredCategoryOffers
  );
  const sortedBrand = sortByBrandsOrCategory(categoryFacet, offersSortBy, false, false);
  if (isArrayNotEmpty(sortedBrand)) {
    return sortedBrand;
  } else {
    return [];
  }
};
const offerTypeFilter = (offerTypeOffers, facetSelected, facetFilter, offerTypesLabel, prettifyLabelList, filterLabel, filteredOfferTypeOffers) => {
  const multiplierValue = getMultiplierLabel(offerTypeOffers);
  const spendAndGetValue = getSpendAndGetLabel(offerTypeOffers);
  const sortFacet = multiplierValue == null ? void 0 : multiplierValue.sort(stringToDescending);
  let offerTypes2 = spendAndGetValue.concat(sortFacet).filter((arr) => Boolean(arr));
  offerTypes2 = offerTypes2 == null ? void 0 : offerTypes2.filter((value, index2) => {
    return offerTypes2.indexOf(value) === index2;
  });
  return getOfferFilteredData(
    offerTypes2,
    facetSelected,
    offerTypeOffers,
    offerTypesLabel,
    facetFilter,
    [],
    prettifyLabelList,
    filterLabel,
    filteredOfferTypeOffers
  );
};
const sortByBrandsOrCategory = (itemList, offersSortBy, isDropDownList, sortBrands = true) => {
  var _a;
  let updatedFacetedList = [];
  updatedFacetedList = (_a = itemList == null ? void 0 : itemList.slice()) == null ? void 0 : _a.sort((a, b) => {
    const firstBanner = isDropDownList ? a.banner : a.label;
    const secondBanner = isDropDownList ? b.banner : b.label;
    if (sortBrands && isArrayNotEmpty(offersSortBy)) {
      const isMultiBannerA = offersSortBy == null ? void 0 : offersSortBy.filter((ob) => firstBanner == null ? void 0 : firstBanner.includes(ob));
      const isMultiBannerB = offersSortBy == null ? void 0 : offersSortBy.filter((ob) => secondBanner == null ? void 0 : secondBanner.includes(ob));
      const sortedA = offersSortBy == null ? void 0 : offersSortBy.indexOf(isMultiBannerA[0]);
      const sortedB = offersSortBy == null ? void 0 : offersSortBy.indexOf(isMultiBannerB[0]);
      return (sortedA >>> 0) - (sortedB >>> 0);
    } else {
      const categoryL1A = isDropDownList ? a.details.categoryLevel1 : a.label;
      const categoryL1B = isDropDownList ? b.details.categoryLevel1 : b.label;
      if (categoryL1A && categoryL1B) {
        return categoryL1A.localeCompare(categoryL1B);
      } else if (categoryL1A) {
        return magicNumber.MINUS_ONE;
      } else {
        return magicNumber.ONE;
      }
    }
  });
  return updatedFacetedList;
};
const updateFilterFacet = (allOffers, facetSelected, facetValues, facetLabels, filteredOffers, filters, prettifyLabelList, offersSortBy, currentBannerId) => {
  const { brand, category, offerType } = facetLabels;
  return brand ? [
    {
      type: FacetTypes.MULTISELECT,
      label: brand,
      values: brand && brandFilter(
        allOffers,
        facetSelected,
        filters,
        brand,
        prettifyLabelList.brand,
        facetLabels,
        filteredOffers,
        offersSortBy,
        currentBannerId
      ),
      selected: isArrayNotEmpty(facetValues) ? facetValues.filter((val) => val.label === brand)[0].selected : false
    },
    {
      type: FacetTypes.MULTISELECT,
      label: offerType,
      values: offerTypeFilter(
        allOffers,
        facetSelected,
        filters,
        offerType,
        prettifyLabelList.offerType,
        facetLabels,
        filteredOffers
      ),
      selected: isArrayNotEmpty(facetValues) ? facetValues.filter((val) => val.label === offerType)[0].selected : false
    },
    {
      type: FacetTypes.MULTISELECT,
      label: category,
      values: category && categoryFilter(
        allOffers,
        facetSelected,
        filters,
        category,
        facetLabels,
        filteredOffers,
        offersSortBy
      ),
      selected: isArrayNotEmpty(facetValues) ? facetValues.filter((val) => val.label === category)[0].selected : false
    }
  ] : [
    {
      type: FacetTypes.MULTISELECT,
      label: offerType,
      values: offerTypeFilter(
        allOffers,
        facetSelected,
        filters,
        offerType,
        prettifyLabelList.offerType,
        facetLabels,
        filteredOffers
      ),
      selected: isArrayNotEmpty(facetValues) ? facetValues.filter((val) => val.label === offerType)[0].selected : false
    },
    {
      type: FacetTypes.MULTISELECT,
      label: category,
      values: categoryFilter(
        allOffers,
        facetSelected,
        filters,
        category,
        facetLabels,
        filteredOffers,
        offersSortBy
      ),
      selected: isArrayNotEmpty(facetValues) ? facetValues.filter((val) => val.label === category)[0].selected : false
    }
  ];
};
const filterOffersData = (filters, offers, facetLabels) => {
  let selectedbrandsArray = [];
  let selectedCategoriesArray = [];
  let selectedofferTypesArray = [];
  const { brand, category, offerType } = facetLabels;
  selectedbrandsArray = getOfferData(selectedbrandsArray, filters, brand, offers, facetLabels);
  selectedCategoriesArray = getOfferData(selectedCategoriesArray, filters, category, offers, facetLabels);
  selectedofferTypesArray = getOfferData(selectedofferTypesArray, filters, offerType, offers, facetLabels);
  const combinedFilteredOffers = [selectedbrandsArray, selectedofferTypesArray, selectedCategoriesArray];
  let combinedSortedOffers = [];
  combinedSortedOffers = combinedFilteredOffers.filter((filteritem) => {
    return filteritem.length;
  });
  const combinedFilteredResult = isArrayNotEmpty(combinedSortedOffers) && (combinedSortedOffers == null ? void 0 : combinedSortedOffers.shift().filter((offerlist) => {
    return combinedSortedOffers.every((item) => {
      return item.indexOf(offerlist) !== magicNumber.MINUS_ONE;
    });
  }));
  const distinctValues = getDistinctOffer(combinedFilteredResult);
  const sortedOfferList = isArrayNotEmpty(distinctValues) && sortOffers(distinctValues);
  return isArrayNotEmpty(sortedOfferList) ? sortedOfferList : offers;
};
const TransactionColumn = (props) => {
  const { label, value, className: className2, icon, src: src2, alt } = props;
  const componentName = `${PREFIX}-triangle-transaction-history`;
  return /* @__PURE__ */ jsxs("div", { className: `${componentName} ${componentName}-${className2}`, children: [
    label && /* @__PURE__ */ jsx(
      "div",
      {
        "aria-hidden": "true",
        className: `${PREFIX}-transaction-label`,
        dangerouslySetInnerHTML: { __html: label }
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-transaction-value`, children: [
      icon && /* @__PURE__ */ jsx(Icon, { type: icon, size: "md" }),
      src2 && /* @__PURE__ */ jsx("img", { className: `${PREFIX}--ct-money-icon`, src: src2, alt }),
      value
    ] })
  ] });
};
TransactionColumn.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  icon: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string
};
const TransactionColumnBadge = (props) => {
  const { badge, badgeData } = props;
  const componentName = `${PREFIX}-triangle-transaction-history`;
  return /* @__PURE__ */ jsx("div", { className: `${componentName}-badge`, children: /* @__PURE__ */ jsx(Badges, { badges: [badge.toUpperCase()], badgesAndPriorities: badgeData }) });
};
TransactionColumnBadge.propTypes = {
  badge: PropTypes.string.isRequired,
  badgeData: PropTypes.object.isRequired
};
const TransactionColumnLogo = (props) => {
  const { banner, bannerImageList, customClass } = props;
  const [bannerDetails, setBannerDetails] = useState({});
  const componentName = `${PREFIX}-triangle-transaction-history`;
  useEffect(() => {
    setBannerDetails(
      bannerImageList && bannerImageList.find(
        (imageList) => banner === (imageList == null ? void 0 : imageList.bannerId) || EMPTY_BANNER_TYPE === (imageList == null ? void 0 : imageList.bannerId)
      )
    );
  }, [bannerImageList, banner]);
  return /* @__PURE__ */ jsx("div", { className: `${componentName}-banner-logo ${customClass}`, children: /* @__PURE__ */ jsx(
    "img",
    {
      "data-component-name": "transaction-history",
      src: bannerDetails == null ? void 0 : bannerDetails.bannerImagePath,
      alt: bannerDetails == null ? void 0 : bannerDetails.bannerImageAlt
    }
  ) });
};
TransactionColumnLogo.propTypes = {
  banner: PropTypes.string.isRequired,
  bannerImageList: PropTypes.arrayOf(
    PropTypes.exact({
      bannerImagePath: PropTypes.string.isRequired,
      bannerId: PropTypes.string.isRequired,
      bannerImageAlt: PropTypes.string.isRequired
    })
  ).isRequired
};
const formEmpty = (values, formType = "shippingAddress") => {
  if (formType === "shippingAddress") {
    const fields = values ? Object.values(values).filter((val) => !!val) : [];
    if (
      // eslint-disable-next-line sonar/expression-complexity
      fields.length <= magicNumber.TWO && (fields[0] === "CA" || (values == null ? void 0 : values.phone) || fields[0] === "CA" && (values == null ? void 0 : values.phone))
    ) {
      return true;
    }
  }
  return values ? !Object.values(values).filter((val) => !!val).length : true;
};
const headerBlockClassName = `${PREFIX}-header-block`;
const HeaderBlock = ({ ...props }) => {
  const { title, subtitle, cta, toggleView, isCTAlink, ctaRedirectLink, openInfoModal } = props;
  const onViewAllClick = (link) => {
    window.location.href = encodeURI(link);
  };
  const ctaRedirectButton = (isCtaLink, subtitleLinkLabel) => {
    const buttonLabel = subtitleLinkLabel ? subtitleLinkLabel : cta == null ? void 0 : cta.ctaLabel;
    const linkClass = subtitleLinkLabel ? `${PREFIX}-button--tertiary ${headerBlockClassName}__subtitleLink` : `${headerBlockClassName}__linkbutton ${PREFIX}-button ${PREFIX}-button--secondary ${PREFIX}-button--small`;
    const ctaLinkProps = ctaRedirectLink ? {
      onClick: () => {
        openInfoModal();
      },
      onKeyUp: (event) => {
        if (event.key === stringKeyCodes.enter) {
          openInfoModal();
        }
      }
    } : { href: cta == null ? void 0 : cta.ctaLink };
    return /* @__PURE__ */ jsx(Fragment, { children: isCtaLink ? /* @__PURE__ */ jsx("a", { role: "button", tabIndex: 0, "data-link-value": buttonLabel, ...ctaLinkProps, className: linkClass, children: buttonLabel }) : /* @__PURE__ */ jsx(
      Button,
      {
        type: "secondary_reverse",
        size: "small",
        label: cta == null ? void 0 : cta.ctaLabel,
        onClick: () => onViewAllClick(cta == null ? void 0 : cta.ctaLink)
      }
    ) });
  };
  const dashboardViewButton = () => {
    const buttonClass = title ? `${PREFIX}-xs-none ${PREFIX}-sm-none ${PREFIX}-md-block` : "";
    return (cta == null ? void 0 : cta.ctaLabel) ? /* @__PURE__ */ jsxs("div", { className: `${buttonClass}`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-md-block ${PREFIX}-xs-none`, children: ctaRedirectButton(isCTAlink) }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-md-none ${PREFIX}-xs-block`, children: ctaRedirectButton(isCTAlink) })
    ] }) : null;
  };
  return title || toggleView ? /* @__PURE__ */ jsxs("div", { className: `${headerBlockClassName} ${PREFIX}-md-flex`, children: [
    title && /* @__PURE__ */ jsxs("div", { className: `${headerBlockClassName}__title-view`, children: [
      /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: title || "", children: (memoizedStringContent) => /* @__PURE__ */ jsx(
        Heading,
        {
          variant: "h2",
          componentClass: `${toggleView ? `${headerBlockClassName}__title ${PREFIX}-body-xl` : `${headerBlockClassName}__header`}`,
          children: memoizedStringContent
        }
      ) }),
      subtitle && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "p",
          {
            className: `${headerBlockClassName}__subtitle`,
            dangerouslySetInnerHTML: { __html: subtitle || "" }
          }
        ),
        ctaRedirectLink && ctaRedirectButton(true, ctaRedirectLink)
      ] })
    ] }),
    toggleView && dashboardViewButton()
  ] }) : /* @__PURE__ */ jsx(Fragment, {});
};
HeaderBlock.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
};
var barcodes = {};
var CODE39 = {};
var Barcode$1 = {};
var hasRequiredBarcode;
function requireBarcode() {
  if (hasRequiredBarcode) return Barcode$1;
  hasRequiredBarcode = 1;
  Object.defineProperty(Barcode$1, "__esModule", {
    value: true
  });
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var Barcode2 = function Barcode3(data, options) {
    _classCallCheck2(this, Barcode3);
    this.data = data;
    this.text = options.text || data;
    this.options = options;
  };
  Barcode$1.default = Barcode2;
  return Barcode$1;
}
var hasRequiredCODE39;
function requireCODE39() {
  if (hasRequiredCODE39) return CODE39;
  hasRequiredCODE39 = 1;
  Object.defineProperty(CODE39, "__esModule", {
    value: true
  });
  CODE39.CODE39 = void 0;
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE39$1 = function(_Barcode) {
    _inherits2(CODE392, _Barcode);
    function CODE392(data, options) {
      _classCallCheck2(this, CODE392);
      data = data.toUpperCase();
      if (options.mod43) {
        data += getCharacter(mod43checksum(data));
      }
      return _possibleConstructorReturn2(this, (CODE392.__proto__ || Object.getPrototypeOf(CODE392)).call(this, data, options));
    }
    _createClass2(CODE392, [{
      key: "encode",
      value: function encode() {
        var result = getEncoding("*");
        for (var i = 0; i < this.data.length; i++) {
          result += getEncoding(this.data[i]) + "0";
        }
        result += getEncoding("*");
        return {
          data: result,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
      }
    }]);
    return CODE392;
  }(_Barcode3.default);
  var characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"];
  var encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];
  function getEncoding(character) {
    return getBinary(characterValue(character));
  }
  function getBinary(characterValue2) {
    return encodings[characterValue2].toString(2);
  }
  function getCharacter(characterValue2) {
    return characters[characterValue2];
  }
  function characterValue(character) {
    return characters.indexOf(character);
  }
  function mod43checksum(data) {
    var checksum = 0;
    for (var i = 0; i < data.length; i++) {
      checksum += characterValue(data[i]);
    }
    checksum = checksum % 43;
    return checksum;
  }
  CODE39.CODE39 = CODE39$1;
  return CODE39;
}
var CODE128$1 = {};
var CODE128_AUTO = {};
var CODE128 = {};
var constants$2 = {};
var hasRequiredConstants$2;
function requireConstants$2() {
  if (hasRequiredConstants$2) return constants$2;
  hasRequiredConstants$2 = 1;
  Object.defineProperty(constants$2, "__esModule", {
    value: true
  });
  var _SET_BY_CODE;
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var SET_A = constants$2.SET_A = 0;
  var SET_B = constants$2.SET_B = 1;
  var SET_C = constants$2.SET_C = 2;
  constants$2.SHIFT = 98;
  var START_A = constants$2.START_A = 103;
  var START_B = constants$2.START_B = 104;
  var START_C = constants$2.START_C = 105;
  constants$2.MODULO = 103;
  constants$2.STOP = 106;
  constants$2.FNC1 = 207;
  constants$2.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty2(_SET_BY_CODE, START_A, SET_A), _defineProperty2(_SET_BY_CODE, START_B, SET_B), _defineProperty2(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);
  constants$2.SWAP = {
    101: SET_A,
    100: SET_B,
    99: SET_C
  };
  constants$2.A_START_CHAR = String.fromCharCode(208);
  constants$2.B_START_CHAR = String.fromCharCode(209);
  constants$2.C_START_CHAR = String.fromCharCode(210);
  constants$2.A_CHARS = "[\0-_È-Ï]";
  constants$2.B_CHARS = "[ -È-Ï]";
  constants$2.C_CHARS = "(Ï*[0-9]{2}Ï*)";
  constants$2.BARS = [11011001100, 11001101100, 11001100110, 10010011e3, 10010001100, 10001001100, 10011001e3, 10011000100, 10001100100, 11001001e3, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011e3, 11011000110, 11000110110, 10100011e3, 10001011e3, 10001000110, 10110001e3, 10001101e3, 10001100010, 11010001e3, 11000101e3, 11000100010, 10110111e3, 10110001110, 10001101110, 10111011e3, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101e3, 11011100010, 11011101110, 11101011e3, 11101000110, 11100010110, 11101101e3, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 1010011e4, 10100001100, 1001011e4, 10010000110, 10000101100, 10000100110, 1011001e4, 10110000100, 1001101e4, 10011000010, 10000110100, 10000110010, 11000010010, 1100101e4, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111e3, 10100011110, 10001011110, 10111101e3, 10111100010, 11110101e3, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 1101001e4, 11010011100, 1100011101011];
  return constants$2;
}
var hasRequiredCODE128$1;
function requireCODE128$1() {
  if (hasRequiredCODE128$1) return CODE128;
  hasRequiredCODE128$1 = 1;
  Object.defineProperty(CODE128, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  var _constants = requireConstants$2();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128$12 = function(_Barcode) {
    _inherits2(CODE1282, _Barcode);
    function CODE1282(data, options) {
      _classCallCheck2(this, CODE1282);
      var _this = _possibleConstructorReturn2(this, (CODE1282.__proto__ || Object.getPrototypeOf(CODE1282)).call(this, data.substring(1), options));
      _this.bytes = data.split("").map(function(char) {
        return char.charCodeAt(0);
      });
      return _this;
    }
    _createClass2(CODE1282, [{
      key: "valid",
      value: function valid() {
        return /^[\x00-\x7F\xC8-\xD3]+$/.test(this.data);
      }
      // The public encoding function
    }, {
      key: "encode",
      value: function encode() {
        var bytes = this.bytes;
        var startIndex = bytes.shift() - 105;
        var startSet = _constants.SET_BY_CODE[startIndex];
        if (startSet === void 0) {
          throw new RangeError("The encoding does not start with a start character.");
        }
        if (this.shouldEncodeAsEan128() === true) {
          bytes.unshift(_constants.FNC1);
        }
        var encodingResult = CODE1282.next(bytes, 1, startSet);
        return {
          text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, "") : this.text,
          data: (
            // Add the start bits
            CODE1282.getBar(startIndex) + // Add the encoded bits
            encodingResult.result + // Add the checksum
            CODE1282.getBar((encodingResult.checksum + startIndex) % _constants.MODULO) + // Add the end bits
            CODE1282.getBar(_constants.STOP)
          )
        };
      }
      // GS1-128/EAN-128
    }, {
      key: "shouldEncodeAsEan128",
      value: function shouldEncodeAsEan128() {
        var isEAN128 = this.options.ean128 || false;
        if (typeof isEAN128 === "string") {
          isEAN128 = isEAN128.toLowerCase() === "true";
        }
        return isEAN128;
      }
      // Get a bar symbol by index
    }], [{
      key: "getBar",
      value: function getBar(index2) {
        return _constants.BARS[index2] ? _constants.BARS[index2].toString() : "";
      }
      // Correct an index by a set and shift it from the bytes array
    }, {
      key: "correctIndex",
      value: function correctIndex(bytes, set) {
        if (set === _constants.SET_A) {
          var charCode = bytes.shift();
          return charCode < 32 ? charCode + 64 : charCode - 32;
        } else if (set === _constants.SET_B) {
          return bytes.shift() - 32;
        } else {
          return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
        }
      }
    }, {
      key: "next",
      value: function next(bytes, pos, set) {
        if (!bytes.length) {
          return { result: "", checksum: 0 };
        }
        var nextCode = void 0, index2 = void 0;
        if (bytes[0] >= 200) {
          index2 = bytes.shift() - 105;
          var nextSet = _constants.SWAP[index2];
          if (nextSet !== void 0) {
            nextCode = CODE1282.next(bytes, pos + 1, nextSet);
          } else {
            if ((set === _constants.SET_A || set === _constants.SET_B) && index2 === _constants.SHIFT) {
              bytes[0] = set === _constants.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
            }
            nextCode = CODE1282.next(bytes, pos + 1, set);
          }
        } else {
          index2 = CODE1282.correctIndex(bytes, set);
          nextCode = CODE1282.next(bytes, pos + 1, set);
        }
        var enc = CODE1282.getBar(index2);
        var weight = index2 * pos;
        return {
          result: enc + nextCode.result,
          checksum: weight + nextCode.checksum
        };
      }
    }]);
    return CODE1282;
  }(_Barcode3.default);
  CODE128.default = CODE128$12;
  return CODE128;
}
var auto = {};
var hasRequiredAuto;
function requireAuto() {
  if (hasRequiredAuto) return auto;
  hasRequiredAuto = 1;
  Object.defineProperty(auto, "__esModule", {
    value: true
  });
  var _constants = requireConstants$2();
  var matchSetALength = function matchSetALength2(string) {
    return string.match(new RegExp("^" + _constants.A_CHARS + "*"))[0].length;
  };
  var matchSetBLength = function matchSetBLength2(string) {
    return string.match(new RegExp("^" + _constants.B_CHARS + "*"))[0].length;
  };
  var matchSetC = function matchSetC2(string) {
    return string.match(new RegExp("^" + _constants.C_CHARS + "*"))[0];
  };
  function autoSelectFromAB(string, isA) {
    var ranges = isA ? _constants.A_CHARS : _constants.B_CHARS;
    var untilC = string.match(new RegExp("^(" + ranges + "+?)(([0-9]{2}){2,})([^0-9]|$)"));
    if (untilC) {
      return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
    }
    var chars = string.match(new RegExp("^" + ranges + "+"))[0];
    if (chars.length === string.length) {
      return string;
    }
    return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
  }
  function autoSelectFromC(string) {
    var cMatch = matchSetC(string);
    var length = cMatch.length;
    if (length === string.length) {
      return string;
    }
    string = string.substring(length);
    var isA = matchSetALength(string) >= matchSetBLength(string);
    return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
  }
  auto.default = function(string) {
    var newString = void 0;
    var cLength = matchSetC(string).length;
    if (cLength >= 2) {
      newString = _constants.C_START_CHAR + autoSelectFromC(string);
    } else {
      var isA = matchSetALength(string) > matchSetBLength(string);
      newString = (isA ? _constants.A_START_CHAR : _constants.B_START_CHAR) + autoSelectFromAB(string, isA);
    }
    return newString.replace(
      /[\xCD\xCE]([^])[\xCD\xCE]/,
      // Any sequence between 205 and 206 characters
      function(match2, char) {
        return String.fromCharCode(203) + char;
      }
    );
  };
  return auto;
}
var hasRequiredCODE128_AUTO;
function requireCODE128_AUTO() {
  if (hasRequiredCODE128_AUTO) return CODE128_AUTO;
  hasRequiredCODE128_AUTO = 1;
  Object.defineProperty(CODE128_AUTO, "__esModule", {
    value: true
  });
  var _CODE2 = requireCODE128$1();
  var _CODE3 = _interopRequireDefault(_CODE2);
  var _auto = requireAuto();
  var _auto2 = _interopRequireDefault(_auto);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128AUTO = function(_CODE) {
    _inherits2(CODE128AUTO2, _CODE);
    function CODE128AUTO2(data, options) {
      _classCallCheck2(this, CODE128AUTO2);
      if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
        var _this = _possibleConstructorReturn2(this, (CODE128AUTO2.__proto__ || Object.getPrototypeOf(CODE128AUTO2)).call(this, (0, _auto2.default)(data), options));
      } else {
        var _this = _possibleConstructorReturn2(this, (CODE128AUTO2.__proto__ || Object.getPrototypeOf(CODE128AUTO2)).call(this, data, options));
      }
      return _possibleConstructorReturn2(_this);
    }
    return CODE128AUTO2;
  }(_CODE3.default);
  CODE128_AUTO.default = CODE128AUTO;
  return CODE128_AUTO;
}
var CODE128A = {};
var hasRequiredCODE128A;
function requireCODE128A() {
  if (hasRequiredCODE128A) return CODE128A;
  hasRequiredCODE128A = 1;
  Object.defineProperty(CODE128A, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _CODE2 = requireCODE128$1();
  var _CODE3 = _interopRequireDefault(_CODE2);
  var _constants = requireConstants$2();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128A$1 = function(_CODE) {
    _inherits2(CODE128A2, _CODE);
    function CODE128A2(string, options) {
      _classCallCheck2(this, CODE128A2);
      return _possibleConstructorReturn2(this, (CODE128A2.__proto__ || Object.getPrototypeOf(CODE128A2)).call(this, _constants.A_START_CHAR + string, options));
    }
    _createClass2(CODE128A2, [{
      key: "valid",
      value: function valid() {
        return new RegExp("^" + _constants.A_CHARS + "+$").test(this.data);
      }
    }]);
    return CODE128A2;
  }(_CODE3.default);
  CODE128A.default = CODE128A$1;
  return CODE128A;
}
var CODE128B = {};
var hasRequiredCODE128B;
function requireCODE128B() {
  if (hasRequiredCODE128B) return CODE128B;
  hasRequiredCODE128B = 1;
  Object.defineProperty(CODE128B, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _CODE2 = requireCODE128$1();
  var _CODE3 = _interopRequireDefault(_CODE2);
  var _constants = requireConstants$2();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128B$1 = function(_CODE) {
    _inherits2(CODE128B2, _CODE);
    function CODE128B2(string, options) {
      _classCallCheck2(this, CODE128B2);
      return _possibleConstructorReturn2(this, (CODE128B2.__proto__ || Object.getPrototypeOf(CODE128B2)).call(this, _constants.B_START_CHAR + string, options));
    }
    _createClass2(CODE128B2, [{
      key: "valid",
      value: function valid() {
        return new RegExp("^" + _constants.B_CHARS + "+$").test(this.data);
      }
    }]);
    return CODE128B2;
  }(_CODE3.default);
  CODE128B.default = CODE128B$1;
  return CODE128B;
}
var CODE128C = {};
var hasRequiredCODE128C;
function requireCODE128C() {
  if (hasRequiredCODE128C) return CODE128C;
  hasRequiredCODE128C = 1;
  Object.defineProperty(CODE128C, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _CODE2 = requireCODE128$1();
  var _CODE3 = _interopRequireDefault(_CODE2);
  var _constants = requireConstants$2();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CODE128C$1 = function(_CODE) {
    _inherits2(CODE128C2, _CODE);
    function CODE128C2(string, options) {
      _classCallCheck2(this, CODE128C2);
      return _possibleConstructorReturn2(this, (CODE128C2.__proto__ || Object.getPrototypeOf(CODE128C2)).call(this, _constants.C_START_CHAR + string, options));
    }
    _createClass2(CODE128C2, [{
      key: "valid",
      value: function valid() {
        return new RegExp("^" + _constants.C_CHARS + "+$").test(this.data);
      }
    }]);
    return CODE128C2;
  }(_CODE3.default);
  CODE128C.default = CODE128C$1;
  return CODE128C;
}
var hasRequiredCODE128;
function requireCODE128() {
  if (hasRequiredCODE128) return CODE128$1;
  hasRequiredCODE128 = 1;
  Object.defineProperty(CODE128$1, "__esModule", {
    value: true
  });
  CODE128$1.CODE128C = CODE128$1.CODE128B = CODE128$1.CODE128A = CODE128$1.CODE128 = void 0;
  var _CODE128_AUTO = requireCODE128_AUTO();
  var _CODE128_AUTO2 = _interopRequireDefault(_CODE128_AUTO);
  var _CODE128A = requireCODE128A();
  var _CODE128A2 = _interopRequireDefault(_CODE128A);
  var _CODE128B = requireCODE128B();
  var _CODE128B2 = _interopRequireDefault(_CODE128B);
  var _CODE128C = requireCODE128C();
  var _CODE128C2 = _interopRequireDefault(_CODE128C);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  CODE128$1.CODE128 = _CODE128_AUTO2.default;
  CODE128$1.CODE128A = _CODE128A2.default;
  CODE128$1.CODE128B = _CODE128B2.default;
  CODE128$1.CODE128C = _CODE128C2.default;
  return CODE128$1;
}
var EAN_UPC = {};
var EAN13 = {};
var constants$1 = {};
var hasRequiredConstants$1;
function requireConstants$1() {
  if (hasRequiredConstants$1) return constants$1;
  hasRequiredConstants$1 = 1;
  Object.defineProperty(constants$1, "__esModule", {
    value: true
  });
  constants$1.SIDE_BIN = "101";
  constants$1.MIDDLE_BIN = "01010";
  constants$1.BINARIES = {
    "L": [
      // The L (left) type of encoding
      "0001101",
      "0011001",
      "0010011",
      "0111101",
      "0100011",
      "0110001",
      "0101111",
      "0111011",
      "0110111",
      "0001011"
    ],
    "G": [
      // The G type of encoding
      "0100111",
      "0110011",
      "0011011",
      "0100001",
      "0011101",
      "0111001",
      "0000101",
      "0010001",
      "0001001",
      "0010111"
    ],
    "R": [
      // The R (right) type of encoding
      "1110010",
      "1100110",
      "1101100",
      "1000010",
      "1011100",
      "1001110",
      "1010000",
      "1000100",
      "1001000",
      "1110100"
    ],
    "O": [
      // The O (odd) encoding for UPC-E
      "0001101",
      "0011001",
      "0010011",
      "0111101",
      "0100011",
      "0110001",
      "0101111",
      "0111011",
      "0110111",
      "0001011"
    ],
    "E": [
      // The E (even) encoding for UPC-E
      "0100111",
      "0110011",
      "0011011",
      "0100001",
      "0011101",
      "0111001",
      "0000101",
      "0010001",
      "0001001",
      "0010111"
    ]
  };
  constants$1.EAN2_STRUCTURE = ["LL", "LG", "GL", "GG"];
  constants$1.EAN5_STRUCTURE = ["GGLLL", "GLGLL", "GLLGL", "GLLLG", "LGGLL", "LLGGL", "LLLGG", "LGLGL", "LGLLG", "LLGLG"];
  constants$1.EAN13_STRUCTURE = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"];
  return constants$1;
}
var EAN = {};
var encoder = {};
var hasRequiredEncoder;
function requireEncoder() {
  if (hasRequiredEncoder) return encoder;
  hasRequiredEncoder = 1;
  Object.defineProperty(encoder, "__esModule", {
    value: true
  });
  var _constants = requireConstants$1();
  var encode = function encode2(data, structure, separator) {
    var encoded = data.split("").map(function(val, idx) {
      return _constants.BINARIES[structure[idx]];
    }).map(function(val, idx) {
      return val ? val[data[idx]] : "";
    });
    if (separator) {
      var last = data.length - 1;
      encoded = encoded.map(function(val, idx) {
        return idx < last ? val + separator : val;
      });
    }
    return encoded.join("");
  };
  encoder.default = encode;
  return encoder;
}
var hasRequiredEAN;
function requireEAN() {
  if (hasRequiredEAN) return EAN;
  hasRequiredEAN = 1;
  Object.defineProperty(EAN, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _constants = requireConstants$1();
  var _encoder = requireEncoder();
  var _encoder2 = _interopRequireDefault(_encoder);
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var EAN$1 = function(_Barcode) {
    _inherits2(EAN3, _Barcode);
    function EAN3(data, options) {
      _classCallCheck2(this, EAN3);
      var _this = _possibleConstructorReturn2(this, (EAN3.__proto__ || Object.getPrototypeOf(EAN3)).call(this, data, options));
      _this.fontSize = !options.flat && options.fontSize > options.width * 10 ? options.width * 10 : options.fontSize;
      _this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
      return _this;
    }
    _createClass2(EAN3, [{
      key: "encode",
      value: function encode() {
        return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
      }
    }, {
      key: "leftText",
      value: function leftText(from, to) {
        return this.text.substr(from, to);
      }
    }, {
      key: "leftEncode",
      value: function leftEncode(data, structure) {
        return (0, _encoder2.default)(data, structure);
      }
    }, {
      key: "rightText",
      value: function rightText(from, to) {
        return this.text.substr(from, to);
      }
    }, {
      key: "rightEncode",
      value: function rightEncode(data, structure) {
        return (0, _encoder2.default)(data, structure);
      }
    }, {
      key: "encodeGuarded",
      value: function encodeGuarded() {
        var textOptions = { fontSize: this.fontSize };
        var guardOptions = { height: this.guardHeight };
        return [{ data: _constants.SIDE_BIN, options: guardOptions }, { data: this.leftEncode(), text: this.leftText(), options: textOptions }, { data: _constants.MIDDLE_BIN, options: guardOptions }, { data: this.rightEncode(), text: this.rightText(), options: textOptions }, { data: _constants.SIDE_BIN, options: guardOptions }];
      }
    }, {
      key: "encodeFlat",
      value: function encodeFlat() {
        var data = [_constants.SIDE_BIN, this.leftEncode(), _constants.MIDDLE_BIN, this.rightEncode(), _constants.SIDE_BIN];
        return {
          data: data.join(""),
          text: this.text
        };
      }
    }]);
    return EAN3;
  }(_Barcode3.default);
  EAN.default = EAN$1;
  return EAN;
}
var hasRequiredEAN13;
function requireEAN13() {
  if (hasRequiredEAN13) return EAN13;
  hasRequiredEAN13 = 1;
  Object.defineProperty(EAN13, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _get = function get(object2, property, receiver) {
    if (object2 === null) object2 = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object2, property);
    if (desc === void 0) {
      var parent = Object.getPrototypeOf(object2);
      if (parent === null) {
        return void 0;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;
      if (getter === void 0) {
        return void 0;
      }
      return getter.call(receiver);
    }
  };
  var _constants = requireConstants$1();
  var _EAN2 = requireEAN();
  var _EAN3 = _interopRequireDefault(_EAN2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var checksum = function checksum2(number) {
    var res = number.substr(0, 12).split("").map(function(n) {
      return +n;
    }).reduce(function(sum, a, idx) {
      return idx % 2 ? sum + a * 3 : sum + a;
    }, 0);
    return (10 - res % 10) % 10;
  };
  var EAN13$1 = function(_EAN) {
    _inherits2(EAN132, _EAN);
    function EAN132(data, options) {
      _classCallCheck2(this, EAN132);
      if (data.search(/^[0-9]{12}$/) !== -1) {
        data += checksum(data);
      }
      var _this = _possibleConstructorReturn2(this, (EAN132.__proto__ || Object.getPrototypeOf(EAN132)).call(this, data, options));
      _this.lastChar = options.lastChar;
      return _this;
    }
    _createClass2(EAN132, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum(this.data);
      }
    }, {
      key: "leftText",
      value: function leftText() {
        return _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "leftText", this).call(this, 1, 6);
      }
    }, {
      key: "leftEncode",
      value: function leftEncode() {
        var data = this.data.substr(1, 6);
        var structure = _constants.EAN13_STRUCTURE[this.data[0]];
        return _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "leftEncode", this).call(this, data, structure);
      }
    }, {
      key: "rightText",
      value: function rightText() {
        return _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "rightText", this).call(this, 7, 6);
      }
    }, {
      key: "rightEncode",
      value: function rightEncode() {
        var data = this.data.substr(7, 6);
        return _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "rightEncode", this).call(this, data, "RRRRRR");
      }
      // The "standard" way of printing EAN13 barcodes with guard bars
    }, {
      key: "encodeGuarded",
      value: function encodeGuarded() {
        var data = _get(EAN132.prototype.__proto__ || Object.getPrototypeOf(EAN132.prototype), "encodeGuarded", this).call(this);
        if (this.options.displayValue) {
          data.unshift({
            data: "000000000000",
            text: this.text.substr(0, 1),
            options: { textAlign: "left", fontSize: this.fontSize }
          });
          if (this.options.lastChar) {
            data.push({
              data: "00"
            });
            data.push({
              data: "00000",
              text: this.options.lastChar,
              options: { fontSize: this.fontSize }
            });
          }
        }
        return data;
      }
    }]);
    return EAN132;
  }(_EAN3.default);
  EAN13.default = EAN13$1;
  return EAN13;
}
var EAN8 = {};
var hasRequiredEAN8;
function requireEAN8() {
  if (hasRequiredEAN8) return EAN8;
  hasRequiredEAN8 = 1;
  Object.defineProperty(EAN8, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _get = function get(object2, property, receiver) {
    if (object2 === null) object2 = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object2, property);
    if (desc === void 0) {
      var parent = Object.getPrototypeOf(object2);
      if (parent === null) {
        return void 0;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;
      if (getter === void 0) {
        return void 0;
      }
      return getter.call(receiver);
    }
  };
  var _EAN2 = requireEAN();
  var _EAN3 = _interopRequireDefault(_EAN2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var checksum = function checksum2(number) {
    var res = number.substr(0, 7).split("").map(function(n) {
      return +n;
    }).reduce(function(sum, a, idx) {
      return idx % 2 ? sum + a : sum + a * 3;
    }, 0);
    return (10 - res % 10) % 10;
  };
  var EAN8$1 = function(_EAN) {
    _inherits2(EAN82, _EAN);
    function EAN82(data, options) {
      _classCallCheck2(this, EAN82);
      if (data.search(/^[0-9]{7}$/) !== -1) {
        data += checksum(data);
      }
      return _possibleConstructorReturn2(this, (EAN82.__proto__ || Object.getPrototypeOf(EAN82)).call(this, data, options));
    }
    _createClass2(EAN82, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum(this.data);
      }
    }, {
      key: "leftText",
      value: function leftText() {
        return _get(EAN82.prototype.__proto__ || Object.getPrototypeOf(EAN82.prototype), "leftText", this).call(this, 0, 4);
      }
    }, {
      key: "leftEncode",
      value: function leftEncode() {
        var data = this.data.substr(0, 4);
        return _get(EAN82.prototype.__proto__ || Object.getPrototypeOf(EAN82.prototype), "leftEncode", this).call(this, data, "LLLL");
      }
    }, {
      key: "rightText",
      value: function rightText() {
        return _get(EAN82.prototype.__proto__ || Object.getPrototypeOf(EAN82.prototype), "rightText", this).call(this, 4, 4);
      }
    }, {
      key: "rightEncode",
      value: function rightEncode() {
        var data = this.data.substr(4, 4);
        return _get(EAN82.prototype.__proto__ || Object.getPrototypeOf(EAN82.prototype), "rightEncode", this).call(this, data, "RRRR");
      }
    }]);
    return EAN82;
  }(_EAN3.default);
  EAN8.default = EAN8$1;
  return EAN8;
}
var EAN5 = {};
var hasRequiredEAN5;
function requireEAN5() {
  if (hasRequiredEAN5) return EAN5;
  hasRequiredEAN5 = 1;
  Object.defineProperty(EAN5, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _constants = requireConstants$1();
  var _encoder = requireEncoder();
  var _encoder2 = _interopRequireDefault(_encoder);
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var checksum = function checksum2(data) {
    var result = data.split("").map(function(n) {
      return +n;
    }).reduce(function(sum, a, idx) {
      return idx % 2 ? sum + a * 9 : sum + a * 3;
    }, 0);
    return result % 10;
  };
  var EAN5$1 = function(_Barcode) {
    _inherits2(EAN52, _Barcode);
    function EAN52(data, options) {
      _classCallCheck2(this, EAN52);
      return _possibleConstructorReturn2(this, (EAN52.__proto__ || Object.getPrototypeOf(EAN52)).call(this, data, options));
    }
    _createClass2(EAN52, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{5}$/) !== -1;
      }
    }, {
      key: "encode",
      value: function encode() {
        var structure = _constants.EAN5_STRUCTURE[checksum(this.data)];
        return {
          data: "1011" + (0, _encoder2.default)(this.data, structure, "01"),
          text: this.text
        };
      }
    }]);
    return EAN52;
  }(_Barcode3.default);
  EAN5.default = EAN5$1;
  return EAN5;
}
var EAN2 = {};
var hasRequiredEAN2;
function requireEAN2() {
  if (hasRequiredEAN2) return EAN2;
  hasRequiredEAN2 = 1;
  Object.defineProperty(EAN2, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _constants = requireConstants$1();
  var _encoder = requireEncoder();
  var _encoder2 = _interopRequireDefault(_encoder);
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var EAN2$1 = function(_Barcode) {
    _inherits2(EAN22, _Barcode);
    function EAN22(data, options) {
      _classCallCheck2(this, EAN22);
      return _possibleConstructorReturn2(this, (EAN22.__proto__ || Object.getPrototypeOf(EAN22)).call(this, data, options));
    }
    _createClass2(EAN22, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{2}$/) !== -1;
      }
    }, {
      key: "encode",
      value: function encode() {
        var structure = _constants.EAN2_STRUCTURE[parseInt(this.data) % 4];
        return {
          // Start bits + Encode the two digits with 01 in between
          data: "1011" + (0, _encoder2.default)(this.data, structure, "01"),
          text: this.text
        };
      }
    }]);
    return EAN22;
  }(_Barcode3.default);
  EAN2.default = EAN2$1;
  return EAN2;
}
var UPC = {};
var hasRequiredUPC;
function requireUPC() {
  if (hasRequiredUPC) return UPC;
  hasRequiredUPC = 1;
  Object.defineProperty(UPC, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  UPC.checksum = checksum;
  var _encoder = requireEncoder();
  var _encoder2 = _interopRequireDefault(_encoder);
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var UPC$1 = function(_Barcode) {
    _inherits2(UPC2, _Barcode);
    function UPC2(data, options) {
      _classCallCheck2(this, UPC2);
      if (data.search(/^[0-9]{11}$/) !== -1) {
        data += checksum(data);
      }
      var _this = _possibleConstructorReturn2(this, (UPC2.__proto__ || Object.getPrototypeOf(UPC2)).call(this, data, options));
      _this.displayValue = options.displayValue;
      if (options.fontSize > options.width * 10) {
        _this.fontSize = options.width * 10;
      } else {
        _this.fontSize = options.fontSize;
      }
      _this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
      return _this;
    }
    _createClass2(UPC2, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum(this.data);
      }
    }, {
      key: "encode",
      value: function encode() {
        if (this.options.flat) {
          return this.flatEncoding();
        } else {
          return this.guardedEncoding();
        }
      }
    }, {
      key: "flatEncoding",
      value: function flatEncoding() {
        var result = "";
        result += "101";
        result += (0, _encoder2.default)(this.data.substr(0, 6), "LLLLLL");
        result += "01010";
        result += (0, _encoder2.default)(this.data.substr(6, 6), "RRRRRR");
        result += "101";
        return {
          data: result,
          text: this.text
        };
      }
    }, {
      key: "guardedEncoding",
      value: function guardedEncoding() {
        var result = [];
        if (this.displayValue) {
          result.push({
            data: "00000000",
            text: this.text.substr(0, 1),
            options: { textAlign: "left", fontSize: this.fontSize }
          });
        }
        result.push({
          data: "101" + (0, _encoder2.default)(this.data[0], "L"),
          options: { height: this.guardHeight }
        });
        result.push({
          data: (0, _encoder2.default)(this.data.substr(1, 5), "LLLLL"),
          text: this.text.substr(1, 5),
          options: { fontSize: this.fontSize }
        });
        result.push({
          data: "01010",
          options: { height: this.guardHeight }
        });
        result.push({
          data: (0, _encoder2.default)(this.data.substr(6, 5), "RRRRR"),
          text: this.text.substr(6, 5),
          options: { fontSize: this.fontSize }
        });
        result.push({
          data: (0, _encoder2.default)(this.data[11], "R") + "101",
          options: { height: this.guardHeight }
        });
        if (this.displayValue) {
          result.push({
            data: "00000000",
            text: this.text.substr(11, 1),
            options: { textAlign: "right", fontSize: this.fontSize }
          });
        }
        return result;
      }
    }]);
    return UPC2;
  }(_Barcode3.default);
  function checksum(number) {
    var result = 0;
    var i;
    for (i = 1; i < 11; i += 2) {
      result += parseInt(number[i]);
    }
    for (i = 0; i < 11; i += 2) {
      result += parseInt(number[i]) * 3;
    }
    return (10 - result % 10) % 10;
  }
  UPC.default = UPC$1;
  return UPC;
}
var UPCE = {};
var hasRequiredUPCE;
function requireUPCE() {
  if (hasRequiredUPCE) return UPCE;
  hasRequiredUPCE = 1;
  Object.defineProperty(UPCE, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _encoder = requireEncoder();
  var _encoder2 = _interopRequireDefault(_encoder);
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  var _UPC = requireUPC();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"];
  var PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]];
  var UPCE$1 = function(_Barcode) {
    _inherits2(UPCE2, _Barcode);
    function UPCE2(data, options) {
      _classCallCheck2(this, UPCE2);
      var _this = _possibleConstructorReturn2(this, (UPCE2.__proto__ || Object.getPrototypeOf(UPCE2)).call(this, data, options));
      _this.isValid = false;
      if (data.search(/^[0-9]{6}$/) !== -1) {
        _this.middleDigits = data;
        _this.upcA = expandToUPCA(data, "0");
        _this.text = options.text || "" + _this.upcA[0] + data + _this.upcA[_this.upcA.length - 1];
        _this.isValid = true;
      } else if (data.search(/^[01][0-9]{7}$/) !== -1) {
        _this.middleDigits = data.substring(1, data.length - 1);
        _this.upcA = expandToUPCA(_this.middleDigits, data[0]);
        if (_this.upcA[_this.upcA.length - 1] === data[data.length - 1]) {
          _this.isValid = true;
        } else {
          return _possibleConstructorReturn2(_this);
        }
      } else {
        return _possibleConstructorReturn2(_this);
      }
      _this.displayValue = options.displayValue;
      if (options.fontSize > options.width * 10) {
        _this.fontSize = options.width * 10;
      } else {
        _this.fontSize = options.fontSize;
      }
      _this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
      return _this;
    }
    _createClass2(UPCE2, [{
      key: "valid",
      value: function valid() {
        return this.isValid;
      }
    }, {
      key: "encode",
      value: function encode() {
        if (this.options.flat) {
          return this.flatEncoding();
        } else {
          return this.guardedEncoding();
        }
      }
    }, {
      key: "flatEncoding",
      value: function flatEncoding() {
        var result = "";
        result += "101";
        result += this.encodeMiddleDigits();
        result += "010101";
        return {
          data: result,
          text: this.text
        };
      }
    }, {
      key: "guardedEncoding",
      value: function guardedEncoding() {
        var result = [];
        if (this.displayValue) {
          result.push({
            data: "00000000",
            text: this.text[0],
            options: { textAlign: "left", fontSize: this.fontSize }
          });
        }
        result.push({
          data: "101",
          options: { height: this.guardHeight }
        });
        result.push({
          data: this.encodeMiddleDigits(),
          text: this.text.substring(1, 7),
          options: { fontSize: this.fontSize }
        });
        result.push({
          data: "010101",
          options: { height: this.guardHeight }
        });
        if (this.displayValue) {
          result.push({
            data: "00000000",
            text: this.text[7],
            options: { textAlign: "right", fontSize: this.fontSize }
          });
        }
        return result;
      }
    }, {
      key: "encodeMiddleDigits",
      value: function encodeMiddleDigits() {
        var numberSystem = this.upcA[0];
        var checkDigit = this.upcA[this.upcA.length - 1];
        var parity = PARITIES[parseInt(checkDigit)][parseInt(numberSystem)];
        return (0, _encoder2.default)(this.middleDigits, parity);
      }
    }]);
    return UPCE2;
  }(_Barcode3.default);
  function expandToUPCA(middleDigits, numberSystem) {
    var lastUpcE = parseInt(middleDigits[middleDigits.length - 1]);
    var expansion = EXPANSIONS[lastUpcE];
    var result = "";
    var digitIndex = 0;
    for (var i = 0; i < expansion.length; i++) {
      var c = expansion[i];
      if (c === "X") {
        result += middleDigits[digitIndex++];
      } else {
        result += c;
      }
    }
    result = "" + numberSystem + result;
    return "" + result + (0, _UPC.checksum)(result);
  }
  UPCE.default = UPCE$1;
  return UPCE;
}
var hasRequiredEAN_UPC;
function requireEAN_UPC() {
  if (hasRequiredEAN_UPC) return EAN_UPC;
  hasRequiredEAN_UPC = 1;
  Object.defineProperty(EAN_UPC, "__esModule", {
    value: true
  });
  EAN_UPC.UPCE = EAN_UPC.UPC = EAN_UPC.EAN2 = EAN_UPC.EAN5 = EAN_UPC.EAN8 = EAN_UPC.EAN13 = void 0;
  var _EAN = requireEAN13();
  var _EAN2 = _interopRequireDefault(_EAN);
  var _EAN3 = requireEAN8();
  var _EAN4 = _interopRequireDefault(_EAN3);
  var _EAN5 = requireEAN5();
  var _EAN6 = _interopRequireDefault(_EAN5);
  var _EAN7 = requireEAN2();
  var _EAN8 = _interopRequireDefault(_EAN7);
  var _UPC = requireUPC();
  var _UPC2 = _interopRequireDefault(_UPC);
  var _UPCE = requireUPCE();
  var _UPCE2 = _interopRequireDefault(_UPCE);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  EAN_UPC.EAN13 = _EAN2.default;
  EAN_UPC.EAN8 = _EAN4.default;
  EAN_UPC.EAN5 = _EAN6.default;
  EAN_UPC.EAN2 = _EAN8.default;
  EAN_UPC.UPC = _UPC2.default;
  EAN_UPC.UPCE = _UPCE2.default;
  return EAN_UPC;
}
var ITF$1 = {};
var ITF = {};
var constants = {};
var hasRequiredConstants;
function requireConstants() {
  if (hasRequiredConstants) return constants;
  hasRequiredConstants = 1;
  Object.defineProperty(constants, "__esModule", {
    value: true
  });
  constants.START_BIN = "1010";
  constants.END_BIN = "11101";
  constants.BINARIES = ["00110", "10001", "01001", "11000", "00101", "10100", "01100", "00011", "10010", "01010"];
  return constants;
}
var hasRequiredITF$1;
function requireITF$1() {
  if (hasRequiredITF$1) return ITF;
  hasRequiredITF$1 = 1;
  Object.defineProperty(ITF, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _constants = requireConstants();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var ITF$12 = function(_Barcode) {
    _inherits2(ITF2, _Barcode);
    function ITF2() {
      _classCallCheck2(this, ITF2);
      return _possibleConstructorReturn2(this, (ITF2.__proto__ || Object.getPrototypeOf(ITF2)).apply(this, arguments));
    }
    _createClass2(ITF2, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^([0-9]{2})+$/) !== -1;
      }
    }, {
      key: "encode",
      value: function encode() {
        var _this2 = this;
        var encoded = this.data.match(/.{2}/g).map(function(pair) {
          return _this2.encodePair(pair);
        }).join("");
        return {
          data: _constants.START_BIN + encoded + _constants.END_BIN,
          text: this.text
        };
      }
      // Calculate the data of a number pair
    }, {
      key: "encodePair",
      value: function encodePair(pair) {
        var second = _constants.BINARIES[pair[1]];
        return _constants.BINARIES[pair[0]].split("").map(function(first, idx) {
          return (first === "1" ? "111" : "1") + (second[idx] === "1" ? "000" : "0");
        }).join("");
      }
    }]);
    return ITF2;
  }(_Barcode3.default);
  ITF.default = ITF$12;
  return ITF;
}
var ITF14 = {};
var hasRequiredITF14;
function requireITF14() {
  if (hasRequiredITF14) return ITF14;
  hasRequiredITF14 = 1;
  Object.defineProperty(ITF14, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _ITF2 = requireITF$1();
  var _ITF3 = _interopRequireDefault(_ITF2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var checksum = function checksum2(data) {
    var res = data.substr(0, 13).split("").map(function(num) {
      return parseInt(num, 10);
    }).reduce(function(sum, n, idx) {
      return sum + n * (3 - idx % 2 * 2);
    }, 0);
    return Math.ceil(res / 10) * 10 - res;
  };
  var ITF14$1 = function(_ITF) {
    _inherits2(ITF142, _ITF);
    function ITF142(data, options) {
      _classCallCheck2(this, ITF142);
      if (data.search(/^[0-9]{13}$/) !== -1) {
        data += checksum(data);
      }
      return _possibleConstructorReturn2(this, (ITF142.__proto__ || Object.getPrototypeOf(ITF142)).call(this, data, options));
    }
    _createClass2(ITF142, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
      }
    }]);
    return ITF142;
  }(_ITF3.default);
  ITF14.default = ITF14$1;
  return ITF14;
}
var hasRequiredITF;
function requireITF() {
  if (hasRequiredITF) return ITF$1;
  hasRequiredITF = 1;
  Object.defineProperty(ITF$1, "__esModule", {
    value: true
  });
  ITF$1.ITF14 = ITF$1.ITF = void 0;
  var _ITF = requireITF$1();
  var _ITF2 = _interopRequireDefault(_ITF);
  var _ITF3 = requireITF14();
  var _ITF4 = _interopRequireDefault(_ITF3);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  ITF$1.ITF = _ITF2.default;
  ITF$1.ITF14 = _ITF4.default;
  return ITF$1;
}
var MSI$1 = {};
var MSI = {};
var hasRequiredMSI$1;
function requireMSI$1() {
  if (hasRequiredMSI$1) return MSI;
  hasRequiredMSI$1 = 1;
  Object.defineProperty(MSI, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI$12 = function(_Barcode) {
    _inherits2(MSI2, _Barcode);
    function MSI2(data, options) {
      _classCallCheck2(this, MSI2);
      return _possibleConstructorReturn2(this, (MSI2.__proto__ || Object.getPrototypeOf(MSI2)).call(this, data, options));
    }
    _createClass2(MSI2, [{
      key: "encode",
      value: function encode() {
        var ret = "110";
        for (var i = 0; i < this.data.length; i++) {
          var digit = parseInt(this.data[i]);
          var bin = digit.toString(2);
          bin = addZeroes(bin, 4 - bin.length);
          for (var b = 0; b < bin.length; b++) {
            ret += bin[b] == "0" ? "100" : "110";
          }
        }
        ret += "1001";
        return {
          data: ret,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]+$/) !== -1;
      }
    }]);
    return MSI2;
  }(_Barcode3.default);
  function addZeroes(number, n) {
    for (var i = 0; i < n; i++) {
      number = "0" + number;
    }
    return number;
  }
  MSI.default = MSI$12;
  return MSI;
}
var MSI10 = {};
var checksums = {};
var hasRequiredChecksums;
function requireChecksums() {
  if (hasRequiredChecksums) return checksums;
  hasRequiredChecksums = 1;
  Object.defineProperty(checksums, "__esModule", {
    value: true
  });
  checksums.mod10 = mod10;
  checksums.mod11 = mod11;
  function mod10(number) {
    var sum = 0;
    for (var i = 0; i < number.length; i++) {
      var n = parseInt(number[i]);
      if ((i + number.length) % 2 === 0) {
        sum += n;
      } else {
        sum += n * 2 % 10 + Math.floor(n * 2 / 10);
      }
    }
    return (10 - sum % 10) % 10;
  }
  function mod11(number) {
    var sum = 0;
    var weights = [2, 3, 4, 5, 6, 7];
    for (var i = 0; i < number.length; i++) {
      var n = parseInt(number[number.length - 1 - i]);
      sum += weights[i % weights.length] * n;
    }
    return (11 - sum % 11) % 11;
  }
  return checksums;
}
var hasRequiredMSI10;
function requireMSI10() {
  if (hasRequiredMSI10) return MSI10;
  hasRequiredMSI10 = 1;
  Object.defineProperty(MSI10, "__esModule", {
    value: true
  });
  var _MSI2 = requireMSI$1();
  var _MSI3 = _interopRequireDefault(_MSI2);
  var _checksums = requireChecksums();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI10$1 = function(_MSI) {
    _inherits2(MSI102, _MSI);
    function MSI102(data, options) {
      _classCallCheck2(this, MSI102);
      return _possibleConstructorReturn2(this, (MSI102.__proto__ || Object.getPrototypeOf(MSI102)).call(this, data + (0, _checksums.mod10)(data), options));
    }
    return MSI102;
  }(_MSI3.default);
  MSI10.default = MSI10$1;
  return MSI10;
}
var MSI11 = {};
var hasRequiredMSI11;
function requireMSI11() {
  if (hasRequiredMSI11) return MSI11;
  hasRequiredMSI11 = 1;
  Object.defineProperty(MSI11, "__esModule", {
    value: true
  });
  var _MSI2 = requireMSI$1();
  var _MSI3 = _interopRequireDefault(_MSI2);
  var _checksums = requireChecksums();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI11$1 = function(_MSI) {
    _inherits2(MSI112, _MSI);
    function MSI112(data, options) {
      _classCallCheck2(this, MSI112);
      return _possibleConstructorReturn2(this, (MSI112.__proto__ || Object.getPrototypeOf(MSI112)).call(this, data + (0, _checksums.mod11)(data), options));
    }
    return MSI112;
  }(_MSI3.default);
  MSI11.default = MSI11$1;
  return MSI11;
}
var MSI1010 = {};
var hasRequiredMSI1010;
function requireMSI1010() {
  if (hasRequiredMSI1010) return MSI1010;
  hasRequiredMSI1010 = 1;
  Object.defineProperty(MSI1010, "__esModule", {
    value: true
  });
  var _MSI2 = requireMSI$1();
  var _MSI3 = _interopRequireDefault(_MSI2);
  var _checksums = requireChecksums();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI1010$1 = function(_MSI) {
    _inherits2(MSI10102, _MSI);
    function MSI10102(data, options) {
      _classCallCheck2(this, MSI10102);
      data += (0, _checksums.mod10)(data);
      data += (0, _checksums.mod10)(data);
      return _possibleConstructorReturn2(this, (MSI10102.__proto__ || Object.getPrototypeOf(MSI10102)).call(this, data, options));
    }
    return MSI10102;
  }(_MSI3.default);
  MSI1010.default = MSI1010$1;
  return MSI1010;
}
var MSI1110 = {};
var hasRequiredMSI1110;
function requireMSI1110() {
  if (hasRequiredMSI1110) return MSI1110;
  hasRequiredMSI1110 = 1;
  Object.defineProperty(MSI1110, "__esModule", {
    value: true
  });
  var _MSI2 = requireMSI$1();
  var _MSI3 = _interopRequireDefault(_MSI2);
  var _checksums = requireChecksums();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI1110$1 = function(_MSI) {
    _inherits2(MSI11102, _MSI);
    function MSI11102(data, options) {
      _classCallCheck2(this, MSI11102);
      data += (0, _checksums.mod11)(data);
      data += (0, _checksums.mod10)(data);
      return _possibleConstructorReturn2(this, (MSI11102.__proto__ || Object.getPrototypeOf(MSI11102)).call(this, data, options));
    }
    return MSI11102;
  }(_MSI3.default);
  MSI1110.default = MSI1110$1;
  return MSI1110;
}
var hasRequiredMSI;
function requireMSI() {
  if (hasRequiredMSI) return MSI$1;
  hasRequiredMSI = 1;
  Object.defineProperty(MSI$1, "__esModule", {
    value: true
  });
  MSI$1.MSI1110 = MSI$1.MSI1010 = MSI$1.MSI11 = MSI$1.MSI10 = MSI$1.MSI = void 0;
  var _MSI = requireMSI$1();
  var _MSI2 = _interopRequireDefault(_MSI);
  var _MSI3 = requireMSI10();
  var _MSI4 = _interopRequireDefault(_MSI3);
  var _MSI5 = requireMSI11();
  var _MSI6 = _interopRequireDefault(_MSI5);
  var _MSI7 = requireMSI1010();
  var _MSI8 = _interopRequireDefault(_MSI7);
  var _MSI9 = requireMSI1110();
  var _MSI10 = _interopRequireDefault(_MSI9);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  MSI$1.MSI = _MSI2.default;
  MSI$1.MSI10 = _MSI4.default;
  MSI$1.MSI11 = _MSI6.default;
  MSI$1.MSI1010 = _MSI8.default;
  MSI$1.MSI1110 = _MSI10.default;
  return MSI$1;
}
var pharmacode = {};
var hasRequiredPharmacode;
function requirePharmacode() {
  if (hasRequiredPharmacode) return pharmacode;
  hasRequiredPharmacode = 1;
  Object.defineProperty(pharmacode, "__esModule", {
    value: true
  });
  pharmacode.pharmacode = void 0;
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var pharmacode$1 = function(_Barcode) {
    _inherits2(pharmacode2, _Barcode);
    function pharmacode2(data, options) {
      _classCallCheck2(this, pharmacode2);
      var _this = _possibleConstructorReturn2(this, (pharmacode2.__proto__ || Object.getPrototypeOf(pharmacode2)).call(this, data, options));
      _this.number = parseInt(data, 10);
      return _this;
    }
    _createClass2(pharmacode2, [{
      key: "encode",
      value: function encode() {
        var z = this.number;
        var result = "";
        while (!isNaN(z) && z != 0) {
          if (z % 2 === 0) {
            result = "11100" + result;
            z = (z - 2) / 2;
          } else {
            result = "100" + result;
            z = (z - 1) / 2;
          }
        }
        result = result.slice(0, -2);
        return {
          data: result,
          text: this.text
        };
      }
    }, {
      key: "valid",
      value: function valid() {
        return this.number >= 3 && this.number <= 131070;
      }
    }]);
    return pharmacode2;
  }(_Barcode3.default);
  pharmacode.pharmacode = pharmacode$1;
  return pharmacode;
}
var codabar = {};
var hasRequiredCodabar;
function requireCodabar() {
  if (hasRequiredCodabar) return codabar;
  hasRequiredCodabar = 1;
  Object.defineProperty(codabar, "__esModule", {
    value: true
  });
  codabar.codabar = void 0;
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var codabar$1 = function(_Barcode) {
    _inherits2(codabar2, _Barcode);
    function codabar2(data, options) {
      _classCallCheck2(this, codabar2);
      if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
        data = "A" + data + "A";
      }
      var _this = _possibleConstructorReturn2(this, (codabar2.__proto__ || Object.getPrototypeOf(codabar2)).call(this, data.toUpperCase(), options));
      _this.text = _this.options.text || _this.text.replace(/[A-D]/g, "");
      return _this;
    }
    _createClass2(codabar2, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
      }
    }, {
      key: "encode",
      value: function encode() {
        var result = [];
        var encodings = this.getEncodings();
        for (var i = 0; i < this.data.length; i++) {
          result.push(encodings[this.data.charAt(i)]);
          if (i !== this.data.length - 1) {
            result.push("0");
          }
        }
        return {
          text: this.text,
          data: result.join("")
        };
      }
    }, {
      key: "getEncodings",
      value: function getEncodings() {
        return {
          "0": "101010011",
          "1": "101011001",
          "2": "101001011",
          "3": "110010101",
          "4": "101101001",
          "5": "110101001",
          "6": "100101011",
          "7": "100101101",
          "8": "100110101",
          "9": "110100101",
          "-": "101001101",
          "$": "101100101",
          ":": "1101011011",
          "/": "1101101011",
          ".": "1101101101",
          "+": "1011011011",
          "A": "1011001001",
          "B": "1001001011",
          "C": "1010010011",
          "D": "1010011001"
        };
      }
    }]);
    return codabar2;
  }(_Barcode3.default);
  codabar.codabar = codabar$1;
  return codabar;
}
var GenericBarcode = {};
var hasRequiredGenericBarcode;
function requireGenericBarcode() {
  if (hasRequiredGenericBarcode) return GenericBarcode;
  hasRequiredGenericBarcode = 1;
  Object.defineProperty(GenericBarcode, "__esModule", {
    value: true
  });
  GenericBarcode.GenericBarcode = void 0;
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var GenericBarcode$1 = function(_Barcode) {
    _inherits2(GenericBarcode2, _Barcode);
    function GenericBarcode2(data, options) {
      _classCallCheck2(this, GenericBarcode2);
      return _possibleConstructorReturn2(this, (GenericBarcode2.__proto__ || Object.getPrototypeOf(GenericBarcode2)).call(this, data, options));
    }
    _createClass2(GenericBarcode2, [{
      key: "encode",
      value: function encode() {
        return {
          data: "10101010101010101010101010101010101010101",
          text: this.text
        };
      }
      // Resturn true/false if the string provided is valid for this encoder
    }, {
      key: "valid",
      value: function valid() {
        return true;
      }
    }]);
    return GenericBarcode2;
  }(_Barcode3.default);
  GenericBarcode.GenericBarcode = GenericBarcode$1;
  return GenericBarcode;
}
var hasRequiredBarcodes;
function requireBarcodes() {
  if (hasRequiredBarcodes) return barcodes;
  hasRequiredBarcodes = 1;
  Object.defineProperty(barcodes, "__esModule", {
    value: true
  });
  var _CODE = requireCODE39();
  var _CODE2 = requireCODE128();
  var _EAN_UPC = requireEAN_UPC();
  var _ITF = requireITF();
  var _MSI = requireMSI();
  var _pharmacode = requirePharmacode();
  var _codabar = requireCodabar();
  var _GenericBarcode = requireGenericBarcode();
  barcodes.default = {
    CODE39: _CODE.CODE39,
    CODE128: _CODE2.CODE128,
    CODE128A: _CODE2.CODE128A,
    CODE128B: _CODE2.CODE128B,
    CODE128C: _CODE2.CODE128C,
    EAN13: _EAN_UPC.EAN13,
    EAN8: _EAN_UPC.EAN8,
    EAN5: _EAN_UPC.EAN5,
    EAN2: _EAN_UPC.EAN2,
    UPC: _EAN_UPC.UPC,
    UPCE: _EAN_UPC.UPCE,
    ITF14: _ITF.ITF14,
    ITF: _ITF.ITF,
    MSI: _MSI.MSI,
    MSI10: _MSI.MSI10,
    MSI11: _MSI.MSI11,
    MSI1010: _MSI.MSI1010,
    MSI1110: _MSI.MSI1110,
    pharmacode: _pharmacode.pharmacode,
    codabar: _codabar.codabar,
    GenericBarcode: _GenericBarcode.GenericBarcode
  };
  return barcodes;
}
var merge = {};
var hasRequiredMerge;
function requireMerge() {
  if (hasRequiredMerge) return merge;
  hasRequiredMerge = 1;
  Object.defineProperty(merge, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  merge.default = function(old, replaceObj) {
    return _extends2({}, old, replaceObj);
  };
  return merge;
}
var linearizeEncodings = {};
var hasRequiredLinearizeEncodings;
function requireLinearizeEncodings() {
  if (hasRequiredLinearizeEncodings) return linearizeEncodings;
  hasRequiredLinearizeEncodings = 1;
  Object.defineProperty(linearizeEncodings, "__esModule", {
    value: true
  });
  linearizeEncodings.default = linearizeEncodings$1;
  function linearizeEncodings$1(encodings) {
    var linearEncodings = [];
    function nextLevel(encoded) {
      if (Array.isArray(encoded)) {
        for (var i = 0; i < encoded.length; i++) {
          nextLevel(encoded[i]);
        }
      } else {
        encoded.text = encoded.text || "";
        encoded.data = encoded.data || "";
        linearEncodings.push(encoded);
      }
    }
    nextLevel(encodings);
    return linearEncodings;
  }
  return linearizeEncodings;
}
var fixOptions = {};
var hasRequiredFixOptions;
function requireFixOptions() {
  if (hasRequiredFixOptions) return fixOptions;
  hasRequiredFixOptions = 1;
  Object.defineProperty(fixOptions, "__esModule", {
    value: true
  });
  fixOptions.default = fixOptions$1;
  function fixOptions$1(options) {
    options.marginTop = options.marginTop || options.margin;
    options.marginBottom = options.marginBottom || options.margin;
    options.marginRight = options.marginRight || options.margin;
    options.marginLeft = options.marginLeft || options.margin;
    return options;
  }
  return fixOptions;
}
var getRenderProperties = {};
var getOptionsFromElement = {};
var optionsFromStrings = {};
var hasRequiredOptionsFromStrings;
function requireOptionsFromStrings() {
  if (hasRequiredOptionsFromStrings) return optionsFromStrings;
  hasRequiredOptionsFromStrings = 1;
  Object.defineProperty(optionsFromStrings, "__esModule", {
    value: true
  });
  optionsFromStrings.default = optionsFromStrings$1;
  function optionsFromStrings$1(options) {
    var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];
    for (var intOption in intOptions) {
      if (intOptions.hasOwnProperty(intOption)) {
        intOption = intOptions[intOption];
        if (typeof options[intOption] === "string") {
          options[intOption] = parseInt(options[intOption], 10);
        }
      }
    }
    if (typeof options["displayValue"] === "string") {
      options["displayValue"] = options["displayValue"] != "false";
    }
    return options;
  }
  return optionsFromStrings;
}
var defaults$1 = {};
var hasRequiredDefaults;
function requireDefaults() {
  if (hasRequiredDefaults) return defaults$1;
  hasRequiredDefaults = 1;
  Object.defineProperty(defaults$1, "__esModule", {
    value: true
  });
  var defaults2 = {
    width: 2,
    height: 100,
    format: "auto",
    displayValue: true,
    fontOptions: "",
    font: "monospace",
    text: void 0,
    textAlign: "center",
    textPosition: "bottom",
    textMargin: 2,
    fontSize: 20,
    background: "#ffffff",
    lineColor: "#000000",
    margin: 10,
    marginTop: void 0,
    marginBottom: void 0,
    marginLeft: void 0,
    marginRight: void 0,
    valid: function valid() {
    }
  };
  defaults$1.default = defaults2;
  return defaults$1;
}
var hasRequiredGetOptionsFromElement;
function requireGetOptionsFromElement() {
  if (hasRequiredGetOptionsFromElement) return getOptionsFromElement;
  hasRequiredGetOptionsFromElement = 1;
  Object.defineProperty(getOptionsFromElement, "__esModule", {
    value: true
  });
  var _optionsFromStrings = requireOptionsFromStrings();
  var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);
  var _defaults = requireDefaults();
  var _defaults2 = _interopRequireDefault(_defaults);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getOptionsFromElement$1(element) {
    var options = {};
    for (var property in _defaults2.default) {
      if (_defaults2.default.hasOwnProperty(property)) {
        if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
          options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
        }
        if (element.hasAttribute("data-" + property.toLowerCase())) {
          options[property] = element.getAttribute("data-" + property.toLowerCase());
        }
      }
    }
    options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");
    options = (0, _optionsFromStrings2.default)(options);
    return options;
  }
  getOptionsFromElement.default = getOptionsFromElement$1;
  return getOptionsFromElement;
}
var renderers = {};
var canvas = {};
var shared = {};
var hasRequiredShared;
function requireShared() {
  if (hasRequiredShared) return shared;
  hasRequiredShared = 1;
  Object.defineProperty(shared, "__esModule", {
    value: true
  });
  shared.getTotalWidthOfEncodings = shared.calculateEncodingAttributes = shared.getBarcodePadding = shared.getEncodingHeight = shared.getMaximumHeightOfEncodings = void 0;
  var _merge = requireMerge();
  var _merge2 = _interopRequireDefault(_merge);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getEncodingHeight(encoding, options) {
    return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
  }
  function getBarcodePadding(textWidth, barcodeWidth, options) {
    if (options.displayValue && barcodeWidth < textWidth) {
      if (options.textAlign == "center") {
        return Math.floor((textWidth - barcodeWidth) / 2);
      } else if (options.textAlign == "left") {
        return 0;
      } else if (options.textAlign == "right") {
        return Math.floor(textWidth - barcodeWidth);
      }
    }
    return 0;
  }
  function calculateEncodingAttributes(encodings, barcodeOptions, context) {
    for (var i = 0; i < encodings.length; i++) {
      var encoding = encodings[i];
      var options = (0, _merge2.default)(barcodeOptions, encoding.options);
      var textWidth;
      if (options.displayValue) {
        textWidth = messureText(encoding.text, options, context);
      } else {
        textWidth = 0;
      }
      var barcodeWidth = encoding.data.length * options.width;
      encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));
      encoding.height = getEncodingHeight(encoding, options);
      encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
    }
  }
  function getTotalWidthOfEncodings(encodings) {
    var totalWidth = 0;
    for (var i = 0; i < encodings.length; i++) {
      totalWidth += encodings[i].width;
    }
    return totalWidth;
  }
  function getMaximumHeightOfEncodings(encodings) {
    var maxHeight2 = 0;
    for (var i = 0; i < encodings.length; i++) {
      if (encodings[i].height > maxHeight2) {
        maxHeight2 = encodings[i].height;
      }
    }
    return maxHeight2;
  }
  function messureText(string, options, context) {
    var ctx;
    if (context) {
      ctx = context;
    } else if (typeof document !== "undefined") {
      ctx = document.createElement("canvas").getContext("2d");
    } else {
      return 0;
    }
    ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;
    var measureTextResult = ctx.measureText(string);
    if (!measureTextResult) {
      return 0;
    }
    var size = measureTextResult.width;
    return size;
  }
  shared.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
  shared.getEncodingHeight = getEncodingHeight;
  shared.getBarcodePadding = getBarcodePadding;
  shared.calculateEncodingAttributes = calculateEncodingAttributes;
  shared.getTotalWidthOfEncodings = getTotalWidthOfEncodings;
  return shared;
}
var hasRequiredCanvas;
function requireCanvas() {
  if (hasRequiredCanvas) return canvas;
  hasRequiredCanvas = 1;
  Object.defineProperty(canvas, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _merge = requireMerge();
  var _merge2 = _interopRequireDefault(_merge);
  var _shared = requireShared();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var CanvasRenderer = function() {
    function CanvasRenderer2(canvas2, encodings, options) {
      _classCallCheck2(this, CanvasRenderer2);
      this.canvas = canvas2;
      this.encodings = encodings;
      this.options = options;
    }
    _createClass2(CanvasRenderer2, [{
      key: "render",
      value: function render() {
        if (!this.canvas.getContext) {
          throw new Error("The browser does not support canvas.");
        }
        this.prepareCanvas();
        for (var i = 0; i < this.encodings.length; i++) {
          var encodingOptions = (0, _merge2.default)(this.options, this.encodings[i].options);
          this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
          this.drawCanvasText(encodingOptions, this.encodings[i]);
          this.moveCanvasDrawing(this.encodings[i]);
        }
        this.restoreCanvas();
      }
    }, {
      key: "prepareCanvas",
      value: function prepareCanvas() {
        var ctx = this.canvas.getContext("2d");
        ctx.save();
        (0, _shared.calculateEncodingAttributes)(this.encodings, this.options, ctx);
        var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
        var maxHeight2 = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);
        this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;
        this.canvas.height = maxHeight2;
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (this.options.background) {
          ctx.fillStyle = this.options.background;
          ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        }
        ctx.translate(this.options.marginLeft, 0);
      }
    }, {
      key: "drawCanvasBarcode",
      value: function drawCanvasBarcode(options, encoding) {
        var ctx = this.canvas.getContext("2d");
        var binary = encoding.data;
        var yFrom;
        if (options.textPosition == "top") {
          yFrom = options.marginTop + options.fontSize + options.textMargin;
        } else {
          yFrom = options.marginTop;
        }
        ctx.fillStyle = options.lineColor;
        for (var b = 0; b < binary.length; b++) {
          var x = b * options.width + encoding.barcodePadding;
          if (binary[b] === "1") {
            ctx.fillRect(x, yFrom, options.width, options.height);
          } else if (binary[b]) {
            ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
          }
        }
      }
    }, {
      key: "drawCanvasText",
      value: function drawCanvasText(options, encoding) {
        var ctx = this.canvas.getContext("2d");
        var font = options.fontOptions + " " + options.fontSize + "px " + options.font;
        if (options.displayValue) {
          var x, y;
          if (options.textPosition == "top") {
            y = options.marginTop + options.fontSize - options.textMargin;
          } else {
            y = options.height + options.textMargin + options.marginTop + options.fontSize;
          }
          ctx.font = font;
          if (options.textAlign == "left" || encoding.barcodePadding > 0) {
            x = 0;
            ctx.textAlign = "left";
          } else if (options.textAlign == "right") {
            x = encoding.width - 1;
            ctx.textAlign = "right";
          } else {
            x = encoding.width / 2;
            ctx.textAlign = "center";
          }
          ctx.fillText(encoding.text, x, y);
        }
      }
    }, {
      key: "moveCanvasDrawing",
      value: function moveCanvasDrawing(encoding) {
        var ctx = this.canvas.getContext("2d");
        ctx.translate(encoding.width, 0);
      }
    }, {
      key: "restoreCanvas",
      value: function restoreCanvas() {
        var ctx = this.canvas.getContext("2d");
        ctx.restore();
      }
    }]);
    return CanvasRenderer2;
  }();
  canvas.default = CanvasRenderer;
  return canvas;
}
var svg = {};
var hasRequiredSvg;
function requireSvg() {
  if (hasRequiredSvg) return svg;
  hasRequiredSvg = 1;
  Object.defineProperty(svg, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _merge = requireMerge();
  var _merge2 = _interopRequireDefault(_merge);
  var _shared = requireShared();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var svgns = "http://www.w3.org/2000/svg";
  var SVGRenderer = function() {
    function SVGRenderer2(svg2, encodings, options) {
      _classCallCheck2(this, SVGRenderer2);
      this.svg = svg2;
      this.encodings = encodings;
      this.options = options;
      this.document = options.xmlDocument || document;
    }
    _createClass2(SVGRenderer2, [{
      key: "render",
      value: function render() {
        var currentX = this.options.marginLeft;
        this.prepareSVG();
        for (var i = 0; i < this.encodings.length; i++) {
          var encoding = this.encodings[i];
          var encodingOptions = (0, _merge2.default)(this.options, encoding.options);
          var group = this.createGroup(currentX, encodingOptions.marginTop, this.svg);
          this.setGroupOptions(group, encodingOptions);
          this.drawSvgBarcode(group, encodingOptions, encoding);
          this.drawSVGText(group, encodingOptions, encoding);
          currentX += encoding.width;
        }
      }
    }, {
      key: "prepareSVG",
      value: function prepareSVG() {
        while (this.svg.firstChild) {
          this.svg.removeChild(this.svg.firstChild);
        }
        (0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
        var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
        var maxHeight2 = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);
        var width = totalWidth + this.options.marginLeft + this.options.marginRight;
        this.setSvgAttributes(width, maxHeight2);
        if (this.options.background) {
          this.drawRect(0, 0, width, maxHeight2, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
        }
      }
    }, {
      key: "drawSvgBarcode",
      value: function drawSvgBarcode(parent, options, encoding) {
        var binary = encoding.data;
        var yFrom;
        if (options.textPosition == "top") {
          yFrom = options.fontSize + options.textMargin;
        } else {
          yFrom = 0;
        }
        var barWidth = 0;
        var x = 0;
        for (var b = 0; b < binary.length; b++) {
          x = b * options.width + encoding.barcodePadding;
          if (binary[b] === "1") {
            barWidth++;
          } else if (barWidth > 0) {
            this.drawRect(x - options.width * barWidth, yFrom, options.width * barWidth, options.height, parent);
            barWidth = 0;
          }
        }
        if (barWidth > 0) {
          this.drawRect(x - options.width * (barWidth - 1), yFrom, options.width * barWidth, options.height, parent);
        }
      }
    }, {
      key: "drawSVGText",
      value: function drawSVGText(parent, options, encoding) {
        var textElem = this.document.createElementNS(svgns, "text");
        if (options.displayValue) {
          var x, y;
          textElem.setAttribute("style", "font:" + options.fontOptions + " " + options.fontSize + "px " + options.font);
          if (options.textPosition == "top") {
            y = options.fontSize - options.textMargin;
          } else {
            y = options.height + options.textMargin + options.fontSize;
          }
          if (options.textAlign == "left" || encoding.barcodePadding > 0) {
            x = 0;
            textElem.setAttribute("text-anchor", "start");
          } else if (options.textAlign == "right") {
            x = encoding.width - 1;
            textElem.setAttribute("text-anchor", "end");
          } else {
            x = encoding.width / 2;
            textElem.setAttribute("text-anchor", "middle");
          }
          textElem.setAttribute("x", x);
          textElem.setAttribute("y", y);
          textElem.appendChild(this.document.createTextNode(encoding.text));
          parent.appendChild(textElem);
        }
      }
    }, {
      key: "setSvgAttributes",
      value: function setSvgAttributes(width, height) {
        var svg2 = this.svg;
        svg2.setAttribute("width", width + "px");
        svg2.setAttribute("height", height + "px");
        svg2.setAttribute("x", "0px");
        svg2.setAttribute("y", "0px");
        svg2.setAttribute("viewBox", "0 0 " + width + " " + height);
        svg2.setAttribute("xmlns", svgns);
        svg2.setAttribute("version", "1.1");
        svg2.setAttribute("style", "transform: translate(0,0)");
      }
    }, {
      key: "createGroup",
      value: function createGroup(x, y, parent) {
        var group = this.document.createElementNS(svgns, "g");
        group.setAttribute("transform", "translate(" + x + ", " + y + ")");
        parent.appendChild(group);
        return group;
      }
    }, {
      key: "setGroupOptions",
      value: function setGroupOptions(group, options) {
        group.setAttribute("style", "fill:" + options.lineColor + ";");
      }
    }, {
      key: "drawRect",
      value: function drawRect(x, y, width, height, parent) {
        var rect = this.document.createElementNS(svgns, "rect");
        rect.setAttribute("x", x);
        rect.setAttribute("y", y);
        rect.setAttribute("width", width);
        rect.setAttribute("height", height);
        parent.appendChild(rect);
        return rect;
      }
    }]);
    return SVGRenderer2;
  }();
  svg.default = SVGRenderer;
  return svg;
}
var object = {};
var hasRequiredObject;
function requireObject() {
  if (hasRequiredObject) return object;
  hasRequiredObject = 1;
  Object.defineProperty(object, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var ObjectRenderer = function() {
    function ObjectRenderer2(object2, encodings, options) {
      _classCallCheck2(this, ObjectRenderer2);
      this.object = object2;
      this.encodings = encodings;
      this.options = options;
    }
    _createClass2(ObjectRenderer2, [{
      key: "render",
      value: function render() {
        this.object.encodings = this.encodings;
      }
    }]);
    return ObjectRenderer2;
  }();
  object.default = ObjectRenderer;
  return object;
}
var hasRequiredRenderers;
function requireRenderers() {
  if (hasRequiredRenderers) return renderers;
  hasRequiredRenderers = 1;
  Object.defineProperty(renderers, "__esModule", {
    value: true
  });
  var _canvas = requireCanvas();
  var _canvas2 = _interopRequireDefault(_canvas);
  var _svg = requireSvg();
  var _svg2 = _interopRequireDefault(_svg);
  var _object = requireObject();
  var _object2 = _interopRequireDefault(_object);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  renderers.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };
  return renderers;
}
var exceptions = {};
var hasRequiredExceptions;
function requireExceptions() {
  if (hasRequiredExceptions) return exceptions;
  hasRequiredExceptions = 1;
  Object.defineProperty(exceptions, "__esModule", {
    value: true
  });
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var InvalidInputException = function(_Error) {
    _inherits2(InvalidInputException2, _Error);
    function InvalidInputException2(symbology, input) {
      _classCallCheck2(this, InvalidInputException2);
      var _this = _possibleConstructorReturn2(this, (InvalidInputException2.__proto__ || Object.getPrototypeOf(InvalidInputException2)).call(this));
      _this.name = "InvalidInputException";
      _this.symbology = symbology;
      _this.input = input;
      _this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
      return _this;
    }
    return InvalidInputException2;
  }(Error);
  var InvalidElementException = function(_Error2) {
    _inherits2(InvalidElementException2, _Error2);
    function InvalidElementException2() {
      _classCallCheck2(this, InvalidElementException2);
      var _this2 = _possibleConstructorReturn2(this, (InvalidElementException2.__proto__ || Object.getPrototypeOf(InvalidElementException2)).call(this));
      _this2.name = "InvalidElementException";
      _this2.message = "Not supported type to render on";
      return _this2;
    }
    return InvalidElementException2;
  }(Error);
  var NoElementException = function(_Error3) {
    _inherits2(NoElementException2, _Error3);
    function NoElementException2() {
      _classCallCheck2(this, NoElementException2);
      var _this3 = _possibleConstructorReturn2(this, (NoElementException2.__proto__ || Object.getPrototypeOf(NoElementException2)).call(this));
      _this3.name = "NoElementException";
      _this3.message = "No element to render on.";
      return _this3;
    }
    return NoElementException2;
  }(Error);
  exceptions.InvalidInputException = InvalidInputException;
  exceptions.InvalidElementException = InvalidElementException;
  exceptions.NoElementException = NoElementException;
  return exceptions;
}
var hasRequiredGetRenderProperties;
function requireGetRenderProperties() {
  if (hasRequiredGetRenderProperties) return getRenderProperties;
  hasRequiredGetRenderProperties = 1;
  Object.defineProperty(getRenderProperties, "__esModule", {
    value: true
  });
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _getOptionsFromElement = requireGetOptionsFromElement();
  var _getOptionsFromElement2 = _interopRequireDefault(_getOptionsFromElement);
  var _renderers = requireRenderers();
  var _renderers2 = _interopRequireDefault(_renderers);
  var _exceptions = requireExceptions();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getRenderProperties$1(element) {
    if (typeof element === "string") {
      return querySelectedRenderProperties(element);
    } else if (Array.isArray(element)) {
      var returnArray = [];
      for (var i = 0; i < element.length; i++) {
        returnArray.push(getRenderProperties$1(element[i]));
      }
      return returnArray;
    } else if (typeof HTMLCanvasElement !== "undefined" && element instanceof HTMLImageElement) {
      return newCanvasRenderProperties(element);
    } else if (element && element.nodeName && element.nodeName.toLowerCase() === "svg" || typeof SVGElement !== "undefined" && element instanceof SVGElement) {
      return {
        element,
        options: (0, _getOptionsFromElement2.default)(element),
        renderer: _renderers2.default.SVGRenderer
      };
    } else if (typeof HTMLCanvasElement !== "undefined" && element instanceof HTMLCanvasElement) {
      return {
        element,
        options: (0, _getOptionsFromElement2.default)(element),
        renderer: _renderers2.default.CanvasRenderer
      };
    } else if (element && element.getContext) {
      return {
        element,
        renderer: _renderers2.default.CanvasRenderer
      };
    } else if (element && (typeof element === "undefined" ? "undefined" : _typeof2(element)) === "object" && !element.nodeName) {
      return {
        element,
        renderer: _renderers2.default.ObjectRenderer
      };
    } else {
      throw new _exceptions.InvalidElementException();
    }
  }
  function querySelectedRenderProperties(string) {
    var selector = document.querySelectorAll(string);
    if (selector.length === 0) {
      return void 0;
    } else {
      var returnArray = [];
      for (var i = 0; i < selector.length; i++) {
        returnArray.push(getRenderProperties$1(selector[i]));
      }
      return returnArray;
    }
  }
  function newCanvasRenderProperties(imgElement) {
    var canvas2 = document.createElement("canvas");
    return {
      element: canvas2,
      options: (0, _getOptionsFromElement2.default)(imgElement),
      renderer: _renderers2.default.CanvasRenderer,
      afterRender: function afterRender() {
        imgElement.setAttribute("src", canvas2.toDataURL());
      }
    };
  }
  getRenderProperties.default = getRenderProperties$1;
  return getRenderProperties;
}
var ErrorHandler = {};
var hasRequiredErrorHandler;
function requireErrorHandler() {
  if (hasRequiredErrorHandler) return ErrorHandler;
  hasRequiredErrorHandler = 1;
  Object.defineProperty(ErrorHandler, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var ErrorHandler$1 = function() {
    function ErrorHandler2(api) {
      _classCallCheck2(this, ErrorHandler2);
      this.api = api;
    }
    _createClass2(ErrorHandler2, [{
      key: "handleCatch",
      value: function handleCatch(e) {
        if (e.name === "InvalidInputException") {
          if (this.api._options.valid !== this.api._defaults.valid) {
            this.api._options.valid(false);
          } else {
            throw e.message;
          }
        } else {
          throw e;
        }
        this.api.render = function() {
        };
      }
    }, {
      key: "wrapBarcodeCall",
      value: function wrapBarcodeCall(func) {
        try {
          var result = func.apply(void 0, arguments);
          this.api._options.valid(true);
          return result;
        } catch (e) {
          this.handleCatch(e);
          return this.api;
        }
      }
    }]);
    return ErrorHandler2;
  }();
  ErrorHandler.default = ErrorHandler$1;
  return ErrorHandler;
}
var JsBarcode_1;
var hasRequiredJsBarcode;
function requireJsBarcode() {
  if (hasRequiredJsBarcode) return JsBarcode_1;
  hasRequiredJsBarcode = 1;
  var _barcodes = requireBarcodes();
  var _barcodes2 = _interopRequireDefault(_barcodes);
  var _merge = requireMerge();
  var _merge2 = _interopRequireDefault(_merge);
  var _linearizeEncodings = requireLinearizeEncodings();
  var _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings);
  var _fixOptions = requireFixOptions();
  var _fixOptions2 = _interopRequireDefault(_fixOptions);
  var _getRenderProperties = requireGetRenderProperties();
  var _getRenderProperties2 = _interopRequireDefault(_getRenderProperties);
  var _optionsFromStrings = requireOptionsFromStrings();
  var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);
  var _ErrorHandler = requireErrorHandler();
  var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);
  var _exceptions = requireExceptions();
  var _defaults = requireDefaults();
  var _defaults2 = _interopRequireDefault(_defaults);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var API = function API2() {
  };
  var JsBarcode = function JsBarcode2(element, text2, options) {
    var api = new API();
    if (typeof element === "undefined") {
      throw Error("No element to render on was provided.");
    }
    api._renderProperties = (0, _getRenderProperties2.default)(element);
    api._encodings = [];
    api._options = _defaults2.default;
    api._errorHandler = new _ErrorHandler2.default(api);
    if (typeof text2 !== "undefined") {
      options = options || {};
      if (!options.format) {
        options.format = autoSelectBarcode();
      }
      api.options(options)[options.format](text2, options).render();
    }
    return api;
  };
  JsBarcode.getModule = function(name2) {
    return _barcodes2.default[name2];
  };
  for (var name in _barcodes2.default) {
    if (_barcodes2.default.hasOwnProperty(name)) {
      registerBarcode(_barcodes2.default, name);
    }
  }
  function registerBarcode(barcodes2, name2) {
    API.prototype[name2] = API.prototype[name2.toUpperCase()] = API.prototype[name2.toLowerCase()] = function(text2, options) {
      var api = this;
      return api._errorHandler.wrapBarcodeCall(function() {
        options.text = typeof options.text === "undefined" ? void 0 : "" + options.text;
        var newOptions = (0, _merge2.default)(api._options, options);
        newOptions = (0, _optionsFromStrings2.default)(newOptions);
        var Encoder = barcodes2[name2];
        var encoded = encode(text2, Encoder, newOptions);
        api._encodings.push(encoded);
        return api;
      });
    };
  }
  function encode(text2, Encoder, options) {
    text2 = "" + text2;
    var encoder2 = new Encoder(text2, options);
    if (!encoder2.valid()) {
      throw new _exceptions.InvalidInputException(encoder2.constructor.name, text2);
    }
    var encoded = encoder2.encode();
    encoded = (0, _linearizeEncodings2.default)(encoded);
    for (var i = 0; i < encoded.length; i++) {
      encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
    }
    return encoded;
  }
  function autoSelectBarcode() {
    if (_barcodes2.default["CODE128"]) {
      return "CODE128";
    }
    return Object.keys(_barcodes2.default)[0];
  }
  API.prototype.options = function(options) {
    this._options = (0, _merge2.default)(this._options, options);
    return this;
  };
  API.prototype.blank = function(size) {
    var zeroes = new Array(size + 1).join("0");
    this._encodings.push({ data: zeroes });
    return this;
  };
  API.prototype.init = function() {
    if (!this._renderProperties) {
      return;
    }
    if (!Array.isArray(this._renderProperties)) {
      this._renderProperties = [this._renderProperties];
    }
    var renderProperty;
    for (var i in this._renderProperties) {
      renderProperty = this._renderProperties[i];
      var options = (0, _merge2.default)(this._options, renderProperty.options);
      if (options.format == "auto") {
        options.format = autoSelectBarcode();
      }
      this._errorHandler.wrapBarcodeCall(function() {
        var text2 = options.value;
        var Encoder = _barcodes2.default[options.format.toUpperCase()];
        var encoded = encode(text2, Encoder, options);
        render(renderProperty, encoded, options);
      });
    }
  };
  API.prototype.render = function() {
    if (!this._renderProperties) {
      throw new _exceptions.NoElementException();
    }
    if (Array.isArray(this._renderProperties)) {
      for (var i = 0; i < this._renderProperties.length; i++) {
        render(this._renderProperties[i], this._encodings, this._options);
      }
    } else {
      render(this._renderProperties, this._encodings, this._options);
    }
    return this;
  };
  API.prototype._defaults = _defaults2.default;
  function render(renderProperties, encodings, options) {
    encodings = (0, _linearizeEncodings2.default)(encodings);
    for (var i = 0; i < encodings.length; i++) {
      encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
      (0, _fixOptions2.default)(encodings[i].options);
    }
    (0, _fixOptions2.default)(options);
    var Renderer = renderProperties.renderer;
    var renderer = new Renderer(renderProperties.element, encodings, options);
    renderer.render();
    if (renderProperties.afterRender) {
      renderProperties.afterRender();
    }
  }
  if (typeof window !== "undefined") {
    window.JsBarcode = JsBarcode;
  }
  if (typeof jQuery !== "undefined") {
    jQuery.fn.JsBarcode = function(content, options) {
      var elementArray = [];
      jQuery(this).each(function() {
        elementArray.push(this);
      });
      return JsBarcode(elementArray, content, options);
    };
  }
  JsBarcode_1 = JsBarcode;
  return JsBarcode_1;
}
var JsBarcodeExports = requireJsBarcode();
const jsBarcode = /* @__PURE__ */ getDefaultExportFromCjs$1(JsBarcodeExports);
const barcodeHeight = 35;
const Barcode = ({
  data,
  id = "barcode",
  ariaLabel,
  displayValue = false,
  height = barcodeHeight
}) => {
  useEffect(() => {
    jsBarcode(`#${id}`, data, {
      height,
      displayValue,
      margin: 0
    });
  }, [data, id, height, displayValue]);
  return /* @__PURE__ */ jsx("svg", { id, "data-testid": id, role: "img", "aria-label": ariaLabel || data });
};
const getMod10CheckDigit = (numericCode) => {
  const arrayFromCode = numericCode.toString().split("");
  const isLengthEven = !(arrayFromCode.length % magicNumber.TWO);
  const mod10Sum = arrayFromCode.reduce((acc, value, index2) => {
    const isIndexEven = !((index2 + magicNumber.ONE) % magicNumber.TWO);
    const int = parseInt(value, 10);
    const getCalcInt = () => {
      const intDoubled = int * magicNumber.TWO;
      return intDoubled > magicNumber.NINE ? intDoubled - magicNumber.NINE : intDoubled;
    };
    if (isLengthEven && isIndexEven) {
      return acc + getCalcInt();
    }
    if (!isLengthEven && !isIndexEven) {
      return acc + getCalcInt();
    }
    return acc + int;
  }, magicNumber.ZERO);
  const remainder = mod10Sum % magicNumber.TEN;
  return !!remainder ? magicNumber.TEN - remainder : magicNumber.ZERO;
};
const componentClassName$1 = `${PREFIX}-giftcard`;
const CARD_NUMBER_GROUP_SIZE = 4;
const PIN_GROUP_SIZE = 3;
const CARD_NUMBER_MIN_DIGITS = 8;
const CARD_NUMBER_MAX_DIGITS = 21;
const PIN_MIN_DIGITS = 1;
const PIN_MAX_DIGITS = 10;
const CARD_MASKING = "****";
const CARD_NUMBER_DIGIT_SLICE = -4;
var TooltipInteractionKeys = /* @__PURE__ */ ((TooltipInteractionKeys2) => {
  TooltipInteractionKeys2[TooltipInteractionKeys2["Enter"] = 0] = "Enter";
  TooltipInteractionKeys2[TooltipInteractionKeys2[" "] = 1] = " ";
  return TooltipInteractionKeys2;
})(TooltipInteractionKeys || {});
const defaultLogo = "ct-card";
const formatCurrency = (value) => localization.formattedPrice(getLanguage(), value / magicNumber.HUNDRED, currencyShortForm, currencyFormat);
const addDividers = (value, groupLength) => {
  const digits = value.split("").filter((char) => /\d/.exec(char));
  const groups = [];
  for (let i = 0; i < digits.length; i += groupLength) {
    groups.push(digits.slice(i, i + groupLength).join(""));
  }
  return groups.join(" ");
};
const removeDividers = (value) => value.split(" ").join("");
const getLengthWithDividers = (digits, groupLength) => digits + Math.floor(digits / groupLength);
const validateLength = (input, minLength, maxLength) => {
  const digits = removeDividers(input);
  return digits.length >= minLength && digits.length <= maxLength;
};
const showApplyGCInlineError = (errorCode, buyNowErrors) => {
  const { gcInvalidCardNumberMsg, gcInvalidPinErrorMsg, gcCardAlreadyAppliedErrorMsg } = buyNowErrors;
  switch (errorCode) {
    case applyGiftCardErrorCodes.invalidGiftCardNumber:
    case applyGiftCardErrorCodes.invalidGiftCardNumber610:
      return gcInvalidCardNumberMsg;
    case applyGiftCardErrorCodes.incorrectGiftPin:
      return gcInvalidPinErrorMsg;
    case applyGiftCardErrorCodes.giftCardAlreadyUsed:
      return gcCardAlreadyAppliedErrorMsg;
    default:
      return "";
  }
};
const NewGiftCardForm = ({
  gcApplyCTALabel,
  gcCardNumberInputLabel,
  gcPinInputLabel,
  gcNumberError,
  gcPinError,
  validateGCFieldsEmpty
}) => {
  const [number, setNumber] = useState("");
  const [pin, setPin] = useState("");
  const componentClassName2 = `${PREFIX}-giftcard`;
  const [isMobileLayout] = useMobileLayoutState();
  const handleNumberChange = (value) => {
    setNumber(addDividers(value, CARD_NUMBER_GROUP_SIZE));
  };
  const handlePinChange = (value) => {
    setPin(addDividers(value, PIN_GROUP_SIZE));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    validateGCFieldsEmpty(number, pin);
  };
  return /* @__PURE__ */ jsx("form", { className: `${componentClassName2}__form`, onSubmit: handleSubmit, children: /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__form-fields`, children: [
    /* @__PURE__ */ jsx(
      TextInput,
      {
        quantumMetricAttribute: { type: "encrypt", value: "true" },
        label: gcCardNumberInputLabel,
        ariaLabelledBy: gcCardNumberInputLabel,
        id: "card-number",
        value: number,
        error: gcNumberError,
        maxLength: getLengthWithDividers(CARD_NUMBER_MAX_DIGITS, CARD_NUMBER_GROUP_SIZE),
        onChange: handleNumberChange,
        size: isMobileLayout ? "default" : "mini",
        inputMode: TextInputModes.NUMERIC,
        pattern: checkoutRegexPatterns.giftCardNumberAndPin
      }
    ),
    /* @__PURE__ */ jsx(
      TextInput,
      {
        quantumMetricAttribute: { type: "encrypt", value: "true" },
        label: gcPinInputLabel,
        ariaLabelledBy: gcPinInputLabel,
        id: "pin",
        value: pin,
        error: gcPinError,
        maxLength: getLengthWithDividers(PIN_MAX_DIGITS, PIN_GROUP_SIZE),
        onChange: handlePinChange,
        size: isMobileLayout ? "default" : "mini",
        inputMode: TextInputModes.NUMERIC,
        pattern: checkoutRegexPatterns.giftCardNumberAndPin
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        type: "secondary",
        buttonType: "submit",
        quantumMetricAttribute: { type: "allow", value: "true" },
        size: "small",
        ariaLabel: gcApplyCTALabel,
        label: gcApplyCTALabel,
        id: "gift-card-apply"
      }
    )
  ] }) });
};
NewGiftCardForm.propTypes = {
  gcApplyCTALabel: PropTypes.string.isRequired,
  gcCardNumberInputLabel: PropTypes.string.isRequired,
  gcPinInputLabel: PropTypes.string.isRequired,
  gcNumberError: PropTypes.string.isRequired,
  gcPinError: PropTypes.string.isRequired,
  validateGCFieldsEmpty: PropTypes.func.isRequired
};
const GiftCard = ({ ...props }) => {
  const {
    gcMaxCardsAmount,
    gcTitle,
    gcLogoIcon,
    gcKeepCardsLabel,
    gcMaxCardsLabel,
    gcMaxCardsReachedLabel,
    gcOrderTotalCoveredLabel,
    gcApplyAnotherCardCTALabel,
    gcApplyCTALabel,
    gcCardNumberColHeader,
    gcBalanceColHeader,
    gcAppliedAmtColHeader,
    gcCardNumberInputLabel,
    gcPinInputLabel,
    gcCardNumberErrorMsg,
    gcPinErrorMsg,
    gcTooltipTitle,
    gcTooltipDesc,
    a11yRemoveLabel,
    giftCardData,
    applyGiftCard,
    deleteGiftCard,
    initiatedGiftCards,
    onGiftCardExpandHandler,
    gcInlineErrorCode,
    setGcInlineErrorCode,
    gcErrorToastMsg,
    showToastMessage,
    isGcSectionExpanded,
    isBuyNowModal
  } = props;
  const tooltipButtonRef = useRef(null);
  const [tooltipVisibility, setTooltipVisibility] = useState(false);
  const [gcNumberError, setGcNumberError] = useState("");
  const [gcPinError, setGcPinError] = useState("");
  const [showNewCardForm, setShowNewCardForm] = useState(false);
  const [maskedNumbers, setMaskedNumbers] = useState("");
  const { numberOfGiftCards, giftCardList, remainingAmount } = giftCardData;
  const noCardsApplied = !numberOfGiftCards;
  const isMaxCardsReached = numberOfGiftCards === gcMaxCardsAmount;
  const isOrderTotalCovered = remainingAmount === 0;
  const generateMaskedCardList = useCallback(() => {
    let maskedGcNumbers = "";
    giftCardList.forEach((card, index2) => {
      var _a;
      maskedGcNumbers += `${CARD_MASKING}${(_a = card.number) == null ? void 0 : _a.substr(CARD_NUMBER_DIGIT_SLICE)}`;
      if (index2 < giftCardList.length - 1) {
        maskedGcNumbers += ", ";
      }
    });
    setMaskedNumbers(maskedGcNumbers);
  }, [giftCardList]);
  useEffect(() => {
    setShowNewCardForm(false);
    generateMaskedCardList();
  }, [generateMaskedCardList, giftCardData]);
  const showGCFieldsErrorMsg = useCallback(
    (errorCode) => {
      if (gcInlineErrorCode) {
        if (isBuyNowModal) {
          const buyNowErrorMsgObj = {
            gcInvalidCardNumberMsg: (props == null ? void 0 : props.gcError601) || "",
            gcInvalidPinErrorMsg: (props == null ? void 0 : props.gcError612) || "",
            gcCardAlreadyAppliedErrorMsg: (props == null ? void 0 : props.gcError604) || ""
          };
          if (errorCode === applyGiftCardErrorCodes.incorrectGiftPin) {
            setGcPinError(showApplyGCInlineError(errorCode, buyNowErrorMsgObj));
            return;
          } else {
            setGcNumberError(showApplyGCInlineError(errorCode, buyNowErrorMsgObj));
            return;
          }
        }
        if (errorCode === applyGiftCardErrorCodes.incorrectGiftPin) {
          setGcPinError(props[`gcError${errorCode}`]);
        } else {
          setGcNumberError(props[`gcError${errorCode}`]);
        }
      }
    },
    [gcInlineErrorCode, props]
  );
  const validateGCFieldsEmpty = useCallback(
    (number, pin) => {
      const isNumberValid = validateLength(number, CARD_NUMBER_MIN_DIGITS, CARD_NUMBER_MAX_DIGITS);
      const isPinValid = validateLength(pin, PIN_MIN_DIGITS, PIN_MAX_DIGITS);
      setGcInlineErrorCode(0);
      setGcPinError("");
      setGcNumberError("");
      if (isNumberValid && isPinValid) {
        applyGiftCard({ giftCardNumber: removeDividers(number), giftCardPin: removeDividers(pin) });
      }
      if (!isNumberValid || !isPinValid) {
        !isNumberValid && setGcNumberError(gcCardNumberErrorMsg);
        !isPinValid && setGcPinError(gcPinErrorMsg);
        showToastMessage(gcErrorToastMsg);
      }
    },
    [applyGiftCard, gcCardNumberErrorMsg, gcErrorToastMsg, gcPinErrorMsg, setGcInlineErrorCode, showToastMessage]
  );
  useEffect(() => {
    showGCFieldsErrorMsg(gcInlineErrorCode);
  }, [gcInlineErrorCode, showGCFieldsErrorMsg]);
  const renderTooltip = () => {
    const tooltipBtnClickHandler = (event) => {
      event.stopPropagation();
      setTooltipVisibility((prev) => !prev);
    };
    const tooltipKeyHandler = (event) => {
      if (event.key in TooltipInteractionKeys) {
        event.preventDefault();
        setTooltipVisibility((prev) => !prev);
      }
    };
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "span",
        {
          className: `${componentClassName$1}__tooltip-btn`,
          ref: tooltipButtonRef,
          onClick: tooltipBtnClickHandler,
          onKeyDown: tooltipKeyHandler,
          role: "button",
          tabIndex: 0,
          "data-testid": "tooltip-btn",
          "aria-label": gcTooltipTitle,
          children: /* @__PURE__ */ jsx(Icon, { type: "ct-information-details", size: "lg" })
        }
      ),
      !!tooltipVisibility && /* @__PURE__ */ jsx(
        Tooltip,
        {
          visibility: tooltipVisibility,
          setVisibility: setTooltipVisibility,
          iconID: "ct-close",
          headerText: gcTooltipTitle,
          bodyText: gcTooltipDesc,
          coords: tooltipButtonRef.current,
          isModalPresent: isBuyNowModal
        }
      )
    ] });
  };
  const renderTitleSection = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${componentClassName$1}__title-section`, children: [
      /* @__PURE__ */ jsx("div", { className: `${componentClassName$1}__logo`, children: /* @__PURE__ */ jsx(Icon, { type: gcLogoIcon ? gcLogoIcon : defaultLogo }) }),
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-h4--sm`, children: gcTitle }),
      renderTooltip(),
      !isGcSectionExpanded ? /* @__PURE__ */ jsx("div", { className: `${componentClassName$1}__masked-number-list`, children: maskedNumbers }) : null
    ] });
  };
  const renderRemoveCardButton = (cardId) => {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: `${componentClassName$1}__remove-card-btn`,
        onClick: () => deleteGiftCard({ id: cardId }),
        "aria-label": a11yRemoveLabel,
        "data-testid": "gift-card-remove",
        children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "md" })
      }
    );
  };
  const renderAppliedCardsTable = () => {
    return giftCardList == null ? void 0 : giftCardList.map((card) => {
      const { id, number, balance, amount } = card;
      const initiatedCard = initiatedGiftCards == null ? void 0 : initiatedGiftCards.find((initiatedGiftCard) => (initiatedGiftCard == null ? void 0 : initiatedGiftCard.id) === id);
      const tableData = [
        {
          [gcCardNumberColHeader]: `${CARD_MASKING} ${number == null ? void 0 : number.substr(CARD_NUMBER_DIGIT_SLICE)}`,
          [gcBalanceColHeader]: formatCurrency(balance),
          [gcAppliedAmtColHeader]: formatCurrency(initiatedCard ? Number(initiatedCard == null ? void 0 : initiatedCard.amount) : amount),
          "": renderRemoveCardButton(id)
        }
      ];
      return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Table, { tableData, headerType: "row", tableType: "borderless" }) }, id);
    });
  };
  const renderAddAnotherCardCTA = () => {
    return !showNewCardForm ? /* @__PURE__ */ jsxs(Button, { type: "tertiary", size: "medium", onClick: () => setShowNewCardForm(true), id: "gift-card-add", children: [
      /* @__PURE__ */ jsx(Icon, { type: "ct-add", size: "md" }),
      /* @__PURE__ */ jsx("span", { children: gcApplyAnotherCardCTALabel })
    ] }) : null;
  };
  const renderAppliedCardsSection = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      renderAppliedCardsTable(),
      isOrderTotalCovered || isMaxCardsReached ? /* @__PURE__ */ jsx("p", { className: `${componentClassName$1}__label`, children: isOrderTotalCovered ? gcOrderTotalCoveredLabel : gcMaxCardsReachedLabel }) : renderAddAnotherCardCTA()
    ] });
  };
  const renderNewCardSection = () => {
    const newGiftCardFormProps = {
      gcApplyCTALabel,
      gcCardNumberInputLabel,
      gcPinInputLabel,
      gcCardNumberErrorMsg,
      gcPinErrorMsg,
      applyGiftCard,
      gcNumberError,
      gcPinError,
      validateGCFieldsEmpty
    };
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(NewGiftCardForm, { ...newGiftCardFormProps }),
      /* @__PURE__ */ jsx("p", { className: `${componentClassName$1}__label`, children: isMaxCardsReached ? gcMaxCardsReachedLabel : replaceStrWithDynamicVal(gcMaxCardsLabel, gcMaxCardsAmount) })
    ] });
  };
  const renderGiftCardSection = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: `${componentClassName$1}__section`, children: [
        /* @__PURE__ */ jsx("p", { className: `${componentClassName$1}__keep-label`, children: gcKeepCardsLabel }),
        noCardsApplied ? renderNewCardSection() : renderAppliedCardsSection()
      ] }),
      showNewCardForm && /* @__PURE__ */ jsxs("div", { className: `${componentClassName$1}__section`, children: [
        !isBuyNowModal && /* @__PURE__ */ jsx("p", { className: `${componentClassName$1}__new-card-heading`, children: gcApplyAnotherCardCTALabel }),
        renderNewCardSection()
      ] })
    ] });
  };
  return /* @__PURE__ */ jsx("div", { className: componentClassName$1, children: isBuyNowModal ? /* @__PURE__ */ jsxs(Fragment, { children: [
    renderTitleSection(),
    renderGiftCardSection()
  ] }) : /* @__PURE__ */ jsx(
    Accordion,
    {
      title: renderTitleSection(),
      isHeaderOpen: isGcSectionExpanded,
      collapseControl: onGiftCardExpandHandler,
      children: renderGiftCardSection()
    }
  ) });
};
GiftCard.propTypes = {
  gcMaxCardsAmount: PropTypes.number.isRequired,
  gcTitle: PropTypes.string.isRequired,
  gcLogoIcon: PropTypes.string.isRequired,
  gcKeepCardsLabel: PropTypes.string.isRequired,
  gcMaxCardsLabel: PropTypes.string.isRequired,
  gcMaxCardsReachedLabel: PropTypes.string.isRequired,
  gcOrderTotalCoveredLabel: PropTypes.string.isRequired,
  gcApplyAnotherCardCTALabel: PropTypes.string.isRequired,
  gcApplyCTALabel: PropTypes.string.isRequired,
  gcCardNumberColHeader: PropTypes.string.isRequired,
  gcBalanceColHeader: PropTypes.string.isRequired,
  gcAppliedAmtColHeader: PropTypes.string.isRequired,
  gcCardNumberInputLabel: PropTypes.string.isRequired,
  gcPinInputLabel: PropTypes.string.isRequired,
  gcCardNumberErrorMsg: PropTypes.string.isRequired,
  gcPinErrorMsg: PropTypes.string.isRequired,
  gcTooltipTitle: PropTypes.string.isRequired,
  gcTooltipDesc: PropTypes.string.isRequired,
  a11yRemoveLabel: PropTypes.string.isRequired,
  applyGiftCard: PropTypes.func.isRequired,
  deleteGiftCard: PropTypes.func.isRequired,
  isGcSectionExpanded: PropTypes.bool.isRequired
};
const parseQuery = (element, hasDelimeter) => {
  const filteredElement = Array.from(new Set(element.split(" ").filter((e) => e)));
  const stringWithDelimeter = filteredElement.toString().replace(/,/g, "+");
  return hasDelimeter ? stringWithDelimeter : element;
};
const excludeQuote = (comboExclude) => {
  const formattedString = comboExclude == null ? void 0 : comboExclude.replace(/'/g, '"');
  return formattedString && JSON.parse(formattedString);
};
const GuestCheckout = ({ ...props }) => {
  const {
    gLoginImage,
    gLoginImageAltText,
    gLoginDescription,
    gLoginHeader,
    earnCTMoneyToggle,
    isMasterOrRewardCardUser
  } = props;
  const getClassName = () => {
    return !earnCTMoneyToggle ? `${PREFIX}-guest-user-signin` : "";
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-signin-copy ${getClassName()}`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-login-header--copy`, "aria-hidden": "true", children: /* @__PURE__ */ jsx("img", { className: `${PREFIX}-login--logo`, src: `${gLoginImage}`, alt: `${gLoginImageAltText}` }) }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-guest-user`, children: [
      !earnCTMoneyToggle && /* @__PURE__ */ jsx("div", { className: `${PREFIX}-login-header--title`, children: gLoginHeader }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-login-header`, children: isMasterOrRewardCardUser || !earnCTMoneyToggle ? gLoginDescription : gLoginHeader })
    ] })
  ] });
};
const CTMoneySnippet = ({ ...props }) => {
  const { balance, title, url, target, allyLabel, isShowIcon } = props;
  return /* @__PURE__ */ jsxs(
    "a",
    {
      href: url,
      className: `${PREFIX}-pencil-banner__link`,
      target,
      rel: "noopener noreferrer",
      "aria-label": `${allyLabel} ${balance}`,
      children: [
        isShowIcon && /* @__PURE__ */ jsx(Icon, { size: "md", type: "ct-join-triangle-rewards-white" }),
        /* @__PURE__ */ jsx(SanitizeStringContentWrapper, { stringContent: title, children: (memoizedStringContent) => /* @__PURE__ */ jsx(
          "span",
          {
            className: `${PREFIX}-pencil-banner__name`,
            dangerouslySetInnerHTML: { __html: memoizedStringContent }
          }
        ) }),
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-pencil-banner__balance`, children: balance })
      ]
    }
  );
};
const SummaryTooltip = ({ ...props }) => {
  const {
    title,
    desc,
    a11yTooltipIcon,
    ariaDescribedbyId,
    a11yCloseIconLabel,
    tooltipIcon,
    isTooltipPreventEvent,
    descElement,
    iconSize
  } = props;
  const [visibility, setVisibility] = useState(false);
  const buttonRef = useRef(null);
  const toolTipButtonHandler = (e, visibilitySetter, currentVisibility) => {
    if (isTooltipPreventEvent) {
      e.preventDefault();
    } else {
      e.stopPropagation();
    }
    visibilitySetter(!currentVisibility);
  };
  const toolTipText = (tooltipDesc, tooltipDescElement) => {
    if (tooltipDescElement) {
      return /* @__PURE__ */ jsx("div", { "data-testid": "tooltip-text", children: tooltipDescElement });
    } else {
      return /* @__PURE__ */ jsx("div", { "data-testid": "tooltip-text", dangerouslySetInnerHTML: { __html: tooltipDesc } });
    }
  };
  const renderTooltipView = () => {
    return !!visibility && /* @__PURE__ */ jsx(
      Tooltip,
      {
        visibility,
        setVisibility,
        iconID: "ct-close",
        headerText: title,
        bodyText: toolTipText(desc, descElement),
        coords: buttonRef.current,
        a11yCloseIconLabel
      }
    );
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        ref: buttonRef,
        className: `${PREFIX}-summary__tooltip-btn`,
        onClick: (event) => toolTipButtonHandler(event, setVisibility, visibility),
        "data-testid": "summary-fee",
        "aria-label": a11yTooltipIcon,
        "aria-describedby": ariaDescribedbyId,
        children: /* @__PURE__ */ jsx("span", { className: visibility ? `${PREFIX}-summary__tooltip-btn--active` : "", children: /* @__PURE__ */ jsx(Icon, { type: tooltipIcon ? tooltipIcon : "ct-information-grey", size: iconSize ? iconSize : "md" }) })
      }
    ),
    renderTooltipView()
  ] });
};
const componentClassName = `${PREFIX}-line-summary`;
const LineSummary = ({ ...props }) => {
  const {
    title,
    value,
    isHeading = false,
    tooltip,
    showTooltipWithTitle,
    className: className2 = componentClassName,
    isSubLineItem,
    isSeparator = false
  } = props;
  const titleId = useMemo(() => {
    return tooltip && checkDataLength(tooltip) ? `id${Math.random().toString(magicNumber.SIXTEEN).slice(magicNumber.TWO)}` : "";
  }, [tooltip]);
  const displayTooltip = () => {
    return tooltip && checkDataLength(tooltip) && /* @__PURE__ */ jsx(SummaryTooltip, { ...tooltip, ariaDescribedbyId: `${titleId}` });
  };
  const subSummaryItemClass = isSubLineItem ? `${className2}__sub-item` : "";
  const headingClass = isHeading ? `${className2}__item--heading` : "";
  const colors = [BrandingColors.RED, BrandingColors.BURGUNDY, BrandingColors.TEAL];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isHeading && /* @__PURE__ */ jsx("hr", {}),
    /* @__PURE__ */ jsxs("div", { className: `${className2} ${subSummaryItemClass}`, children: [
      isSeparator && /* @__PURE__ */ jsx(Separator, { colors, style: SeparatorStyle.HORIZONTAL, size: SeparatorSize.FULL_WIDTH }),
      title && /* @__PURE__ */ jsxs("div", { className: `${className2}__item ${headingClass}`, children: [
        /* @__PURE__ */ jsx("span", { id: `${titleId}`, children: title }),
        showTooltipWithTitle && displayTooltip()
      ] }),
      /* @__PURE__ */ jsxs("div", { className: `${className2}__value`, children: [
        value && typeof value === Types.String ? /* @__PURE__ */ jsx("label", { children: value }) : value,
        !showTooltipWithTitle && displayTooltip()
      ] })
    ] })
  ] });
};
const TransactionDetail = (props) => {
  const {
    isOpen,
    closeFlyout,
    transactionDetailLabel,
    transaction,
    bannerImageList,
    storeNameLabel,
    datePlacedLabel,
    transactionDate,
    a11yCloseIconLabel,
    transactionAmountList
  } = props;
  const contentRef = useRef(null);
  const componentClass = `${PREFIX}-transaction-detail`;
  const modalClassName = `${PREFIX}-previous-element`;
  const previousElement = document.querySelector(`button[${previousElementName}]`);
  const closeModalHandler = () => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    closeFlyout();
    if (previousElement) {
      setTimeout(() => {
        previousElement == null ? void 0 : previousElement.focus();
        previousElement == null ? void 0 : previousElement.removeAttribute(previousElementName);
      }, 0);
    }
  };
  const flyoutModalProps = {
    isOpen,
    closeFlyout,
    isStoreSelectorModalUsed: false
  };
  const { storeName, banner } = transaction;
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add(MODAL_OPEN_CLASS$1);
    } else {
      document.body.classList.remove(MODAL_OPEN_CLASS$1);
    }
    return () => {
      document.body.classList.remove(MODAL_OPEN_CLASS$1);
    };
  }, [isOpen]);
  useClickOutsideClose(contentRef, () => closeModalHandler(), isOpen, true);
  const getModalHeader = () => /* @__PURE__ */ jsxs("div", { className: `${componentClass}__header`, children: [
    /* @__PURE__ */ jsx(Heading, { variant: "h2", componentClass: `${componentClass}__title`, children: transactionDetailLabel }),
    /* @__PURE__ */ jsx(
      Button,
      {
        "data-testid": "close-button",
        type: "icon_button",
        onClick: closeModalHandler,
        ariaLabel: a11yCloseIconLabel,
        children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" })
      }
    )
  ] });
  const getModalDescription = () => /* @__PURE__ */ jsxs("section", { className: `${PREFIX}-xs-flex ${componentClass}__body`, children: [
    /* @__PURE__ */ jsx(
      TransactionColumnLogo,
      {
        banner,
        bannerImageList,
        customClass: `${PREFIX}-xs-none ${PREFIX}-sm-flex`
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-row`, children: [
      /* @__PURE__ */ jsx(PreviewDetail, { title: storeNameLabel, detail: storeName }),
      /* @__PURE__ */ jsx(PreviewDetail, { title: datePlacedLabel, detail: transactionDate })
    ] })
  ] });
  return isOpen ? /* @__PURE__ */ jsx(FlyoutModalComponent, { ...flyoutModalProps, children: /* @__PURE__ */ jsxs("div", { className: `${componentClass}`, children: [
    getModalHeader(),
    getModalDescription(),
    transactionAmountList.map((item, index2) => /* @__PURE__ */ jsx(
      LineSummary,
      {
        className: `${PREFIX}-xs-flex ${PREFIX}-xs-justify-space-between ${PREFIX}-line-summary${item.isCtMoneyDetailView ? "__expand" : ""}`,
        title: item == null ? void 0 : item.title,
        value: item == null ? void 0 : item.value
      },
      index2
    ))
  ] }) }) : null;
};
const carouselSettings = {
  carouselDotsDefault: true,
  // value to show or hide carousel dots
  carouselInfiniteScrollingDefault: true,
  // value to enable or disable carousel's infinite scrolling
  desktopThresholdDefault: 4,
  // value to display number of carousel items on desktop
  mDefaultCarouselSettings: {
    initialSlide: 0,
    className: "center",
    centerMode: true,
    centerPadding: 50,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false
  },
  // value to display number of carousel items on mobile portrait mode
  mobileLandscapeThresholdDefault: 2,
  // value to display number of carousel items on mobile landscape mode
  tabletPortraitThresholdDefault: 3,
  // value to display number of carousel items on tablet portrait mode
  variableWidthClassName: "variable-width",
  cardSpacing: 16,
  disabledClass: "swiper-button-disabled"
};
const { variableWidthClassName: variableWidthClassName$1 } = carouselSettings;
const carouselSettingValues = (carouselList, deviceThreshold, tabletArrowSettings) => {
  return {
    arrows: tabletArrowSettings ? tabletArrowSettings : false,
    slidesToShow: carouselList.length < deviceThreshold ? carouselList.length : deviceThreshold,
    slidesToScroll: carouselList.length < deviceThreshold ? carouselList.length : deviceThreshold,
    variableWidth: carouselList.length < deviceThreshold,
    className: carouselList.length < deviceThreshold ? variableWidthClassName$1 : null
  };
};
const {
  desktopThresholdDefault,
  mDefaultCarouselSettings,
  mobileLandscapeThresholdDefault,
  tabletPortraitThresholdDefault,
  carouselDotsDefault,
  carouselInfiniteScrollingDefault,
  variableWidthClassName
} = carouselSettings;
const Carousel$1 = (props) => {
  const {
    title,
    carouselList,
    path,
    a11yCarouselNextLabel,
    a11yCarouselPreviousLabel,
    desktopThreshold,
    mobileLandscapeThreshold,
    tabletPortraitThreshold,
    carouselClassName,
    mobileCarouselSettings,
    tabletArrowSettings,
    sliderRef,
    initialSlide,
    displayArrows,
    displayDots,
    responsiveDesign,
    infiniteScrolling,
    carouselCallbackHandler,
    responsiveWideDesktopThreshold
  } = props;
  const { mobilePortrait, mobileLandscape, tabletPortrait, tabletMaxWidth } = BREAKPOINTS;
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const slidesToShow = responsiveWideDesktopThreshold ?? Math.min(carouselList.length, desktopThreshold);
  const slidesToScroll = Math.min(carouselList.length, responsiveWideDesktopThreshold ?? desktopThreshold);
  const variableWidth = responsiveWideDesktopThreshold ? false : carouselList.length < desktopThreshold;
  const variableWidthCustomClassName = variableWidth ? variableWidthClassName : null;
  const infiniteScroll = responsiveWideDesktopThreshold ? carouselList.length >= responsiveWideDesktopThreshold : infiniteScrolling ?? carouselInfiniteScrollingDefault;
  const settings = {
    onLazyLoad: carouselCallbackHandler ? () => setTimeout(carouselCallbackHandler) : void 0,
    slidesToShow,
    slidesToScroll,
    variableWidth,
    className: variableWidthCustomClassName,
    dots: displayDots,
    infinite: infiniteScroll,
    speed: 500,
    beforeChange(_prev, next) {
      const slideWidth = carouselList.length < desktopThreshold ? carouselList.length : desktopThreshold;
      setActiveSlideIndex(next > 0 ? next / slideWidth : 0);
    },
    initialSlide,
    arrows: displayArrows,
    customPaging: function(i) {
      return /* @__PURE__ */ jsx(
        "button",
        {
          "aria-current": i === activeSlideIndex ? "true" : "false",
          "aria-label": `${title} Slide ${i + magicNumber.ONE}`,
          "data-testid": "slick-button",
          children: i + magicNumber.ONE
        }
      );
    },
    lazyLoad: !isPrerenderOrNot(),
    // to lazy load the images, lazy load will be false for googlebot
    nextArrow: /* @__PURE__ */ jsx(CarouselNavigationArrow, { ariaLabel: a11yCarouselNextLabel, type: "ct-chevron-right", size: "md", path }),
    prevArrow: /* @__PURE__ */ jsx(
      CarouselNavigationArrow,
      {
        ariaLabel: a11yCarouselPreviousLabel,
        type: "ct-chevron-left",
        size: "md",
        path
      }
    ),
    responsive: responsiveDesign ?? [
      {
        breakpoint: mobilePortrait,
        settings: mobileCarouselSettings
      },
      {
        breakpoint: mobileLandscape,
        settings: carouselSettingValues(carouselList, mobileLandscapeThreshold, tabletArrowSettings)
      },
      {
        breakpoint: tabletPortrait,
        settings: carouselSettingValues(carouselList, tabletPortraitThreshold, tabletArrowSettings)
      },
      {
        breakpoint: tabletMaxWidth,
        settings: carouselSettingValues(carouselList, desktopThreshold, tabletArrowSettings)
      }
    ]
  };
  return /* @__PURE__ */ jsx("div", { className: `${carouselClassName} ${PREFIX}-carousel`, children: /* @__PURE__ */ jsx(Slider, { ...settings, ref: sliderRef, children: carouselList }) });
};
Carousel$1.defaultProps = {
  desktopThreshold: desktopThresholdDefault,
  mobileCarouselSettings: mDefaultCarouselSettings,
  mobileLandscapeThreshold: mobileLandscapeThresholdDefault,
  tabletPortraitThreshold: tabletPortraitThresholdDefault,
  carouselClassName: "",
  initialSlide: 0,
  displayArrows: true,
  displayDots: carouselDotsDefault
};
Carousel$1.propTypes = {
  ...Carousel$1.propTypes
};
const plaCarouselSchemaId = ["cat1pla_rr", "cat2pla_rr", "pla_rr"];
function isObject$2(obj) {
  return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend$2(target, src2) {
  if (target === void 0) {
    target = {};
  }
  if (src2 === void 0) {
    src2 = {};
  }
  const noExtend = ["__proto__", "constructor", "prototype"];
  Object.keys(src2).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
    if (typeof target[key] === "undefined") target[key] = src2[key];
    else if (isObject$2(src2[key]) && isObject$2(target[key]) && Object.keys(src2[key]).length > 0) {
      extend$2(target[key], src2[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc = typeof document !== "undefined" ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function CustomEvent2() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === "undefined") {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === "undefined") {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== "undefined" ? window : {};
  extend$2(win, ssrWindow);
  return win;
}
function classesToTokens(classes2) {
  if (classes2 === void 0) {
    classes2 = "";
  }
  return classes2.trim().split(" ").filter((c) => !!c.trim());
}
function deleteProps(obj) {
  const object2 = obj;
  Object.keys(object2).forEach((key) => {
    try {
      object2[key] = null;
    } catch (e) {
    }
    try {
      delete object2[key];
    } catch (e) {
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window2 = getWindow();
  let style;
  if (window2.getComputedStyle) {
    style = window2.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = "x";
  }
  const window2 = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);
  if (window2.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(",").length > 6) {
      curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ");
    }
    transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
    matrix = transformMatrix.toString().split(",");
  }
  if (axis === "x") {
    if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === "y") {
    if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$1(o) {
  return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
  if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend$1() {
  const to = Object(arguments.length <= 0 ? void 0 : arguments[0]);
  const noExtend = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const nextSource = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== void 0 && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
  let {
    swiper,
    targetPosition,
    side
  } = _ref;
  const window2 = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = "none";
  window2.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev";
  const isOutOfBound = (current, target) => {
    return dir === "next" && current >= target || dir === "prev" && current <= target;
  };
  const animate = () => {
    time = (/* @__PURE__ */ new Date()).getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = "hidden";
      swiper.wrapperEl.style.scrollSnapType = "";
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = "";
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window2.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
  };
  animate();
}
function elementChildren(element, selector) {
  if (selector === void 0) {
    selector = "";
  }
  const window2 = getWindow();
  const children = [...element.children];
  if (window2.HTMLSlotElement && element instanceof HTMLSlotElement) {
    children.push(...element.assignedElements());
  }
  if (!selector) {
    return children;
  }
  return children.filter((el) => el.matches(selector));
}
function elementIsChildOfSlot(el, slot) {
  const elementsQueue = [slot];
  while (elementsQueue.length > 0) {
    const elementToCheck = elementsQueue.shift();
    if (el === elementToCheck) {
      return true;
    }
    elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
  }
}
function elementIsChildOf(el, parent) {
  const window2 = getWindow();
  let isChild = parent.contains(el);
  if (!isChild && window2.HTMLSlotElement && parent instanceof HTMLSlotElement) {
    const children = [...parent.assignedElements()];
    isChild = children.includes(el);
    if (!isChild) {
      isChild = elementIsChildOfSlot(el, parent);
    }
  }
  return isChild;
}
function showWarning(text2) {
  try {
    console.warn(text2);
    return;
  } catch (err) {
  }
}
function createElement(tag, classes2) {
  if (classes2 === void 0) {
    classes2 = [];
  }
  const el = document.createElement(tag);
  el.classList.add(...Array.isArray(classes2) ? classes2 : classesToTokens(classes2));
  return el;
}
function elementOffset(el) {
  const window2 = getWindow();
  const document2 = getDocument();
  const box = el.getBoundingClientRect();
  const body = document2.body;
  const clientTop = el.clientTop || body.clientTop || 0;
  const clientLeft = el.clientLeft || body.clientLeft || 0;
  const scrollTop = el === window2 ? window2.scrollY : el.scrollTop;
  const scrollLeft = el === window2 ? window2.scrollX : el.scrollLeft;
  return {
    top: box.top + scrollTop - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling;
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling;
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window2 = getWindow();
  return window2.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return void 0;
}
function elementParents(el, selector) {
  const parents = [];
  let parent = el.parentElement;
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementOuterSize(el, size, includeMargins) {
  const window2 = getWindow();
  {
    return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
  }
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter((e) => !!e);
}
let support;
function calcSupport() {
  const window2 = getWindow();
  const document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && document2.documentElement.style && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
let deviceCached;
function calcDevice(_temp) {
  let {
    userAgent
  } = _temp === void 0 ? {} : _temp;
  const support2 = getSupport();
  const window2 = getWindow();
  const platform = window2.navigator.platform;
  const ua = userAgent || window2.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window2.screen.width;
  const screenHeight = window2.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, "13_0_0"];
    macos = false;
  }
  if (android && !windows) {
    device.os = "android";
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = "ios";
    device.ios = true;
  }
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
let browser;
function calcBrowser() {
  const window2 = getWindow();
  const device = getDevice();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window2.navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
  }
  if (isSafari()) {
    const ua = String(window2.navigator.userAgent);
    if (ua.includes("Version/")) {
      const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent);
  const isSafariBrowser = isSafari();
  const need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix,
    need3dFix,
    isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize(_ref) {
  let {
    swiper,
    on,
    emit
  } = _ref;
  const window2 = getWindow();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit("beforeResize");
    emit("resize");
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver((entries2) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries2.forEach((_ref2) => {
          let {
            contentBoxSize,
            contentRect,
            target
          } = _ref2;
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window2.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit("orientationchange");
  };
  on("init", () => {
    if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler);
    window2.addEventListener("orientationchange", orientationChangeHandler);
  });
  on("destroy", () => {
    removeObserver();
    window2.removeEventListener("resize", resizeHandler);
    window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const observers2 = [];
  const window2 = getWindow();
  const attach = function(target, options) {
    if (options === void 0) {
      options = {};
    }
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
    const observer = new ObserverFunc((mutations) => {
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate2() {
        emit("observerUpdate", mutations[0]);
      };
      if (window2.requestAnimationFrame) {
        window2.requestAnimationFrame(observerUpdate);
      } else {
        window2.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === "undefined" ? true : options.attributes,
      childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
      characterData: typeof options.characterData === "undefined" ? true : options.characterData
    });
    observers2.push(observer);
  };
  const init = () => {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = elementParents(swiper.hostEl);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers2.forEach((observer) => {
      observer.disconnect();
    });
    observers2.splice(0, observers2.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on("init", init);
  on("destroy", destroy);
}
var eventsEmitter = {
  on(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    const method = priority ? "unshift" : "push";
    events2.split(" ").forEach((event) => {
      if (!self2.eventsListeners[event]) self2.eventsListeners[event] = [];
      self2.eventsListeners[event][method](handler);
    });
    return self2;
  },
  once(events2, handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    function onceHandler() {
      self2.off(events2, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self2, args);
    }
    onceHandler.__emitterProxy = handler;
    return self2.on(events2, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (typeof handler !== "function") return self2;
    const method = priority ? "unshift" : "push";
    if (self2.eventsAnyListeners.indexOf(handler) < 0) {
      self2.eventsAnyListeners[method](handler);
    }
    return self2;
  },
  offAny(handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsAnyListeners) return self2;
    const index2 = self2.eventsAnyListeners.indexOf(handler);
    if (index2 >= 0) {
      self2.eventsAnyListeners.splice(index2, 1);
    }
    return self2;
  },
  off(events2, handler) {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsListeners) return self2;
    events2.split(" ").forEach((event) => {
      if (typeof handler === "undefined") {
        self2.eventsListeners[event] = [];
      } else if (self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler, index2) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self2.eventsListeners[event].splice(index2, 1);
          }
        });
      }
    });
    return self2;
  },
  emit() {
    const self2 = this;
    if (!self2.eventsListeners || self2.destroyed) return self2;
    if (!self2.eventsListeners) return self2;
    let events2;
    let data;
    let context;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
      events2 = args[0];
      data = args.slice(1, args.length);
      context = self2;
    } else {
      events2 = args[0].events;
      data = args[0].data;
      context = args[0].context || self2;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
    eventsArray.forEach((event) => {
      if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
        self2.eventsAnyListeners.forEach((eventHandler) => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self2.eventsListeners && self2.eventsListeners[event]) {
        self2.eventsListeners[event].forEach((eventHandler) => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self2;
  }
};
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }
  width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
  height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
function updateSlides() {
  const swiper = this;
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === "function") {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === "function") {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index2 = 0;
  if (typeof swiperSize === "undefined") {
    return;
  }
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween;
  slides.forEach((slideEl) => {
    if (rtl) {
      slideEl.style.marginLeft = "";
    } else {
      slideEl.style.marginRight = "";
    }
    slideEl.style.marginBottom = "";
    slideEl.style.marginTop = "";
  });
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
    return typeof params.breakpoints[key].slidesPerView !== "undefined";
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    let slide2;
    if (slides[i]) slide2 = slides[i];
    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide2, slides);
    }
    if (slides[i] && elementStyle(slide2, "display") === "none") continue;
    if (params.slidesPerView === "auto") {
      if (shouldResetSlideSize) {
        slides[i].style[swiper.getDirectionLabel("width")] = ``;
      }
      const slideStyles = getComputedStyle(slide2);
      const currentTransform = slide2.style.transform;
      const currentWebKitTransform = slide2.style.webkitTransform;
      if (currentTransform) {
        slide2.style.transform = "none";
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = "none";
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? elementOuterSize(slide2, "width") : elementOuterSize(slide2, "height");
      } else {
        const width = getDirectionPropertyValue(slideStyles, "width");
        const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
        const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
        const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
        const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
        const boxSizing = slideStyles.getPropertyValue("box-sizing");
        if (boxSizing && boxSizing === "border-box") {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide2;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide2.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1e3) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index2 % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index2 - Math.min(swiper.params.slidesPerGroupSkip, index2)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index2 += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach((slideEl) => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
    snapGrid = snapGrid.map((snap) => {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
    if (allSlidesSize + offsetSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit("slidesLengthChange");
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit("snapGridLengthChange");
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit("slidesGridLengthChange");
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit("slidesUpdated");
  if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === "number") {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = (index2) => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index2)];
    }
    return swiper.slides[index2];
  };
  if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach((slide2) => {
        activeSlides.push(slide2);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index2 = swiper.activeIndex + i;
        if (index2 > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index2));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== "undefined") {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}
const toggleSlideClasses$1 = (slideEl, condition, className2) => {
  if (condition && !slideEl.classList.contains(className2)) {
    slideEl.classList.add(className2);
  } else if (!condition && slideEl.classList.contains(className2)) {
    slideEl.classList.remove(className2);
  }
};
function updateSlidesProgress(translate2) {
  if (translate2 === void 0) {
    translate2 = this && this.translate || 0;
  }
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
  let offsetCenter = -translate2;
  if (rtl) offsetCenter = translate2;
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide2 = slides[i];
    let slideOffset = slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide2);
      swiper.visibleSlidesIndexes.push(i);
    }
    toggleSlideClasses$1(slide2, isVisible, params.slideVisibleClass);
    toggleSlideClasses$1(slide2, isFullyVisible, params.slideFullyVisibleClass);
    slide2.progress = rtl ? -slideProgress : slideProgress;
    slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}
function updateProgress(translate2) {
  const swiper = this;
  if (typeof translate2 === "undefined") {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate2 - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate2 - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate2 - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate2);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate2);
  if (isBeginning && !wasBeginning) {
    swiper.emit("reachBeginning toEdge");
  }
  if (isEnd && !wasEnd) {
    swiper.emit("reachEnd toEdge");
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit("fromEdge");
  }
  swiper.emit("progress", progress);
}
const toggleSlideClasses = (slideEl, condition, className2) => {
  if (condition && !slideEl.classList.contains(className2)) {
    slideEl.classList.add(className2);
  } else if (!condition && slideEl.classList.contains(className2)) {
    slideEl.classList.remove(className2);
  }
};
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const getFilteredSlide = (selector) => {
    return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  let activeSlide;
  let prevSlide;
  let nextSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.find((slideEl) => slideEl.column === activeIndex);
      nextSlide = slides.find((slideEl) => slideEl.column === activeIndex + 1);
      prevSlide = slides.find((slideEl) => slideEl.column === activeIndex - 1);
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    if (!gridEnabled) {
      nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }
      prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
    }
  }
  slides.forEach((slideEl) => {
    toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
    toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
    toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
  });
  swiper.emitSlidesClasses();
}
const processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl) lazyEl.remove();
  }
};
const unlazy = (swiper, index2) => {
  if (!swiper.slides[index2]) return;
  const imageEl = swiper.slides[index2].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute("loading");
};
const preload = (swiper) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper, i);
      }
    }
  }
};
function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== "undefined") {
      if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate2 >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = (aIndex) => {
    let realIndex2 = aIndex - swiper.virtual.slidesBefore;
    if (realIndex2 < 0) {
      realIndex2 = swiper.virtual.slides.length + realIndex2;
    }
    if (realIndex2 >= swiper.virtual.slides.length) {
      realIndex2 -= swiper.virtual.slides.length;
    }
    return realIndex2;
  };
  if (typeof activeIndex === "undefined") {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate2) >= 0) {
    snapIndex = snapGrid.indexOf(translate2);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit("snapIndexChange");
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  let realIndex;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (gridEnabled) {
    const firstSlideInColumn = swiper.slides.find((slideEl) => slideEl.column === activeIndex);
    let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit("activeIndexChange");
  swiper.emit("snapIndexChange");
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit("realIndexChange");
    }
    swiper.emit("slideChange");
  }
}
function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide2 = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide2 && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach((pathEl) => {
      if (!slide2 && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide2 = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide2) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide2) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide2 && slideFound) {
    swiper.clickedSlide = slide2;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = void 0;
    swiper.clickedIndex = void 0;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? "x" : "y";
  }
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate2 : translate2;
  }
  if (params.cssMode) {
    return translate2;
  }
  let currentTranslate = getTranslate(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate2 : translate2;
  } else {
    y = translate2;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
  }
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate2);
  }
  swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2, speed, runCallbacks, translateBounds, internal) {
  if (translate2 === void 0) {
    translate2 = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate2 = swiper.minTranslate();
  const maxTranslate2 = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2) newTranslate = minTranslate2;
  else if (translateBounds && translate2 < maxTranslate2) newTranslate = maxTranslate2;
  else newTranslate = translate2;
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionEnd");
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionStart");
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          swiper.animating = false;
          if (runCallbacks) {
            swiper.emit("transitionEnd");
          }
        };
      }
      swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
  }
  swiper.emit("setTransition", duration, byController);
}
function transitionEmit(_ref) {
  let {
    swiper,
    runCallbacks,
    direction,
    step
  } = _ref;
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = "next";
    else if (activeIndex < previousIndex) dir = "prev";
    else dir = "reset";
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === "next") {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "Start"
  });
}
function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "End"
  });
}
var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index2, speed, runCallbacks, internal, initial) {
  if (index2 === void 0) {
    index2 = 0;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index2 === "string") {
    index2 = parseInt(index2, 10);
  }
  const swiper = this;
  let slideIndex = index2;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate2 = -snapGrid[snapIndex];
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== "undefined") {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate2 > swiper.translate && translate2 > swiper.minTranslate() : translate2 < swiper.translate && translate2 < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit("beforeSlideChangeStart");
  }
  swiper.updateProgress(translate2);
  let direction;
  if (slideIndex > activeIndex) direction = "next";
  else if (slideIndex < activeIndex) direction = "prev";
  else direction = "reset";
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  const isInitialVirtual = isVirtual && initial;
  if (!isInitialVirtual && (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate)) {
    swiper.updateActiveIndex(slideIndex);
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== "slide") {
      swiper.setTranslate(translate2);
    }
    if (direction !== "reset") {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate2 : -translate2;
    if (speed === 0) {
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = "none";
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        });
      } else {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = "";
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t,
        behavior: "smooth"
      });
    }
    return true;
  }
  const browser2 = getBrowser();
  const isSafari = browser2.isSafari;
  if (isVirtual && !initial && isSafari && swiper.isElement) {
    swiper.virtual.update(false, false, slideIndex);
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate2);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit("beforeTransitionStart", speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop(index2, speed, runCallbacks, internal) {
  if (index2 === void 0) {
    index2 = 0;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index2 === "string") {
    const indexAsNumber = parseInt(index2, 10);
    index2 = indexAsNumber;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  let newIndex = index2;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      let targetSlideIndex;
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      const {
        centeredSlides
      } = swiper.params;
      let slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === "auto") {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      let needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (centeredSlides) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) {
        needLoopFix = false;
      }
      if (needLoopFix) {
        const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
        swiper.loopFix({
          direction,
          slideTo: true,
          activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === "next" ? swiper.realIndex : void 0
        });
      }
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(() => {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}
function slideNext(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: "next"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: "prev"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate2);
  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
  const isFreeMode = params.freeMode && params.freeMode.enabled;
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === "undefined" && (params.cssMode || isFreeMode)) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== "undefined") {
      prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== "undefined") {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === "undefined") {
    speed = swiper.params.speed;
  }
  let index2 = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index2);
  const snapIndex = skip + Math.floor((index2 - skip) / swiper.params.slidesPerGroup);
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate2 >= swiper.snapGrid[snapIndex]) {
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
      index2 += swiper.params.slidesPerGroup;
    }
  } else {
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index2 -= swiper.params.slidesPerGroup;
    }
  }
  index2 = Math.max(index2, 0);
  index2 = Math.min(index2, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index2, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper = this;
  if (swiper.destroyed) return;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(slideRealIndex, initial) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  const initSlides = () => {
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index2) => {
      el.setAttribute("data-swiper-slide-index", index2);
    });
  };
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  const addBlankSlides = (amountOfSlides) => {
    for (let i = 0; i < amountOfSlides; i += 1) {
      const slideEl = swiper.isElement ? createElement("swiper-slide", [params.slideBlankClass]) : createElement("div", [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    }
    initSlides();
  } else {
    initSlides();
  }
  swiper.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? void 0 : "next",
    initial
  });
}
function loopFix(_temp) {
  let {
    slideRealIndex,
    slideTo: slideTo2 = true,
    direction,
    setTranslate: setTranslate2,
    activeSlideIndex,
    initial,
    byController,
    byMousewheel
  } = _temp === void 0 ? {} : _temp;
  const swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit("beforeLoopFix");
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  const {
    centeredSlides,
    initialSlide
  } = params;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo2) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
    return;
  }
  let slidesPerView = params.slidesPerView;
  if (slidesPerView === "auto") {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (centeredSlides && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  let loopedSlides = slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
    showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
  } else if (gridEnabled && params.grid.fill === "row") {
    showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  }
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
  let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
  if (typeof activeSlideIndex === "undefined") {
    activeSlideIndex = swiper.getSlideIndex(slides.find((el) => el.classList.contains(params.slideActiveClass)));
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === "next" || !direction;
  const isPrev = direction === "prev" || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate2 === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
      const index2 = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        const colIndexToPrepend = cols - index2 - 1;
        for (let i2 = slides.length - 1; i2 >= 0; i2 -= 1) {
          if (slides[i2].column === colIndexToPrepend) prependSlidesIndexes.push(i2);
        }
      } else {
        prependSlidesIndexes.push(cols - index2 - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
    if (isInitialOverflow) {
      slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
    }
    for (let i = 0; i < slidesAppended; i += 1) {
      const index2 = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        slides.forEach((slide2, slideIndex) => {
          if (slide2.column === index2) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index2);
      }
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(() => {
    swiper.__preventObserver__ = false;
  });
  if (swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
    if (appendSlidesIndexes.includes(activeSlideIndex)) {
      appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (prependSlidesIndexes.includes(activeSlideIndex)) {
      prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach((index2) => {
      slides[index2].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index2]);
      slides[index2].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach((index2) => {
      slides[index2].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index2]);
      slides[index2].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === "auto") {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach((slide2, slideIndex) => {
      swiper.grid.updateSlide(slideIndex, slide2, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo2) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
          if (setTranslate2) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate2) {
          const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate2) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate: setTranslate2,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach((c) => {
        if (!c.destroyed && c.params.loop) c.loopFix({
          ...loopParams,
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo2 : false
        });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo2 : false
      });
    }
  }
  swiper.emit("loopFix");
}
function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach((slideEl) => {
    const index2 = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index2] = slideEl;
  });
  swiper.slides.forEach((slideEl) => {
    slideEl.removeAttribute("data-swiper-slide-index");
  });
  newSlidesOrder.forEach((slideEl) => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}
var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = "move";
  el.style.cursor = moving ? "grabbing" : "grab";
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}
function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}
var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  const window2 = getWindow();
  const {
    params
  } = swiper;
  const edgeSwipeDetection = params.edgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === "prevent") {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  const swiper = this;
  const document2 = getDocument();
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  const data = swiper.touchEventsData;
  if (e.type === "pointerdown") {
    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
      return;
    }
    data.pointerId = e.pointerId;
  } else if (e.type === "touchstart" && e.targetTouches.length === 1) {
    data.touchId = e.targetTouches[0].identifier;
  }
  if (e.type === "touchstart") {
    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
    return;
  }
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === "mouse") return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let targetEl = e.target;
  if (params.touchEventsTarget === "wrapper") {
    if (!elementIsChildOf(targetEl, swiper.wrapperEl)) return;
  }
  if ("which" in e && e.which === 3) return;
  if ("button" in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
  const eventPath = e.composedPath ? e.composedPath() : e.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;
  if (!preventEdgeSwipe(swiper, e, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: void 0,
    startMoving: void 0
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = void 0;
  if (params.threshold > 0) data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === "SELECT") {
      data.isTouched = false;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== targetEl && (e.pointerType === "mouse" || e.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) {
    document2.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit("touchStart", e);
}
function onTouchMove(event) {
  const document2 = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === "mouse") return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (e.type === "pointermove") {
    if (data.touchId !== null) return;
    const id = e.pointerId;
    if (id !== data.pointerId) return;
  }
  let targetTouch;
  if (e.type === "touchmove") {
    targetTouch = [...e.changedTouches].find((t) => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit("touchMoveOpposite", e);
    }
    return;
  }
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
      return;
    } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
      return;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== e.target && e.pointerType !== "mouse") {
    document2.activeElement.blur();
  }
  if (document2.activeElement) {
    if (e.target === document2.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit("touchMove", e);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling === "undefined") {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit("touchMoveOpposite", e);
  }
  if (typeof data.startMoving === "undefined") {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? "prev" : "next";
  swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent("transitionend", {
        bubbles: true,
        cancelable: true,
        detail: {
          bySwiperTouchMove: true
        }
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit("sliderFirstMove", e);
  }
  (/* @__PURE__ */ new Date()).getTime();
  if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit("sliderMove", e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
      swiper.loopFix({
        direction: "prev",
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && true && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: "next",
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }
  if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  swiper.updateProgress(data.currentTranslate);
  swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let targetTouch;
  const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
  if (!isTouchEvent) {
    if (data.touchId !== null) return;
    if (e.pointerId !== data.pointerId) return;
    targetTouch = e;
  } else {
    targetTouch = [...e.changedTouches].find((t) => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e.type)) {
    const proceed = ["pointercancel", "contextmenu"].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === "mouse") return;
  if (data.allowTouchCallbacks) {
    swiper.emit("touchEnd", e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }
  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime;
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit("tap click", e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit("doubleTap doubleClick", e);
    }
  }
  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment2] !== "undefined") {
      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment2]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment2] - slidesGrid[i];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === "next") {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
      else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === "prev") {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === "next") {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === "prev") {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit("setTranslate", swiper.translate, false);
}
function onLoad(e) {
  const swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}
function onDocumentTouchStart() {
  const swiper = this;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = "auto";
  }
}
const events = (swiper, method) => {
  const document2 = getDocument();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
  const swiperMethod = method;
  if (!el || typeof el === "string") return;
  document2[domMethod]("touchstart", swiper.onDocumentTouchStart, {
    passive: false,
    capture
  });
  el[domMethod]("touchstart", swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]("pointerdown", swiper.onTouchStart, {
    passive: false
  });
  document2[domMethod]("touchmove", swiper.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("pointermove", swiper.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("touchend", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerup", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointercancel", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("touchcancel", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerout", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerleave", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("contextmenu", swiper.onTouchEnd, {
    passive: true
  });
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]("click", swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]("scroll", swiper.onScroll);
  }
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
  } else {
    swiper[swiperMethod]("observerUpdate", onResize, true);
  }
  el[domMethod]("load", swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, "on");
}
function detachEvents() {
  const swiper = this;
  events(swiper, "off");
}
var events$1 = {
  attachEvents,
  detachEvents
};
const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0) return;
  const document2 = getDocument();
  const breakpointsBase = params.breakpointsBase === "window" || !params.breakpointsBase ? params.breakpointsBase : "container";
  const breakpointContainer = ["window", "container"].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document2.querySelector(params.breakpointsBase);
  const breakpoint = swiper.getBreakpoint(breakpoints2, breakpointsBase, breakpointContainer);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasGrabCursor = swiper.params.grabCursor;
  const isGrabCursor = breakpointParams.grabCursor;
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  if (wasGrabCursor && !isGrabCursor) {
    swiper.unsetGrabCursor();
  } else if (!wasGrabCursor && isGrabCursor) {
    swiper.setGrabCursor();
  }
  ["navigation", "pagination", "scrollbar"].forEach((prop) => {
    if (typeof breakpointParams[prop] === "undefined") return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend$1(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit("_beforeBreakpoint", breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base, containerEl) {
  if (base === void 0) {
    base = "window";
  }
  if (!breakpoints2 || base === "container" && !containerEl) return void 0;
  let breakpoint = false;
  const window2 = getWindow();
  const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints2).map((point) => {
    if (typeof point === "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === "window") {
      if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || "max";
}
var breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries2, prefix) {
  const resultClasses = [];
  entries2.forEach((item) => {
    if (typeof item === "object") {
      Object.keys(item).forEach((classNames) => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === "string") {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  const suffixes = prepareClasses(["initialized", params.direction, {
    "free-mode": swiper.params.freeMode && params.freeMode.enabled
  }, {
    "autoheight": params.autoHeight
  }, {
    "rtl": rtl
  }, {
    "grid": params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    "android": device.android
  }, {
    "ios": device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    "centered": params.cssMode && params.centeredSlides
  }, {
    "watch-progress": params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}
function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  if (!el || typeof el === "string") return;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}
var classes = {
  addClasses,
  removeClasses
};
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? "lock" : "unlock");
  }
}
var checkOverflow$1 = {
  checkOverflow
};
var defaults = {
  init: true,
  direction: "horizontal",
  oneWayMovement: false,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: "swiper",
  enabled: true,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== "object" || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (["pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && "enabled" in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend$1(allModulesParams, obj);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
let Swiper$1 = class Swiper {
  constructor() {
    let el;
    let params;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;
    const document2 = getDocument();
    if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document2.querySelectorAll(params.el).forEach((containerEl) => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    }
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach((mod) => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });
    const swiperParams = extend$1({}, defaults, allModulesParams);
    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params);
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach((eventName) => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === "horizontal";
      },
      isVertical() {
        return swiper.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit("_swiper");
    if (swiper.params.init) {
      swiper.init();
    }
    return swiper;
  }
  getDirectionLabel(property) {
    if (this.isHorizontal()) {
      return property;
    }
    return {
      "width": "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      "marginRight": "marginBottom"
    }[property];
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = elementIndex(slides[0]);
    return elementIndex(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index2) {
    return this.getSlideIndex(this.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === index2));
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit("enable");
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit("disable");
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(" ").filter((className2) => {
      return className2.indexOf("swiper") === 0 || className2.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return "";
    return slideEl.className.split(" ").filter((className2) => {
      return className2.indexOf("swiper-slide") === 0 || className2.indexOf(swiper.params.slideClass) === 0;
    }).join(" ");
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.forEach((slideEl) => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit("_slideClass", slideEl, classNames);
    });
    swiper.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view, exact) {
    if (view === void 0) {
      view = "current";
    }
    if (exact === void 0) {
      exact = false;
    }
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === "number") return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += Math.ceil(slides[i].swiperSlideSize);
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      if (view === "current") {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate2();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate2();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit("update");
  }
  changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
    }
    if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach((slideEl) => {
      if (newDirection === "vertical") {
        slideEl.style.width = "";
      } else {
        slideEl.style.height = "";
      }
    });
    swiper.emit("changeDirection");
    if (needUpdate) swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
    swiper.rtl = direction === "rtl";
    swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "rtl";
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "ltr";
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted) return true;
    let el = element || swiper.params.el;
    if (typeof el === "string") {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        return res;
      }
      return elementChildren(el, getWrapperSelector())[0];
    };
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = createElement("div", swiper.params.wrapperClass);
      el.append(wrapperEl);
      elementChildren(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
      rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
      wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit("beforeInit");
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.addClasses();
    swiper.updateSize();
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }
    if (swiper.params.loop) {
      swiper.loopCreate(void 0, true);
    }
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener("load", (e) => {
          processLazyPreloader(swiper, e.target);
        });
      }
    });
    preload(swiper);
    swiper.initialized = true;
    preload(swiper);
    swiper.emit("init");
    swiper.emit("afterInit");
    return swiper;
  }
  destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }
    if (cleanStyles === void 0) {
      cleanStyles = true;
    }
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === "undefined" || swiper.destroyed) {
      return null;
    }
    swiper.emit("beforeDestroy");
    swiper.initialized = false;
    swiper.detachEvents();
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (cleanStyles) {
      swiper.removeClasses();
      if (el && typeof el !== "string") {
        el.removeAttribute("style");
      }
      if (wrapperEl) {
        wrapperEl.removeAttribute("style");
      }
      if (slides && slides.length) {
        slides.forEach((slideEl) => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute("style");
          slideEl.removeAttribute("data-swiper-slide-index");
        });
      }
    }
    swiper.emit("destroy");
    Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      if (swiper.el && typeof swiper.el !== "string") {
        swiper.el.swiper = null;
      }
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === "function" && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach((m) => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
};
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);
const paramsList = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function isObject(o) {
  return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object" && !o.__swiper__;
}
function extend(target, src2) {
  const noExtend = ["__proto__", "constructor", "prototype"];
  Object.keys(src2).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
    if (typeof target[key] === "undefined") target[key] = src2[key];
    else if (isObject(src2[key]) && isObject(target[key]) && Object.keys(src2[key]).length > 0) {
      if (src2[key].__swiper__) target[key] = src2[key];
      else extend(target[key], src2[key]);
    } else {
      target[key] = src2[key];
    }
  });
}
function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }
  return params.navigation && typeof params.navigation.nextEl === "undefined" && typeof params.navigation.prevEl === "undefined";
}
function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }
  return params.pagination && typeof params.pagination.el === "undefined";
}
function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }
  return params.scrollbar && typeof params.scrollbar.el === "undefined";
}
function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = "";
  }
  const classes2 = classNames.split(" ").map((c) => c.trim()).filter((c) => !!c);
  const unique = [];
  classes2.forEach((c) => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(" ");
}
function wrapperClass(className2) {
  if (className2 === void 0) {
    className2 = "";
  }
  if (!className2) return "swiper-wrapper";
  if (!className2.includes("swiper-wrapper")) return `swiper-wrapper ${className2}`;
  return className2;
}
function updateSwiper(_ref) {
  let {
    swiper,
    slides,
    passedParams,
    changedParams,
    nextEl,
    prevEl,
    scrollbarEl,
    paginationEl
  } = _ref;
  const updateParams = changedParams.filter((key) => key !== "children" && key !== "direction" && key !== "wrapperClass");
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  let loopNeedDestroy;
  let loopNeedEnable;
  let loopNeedReloop;
  if (changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && !passedParams.thumbs.swiper.destroyed && currentParams.thumbs && (!currentParams.thumbs.swiper || currentParams.thumbs.swiper.destroyed)) {
    needThumbsInit = true;
  }
  if (changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = (mod) => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();
    if (mod === "navigation") {
      if (swiper.isElement) {
        swiper[mod].prevEl.remove();
        swiper[mod].nextEl.remove();
      }
      currentParams[mod].prevEl = void 0;
      currentParams[mod].nextEl = void 0;
      swiper[mod].prevEl = void 0;
      swiper[mod].nextEl = void 0;
    } else {
      if (swiper.isElement) {
        swiper[mod].el.remove();
      }
      currentParams[mod].el = void 0;
      swiper[mod].el = void 0;
    }
  };
  if (changedParams.includes("loop") && swiper.isElement) {
    if (currentParams.loop && !passedParams.loop) {
      loopNeedDestroy = true;
    } else if (!currentParams.loop && passedParams.loop) {
      loopNeedEnable = true;
    } else {
      loopNeedReloop = true;
    }
  }
  updateParams.forEach((key) => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      Object.assign(currentParams[key], passedParams[key]);
      if ((key === "navigation" || key === "pagination" || key === "scrollbar") && "enabled" in passedParams[key] && !passedParams[key].enabled) {
        destroyModule(key);
      }
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === "navigation" || key === "pagination" || key === "scrollbar")) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes("controller") && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes("children") && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes("virtual") && virtual && currentParams.virtual.enabled) {
    if (slides) virtual.slides = slides;
    virtual.update(true);
  }
  if (changedParams.includes("children") && slides && currentParams.loop) {
    loopNeedReloop = true;
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (swiper.isElement && (!paginationEl || typeof paginationEl === "string")) {
      paginationEl = document.createElement("div");
      paginationEl.classList.add("swiper-pagination");
      paginationEl.part.add("pagination");
      swiper.el.appendChild(paginationEl);
    }
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === "string")) {
      scrollbarEl = document.createElement("div");
      scrollbarEl.classList.add("swiper-scrollbar");
      scrollbarEl.part.add("scrollbar");
      swiper.el.appendChild(scrollbarEl);
    }
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (swiper.isElement) {
      if (!nextEl || typeof nextEl === "string") {
        nextEl = document.createElement("div");
        nextEl.classList.add("swiper-button-next");
        nextEl.innerHTML = swiper.hostEl.constructor.nextButtonSvg;
        nextEl.part.add("button-next");
        swiper.el.appendChild(nextEl);
      }
      if (!prevEl || typeof prevEl === "string") {
        prevEl = document.createElement("div");
        prevEl.classList.add("swiper-button-prev");
        prevEl.innerHTML = swiper.hostEl.constructor.prevButtonSvg;
        prevEl.part.add("button-prev");
        swiper.el.appendChild(prevEl);
      }
    }
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes("allowSlideNext")) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes("allowSlidePrev")) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes("direction")) {
    swiper.changeDirection(passedParams.direction, false);
  }
  if (loopNeedDestroy || loopNeedReloop) {
    swiper.loopDestroy();
  }
  if (loopNeedEnable || loopNeedReloop) {
    swiper.loopCreate();
  }
  swiper.update();
}
function getParams(obj, splitEvents) {
  if (obj === void 0) {
    obj = {};
  }
  if (splitEvents === void 0) {
    splitEvents = true;
  }
  const params = {
    on: {}
  };
  const events2 = {};
  const passedParams = {};
  extend(params, defaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map((key) => key.replace(/_/, ""));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach((key) => {
    if (typeof obj[key] === "undefined") return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === "function") {
      if (splitEvents) {
        events2[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ["navigation", "pagination", "scrollbar"].forEach((key) => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events: events2
  };
}
function mountSwiper(_ref, swiperParams) {
  let {
    el,
    nextEl,
    prevEl,
    paginationEl,
    scrollbarEl,
    swiper
  } = _ref;
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}
function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;
  const addKey = (key) => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };
  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join("") !== childrenKeys.join("")) addKey("children");
    if (oldChildren.length !== children.length) addKey("children");
  }
  const watchParams = paramsList.filter((key) => key[0] === "_").map((key) => key.replace(/_/, ""));
  watchParams.forEach((key) => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach((newKey) => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach((oldKey) => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}
const updateOnVirtualData = (swiper) => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};
function _extends$d() {
  _extends$d = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$d.apply(this, arguments);
}
function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes("SwiperSlide");
}
function processChildren(c) {
  const slides = [];
  React.Children.toArray(c).forEach((child) => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach((slide2) => slides.push(slide2));
    }
  });
  return slides;
}
function getChildren(c) {
  const slides = [];
  const slots = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  React.Children.toArray(c).forEach((child) => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach((slide2) => slides.push(slide2));
      } else {
        slots["container-end"].push(child);
      }
    } else {
      slots["container-end"].push(child);
    }
  });
  return {
    slides,
    slots
  };
}
function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const getSlideIndex = (index2) => {
    let slideIndex = index2;
    if (index2 < 0) {
      slideIndex = slides.length + index2;
    } else if (slideIndex >= slides.length) {
      slideIndex = slideIndex - slides.length;
    }
    return slideIndex;
  };
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? "right" : "left"]: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  const {
    from,
    to
  } = virtualData;
  const loopFrom = swiper.params.loop ? -slides.length : 0;
  const loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
  const slidesToRender = [];
  for (let i = loopFrom; i < loopTo; i += 1) {
    if (i >= from && i <= to) {
      slidesToRender.push(slides[getSlideIndex(i)]);
    }
  }
  return slidesToRender.map((child, index2) => {
    return /* @__PURE__ */ React.cloneElement(child, {
      swiper,
      style,
      key: child.props.virtualIndex || child.key || `slide-${index2}`
    });
  });
}
function useIsomorphicLayoutEffect(callback, deps) {
  if (typeof window === "undefined") return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}
const SwiperSlideContext = /* @__PURE__ */ createContext(null);
const SwiperContext = /* @__PURE__ */ createContext(null);
const Swiper2 = /* @__PURE__ */ forwardRef(function(_temp, externalElRef) {
  let {
    className: className2,
    tag: Tag2 = "div",
    wrapperTag: WrapperTag = "div",
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = useState("swiper");
  const [virtualData, setVirtualData] = useState(null);
  const [breakpointChanged, setBreakpointChanged] = useState(false);
  const initializedRef = useRef(false);
  const swiperElRef = useRef(null);
  const swiperRef = useRef(null);
  const oldPassedParamsRef = useRef(null);
  const oldSlides = useRef(null);
  const nextElRef = useRef(null);
  const prevElRef = useRef(null);
  const paginationElRef = useRef(null);
  const scrollbarElRef = useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events: events2
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes2) {
      setContainerClasses(classes2);
    }
  });
  const initSwiper = () => {
    Object.assign(swiperParams.on, events2);
    eventsAssigned = true;
    const passParams = {
      ...swiperParams
    };
    delete passParams.wrapperClass;
    swiperRef.current = new Swiper$1(passParams);
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }
  if (swiperRef.current) {
    swiperRef.current.on("_beforeBreakpoint", onBeforeBreakpoint);
  }
  const attachEvents2 = () => {
    if (eventsAssigned || !events2 || !swiperRef.current) return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.on(eventName, events2[eventName]);
    });
  };
  const detachEvents2 = () => {
    if (!events2 || !swiperRef.current) return;
    Object.keys(events2).forEach((eventName) => {
      swiperRef.current.off(eventName, events2[eventName]);
    });
  };
  useEffect(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off("_beforeBreakpoint", onBeforeBreakpoint);
    };
  });
  useEffect(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });
  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current) return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper && !swiperRef.current.destroyed) onSwiper(swiperRef.current);
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);
  useIsomorphicLayoutEffect(() => {
    attachEvents2();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, (c) => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents2();
    };
  });
  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    return slides.map((child, index2) => {
      return /* @__PURE__ */ React.cloneElement(child, {
        swiper: swiperRef.current,
        swiperSlideIndex: index2
      });
    });
  }
  return /* @__PURE__ */ React.createElement(Tag2, _extends$d({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className2 ? ` ${className2}` : ""}`)
  }, restProps), /* @__PURE__ */ React.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots["container-start"], /* @__PURE__ */ React.createElement(WrapperTag, {
    className: wrapperClass(swiperParams.wrapperClass)
  }, slots["wrapper-start"], renderSlides(), slots["wrapper-end"]), needsNavigation(swiperParams) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ React.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /* @__PURE__ */ React.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /* @__PURE__ */ React.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots["container-end"]));
});
Swiper2.displayName = "Swiper";
const SwiperSlide = /* @__PURE__ */ forwardRef(function(_temp, externalRef) {
  let {
    tag: Tag2 = "div",
    children,
    className: className2 = "",
    swiper,
    zoom,
    lazy,
    virtualIndex,
    swiperSlideIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = useRef(null);
  const [slideClasses, setSlideClasses] = useState("swiper-slide");
  const [lazyLoaded, setLazyLoaded] = useState(false);
  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }
  useIsomorphicLayoutEffect(() => {
    if (typeof swiperSlideIndex !== "undefined") {
      slideElRef.current.swiperSlideIndex = swiperSlideIndex;
    }
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== "swiper-slide") {
        setSlideClasses("swiper-slide");
      }
      return;
    }
    swiper.on("_slideClass", updateClasses);
    return () => {
      if (!swiper) return;
      swiper.off("_slideClass", updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf("swiper-slide-active") >= 0,
    isVisible: slideClasses.indexOf("swiper-slide-visible") >= 0,
    isPrev: slideClasses.indexOf("swiper-slide-prev") >= 0,
    isNext: slideClasses.indexOf("swiper-slide-next") >= 0
  };
  const renderChildren = () => {
    return typeof children === "function" ? children(slideData) : children;
  };
  const onLoad2 = () => {
    setLazyLoaded(true);
  };
  return /* @__PURE__ */ React.createElement(Tag2, _extends$d({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className2 ? ` ${className2}` : ""}`),
    "data-swiper-slide-index": virtualIndex,
    onLoad: onLoad2
  }, rest), zoom && /* @__PURE__ */ React.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, /* @__PURE__ */ React.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === "number" ? zoom : void 0
  }, renderChildren(), lazy && !lazyLoaded && /* @__PURE__ */ React.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !zoom && /* @__PURE__ */ React.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, renderChildren(), lazy && !lazyLoaded && /* @__PURE__ */ React.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
SwiperSlide.displayName = "SwiperSlide";
function Keyboard(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const document2 = getDocument();
  const window2 = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });
  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40;
    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }
    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return void 0;
    }
    if (document2.activeElement && document2.activeElement.nodeName && (document2.activeElement.nodeName.toLowerCase() === "input" || document2.activeElement.nodeName.toLowerCase() === "textarea")) {
      return void 0;
    }
    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false;
      if (elementParents(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && elementParents(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) {
        return void 0;
      }
      const el = swiper.el;
      const swiperWidth = el.clientWidth;
      const swiperHeight = el.clientHeight;
      const windowWidth = window2.innerWidth;
      const windowHeight = window2.innerHeight;
      const swiperOffset = elementOffset(el);
      if (rtl) swiperOffset.left -= el.scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];
      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];
        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue;
          inView = true;
        }
      }
      if (!inView) return void 0;
    }
    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
      }
      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
      }
      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }
    emit("keyPress", kc);
    return void 0;
  }
  function enable() {
    if (swiper.keyboard.enabled) return;
    document2.addEventListener("keydown", handle);
    swiper.keyboard.enabled = true;
  }
  function disable() {
    if (!swiper.keyboard.enabled) return;
    document2.removeEventListener("keydown", handle);
    swiper.keyboard.enabled = false;
  }
  on("init", () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on("destroy", () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach((key) => {
      if (!params[key] && params.auto === true) {
        let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = createElement("div", checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}
function Navigation$1(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  });
  swiper.navigation = {
    nextEl: null,
    prevEl: null
  };
  function getEl(el) {
    let res;
    if (el && typeof el === "string" && swiper.isElement) {
      res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
      if (res) return res;
    }
    if (el) {
      if (typeof el === "string") res = [...document.querySelectorAll(el)];
      if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
        res = swiper.el.querySelector(el);
      } else if (res && res.length === 1) {
        res = res[0];
      }
    }
    if (el && !res) return el;
    return res;
  }
  function toggleEl(el, disabled) {
    const params = swiper.params.navigation;
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      if (subEl) {
        subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
        if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        }
      }
    });
  }
  function update2() {
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (swiper.params.loop) {
      toggleEl(prevEl, false);
      toggleEl(nextEl, false);
      return;
    }
    toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit("navigationPrev");
  }
  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit("navigationNext");
  }
  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    });
    if (!(params.nextEl || params.prevEl)) return;
    let nextEl = getEl(params.nextEl);
    let prevEl = getEl(params.prevEl);
    Object.assign(swiper.navigation, {
      nextEl,
      prevEl
    });
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const initButton = (el, dir) => {
      if (el) {
        el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
      }
      if (!swiper.enabled && el) {
        el.classList.add(...params.lockClass.split(" "));
      }
    };
    nextEl.forEach((el) => initButton(el, "next"));
    prevEl.forEach((el) => initButton(el, "prev"));
  }
  function destroy() {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const destroyButton = (el, dir) => {
      el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
      el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
    };
    nextEl.forEach((el) => destroyButton(el, "next"));
    prevEl.forEach((el) => destroyButton(el, "prev"));
  }
  on("init", () => {
    if (swiper.params.navigation.enabled === false) {
      disable();
    } else {
      init();
      update2();
    }
  });
  on("toEdge fromEdge lock unlock", () => {
    update2();
  });
  on("destroy", () => {
    destroy();
  });
  on("enable disable", () => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (swiper.enabled) {
      update2();
      return;
    }
    [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.add(swiper.params.navigation.lockClass));
  });
  on("click", (_s, e) => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const targetEl = e.target;
    let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
    if (swiper.isElement && !targetIsButton) {
      const path = e.path || e.composedPath && e.composedPath();
      if (path) {
        targetIsButton = path.find((pathEl) => nextEl.includes(pathEl) || prevEl.includes(pathEl));
      }
    }
    if (swiper.params.navigation.hideOnClick && !targetIsButton) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;
      if (nextEl.length) {
        isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      } else if (prevEl.length) {
        isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit("navigationShow");
      } else {
        emit("navigationHide");
      }
      [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.toggle(swiper.params.navigation.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
    init();
    update2();
  };
  const disable = () => {
    swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update: update2,
    init,
    destroy
  });
}
function classesToSelector(classes2) {
  if (classes2 === void 0) {
    classes2 = "";
  }
  return `.${classes2.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Pagination(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const pfx = "swiper-pagination";
  extendParams({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: (number) => number,
      formatFractionTotal: (number) => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl) return;
    bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function getMoveDirection(prevIndex, nextIndex, length) {
    prevIndex = prevIndex % length;
    nextIndex = nextIndex % length;
    if (nextIndex === prevIndex + 1) {
      return "next";
    } else if (nextIndex === prevIndex - 1) {
      return "previous";
    }
    return;
  }
  function onBulletClick(e) {
    const bulletEl = e.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e.preventDefault();
    const index2 = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index2) return;
      const moveDirection = getMoveDirection(swiper.realIndex, index2, swiper.slides.length);
      if (moveDirection === "next") {
        swiper.slideNext();
      } else if (moveDirection === "previous") {
        swiper.slidePrev();
      } else {
        swiper.slideToLoop(index2);
      }
    } else {
      swiper.slideTo(index2);
    }
  }
  function update2() {
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== "undefined") {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? "width" : "height");
        el.forEach((subEl) => {
          subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== void 0) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach((bulletEl) => {
        const classesToRemove = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`)].map((s) => typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach((bullet) => {
          const bulletIndex = elementIndex(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(" "));
          } else if (swiper.isElement) {
            bullet.setAttribute("part", "bullet");
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, "prev");
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, "next");
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(" "));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            if (bullets[i]) {
              bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
            }
          }
          setSideBullets(firstDisplayedBullet, "prev");
          setSideBullets(lastDisplayedBullet, "next");
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? "right" : "left";
        bullets.forEach((bullet) => {
          bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === "fraction") {
        subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach((fractionEl) => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach((totalEl) => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === "progressbar") {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
        } else {
          progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === "horizontal") {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach((progressEl) => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === "custom" && params.renderCustom) {
        subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
        if (subElIndex === 0) emit("paginationRender", subEl);
      } else {
        if (subElIndex === 0) emit("paginationRender", subEl);
        emit("paginationUpdate", subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
      }
    });
  }
  function render() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let paginationHTML = "";
    if (params.type === "bullets") {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === "fraction") {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === "progressbar") {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach((subEl) => {
      if (params.type !== "custom") {
        subEl.innerHTML = paginationHTML || "";
      }
      if (params.type === "bullets") {
        swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
      }
    });
    if (params.type !== "custom") {
      emit("paginationRender", el[0]);
    }
  }
  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: "swiper-pagination"
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let el;
    if (typeof params.el === "string" && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === "string") {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      if (el.length > 1) {
        el = el.find((subEl) => {
          if (elementParents(subEl, ".swiper")[0] !== swiper.el) return false;
          return true;
        });
      }
    }
    if (Array.isArray(el) && el.length === 1) el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      if (params.type === "bullets" && params.clickable) {
        subEl.classList.add(...(params.clickableClass || "").split(" "));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === "bullets" && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === "progressbar" && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener("click", onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || "").split(" "));
          subEl.removeEventListener("click", onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl) => subEl.classList.remove(...params.bulletActiveClass.split(" ")));
  }
  on("changeDirection", () => {
    if (!swiper.pagination || !swiper.pagination.el) return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on("init", () => {
    if (swiper.params.pagination.enabled === false) {
      disable();
    } else {
      init();
      render();
      update2();
    }
  });
  on("activeIndexChange", () => {
    if (typeof swiper.snapIndex === "undefined") {
      update2();
    }
  });
  on("snapIndexChange", () => {
    update2();
  });
  on("snapGridLengthChange", () => {
    render();
    update2();
  });
  on("destroy", () => {
    destroy();
  });
  on("enable disable", () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
    }
  });
  on("lock unlock", () => {
    update2();
  });
  on("click", (_s, e) => {
    const targetEl = e.target;
    const el = makeElementsArray(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit("paginationShow");
      } else {
        emit("paginationHide");
      }
      el.forEach((subEl) => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init();
    render();
    update2();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update: update2,
    init,
    destroy
  });
}
function A11y(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: true
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;
  let preventFocusHandler;
  let focusTargetSlideEl;
  let visibilityChangedTimestamp = (/* @__PURE__ */ new Date()).getTime();
  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.innerHTML = "";
    notification.innerHTML = message;
  }
  function getRandomNumber(size) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(size).replace(/x/g, randomChar);
  }
  function makeElFocusable(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("tabIndex", "0");
    });
  }
  function makeElNotFocusable(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("tabIndex", "-1");
    });
  }
  function addElRole(el, role) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("role", role);
    });
  }
  function addElRoleDescription(el, description) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-roledescription", description);
    });
  }
  function addElControls(el, controls) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-controls", controls);
    });
  }
  function addElLabel(el, label) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-label", label);
    });
  }
  function addElId(el, id) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("id", id);
    });
  }
  function addElLive(el, live) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-live", live);
    });
  }
  function disableEl(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-disabled", true);
    });
  }
  function enableEl(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-disabled", false);
    });
  }
  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const targetEl = e.target;
    if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
      if (!e.target.matches(classesToSelector(swiper.params.pagination.bulletClass))) return;
    }
    if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
      const prevEls = makeElementsArray(swiper.navigation.prevEl);
      const nextEls = makeElementsArray(swiper.navigation.nextEl);
      if (nextEls.includes(targetEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          notify(params.lastSlideMessage);
        } else {
          notify(params.nextSlideMessage);
        }
      }
      if (prevEls.includes(targetEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          notify(params.firstSlideMessage);
        } else {
          notify(params.prevSlideMessage);
        }
      }
    }
    if (swiper.pagination && targetEl.matches(classesToSelector(swiper.params.pagination.bulletClass))) {
      targetEl.click();
    }
  }
  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (prevEl) {
      if (swiper.isBeginning) {
        disableEl(prevEl);
        makeElNotFocusable(prevEl);
      } else {
        enableEl(prevEl);
        makeElFocusable(prevEl);
      }
    }
    if (nextEl) {
      if (swiper.isEnd) {
        disableEl(nextEl);
        makeElNotFocusable(nextEl);
      } else {
        enableEl(nextEl);
        makeElFocusable(nextEl);
      }
    }
  }
  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }
  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }
  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.forEach((bulletEl) => {
      if (swiper.params.pagination.clickable) {
        makeElFocusable(bulletEl);
        if (!swiper.params.pagination.renderBullet) {
          addElRole(bulletEl, "button");
          addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, elementIndex(bulletEl) + 1));
        }
      }
      if (bulletEl.matches(classesToSelector(swiper.params.pagination.bulletActiveClass))) {
        bulletEl.setAttribute("aria-current", "true");
      } else {
        bulletEl.removeAttribute("aria-current");
      }
    });
  }
  const initNavEl = (el, wrapperId, message) => {
    makeElFocusable(el);
    if (el.tagName !== "BUTTON") {
      addElRole(el, "button");
      el.addEventListener("keydown", onEnterOrSpaceKey);
    }
    addElLabel(el, message);
    addElControls(el, wrapperId);
  };
  const handlePointerDown = (e) => {
    if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) {
      preventFocusHandler = true;
    }
    swiper.a11y.clicked = true;
  };
  const handlePointerUp = () => {
    preventFocusHandler = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };
  const onVisibilityChange = (e) => {
    visibilityChangedTimestamp = (/* @__PURE__ */ new Date()).getTime();
  };
  const handleFocus = (e) => {
    if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
    if ((/* @__PURE__ */ new Date()).getTime() - visibilityChangedTimestamp < 100) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    focusTargetSlideEl = slideEl;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }
    requestAnimationFrame(() => {
      if (preventFocusHandler) return;
      if (swiper.params.loop) {
        swiper.slideToLoop(parseInt(slideEl.getAttribute("data-swiper-slide-index")), 0);
      } else {
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
      }
      preventFocusHandler = false;
    });
  };
  const initSlides = () => {
    const params = swiper.params.a11y;
    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
    }
    if (params.slideRole) {
      addElRole(swiper.slides, params.slideRole);
    }
    const slidesLength = swiper.slides.length;
    if (params.slideLabelMessage) {
      swiper.slides.forEach((slideEl, index2) => {
        const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index2;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel(slideEl, ariaLabelMessage);
      });
    }
  };
  const init = () => {
    const params = swiper.params.a11y;
    swiper.el.append(liveRegion);
    const containerEl = swiper.el;
    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
    }
    if (params.containerMessage) {
      addElLabel(containerEl, params.containerMessage);
    }
    if (params.containerRole) {
      addElRole(containerEl, params.containerRole);
    }
    const wrapperEl = swiper.wrapperEl;
    const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
    addElId(wrapperEl, wrapperId);
    addElLive(wrapperEl, live);
    initSlides();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach((el) => initNavEl(el, wrapperId, params.nextSlideMessage));
    }
    if (prevEl) {
      prevEl.forEach((el) => initNavEl(el, wrapperId, params.prevSlideMessage));
    }
    if (hasClickablePagination()) {
      const paginationEl = makeElementsArray(swiper.pagination.el);
      paginationEl.forEach((el) => {
        el.addEventListener("keydown", onEnterOrSpaceKey);
      });
    }
    const document2 = getDocument();
    document2.addEventListener("visibilitychange", onVisibilityChange);
    swiper.el.addEventListener("focus", handleFocus, true);
    swiper.el.addEventListener("focus", handleFocus, true);
    swiper.el.addEventListener("pointerdown", handlePointerDown, true);
    swiper.el.addEventListener("pointerup", handlePointerUp, true);
  };
  function destroy() {
    if (liveRegion) liveRegion.remove();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach((el) => el.removeEventListener("keydown", onEnterOrSpaceKey));
    }
    if (prevEl) {
      prevEl.forEach((el) => el.removeEventListener("keydown", onEnterOrSpaceKey));
    }
    if (hasClickablePagination()) {
      const paginationEl = makeElementsArray(swiper.pagination.el);
      paginationEl.forEach((el) => {
        el.removeEventListener("keydown", onEnterOrSpaceKey);
      });
    }
    const document2 = getDocument();
    document2.removeEventListener("visibilitychange", onVisibilityChange);
    if (swiper.el && typeof swiper.el !== "string") {
      swiper.el.removeEventListener("focus", handleFocus, true);
      swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
      swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
  }
  on("beforeInit", () => {
    liveRegion = createElement("span", swiper.params.a11y.notificationClass);
    liveRegion.setAttribute("aria-live", "assertive");
    liveRegion.setAttribute("aria-atomic", "true");
  });
  on("afterInit", () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on("fromEdge toEdge afterInit lock unlock", () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on("paginationUpdate", () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on("destroy", () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}
const CarouselSwiper = (props) => {
  var _a, _b, _c, _d;
  const {
    carouselList,
    path,
    a11yCarouselNextLabel,
    a11yCarouselPreviousLabel,
    breakpointSettings,
    carouselClassName = "",
    sliderRef,
    dynamicBullet,
    arrowBottom,
    infiniteScrolling,
    centerInsufficientSlides,
    carouselCallbackHandler
  } = props;
  const { mobileMinWidth, tabletPortrait, tabletMaxWidth, desktopLarg } = BREAKPOINTS;
  const uniqueId = (Math.random() + 1).toString(36).substring(7);
  const breakpointSpacing = (breakpointKey) => {
    let spacing;
    if (breakpointSettings[breakpointKey].spacing) {
      spacing = breakpointSettings[breakpointKey].spacing;
    }
    return spacing || carouselSettings.cardSpacing;
  };
  const settings = {
    slidesPerView: breakpointSettings.xs.slidesToShow,
    slidesPerGroup: breakpointSettings.xs.slidesPerGroup,
    centerInsufficientSlides: centerInsufficientSlides ?? true,
    spaceBetween: breakpointSpacing(Size.XS),
    pagination: {
      clickable: true,
      dynamicBullets: dynamicBullet.show,
      dynamicMainBullets: dynamicBullet.count
    },
    navigation: {
      nextEl: `.${PREFIX}-carousel-swiper--next--${uniqueId}`,
      prevEl: `.${PREFIX}-carousel-swiper--prev--${uniqueId}`,
      disabledClass: carouselSettings.disabledClass
    },
    keyboard: {
      enabled: true
    },
    loop: infiniteScrolling || false,
    breakpoints: {
      // 375 - 767
      [mobileMinWidth]: {
        slidesPerView: breakpointSettings.xs.slidesToShow,
        slidesPerGroup: breakpointSettings.xs.slidesPerGroup,
        spaceBetween: breakpointSpacing(Size.XS)
      },
      // 768 - 1279
      [tabletPortrait]: {
        slidesPerView: breakpointSettings.sm.slidesToShow,
        slidesPerGroup: breakpointSettings.sm.slidesPerGroup,
        spaceBetween: breakpointSpacing(Size.SMALL)
      },
      // 1280 - 2559
      [tabletMaxWidth + 1]: {
        slidesPerView: breakpointSettings.md.slidesToShow,
        slidesPerGroup: breakpointSettings.md.slidesPerGroup,
        spaceBetween: breakpointSpacing(Size.MEDIUM)
      },
      // 2560 and above
      [desktopLarg]: {
        slidesPerView: breakpointSettings.lg.slidesToShow,
        slidesPerGroup: breakpointSettings.lg.slidesPerGroup,
        spaceBetween: breakpointSpacing(Size.LARGE)
      }
    },
    /**
     * callback function after swiper initialization
     */
    onAfterInit: () => {
      carouselCallbackHandler && setTimeout(carouselCallbackHandler);
    },
    modules: [Pagination, Navigation$1, Keyboard, A11y]
  };
  const classChevronArrow = arrowBottom ? `${PREFIX}-carousel-swiper__arrowBottom` : "";
  const [swiperInstance, setSwiperInstance] = useState();
  useEffect(() => {
    var _a2;
    if (swiperInstance) {
      (_a2 = swiperInstance == null ? void 0 : swiperInstance.wrapperEl) == null ? void 0 : _a2.removeAttribute("aria-live");
    }
  }, [swiperInstance]);
  return /* @__PURE__ */ jsxs("div", { className: `${carouselClassName} ${PREFIX}-carousel-swiper ${classChevronArrow}`, children: [
    /* @__PURE__ */ jsx(Swiper2, { ...settings, ref: sliderRef, onSwiper: setSwiperInstance, children: carouselList.map((item, index2) => /* @__PURE__ */ jsx(SwiperSlide, { children: item }, index2)) }),
    /* @__PURE__ */ jsx(
      CarouselNavigationArrow,
      {
        ariaLabel: a11yCarouselNextLabel,
        className: `${PREFIX}-carousel-swiper--next ${PREFIX}-carousel-swiper--next--${uniqueId} ${((_b = (_a = sliderRef == null ? void 0 : sliderRef.current) == null ? void 0 : _a.swiper) == null ? void 0 : _b.isEnd) ? carouselSettings.disabledClass : ""}`,
        type: "ct-chevron-right",
        size: "md",
        path
      }
    ),
    /* @__PURE__ */ jsx(
      CarouselNavigationArrow,
      {
        ariaLabel: a11yCarouselPreviousLabel,
        className: `${PREFIX}-carousel-swiper--prev ${PREFIX}-carousel-swiper--prev--${uniqueId} ${((_d = (_c = sliderRef == null ? void 0 : sliderRef.current) == null ? void 0 : _c.swiper) == null ? void 0 : _d.isBeginning) ? carouselSettings.disabledClass : ""}`,
        type: "ct-chevron-left",
        size: "md",
        path
      }
    )
  ] });
};
const ProductListingAd = (props) => {
  const { carouselList, breakpointSettings, infiniteScrolling, centerInsufficientSlides, dynamicBullet, sliderRef } = props;
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product__list-view`, children: /* @__PURE__ */ jsx(
    CarouselSwiper,
    {
      carouselList,
      breakpointSettings,
      centerInsufficientSlides,
      spacing: carouselSettings.cardSpacing,
      dynamicBullet,
      infiniteScrolling,
      sliderRef
    }
  ) });
};
ProductListingAd.propTypes = {
  carouselList: PropTypes.array
};
const renderClearanceBadge = (badges, enableBadges) => {
  if (!enableBadges) {
    return [];
  }
  const hasSaleClearanceBadge = badges == null ? void 0 : badges.filter(
    (item) => item.includes("CLEARANCE") || item.includes("PROMO") || item.includes("SALE")
  );
  if (((hasSaleClearanceBadge == null ? void 0 : hasSaleClearanceBadge.includes("PROMO")) || (hasSaleClearanceBadge == null ? void 0 : hasSaleClearanceBadge.includes("SALE"))) && (hasSaleClearanceBadge == null ? void 0 : hasSaleClearanceBadge.includes("CLEARANCE"))) {
    return [hasSaleClearanceBadge[0]];
  }
  return hasSaleClearanceBadge || [];
};
const Recommendations$1 = (props) => {
  const {
    title,
    productList,
    path,
    priceProps,
    productCardClick,
    carouselCallbackHandler,
    maximumNumberOfRecommendations,
    a11yCarouselPreviousLabel,
    a11yCarouselNextLabel,
    a11yStrikeOutPrice,
    a11yStrikeOutPriceRange,
    badgePriorities,
    language: language2,
    imageDataComponentName,
    enableBadges,
    enableSaveStory,
    returnPolicy,
    a11yClickToReadFootnote,
    selectedSchemaId,
    sliderRef,
    a11yCloseIconLabel,
    a11yTooltipIcon,
    enableBoldedBrandName = false,
    plaBreakpointSettings,
    plaInfiniteScrolling,
    plaCenterInsufficientSlides,
    plaDynamicBullet,
    breakpointSettings,
    centerInsufficientSlides,
    infiniteScrolling,
    dynamicBullet,
    enableAddToCartOptions,
    addButton,
    optionsButton,
    clickedATCCardIdx,
    addToCartBtnClick,
    showAtcBtnSpinner,
    addToCartLabel,
    quickLookLabel,
    enableATCForSingleSkuMiniPdp,
    isPriceRangeViewEnabled = false,
    isInBuyBox
  } = props;
  const {
    unitPriceLabel,
    clearancePriceLabel,
    promotionalPriceLabel,
    threshold,
    nowFromLabel,
    saveFromLabel,
    wasFromLabel,
    fromLabel
  } = priceProps;
  const productProps = {
    ratingsAndReview: true,
    featureHeaderLabel: "",
    variantAvailableMsg: "",
    moreLabel: "",
    unitPriceLabel,
    clearancePriceLabel,
    promotionalPriceLabel,
    thresholdValue: threshold,
    nowFromLabel,
    saveFromLabel,
    wasFromLabel,
    fromLabel,
    enableAddToCartOptions,
    addButton,
    optionsButton
  };
  const getProductCarouselList = () => {
    return productList.slice(0, maximumNumberOfRecommendations).map((product, index2) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
      const {
        type,
        title: productTitle,
        brand,
        images,
        rating,
        ratingsCount,
        timeTestedPrice,
        priceShortMessage,
        priceLongMessage,
        longDescription,
        featureBullets,
        onlineOnly,
        discount,
        badges,
        currentPrice,
        feeMessages,
        url,
        code,
        isOnSale,
        originalPrice
      } = product;
      const pageType = getPageType();
      const urlParams = {
        rrecName: title,
        rrecReferrer: pageType,
        rrecProductId: code,
        rrecProductSlot: index2 + magicNumber.ONE,
        rrecSchemeId: selectedSchemaId,
        rrec: true
      };
      const showUpdatedATCSpinner = (idx) => {
        return clickedATCCardIdx === idx ? showAtcBtnSpinner : false;
      };
      return /* @__PURE__ */ jsx(
        ProductCard,
        {
          isInBuyBox,
          originalPrice: isInBuyBox && originalPrice,
          isPriceRangeViewEnabled,
          product,
          url: appendQueryParamsToUrl(url, urlParams),
          productProps,
          path,
          idx: index2,
          cardType: "grid",
          title: productTitle,
          type,
          code: null,
          brand,
          images,
          rating,
          ratingsCount: ratingsCount || 0,
          timeTestedPrice,
          discount,
          priceShortMessage,
          priceLongMessage,
          longDescription,
          featureBullets,
          onlineOnly,
          productCardClick: (event, productdata, idx) => productCardClick(event, productdata, idx),
          a11yStrikeOutPrice,
          a11yStrikeOutPriceRange,
          showRatingSection: true,
          badges: renderClearanceBadge(badges, enableBadges),
          badgePriorities,
          language: language2,
          feeTitle: ((_a = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _a.value) ? replaceStrWithDynamicVal(
            addDynamicToken((_b = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _b.feeTitle, "$x"),
            getFormattedPriceValue(language2, (_c = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _c.value)
          ) : "",
          feeDisclaimerType: (_d = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _d.type,
          feeDisclaimerMessage: (_e = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _e.feeDisclaimerMessage,
          feeDisclaimerTitle: (_f = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _f.feeDisclaimerTitle,
          currentPrice,
          nowFromLabel,
          saveFromLabel,
          wasFromLabel,
          fromLabel,
          imageDataComponentName,
          returnPolicy,
          unitPriceLabel,
          promotionalPriceLabel,
          clearancePriceLabel,
          thresholdValue: threshold,
          enableSaveStory,
          productDataId: code,
          a11yClickToReadFootnote,
          accessibilityId: getAccessibilityId(
            selectedSchemaId,
            ((_h = (_g = product == null ? void 0 : product.skus) == null ? void 0 : _g[0]) == null ? void 0 : _h.code) ? (_j = (_i = product == null ? void 0 : product.skus) == null ? void 0 : _i[0]) == null ? void 0 : _j.code : code
          ),
          a11yCloseIconLabel,
          a11yTooltipIcon,
          boldBrand: enableBoldedBrandName,
          isOnSale,
          enableBadges,
          showSaleClearanceBadge: true,
          swiperLazyLoading: true,
          addToCartBtnClick,
          showAtcBtnSpinner: showUpdatedATCSpinner(index2),
          addToCartLabel,
          quickLookLabel,
          enableATCForSingleSkuMiniPdp
        },
        index2
      );
    });
  };
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-recommendations`, children: [
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-recommendations__title`, "data-testid": "recommendations-title", children: /* @__PURE__ */ jsx("h2", { children: title }) }),
    productList && productList.length > 0 && (plaCarouselSchemaId.includes(selectedSchemaId) ? /* @__PURE__ */ jsx(
      ProductListingAd,
      {
        carouselList: getProductCarouselList(),
        breakpointSettings: plaBreakpointSettings,
        infiniteScrolling: plaInfiniteScrolling,
        centerInsufficientSlides: plaCenterInsufficientSlides,
        dynamicBullet: plaDynamicBullet,
        sliderRef
      }
    ) : /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product__grid-view`, children: /* @__PURE__ */ jsx(
      CarouselSwiper,
      {
        carouselList: getProductCarouselList(),
        carouselCallbackHandler,
        sliderRef,
        a11yCarouselPreviousLabel,
        a11yCarouselNextLabel,
        breakpointSettings,
        centerInsufficientSlides,
        infiniteScrolling,
        dynamicBullet
      }
    ) }))
  ] });
};
Recommendations$1.propTypes = {
  title: PropTypes.string,
  productList: PropTypes.array,
  path: PropTypes.string,
  priceProps: PropTypes.object,
  productCardClick: PropTypes.func,
  maximumNumberOfRecommendations: PropTypes.number,
  a11yCarouselPreviousLabel: PropTypes.string,
  a11yCarouselNextLabel: PropTypes.string,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  language: PropTypes.string.isRequired,
  imageDataComponentName: PropTypes.string,
  enableBadges: PropTypes.bool,
  enableSaveStory: PropTypes.bool,
  returnPolicy: PropTypes.func,
  a11yClickToReadFootnote: PropTypes.string,
  selectedSchemaId: PropTypes.string,
  a11yCloseIconLabel: PropTypes.string,
  a11yTooltipIcon: PropTypes.string
};
Recommendations$1.displayName = "Recommendations";
const featureProductListConst = "featured-product-lists";
const FeaturedProductList$1 = ({
  aemProps,
  productList,
  badgePriorities,
  a11yStrikeOutPrice,
  a11yStrikeOutPriceRange,
  language: language2,
  title,
  maxRecommendations,
  priceProps,
  productCardClickHandler,
  imageDataComponentName,
  returnPolicy,
  a11yClickToReadFootnote,
  enableBoldedBrandName = false,
  addToCartBtnClick,
  clickedATCCardIdx,
  showAtcBtnSpinner
}) => {
  const {
    unitPriceLabel,
    clearancePriceLabel,
    promotionalPriceLabel,
    threshold,
    nowFromLabel,
    saveFromLabel,
    wasFromLabel,
    fromLabel
  } = priceProps;
  const productProps = {
    ratingsAndReview: aemProps.enableRatingAndReviewInfo,
    featureHeaderLabel: "",
    variantAvailableMsg: "",
    moreLabel: "",
    navigateTo: "",
    unitPriceLabel,
    clearancePriceLabel,
    promotionalPriceLabel,
    thresholdValue: threshold,
    nowFromLabel,
    saveFromLabel,
    wasFromLabel,
    fromLabel,
    addButton: aemProps.ctaProps.addButton,
    optionsButton: aemProps.ctaProps.optionsButton,
    enableAddToCartOptions: aemProps.ctaProps.enableAddToCartOptions
  };
  const carouselRef = useRef(null);
  const cardClickHandler = (event, productData, idx) => {
    event.preventDefault();
    event.stopPropagation();
    productCardClickHandler == null ? void 0 : productCardClickHandler(idx);
    window.open(productData.url, aemProps.linkTarget || "_self", "noopener");
  };
  const showUpdatedATCSpinner = (idx) => {
    return typeof clickedATCCardIdx === "number" && clickedATCCardIdx === idx ? !!showAtcBtnSpinner : false;
  };
  const productCards = () => {
    return productList.slice(0, maxRecommendations).map((productData, i) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
      const {
        title: productTitle,
        brand,
        code,
        discount,
        onlineOnly,
        priceShortMessage,
        priceLongMessage,
        longDescription,
        salePrice,
        badges: productBadges,
        rating,
        ratingsCount,
        images,
        currentPrice,
        originalPrice,
        priceMessage,
        displayWasLabel,
        feeMessages,
        url
      } = productData;
      const sPrice = aemProps.enableSaveStory ? salePrice : null;
      const badges = aemProps.enableBadges ? productBadges : [];
      const aemImage = aemProps.products && isArrayNotEmpty(aemProps.products) && ((_b = (_a = aemProps == null ? void 0 : aemProps.products) == null ? void 0 : _a.find((singleDetail) => singleDetail.skuId === code)) == null ? void 0 : _b.productImage);
      const hybrisImageData = isArrayNotEmpty(images) && images[0];
      const finalImages = !!aemImage ? [
        {
          ...hybrisImageData,
          url: aemImage
        }
      ] : images;
      return /* @__PURE__ */ jsx(
        ProductCard,
        {
          product: productData,
          badgePriorities,
          brand,
          cardType: "grid",
          url,
          code: ((_c = productData == null ? void 0 : productData.skus) == null ? void 0 : _c.length) === magicNumber.ONE ? (_e = (_d = productData == null ? void 0 : productData.skus) == null ? void 0 : _d[0]) == null ? void 0 : _e.formattedCode : "",
          idx: i,
          images: finalImages,
          showRatingSection: true,
          rating,
          salePrice: sPrice,
          productProps,
          ratingsCount,
          title: productTitle,
          badges,
          hideDisclaimer: true,
          priceShortMessage,
          priceLongMessage,
          longDescription,
          discount,
          onlineOnly,
          productCardClick: (event, product, idx) => cardClickHandler(event, product, idx),
          hideDescription: aemProps.disableProductDescription,
          hideSaveLabel: !aemProps.enableSaveStory,
          a11yStrikeOutPrice,
          a11yStrikeOutPriceRange,
          language: language2,
          feeTitle: ((_f = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _f.value) ? replaceStrWithDynamicVal(
            addDynamicToken((_g = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _g.feeTitle, "$x"),
            getFormattedPriceValue(language2, (_h = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _h.value)
          ) : "",
          feeDisclaimerType: (_i = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _i.type,
          feeDisclaimerMessage: (_j = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _j.feeDisclaimerMessage,
          feeDisclaimerTitle: (_k = feeMessages == null ? void 0 : feeMessages[0]) == null ? void 0 : _k.feeDisclaimerTitle,
          currentPrice,
          originalPrice,
          priceMessage,
          nowFromLabel,
          saveFromLabel,
          wasFromLabel,
          fromLabel,
          displayWasLabel,
          unitPriceLabel,
          promotionalPriceLabel,
          clearancePriceLabel,
          thresholdValue: threshold,
          imageDataComponentName,
          returnPolicy,
          productDataId: code,
          addToCartBtnClick,
          showAtcBtnSpinner: showUpdatedATCSpinner(i),
          a11yClickToReadFootnote,
          accessibilityId: getAccessibilityId(
            featureProductListConst,
            ((_l = productData == null ? void 0 : productData.skus) == null ? void 0 : _l[0].code) ? (_m = productData == null ? void 0 : productData.skus) == null ? void 0 : _m[0].code : code
          ),
          boldBrand: enableBoldedBrandName
        },
        i
      );
    });
  };
  const breakpointSettings = {
    xs: {
      slidesToShow: 2.2,
      slidesPerGroup: 2,
      spacing: 12
    },
    sm: {
      slidesToShow: 4.2,
      slidesPerGroup: 4,
      spacing: 12
    },
    md: {
      slidesToShow: 5,
      slidesPerGroup: 5
    },
    lg: {
      slidesToShow: 7,
      slidesPerGroup: 7
    }
  };
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-featured-product-list ${PREFIX}-container`, children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-col-md-12 ${PREFIX}-col-sm-12 ${PREFIX}-col-xs-6`, children: [
    /* @__PURE__ */ jsx("h2", { className: `${PREFIX}-featured-product-list__title`, "data-testid": "featured-product-title", children: aemProps.title || title }),
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-product__grid-view`, children: /* @__PURE__ */ jsx(
      CarouselSwiper,
      {
        sliderRef: carouselRef,
        carouselList: productCards(),
        carouselClassName: "carousel-authored",
        a11yCarouselNextLabel: aemProps.a11yCarouselNextLabel,
        a11yCarouselPreviousLabel: aemProps.a11yCarouselPreviousLabel,
        title: aemProps.title || title,
        breakpointSettings,
        centerInsufficientSlides: false,
        infiniteScrolling: false,
        dynamicBullet: { show: true, count: 3 }
      }
    ) })
  ] }) });
};
const ActivationMessage = (props) => {
  const {
    ClassName,
    selectedCard,
    title,
    details,
    isCardVisible,
    messages,
    shopNowCtaA11yLabel,
    shopNowCtaLabel,
    shopNowCtaLink,
    shopNowCtaLinkTarget,
    weeklyOffersCtaLabel,
    weeklyOffersCtaLink,
    weeklyOffersCtaLinkTarget,
    weeklyOffersCtaA11yLabel,
    isLoyaltyIdInvalid,
    selectedOfferArray,
    openModal,
    a11yLabelForOfferDetails
  } = props;
  const activationOfferDetails = () => {
    if (isCardVisible) {
      const { daysLeft, shortDesc, offerEndDate } = selectedCard;
      const message = daysLeft === String(magicNumber.ZERO) ? messages == null ? void 0 : messages.staticMessage : replaceStrWithDynamicVal(messages == null ? void 0 : messages.dynamicMessage, daysLeft);
      const updatedMessage = Number(daysLeft) > magicNumber.SEVEN ? `${(messages == null ? void 0 : messages.dynamicMessageWithDate) || "Offer Ends:"} ${offerEndDate == null ? void 0 : offerEndDate.replace(
        offerEndDateRegex,
        "$1/$2/$3"
      )}` : message;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx("p", { className: `${ClassName}_activation-message_description`, children: shortDesc }),
        /* @__PURE__ */ jsx("p", { className: `${ClassName}_activation-message_offer-duration`, children: updatedMessage })
      ] });
    } else {
      return null;
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${ClassName}_activation-message ${isCardVisible ? "" : `${ClassName}_activation-message-without-offer`}`,
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            onClick: (e) => openModal(selectedOfferArray[0], e),
            onKeyDown: (e) => {
              if (e.key === stringKeyCodes.space || e.key === stringKeyCodes.enter) {
                e.preventDefault();
                openModal(selectedOfferArray[0], e);
              }
            },
            role: "button",
            tabIndex: 0,
            children: [
              /* @__PURE__ */ jsxs("div", { className: `${ClassName}_activation-message_title`, children: [
                /* @__PURE__ */ jsx("h1", { className: `${ClassName}_activation-message_title__item`, children: title }),
                activationOfferDetails()
              ] }),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: `${ClassName}_activation-message_details`,
                  dangerouslySetInnerHTML: { __html: details }
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "sr-only", children: a11yLabelForOfferDetails })
            ]
          }
        ),
        isCardVisible && /* @__PURE__ */ jsx("div", { className: `${ClassName}_button`, children: /* @__PURE__ */ jsx(
          "a",
          {
            "aria-label": shopNowCtaA11yLabel,
            className: `${PREFIX}-button2 ${PREFIX}-button2--mini ${PREFIX}-button2--primary ${PREFIX}-button2--primary-dark`,
            href: shopNowCtaLink,
            target: shopNowCtaLinkTarget,
            children: shopNowCtaLabel
          }
        ) }),
        isLoyaltyIdInvalid && /* @__PURE__ */ jsx("div", { className: `${ClassName}_button`, children: /* @__PURE__ */ jsx(
          "a",
          {
            "aria-label": weeklyOffersCtaA11yLabel,
            className: `${PREFIX}-button2 ${PREFIX}-button2--mini ${PREFIX}-button2--primary ${PREFIX}-button2--primary-dark`,
            href: weeklyOffersCtaLink,
            target: weeklyOffersCtaLinkTarget,
            children: weeklyOffersCtaLabel
          }
        ) })
      ]
    }
  );
};
ActivationMessage.propTypes = {
  ClassName: PropTypes.string,
  selectedCard: PropTypes.object,
  title: PropTypes.string,
  details: PropTypes.string,
  isCardVisible: PropTypes.bool,
  messages: PropTypes.object,
  shopNowCtaA11yLabel: PropTypes.string,
  shopNowCtaLabel: PropTypes.string,
  shopNowCtaLink: PropTypes.string,
  shopNowCtaLinkTarget: PropTypes.string
};
const OfferBanner = (props) => {
  const { bannerImagePath, bannerImageAlt, badgeImageUrl, returnPolicy, bannerLogoImgComponentName } = props;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-offers-card__banner`, children: [
    /* @__PURE__ */ jsx(
      "img",
      {
        className: `${PREFIX}-offers-card__banner-icon`,
        alt: bannerImageAlt,
        ...applyAkamaiPolicy(bannerImagePath, bannerLogoImgComponentName, false, returnPolicy)
      }
    ),
    /* @__PURE__ */ jsx(
      "img",
      {
        className: `${PREFIX}-offers-card__banner-icon`,
        alt: "",
        ...applyAkamaiPolicy(badgeImageUrl, bannerLogoImgComponentName, false, returnPolicy)
      }
    )
  ] }) });
};
const EmailActivationCard = (props) => {
  const {
    ClassName,
    selectedCard,
    isCardVisible,
    bannerImageList,
    failedActivationImage,
    failedActivationImageAltText,
    title,
    multiOffer,
    selectedOfferArray,
    activatedLabel,
    offerDetailsLabel,
    multipleOfferTilesSuccessMessage,
    offerEndsMessage,
    offerEndsTodayMessage,
    offerEndsDateMessage,
    akamaiPolicy,
    activateLabel,
    redeemedLabel,
    moreDetailsLabel,
    callCertona,
    recomendationList,
    a11yLabelForOfferDetails
  } = props;
  const {
    returnPolicy,
    fallbackOfferImageUrl,
    offersCardImgComponentName,
    fallbackImageForBrandLogo,
    fallbackImageForBrandLogoAltText,
    bannerLogoImgComponentName
  } = akamaiPolicy || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState({});
  const openOfferModal = (offerInModal, event) => {
    const viewAllOffersCTAEle = event.currentTarget;
    viewAllOffersCTAEle.setAttribute(previousElementName, "true");
    setIsModalOpen(true);
    setSelectedOffer(offerInModal);
    callCertona && callCertona();
  };
  const columns = {
    md: magicNumber.TWELVE / magicNumber.FOUR,
    sm: magicNumber.TWELVE / magicNumber.THREE,
    xs: magicNumber.THREE
  };
  const labels = {
    activatedLabel,
    activateLabel,
    redeemedLabel
  };
  const offerDetailsCardElement = () => {
    if (isCardVisible) {
      const { imageUrl, badgeImageUrl, displayBanner } = selectedCard;
      const setBannerLogo2 = (bannerName) => {
        const getBannerName = bannerName == null ? void 0 : bannerName.toString();
        return bannerImageList && bannerImageList.find((imageList) => getBannerName === imageList.bannerId);
      };
      const { bannerImagePath, bannerImageAlt } = setBannerLogo2(displayBanner) || {};
      const mutipleBanner = displayBanner == null ? void 0 : displayBanner.includes(",");
      const brandImage = mutipleBanner ? fallbackImageForBrandLogo : bannerImagePath;
      const brandImageAlt = mutipleBanner ? fallbackImageForBrandLogoAltText : bannerImageAlt;
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${ClassName}_offer-card`,
          onClick: (e) => openOfferModal(selectedOfferArray[0], e),
          onKeyDown: (e) => {
            if (e.key === stringKeyCodes.space || e.key === stringKeyCodes.enter) {
              e.preventDefault();
              openOfferModal(selectedOfferArray[0], e);
            }
          },
          role: "button",
          tabIndex: 0,
          children: [
            /* @__PURE__ */ jsx(
              OfferBanner,
              {
                bannerImagePath: brandImage,
                bannerImageAlt: brandImageAlt,
                badgeImageAlt: "Banner Image",
                badgeImageUrl,
                returnPolicy,
                bannerLogoImgComponentName
              }
            ),
            /* @__PURE__ */ jsxs("picture", { children: [
              /* @__PURE__ */ jsx(
                "source",
                {
                  type: "image/png",
                  ...applyAkamaiPolicy(imageUrl, offersCardImgComponentName, false, returnPolicy)
                }
              ),
              /* @__PURE__ */ jsx(
                "img",
                {
                  className: `${ClassName}_offer-card_image`,
                  alt: "",
                  ...applyAkamaiPolicy(
                    fallbackOfferImageUrl,
                    offersCardImgComponentName,
                    false,
                    returnPolicy
                  )
                }
              )
            ] }),
            /* @__PURE__ */ jsx("span", { className: "sr-only", children: a11yLabelForOfferDetails })
          ]
        }
      );
    } else if (title) {
      return /* @__PURE__ */ jsx("div", { className: `${ClassName}_offer-card ${ClassName}_offer-card_error`, children: /* @__PURE__ */ jsx(
        "img",
        {
          className: `${ClassName}_offer-card_image`,
          src: failedActivationImage,
          alt: failedActivationImageAltText
        }
      ) });
    } else {
      return null;
    }
  };
  const renderOfferCard = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${ClassName}_offer-container`, children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          "data-testid": "rendermultipleoffers",
          dangerouslySetInnerHTML: { __html: multipleOfferTilesSuccessMessage }
        }
      ),
      selectedOfferArray == null ? void 0 : selectedOfferArray.map((offer, index2) => /* @__PURE__ */ jsx(
        OfferCard,
        {
          bannerImageList,
          offerEndsLabel: offerEndsMessage,
          offerEndsTodayLabel: offerEndsTodayMessage,
          offerEndsDateLabel: offerEndsDateMessage,
          offer,
          openModal: openOfferModal,
          activateOffer: () => {
            return null;
          },
          modalLabel: offerDetailsLabel,
          moreDetailsLabel,
          status: getButtonStatus(offer == null ? void 0 : offer.offerStatus, offerConstants, labels),
          columns,
          akamaiPolicy
        },
        `offer_${index2}`
      ))
    ] });
  };
  const offerModalWrapper = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: checkDataLength(selectedOffer) && isModalOpen && /* @__PURE__ */ jsx("div", { className: `${PREFIX}__offers_details`, children: /* @__PURE__ */ jsx(
      OfferFlyout,
      {
        modalLabel: offerDetailsLabel,
        moreDetailsLabel,
        activatedLabel,
        offerEndsTodayLabel: "",
        offerEndsLabel: "",
        redeemedLabel: "",
        ...props,
        isOpen: isModalOpen,
        setIsFlyoutOpen: (value) => setIsModalOpen(value),
        offer: selectedOffer,
        activateOffer: () => {
          return null;
        },
        status: getButtonStatus(
          selectedOffer == null ? void 0 : selectedOffer.offerStatus,
          offerConstants,
          labels
        ),
        columns,
        akamaiPolicy,
        recomendationList
      }
    ) }) });
  };
  const renderEmailActivationCard = () => {
    return !isCardVisible && multiOffer && selectedOfferArray ? /* @__PURE__ */ jsx("div", { className: `${ClassName}_multiple`, children: renderOfferCard() }) : /* @__PURE__ */ jsxs("div", { className: ClassName, children: [
      offerDetailsCardElement(),
      /* @__PURE__ */ jsx(ActivationMessage, { ...props, openModal: openOfferModal })
    ] });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    renderEmailActivationCard(),
    offerModalWrapper()
  ] });
};
EmailActivationCard.propTypes = {
  ClassName: PropTypes.string,
  messages: PropTypes.object,
  isCardVisible: PropTypes.bool,
  selectedCard: PropTypes.object,
  selectedOfferArray: PropTypes.array
};
const PreviewCard = (props) => {
  const {
    details,
    showLock,
    title,
    icon,
    editLabel,
    onEditButtonClickHandler,
    subTitle,
    status,
    isRowWithTwoColumnsOnMobile = true
  } = props;
  const previewItems = () => {
    return details.map((el, i) => /* @__PURE__ */ jsx(
      PreviewDetail,
      {
        title: el.title,
        detail: el.detail,
        changeClass: true,
        isRowWithTwoColumnsOnMobile,
        shouldRenderWithoutDetail: true
      },
      i
    ));
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    status && /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-subscription__${status == null ? void 0 : status.type}`, children: [
      /* @__PURE__ */ jsx(Icon, { size: "md", type: status == null ? void 0 : status.icon }),
      status == null ? void 0 : status.label
    ] }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-subscription__header ${PREFIX}-xs-flex ${PREFIX}-xs-justify-space-between`, children: [
      subTitle ? /* @__PURE__ */ jsxs("h4", { className: `${PREFIX}-subscription__subtitle`, children: [
        icon && /* @__PURE__ */ jsx(Icon, { size: "md", type: icon }),
        subTitle
      ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs("h4", { className: `${PREFIX}-subscription__title`, children: [
          icon && /* @__PURE__ */ jsx(Icon, { size: "md", type: icon }),
          title
        ] }),
        showLock && /* @__PURE__ */ jsx(Icon, { size: "md", type: showLock })
      ] }),
      editLabel && /* @__PURE__ */ jsx(
        Button,
        {
          ariaLabel: `${editLabel} ${title}`,
          id: "shopping-edit-preview",
          type: "tertiary",
          onClick: () => onEditButtonClickHandler(),
          children: editLabel
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: `${PREFIX}-subscription__title--section ${PREFIX}-xs-flex ${PREFIX}-xs-justify-space-between`,
        children: subTitle && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Heading, { variant: "h4", componentClass: `${PREFIX}-subscription__title`, children: title }),
          showLock && /* @__PURE__ */ jsx(Icon, { size: "md", type: showLock })
        ] })
      }
    ),
    details && previewItems()
  ] });
};
const initBanner = (element) => {
  const isBannerClickable = element.querySelector(`.${PREFIX}-banner--is-clickable`);
  if (isBannerClickable) {
    isBannerClickable.addEventListener("click", (event) => {
      const elemTarget = event.target;
      if (elemTarget.nodeName !== "BUTTON" && elemTarget.nodeName !== "A") {
        const dataUrl = isBannerClickable.getAttribute("data-url");
        const dataTarget = isBannerClickable.getAttribute("data-target");
        if (dataUrl && dataTarget) {
          window.open(dataUrl, dataTarget, "noopener");
        }
      }
    });
  }
};
const Banner = (element) => {
  const elementArray = element ? [element] : null;
  const elementRef = typeof element === "string" ? document.querySelectorAll(element) : elementArray;
  if (elementRef) {
    elementRef.forEach((el) => {
      initBanner(el);
    });
  }
};
const getCardNameAndNumber = (propText, card) => {
  return `${replaceMultipleStrWithDynamicVal(propText, [
    getCapitalizeString(card.type),
    card.maskedCardNumber.slice(magicNumber.MINUS_FOUR)
  ])}`;
};
const getDateFromCreditCard = (validToMonth, validToYear) => {
  const month = String(validToMonth).padStart(magicNumber.TWO, `${magicNumber.ZERO}`);
  const year = String(validToYear).substr(magicNumber.MINUS_TWO);
  return `${month}/${year}`;
};
const getCardLogo = (cardsData, cardType = "") => cardsData == null ? void 0 : cardsData.find((item) => {
  var _a;
  return ~((_a = item.type.trim().toLowerCase().split(",")) == null ? void 0 : _a.indexOf(cardType.trim().toLowerCase()));
});
const getCardNumber = (cardNumber) => {
  return cardTypes[0].readOnlyValue + cardNumber.replace(/ /g, "");
};
const getCardType = (card) => {
  if (!card) {
    return "";
  }
  const cardLowerCase = card.toLowerCase();
  const cardsType = [CardType$1.amex, CardType$1.master, CardType$1.triangle, CardType$1.paypal, CardType$1.visa];
  const cardMatched = cardsType.find((type) => cardLowerCase.includes(type));
  return cardMatched || "";
};
const checkStateProvince = (value, country, stateProvince) => {
  if (country === currencyShortForm) {
    return (value == null ? void 0 : value.toUpperCase()) === `${country}-${stateProvince}`;
  } else {
    return false;
  }
};
const checkAddressChange = (triangleStatus, updatedProvince, province, updatedCountry, country) => {
  return Boolean(
    (isTriangleSelectMember(triangleStatus) || wasTriangleSelectMember(triangleStatus)) && (updatedProvince !== province || updatedCountry !== country)
  );
};
const CardColumn = (props) => {
  const { componentName, cardDetails, ctaDetails, image } = props;
  const rowClasses = `${PREFIX}-xs-flex ${PREFIX}-md-row ${PREFIX}-xs-col-row`;
  return /* @__PURE__ */ jsxs("li", { className: `${componentName} ${rowClasses} between-xs middle-md top-xs`, children: [
    /* @__PURE__ */ jsxs("div", { className: `${componentName}__content ${rowClasses} middle-md top-xs`, children: [
      /* @__PURE__ */ jsx("img", { className: `${componentName}__img--wrapper`, src: image == null ? void 0 : image.logo, alt: image == null ? void 0 : image.type }),
      /* @__PURE__ */ jsx("div", { className: `${componentName}__content--details ${rowClasses}`, children: cardDetails.map((el, i) => {
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${componentName}__content--wrapper ${PREFIX}-xs-flex ${PREFIX}-xs-row ${PREFIX}-md-col-row`,
            children: [
              /* @__PURE__ */ jsx("p", { className: `${componentName}__label`, children: el.label }),
              /* @__PURE__ */ jsx("p", { className: `${componentName}__value ${(el == null ? void 0 : el.isExpired) ? el.isExpired : ""}`, children: el.value })
            ]
          },
          i
        );
      }) })
    ] }),
    /* @__PURE__ */ jsx("div", { className: `${componentName}__cta--wrapper ${PREFIX}-xs-flex between-xs start-md`, children: ctaDetails.map((el, i) => {
      return /* @__PURE__ */ jsxs(Button, { id: el.id, type: "tertiary", size: "mini", onClick: el.onClickFunction, children: [
        el.icon && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: `${PREFIX}-xs-none ${PREFIX}-sm-block ${PREFIX}-md-block`, children: /* @__PURE__ */ jsx(Icon, { type: el.icon, size: "lg" }) }),
          /* @__PURE__ */ jsx("div", { className: `${PREFIX}-sm-none`, children: /* @__PURE__ */ jsx(Icon, { type: el.icon, size: "md" }) })
        ] }),
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-xs-none ${PREFIX}-sm-block ${PREFIX}-md-block`, children: el.label }),
        /* @__PURE__ */ jsx("span", { className: `${PREFIX}-sm-none`, children: el.mobileLabel ? el.mobileLabel : el.label })
      ] }, i);
    }) })
  ] });
};
const HeroBannerSplit = ({ ...props }) => {
  const { img, bgImg, children, className: className2, dynamicImgs, isPostPurchaseComp } = props;
  const bannerClass = className2 ? className2 : `${PREFIX}-hero-banner`;
  const imgClass = img ? `${bannerClass}__image` : "";
  const bgImageInline = bgImg ? { backgroundImage: `url(${bgImg})` } : {};
  return isPostPurchaseComp ? /* @__PURE__ */ jsxs("section", { className: `${bannerClass} ${PREFIX}-post-purchase ${PREFIX}-row`, children: [
    /* @__PURE__ */ jsx("div", { className: `${bannerClass}__bgimage`, style: bgImageInline }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-col-md-3 ${PREFIX}-col-sm-3 ${imgClass}`, children: [
      img && /* @__PURE__ */ jsx("img", { "data-component-name": img == null ? void 0 : img.dataComp, src: img == null ? void 0 : img.url, alt: img == null ? void 0 : img.altText }),
      dynamicImgs
    ] }),
    /* @__PURE__ */ jsx("div", { className: `${bannerClass}__content ${PREFIX}-col-md-9 ${PREFIX}-col-sm-12`, children })
  ] }) : /* @__PURE__ */ jsxs("section", { className: `${bannerClass} ${PREFIX}-row`, style: bgImageInline, children: [
    /* @__PURE__ */ jsx("div", { className: `${bannerClass}__content ${PREFIX}-col-md-6 ${PREFIX}-col-sm-6`, children }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-col-md-6 ${PREFIX}-col-sm-6 ${imgClass}`, children: [
      img && /* @__PURE__ */ jsx("img", { "data-component-name": img == null ? void 0 : img.dataComp, src: img == null ? void 0 : img.url, alt: img == null ? void 0 : img.altText }),
      dynamicImgs
    ] })
  ] });
};
HeroBannerSplit.propTypes = {
  img: PropTypes.shape({
    url: PropTypes.string,
    altText: PropTypes.string,
    title: PropTypes.string,
    dataComp: PropTypes.string
  }),
  bgImg: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired
};
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length; ) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
var lodash_memoize;
var hasRequiredLodash_memoize;
function requireLodash_memoize() {
  if (hasRequiredLodash_memoize) return lodash_memoize;
  hasRequiredLodash_memoize = 1;
  var FUNC_ERROR_TEXT = "Expected a function";
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var funcTag = "[object Function]", genTag = "[object GeneratorFunction]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  function getValue2(object2, key) {
    return object2 == null ? void 0 : object2[key];
  }
  function isHostObject(value) {
    var result = false;
    if (value != null && typeof value.toString != "function") {
      try {
        result = !!(value + "");
      } catch (e) {
      }
    }
    return result;
  }
  var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
  var coreJsData = root["__core-js_shared__"];
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var funcToString = funcProto.toString;
  var hasOwnProperty = objectProto.hasOwnProperty;
  var objectToString = objectProto.toString;
  var reIsNative = RegExp(
    "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var splice = arrayProto.splice;
  var Map2 = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
  function Hash(entries2) {
    var index2 = -1, length = entries2 ? entries2.length : 0;
    this.clear();
    while (++index2 < length) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }
  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : void 0;
  }
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
  }
  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
    return this;
  }
  Hash.prototype.clear = hashClear;
  Hash.prototype["delete"] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  function ListCache(entries2) {
    var index2 = -1, length = entries2 ? entries2.length : 0;
    this.clear();
    while (++index2 < length) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear() {
    this.__data__ = [];
  }
  function listCacheDelete(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index2 == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index2, 1);
    }
    return true;
  }
  function listCacheGet(key) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    return index2 < 0 ? void 0 : data[index2][1];
  }
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  function listCacheSet(key, value) {
    var data = this.__data__, index2 = assocIndexOf(data, key);
    if (index2 < 0) {
      data.push([key, value]);
    } else {
      data[index2][1] = value;
    }
    return this;
  }
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  function MapCache(entries2) {
    var index2 = -1, length = entries2 ? entries2.length : 0;
    this.clear();
    while (++index2 < length) {
      var entry = entries2[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear() {
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map2 || ListCache)(),
      "string": new Hash()
    };
  }
  function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
  }
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  }
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseIsNative(value) {
    if (!isObject2(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative(object2, key) {
    var value = getValue2(object2, key);
    return baseIsNative(value) ? value : void 0;
  }
  function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function memoize2(func, resolver2) {
    if (typeof func != "function" || resolver2 && typeof resolver2 != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments, key = resolver2 ? resolver2.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize2.Cache || MapCache)();
    return memoized;
  }
  memoize2.Cache = MapCache;
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  function isFunction(value) {
    var tag = isObject2(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
  }
  function isObject2(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  lodash_memoize = memoize2;
  return lodash_memoize;
}
var lodash_memoizeExports = requireLodash_memoize();
const memoize$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(lodash_memoizeExports);
function resolver(options) {
  return JSON.stringify(options);
}
function uniqDefined(arr) {
  return arr.filter(function(el, index2) {
    return el && arr.indexOf(el) === index2;
  });
}
function normalizeLocales(arr) {
  return arr.map(function(el) {
    if (!el || el.indexOf("-") === -1 || el.toLowerCase() !== el) {
      return el;
    }
    var splitEl = el.split("-");
    return splitEl[0] + "-" + splitEl[1].toUpperCase();
  });
}
function getUserLocalesInternal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$useFallbackLocal = _ref.useFallbackLocale, useFallbackLocale = _ref$useFallbackLocal === void 0 ? true : _ref$useFallbackLocal, _ref$fallbackLocale = _ref.fallbackLocale, fallbackLocale = _ref$fallbackLocale === void 0 ? "en-US" : _ref$fallbackLocale;
  var languageList = [];
  if (typeof window !== "undefined") {
    var _window = window, navigator2 = _window.navigator;
    languageList = languageList.concat(navigator2.languages, navigator2.language, navigator2.userLanguage, navigator2.browserLanguage, navigator2.systemLanguage);
  }
  if (useFallbackLocale) {
    languageList.push(fallbackLocale);
  }
  return normalizeLocales(uniqDefined(languageList));
}
var getUserLocales = memoize$1(getUserLocalesInternal, resolver);
function getUserLocaleInternal(options) {
  return getUserLocales(options)[0] || null;
}
var getUserLocale = memoize$1(getUserLocaleInternal, resolver);
function makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborInternal(date, offset) {
    if (offset === void 0) {
      offset = defaultOffset;
    }
    var previousPeriod = getPeriod(date) + offset;
    return getEdgeOfPeriod(previousPeriod);
  };
}
function makeGetEnd(getBeginOfNextPeriod) {
  return function makeGetEndInternal(date) {
    return new Date(getBeginOfNextPeriod(date).getTime() - 1);
  };
}
function makeGetRange(getStart, getEnd2) {
  return function makeGetRangeInternal(date) {
    return [getStart(date), getEnd2(date)];
  };
}
function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }
  if (typeof date === "number") {
    return date;
  }
  var year = parseInt(date, 10);
  if (typeof date === "string" && !isNaN(year)) {
    return year;
  }
  throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getMonth(date) {
  if (date instanceof Date) {
    return date.getMonth();
  }
  throw new Error("Failed to get month from date: ".concat(date, "."));
}
function getDate(date) {
  if (date instanceof Date) {
    return date.getDate();
  }
  throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getCenturyStart(date) {
  var year = getYear(date);
  var centuryStartYear = year + (-year + 1) % 100;
  var centuryStartDate = /* @__PURE__ */ new Date();
  centuryStartDate.setFullYear(centuryStartYear, 0, 1);
  centuryStartDate.setHours(0, 0, 0, 0);
  return centuryStartDate;
}
var getPreviousCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, -100);
var getNextCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, 100);
var getCenturyEnd = makeGetEnd(getNextCenturyStart);
var getPreviousCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, -100);
var getCenturyRange = makeGetRange(getCenturyStart, getCenturyEnd);
function getDecadeStart(date) {
  var year = getYear(date);
  var decadeStartYear = year + (-year + 1) % 10;
  var decadeStartDate = /* @__PURE__ */ new Date();
  decadeStartDate.setFullYear(decadeStartYear, 0, 1);
  decadeStartDate.setHours(0, 0, 0, 0);
  return decadeStartDate;
}
var getPreviousDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, -10);
var getNextDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, 10);
var getDecadeEnd = makeGetEnd(getNextDecadeStart);
var getPreviousDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, -10);
var getDecadeRange = makeGetRange(getDecadeStart, getDecadeEnd);
function getYearStart(date) {
  var year = getYear(date);
  var yearStartDate = /* @__PURE__ */ new Date();
  yearStartDate.setFullYear(year, 0, 1);
  yearStartDate.setHours(0, 0, 0, 0);
  return yearStartDate;
}
var getPreviousYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, -1);
var getNextYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, 1);
var getYearEnd = makeGetEnd(getNextYearStart);
var getPreviousYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, -1);
var getYearRange = makeGetRange(getYearStart, getYearEnd);
function makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborMonthInternal(date, offset) {
    if (offset === void 0) {
      offset = defaultOffset;
    }
    var year = getYear(date);
    var month = getMonth(date) + offset;
    var previousPeriod = /* @__PURE__ */ new Date();
    previousPeriod.setFullYear(year, month, 1);
    previousPeriod.setHours(0, 0, 0, 0);
    return getEdgeOfPeriod(previousPeriod);
  };
}
function getMonthStart(date) {
  var year = getYear(date);
  var month = getMonth(date);
  var monthStartDate = /* @__PURE__ */ new Date();
  monthStartDate.setFullYear(year, month, 1);
  monthStartDate.setHours(0, 0, 0, 0);
  return monthStartDate;
}
var getPreviousMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, -1);
var getNextMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, 1);
var getMonthEnd = makeGetEnd(getNextMonthStart);
var getPreviousMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, -1);
var getMonthRange = makeGetRange(getMonthStart, getMonthEnd);
function makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborDayInternal(date, offset) {
    if (offset === void 0) {
      offset = defaultOffset;
    }
    var year = getYear(date);
    var month = getMonth(date);
    var day = getDate(date) + offset;
    var previousPeriod = /* @__PURE__ */ new Date();
    previousPeriod.setFullYear(year, month, day);
    previousPeriod.setHours(0, 0, 0, 0);
    return getEdgeOfPeriod(previousPeriod);
  };
}
function getDayStart(date) {
  var year = getYear(date);
  var month = getMonth(date);
  var day = getDate(date);
  var dayStartDate = /* @__PURE__ */ new Date();
  dayStartDate.setFullYear(year, month, day);
  dayStartDate.setHours(0, 0, 0, 0);
  return dayStartDate;
}
var getNextDayStart = makeGetEdgeOfNeighborDay(getDayStart, 1);
var getDayEnd = makeGetEnd(getNextDayStart);
var getDayRange = makeGetRange(getDayStart, getDayEnd);
function getDaysInMonth(date) {
  return getDate(getMonthEnd(date));
}
var _CALENDAR_TYPE_LOCALE;
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}
function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _defineProperty$d(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var CALENDAR_TYPES = {
  ARABIC: "Arabic",
  HEBREW: "Hebrew",
  ISO_8601: "ISO 8601",
  US: "US"
};
var CALENDAR_TYPE_LOCALES = (_CALENDAR_TYPE_LOCALE = {}, _defineProperty$d(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.US, ["en-CA", "en-US", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-DO", "es-EC", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PE", "es-PR", "es-SV", "es-VE", "pt-BR"]), _defineProperty$d(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.ARABIC, [
  // ar-LB, ar-MA intentionally missing
  "ar",
  "ar-AE",
  "ar-BH",
  "ar-DZ",
  "ar-EG",
  "ar-IQ",
  "ar-JO",
  "ar-KW",
  "ar-LY",
  "ar-OM",
  "ar-QA",
  "ar-SA",
  "ar-SD",
  "ar-SY",
  "ar-YE",
  "dv",
  "dv-MV",
  "ps",
  "ps-AR"
]), _defineProperty$d(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.HEBREW, ["he", "he-IL"]), _CALENDAR_TYPE_LOCALE);
var WEEKDAYS = _toConsumableArray$2(Array(7)).map(function(el, index2) {
  return index2;
});
var formatterCache = /* @__PURE__ */ new Map();
function getFormatter(options) {
  return function(locale2, date) {
    var localeWithDefault = locale2 || getUserLocale();
    if (!formatterCache.has(localeWithDefault)) {
      formatterCache.set(localeWithDefault, /* @__PURE__ */ new Map());
    }
    var formatterCacheLocale = formatterCache.get(localeWithDefault);
    if (!formatterCacheLocale.has(options)) {
      formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault, options).format);
    }
    return formatterCacheLocale.get(options)(date);
  };
}
function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}
function getSafeFormatter(options) {
  return function(locale2, date) {
    return getFormatter(options)(locale2, toSafeHour(date));
  };
}
var formatDayOptions = {
  day: "numeric"
};
var formatLongDateOptions = {
  day: "numeric",
  month: "long",
  year: "numeric"
};
var formatMonthOptions = {
  month: "long"
};
var formatMonthYearOptions = {
  month: "long",
  year: "numeric"
};
var formatShortWeekdayOptions = {
  weekday: "short"
};
var formatWeekdayOptions = {
  weekday: "long"
};
var formatYearOptions = {
  year: "numeric"
};
var formatDay = getSafeFormatter(formatDayOptions);
var formatLongDate = getSafeFormatter(formatLongDateOptions);
var formatMonth = getSafeFormatter(formatMonthOptions);
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
var formatWeekday = getSafeFormatter(formatWeekdayOptions);
var formatYear = getSafeFormatter(formatYearOptions);
var SUNDAY = WEEKDAYS[0];
var FRIDAY = WEEKDAYS[5];
var SATURDAY = WEEKDAYS[6];
function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var weekday = date.getDay();
  switch (calendarType) {
    case CALENDAR_TYPES.ISO_8601:
      return (weekday + 6) % 7;
    case CALENDAR_TYPES.ARABIC:
      return (weekday + 1) % 7;
    case CALENDAR_TYPES.HEBREW:
    case CALENDAR_TYPES.US:
      return weekday;
    default:
      throw new Error("Unsupported calendar type.");
  }
}
function getBeginOfCenturyYear(date) {
  var beginOfCentury = getCenturyStart(date);
  return getYear(beginOfCentury);
}
function getBeginOfDecadeYear(date) {
  var beginOfDecade = getDecadeStart(date);
  return getYear(beginOfDecade);
}
function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var year = getYear(date);
  var monthIndex = getMonth(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
}
function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var calendarTypeForWeekNumber = calendarType === CALENDAR_TYPES.US ? CALENDAR_TYPES.US : CALENDAR_TYPES.ISO_8601;
  var beginOfWeek = getBeginOfWeek(date, calendarType);
  var year = getYear(date) + 1;
  var dayInWeekOne;
  var beginOfFirstWeek;
  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === CALENDAR_TYPES.ISO_8601 ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarType);
    year -= 1;
  } while (date < beginOfFirstWeek);
  return Math.round((beginOfWeek - beginOfFirstWeek) / (864e5 * 7)) + 1;
}
function getBegin(rangeType, date) {
  switch (rangeType) {
    case "century":
      return getCenturyStart(date);
    case "decade":
      return getDecadeStart(date);
    case "year":
      return getYearStart(date);
    case "month":
      return getMonthStart(date);
    case "day":
      return getDayStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case "century":
      return getPreviousCenturyStart(date);
    case "decade":
      return getPreviousDecadeStart(date);
    case "year":
      return getPreviousYearStart(date);
    case "month":
      return getPreviousMonthStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case "century":
      return getNextCenturyStart(date);
    case "decade":
      return getNextDecadeStart(date);
    case "year":
      return getNextYearStart(date);
    case "month":
      return getNextMonthStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getBeginPrevious2 = function getBeginPrevious22(rangeType, date) {
  switch (rangeType) {
    case "decade":
      return getPreviousDecadeStart(date, -100);
    case "year":
      return getPreviousYearStart(date, -10);
    case "month":
      return getPreviousMonthStart(date, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
var getBeginNext2 = function getBeginNext22(rangeType, date) {
  switch (rangeType) {
    case "decade":
      return getNextDecadeStart(date, 100);
    case "year":
      return getNextYearStart(date, 10);
    case "month":
      return getNextMonthStart(date, 12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
function getEnd(rangeType, date) {
  switch (rangeType) {
    case "century":
      return getCenturyEnd(date);
    case "decade":
      return getDecadeEnd(date);
    case "year":
      return getYearEnd(date);
    case "month":
      return getMonthEnd(date);
    case "day":
      return getDayEnd(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case "century":
      return getPreviousCenturyEnd(date);
    case "decade":
      return getPreviousDecadeEnd(date);
    case "year":
      return getPreviousYearEnd(date);
    case "month":
      return getPreviousMonthEnd(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getEndPrevious2 = function getEndPrevious22(rangeType, date) {
  switch (rangeType) {
    case "decade":
      return getPreviousDecadeEnd(date, -100);
    case "year":
      return getPreviousYearEnd(date, -10);
    case "month":
      return getPreviousMonthEnd(date, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
function getRange(rangeType, date) {
  switch (rangeType) {
    case "century":
      return getCenturyRange(date);
    case "decade":
      return getDecadeRange(date);
    case "year":
      return getYearRange(date);
    case "month":
      return getMonthRange(date);
    case "day":
      return getDayRange(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function(a, b) {
    return a - b;
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
}
function toYearLabel(locale2) {
  var formatYear$1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : formatYear;
  var dates = arguments.length > 2 ? arguments[2] : void 0;
  return dates.map(function(date) {
    return formatYear$1(locale2, date);
  }).join(" – ");
}
function getCenturyLabel(locale2, formatYear2, date) {
  return toYearLabel(locale2, formatYear2, getCenturyRange(date));
}
function getDecadeLabel(locale2, formatYear2, date) {
  return toYearLabel(locale2, formatYear2, getDecadeRange(date));
}
function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var weekday = date.getDay();
  switch (calendarType) {
    case CALENDAR_TYPES.ARABIC:
    case CALENDAR_TYPES.HEBREW:
      return weekday === FRIDAY || weekday === SATURDAY;
    case CALENDAR_TYPES.ISO_8601:
    case CALENDAR_TYPES.US:
      return weekday === SATURDAY || weekday === SUNDAY;
    default:
      throw new Error("Unsupported calendar type.");
  }
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
var calendarTypes = Object.values(CALENDAR_TYPES);
var allViews$1 = ["century", "decade", "year", "month"];
var isCalendarType = PropTypes.oneOf(calendarTypes);
var isClassName = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);
var isMinDate = function isMinDate2(props, propName, componentName) {
  var minDate = props[propName];
  if (!minDate) {
    return null;
  }
  if (!(minDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }
  var maxDate = props.maxDate;
  if (maxDate && minDate > maxDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
  }
  return null;
};
var isMaxDate = function isMaxDate2(props, propName, componentName) {
  var maxDate = props[propName];
  if (!maxDate) {
    return null;
  }
  if (!(maxDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }
  var minDate = props.minDate;
  if (minDate && maxDate < minDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
  }
  return null;
};
var isRef = PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
  current: PropTypes.any
})]);
var isValue = PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.arrayOf(PropTypes.instanceOf(Date))]);
var isViews = PropTypes.arrayOf(PropTypes.oneOf(allViews$1));
var isView = function isView2(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;
  var allowedViews = views || allViews$1;
  if (view !== void 0 && allowedViews.indexOf(view) === -1) {
    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function(a) {
      return '"'.concat(a, '"');
    }).join(", "), "]."));
  }
  return null;
};
isView.isRequired = function(props, propName, componentName) {
  var view = props[propName];
  if (!view) {
    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
  }
  return isView(props, propName, componentName);
};
var tileGroupProps = {
  activeStartDate: PropTypes.instanceOf(Date).isRequired,
  hover: PropTypes.instanceOf(Date),
  locale: PropTypes.string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func,
  tileClassName: PropTypes.oneOfType([PropTypes.func, isClassName]),
  tileContent: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  value: isValue,
  valueType: PropTypes.string
};
var tileProps = {
  activeStartDate: PropTypes.instanceOf(Date).isRequired,
  classes: PropTypes.arrayOf(PropTypes.string).isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  locale: PropTypes.string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  tileClassName: PropTypes.oneOfType([PropTypes.func, isClassName]),
  tileContent: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  tileDisabled: PropTypes.func
};
var className$6 = "react-calendar__navigation";
function Navigation(_ref) {
  var activeStartDate = _ref.activeStartDate, drillUp = _ref.drillUp, _ref$formatMonthYear = _ref.formatMonthYear, formatMonthYear$1 = _ref$formatMonthYear === void 0 ? formatMonthYear : _ref$formatMonthYear, _ref$formatYear = _ref.formatYear, formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear, locale2 = _ref.locale, maxDate = _ref.maxDate, minDate = _ref.minDate, _ref$navigationAriaLa = _ref.navigationAriaLabel, navigationAriaLabel = _ref$navigationAriaLa === void 0 ? "" : _ref$navigationAriaLa, navigationAriaLive = _ref.navigationAriaLive, navigationLabel = _ref.navigationLabel, _ref$next2AriaLabel = _ref.next2AriaLabel, next2AriaLabel = _ref$next2AriaLabel === void 0 ? "" : _ref$next2AriaLabel, _ref$next2Label = _ref.next2Label, next2Label = _ref$next2Label === void 0 ? "»" : _ref$next2Label, _ref$nextAriaLabel = _ref.nextAriaLabel, nextAriaLabel = _ref$nextAriaLabel === void 0 ? "" : _ref$nextAriaLabel, _ref$nextLabel = _ref.nextLabel, nextLabel = _ref$nextLabel === void 0 ? "›" : _ref$nextLabel, _ref$prev2AriaLabel = _ref.prev2AriaLabel, prev2AriaLabel = _ref$prev2AriaLabel === void 0 ? "" : _ref$prev2AriaLabel, _ref$prev2Label = _ref.prev2Label, prev2Label = _ref$prev2Label === void 0 ? "«" : _ref$prev2Label, _ref$prevAriaLabel = _ref.prevAriaLabel, prevAriaLabel = _ref$prevAriaLabel === void 0 ? "" : _ref$prevAriaLabel, _ref$prevLabel = _ref.prevLabel, prevLabel = _ref$prevLabel === void 0 ? "‹" : _ref$prevLabel, setActiveStartDate = _ref.setActiveStartDate, showDoubleView = _ref.showDoubleView, view = _ref.view, views = _ref.views;
  var drillUpAvailable = views.indexOf(view) > 0;
  var shouldShowPrevNext2Buttons = view !== "century";
  var previousActiveStartDate = getBeginPrevious(view, activeStartDate);
  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginPrevious2(view, activeStartDate);
  var nextActiveStartDate = getBeginNext(view, activeStartDate);
  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginNext2(view, activeStartDate);
  var prevButtonDisabled = function() {
    if (previousActiveStartDate.getFullYear() < 0) {
      return true;
    }
    var previousActiveEndDate = getEndPrevious(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();
  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function() {
    if (previousActiveStartDate2.getFullYear() < 0) {
      return true;
    }
    var previousActiveEndDate = getEndPrevious2(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();
  var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;
  function onClickPrevious() {
    setActiveStartDate(previousActiveStartDate, "prev");
  }
  function onClickPrevious2() {
    setActiveStartDate(previousActiveStartDate2, "prev2");
  }
  function onClickNext() {
    setActiveStartDate(nextActiveStartDate, "next");
  }
  function onClickNext2() {
    setActiveStartDate(nextActiveStartDate2, "next2");
  }
  function renderLabel(date) {
    var label = function() {
      switch (view) {
        case "century":
          return getCenturyLabel(locale2, formatYear$1, date);
        case "decade":
          return getDecadeLabel(locale2, formatYear$1, date);
        case "year":
          return formatYear$1(locale2, date);
        case "month":
          return formatMonthYear$1(locale2, date);
        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }();
    return navigationLabel ? navigationLabel({
      date,
      label,
      locale: locale2 || getUserLocale(),
      view
    }) : label;
  }
  function renderButton() {
    var labelClassName = "".concat(className$6, "__label");
    return /* @__PURE__ */ React.createElement("button", {
      "aria-label": navigationAriaLabel,
      "aria-live": navigationAriaLive,
      className: labelClassName,
      disabled: !drillUpAvailable,
      onClick: drillUp,
      style: {
        flexGrow: 1
      },
      type: "button"
    }, /* @__PURE__ */ React.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
    }, renderLabel(activeStartDate)), showDoubleView && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", {
      className: "".concat(labelClassName, "__divider")
    }, " – "), /* @__PURE__ */ React.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
    }, renderLabel(nextActiveStartDate))));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: className$6
  }, prev2Label !== null && shouldShowPrevNext2Buttons && /* @__PURE__ */ React.createElement("button", {
    "aria-label": prev2AriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__prev2-button"),
    disabled: prev2ButtonDisabled,
    onClick: onClickPrevious2,
    type: "button"
  }, prev2Label), prevLabel !== null && /* @__PURE__ */ React.createElement("button", {
    "aria-label": prevAriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__prev-button"),
    disabled: prevButtonDisabled,
    onClick: onClickPrevious,
    type: "button"
  }, prevLabel), renderButton(), nextLabel !== null && /* @__PURE__ */ React.createElement("button", {
    "aria-label": nextAriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__next-button"),
    disabled: nextButtonDisabled,
    onClick: onClickNext,
    type: "button"
  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && /* @__PURE__ */ React.createElement("button", {
    "aria-label": next2AriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__next2-button"),
    disabled: next2ButtonDisabled,
    onClick: onClickNext2,
    type: "button"
  }, next2Label));
}
Navigation.propTypes = {
  activeStartDate: PropTypes.instanceOf(Date).isRequired,
  drillUp: PropTypes.func.isRequired,
  formatMonthYear: PropTypes.func,
  formatYear: PropTypes.func,
  locale: PropTypes.string,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  navigationAriaLabel: PropTypes.string,
  navigationAriaLive: PropTypes.string,
  navigationLabel: PropTypes.func,
  next2AriaLabel: PropTypes.string,
  next2Label: PropTypes.node,
  nextAriaLabel: PropTypes.string,
  nextLabel: PropTypes.node,
  prev2AriaLabel: PropTypes.string,
  prev2Label: PropTypes.node,
  prevAriaLabel: PropTypes.string,
  prevLabel: PropTypes.node,
  setActiveStartDate: PropTypes.func.isRequired,
  showDoubleView: PropTypes.bool,
  view: isView.isRequired,
  views: isViews.isRequired
};
var _excluded$9 = ["children", "className", "direction", "count", "offset", "style", "wrap"];
function _extends$c() {
  _extends$c = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$c.apply(this, arguments);
}
function ownKeys$c(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$c(Object(source), true).forEach(function(key) {
      _defineProperty$c(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$c(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties$9(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$9(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$9(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function toPercent(num) {
  return "".concat(num, "%");
}
function Flex(_ref) {
  var children = _ref.children, className2 = _ref.className, direction = _ref.direction, count = _ref.count, offset = _ref.offset, style = _ref.style, wrap = _ref.wrap, otherProps = _objectWithoutProperties$9(_ref, _excluded$9);
  return /* @__PURE__ */ React.createElement("div", _extends$c({
    className: className2,
    style: _objectSpread$c({
      display: "flex",
      flexDirection: direction,
      flexWrap: wrap ? "wrap" : "no-wrap"
    }, style)
  }, otherProps), React.Children.map(children, function(child, index2) {
    return /* @__PURE__ */ React.cloneElement(child, _objectSpread$c(_objectSpread$c({}, child.props), {}, {
      style: {
        flexBasis: toPercent(100 / count),
        flexShrink: 0,
        flexGrow: 0,
        overflow: "hidden",
        marginLeft: offset && index2 === 0 ? toPercent(100 * offset / count) : null
      }
    }));
  }));
}
Flex.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  count: PropTypes.number.isRequired,
  direction: PropTypes.string,
  offset: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  wrap: PropTypes.bool
};
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function between(value, min, max) {
  if (min && min > value) {
    return min;
  }
  if (max && max < value) {
    return max;
  }
  return value;
}
function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
}
function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
}
function getRangeClassNames(valueRange, dateRange, baseClassName2) {
  var isRange = doRangesOverlap(dateRange, valueRange);
  var classes2 = [];
  if (isRange) {
    classes2.push(baseClassName2);
    var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
    var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);
    if (isRangeStart) {
      classes2.push("".concat(baseClassName2, "Start"));
    }
    if (isRangeEnd) {
      classes2.push("".concat(baseClassName2, "End"));
    }
    if (isRangeStart && isRangeEnd) {
      classes2.push("".concat(baseClassName2, "BothEnds"));
    }
  }
  return classes2;
}
function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, value = _ref.value, valueType = _ref.valueType, date = _ref.date, dateType = _ref.dateType, hover = _ref.hover;
  var className2 = "react-calendar__tile";
  var classes2 = [className2];
  if (!date) {
    return classes2;
  }
  if (!Array.isArray(date) && !dateType) {
    throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
  }
  var now2 = /* @__PURE__ */ new Date();
  var dateRange = Array.isArray(date) ? date : getRange(dateType, date);
  if (isValueWithinRange(now2, dateRange)) {
    classes2.push("".concat(className2, "--now"));
  }
  if (!value) {
    return classes2;
  }
  if (!Array.isArray(value) && !valueType) {
    throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
  }
  var valueRange = Array.isArray(value) ? value : getRange(valueType, value);
  if (isRangeWithinRange(valueRange, dateRange)) {
    classes2.push("".concat(className2, "--active"));
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes2.push("".concat(className2, "--hasActive"));
  }
  var valueRangeClassNames = getRangeClassNames(valueRange, dateRange, "".concat(className2, "--range"));
  classes2.push.apply(classes2, _toConsumableArray$1(valueRangeClassNames));
  var valueArray = [].concat(value);
  if (hover && valueArray.length === 1) {
    var hoverRange = hover > valueRange[0] ? [valueRange[0], hover] : [hover, valueRange[0]];
    var hoverRangeClassNames = getRangeClassNames(hoverRange, dateRange, "".concat(className2, "--hover"));
    classes2.push.apply(classes2, _toConsumableArray$1(hoverRangeClassNames));
  }
  return classes2;
}
var _excluded$8 = ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"];
function ownKeys$b(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$b(Object(source), true).forEach(function(key) {
      _defineProperty$b(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$b(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$b() {
  _extends$b = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$b.apply(this, arguments);
}
function _objectWithoutProperties$8(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$8(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$8(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function TileGroup(_ref) {
  var className2 = _ref.className, _ref$count = _ref.count, count = _ref$count === void 0 ? 3 : _ref$count, dateTransform = _ref.dateTransform, dateType = _ref.dateType, end = _ref.end, hover = _ref.hover, offset = _ref.offset, start = _ref.start, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step, Tile2 = _ref.tile, value = _ref.value, valueType = _ref.valueType, tileProps2 = _objectWithoutProperties$8(_ref, _excluded$8);
  var tiles = [];
  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    tiles.push(/* @__PURE__ */ React.createElement(Tile2, _extends$b({
      key: date.getTime(),
      classes: getTileClasses({
        value,
        valueType,
        date,
        dateType,
        hover
      }),
      date,
      point
    }, tileProps2)));
  }
  return /* @__PURE__ */ React.createElement(Flex, {
    className: className2,
    count,
    offset,
    wrap: true
  }, tiles);
}
TileGroup.propTypes = _objectSpread$b(_objectSpread$b({}, tileGroupProps), {}, {
  activeStartDate: PropTypes.instanceOf(Date),
  count: PropTypes.number,
  dateTransform: PropTypes.func.isRequired,
  dateType: PropTypes.string,
  offset: PropTypes.number,
  step: PropTypes.number,
  tile: PropTypes.func.isRequired
});
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function ownKeys$a(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$a(Object(source), true).forEach(function(key) {
      _defineProperty$a(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1(o, p);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
function _defineProperty$a(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
}
function getValue$1(nextProps, prop) {
  var activeStartDate = nextProps.activeStartDate, date = nextProps.date, view = nextProps.view;
  return typeof prop === "function" ? prop({
    activeStartDate,
    date,
    view
  }) : prop;
}
var Tile = /* @__PURE__ */ function(_Component) {
  _inherits$1(Tile2, _Component);
  var _super = _createSuper$1(Tile2);
  function Tile2() {
    var _this;
    _classCallCheck$1(this, Tile2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$a(_assertThisInitialized$1(_this), "state", {});
    return _this;
  }
  _createClass$1(Tile2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props, activeStartDate = _this$props.activeStartDate, children = _this$props.children, classes2 = _this$props.classes, date = _this$props.date, formatAbbr = _this$props.formatAbbr, locale2 = _this$props.locale, maxDate = _this$props.maxDate, maxDateTransform = _this$props.maxDateTransform, minDate = _this$props.minDate, minDateTransform = _this$props.minDateTransform, onClick2 = _this$props.onClick, onMouseOver = _this$props.onMouseOver, style = _this$props.style, tileDisabled = _this$props.tileDisabled, view = _this$props.view;
      var _this$state = this.state, tileClassName = _this$state.tileClassName, tileContent = _this$state.tileContent;
      return /* @__PURE__ */ React.createElement("button", {
        className: clsx(classes2, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
          activeStartDate,
          date,
          view
        }),
        onClick: onClick2 && function(event) {
          return onClick2(date, event);
        },
        onFocus: onMouseOver && function() {
          return onMouseOver(date);
        },
        onMouseOver: onMouseOver && function() {
          return onMouseOver(date);
        },
        style,
        type: "button"
      }, formatAbbr ? /* @__PURE__ */ React.createElement("abbr", {
        "aria-label": formatAbbr(locale2, date)
      }, children) : children, tileContent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var activeStartDate = nextProps.activeStartDate, tileClassName = nextProps.tileClassName, tileContent = nextProps.tileContent;
      var nextState = {};
      if (tileClassName !== prevState.tileClassNameProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
        nextState.tileClassName = getValue$1(nextProps, tileClassName);
        nextState.tileClassNameProps = tileClassName;
      }
      if (tileContent !== prevState.tileContentProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
        nextState.tileContent = getValue$1(nextProps, tileContent);
        nextState.tileContentProps = tileContent;
      }
      nextState.activeStartDateProps = activeStartDate;
      return nextState;
    }
  }]);
  return Tile2;
}(Component);
Tile.propTypes = _objectSpread$a(_objectSpread$a({}, tileProps), {}, {
  children: PropTypes.node.isRequired,
  formatAbbr: PropTypes.func,
  maxDateTransform: PropTypes.func.isRequired,
  minDateTransform: PropTypes.func.isRequired
});
var _excluded$7 = ["classes", "formatYear"];
function ownKeys$9(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$9(Object(source), true).forEach(function(key) {
      _defineProperty$9(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$a() {
  _extends$a = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$a.apply(this, arguments);
}
function _objectWithoutProperties$7(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$7(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var className$5 = "react-calendar__century-view__decades__decade";
function Decade(_ref) {
  var classes2 = _ref.classes, _ref$formatYear = _ref.formatYear, formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear, otherProps = _objectWithoutProperties$7(_ref, _excluded$7);
  var date = otherProps.date, locale2 = otherProps.locale;
  return /* @__PURE__ */ React.createElement(Tile, _extends$a({}, otherProps, {
    classes: [].concat(classes2, className$5),
    maxDateTransform: getDecadeEnd,
    minDateTransform: getDecadeStart,
    view: "century"
  }), getDecadeLabel(locale2, formatYear$1, date));
}
Decade.propTypes = _objectSpread$9(_objectSpread$9({}, tileProps), {}, {
  formatYear: PropTypes.func
});
function ownKeys$8(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$8(Object(source), true).forEach(function(key) {
      _defineProperty$8(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$9.apply(this, arguments);
}
function Decades(props) {
  var activeStartDate = props.activeStartDate;
  var start = getBeginOfCenturyYear(activeStartDate);
  var end = start + 99;
  return /* @__PURE__ */ React.createElement(TileGroup, _extends$9({}, props, {
    className: "react-calendar__century-view__decades",
    dateTransform: getDecadeStart,
    dateType: "decade",
    end,
    start,
    step: 10,
    tile: Decade
  }));
}
Decades.propTypes = _objectSpread$8({}, tileGroupProps);
function CenturyView(props) {
  function renderDecades() {
    return /* @__PURE__ */ React.createElement(Decades, props);
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "react-calendar__century-view"
  }, renderDecades());
}
var _excluded$6 = ["classes", "formatYear"];
function ownKeys$7(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$7(Object(source), true).forEach(function(key) {
      _defineProperty$7(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$8() {
  _extends$8 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$8.apply(this, arguments);
}
function _objectWithoutProperties$6(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$6(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var className$4 = "react-calendar__decade-view__years__year";
function Year(_ref) {
  var classes2 = _ref.classes, _ref$formatYear = _ref.formatYear, formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear, otherProps = _objectWithoutProperties$6(_ref, _excluded$6);
  var date = otherProps.date, locale2 = otherProps.locale;
  return /* @__PURE__ */ React.createElement(Tile, _extends$8({}, otherProps, {
    classes: [].concat(classes2, className$4),
    maxDateTransform: getYearEnd,
    minDateTransform: getYearStart,
    view: "decade"
  }), formatYear$1(locale2, date));
}
Year.propTypes = _objectSpread$7(_objectSpread$7({}, tileProps), {}, {
  formatYear: PropTypes.func
});
function ownKeys$6(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$6(Object(source), true).forEach(function(key) {
      _defineProperty$6(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$7() {
  _extends$7 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$7.apply(this, arguments);
}
function Years(props) {
  var activeStartDate = props.activeStartDate;
  var start = getBeginOfDecadeYear(activeStartDate);
  var end = start + 9;
  return /* @__PURE__ */ React.createElement(TileGroup, _extends$7({}, props, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(year) {
      var date = /* @__PURE__ */ new Date();
      date.setFullYear(year, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "year",
    end,
    start,
    tile: Year
  }));
}
Years.propTypes = _objectSpread$6({}, tileGroupProps);
function DecadeView(props) {
  function renderYears() {
    return /* @__PURE__ */ React.createElement(Years, props);
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "react-calendar__decade-view"
  }, renderYears());
}
var _excluded$5 = ["classes", "formatMonth", "formatMonthYear"];
function ownKeys$5(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$5(Object(source), true).forEach(function(key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}
function _objectWithoutProperties$5(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$5(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var className$3 = "react-calendar__year-view__months__month";
function Month(_ref) {
  var classes2 = _ref.classes, _ref$formatMonth = _ref.formatMonth, formatMonth$1 = _ref$formatMonth === void 0 ? formatMonth : _ref$formatMonth, _ref$formatMonthYear = _ref.formatMonthYear, formatMonthYear$1 = _ref$formatMonthYear === void 0 ? formatMonthYear : _ref$formatMonthYear, otherProps = _objectWithoutProperties$5(_ref, _excluded$5);
  var date = otherProps.date, locale2 = otherProps.locale;
  return /* @__PURE__ */ React.createElement(Tile, _extends$6({}, otherProps, {
    classes: [].concat(classes2, className$3),
    formatAbbr: formatMonthYear$1,
    maxDateTransform: getMonthEnd,
    minDateTransform: getMonthStart,
    view: "year"
  }), formatMonth$1(locale2, date));
}
Month.propTypes = _objectSpread$5(_objectSpread$5({}, tileProps), {}, {
  formatMonth: PropTypes.func,
  formatMonthYear: PropTypes.func
});
function ownKeys$4(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
function Months(props) {
  var activeStartDate = props.activeStartDate;
  var start = 0;
  var end = 11;
  var year = getYear(activeStartDate);
  return /* @__PURE__ */ React.createElement(TileGroup, _extends$5({}, props, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      var date = /* @__PURE__ */ new Date();
      date.setFullYear(year, monthIndex, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "month",
    end,
    start,
    tile: Month
  }));
}
Months.propTypes = _objectSpread$4(_objectSpread$4({}, tileGroupProps), {}, {
  locale: PropTypes.string
});
function YearView(props) {
  function renderMonths() {
    return /* @__PURE__ */ React.createElement(Months, props);
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "react-calendar__year-view"
  }, renderMonths());
}
var _excluded$4 = ["formatDay", "formatLongDate", "calendarType", "classes", "currentMonthIndex"];
function ownKeys$3(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$4(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var className$2 = "react-calendar__month-view__days__day";
function Day(_ref) {
  var _ref$formatDay = _ref.formatDay, formatDay$1 = _ref$formatDay === void 0 ? formatDay : _ref$formatDay, _ref$formatLongDate = _ref.formatLongDate, formatLongDate$1 = _ref$formatLongDate === void 0 ? formatLongDate : _ref$formatLongDate, calendarType = _ref.calendarType, classes2 = _ref.classes, currentMonthIndex = _ref.currentMonthIndex, otherProps = _objectWithoutProperties$4(_ref, _excluded$4);
  var date = otherProps.date, locale2 = otherProps.locale;
  return /* @__PURE__ */ React.createElement(Tile, _extends$4({}, otherProps, {
    classes: [].concat(classes2, className$2, isWeekend(date, calendarType) ? "".concat(className$2, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className$2, "--neighboringMonth") : null),
    formatAbbr: formatLongDate$1,
    maxDateTransform: getDayEnd,
    minDateTransform: getDayStart,
    view: "month"
  }), formatDay$1(locale2, date));
}
Day.propTypes = _objectSpread$3(_objectSpread$3({}, tileProps), {}, {
  currentMonthIndex: PropTypes.number.isRequired,
  formatDay: PropTypes.func,
  formatLongDate: PropTypes.func
});
var _excluded$3 = ["showFixedNumberOfWeeks", "showNeighboringMonth"];
function ownKeys$2(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function Days(props) {
  var activeStartDate = props.activeStartDate, calendarType = props.calendarType;
  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, showNeighboringMonth = props.showNeighboringMonth, otherProps = _objectWithoutProperties$3(props, _excluded$3);
  var year = getYear(activeStartDate);
  var monthIndex = getMonth(activeStartDate);
  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
  var dayOfWeek = getDayOfWeek(activeStartDate, calendarType);
  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
  var end = function() {
    if (showFixedNumberOfWeeks) {
      return start + 6 * 7 - 1;
    }
    var daysInMonth2 = getDaysInMonth(activeStartDate);
    if (showNeighboringMonth) {
      var activeEndDate = /* @__PURE__ */ new Date();
      activeEndDate.setFullYear(year, monthIndex, daysInMonth2);
      activeEndDate.setHours(0, 0, 0, 0);
      var daysUntilEndOfTheWeek = 7 - getDayOfWeek(activeEndDate, calendarType) - 1;
      return daysInMonth2 + daysUntilEndOfTheWeek;
    }
    return daysInMonth2;
  }();
  return /* @__PURE__ */ React.createElement(TileGroup, _extends$3({}, otherProps, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: monthIndex,
    dateTransform: function dateTransform(day) {
      var date = /* @__PURE__ */ new Date();
      date.setFullYear(year, monthIndex, day);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "day",
    end,
    offset,
    start,
    tile: Day
  }));
}
Days.propTypes = _objectSpread$2({
  calendarType: isCalendarType.isRequired,
  showFixedNumberOfWeeks: PropTypes.bool,
  showNeighboringMonth: PropTypes.bool
}, tileGroupProps);
var className$1 = "react-calendar__month-view__weekdays";
var weekdayClassName = "".concat(className$1, "__weekday");
function Weekdays(props) {
  var calendarType = props.calendarType, _props$formatShortWee = props.formatShortWeekday, formatShortWeekday$1 = _props$formatShortWee === void 0 ? formatShortWeekday : _props$formatShortWee, _props$formatWeekday = props.formatWeekday, formatWeekday$1 = _props$formatWeekday === void 0 ? formatWeekday : _props$formatWeekday, locale2 = props.locale, onMouseLeave = props.onMouseLeave;
  var anyDate = /* @__PURE__ */ new Date();
  var beginOfMonth = getMonthStart(anyDate);
  var year = getYear(beginOfMonth);
  var monthIndex = getMonth(beginOfMonth);
  var weekdays = [];
  for (var weekday = 1; weekday <= 7; weekday += 1) {
    var weekdayDate = new Date(year, monthIndex, weekday - getDayOfWeek(beginOfMonth, calendarType));
    var abbr = formatWeekday$1(locale2, weekdayDate);
    weekdays.push(/* @__PURE__ */ React.createElement("div", {
      key: weekday,
      className: clsx(weekdayClassName, isWeekend(weekdayDate, calendarType) && "".concat(weekdayClassName, "--weekend"))
    }, /* @__PURE__ */ React.createElement("abbr", {
      "aria-label": abbr,
      title: abbr
    }, formatShortWeekday$1(locale2, weekdayDate).replace(".", ""))));
  }
  return /* @__PURE__ */ React.createElement(Flex, {
    className: className$1,
    count: 7,
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave
  }, weekdays);
}
Weekdays.propTypes = {
  calendarType: isCalendarType.isRequired,
  formatShortWeekday: PropTypes.func,
  formatWeekday: PropTypes.func,
  locale: PropTypes.string,
  onMouseLeave: PropTypes.func
};
var _excluded$2 = ["date", "onClickWeekNumber", "weekNumber"];
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function ownKeys$1(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var className = "react-calendar__tile";
function WeekNumber(_ref) {
  var date = _ref.date, onClickWeekNumber = _ref.onClickWeekNumber, weekNumber = _ref.weekNumber, otherProps = _objectWithoutProperties$2(_ref, _excluded$2);
  var props = _objectSpread$1({
    className
  }, otherProps);
  var children = /* @__PURE__ */ React.createElement("span", null, weekNumber);
  return onClickWeekNumber ? /* @__PURE__ */ React.createElement("button", _extends$2({}, props, {
    onClick: function onClick2(event) {
      return onClickWeekNumber(weekNumber, date, event);
    },
    type: "button"
  }), children) : /* @__PURE__ */ React.createElement("div", props, children);
}
WeekNumber.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  onClickWeekNumber: PropTypes.func,
  weekNumber: PropTypes.node.isRequired
};
function WeekNumbers(props) {
  var activeStartDate = props.activeStartDate, calendarType = props.calendarType, onClickWeekNumber = props.onClickWeekNumber, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
  var numberOfWeeks = function() {
    if (showFixedNumberOfWeeks) {
      return 6;
    }
    var numberOfDays = getDaysInMonth(activeStartDate);
    var startWeekday = getDayOfWeek(activeStartDate, calendarType);
    var days = numberOfDays - (7 - startWeekday);
    return 1 + Math.ceil(days / 7);
  }();
  var dates = function() {
    var year = getYear(activeStartDate);
    var monthIndex = getMonth(activeStartDate);
    var day = getDate(activeStartDate);
    var result = [];
    for (var index2 = 0; index2 < numberOfWeeks; index2 += 1) {
      result.push(getBeginOfWeek(new Date(year, monthIndex, day + index2 * 7), calendarType));
    }
    return result;
  }();
  var weekNumbers = dates.map(function(date) {
    return getWeekNumber(date, calendarType);
  });
  return /* @__PURE__ */ React.createElement(Flex, {
    className: "react-calendar__month-view__weekNumbers",
    count: numberOfWeeks,
    direction: "column",
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave,
    style: {
      flexBasis: "calc(100% * (1 / 8)",
      flexShrink: 0
    }
  }, weekNumbers.map(function(weekNumber, weekIndex) {
    return /* @__PURE__ */ React.createElement(WeekNumber, {
      key: weekNumber,
      date: dates[weekIndex],
      onClickWeekNumber,
      weekNumber
    });
  }));
}
WeekNumbers.propTypes = {
  activeStartDate: PropTypes.instanceOf(Date).isRequired,
  calendarType: isCalendarType.isRequired,
  onClickWeekNumber: PropTypes.func,
  onMouseLeave: PropTypes.func,
  showFixedNumberOfWeeks: PropTypes.bool
};
var _excluded$1 = ["calendarType", "formatShortWeekday", "formatWeekday", "onClickWeekNumber", "showWeekNumbers"];
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function getCalendarTypeFromLocale(locale2) {
  return Object.keys(CALENDAR_TYPE_LOCALES).find(function(calendarType) {
    return CALENDAR_TYPE_LOCALES[calendarType].includes(locale2);
  }) || CALENDAR_TYPES.ISO_8601;
}
function MonthView(props) {
  var activeStartDate = props.activeStartDate, locale2 = props.locale, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
  var _props$calendarType = props.calendarType, calendarType = _props$calendarType === void 0 ? getCalendarTypeFromLocale(locale2) : _props$calendarType, formatShortWeekday2 = props.formatShortWeekday, formatWeekday2 = props.formatWeekday, onClickWeekNumber = props.onClickWeekNumber, showWeekNumbers = props.showWeekNumbers, childProps = _objectWithoutProperties$1(props, _excluded$1);
  function renderWeekdays() {
    return /* @__PURE__ */ React.createElement(Weekdays, {
      calendarType,
      formatShortWeekday: formatShortWeekday2,
      formatWeekday: formatWeekday2,
      locale: locale2,
      onMouseLeave
    });
  }
  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(WeekNumbers, {
      activeStartDate,
      calendarType,
      onClickWeekNumber,
      onMouseLeave,
      showFixedNumberOfWeeks
    });
  }
  function renderDays() {
    return /* @__PURE__ */ React.createElement(Days, _extends$1({
      calendarType
    }, childProps));
  }
  var className2 = "react-calendar__month-view";
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx(className2, showWeekNumbers ? "".concat(className2, "--weekNumbers") : "")
  }, /* @__PURE__ */ React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "flex-end"
    }
  }, renderWeekNumbers(), /* @__PURE__ */ React.createElement("div", {
    style: {
      flexGrow: 1,
      width: "100%"
    }
  }, renderWeekdays(), renderDays())));
}
MonthView.propTypes = {
  activeStartDate: PropTypes.instanceOf(Date).isRequired,
  calendarType: isCalendarType,
  formatShortWeekday: PropTypes.func,
  formatWeekday: PropTypes.func,
  locale: PropTypes.string,
  onClickWeekNumber: PropTypes.func,
  onMouseLeave: PropTypes.func,
  showFixedNumberOfWeeks: PropTypes.bool,
  showWeekNumbers: PropTypes.bool
};
var _excluded = ["activeStartDate", "defaultActiveStartDate", "defaultValue", "defaultView", "maxDetail", "minDetail", "value", "view"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function ownKeys(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var defaultMinDate = /* @__PURE__ */ new Date();
defaultMinDate.setFullYear(1, 0, 1);
defaultMinDate.setHours(0, 0, 0, 0);
var defaultMaxDate = /* @__PURE__ */ new Date(864e13);
var baseClassName = "react-calendar";
var allViews = ["century", "decade", "year", "month"];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ["day"]);
function toDate(value) {
  if (value instanceof Date) {
    return value;
  }
  return new Date(value);
}
function getLimitedViews(minDetail, maxDetail) {
  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
}
function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);
  return views.indexOf(view) !== -1;
}
function getView(view, minDetail, maxDetail) {
  if (isViewAllowed(view, minDetail, maxDetail)) {
    return view;
  }
  return maxDetail;
}
function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
}
function getValue(value, index2) {
  if (!value) {
    return null;
  }
  var rawValue = Array.isArray(value) && value.length === 2 ? value[index2] : value;
  if (!rawValue) {
    return null;
  }
  var valueDate = toDate(rawValue);
  if (isNaN(valueDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }
  return valueDate;
}
function getDetailValue(_ref, index2) {
  var value = _ref.value, minDate = _ref.minDate, maxDate = _ref.maxDate, maxDetail = _ref.maxDetail;
  var valuePiece = getValue(value, index2);
  if (!valuePiece) {
    return null;
  }
  var valueType = getValueType(maxDetail);
  var detailValueFrom = [getBegin, getEnd][index2](valueType, valuePiece);
  return between(detailValueFrom, minDate, maxDate);
}
var getDetailValueFrom = function getDetailValueFrom2(args) {
  return getDetailValue(args, 0);
};
var getDetailValueTo = function getDetailValueTo2(args) {
  return getDetailValue(args, 1);
};
var getDetailValueArray = function getDetailValueArray2(args) {
  var value = args.value;
  if (Array.isArray(value)) {
    return value;
  }
  return [getDetailValueFrom, getDetailValueTo].map(function(fn) {
    return fn(args);
  });
};
function getActiveStartDate(props) {
  var maxDate = props.maxDate, maxDetail = props.maxDetail, minDate = props.minDate, minDetail = props.minDetail, value = props.value, view = props.view;
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom({
    value,
    minDate,
    maxDate,
    maxDetail
  }) || /* @__PURE__ */ new Date();
  return getBegin(rangeType, valueFrom);
}
function getInitialActiveStartDate(props) {
  var activeStartDate = props.activeStartDate, defaultActiveStartDate = props.defaultActiveStartDate, defaultValue = props.defaultValue, defaultView = props.defaultView, maxDetail = props.maxDetail, minDetail = props.minDetail, value = props.value, view = props.view, otherProps = _objectWithoutProperties(props, _excluded);
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = activeStartDate || defaultActiveStartDate;
  if (valueFrom) {
    return getBegin(rangeType, valueFrom);
  }
  return getActiveStartDate(_objectSpread({
    maxDetail,
    minDetail,
    value: value || defaultValue,
    view: view || defaultView
  }, otherProps));
}
var getIsSingleValue = function getIsSingleValue2(value) {
  return value && [].concat(value).length === 1;
};
var Calendar$1 = /* @__PURE__ */ function(_Component) {
  _inherits(Calendar2, _Component);
  var _super = _createSuper(Calendar2);
  function Calendar2() {
    var _this;
    _classCallCheck(this, Calendar2);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      activeStartDate: _this.props.defaultActiveStartDate,
      value: _this.props.defaultValue,
      view: _this.props.defaultView
    });
    _defineProperty(_assertThisInitialized(_this), "setStateAndCallCallbacks", function(nextState, event, callback) {
      var _assertThisInitialize = _assertThisInitialized(_this), previousActiveStartDate = _assertThisInitialize.activeStartDate, previousView = _assertThisInitialize.view;
      var _this$props = _this.props, allowPartialRange = _this$props.allowPartialRange, onActiveStartDateChange = _this$props.onActiveStartDateChange, onChange = _this$props.onChange, onViewChange = _this$props.onViewChange, selectRange = _this$props.selectRange;
      var prevArgs = {
        activeStartDate: previousActiveStartDate,
        view: previousView
      };
      _this.setState(nextState, function() {
        var args = {
          action: nextState.action,
          activeStartDate: nextState.activeStartDate || _this.activeStartDate,
          value: nextState.value || _this.value,
          view: nextState.view || _this.view
        };
        function shouldUpdate(key) {
          return (
            // Key must exist, and…
            key in nextState && // …key changed from undefined to defined or the other way around, or…
            (_typeof(nextState[key]) !== _typeof(prevArgs[key]) || // …value changed.
            (nextState[key] instanceof Date ? nextState[key].getTime() !== prevArgs[key].getTime() : nextState[key] !== prevArgs[key]))
          );
        }
        if (shouldUpdate("activeStartDate")) {
          if (onActiveStartDateChange) onActiveStartDateChange(args);
        }
        if (shouldUpdate("view")) {
          if (onViewChange) onViewChange(args);
        }
        if (shouldUpdate("value")) {
          if (onChange) {
            if (selectRange) {
              var isSingleValue = getIsSingleValue(nextState.value);
              if (!isSingleValue) {
                onChange(nextState.value, event);
              } else if (allowPartialRange) {
                onChange([nextState.value], event);
              }
            } else {
              onChange(nextState.value, event);
            }
          }
        }
        if (callback) callback(args);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function(nextActiveStartDate, action) {
      _this.setStateAndCallCallbacks({
        action,
        activeStartDate: nextActiveStartDate
      });
    });
    _defineProperty(_assertThisInitialized(_this), "drillDown", function(nextActiveStartDate, event) {
      if (!_this.drillDownAvailable) {
        return;
      }
      _this.onClickTile(nextActiveStartDate, event);
      var _assertThisInitialize2 = _assertThisInitialized(_this), view = _assertThisInitialize2.view, views = _assertThisInitialize2.views;
      var onDrillDown = _this.props.onDrillDown;
      var nextView = views[views.indexOf(view) + 1];
      _this.setStateAndCallCallbacks({
        action: "drillDown",
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, void 0, onDrillDown);
    });
    _defineProperty(_assertThisInitialized(_this), "drillUp", function() {
      if (!_this.drillUpAvailable) {
        return;
      }
      var _assertThisInitialize3 = _assertThisInitialized(_this), activeStartDate = _assertThisInitialize3.activeStartDate, view = _assertThisInitialize3.view, views = _assertThisInitialize3.views;
      var onDrillUp = _this.props.onDrillUp;
      var nextView = views[views.indexOf(view) - 1];
      var nextActiveStartDate = getBegin(nextView, activeStartDate);
      _this.setStateAndCallCallbacks({
        action: "drillUp",
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, void 0, onDrillUp);
    });
    _defineProperty(_assertThisInitialized(_this), "onChange", function(value, event) {
      var _assertThisInitialize4 = _assertThisInitialized(_this), previousValue = _assertThisInitialize4.value;
      var _this$props2 = _this.props, goToRangeStartOnSelect = _this$props2.goToRangeStartOnSelect, selectRange = _this$props2.selectRange;
      _this.onClickTile(value, event);
      var isFirstValueInRange = selectRange && !getIsSingleValue(previousValue);
      var nextValue;
      if (selectRange) {
        var _assertThisInitialize5 = _assertThisInitialized(_this), valueType = _assertThisInitialize5.valueType;
        if (isFirstValueInRange) {
          nextValue = getBegin(valueType, value);
        } else {
          nextValue = getValueRange(valueType, previousValue, value);
        }
      } else {
        nextValue = _this.getProcessedValue(value);
      }
      var nextActiveStartDate = (
        // Range selection turned off
        !selectRange || // Range selection turned on, first value
        isFirstValueInRange || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
        goToRangeStartOnSelect ? getActiveStartDate(_objectSpread(_objectSpread({}, _this.props), {}, {
          value: nextValue
        })) : null
      );
      event.persist();
      _this.setStateAndCallCallbacks({
        action: "onChange",
        activeStartDate: nextActiveStartDate,
        value: nextValue
      }, event);
    });
    _defineProperty(_assertThisInitialized(_this), "onClickTile", function(value, event) {
      var _assertThisInitialize6 = _assertThisInitialized(_this), view = _assertThisInitialize6.view;
      var _this$props3 = _this.props, onClickDay = _this$props3.onClickDay, onClickDecade = _this$props3.onClickDecade, onClickMonth = _this$props3.onClickMonth, onClickYear = _this$props3.onClickYear;
      var callback = function() {
        switch (view) {
          case "century":
            return onClickDecade;
          case "decade":
            return onClickYear;
          case "year":
            return onClickMonth;
          case "month":
            return onClickDay;
          default:
            throw new Error("Invalid view: ".concat(view, "."));
        }
      }();
      if (callback) callback(value, event);
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function(value) {
      _this.setState(function(prevState) {
        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
          return null;
        }
        return {
          hover: value
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function() {
      _this.setState({
        hover: null
      });
    });
    return _this;
  }
  _createClass(Calendar2, [{
    key: "activeStartDate",
    get: function get() {
      var activeStartDateProps = this.props.activeStartDate;
      var activeStartDateState = this.state.activeStartDate;
      return activeStartDateProps || activeStartDateState || getInitialActiveStartDate(this.props);
    }
  }, {
    key: "value",
    get: function get() {
      var _this$props4 = this.props, selectRange = _this$props4.selectRange, valueProps = _this$props4.value;
      var valueState = this.state.value;
      if (selectRange && getIsSingleValue(valueState)) {
        return valueState;
      }
      return valueProps !== void 0 ? valueProps : valueState;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }, {
    key: "view",
    get: function get() {
      var _this$props5 = this.props, minDetail = _this$props5.minDetail, maxDetail = _this$props5.maxDetail, viewProps = _this$props5.view;
      var viewState = this.state.view;
      return getView(viewProps || viewState, minDetail, maxDetail);
    }
  }, {
    key: "views",
    get: function get() {
      var _this$props6 = this.props, minDetail = _this$props6.minDetail, maxDetail = _this$props6.maxDetail;
      return getLimitedViews(minDetail, maxDetail);
    }
  }, {
    key: "hover",
    get: function get() {
      var selectRange = this.props.selectRange;
      var hover = this.state.hover;
      return selectRange ? hover : null;
    }
  }, {
    key: "drillDownAvailable",
    get: function get() {
      var view = this.view, views = this.views;
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var view = this.view, views = this.views;
      return views.indexOf(view) > 0;
    }
    /**
     * Gets current value in a desired format.
     */
  }, {
    key: "getProcessedValue",
    value: function getProcessedValue(value) {
      var _this$props7 = this.props, minDate = _this$props7.minDate, maxDate = _this$props7.maxDate, maxDetail = _this$props7.maxDetail, returnValue = _this$props7.returnValue;
      var processFunction = function() {
        switch (returnValue) {
          case "start":
            return getDetailValueFrom;
          case "end":
            return getDetailValueTo;
          case "range":
            return getDetailValueArray;
          default:
            throw new Error("Invalid returnValue.");
        }
      }();
      return processFunction({
        value,
        minDate,
        maxDate,
        maxDetail
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent(next) {
      var currentActiveStartDate = this.activeStartDate, onMouseOver = this.onMouseOver, valueType = this.valueType, value = this.value, view = this.view;
      var _this$props8 = this.props, calendarType = _this$props8.calendarType, locale2 = _this$props8.locale, maxDate = _this$props8.maxDate, minDate = _this$props8.minDate, selectRange = _this$props8.selectRange, tileClassName = _this$props8.tileClassName, tileContent = _this$props8.tileContent, tileDisabled = _this$props8.tileDisabled;
      var hover = this.hover;
      var activeStartDate = next ? getBeginNext(view, currentActiveStartDate) : getBegin(view, currentActiveStartDate);
      var onClick2 = this.drillDownAvailable ? this.drillDown : this.onChange;
      var commonProps = {
        activeStartDate,
        hover,
        locale: locale2,
        maxDate,
        minDate,
        onClick: onClick2,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName,
        tileContent,
        tileDisabled,
        value,
        valueType
      };
      switch (view) {
        case "century": {
          var formatYear2 = this.props.formatYear;
          return /* @__PURE__ */ React.createElement(CenturyView, _extends({
            formatYear: formatYear2
          }, commonProps));
        }
        case "decade": {
          var _formatYear = this.props.formatYear;
          return /* @__PURE__ */ React.createElement(DecadeView, _extends({
            formatYear: _formatYear
          }, commonProps));
        }
        case "year": {
          var _this$props9 = this.props, formatMonth2 = _this$props9.formatMonth, formatMonthYear2 = _this$props9.formatMonthYear;
          return /* @__PURE__ */ React.createElement(YearView, _extends({
            formatMonth: formatMonth2,
            formatMonthYear: formatMonthYear2
          }, commonProps));
        }
        case "month": {
          var _this$props10 = this.props, formatDay2 = _this$props10.formatDay, formatLongDate2 = _this$props10.formatLongDate, formatShortWeekday2 = _this$props10.formatShortWeekday, formatWeekday2 = _this$props10.formatWeekday, onClickWeekNumber = _this$props10.onClickWeekNumber, showDoubleView = _this$props10.showDoubleView, showFixedNumberOfWeeks = _this$props10.showFixedNumberOfWeeks, showNeighboringMonth = _this$props10.showNeighboringMonth, showWeekNumbers = _this$props10.showWeekNumbers;
          var onMouseLeave = this.onMouseLeave;
          return /* @__PURE__ */ React.createElement(MonthView, _extends({
            calendarType,
            formatDay: formatDay2,
            formatLongDate: formatLongDate2,
            formatShortWeekday: formatShortWeekday2,
            formatWeekday: formatWeekday2,
            onClickWeekNumber,
            onMouseLeave: selectRange ? onMouseLeave : null,
            showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== "undefined" ? showFixedNumberOfWeeks : showDoubleView,
            showNeighboringMonth,
            showWeekNumbers
          }, commonProps));
        }
        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;
      if (!showNavigation) {
        return null;
      }
      var activeStartDate = this.activeStartDate, view = this.view, views = this.views;
      var _this$props11 = this.props, formatMonthYear2 = _this$props11.formatMonthYear, formatYear2 = _this$props11.formatYear, locale2 = _this$props11.locale, maxDate = _this$props11.maxDate, minDate = _this$props11.minDate, navigationAriaLabel = _this$props11.navigationAriaLabel, navigationAriaLive = _this$props11.navigationAriaLive, navigationLabel = _this$props11.navigationLabel, next2AriaLabel = _this$props11.next2AriaLabel, next2Label = _this$props11.next2Label, nextAriaLabel = _this$props11.nextAriaLabel, nextLabel = _this$props11.nextLabel, prev2AriaLabel = _this$props11.prev2AriaLabel, prev2Label = _this$props11.prev2Label, prevAriaLabel = _this$props11.prevAriaLabel, prevLabel = _this$props11.prevLabel, showDoubleView = _this$props11.showDoubleView;
      return /* @__PURE__ */ React.createElement(Navigation, {
        activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear2,
        formatYear: formatYear2,
        locale: locale2,
        maxDate,
        minDate,
        navigationAriaLabel,
        navigationAriaLive,
        navigationLabel,
        next2AriaLabel,
        next2Label,
        nextAriaLabel,
        nextLabel,
        prev2AriaLabel,
        prev2Label,
        prevAriaLabel,
        prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        showDoubleView,
        view,
        views
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props, className2 = _this$props12.className, inputRef = _this$props12.inputRef, selectRange = _this$props12.selectRange, showDoubleView = _this$props12.showDoubleView;
      var onMouseLeave = this.onMouseLeave, value = this.value;
      var valueArray = [].concat(value);
      return /* @__PURE__ */ React.createElement("div", {
        className: clsx(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), showDoubleView && "".concat(baseClassName, "--doubleView"), className2),
        ref: inputRef
      }, this.renderNavigation(), /* @__PURE__ */ React.createElement("div", {
        className: "".concat(baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : null,
        onMouseLeave: selectRange ? onMouseLeave : null
      }, this.renderContent(), showDoubleView && this.renderContent(true)));
    }
  }]);
  return Calendar2;
}(Component);
Calendar$1.defaultProps = {
  goToRangeStartOnSelect: true,
  maxDate: defaultMaxDate,
  maxDetail: "month",
  minDate: defaultMinDate,
  minDetail: "century",
  returnValue: "start",
  showNavigation: true,
  showNeighboringMonth: true
};
var isActiveStartDate = PropTypes.instanceOf(Date);
var isLooseValue = PropTypes.oneOfType([PropTypes.string, isValue]);
Calendar$1.propTypes = {
  activeStartDate: isActiveStartDate,
  allowPartialRange: PropTypes.bool,
  calendarType: isCalendarType,
  className: isClassName,
  defaultActiveStartDate: isActiveStartDate,
  defaultValue: isLooseValue,
  defaultView: isView,
  formatDay: PropTypes.func,
  formatLongDate: PropTypes.func,
  formatMonth: PropTypes.func,
  formatMonthYear: PropTypes.func,
  formatShortWeekday: PropTypes.func,
  formatWeekday: PropTypes.func,
  formatYear: PropTypes.func,
  goToRangeStartOnSelect: PropTypes.bool,
  inputRef: isRef,
  locale: PropTypes.string,
  maxDate: isMaxDate,
  maxDetail: PropTypes.oneOf(allViews),
  minDate: isMinDate,
  minDetail: PropTypes.oneOf(allViews),
  navigationAriaLabel: PropTypes.string,
  navigationAriaLive: PropTypes.oneOf(["off", "polite", "assertive"]),
  navigationLabel: PropTypes.func,
  next2AriaLabel: PropTypes.string,
  next2Label: PropTypes.node,
  nextAriaLabel: PropTypes.string,
  nextLabel: PropTypes.node,
  onActiveStartDateChange: PropTypes.func,
  onChange: PropTypes.func,
  onClickDay: PropTypes.func,
  onClickDecade: PropTypes.func,
  onClickMonth: PropTypes.func,
  onClickWeekNumber: PropTypes.func,
  onClickYear: PropTypes.func,
  onDrillDown: PropTypes.func,
  onDrillUp: PropTypes.func,
  onViewChange: PropTypes.func,
  prev2AriaLabel: PropTypes.string,
  prev2Label: PropTypes.node,
  prevAriaLabel: PropTypes.string,
  prevLabel: PropTypes.node,
  returnValue: PropTypes.oneOf(["start", "end", "range"]),
  selectRange: PropTypes.bool,
  showDoubleView: PropTypes.bool,
  showFixedNumberOfWeeks: PropTypes.bool,
  showNavigation: PropTypes.bool,
  showNeighboringMonth: PropTypes.bool,
  showWeekNumbers: PropTypes.bool,
  tileClassName: PropTypes.oneOfType([PropTypes.func, isClassName]),
  tileContent: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  tileDisabled: PropTypes.func,
  value: isLooseValue,
  view: isView
};
const Calendar = (props) => {
  const {
    clickDayHandler,
    showNeighboringMonth,
    activeStartDate,
    activeStartDateChangeHandler,
    formatShortWeekday: formatShortWeekday2,
    calendarType,
    locale: locale2,
    higherNextLabel,
    higherPrevLabel,
    nextLabel,
    prevLabel,
    maxDetail,
    minDetail,
    tileContentHandler,
    tileClassNameHandler,
    minDate,
    maxDate,
    tileDisabledHandler,
    value
  } = props;
  return /* @__PURE__ */ jsx(
    Calendar$1,
    {
      onClickDay: clickDayHandler,
      showNeighboringMonth,
      activeStartDate,
      onActiveStartDateChange: activeStartDateChangeHandler,
      formatShortWeekday: formatShortWeekday2,
      calendarType,
      locale: locale2,
      next2Label: higherNextLabel,
      prev2Label: higherPrevLabel,
      nextLabel,
      prevLabel,
      maxDetail,
      minDetail,
      tileContent: tileContentHandler,
      tileClassName: tileClassNameHandler,
      minDate,
      maxDate,
      tileDisabled: tileDisabledHandler,
      value
    }
  );
};
Calendar.displayName = "CalendarInLib";
const SkinnyBannerModal = ({ ...props }) => {
  const {
    modalHeading,
    isModalOpen,
    modalDescription,
    modalSecondaryHeader,
    optionalCTALink,
    optionalCTALabel,
    modalLogo,
    usModalImgAltText,
    setModalOpen,
    usModalDesktopBgImg,
    usModalMobileBgImg,
    closeCtaAccessibilityLabel,
    ctaAccessibilityLabel,
    optionalCTAHandler,
    disclaimerMessage
  } = props;
  const previousElement = document.querySelector(`button[${previousElementName}]`);
  const skinnyBannerRef = useRef(null);
  const componentName = `${PREFIX}-ultra-slim-banner__modal`;
  const [isMobile2, setIsMobile] = useState(window.innerWidth <= BREAKPOINTS.mobileMaxWidth);
  const setDisclaimerElementHeight = () => {
    const disclaimerTextElement = document.getElementsByClassName(
      `${PREFIX}-ultra-slim-banner__modal-text-disclaimer`
    )[0];
    disclaimerTextElement == null ? void 0 : disclaimerTextElement.setAttribute(
      "style",
      // eslint-disable-next-line no-unsafe-optional-chaining
      `height: ${window.innerHeight - (disclaimerTextElement == null ? void 0 : disclaimerTextElement.offsetTop) - magicNumber.EIGHTY}px`
    );
  };
  useEffect(() => {
    setDisclaimerElementHeight();
  }, [isModalOpen]);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= BREAKPOINTS.mobileMaxWidth);
    setDisclaimerElementHeight();
  };
  useGlobalResizeEvent(handleResize);
  const closeHandler = () => {
    setModalOpen(false);
    if (previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  useClickOutsideClose(skinnyBannerRef, closeHandler, isModalOpen, true);
  return /* @__PURE__ */ jsx(ReactModal, { isOpen: isModalOpen, closeHandler: () => closeHandler(), children: /* @__PURE__ */ jsxs("div", { ref: skinnyBannerRef, className: `${componentName}`, children: [
    /* @__PURE__ */ jsxs(
      "section",
      {
        style: {
          backgroundImage: `url(${isMobile2 ? usModalMobileBgImg : usModalDesktopBgImg})`
        },
        className: `${componentName}-bg`,
        children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              id: "banner-modal-close-btn",
              type: "icon_button",
              ariaLabel: closeCtaAccessibilityLabel,
              onClick: () => closeHandler(),
              children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" })
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: `${componentName}-bg-text`, children: [
            /* @__PURE__ */ jsx("img", { src: modalLogo, alt: usModalImgAltText }),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: `${componentName}-bg-text-heading`,
                dangerouslySetInnerHTML: { __html: modalHeading }
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs("section", { className: `${componentName}-text`, children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${componentName}-text-heading`,
          dangerouslySetInnerHTML: { __html: modalSecondaryHeader }
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${componentName}-text-description`,
          dangerouslySetInnerHTML: { __html: modalDescription }
        }
      ),
      /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        "div",
        {
          className: `${componentName}-text-disclaimer`,
          dangerouslySetInnerHTML: { __html: disclaimerMessage }
        }
      ) }),
      optionalCTALabel && optionalCTALink && /* @__PURE__ */ jsx(
        Button,
        {
          type: "primary",
          size: "medium",
          ariaLabel: ctaAccessibilityLabel,
          onClick: optionalCTAHandler,
          children: /* @__PURE__ */ jsx("span", { className: `${componentName}-text-button`, children: optionalCTALabel })
        }
      )
    ] })
  ] }) });
};
SkinnyBannerModal.propTypes = {
  modalHeading: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  modalDescription: PropTypes.string.isRequired,
  modalSecondaryHeader: PropTypes.string.isRequired,
  optionalCTALink: PropTypes.string,
  optionalCTALabel: PropTypes.string,
  modalLogo: PropTypes.string.isRequired,
  usModalImgAltText: PropTypes.string.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  usModalMobileBgImg: PropTypes.string.isRequired,
  usModalDesktopBgImg: PropTypes.string.isRequired,
  closeCtaAccessibilityLabel: PropTypes.string.isRequired,
  ctaAccessibilityLabel: PropTypes.string,
  optionalCTAHandler: PropTypes.func
};
var ChartTypes = /* @__PURE__ */ ((ChartTypes2) => {
  ChartTypes2["BAR"] = "bar";
  ChartTypes2["BUBBLE"] = "bubble";
  ChartTypes2["DOUGHNUT"] = "doughnut";
  ChartTypes2["PIE"] = "pie";
  ChartTypes2["LINE"] = "line";
  ChartTypes2["POLAR_AREA"] = "polarArea";
  ChartTypes2["RADAR"] = "radar";
  ChartTypes2["SCATTER"] = "scatter";
  return ChartTypes2;
})(ChartTypes || {});
var FeatureTypes = /* @__PURE__ */ ((FeatureTypes2) => {
  FeatureTypes2["PROGRESS_OUTLINE"] = "progressOutline";
  FeatureTypes2["CUSTOM_BACKGROUND"] = "customCanvasBackgroundColor";
  return FeatureTypes2;
})(FeatureTypes || {});
const applyCustomBG = (type, color) => ({
  id: type,
  isPlugin: true,
  beforeDraw: (chart) => {
    chart.ctx.save();
    chart.ctx.globalCompositeOperation = "destination-over";
    chart.ctx.fillStyle = color || "white";
    chart.ctx.fillRect(0, 0, chart.width, chart.height);
    chart.ctx.restore();
  }
});
const drawProgressStroke = (type) => ({
  id: type,
  isPlugin: true,
  beforeDatasetsDraw: (chart) => {
    const {
      ctx,
      data: { datasets },
      chartArea: { left, width },
      scales: { y }
    } = chart;
    ctx.save();
    datasets.forEach(
      ({
        data,
        progress = magicNumber.ZERO,
        progressBackgroundColor,
        borderColor,
        barThickness = magicNumber.SIXTEEN,
        borderWidth = magicNumber.ONE,
        borderRadius = magicNumber.TEN,
        fontHeight = magicNumber.SIXTEEN,
        padding = magicNumber.ZERO
      }) => {
        const leftWithPadding = left + padding;
        const widthWithPadding = width - padding;
        data.forEach((d, pointIndex) => {
          const yCalculation = y.getPixelForValue(pointIndex) - barThickness / magicNumber.TWO;
          ctx.beginPath();
          ctx.strokeStyle = borderColor;
          ctx.lineWidth = borderWidth;
          ctx.fillStyle = progressBackgroundColor;
          const rectWidth = widthWithPadding * (progress > d ? d : progress / d);
          ctx.roundRect(leftWithPadding, yCalculation, rectWidth, barThickness, [borderRadius]);
          ctx.fill();
          ctx.font = `${fontHeight}px lato`;
          for (let i = magicNumber.ZERO; i <= d; i++) {
            const step = widthWithPadding * (i / d);
            const fixDivider = i >= magicNumber.TEN ? magicNumber.ONE : magicNumber.TWO;
            const fix = i ? -fontHeight / fixDivider : magicNumber.ZERO;
            ctx.fillText(
              String(i),
              leftWithPadding + fix + step,
              yCalculation + barThickness * magicNumber.TWO
            );
          }
        });
      }
    );
  }
});
const checkPlugInType = (value) => {
  const { type, color } = value;
  switch (type) {
    case FeatureTypes.PROGRESS_OUTLINE:
      return drawProgressStroke(type);
    case FeatureTypes.CUSTOM_BACKGROUND:
      return applyCustomBG(type, color || "");
    default:
      return void 0;
  }
};
const patternStyle = (ctx, patternColor) => {
  switch (patternColor) {
    case colorComboType.NAVY_TEAL:
      ctx.fillStyle = colorCombos.navyTeal.fill;
      ctx.strokeStyle = colorCombos.navyTeal.stroke;
      break;
    case colorComboType.TEAL_NAVY:
      ctx.fillStyle = colorCombos.tealNavy.fill;
      ctx.strokeStyle = colorCombos.tealNavy.stroke;
      break;
    case colorComboType.LIMESTONE_TEAL:
      ctx.fillStyle = colorCombos.limestoneTeal.fill;
      ctx.strokeStyle = colorCombos.limestoneTeal.stroke;
      break;
    case colorComboType.TEAL_WHITE:
      ctx.fillStyle = colorCombos.tealWhite.fill;
      ctx.strokeStyle = colorCombos.tealWhite.stroke;
      break;
    default:
      ctx.fillStyle = patternColor;
      ctx.strokeStyle = patternColor;
  }
};
const getPatternBasedOnSize = (ctx, patternSize, defaultSizing) => {
  switch (patternSize) {
    case Size.LARGE:
      ctx.beginPath();
      ctx.moveTo(magicNumber.TEN, magicNumber.ZERO);
      ctx.lineTo(defaultSizing, magicNumber.FIFTEEN);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(magicNumber.ZERO, magicNumber.FIFTEEN);
      ctx.lineTo(magicNumber.TEN, defaultSizing);
      ctx.stroke();
      break;
    case Size.MEDIUM:
      ctx.beginPath();
      ctx.moveTo(magicNumber.TEN, magicNumber.ZERO);
      ctx.lineTo(defaultSizing, magicNumber.TEN);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(magicNumber.ZERO, magicNumber.TEN);
      ctx.lineTo(magicNumber.TEN, defaultSizing);
      ctx.stroke();
      break;
    case SizeReverse.MEDIUM:
      ctx.beginPath();
      ctx.moveTo(magicNumber.ZERO, magicNumber.TEN);
      ctx.lineTo(magicNumber.TEN, magicNumber.ZERO);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(magicNumber.TEN, defaultSizing);
      ctx.lineTo(defaultSizing, magicNumber.TEN);
      ctx.stroke();
      break;
    case Size.SMALL:
      ctx.beginPath();
      ctx.moveTo(magicNumber.FOUR, magicNumber.ZERO);
      ctx.lineTo(defaultSizing, magicNumber.SIX);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(magicNumber.ZERO, magicNumber.SIX);
      ctx.lineTo(magicNumber.FOUR, defaultSizing);
      ctx.stroke();
      break;
    default:
      ctx.beginPath();
      ctx.moveTo(magicNumber.ZERO, magicNumber.SIXTEEN);
      ctx.lineTo(magicNumber.FOUR, defaultSizing);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(magicNumber.ZERO, magicNumber.SIX);
      ctx.lineTo(magicNumber.FOURTEEN, defaultSizing);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(magicNumber.FOUR, magicNumber.ZERO);
      ctx.lineTo(defaultSizing, magicNumber.SIXTEEN);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(magicNumber.FOURTEEN, magicNumber.ZERO);
      ctx.lineTo(defaultSizing, magicNumber.SIX);
      ctx.stroke();
  }
};
const createCanvasPattern = (patternColor, patternSize, canvasId, repetition = "repeat") => {
  const canvas2 = canvasId ? document.getElementById(canvasId) : document.createElement("canvas");
  const ctx = canvas2.getContext("2d");
  let defaultSizing;
  let strokeWidth;
  switch (patternSize) {
    case Size.LARGE:
      defaultSizing = magicNumber.TWENTYFIVE;
      strokeWidth = magicNumber.THREE;
      break;
    case Size.MEDIUM:
    case SizeReverse.MEDIUM:
      defaultSizing = magicNumber.TWENTY;
      strokeWidth = magicNumber.TWO;
      break;
    case Size.SMALL:
      defaultSizing = magicNumber.TEN;
      strokeWidth = magicNumber.ONE;
      break;
    default:
      defaultSizing = magicNumber.TWENTY;
      strokeWidth = magicNumber.ONE;
  }
  canvas2.width = defaultSizing;
  canvas2.height = defaultSizing;
  patternStyle(ctx, patternColor);
  ctx.fillRect(magicNumber.ZERO, magicNumber.ZERO, defaultSizing, defaultSizing);
  ctx.lineWidth = strokeWidth;
  getPatternBasedOnSize(ctx, patternSize, defaultSizing);
  return ctx.createPattern(canvas2, repetition);
};
const isCreditCardExpired = (card, referenceDate) => {
  const yearLength = card.validToYear.length;
  const year = +card.validToYear;
  const month = +card.validToMonth;
  const currentYear2 = yearLength === magicNumber.TWO ? referenceDate.getFullYear() % magicNumber.HUNDRED : referenceDate.getFullYear();
  const currentMonth = referenceDate.getMonth() + magicNumber.ONE;
  if (year > currentYear2) {
    return false;
  } else if (year === currentYear2 && month >= currentMonth) {
    return false;
  } else {
    return true;
  }
};
const getDateDetails = (date, year) => {
  return {
    validToYear: year,
    validToMonth: date
  };
};
const SummaryCard = ({ ...props }) => {
  const { image, title, subTitle, children, ctaButtonInfo, componentClass } = props;
  const className2 = componentClass ? `${PREFIX}-${componentClass}` : `${PREFIX}-summary-card`;
  return /* @__PURE__ */ jsx(CommonCardWrapper, { noPadding: true, children: /* @__PURE__ */ jsx(CommonCard, { noPadding: true, children: /* @__PURE__ */ jsxs(Fragment, { children: [
    image && /* @__PURE__ */ jsx("div", { className: `${className2}__image-wrapper ${PREFIX}-row`, children: /* @__PURE__ */ jsx("img", { src: image.url, alt: image.altText }) }),
    title && /* @__PURE__ */ jsxs("div", { className: `${className2}__heading`, children: [
      /* @__PURE__ */ jsx("h4", { className: `${className2}__title ${PREFIX}-sm-block`, children: title }),
      subTitle && /* @__PURE__ */ jsx("p", { className: `${className2}__subtitle`, children: subTitle })
    ] }),
    children,
    ctaButtonInfo && /* @__PURE__ */ jsxs(
      "a",
      {
        className: `${className2}__link ${PREFIX}-row`,
        "aria-label": ctaButtonInfo.label,
        href: ctaButtonInfo.url,
        target: ctaButtonInfo.target,
        title: ctaButtonInfo.label,
        children: [
          ctaButtonInfo.label,
          ctaButtonInfo.ctaIcon && /* @__PURE__ */ jsx(Icon, { type: ctaButtonInfo.ctaIcon.type, size: ctaButtonInfo.ctaIcon.size })
        ]
      }
    )
  ] }) }) });
};
const getButtonType = (isSubmit) => isSubmit ? "submit" : "button";
const BalanceScreen = ({ ...props }) => {
  const {
    balanceScreenImg,
    balanceCheckerTitle,
    balanceCheckerDescription,
    cardNumberLabel,
    cardImage,
    cardImageAltText,
    ctaList,
    selectedCardNumber,
    setSelectedCardNumber,
    cardNumberError,
    isValidationCheck,
    headingVariant
  } = props.data;
  const componentClassName2 = `${PREFIX}-balance-checker-screen`;
  const renderCTA = () => {
    return ctaList == null ? void 0 : ctaList.map((cta, i) => {
      return cta.url ? /* @__PURE__ */ jsxs(
        "a",
        {
          href: cta.url,
          target: cta.target,
          "aria-label": cta.a11yLabel,
          className: `${PREFIX}-button ${PREFIX}-button--${cta.type || "primary"} ${cta.ctaClassName ?? ""}`,
          children: [
            cta.label,
            cta.target === linkTargetOptions.newTarget && /* @__PURE__ */ jsx(Icon, { type: "ct-north-east", size: "lg" })
          ]
        },
        i
      ) : /* @__PURE__ */ jsxs(
        Button,
        {
          type: cta.type || "primary",
          size: cta.size || "large",
          onClick: cta.btnFunc,
          showSpinner: Boolean(cta.showSpinner),
          ariaLabel: cta.a11yLabel,
          children: [
            cta.label,
            cta.target === linkTargetOptions.newTarget && /* @__PURE__ */ jsx(Icon, { type: "ct-north-east", size: "lg" })
          ]
        },
        i
      );
    });
  };
  return /* @__PURE__ */ jsxs("section", { className: `${componentClassName2}`, children: [
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__content-container`, children: [
      /* @__PURE__ */ jsx(
        "img",
        {
          className: `${componentClassName2}__img`,
          src: balanceScreenImg.image,
          alt: balanceScreenImg.imageAlt
        }
      ),
      /* @__PURE__ */ jsx(Heading, { variant: headingVariant, componentClass: `${componentClassName2}__title`, children: balanceCheckerTitle }),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: `${componentClassName2}__description`,
          dangerouslySetInnerHTML: { __html: balanceCheckerDescription }
        }
      ),
      /* @__PURE__ */ jsx(
        CardInput,
        {
          id: "card-input",
          label: cardNumberLabel,
          cardType: "loyalty",
          value: selectedCardNumber,
          cardImage,
          cardImageAltText,
          onChange: setSelectedCardNumber,
          inlineValidation: {
            msg: sendError(cardNumberError, isValidationCheck),
            style: "error",
            icon: "ct-input-error"
          }
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__button-container`, children: renderCTA() })
  ] });
};
BalanceScreen.propTypes = {
  data: PropTypes.exact({
    balanceScreenImg: PropTypes.exact({
      image: PropTypes.string,
      imageAlt: PropTypes.string
    }),
    balanceCheckerTitle: PropTypes.string,
    balanceCheckerDescription: PropTypes.string,
    cardNumberLabel: PropTypes.string,
    cardImage: PropTypes.string,
    cardImageAltText: PropTypes.string,
    ctaList: PropTypes.array,
    setSelectedCardNumber: PropTypes.func,
    selectedCardNumber: PropTypes.string,
    cardNumberError: PropTypes.string,
    isValidationCheck: PropTypes.bool
  })
};
const ExpandCard = ({ ...props }) => {
  const { customClass, children, separatorProps, icon } = props;
  const { isColorDynamic, style, colors } = separatorProps;
  const [isOpen, setIsOpen] = useState(false);
  const className2 = customClass ? customClass : `${PREFIX}-expand-card-button `;
  const type = isOpen ? "up" : "down";
  const iconType = icon ? icon : `ct-chevron-${type}`;
  const separatorStyle = style ? style : SeparatorStyle.SKEW;
  const getColors = isOpen ? colors[0] : colors[magicNumber.ONE];
  const separatorColors = isColorDynamic ? getColors : colors;
  return /* @__PURE__ */ jsxs("section", { className: `${className2}`, children: [
    isOpen && /* @__PURE__ */ jsx(Fragment, { children }),
    /* @__PURE__ */ jsx(Button, { type: "icon_button", id: "expand-card", onClick: () => setIsOpen(!isOpen), children: /* @__PURE__ */ jsx(Icon, { type: iconType }) }),
    separatorProps && /* @__PURE__ */ jsx(Separator, { colors: separatorColors, style: separatorStyle })
  ] });
};
ExpandCard.propTypes = {
  customClass: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.string
};
const getCTA = (label, link, target, a11yLabel) => {
  return { label, link, target, a11yLabel };
};
const getTooltipText = (title, desc, accessibility, tooltipIcon, isTooltipPreventEvent) => {
  const { a11yTooltipIcon, a11yCloseIconLabel } = accessibility;
  return {
    title: removeHtmlTagsFromString(title),
    desc,
    a11yTooltipIcon,
    a11yCloseIconLabel,
    tooltipIcon,
    isTooltipPreventEvent
  };
};
const getAkamaiPolicy = (returnPolicy, fallbackOfferImageUrl, fallbackImageForBrandLogo, fallbackImageForBrandLogoAltText) => {
  return {
    offersCardImgComponentName: offerConstants.offersCardImgComponentName,
    bannerLogoImgComponentName: offerConstants.bannerLogoImgComponentName,
    returnPolicy,
    fallbackOfferImageUrl,
    fallbackImageForBrandLogo,
    fallbackImageForBrandLogoAltText
  };
};
const InfoMessage = ({ ...props }) => {
  const { fitmentmessage, ctas, icon, type, fitmentTitle } = props;
  const modifierClass = !isArrayNotEmpty(ctas) ? `${PREFIX}-infomessage--no-margin` : "";
  return fitmentmessage ? /* @__PURE__ */ jsxs("div", { role: "alert", "data-testid": "infomessage", className: `${PREFIX}-infomessage ${PREFIX}-infomessage--${type}`, children: [
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-infomessage__fitment ${modifierClass}`, children: [
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-infomessage__fitment-icon`, children: icon && /* @__PURE__ */ jsx(Icon, { type: icon, size: "lg" }) }),
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-infomessage__fitment-text`, children: [
        fitmentTitle && /* @__PURE__ */ jsx("h4", { className: `${PREFIX}-infomessage__fitment-title`, children: fitmentTitle }),
        fitmentmessage
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: `${PREFIX}-infomessage__button`, children: isArrayNotEmpty(ctas) && ctas.map((cta, index2) => /* @__PURE__ */ jsx(
      Button,
      {
        "data-testid": cta.ctaId ? cta.ctaId : "infomessage-changevehicle-button",
        type: "tertiary",
        label: cta.text,
        onClick: cta.changeHandler
      },
      `${index2 + magicNumber.ONE}`
    )) })
  ] }) : null;
};
var OptionDescriptors = /* @__PURE__ */ ((OptionDescriptors2) => {
  OptionDescriptors2["MANUFACTURER_PART_NUMBER"] = "MANUFACTURER_PART_NUMBER";
  return OptionDescriptors2;
})(OptionDescriptors || {});
const getErrorCodeMessage = (errorCode, messages) => {
  const { errorMsg, redirectError } = messages;
  switch (errorCode) {
    case errorCodes.error00138:
      return redirectError;
    case errorCodes.error00140:
      return errorCodes.error00140;
    case errorCodes.error00049:
      return errorCodes.error00049;
    case errorCodes.error00130:
      return errorCodes.error00130;
    case errorCodes.error00055:
    // return error screen for try again
    case errorCodes.error00030:
      return errorCodes.error00055;
    default:
      return errorMsg;
  }
};
const QcLanguageTab = ({ ...props }) => {
  const { tabContent, viewReverse = false } = props;
  const genericClass = `${PREFIX}-xs`;
  const renderCheckbox = (checkbox) => {
    const { label, checked, ariaLabel, value, handleCheckbox } = checkbox;
    return /* @__PURE__ */ jsx(
      Checkbox,
      {
        id: checkbox.id,
        label,
        value,
        checked,
        ariaLabel,
        onChange: handleCheckbox,
        error: checkbox.sendError
      }
    );
  };
  const renderTabs = () => {
    return tabContent.map((tab, i) => /* @__PURE__ */ createElement$1("section", { ...tab == null ? void 0 : tab.tabLabel, key: i }, /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${(tab == null ? void 0 : tab.tncContent) && (tab == null ? void 0 : tab.checkbox) && `${genericClass}-flex ${genericClass}-${viewReverse ? "column-reverse" : "col-row"}`}`,
        children: [
          tab.tncContent,
          (tab == null ? void 0 : tab.checkbox) && renderCheckbox(tab.checkbox)
        ]
      }
    )));
  };
  return /* @__PURE__ */ jsx(Tabs, { children: renderTabs() });
};
QcLanguageTab.propTypes = {
  tabContent: PropTypes.array,
  componentClassName: PropTypes.string
};
function useFocusOnce(ref, enabled) {
  useEffect(() => {
    if (enabled && ref.current) {
      ref.current.focus();
    }
  }, [enabled, ref]);
}
const useFocusOnceRef = (enabled = false) => {
  const ref = useRef(null);
  useFocusOnce(ref, enabled);
  return ref;
};
const useHandleFocusTrap = (e) => {
  useEffect(() => {
    const mastercardExampleModal = document.getElementById("modal-triangle-mastercard");
    const rewardsExampleModal = document.getElementById("modal-triangle-reward");
    const learnMoreModal = document.getElementById("learnMoreModal");
    if (mastercardExampleModal || rewardsExampleModal || learnMoreModal) {
      document.addEventListener("keydown", useHandleFocusTrap);
    }
    return () => {
      document.removeEventListener("keydown", useHandleFocusTrap);
    };
  }, []);
  const modal = document.querySelector(`.${learnMoreModalData == null ? void 0 : learnMoreModalData.trianglePopupOpenedClass}`);
  const isTabPressed2 = e.key === stringKeyCodes.tab;
  const focusableContent = modal && modal.querySelectorAll("button")[0];
  if (!isTabPressed2 || !modal) {
    return;
  }
  focusableContent.focus();
  e.preventDefault();
};
function useIsChanged(value) {
  const ref = useRef(value);
  const flag = useRef(false);
  useEffect(() => {
    ref.current = value;
    flag.current = flag.current && Boolean(value);
  }, [value]);
  return flag && ref.current != value;
}
const NavItem = (props) => {
  const primaryMenuBarId = "primaryMenuBar";
  const navigationRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { categoriesList, subNavItemLimit, viewMoreLabel } = props;
  const showDropdownList = (itemIndex) => {
    setIsMenuOpen(true);
    const listItem = document.getElementsByClassName(`${PREFIX}-primary-nav-bar__nav-list--item`);
    if (categoriesList[itemIndex]["isSelected"]) {
      setIsMenuOpen(false);
      categoriesList[itemIndex]["isSelected"] = false;
      listItem[itemIndex].classList.remove(`${PREFIX}-primary-nav-bar__nav-list--item-active`);
    } else {
      categoriesList[itemIndex]["isSelected"] = true;
      listItem[itemIndex].classList.add(`${PREFIX}-primary-nav-bar__nav-list--item-active`);
    }
    Object.values(listItem).forEach((element, elementIndex2) => {
      if (elementIndex2 !== itemIndex) {
        categoriesList[elementIndex2]["isSelected"] = false;
        element.classList.remove(`${PREFIX}-primary-nav-bar__nav-list--item-active`);
      }
    });
  };
  const closeHandler = () => {
    setIsMenuOpen(false);
    const listItem = document.getElementsByClassName(`${PREFIX}-primary-nav-bar__nav-list--item`);
    Object.values(listItem).forEach((element, elementIndex2) => {
      categoriesList[elementIndex2]["isSelected"] = false;
      element.classList.remove(`${PREFIX}-primary-nav-bar__nav-list--item-active`);
    });
  };
  useClickOutsideClose(navigationRef, closeHandler, isMenuOpen, true);
  const getNavigationListItem = (category, index2) => {
    const { navTitle, navUrl, subSectionTab } = category;
    const desiredData = {
      url: "",
      megaNavTitle: ""
    };
    const constructedData = {
      ...desiredData,
      url: navUrl,
      megaNavTitle: navTitle,
      subSectionTab,
      subNavItemLimit,
      viewMoreLabel
    };
    return /* @__PURE__ */ jsxs(
      "li",
      {
        className: `${PREFIX}-primary-nav-bar__nav-list--item`,
        onMouseEnter: () => showDropdownList(index2),
        onMouseLeave: closeHandler,
        children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              className: `${PREFIX}-menu-buttons ${PREFIX}-button--tertiary`,
              onKeyDown: (e) => {
                if (e.key === stringKeyCodes.enter) {
                  showDropdownList(index2);
                }
              },
              "aria-haspopup": true,
              "aria-expanded": isMenuOpen,
              "data-testid": `primary-nav-link-${index2}`,
              id: `${index2}-${navTitle}`,
              children: navTitle
            }
          ),
          /* @__PURE__ */ jsx("span", { className: `${PREFIX}-border-class` }),
          /* @__PURE__ */ jsx("div", { className: `${PREFIX}-col-md-12`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-mega-navigation-container`, children: /* @__PURE__ */ jsx(MegaNavigationDesktop, { catalog: constructedData, isKp: true }) }) })
        ]
      },
      `${index2}-${navTitle}`
    );
  };
  const getNavigationList = () => {
    return /* @__PURE__ */ jsx(
      "ul",
      {
        ref: navigationRef,
        className: `${PREFIX}-primary-nav-bar__nav-list`,
        id: primaryMenuBarId,
        "data-testid": "primary-nav-list",
        children: categoriesList.map((category, index2) => {
          return getNavigationListItem(category, index2);
        })
      }
    );
  };
  const menuSizeModifier = "size-default";
  return /* @__PURE__ */ jsx(Fragment, { children: categoriesList.length ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-primary-nav`, id: "primary-nav", "data-testid": "primary-nav", children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row ${PREFIX}-container`, children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-col-md-12 ${PREFIX}-col-sm-12 ${PREFIX}-col-xs-6`, children: /* @__PURE__ */ jsx("nav", { className: `${PREFIX}-primary-nav-bar ${PREFIX}-primary-nav-bar__nav`, children: getNavigationList() }) }) }) }) : /* @__PURE__ */ jsx(
    SkeletonComponent,
    {
      skeletonClass: `${PREFIX}-full-width-container ${PREFIX}-primary-nav__skeleton ${PREFIX}-primary-nav__skeleton--${menuSizeModifier}`
    }
  ) });
};
NavItem.propTypes = {
  categoriesList: PropTypes.array,
  subNavItemLimit: PropTypes.number,
  viewMoreLabel: PropTypes.string
};
const DataTableHeader = (props) => {
  const { headerData } = props;
  return /* @__PURE__ */ jsx("thead", { children: headerData.map((item, indexRow) => {
    return /* @__PURE__ */ jsx("tr", { children: item.map((cell, indexCell) => {
      return /* @__PURE__ */ jsx(
        "th",
        {
          rowSpan: (cell == null ? void 0 : cell.rowSpan) || magicNumber.ONE,
          colSpan: (cell == null ? void 0 : cell.colSpan) || magicNumber.ONE,
          children: cell == null ? void 0 : cell.content
        },
        `${indexRow}_${indexCell}`
      );
    }) }, `${indexRow}`);
  }) });
};
const DataTableBody = (props) => {
  const { bodyData } = props;
  return /* @__PURE__ */ jsx("tbody", { children: bodyData.map((item, indexRow) => {
    return /* @__PURE__ */ jsx("tr", { children: item.map((cell, indexCell) => {
      return /* @__PURE__ */ jsx(
        "td",
        {
          rowSpan: (cell == null ? void 0 : cell.rowSpan) || magicNumber.ONE,
          colSpan: (cell == null ? void 0 : cell.colSpan) || magicNumber.ONE,
          children: cell == null ? void 0 : cell.content
        },
        `${indexRow}_${indexCell}`
      );
    }) }, `${indexRow}`);
  }) });
};
const DataTable = (props) => {
  const { headerData, bodyData } = props;
  return /* @__PURE__ */ jsxs("table", { className: `${PREFIX}-data-table`, children: [
    /* @__PURE__ */ jsx(DataTableHeader, { headerData }),
    /* @__PURE__ */ jsx(DataTableBody, { bodyData })
  ] });
};
const TextInputGroup = ({ ...props }) => {
  const { setInputFormValue, isAddFormFieldBtnClicked, isAllReqFieldFilled, inputFieldValues, groupCols } = props;
  const textInputFields = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: inputFieldValues.map((value, index2) => {
      return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-col-md-${magicNumber.TWELVE / groupCols}`, children: /* @__PURE__ */ jsx(
        TextInput,
        {
          id: value == null ? void 0 : value.id,
          label: value == null ? void 0 : value.label,
          value: value == null ? void 0 : value.value,
          onChange: (val) => {
            setInputFormValue(value == null ? void 0 : value.id, val);
          },
          size: "small",
          maxLength: magicNumber.FIFTY,
          error: isAddFormFieldBtnClicked && (value == null ? void 0 : value.isError) && "error",
          isAllReqFieldFilled,
          noTextError: true
        }
      ) }, index2);
    }) });
  };
  return textInputFields();
};
const TextInputGroupHeading = ({ ...props }) => {
  const { heading, subHeading } = props;
  const textInputHeadingSection = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-initiative-details__container`, children: [
      /* @__PURE__ */ jsx("h1", { className: `${PREFIX}-initiative-details__heading`, children: heading }),
      /* @__PURE__ */ jsx("p", { className: `${PREFIX}-initiative-details__sub-heading`, children: subHeading })
    ] });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: textInputHeadingSection() });
};
const TextInputGroupPreview = ({ ...props }) => {
  const { inputFieldValues, groupCols } = props;
  const textInputGroupPreview = () => {
    return /* @__PURE__ */ jsx(Fragment, { children: inputFieldValues.map((obj, index2) => {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${PREFIX}-col-md-${magicNumber.TWELVE / groupCols} ${PREFIX}-estimator-form-prev__field`,
          children: [
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-estimator-form-prev__title`, children: obj.label }),
            /* @__PURE__ */ jsx("div", { className: `${PREFIX}-estimator-form-prev__desc`, children: obj.value })
          ]
        },
        index2
      );
    }) });
  };
  return /* @__PURE__ */ jsx(Fragment, { children: textInputGroupPreview() });
};
const PreviewDetailsList = ({ ...props }) => {
  const { label, value } = props;
  return /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-preview-details-list__item`, children: [
    /* @__PURE__ */ jsx("label", { className: `${PREFIX}-preview-details-list__label`, htmlFor: "etInitiativeName", children: label }),
    ":",
    /* @__PURE__ */ jsx("span", { className: `${PREFIX}-preview-details-list__value`, children: value })
  ] }, label);
};
PreviewDetailsList.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string
};
const SpinnerModal = ({ ...props }) => {
  const { showSpinner, componentClass = "", loadingMessage } = props;
  return /* @__PURE__ */ jsx(ReactModal, { isOpen: showSpinner, role: "dialog", ariaModal: true, children: /* @__PURE__ */ jsxs(
    "section",
    {
      "data-testid": "spinner-modal",
      role: "alert",
      className: `${PREFIX}-spinner-modal ${componentClass} ${PREFIX}-xs-align-items-center ${PREFIX}-xs-col-row ${PREFIX}-xs-flex`,
      children: [
        /* @__PURE__ */ jsx(Spinner, {}),
        loadingMessage
      ]
    }
  ) });
};
var lodash$1 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var lodash = lodash$1.exports;
var hasRequiredLodash;
function requireLodash() {
  if (hasRequiredLodash) return lodash$1.exports;
  hasRequiredLodash = 1;
  (function(module, exports) {
    (function() {
      var undefined$1;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = exports && !exports.nodeType && exports;
      var freeModule = freeExports && true && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply2(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          var value = array[index2];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          if (iteratee(array[index2], index2, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          if (!predicate(array[index2], index2, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index2 < length) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          if (comparator(value, array[index2])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index2 < length) {
          result[index2] = iteratee(array[index2], index2, array);
        }
        return result;
      }
      function arrayPush2(array, values) {
        var index2 = -1, length = values.length, offset = array.length;
        while (++index2 < length) {
          array[offset + index2] = values[index2];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index2 = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index2];
        }
        while (++index2 < length) {
          accumulator = iteratee(accumulator, array[index2], index2, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index2 = -1, length = array == null ? 0 : array.length;
        while (++index2 < length) {
          if (predicate(array[index2], index2, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index2-- : ++index2 < length) {
          if (predicate(array[index2], index2, array)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index2 = fromIndex - 1, length = array.length;
        while (++index2 < length) {
          if (comparator(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object2) {
          return object2 == null ? undefined$1 : object2[key];
        };
      }
      function basePropertyOf(object2) {
        return function(key) {
          return object2 == null ? undefined$1 : object2[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index2, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index2 = -1, length = array.length;
        while (++index2 < length) {
          var current = iteratee(array[index2]);
          if (current !== undefined$1) {
            result = result === undefined$1 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index2 = -1, result = Array(n);
        while (++index2 < n) {
          result[index2] = iteratee(index2);
        }
        return result;
      }
      function baseToPairs(object2, props) {
        return arrayMap(props, function(key) {
          return [key, object2[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object2, props) {
        return arrayMap(props, function(key) {
          return object2[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index2 = -1, length = strSymbols.length;
        while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index2 = strSymbols.length;
        while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
        }
        return index2;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue2(object2, key) {
        return object2 == null ? undefined$1 : object2[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index2 = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index2] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index2 = -1, length = array.length, resIndex = 0, result = [];
        while (++index2 < length) {
          var value = array[index2];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index2] = PLACEHOLDER;
            result[resIndex++] = index2;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index2 = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index2] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index2 = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index2] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index2 = fromIndex - 1, length = array.length;
        while (++index2 < length) {
          if (array[index2] === value) {
            return index2;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index2 = fromIndex + 1;
        while (index2--) {
          if (array[index2] === value) {
            return index2;
          }
        }
        return index2;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index2 = string.length;
        while (index2-- && reWhitespace.test(string.charAt(index2))) {
        }
        return index2;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
        function lodash2(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = /* @__PURE__ */ function() {
          function object2() {
          }
          return function(proto) {
            if (!isObject2(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object2.prototype = proto;
            var result2 = new object2();
            object2.prototype = undefined$1;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined$1;
        }
        lodash2.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash2
          }
        };
        lodash2.prototype = baseLodash.prototype;
        lodash2.prototype.constructor = lodash2;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView2(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index2 += dir;
              var iterIndex = -1, value = array[index2];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries2) {
          var index2 = -1, length = entries2 == null ? 0 : entries2.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries2[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined$1 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries2) {
          var index2 = -1, length = entries2 == null ? 0 : entries2.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries2[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          if (index2 < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index2 == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index2, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          return index2 < 0 ? undefined$1 : data[index2][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index2 = assocIndexOf(data, key);
          if (index2 < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index2][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries2) {
          var index2 = -1, length = entries2 == null ? 0 : entries2.length;
          this.clear();
          while (++index2 < length) {
            var entry = entries2[index2];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index2 = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index2 < length) {
            this.add(values2[index2]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries2) {
          var data = this.__data__ = new ListCache(entries2);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined$1;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object2, key, value) {
          if (value !== undefined$1 && !eq(object2[key], value) || value === undefined$1 && !(key in object2)) {
            baseAssignValue(object2, key, value);
          }
        }
        function assignValue(object2, key, value) {
          var objValue = object2[key];
          if (!(hasOwnProperty.call(object2, key) && eq(objValue, value)) || value === undefined$1 && !(key in object2)) {
            baseAssignValue(object2, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object2, source) {
          return object2 && copyObject(source, keys(source), object2);
        }
        function baseAssignIn(object2, source) {
          return object2 && copyObject(source, keysIn(source), object2);
        }
        function baseAssignValue(object2, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object2, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object2[key] = value;
          }
        }
        function baseAt(object2, paths) {
          var index2 = -1, length = paths.length, result2 = Array2(length), skip = object2 == null;
          while (++index2 < length) {
            result2[index2] = skip ? undefined$1 : get(object2, paths[index2]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined$1) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined$1) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object2, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object2 ? customizer(value, key, object2, stack) : customizer(value);
          }
          if (result2 !== undefined$1) {
            return result2;
          }
          if (!isObject2(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object2) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object2 ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined$1 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object2) {
            return baseConformsTo(object2, source, props);
          };
        }
        function baseConformsTo(object2, source, props) {
          var length = props.length;
          if (object2 == null) {
            return !length;
          }
          object2 = Object2(object2);
          while (length--) {
            var key = props[length], predicate = source[key], value = object2[key];
            if (value === undefined$1 && !(key in object2) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined$1, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index2 < length) {
              var value = array[index2], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index2, collection2) {
            result2 = !!predicate(value, index2, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index2 = -1, length = array.length;
          while (++index2 < length) {
            var value = array[index2], current = iteratee2(value);
            if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger2(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined$1 || end > length ? length : toInteger2(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index2, collection2) {
            if (predicate(value, index2, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index2 = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index2 < length) {
            var value = array[index2];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush2(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object2, iteratee2) {
          return object2 && baseFor(object2, iteratee2, keys);
        }
        function baseForOwnRight(object2, iteratee2) {
          return object2 && baseForRight(object2, iteratee2, keys);
        }
        function baseFunctions(object2, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object2[key]);
          });
        }
        function baseGet(object2, path) {
          path = castPath(path, object2);
          var index2 = 0, length = path.length;
          while (object2 != null && index2 < length) {
            object2 = object2[toKey(path[index2++])];
          }
          return index2 && index2 == length ? object2 : undefined$1;
        }
        function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object2);
          return isArray(object2) ? result2 : arrayPush2(result2, symbolsFunc(object2));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined$1 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object2, key) {
          return object2 != null && hasOwnProperty.call(object2, key);
        }
        function baseHasIn(object2, key) {
          return object2 != null && key in Object2(object2);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
          }
          array = arrays[0];
          var index2 = -1, seen = caches[0];
          outer:
            while (++index2 < length && result2.length < maxLength) {
              var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object2, setter, iteratee2, accumulator) {
          baseForOwn(object2, function(value, key, object3) {
            setter(accumulator, iteratee2(value), key, object3);
          });
          return accumulator;
        }
        function baseInvoke(object2, path, args) {
          path = castPath(path, object2);
          object2 = parent(object2, path);
          var func = object2 == null ? object2 : object2[toKey(last(path))];
          return func == null ? undefined$1 : apply2(func, object2, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object2), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object2), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object2)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object2, source, matchData, customizer) {
          var index2 = matchData.length, length = index2, noCustomizer = !customizer;
          if (object2 == null) {
            return !length;
          }
          object2 = Object2(object2);
          while (index2--) {
            var data = matchData[index2];
            if (noCustomizer && data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) {
              return false;
            }
          }
          while (++index2 < length) {
            data = matchData[index2];
            var key = data[0], objValue = object2[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined$1 && !(key in object2)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object2, source, stack);
              }
              if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject2(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object2) {
          if (!isPrototype(object2)) {
            return nativeKeys(object2);
          }
          var result2 = [];
          for (var key in Object2(object2)) {
            if (hasOwnProperty.call(object2, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object2) {
          if (!isObject2(object2)) {
            return nativeKeysIn(object2);
          }
          var isProto = isPrototype(object2), result2 = [];
          for (var key in object2) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object2, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index2] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object2) {
            return object2 === source || baseIsMatch(object2, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object2) {
            var objValue = get(object2, path);
            return objValue === undefined$1 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object2, source, srcIndex, customizer, stack) {
          if (object2 === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject2(srcValue)) {
              baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object2, key), srcValue, key + "", object2, source, stack) : undefined$1;
              if (newValue === undefined$1) {
                newValue = srcValue;
              }
              assignMergeValue(object2, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object2, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object2, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack) : undefined$1;
          var isCommon = newValue === undefined$1;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject2(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object2, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined$1;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index2 = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index2, "value": value };
          });
          return baseSortBy(result2, function(object2, other) {
            return compareMultiple(object2, other, orders);
          });
        }
        function basePick(object2, paths) {
          return basePickBy(object2, paths, function(value, path) {
            return hasIn(object2, path);
          });
        }
        function basePickBy(object2, paths, predicate) {
          var index2 = -1, length = paths.length, result2 = {};
          while (++index2 < length) {
            var path = paths[index2], value = baseGet(object2, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object2), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object2) {
            return baseGet(object2, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index2 < length) {
            var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index2 = indexes[length];
            if (length == lastIndex || index2 !== previous) {
              var previous = index2;
              if (isIndex(index2)) {
                splice.call(array, index2, 1);
              } else {
                baseUnset(array, index2);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index2] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string, n) {
          var result2 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object2, path, value, customizer) {
          if (!isObject2(object2)) {
            return object2;
          }
          path = castPath(path, object2);
          var index2 = -1, length = path.length, lastIndex = length - 1, nested = object2;
          while (nested != null && ++index2 < length) {
            var key = toKey(path[index2]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object2;
            }
            if (index2 != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
              if (newValue === undefined$1) {
                newValue = isObject2(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object2;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index2 = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index2 < length) {
            result2[index2] = array[index2 + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index2, collection2) {
            result2 = predicate(value, index2, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index2 = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index2 < length) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            if (!index2 || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -Infinity ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index2 < length) {
              var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object2, path) {
          path = castPath(path, object2);
          object2 = parent(object2, path);
          return object2 == null || delete object2[toKey(last(path))];
        }
        function baseUpdate(object2, path, updater, customizer) {
          return baseSet(object2, path, updater(baseGet(object2, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index2 = fromRight ? length : -1;
          while ((fromRight ? index2-- : ++index2 < length) && predicate(array[index2], index2, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush2([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index2 = -1, result2 = Array2(length);
          while (++index2 < length) {
            var array = arrays[index2], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index2) {
                result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index2 = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index2 < length) {
            var value = index2 < valsLength ? values2[index2] : undefined$1;
            assignFunc(result2, props[index2], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object2) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object2) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined$1 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object2, other, orders) {
          var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index2 < length) {
            var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
            if (result2) {
              if (index2 >= ordersLength) {
                return result2;
              }
              var order = orders[index2];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object2.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index2 = -1, length = source.length;
          array || (array = Array2(length));
          while (++index2 < length) {
            array[index2] = source[index2];
          }
          return array;
        }
        function copyObject(source, props, object2, customizer) {
          var isNew = !object2;
          object2 || (object2 = {});
          var index2 = -1, length = props.length;
          while (++index2 < length) {
            var key = props[index2];
            var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : undefined$1;
            if (newValue === undefined$1) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object2, key, newValue);
            } else {
              assignValue(object2, key, newValue);
            }
          }
          return object2;
        }
        function copySymbols(source, object2) {
          return copyObject(source, getSymbols(source), object2);
        }
        function copySymbolsIn(source, object2) {
          return copyObject(source, getSymbolsIn(source), object2);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object2, sources) {
            var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined$1 : customizer;
              length = 1;
            }
            object2 = Object2(object2);
            while (++index2 < length) {
              var source = sources[index2];
              if (source) {
                assigner(object2, source, index2, customizer);
              }
            }
            return object2;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index2-- : ++index2 < length) {
              if (iteratee2(iterable[index2], index2, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object2, iteratee2, keysFunc) {
            var index2 = -1, iterable = Object2(object2), props = keysFunc(object2), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index2];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object2;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject2(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
            while (index2--) {
              args[index2] = arguments[index2];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined$1,
                args,
                holders,
                undefined$1,
                undefined$1,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply2(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index2 = findIndexFunc(collection, predicate, fromIndex);
            return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index2--) {
              var func = funcs[index2];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index2 = wrapper ? index2 : length;
            while (++index2 < length) {
              func = funcs[index2];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
              while (++index3 < length) {
                result2 = funcs[index3].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index2 = length;
            while (index2--) {
              args[index2] = arguments[index2];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object2, iteratee2) {
            return baseInverter(object2, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined$1 && other === undefined$1) {
              return defaultValue;
            }
            if (value !== undefined$1) {
              result2 = value;
            }
            if (other !== undefined$1) {
              if (result2 === undefined$1) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply2(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined$1 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply2(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined$1;
            }
            start = toFinite(start);
            if (end === undefined$1) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= -4;
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined$1, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger2(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object2) {
            var tag = getTag(object2);
            if (tag == mapTag) {
              return mapToArray(object2);
            }
            if (tag == setTag) {
              return setToPairs(object2);
            }
            return baseToPairs(object2, keysFunc(object2));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= -97;
            partials = holders = undefined$1;
          }
          ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger2(ary2), 0);
          arity = arity === undefined$1 ? arity : toInteger2(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined$1;
          }
          var data = isBindKey ? undefined$1 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= -25;
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined$1, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object2) {
          if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object2, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object2, source, stack) {
          if (isObject2(objValue) && isObject2(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined$1 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
          stack.set(array, other);
          stack.set(other, array);
          while (++index2 < arrLength) {
            var arrValue = array[index2], othValue = other[index2];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
            }
            if (compared !== undefined$1) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
                return false;
              }
              object2 = object2.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object2, +other);
            case errorTag:
              return object2.name == other.name && object2.message == other.message;
            case regexpTag:
            case stringTag:
              return object2 == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object2.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object2);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object2, other);
              var result2 = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object2);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object2) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index2 = objLength;
          while (index2--) {
            var key = objProps[index2];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object2);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object2;
          }
          var result2 = true;
          stack.set(object2, other);
          stack.set(other, object2);
          var skipCtor = isPartial;
          while (++index2 < objLength) {
            key = objProps[index2];
            var objValue = object2[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
            }
            if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object2.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object2);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined$1, flatten), func + "");
        }
        function getAllKeys(object2) {
          return baseGetAllKeys(object2, keys, getSymbols);
        }
        function getAllKeysIn(object2) {
          return baseGetAllKeys(object2, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop2 : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object2 = hasOwnProperty.call(lodash2, "placeholder") ? lodash2 : func;
          return object2.placeholder;
        }
        function getIteratee() {
          var result2 = lodash2.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object2) {
          var result2 = keys(object2), length = result2.length;
          while (length--) {
            var key = result2[length], value = object2[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object2, key) {
          var value = getValue2(object2, key);
          return baseIsNative(value) ? value : undefined$1;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined$1;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
          if (object2 == null) {
            return [];
          }
          object2 = Object2(object2);
          return arrayFilter(nativeGetSymbols(object2), function(symbol) {
            return propertyIsEnumerable.call(object2, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object2) {
          var result2 = [];
          while (object2) {
            arrayPush2(result2, getSymbols(object2));
            object2 = getPrototype(object2);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView2(start, end, transforms) {
          var index2 = -1, length = transforms.length;
          while (++index2 < length) {
            var data = transforms[index2], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match2 = source.match(reWrapDetails);
          return match2 ? match2[1].split(reSplitDetails) : [];
        }
        function hasPath(object2, path, hasFunc) {
          path = castPath(path, object2);
          var index2 = -1, length = path.length, result2 = false;
          while (++index2 < length) {
            var key = toKey(path[index2]);
            if (!(result2 = object2 != null && hasFunc(object2, key))) {
              break;
            }
            object2 = object2[key];
          }
          if (result2 || ++index2 != length) {
            return result2;
          }
          length = object2 == null ? 0 : object2.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object2) || isArguments(object2));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object2) {
          return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
        }
        function initCloneByTag(object2, tag, isDeep) {
          var Ctor = object2.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object2);
            case boolTag:
            case dateTag:
              return new Ctor(+object2);
            case dataViewTag:
              return cloneDataView(object2, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object2, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object2);
            case regexpTag:
              return cloneRegExp(object2);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object2);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index2, object2) {
          if (!isObject2(object2)) {
            return false;
          }
          var type = typeof index2;
          if (type == "number" ? isArrayLike(object2) && isIndex(index2, object2.length) : type == "string" && index2 in object2) {
            return eq(object2[index2], value);
          }
          return false;
        }
        function isKey(value, object2) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object2(object2);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash2[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject2(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object2) {
            if (object2 == null) {
              return false;
            }
            return object2[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object2));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize2(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object2) {
          var result2 = [];
          if (object2 != null) {
            for (var key in Object2(object2)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index2 < length) {
              array[index2] = args[start + index2];
            }
            index2 = -1;
            var otherArgs = Array2(start + 1);
            while (++index2 < start) {
              otherArgs[index2] = args[index2];
            }
            otherArgs[start] = transform2(array);
            return apply2(func, this, otherArgs);
          };
        }
        function parent(object2, path) {
          return path.length < 2 ? object2 : baseGet(object2, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index2 = indexes[length];
            array[length] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
          }
          return array;
        }
        function safeGet(object2, key) {
          if (key === "constructor" && typeof object2[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object2[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined$1, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index2 = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined$1 ? length : size2;
          while (++index2 < size2) {
            var rand = baseRandom(index2, lastIndex), value = array[rand];
            array[rand] = array[index2];
            array[index2] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match2, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -Infinity ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger2(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
          while (index2 < length) {
            result2[resIndex++] = baseSlice(array, index2, index2 += size2);
          }
          return result2;
        }
        function compact(array) {
          var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index2 < length) {
            var value = array[index2];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index2 = length;
          while (index2--) {
            args[index2 - 1] = arguments[index2];
          }
          return arrayPush2(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined$1;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined$1 ? 1 : toInteger2(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined$1 ? 1 : toInteger2(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex2(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length + index2, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index2);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index2 = length - 1;
          if (fromIndex !== undefined$1) {
            index2 = toInteger2(fromIndex);
            index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined$1 ? 1 : toInteger2(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index2 < length) {
            var pair = pairs[index2];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined$1;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
          if (index2 < 0) {
            index2 = nativeMax(length + index2, 0);
          }
          return baseIndexOf(array, value, index2);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined$1;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined$1;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index2 = length;
          if (fromIndex !== undefined$1) {
            index2 = toInteger2(fromIndex);
            index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger2(n)) : undefined$1;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index2) {
            return isIndex(index2, length) ? +index2 : index2;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index2 = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index2 < length) {
            var value = array[index2];
            if (predicate(value, index2, array)) {
              result2.push(value);
              indexes.push(index2);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger2(start);
            end = end === undefined$1 ? length : toInteger2(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index2 = baseSortedIndex(array, value);
            if (index2 < length && eq(array[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index2 = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined$1 ? 1 : toInteger2(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined$1 ? 1 : toInteger2(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index2) {
            return arrayMap(array, baseProperty(index2));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply2(iteratee2, undefined$1, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined$1;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined$1;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash2(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object2) {
            return baseAt(object2, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined$1
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined$1);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined$1) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone3 = wrapperClone(parent2);
            clone3.__index__ = 0;
            clone3.__values__ = undefined$1;
            if (result2) {
              previous.__wrapped__ = clone3;
            } else {
              result2 = clone3;
            }
            var previous = clone3;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined$1
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex2);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined$1 ? 1 : toInteger2(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger2(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index2] = isFunc ? apply2(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined$1 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
            n = 1;
          } else {
            n = toInteger2(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined$1;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now2 = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger2(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined$1 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger2(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined$1;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object2, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object2, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined$1 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject2(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined$1;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now2();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined$1;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined$1;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined$1) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined$1;
          }
          function flush() {
            return timerId === undefined$1 ? result2 : trailingEdge(now2());
          }
          function debounced() {
            var time = now2(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined$1) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined$1) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize2(func, resolver2) {
          if (typeof func != "function" || resolver2 != null && typeof resolver2 != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver2 ? resolver2.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize2.Cache || MapCache)();
          return memoized;
        }
        memoize2.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index2 = -1, length = nativeMin(args.length, funcsLength);
            while (++index2 < length) {
              args[index2] = transforms[index2].call(this, args[index2]);
            }
            return apply2(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined$1 ? start : toInteger2(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger2(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush2(otherArgs, array);
            }
            return apply2(func, this, otherArgs);
          });
        }
        function throttle2(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject2(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone2(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object2, source) {
          return source == null || baseConformsTo(object2, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(/* @__PURE__ */ function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          var result2 = customizer ? customizer(value, other) : undefined$1;
          return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject2(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger2(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject2(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object2, source) {
          return object2 === source || baseIsMatch(object2, source, getMatchData(source));
        }
        function isMatchWith(object2, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return baseIsMatch(object2, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -9007199254740991 && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined$1;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -Infinity) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger2(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger2(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject2(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject2(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger2(value), -9007199254740991, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign2 = createAssigner(function(object2, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object2);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object2, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object2, source) {
          copyObject(source, keysIn(source), object2);
        });
        var assignInWith = createAssigner(function(object2, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object2, customizer);
        });
        var assignWith = createAssigner(function(object2, source, srcIndex, customizer) {
          copyObject(source, keys(source), object2, customizer);
        });
        var at = flatRest(baseAt);
        function create2(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults2 = baseRest(function(object2, sources) {
          object2 = Object2(object2);
          var index2 = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index2 < length) {
            var source = sources[index2];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object2[key];
              if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object2, key)) {
                object2[key] = source[key];
              }
            }
          }
          return object2;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined$1, customDefaultsMerge);
          return apply2(mergeWith, undefined$1, args);
        });
        function findKey2(object2, predicate) {
          return baseFindKey(object2, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object2, predicate) {
          return baseFindKey(object2, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object2, iteratee2) {
          return object2 == null ? object2 : baseFor(object2, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object2, iteratee2) {
          return object2 == null ? object2 : baseForRight(object2, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object2, iteratee2) {
          return object2 && baseForOwn(object2, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object2, iteratee2) {
          return object2 && baseForOwnRight(object2, getIteratee(iteratee2, 3));
        }
        function functions(object2) {
          return object2 == null ? [] : baseFunctions(object2, keys(object2));
        }
        function functionsIn(object2) {
          return object2 == null ? [] : baseFunctions(object2, keysIn(object2));
        }
        function get(object2, path, defaultValue) {
          var result2 = object2 == null ? undefined$1 : baseGet(object2, path);
          return result2 === undefined$1 ? defaultValue : result2;
        }
        function has2(object2, path) {
          return object2 != null && hasPath(object2, path, baseHas);
        }
        function hasIn(object2, path) {
          return object2 != null && hasPath(object2, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object2) {
          return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
        }
        function keysIn(object2) {
          return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
        }
        function mapKeys(object2, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object2, function(value, key, object3) {
            baseAssignValue(result2, iteratee2(value, key, object3), value);
          });
          return result2;
        }
        function mapValues(object2, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object2, function(value, key, object3) {
            baseAssignValue(result2, key, iteratee2(value, key, object3));
          });
          return result2;
        }
        var merge2 = createAssigner(function(object2, source, srcIndex) {
          baseMerge(object2, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object2, source, srcIndex, customizer) {
          baseMerge(object2, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object2, paths) {
          var result2 = {};
          if (object2 == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object2);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object2, getAllKeysIn(object2), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object2, predicate) {
          return pickBy(object2, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object2, paths) {
          return object2 == null ? {} : basePick(object2, paths);
        });
        function pickBy(object2, predicate) {
          if (object2 == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object2), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object2, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object2, path, defaultValue) {
          path = castPath(path, object2);
          var index2 = -1, length = path.length;
          if (!length) {
            length = 1;
            object2 = undefined$1;
          }
          while (++index2 < length) {
            var value = object2 == null ? undefined$1 : object2[toKey(path[index2])];
            if (value === undefined$1) {
              index2 = length;
              value = defaultValue;
            }
            object2 = isFunction(value) ? value.call(object2) : value;
          }
          return object2;
        }
        function set(object2, path, value) {
          return object2 == null ? object2 : baseSet(object2, path, value);
        }
        function setWith(object2, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return object2 == null ? object2 : baseSet(object2, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object2, iteratee2, accumulator) {
          var isArr = isArray(object2), isArrLike = isArr || isBuffer(object2) || isTypedArray(object2);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object2 && object2.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject2(object2)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object2)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object2, function(value, index2, object3) {
            return iteratee2(accumulator, value, index2, object3);
          });
          return accumulator;
        }
        function unset(object2, path) {
          return object2 == null ? true : baseUnset(object2, path);
        }
        function update2(object2, path, updater) {
          return object2 == null ? object2 : baseUpdate(object2, path, castFunction(updater));
        }
        function updateWith(object2, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined$1;
          return object2 == null ? object2 : baseUpdate(object2, path, castFunction(updater), customizer);
        }
        function values(object2) {
          return object2 == null ? [] : baseValues(object2, keys(object2));
        }
        function valuesIn(object2) {
          return object2 == null ? [] : baseValues(object2, keysIn(object2));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined$1) {
            upper = lower;
            lower = undefined$1;
          }
          if (upper !== undefined$1) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined$1) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined$1;
          }
          if (floating === undefined$1) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined$1;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined$1;
            }
          }
          if (lower === undefined$1 && upper === undefined$1) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined$1) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index2) {
          word = word.toLowerCase();
          return result2 + (index2 ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined$1 ? length : baseClamp(toInteger2(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger2(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger2(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger2(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
            n = 1;
          } else {
            n = toInteger2(n);
          }
          return baseRepeat(toString(string), n);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined$1;
          }
          limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger2(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash2.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined$1;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index2 = offset + match2.length;
            return match2;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined$1)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject2(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger2(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined$1) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match2, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match2 = separator.exec(substring)) {
                var newEnd = match2.index;
              }
              result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index2 = result2.lastIndexOf(separator);
            if (index2 > -1) {
              result2 = result2.slice(0, index2);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index2) {
          return result2 + (index2 ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined$1 : pattern;
          if (pattern === undefined$1) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply2(func, undefined$1, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object2, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object2, key, bind(object2[key], object2));
          });
          return object2;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index2 = -1;
            while (++index2 < length) {
              var pair = pairs[index2];
              if (apply2(pair[0], this, args)) {
                return apply2(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object2) {
            return baseInvoke(object2, path, args);
          };
        });
        var methodOf = baseRest(function(object2, args) {
          return function(path) {
            return baseInvoke(object2, path, args);
          };
        });
        function mixin(object2, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object2;
            object2 = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object2);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object2[methodName] = func;
            if (isFunc) {
              object2.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object2(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object2 });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object2, arrayPush2([this.value()], arguments));
              };
            }
          });
          return object2;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop2() {
        }
        function nthArg(n) {
          n = toInteger2(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object2) {
          return function(path) {
            return object2 == null ? undefined$1 : baseGet(object2, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger2(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index2 < n) {
            iteratee2(index2);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash2.after = after;
        lodash2.ary = ary;
        lodash2.assign = assign2;
        lodash2.assignIn = assignIn;
        lodash2.assignInWith = assignInWith;
        lodash2.assignWith = assignWith;
        lodash2.at = at;
        lodash2.before = before;
        lodash2.bind = bind;
        lodash2.bindAll = bindAll;
        lodash2.bindKey = bindKey;
        lodash2.castArray = castArray;
        lodash2.chain = chain;
        lodash2.chunk = chunk;
        lodash2.compact = compact;
        lodash2.concat = concat;
        lodash2.cond = cond;
        lodash2.conforms = conforms;
        lodash2.constant = constant;
        lodash2.countBy = countBy;
        lodash2.create = create2;
        lodash2.curry = curry;
        lodash2.curryRight = curryRight;
        lodash2.debounce = debounce;
        lodash2.defaults = defaults2;
        lodash2.defaultsDeep = defaultsDeep;
        lodash2.defer = defer;
        lodash2.delay = delay;
        lodash2.difference = difference;
        lodash2.differenceBy = differenceBy;
        lodash2.differenceWith = differenceWith;
        lodash2.drop = drop;
        lodash2.dropRight = dropRight;
        lodash2.dropRightWhile = dropRightWhile;
        lodash2.dropWhile = dropWhile;
        lodash2.fill = fill;
        lodash2.filter = filter;
        lodash2.flatMap = flatMap;
        lodash2.flatMapDeep = flatMapDeep;
        lodash2.flatMapDepth = flatMapDepth;
        lodash2.flatten = flatten;
        lodash2.flattenDeep = flattenDeep;
        lodash2.flattenDepth = flattenDepth;
        lodash2.flip = flip;
        lodash2.flow = flow;
        lodash2.flowRight = flowRight;
        lodash2.fromPairs = fromPairs;
        lodash2.functions = functions;
        lodash2.functionsIn = functionsIn;
        lodash2.groupBy = groupBy;
        lodash2.initial = initial;
        lodash2.intersection = intersection;
        lodash2.intersectionBy = intersectionBy;
        lodash2.intersectionWith = intersectionWith;
        lodash2.invert = invert;
        lodash2.invertBy = invertBy;
        lodash2.invokeMap = invokeMap;
        lodash2.iteratee = iteratee;
        lodash2.keyBy = keyBy;
        lodash2.keys = keys;
        lodash2.keysIn = keysIn;
        lodash2.map = map;
        lodash2.mapKeys = mapKeys;
        lodash2.mapValues = mapValues;
        lodash2.matches = matches;
        lodash2.matchesProperty = matchesProperty;
        lodash2.memoize = memoize2;
        lodash2.merge = merge2;
        lodash2.mergeWith = mergeWith;
        lodash2.method = method;
        lodash2.methodOf = methodOf;
        lodash2.mixin = mixin;
        lodash2.negate = negate;
        lodash2.nthArg = nthArg;
        lodash2.omit = omit;
        lodash2.omitBy = omitBy;
        lodash2.once = once;
        lodash2.orderBy = orderBy;
        lodash2.over = over;
        lodash2.overArgs = overArgs;
        lodash2.overEvery = overEvery;
        lodash2.overSome = overSome;
        lodash2.partial = partial;
        lodash2.partialRight = partialRight;
        lodash2.partition = partition;
        lodash2.pick = pick;
        lodash2.pickBy = pickBy;
        lodash2.property = property;
        lodash2.propertyOf = propertyOf;
        lodash2.pull = pull;
        lodash2.pullAll = pullAll;
        lodash2.pullAllBy = pullAllBy;
        lodash2.pullAllWith = pullAllWith;
        lodash2.pullAt = pullAt;
        lodash2.range = range;
        lodash2.rangeRight = rangeRight;
        lodash2.rearg = rearg;
        lodash2.reject = reject;
        lodash2.remove = remove;
        lodash2.rest = rest;
        lodash2.reverse = reverse;
        lodash2.sampleSize = sampleSize;
        lodash2.set = set;
        lodash2.setWith = setWith;
        lodash2.shuffle = shuffle;
        lodash2.slice = slice;
        lodash2.sortBy = sortBy;
        lodash2.sortedUniq = sortedUniq;
        lodash2.sortedUniqBy = sortedUniqBy;
        lodash2.split = split;
        lodash2.spread = spread;
        lodash2.tail = tail;
        lodash2.take = take;
        lodash2.takeRight = takeRight;
        lodash2.takeRightWhile = takeRightWhile;
        lodash2.takeWhile = takeWhile;
        lodash2.tap = tap;
        lodash2.throttle = throttle2;
        lodash2.thru = thru;
        lodash2.toArray = toArray;
        lodash2.toPairs = toPairs;
        lodash2.toPairsIn = toPairsIn;
        lodash2.toPath = toPath;
        lodash2.toPlainObject = toPlainObject;
        lodash2.transform = transform;
        lodash2.unary = unary;
        lodash2.union = union;
        lodash2.unionBy = unionBy;
        lodash2.unionWith = unionWith;
        lodash2.uniq = uniq;
        lodash2.uniqBy = uniqBy;
        lodash2.uniqWith = uniqWith;
        lodash2.unset = unset;
        lodash2.unzip = unzip;
        lodash2.unzipWith = unzipWith;
        lodash2.update = update2;
        lodash2.updateWith = updateWith;
        lodash2.values = values;
        lodash2.valuesIn = valuesIn;
        lodash2.without = without;
        lodash2.words = words;
        lodash2.wrap = wrap;
        lodash2.xor = xor;
        lodash2.xorBy = xorBy;
        lodash2.xorWith = xorWith;
        lodash2.zip = zip;
        lodash2.zipObject = zipObject;
        lodash2.zipObjectDeep = zipObjectDeep;
        lodash2.zipWith = zipWith;
        lodash2.entries = toPairs;
        lodash2.entriesIn = toPairsIn;
        lodash2.extend = assignIn;
        lodash2.extendWith = assignInWith;
        mixin(lodash2, lodash2);
        lodash2.add = add;
        lodash2.attempt = attempt;
        lodash2.camelCase = camelCase;
        lodash2.capitalize = capitalize;
        lodash2.ceil = ceil;
        lodash2.clamp = clamp;
        lodash2.clone = clone2;
        lodash2.cloneDeep = cloneDeep;
        lodash2.cloneDeepWith = cloneDeepWith;
        lodash2.cloneWith = cloneWith;
        lodash2.conformsTo = conformsTo;
        lodash2.deburr = deburr;
        lodash2.defaultTo = defaultTo;
        lodash2.divide = divide;
        lodash2.endsWith = endsWith;
        lodash2.eq = eq;
        lodash2.escape = escape;
        lodash2.escapeRegExp = escapeRegExp;
        lodash2.every = every;
        lodash2.find = find;
        lodash2.findIndex = findIndex2;
        lodash2.findKey = findKey2;
        lodash2.findLast = findLast;
        lodash2.findLastIndex = findLastIndex;
        lodash2.findLastKey = findLastKey;
        lodash2.floor = floor;
        lodash2.forEach = forEach;
        lodash2.forEachRight = forEachRight;
        lodash2.forIn = forIn;
        lodash2.forInRight = forInRight;
        lodash2.forOwn = forOwn;
        lodash2.forOwnRight = forOwnRight;
        lodash2.get = get;
        lodash2.gt = gt;
        lodash2.gte = gte;
        lodash2.has = has2;
        lodash2.hasIn = hasIn;
        lodash2.head = head;
        lodash2.identity = identity;
        lodash2.includes = includes;
        lodash2.indexOf = indexOf;
        lodash2.inRange = inRange;
        lodash2.invoke = invoke;
        lodash2.isArguments = isArguments;
        lodash2.isArray = isArray;
        lodash2.isArrayBuffer = isArrayBuffer;
        lodash2.isArrayLike = isArrayLike;
        lodash2.isArrayLikeObject = isArrayLikeObject;
        lodash2.isBoolean = isBoolean;
        lodash2.isBuffer = isBuffer;
        lodash2.isDate = isDate2;
        lodash2.isElement = isElement;
        lodash2.isEmpty = isEmpty;
        lodash2.isEqual = isEqual;
        lodash2.isEqualWith = isEqualWith;
        lodash2.isError = isError;
        lodash2.isFinite = isFinite;
        lodash2.isFunction = isFunction;
        lodash2.isInteger = isInteger;
        lodash2.isLength = isLength;
        lodash2.isMap = isMap;
        lodash2.isMatch = isMatch;
        lodash2.isMatchWith = isMatchWith;
        lodash2.isNaN = isNaN2;
        lodash2.isNative = isNative;
        lodash2.isNil = isNil;
        lodash2.isNull = isNull;
        lodash2.isNumber = isNumber;
        lodash2.isObject = isObject2;
        lodash2.isObjectLike = isObjectLike;
        lodash2.isPlainObject = isPlainObject;
        lodash2.isRegExp = isRegExp;
        lodash2.isSafeInteger = isSafeInteger;
        lodash2.isSet = isSet;
        lodash2.isString = isString;
        lodash2.isSymbol = isSymbol;
        lodash2.isTypedArray = isTypedArray;
        lodash2.isUndefined = isUndefined;
        lodash2.isWeakMap = isWeakMap;
        lodash2.isWeakSet = isWeakSet;
        lodash2.join = join;
        lodash2.kebabCase = kebabCase;
        lodash2.last = last;
        lodash2.lastIndexOf = lastIndexOf;
        lodash2.lowerCase = lowerCase;
        lodash2.lowerFirst = lowerFirst;
        lodash2.lt = lt;
        lodash2.lte = lte;
        lodash2.max = max;
        lodash2.maxBy = maxBy;
        lodash2.mean = mean;
        lodash2.meanBy = meanBy;
        lodash2.min = min;
        lodash2.minBy = minBy;
        lodash2.stubArray = stubArray;
        lodash2.stubFalse = stubFalse;
        lodash2.stubObject = stubObject;
        lodash2.stubString = stubString;
        lodash2.stubTrue = stubTrue;
        lodash2.multiply = multiply;
        lodash2.nth = nth;
        lodash2.noConflict = noConflict;
        lodash2.noop = noop2;
        lodash2.now = now2;
        lodash2.pad = pad;
        lodash2.padEnd = padEnd;
        lodash2.padStart = padStart;
        lodash2.parseInt = parseInt2;
        lodash2.random = random;
        lodash2.reduce = reduce;
        lodash2.reduceRight = reduceRight;
        lodash2.repeat = repeat;
        lodash2.replace = replace;
        lodash2.result = result;
        lodash2.round = round;
        lodash2.runInContext = runInContext2;
        lodash2.sample = sample;
        lodash2.size = size;
        lodash2.snakeCase = snakeCase;
        lodash2.some = some;
        lodash2.sortedIndex = sortedIndex;
        lodash2.sortedIndexBy = sortedIndexBy;
        lodash2.sortedIndexOf = sortedIndexOf;
        lodash2.sortedLastIndex = sortedLastIndex;
        lodash2.sortedLastIndexBy = sortedLastIndexBy;
        lodash2.sortedLastIndexOf = sortedLastIndexOf;
        lodash2.startCase = startCase;
        lodash2.startsWith = startsWith;
        lodash2.subtract = subtract;
        lodash2.sum = sum;
        lodash2.sumBy = sumBy;
        lodash2.template = template;
        lodash2.times = times;
        lodash2.toFinite = toFinite;
        lodash2.toInteger = toInteger2;
        lodash2.toLength = toLength;
        lodash2.toLower = toLower;
        lodash2.toNumber = toNumber;
        lodash2.toSafeInteger = toSafeInteger;
        lodash2.toString = toString;
        lodash2.toUpper = toUpper;
        lodash2.trim = trim;
        lodash2.trimEnd = trimEnd;
        lodash2.trimStart = trimStart;
        lodash2.truncate = truncate;
        lodash2.unescape = unescape;
        lodash2.uniqueId = uniqueId;
        lodash2.upperCase = upperCase;
        lodash2.upperFirst = upperFirst;
        lodash2.each = forEach;
        lodash2.eachRight = forEachRight;
        lodash2.first = head;
        mixin(lodash2, function() {
          var source = {};
          baseForOwn(lodash2, function(func, methodName) {
            if (!hasOwnProperty.call(lodash2.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash2.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash2[methodName].placeholder = lodash2;
        });
        arrayEach(["drop", "take"], function(methodName, index2) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined$1 ? 1 : nativeMax(toInteger2(n), 0);
            var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
          var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index2) {
          var takeName = "take" + (index2 ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index2) {
          var dropName = "drop" + (index2 ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger2(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined$1) {
            end = toInteger2(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash2.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash2, arrayPush2([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash2.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash2[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined$1
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash2.prototype.at = wrapperAt;
        lodash2.prototype.chain = wrapperChain;
        lodash2.prototype.commit = wrapperCommit;
        lodash2.prototype.next = wrapperNext;
        lodash2.prototype.plant = wrapperPlant;
        lodash2.prototype.reverse = wrapperReverse;
        lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
        lodash2.prototype.first = lodash2.prototype.head;
        if (symIterator) {
          lodash2.prototype[symIterator] = wrapperToIterator;
        }
        return lodash2;
      };
      var _ = runInContext();
      if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(lodash);
  })(lodash$1, lodash$1.exports);
  return lodash$1.exports;
}
var lodashExports = requireLodash();
function useCallbackOnce(callback) {
  const callbackRef = useRef(callback);
  const onceRef = useRef(null);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  if (!onceRef.current) {
    onceRef.current = lodashExports.once(() => {
      if (callbackRef.current) {
        callbackRef.current();
      }
    });
  }
  return onceRef.current;
}
const PillsList = (props) => {
  const { updatedPillsListValue } = props;
  const pillsListRef = useRef(null);
  const processClickOrEnter = (event, currentIndex, value, pillsListNode) => {
    handleClickOrEnterAccessibility(event, currentIndex, pillsListNode, selectionTypeChecked);
    props.handleClickOrEnter(value);
  };
  const processKeyDown = (event, currentIndex, value, pillsListNode) => {
    if (event.key === stringKeyCodes.rightArrow) {
      handleArrowsAccessibility(event, arrowActionIdentifier$1.NEXT, currentIndex, pillsListNode);
    }
    if (event.key === stringKeyCodes.leftArrow) {
      handleArrowsAccessibility(event, arrowActionIdentifier$1.PREVIOUS, currentIndex, pillsListNode);
    }
    if (event.key === stringKeyCodes.enter || event.key === stringKeyCodes.space) {
      processClickOrEnter(event, currentIndex, value, pillsListNode);
    }
  };
  return /* @__PURE__ */ jsx(
    "ul",
    {
      "aria-labelledby": "variant-type-label",
      className: `${PREFIX}-variants__variant-list`,
      role: "radiogroup",
      ref: pillsListRef,
      children: updatedPillsListValue.map((element, index2) => {
        const value = element == null ? void 0 : element.value;
        const isSelectedPill = element == null ? void 0 : element.selected;
        const disabledVariantClass = (element == null ? void 0 : element.crossingOut) ? ` ${PREFIX}-variants__disabled` : "";
        return /* @__PURE__ */ jsx("li", { className: `${PREFIX}-variants__variant-item`, role: "presentation", children: /* @__PURE__ */ jsx(
          "div",
          {
            className: `${PREFIX}-variants__variant ${PREFIX}-variants__variant--${isSelectedPill ? "selected" : "unselected"}${disabledVariantClass} `,
            "aria-label": value,
            "aria-checked": isSelectedPill,
            "data-accessibility": "true",
            role: "radio",
            tabIndex: isSelectedPill ? 0 : -1,
            onKeyDown: (event) => {
              processKeyDown(event, index2, element, pillsListRef.current);
            },
            onClick: (event) => {
              processClickOrEnter(event, index2, element, pillsListRef.current);
            },
            children: /* @__PURE__ */ jsx("span", { className: `${PREFIX}-variants__variant-text`, children: value })
          }
        ) }, index2);
      })
    }
  );
};
PillsList.propTypes = {
  updatedPillsListValue: PropTypes.array,
  handleClickOrEnter: PropTypes.func
};
const setFocusToElement = (id) => {
  var _a;
  (_a = document.getElementById(id)) == null ? void 0 : _a.focus();
};
const getHeaderButtonLabel = (filteredOffers, allOffersActivated, activateOfferLabel, activateAllOffersLabel) => {
  const offersInActivateStatus = filteredOffers && filteredOffers.filter(
    (item) => {
      var _a, _b;
      return ((_a = item == null ? void 0 : item.offerStatus) == null ? void 0 : _a.toLocaleLowerCase()) === ((_b = statusLabel.activateStatus) == null ? void 0 : _b.toLocaleLowerCase());
    }
  );
  return allOffersActivated ? allOffersActivated == null ? void 0 : allOffersActivated.label : replaceMultipleStrWithDynamicVal(
    // eslint-disable-next-line sonar/no-nested-conditional
    (offersInActivateStatus == null ? void 0 : offersInActivateStatus.length) === magicNumber.ONE ? activateOfferLabel : activateAllOffersLabel,
    // eslint-disable-next-line no-unsafe-optional-chaining
    [(offersInActivateStatus == null ? void 0 : offersInActivateStatus.length).toString()]
  );
};
const subscriptionStartDateDeadline = new Date(Date.UTC(Number("2022"), Number("2"), Number("22")));
const getUserProfileStatus = (isAuthFlowExecuted, userProfileData, isGuestLoyaltyUser) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  const isAuthenticated = isAuthFlowExecuted && checkDataLength(userProfileData);
  const isWelcomeGiftEligible1 = !!((_a = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _a.tsWelcomeGift) && wasTriangleSelectMember((_b = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _b.tsSubscriptionStatus) && !!((_c = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _c.tsSubscriptionStartDate) && convertEpsilonDate((_d = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _d.tsSubscriptionStartDate).getTime() < subscriptionStartDateDeadline.getTime();
  const isWelcomeGiftEligible2 = !((_e = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _e.tsWelcomeGift) && !((_f = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _f.tsSubscriptionStatus);
  return {
    isGuest: isAuthFlowExecuted && !checkDataLength(userProfileData),
    isAuthenticated,
    hasLoyalty: isAtleastOneParamValid(!!((_g = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _g.cardNumber), !!((_h = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _h.id)),
    hasSubscription: isTriangleSelectMember((_i = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _i.tsSubscriptionStatus),
    hadSubscription: wasTriangleSelectMember((_j = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _j.tsSubscriptionStatus),
    isWelcomeGiftEligible: isAuthenticated && (isWelcomeGiftEligible1 || isWelcomeGiftEligible2),
    partnerCIRLinkStatus: (_l = (_k = userProfileData == null ? void 0 : userProfileData.linkedPartnerCards) == null ? void 0 : _k.CIR) == null ? void 0 : _l.partnerLinkStatus,
    partiallyAuthenticated: (userProfileData == null ? void 0 : userProfileData.role) === userLoginStatus.partiallyAuthenticatedUser,
    hasLoyaltyAccount: isAtleastOneParamValid(!!((_m = userProfileData == null ? void 0 : userProfileData.loyalty) == null ? void 0 : _m.cardNumber), isGuestLoyaltyUser)
  };
};
const ErrorCard = ({ ...props }) => {
  const { title, description, linkUrl, linkLabel } = props;
  const componentClassName2 = `${PREFIX}-package-error-card`;
  return /* @__PURE__ */ jsxs("div", { className: componentClassName2, children: [
    /* @__PURE__ */ jsx("h3", { className: `${componentClassName2}__title`, children: title }),
    /* @__PURE__ */ jsx("p", { className: `${componentClassName2}__content ${PREFIX}-col-md-6`, children: description }),
    /* @__PURE__ */ jsx(
      "a",
      {
        href: linkUrl,
        className: `${componentClassName2}__button ${PREFIX}-button ${PREFIX}-button--primary ${PREFIX}-button--small`,
        "aria-label": linkLabel,
        children: linkLabel
      }
    )
  ] });
};
ErrorCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkUrl: PropTypes.string,
  linkLabel: PropTypes.string
};
const SwapConfirmationModal = ({ ...props }) => {
  var _a, _b, _c, _d;
  const {
    isModalOpen,
    title,
    subtitle,
    swapRow,
    swappableRow,
    ctaList,
    closeModal,
    returnPolicy,
    displayCloseButton = true
  } = props;
  const contentRef = useRef(null);
  const modalClassName = `${PREFIX}-react-modal`;
  const focusLockEventRef = useRef();
  const previousElement = document.querySelector(`button[${previousElementName}]`);
  const componentClassName2 = `${PREFIX}-swap-modal`;
  const closeHandler = () => {
    closeModal();
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    if (previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  useEffect(() => {
    if (isModalOpen) {
      focusLockEventRef.current = enableFocusLock(contentRef);
    } else {
      disableFocusLock(focusLockEventRef.current);
    }
  }, [isModalOpen]);
  const renderCTA = () => {
    return ctaList == null ? void 0 : ctaList.map((cta, i) => {
      return Boolean(cta.btnVersion === 2) ? /* @__PURE__ */ jsxs(
        ButtonV2,
        {
          variant: Variation.PRIMARY,
          size: Size.MEDIUM,
          color: cta.color,
          customClass: (cta == null ? void 0 : cta.modifierClass) ? `${componentClassName2}__${cta == null ? void 0 : cta.modifierClass}` : "",
          onClick: () => cta == null ? void 0 : cta.ctaClickedCallBack(),
          children: [
            (cta == null ? void 0 : cta.showBaseIcon) && /* @__PURE__ */ jsx(BaseIcon, { animation: { type: Animation$1.PULSE }, size: Size.XL, isOutline: true }),
            cta == null ? void 0 : cta.ctaLabel
          ]
        },
        i
      ) : /* @__PURE__ */ jsx(
        Button,
        {
          type: cta == null ? void 0 : cta.ctaType,
          size: "small",
          modifierClass: (cta == null ? void 0 : cta.modifierClass) ? `${componentClassName2}__${cta == null ? void 0 : cta.modifierClass}` : "",
          onClick: () => cta == null ? void 0 : cta.ctaClickedCallBack(),
          children: cta == null ? void 0 : cta.ctaLabel
        },
        i
      );
    });
  };
  useClickOutsideClose(contentRef, () => closeHandler(), isModalOpen, true);
  return /* @__PURE__ */ jsx(ReactModal, { isOpen: isModalOpen, closeHandler: () => closeHandler(), children: /* @__PURE__ */ jsxs("section", { ref: contentRef, className: componentClassName2, children: [
    displayCloseButton && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__close-container`, children: /* @__PURE__ */ jsx(Button, { id: "info-button", type: "icon_button", onClick: () => closeHandler(), children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" }) }) }),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-xs-align-items-center ${componentClassName2}__container`, children: [
      /* @__PURE__ */ jsx(HeaderBlock, { title, subtitle }),
      /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__body`, children: [
        /* @__PURE__ */ jsx("p", { className: `${componentClassName2}__body__title`, children: swapRow == null ? void 0 : swapRow.label }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${PREFIX}-row ${PREFIX}-xs-align-items-center ${componentClassName2}__swap-card`,
            children: [
              /* @__PURE__ */ jsx(
                "img",
                {
                  className: `${componentClassName2}__swap-card__img`,
                  alt: (_a = swapRow == null ? void 0 : swapRow.imgAttribute) == null ? void 0 : _a.alt,
                  ...applyAkamaiPolicy(
                    (_b = swapRow == null ? void 0 : swapRow.imgAttribute) == null ? void 0 : _b.src,
                    offerConstants.bannerLogoImgComponentName,
                    false,
                    returnPolicy
                  )
                }
              ),
              /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__swap-card__desc`, children: swapRow == null ? void 0 : swapRow.desc })
            ]
          }
        ),
        /* @__PURE__ */ jsx("p", { children: swappableRow == null ? void 0 : swappableRow.label }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `${PREFIX}-row ${PREFIX}-xs-align-items-center ${componentClassName2}__swap-card`,
            children: [
              /* @__PURE__ */ jsx(
                "img",
                {
                  className: `${componentClassName2}__swap-card__img`,
                  alt: (_c = swappableRow == null ? void 0 : swappableRow.imgAttribute) == null ? void 0 : _c.alt,
                  ...applyAkamaiPolicy(
                    (_d = swappableRow == null ? void 0 : swappableRow.imgAttribute) == null ? void 0 : _d.src,
                    offerConstants.bannerLogoImgComponentName,
                    false,
                    returnPolicy
                  )
                }
              ),
              /* @__PURE__ */ jsx("span", { className: `${componentClassName2}__swap-card__detail`, children: swappableRow == null ? void 0 : swappableRow.desc })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__footer`, children: renderCTA() })
    ] })
  ] }) });
};
const InformativeModal = ({ ...props }) => {
  const { closeInformationModal, title, isModalOpen, children, headingVariant } = props;
  const componentClassName2 = `${PREFIX}-informative-modal`;
  const contentRef = useRef(null);
  const modalClassName = `${PREFIX}-react-modal`;
  const previousElement = document.querySelector(`button[${previousElementName}]`);
  const closeHandler = () => {
    modalAccessibilityHandler({ modalOpen: false, modalClassName });
    closeInformationModal();
    if (previousElement) {
      previousElement.focus();
      previousElement.removeAttribute(previousElementName);
    }
  };
  useClickOutsideClose(contentRef, () => closeHandler(), isModalOpen, true);
  return /* @__PURE__ */ jsx(ReactModal, { closeHandler: () => closeHandler(), isOpen: isModalOpen, children: /* @__PURE__ */ jsxs("div", { className: componentClassName2, ref: contentRef, children: [
    /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__close-container`, children: /* @__PURE__ */ jsx(Button, { type: "icon_button", onClick: () => closeHandler(), children: /* @__PURE__ */ jsx(Icon, { type: "ct-close", size: "lg" }) }) }),
    /* @__PURE__ */ jsxs("div", { className: ` ${componentClassName2}__container`, children: [
      /* @__PURE__ */ jsx(Heading, { variant: headingVariant, componentClass: `${componentClassName2}__header-text`, children: title }),
      children
    ] })
  ] }) });
};
InformativeModal.propTypes = {
  closeInformationModal: PropTypes.func,
  isModalOpen: PropTypes.bool
};
var ProgressSizes = /* @__PURE__ */ ((ProgressSizes2) => {
  ProgressSizes2["SMALL"] = "small";
  ProgressSizes2["LARGE"] = "large";
  return ProgressSizes2;
})(ProgressSizes || {});
var ProgressType = /* @__PURE__ */ ((ProgressType2) => {
  ProgressType2["SPINNER"] = "spinner";
  ProgressType2["PROGRESS"] = "progress";
  return ProgressType2;
})(ProgressType || {});
var ProgressValuePosition = /* @__PURE__ */ ((ProgressValuePosition2) => {
  ProgressValuePosition2["INSIDE"] = "inside";
  ProgressValuePosition2["BELOW"] = "below";
  return ProgressValuePosition2;
})(ProgressValuePosition || {});
const CircularProgress = ({ ...props }) => {
  const [strokeDashOffset, setStrokeDashOffset] = useState(0);
  const className2 = `${PREFIX}-circular-progress`;
  const circularProgresElement = useRef(null);
  const progressContainer = useRef(null);
  useLayoutEffect(() => {
    const progressCircle = circularProgresElement.current;
    const strokeWidth = parseInt(window.getComputedStyle(progressCircle).strokeWidth, 10);
    const radius = progressCircle.getBoundingClientRect().width / 2;
    const cirumference = 2 * radius * Math.PI;
    const capWidth = props.value === 0 || props.value === 100 ? 0 : strokeWidth;
    const strokeOffset = (cirumference - props.value * cirumference / 100 + capWidth) * -1;
    setStrokeDashOffset(strokeOffset);
    if (props.strokeColor) {
      progressContainer.current.style.stroke = props.strokeColor;
      progressContainer.current.style.color = props.strokeColor;
      progressContainer.current.style.fill = props.strokeColor;
    }
  }, [props.size, props.value, className2, props.strokeColor]);
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: `${className2} ${className2}--${props.type} ${className2}--${props.size} ${className2}--${props.position}`,
      ref: progressContainer,
      children: [
        /* @__PURE__ */ jsxs("svg", { className: `${className2}__svg`, children: [
          /* @__PURE__ */ jsx("circle", { className: `${className2}__track` }),
          /* @__PURE__ */ jsx(
            "circle",
            {
              className: `${className2}__progress ${className2}__progress--${props.type}`,
              strokeDashoffset: props.type && props.type !== ProgressType.SPINNER ? strokeDashOffset : 0,
              ref: circularProgresElement
            }
          )
        ] }),
        props.displayValue && /* @__PURE__ */ jsx("span", { className: `${className2}__value ${className2}__value--${props.type}`, children: props.value }),
        props.children
      ]
    }
  );
};
CircularProgress.defaultProps = {
  value: 0,
  type: ProgressType.SPINNER,
  displayValue: false,
  position: ProgressValuePosition.INSIDE
};
CircularProgress.propTypes = {
  value: PropTypes.number,
  size: PropTypes.oneOf([ProgressSizes.LARGE, ProgressSizes.SMALL]),
  type: PropTypes.oneOf([ProgressType.PROGRESS, ProgressType.SPINNER]),
  displayValue: PropTypes.bool,
  position: PropTypes.oneOf([ProgressValuePosition.BELOW, ProgressValuePosition.INSIDE]),
  strokeColor: PropTypes.string
};
CircularProgress.displayName = "CircularProgressInLib";
const onElementAvailable = (selector, callback) => {
  const observer = new MutationObserver(() => {
    const nodeList = document.querySelectorAll(selector);
    if (nodeList.length > 0) {
      callback(nodeList);
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
};
const getOfferCodesParam = (offerCodeParameterName) => {
  var _a;
  const urlParams = new URLSearchParams(window.location.search);
  return ((_a = urlParams.get(offerCodeParameterName)) == null ? void 0 : _a.split(offerCodesRegEx, 1)[0]) || "";
};
const getColumns = (rewardsPerRowDesktop, rewardsPerRowTablet) => {
  return {
    md: rewardsPerRowDesktop ? magicNumber.TWELVE / rewardsPerRowDesktop : magicNumber.TWELVE / magicNumber.THREE,
    sm: rewardsPerRowTablet ? magicNumber.TWELVE / rewardsPerRowTablet : magicNumber.TWELVE / magicNumber.TWO,
    xs: magicNumber.THREE
  };
};
const brazeCustomEvents = {
  event: {
    accessWeeklyOffers: "web_access_weekly_offers",
    accessEmailOffers: "web_access_email_offers",
    loyaltyOffersView: "web_loyalty_offers_view",
    loyaltyOffersActivationAll: "web_loyalty_offers_activation_all",
    loyaltyOffersActivation: "web_loyalty_offers_activation",
    loyaltyOffersActivationInlinePte: "web_loyalty_offers_activation_inline_pte",
    loyaltyOffersActivationFlyoutPte: "web_loyalty_offers_activation_flyout_pte",
    loyaltyOffersActivationCarousel: "web_loyalty_offers_activation_carousel",
    loyaltyOffersViewAllCarousel: "web_loyalty_offers_view_all_carousel",
    triangleOpenOfferSwapTab: "web_open_offer_swap_tab",
    triangleOfferClickSwap: "web_offer_click_swap",
    triangleOfferClickSelect: "web_offer_click_select",
    triangleOfferSwap: "web_offer_swap_success",
    triangleOfferSwapErrorUnavailable: "web_offer_swap_error_unavailable",
    triangleSwapErrorAlreadyInWOL: "web_swap_error_already_in_WOL",
    triangleFilterSwapOffer: "web_filter_swap_offer",
    successfulLoyaltySignin: "web_successful_loyalty_signin",
    successfulGigyaSignin: "web_successful_gigya_signin",
    registrationGigya: "web_registration_gigya",
    registrationLoyalty: "web_registration_loyalty",
    flyerView: "web_flyer_view",
    flyerProductClick: "web_flyer_product_click",
    addToCart: "web_add_to_cart",
    shoppingCart: "web_shopping_cart",
    removeFromCart: "web_remove_from_cart",
    wishlistConversion: "web_wishlist_conversion",
    webClearanceView: "web_clearance_view",
    webSalesView: "web_sales_view",
    webSearch: "web_search",
    webSetStore: "web_set_store"
  }
};
const brazeCustomEventsPages = {
  clearance: "clearance",
  sale: "sale"
};
const TabsItemContainer = (props) => /* @__PURE__ */ jsx(Fragment, { children: props.children });
TabsItemContainer.displayName = "TabsItemContainer";
const ComparisonTable = ({ ...props }) => {
  const {
    rowsOnLoad,
    comparisonTableData,
    title,
    seeMoreLabel,
    seeLessLabel,
    isSticky,
    setIsSticky,
    visibleRows,
    setVisibleRows,
    isTableExpanded,
    setIsTableExpanded,
    toggleComponent
  } = props;
  const compareSimilarProductClass = `${PREFIX}-csp`;
  const stickyHeaderClass = isSticky ? `${PREFIX}__sticky-header` : "";
  const handleShowMore = () => {
    const numberOfHiddenRows = comparisonTableData.length - rowsOnLoad;
    setVisibleRows((prevVisibleRows) => isTableExpanded ? rowsOnLoad + 1 : prevVisibleRows + numberOfHiddenRows);
    setIsTableExpanded(!isTableExpanded);
    isTableExpanded && (setIsSticky == null ? void 0 : setIsSticky(false));
  };
  const visibleData = comparisonTableData.slice(0, visibleRows);
  const buttonChevron = isTableExpanded ? "ct-chevron-up" : "ct-chevron-down";
  return /* @__PURE__ */ jsxs("div", { id: compareSimilarProductClass, className: compareSimilarProductClass, children: [
    title && /* @__PURE__ */ jsx("div", { className: `${compareSimilarProductClass}__header`, children: /* @__PURE__ */ jsx("h2", { children: title }) }),
    /* @__PURE__ */ jsxs("div", { className: `${compareSimilarProductClass}__table ${stickyHeaderClass}`, children: [
      toggleComponent,
      /* @__PURE__ */ jsx(
        Table,
        {
          tableRichText: true,
          tableType: window.innerWidth > BREAKPOINTS.tabletMaxWidth ? "stripped" : "vertical-stripped",
          headerType: window.innerWidth > BREAKPOINTS.tabletMaxWidth ? "column" : "row",
          tableData: visibleData
        }
      ),
      /* @__PURE__ */ jsx("div", { className: `${compareSimilarProductClass}__show-more-button`, children: /* @__PURE__ */ jsxs(Button, { id: "viewProductBtn", type: "tertiary", size: "medium", onClick: handleShowMore, children: [
        isTableExpanded ? seeLessLabel : seeMoreLabel,
        /* @__PURE__ */ jsx(Icon, { type: buttonChevron, size: "sm" })
      ] }) })
    ] })
  ] });
};
ComparisonTable.propTypes = {
  rowsOnLoad: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  seeLessLabel: PropTypes.string,
  seeMoreLabel: PropTypes.string
};
const getOfferParams = (selectedOffer) => {
  var _a, _b;
  return {
    date: getCurrentDate(),
    loyalty_offers_code: selectedOffer == null ? void 0 : selectedOffer.offerCode,
    loyalty_offers_description: (_a = selectedOffer == null ? void 0 : selectedOffer.details) == null ? void 0 : _a.bonusDetailedDescription,
    loyalty_offers_name: (_b = selectedOffer == null ? void 0 : selectedOffer.details) == null ? void 0 : _b.offerShortDesc
  };
};
const getSourceParam = (bannerId) => {
  return {
    source: bannerId
  };
};
const getCategoryParams = (breadcrumbList, categoryList) => {
  const [categoryL1, categoryL2, categoryL3, categoryL4] = breadcrumbList || [];
  const currentBreadcrumbVal = isArrayNotEmpty(breadcrumbList) && breadcrumbList[breadcrumbList.length - 1];
  return {
    category_breadcrumb: categoryList,
    category_id: currentBreadcrumbVal == null ? void 0 : currentBreadcrumbVal.categoryId,
    category_name: currentBreadcrumbVal == null ? void 0 : currentBreadcrumbVal.label,
    category_l1_id: categoryL1 == null ? void 0 : categoryL1.categoryId,
    category_l1_name: categoryL1 == null ? void 0 : categoryL1.label,
    category_l2_id: categoryL2 == null ? void 0 : categoryL2.categoryId,
    category_l2_name: categoryL2 == null ? void 0 : categoryL2.label,
    category_l3_id: categoryL3 == null ? void 0 : categoryL3.categoryId,
    category_l3_name: categoryL3 == null ? void 0 : categoryL3.label,
    category_l4_id: categoryL4 == null ? void 0 : categoryL4.categoryId,
    category_l4_name: categoryL4 == null ? void 0 : categoryL4.label
  };
};
const getBaseProductParams = (cartItemData, productPrice) => {
  const { code, name, currentPrice } = (cartItemData == null ? void 0 : cartItemData.entry) || {};
  return {
    item_id: code,
    item_name: name,
    price: (productPrice == null ? void 0 : productPrice.value) ? productPrice == null ? void 0 : productPrice.value : currentPrice == null ? void 0 : currentPrice.value,
    currency: currencyFormat
  };
};
const getProductParams = (cartItemData, productPrice) => {
  const { brand } = (cartItemData == null ? void 0 : cartItemData.entry) || {};
  return {
    item_brand: brand == null ? void 0 : brand.label,
    quantity: cartItemData == null ? void 0 : cartItemData.numberOfItems,
    ...getBaseProductParams(cartItemData, productPrice)
  };
};
const getStoreParams = (store) => {
  return {
    store_name: store == null ? void 0 : store.name,
    store_number: store == null ? void 0 : store.id
  };
};
const MultiboxInput = ({
  inputLabel,
  numInputs,
  onChange,
  error,
  onVerify,
  shouldCleanInputsOnCTA: isClearOnCTA,
  setShouldCleanInputsOnCTA
}) => {
  const componentClassName2 = "multibox-input";
  const boxReference = useRef([]);
  const [inputCodeArray, setInputCodeArray] = useState(new Array(numInputs).fill(""));
  useEffect(() => {
    boxReference.current = Array.from({ length: numInputs }, () => React.createRef());
  }, [numInputs]);
  useEffect(() => {
    if (isClearOnCTA) {
      const emptyArray = new Array(numInputs).fill("");
      setInputCodeArray(emptyArray);
      onChange(emptyArray);
      setShouldCleanInputsOnCTA(false);
    }
  }, [isClearOnCTA]);
  const handleChange = (value, index2) => {
    var _a;
    const newArr = [...inputCodeArray];
    newArr[index2] = value;
    onChange(newArr);
    setInputCodeArray(newArr);
    if (value && index2 < numInputs - 1) {
      (_a = boxReference.current[index2 + 1].current) == null ? void 0 : _a.focus();
    }
  };
  const handleBackspaceAndEnter = (e, index2) => {
    var _a, _b, _c;
    if (e.key === stringKeyCodes.backspace && !e.target.value && index2 > 0) {
      (_a = boxReference.current[index2 - 1].current) == null ? void 0 : _a.focus();
    }
    if (e.key === stringKeyCodes.rightArrow && index2 < numInputs - 1) {
      (_b = boxReference.current[index2 + 1].current) == null ? void 0 : _b.focus();
    }
    if (e.key === stringKeyCodes.leftArrow && index2 > 0) {
      (_c = boxReference.current[index2 - 1].current) == null ? void 0 : _c.focus();
    }
    if (e.key === stringKeyCodes.enter) {
      onVerify();
    }
  };
  const renderErrorField = () => {
    return /* @__PURE__ */ jsx("span", { className: `${PREFIX}-${componentClassName2}__msg-text`, id: "input_textError", children: error });
  };
  const handlePaste = (event, index2) => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData("text");
    const numbers = pasteData.split("").filter((number) => !isNaN(Number(number)));
    if (numbers.length > 0 || numbers.length > index2) {
      const newInputCodeArray = [...inputCodeArray];
      numbers.forEach((num) => {
        var _a;
        if (index2 < numInputs) {
          newInputCodeArray[index2] = num;
          if (index2 < numInputs - 1) {
            (_a = boxReference.current[index2 + 1].current) == null ? void 0 : _a.focus();
          }
          index2++;
        }
      });
      setInputCodeArray(newInputCodeArray);
      onChange(newInputCodeArray);
    }
  };
  return /* @__PURE__ */ jsxs("section", { className: `${PREFIX}-${componentClassName2}`, children: [
    /* @__PURE__ */ jsx("p", { className: `${PREFIX}-${componentClassName2}__code-field-label`, children: inputLabel }),
    /* @__PURE__ */ jsx(
      "section",
      {
        className: error ? `${PREFIX}-${componentClassName2}__container ${PREFIX}-${componentClassName2}__container--error` : `${PREFIX}-${componentClassName2}__container`,
        children: inputCodeArray.map((value, index2) => /* @__PURE__ */ jsx("div", { className: `${PREFIX}-multibox-input`, children: /* @__PURE__ */ jsx(
          TextInput,
          {
            value,
            maxLength: 1,
            onChange: (e) => handleChange(e, index2),
            onKeyDown: (e) => handleBackspaceAndEnter(e, index2),
            textInputRef: boxReference.current[index2],
            id: `multibox-input-${index2}`,
            onPaste: (e) => handlePaste(e, index2)
          },
          index2
        ) }, index2))
      }
    ),
    error && renderErrorField()
  ] });
};
const VerificationScreen = ({ ...props }) => {
  const verificationScreenCodeId = "verification-screen-code";
  const componentClassName2 = `${PREFIX}-verification-screen`;
  const {
    primaryLogo,
    secondaryLogo,
    title,
    subTitle,
    codeFieldLabel,
    ctaList,
    input: { onChange, error },
    userID,
    toast,
    buttonGroupDirection
  } = props;
  const [inputCode, setInputCode] = useState([]);
  const [shouldCleanInputsOnCTA, setShouldCleanInputsOnCTA] = useState(false);
  useEffect(() => {
    setFocusToElement(verificationScreenCodeId);
  });
  useEffect(() => {
    const convertedInputCode = convertCodeArrayToString(inputCode);
    if (!convertedInputCode || verificationCodeRegex.exec(convertedInputCode)) {
      onChange(false);
    }
  }, [inputCode, onChange]);
  const verifyCodeHandler = () => {
    const convertedInputCode = convertCodeArrayToString(inputCode);
    if (verificationCodeRegex.exec(convertedInputCode)) {
      ctaList[0].onClick(convertedInputCode);
    } else {
      onChange(true);
    }
  };
  const toastMessageProps = useMemo(() => toast == null ? void 0 : toast.msg, [toast == null ? void 0 : toast.msg]);
  const renderToastMessage = () => (toast == null ? void 0 : toast.show) ? /* @__PURE__ */ jsx(InlineToast, { state: State.CAUTION, children: toastMessageProps }) : null;
  const renderVerificationScreenHeader = () => {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      primaryLogo && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__logo`, children: /* @__PURE__ */ jsx("img", { src: primaryLogo, alt: "" }) }),
      /* @__PURE__ */ jsxs("section", { className: `${componentClassName2}__header`, children: [
        secondaryLogo && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__header--logo`, children: /* @__PURE__ */ jsx("img", { src: secondaryLogo, alt: "" }) }),
        /* @__PURE__ */ jsx("p", { className: `${componentClassName2}__header--title`, children: title })
      ] })
    ] });
  };
  const onSecondButtonClick = () => {
    ctaList[1].onClick();
    setShouldCleanInputsOnCTA(true);
  };
  const convertCodeArrayToString = (codeArray) => codeArray.map((number) => number.toString()).join("");
  const renderVerificationScreenFooter = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    return /* @__PURE__ */ jsxs(
      ButtonGroup,
      {
        isWrap: false,
        direction: buttonGroupDirection ?? Direction.VERTICAL,
        customClass: `${componentClassName2}__footer`,
        position: Position.CENTER,
        children: [
          /* @__PURE__ */ jsx(
            ButtonV2,
            {
              variant: ((_a = ctaList[0]) == null ? void 0 : _a.variant) || Variation.PRIMARY,
              onClick: verifyCodeHandler,
              color: ((_b = ctaList[0]) == null ? void 0 : _b.color) || ButtonColors.DARK,
              children: ctaList[0].children
            }
          ),
          /* @__PURE__ */ jsx(
            ButtonV2,
            {
              variant: ((_c = ctaList[1]) == null ? void 0 : _c.variant) || Variation.TERTIARY,
              onClick: onSecondButtonClick,
              color: ((_d = ctaList[1]) == null ? void 0 : _d.color) || ButtonColors.DEFAULT,
              disabled: (_e = ctaList[1]) == null ? void 0 : _e.disabled,
              "aria-disabled": (_g = (_f = ctaList[1]) == null ? void 0 : _f.a11y) == null ? void 0 : _g.disabled,
              children: ctaList[1].children
            }
          )
        ]
      }
    );
  };
  const renderVerificationScreenBody = () => {
    return /* @__PURE__ */ jsxs("section", { className: `${componentClassName2}__body`, children: [
      /* @__PURE__ */ jsx("p", { className: `${componentClassName2}__body--text`, children: subTitle }),
      /* @__PURE__ */ jsx("p", { className: `${componentClassName2}__body--userID`, dangerouslySetInnerHTML: { __html: userID } }),
      /* @__PURE__ */ jsx("div", { className: `${PREFIX}-xs-justify-center ${componentClassName2}__code-field`, children: /* @__PURE__ */ jsx(
        MultiboxInput,
        {
          inputLabel: codeFieldLabel,
          numInputs: verificationScreenInputsCount,
          onChange: setInputCode,
          error,
          onVerify: verifyCodeHandler,
          shouldCleanInputsOnCTA,
          setShouldCleanInputsOnCTA
        }
      ) }),
      renderToastMessage()
    ] });
  };
  return /* @__PURE__ */ jsxs("div", { className: componentClassName2, children: [
    renderVerificationScreenHeader(),
    renderVerificationScreenBody(),
    renderVerificationScreenFooter()
  ] });
};
const SkipLink = ({ ...props }) => {
  const { label, customClass, skipTo } = props;
  return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-accessibility-links ${PREFIX}-accessibility-links-align`, children: /* @__PURE__ */ jsx(
    "a",
    {
      className: `${PREFIX}-skip-link ${PREFIX}-skip-link--vertical-filters ${customClass}`,
      href: `#${skipTo}`,
      children: label
    }
  ) });
};
var ContentVariation = /* @__PURE__ */ ((ContentVariation2) => {
  ContentVariation2["Image"] = "image";
  ContentVariation2["CaptionImage"] = "captioned_image";
  ContentVariation2["ImageLeft"] = "image_left";
  ContentVariation2["Right"] = "right";
  ContentVariation2["ImageRight"] = "image_right";
  return ContentVariation2;
})(ContentVariation || {});
const CustomContentCard = ({ ...props }) => {
  const { type, cardInfo, contentPosition, triggerEvent } = props;
  const { imageUrl, title, description, url, linkText } = cardInfo;
  const componentClass = `${PREFIX}-custom-card__container`;
  const isCardPositionRight = Boolean(contentPosition === ContentVariation.ImageRight);
  const modifierClass = type === ContentVariation.CaptionImage ? `${PREFIX}-col-md-5 ${PREFIX}-col-sm-6` : "";
  const isMobile2 = useIsMobile();
  const renderImageContentCard = (link) => /* @__PURE__ */ jsx(
    ButtonV2,
    {
      variant: Variation.TERTIARY,
      customClass: `${componentClass}__image ${modifierClass}`,
      onClick: () => triggerContentCardEvent(link),
      children: /* @__PURE__ */ jsxs("picture", { children: [
        /* @__PURE__ */ jsx("source", { srcSet: imageUrl }),
        /* @__PURE__ */ jsx("img", { className: `${componentClass}__image--img`, alt: title ?? "", src: imageUrl })
      ] })
    }
  );
  const triggerContentCardEvent = (link) => {
    triggerEvent && triggerEvent(cardInfo);
    if (link) {
      window.location.href = encodeURI(link);
    }
  };
  const renderCaptionedImageContentCard = () => /* @__PURE__ */ jsxs("div", { className: `${componentClass} ${PREFIX}-row`, children: [
    (!isCardPositionRight || isMobile2) && renderImageContentCard(url),
    /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-col-md-7 ${PREFIX}-col-sm-6 ${componentClass}__content`, children: [
      title && /* @__PURE__ */ jsx(HeaderBlock, { title, subtitle: description }),
      linkText && /* @__PURE__ */ jsx(
        ButtonV2,
        {
          variant: Variation.PRIMARY,
          size: Size.MINI,
          color: ButtonColors.DARK,
          a11y: { label: linkText },
          onClick: () => triggerContentCardEvent(url),
          children: linkText
        }
      )
    ] }),
    isCardPositionRight && !isMobile2 && renderImageContentCard(url)
  ] });
  switch (type) {
    case ContentVariation.Image:
      return renderImageContentCard();
    case ContentVariation.CaptionImage:
      return renderCaptionedImageContentCard();
    default:
      return null;
  }
};
const TransactionBackgroundImage = (props) => {
  const { showBg, img, altText } = props;
  return showBg ? /* @__PURE__ */ jsx("img", { className: `${PREFIX}-transaction-bg`, src: img, alt: altText }) : null;
};
const RenderFullModal = (props) => {
  const {
    comparisonTableData,
    rowsOnLoad,
    seeMoreLabel,
    seeLessLabel,
    isSticky,
    setIsSticky,
    visibleRows,
    setVisibleRows,
    isTableExpanded,
    setIsTableExpanded
  } = props;
  useEffect(() => {
    const handleScroll = (scrollTop) => {
      const buyBoxCompEL = document.querySelector(".first-row") || null;
      const buyBoxCompELHeight = (buyBoxCompEL == null ? void 0 : buyBoxCompEL.clientHeight) ?? 0;
      scrollTop + 100 > buyBoxCompELHeight && setIsSticky(true);
      if (scrollTop === 0) {
        setIsSticky(false);
      }
    };
    const scrollableElement = document.querySelector(`.${PREFIX}-csp__table `);
    scrollableElement.addEventListener("scroll", () => handleScroll(scrollableElement.scrollTop));
    return () => {
      scrollableElement.removeEventListener("scroll", () => handleScroll(scrollableElement.scrollTop));
    };
  }, []);
  const overFlowHiddenClass = "modal-open-not-scroll";
  document.body.classList.add(overFlowHiddenClass);
  return /* @__PURE__ */ jsx(
    ComparisonTable,
    {
      comparisonTableData,
      rowsOnLoad,
      seeMoreLabel,
      seeLessLabel,
      isSticky,
      setIsSticky,
      visibleRows,
      setVisibleRows,
      isTableExpanded,
      setIsTableExpanded
    }
  );
};
const CompareProductsFlyout = ({ ...props }) => {
  const {
    compareProductList,
    returnPolicy,
    productCardClick,
    removeCompareProductCard,
    compareProductCardClearAllBtn,
    compareBtn,
    isHalfModalOpen,
    setIsHalfModalOpen,
    isFullModalOpen,
    setIsFullModalOpen,
    compareProductsL,
    clearAllLabel,
    compareL,
    selectItemsToCompareL,
    a11yStrikeOutPrice,
    a11yStrikeOutPriceRange,
    closeLabel,
    language: language2,
    badgePriority,
    emptyCardClick,
    addProductItemToWishlist,
    addToCartBtnClick,
    wishlistItems,
    compareProductsSpecificationList,
    showAtcBtnSpinner,
    clickedATCCardIdx,
    showWishlistBtnSpinner,
    clickedWishlistIdx,
    showDifferencesData,
    isShowDifferenceToggled,
    viewMoreSpecsL,
    viewFewSpecsL,
    addItemstoCompareL,
    showDiffL,
    addAllToWishListL,
    specificationLabel,
    compareBtnSpinner,
    noOfSpecsOnIniLoad,
    addToCartLabel,
    addButton,
    optionsButton,
    isAllComparisonProductAreWishlist,
    notApplicableL
  } = props;
  const [isSticky, setIsSticky] = useState(false);
  const compareProductsFlyoutClass = `${PREFIX}-compare-products-flyout`;
  const showFullModalClass = isFullModalOpen ? `${PREFIX}-compare-products-flyout__full-modal` : "";
  const showOverlayClass = isFullModalOpen ? `${PREFIX}-overlay` : "";
  const showHalfOrFullModalClass = isHalfModalOpen ? `${PREFIX}-compare-products-flyout__half-modal` : showFullModalClass;
  useEffect(() => {
    var _a;
    const productDataCardList = document.body.getElementsByClassName(`${PREFIX}-product__list-view`);
    if (isHalfModalOpen) {
      productDataCardList.length && ((_a = productDataCardList[productDataCardList.length - 1]) == null ? void 0 : _a.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      }));
      document.body.classList.remove(MODAL_OPEN_CLASS_NOT_SCROLL);
    }
  }, [isHalfModalOpen, compareProductList]);
  const showUpdatedSpinner = (idx, isATCSpinner) => {
    const cardIndex = isATCSpinner ? clickedATCCardIdx : clickedWishlistIdx;
    const isSpinnerShow = isATCSpinner ? showAtcBtnSpinner : showWishlistBtnSpinner;
    return cardIndex === idx ? isSpinnerShow : false;
  };
  const getProductCodes = (productList) => {
    return (productList == null ? void 0 : productList.filter((product) => product.isWishlistEligible && !product.isWishlistItemActive).map(({ code, skus, currentPrice }) => ({ code, skus, currentPrice }))) || [];
  };
  const updateComparisonProductList = () => {
    const updatedProductList = [...compareProductList];
    const numberOfEmptyCard = 4 - updatedProductList.length;
    if (numberOfEmptyCard < 4) {
      [...Array(numberOfEmptyCard)].forEach(() => {
        updatedProductList.push({});
      });
    } else {
      return compareProductList;
    }
    return updatedProductList;
  };
  const getProductSkuCode = (sku, code) => {
    var _a;
    return (sku == null ? void 0 : sku.length) === 1 ? (_a = sku == null ? void 0 : sku[0]) == null ? void 0 : _a.code : code.toUpperCase().replace("P", "");
  };
  const isWishlistActive = (sku, code) => {
    var _a;
    return (_a = wishlistItems == null ? void 0 : wishlistItems.products) == null ? void 0 : _a.some((wishlist) => wishlist.code === getProductSkuCode(sku, code));
  };
  const renderCTA = () => {
    return /* @__PURE__ */ jsxs("div", { className: `${compareProductsFlyoutClass}__btn-row`, children: [
      /* @__PURE__ */ jsx(
        SpinnerButton,
        {
          variant: Variation.PRIMARY,
          color: ButtonColors.DARK,
          size: Size.MINI,
          a11y: {
            label: compareL
          },
          showSpinner: compareBtnSpinner,
          onClick: compareBtn,
          "dap-wac-link": "true",
          "dap-wac-loc": compareProductsL,
          "dap-wac-value": compareL,
          "dap-wac-link-section": "compare-button",
          customClass: `${compareProductsFlyoutClass}__btn-row-compare`,
          children: !compareBtnSpinner && compareL
        }
      ),
      /* @__PURE__ */ jsx(
        ButtonV2,
        {
          variant: Variation.TERTIARY,
          a11y: {
            label: clearAllLabel
          },
          onClick: compareProductCardClearAllBtn,
          children: clearAllLabel
        }
      )
    ] });
  };
  const getProductCardsList = (product, index2, showGridViewListView) => {
    var _a, _b, _c;
    const {
      title: productTitle,
      brand,
      images,
      rating,
      ratingsCount,
      currentPrice,
      url,
      code,
      skus,
      isOnSale,
      badges,
      isWishlistToShow,
      isWishlistEligible
    } = product;
    const productProps = {
      ratingsAndReview: true,
      addButton,
      optionsButton
    };
    const isWishlistItemActive = areAllParamsValid(isWishlistToShow, isWishlistActive(skus, code));
    return /* @__PURE__ */ jsx("div", { className: showGridViewListView, children: /* @__PURE__ */ jsx(
      ProductCard,
      {
        product,
        url,
        productProps,
        idx: index2,
        cardType: "grid",
        title: productTitle,
        code: null,
        brand,
        images,
        rating,
        ratingsCount: ratingsCount || 0,
        productCardClick: (event, productdata, idx) => productCardClick(event, productdata, idx),
        a11yStrikeOutPrice,
        a11yStrikeOutPriceRange,
        showRatingSection: true,
        language: language2,
        currentPrice: currentPrice || ((_a = skus == null ? void 0 : skus[0]) == null ? void 0 : _a.currentPrice),
        returnPolicy,
        enableSaveStory: false,
        productDataId: code,
        accessibilityId: getAccessibilityId(code, ((_b = skus == null ? void 0 : skus[0]) == null ? void 0 : _b.code) ? (_c = skus == null ? void 0 : skus[0]) == null ? void 0 : _c.code : code),
        boldBrand: true,
        showSaleClearanceBadge: true,
        swiperLazyLoading: true,
        showCloseBtn: true,
        removeCompareProductCard,
        isOnSale,
        closeLabel,
        isFullModalOpen,
        isHalfModalOpen,
        isSticky,
        badges,
        badgePriorities: badgePriority,
        showBadge: isFullModalOpen,
        addProductItemToWishlist,
        addToCartBtnClick,
        isWishlistToShow,
        isWishlistItemActive,
        isWishlistEligible,
        showAtcBtnSpinner: showUpdatedSpinner(index2, true),
        showWishlistBtnSpinner: showUpdatedSpinner(index2, false),
        addToCartLabel,
        enableBadges: isFullModalOpen
      },
      index2
    ) });
  };
  const emptyCard = (index2) => {
    return isFullModalOpen ? /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${compareProductsFlyoutClass}__full-modal-empty-card ${PREFIX}-sm-justify-center ${PREFIX}-sm-align-items-center ${PREFIX}-sm-flex ${PREFIX}-sm-column`,
        children: [
          /* @__PURE__ */ jsx(Icon, { type: "ct-plus", size: "md" }),
          /* @__PURE__ */ jsx(
            ButtonV2,
            {
              variant: Variation.TERTIARY,
              color: ButtonColors.DARK,
              a11y: {
                label: addItemstoCompareL
              },
              onClick: emptyCardClick,
              children: addItemstoCompareL
            }
          )
        ]
      }
    ) : /* @__PURE__ */ jsx("div", { className: `${compareProductsFlyoutClass}__empty-product-card`, children: /* @__PURE__ */ jsx("div", { className: `${compareProductsFlyoutClass}__empty-product-card-text`, children: replaceStrWithDynamicVal(selectItemsToCompareL, index2 + 1) }) });
  };
  const renderHalfModal = () => {
    return [...Array(PRODUCT_CARD_COUNT)].map((_el, index2) => {
      if (isArrayEmpty(Object.keys(updateComparisonProductList()[index2]))) {
        return emptyCard(index2);
      } else {
        return getProductCardsList(compareProductList[index2], index2, `${PREFIX}-product__list-view`);
      }
    });
  };
  const getCompareTableProductCard = () => {
    return [...Array(PRODUCT_CARD_COUNT)].map((_el, index2) => {
      var _a;
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: `${PREFIX}-common-card ${PREFIX}-product__content`,
          children: /* @__PURE__ */ jsx("div", { className: `${PREFIX}-csp-product-list`, children: isArrayEmpty(Object.keys(updateComparisonProductList()[index2])) ? emptyCard(index2) : /* @__PURE__ */ jsx("div", { role: "none", children: getProductCardsList(compareProductList[index2], index2, `${PREFIX}-product__grid-view`) }) })
        },
        ((_a = compareProductList[index2]) == null ? void 0 : _a.code) || index2
      );
    });
  };
  const productCardTableData = [{ "": getCompareTableProductCard() }];
  const halfModelData = [{ "": renderHalfModal() }];
  const getCustomRowInFullModal = () => {
    return [...Array(1)].map((index2) => /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-custom-row-section ${PREFIX}-sm-flex ${PREFIX}-sm-column`, children: [
      /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-custom-row-left ${PREFIX}-sm-flex  ${PREFIX}-sm-justify-space-between`, children: [
        /* @__PURE__ */ jsxs("div", { className: `${PREFIX}-custom-row-switch-button ${PREFIX}-sm-flex`, children: [
          /* @__PURE__ */ jsx(
            Switch,
            {
              handleInputChange: showDifferencesData,
              label: showDiffL,
              checked: isShowDifferenceToggled
            }
          ),
          /* @__PURE__ */ jsx("span", { children: "|" }),
          /* @__PURE__ */ jsx(
            ButtonV2,
            {
              variant: Variation.TERTIARY,
              color: ButtonColors.DARK,
              a11y: {
                label: addAllToWishListL
              },
              icon: {
                type: isAllComparisonProductAreWishlist ? "ct-favorite-active" : "ct-favorite-inactive",
                size: "md"
              },
              onClick: (event) => addProductItemToWishlist(
                event,
                getProductCodes(compareProductList),
                false,
                null,
                true
              ),
              children: addAllToWishListL
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          ButtonV2,
          {
            variant: Variation.TERTIARY,
            color: ButtonColors.DARK,
            a11y: {
              label: clearAllLabel
            },
            onClick: compareProductCardClearAllBtn,
            children: clearAllLabel
          }
        )
      ] }),
      /* @__PURE__ */ jsx("span", { className: `${PREFIX}-specification-label`, children: specificationLabel })
    ] }, index2));
  };
  const customRowData = [{ "": getCustomRowInFullModal(), colspan: PRODUCT_CARD_COUNT }];
  const specificationData = Object.entries(compareProductsSpecificationList).map(
    ([label, values]) => ({
      [label]: [...Array(PRODUCT_CARD_COUNT)].map((_, idx) => /* @__PURE__ */ jsxs(
        "div",
        {
          className: `${PREFIX}-specification-row ${PREFIX}-sm-flex ${PREFIX}-sm-column`,
          children: [
            /* @__PURE__ */ jsx("span", { children: idx === 0 ? label : "" }),
            /* @__PURE__ */ jsx("span", { children: values[idx] || notApplicableL })
          ]
        },
        `${label}-${idx}`
      ))
    })
  );
  const comparisonTableData = [
    ...productCardTableData,
    ...halfModelData,
    ...customRowData,
    ...specificationData
  ];
  const [visibleRows, setVisibleRows] = useState(+noOfSpecsOnIniLoad + 1);
  const [isTableExpanded, setIsTableExpanded] = useState(visibleRows === comparisonTableData.length);
  return /* @__PURE__ */ jsx("div", { className: `${showOverlayClass}`, children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: `${compareProductsFlyoutClass} ${PREFIX}-column ${PREFIX}-sticky-comparison-bar 
            ${PREFIX}-sticky-comparison-bar--sticky ${showHalfOrFullModalClass}`,
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            className: `${compareProductsFlyoutClass}__comparison-btn`,
            onClick: () => {
              setIsHalfModalOpen(!isHalfModalOpen);
              setIsFullModalOpen(false);
              setIsSticky(false);
            },
            children: [
              /* @__PURE__ */ jsx(Heading, { variant: "h3", componentClass: `${compareProductsFlyoutClass}__comparison-heading`, children: `${compareProductsL ?? ""} (${compareProductList == null ? void 0 : compareProductList.length})` }),
              /* @__PURE__ */ jsx("div", { className: `${compareProductsFlyoutClass}__comparison-heading-icon`, children: isHalfModalOpen || isFullModalOpen ? /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-down", size: "lg" }) : /* @__PURE__ */ jsx(Icon, { type: "ct-chevron-up", size: "lg" }) })
            ]
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: `${compareProductsFlyoutClass}__product-card-row ${PREFIX}-full-width-container`, children: [
          /* @__PURE__ */ jsx("div", { className: `${compareProductsFlyoutClass}__product-card-row-data`, children: isFullModalOpen ? /* @__PURE__ */ jsx(
            RenderFullModal,
            {
              comparisonTableData,
              rowsOnLoad: noOfSpecsOnIniLoad,
              seeMoreLabel: viewMoreSpecsL,
              seeLessLabel: viewFewSpecsL,
              isSticky,
              setIsSticky,
              visibleRows,
              setVisibleRows,
              isTableExpanded,
              setIsTableExpanded
            }
          ) : renderHalfModal() }),
          !isFullModalOpen && renderCTA()
        ] })
      ]
    }
  ) });
};
CompareProductsFlyout.propTypes = {
  compareProductList: PropTypes.array,
  returnPolicy: PropTypes.func,
  productCardClick: PropTypes.func,
  removeCompareProductCard: PropTypes.func,
  compareProductCardClearAllBtn: PropTypes.func,
  compareBtn: PropTypes.func,
  isHalfModalOpen: PropTypes.bool,
  setIsHalfModalOpen: PropTypes.func,
  isFullModalOpen: PropTypes.bool,
  setIsFullModalOpen: PropTypes.func,
  compareProductsL: PropTypes.string,
  clearAllLabel: PropTypes.string,
  compareL: PropTypes.string,
  selectItemsToCompareL: PropTypes.string,
  a11yStrikeOutPrice: PropTypes.string,
  a11yStrikeOutPriceRange: PropTypes.string,
  closeLabel: PropTypes.string,
  language: PropTypes.string
};
const getFormatValueWithIcon = (value) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Icon, { size: "md", type: "ct-triangleMoney" }),
    getBalance(value)
  ] });
};
var dist = { exports: {} };
function memoize(fn) {
  var cache = {};
  return function(arg) {
    if (cache[arg] === void 0) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var index = memoize(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
const isPropValid_browser_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index
}, Symbol.toStringTag, { value: "Module" }));
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(isPropValid_browser_esm);
var hasRequiredDist;
function requireDist() {
  if (hasRequiredDist) return dist.exports;
  hasRequiredDist = 1;
  (function(module, exports) {
    !function(t, e) {
      module.exports = e(React);
    }(self, function(t) {
      return (() => {
        var e = { 297: (e2) => {
          e2.exports = t;
        } }, n = {};
        function s(t2) {
          var i2 = n[t2];
          if (void 0 !== i2) return i2.exports;
          var o = n[t2] = { exports: {} };
          return e[t2](o, o.exports, s), o.exports;
        }
        s.n = (t2) => {
          var e2 = t2 && t2.__esModule ? () => t2.default : () => t2;
          return s.d(e2, { a: e2 }), e2;
        }, s.d = (t2, e2) => {
          for (var n2 in e2) s.o(e2, n2) && !s.o(t2, n2) && Object.defineProperty(t2, n2, { enumerable: true, get: e2[n2] });
        }, s.o = (t2, e2) => Object.prototype.hasOwnProperty.call(t2, e2), s.r = (t2) => {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t2, "__esModule", { value: true });
        };
        var i = {};
        return (() => {
          s.r(i), s.d(i, { default: () => jo });
          var t2 = s(297), e2 = s.n(t2);
          const n2 = (t3) => t3;
          let r2 = n2;
          const a = { some: 0, all: 1 };
          const l = (t3) => /^\-?\d*\.?\d+$/.test(t3), u = (t3) => /^0[^.\s]+$/.test(t3), c = (t3) => Array.isArray(t3);
          function h(t3, e3) {
            -1 === t3.indexOf(e3) && t3.push(e3);
          }
          function d(t3, e3) {
            const n3 = t3.indexOf(e3);
            n3 > -1 && t3.splice(n3, 1);
          }
          class m {
            constructor() {
              this.subscriptions = [];
            }
            add(t3) {
              return h(this.subscriptions, t3), () => d(this.subscriptions, t3);
            }
            notify(t3, e3, n3) {
              const s2 = this.subscriptions.length;
              if (s2) if (1 === s2) this.subscriptions[0](t3, e3, n3);
              else for (let i2 = 0; i2 < s2; i2++) {
                const s3 = this.subscriptions[i2];
                s3 && s3(t3, e3, n3);
              }
            }
            getSize() {
              return this.subscriptions.length;
            }
            clear() {
              this.subscriptions.length = 0;
            }
          }
          function p(t3, e3) {
            return e3 ? t3 * (1e3 / e3) : 0;
          }
          class f {
            constructor() {
              this.order = [], this.scheduled = /* @__PURE__ */ new Set();
            }
            add(t3) {
              if (!this.scheduled.has(t3)) return this.scheduled.add(t3), this.order.push(t3), true;
            }
            remove(t3) {
              const e3 = this.order.indexOf(t3);
              -1 !== e3 && (this.order.splice(e3, 1), this.scheduled.delete(t3));
            }
            clear() {
              this.order.length = 0, this.scheduled.clear();
            }
          }
          const g = ["prepare", "read", "update", "preRender", "render", "postRender"], { schedule: y, cancel: v, state: x, steps: P } = function(t3, e3) {
            let n3 = false, s2 = true;
            const i2 = { delta: 0, timestamp: 0, isProcessing: false }, o = g.reduce((t4, e4) => (t4[e4] = function(t5) {
              let e5 = new f(), n4 = new f(), s3 = 0, i3 = false, o2 = false;
              const r4 = /* @__PURE__ */ new WeakSet(), a3 = { schedule: (t6, o3 = false, a4 = false) => {
                const l2 = a4 && i3, u2 = l2 ? e5 : n4;
                return o3 && r4.add(t6), u2.add(t6) && l2 && i3 && (s3 = e5.order.length), t6;
              }, cancel: (t6) => {
                n4.remove(t6), r4.delete(t6);
              }, process: (l2) => {
                if (i3) o2 = true;
                else {
                  if (i3 = true, [e5, n4] = [n4, e5], n4.clear(), s3 = e5.order.length, s3) for (let n5 = 0; n5 < s3; n5++) {
                    const s4 = e5.order[n5];
                    s4(l2), r4.has(s4) && (a3.schedule(s4), t5());
                  }
                  i3 = false, o2 && (o2 = false, a3.process(l2));
                }
              } };
              return a3;
            }(() => n3 = true), t4), {}), r3 = (t4) => o[t4].process(i2), a2 = () => {
              const e4 = performance.now();
              n3 = false, i2.delta = s2 ? 1e3 / 60 : Math.max(Math.min(e4 - i2.timestamp, 40), 1), i2.timestamp = e4, i2.isProcessing = true, g.forEach(r3), i2.isProcessing = false, n3 && (s2 = false, t3(a2));
            };
            return { schedule: g.reduce((e4, r4) => {
              const l2 = o[r4];
              return e4[r4] = (e5, o2 = false, r5 = false) => (n3 || (n3 = true, s2 = true, i2.isProcessing || t3(a2)), l2.schedule(e5, o2, r5)), e4;
            }, {}), cancel: (t4) => g.forEach((e4) => o[e4].cancel(t4)), state: i2, steps: o };
          }("undefined" != typeof requestAnimationFrame ? requestAnimationFrame : n2);
          class T {
            constructor(t3, e3 = {}) {
              var n3;
              this.version = "10.16.5", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = false, this.events = {}, this.updateAndNotify = (t4, e4 = true) => {
                this.prev = this.current, this.current = t4;
                const { delta: n4, timestamp: s2 } = x;
                this.lastUpdated !== s2 && (this.timeDelta = n4, this.lastUpdated = s2, y.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), e4 && this.events.renderRequest && this.events.renderRequest.notify(this.current);
              }, this.scheduleVelocityCheck = () => y.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: t4 }) => {
                t4 !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
              }, this.hasAnimated = false, this.prev = this.current = t3, this.canTrackVelocity = (n3 = this.current, !isNaN(parseFloat(n3))), this.owner = e3.owner;
            }
            onChange(t3) {
              return this.on("change", t3);
            }
            on(t3, e3) {
              this.events[t3] || (this.events[t3] = new m());
              const n3 = this.events[t3].add(e3);
              return "change" === t3 ? () => {
                n3(), y.read(() => {
                  this.events.change.getSize() || this.stop();
                });
              } : n3;
            }
            clearListeners() {
              for (const t3 in this.events) this.events[t3].clear();
            }
            attach(t3, e3) {
              this.passiveEffect = t3, this.stopPassiveEffect = e3;
            }
            set(t3, e3 = true) {
              e3 && this.passiveEffect ? this.passiveEffect(t3, this.updateAndNotify) : this.updateAndNotify(t3, e3);
            }
            setWithVelocity(t3, e3, n3) {
              this.set(e3), this.prev = t3, this.timeDelta = n3;
            }
            jump(t3) {
              this.updateAndNotify(t3), this.prev = t3, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
            }
            get() {
              return this.current;
            }
            getPrevious() {
              return this.prev;
            }
            getVelocity() {
              return this.canTrackVelocity ? p(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
            }
            start(t3) {
              return this.stop(), new Promise((e3) => {
                this.hasAnimated = true, this.animation = t3(e3), this.events.animationStart && this.events.animationStart.notify();
              }).then(() => {
                this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
              });
            }
            stop() {
              this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
            }
            isAnimating() {
              return !!this.animation;
            }
            clearAnimation() {
              delete this.animation;
            }
            destroy() {
              this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
            }
          }
          function S(t3, e3) {
            return new T(t3, e3);
          }
          const w = (t3) => (e3) => "string" == typeof e3 && e3.startsWith(t3), E = w("--"), A = w("var(--"), V = (t3) => Math.round(1e5 * t3) / 1e5, C = /(-)?([\d]*\.?[\d])+/g, M = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, D = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
          function k(t3) {
            return "string" == typeof t3;
          }
          const R = (t3, e3, n3) => Math.min(Math.max(n3, t3), e3), L = { test: (t3) => "number" == typeof t3, parse: parseFloat, transform: (t3) => t3 }, j = { ...L, transform: (t3) => R(0, 1, t3) }, B = { ...L, default: 1 }, F = (t3, e3) => (n3) => Boolean(k(n3) && D.test(n3) && n3.startsWith(t3) || e3 && Object.prototype.hasOwnProperty.call(n3, e3)), O = (t3, e3, n3) => (s2) => {
            if (!k(s2)) return s2;
            const [i2, o, r3, a2] = s2.match(C);
            return { [t3]: parseFloat(i2), [e3]: parseFloat(o), [n3]: parseFloat(r3), alpha: void 0 !== a2 ? parseFloat(a2) : 1 };
          }, I = { ...L, transform: (t3) => Math.round(((t4) => R(0, 255, t4))(t3)) }, U = { test: F("rgb", "red"), parse: O("red", "green", "blue"), transform: ({ red: t3, green: e3, blue: n3, alpha: s2 = 1 }) => "rgba(" + I.transform(t3) + ", " + I.transform(e3) + ", " + I.transform(n3) + ", " + V(j.transform(s2)) + ")" }, N = { test: F("#"), parse: function(t3) {
            let e3 = "", n3 = "", s2 = "", i2 = "";
            return t3.length > 5 ? (e3 = t3.substring(1, 3), n3 = t3.substring(3, 5), s2 = t3.substring(5, 7), i2 = t3.substring(7, 9)) : (e3 = t3.substring(1, 2), n3 = t3.substring(2, 3), s2 = t3.substring(3, 4), i2 = t3.substring(4, 5), e3 += e3, n3 += n3, s2 += s2, i2 += i2), { red: parseInt(e3, 16), green: parseInt(n3, 16), blue: parseInt(s2, 16), alpha: i2 ? parseInt(i2, 16) / 255 : 1 };
          }, transform: U.transform }, $ = (t3) => ({ test: (e3) => k(e3) && e3.endsWith(t3) && 1 === e3.split(" ").length, parse: parseFloat, transform: (e3) => `${e3}${t3}` }), W = $("deg"), H = $("%"), z = $("px"), Y = $("vh"), X = $("vw"), G = { ...H, parse: (t3) => H.parse(t3) / 100, transform: (t3) => H.transform(100 * t3) }, q = { test: F("hsl", "hue"), parse: O("hue", "saturation", "lightness"), transform: ({ hue: t3, saturation: e3, lightness: n3, alpha: s2 = 1 }) => "hsla(" + Math.round(t3) + ", " + H.transform(V(e3)) + ", " + H.transform(V(n3)) + ", " + V(j.transform(s2)) + ")" }, Z = { test: (t3) => U.test(t3) || N.test(t3) || q.test(t3), parse: (t3) => U.test(t3) ? U.parse(t3) : q.test(t3) ? q.parse(t3) : N.parse(t3), transform: (t3) => k(t3) ? t3 : t3.hasOwnProperty("red") ? U.transform(t3) : q.transform(t3) }, K = { regex: /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, countKey: "Vars", token: "${v}", parse: n2 }, _ = { regex: M, countKey: "Colors", token: "${c}", parse: Z.parse }, J = { regex: C, countKey: "Numbers", token: "${n}", parse: L.parse };
          function Q(t3, { regex: e3, countKey: n3, token: s2, parse: i2 }) {
            const o = t3.tokenised.match(e3);
            o && (t3["num" + n3] = o.length, t3.tokenised = t3.tokenised.replace(e3, s2), t3.values.push(...o.map(i2)));
          }
          function tt(t3) {
            const e3 = t3.toString(), n3 = { value: e3, tokenised: e3, values: [], numVars: 0, numColors: 0, numNumbers: 0 };
            return n3.value.includes("var(--") && Q(n3, K), Q(n3, _), Q(n3, J), n3;
          }
          function et(t3) {
            return tt(t3).values;
          }
          function nt(t3) {
            const { values: e3, numColors: n3, numVars: s2, tokenised: i2 } = tt(t3), o = e3.length;
            return (t4) => {
              let e4 = i2;
              for (let i3 = 0; i3 < o; i3++) e4 = i3 < s2 ? e4.replace(K.token, t4[i3]) : i3 < s2 + n3 ? e4.replace(_.token, Z.transform(t4[i3])) : e4.replace(J.token, V(t4[i3]));
              return e4;
            };
          }
          const st = (t3) => "number" == typeof t3 ? 0 : t3, it = { test: function(t3) {
            var e3, n3;
            return isNaN(t3) && k(t3) && ((null === (e3 = t3.match(C)) || void 0 === e3 ? void 0 : e3.length) || 0) + ((null === (n3 = t3.match(M)) || void 0 === n3 ? void 0 : n3.length) || 0) > 0;
          }, parse: et, createTransformer: nt, getAnimatableNone: function(t3) {
            const e3 = et(t3);
            return nt(t3)(e3.map(st));
          } }, ot = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
          function rt(t3) {
            const [e3, n3] = t3.slice(0, -1).split("(");
            if ("drop-shadow" === e3) return t3;
            const [s2] = n3.match(C) || [];
            if (!s2) return t3;
            const i2 = n3.replace(s2, "");
            let o = ot.has(e3) ? 1 : 0;
            return s2 !== n3 && (o *= 100), e3 + "(" + o + i2 + ")";
          }
          const at = /([a-z-]*)\(.*?\)/g, lt = { ...it, getAnimatableNone: (t3) => {
            const e3 = t3.match(at);
            return e3 ? e3.map(rt).join(" ") : t3;
          } }, ut = { ...L, transform: Math.round }, ct = { borderWidth: z, borderTopWidth: z, borderRightWidth: z, borderBottomWidth: z, borderLeftWidth: z, borderRadius: z, radius: z, borderTopLeftRadius: z, borderTopRightRadius: z, borderBottomRightRadius: z, borderBottomLeftRadius: z, width: z, maxWidth: z, height: z, maxHeight: z, size: z, top: z, right: z, bottom: z, left: z, padding: z, paddingTop: z, paddingRight: z, paddingBottom: z, paddingLeft: z, margin: z, marginTop: z, marginRight: z, marginBottom: z, marginLeft: z, rotate: W, rotateX: W, rotateY: W, rotateZ: W, scale: B, scaleX: B, scaleY: B, scaleZ: B, skew: W, skewX: W, skewY: W, distance: z, translateX: z, translateY: z, translateZ: z, x: z, y: z, z, perspective: z, transformPerspective: z, opacity: j, originX: G, originY: G, originZ: z, zIndex: ut, fillOpacity: j, strokeOpacity: j, numOctaves: ut }, ht = { ...ct, color: Z, backgroundColor: Z, outlineColor: Z, fill: Z, stroke: Z, borderColor: Z, borderTopColor: Z, borderRightColor: Z, borderBottomColor: Z, borderLeftColor: Z, filter: lt, WebkitFilter: lt }, dt = (t3) => ht[t3];
          function mt(t3, e3) {
            let n3 = dt(t3);
            return n3 !== lt && (n3 = it), n3.getAnimatableNone ? n3.getAnimatableNone(e3) : void 0;
          }
          const pt = (t3) => (e3) => e3.test(t3), ft = [L, z, H, W, X, Y, { test: (t3) => "auto" === t3, parse: (t3) => t3 }], gt = (t3) => ft.find(pt(t3)), yt = [...ft, Z, it];
          function vt(t3, e3, n3, s2 = {}, i2 = {}) {
            return "function" == typeof e3 && (e3 = e3(void 0 !== n3 ? n3 : t3.custom, s2, i2)), "string" == typeof e3 && (e3 = t3.variants && t3.variants[e3]), "function" == typeof e3 && (e3 = e3(void 0 !== n3 ? n3 : t3.custom, s2, i2)), e3;
          }
          function xt(t3, e3, n3) {
            const s2 = t3.getProps();
            return vt(s2, e3, void 0 !== n3 ? n3 : s2.custom, function(t4) {
              const e4 = {};
              return t4.values.forEach((t5, n4) => e4[n4] = t5.get()), e4;
            }(t3), function(t4) {
              const e4 = {};
              return t4.values.forEach((t5, n4) => e4[n4] = t5.getVelocity()), e4;
            }(t3));
          }
          function Pt(t3, e3, n3) {
            t3.hasValue(e3) ? t3.getValue(e3).set(n3) : t3.addValue(e3, S(n3));
          }
          function bt(t3, e3) {
            const n3 = xt(t3, e3);
            let { transitionEnd: s2 = {}, transition: i2 = {}, ...o } = n3 ? t3.makeTargetAnimatable(n3, false) : {};
            o = { ...o, ...s2 };
            for (const e4 in o) Pt(t3, e4, (r3 = o[e4], c(r3) ? r3[r3.length - 1] || 0 : r3));
            var r3;
          }
          function Tt(t3, e3) {
            [...e3].reverse().forEach((n3) => {
              const s2 = t3.getVariant(n3);
              s2 && bt(t3, s2), t3.variantChildren && t3.variantChildren.forEach((t4) => {
                Tt(t4, e3);
              });
            });
          }
          function St(t3, e3) {
            if (e3) return (e3[t3] || e3.default || e3).from;
          }
          const wt = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"], Et = new Set(wt), At = (t3) => t3.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), Vt = "data-" + At("framerAppearId"), Ct = (t3) => 1e3 * t3, Mt = (t3) => t3 / 1e3, Dt = (t3) => Array.isArray(t3) && "number" == typeof t3[0];
          function kt(t3) {
            return Boolean(!t3 || "string" == typeof t3 && Lt[t3] || Dt(t3) || Array.isArray(t3) && t3.every(kt));
          }
          const Rt = ([t3, e3, n3, s2]) => `cubic-bezier(${t3}, ${e3}, ${n3}, ${s2})`, Lt = { linear: "linear", ease: "ease", easeIn: "ease-in", easeOut: "ease-out", easeInOut: "ease-in-out", circIn: Rt([0, 0.65, 0.55, 1]), circOut: Rt([0.55, 0, 1, 0.45]), backIn: Rt([0.31, 0.01, 0.66, -0.59]), backOut: Rt([0.33, 1.53, 0.69, 0.99]) };
          function jt(t3) {
            if (t3) return Dt(t3) ? Rt(t3) : Array.isArray(t3) ? t3.map(jt) : Lt[t3];
          }
          const Bt = (t3, e3, n3) => (((1 - 3 * n3 + 3 * e3) * t3 + (3 * n3 - 6 * e3)) * t3 + 3 * e3) * t3;
          function Ft(t3, e3, s2, i2) {
            if (t3 === e3 && s2 === i2) return n2;
            return (n3) => 0 === n3 || 1 === n3 ? n3 : Bt(function(t4, e4, n4, s3, i3) {
              let o, r3, a2 = 0;
              do {
                r3 = e4 + (n4 - e4) / 2, o = Bt(r3, s3, i3) - t4, o > 0 ? n4 = r3 : e4 = r3;
              } while (Math.abs(o) > 1e-7 && ++a2 < 12);
              return r3;
            }(n3, 0, 1, t3, s2), e3, i2);
          }
          const Ot = Ft(0.42, 0, 1, 1), It = Ft(0, 0, 0.58, 1), Ut = Ft(0.42, 0, 0.58, 1), Nt = (t3) => (e3) => e3 <= 0.5 ? t3(2 * e3) / 2 : (2 - t3(2 * (1 - e3))) / 2, $t = (t3) => (e3) => 1 - t3(1 - e3), Wt = (t3) => 1 - Math.sin(Math.acos(t3)), Ht = $t(Wt), zt = Nt(Ht), Yt = Ft(0.33, 1.53, 0.69, 0.99), Xt = $t(Yt), Gt = Nt(Xt), qt = { linear: n2, easeIn: Ot, easeInOut: Ut, easeOut: It, circIn: Wt, circInOut: zt, circOut: Ht, backIn: Xt, backInOut: Gt, backOut: Yt, anticipate: (t3) => (t3 *= 2) < 1 ? 0.5 * Xt(t3) : 0.5 * (2 - Math.pow(2, -10 * (t3 - 1))) }, Zt = (t3) => {
            if (Array.isArray(t3)) {
              r2(4 === t3.length);
              const [e3, n3, s2, i2] = t3;
              return Ft(e3, n3, s2, i2);
            }
            return "string" == typeof t3 ? qt[t3] : t3;
          }, Kt = (t3, e3, n3) => -n3 * t3 + n3 * e3 + t3;
          function _t(t3, e3, n3) {
            return n3 < 0 && (n3 += 1), n3 > 1 && (n3 -= 1), n3 < 1 / 6 ? t3 + 6 * (e3 - t3) * n3 : n3 < 0.5 ? e3 : n3 < 2 / 3 ? t3 + (e3 - t3) * (2 / 3 - n3) * 6 : t3;
          }
          const Jt = (t3, e3, n3) => {
            const s2 = t3 * t3;
            return Math.sqrt(Math.max(0, n3 * (e3 * e3 - s2) + s2));
          }, Qt = [N, U, q];
          function te(t3) {
            const e3 = (n3 = t3, Qt.find((t4) => t4.test(n3)));
            var n3;
            let s2 = e3.parse(t3);
            return e3 === q && (s2 = function({ hue: t4, saturation: e4, lightness: n4, alpha: s3 }) {
              t4 /= 360, n4 /= 100;
              let i2 = 0, o = 0, r3 = 0;
              if (e4 /= 100) {
                const s4 = n4 < 0.5 ? n4 * (1 + e4) : n4 + e4 - n4 * e4, a2 = 2 * n4 - s4;
                i2 = _t(a2, s4, t4 + 1 / 3), o = _t(a2, s4, t4), r3 = _t(a2, s4, t4 - 1 / 3);
              } else i2 = o = r3 = n4;
              return { red: Math.round(255 * i2), green: Math.round(255 * o), blue: Math.round(255 * r3), alpha: s3 };
            }(s2)), s2;
          }
          const ee = (t3, e3) => {
            const n3 = te(t3), s2 = te(e3), i2 = { ...n3 };
            return (t4) => (i2.red = Jt(n3.red, s2.red, t4), i2.green = Jt(n3.green, s2.green, t4), i2.blue = Jt(n3.blue, s2.blue, t4), i2.alpha = Kt(n3.alpha, s2.alpha, t4), U.transform(i2));
          }, ne = (t3, e3) => (n3) => e3(t3(n3)), se = (...t3) => t3.reduce(ne), ie = (t3, e3) => (n3) => `${n3 > 0 ? e3 : t3}`;
          function oe(t3, e3) {
            return "number" == typeof t3 ? (n3) => Kt(t3, e3, n3) : Z.test(t3) ? ee(t3, e3) : t3.startsWith("var(") ? ie(t3, e3) : le(t3, e3);
          }
          const re = (t3, e3) => {
            const n3 = [...t3], s2 = n3.length, i2 = t3.map((t4, n4) => oe(t4, e3[n4]));
            return (t4) => {
              for (let e4 = 0; e4 < s2; e4++) n3[e4] = i2[e4](t4);
              return n3;
            };
          }, ae = (t3, e3) => {
            const n3 = { ...t3, ...e3 }, s2 = {};
            for (const i2 in n3) void 0 !== t3[i2] && void 0 !== e3[i2] && (s2[i2] = oe(t3[i2], e3[i2]));
            return (t4) => {
              for (const e4 in s2) n3[e4] = s2[e4](t4);
              return n3;
            };
          }, le = (t3, e3) => {
            const n3 = it.createTransformer(e3), s2 = tt(t3), i2 = tt(e3);
            return s2.numVars === i2.numVars && s2.numColors === i2.numColors && s2.numNumbers >= i2.numNumbers ? se(re(s2.values, i2.values), n3) : ie(t3, e3);
          }, ue = (t3, e3, n3) => {
            const s2 = e3 - t3;
            return 0 === s2 ? 1 : (n3 - t3) / s2;
          }, ce = (t3, e3) => (n3) => Kt(t3, e3, n3);
          function he(t3, e3, { clamp: s2 = true, ease: i2, mixer: o } = {}) {
            const a2 = t3.length;
            if (r2(a2 === e3.length), 1 === a2) return () => e3[0];
            t3[0] > t3[a2 - 1] && (t3 = [...t3].reverse(), e3 = [...e3].reverse());
            const l2 = function(t4, e4, s3) {
              const i3 = [], o2 = s3 || ("number" == typeof (r3 = t4[0]) ? ce : "string" == typeof r3 ? Z.test(r3) ? ee : le : Array.isArray(r3) ? re : "object" == typeof r3 ? ae : ce);
              var r3;
              const a3 = t4.length - 1;
              for (let s4 = 0; s4 < a3; s4++) {
                let r4 = o2(t4[s4], t4[s4 + 1]);
                if (e4) {
                  const t5 = Array.isArray(e4) ? e4[s4] || n2 : e4;
                  r4 = se(t5, r4);
                }
                i3.push(r4);
              }
              return i3;
            }(e3, i2, o), u2 = l2.length, c2 = (e4) => {
              let n3 = 0;
              if (u2 > 1) for (; n3 < t3.length - 2 && !(e4 < t3[n3 + 1]); n3++) ;
              const s3 = ue(t3[n3], t3[n3 + 1], e4);
              return l2[n3](s3);
            };
            return s2 ? (e4) => c2(R(t3[0], t3[a2 - 1], e4)) : c2;
          }
          function de({ duration: t3 = 300, keyframes: e3, times: n3, ease: s2 = "easeInOut" }) {
            const i2 = ((t4) => Array.isArray(t4) && "number" != typeof t4[0])(s2) ? s2.map(Zt) : Zt(s2), o = { done: false, value: e3[0] }, r3 = he(function(t4, e4) {
              return t4.map((t5) => t5 * e4);
            }(n3 && n3.length === e3.length ? n3 : function(t4) {
              const e4 = [0];
              return function(t5, e5) {
                const n4 = t5[t5.length - 1];
                for (let s3 = 1; s3 <= e5; s3++) {
                  const i3 = ue(0, e5, s3);
                  t5.push(Kt(n4, 1, i3));
                }
              }(e4, t4.length - 1), e4;
            }(e3), t3), e3, { ease: Array.isArray(i2) ? i2 : (a2 = e3, l2 = i2, a2.map(() => l2 || Ut).splice(0, a2.length - 1)) });
            var a2, l2;
            return { calculatedDuration: t3, next: (e4) => (o.value = r3(e4), o.done = e4 >= t3, o) };
          }
          function me(t3, e3, n3) {
            const s2 = Math.max(e3 - 5, 0);
            return p(n3 - t3(s2), e3 - s2);
          }
          function pe(t3, e3) {
            return t3 * Math.sqrt(1 - e3 * e3);
          }
          const fe = ["duration", "bounce"], ge = ["stiffness", "damping", "mass"];
          function ye(t3, e3) {
            return e3.some((e4) => void 0 !== t3[e4]);
          }
          function ve({ keyframes: t3, restDelta: e3, restSpeed: n3, ...s2 }) {
            const i2 = t3[0], r3 = t3[t3.length - 1], a2 = { done: false, value: i2 }, { stiffness: l2, damping: u2, mass: c2, velocity: h2, duration: d2, isResolvedFromDuration: m2 } = function(t4) {
              let e4 = { velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: false, ...t4 };
              if (!ye(t4, ge) && ye(t4, fe)) {
                const n4 = function({ duration: t5 = 800, bounce: e5 = 0.25, velocity: n5 = 0, mass: s3 = 1 }) {
                  let i3, r4;
                  let a3 = 1 - e5;
                  a3 = R(0.05, 1, a3), t5 = R(0.01, 10, Mt(t5)), a3 < 1 ? (i3 = (e6) => {
                    const s4 = e6 * a3, i4 = s4 * t5;
                    return 1e-3 - (s4 - n5) / pe(e6, a3) * Math.exp(-i4);
                  }, r4 = (e6) => {
                    const s4 = e6 * a3 * t5, o = s4 * n5 + n5, r5 = Math.pow(a3, 2) * Math.pow(e6, 2) * t5, l4 = Math.exp(-s4), u3 = pe(Math.pow(e6, 2), a3);
                    return (1e-3 - i3(e6) > 0 ? -1 : 1) * ((o - r5) * l4) / u3;
                  }) : (i3 = (e6) => Math.exp(-e6 * t5) * ((e6 - n5) * t5 + 1) - 1e-3, r4 = (e6) => Math.exp(-e6 * t5) * (t5 * t5 * (n5 - e6)));
                  const l3 = function(t6, e6, n6) {
                    let s4 = n6;
                    for (let n7 = 1; n7 < 12; n7++) s4 -= t6(s4) / e6(s4);
                    return s4;
                  }(i3, r4, 5 / t5);
                  if (t5 = Ct(t5), isNaN(l3)) return { stiffness: 100, damping: 10, duration: t5 };
                  {
                    const e6 = Math.pow(l3, 2) * s3;
                    return { stiffness: e6, damping: 2 * a3 * Math.sqrt(s3 * e6), duration: t5 };
                  }
                }(t4);
                e4 = { ...e4, ...n4, velocity: 0, mass: 1 }, e4.isResolvedFromDuration = true;
              }
              return e4;
            }(s2), p2 = h2 ? -Mt(h2) : 0, f2 = u2 / (2 * Math.sqrt(l2 * c2)), g2 = r3 - i2, y2 = Mt(Math.sqrt(l2 / c2)), v2 = Math.abs(g2) < 5;
            let x2;
            if (n3 || (n3 = v2 ? 0.01 : 2), e3 || (e3 = v2 ? 5e-3 : 0.5), f2 < 1) {
              const t4 = pe(y2, f2);
              x2 = (e4) => {
                const n4 = Math.exp(-f2 * y2 * e4);
                return r3 - n4 * ((p2 + f2 * y2 * g2) / t4 * Math.sin(t4 * e4) + g2 * Math.cos(t4 * e4));
              };
            } else if (1 === f2) x2 = (t4) => r3 - Math.exp(-y2 * t4) * (g2 + (p2 + y2 * g2) * t4);
            else {
              const t4 = y2 * Math.sqrt(f2 * f2 - 1);
              x2 = (e4) => {
                const n4 = Math.exp(-f2 * y2 * e4), s3 = Math.min(t4 * e4, 300);
                return r3 - n4 * ((p2 + f2 * y2 * g2) * Math.sinh(s3) + t4 * g2 * Math.cosh(s3)) / t4;
              };
            }
            return { calculatedDuration: m2 && d2 || null, next: (t4) => {
              const s3 = x2(t4);
              if (m2) a2.done = t4 >= d2;
              else {
                let i3 = p2;
                0 !== t4 && (i3 = f2 < 1 ? me(x2, t4, s3) : 0);
                const o = Math.abs(i3) <= n3, l3 = Math.abs(r3 - s3) <= e3;
                a2.done = o && l3;
              }
              return a2.value = a2.done ? r3 : s3, a2;
            } };
          }
          function xe({ keyframes: t3, velocity: e3 = 0, power: n3 = 0.8, timeConstant: s2 = 325, bounceDamping: i2 = 10, bounceStiffness: o = 500, modifyTarget: r3, min: a2, max: l2, restDelta: u2 = 0.5, restSpeed: c2 }) {
            const h2 = t3[0], d2 = { done: false, value: h2 }, m2 = (t4) => void 0 === a2 ? l2 : void 0 === l2 || Math.abs(a2 - t4) < Math.abs(l2 - t4) ? a2 : l2;
            let p2 = n3 * e3;
            const f2 = h2 + p2, g2 = void 0 === r3 ? f2 : r3(f2);
            g2 !== f2 && (p2 = g2 - h2);
            const y2 = (t4) => -p2 * Math.exp(-t4 / s2), v2 = (t4) => g2 + y2(t4), x2 = (t4) => {
              const e4 = y2(t4), n4 = v2(t4);
              d2.done = Math.abs(e4) <= u2, d2.value = d2.done ? g2 : n4;
            };
            let P2, b;
            const T2 = (t4) => {
              var e4;
              e4 = d2.value, (void 0 !== a2 && e4 < a2 || void 0 !== l2 && e4 > l2) && (P2 = t4, b = ve({ keyframes: [d2.value, m2(d2.value)], velocity: me(v2, t4, d2.value), damping: i2, stiffness: o, restDelta: u2, restSpeed: c2 }));
            };
            return T2(0), { calculatedDuration: null, next: (t4) => {
              let e4 = false;
              return b || void 0 !== P2 || (e4 = true, x2(t4), T2(t4)), void 0 !== P2 && t4 > P2 ? b.next(t4 - P2) : (!e4 && x2(t4), d2);
            } };
          }
          const Pe = (t3) => {
            const e3 = ({ timestamp: e4 }) => t3(e4);
            return { start: () => y.update(e3, true), stop: () => v(e3), now: () => x.isProcessing ? x.timestamp : performance.now() };
          };
          function be(t3) {
            let e3 = 0, n3 = t3.next(e3);
            for (; !n3.done && e3 < 2e4; ) e3 += 50, n3 = t3.next(e3);
            return e3 >= 2e4 ? 1 / 0 : e3;
          }
          const Te = { decay: xe, inertia: xe, tween: de, keyframes: de, spring: ve };
          function Se({ autoplay: t3 = true, delay: e3 = 0, driver: n3 = Pe, keyframes: s2, type: i2 = "keyframes", repeat: o = 0, repeatDelay: r3 = 0, repeatType: a2 = "loop", onPlay: l2, onStop: u2, onComplete: c2, onUpdate: h2, ...d2 }) {
            let m2, p2, f2 = 1, g2 = false;
            const y2 = () => {
              p2 = new Promise((t4) => {
                m2 = t4;
              });
            };
            let v2;
            y2();
            const x2 = Te[i2] || de;
            let P2;
            x2 !== de && "number" != typeof s2[0] && (P2 = he([0, 100], s2, { clamp: false }), s2 = [0, 100]);
            const b = x2({ ...d2, keyframes: s2 });
            let T2;
            "mirror" === a2 && (T2 = x2({ ...d2, keyframes: [...s2].reverse(), velocity: -(d2.velocity || 0) }));
            let S2 = "idle", w2 = null, E2 = null, A2 = null;
            null === b.calculatedDuration && o && (b.calculatedDuration = be(b));
            const { calculatedDuration: V2 } = b;
            let C2 = 1 / 0, M2 = 1 / 0;
            null !== V2 && (C2 = V2 + r3, M2 = C2 * (o + 1) - r3);
            let D2 = 0;
            const k2 = (t4) => {
              if (null === E2) return;
              f2 > 0 && (E2 = Math.min(E2, t4)), f2 < 0 && (E2 = Math.min(t4 - M2 / f2, E2)), D2 = null !== w2 ? w2 : Math.round(t4 - E2) * f2;
              const n4 = D2 - e3 * (f2 >= 0 ? 1 : -1), i3 = f2 >= 0 ? n4 < 0 : n4 > M2;
              D2 = Math.max(n4, 0), "finished" === S2 && null === w2 && (D2 = M2);
              let l3 = D2, u3 = b;
              if (o) {
                const t5 = D2 / C2;
                let e4 = Math.floor(t5), n5 = t5 % 1;
                !n5 && t5 >= 1 && (n5 = 1), 1 === n5 && e4--, e4 = Math.min(e4, o + 1);
                const s3 = Boolean(e4 % 2);
                s3 && ("reverse" === a2 ? (n5 = 1 - n5, r3 && (n5 -= r3 / C2)) : "mirror" === a2 && (u3 = T2));
                let i4 = R(0, 1, n5);
                D2 > M2 && (i4 = "reverse" === a2 && s3 ? 1 : 0), l3 = i4 * C2;
              }
              const c3 = i3 ? { done: false, value: s2[0] } : u3.next(l3);
              P2 && (c3.value = P2(c3.value));
              let { done: d3 } = c3;
              i3 || null === V2 || (d3 = f2 >= 0 ? D2 >= M2 : D2 <= 0);
              const m3 = null === w2 && ("finished" === S2 || "running" === S2 && d3);
              return h2 && h2(c3.value), m3 && B2(), c3;
            }, L2 = () => {
              v2 && v2.stop(), v2 = void 0;
            }, j2 = () => {
              S2 = "idle", L2(), m2(), y2(), E2 = A2 = null;
            }, B2 = () => {
              S2 = "finished", c2 && c2(), L2(), m2();
            }, F2 = () => {
              if (g2) return;
              v2 || (v2 = n3(k2));
              const t4 = v2.now();
              l2 && l2(), null !== w2 ? E2 = t4 - w2 : E2 && "finished" !== S2 || (E2 = t4), "finished" === S2 && y2(), A2 = E2, w2 = null, S2 = "running", v2.start();
            };
            t3 && F2();
            const O2 = { then: (t4, e4) => p2.then(t4, e4), get time() {
              return Mt(D2);
            }, set time(t4) {
              t4 = Ct(t4), D2 = t4, null === w2 && v2 && 0 !== f2 ? E2 = v2.now() - t4 / f2 : w2 = t4;
            }, get duration() {
              const t4 = null === b.calculatedDuration ? be(b) : b.calculatedDuration;
              return Mt(t4);
            }, get speed() {
              return f2;
            }, set speed(t4) {
              t4 !== f2 && v2 && (f2 = t4, O2.time = Mt(D2));
            }, get state() {
              return S2;
            }, play: F2, pause: () => {
              S2 = "paused", w2 = D2;
            }, stop: () => {
              g2 = true, "idle" !== S2 && (S2 = "idle", u2 && u2(), j2());
            }, cancel: () => {
              null !== A2 && k2(A2), j2();
            }, complete: () => {
              S2 = "finished";
            }, sample: (t4) => (E2 = 0, k2(t4)) };
            return O2;
          }
          const we = /* @__PURE__ */ function(t3) {
            let e3;
            return () => (void 0 === e3 && (e3 = Object.hasOwnProperty.call(Element.prototype, "animate")), e3);
          }(), Ee = /* @__PURE__ */ new Set(["opacity", "clipPath", "filter", "transform", "backgroundColor"]);
          const Ae = { type: "spring", stiffness: 500, damping: 25, restSpeed: 10 }, Ve = { type: "keyframes", duration: 0.8 }, Ce = { type: "keyframes", ease: [0.25, 0.1, 0.35, 1], duration: 0.3 }, Me = (t3, { keyframes: e3 }) => e3.length > 2 ? Ve : Et.has(t3) ? t3.startsWith("scale") ? { type: "spring", stiffness: 550, damping: 0 === e3[1] ? 2 * Math.sqrt(550) : 30, restSpeed: 10 } : Ae : Ce, De = (t3, e3) => !("zIndex" === t3 || "number" != typeof e3 && !Array.isArray(e3) && ("string" != typeof e3 || !it.test(e3) && "0" !== e3 || e3.startsWith("url(")));
          function ke(t3) {
            return "number" == typeof t3 ? 0 === t3 : null !== t3 ? "none" === t3 || "0" === t3 || u(t3) : void 0;
          }
          function Re(t3, e3) {
            return t3[e3] || t3.default || t3;
          }
          const Le = (t3, e3, s2, i2 = {}) => (r3) => {
            const a2 = Re(i2, t3) || {}, l2 = a2.delay || i2.delay || 0;
            let { elapsed: u2 = 0 } = i2;
            u2 -= Ct(l2);
            const c2 = function(t4, e4, n3, s3) {
              const i3 = De(e4, n3);
              let o;
              o = Array.isArray(n3) ? [...n3] : [null, n3];
              const r4 = void 0 !== s3.from ? s3.from : t4.get();
              let a3;
              const l3 = [];
              for (let t5 = 0; t5 < o.length; t5++) null === o[t5] && (o[t5] = 0 === t5 ? r4 : o[t5 - 1]), ke(o[t5]) && l3.push(t5), "string" == typeof o[t5] && "none" !== o[t5] && "0" !== o[t5] && (a3 = o[t5]);
              if (i3 && l3.length && a3) for (let t5 = 0; t5 < l3.length; t5++) o[l3[t5]] = mt(e4, a3);
              return o;
            }(e3, t3, s2, a2), h2 = c2[0], d2 = c2[c2.length - 1], m2 = De(t3, h2), p2 = De(t3, d2);
            let f2 = { keyframes: c2, velocity: e3.getVelocity(), ease: "easeOut", ...a2, delay: -u2, onUpdate: (t4) => {
              e3.set(t4), a2.onUpdate && a2.onUpdate(t4);
            }, onComplete: () => {
              r3(), a2.onComplete && a2.onComplete();
            } };
            if (function({ when: t4, delay: e4, delayChildren: n3, staggerChildren: s3, staggerDirection: i3, repeat: o, repeatType: r4, repeatDelay: a3, from: l3, elapsed: u3, ...c3 }) {
              return !!Object.keys(c3).length;
            }(a2) || (f2 = { ...f2, ...Me(t3, f2) }), f2.duration && (f2.duration = Ct(f2.duration)), f2.repeatDelay && (f2.repeatDelay = Ct(f2.repeatDelay)), !m2 || !p2 || false === a2.type) return function({ keyframes: t4, delay: e4, onUpdate: s3, onComplete: i3 }) {
              const o = () => (s3 && s3(t4[t4.length - 1]), i3 && i3(), { time: 0, speed: 1, duration: 0, play: n2, pause: n2, stop: n2, then: (t5) => (t5(), Promise.resolve()), cancel: n2, complete: n2 });
              return e4 ? Se({ keyframes: [0, 1], duration: 0, delay: e4, onComplete: o }) : o();
            }(f2);
            if (e3.owner && e3.owner.current instanceof HTMLElement && !e3.owner.getProps().onUpdate) {
              const s3 = function(t4, e4, { onUpdate: s4, onComplete: i3, ...o }) {
                if (!we() || !Ee.has(e4) || o.repeatDelay || "mirror" === o.repeatType || 0 === o.damping || "inertia" === o.type) return false;
                let r4, a3, l3 = false;
                const u3 = () => {
                  a3 = new Promise((t5) => {
                    r4 = t5;
                  });
                };
                u3();
                let { keyframes: c3, duration: h3 = 300, ease: d3, times: m3 } = o;
                if (((t5, e5) => "spring" === e5.type || "backgroundColor" === t5 || !kt(e5.ease))(e4, o)) {
                  const t5 = Se({ ...o, repeat: 0, delay: 0 });
                  let e5 = { done: false, value: c3[0] };
                  const n3 = [];
                  let s5 = 0;
                  for (; !e5.done && s5 < 2e4; ) e5 = t5.sample(s5), n3.push(e5.value), s5 += 10;
                  m3 = void 0, c3 = n3, h3 = s5 - 10, d3 = "linear";
                }
                const p3 = function(t5, e5, n3, { delay: s5 = 0, duration: i4, repeat: o2 = 0, repeatType: r5 = "loop", ease: a4, times: l4 } = {}) {
                  const u4 = { [e5]: n3 };
                  l4 && (u4.offset = l4);
                  const c4 = jt(a4);
                  return Array.isArray(c4) && (u4.easing = c4), t5.animate(u4, { delay: s5, duration: i4, easing: Array.isArray(c4) ? "linear" : c4, fill: "both", iterations: o2 + 1, direction: "reverse" === r5 ? "alternate" : "normal" });
                }(t4.owner.current, e4, c3, { ...o, duration: h3, ease: d3, times: m3 });
                o.syncStart && (p3.startTime = x.isProcessing ? x.timestamp : document.timeline ? document.timeline.currentTime : performance.now());
                const f3 = () => p3.cancel(), g2 = () => {
                  y.update(f3), r4(), u3();
                };
                return p3.onfinish = () => {
                  t4.set(function(t5, { repeat: e5, repeatType: n3 = "loop" }) {
                    return t5[e5 && "loop" !== n3 && e5 % 2 == 1 ? 0 : t5.length - 1];
                  }(c3, o)), i3 && i3(), g2();
                }, { then: (t5, e5) => a3.then(t5, e5), attachTimeline: (t5) => (p3.timeline = t5, p3.onfinish = null, n2), get time() {
                  return Mt(p3.currentTime || 0);
                }, set time(t5) {
                  p3.currentTime = Ct(t5);
                }, get speed() {
                  return p3.playbackRate;
                }, set speed(t5) {
                  p3.playbackRate = t5;
                }, get duration() {
                  return Mt(h3);
                }, play: () => {
                  l3 || (p3.play(), v(f3));
                }, pause: () => p3.pause(), stop: () => {
                  if (l3 = true, "idle" === p3.playState) return;
                  const { currentTime: e5 } = p3;
                  if (e5) {
                    const n3 = Se({ ...o, autoplay: false });
                    t4.setWithVelocity(n3.sample(e5 - 10).value, n3.sample(e5).value, 10);
                  }
                  g2();
                }, complete: () => p3.finish(), cancel: g2 };
              }(e3, t3, f2);
              if (s3) return s3;
            }
            return Se(f2);
          }, je = (t3) => Boolean(t3 && t3.getVelocity);
          function Be(t3) {
            return Boolean(je(t3) && t3.add);
          }
          function Fe({ protectedKeys: t3, needsAnimating: e3 }, n3) {
            const s2 = t3.hasOwnProperty(n3) && true !== e3[n3];
            return e3[n3] = false, s2;
          }
          function Oe(t3, e3, { delay: n3 = 0, transitionOverride: s2, type: i2 } = {}) {
            let { transition: o = t3.getDefaultTransition(), transitionEnd: r3, ...a2 } = t3.makeTargetAnimatable(e3);
            const l2 = t3.getValue("willChange");
            s2 && (o = s2);
            const u2 = [], c2 = i2 && t3.animationState && t3.animationState.getState()[i2];
            for (const e4 in a2) {
              const s3 = t3.getValue(e4), i3 = a2[e4];
              if (!s3 || void 0 === i3 || c2 && Fe(c2, e4)) continue;
              const r4 = { delay: n3, elapsed: 0, ...o };
              if (window.HandoffAppearAnimations && !s3.hasAnimated) {
                const n4 = t3.getProps()[Vt];
                n4 && (r4.elapsed = window.HandoffAppearAnimations(n4, e4, s3, y), r4.syncStart = true);
              }
              s3.start(Le(e4, s3, i3, t3.shouldReduceMotion && Et.has(e4) ? { type: false } : r4));
              const h2 = s3.animation;
              Be(l2) && (l2.add(e4), h2.then(() => l2.remove(e4))), u2.push(h2);
            }
            return r3 && Promise.all(u2).then(() => {
              r3 && bt(t3, r3);
            }), u2;
          }
          function Ie(t3, e3, n3 = {}) {
            const s2 = xt(t3, e3, n3.custom);
            let { transition: i2 = t3.getDefaultTransition() || {} } = s2 || {};
            n3.transitionOverride && (i2 = n3.transitionOverride);
            const o = s2 ? () => Promise.all(Oe(t3, s2, n3)) : () => Promise.resolve(), r3 = t3.variantChildren && t3.variantChildren.size ? (s3 = 0) => {
              const { delayChildren: o2 = 0, staggerChildren: r4, staggerDirection: a3 } = i2;
              return function(t4, e4, n4 = 0, s4 = 0, i3 = 1, o3) {
                const r5 = [], a4 = (t4.variantChildren.size - 1) * s4, l2 = 1 === i3 ? (t5 = 0) => t5 * s4 : (t5 = 0) => a4 - t5 * s4;
                return Array.from(t4.variantChildren).sort(Ue).forEach((t5, s5) => {
                  t5.notify("AnimationStart", e4), r5.push(Ie(t5, e4, { ...o3, delay: n4 + l2(s5) }).then(() => t5.notify("AnimationComplete", e4)));
                }), Promise.all(r5);
              }(t3, e3, o2 + s3, r4, a3, n3);
            } : () => Promise.resolve(), { when: a2 } = i2;
            if (a2) {
              const [t4, e4] = "beforeChildren" === a2 ? [o, r3] : [r3, o];
              return t4().then(() => e4());
            }
            return Promise.all([o(), r3(n3.delay)]);
          }
          function Ue(t3, e3) {
            return t3.sortNodePosition(e3);
          }
          function Ne(t3, e3, n3 = {}) {
            let s2;
            if (t3.notify("AnimationStart", e3), Array.isArray(e3)) {
              const i2 = e3.map((e4) => Ie(t3, e4, n3));
              s2 = Promise.all(i2);
            } else if ("string" == typeof e3) s2 = Ie(t3, e3, n3);
            else {
              const i2 = "function" == typeof e3 ? xt(t3, e3, n3.custom) : e3;
              s2 = Promise.all(Oe(t3, i2, n3));
            }
            return s2.then(() => t3.notify("AnimationComplete", e3));
          }
          function $e() {
            const e3 = /* @__PURE__ */ new Set(), n3 = { subscribe: (t3) => (e3.add(t3), () => {
              e3.delete(t3);
            }), start(n4, s2) {
              const i2 = [];
              return e3.forEach((t3) => {
                i2.push(Ne(t3, n4, { transitionOverride: s2 }));
              }), Promise.all(i2);
            }, set: (n4) => e3.forEach((t3) => {
              !function(t4, e4) {
                Array.isArray(e4) ? Tt(t4, e4) : "string" == typeof e4 ? Tt(t4, [e4]) : bt(t4, e4);
              }(t3, n4);
            }), stop() {
              e3.forEach((t3) => {
                !function(t4) {
                  t4.values.forEach((t5) => t5.stop());
                }(t3);
              });
            }, mount: () => () => {
              n3.stop();
            } };
            return n3;
          }
          function We(e3) {
            const n3 = (0, t2.useRef)(null);
            return null === n3.current && (n3.current = e3()), n3.current;
          }
          const He = "undefined" != typeof document, ze = He ? t2.useLayoutEffect : t2.useEffect, Ye = (0, t2.createContext)({ transformPagePoint: (t3) => t3, isStatic: false, reducedMotion: "never" }), Xe = (0, t2.createContext)({}), Ge = (0, t2.createContext)(null), qe = (0, t2.createContext)({ strict: false });
          function Ze(t3) {
            return "object" == typeof t3 && Object.prototype.hasOwnProperty.call(t3, "current");
          }
          function Ke(t3) {
            return "string" == typeof t3 || Array.isArray(t3);
          }
          function _e(t3) {
            return "object" == typeof t3 && "function" == typeof t3.start;
          }
          const Je = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"], Qe = ["initial", ...Je];
          function tn(t3) {
            return _e(t3.animate) || Qe.some((e3) => Ke(t3[e3]));
          }
          function en(t3) {
            return Boolean(tn(t3) || t3.variants);
          }
          function nn(t3) {
            return Array.isArray(t3) ? t3.join(" ") : t3;
          }
          const sn = { animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"], exit: ["exit"], drag: ["drag", "dragControls"], focus: ["whileFocus"], hover: ["whileHover", "onHoverStart", "onHoverEnd"], tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"], pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"], inView: ["whileInView", "onViewportEnter", "onViewportLeave"], layout: ["layout", "layoutId"] }, on = {};
          for (const t3 in sn) on[t3] = { isEnabled: (e3) => sn[t3].some((t4) => !!e3[t4]) };
          const rn = (0, t2.createContext)({}), an = (0, t2.createContext)({}), ln = Symbol.for("motionComponentSymbol");
          function un({ preloadedFeatures: e3, createVisualElement: n3, useRender: s2, useVisualState: i2, Component: o }) {
            e3 && function(t3) {
              for (const e4 in t3) on[e4] = { ...on[e4], ...t3[e4] };
            }(e3);
            const r3 = (0, t2.forwardRef)(function(r4, a2) {
              let l2;
              const u2 = { ...(0, t2.useContext)(Ye), ...r4, layoutId: cn(r4) }, { isStatic: c2 } = u2, h2 = function(e4) {
                const { initial: n4, animate: s3 } = function(t3, e5) {
                  if (tn(t3)) {
                    const { initial: e6, animate: n5 } = t3;
                    return { initial: false === e6 || Ke(e6) ? e6 : void 0, animate: Ke(n5) ? n5 : void 0 };
                  }
                  return false !== t3.inherit ? e5 : {};
                }(e4, (0, t2.useContext)(Xe));
                return (0, t2.useMemo)(() => ({ initial: n4, animate: s3 }), [nn(n4), nn(s3)]);
              }(r4), d2 = i2(r4, c2);
              if (!c2 && He) {
                h2.visualElement = function(e4, n4, s4, i4) {
                  const { visualElement: o2 } = (0, t2.useContext)(Xe), r5 = (0, t2.useContext)(qe), a3 = (0, t2.useContext)(Ge), l3 = (0, t2.useContext)(Ye).reducedMotion, u3 = (0, t2.useRef)();
                  i4 = i4 || r5.renderer, !u3.current && i4 && (u3.current = i4(e4, { visualState: n4, parent: o2, props: s4, presenceContext: a3, blockInitialAnimation: !!a3 && false === a3.initial, reducedMotionConfig: l3 }));
                  const c3 = u3.current;
                  (0, t2.useInsertionEffect)(() => {
                    c3 && c3.update(s4, a3);
                  });
                  const h3 = (0, t2.useRef)(Boolean(window.HandoffAppearAnimations));
                  return ze(() => {
                    c3 && (c3.render(), h3.current && c3.animationState && c3.animationState.animateChanges());
                  }), (0, t2.useEffect)(() => {
                    c3 && (c3.updateFeatures(), !h3.current && c3.animationState && c3.animationState.animateChanges(), window.HandoffAppearAnimations = void 0, h3.current = false);
                  }), c3;
                }(o, d2, u2, n3);
                const s3 = (0, t2.useContext)(an), i3 = (0, t2.useContext)(qe).strict;
                h2.visualElement && (l2 = h2.visualElement.loadFeatures(u2, i3, e3, s3));
              }
              return t2.createElement(Xe.Provider, { value: h2 }, l2 && h2.visualElement ? t2.createElement(l2, { visualElement: h2.visualElement, ...u2 }) : null, s2(o, r4, function(e4, n4, s3) {
                return (0, t2.useCallback)((t3) => {
                  t3 && e4.mount && e4.mount(t3), n4 && (t3 ? n4.mount(t3) : n4.unmount()), s3 && ("function" == typeof s3 ? s3(t3) : Ze(s3) && (s3.current = t3));
                }, [n4]);
              }(d2, h2.visualElement, a2), d2, c2, h2.visualElement));
            });
            return r3[ln] = o, r3;
          }
          function cn({ layoutId: e3 }) {
            const n3 = (0, t2.useContext)(rn).id;
            return n3 && void 0 !== e3 ? n3 + "-" + e3 : e3;
          }
          function hn(t3) {
            function e3(e4, n4 = {}) {
              return un(t3(e4, n4));
            }
            if ("undefined" == typeof Proxy) return e3;
            const n3 = /* @__PURE__ */ new Map();
            return new Proxy(e3, { get: (t4, s2) => (n3.has(s2) || n3.set(s2, e3(s2)), n3.get(s2)) });
          }
          const dn = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];
          function mn(t3) {
            return "string" == typeof t3 && !t3.includes("-") && !!(dn.indexOf(t3) > -1 || /[A-Z]/.test(t3));
          }
          const pn = {};
          function fn(t3, { layout: e3, layoutId: n3 }) {
            return Et.has(t3) || t3.startsWith("origin") || (e3 || void 0 !== n3) && (!!pn[t3] || "opacity" === t3);
          }
          const gn = { x: "translateX", y: "translateY", z: "translateZ", transformPerspective: "perspective" }, yn = wt.length, vn = (t3, e3) => e3 && "number" == typeof t3 ? e3.transform(t3) : t3;
          function xn(t3, e3, n3, s2) {
            const { style: i2, vars: o, transform: r3, transformOrigin: a2 } = t3;
            let l2 = false, u2 = false, c2 = true;
            for (const t4 in e3) {
              const n4 = e3[t4];
              if (E(t4)) {
                o[t4] = n4;
                continue;
              }
              const s3 = ct[t4], h2 = vn(n4, s3);
              if (Et.has(t4)) {
                if (l2 = true, r3[t4] = h2, !c2) continue;
                n4 !== (s3.default || 0) && (c2 = false);
              } else t4.startsWith("origin") ? (u2 = true, a2[t4] = h2) : i2[t4] = h2;
            }
            if (e3.transform || (l2 || s2 ? i2.transform = function(t4, { enableHardwareAcceleration: e4 = true, allowTransformNone: n4 = true }, s3, i3) {
              let o2 = "";
              for (let e5 = 0; e5 < yn; e5++) {
                const n5 = wt[e5];
                void 0 !== t4[n5] && (o2 += `${gn[n5] || n5}(${t4[n5]}) `);
              }
              return e4 && !t4.z && (o2 += "translateZ(0)"), o2 = o2.trim(), i3 ? o2 = i3(t4, s3 ? "" : o2) : n4 && s3 && (o2 = "none"), o2;
            }(t3.transform, n3, c2, s2) : i2.transform && (i2.transform = "none")), u2) {
              const { originX: t4 = "50%", originY: e4 = "50%", originZ: n4 = 0 } = a2;
              i2.transformOrigin = `${t4} ${e4} ${n4}`;
            }
          }
          function Pn(t3, e3, n3) {
            for (const s2 in e3) je(e3[s2]) || fn(s2, n3) || (t3[s2] = e3[s2]);
          }
          function bn(e3, n3, s2) {
            const i2 = {}, o = function(e4, n4, s3) {
              const i3 = {};
              return Pn(i3, e4.style || {}, e4), Object.assign(i3, function({ transformTemplate: e5 }, n5, s4) {
                return (0, t2.useMemo)(() => {
                  const t3 = { style: {}, transform: {}, transformOrigin: {}, vars: {} };
                  return xn(t3, n5, { enableHardwareAcceleration: !s4 }, e5), Object.assign({}, t3.vars, t3.style);
                }, [n5]);
              }(e4, n4, s3)), e4.transformValues ? e4.transformValues(i3) : i3;
            }(e3, n3, s2);
            return e3.drag && false !== e3.dragListener && (i2.draggable = false, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = true === e3.drag ? "none" : "pan-" + ("x" === e3.drag ? "y" : "x")), void 0 === e3.tabIndex && (e3.onTap || e3.onTapStart || e3.whileTap) && (i2.tabIndex = 0), i2.style = o, i2;
          }
          const Tn = /* @__PURE__ */ new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "onLayoutAnimationStart", "onLayoutAnimationComplete", "onLayoutMeasure", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "ignoreStrict", "viewport"]);
          function Sn(t3) {
            return t3.startsWith("while") || t3.startsWith("drag") && "draggable" !== t3 || t3.startsWith("layout") || t3.startsWith("onTap") || t3.startsWith("onPan") || Tn.has(t3);
          }
          let wn = (t3) => !Sn(t3);
          try {
            (En = require$$1.default) && (wn = (t3) => t3.startsWith("on") ? !Sn(t3) : En(t3));
          } catch (t3) {
          }
          var En;
          function An(t3, e3, n3) {
            return "string" == typeof t3 ? t3 : z.transform(e3 + n3 * t3);
          }
          const Vn = { offset: "stroke-dashoffset", array: "stroke-dasharray" }, Cn = { offset: "strokeDashoffset", array: "strokeDasharray" };
          function Mn(t3, { attrX: e3, attrY: n3, attrScale: s2, originX: i2, originY: o, pathLength: r3, pathSpacing: a2 = 1, pathOffset: l2 = 0, ...u2 }, c2, h2, d2) {
            if (xn(t3, u2, c2, d2), h2) return void (t3.style.viewBox && (t3.attrs.viewBox = t3.style.viewBox));
            t3.attrs = t3.style, t3.style = {};
            const { attrs: m2, style: p2, dimensions: f2 } = t3;
            m2.transform && (f2 && (p2.transform = m2.transform), delete m2.transform), f2 && (void 0 !== i2 || void 0 !== o || p2.transform) && (p2.transformOrigin = function(t4, e4, n4) {
              return `${An(e4, t4.x, t4.width)} ${An(n4, t4.y, t4.height)}`;
            }(f2, void 0 !== i2 ? i2 : 0.5, void 0 !== o ? o : 0.5)), void 0 !== e3 && (m2.x = e3), void 0 !== n3 && (m2.y = n3), void 0 !== s2 && (m2.scale = s2), void 0 !== r3 && function(t4, e4, n4 = 1, s3 = 0, i3 = true) {
              t4.pathLength = 1;
              const o2 = i3 ? Vn : Cn;
              t4[o2.offset] = z.transform(-s3);
              const r4 = z.transform(e4), a3 = z.transform(n4);
              t4[o2.array] = `${r4} ${a3}`;
            }(m2, r3, a2, l2, false);
          }
          const Dn = (t3) => "string" == typeof t3 && "svg" === t3.toLowerCase();
          function kn(e3, n3, s2, i2) {
            const o = (0, t2.useMemo)(() => {
              const t3 = { style: {}, transform: {}, transformOrigin: {}, vars: {}, attrs: {} };
              return Mn(t3, n3, { enableHardwareAcceleration: false }, Dn(i2), e3.transformTemplate), { ...t3.attrs, style: { ...t3.style } };
            }, [n3]);
            if (e3.style) {
              const t3 = {};
              Pn(t3, e3.style, e3), o.style = { ...t3, ...o.style };
            }
            return o;
          }
          function Rn(e3 = false) {
            return (n3, s2, i2, { latestValues: o }, r3) => {
              const a2 = (mn(n3) ? kn : bn)(s2, o, r3, n3), l2 = { ...function(t3, e4, n4) {
                const s3 = {};
                for (const i3 in t3) "values" === i3 && "object" == typeof t3.values || (wn(i3) || true === n4 && Sn(i3) || !e4 && !Sn(i3) || t3.draggable && i3.startsWith("onDrag")) && (s3[i3] = t3[i3]);
                return s3;
              }(s2, "string" == typeof n3, e3), ...a2, ref: i2 }, { children: u2 } = s2, c2 = (0, t2.useMemo)(() => je(u2) ? u2.get() : u2, [u2]);
              return (0, t2.createElement)(n3, { ...l2, children: c2 });
            };
          }
          function Ln(t3, { style: e3, vars: n3 }, s2, i2) {
            Object.assign(t3.style, e3, i2 && i2.getProjectionStyles(s2));
            for (const e4 in n3) t3.style.setProperty(e4, n3[e4]);
          }
          const jn = /* @__PURE__ */ new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);
          function Bn(t3, e3, n3, s2) {
            Ln(t3, e3, void 0, s2);
            for (const n4 in e3.attrs) t3.setAttribute(jn.has(n4) ? n4 : At(n4), e3.attrs[n4]);
          }
          function Fn(t3, e3) {
            const { style: n3 } = t3, s2 = {};
            for (const i2 in n3) (je(n3[i2]) || e3.style && je(e3.style[i2]) || fn(i2, t3)) && (s2[i2] = n3[i2]);
            return s2;
          }
          function On(t3, e3) {
            const n3 = Fn(t3, e3);
            for (const s2 in t3) (je(t3[s2]) || je(e3[s2])) && (n3[-1 !== wt.indexOf(s2) ? "attr" + s2.charAt(0).toUpperCase() + s2.substring(1) : s2] = t3[s2]);
            return n3;
          }
          function In(t3) {
            const e3 = je(t3) ? t3.get() : t3;
            return n3 = e3, Boolean(n3 && "object" == typeof n3 && n3.mix && n3.toValue) ? e3.toValue() : e3;
            var n3;
          }
          const Un = (e3) => (n3, s2) => {
            const i2 = (0, t2.useContext)(Xe), o = (0, t2.useContext)(Ge), r3 = () => function({ scrapeMotionValuesFromProps: t3, createRenderState: e4, onMount: n4 }, s3, i3, o2) {
              const r4 = { latestValues: Nn(s3, i3, o2, t3), renderState: e4() };
              return n4 && (r4.mount = (t4) => n4(s3, t4, r4)), r4;
            }(e3, n3, i2, o);
            return s2 ? r3() : We(r3);
          };
          function Nn(t3, e3, n3, s2) {
            const i2 = {}, o = s2(t3, {});
            for (const t4 in o) i2[t4] = In(o[t4]);
            let { initial: r3, animate: a2 } = t3;
            const l2 = tn(t3), u2 = en(t3);
            e3 && u2 && !l2 && false !== t3.inherit && (void 0 === r3 && (r3 = e3.initial), void 0 === a2 && (a2 = e3.animate));
            let c2 = !!n3 && false === n3.initial;
            c2 = c2 || false === r3;
            const h2 = c2 ? a2 : r3;
            return h2 && "boolean" != typeof h2 && !_e(h2) && (Array.isArray(h2) ? h2 : [h2]).forEach((e4) => {
              const n4 = vt(t3, e4);
              if (!n4) return;
              const { transitionEnd: s3, transition: o2, ...r4 } = n4;
              for (const t4 in r4) {
                let e5 = r4[t4];
                Array.isArray(e5) && (e5 = e5[c2 ? e5.length - 1 : 0]), null !== e5 && (i2[t4] = e5);
              }
              for (const t4 in s3) i2[t4] = s3[t4];
            }), i2;
          }
          const $n = { useVisualState: Un({ scrapeMotionValuesFromProps: On, createRenderState: () => ({ style: {}, transform: {}, transformOrigin: {}, vars: {}, attrs: {} }), onMount: (t3, e3, { renderState: n3, latestValues: s2 }) => {
            y.read(() => {
              try {
                n3.dimensions = "function" == typeof e3.getBBox ? e3.getBBox() : e3.getBoundingClientRect();
              } catch (t4) {
                n3.dimensions = { x: 0, y: 0, width: 0, height: 0 };
              }
            }), y.render(() => {
              Mn(n3, s2, { enableHardwareAcceleration: false }, Dn(e3.tagName), t3.transformTemplate), Bn(e3, n3);
            });
          } }) }, Wn = { useVisualState: Un({ scrapeMotionValuesFromProps: Fn, createRenderState: () => ({ style: {}, transform: {}, transformOrigin: {}, vars: {} }) }) };
          function Hn(t3, e3, n3, s2 = { passive: true }) {
            return t3.addEventListener(e3, n3, s2), () => t3.removeEventListener(e3, n3);
          }
          const zn = (t3) => "mouse" === t3.pointerType ? "number" != typeof t3.button || t3.button <= 0 : false !== t3.isPrimary;
          function Yn(t3, e3 = "page") {
            return { point: { x: t3[e3 + "X"], y: t3[e3 + "Y"] } };
          }
          function Xn(t3, e3, n3, s2) {
            return Hn(t3, e3, /* @__PURE__ */ ((t4) => (e4) => zn(e4) && t4(e4, Yn(e4)))(n3), s2);
          }
          function Gn(t3) {
            let e3 = null;
            return () => null === e3 && (e3 = t3, () => {
              e3 = null;
            });
          }
          const qn = Gn("dragHorizontal"), Zn = Gn("dragVertical");
          function Kn(t3) {
            let e3 = false;
            if ("y" === t3) e3 = Zn();
            else if ("x" === t3) e3 = qn();
            else {
              const t4 = qn(), n3 = Zn();
              t4 && n3 ? e3 = () => {
                t4(), n3();
              } : (t4 && t4(), n3 && n3());
            }
            return e3;
          }
          function _n() {
            const t3 = Kn(true);
            return !t3 || (t3(), false);
          }
          class Jn {
            constructor(t3) {
              this.isMounted = false, this.node = t3;
            }
            update() {
            }
          }
          function Qn(t3, e3) {
            const n3 = "pointer" + (e3 ? "enter" : "leave"), s2 = "onHover" + (e3 ? "Start" : "End");
            return Xn(t3.current, n3, (n4, i2) => {
              if ("touch" === n4.type || _n()) return;
              const o = t3.getProps();
              t3.animationState && o.whileHover && t3.animationState.setActive("whileHover", e3), o[s2] && y.update(() => o[s2](n4, i2));
            }, { passive: !t3.getProps()[s2] });
          }
          const ts = (t3, e3) => !!e3 && (t3 === e3 || ts(t3, e3.parentElement));
          function es(t3, e3) {
            if (!e3) return;
            const n3 = new PointerEvent("pointer" + t3);
            e3(n3, Yn(n3));
          }
          const ns = /* @__PURE__ */ new WeakMap(), ss = /* @__PURE__ */ new WeakMap(), is = (t3) => {
            const e3 = ns.get(t3.target);
            e3 && e3(t3);
          }, os = (t3) => {
            t3.forEach(is);
          };
          const rs = { some: 0, all: 1 }, as = { inView: { Feature: class extends Jn {
            constructor() {
              super(...arguments), this.hasEnteredView = false, this.isInView = false;
            }
            startObserver() {
              this.unmount();
              const { viewport: t3 = {} } = this.node.getProps(), { root: e3, margin: n3, amount: s2 = "some", once: i2 } = t3, o = { root: e3 ? e3.current : void 0, rootMargin: n3, threshold: "number" == typeof s2 ? s2 : rs[s2] };
              return function(t4, e4, n4) {
                const s3 = function({ root: t5, ...e5 }) {
                  const n5 = t5 || document;
                  ss.has(n5) || ss.set(n5, {});
                  const s4 = ss.get(n5), i3 = JSON.stringify(e5);
                  return s4[i3] || (s4[i3] = new IntersectionObserver(os, { root: t5, ...e5 })), s4[i3];
                }(e4);
                return ns.set(t4, n4), s3.observe(t4), () => {
                  ns.delete(t4), s3.unobserve(t4);
                };
              }(this.node.current, o, (t4) => {
                const { isIntersecting: e4 } = t4;
                if (this.isInView === e4) return;
                if (this.isInView = e4, i2 && !e4 && this.hasEnteredView) return;
                e4 && (this.hasEnteredView = true), this.node.animationState && this.node.animationState.setActive("whileInView", e4);
                const { onViewportEnter: n4, onViewportLeave: s3 } = this.node.getProps(), o2 = e4 ? n4 : s3;
                o2 && o2(t4);
              });
            }
            mount() {
              this.startObserver();
            }
            update() {
              if ("undefined" == typeof IntersectionObserver) return;
              const { props: t3, prevProps: e3 } = this.node;
              ["amount", "margin", "root"].some(function({ viewport: t4 = {} }, { viewport: e4 = {} } = {}) {
                return (n3) => t4[n3] !== e4[n3];
              }(t3, e3)) && this.startObserver();
            }
            unmount() {
            }
          } }, tap: { Feature: class extends Jn {
            constructor() {
              super(...arguments), this.removeStartListeners = n2, this.removeEndListeners = n2, this.removeAccessibleListeners = n2, this.startPointerPress = (t3, e3) => {
                if (this.removeEndListeners(), this.isPressing) return;
                const n3 = this.node.getProps(), s2 = Xn(window, "pointerup", (t4, e4) => {
                  if (!this.checkPressEnd()) return;
                  const { onTap: n4, onTapCancel: s3 } = this.node.getProps();
                  y.update(() => {
                    ts(this.node.current, t4.target) ? n4 && n4(t4, e4) : s3 && s3(t4, e4);
                  });
                }, { passive: !(n3.onTap || n3.onPointerUp) }), i2 = Xn(window, "pointercancel", (t4, e4) => this.cancelPress(t4, e4), { passive: !(n3.onTapCancel || n3.onPointerCancel) });
                this.removeEndListeners = se(s2, i2), this.startPress(t3, e3);
              }, this.startAccessiblePress = () => {
                const t3 = Hn(this.node.current, "keydown", (t4) => {
                  "Enter" !== t4.key || this.isPressing || (this.removeEndListeners(), this.removeEndListeners = Hn(this.node.current, "keyup", (t5) => {
                    "Enter" === t5.key && this.checkPressEnd() && es("up", (t6, e4) => {
                      const { onTap: n3 } = this.node.getProps();
                      n3 && y.update(() => n3(t6, e4));
                    });
                  }), es("down", (t5, e4) => {
                    this.startPress(t5, e4);
                  }));
                }), e3 = Hn(this.node.current, "blur", () => {
                  this.isPressing && es("cancel", (t4, e4) => this.cancelPress(t4, e4));
                });
                this.removeAccessibleListeners = se(t3, e3);
              };
            }
            startPress(t3, e3) {
              this.isPressing = true;
              const { onTapStart: n3, whileTap: s2 } = this.node.getProps();
              s2 && this.node.animationState && this.node.animationState.setActive("whileTap", true), n3 && y.update(() => n3(t3, e3));
            }
            checkPressEnd() {
              return this.removeEndListeners(), this.isPressing = false, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", false), !_n();
            }
            cancelPress(t3, e3) {
              if (!this.checkPressEnd()) return;
              const { onTapCancel: n3 } = this.node.getProps();
              n3 && y.update(() => n3(t3, e3));
            }
            mount() {
              const t3 = this.node.getProps(), e3 = Xn(this.node.current, "pointerdown", this.startPointerPress, { passive: !(t3.onTapStart || t3.onPointerStart) }), n3 = Hn(this.node.current, "focus", this.startAccessiblePress);
              this.removeStartListeners = se(e3, n3);
            }
            unmount() {
              this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
            }
          } }, focus: { Feature: class extends Jn {
            constructor() {
              super(...arguments), this.isActive = false;
            }
            onFocus() {
              let t3 = false;
              try {
                t3 = this.node.current.matches(":focus-visible");
              } catch (e3) {
                t3 = true;
              }
              t3 && this.node.animationState && (this.node.animationState.setActive("whileFocus", true), this.isActive = true);
            }
            onBlur() {
              this.isActive && this.node.animationState && (this.node.animationState.setActive("whileFocus", false), this.isActive = false);
            }
            mount() {
              this.unmount = se(Hn(this.node.current, "focus", () => this.onFocus()), Hn(this.node.current, "blur", () => this.onBlur()));
            }
            unmount() {
            }
          } }, hover: { Feature: class extends Jn {
            mount() {
              this.unmount = se(Qn(this.node, true), Qn(this.node, false));
            }
            unmount() {
            }
          } } };
          function ls(t3, e3) {
            if (!Array.isArray(e3)) return false;
            const n3 = e3.length;
            if (n3 !== t3.length) return false;
            for (let s2 = 0; s2 < n3; s2++) if (e3[s2] !== t3[s2]) return false;
            return true;
          }
          const us = [...Je].reverse(), cs = Je.length;
          function hs(t3 = false) {
            return { isActive: t3, protectedKeys: {}, needsAnimating: {}, prevResolvedValues: {} };
          }
          let ds = 0;
          const ms = { animation: { Feature: class extends Jn {
            constructor(t3) {
              super(t3), t3.animationState || (t3.animationState = function(t4) {
                let e3 = /* @__PURE__ */ function(t5) {
                  return (e4) => Promise.all(e4.map(({ animation: e5, options: n4 }) => Ne(t5, e5, n4)));
                }(t4);
                const n3 = { animate: hs(true), whileInView: hs(), whileHover: hs(), whileTap: hs(), whileDrag: hs(), whileFocus: hs(), exit: hs() };
                let s2 = true;
                const i2 = (e4, n4) => {
                  const s3 = xt(t4, n4);
                  if (s3) {
                    const { transition: t5, transitionEnd: n5, ...i3 } = s3;
                    e4 = { ...e4, ...i3, ...n5 };
                  }
                  return e4;
                };
                function o(o2, r3) {
                  const a2 = t4.getProps(), l2 = t4.getVariantContext(true) || {}, u2 = [], h2 = /* @__PURE__ */ new Set();
                  let d2 = {}, m2 = 1 / 0;
                  for (let e4 = 0; e4 < cs; e4++) {
                    const g3 = us[e4], y2 = n3[g3], v2 = void 0 !== a2[g3] ? a2[g3] : l2[g3], x2 = Ke(v2), P2 = g3 === r3 ? y2.isActive : null;
                    false === P2 && (m2 = e4);
                    let b = v2 === l2[g3] && v2 !== a2[g3] && x2;
                    if (b && s2 && t4.manuallyAnimateOnMount && (b = false), y2.protectedKeys = { ...d2 }, !y2.isActive && null === P2 || !v2 && !y2.prevProp || _e(v2) || "boolean" == typeof v2) continue;
                    const T2 = (p2 = y2.prevProp, "string" == typeof (f2 = v2) ? f2 !== p2 : !!Array.isArray(f2) && !ls(f2, p2));
                    let S2 = T2 || g3 === r3 && y2.isActive && !b && x2 || e4 > m2 && x2;
                    const w2 = Array.isArray(v2) ? v2 : [v2];
                    let E2 = w2.reduce(i2, {});
                    false === P2 && (E2 = {});
                    const { prevResolvedValues: A2 = {} } = y2, V2 = { ...A2, ...E2 }, C2 = (t5) => {
                      S2 = true, h2.delete(t5), y2.needsAnimating[t5] = true;
                    };
                    for (const t5 in V2) {
                      const e5 = E2[t5], n4 = A2[t5];
                      d2.hasOwnProperty(t5) || (e5 !== n4 ? c(e5) && c(n4) ? !ls(e5, n4) || T2 ? C2(t5) : y2.protectedKeys[t5] = true : void 0 !== e5 ? C2(t5) : h2.add(t5) : void 0 !== e5 && h2.has(t5) ? C2(t5) : y2.protectedKeys[t5] = true);
                    }
                    y2.prevProp = v2, y2.prevResolvedValues = E2, y2.isActive && (d2 = { ...d2, ...E2 }), s2 && t4.blockInitialAnimation && (S2 = false), S2 && !b && u2.push(...w2.map((t5) => ({ animation: t5, options: { type: g3, ...o2 } })));
                  }
                  var p2, f2;
                  if (h2.size) {
                    const e4 = {};
                    h2.forEach((n4) => {
                      const s3 = t4.getBaseTarget(n4);
                      void 0 !== s3 && (e4[n4] = s3);
                    }), u2.push({ animation: e4 });
                  }
                  let g2 = Boolean(u2.length);
                  return s2 && false === a2.initial && !t4.manuallyAnimateOnMount && (g2 = false), s2 = false, g2 ? e3(u2) : Promise.resolve();
                }
                return { animateChanges: o, setActive: function(e4, s3, i3) {
                  var r3;
                  if (n3[e4].isActive === s3) return Promise.resolve();
                  null === (r3 = t4.variantChildren) || void 0 === r3 || r3.forEach((t5) => {
                    var n4;
                    return null === (n4 = t5.animationState) || void 0 === n4 ? void 0 : n4.setActive(e4, s3);
                  }), n3[e4].isActive = s3;
                  const a2 = o(i3, e4);
                  for (const t5 in n3) n3[t5].protectedKeys = {};
                  return a2;
                }, setAnimateFunction: function(n4) {
                  e3 = n4(t4);
                }, getState: () => n3 };
              }(t3));
            }
            updateAnimationControlsSubscription() {
              const { animate: t3 } = this.node.getProps();
              this.unmount(), _e(t3) && (this.unmount = t3.subscribe(this.node));
            }
            mount() {
              this.updateAnimationControlsSubscription();
            }
            update() {
              const { animate: t3 } = this.node.getProps(), { animate: e3 } = this.node.prevProps || {};
              t3 !== e3 && this.updateAnimationControlsSubscription();
            }
            unmount() {
            }
          } }, exit: { Feature: class extends Jn {
            constructor() {
              super(...arguments), this.id = ds++;
            }
            update() {
              if (!this.node.presenceContext) return;
              const { isPresent: t3, onExitComplete: e3, custom: n3 } = this.node.presenceContext, { isPresent: s2 } = this.node.prevPresenceContext || {};
              if (!this.node.animationState || t3 === s2) return;
              const i2 = this.node.animationState.setActive("exit", !t3, { custom: null != n3 ? n3 : this.node.getProps().custom });
              e3 && !t3 && i2.then(() => e3(this.id));
            }
            mount() {
              const { register: t3 } = this.node.presenceContext || {};
              t3 && (this.unmount = t3(this.id));
            }
            unmount() {
            }
          } } }, ps = (t3, e3) => Math.abs(t3 - e3);
          class fs {
            constructor(t3, e3, { transformPagePoint: n3 } = {}) {
              if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = () => {
                if (!this.lastMoveEvent || !this.lastMoveEventInfo) return;
                const t4 = vs(this.lastMoveEventInfo, this.history), e4 = null !== this.startEvent, n4 = function(t5, e5) {
                  const n5 = ps(t5.x, e5.x), s4 = ps(t5.y, e5.y);
                  return Math.sqrt(n5 ** 2 + s4 ** 2);
                }(t4.offset, { x: 0, y: 0 }) >= 3;
                if (!e4 && !n4) return;
                const { point: s3 } = t4, { timestamp: i3 } = x;
                this.history.push({ ...s3, timestamp: i3 });
                const { onStart: o2, onMove: r4 } = this.handlers;
                e4 || (o2 && o2(this.lastMoveEvent, t4), this.startEvent = this.lastMoveEvent), r4 && r4(this.lastMoveEvent, t4);
              }, this.handlePointerMove = (t4, e4) => {
                this.lastMoveEvent = t4, this.lastMoveEventInfo = gs(e4, this.transformPagePoint), y.update(this.updatePoint, true);
              }, this.handlePointerUp = (t4, e4) => {
                if (this.end(), !this.lastMoveEvent || !this.lastMoveEventInfo) return;
                const { onEnd: n4, onSessionEnd: s3 } = this.handlers, i3 = vs("pointercancel" === t4.type ? this.lastMoveEventInfo : gs(e4, this.transformPagePoint), this.history);
                this.startEvent && n4 && n4(t4, i3), s3 && s3(t4, i3);
              }, !zn(t3)) return;
              this.handlers = e3, this.transformPagePoint = n3;
              const s2 = gs(Yn(t3), this.transformPagePoint), { point: i2 } = s2, { timestamp: o } = x;
              this.history = [{ ...i2, timestamp: o }];
              const { onSessionStart: r3 } = e3;
              r3 && r3(t3, vs(s2, this.history)), this.removeListeners = se(Xn(window, "pointermove", this.handlePointerMove), Xn(window, "pointerup", this.handlePointerUp), Xn(window, "pointercancel", this.handlePointerUp));
            }
            updateHandlers(t3) {
              this.handlers = t3;
            }
            end() {
              this.removeListeners && this.removeListeners(), v(this.updatePoint);
            }
          }
          function gs(t3, e3) {
            return e3 ? { point: e3(t3.point) } : t3;
          }
          function ys(t3, e3) {
            return { x: t3.x - e3.x, y: t3.y - e3.y };
          }
          function vs({ point: t3 }, e3) {
            return { point: t3, delta: ys(t3, Ps(e3)), offset: ys(t3, xs(e3)), velocity: bs(e3, 0.1) };
          }
          function xs(t3) {
            return t3[0];
          }
          function Ps(t3) {
            return t3[t3.length - 1];
          }
          function bs(t3, e3) {
            if (t3.length < 2) return { x: 0, y: 0 };
            let n3 = t3.length - 1, s2 = null;
            const i2 = Ps(t3);
            for (; n3 >= 0 && (s2 = t3[n3], !(i2.timestamp - s2.timestamp > Ct(e3))); ) n3--;
            if (!s2) return { x: 0, y: 0 };
            const o = Mt(i2.timestamp - s2.timestamp);
            if (0 === o) return { x: 0, y: 0 };
            const r3 = { x: (i2.x - s2.x) / o, y: (i2.y - s2.y) / o };
            return r3.x === 1 / 0 && (r3.x = 0), r3.y === 1 / 0 && (r3.y = 0), r3;
          }
          function Ts(t3) {
            return t3.max - t3.min;
          }
          function Ss(t3, e3 = 0, n3 = 0.01) {
            return Math.abs(t3 - e3) <= n3;
          }
          function ws(t3, e3, n3, s2 = 0.5) {
            t3.origin = s2, t3.originPoint = Kt(e3.min, e3.max, t3.origin), t3.scale = Ts(n3) / Ts(e3), (Ss(t3.scale, 1, 1e-4) || isNaN(t3.scale)) && (t3.scale = 1), t3.translate = Kt(n3.min, n3.max, t3.origin) - t3.originPoint, (Ss(t3.translate) || isNaN(t3.translate)) && (t3.translate = 0);
          }
          function Es(t3, e3, n3, s2) {
            ws(t3.x, e3.x, n3.x, s2 ? s2.originX : void 0), ws(t3.y, e3.y, n3.y, s2 ? s2.originY : void 0);
          }
          function As(t3, e3, n3) {
            t3.min = n3.min + e3.min, t3.max = t3.min + Ts(e3);
          }
          function Vs(t3, e3, n3) {
            t3.min = e3.min - n3.min, t3.max = t3.min + Ts(e3);
          }
          function Cs(t3, e3, n3) {
            Vs(t3.x, e3.x, n3.x), Vs(t3.y, e3.y, n3.y);
          }
          function Ms(t3, e3, n3) {
            return { min: void 0 !== e3 ? t3.min + e3 : void 0, max: void 0 !== n3 ? t3.max + n3 - (t3.max - t3.min) : void 0 };
          }
          function Ds(t3, e3) {
            let n3 = e3.min - t3.min, s2 = e3.max - t3.max;
            return e3.max - e3.min < t3.max - t3.min && ([n3, s2] = [s2, n3]), { min: n3, max: s2 };
          }
          const ks = 0.35;
          function Rs(t3, e3, n3) {
            return { min: Ls(t3, e3), max: Ls(t3, n3) };
          }
          function Ls(t3, e3) {
            return "number" == typeof t3 ? t3 : t3[e3] || 0;
          }
          function js(t3) {
            return [t3("x"), t3("y")];
          }
          function Bs({ top: t3, left: e3, right: n3, bottom: s2 }) {
            return { x: { min: e3, max: n3 }, y: { min: t3, max: s2 } };
          }
          function Fs(t3) {
            return void 0 === t3 || 1 === t3;
          }
          function Os({ scale: t3, scaleX: e3, scaleY: n3 }) {
            return !Fs(t3) || !Fs(e3) || !Fs(n3);
          }
          function Is(t3) {
            return Os(t3) || Us(t3) || t3.z || t3.rotate || t3.rotateX || t3.rotateY;
          }
          function Us(t3) {
            return Ns(t3.x) || Ns(t3.y);
          }
          function Ns(t3) {
            return t3 && "0%" !== t3;
          }
          function $s(t3, e3, n3) {
            return n3 + e3 * (t3 - n3);
          }
          function Ws(t3, e3, n3, s2, i2) {
            return void 0 !== i2 && (t3 = $s(t3, i2, s2)), $s(t3, n3, s2) + e3;
          }
          function Hs(t3, e3 = 0, n3 = 1, s2, i2) {
            t3.min = Ws(t3.min, e3, n3, s2, i2), t3.max = Ws(t3.max, e3, n3, s2, i2);
          }
          function zs(t3, { x: e3, y: n3 }) {
            Hs(t3.x, e3.translate, e3.scale, e3.originPoint), Hs(t3.y, n3.translate, n3.scale, n3.originPoint);
          }
          function Ys(t3) {
            return Number.isInteger(t3) || t3 > 1.0000000000001 || t3 < 0.999999999999 ? t3 : 1;
          }
          function Xs(t3, e3) {
            t3.min = t3.min + e3, t3.max = t3.max + e3;
          }
          function Gs(t3, e3, [n3, s2, i2]) {
            const o = void 0 !== e3[i2] ? e3[i2] : 0.5, r3 = Kt(t3.min, t3.max, o);
            Hs(t3, e3[n3], e3[s2], r3, e3.scale);
          }
          const qs = ["x", "scaleX", "originX"], Zs = ["y", "scaleY", "originY"];
          function Ks(t3, e3) {
            Gs(t3.x, e3, qs), Gs(t3.y, e3, Zs);
          }
          function _s(t3, e3) {
            return Bs(function(t4, e4) {
              if (!e4) return t4;
              const n3 = e4({ x: t4.left, y: t4.top }), s2 = e4({ x: t4.right, y: t4.bottom });
              return { top: n3.y, left: n3.x, bottom: s2.y, right: s2.x };
            }(t3.getBoundingClientRect(), e3));
          }
          const Js = /* @__PURE__ */ new WeakMap();
          class Qs {
            constructor(t3) {
              this.openGlobalLock = null, this.isDragging = false, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = false, this.hasMutatedConstraints = false, this.elastic = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }, this.visualElement = t3;
            }
            start(t3, { snapToCursor: e3 = false } = {}) {
              const { presenceContext: n3 } = this.visualElement;
              n3 && false === n3.isPresent || (this.panSession = new fs(t3, { onSessionStart: (t4) => {
                this.stopAnimation(), e3 && this.snapToCursor(Yn(t4, "page").point);
              }, onStart: (t4, e4) => {
                const { drag: n4, dragPropagation: s2, onDragStart: i2 } = this.getProps();
                if (n4 && !s2 && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = Kn(n4), !this.openGlobalLock)) return;
                this.isDragging = true, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = true, this.visualElement.projection.target = void 0), js((t5) => {
                  let e5 = this.getAxisMotionValue(t5).get() || 0;
                  if (H.test(e5)) {
                    const { projection: n5 } = this.visualElement;
                    if (n5 && n5.layout) {
                      const s3 = n5.layout.layoutBox[t5];
                      s3 && (e5 = Ts(s3) * (parseFloat(e5) / 100));
                    }
                  }
                  this.originPoint[t5] = e5;
                }), i2 && y.update(() => i2(t4, e4), false, true);
                const { animationState: o } = this.visualElement;
                o && o.setActive("whileDrag", true);
              }, onMove: (t4, e4) => {
                const { dragPropagation: n4, dragDirectionLock: s2, onDirectionLock: i2, onDrag: o } = this.getProps();
                if (!n4 && !this.openGlobalLock) return;
                const { offset: r3 } = e4;
                if (s2 && null === this.currentDirection) return this.currentDirection = function(t5, e5 = 10) {
                  let n5 = null;
                  return Math.abs(t5.y) > e5 ? n5 = "y" : Math.abs(t5.x) > e5 && (n5 = "x"), n5;
                }(r3), void (null !== this.currentDirection && i2 && i2(this.currentDirection));
                this.updateAxis("x", e4.point, r3), this.updateAxis("y", e4.point, r3), this.visualElement.render(), o && o(t4, e4);
              }, onSessionEnd: (t4, e4) => this.stop(t4, e4) }, { transformPagePoint: this.visualElement.getTransformPagePoint() }));
            }
            stop(t3, e3) {
              const n3 = this.isDragging;
              if (this.cancel(), !n3) return;
              const { velocity: s2 } = e3;
              this.startAnimation(s2);
              const { onDragEnd: i2 } = this.getProps();
              i2 && y.update(() => i2(t3, e3));
            }
            cancel() {
              this.isDragging = false;
              const { projection: t3, animationState: e3 } = this.visualElement;
              t3 && (t3.isAnimationBlocked = false), this.panSession && this.panSession.end(), this.panSession = void 0;
              const { dragPropagation: n3 } = this.getProps();
              !n3 && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), e3 && e3.setActive("whileDrag", false);
            }
            updateAxis(t3, e3, n3) {
              const { drag: s2 } = this.getProps();
              if (!n3 || !ti(t3, s2, this.currentDirection)) return;
              const i2 = this.getAxisMotionValue(t3);
              let o = this.originPoint[t3] + n3[t3];
              this.constraints && this.constraints[t3] && (o = function(t4, { min: e4, max: n4 }, s3) {
                return void 0 !== e4 && t4 < e4 ? t4 = s3 ? Kt(e4, t4, s3.min) : Math.max(t4, e4) : void 0 !== n4 && t4 > n4 && (t4 = s3 ? Kt(n4, t4, s3.max) : Math.min(t4, n4)), t4;
              }(o, this.constraints[t3], this.elastic[t3])), i2.set(o);
            }
            resolveConstraints() {
              const { dragConstraints: t3, dragElastic: e3 } = this.getProps(), { layout: n3 } = this.visualElement.projection || {}, s2 = this.constraints;
              t3 && Ze(t3) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : this.constraints = !(!t3 || !n3) && function(t4, { top: e4, left: n4, bottom: s3, right: i2 }) {
                return { x: Ms(t4.x, n4, i2), y: Ms(t4.y, e4, s3) };
              }(n3.layoutBox, t3), this.elastic = function(t4 = ks) {
                return false === t4 ? t4 = 0 : true === t4 && (t4 = ks), { x: Rs(t4, "left", "right"), y: Rs(t4, "top", "bottom") };
              }(e3), s2 !== this.constraints && n3 && this.constraints && !this.hasMutatedConstraints && js((t4) => {
                this.getAxisMotionValue(t4) && (this.constraints[t4] = function(t5, e4) {
                  const n4 = {};
                  return void 0 !== e4.min && (n4.min = e4.min - t5.min), void 0 !== e4.max && (n4.max = e4.max - t5.min), n4;
                }(n3.layoutBox[t4], this.constraints[t4]));
              });
            }
            resolveRefConstraints() {
              const { dragConstraints: t3, onMeasureDragConstraints: e3 } = this.getProps();
              if (!t3 || !Ze(t3)) return false;
              const n3 = t3.current;
              const { projection: s2 } = this.visualElement;
              if (!s2 || !s2.layout) return false;
              const i2 = function(t4, e4, n4) {
                const s3 = _s(t4, n4), { scroll: i3 } = e4;
                return i3 && (Xs(s3.x, i3.offset.x), Xs(s3.y, i3.offset.y)), s3;
              }(n3, s2.root, this.visualElement.getTransformPagePoint());
              let o = function(t4, e4) {
                return { x: Ds(t4.x, e4.x), y: Ds(t4.y, e4.y) };
              }(s2.layout.layoutBox, i2);
              if (e3) {
                const t4 = e3(function({ x: t5, y: e4 }) {
                  return { top: e4.min, right: t5.max, bottom: e4.max, left: t5.min };
                }(o));
                this.hasMutatedConstraints = !!t4, t4 && (o = Bs(t4));
              }
              return o;
            }
            startAnimation(t3) {
              const { drag: e3, dragMomentum: n3, dragElastic: s2, dragTransition: i2, dragSnapToOrigin: o, onDragTransitionEnd: r3 } = this.getProps(), a2 = this.constraints || {}, l2 = js((r4) => {
                if (!ti(r4, e3, this.currentDirection)) return;
                let l3 = a2 && a2[r4] || {};
                o && (l3 = { min: 0, max: 0 });
                const u2 = s2 ? 200 : 1e6, c2 = s2 ? 40 : 1e7, h2 = { type: "inertia", velocity: n3 ? t3[r4] : 0, bounceStiffness: u2, bounceDamping: c2, timeConstant: 750, restDelta: 1, restSpeed: 10, ...i2, ...l3 };
                return this.startAxisValueAnimation(r4, h2);
              });
              return Promise.all(l2).then(r3);
            }
            startAxisValueAnimation(t3, e3) {
              const n3 = this.getAxisMotionValue(t3);
              return n3.start(Le(t3, n3, 0, e3));
            }
            stopAnimation() {
              js((t3) => this.getAxisMotionValue(t3).stop());
            }
            getAxisMotionValue(t3) {
              const e3 = "_drag" + t3.toUpperCase(), n3 = this.visualElement.getProps();
              return n3[e3] || this.visualElement.getValue(t3, (n3.initial ? n3.initial[t3] : void 0) || 0);
            }
            snapToCursor(t3) {
              js((e3) => {
                const { drag: n3 } = this.getProps();
                if (!ti(e3, n3, this.currentDirection)) return;
                const { projection: s2 } = this.visualElement, i2 = this.getAxisMotionValue(e3);
                if (s2 && s2.layout) {
                  const { min: n4, max: o } = s2.layout.layoutBox[e3];
                  i2.set(t3[e3] - Kt(n4, o, 0.5));
                }
              });
            }
            scalePositionWithinConstraints() {
              if (!this.visualElement.current) return;
              const { drag: t3, dragConstraints: e3 } = this.getProps(), { projection: n3 } = this.visualElement;
              if (!Ze(e3) || !n3 || !this.constraints) return;
              this.stopAnimation();
              const s2 = { x: 0, y: 0 };
              js((t4) => {
                const e4 = this.getAxisMotionValue(t4);
                if (e4) {
                  const n4 = e4.get();
                  s2[t4] = function(t5, e5) {
                    let n5 = 0.5;
                    const s3 = Ts(t5), i3 = Ts(e5);
                    return i3 > s3 ? n5 = ue(e5.min, e5.max - s3, t5.min) : s3 > i3 && (n5 = ue(t5.min, t5.max - i3, e5.min)), R(0, 1, n5);
                  }({ min: n4, max: n4 }, this.constraints[t4]);
                }
              });
              const { transformTemplate: i2 } = this.visualElement.getProps();
              this.visualElement.current.style.transform = i2 ? i2({}, "") : "none", n3.root && n3.root.updateScroll(), n3.updateLayout(), this.resolveConstraints(), js((e4) => {
                if (!ti(e4, t3, null)) return;
                const n4 = this.getAxisMotionValue(e4), { min: i3, max: o } = this.constraints[e4];
                n4.set(Kt(i3, o, s2[e4]));
              });
            }
            addListeners() {
              if (!this.visualElement.current) return;
              Js.set(this.visualElement, this);
              const t3 = Xn(this.visualElement.current, "pointerdown", (t4) => {
                const { drag: e4, dragListener: n4 = true } = this.getProps();
                e4 && n4 && this.start(t4);
              }), e3 = () => {
                const { dragConstraints: t4 } = this.getProps();
                Ze(t4) && (this.constraints = this.resolveRefConstraints());
              }, { projection: n3 } = this.visualElement, s2 = n3.addEventListener("measure", e3);
              n3 && !n3.layout && (n3.root && n3.root.updateScroll(), n3.updateLayout()), e3();
              const i2 = Hn(window, "resize", () => this.scalePositionWithinConstraints()), o = n3.addEventListener("didUpdate", ({ delta: t4, hasLayoutChanged: e4 }) => {
                this.isDragging && e4 && (js((e5) => {
                  const n4 = this.getAxisMotionValue(e5);
                  n4 && (this.originPoint[e5] += t4[e5].translate, n4.set(n4.get() + t4[e5].translate));
                }), this.visualElement.render());
              });
              return () => {
                i2(), t3(), s2(), o && o();
              };
            }
            getProps() {
              const t3 = this.visualElement.getProps(), { drag: e3 = false, dragDirectionLock: n3 = false, dragPropagation: s2 = false, dragConstraints: i2 = false, dragElastic: o = ks, dragMomentum: r3 = true } = t3;
              return { ...t3, drag: e3, dragDirectionLock: n3, dragPropagation: s2, dragConstraints: i2, dragElastic: o, dragMomentum: r3 };
            }
          }
          function ti(t3, e3, n3) {
            return !(true !== e3 && e3 !== t3 || null !== n3 && n3 !== t3);
          }
          const ei = (t3) => (e3, n3) => {
            t3 && y.update(() => t3(e3, n3));
          }, ni = { hasAnimatedSinceResize: true, hasEverUpdated: false };
          function si(t3, e3) {
            return e3.max === e3.min ? 0 : t3 / (e3.max - e3.min) * 100;
          }
          const ii = { correct: (t3, e3) => {
            if (!e3.target) return t3;
            if ("string" == typeof t3) {
              if (!z.test(t3)) return t3;
              t3 = parseFloat(t3);
            }
            return `${si(t3, e3.target.x)}% ${si(t3, e3.target.y)}%`;
          } }, oi = { correct: (t3, { treeScale: e3, projectionDelta: n3 }) => {
            const s2 = t3, i2 = it.parse(t3);
            if (i2.length > 5) return s2;
            const o = it.createTransformer(t3), r3 = "number" != typeof i2[0] ? 1 : 0, a2 = n3.x.scale * e3.x, l2 = n3.y.scale * e3.y;
            i2[0 + r3] /= a2, i2[1 + r3] /= l2;
            const u2 = Kt(a2, l2, 0.5);
            return "number" == typeof i2[2 + r3] && (i2[2 + r3] /= u2), "number" == typeof i2[3 + r3] && (i2[3 + r3] /= u2), o(i2);
          } };
          class ri extends t2.Component {
            componentDidMount() {
              const { visualElement: t3, layoutGroup: e3, switchLayoutGroup: n3, layoutId: s2 } = this.props, { projection: i2 } = t3;
              var o;
              o = li, Object.assign(pn, o), i2 && (e3.group && e3.group.add(i2), n3 && n3.register && s2 && n3.register(i2), i2.root.didUpdate(), i2.addEventListener("animationComplete", () => {
                this.safeToRemove();
              }), i2.setOptions({ ...i2.options, onExitComplete: () => this.safeToRemove() })), ni.hasEverUpdated = true;
            }
            getSnapshotBeforeUpdate(t3) {
              const { layoutDependency: e3, visualElement: n3, drag: s2, isPresent: i2 } = this.props, o = n3.projection;
              return o ? (o.isPresent = i2, s2 || t3.layoutDependency !== e3 || void 0 === e3 ? o.willUpdate() : this.safeToRemove(), t3.isPresent !== i2 && (i2 ? o.promote() : o.relegate() || y.postRender(() => {
                const t4 = o.getStack();
                t4 && t4.members.length || this.safeToRemove();
              })), null) : null;
            }
            componentDidUpdate() {
              const { projection: t3 } = this.props.visualElement;
              t3 && (t3.root.didUpdate(), queueMicrotask(() => {
                !t3.currentAnimation && t3.isLead() && this.safeToRemove();
              }));
            }
            componentWillUnmount() {
              const { visualElement: t3, layoutGroup: e3, switchLayoutGroup: n3 } = this.props, { projection: s2 } = t3;
              s2 && (s2.scheduleCheckAfterUnmount(), e3 && e3.group && e3.group.remove(s2), n3 && n3.deregister && n3.deregister(s2));
            }
            safeToRemove() {
              const { safeToRemove: t3 } = this.props;
              t3 && t3();
            }
            render() {
              return null;
            }
          }
          function ai(e3) {
            const [n3, s2] = function() {
              const e4 = (0, t2.useContext)(Ge);
              if (null === e4) return [true, null];
              const { isPresent: n4, onExitComplete: s3, register: i3 } = e4, o = (0, t2.useId)();
              return (0, t2.useEffect)(() => i3(o), []), !n4 && s3 ? [false, () => s3 && s3(o)] : [true];
            }(), i2 = (0, t2.useContext)(rn);
            return t2.createElement(ri, { ...e3, layoutGroup: i2, switchLayoutGroup: (0, t2.useContext)(an), isPresent: n3, safeToRemove: s2 });
          }
          const li = { borderRadius: { ...ii, applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"] }, borderTopLeftRadius: ii, borderTopRightRadius: ii, borderBottomLeftRadius: ii, borderBottomRightRadius: ii, boxShadow: oi }, ui = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], ci = ui.length, hi = (t3) => "string" == typeof t3 ? parseFloat(t3) : t3, di = (t3) => "number" == typeof t3 || z.test(t3);
          function mi(t3, e3) {
            return void 0 !== t3[e3] ? t3[e3] : t3.borderRadius;
          }
          const pi = gi(0, 0.5, Ht), fi = gi(0.5, 0.95, n2);
          function gi(t3, e3, n3) {
            return (s2) => s2 < t3 ? 0 : s2 > e3 ? 1 : n3(ue(t3, e3, s2));
          }
          function yi(t3, e3) {
            t3.min = e3.min, t3.max = e3.max;
          }
          function vi(t3, e3) {
            yi(t3.x, e3.x), yi(t3.y, e3.y);
          }
          function xi(t3, e3, n3, s2, i2) {
            return t3 = $s(t3 -= e3, 1 / n3, s2), void 0 !== i2 && (t3 = $s(t3, 1 / i2, s2)), t3;
          }
          function Pi(t3, e3, [n3, s2, i2], o, r3) {
            !function(t4, e4 = 0, n4 = 1, s3 = 0.5, i3, o2 = t4, r4 = t4) {
              if (H.test(e4) && (e4 = parseFloat(e4), e4 = Kt(r4.min, r4.max, e4 / 100) - r4.min), "number" != typeof e4) return;
              let a2 = Kt(o2.min, o2.max, s3);
              t4 === o2 && (a2 -= e4), t4.min = xi(t4.min, e4, n4, a2, i3), t4.max = xi(t4.max, e4, n4, a2, i3);
            }(t3, e3[n3], e3[s2], e3[i2], e3.scale, o, r3);
          }
          const bi = ["x", "scaleX", "originX"], Ti = ["y", "scaleY", "originY"];
          function Si(t3, e3, n3, s2) {
            Pi(t3.x, e3, bi, n3 ? n3.x : void 0, s2 ? s2.x : void 0), Pi(t3.y, e3, Ti, n3 ? n3.y : void 0, s2 ? s2.y : void 0);
          }
          function wi(t3) {
            return 0 === t3.translate && 1 === t3.scale;
          }
          function Ei(t3) {
            return wi(t3.x) && wi(t3.y);
          }
          function Ai(t3, e3) {
            return Math.round(t3.x.min) === Math.round(e3.x.min) && Math.round(t3.x.max) === Math.round(e3.x.max) && Math.round(t3.y.min) === Math.round(e3.y.min) && Math.round(t3.y.max) === Math.round(e3.y.max);
          }
          function Vi(t3) {
            return Ts(t3.x) / Ts(t3.y);
          }
          class Ci {
            constructor() {
              this.members = [];
            }
            add(t3) {
              h(this.members, t3), t3.scheduleRender();
            }
            remove(t3) {
              if (d(this.members, t3), t3 === this.prevLead && (this.prevLead = void 0), t3 === this.lead) {
                const t4 = this.members[this.members.length - 1];
                t4 && this.promote(t4);
              }
            }
            relegate(t3) {
              const e3 = this.members.findIndex((e4) => t3 === e4);
              if (0 === e3) return false;
              let n3;
              for (let t4 = e3; t4 >= 0; t4--) {
                const e4 = this.members[t4];
                if (false !== e4.isPresent) {
                  n3 = e4;
                  break;
                }
              }
              return !!n3 && (this.promote(n3), true);
            }
            promote(t3, e3) {
              const n3 = this.lead;
              if (t3 !== n3 && (this.prevLead = n3, this.lead = t3, t3.show(), n3)) {
                n3.instance && n3.scheduleRender(), t3.scheduleRender(), t3.resumeFrom = n3, e3 && (t3.resumeFrom.preserveOpacity = true), n3.snapshot && (t3.snapshot = n3.snapshot, t3.snapshot.latestValues = n3.animationValues || n3.latestValues), t3.root && t3.root.isUpdating && (t3.isLayoutDirty = true);
                const { crossfade: s2 } = t3.options;
                false === s2 && n3.hide();
              }
            }
            exitAnimationComplete() {
              this.members.forEach((t3) => {
                const { options: e3, resumingFrom: n3 } = t3;
                e3.onExitComplete && e3.onExitComplete(), n3 && n3.options.onExitComplete && n3.options.onExitComplete();
              });
            }
            scheduleRender() {
              this.members.forEach((t3) => {
                t3.instance && t3.scheduleRender(false);
              });
            }
            removeLeadSnapshot() {
              this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
            }
          }
          function Mi(t3, e3, n3) {
            let s2 = "";
            const i2 = t3.x.translate / e3.x, o = t3.y.translate / e3.y;
            if ((i2 || o) && (s2 = `translate3d(${i2}px, ${o}px, 0) `), 1 === e3.x && 1 === e3.y || (s2 += `scale(${1 / e3.x}, ${1 / e3.y}) `), n3) {
              const { rotate: t4, rotateX: e4, rotateY: i3 } = n3;
              t4 && (s2 += `rotate(${t4}deg) `), e4 && (s2 += `rotateX(${e4}deg) `), i3 && (s2 += `rotateY(${i3}deg) `);
            }
            const r3 = t3.x.scale * e3.x, a2 = t3.y.scale * e3.y;
            return 1 === r3 && 1 === a2 || (s2 += `scale(${r3}, ${a2})`), s2 || "none";
          }
          const Di = (t3, e3) => t3.depth - e3.depth;
          class ki {
            constructor() {
              this.children = [], this.isDirty = false;
            }
            add(t3) {
              h(this.children, t3), this.isDirty = true;
            }
            remove(t3) {
              d(this.children, t3), this.isDirty = true;
            }
            forEach(t3) {
              this.isDirty && this.children.sort(Di), this.isDirty = false, this.children.forEach(t3);
            }
          }
          const Ri = ["", "X", "Y", "Z"];
          let Li = 0;
          const ji = { type: "projectionFrame", totalNodes: 0, resolvedTargetDeltas: 0, recalculatedProjection: 0 };
          function Bi({ attachResizeListener: t3, defaultParent: e3, measureScroll: n3, checkIsScrollRoot: s2, resetTransform: i2 }) {
            return class {
              constructor(t4 = {}, n4 = null == e3 ? void 0 : e3()) {
                this.id = Li++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = false, this.isAnimationBlocked = false, this.isLayoutDirty = false, this.isProjectionDirty = false, this.isSharedProjectionDirty = false, this.isTransformDirty = false, this.updateManuallyBlocked = false, this.updateBlockedByResize = false, this.isUpdating = false, this.isSVG = false, this.needsReset = false, this.shouldResetTransform = false, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = false, this.updateScheduled = false, this.checkUpdateFailed = () => {
                  this.isUpdating && (this.isUpdating = false, this.clearAllSnapshots());
                }, this.updateProjection = () => {
                  var t5;
                  ji.totalNodes = ji.resolvedTargetDeltas = ji.recalculatedProjection = 0, this.nodes.forEach(Ii), this.nodes.forEach(Yi), this.nodes.forEach(Xi), this.nodes.forEach(Ui), t5 = ji, window.MotionDebug && window.MotionDebug.record(t5);
                }, this.hasProjected = false, this.isVisible = true, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = t4, this.root = n4 ? n4.root || n4 : this, this.path = n4 ? [...n4.path, n4] : [], this.parent = n4, this.depth = n4 ? n4.depth + 1 : 0;
                for (let t5 = 0; t5 < this.path.length; t5++) this.path[t5].shouldResetTransform = true;
                this.root === this && (this.nodes = new ki());
              }
              addEventListener(t4, e4) {
                return this.eventHandlers.has(t4) || this.eventHandlers.set(t4, new m()), this.eventHandlers.get(t4).add(e4);
              }
              notifyListeners(t4, ...e4) {
                const n4 = this.eventHandlers.get(t4);
                n4 && n4.notify(...e4);
              }
              hasListeners(t4) {
                return this.eventHandlers.has(t4);
              }
              mount(e4, n4 = this.root.hasTreeAnimated) {
                if (this.instance) return;
                var s3;
                this.isSVG = (s3 = e4) instanceof SVGElement && "svg" !== s3.tagName, this.instance = e4;
                const { layoutId: i3, layout: o, visualElement: r3 } = this.options;
                if (r3 && !r3.current && r3.mount(e4), this.root.nodes.add(this), this.parent && this.parent.children.add(this), n4 && (o || i3) && (this.isLayoutDirty = true), t3) {
                  let n5;
                  const s4 = () => this.root.updateBlockedByResize = false;
                  t3(e4, () => {
                    this.root.updateBlockedByResize = true, n5 && n5(), n5 = function(t4, e5) {
                      const n6 = performance.now(), s5 = ({ timestamp: e6 }) => {
                        const i4 = e6 - n6;
                        i4 >= 250 && (v(s5), t4(i4 - 250));
                      };
                      return y.read(s5, true), () => v(s5);
                    }(s4), ni.hasAnimatedSinceResize && (ni.hasAnimatedSinceResize = false, this.nodes.forEach(zi));
                  });
                }
                i3 && this.root.registerSharedNode(i3, this), false !== this.options.animate && r3 && (i3 || o) && this.addEventListener("didUpdate", ({ delta: t4, hasLayoutChanged: e5, hasRelativeTargetChanged: n5, layout: s4 }) => {
                  if (this.isTreeAnimationBlocked()) return this.target = void 0, void (this.relativeTarget = void 0);
                  const i4 = this.options.transition || r3.getDefaultTransition() || Ji, { onLayoutAnimationStart: o2, onLayoutAnimationComplete: a2 } = r3.getProps(), l2 = !this.targetLayout || !Ai(this.targetLayout, s4) || n5, u2 = !e5 && n5;
                  if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || u2 || e5 && (l2 || !this.currentAnimation)) {
                    this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(t4, u2);
                    const e6 = { ...Re(i4, "layout"), onPlay: o2, onComplete: a2 };
                    (r3.shouldReduceMotion || this.options.layoutRoot) && (e6.delay = 0, e6.type = false), this.startAnimation(e6);
                  } else e5 || zi(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
                  this.targetLayout = s4;
                });
              }
              unmount() {
                this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
                const t4 = this.getStack();
                t4 && t4.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, v(this.updateProjection);
              }
              blockUpdate() {
                this.updateManuallyBlocked = true;
              }
              unblockUpdate() {
                this.updateManuallyBlocked = false;
              }
              isUpdateBlocked() {
                return this.updateManuallyBlocked || this.updateBlockedByResize;
              }
              isTreeAnimationBlocked() {
                return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
              }
              startUpdate() {
                this.isUpdateBlocked() || (this.isUpdating = true, this.nodes && this.nodes.forEach(Gi), this.animationId++);
              }
              getTransformTemplate() {
                const { visualElement: t4 } = this.options;
                return t4 && t4.getProps().transformTemplate;
              }
              willUpdate(t4 = true) {
                if (this.root.hasTreeAnimated = true, this.root.isUpdateBlocked()) return void (this.options.onExitComplete && this.options.onExitComplete());
                if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty) return;
                this.isLayoutDirty = true;
                for (let t5 = 0; t5 < this.path.length; t5++) {
                  const e5 = this.path[t5];
                  e5.shouldResetTransform = true, e5.updateScroll("snapshot"), e5.options.layoutRoot && e5.willUpdate(false);
                }
                const { layoutId: e4, layout: n4 } = this.options;
                if (void 0 === e4 && !n4) return;
                const s3 = this.getTransformTemplate();
                this.prevTransformTemplateValue = s3 ? s3(this.latestValues, "") : void 0, this.updateSnapshot(), t4 && this.notifyListeners("willUpdate");
              }
              update() {
                if (this.updateScheduled = false, this.isUpdateBlocked()) return this.unblockUpdate(), this.clearAllSnapshots(), void this.nodes.forEach($i);
                this.isUpdating || this.nodes.forEach(Wi), this.isUpdating = false, this.nodes.forEach(Hi), this.nodes.forEach(Fi), this.nodes.forEach(Oi), this.clearAllSnapshots();
                const t4 = performance.now();
                x.delta = R(0, 1e3 / 60, t4 - x.timestamp), x.timestamp = t4, x.isProcessing = true, P.update.process(x), P.preRender.process(x), P.render.process(x), x.isProcessing = false;
              }
              didUpdate() {
                this.updateScheduled || (this.updateScheduled = true, queueMicrotask(() => this.update()));
              }
              clearAllSnapshots() {
                this.nodes.forEach(Ni), this.sharedNodes.forEach(qi);
              }
              scheduleUpdateProjection() {
                y.preRender(this.updateProjection, false, true);
              }
              scheduleCheckAfterUnmount() {
                y.postRender(() => {
                  this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
                });
              }
              updateSnapshot() {
                !this.snapshot && this.instance && (this.snapshot = this.measure());
              }
              updateLayout() {
                if (!this.instance) return;
                if (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead() || this.isLayoutDirty)) return;
                if (this.resumeFrom && !this.resumeFrom.instance) for (let t5 = 0; t5 < this.path.length; t5++) this.path[t5].updateScroll();
                const t4 = this.layout;
                this.layout = this.measure(false), this.layoutCorrected = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }, this.isLayoutDirty = false, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
                const { visualElement: e4 } = this.options;
                e4 && e4.notify("LayoutMeasure", this.layout.layoutBox, t4 ? t4.layoutBox : void 0);
              }
              updateScroll(t4 = "measure") {
                let e4 = Boolean(this.options.layoutScroll && this.instance);
                this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === t4 && (e4 = false), e4 && (this.scroll = { animationId: this.root.animationId, phase: t4, isRoot: s2(this.instance), offset: n3(this.instance) });
              }
              resetTransform() {
                if (!i2) return;
                const t4 = this.isLayoutDirty || this.shouldResetTransform, e4 = this.projectionDelta && !Ei(this.projectionDelta), n4 = this.getTransformTemplate(), s3 = n4 ? n4(this.latestValues, "") : void 0, o = s3 !== this.prevTransformTemplateValue;
                t4 && (e4 || Is(this.latestValues) || o) && (i2(this.instance, s3), this.shouldResetTransform = false, this.scheduleRender());
              }
              measure(t4 = true) {
                const e4 = this.measurePageBox();
                let n4 = this.removeElementScroll(e4);
                var s3;
                return t4 && (n4 = this.removeTransform(n4)), eo((s3 = n4).x), eo(s3.y), { animationId: this.root.animationId, measuredBox: e4, layoutBox: n4, latestValues: {}, source: this.id };
              }
              measurePageBox() {
                const { visualElement: t4 } = this.options;
                if (!t4) return { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
                const e4 = t4.measureViewportBox(), { scroll: n4 } = this.root;
                return n4 && (Xs(e4.x, n4.offset.x), Xs(e4.y, n4.offset.y)), e4;
              }
              removeElementScroll(t4) {
                const e4 = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
                vi(e4, t4);
                for (let n4 = 0; n4 < this.path.length; n4++) {
                  const s3 = this.path[n4], { scroll: i3, options: o } = s3;
                  if (s3 !== this.root && i3 && o.layoutScroll) {
                    if (i3.isRoot) {
                      vi(e4, t4);
                      const { scroll: n5 } = this.root;
                      n5 && (Xs(e4.x, -n5.offset.x), Xs(e4.y, -n5.offset.y));
                    }
                    Xs(e4.x, i3.offset.x), Xs(e4.y, i3.offset.y);
                  }
                }
                return e4;
              }
              applyTransform(t4, e4 = false) {
                const n4 = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
                vi(n4, t4);
                for (let t5 = 0; t5 < this.path.length; t5++) {
                  const s3 = this.path[t5];
                  !e4 && s3.options.layoutScroll && s3.scroll && s3 !== s3.root && Ks(n4, { x: -s3.scroll.offset.x, y: -s3.scroll.offset.y }), Is(s3.latestValues) && Ks(n4, s3.latestValues);
                }
                return Is(this.latestValues) && Ks(n4, this.latestValues), n4;
              }
              removeTransform(t4) {
                const e4 = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
                vi(e4, t4);
                for (let t5 = 0; t5 < this.path.length; t5++) {
                  const n4 = this.path[t5];
                  if (!n4.instance) continue;
                  if (!Is(n4.latestValues)) continue;
                  Os(n4.latestValues) && n4.updateSnapshot();
                  const s3 = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
                  vi(s3, n4.measurePageBox()), Si(e4, n4.latestValues, n4.snapshot ? n4.snapshot.layoutBox : void 0, s3);
                }
                return Is(this.latestValues) && Si(e4, this.latestValues), e4;
              }
              setTargetDelta(t4) {
                this.targetDelta = t4, this.root.scheduleUpdateProjection(), this.isProjectionDirty = true;
              }
              setOptions(t4) {
                this.options = { ...this.options, ...t4, crossfade: void 0 === t4.crossfade || t4.crossfade };
              }
              clearMeasurements() {
                this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = false;
              }
              forceRelativeParentToResolveTarget() {
                this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== x.timestamp && this.relativeParent.resolveTargetDelta(true);
              }
              resolveTargetDelta(t4 = false) {
                var e4;
                const n4 = this.getLead();
                this.isProjectionDirty || (this.isProjectionDirty = n4.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = n4.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = n4.isSharedProjectionDirty);
                const s3 = Boolean(this.resumingFrom) || this !== n4;
                if (!(t4 || s3 && this.isSharedProjectionDirty || this.isProjectionDirty || (null === (e4 = this.parent) || void 0 === e4 ? void 0 : e4.isProjectionDirty) || this.attemptToResolveRelativeTarget)) return;
                const { layout: i3, layoutId: o } = this.options;
                if (this.layout && (i3 || o)) {
                  if (this.resolvedRelativeTargetAt = x.timestamp, !this.targetDelta && !this.relativeTarget) {
                    const t5 = this.getClosestProjectingParent();
                    t5 && t5.layout && 1 !== this.animationProgress ? (this.relativeParent = t5, this.forceRelativeParentToResolveTarget(), this.relativeTarget = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }, this.relativeTargetOrigin = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }, Cs(this.relativeTargetOrigin, this.layout.layoutBox, t5.layout.layoutBox), vi(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
                  }
                  if (this.relativeTarget || this.targetDelta) {
                    var r3, a2, l2;
                    if (this.target || (this.target = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }, this.targetWithTransforms = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), r3 = this.target, a2 = this.relativeTarget, l2 = this.relativeParent.target, As(r3.x, a2.x, l2.x), As(r3.y, a2.y, l2.y)) : this.targetDelta ? (Boolean(this.resumingFrom) ? this.target = this.applyTransform(this.layout.layoutBox) : vi(this.target, this.layout.layoutBox), zs(this.target, this.targetDelta)) : vi(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
                      this.attemptToResolveRelativeTarget = false;
                      const t5 = this.getClosestProjectingParent();
                      t5 && Boolean(t5.resumingFrom) === Boolean(this.resumingFrom) && !t5.options.layoutScroll && t5.target && 1 !== this.animationProgress ? (this.relativeParent = t5, this.forceRelativeParentToResolveTarget(), this.relativeTarget = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }, this.relativeTargetOrigin = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }, Cs(this.relativeTargetOrigin, this.target, t5.target), vi(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
                    }
                    ji.resolvedTargetDeltas++;
                  }
                }
              }
              getClosestProjectingParent() {
                if (this.parent && !Os(this.parent.latestValues) && !Us(this.parent.latestValues)) return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
              }
              isProjecting() {
                return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
              }
              calcProjection() {
                var t4;
                const e4 = this.getLead(), n4 = Boolean(this.resumingFrom) || this !== e4;
                let s3 = true;
                if ((this.isProjectionDirty || (null === (t4 = this.parent) || void 0 === t4 ? void 0 : t4.isProjectionDirty)) && (s3 = false), n4 && (this.isSharedProjectionDirty || this.isTransformDirty) && (s3 = false), this.resolvedRelativeTargetAt === x.timestamp && (s3 = false), s3) return;
                const { layout: i3, layoutId: o } = this.options;
                if (this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !i3 && !o) return;
                vi(this.layoutCorrected, this.layout.layoutBox);
                const r3 = this.treeScale.x, a2 = this.treeScale.y;
                !function(t5, e5, n5, s4 = false) {
                  const i4 = n5.length;
                  if (!i4) return;
                  let o2, r4;
                  e5.x = e5.y = 1;
                  for (let a3 = 0; a3 < i4; a3++) {
                    o2 = n5[a3], r4 = o2.projectionDelta;
                    const i5 = o2.instance;
                    i5 && i5.style && "contents" === i5.style.display || (s4 && o2.options.layoutScroll && o2.scroll && o2 !== o2.root && Ks(t5, { x: -o2.scroll.offset.x, y: -o2.scroll.offset.y }), r4 && (e5.x *= r4.x.scale, e5.y *= r4.y.scale, zs(t5, r4)), s4 && Is(o2.latestValues) && Ks(t5, o2.latestValues));
                  }
                  e5.x = Ys(e5.x), e5.y = Ys(e5.y);
                }(this.layoutCorrected, this.treeScale, this.path, n4), !e4.layout || e4.target || 1 === this.treeScale.x && 1 === this.treeScale.y || (e4.target = e4.layout.layoutBox);
                const { target: l2 } = e4;
                if (!l2) return void (this.projectionTransform && (this.projectionDelta = { x: { translate: 0, scale: 1, origin: 0, originPoint: 0 }, y: { translate: 0, scale: 1, origin: 0, originPoint: 0 } }, this.projectionTransform = "none", this.scheduleRender()));
                this.projectionDelta || (this.projectionDelta = { x: { translate: 0, scale: 1, origin: 0, originPoint: 0 }, y: { translate: 0, scale: 1, origin: 0, originPoint: 0 } }, this.projectionDeltaWithTransform = { x: { translate: 0, scale: 1, origin: 0, originPoint: 0 }, y: { translate: 0, scale: 1, origin: 0, originPoint: 0 } });
                const u2 = this.projectionTransform;
                Es(this.projectionDelta, this.layoutCorrected, l2, this.latestValues), this.projectionTransform = Mi(this.projectionDelta, this.treeScale), this.projectionTransform === u2 && this.treeScale.x === r3 && this.treeScale.y === a2 || (this.hasProjected = true, this.scheduleRender(), this.notifyListeners("projectionUpdate", l2)), ji.recalculatedProjection++;
              }
              hide() {
                this.isVisible = false;
              }
              show() {
                this.isVisible = true;
              }
              scheduleRender(t4 = true) {
                if (this.options.scheduleRender && this.options.scheduleRender(), t4) {
                  const t5 = this.getStack();
                  t5 && t5.scheduleRender();
                }
                this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
              }
              setAnimationOrigin(t4, e4 = false) {
                const n4 = this.snapshot, s3 = n4 ? n4.latestValues : {}, i3 = { ...this.latestValues }, o = { x: { translate: 0, scale: 1, origin: 0, originPoint: 0 }, y: { translate: 0, scale: 1, origin: 0, originPoint: 0 } };
                this.relativeParent && this.relativeParent.options.layoutRoot || (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !e4;
                const r3 = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }, a2 = (n4 ? n4.source : void 0) !== (this.layout ? this.layout.source : void 0), l2 = this.getStack(), u2 = !l2 || l2.members.length <= 1, c2 = Boolean(a2 && !u2 && true === this.options.crossfade && !this.path.some(_i));
                let h2;
                this.animationProgress = 0, this.mixTargetDelta = (e5) => {
                  const n5 = e5 / 1e3;
                  var l3, d2, m2, p2, f2, g2;
                  Zi(o.x, t4.x, n5), Zi(o.y, t4.y, n5), this.setTargetDelta(o), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Cs(r3, this.layout.layoutBox, this.relativeParent.layout.layoutBox), m2 = this.relativeTarget, p2 = this.relativeTargetOrigin, f2 = r3, g2 = n5, Ki(m2.x, p2.x, f2.x, g2), Ki(m2.y, p2.y, f2.y, g2), h2 && (l3 = this.relativeTarget, d2 = h2, l3.x.min === d2.x.min && l3.x.max === d2.x.max && l3.y.min === d2.y.min && l3.y.max === d2.y.max) && (this.isProjectionDirty = false), h2 || (h2 = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } }), vi(h2, this.relativeTarget)), a2 && (this.animationValues = i3, function(t5, e6, n6, s4, i4, o2) {
                    i4 ? (t5.opacity = Kt(0, void 0 !== n6.opacity ? n6.opacity : 1, pi(s4)), t5.opacityExit = Kt(void 0 !== e6.opacity ? e6.opacity : 1, 0, fi(s4))) : o2 && (t5.opacity = Kt(void 0 !== e6.opacity ? e6.opacity : 1, void 0 !== n6.opacity ? n6.opacity : 1, s4));
                    for (let i5 = 0; i5 < ci; i5++) {
                      const o3 = `border${ui[i5]}Radius`;
                      let r4 = mi(e6, o3), a3 = mi(n6, o3);
                      void 0 === r4 && void 0 === a3 || (r4 || (r4 = 0), a3 || (a3 = 0), 0 === r4 || 0 === a3 || di(r4) === di(a3) ? (t5[o3] = Math.max(Kt(hi(r4), hi(a3), s4), 0), (H.test(a3) || H.test(r4)) && (t5[o3] += "%")) : t5[o3] = a3);
                    }
                    (e6.rotate || n6.rotate) && (t5.rotate = Kt(e6.rotate || 0, n6.rotate || 0, s4));
                  }(i3, s3, this.latestValues, n5, c2, u2)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = n5;
                }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
              }
              startAnimation(t4) {
                this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (v(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = y.update(() => {
                  ni.hasAnimatedSinceResize = true, this.currentAnimation = function(t5, e4, n4) {
                    const s3 = je(0) ? 0 : S(0);
                    return s3.start(Le("", s3, 1e3, n4)), s3.animation;
                  }(0, 0, { ...t4, onUpdate: (e4) => {
                    this.mixTargetDelta(e4), t4.onUpdate && t4.onUpdate(e4);
                  }, onComplete: () => {
                    t4.onComplete && t4.onComplete(), this.completeAnimation();
                  } }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
                });
              }
              completeAnimation() {
                this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
                const t4 = this.getStack();
                t4 && t4.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
              }
              finishAnimation() {
                this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(1e3), this.currentAnimation.stop()), this.completeAnimation();
              }
              applyTransformsToTarget() {
                const t4 = this.getLead();
                let { targetWithTransforms: e4, target: n4, layout: s3, latestValues: i3 } = t4;
                if (e4 && n4 && s3) {
                  if (this !== t4 && this.layout && s3 && no(this.options.animationType, this.layout.layoutBox, s3.layoutBox)) {
                    n4 = this.target || { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
                    const e5 = Ts(this.layout.layoutBox.x);
                    n4.x.min = t4.target.x.min, n4.x.max = n4.x.min + e5;
                    const s4 = Ts(this.layout.layoutBox.y);
                    n4.y.min = t4.target.y.min, n4.y.max = n4.y.min + s4;
                  }
                  vi(e4, n4), Ks(e4, i3), Es(this.projectionDeltaWithTransform, this.layoutCorrected, e4, i3);
                }
              }
              registerSharedNode(t4, e4) {
                this.sharedNodes.has(t4) || this.sharedNodes.set(t4, new Ci()), this.sharedNodes.get(t4).add(e4);
                const n4 = e4.options.initialPromotionConfig;
                e4.promote({ transition: n4 ? n4.transition : void 0, preserveFollowOpacity: n4 && n4.shouldPreserveFollowOpacity ? n4.shouldPreserveFollowOpacity(e4) : void 0 });
              }
              isLead() {
                const t4 = this.getStack();
                return !t4 || t4.lead === this;
              }
              getLead() {
                var t4;
                const { layoutId: e4 } = this.options;
                return e4 && (null === (t4 = this.getStack()) || void 0 === t4 ? void 0 : t4.lead) || this;
              }
              getPrevLead() {
                var t4;
                const { layoutId: e4 } = this.options;
                return e4 ? null === (t4 = this.getStack()) || void 0 === t4 ? void 0 : t4.prevLead : void 0;
              }
              getStack() {
                const { layoutId: t4 } = this.options;
                if (t4) return this.root.sharedNodes.get(t4);
              }
              promote({ needsReset: t4, transition: e4, preserveFollowOpacity: n4 } = {}) {
                const s3 = this.getStack();
                s3 && s3.promote(this, n4), t4 && (this.projectionDelta = void 0, this.needsReset = true), e4 && this.setOptions({ transition: e4 });
              }
              relegate() {
                const t4 = this.getStack();
                return !!t4 && t4.relegate(this);
              }
              resetRotation() {
                const { visualElement: t4 } = this.options;
                if (!t4) return;
                let e4 = false;
                const { latestValues: n4 } = t4;
                if ((n4.rotate || n4.rotateX || n4.rotateY || n4.rotateZ) && (e4 = true), !e4) return;
                const s3 = {};
                for (let e5 = 0; e5 < Ri.length; e5++) {
                  const i3 = "rotate" + Ri[e5];
                  n4[i3] && (s3[i3] = n4[i3], t4.setStaticValue(i3, 0));
                }
                t4.render();
                for (const e5 in s3) t4.setStaticValue(e5, s3[e5]);
                t4.scheduleRender();
              }
              getProjectionStyles(t4 = {}) {
                var e4, n4;
                const s3 = {};
                if (!this.instance || this.isSVG) return s3;
                if (!this.isVisible) return { visibility: "hidden" };
                s3.visibility = "";
                const i3 = this.getTransformTemplate();
                if (this.needsReset) return this.needsReset = false, s3.opacity = "", s3.pointerEvents = In(t4.pointerEvents) || "", s3.transform = i3 ? i3(this.latestValues, "") : "none", s3;
                const o = this.getLead();
                if (!this.projectionDelta || !this.layout || !o.target) {
                  const e5 = {};
                  return this.options.layoutId && (e5.opacity = void 0 !== this.latestValues.opacity ? this.latestValues.opacity : 1, e5.pointerEvents = In(t4.pointerEvents) || ""), this.hasProjected && !Is(this.latestValues) && (e5.transform = i3 ? i3({}, "") : "none", this.hasProjected = false), e5;
                }
                const r3 = o.animationValues || o.latestValues;
                this.applyTransformsToTarget(), s3.transform = Mi(this.projectionDeltaWithTransform, this.treeScale, r3), i3 && (s3.transform = i3(r3, s3.transform));
                const { x: a2, y: l2 } = this.projectionDelta;
                s3.transformOrigin = `${100 * a2.origin}% ${100 * l2.origin}% 0`, o.animationValues ? s3.opacity = o === this ? null !== (n4 = null !== (e4 = r3.opacity) && void 0 !== e4 ? e4 : this.latestValues.opacity) && void 0 !== n4 ? n4 : 1 : this.preserveOpacity ? this.latestValues.opacity : r3.opacityExit : s3.opacity = o === this ? void 0 !== r3.opacity ? r3.opacity : "" : void 0 !== r3.opacityExit ? r3.opacityExit : 0;
                for (const t5 in pn) {
                  if (void 0 === r3[t5]) continue;
                  const { correct: e5, applyTo: n5 } = pn[t5], i4 = "none" === s3.transform ? r3[t5] : e5(r3[t5], o);
                  if (n5) {
                    const t6 = n5.length;
                    for (let e6 = 0; e6 < t6; e6++) s3[n5[e6]] = i4;
                  } else s3[t5] = i4;
                }
                return this.options.layoutId && (s3.pointerEvents = o === this ? In(t4.pointerEvents) || "" : "none"), s3;
              }
              clearSnapshot() {
                this.resumeFrom = this.snapshot = void 0;
              }
              resetTree() {
                this.root.nodes.forEach((t4) => {
                  var e4;
                  return null === (e4 = t4.currentAnimation) || void 0 === e4 ? void 0 : e4.stop();
                }), this.root.nodes.forEach($i), this.root.sharedNodes.clear();
              }
            };
          }
          function Fi(t3) {
            t3.updateLayout();
          }
          function Oi(t3) {
            var e3;
            const n3 = (null === (e3 = t3.resumeFrom) || void 0 === e3 ? void 0 : e3.snapshot) || t3.snapshot;
            if (t3.isLead() && t3.layout && n3 && t3.hasListeners("didUpdate")) {
              const { layoutBox: e4, measuredBox: s2 } = t3.layout, { animationType: i2 } = t3.options, o = n3.source !== t3.layout.source;
              "size" === i2 ? js((t4) => {
                const s3 = o ? n3.measuredBox[t4] : n3.layoutBox[t4], i3 = Ts(s3);
                s3.min = e4[t4].min, s3.max = s3.min + i3;
              }) : no(i2, n3.layoutBox, e4) && js((s3) => {
                const i3 = o ? n3.measuredBox[s3] : n3.layoutBox[s3], r4 = Ts(e4[s3]);
                i3.max = i3.min + r4, t3.relativeTarget && !t3.currentAnimation && (t3.isProjectionDirty = true, t3.relativeTarget[s3].max = t3.relativeTarget[s3].min + r4);
              });
              const r3 = { x: { translate: 0, scale: 1, origin: 0, originPoint: 0 }, y: { translate: 0, scale: 1, origin: 0, originPoint: 0 } };
              Es(r3, e4, n3.layoutBox);
              const a2 = { x: { translate: 0, scale: 1, origin: 0, originPoint: 0 }, y: { translate: 0, scale: 1, origin: 0, originPoint: 0 } };
              o ? Es(a2, t3.applyTransform(s2, true), n3.measuredBox) : Es(a2, e4, n3.layoutBox);
              const l2 = !Ei(r3);
              let u2 = false;
              if (!t3.resumeFrom) {
                const s3 = t3.getClosestProjectingParent();
                if (s3 && !s3.resumeFrom) {
                  const { snapshot: i3, layout: o2 } = s3;
                  if (i3 && o2) {
                    const r4 = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
                    Cs(r4, n3.layoutBox, i3.layoutBox);
                    const a3 = { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
                    Cs(a3, e4, o2.layoutBox), Ai(r4, a3) || (u2 = true), s3.options.layoutRoot && (t3.relativeTarget = a3, t3.relativeTargetOrigin = r4, t3.relativeParent = s3);
                  }
                }
              }
              t3.notifyListeners("didUpdate", { layout: e4, snapshot: n3, delta: a2, layoutDelta: r3, hasLayoutChanged: l2, hasRelativeTargetChanged: u2 });
            } else if (t3.isLead()) {
              const { onExitComplete: e4 } = t3.options;
              e4 && e4();
            }
            t3.options.transition = void 0;
          }
          function Ii(t3) {
            ji.totalNodes++, t3.parent && (t3.isProjecting() || (t3.isProjectionDirty = t3.parent.isProjectionDirty), t3.isSharedProjectionDirty || (t3.isSharedProjectionDirty = Boolean(t3.isProjectionDirty || t3.parent.isProjectionDirty || t3.parent.isSharedProjectionDirty)), t3.isTransformDirty || (t3.isTransformDirty = t3.parent.isTransformDirty));
          }
          function Ui(t3) {
            t3.isProjectionDirty = t3.isSharedProjectionDirty = t3.isTransformDirty = false;
          }
          function Ni(t3) {
            t3.clearSnapshot();
          }
          function $i(t3) {
            t3.clearMeasurements();
          }
          function Wi(t3) {
            t3.isLayoutDirty = false;
          }
          function Hi(t3) {
            const { visualElement: e3 } = t3.options;
            e3 && e3.getProps().onBeforeLayoutMeasure && e3.notify("BeforeLayoutMeasure"), t3.resetTransform();
          }
          function zi(t3) {
            t3.finishAnimation(), t3.targetDelta = t3.relativeTarget = t3.target = void 0, t3.isProjectionDirty = true;
          }
          function Yi(t3) {
            t3.resolveTargetDelta();
          }
          function Xi(t3) {
            t3.calcProjection();
          }
          function Gi(t3) {
            t3.resetRotation();
          }
          function qi(t3) {
            t3.removeLeadSnapshot();
          }
          function Zi(t3, e3, n3) {
            t3.translate = Kt(e3.translate, 0, n3), t3.scale = Kt(e3.scale, 1, n3), t3.origin = e3.origin, t3.originPoint = e3.originPoint;
          }
          function Ki(t3, e3, n3, s2) {
            t3.min = Kt(e3.min, n3.min, s2), t3.max = Kt(e3.max, n3.max, s2);
          }
          function _i(t3) {
            return t3.animationValues && void 0 !== t3.animationValues.opacityExit;
          }
          const Ji = { duration: 0.45, ease: [0.4, 0, 0.1, 1] }, Qi = (t3) => "undefined" != typeof navigator && navigator.userAgent.toLowerCase().includes(t3), to = Qi("applewebkit/") && !Qi("chrome/") ? Math.round : n2;
          function eo(t3) {
            t3.min = to(t3.min), t3.max = to(t3.max);
          }
          function no(t3, e3, n3) {
            return "position" === t3 || "preserve-aspect" === t3 && !Ss(Vi(e3), Vi(n3), 0.2);
          }
          const so = Bi({ attachResizeListener: (t3, e3) => Hn(t3, "resize", e3), measureScroll: () => ({ x: document.documentElement.scrollLeft || document.body.scrollLeft, y: document.documentElement.scrollTop || document.body.scrollTop }), checkIsScrollRoot: () => true }), io = { current: void 0 }, oo = Bi({ measureScroll: (t3) => ({ x: t3.scrollLeft, y: t3.scrollTop }), defaultParent: () => {
            if (!io.current) {
              const t3 = new so({});
              t3.mount(window), t3.setOptions({ layoutScroll: true }), io.current = t3;
            }
            return io.current;
          }, resetTransform: (t3, e3) => {
            t3.style.transform = void 0 !== e3 ? e3 : "none";
          }, checkIsScrollRoot: (t3) => Boolean("fixed" === window.getComputedStyle(t3).position) }), ro = { pan: { Feature: class extends Jn {
            constructor() {
              super(...arguments), this.removePointerDownListener = n2;
            }
            onPointerDown(t3) {
              this.session = new fs(t3, this.createPanHandlers(), { transformPagePoint: this.node.getTransformPagePoint() });
            }
            createPanHandlers() {
              const { onPanSessionStart: t3, onPanStart: e3, onPan: n3, onPanEnd: s2 } = this.node.getProps();
              return { onSessionStart: ei(t3), onStart: ei(e3), onMove: n3, onEnd: (t4, e4) => {
                delete this.session, s2 && y.update(() => s2(t4, e4));
              } };
            }
            mount() {
              this.removePointerDownListener = Xn(this.node.current, "pointerdown", (t3) => this.onPointerDown(t3));
            }
            update() {
              this.session && this.session.updateHandlers(this.createPanHandlers());
            }
            unmount() {
              this.removePointerDownListener(), this.session && this.session.end();
            }
          } }, drag: { Feature: class extends Jn {
            constructor(t3) {
              super(t3), this.removeGroupControls = n2, this.removeListeners = n2, this.controls = new Qs(t3);
            }
            mount() {
              const { dragControls: t3 } = this.node.getProps();
              t3 && (this.removeGroupControls = t3.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || n2;
            }
            unmount() {
              this.removeGroupControls(), this.removeListeners();
            }
          }, ProjectionNode: oo, MeasureLayout: ai } }, ao = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
          function lo(t3, e3, n3 = 1) {
            const [s2, i2] = function(t4) {
              const e4 = ao.exec(t4);
              if (!e4) return [,];
              const [, n4, s3] = e4;
              return [n4, s3];
            }(t3);
            if (!s2) return;
            const o = window.getComputedStyle(e3).getPropertyValue(s2);
            if (o) {
              const t4 = o.trim();
              return l(t4) ? parseFloat(t4) : t4;
            }
            return A(i2) ? lo(i2, e3, n3 + 1) : i2;
          }
          const uo = /* @__PURE__ */ new Set(["width", "height", "top", "left", "right", "bottom", "x", "y", "translateX", "translateY"]), co = (t3) => uo.has(t3), ho = (t3) => t3 === L || t3 === z, mo = (t3, e3) => parseFloat(t3.split(", ")[e3]), po = (t3, e3) => (n3, { transform: s2 }) => {
            if ("none" === s2 || !s2) return 0;
            const i2 = s2.match(/^matrix3d\((.+)\)$/);
            if (i2) return mo(i2[1], e3);
            {
              const e4 = s2.match(/^matrix\((.+)\)$/);
              return e4 ? mo(e4[1], t3) : 0;
            }
          }, fo = /* @__PURE__ */ new Set(["x", "y", "z"]), go = wt.filter((t3) => !fo.has(t3)), yo = { width: ({ x: t3 }, { paddingLeft: e3 = "0", paddingRight: n3 = "0" }) => t3.max - t3.min - parseFloat(e3) - parseFloat(n3), height: ({ y: t3 }, { paddingTop: e3 = "0", paddingBottom: n3 = "0" }) => t3.max - t3.min - parseFloat(e3) - parseFloat(n3), top: (t3, { top: e3 }) => parseFloat(e3), left: (t3, { left: e3 }) => parseFloat(e3), bottom: ({ y: t3 }, { top: e3 }) => parseFloat(e3) + (t3.max - t3.min), right: ({ x: t3 }, { left: e3 }) => parseFloat(e3) + (t3.max - t3.min), x: po(4, 13), y: po(5, 14) };
          yo.translateX = yo.x, yo.translateY = yo.y;
          function vo(t3, e3, n3, s2) {
            return ((t4) => Object.keys(t4).some(co))(e3) ? ((t4, e4, n4 = {}, s3 = {}) => {
              e4 = { ...e4 }, s3 = { ...s3 };
              const i2 = Object.keys(e4).filter(co);
              let o = [], a2 = false;
              const l2 = [];
              if (i2.forEach((i3) => {
                const u2 = t4.getValue(i3);
                if (!t4.hasValue(i3)) return;
                let h2 = n4[i3], d2 = gt(h2);
                const m2 = e4[i3];
                let p2;
                if (c(m2)) {
                  const t5 = m2.length, e5 = null === m2[0] ? 1 : 0;
                  h2 = m2[e5], d2 = gt(h2);
                  for (let n5 = e5; n5 < t5 && null !== m2[n5]; n5++) p2 ? r2(gt(m2[n5]) === p2) : (p2 = gt(m2[n5]), r2(p2 === d2 || ho(d2) && ho(p2)));
                } else p2 = gt(m2);
                if (d2 !== p2) if (ho(d2) && ho(p2)) {
                  const t5 = u2.get();
                  "string" == typeof t5 && u2.set(parseFloat(t5)), "string" == typeof m2 ? e4[i3] = parseFloat(m2) : Array.isArray(m2) && p2 === z && (e4[i3] = m2.map(parseFloat));
                } else (null == d2 ? void 0 : d2.transform) && (null == p2 ? void 0 : p2.transform) && (0 === h2 || 0 === m2) ? 0 === h2 ? u2.set(p2.transform(h2)) : e4[i3] = d2.transform(m2) : (a2 || (o = function(t5) {
                  const e5 = [];
                  return go.forEach((n5) => {
                    const s4 = t5.getValue(n5);
                    void 0 !== s4 && (e5.push([n5, s4.get()]), s4.set(n5.startsWith("scale") ? 1 : 0));
                  }), e5.length && t5.render(), e5;
                }(t4), a2 = true), l2.push(i3), s3[i3] = void 0 !== s3[i3] ? s3[i3] : e4[i3], u2.jump(m2));
              }), l2.length) {
                const n5 = l2.indexOf("height") >= 0 ? window.pageYOffset : null, i3 = ((t5, e5, n6) => {
                  const s4 = e5.measureViewportBox(), i4 = e5.current, o2 = getComputedStyle(i4), { display: r3 } = o2, a3 = {};
                  "none" === r3 && e5.setStaticValue("display", t5.display || "block"), n6.forEach((t6) => {
                    a3[t6] = yo[t6](s4, o2);
                  }), e5.render();
                  const l3 = e5.measureViewportBox();
                  return n6.forEach((n7) => {
                    const s5 = e5.getValue(n7);
                    s5 && s5.jump(a3[n7]), t5[n7] = yo[n7](l3, o2);
                  }), t5;
                })(e4, t4, l2);
                return o.length && o.forEach(([e5, n6]) => {
                  t4.getValue(e5).set(n6);
                }), t4.render(), He && null !== n5 && window.scrollTo({ top: n5 }), { target: i3, transitionEnd: s3 };
              }
              return { target: e4, transitionEnd: s3 };
            })(t3, e3, n3, s2) : { target: e3, transitionEnd: s2 };
          }
          const xo = { current: null }, Po = { current: false }, bo = /* @__PURE__ */ new WeakMap(), To = Object.keys(on), So = To.length, wo = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"], Eo = Qe.length;
          class Ao extends class {
            constructor({ parent: t3, props: e3, presenceContext: n3, reducedMotionConfig: s2, visualState: i2 }, o = {}) {
              this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = false, this.isControllingVariants = false, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
                this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
              }, this.scheduleRender = () => y.render(this.render, false, true);
              const { latestValues: r3, renderState: a2 } = i2;
              this.latestValues = r3, this.baseTarget = { ...r3 }, this.initialValues = e3.initial ? { ...r3 } : {}, this.renderState = a2, this.parent = t3, this.props = e3, this.presenceContext = n3, this.depth = t3 ? t3.depth + 1 : 0, this.reducedMotionConfig = s2, this.options = o, this.isControllingVariants = tn(e3), this.isVariantNode = en(e3), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = Boolean(t3 && t3.current);
              const { willChange: l2, ...u2 } = this.scrapeMotionValuesFromProps(e3, {});
              for (const t4 in u2) {
                const e4 = u2[t4];
                void 0 !== r3[t4] && je(e4) && (e4.set(r3[t4], false), Be(l2) && l2.add(t4));
              }
            }
            scrapeMotionValuesFromProps(t3, e3) {
              return {};
            }
            mount(t3) {
              this.current = t3, bo.set(t3, this), this.projection && !this.projection.instance && this.projection.mount(t3), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((t4, e3) => this.bindToMotionValue(e3, t4)), Po.current || function() {
                if (Po.current = true, He) if (window.matchMedia) {
                  const t4 = window.matchMedia("(prefers-reduced-motion)"), e3 = () => xo.current = t4.matches;
                  t4.addListener(e3), e3();
                } else xo.current = false;
              }(), this.shouldReduceMotion = "never" !== this.reducedMotionConfig && ("always" === this.reducedMotionConfig || xo.current), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
            }
            unmount() {
              bo.delete(this.current), this.projection && this.projection.unmount(), v(this.notifyUpdate), v(this.render), this.valueSubscriptions.forEach((t3) => t3()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
              for (const t3 in this.events) this.events[t3].clear();
              for (const t3 in this.features) this.features[t3].unmount();
              this.current = null;
            }
            bindToMotionValue(t3, e3) {
              const n3 = Et.has(t3), s2 = e3.on("change", (e4) => {
                this.latestValues[t3] = e4, this.props.onUpdate && y.update(this.notifyUpdate, false, true), n3 && this.projection && (this.projection.isTransformDirty = true);
              }), i2 = e3.on("renderRequest", this.scheduleRender);
              this.valueSubscriptions.set(t3, () => {
                s2(), i2();
              });
            }
            sortNodePosition(t3) {
              return this.current && this.sortInstanceNodePosition && this.type === t3.type ? this.sortInstanceNodePosition(this.current, t3.current) : 0;
            }
            loadFeatures({ children: t3, ...e3 }, n3, s2, i2) {
              let o, r3;
              for (let t4 = 0; t4 < So; t4++) {
                const n4 = To[t4], { isEnabled: s3, Feature: i3, ProjectionNode: a2, MeasureLayout: l2 } = on[n4];
                a2 && (o = a2), s3(e3) && (!this.features[n4] && i3 && (this.features[n4] = new i3(this)), l2 && (r3 = l2));
              }
              if (!this.projection && o) {
                this.projection = new o(this.latestValues, this.parent && this.parent.projection);
                const { layoutId: t4, layout: n4, drag: s3, dragConstraints: r4, layoutScroll: a2, layoutRoot: l2 } = e3;
                this.projection.setOptions({ layoutId: t4, layout: n4, alwaysMeasureLayout: Boolean(s3) || r4 && Ze(r4), visualElement: this, scheduleRender: () => this.scheduleRender(), animationType: "string" == typeof n4 ? n4 : "both", initialPromotionConfig: i2, layoutScroll: a2, layoutRoot: l2 });
              }
              return r3;
            }
            updateFeatures() {
              for (const t3 in this.features) {
                const e3 = this.features[t3];
                e3.isMounted ? e3.update() : (e3.mount(), e3.isMounted = true);
              }
            }
            triggerBuild() {
              this.build(this.renderState, this.latestValues, this.options, this.props);
            }
            measureViewportBox() {
              return this.current ? this.measureInstanceViewportBox(this.current, this.props) : { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
            }
            getStaticValue(t3) {
              return this.latestValues[t3];
            }
            setStaticValue(t3, e3) {
              this.latestValues[t3] = e3;
            }
            makeTargetAnimatable(t3, e3 = true) {
              return this.makeTargetAnimatableFromInstance(t3, this.props, e3);
            }
            update(t3, e3) {
              (t3.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t3, this.prevPresenceContext = this.presenceContext, this.presenceContext = e3;
              for (let e4 = 0; e4 < wo.length; e4++) {
                const n3 = wo[e4];
                this.propEventSubscriptions[n3] && (this.propEventSubscriptions[n3](), delete this.propEventSubscriptions[n3]);
                const s2 = t3["on" + n3];
                s2 && (this.propEventSubscriptions[n3] = this.on(n3, s2));
              }
              this.prevMotionValues = function(t4, e4, n3) {
                const { willChange: s2 } = e4;
                for (const i2 in e4) {
                  const o = e4[i2], r3 = n3[i2];
                  if (je(o)) t4.addValue(i2, o), Be(s2) && s2.add(i2);
                  else if (je(r3)) t4.addValue(i2, S(o, { owner: t4 })), Be(s2) && s2.remove(i2);
                  else if (r3 !== o) if (t4.hasValue(i2)) {
                    const e5 = t4.getValue(i2);
                    !e5.hasAnimated && e5.set(o);
                  } else {
                    const e5 = t4.getStaticValue(i2);
                    t4.addValue(i2, S(void 0 !== e5 ? e5 : o, { owner: t4 }));
                  }
                }
                for (const s3 in n3) void 0 === e4[s3] && t4.removeValue(s3);
                return e4;
              }(this, this.scrapeMotionValuesFromProps(t3, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
            }
            getProps() {
              return this.props;
            }
            getVariant(t3) {
              return this.props.variants ? this.props.variants[t3] : void 0;
            }
            getDefaultTransition() {
              return this.props.transition;
            }
            getTransformPagePoint() {
              return this.props.transformPagePoint;
            }
            getClosestVariantNode() {
              return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
            }
            getVariantContext(t3 = false) {
              if (t3) return this.parent ? this.parent.getVariantContext() : void 0;
              if (!this.isControllingVariants) {
                const t4 = this.parent && this.parent.getVariantContext() || {};
                return void 0 !== this.props.initial && (t4.initial = this.props.initial), t4;
              }
              const e3 = {};
              for (let t4 = 0; t4 < Eo; t4++) {
                const n3 = Qe[t4], s2 = this.props[n3];
                (Ke(s2) || false === s2) && (e3[n3] = s2);
              }
              return e3;
            }
            addVariantChild(t3) {
              const e3 = this.getClosestVariantNode();
              if (e3) return e3.variantChildren && e3.variantChildren.add(t3), () => e3.variantChildren.delete(t3);
            }
            addValue(t3, e3) {
              e3 !== this.values.get(t3) && (this.removeValue(t3), this.bindToMotionValue(t3, e3)), this.values.set(t3, e3), this.latestValues[t3] = e3.get();
            }
            removeValue(t3) {
              this.values.delete(t3);
              const e3 = this.valueSubscriptions.get(t3);
              e3 && (e3(), this.valueSubscriptions.delete(t3)), delete this.latestValues[t3], this.removeValueFromRenderState(t3, this.renderState);
            }
            hasValue(t3) {
              return this.values.has(t3);
            }
            getValue(t3, e3) {
              if (this.props.values && this.props.values[t3]) return this.props.values[t3];
              let n3 = this.values.get(t3);
              return void 0 === n3 && void 0 !== e3 && (n3 = S(e3, { owner: this }), this.addValue(t3, n3)), n3;
            }
            readValue(t3) {
              var e3;
              return void 0 === this.latestValues[t3] && this.current ? null !== (e3 = this.getBaseTargetFromProps(this.props, t3)) && void 0 !== e3 ? e3 : this.readValueFromInstance(this.current, t3, this.options) : this.latestValues[t3];
            }
            setBaseTarget(t3, e3) {
              this.baseTarget[t3] = e3;
            }
            getBaseTarget(t3) {
              var e3;
              const { initial: n3 } = this.props, s2 = "string" == typeof n3 || "object" == typeof n3 ? null === (e3 = vt(this.props, n3)) || void 0 === e3 ? void 0 : e3[t3] : void 0;
              if (n3 && void 0 !== s2) return s2;
              const i2 = this.getBaseTargetFromProps(this.props, t3);
              return void 0 === i2 || je(i2) ? void 0 !== this.initialValues[t3] && void 0 === s2 ? void 0 : this.baseTarget[t3] : i2;
            }
            on(t3, e3) {
              return this.events[t3] || (this.events[t3] = new m()), this.events[t3].add(e3);
            }
            notify(t3, ...e3) {
              this.events[t3] && this.events[t3].notify(...e3);
            }
          } {
            sortInstanceNodePosition(t3, e3) {
              return 2 & t3.compareDocumentPosition(e3) ? 1 : -1;
            }
            getBaseTargetFromProps(t3, e3) {
              return t3.style ? t3.style[e3] : void 0;
            }
            removeValueFromRenderState(t3, { vars: e3, style: n3 }) {
              delete e3[t3], delete n3[t3];
            }
            makeTargetAnimatableFromInstance({ transition: t3, transitionEnd: e3, ...n3 }, { transformValues: s2 }, i2) {
              let o = function(t4, e4, n4) {
                const s3 = {};
                for (const i3 in t4) {
                  const t5 = St(i3, e4);
                  if (void 0 !== t5) s3[i3] = t5;
                  else {
                    const t6 = n4.getValue(i3);
                    t6 && (s3[i3] = t6.get());
                  }
                }
                return s3;
              }(n3, t3 || {}, this);
              if (s2 && (e3 && (e3 = s2(e3)), n3 && (n3 = s2(n3)), o && (o = s2(o))), i2) {
                !function(t5, e4, n4) {
                  var s3, i3;
                  const o2 = Object.keys(e4).filter((e5) => !t5.hasValue(e5)), r3 = o2.length;
                  var a2;
                  if (r3) for (let c2 = 0; c2 < r3; c2++) {
                    const r4 = o2[c2], h2 = e4[r4];
                    let d2 = null;
                    Array.isArray(h2) && (d2 = h2[0]), null === d2 && (d2 = null !== (i3 = null !== (s3 = n4[r4]) && void 0 !== s3 ? s3 : t5.readValue(r4)) && void 0 !== i3 ? i3 : e4[r4]), null != d2 && ("string" == typeof d2 && (l(d2) || u(d2)) ? d2 = parseFloat(d2) : (a2 = d2, !yt.find(pt(a2)) && it.test(h2) && (d2 = mt(r4, h2))), t5.addValue(r4, S(d2, { owner: t5 })), void 0 === n4[r4] && (n4[r4] = d2), null !== d2 && t5.setBaseTarget(r4, d2));
                  }
                }(this, n3, o);
                const t4 = ((t5, e4, n4, s3) => {
                  const i3 = function(t6, { ...e5 }, n5) {
                    const s4 = t6.current;
                    if (!(s4 instanceof Element)) return { target: e5, transitionEnd: n5 };
                    n5 && (n5 = { ...n5 }), t6.values.forEach((t7) => {
                      const e6 = t7.get();
                      if (!A(e6)) return;
                      const n6 = lo(e6, s4);
                      n6 && t7.set(n6);
                    });
                    for (const t7 in e5) {
                      const i4 = e5[t7];
                      if (!A(i4)) continue;
                      const o2 = lo(i4, s4);
                      o2 && (e5[t7] = o2, n5 || (n5 = {}), void 0 === n5[t7] && (n5[t7] = i4));
                    }
                    return { target: e5, transitionEnd: n5 };
                  }(t5, e4, s3);
                  return vo(t5, e4 = i3.target, n4, s3 = i3.transitionEnd);
                })(this, n3, o, e3);
                e3 = t4.transitionEnd, n3 = t4.target;
              }
              return { transition: t3, transitionEnd: e3, ...n3 };
            }
          }
          class Vo extends Ao {
            readValueFromInstance(t3, e3) {
              if (Et.has(e3)) {
                const t4 = dt(e3);
                return t4 && t4.default || 0;
              }
              {
                const s2 = (n3 = t3, window.getComputedStyle(n3)), i2 = (E(e3) ? s2.getPropertyValue(e3) : s2[e3]) || 0;
                return "string" == typeof i2 ? i2.trim() : i2;
              }
              var n3;
            }
            measureInstanceViewportBox(t3, { transformPagePoint: e3 }) {
              return _s(t3, e3);
            }
            build(t3, e3, n3, s2) {
              xn(t3, e3, n3, s2.transformTemplate);
            }
            scrapeMotionValuesFromProps(t3, e3) {
              return Fn(t3, e3);
            }
            handleChildMotionValue() {
              this.childSubscription && (this.childSubscription(), delete this.childSubscription);
              const { children: t3 } = this.props;
              je(t3) && (this.childSubscription = t3.on("change", (t4) => {
                this.current && (this.current.textContent = `${t4}`);
              }));
            }
            renderInstance(t3, e3, n3, s2) {
              Ln(t3, e3, n3, s2);
            }
          }
          class Co extends Ao {
            constructor() {
              super(...arguments), this.isSVGTag = false;
            }
            getBaseTargetFromProps(t3, e3) {
              return t3[e3];
            }
            readValueFromInstance(t3, e3) {
              if (Et.has(e3)) {
                const t4 = dt(e3);
                return t4 && t4.default || 0;
              }
              return e3 = jn.has(e3) ? e3 : At(e3), t3.getAttribute(e3);
            }
            measureInstanceViewportBox() {
              return { x: { min: 0, max: 0 }, y: { min: 0, max: 0 } };
            }
            scrapeMotionValuesFromProps(t3, e3) {
              return On(t3, e3);
            }
            build(t3, e3, n3, s2) {
              Mn(t3, e3, n3, this.isSVGTag, s2.transformTemplate);
            }
            renderInstance(t3, e3, n3, s2) {
              Bn(t3, e3, 0, s2);
            }
            mount(t3) {
              this.isSVGTag = Dn(t3.tagName), super.mount(t3);
            }
          }
          const Mo = (t3, e3) => mn(t3) ? new Co(e3, { enableHardwareAcceleration: false }) : new Vo(e3, { enableHardwareAcceleration: true }), Do = { ...ms, ...as, ...ro, layout: { ProjectionNode: oo, MeasureLayout: ai } }, ko = hn((t3, e3) => function(t4, { forwardMotionProps: e4 = false }, n3, s2) {
            return { ...mn(t4) ? $n : Wn, preloadedFeatures: n3, useRender: Rn(e4), createVisualElement: s2, Component: t4 };
          }(t3, e3, Do, Mo)), Ro = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9], Lo = ({ className: n3, animateToNumber: s2, fontStyle: i2, transitions: o, includeComma: r3, locale: l2 }) => {
            const u2 = e2().useRef(null), c2 = function(e3, { root: n4, margin: s3, amount: i3, once: o2 = false } = {}) {
              const [r4, l3] = (0, t2.useState)(false);
              return (0, t2.useEffect)(() => {
                if (!e3.current || o2 && r4) return;
                const t3 = { root: n4 && n4.current || void 0, margin: s3, amount: i3 };
                return function(t4, e4, { root: n5, margin: s4, amount: i4 = "some" } = {}) {
                  const o3 = function(t5, e5, n6) {
                    if ("string" == typeof t5) {
                      t5 = document.querySelectorAll(t5);
                    } else t5 instanceof Element && (t5 = [t5]);
                    return Array.from(t5 || []);
                  }(t4), r5 = /* @__PURE__ */ new WeakMap(), l4 = new IntersectionObserver((t5) => {
                    t5.forEach((t6) => {
                      const n6 = r5.get(t6.target);
                      if (t6.isIntersecting !== Boolean(n6)) if (t6.isIntersecting) {
                        const n7 = e4(t6);
                        "function" == typeof n7 ? r5.set(t6.target, n7) : l4.unobserve(t6.target);
                      } else n6 && (n6(t6), r5.delete(t6.target));
                    });
                  }, { root: n5, rootMargin: s4, threshold: "number" == typeof i4 ? i4 : a[i4] });
                  return o3.forEach((t5) => l4.observe(t5)), () => l4.disconnect();
                }(e3.current, () => (l3(true), o2 ? void 0 : () => l3(false)), t3);
              }, [n4, e3, s3, o2]), r4;
            }(u2, { once: true }), h2 = function() {
              const t3 = We($e);
              return ze(t3.mount, []), t3;
            }(), d2 = e2().useRef(0), m2 = r3 ? Math.abs(s2).toLocaleString(l2 || "en-US") : String(Math.abs(s2)), p2 = Array.from(m2, Number).map((t3, e3) => isNaN(t3) ? m2[e3] : t3), [f2, g2] = e2().useState(0), [y2, v2] = e2().useState(0), x2 = e2().useRef(null);
            return e2().useEffect(() => {
              var t3;
              const e3 = null === (t3 = x2.current.getClientRects()) || void 0 === t3 ? void 0 : t3[0];
              e3 && (g2(e3.height), v2(e3.width));
            }, [s2, i2]), e2().useEffect(() => {
              c2 && h2.start("visible");
            }, [c2, s2]), e2().createElement("span", { ref: u2 }, 0 !== f2 && e2().createElement("div", { style: { display: "flex", flexDirection: "row", overflow: "hidden" }, className: n3 }, p2.map((t3, n4) => "string" == typeof t3 ? e2().createElement("div", { key: n4, style: { ...i2, fontVariantNumeric: "tabular-nums" } }, t3) : e2().createElement("div", { key: n4, style: { height: f2, width: y2 } }, Ro.map((t4) => e2().createElement(ko.div, { style: { ...i2, fontVariantNumeric: "tabular-nums" }, key: "" + d2.current++, initial: "hidden", variants: { hidden: { y: 0 }, visible: { y: f2 * p2[n4] * -1 - 20 * f2 } }, animate: h2, transition: null == o ? void 0 : o(n4) }, t4))))), e2().createElement("div", { ref: x2, style: { position: "absolute", top: -9999, ...i2 } }, 0));
          }, jo = e2().memo(Lo, (t3, e3) => t3.animateToNumber === e3.animateToNumber && t3.fontStyle === e3.fontStyle && t3.includeComma === e3.includeComma);
        })(), i;
      })();
    });
  })(dist);
  return dist.exports;
}
var distExports = requireDist();
const AnimatedNumbers = /* @__PURE__ */ getDefaultExportFromCjs$1(distExports);
const useAnimatedNumber = (totalSavings) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("span", { className: "sr-only", children: getLanguage() === multiLanguageLabel.englishLangLabel.toLowerCase() ? `$${totalSavings}` : `${totalSavings}$` }),
    getLanguage() === multiLanguageLabel.englishLangLabel.toLowerCase() && /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: `${PREFIX}-currency`, children: "$" }),
    /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: /* @__PURE__ */ jsx(
      AnimatedNumbers,
      {
        className: `${PREFIX}-amount`,
        animateToNumber: totalSavings,
        locale: getCaLocale(),
        includeComma: true
      }
    ) }),
    getLanguage() === multiLanguageLabel.frenchLangLabel.toLowerCase() && /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: `${PREFIX}-currency`, children: "$" })
  ] });
};
const useIsPaymentBAFlow = (flowType) => {
  return useMemo(() => {
    return flowType === PaymentFlowType.BILLING_ADDRESS;
  }, [flowType]);
};
const useIsPaymentPOFlow = (flowType) => {
  return useMemo(() => {
    return flowType === PaymentFlowType.PLACE_ORDER;
  }, [flowType]);
};
const useIsPaymentNormalFlow = (flowType) => {
  return useMemo(() => {
    return flowType === PaymentFlowType.NORMAL;
  }, [flowType]);
};
const useIsNotPaymentBAFlow = (flowType) => {
  return useMemo(() => {
    return flowType !== PaymentFlowType.BILLING_ADDRESS;
  }, [flowType]);
};
function useDoOnce(callback) {
  const callbackRef = useRef(lodashExports.once(callback));
  return callbackRef.current();
}
const isFirstTimeUserVisit = () => document.referrer === "" || !document.referrer.includes(window.location.hostname);
const ProductListFlyout = ({ ...props }) => {
  const {
    isOpen,
    closeFlyout,
    cartAccessoriesFlyOutTitle,
    skeletonSize,
    hasMinimumNumberOfRecommendations,
    closeLabel,
    viewCatCTALabel,
    showAllCTALabel,
    categoryRedirectionUrl,
    optionsAriaLabel,
    isFetchingData,
    clickedOptionsProductCode
  } = props;
  const cartAccessoriesFlyout = `${PREFIX}-cart-accessories-flyout`;
  const productListBodyClassName = props.enableATCFlyOut ? `${cartAccessoriesFlyout}__product-list-body` : "";
  const skeletonComponent = () => {
    return /* @__PURE__ */ jsx("div", { className: `${PREFIX}-row ${PREFIX}-container`, children: /* @__PURE__ */ jsxs("ul", { className: `${cartAccessoriesFlyout}__skeleton-container`, children: [
      /* @__PURE__ */ jsx("li", { className: `${cartAccessoriesFlyout}__header-content`, children: /* @__PURE__ */ jsx(SkeletonComponent, { skeletonClass: `${cartAccessoriesFlyout}__skeleton-header` }) }),
      [...Array(skeletonSize)].map((index2) => /* @__PURE__ */ jsx("li", { className: `${cartAccessoriesFlyout}__content`, children: /* @__PURE__ */ jsx(SkeletonComponent, { skeletonClass: `${cartAccessoriesFlyout}__skeleton-list` }) }, index2))
    ] }) });
  };
  const renderRecommendations = () => {
    var _a;
    return hasMinimumNumberOfRecommendations ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        RecommendationsList,
        {
          title: props.title,
          productList: props.productList,
          priceProps: props.priceProps,
          language: getLanguage(),
          imageDataComponentName: "featured-list-three-tile",
          returnPolicy: props.returnPolicy,
          selectedSchemaId: props.selectedSchemaId,
          addToCartClickHandler: props.addToCartClickHandler,
          addToCartLabel: props.addToCartLabel,
          addedToCartLabel: props.addedToCartLabel,
          isYouNeedThis: props.isYouNeedThis,
          miniCartData: props.miniCartData,
          plusMinusSymbol: props.plusMinusSymbol,
          maximumNumberOfRecommendations: (_a = props.productList) == null ? void 0 : _a.length,
          enableATCFlyOut: props.enableATCFlyOut,
          optionsCTA: props == null ? void 0 : props.optionsCTA,
          showSpinner: props.showSpinner,
          atcClickedProductCode: props.atcClickedProductCode,
          itemsLabel: props.itemsLabel,
          enableMiniPDPFlyoutInDigiFlyer: props.enableMiniPDPFlyoutInDigiFlyer,
          optionClickHandler: props.optionClickHandler,
          optionsAriaLabel,
          isFetchingData,
          clickedOptionsProductCode
        }
      ),
      isAtleastOneParamValid(
        Boolean(props.enableATCFlyOut),
        Boolean(props.enableMiniPDPFlyoutInDigiFlyer)
      ) && /* @__PURE__ */ jsx("div", { className: `${cartAccessoriesFlyout}__view-category`, children: /* @__PURE__ */ jsx(
        ButtonV2,
        {
          customClass: `${cartAccessoriesFlyout}__view-category--btn`,
          variant: props.enableMiniPDPFlyoutInDigiFlyer ? Variation.SECONDARY : Variation.PRIMARY,
          size: Size.MEDIUM,
          a11y: {
            label: props.enableMiniPDPFlyoutInDigiFlyer ? showAllCTALabel : viewCatCTALabel
          },
          onClick: categoryRedirectionUrl,
          children: props.enableMiniPDPFlyoutInDigiFlyer ? showAllCTALabel : viewCatCTALabel
        }
      ) })
    ] }) : skeletonComponent();
  };
  return /* @__PURE__ */ jsx(
    FlyoutModalComponent,
    {
      isOpen,
      closeFlyout,
      isStoreSelectorModalUsed: false,
      title: cartAccessoriesFlyOutTitle,
      children: /* @__PURE__ */ jsxs("div", { className: `${cartAccessoriesFlyout}__container`, children: [
        /* @__PURE__ */ jsx("div", { className: `${cartAccessoriesFlyout}__header`, children: /* @__PURE__ */ jsx(
          IconButton,
          {
            icon: { size: iconSizes.Medium, type: "ct-close" },
            "aria-label": closeLabel,
            variant: Variation.TERTIARY,
            color: ButtonColors.DEFAULT,
            onClick: closeFlyout
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: `${cartAccessoriesFlyout}__body ${productListBodyClassName}`, children: renderRecommendations() })
      ] })
    }
  );
};
const PasskeyItem = ({ ...props }) => {
  const { storageName, storageImage, removeLabel, addedOnLabel, registrationDate, passkeyId, onDeletePasskeyClick } = props;
  const componentClassName2 = `${PREFIX}-passkey-item`;
  const shouldDisplayDeleteBtn = !!onDeletePasskeyClick && !!removeLabel;
  return /* @__PURE__ */ jsx("div", { className: componentClassName2, children: /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__container`, children: [
    /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__content`, children: [
      /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__image`, children: /* @__PURE__ */ jsx("img", { src: storageImage, alt: storageName }) }),
      /* @__PURE__ */ jsxs("div", { className: `${componentClassName2}__description`, children: [
        /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__storage`, children: storageName }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `${componentClassName2}__date`,
            children: `${addedOnLabel} ${convertTicksToDate(registrationDate)}`
          }
        )
      ] })
    ] }),
    shouldDisplayDeleteBtn && /* @__PURE__ */ jsx("div", { className: `${componentClassName2}__remove`, children: /* @__PURE__ */ jsx(
      ButtonV2,
      {
        variant: Variation.TERTIARY,
        a11y: { label: removeLabel },
        icon: { type: "ct-delete" },
        onClick: () => onDeletePasskeyClick(passkeyId),
        children: removeLabel
      }
    ) })
  ] }) });
};
const GridCard = ({ ...props }) => {
  const { children, customClass, gap = Size.XS } = props;
  const componentClass = `${PREFIX}-card--${Direction.VERTICAL}`;
  const componentGapClass = `${PREFIX}-card--gap-${gap ? gap : Size.XS}`;
  const customClassName = customClass ? ` ${customClass}` : "";
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${componentClass}${customClassName} ${PREFIX}-xs-flex ${PREFIX}-xs-column ${componentGapClass}`,
      children
    }
  );
};
GridCard.displayName = "GridCard";
const ListCard = ({ ...props }) => {
  const { children, customClass, gap = Size.XS } = props;
  const componentClass = `${PREFIX}-card--${Direction.HORIZONTAL}`;
  const componentGapClass = `${PREFIX}-card--gap-${gap ? gap : Size.XS}`;
  const customClassName = customClass ? ` ${customClass}` : "";
  return /* @__PURE__ */ jsx("div", { className: `${componentClass}${customClassName} ${PREFIX}-xs-flex ${componentGapClass}`, children });
};
ListCard.displayName = "ListCard";
const Card = React.forwardRef(
  ({ ...props }, ref) => {
    const {
      children,
      customClass,
      customViewClass,
      id,
      gap,
      style = {
        state: State.DEFAULT,
        shadow: Shadow.REGULAR
      },
      orientation = Direction.VERTICAL,
      header = { shouldWrapToast: false },
      type
    } = props;
    const { radius = { size: Radius.ROUNDED_XS, position: Position.ALL } } = style;
    const componentClass = `${PREFIX}-card`;
    const cardTypeClass = type ? ` ${PREFIX}-${type}-card` : "";
    const customClassName = customClass ? ` ${customClass}` : "";
    const radiusPosition = (radius == null ? void 0 : radius.position) === Position.ALL ? "" : `-${radius == null ? void 0 : radius.position}`;
    const showRadiusClass = (radius == null ? void 0 : radius.size) !== Radius.NONE ? ` ${componentClass}--${radius == null ? void 0 : radius.size}${radiusPosition}` : "";
    const shadowClass = `${componentClass}--${style.shadow ? style.shadow : Shadow.REGULAR}`;
    const stateClass = style.state !== State.DEFAULT ? ` ${componentClass}--${style.state}` : "";
    const cardView = () => orientation === Direction.HORIZONTAL ? /* @__PURE__ */ jsx(ListCard, { gap, customClass: customViewClass, children }) : /* @__PURE__ */ jsx(GridCard, { gap, customClass: customViewClass, children });
    const renderToast = () => {
      var _a, _b;
      if (header == null ? void 0 : header.toast) {
        return (header == null ? void 0 : header.shouldWrapToast) ? /* @__PURE__ */ jsx("div", { className: `${PREFIX}-inline-toast__wrapper`, children: /* @__PURE__ */ jsx(InlineToast, { ...header == null ? void 0 : header.toast, children: (_a = header == null ? void 0 : header.toast) == null ? void 0 : _a.children }) }) : /* @__PURE__ */ jsx(InlineToast, { ...header == null ? void 0 : header.toast, children: (_b = header == null ? void 0 : header.toast) == null ? void 0 : _b.children });
      } else {
        return null;
      }
    };
    const renderHeader = () => (header == null ? void 0 : header.content) ? /* @__PURE__ */ jsx("h2", { className: `${componentClass}__heading`, children: header == null ? void 0 : header.content }) : null;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ref,
        id,
        className: `${componentClass} ${shadowClass}${cardTypeClass}${stateClass}${showRadiusClass}${customClassName}`,
        children: [
          renderHeader(),
          renderToast(),
          cardView()
        ]
      }
    );
  }
);
Card.displayName = "Card";
let Carousel = null;
let Recommendations = null;
let FeaturedProductList = null;
(() => {
  if (typeof window !== "undefined") {
    Carousel = Carousel$1;
    Recommendations = Recommendations$1;
    FeaturedProductList = FeaturedProductList$1;
  }
})();
export {
  Accordion,
  AccountsDropdown,
  ActiveOwnership,
  Animation,
  Autocomplete,
  AutomotiveErrorCard,
  AutomotiveProductCardsVehicleContextWrapper,
  BREAKPOINTS,
  Badges,
  BalanceScreen,
  Banner,
  BannerDisclaimer,
  BannerType$1 as BannerType,
  BannerViewType,
  Barcode,
  BaseIcon,
  BrandFooter,
  BrandingColors,
  Breadcrumb,
  Button,
  ButtonColors,
  ButtonGroup,
  ButtonToggle,
  ButtonType,
  ButtonV2,
  CTMoneySnippet,
  Calendar,
  Card,
  CardColumn,
  CardInput,
  CardType$1 as CardType,
  Carousel,
  CarouselSwiper,
  Cart,
  CartFlyout,
  CartServicesComponent,
  CascadingDropdown,
  CategoryCard,
  CategoryIcons,
  CertonaConstants,
  ChartTypes,
  Checkbox,
  CircularProgress,
  ClampLinesEllipsis,
  CommonButtonClass,
  CommonCard,
  CommonCardWrapper,
  CommonClass,
  CommonStatusToast,
  CommonWarningToast,
  CompareProductsFlyout,
  ComparisonTable,
  ComplexCTA,
  ConfirmationModal,
  ContactUsByEmail,
  ContentVariation,
  CtaType,
  CustomContentCard,
  CustomDropdown,
  CustomTextArea,
  DOBFormatConstant,
  DataGrid,
  DataTable,
  DatePicker,
  Direction,
  DisplayViewType,
  Dropdown,
  EmailActivationCard,
  EmptyCartWishlist,
  EmptyScreen,
  ErrorCard,
  ErrorScreen,
  EstimateFeesModal,
  ExpandButton,
  ExpandCard,
  FORWARD_SLASH,
  FacetPanelModal,
  FeatureTypes,
  FeaturedProductList,
  Features,
  FeeType$1 as FeeType,
  Filters,
  FlyoutModalComponent,
  FullPageSpinner,
  GiftCard,
  Animation$1 as GlobalAnimation,
  GuestCheckout,
  HeaderBlock,
  HeaderStoreLocator,
  Heading,
  HeroBannerSplit,
  IVariant,
  Icon,
  IconButton,
  InfoMessage,
  InformationCard,
  InformationModal,
  InformativeModal,
  InlineToast,
  InteractiveElementEvents,
  JumpList,
  LanguageToggle,
  LineSummary,
  LinkRewardsCard as LinkCard,
  LinkOptionsCard,
  LoyaltyCards,
  MODAL_OPEN_CLASS_NOT_SCROLL,
  Map$1 as Map,
  MediaGalleryViewer,
  MediaTypeValue,
  MegaNavigation,
  MegaNavigationDesktop,
  MergeCartModal,
  MessageCard,
  Modal,
  MultiSelectCheckBoxes,
  NavExpansionPanel,
  NavItem,
  NavigationFlyout,
  NewVehicleBanner,
  NotificationBadge,
  OSType,
  OfferCard,
  OfferFlyout,
  OptionDescriptors,
  OptionListSize,
  OtpErrorType,
  Overlay,
  Overview,
  PURCHASE_TYPE,
  Pagination$1 as Pagination,
  PasskeyItem,
  PasswordsForm,
  PaymentFlowType,
  Pill,
  PillsList,
  Position,
  PostalCodeModal,
  PreviewCard,
  PreviewDetail,
  PreviewDetailsList,
  Price,
  ProductCard,
  VehicleProductCard as ProductCardVehicle,
  ProductCartItem,
  ProductDoesNotFit,
  ProductFitmentMessage,
  ProductGridView,
  ProductImageComponent,
  ProductInformation,
  ProductItemInfo,
  ProductListCard,
  ProductListFlyout,
  ProductSourceTypes,
  ProgressBar,
  ProgressSizes,
  ProgressType,
  PromoMessages,
  QcLanguageTab,
  QuantitySelector,
  REDEEM_TYPE,
  Radio,
  ReactModal,
  Rebate,
  Recommendations,
  RecommendationsList,
  ReferenceComponent,
  Resources,
  Review,
  RichTextModal,
  RoadRating,
  RoadRatingBadge,
  SanitizeStringContentWrapper,
  SearchBar,
  SearchTitle,
  SelectBanner,
  SeoTable,
  Separator,
  SeparatorSize,
  SeparatorStyle,
  ServiceInstallation,
  ServiceInstallationMessage,
  SignInDropDown,
  SignOut,
  Size,
  SkeletonComponent,
  SkinnyBannerModal,
  SkipLink,
  SnippetCard,
  Specifications,
  Spinner,
  SpinnerButton,
  SpinnerModal,
  SpinnerStyle,
  SpinnerTypes,
  State,
  StaticProductTitle,
  Status,
  Step,
  StickyBuyBar,
  StickyTOC,
  StoreDetails,
  StoreDetailsModal,
  StoreSelectorModal,
  StoreTooltip,
  SuccessScreen,
  SuccessScreenModal,
  SummaryCard,
  SwapConfirmationModal,
  Switch,
  Symbols,
  TabV2,
  TabVariants,
  Table,
  Tabs,
  TabsItemContainer,
  TabsV2,
  Tag,
  TemplateCard,
  TermsAndConditions,
  TextArea,
  TextInput,
  TextInputGroup,
  TextInputGroupHeading,
  TextInputGroupPreview,
  TextInputModes,
  TimePicker,
  Toast,
  Tooltip,
  TransactionBackgroundImage,
  TransactionColumn,
  TransactionColumnBadge,
  TransactionColumnLogo,
  TransactionDetail,
  UnfinishedPackageCard,
  UrgencyMessage,
  UserGreeting,
  Variants,
  VariantsAlt,
  VariantsWrapper,
  Variation,
  VehicleAvailabilitySection,
  VehicleBanner,
  VehicleHeader,
  VerificationScreen,
  VideoGalleryViewer,
  Wishlist,
  addAndRemoveHideClass,
  addClass,
  addDynamicToken,
  addParam,
  anyDividerRegExp,
  appendQueryParam,
  appendQueryParamsToUrl,
  appendReturnUrl,
  appendTrackingInfo,
  applyAkamaiPolicy,
  applyGiftCardErrorCodes,
  areAllParamsValid,
  arraysElementsAreEqual,
  arrowActionIdentifier$1 as arrowActionIdentifier,
  balanceCheckerScreen,
  baseCTFSInputStyles,
  brazeCustomEvents,
  brazeCustomEventsPages,
  canadaPostApi,
  capitalizeWords,
  cardNumberFormatted,
  carouselSettingValues,
  checkAddressChange,
  checkCurrentPage,
  checkDataLength,
  checkEmptyValue,
  checkIfDateIsOverdue,
  checkInstanceOf,
  checkInstanceOfPrice,
  checkKeyPresenceInArray,
  checkLastItemArray,
  checkNavigationUrl,
  checkNeedUpdateWeekdayHours,
  checkNestedProps,
  checkNotNullAndUndefined,
  checkPathname,
  checkPlugInType,
  checkReturnURL,
  checkStateProvince,
  checkStoreHashInURL,
  checkStoreParamInURL,
  checkToggle,
  checkUndefined,
  checkWasCurrentPrice,
  checkoutRegexPatterns,
  choose,
  collapseControl,
  combineBadges,
  commonIcons,
  compareTwoArrays,
  confirmationModalConstant,
  createCanvasPattern,
  createPaginationHref,
  createShopAllLink,
  currentYear,
  customDebounce,
  dashboardBannerTypes,
  dateOptions,
  daysCalculationConstants,
  daysInMonth,
  deviceTypes,
  disableFocusLock,
  eEntryType,
  enableDestructOnUndefinedData,
  enableFocusLock,
  errorCodes,
  errorOrderModificationCodes,
  excludeQuote,
  excludeUtmParams,
  extractKeyValues,
  extractServiceBasedOnSku,
  filterOffersData,
  filterSpecification,
  findParamValue,
  fitmentTypeCodeValue,
  formEmpty,
  formatCreditCard,
  formatedPhoneNumberAccessibility,
  generateDOBStr,
  generateDayMonthYearFromDOBStr,
  generateGoogleMapOnAddress,
  generateUniqueId,
  getAccessibilityId,
  getAkamaiPolicy,
  getBalance,
  getBannerLogo,
  getBaseProductParams,
  getButtonStatus,
  getButtonType,
  getCTA,
  getCapitalizeString,
  getCardErrorCheck,
  getCardLogo,
  getCardNameAndNumber,
  getCardNumber,
  getCardType,
  getCategoryParams,
  getColumns,
  getCookieValue,
  getCurrentDate,
  getCurrentDay,
  getDateDetails,
  getDateFormatNumericYear,
  getDateFromCreditCard,
  getDateOfBirth,
  getDateTime,
  getDaysDifference,
  getDeviceOS,
  getDeviceType,
  getDivideByAmount,
  getETATimeOptions,
  getErrorCodeMessage,
  getErrorMessage,
  getEstimatedTimeOfSendingProduct,
  getFeeTitle,
  getFileNameFromUrl,
  getFormatValueWithIcon,
  getFormattedDateTime,
  getFormattedDateTimeWithYear,
  getFormattedDateWithComparison,
  getFormattedPhoneNumber,
  getFormattedPrice,
  getFormattedPriceValue,
  getFormattedPriceWithLocale,
  getFormattedTimeDate,
  getHeaderButtonLabel,
  getInteractiveElements,
  getIsMobile,
  getLastCharacters,
  getLoyaltyCards,
  getMod10CheckDigit,
  getMonthList,
  getMultipleByAmount,
  getNameDetails,
  getNextDayStoreTimings,
  getNumberFromFormattedPrice,
  getNumberFromFormattedPriceWithLocale,
  getOfferCardExpiryDate,
  getOfferCodesParam,
  getOfferParams,
  getOfferSorting,
  getPTEBaseTotal,
  getPageTitle,
  getPageType,
  getParamValue,
  getParameterFromURL,
  getPhoneNumber,
  getPriceRangePill,
  getPriceValue,
  getProductParams,
  getQueryString$1 as getQueryString,
  getQueryStringParams,
  getSAPIRequestQueryParam,
  getSetOfFourPriceForStaggered,
  getSourceParam,
  getSourceTypeData,
  getStoreParams,
  getStoreTimings,
  getStringBasedOnCondition,
  getStringOrDefault,
  getSubscriptionDateTime,
  getTooltipText,
  getTotalPteReward,
  getTransactionName,
  getUserProfileStatus,
  getValueByComponent,
  googlePlaceServices$1 as googlePlaceServices,
  handleArrowsAccessibility,
  handleClickOrEnterAccessibility,
  handleModalEventListeners,
  hashCreditCard,
  iconSizes,
  isAccountPageType,
  isAmountGreaterThan,
  isAnnualTopupTransaction,
  isArrayEmpty,
  isArrayNotEmpty,
  isAtleastOneParamValid,
  isAutoServiceAvailableInStore,
  isBalloonProduct,
  isCreditCardExpired,
  isDateValid,
  isEnterPressed,
  isEscPressed,
  isFalse,
  isFirstTimeUserVisit,
  isL1ShopAllPage,
  isMockParamInURL,
  isMultiplierOffer,
  isOrderBOPIS,
  isOrderSTH,
  isOtpErrorCode,
  isPetroConversionTransaction,
  isPetroOrAnnualTopUpTransactions,
  isPrerenderOrNot,
  isSpacePressed,
  isStringInList,
  isTabPressed,
  isTriangleSelectMember,
  isUrl,
  isValidPrice,
  isVerticalFilters,
  learnMoreModalData,
  index$1 as libUtils,
  linkRewardsAnalytics,
  linkTargetOptions,
  localeCookieName,
  localization,
  magicNumber,
  maskCardNumberExceptLastFourDigits,
  maxDaysInMonth,
  modalAccessibilityHandler,
  modifyRedirectUrlByParams,
  offerComponentLocation,
  offerConstants,
  onElementAvailable,
  otpErrorCodes,
  pageNumberConstants,
  pageTypes,
  parseQuery,
  plaCarouselSchemaId,
  popUpAEMHandler,
  preProcessSvgUseTag,
  productWheelTypes,
  promiseQueue,
  pushUrlHistory,
  quebecIsocode,
  queryParameters,
  recommendationQueryParam,
  redirectToPage,
  removeAllParametersFromURL,
  removeClass,
  removeHtmlTagsFromString,
  removeHtmlTagsFromStringByName,
  removeParam,
  removeParameterFromURL,
  renderClearanceBadge,
  renderItemPrice,
  renderVehicleInfo,
  replaceMultipleStrWithDynamicVal,
  replaceStrWithDynamicElement,
  replaceStrWithDynamicVal,
  replaceStringCharacter$1 as replaceStringCharacter,
  saleOrClearanceBadge,
  sanitizeStringContent,
  scrollBetweenElements,
  scrollToElement,
  scrollToElementIfExists,
  scrollToFooter,
  scrollToTop$1 as scrollToTop,
  searchConstants,
  selectedSKUBadge,
  sendError,
  setFocusToElement,
  shippingAddressErrorCodes,
  signoutRedirection,
  signoutRedirectionList,
  sortByBrandsOrCategory,
  sortOffers,
  staggeredSkuLength,
  statusIcons,
  statusLabel,
  stringKeyCodes,
  stringToBooleanMap,
  stringifyElement,
  technicalDifficultiesErrCode,
  totalCurrentPrice,
  updateFilterFacet,
  updateHashInURL,
  updateParam,
  updateParameterInURL,
  updateUrlHistory,
  urlRedirection,
  useAnimatedNumber,
  useCalculatedLoyaltyValue,
  useCallbackOnce,
  useClickOutsideClose,
  useDesktopLayoutState,
  useDoOnce,
  useFocusOnce,
  useFocusOnceRef,
  useFocusedTable,
  useGenerateSaveMessage,
  useGlobalBeforeUnloadEvent,
  useGlobalResizeEvent,
  useGlobalScrollEvent,
  useHandleFocusTrap,
  useIsChanged,
  useIsMobile,
  useIsNotPaymentBAFlow,
  useIsPaymentBAFlow,
  useIsPaymentNormalFlow,
  useIsPaymentPOFlow,
  useMobileLayoutState,
  useOnClickOutside,
  useOnKeyDownOutside,
  useOnKeyUpOutside,
  validateCardInput,
  validateDateBetweenTwoDates,
  validatePostalCode,
  variantsConstant$1 as variantsConstant,
  verificationCodeRegex,
  yearDropdownCalculation
};
//# sourceMappingURL=index.es.js.map
